/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 444);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var core = __webpack_require__(47);
var hide = __webpack_require__(33);
var redefine = __webpack_require__(34);
var ctx = __webpack_require__(48);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(85);


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function translateField(field, translation) {
  var fieldTranslation = translation !== undefined && translation.fields !== undefined ? translation.fields[field.name] : undefined;
  if (field.columns && fieldTranslation !== undefined && fieldTranslation.columns !== undefined) {
    var columns = field.columns.map(function (column) {
      return Object.assign({}, column, fieldTranslation.columns[column.name]);
    });
    fieldTranslation = Object.assign({}, fieldTranslation, { columns: columns });
  }
  if (field.columnHeaders && fieldTranslation !== undefined && fieldTranslation.columnHeaders !== undefined) {
    var columnHeaders = field.columnHeaders.map(function (columnHeader) {
      return Object.assign({}, columnHeader, fieldTranslation.columnHeaders[columnHeader.name]);
    });
    fieldTranslation = Object.assign({}, fieldTranslation, { columnHeaders: columnHeaders });
  }
  if (field.type === "table" || field.type === "multiTable") {
    if (fieldTranslation !== undefined && fieldTranslation.options !== undefined) {
      var options = Object.keys(field.options).map(function (key) {
        return { key: key, value: Object.assign({}, field.options[key], fieldTranslation.options[key]) };
      }).reduce(function (object, item) {
        return Object.assign({}, object, _defineProperty({}, item.key, item.value));
      }, {});
      fieldTranslation = Object.assign({}, fieldTranslation, { options: options });
    } else {
      fieldTranslation = Object.assign({}, fieldTranslation, { options: field.options });
    }
  } else if (field.options !== undefined && fieldTranslation !== undefined && fieldTranslation.options !== undefined) {
    var options = field.options.map(function (option) {
      return Object.assign({}, option, { text: fieldTranslation.options[option.value] });
    });
    fieldTranslation = Object.assign({}, fieldTranslation, { options: options });
  }
  if (field.type === "matrix" && fieldTranslation !== undefined) {
    fieldTranslation = Object.assign({}, fieldTranslation, {
      fields: field.fields.map(function (field) {
        return translateField(field, fieldTranslation);
      }),
      categories: field.categories.map(function (category) {
        return Object.assign({}, category, fieldTranslation.categories !== undefined ? fieldTranslation.categories[category.name] : undefined);
      })
    });
  }
  return fieldTranslation !== undefined ? Object.assign({}, field, fieldTranslation) : field;
}

function updateLabels(area, areaTranslation) {
  return Object.assign({}, area, Object.assign({}, areaTranslation, {
    fields: area.fields !== undefined ? area.fields.map(function (field) {
      return translateField(field, areaTranslation);
    }) : undefined
  }));
}

function isFormOrAreaNotDefined(form, key) {
  return form === undefined || form.filter(function (area) {
    return area.name === key;
  }).length === 0;
}

function hasFields(variable, key) {
  return variable[key] !== undefined && variable[key].fields !== undefined;
}

function updateColumns(fieldForm, fieldTranslation, fieldVariant) {
  var columnTranslations = fieldTranslation !== undefined && fieldTranslation.columns !== undefined ? fieldTranslation.columns : {};
  return Object.assign({}, fieldVariant, {
    columns: fieldForm.columns === undefined ? undefined : fieldForm.columns.map(function (column) {
      return _defineProperty({}, column.name, Object.assign({}, fieldTranslation !== undefined && fieldTranslation.columns !== undefined ? fieldTranslation.columns[column.name] : undefined, fieldVariant.columns[column.name]));
    }).reduce(function (object, field) {
      return Object.assign({}, object, field);
    })
  });
}

function mergedFieldVariant(fieldDetails, translation, variant) {
  var form = fieldDetails.form;
  var key = fieldDetails.key;
  var field = fieldDetails.field;

  var fieldVariant = variant[key].fields[field.name];
  var fieldTranslation = translation[key].fields[field.name];
  var fieldForm = form.filter(function (area) {
    return area.name === key;
  })[0].fields.filter(function (f) {
    return f.name === field.name;
  })[0];

  if (fieldVariant !== undefined && fieldVariant.columns !== undefined) {
    fieldVariant = updateColumns(fieldForm, fieldTranslation, fieldVariant);
  }

  return fieldVariant;
}

function mergeVariantFields(formDetails, translation, variant) {
  var form = formDetails.form;
  var key = formDetails.key;
  var fields = form.filter(function (area) {
    return area.name === key;
  })[0].fields;
  return fields === undefined ? undefined : fields.map(function (field) {
    if (hasFields(translation, key) && hasFields(variant, key)) {
      return _defineProperty({}, field.name, Object.assign({}, translation[key].fields[field.name], mergedFieldVariant({ form: form, key: key, field: field }, translation, variant)));
    } else if (hasFields(translation, key)) {
      return _defineProperty({}, field.name, translation[key].fields[field.name]);
    } else if (hasFields(variant, key)) {
      return _defineProperty({}, field.name, variant[key].fields[field.name]);
    } else {
      return undefined;
    }
  }).reduce(function (object, field) {
    return Object.assign({}, object, field);
  });
}

/* Replaced by mergeVariant 2019-01-17
function mergeLabels(form,translation,variant) {
  var labels={};
  if (variant!==undefined) {
    var possibleTranslations=Object.keys(translation).concat(Object.keys(variant).concat(form!==undefined ? form.map(area=>area.name): undefined));
    [...new Set(possibleTranslations)]
    .forEach(key=>{
      if (isFormOrAreaNotDefined(form,key)) {
        labels[key]=variant[key];
      } else {
        let mergedVariant=Object.assign({},variant[key],{
          fields: mergeVariantFields({form:form, key:key },translation,variant)
        });
        labels[key]=Object.assign({},translation[key],mergedVariant);
      }
    });
  } else {
    labels=translation;
  }
  return labels;
}
*/

function translatedArea(area, languageTranslation) {
  var areaTranslation = languageTranslation !== undefined ? languageTranslation[area.name] : undefined;
  var labels = areaTranslation !== undefined ? updateLabels(area, areaTranslation) : area;

  if (languageTranslation.variant !== undefined) {
    labels = updateLabels(labels, languageTranslation.variant[area.name]);
  }
  return labels;
}

function mergeVariant(translation, variant) {
  //  return Object.assign({},translation,variant);
  if (translation && (typeof translation === "undefined" ? "undefined" : _typeof(translation)) === 'object' && !Array.isArray(translation) && Object.keys(translation).length > 0) {
    var outcome = Object.keys(translation).map(function (key) {
      return {
        key: key,
        value: variant !== undefined && variant[key] !== undefined ? _typeof(variant[key]) === "object" ? mergeVariant(translation[key], variant[key]) : variant[key] : translation[key]
      };
    }).reduce(function (result, item) {
      return Object.assign({}, result, _defineProperty({}, item.key, item.value));
    }, {});
    return outcome;
  } else {
    return variant !== undefined ? variant : translation;
  }
}

var Translations = function () {
  function Translations(listOfTranslations) {
    _classCallCheck(this, Translations);

    this.translations = listOfTranslations !== undefined && listOfTranslations.length > 0 ? listOfTranslations.reduce(function (translations, lang) {
      return Object.assign({}, translations, lang);
    }) : undefined;
  }

  _createClass(Translations, [{
    key: "loadVariants",
    value: function loadVariants(listOfVariants) {
      this.variants = listOfVariants.reduce(function (translations, lang) {
        return Object.assign({}, translations, lang);
      });
      return this;
    }
  }, {
    key: "getFormLabels",
    value: function getFormLabels(formDefinition, language, variant) {
      return mergeVariant(
      //      formDefinition,
      this.translations[language] || this.translations["english"], this.variants !== undefined ? this.variants[(language !== undefined ? language : "english") + "_" + variant] : undefined);
    }
  }, {
    key: "getTranslation",
    value: function getTranslation(props, variant) {
      var language = props !== undefined && props.language !== undefined ? props.language : typeof props === "string" ? props : undefined;
      var languageVariant = props !== undefined && variant === undefined && props.variant !== undefined ? props.variant : variant;

      return mergeVariant(this.translations[language] || this.translations["english"], this.variants !== undefined ? this.variants[(language !== undefined ? language : "english") + "_" + languageVariant] : undefined);
    }
  }, {
    key: "createTranslatedForm",
    value: function createTranslatedForm(formDefinition, language, variant) {
      var labels = this.getFormLabels(formDefinition, language, variant);
      return formDefinition !== undefined ? formDefinition.map(function (area) {
        return translatedArea(area, labels);
      }) : undefined;
    }
  }, {
    key: "formatLabel",
    value: function formatLabel(message) {
      var args = Array.prototype.slice.call(arguments, 1);
      return message.replace(/{(\d+)}/g, function (match, number) {
        return typeof args[number] != 'undefined' ? args[number] : match;
      });
    }
  }]);

  return Translations;
}();

module.exports = Translations;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/**
 *  Copyright (c) 2014-2015, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  global.Immutable = factory();
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step > 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    findEntry: function(predicate, context) {
      var found;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findLastEntry: function(predicate, context) {
      return this.toSeq().reverse().findEntry(predicate, context);
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  // Temporary warning about using length
  (function () {
    try {
      Object.defineProperty(IterablePrototype, 'length', {
        get: function () {
          if (!Iterable.noLengthWarning) {
            var stack;
            try {
              throw new Error();
            } catch (error) {
              stack = error.stack;
            }
            if (stack.indexOf('_wrapObject') === -1) {
              console && console.warn && console.warn(
                'iterable.length has been deprecated, '+
                'use iterable.size or iterable.count(). '+
                'This warning will become a silent error in a future version. ' +
                stack
              );
              return this.size;
            }
          }
        }
      });
    } catch (e) {}
  })();



  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLastKey: function(predicate, context) {
      return this.toSeq().reverse().findKey(predicate, context);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    lastKeyOf: function(searchValue) {
      return this.findLastKey(function(value ) {return is(value, searchValue)});
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.toKeyedSeq().keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.toKeyedSeq().reverse().keyOf(searchValue);
      return key === undefined ? -1 : key;

      // var index =
      // return this.toSeq().reverse().indexOf(searchValue);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var key = this.toKeyedSeq().findLastKey(predicate, context);
      return key === undefined ? -1 : key;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : value;
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var validateFormat =  false ? function (format) {
  if (format === undefined) {
    throw new Error('invariant(...): Second argument must be a string.');
  }
} : function (format) {};
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments to provide
 * information about what broke and what you were expecting.
 *
 * The invariant message will be stripped in production, but the invariant will
 * remain to ensure logic does not differ in production.
 */

function invariant(condition, format) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  validateFormat(format);

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return String(args[argIndex++]);
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // Skip invariant's own stack frame.

    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Search = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Demo = __webpack_require__(308);

var _Demo2 = _interopRequireDefault(_Demo);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

var _performance = __webpack_require__(668);

var _performance2 = _interopRequireDefault(_performance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(206), __webpack_require__(207)]);

var Login = function (_React$Component) {
  _inherits(Login, _React$Component);

  function Login() {
    _classCallCheck(this, Login);

    return _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).apply(this, arguments));
  }

  _createClass(Login, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      return _react2.default.createElement('div', { title: labels.general.login, style: { background: "url('/icons/user_Avatar-32x48.png') 5px 5px no-repeat", backgroundSize: "20px 30px", height: 45 } });
    }
  }]);

  return Login;
}(_react2.default.Component);

var Profile = function (_React$Component2) {
  _inherits(Profile, _React$Component2);

  function Profile() {
    _classCallCheck(this, Profile);

    return _possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).apply(this, arguments));
  }

  _createClass(Profile, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      return _react2.default.createElement('div', { title: labels.general.profile, style: { background: "url('/icons/user_Avatar-32x48.png') 5px 5px no-repeat", backgroundSize: "20px 30px", height: 40 } });
    }
  }]);

  return Profile;
}(_react2.default.Component);

var SearchField = function (_React$Component3) {
  _inherits(SearchField, _React$Component3);

  function SearchField() {
    _classCallCheck(this, SearchField);

    return _possibleConstructorReturn(this, (SearchField.__proto__ || Object.getPrototypeOf(SearchField)).apply(this, arguments));
  }

  _createClass(SearchField, [{
    key: 'performSearch',
    value: function performSearch(event) {
      event.preventDefault();
    }
  }, {
    key: 'updateCriteria',
    value: function updateCriteria(event) {
      this.setState({ search: event.target.value });
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      return _react2.default.createElement(
        'div',
        { style: { width: 229, height: 38, background: "#374151", border: "1px solid #374151", boxSizing: "border-box", boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.05)", borderRadius: "6px" } },
        _react2.default.createElement(
          'form',
          { method: 'GET', action: '/search', style: { display: "flex", justifyContent: "flex-end" } },
          _react2.default.createElement(SearchIcon, null),
          _react2.default.createElement('input', { className: 'input', style: { marginTop: 2, fontSize: "14px", color: "white", background: "#374151", borderStyle: "none" }, autoFocus: true, name: 'criteria', placeholder: labels.general.search, onChange: this.updateCriteria.bind(this) })
        )
      );
    }
  }]);

  return SearchField;
}(_react2.default.Component);

var Add = function (_React$Component4) {
  _inherits(Add, _React$Component4);

  function Add() {
    _classCallCheck(this, Add);

    return _possibleConstructorReturn(this, (Add.__proto__ || Object.getPrototypeOf(Add)).apply(this, arguments));
  }

  _createClass(Add, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      return _react2.default.createElement('div', { title: labels.general.addProject, style: { background: "url('/images/Top_Plus.png') center", height: 40 } });
    }
  }]);

  return Add;
}(_react2.default.Component);

var Filter = function (_React$Component5) {
  _inherits(Filter, _React$Component5);

  function Filter() {
    _classCallCheck(this, Filter);

    return _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).apply(this, arguments));
  }

  _createClass(Filter, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      return _react2.default.createElement('div', { title: labels.general.filterProjects, style: { background: "url('/images/Top_Filter.gif') center", height: 40 } });
    }
  }]);

  return Filter;
}(_react2.default.Component);

var MenuEntry = function (_React$Component6) {
  _inherits(MenuEntry, _React$Component6);

  function MenuEntry() {
    _classCallCheck(this, MenuEntry);

    return _possibleConstructorReturn(this, (MenuEntry.__proto__ || Object.getPrototypeOf(MenuEntry)).apply(this, arguments));
  }

  _createClass(MenuEntry, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { width: 30, textAlign: "center", display: "inline-block", fontFamily: "Arial, 'Helvetica Neue', Helvetica, sans-serif", fontSize: "11px" } },
        _react2.default.createElement(
          'a',
          { href: this.props.link, style: { textDecoration: "none", color: "black" } },
          this.props.children
        )
      );
    }
  }]);

  return MenuEntry;
}(_react2.default.Component);

var Search = exports.Search = function (_React$Component7) {
  _inherits(Search, _React$Component7);

  function Search(props) {
    _classCallCheck(this, Search);

    var _this7 = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props));

    _this7.state = { showInput: false };
    return _this7;
  }

  _createClass(Search, [{
    key: 'search',
    value: function search(event) {
      event.preventDefault();
      this.setState({ showInput: !this.state.showInput });
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      return this.state.showInput ? _react2.default.createElement(
        'div',
        { style: { width: 300, textAlign: "right", height: 48 } },
        _react2.default.createElement(SearchField, this.props)
      ) : _react2.default.createElement(
        'div',
        { id: 'search', onClick: this.search.bind(this) },
        _react2.default.createElement(
          MenuEntry,
          _extends({}, this.props, { link: '#' }),
          _react2.default.createElement('div', { title: labels.general.search, style: { background: "url('/images/Top_Search.gif') -8px 2px no-repeat", height: 48 } })
        )
      );
    }
  }]);

  return Search;
}(_react2.default.Component);

var Menu = function (_React$Component8) {
  _inherits(Menu, _React$Component8);

  function Menu() {
    _classCallCheck(this, Menu);

    return _possibleConstructorReturn(this, (Menu.__proto__ || Object.getPrototypeOf(Menu)).apply(this, arguments));
  }

  _createClass(Menu, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { float: "right", display: "flex", justifyContent: "space-around", paddingTop: this.props.topMargin, marginRight: 30 } },
        _react2.default.createElement(
          MenuEntry,
          _extends({}, this.props, { link: '/add' }),
          _react2.default.createElement(Add, this.props)
        ),
        this.props.user !== undefined ? _react2.default.createElement(
          MenuEntry,
          _extends({}, this.props, { link: '/filter' }),
          _react2.default.createElement(Filter, this.props)
        ) : null,
        this.props.user !== undefined ? _react2.default.createElement(
          MenuEntry,
          _extends({}, this.props, { link: '/profile' }),
          _react2.default.createElement(Profile, this.props)
        ) : this.props.tenant !== undefined && this.props.tenant.name ? _react2.default.createElement(
          MenuEntry,
          _extends({}, this.props, { link: '/setupTenant.html' }),
          _react2.default.createElement(Profile, this.props)
        ) : _react2.default.createElement(
          MenuEntry,
          _extends({}, this.props, { link: '/login' }),
          _react2.default.createElement(Login, this.props)
        )
      );
    }
  }]);

  return Menu;
}(_react2.default.Component);

var HamburgerIcon = function (_React$Component9) {
  _inherits(HamburgerIcon, _React$Component9);

  function HamburgerIcon() {
    _classCallCheck(this, HamburgerIcon);

    return _possibleConstructorReturn(this, (HamburgerIcon.__proto__ || Object.getPrototypeOf(HamburgerIcon)).apply(this, arguments));
  }

  _createClass(HamburgerIcon, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        { style: { marginLeft: 20, marginRight: 15 } },
        _react2.default.createElement(
          'svg',
          { width: '24', height: '16', viewBox: '0 0 20 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
          _react2.default.createElement('path', { d: 'M2 15H18.25', stroke: '#6B7280', strokeWidth: '1.25', strokeLinecap: 'round', strokeLinejoin: 'round' }),
          _react2.default.createElement('path', { d: 'M2 10H18.25', stroke: '#6B7280', strokeWidth: '1.25', strokeLinecap: 'round', strokeLinejoin: 'round' }),
          _react2.default.createElement('path', { d: 'M2 5H18.25', stroke: '#6B7280', strokeWidth: '1.25', strokeLinecap: 'round', strokeLinejoin: 'round' })
        )
      );
    }
  }]);

  return HamburgerIcon;
}(_react2.default.Component);

var SearchIcon = function (_React$Component10) {
  _inherits(SearchIcon, _React$Component10);

  function SearchIcon() {
    _classCallCheck(this, SearchIcon);

    return _possibleConstructorReturn(this, (SearchIcon.__proto__ || Object.getPrototypeOf(SearchIcon)).apply(this, arguments));
  }

  _createClass(SearchIcon, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        { style: { marginLeft: 15, marginRight: 10, marginTop: 10 } },
        _react2.default.createElement(
          'svg',
          { className: 'icon bs-nm  ', width: '16', height: '16', viewBox: '0 0 20 20', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
          _react2.default.createElement('path', { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4ZM2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 9.29583 13.5892 10.4957 12.8907 11.4765L17.7071 16.2929C18.0976 16.6834 18.0976 17.3166 17.7071 17.7071C17.3166 18.0976 16.6834 18.0976 16.2929 17.7071L11.4765 12.8907C10.4957 13.5892 9.29583 14 8 14C4.68629 14 2 11.3137 2 8Z', fill: '#9A9EB1' })
        )
      );
    }
  }]);

  return SearchIcon;
}(_react2.default.Component);

var HomeIcon = function (_React$Component11) {
  _inherits(HomeIcon, _React$Component11);

  function HomeIcon() {
    _classCallCheck(this, HomeIcon);

    return _possibleConstructorReturn(this, (HomeIcon.__proto__ || Object.getPrototypeOf(HomeIcon)).apply(this, arguments));
  }

  _createClass(HomeIcon, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'svg',
          { className: 'icon bs-nm', width: '16', height: '16', viewBox: '0 0 20 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
          _react2.default.createElement('path', { d: 'M17.8045 9.52852L10.4712 2.19519C10.3462 2.07021 10.1766 2 9.99986 2C9.82308 2 9.65354 2.07021 9.52852 2.19519L2.19519 9.52852C2.10198 9.62176 2.03851 9.74054 2.0128 9.86984C1.98709 9.99914 2.00029 10.1332 2.05074 10.255C2.10119 10.3768 2.18661 10.4809 2.29622 10.5541C2.40583 10.6274 2.53469 10.6665 2.66652 10.6665H3.49986C3.54406 10.6665 3.58645 10.6841 3.61771 10.7153C3.64897 10.7466 3.66652 10.789 3.66652 10.8332V17.3332C3.66652 17.51 3.73676 17.6796 3.86179 17.8046C3.98681 17.9296 4.15638 17.9999 4.33319 17.9999H8.16652C8.21073 17.9999 8.25312 17.9823 8.28438 17.951C8.31563 17.9198 8.33319 17.8774 8.33319 17.8332V14.6665C8.33319 14.2245 8.50879 13.8006 8.82135 13.488C9.13391 13.1755 9.55783 12.9999 9.99986 12.9999C10.4419 12.9999 10.8658 13.1755 11.1784 13.488C11.4909 13.8006 11.6665 14.2245 11.6665 14.6665V17.8332C11.6665 17.8774 11.6841 17.9198 11.7153 17.951C11.7466 17.9823 11.789 17.9999 11.8332 17.9999H15.6665C15.8433 17.9999 16.0129 17.9296 16.1379 17.8046C16.263 17.6796 16.3332 17.51 16.3332 17.3332V10.8332C16.3332 10.789 16.3507 10.7466 16.382 10.7153C16.4133 10.6841 16.4557 10.6665 16.4999 10.6665H17.3332C17.465 10.6665 17.5939 10.6274 17.7035 10.5541C17.8131 10.4809 17.8985 10.3768 17.949 10.255C17.9994 10.1332 18.0126 9.99914 17.9869 9.86984C17.9612 9.74054 17.8977 9.62176 17.8045 9.52852Z', fill: '#9A9EB1' })
        )
      );
    }
  }]);

  return HomeIcon;
}(_react2.default.Component);

var Separator = function (_React$Component12) {
  _inherits(Separator, _React$Component12);

  function Separator() {
    _classCallCheck(this, Separator);

    return _possibleConstructorReturn(this, (Separator.__proto__ || Object.getPrototypeOf(Separator)).apply(this, arguments));
  }

  _createClass(Separator, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        { style: { marginLeft: 16, marginRight: 16 } },
        _react2.default.createElement(
          'svg',
          { width: '7', height: '10', viewBox: '0 0 7 10', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
          _react2.default.createElement('path', { d: 'M6.9692 5C6.96937 5.1366 6.9404 5.27167 6.88423 5.39619C6.82805 5.52071 6.74597 5.63182 6.64344 5.72209L1.98596 9.81953C1.83162 9.94903 1.63274 10.013 1.43184 9.99779C1.23095 9.98257 1.04398 9.88935 0.910916 9.73807C0.777855 9.58679 0.709263 9.38945 0.719808 9.18825C0.730353 8.98705 0.819197 8.79797 0.967343 8.66142L5.04014 5.07852C5.05132 5.06872 5.06027 5.05664 5.06641 5.0431C5.07255 5.02956 5.07572 5.01487 5.07572 5C5.07572 4.98513 5.07255 4.97044 5.06641 4.9569C5.06027 4.94336 5.05132 4.93128 5.04014 4.92148L0.967343 1.33858C0.819197 1.20203 0.730353 1.01295 0.719808 0.811749C0.709263 0.610551 0.777855 0.413213 0.910916 0.261931C1.04398 0.110648 1.23095 0.0174293 1.43184 0.0022066C1.63274 -0.0130161 1.83162 0.0509657 1.98596 0.180471L6.64177 4.27665C6.74455 4.36709 6.8269 4.47836 6.88335 4.60308C6.93981 4.7278 6.96907 4.8631 6.9692 5Z', fill: '#9A9EB1' })
        )
      );
    }
  }]);

  return Separator;
}(_react2.default.Component);

var Navigation = function (_React$Component13) {
  _inherits(Navigation, _React$Component13);

  function Navigation() {
    _classCallCheck(this, Navigation);

    return _possibleConstructorReturn(this, (Navigation.__proto__ || Object.getPrototypeOf(Navigation)).apply(this, arguments));
  }

  _createClass(Navigation, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      var link = this.props.projectMenu === undefined ? "?showMenu=true" : "?";
      var href = (this.props.portfolioSource !== undefined ? this.props.portfolioSource : '') + (this.props.project.isProgramme ? "/programmes/" : this.props.project.isProduct ? "/products/" : this.props.project.isRelease ? "/releases/" : "/projects/") + this.props.project.id;
      return _react2.default.createElement(
        'span',
        null,
        this.props.parent !== undefined ? "  /  " : null,
        _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'a',
            { href: href, style: { color: this.props.layout.color, textDecoration: "none" } },
            this.props.project.releaseName || this.props.project.name
          )
        ),
        _react2.default.createElement(
          'span',
          { title: labels.general.projectMenu, style: { marginLeft: 15 } },
          _react2.default.createElement(
            'a',
            { href: link },
            _react2.default.createElement(HamburgerIcon, null)
          ),
          _react2.default.createElement(
            'div',
            { id: 'projectMenu' },
            this.props.projectMenu
          )
        )
      );
    }
  }]);

  return Navigation;
}(_react2.default.Component);

var ClientScriptConfig = function (_React$Component14) {
  _inherits(ClientScriptConfig, _React$Component14);

  function ClientScriptConfig() {
    _classCallCheck(this, ClientScriptConfig);

    return _possibleConstructorReturn(this, (ClientScriptConfig.__proto__ || Object.getPrototypeOf(ClientScriptConfig)).apply(this, arguments));
  }

  _createClass(ClientScriptConfig, [{
    key: 'transferState',
    value: function transferState() {
      var clientDataWithLanguageSettings = Object.assign({}, this.props.client, {
        language: this.props.language,
        variant: this.props.variant,
        tenant: _performance2.default.strippedTenant(this.props.client.tenant, this.props.client.includeStakeholders),
        showMenu: this.props.showMenu,
        project: _performance2.default.strippetProject(this.props.client.project)
      });
      if (this.props.environment !== undefined && this.props.environment.demo !== undefined) {
        clientDataWithLanguageSettings.environment = { demo: this.props.environment.demo };
      }
      return { __html: "window.APP_DATA=" + JSON.stringify(clientDataWithLanguageSettings) };
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.client !== undefined ? _react2.default.createElement('script', { lang: 'javascript', dangerouslySetInnerHTML: this.transferState() }) : null;
    }
  }]);

  return ClientScriptConfig;
}(_react2.default.Component);

var PortfolioNavigation = function (_React$Component15) {
  _inherits(PortfolioNavigation, _React$Component15);

  function PortfolioNavigation() {
    _classCallCheck(this, PortfolioNavigation);

    return _possibleConstructorReturn(this, (PortfolioNavigation.__proto__ || Object.getPrototypeOf(PortfolioNavigation)).apply(this, arguments));
  }

  _createClass(PortfolioNavigation, [{
    key: 'getPortfolioUrl',
    value: function getPortfolioUrl(source, portfolio) {
      return (source !== undefined ? source + "/portfolios/" : "/portfolio/") + (portfolio.id !== "other" ? portfolio.id : source !== undefined ? "_other" : portfolio.id);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this16 = this;

      var labels = translations.getTranslation(this.props);
      var portfolio = this.props.portfolio !== undefined ? this.props.portfolio : this.props.project !== undefined && this.props.project.portfolio !== undefined && this.props.tenant.portfolios !== undefined ? this.props.tenant.portfolios.filter(function (portfolio) {
        return portfolio.id === _this16.props.project.portfolio;
      })[0] : undefined;
      if (this.props.project !== undefined && portfolio === undefined && this.props.tenant !== undefined && this.props.tenant.portfolios !== undefined && this.props.tenant.portfolios.length > 0) {
        portfolio = { id: "other", name: labels.general.otherPortfolio };
      }
      if (portfolio !== undefined && portfolio.other) {
        portfolio.name = labels.general.otherPortfolio;
        portfolio.id = "other";
      }
      return portfolio !== undefined ? _react2.default.createElement(
        'span',
        null,
        portfolio.name !== undefined ? _react2.default.createElement(
          'a',
          { style: { color: this.props.layout.color, textDecoration: "none", fontfamily: "Lato", fontstyle: "normal", fontweight: "normal", fontsize: "14px", lineheight: "20px" }, href: this.getPortfolioUrl(this.props.portfolioSource, portfolio) },
          ' ',
          _react2.default.createElement(Separator, null),
          portfolio.name
        ) : portfolio,
        portfolio.id === "other" && this.props.project !== undefined ? "  /  " : null
      ) : null;
    }
  }]);

  return PortfolioNavigation;
}(_react2.default.Component);

var ClientScript = function (_React$Component16) {
  _inherits(ClientScript, _React$Component16);

  function ClientScript() {
    _classCallCheck(this, ClientScript);

    return _possibleConstructorReturn(this, (ClientScript.__proto__ || Object.getPrototypeOf(ClientScript)).apply(this, arguments));
  }

  _createClass(ClientScript, [{
    key: 'render',
    value: function render() {
      return this.props.client !== undefined ? _react2.default.createElement('script', { src: '/client/bundle.js' }) : null;
    }
  }]);

  return ClientScript;
}(_react2.default.Component);

var EnvironmentDetails = function (_React$Component17) {
  _inherits(EnvironmentDetails, _React$Component17);

  function EnvironmentDetails() {
    _classCallCheck(this, EnvironmentDetails);

    return _possibleConstructorReturn(this, (EnvironmentDetails.__proto__ || Object.getPrototypeOf(EnvironmentDetails)).apply(this, arguments));
  }

  _createClass(EnvironmentDetails, [{
    key: 'render',
    value: function render() {
      return this.props.environment !== undefined ? _react2.default.createElement(
        'div',
        { style: { position: "relative" } },
        this.props.environment.name !== "production" ? _react2.default.createElement(
          'div',
          { style: { position: "fixed", top: 0, bottom: 0, left: 0, right: 0, display: "flex", justifyContent: "center", alignItems: "center", pointerEvents: "none", zIndex: 9999 } },
          _react2.default.createElement(
            'div',
            { style: { color: "rgba(255,0,0,0.15)", fontSize: "8em", transform: "rotate(-45deg)" } },
            this.props.environment.name !== undefined ? this.props.environment.name : "local"
          )
        ) : null,
        this.props.environment.disabledPersistence ? _react2.default.createElement(
          'div',
          { id: 'demo' },
          _react2.default.createElement(_Demo2.default, this.props)
        ) : null
      ) : null;
    }
  }]);

  return EnvironmentDetails;
}(_react2.default.Component);

var Layout = function (_React$Component18) {
  _inherits(Layout, _React$Component18);

  function Layout() {
    _classCallCheck(this, Layout);

    return _possibleConstructorReturn(this, (Layout.__proto__ || Object.getPrototypeOf(Layout)).apply(this, arguments));
  }

  _createClass(Layout, [{
    key: 'render',
    value: function render() {
      var _this20 = this;

      var labels = translations.getTranslation(this.props);
      var defaultLayout = {
        logo: "/progreto_logo.png",
        color: "#595959",
        height: 46,
        width: 149,
        size: 119,
        position: 30,
        backgroundColor: "#1F2937",
        showTenantName: true
      };
      var layout = this.props.tenant !== undefined && this.props.tenant.design !== undefined && this.props.tenant.design.enabled ? this.props.tenant.design : defaultLayout;

      var foundTenant = this.props.project !== undefined && this.props.tenant !== undefined && this.props.tenant.portfolios != undefined && this.props.tenant.portfolios.length > 0 ? this.props.tenant.portfolios.filter(function (portfolio) {
        return portfolio.id === _this20.props.project.portfolio;
      })[0] : undefined;
      var portfolio = this.props.project !== undefined && this.props.project.portfolio !== undefined && this.props.tenant.portfolios !== undefined ? foundTenant !== undefined ? foundTenant : { id: "other", name: labels.general.otherPortfolio } : undefined;

      var project = this.props.project !== undefined ? _react2.default.createElement(Navigation, _extends({}, this.props, { layout: layout, parent: portfolio, project: this.props.project, projectMenu: this.props.projectMenu })) : "";
      var tenantName = this.props.tenant !== undefined && this.props.tenant.name !== undefined ? this.props.tenant.name : _react2.default.createElement(
        'span',
        null,
        '<',
        labels.general.unknownTenantName,
        '>'
      );

      var htmlLanguage = function htmlLanguage() {
        switch (_this20.props.language) {
          case "norwegian":
            return "nb";
          default:
            return "en";
        }
      };

      return _react2.default.createElement(
        'html',
        { lang: htmlLanguage() },
        _react2.default.createElement(
          'head',
          null,
          _react2.default.createElement('meta', { charSet: 'utf-8' }),
          _react2.default.createElement('meta', { name: 'viewport', content: 'width=device-width, initial-scale=1.0' }),
          _react2.default.createElement('meta', { name: 'description', content: 'Progreto - implementing your strategic plan' }),
          _react2.default.createElement('link', { rel: 'stylesheet', href: '/progreto.css' }),
          _react2.default.createElement('link', { href: 'https://fonts.googleapis.com/css?family=Lato&display=swap', rel: 'stylesheet' }),
          _react2.default.createElement(
            'title',
            null,
            layout.title !== undefined ? layout.title : "Progreto - implementing your strategic plan"
          ),
          _react2.default.createElement(ClientScriptConfig, _extends({}, this.props, { client: this.props.client !== undefined ? this.props.client : "true" }))
        ),
        _react2.default.createElement(
          'body',
          { style: { marginTop: 0, marginLeft: 0, marginRight: 0 } },
          _react2.default.createElement(EnvironmentDetails, this.props),
          _react2.default.createElement(
            'div',
            { style: { width: "100%" } },
            _react2.default.createElement(
              'div',
              { style: { display: "inline-block", color: layout.color, position: "relative", width: "100%", borderBottom: "2px solid #f5f5f5" } },
              _react2.default.createElement(
                'div',
                { style: { width: "100%", margin: "0 auto !important", backgroundColor: layout.backgroundColor } },
                _react2.default.createElement(
                  'div',
                  { style: { maxWidth: 1400, float: "none", width: "100%", margin: "0 auto !important", backgroundColor: layout.backgroundColor, height: layout.height + 18, marginBottom: 20 } },
                  _react2.default.createElement(
                    'a',
                    { style: { position: "absolute", paddingTop: 3, height: layout.height, width: layout.width, backgroundImage: layout.background !== undefined ? "url('" + layout.background + "')" : undefined, backgroundSize: "auto", backgroundRepeat: "no-repeat", backgroundColor: layout.backgroundColor }, href: this.props.portfolioSource !== undefined ? this.props.portfolioSource : "/" },
                    _react2.default.createElement('div', { style: { display: "inline-block", width: layout.width, height: layout.height, paddingTop: 10, backgroundImage: "url('" + layout.logo + "')", backgroundPosition: layout.position, backgroundSize: layout.size !== undefined ? layout.size : "contain", backgroundRepeat: "no-repeat" } })
                  ),
                  this.props.user !== undefined ? _react2.default.createElement(
                    'div',
                    { style: { paddingLeft: layout.width + 50, paddingTop: 13 } },
                    _react2.default.createElement(SearchField, this.props)
                  ) : null
                )
              ),
              _react2.default.createElement(
                'div',
                { style: { maxWidth: 1400, float: "none", margin: "0 auto !important", paddingTop: 10, marginBottom: 10 } },
                _react2.default.createElement(
                  'div',
                  { style: { marginLeft: 30, marginTop: 5, display: "inline-block", fontFamily: "Lato, Georgia, Times, 'Times New Roman', serif", color: layout.color, fontSize: "14px" } },
                  _react2.default.createElement(
                    'a',
                    { href: this.props.portfolioSource !== undefined ? this.props.portfolioSource : "/" },
                    _react2.default.createElement(HomeIcon, null)
                  ),
                  _react2.default.createElement(PortfolioNavigation, _extends({}, this.props, { layout: layout })),
                  project
                ),
                _react2.default.createElement(Menu, _extends({}, this.props, { topMargin: 0 }))
              )
            )
          ),
          layout.showTenantName ? _react2.default.createElement(
            'div',
            { style: { maxWidth: 1400, float: "none", margin: "0 auto !important" } },
            _react2.default.createElement(
              'div',
              { style: { paddingLeft: 30, paddingTop: 10, fontFamily: "Lato", fontSize: "120%" } },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'a',
                  { href: '/setupTenant.html', style: { color: layout.color, textDecoration: "none" } },
                  tenantName
                )
              )
            )
          ) : null,
          _react2.default.createElement(
            'div',
            { style: { maxWidth: 1400, float: "none", margin: "0 auto !important" }, id: this.props.view },
            this.props.children
          ),
          _react2.default.createElement(ClientScript, _extends({}, this.props, { client: this.props.client !== undefined ? this.props.client : "true" }))
        )
      );
    }
  }]);

  return Layout;
}(_react2.default.Component);

exports.default = Layout;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BlockTree = __webpack_require__(814);

var ContentState = __webpack_require__(225);

var EditorBidiService = __webpack_require__(816);

var SelectionState = __webpack_require__(159);

var Immutable = __webpack_require__(4);

var OrderedSet = Immutable.OrderedSet,
    Record = Immutable.Record,
    Stack = Immutable.Stack,
    OrderedMap = Immutable.OrderedMap,
    List = Immutable.List; // When configuring an editor, the user can chose to provide or not provide
// basically all keys. `currentContent` varies, so this type doesn't include it.
// (See the types defined below.)

var defaultRecord = {
  allowUndo: true,
  currentContent: null,
  decorator: null,
  directionMap: null,
  forceSelection: false,
  inCompositionMode: false,
  inlineStyleOverride: null,
  lastChangeType: null,
  nativelyRenderedContent: null,
  redoStack: Stack(),
  selection: null,
  treeMap: null,
  undoStack: Stack()
};
var EditorStateRecord = Record(defaultRecord);

var EditorState = /*#__PURE__*/function () {
  EditorState.createEmpty = function createEmpty(decorator) {
    return this.createWithText('', decorator);
  };

  EditorState.createWithText = function createWithText(text, decorator) {
    return EditorState.createWithContent(ContentState.createFromText(text), decorator);
  };

  EditorState.createWithContent = function createWithContent(contentState, decorator) {
    if (contentState.getBlockMap().count() === 0) {
      return EditorState.createEmpty(decorator);
    }

    var firstKey = contentState.getBlockMap().first().getKey();
    return EditorState.create({
      currentContent: contentState,
      undoStack: Stack(),
      redoStack: Stack(),
      decorator: decorator || null,
      selection: SelectionState.createEmpty(firstKey)
    });
  };

  EditorState.create = function create(config) {
    var currentContent = config.currentContent,
        decorator = config.decorator;

    var recordConfig = _objectSpread({}, config, {
      treeMap: generateNewTreeMap(currentContent, decorator),
      directionMap: EditorBidiService.getDirectionMap(currentContent)
    });

    return new EditorState(new EditorStateRecord(recordConfig));
  };

  EditorState.fromJS = function fromJS(config) {
    return new EditorState(new EditorStateRecord(_objectSpread({}, config, {
      directionMap: config.directionMap != null ? OrderedMap(config.directionMap) : config.directionMap,
      inlineStyleOverride: config.inlineStyleOverride != null ? OrderedSet(config.inlineStyleOverride) : config.inlineStyleOverride,
      nativelyRenderedContent: config.nativelyRenderedContent != null ? ContentState.fromJS(config.nativelyRenderedContent) : config.nativelyRenderedContent,
      redoStack: config.redoStack != null ? Stack(config.redoStack.map(function (v) {
        return ContentState.fromJS(v);
      })) : config.redoStack,
      selection: config.selection != null ? new SelectionState(config.selection) : config.selection,
      treeMap: config.treeMap != null ? OrderedMap(config.treeMap).map(function (v) {
        return List(v).map(function (v) {
          return BlockTree.fromJS(v);
        });
      }) : config.treeMap,
      undoStack: config.undoStack != null ? Stack(config.undoStack.map(function (v) {
        return ContentState.fromJS(v);
      })) : config.undoStack,
      currentContent: ContentState.fromJS(config.currentContent)
    })));
  };

  EditorState.set = function set(editorState, put) {
    var map = editorState.getImmutable().withMutations(function (state) {
      var existingDecorator = state.get('decorator');
      var decorator = existingDecorator;

      if (put.decorator === null) {
        decorator = null;
      } else if (put.decorator) {
        decorator = put.decorator;
      }

      var newContent = put.currentContent || editorState.getCurrentContent();

      if (decorator !== existingDecorator) {
        var treeMap = state.get('treeMap');
        var newTreeMap;

        if (decorator && existingDecorator) {
          newTreeMap = regenerateTreeForNewDecorator(newContent, newContent.getBlockMap(), treeMap, decorator, existingDecorator);
        } else {
          newTreeMap = generateNewTreeMap(newContent, decorator);
        }

        state.merge({
          decorator: decorator,
          treeMap: newTreeMap,
          nativelyRenderedContent: null
        });
        return;
      }

      var existingContent = editorState.getCurrentContent();

      if (newContent !== existingContent) {
        state.set('treeMap', regenerateTreeForNewBlocks(editorState, newContent.getBlockMap(), newContent.getEntityMap(), decorator));
      }

      state.merge(put);
    });
    return new EditorState(map);
  };

  var _proto = EditorState.prototype;

  _proto.toJS = function toJS() {
    return this.getImmutable().toJS();
  };

  _proto.getAllowUndo = function getAllowUndo() {
    return this.getImmutable().get('allowUndo');
  };

  _proto.getCurrentContent = function getCurrentContent() {
    return this.getImmutable().get('currentContent');
  };

  _proto.getUndoStack = function getUndoStack() {
    return this.getImmutable().get('undoStack');
  };

  _proto.getRedoStack = function getRedoStack() {
    return this.getImmutable().get('redoStack');
  };

  _proto.getSelection = function getSelection() {
    return this.getImmutable().get('selection');
  };

  _proto.getDecorator = function getDecorator() {
    return this.getImmutable().get('decorator');
  };

  _proto.isInCompositionMode = function isInCompositionMode() {
    return this.getImmutable().get('inCompositionMode');
  };

  _proto.mustForceSelection = function mustForceSelection() {
    return this.getImmutable().get('forceSelection');
  };

  _proto.getNativelyRenderedContent = function getNativelyRenderedContent() {
    return this.getImmutable().get('nativelyRenderedContent');
  };

  _proto.getLastChangeType = function getLastChangeType() {
    return this.getImmutable().get('lastChangeType');
  }
  /**
   * While editing, the user may apply inline style commands with a collapsed
   * cursor, intending to type text that adopts the specified style. In this
   * case, we track the specified style as an "override" that takes precedence
   * over the inline style of the text adjacent to the cursor.
   *
   * If null, there is no override in place.
   */
  ;

  _proto.getInlineStyleOverride = function getInlineStyleOverride() {
    return this.getImmutable().get('inlineStyleOverride');
  };

  EditorState.setInlineStyleOverride = function setInlineStyleOverride(editorState, inlineStyleOverride) {
    return EditorState.set(editorState, {
      inlineStyleOverride: inlineStyleOverride
    });
  }
  /**
   * Get the appropriate inline style for the editor state. If an
   * override is in place, use it. Otherwise, the current style is
   * based on the location of the selection state.
   */
  ;

  _proto.getCurrentInlineStyle = function getCurrentInlineStyle() {
    var override = this.getInlineStyleOverride();

    if (override != null) {
      return override;
    }

    var content = this.getCurrentContent();
    var selection = this.getSelection();

    if (selection.isCollapsed()) {
      return getInlineStyleForCollapsedSelection(content, selection);
    }

    return getInlineStyleForNonCollapsedSelection(content, selection);
  };

  _proto.getBlockTree = function getBlockTree(blockKey) {
    return this.getImmutable().getIn(['treeMap', blockKey]);
  };

  _proto.isSelectionAtStartOfContent = function isSelectionAtStartOfContent() {
    var firstKey = this.getCurrentContent().getBlockMap().first().getKey();
    return this.getSelection().hasEdgeWithin(firstKey, 0, 0);
  };

  _proto.isSelectionAtEndOfContent = function isSelectionAtEndOfContent() {
    var content = this.getCurrentContent();
    var blockMap = content.getBlockMap();
    var last = blockMap.last();
    var end = last.getLength();
    return this.getSelection().hasEdgeWithin(last.getKey(), end, end);
  };

  _proto.getDirectionMap = function getDirectionMap() {
    return this.getImmutable().get('directionMap');
  }
  /**
   * Incorporate native DOM selection changes into the EditorState. This
   * method can be used when we simply want to accept whatever the DOM
   * has given us to represent selection, and we do not need to re-render
   * the editor.
   *
   * To forcibly move the DOM selection, see `EditorState.forceSelection`.
   */
  ;

  EditorState.acceptSelection = function acceptSelection(editorState, selection) {
    return updateSelection(editorState, selection, false);
  }
  /**
   * At times, we need to force the DOM selection to be where we
   * need it to be. This can occur when the anchor or focus nodes
   * are non-text nodes, for instance. In this case, we want to trigger
   * a re-render of the editor, which in turn forces selection into
   * the correct place in the DOM. The `forceSelection` method
   * accomplishes this.
   *
   * This method should be used in cases where you need to explicitly
   * move the DOM selection from one place to another without a change
   * in ContentState.
   */
  ;

  EditorState.forceSelection = function forceSelection(editorState, selection) {
    if (!selection.getHasFocus()) {
      selection = selection.set('hasFocus', true);
    }

    return updateSelection(editorState, selection, true);
  }
  /**
   * Move selection to the end of the editor without forcing focus.
   */
  ;

  EditorState.moveSelectionToEnd = function moveSelectionToEnd(editorState) {
    var content = editorState.getCurrentContent();
    var lastBlock = content.getLastBlock();
    var lastKey = lastBlock.getKey();
    var length = lastBlock.getLength();
    return EditorState.acceptSelection(editorState, new SelectionState({
      anchorKey: lastKey,
      anchorOffset: length,
      focusKey: lastKey,
      focusOffset: length,
      isBackward: false
    }));
  }
  /**
   * Force focus to the end of the editor. This is useful in scenarios
   * where we want to programmatically focus the input and it makes sense
   * to allow the user to continue working seamlessly.
   */
  ;

  EditorState.moveFocusToEnd = function moveFocusToEnd(editorState) {
    var afterSelectionMove = EditorState.moveSelectionToEnd(editorState);
    return EditorState.forceSelection(afterSelectionMove, afterSelectionMove.getSelection());
  }
  /**
   * Push the current ContentState onto the undo stack if it should be
   * considered a boundary state, and set the provided ContentState as the
   * new current content.
   */
  ;

  EditorState.push = function push(editorState, contentState, changeType) {
    var forceSelection = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    if (editorState.getCurrentContent() === contentState) {
      return editorState;
    }

    var directionMap = EditorBidiService.getDirectionMap(contentState, editorState.getDirectionMap());

    if (!editorState.getAllowUndo()) {
      return EditorState.set(editorState, {
        currentContent: contentState,
        directionMap: directionMap,
        lastChangeType: changeType,
        selection: contentState.getSelectionAfter(),
        forceSelection: forceSelection,
        inlineStyleOverride: null
      });
    }

    var selection = editorState.getSelection();
    var currentContent = editorState.getCurrentContent();
    var undoStack = editorState.getUndoStack();
    var newContent = contentState;

    if (selection !== currentContent.getSelectionAfter() || mustBecomeBoundary(editorState, changeType)) {
      undoStack = undoStack.push(currentContent);
      newContent = newContent.set('selectionBefore', selection);
    } else if (changeType === 'insert-characters' || changeType === 'backspace-character' || changeType === 'delete-character') {
      // Preserve the previous selection.
      newContent = newContent.set('selectionBefore', currentContent.getSelectionBefore());
    }

    var inlineStyleOverride = editorState.getInlineStyleOverride(); // Don't discard inline style overrides for the following change types:

    var overrideChangeTypes = ['adjust-depth', 'change-block-type', 'split-block'];

    if (overrideChangeTypes.indexOf(changeType) === -1) {
      inlineStyleOverride = null;
    }

    var editorStateChanges = {
      currentContent: newContent,
      directionMap: directionMap,
      undoStack: undoStack,
      redoStack: Stack(),
      lastChangeType: changeType,
      selection: contentState.getSelectionAfter(),
      forceSelection: forceSelection,
      inlineStyleOverride: inlineStyleOverride
    };
    return EditorState.set(editorState, editorStateChanges);
  }
  /**
   * Make the top ContentState in the undo stack the new current content and
   * push the current content onto the redo stack.
   */
  ;

  EditorState.undo = function undo(editorState) {
    if (!editorState.getAllowUndo()) {
      return editorState;
    }

    var undoStack = editorState.getUndoStack();
    var newCurrentContent = undoStack.peek();

    if (!newCurrentContent) {
      return editorState;
    }

    var currentContent = editorState.getCurrentContent();
    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
    return EditorState.set(editorState, {
      currentContent: newCurrentContent,
      directionMap: directionMap,
      undoStack: undoStack.shift(),
      redoStack: editorState.getRedoStack().push(currentContent),
      forceSelection: true,
      inlineStyleOverride: null,
      lastChangeType: 'undo',
      nativelyRenderedContent: null,
      selection: currentContent.getSelectionBefore()
    });
  }
  /**
   * Make the top ContentState in the redo stack the new current content and
   * push the current content onto the undo stack.
   */
  ;

  EditorState.redo = function redo(editorState) {
    if (!editorState.getAllowUndo()) {
      return editorState;
    }

    var redoStack = editorState.getRedoStack();
    var newCurrentContent = redoStack.peek();

    if (!newCurrentContent) {
      return editorState;
    }

    var currentContent = editorState.getCurrentContent();
    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
    return EditorState.set(editorState, {
      currentContent: newCurrentContent,
      directionMap: directionMap,
      undoStack: editorState.getUndoStack().push(currentContent),
      redoStack: redoStack.shift(),
      forceSelection: true,
      inlineStyleOverride: null,
      lastChangeType: 'redo',
      nativelyRenderedContent: null,
      selection: newCurrentContent.getSelectionAfter()
    });
  }
  /**
   * Not for public consumption.
   */
  ;

  function EditorState(immutable) {
    _defineProperty(this, "_immutable", void 0);

    this._immutable = immutable;
  }
  /**
   * Not for public consumption.
   */


  _proto.getImmutable = function getImmutable() {
    return this._immutable;
  };

  return EditorState;
}();
/**
 * Set the supplied SelectionState as the new current selection, and set
 * the `force` flag to trigger manual selection placement by the view.
 */


function updateSelection(editorState, selection, forceSelection) {
  return EditorState.set(editorState, {
    selection: selection,
    forceSelection: forceSelection,
    nativelyRenderedContent: null,
    inlineStyleOverride: null
  });
}
/**
 * Regenerate the entire tree map for a given ContentState and decorator.
 * Returns an OrderedMap that maps all available ContentBlock objects.
 */


function generateNewTreeMap(contentState, decorator) {
  return contentState.getBlockMap().map(function (block) {
    return BlockTree.generate(contentState, block, decorator);
  }).toOrderedMap();
}
/**
 * Regenerate tree map objects for all ContentBlocks that have changed
 * between the current editorState and newContent. Returns an OrderedMap
 * with only changed regenerated tree map objects.
 */


function regenerateTreeForNewBlocks(editorState, newBlockMap, newEntityMap, decorator) {
  var contentState = editorState.getCurrentContent().set('entityMap', newEntityMap);
  var prevBlockMap = contentState.getBlockMap();
  var prevTreeMap = editorState.getImmutable().get('treeMap');
  return prevTreeMap.merge(newBlockMap.toSeq().filter(function (block, key) {
    return block !== prevBlockMap.get(key);
  }).map(function (block) {
    return BlockTree.generate(contentState, block, decorator);
  }));
}
/**
 * Generate tree map objects for a new decorator object, preserving any
 * decorations that are unchanged from the previous decorator.
 *
 * Note that in order for this to perform optimally, decoration Lists for
 * decorators should be preserved when possible to allow for direct immutable
 * List comparison.
 */


function regenerateTreeForNewDecorator(content, blockMap, previousTreeMap, decorator, existingDecorator) {
  return previousTreeMap.merge(blockMap.toSeq().filter(function (block) {
    return decorator.getDecorations(block, content) !== existingDecorator.getDecorations(block, content);
  }).map(function (block) {
    return BlockTree.generate(content, block, decorator);
  }));
}
/**
 * Return whether a change should be considered a boundary state, given
 * the previous change type. Allows us to discard potential boundary states
 * during standard typing or deletion behavior.
 */


function mustBecomeBoundary(editorState, changeType) {
  var lastChangeType = editorState.getLastChangeType();
  return changeType !== lastChangeType || changeType !== 'insert-characters' && changeType !== 'backspace-character' && changeType !== 'delete-character';
}

function getInlineStyleForCollapsedSelection(content, selection) {
  var startKey = selection.getStartKey();
  var startOffset = selection.getStartOffset();
  var startBlock = content.getBlockForKey(startKey); // If the cursor is not at the start of the block, look backward to
  // preserve the style of the preceding character.

  if (startOffset > 0) {
    return startBlock.getInlineStyleAt(startOffset - 1);
  } // The caret is at position zero in this block. If the block has any
  // text at all, use the style of the first character.


  if (startBlock.getLength()) {
    return startBlock.getInlineStyleAt(0);
  } // Otherwise, look upward in the document to find the closest character.


  return lookUpwardForInlineStyle(content, startKey);
}

function getInlineStyleForNonCollapsedSelection(content, selection) {
  var startKey = selection.getStartKey();
  var startOffset = selection.getStartOffset();
  var startBlock = content.getBlockForKey(startKey); // If there is a character just inside the selection, use its style.

  if (startOffset < startBlock.getLength()) {
    return startBlock.getInlineStyleAt(startOffset);
  } // Check if the selection at the end of a non-empty block. Use the last
  // style in the block.


  if (startOffset > 0) {
    return startBlock.getInlineStyleAt(startOffset - 1);
  } // Otherwise, look upward in the document to find the closest character.


  return lookUpwardForInlineStyle(content, startKey);
}

function lookUpwardForInlineStyle(content, fromKey) {
  var lastNonEmpty = content.getBlockMap().reverse().skipUntil(function (_, k) {
    return k === fromKey;
  }).skip(1).skipUntil(function (block, _) {
    return block.getLength();
  }).first();

  if (lastNonEmpty) {
    return lastNonEmpty.getInlineStyleAt(lastNonEmpty.getLength() - 1);
  }

  return OrderedSet();
}

module.exports = EditorState;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(106)('wks');
var uid = __webpack_require__(75);
var Symbol = __webpack_require__(5).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormattedContent = function (_React$Component) {
  _inherits(FormattedContent, _React$Component);

  function FormattedContent() {
    _classCallCheck(this, FormattedContent);

    return _possibleConstructorReturn(this, (FormattedContent.__proto__ || Object.getPrototypeOf(FormattedContent)).apply(this, arguments));
  }

  _createClass(FormattedContent, [{
    key: 'translateToHTML',
    value: function translateToHTML(content) {
      return content !== undefined && content !== null ? content.startsWith("<p>") || content.startsWith("<ul>") || content.startsWith("<ol>") ? content : content.replace(/\*/g, "<li/>").replace(/\r\n/g, "<br/>").replace(/\n/g, "<br/>") : "";
    }
  }, {
    key: 'render',
    value: function render() {
      return typeof this.props.value === "string" ? _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: this.translateToHTML(this.props.value) } }) : this.props.value !== undefined ? this.props.value : null;
    }
  }]);

  return FormattedContent;
}(_react2.default.Component);

exports.default = FormattedContent;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(50);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _sendCommand = __webpack_require__(25);

var _sendCommand2 = _interopRequireDefault(_sendCommand);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(113), __webpack_require__(114)]);

var ActionItem = function (_React$Component) {
  _inherits(ActionItem, _React$Component);

  function ActionItem() {
    _classCallCheck(this, ActionItem);

    return _possibleConstructorReturn(this, (ActionItem.__proto__ || Object.getPrototypeOf(ActionItem)).apply(this, arguments));
  }

  _createClass(ActionItem, [{
    key: 'render',
    value: function render() {
      var itemType = this.props.project.isProgramme === true ? "/programmes/" : "/projects/";
      return _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'a',
          { onClick: this.props.onClick, href: itemType + this.props.project.id + "/" + this.props.url + "/" + this.props.nextStage.id },
          this.props.label,
          ' ',
          this.props.nextStage.name
        )
      );
    }
  }]);

  return ActionItem;
}(_react2.default.Component);

var ApproveAction = function (_React$Component2) {
  _inherits(ApproveAction, _React$Component2);

  function ApproveAction() {
    _classCallCheck(this, ApproveAction);

    return _possibleConstructorReturn(this, (ApproveAction.__proto__ || Object.getPrototypeOf(ApproveAction)).apply(this, arguments));
  }

  _createClass(ApproveAction, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).menu;
      return this.props.project.requestedStageTransition ? _react2.default.createElement(ActionItem, _extends({}, this.props, { url: 'approve', label: labels.approve })) : null;
    }
  }]);

  return ApproveAction;
}(_react2.default.Component);

var RetractAction = function (_React$Component3) {
  _inherits(RetractAction, _React$Component3);

  function RetractAction() {
    _classCallCheck(this, RetractAction);

    return _possibleConstructorReturn(this, (RetractAction.__proto__ || Object.getPrototypeOf(RetractAction)).apply(this, arguments));
  }

  _createClass(RetractAction, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).menu;
      return this.props.project.requestedStageTransition ? _react2.default.createElement(ActionItem, _extends({}, this.props, { url: 'retract', label: labels.retractRequest })) : null;
    }
  }]);

  return RetractAction;
}(_react2.default.Component);

var RequestAction = function (_React$Component4) {
  _inherits(RequestAction, _React$Component4);

  function RequestAction() {
    _classCallCheck(this, RequestAction);

    return _possibleConstructorReturn(this, (RequestAction.__proto__ || Object.getPrototypeOf(RequestAction)).apply(this, arguments));
  }

  _createClass(RequestAction, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).menu;
      return !this.props.project.requestedStageTransition && !this.props.project.requestedStageException ? _react2.default.createElement(ActionItem, _extends({}, this.props, { url: 'request', label: labels.request })) : null;
    }
  }]);

  return RequestAction;
}(_react2.default.Component);

var RecommendCloseAction = function (_React$Component5) {
  _inherits(RecommendCloseAction, _React$Component5);

  function RecommendCloseAction() {
    _classCallCheck(this, RecommendCloseAction);

    return _possibleConstructorReturn(this, (RecommendCloseAction.__proto__ || Object.getPrototypeOf(RecommendCloseAction)).apply(this, arguments));
  }

  _createClass(RecommendCloseAction, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).menu;
      return this.props.project.isClosing && this.props.project.recommendedProjectClosure === undefined ? _react2.default.createElement(ActionItem, _extends({}, this.props, { url: 'recommend', label: labels.recommend })) : null;
    }
  }]);

  return RecommendCloseAction;
}(_react2.default.Component);

var ApproveCloseAction = function (_React$Component6) {
  _inherits(ApproveCloseAction, _React$Component6);

  function ApproveCloseAction() {
    _classCallCheck(this, ApproveCloseAction);

    return _possibleConstructorReturn(this, (ApproveCloseAction.__proto__ || Object.getPrototypeOf(ApproveCloseAction)).apply(this, arguments));
  }

  _createClass(ApproveCloseAction, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).menu;
      return this.props.project.recommendedProjectClosure !== undefined && this.props.project.isClosing === true ? _react2.default.createElement(ActionItem, _extends({}, this.props, { url: 'approve', label: labels.approve })) : null;
    }
  }]);

  return ApproveCloseAction;
}(_react2.default.Component);

var RetractCloseAction = function (_React$Component7) {
  _inherits(RetractCloseAction, _React$Component7);

  function RetractCloseAction() {
    _classCallCheck(this, RetractCloseAction);

    return _possibleConstructorReturn(this, (RetractCloseAction.__proto__ || Object.getPrototypeOf(RetractCloseAction)).apply(this, arguments));
  }

  _createClass(RetractCloseAction, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).menu;
      return this.props.project.recommendedProjectClosure !== undefined && this.props.project.isClosing === true ? _react2.default.createElement(ActionItem, _extends({}, this.props, { url: 'retract', label: labels.retract })) : null;
    }
  }]);

  return RetractCloseAction;
}(_react2.default.Component);

var PrepareProjectClosureAction = function (_React$Component8) {
  _inherits(PrepareProjectClosureAction, _React$Component8);

  function PrepareProjectClosureAction() {
    _classCallCheck(this, PrepareProjectClosureAction);

    return _possibleConstructorReturn(this, (PrepareProjectClosureAction.__proto__ || Object.getPrototypeOf(PrepareProjectClosureAction)).apply(this, arguments));
  }

  _createClass(PrepareProjectClosureAction, [{
    key: 'prepareClosure',
    value: function prepareClosure(event) {
      var _this9 = this;

      event.preventDefault();
      (0, _sendCommand2.default)({ type: "prepareProjectClosure", project: { id: this.props.project.id } }).then(function () {
        return window.location = "/projects/" + _this9.props.project.id;
      }).catch(function (error) {
        console.log("[ERROR] not able to prepare closure, got ", error);
        alert("An error occured, please try again");
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).menu;
      return this.props.project.isClosing !== true && this.props.project.isCompleted !== true && this.props.project.isStarted === true ? _react2.default.createElement(ActionItem, _extends({}, this.props, { onClick: this.prepareClosure.bind(this), url: 'propose', label: labels.prepareProjectClosure, nextStage: { name: "" } })) : null;
    }
  }]);

  return PrepareProjectClosureAction;
}(_react2.default.Component);

var CloseActions = function (_React$Component9) {
  _inherits(CloseActions, _React$Component9);

  function CloseActions() {
    _classCallCheck(this, CloseActions);

    return _possibleConstructorReturn(this, (CloseActions.__proto__ || Object.getPrototypeOf(CloseActions)).apply(this, arguments));
  }

  _createClass(CloseActions, [{
    key: 'render',
    value: function render() {
      var nextStage = { id: "close", name: "project close" };
      return _react2.default.createElement(
        'ul',
        { style: { marginBottom: 0 } },
        _react2.default.createElement(PrepareProjectClosureAction, _extends({}, this.props, { nextStage: nextStage })),
        _react2.default.createElement(RecommendCloseAction, _extends({}, this.props, { nextStage: nextStage })),
        _react2.default.createElement(RetractCloseAction, _extends({}, this.props, { nextStage: nextStage })),
        _react2.default.createElement(ApproveCloseAction, _extends({}, this.props, { nextStage: nextStage }))
      );
    }
  }]);

  return CloseActions;
}(_react2.default.Component);

var StageActions = function (_React$Component10) {
  _inherits(StageActions, _React$Component10);

  function StageActions() {
    _classCallCheck(this, StageActions);

    return _possibleConstructorReturn(this, (StageActions.__proto__ || Object.getPrototypeOf(StageActions)).apply(this, arguments));
  }

  _createClass(StageActions, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'ul',
        { style: { marginTop: 0 } },
        _react2.default.createElement(RequestAction, this.props),
        _react2.default.createElement(RetractAction, this.props),
        _react2.default.createElement(ApproveAction, this.props)
      );
    }
  }]);

  return StageActions;
}(_react2.default.Component);

var Progress = function (_React$Component11) {
  _inherits(Progress, _React$Component11);

  function Progress() {
    _classCallCheck(this, Progress);

    return _possibleConstructorReturn(this, (Progress.__proto__ || Object.getPrototypeOf(Progress)).apply(this, arguments));
  }

  _createClass(Progress, [{
    key: 'findNextStage',
    value: function findNextStage(project) {
      var nextStage = undefined;
      if (project.stages !== undefined && project.stages.length > 0) {
        var currentIndex = -1;
        if (project.currentStage !== undefined) {
          project.stages.forEach(function (stage, index) {
            if (stage.id === project.currentStage.id) {
              currentIndex = index;
            }
          });
        }
        if (currentIndex + 1 < project.stages.length) {
          nextStage = project.stages[currentIndex + 1];
        } else {
          var closeProject = true;
        }
      }
      return nextStage;
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).menu;
      var nextStage = this.findNextStage(this.props.project);
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'b',
          null,
          labels.progress
        ),
        _react2.default.createElement(CloseActions, this.props),
        this.props.project.state !== "completed" && nextStage !== undefined && !this.props.project.requestedStageException ? _react2.default.createElement(StageActions, _extends({}, this.props, { nextStage: nextStage })) : null
      );
    }
  }]);

  return Progress;
}(_react2.default.Component);

var StatusMenu = function (_React$Component12) {
  _inherits(StatusMenu, _React$Component12);

  function StatusMenu() {
    _classCallCheck(this, StatusMenu);

    return _possibleConstructorReturn(this, (StatusMenu.__proto__ || Object.getPrototypeOf(StatusMenu)).apply(this, arguments));
  }

  _createClass(StatusMenu, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).menu;
      var itemType = this.props.project.isProgramme === true ? "/programmes/" : "/projects/";
      if (this.props.project.isRelease) {
        return _react2.default.createElement('div', null);
      }
      return this.props.project.state !== "completed" ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'b',
          null,
          labels.status
        ),
        _react2.default.createElement(
          'ul',
          null,
          this.props.user !== undefined && (this.props.project.isStopped || this.props.project.isPaused) ? _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'a',
              { href: itemType + this.props.project.id + "/state/start" },
              this.props.project.isProgramme ? labels.startProgramme : labels.startProject
            )
          ) : _react2.default.createElement(
            'li',
            null,
            this.props.project.isProgramme ? labels.startProgramme : labels.startProject
          ),
          this.props.user !== undefined && this.props.project.isStarted ? _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'a',
              { href: itemType + this.props.project.id + "/state/pause" },
              this.props.project.isProgramme ? labels.pauseProgramme : labels.pauseProject
            )
          ) : _react2.default.createElement(
            'li',
            null,
            this.props.project.isProgramme ? labels.pauseProgramme : labels.pauseProject
          ),
          this.props.user !== undefined && (this.props.project.isStarted || this.props.project.isPaused) ? _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'a',
              { href: itemType + this.props.project.id + "/state/stop" },
              this.props.project.isProgramme ? labels.stopProgramme : labels.stopProject
            )
          ) : _react2.default.createElement(
            'li',
            null,
            this.props.project.isProgramme ? labels.stopProgramme : labels.stopProject
          )
        )
      ) : null;
    }
  }]);

  return StatusMenu;
}(_react2.default.Component);

var PlanActions = function (_React$Component13) {
  _inherits(PlanActions, _React$Component13);

  function PlanActions() {
    _classCallCheck(this, PlanActions);

    return _possibleConstructorReturn(this, (PlanActions.__proto__ || Object.getPrototypeOf(PlanActions)).apply(this, arguments));
  }

  _createClass(PlanActions, [{
    key: 'render',
    value: function render() {
      var currentStage = this.props.project !== undefined ? this.props.project.currentStage : undefined;
      return currentStage !== undefined && this.props.project.requestedStageException === undefined ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'b',
          null,
          'Plan'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'a',
              { href: "/projects/" + this.props.project.id + "/plan?exception=true" },
              'Request Exception Plan Approval'
            )
          )
        )
      ) : null;
    }
  }]);

  return PlanActions;
}(_react2.default.Component);

var ProjectMenu = function (_React$Component14) {
  _inherits(ProjectMenu, _React$Component14);

  function ProjectMenu() {
    _classCallCheck(this, ProjectMenu);

    return _possibleConstructorReturn(this, (ProjectMenu.__proto__ || Object.getPrototypeOf(ProjectMenu)).apply(this, arguments));
  }

  _createClass(ProjectMenu, [{
    key: 'render',
    value: function render() {
      var _ref;

      var labels = translations.getTranslation(this.props).menu;
      var project = this.props.project !== undefined ? this.props.project : this.props.programme !== undefined ? this.props.programme : this.props.product !== undefined ? this.props.product : this.props.release !== undefined ? this.props.release : undefined;
      var itemType = project === undefined ? "/projects/" : project.isProgramme === true ? "/programmes/" : project.isRelease ? "/releases/" : project.isProduct ? "/products/" : "/projects/";
      return this.props.showMenu === true ? _react2.default.createElement(
        'div',
        { style: (_ref = { position: "absolute", zIndex: 1, fontFamily: "Lato", backgroundColor: "white", color: "black", marginLeft: 150, marginTop: 2, padding: 20, width: 260 }, _defineProperty(_ref, 'backgroundColor', "white"), _defineProperty(_ref, 'border', "1px solid #E5E5E5"), _defineProperty(_ref, 'boxShadow', "0px 8px 16px rgba(0,0,0,0.15)"), _defineProperty(_ref, 'borderRadius', 4), _ref) },
        project.isProduct !== true && project.isRelease !== true && project.isProgramme !== true ? _react2.default.createElement(Progress, this.props) : null,
        _react2.default.createElement(PlanActions, this.props),
        _react2.default.createElement(
          'div',
          null,
          project.isProduct !== true ? _react2.default.createElement(StatusMenu, this.props) : null,
          _react2.default.createElement(
            'b',
            null,
            labels.actions
          ),
          _react2.default.createElement(
            'ul',
            null,
            this.props.user !== undefined ? _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { href: itemType + project.id + "/properties" },
                labels.editProperties
              )
            ) : _react2.default.createElement(
              'li',
              null,
              labels.editProperties
            ),
            this.props.user !== undefined ? _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { href: itemType + project.id + "/log" },
                labels.openLog
              )
            ) : _react2.default.createElement(
              'li',
              null,
              labels.openLog
            ),
            project.isProgramme !== true && project.isRelease !== true && project.isProduct !== true ? _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { href: itemType + project.id + "/settings" },
                labels.projectSettings
              )
            ) : null,
            project.isProgramme !== true && project.isRelease !== true && project.isProduct !== true ? _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { href: itemType + project.id + "/clone" },
                labels.cloneProject
              )
            ) : null
          )
        )
      ) : null;
    }
  }]);

  return ProjectMenu;
}(_react2.default.Component);

exports.default = ProjectMenu;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(65);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(7)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(3);
var IE8_DOM_DEFINE = __webpack_require__(265);
var toPrimitive = __webpack_require__(53);
var dP = Object.defineProperty;

exports.f = __webpack_require__(19) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(12);

var DOMProperty = __webpack_require__(103);
var ReactDOMComponentFlags = __webpack_require__(378);

var invariant = __webpack_require__(6);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(54);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Root reference for iframes.
 */

var root;
if (typeof window !== 'undefined') { // Browser window
  root = window;
} else if (typeof self !== 'undefined') { // Web Worker
  root = self;
} else { // Other environments
  console.warn("Using browser-only version of superagent in non-browser environment");
  root = this;
}

var Emitter = __webpack_require__(669);
var RequestBase = __webpack_require__(670);
var isObject = __webpack_require__(309);
var ResponseBase = __webpack_require__(671);
var Agent = __webpack_require__(673);

/**
 * Noop.
 */

function noop(){};

/**
 * Expose `request`.
 */

var request = exports = module.exports = function(method, url) {
  // callback
  if ('function' == typeof url) {
    return new exports.Request('GET', method).end(url);
  }

  // url first
  if (1 == arguments.length) {
    return new exports.Request('GET', method);
  }

  return new exports.Request(method, url);
}

exports.Request = Request;

/**
 * Determine XHR.
 */

request.getXHR = function () {
  if (root.XMLHttpRequest
      && (!root.location || 'file:' != root.location.protocol
          || !root.ActiveXObject)) {
    return new XMLHttpRequest;
  } else {
    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
  }
  throw Error("Browser-only version of superagent could not find XHR");
};

/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */

var trim = ''.trim
  ? function(s) { return s.trim(); }
  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };

/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */

function serialize(obj) {
  if (!isObject(obj)) return obj;
  var pairs = [];
  for (var key in obj) {
    pushEncodedKeyValuePair(pairs, key, obj[key]);
  }
  return pairs.join('&');
}

/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */

function pushEncodedKeyValuePair(pairs, key, val) {
  if (val != null) {
    if (Array.isArray(val)) {
      val.forEach(function(v) {
        pushEncodedKeyValuePair(pairs, key, v);
      });
    } else if (isObject(val)) {
      for(var subkey in val) {
        pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
      }
    } else {
      pairs.push(encodeURIComponent(key)
        + '=' + encodeURIComponent(val));
    }
  } else if (val === null) {
    pairs.push(encodeURIComponent(key));
  }
}

/**
 * Expose serialization method.
 */

request.serializeObject = serialize;

/**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */

function parseString(str) {
  var obj = {};
  var pairs = str.split('&');
  var pair;
  var pos;

  for (var i = 0, len = pairs.length; i < len; ++i) {
    pair = pairs[i];
    pos = pair.indexOf('=');
    if (pos == -1) {
      obj[decodeURIComponent(pair)] = '';
    } else {
      obj[decodeURIComponent(pair.slice(0, pos))] =
        decodeURIComponent(pair.slice(pos + 1));
    }
  }

  return obj;
}

/**
 * Expose parser.
 */

request.parseString = parseString;

/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */

request.types = {
  html: 'text/html',
  json: 'application/json',
  xml: 'text/xml',
  urlencoded: 'application/x-www-form-urlencoded',
  'form': 'application/x-www-form-urlencoded',
  'form-data': 'application/x-www-form-urlencoded'
};

/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */

request.serialize = {
  'application/x-www-form-urlencoded': serialize,
  'application/json': JSON.stringify
};

/**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */

request.parse = {
  'application/x-www-form-urlencoded': parseString,
  'application/json': JSON.parse
};

/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

function parseHeader(str) {
  var lines = str.split(/\r?\n/);
  var fields = {};
  var index;
  var line;
  var field;
  var val;

  for (var i = 0, len = lines.length; i < len; ++i) {
    line = lines[i];
    index = line.indexOf(':');
    if (index === -1) { // could be empty line, just skip it
      continue;
    }
    field = line.slice(0, index).toLowerCase();
    val = trim(line.slice(index + 1));
    fields[field] = val;
  }

  return fields;
}

/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */

function isJSON(mime) {
  // should match /json or +json
  // but not /json-seq
  return /[\/+]json($|[^-\w])/.test(mime);
}

/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */

function Response(req) {
  this.req = req;
  this.xhr = this.req.xhr;
  // responseText is accessible only if responseType is '' or 'text' and on older browsers
  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
     ? this.xhr.responseText
     : null;
  this.statusText = this.req.xhr.statusText;
  var status = this.xhr.status;
  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
  if (status === 1223) {
    status = 204;
  }
  this._setStatusProperties(status);
  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
  // getResponseHeader still works. so we get content-type even if getting
  // other headers fails.
  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
  this._setHeaderProperties(this.header);

  if (null === this.text && req._responseType) {
    this.body = this.xhr.response;
  } else {
    this.body = this.req.method != 'HEAD'
      ? this._parseBody(this.text ? this.text : this.xhr.response)
      : null;
  }
}

ResponseBase(Response.prototype);

/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */

Response.prototype._parseBody = function(str) {
  var parse = request.parse[this.type];
  if (this.req._parser) {
    return this.req._parser(this, str);
  }
  if (!parse && isJSON(this.type)) {
    parse = request.parse['application/json'];
  }
  return parse && str && (str.length || str instanceof Object)
    ? parse(str)
    : null;
};

/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */

Response.prototype.toError = function(){
  var req = this.req;
  var method = req.method;
  var url = req.url;

  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
  var err = new Error(msg);
  err.status = this.status;
  err.method = method;
  err.url = url;

  return err;
};

/**
 * Expose `Response`.
 */

request.Response = Response;

/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */

function Request(method, url) {
  var self = this;
  this._query = this._query || [];
  this.method = method;
  this.url = url;
  this.header = {}; // preserves header name case
  this._header = {}; // coerces header names to lowercase
  this.on('end', function(){
    var err = null;
    var res = null;

    try {
      res = new Response(self);
    } catch(e) {
      err = new Error('Parser is unable to parse the response');
      err.parse = true;
      err.original = e;
      // issue #675: return the raw response if the response parsing fails
      if (self.xhr) {
        // ie9 doesn't have 'response' property
        err.rawResponse = typeof self.xhr.responseType == 'undefined' ? self.xhr.responseText : self.xhr.response;
        // issue #876: return the http status code if the response parsing fails
        err.status = self.xhr.status ? self.xhr.status : null;
        err.statusCode = err.status; // backwards-compat only
      } else {
        err.rawResponse = null;
        err.status = null;
      }

      return self.callback(err);
    }

    self.emit('response', res);

    var new_err;
    try {
      if (!self._isResponseOK(res)) {
        new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
      }
    } catch(custom_err) {
      new_err = custom_err; // ok() callback can throw
    }

    // #1000 don't catch errors from the callback to avoid double calling it
    if (new_err) {
      new_err.original = err;
      new_err.response = res;
      new_err.status = res.status;
      self.callback(new_err, res);
    } else {
      self.callback(null, res);
    }
  });
}

/**
 * Mixin `Emitter` and `RequestBase`.
 */

Emitter(Request.prototype);
RequestBase(Request.prototype);

/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.type = function(type){
  this.set('Content-Type', request.types[type] || type);
  return this;
};

/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.accept = function(type){
  this.set('Accept', request.types[type] || type);
  return this;
};

/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.auth = function(user, pass, options){
  if (1 === arguments.length) pass = '';
  if (typeof pass === 'object' && pass !== null) { // pass is optional and can be replaced with options
    options = pass;
    pass = '';
  }
  if (!options) {
    options = {
      type: 'function' === typeof btoa ? 'basic' : 'auto',
    };
  }

  var encoder = function(string) {
    if ('function' === typeof btoa) {
      return btoa(string);
    }
    throw new Error('Cannot use basic auth, btoa is not a function');
  };

  return this._auth(user, pass, options, encoder);
};

/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.query = function(val){
  if ('string' != typeof val) val = serialize(val);
  if (val) this._query.push(val);
  return this;
};

/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.attach = function(field, file, options){
  if (file) {
    if (this._data) {
      throw Error("superagent can't mix .send() and .attach()");
    }

    this._getFormData().append(field, file, options || file.name);
  }
  return this;
};

Request.prototype._getFormData = function(){
  if (!this._formData) {
    this._formData = new root.FormData();
  }
  return this._formData;
};

/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */

Request.prototype.callback = function(err, res){
  if (this._shouldRetry(err, res)) {
    return this._retry();
  }

  var fn = this._callback;
  this.clearTimeout();

  if (err) {
    if (this._maxRetries) err.retries = this._retries - 1;
    this.emit('error', err);
  }

  fn(err, res);
};

/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */

Request.prototype.crossDomainError = function(){
  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
  err.crossDomain = true;

  err.status = this.status;
  err.method = this.method;
  err.url = this.url;

  this.callback(err);
};

// This only warns, because the request is still likely to work
Request.prototype.buffer = Request.prototype.ca = Request.prototype.agent = function(){
  console.warn("This is not supported in browser version of superagent");
  return this;
};

// This throws, because it can't send/receive data as expected
Request.prototype.pipe = Request.prototype.write = function(){
  throw Error("Streaming is not supported in browser version of superagent");
};

/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */
Request.prototype._isHost = function _isHost(obj) {
  // Native objects stringify to [object File], [object Blob], [object FormData], etc.
  return obj && 'object' === typeof obj && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
}

/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */

Request.prototype.end = function(fn){
  if (this._endCalled) {
    console.warn("Warning: .end() was called twice. This is not supported in superagent");
  }
  this._endCalled = true;

  // store callback
  this._callback = fn || noop;

  // querystring
  this._finalizeQueryString();

  return this._end();
};

Request.prototype._end = function() {
  var self = this;
  var xhr = (this.xhr = request.getXHR());
  var data = this._formData || this._data;

  this._setTimeouts();

  // state change
  xhr.onreadystatechange = function(){
    var readyState = xhr.readyState;
    if (readyState >= 2 && self._responseTimeoutTimer) {
      clearTimeout(self._responseTimeoutTimer);
    }
    if (4 != readyState) {
      return;
    }

    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
    // result in the error "Could not complete the operation due to error c00c023f"
    var status;
    try { status = xhr.status } catch(e) { status = 0; }

    if (!status) {
      if (self.timedout || self._aborted) return;
      return self.crossDomainError();
    }
    self.emit('end');
  };

  // progress
  var handleProgress = function(direction, e) {
    if (e.total > 0) {
      e.percent = e.loaded / e.total * 100;
    }
    e.direction = direction;
    self.emit('progress', e);
  };
  if (this.hasListeners('progress')) {
    try {
      xhr.onprogress = handleProgress.bind(null, 'download');
      if (xhr.upload) {
        xhr.upload.onprogress = handleProgress.bind(null, 'upload');
      }
    } catch(e) {
      // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
      // Reported here:
      // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
  }

  // initiate request
  try {
    if (this.username && this.password) {
      xhr.open(this.method, this.url, true, this.username, this.password);
    } else {
      xhr.open(this.method, this.url, true);
    }
  } catch (err) {
    // see #1149
    return this.callback(err);
  }

  // CORS
  if (this._withCredentials) xhr.withCredentials = true;

  // body
  if (!this._formData && 'GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
    // serialize stuff
    var contentType = this._header['content-type'];
    var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
    if (!serialize && isJSON(contentType)) {
      serialize = request.serialize['application/json'];
    }
    if (serialize) data = serialize(data);
  }

  // set header fields
  for (var field in this.header) {
    if (null == this.header[field]) continue;

    if (this.header.hasOwnProperty(field))
      xhr.setRequestHeader(field, this.header[field]);
  }

  if (this._responseType) {
    xhr.responseType = this._responseType;
  }

  // send stuff
  this.emit('request', this);

  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
  // We need null here if data is undefined
  xhr.send(typeof data !== 'undefined' ? data : null);
  return this;
};

request.agent = function() {
  return new Agent();
};

["GET", "POST", "OPTIONS", "PATCH", "PUT", "DELETE"].forEach(function(method) {
  Agent.prototype[method.toLowerCase()] = function(url, fn) {
    var req = new request.Request(method, url);
    this._setDefaults(req);
    if (fn) {
      req.end(fn);
    }
    return req;
  };
});

Agent.prototype.del = Agent.prototype['delete'];

/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.get = function(url, data, fn) {
  var req = request('GET', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.head = function(url, data, fn) {
  var req = request('HEAD', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.query(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.options = function(url, data, fn) {
  var req = request('OPTIONS', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

function del(url, data, fn) {
  var req = request('DELETE', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
}

request['del'] = del;
request['delete'] = del;

/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.patch = function(url, data, fn) {
  var req = request('PATCH', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.post = function(url, data, fn) {
  var req = request('POST', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};

/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */

request.put = function(url, data, fn) {
  var req = request('PUT', url);
  if ('function' == typeof data) (fn = data), (data = null);
  if (data) req.send(data);
  if (fn) req.end(fn);
  return req;
};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(667)();
}


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var request = __webpack_require__(23);

function sendCommand(command) {
  return new Promise(function (resolve, reject) {
    request.post("/").send(command).end(function (error, response) {
      if (error === null && response.status === 200) {
        var message = JSON.parse(response.text);
        if (message.status === "OK") {
          console.log("Success for command '" + command.type + "'");
          resolve(message);
        } else {
          console.log("Error: " + message.message);
          reject({ status: 200, message: message.message });
        }
      } else {
        console.log("Error: " + error + ", got " + response.status + " with message " + response.text);
        reject({ status: response.status, message: response.text });
      }
    });
  });
}

module.exports = sendCommand;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

//     uuid.js
//
//     Copyright (c) 2010-2012 Robert Kieffer
//     MIT License - http://opensource.org/licenses/mit-license.php

// Unique ID creation requires a high quality random # generator.  We feature
// detect to determine the best RNG source, normalizing to a function that
// returns 128-bits of randomness, since that's what's usually required
var _rng = __webpack_require__(674);

// Maps for number <-> hex string conversion
var _byteToHex = [];
var _hexToByte = {};
for (var i = 0; i < 256; i++) {
  _byteToHex[i] = (i + 0x100).toString(16).substr(1);
  _hexToByte[_byteToHex[i]] = i;
}

// **`parse()` - Parse a UUID into it's component bytes**
function parse(s, buf, offset) {
  var i = (buf && offset) || 0, ii = 0;

  buf = buf || [];
  s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
    if (ii < 16) { // Don't overflow!
      buf[i + ii++] = _hexToByte[oct];
    }
  });

  // Zero out remaining bytes if string was short
  while (ii < 16) {
    buf[i + ii++] = 0;
  }

  return buf;
}

// **`unparse()` - Convert UUID byte array (ala parse()) into a string**
function unparse(buf, offset) {
  var i = offset || 0, bth = _byteToHex;
  return  bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]];
}

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

// random #'s we need to init node and clockseq
var _seedBytes = _rng();

// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
var _nodeId = [
  _seedBytes[0] | 0x01,
  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
];

// Per 4.2.2, randomize (14 bit) clockseq
var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

// Previous uuid creation time
var _lastMSecs = 0, _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};

  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  var node = options.node || _nodeId;
  for (var n = 0; n < 6; n++) {
    b[i + n] = node[n];
  }

  return buf ? buf : unparse(b);
}

// **`v4()` - Generate random UUID**

// See https://github.com/broofa/node-uuid for API details
function v4(options, buf, offset) {
  // Deprecated - 'format' argument, as supported in v1.2
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options == 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || _rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ii++) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || unparse(rnds);
}

// Export public API
var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;
uuid.parse = parse;
uuid.unparse = unparse;

module.exports = uuid;


/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeleteItem = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Area = __webpack_require__(115);

var _Area2 = _interopRequireDefault(_Area);

var _Field = __webpack_require__(36);

var _Field2 = _interopRequireDefault(_Field);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(113), __webpack_require__(114)]);

var Tab = function (_React$Component) {
  _inherits(Tab, _React$Component);

  function Tab() {
    _classCallCheck(this, Tab);

    return _possibleConstructorReturn(this, (Tab.__proto__ || Object.getPrototypeOf(Tab)).apply(this, arguments));
  }

  _createClass(Tab, [{
    key: 'select',
    value: function select(event) {
      event.preventDefault();
      if (this.props.index <= this.props.available) {
        this.props.onSelect(this.props.index);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var selected = this.props.selected === this.props.index;
      var border = "solid grey 5px";
      var color = "darkgrey";
      var fontWeight = "normal";
      var textDecoration = "underline";
      var cursor = "pointer";
      if (selected) {
        border = "solid #0079BD 5px";
        color = "black";
        fontWeight = "bold";
        textDecoration = "none";
        cursor = "normal";
      } else if (this.props.index < this.props.available) {
        border = "solid #47b857 5px"; //#4b9d39
        color = "black";
        cursor;
      } else if (this.props.index > this.props.available) {
        cursor = "normal";
        textDecoration = "none";
      } else {
        color = "black";
        cursor = "pointer";
      }
      return _react2.default.createElement(
        'div',
        { onClick: this.select.bind(this), style: { fontSize: "14pt", margin: 3, minWidth: 100, cursor: cursor, textDecoration: textDecoration, padding: 5, fontWeight: fontWeight, fontFamily: "Lato, Arial", textAlign: "center", borderBottom: border, color: color } },
        this.props.title
      );
    }
  }]);

  return Tab;
}(_react2.default.Component);

var TabView = function (_Component) {
  _inherits(TabView, _Component);

  function TabView(props) {
    _classCallCheck(this, TabView);

    var _this2 = _possibleConstructorReturn(this, (TabView.__proto__ || Object.getPrototypeOf(TabView)).call(this, props));

    _this2.state = _this2.calculateState(props, props.selected);
    return _this2;
  }

  _createClass(TabView, [{
    key: 'calculateState',
    value: function calculateState(props, selected) {
      var _this3 = this;

      var available = 0;
      var next = 0;
      if (props.item !== undefined && props.item._progress !== undefined) {
        props.areas.forEach(function (area, index) {
          if (area.title === props.item._progress && area.name === undefined || area.name !== undefined && area.name === props.item._progress) {
            available = index;
          }
          if (props.item !== undefined && (area.title === props.item._currentProgress && area.name === undefined || area.name !== undefined && area.name === props.item._currentProgress)) {
            next = index + 1 < props.areas.length ? index + 1 : props.areas.length - 1;
            while (next < props.areas.length - 1 && !_this3.showArea(_this3.props.areas[next], _this3.props.displayType)) {
              next = next + 1;
            }
          }
        });
      }
      return {
        item: props.updatedItem !== undefined ? props.updatedItem : props.item !== undefined ? props.item : {},
        selected: selected !== undefined ? selected : props.item !== undefined && props.item._currentProgress !== undefined ? next : available,
        available: available
      };
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState(Object.assign({}, this.calculateState(props, props.modified ? this.state.selected : undefined), {
        updated: props.modified === undefined ? true : false
      }));
    }
  }, {
    key: 'select',
    value: function select(index) {
      this.setState({
        updated: false,
        selected: index,
        item: Object.assign({}, this.state.item, this.getFormValues(this._form))
      });
      if (this.props.onTabChange !== undefined) {
        var selected = this.props.areas[index].name !== undefined ? this.props.areas[index].name : this.props.areas[index].title;
        this.props.onTabChange(selected);
      }
    }
  }, {
    key: 'cancelForm',
    value: function cancelForm(event) {
      if (event !== undefined) {
        event.preventDefault();
      }
      if (this.props.onCancel !== undefined) {
        this.props.onCancel(event);
      }
    }
  }, {
    key: 'deleteItem',
    value: function deleteItem(event) {
      if (event !== undefined) {
        event.preventDefault();
      }
      if (this.props.onDelete !== undefined) {
        this.props.onDelete(this.props.item);
      }
    }
  }, {
    key: 'getFormValues',
    value: function getFormValues(form) {
      var formValues = Object.assign({}, this.state.item, {
        id: this.props.item !== undefined ? this.props.item.id : this.state.id !== undefined ? this.state.id : undefined
      });
      if (form !== undefined && form !== null) {
        for (var i = 0; i < form.elements.length; i++) {
          var value = form.elements[i].value;
          if (value.trim().length === 0) {
            value = undefined;
          }
          if (form.elements[i].name !== undefined && form.elements[i].name.trim().length > 0) {
            formValues[form.elements[i].name] = value;
          }
        }
      }
      formValues.cancel = undefined;
      formValues.save = undefined;
      return formValues;
    }
  }, {
    key: 'submit',
    value: function submit(event) {
      event.preventDefault();
      if (this.state.available < this.props.areas.length) {
        var formValues = this.getFormValues(event.target); //this._form);
        //      var available=this.state.selected>=this.state.available && (this.state.available+1)<this.props.areas.length ? this.state.available+1 : this.state.available;
        var currentArea = this.props.areas[this.state.selected];
        formValues._progress = currentArea.name !== undefined ? currentArea.name : currentArea.title;
        if (this.props.onUpdate !== undefined) {
          if (window !== undefined && window.scrollTo !== undefined) {
            window.scrollTo(0, 0);
          };
          var item = Object.assign({}, this.state.item, formValues);
          this.props.onUpdate(item);
        }
      }
    }
  }, {
    key: 'showEntryForm',
    value: function showEntryForm(details) {
      if (this.props.onAddEntry !== undefined) {
        this.props.onAddEntry(details);
      }
    }
  }, {
    key: 'showSummaryDetails',
    value: function showSummaryDetails(status) {
      this.setState({ showSummaryDetails: status.show });
    }
  }, {
    key: 'showArea',
    value: function showArea(area, displayType) {
      var excluded = area.excludedFor !== undefined ? area.excludedFor.filter(function (type) {
        return type === displayType;
      }).length > 0 : undefined;
      var included = area.includedFor !== undefined ? area.includedFor.filter(function (type) {
        return type === displayType;
      }).length > 0 : undefined;
      var show = excluded === undefined && included === undefined || included === undefined && !excluded || included && excluded === undefined ? true : false;
      return show;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var labels = translations.getTranslation(this.props).form;
      var selectedArea = this.props.areas.filter(function (area, index) {
        return index === _this4.state.selected;
      })[0];
      if (this.state.selected >= this.props.areas.length) {
        selectedArea = this.props.areas.slice(-1)[0];
      }
      var saveLabel = this.props.label;
      if (Array.isArray(this.props.label)) {
        var labelForTab = this.props.label.filter(function (tabLabel) {
          return selectedArea !== undefined && tabLabel.name === selectedArea.name;
        })[0];
        saveLabel = labelForTab !== undefined ? labelForTab.label : undefined;
      }
      return _react2.default.createElement(
        'div',
        null,
        this.state.updated ? _react2.default.createElement(
          'div',
          { style: { backgroundColor: "#E4F1E7", fontFamily: "Lato", border: "solid #E4F1E7 1px", marginBottom: 10, padding: 5, textAlign: "center" } },
          _react2.default.createElement(
            'b',
            null,
            labels.changesAreSaved
          )
        ) : null,
        _react2.default.createElement(
          'div',
          { style: { display: "flex", justifyContent: "space-around", flexWrap: "wrap" } },
          this.state.showSummaryDetails === undefined || this.state.showSummaryDetails === false ? this.props.areas.map(function (area, index) {
            return _this4.showArea(area, _this4.props.displayType) !== true ? null : _react2.default.createElement(Tab, { key: index, index: index, title: area.title !== undefined ? area.title : ".(" + area.name + ")", selected: _this4.state.selected, available: _this4.state.available, onSelect: _this4.select.bind(_this4) });
          }) : null
        ),
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 15 } },
          this.props.summary !== undefined ? this.props.summary(selectedArea !== undefined ? selectedArea.name !== undefined ? selectedArea.name : selectedArea.title : "(unknown)", {
            values: this.state.item,
            oldValues: this.props.item !== undefined ? this.props.item : {},
            onDetails: this.showSummaryDetails.bind(this)
          }) : null
        ),
        _react2.default.createElement(
          'form',
          { ref: function ref(form) {
              return _this4._form = form;
            }, onSubmit: this.submit.bind(this) },
          _react2.default.createElement(
            'div',
            { style: { paddingTop: 15 } },
            this.props.areas.map(function (area, index) {
              return _this4.showArea(area, _this4.props.displayType) !== true ? null : index === _this4.state.selected ? _react2.default.createElement(
                'div',
                { key: index },
                _react2.default.createElement(
                  _Area2.default,
                  _extends({ key: area.title }, area, { title: undefined }),
                  area.fields !== undefined ? area.fields.map(function (field) {
                    return _react2.default.createElement(_Field2.default, _extends({
                      key: field.name !== undefined ? field.name : field.title,
                      language: _this4.props.language,
                      variant: _this4.props.variant
                    }, field, {
                      value: _this4.state.item[field.name],
                      statusValue: field.includeStatus ? _this4.state.item[field.name + "_status"] : undefined,
                      previousValue: _this4.state.item.previousValues !== undefined ? _this4.state.item.previousValues[field.name] : undefined,
                      previousStatusValue: field.includeStatus && _this4.state.item.previousValues !== undefined ? _this4.state.item.previousValues[field.name + "_status"] : undefined,
                      onChange: _this4.props.handleFieldChange !== undefined ? _this4.props.handleFieldChange(field.name) : field.onChange,
                      addEntry: field.options !== undefined && field.options.addEntry !== undefined ? Object.assign({}, field.options.addEntry, { handler: _this4.showEntryForm.bind(_this4) }) : null,
                      onEditEntry: _this4.props.onEditEntry,
                      displayType: _this4.props.displayType,
                      forceReadOnly: _this4.props.forceReadOnly
                    }));
                  }) : null
                ),
                saveLabel !== undefined && area.hideButtons !== true ? _react2.default.createElement(
                  'div',
                  { style: { display: "flex", width: "100%", justifyContent: "space-between" } },
                  _react2.default.createElement('input', { className: 'cancel', type: 'button', onClick: _this4.cancelForm.bind(_this4), name: 'cancel', value: labels.cancel }),
                  _this4.props.onDelete !== undefined && _this4.props.item !== undefined && _this4.props.item.id !== undefined ? _react2.default.createElement(DeleteItem, _extends({}, _this4.props, { onConfirm: _this4.deleteItem.bind(_this4) })) : null,
                  _react2.default.createElement('input', { className: 'save', type: 'submit', name: 'save', value: _this4.props.item !== undefined && _this4.props.item.id === undefined || _this4.props.item === undefined ? labels.add + " " + saveLabel.toLowerCase() : labels.update + " " + saveLabel.toLowerCase() })
                ) : _this4.props.actions !== undefined ? _this4.props.actions : null
              ) : null;
            })
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          this.props.details !== undefined ? this.props.details(selectedArea.name !== undefined ? selectedArea.name : selectedArea.title, this.state.item, this.props.item !== undefined ? this.props.item : {}) : null
        )
      );
    }
  }]);

  return TabView;
}(_react.Component);

var AreaDetails = function (_Component2) {
  _inherits(AreaDetails, _Component2);

  function AreaDetails() {
    _classCallCheck(this, AreaDetails);

    return _possibleConstructorReturn(this, (AreaDetails.__proto__ || Object.getPrototypeOf(AreaDetails)).apply(this, arguments));
  }

  _createClass(AreaDetails, [{
    key: 'render',
    value: function render() {
      var _this6 = this;

      var area = this.props;
      var excluded = this.props.excludedFor !== undefined ? this.props.excludedFor.filter(function (type) {
        return type === _this6.props.displayType;
      }).length > 0 : undefined;
      var included = this.props.includedFor !== undefined ? this.props.includedFor.filter(function (type) {
        return type === _this6.props.displayType;
      }).length > 0 : undefined;
      var show = excluded === undefined && included === undefined || included === undefined && !excluded || included && excluded === undefined ? true : false;
      return false ? _react2.default.createElement(
        _Area2.default,
        _extends({ title: area.title !== undefined ? area.title : ".(" + area.name + ")" }, area),
        area.fields.map(function (field, index) {
          return _react2.default.createElement(_Field2.default, _extends({ key: index }, _this6.props, field, {
            value: field.value !== undefined ? field.value : _this6.props.item !== undefined && _this6.props.item[field.name] !== undefined ? _this6.props.item[field.name] : undefined
          }));
        })
      ) : null;
    }
  }]);

  return AreaDetails;
}(_react.Component);

var AreaForm = function (_Component3) {
  _inherits(AreaForm, _Component3);

  function AreaForm() {
    _classCallCheck(this, AreaForm);

    return _possibleConstructorReturn(this, (AreaForm.__proto__ || Object.getPrototypeOf(AreaForm)).apply(this, arguments));
  }

  _createClass(AreaForm, [{
    key: 'cancelForm',
    value: function cancelForm(event) {
      if (event !== undefined) {
        event.preventDefault();
      }
      if (this.props.onCancel !== undefined) {
        this.props.onCancel(event);
      }
    }
  }, {
    key: 'deleteItem',
    value: function deleteItem(event) {
      if (event !== undefined) {
        event.preventDefault();
      }
      if (this.props.onDelete !== undefined) {
        this.props.onDelete(this.props.item);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      var labels = translations.getTranslation(this.props).form;
      return this.props.display === "tab" ? _react2.default.createElement(TabView, this.props) : _react2.default.createElement(
        'div',
        null,
        this.props.areas.map(function (area, index) {
          return _react2.default.createElement(AreaDetails, _extends({ key: index }, area, _this8.props));
        }),
        this.props.label !== undefined && !Array.isArray(this.props.label) ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('input', { className: 'cancel', type: 'button', onClick: this.cancelForm.bind(this), name: 'cancel', value: labels.cancel }),
          this.props.onDelete !== undefined && this.props.item !== undefined && this.props.item.id !== undefined ? _react2.default.createElement(DeleteItem, { onConfirm: this.deleteItem.bind(this), label: this.props.label }) : null,
          _react2.default.createElement('input', { className: 'save', type: 'submit', name: 'save', value: this.props.item !== undefined && this.props.item.id === undefined || this.props.item === undefined ? labels.add + " " + this.props.label.toLowerCase() : labels.update + " " + this.props.label.toLowerCase() })
        ) : this.props.actions !== undefined ? this.props.actions : null
      );
    }
  }]);

  return AreaForm;
}(_react.Component);

exports.default = AreaForm;

var DeleteItem = exports.DeleteItem = function (_React$Component2) {
  _inherits(DeleteItem, _React$Component2);

  function DeleteItem(props) {
    _classCallCheck(this, DeleteItem);

    var _this9 = _possibleConstructorReturn(this, (DeleteItem.__proto__ || Object.getPrototypeOf(DeleteItem)).call(this, props));

    _this9.state = { confirm: false };
    return _this9;
  }

  _createClass(DeleteItem, [{
    key: 'deleteItem',
    value: function deleteItem(event) {
      this.setState({ confirm: true });
    }
  }, {
    key: 'confirmDelete',
    value: function confirmDelete(event) {
      this.props.onConfirm(event);
    }
  }, {
    key: 'cancel',
    value: function cancel(event) {
      event.preventDefault();
      this.setState({ confirm: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).form;
      return this.state.confirm ? _react2.default.createElement(
        'div',
        { style: { border: "solid 1px black", textAlign: "center", padding: 5 } },
        _react2.default.createElement(
          'div',
          { style: { padding: 10 } },
          this.props.confirmDeleteMessage !== undefined ? this.props.confirmDeleteMessage : labels.confirmDeleteMessage
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "flex", justifyContent: "space-between" } },
          _react2.default.createElement(
            'a',
            { style: { padding: 5, paddingRight: 15 }, className: 'cancel', href: '#', onClick: this.cancel.bind(this) },
            labels.cancelDelete
          ),
          _react2.default.createElement('input', { style: { padding: 5 }, className: 'delete', type: 'button', name: 'delete', onClick: this.confirmDelete.bind(this), value: labels.delete + " " + this.props.label.toLowerCase() })
        )
      ) : _react2.default.createElement('input', { className: 'delete', type: 'button', name: 'delete', onClick: this.deleteItem.bind(this), value: labels.delete + " " + this.props.label.toLowerCase() });
    }
  }]);

  return DeleteItem;
}(_react2.default.Component);

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var CharacterMetadata = __webpack_require__(43);

var ContentStateInlineStyle = __webpack_require__(804);

var applyEntityToContentState = __webpack_require__(805);

var getCharacterRemovalRange = __webpack_require__(807);

var getContentStateFragment = __webpack_require__(157);

var Immutable = __webpack_require__(4);

var insertFragmentIntoContentState = __webpack_require__(810);

var insertTextIntoContentState = __webpack_require__(811);

var invariant = __webpack_require__(9);

var modifyBlockForContentState = __webpack_require__(344);

var removeEntitiesAtEdges = __webpack_require__(342);

var removeRangeFromContentState = __webpack_require__(812);

var splitBlockInContentState = __webpack_require__(813);

var OrderedSet = Immutable.OrderedSet;
/**
 * `DraftModifier` provides a set of convenience methods that apply
 * modifications to a `ContentState` object based on a target `SelectionState`.
 *
 * Any change to a `ContentState` should be decomposable into a series of
 * transaction functions that apply the required changes and return output
 * `ContentState` objects.
 *
 * These functions encapsulate some of the most common transaction sequences.
 */

var DraftModifier = {
  replaceText: function replaceText(contentState, rangeToReplace, text, inlineStyle, entityKey) {
    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToReplace);
    var withoutText = removeRangeFromContentState(withoutEntities, rangeToReplace);
    var character = CharacterMetadata.create({
      style: inlineStyle || OrderedSet(),
      entity: entityKey || null
    });
    return insertTextIntoContentState(withoutText, withoutText.getSelectionAfter(), text, character);
  },
  insertText: function insertText(contentState, targetRange, text, inlineStyle, entityKey) {
    !targetRange.isCollapsed() ?  false ? invariant(false, 'Target range must be collapsed for `insertText`.') : invariant(false) : void 0;
    return DraftModifier.replaceText(contentState, targetRange, text, inlineStyle, entityKey);
  },
  moveText: function moveText(contentState, removalRange, targetRange) {
    var movedFragment = getContentStateFragment(contentState, removalRange);
    var afterRemoval = DraftModifier.removeRange(contentState, removalRange, 'backward');
    return DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
  },
  replaceWithFragment: function replaceWithFragment(contentState, targetRange, fragment) {
    var mergeBlockData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'REPLACE_WITH_NEW_DATA';
    var withoutEntities = removeEntitiesAtEdges(contentState, targetRange);
    var withoutText = removeRangeFromContentState(withoutEntities, targetRange);
    return insertFragmentIntoContentState(withoutText, withoutText.getSelectionAfter(), fragment, mergeBlockData);
  },
  removeRange: function removeRange(contentState, rangeToRemove, removalDirection) {
    var startKey, endKey, startBlock, endBlock;

    if (rangeToRemove.getIsBackward()) {
      rangeToRemove = rangeToRemove.merge({
        anchorKey: rangeToRemove.getFocusKey(),
        anchorOffset: rangeToRemove.getFocusOffset(),
        focusKey: rangeToRemove.getAnchorKey(),
        focusOffset: rangeToRemove.getAnchorOffset(),
        isBackward: false
      });
    }

    startKey = rangeToRemove.getAnchorKey();
    endKey = rangeToRemove.getFocusKey();
    startBlock = contentState.getBlockForKey(startKey);
    endBlock = contentState.getBlockForKey(endKey);
    var startOffset = rangeToRemove.getStartOffset();
    var endOffset = rangeToRemove.getEndOffset();
    var startEntityKey = startBlock.getEntityAt(startOffset);
    var endEntityKey = endBlock.getEntityAt(endOffset - 1); // Check whether the selection state overlaps with a single entity.
    // If so, try to remove the appropriate substring of the entity text.

    if (startKey === endKey) {
      if (startEntityKey && startEntityKey === endEntityKey) {
        var adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
        return removeRangeFromContentState(contentState, adjustedRemovalRange);
      }
    }

    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToRemove);
    return removeRangeFromContentState(withoutEntities, rangeToRemove);
  },
  splitBlock: function splitBlock(contentState, selectionState) {
    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
    var withoutText = removeRangeFromContentState(withoutEntities, selectionState);
    return splitBlockInContentState(withoutText, withoutText.getSelectionAfter());
  },
  applyInlineStyle: function applyInlineStyle(contentState, selectionState, inlineStyle) {
    return ContentStateInlineStyle.add(contentState, selectionState, inlineStyle);
  },
  removeInlineStyle: function removeInlineStyle(contentState, selectionState, inlineStyle) {
    return ContentStateInlineStyle.remove(contentState, selectionState, inlineStyle);
  },
  setBlockType: function setBlockType(contentState, selectionState, blockType) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({
        type: blockType,
        depth: 0
      });
    });
  },
  setBlockData: function setBlockData(contentState, selectionState, blockData) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({
        data: blockData
      });
    });
  },
  mergeBlockData: function mergeBlockData(contentState, selectionState, blockData) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({
        data: block.getData().merge(blockData)
      });
    });
  },
  applyEntity: function applyEntity(contentState, selectionState, entityKey) {
    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
    return applyEntityToContentState(withoutEntities, selectionState, entityKey);
  }
};
module.exports = DraftModifier;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var nullthrows = function nullthrows(x) {
  if (x != null) {
    return x;
  }

  throw new Error("Got unexpected null or undefined");
};

module.exports = nullthrows;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var UserAgentData = __webpack_require__(823);

var VersionRange = __webpack_require__(826);

var mapObject = __webpack_require__(827);

var memoizeStringOnly = __webpack_require__(828);
/**
 * Checks to see whether `name` and `version` satisfy `query`.
 *
 * @param {string} name Name of the browser, device, engine or platform
 * @param {?string} version Version of the browser, engine or platform
 * @param {string} query Query of form "Name [range expression]"
 * @param {?function} normalizer Optional pre-processor for range expression
 * @return {boolean}
 */


function compare(name, version, query, normalizer) {
  // check for exact match with no version
  if (name === query) {
    return true;
  } // check for non-matching names


  if (!query.startsWith(name)) {
    return false;
  } // full comparison with version


  var range = query.slice(name.length);

  if (version) {
    range = normalizer ? normalizer(range) : range;
    return VersionRange.contains(range, version);
  }

  return false;
}
/**
 * Normalizes `version` by stripping any "NT" prefix, but only on the Windows
 * platform.
 *
 * Mimics the stripping performed by the `UserAgentWindowsPlatform` PHP class.
 *
 * @param {string} version
 * @return {string}
 */


function normalizePlatformVersion(version) {
  if (UserAgentData.platformName === 'Windows') {
    return version.replace(/^\s*NT/, '');
  }

  return version;
}
/**
 * Provides client-side access to the authoritative PHP-generated User Agent
 * information supplied by the server.
 */


var UserAgent = {
  /**
   * Check if the User Agent browser matches `query`.
   *
   * `query` should be a string like "Chrome" or "Chrome > 33".
   *
   * Valid browser names include:
   *
   * - ACCESS NetFront
   * - AOL
   * - Amazon Silk
   * - Android
   * - BlackBerry
   * - BlackBerry PlayBook
   * - Chrome
   * - Chrome for iOS
   * - Chrome frame
   * - Facebook PHP SDK
   * - Facebook for iOS
   * - Firefox
   * - IE
   * - IE Mobile
   * - Mobile Safari
   * - Motorola Internet Browser
   * - Nokia
   * - Openwave Mobile Browser
   * - Opera
   * - Opera Mini
   * - Opera Mobile
   * - Safari
   * - UIWebView
   * - Unknown
   * - webOS
   * - etc...
   *
   * An authoritative list can be found in the PHP `BrowserDetector` class and
   * related classes in the same file (see calls to `new UserAgentBrowser` here:
   * https://fburl.com/50728104).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isBrowser: function isBrowser(query) {
    return compare(UserAgentData.browserName, UserAgentData.browserFullVersion, query);
  },

  /**
   * Check if the User Agent browser uses a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
  isBrowserArchitecture: function isBrowserArchitecture(query) {
    return compare(UserAgentData.browserArchitecture, null, query);
  },

  /**
   * Check if the User Agent device matches `query`.
   *
   * `query` should be a string like "iPhone" or "iPad".
   *
   * Valid device names include:
   *
   * - Kindle
   * - Kindle Fire
   * - Unknown
   * - iPad
   * - iPhone
   * - iPod
   * - etc...
   *
   * An authoritative list can be found in the PHP `DeviceDetector` class and
   * related classes in the same file (see calls to `new UserAgentDevice` here:
   * https://fburl.com/50728332).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name"
   * @return {boolean}
   */
  isDevice: function isDevice(query) {
    return compare(UserAgentData.deviceName, null, query);
  },

  /**
   * Check if the User Agent rendering engine matches `query`.
   *
   * `query` should be a string like "WebKit" or "WebKit >= 537".
   *
   * Valid engine names include:
   *
   * - Gecko
   * - Presto
   * - Trident
   * - WebKit
   * - etc...
   *
   * An authoritative list can be found in the PHP `RenderingEngineDetector`
   * class related classes in the same file (see calls to `new
   * UserAgentRenderingEngine` here: https://fburl.com/50728617).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isEngine: function isEngine(query) {
    return compare(UserAgentData.engineName, UserAgentData.engineVersion, query);
  },

  /**
   * Check if the User Agent platform matches `query`.
   *
   * `query` should be a string like "Windows" or "iOS 5 - 6".
   *
   * Valid platform names include:
   *
   * - Android
   * - BlackBerry OS
   * - Java ME
   * - Linux
   * - Mac OS X
   * - Mac OS X Calendar
   * - Mac OS X Internet Account
   * - Symbian
   * - SymbianOS
   * - Windows
   * - Windows Mobile
   * - Windows Phone
   * - iOS
   * - iOS Facebook Integration Account
   * - iOS Facebook Social Sharing UI
   * - webOS
   * - Chrome OS
   * - etc...
   *
   * An authoritative list can be found in the PHP `PlatformDetector` class and
   * related classes in the same file (see calls to `new UserAgentPlatform`
   * here: https://fburl.com/50729226).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isPlatform: function isPlatform(query) {
    return compare(UserAgentData.platformName, UserAgentData.platformFullVersion, query, normalizePlatformVersion);
  },

  /**
   * Check if the User Agent platform is a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
  isPlatformArchitecture: function isPlatformArchitecture(query) {
    return compare(UserAgentData.platformArchitecture, null, query);
  }
};
module.exports = mapObject(UserAgent, memoizeStringOnly);

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(20);
var createDesc = __webpack_require__(74);
module.exports = __webpack_require__(19) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var hide = __webpack_require__(33);
var has = __webpack_require__(39);
var SRC = __webpack_require__(75)('src');
var $toString = __webpack_require__(448);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(47).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var fails = __webpack_require__(7);
var defined = __webpack_require__(54);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Period = __webpack_require__(675);

var _Period2 = _interopRequireDefault(_Period);

var _Table = __webpack_require__(683);

var _Table2 = _interopRequireDefault(_Table);

var _MultiTable = __webpack_require__(794);

var _MultiTable2 = _interopRequireDefault(_MultiTable);

var _Matrix = __webpack_require__(795);

var _Matrix2 = _interopRequireDefault(_Matrix);

var _StatusSelector = __webpack_require__(796);

var _StatusSelector2 = _interopRequireDefault(_StatusSelector);

var _Status = __webpack_require__(208);

var _Status2 = _interopRequireDefault(_Status);

var _FormattedContent = __webpack_require__(15);

var _FormattedContent2 = _interopRequireDefault(_FormattedContent);

var _ProcessView = __webpack_require__(801);

var _ProcessView2 = _interopRequireDefault(_ProcessView);

var _RichTextEditor = __webpack_require__(802);

var _RichTextEditor2 = _interopRequireDefault(_RichTextEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var width = 280;

var height = 30;
var inputStyle = {
  paddingLeft: 5,
  paddingRight: 5,
  paddingBottom: 5,
  fontFamily: "Lato, Arial, Verdana, Geneva, sans-serif",
  backgroundColor: "#ffffff",
  border: "1px solid #C1C1C1",
  borderRadius: 0,
  fontSize: "12pt"
};

var ExpandableTextArea = function (_React$Component) {
  _inherits(ExpandableTextArea, _React$Component);

  function ExpandableTextArea(props) {
    _classCallCheck(this, ExpandableTextArea);

    var _this = _possibleConstructorReturn(this, (ExpandableTextArea.__proto__ || Object.getPrototypeOf(ExpandableTextArea)).call(this, props));

    _this.state = { height: height * _this.props.height };
    return _this;
  }

  _createClass(ExpandableTextArea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.calculateSize();
    }
  }, {
    key: "calculateSize",
    value: function calculateSize() {
      this._textarea.style.height = "auto";
      if (this._textarea.scrollHeight > height * this.props.height) {
        this._textarea.style.height = this._textarea.scrollHeight + 2 + "px";
      } else {
        this._textarea.style.height = height * this.props.height + "px";
      }
    }
  }, {
    key: "expand",
    value: function expand(event) {
      this.calculateSize();
      if (this.props.onChange !== undefined) {
        this.props.onChange(event);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return this.props.expand ? _react2.default.createElement("textArea", {
        ref: function ref(_ref) {
          return _this2._textarea = _ref;
        },
        onChange: this.expand.bind(this),
        name: this.props.name,
        defaultValue: this.props.value,
        style: Object.assign({}, inputStyle, {
          height: this.state.height,
          width: "100%"
        }),
        placeholder: this.props.help
      }) : _react2.default.createElement("textArea", {
        onChange: this.props.onChange,
        name: this.props.name,
        defaultValue: this.props.value,
        style: Object.assign({}, inputStyle, {
          height: height * this.props.height,
          width: "100%"
        }),
        placeholder: this.props.help
      });
    }
  }]);

  return ExpandableTextArea;
}(_react2.default.Component);

var TextField = function (_React$Component2) {
  _inherits(TextField, _React$Component2);

  function TextField() {
    _classCallCheck(this, TextField);

    return _possibleConstructorReturn(this, (TextField.__proto__ || Object.getPrototypeOf(TextField)).apply(this, arguments));
  }

  _createClass(TextField, [{
    key: "render",
    value: function render() {
      return this.props.height !== undefined ? this.props.plainText === true ? _react2.default.createElement(ExpandableTextArea, _extends({}, this.props, { expand: true })) : _react2.default.createElement(_RichTextEditor2.default, _extends({ style: inputStyle }, this.props)) : _react2.default.createElement("input", {
        onChange: this.props.onChange,
        disabled: this.props.disabled,
        className: "input",
        name: this.props.name,
        defaultValue: this.props.controlled ? undefined : this.props.value,
        style: Object.assign({}, inputStyle, { height: height }),
        placeholder: this.props.help,
        readOnly: this.props.readonly,
        autoComplete: this.props.autoComplete !== undefined ? this.props.autoComplete : "on",
        value: this.props.controlled ? this.props.value ? this.props.value : "" : undefined
      });
    }
  }]);

  return TextField;
}(_react2.default.Component);

var InputField = function (_React$Component3) {
  _inherits(InputField, _React$Component3);

  function InputField() {
    _classCallCheck(this, InputField);

    return _possibleConstructorReturn(this, (InputField.__proto__ || Object.getPrototypeOf(InputField)).apply(this, arguments));
  }

  _createClass(InputField, [{
    key: "render",
    value: function render() {
      return this.props.type === "process" ? _react2.default.createElement(_ProcessView2.default, this.props) : this.props.type === "table" ? _react2.default.createElement(_Table2.default, this.props) : this.props.type === "period" ? _react2.default.createElement(_Period2.default, this.props) : this.props.options === undefined ? _react2.default.createElement(TextField, this.props) : _react2.default.createElement(
        "select",
        {
          onChange: this.props.onChange,
          className: "input",
          style: Object.assign({}, inputStyle, { height: height }),
          name: this.props.name,
          defaultValue: this.props.value !== undefined && !this.props.controlled ? this.props.value : this.props.controlled ? undefined : this.props.defaultValue,
          value: this.props.controlled ? this.props.value !== undefined ? this.props.value : this.props.defaultValue : undefined,
          disabled: this.props.disabled
        },
        this.props.options.map(function (option) {
          return _react2.default.createElement(
            "option",
            { key: option.value, value: option.value },
            option.text !== undefined ? option.text : ".(" + option.value + ")"
          );
        })
      );
    }
  }]);

  return InputField;
}(_react2.default.Component);

var AddEntry = function (_React$Component4) {
  _inherits(AddEntry, _React$Component4);

  function AddEntry() {
    _classCallCheck(this, AddEntry);

    return _possibleConstructorReturn(this, (AddEntry.__proto__ || Object.getPrototypeOf(AddEntry)).apply(this, arguments));
  }

  _createClass(AddEntry, [{
    key: "showForm",
    value: function showForm(event) {
      event.preventDefault();
      if (this.props.addEntry.handler !== undefined) {
        this.props.addEntry.handler({
          field: this.props.name,
          item: Object.assign({}, this.props.item, {
            _progress: this.props.addEntry !== undefined && this.props.addEntry.formDefinition !== undefined && this.props.addEntry.formDefinition.length > 0 ? this.props.addEntry.formDefinition.slice(-1)[0].name : undefined
          }),
          form: this.props.addEntry.formDefinition,
          type: this.props.type
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var disabled = this.props._disableOption !== undefined && this.props._disableOption.includes("addEntry");
      if (this.props.addEntry !== undefined && this.props.addEntry !== null && this.props.type === "table") {
        var title = this.props.addEntry.title !== undefined ? this.props.addEntry.title : ".(options.addEntry)";
        return disabled ? null : _react2.default.createElement(
          "div",
          {
            style: {
              cursor: "pointer",
              float: "right",
              textDecoration: "underline"
            },
            onClick: this.showForm.bind(this)
          },
          title
        );
      } else {
        return null;
      }
    }
  }]);

  return AddEntry;
}(_react2.default.Component);

var OrdinaryField = function (_React$Component5) {
  _inherits(OrdinaryField, _React$Component5);

  function OrdinaryField(props) {
    _classCallCheck(this, OrdinaryField);

    var _this6 = _possibleConstructorReturn(this, (OrdinaryField.__proto__ || Object.getPrototypeOf(OrdinaryField)).call(this, props));

    _this6.state = { showHelp: false, showPrevious: false };
    return _this6;
  }

  _createClass(OrdinaryField, [{
    key: "toggleHelp",
    value: function toggleHelp(event) {
      event.preventDefault();
      this.setState({ showHelp: !this.state.showHelp });
    }
  }, {
    key: "togglePrevious",
    value: function togglePrevious(event) {
      event.preventDefault();
      this.setState({ showPrevious: !this.state.showPrevious });
    }
  }, {
    key: "onEditEntry",
    value: function onEditEntry(item) {
      if (this.props.onEditEntry !== undefined && this.props.options !== undefined && this.props.options.edit !== undefined) {
        this.props.onEditEntry({
          field: this.props.name,
          form: this.props.options.edit.formDefinition,
          item: item,
          type: this.props.type
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      var className = this.props.height !== undefined || this.props.type === "period" || this.props.type === "table" || this.props.type === "process" ? "textarea" : "field";
      var title = this.props.title !== undefined ? this.props.title : ".(" + this.props.name + ")";
      var excluded = this.props.excludedFor !== undefined ? this.props.excludedFor.filter(function (type) {
        return type === _this7.props.displayType;
      }).length > 0 : undefined;
      var included = this.props.includedFor !== undefined ? this.props.includedFor.filter(function (type) {
        return type === _this7.props.displayType;
      }).length > 0 : undefined;
      var show = excluded === undefined && included === undefined || included === undefined && !excluded || included && excluded === undefined ? true : false;
      return show ? _react2.default.createElement(
        "div",
        { className: className, style: { marginBottom: 20 } },
        _react2.default.createElement(AddEntry, this.props),
        _react2.default.createElement(
          "div",
          { style: { fontWeight: "bold", fontSize: "14pt" } },
          _react2.default.createElement(
            "div",
            { style: { marginBottom: 5 } },
            title,
            " ",
            this.props.optional !== undefined ? null : _react2.default.createElement(
              "span",
              { style: { color: "red" } },
              "*"
            ),
            this.props.showFlag === true ? _react2.default.createElement("img", {
              style: {
                paddingLeft: 10,
                verticalAlign: "bottom",
                paddingTop: 3
              },
              src: "/images/Flag_FinishGrey_22x16.gif"
            }) : null,
            this.props.includeStatus ? _react2.default.createElement(
              "div",
              {
                style: {
                  display: "inline-block",
                  fontWeight: "normal",
                  paddingLeft: 20,
                  height: 18
                }
              },
              _react2.default.createElement(_StatusSelector2.default, _extends({}, this.props, {
                name: this.props.name,
                value: this.props.statusValue,
                style: {
                  top: -1,
                  padding: 10,
                  left: -10,
                  item: { padding: 5 }
                }
              }))
            ) : null,
            this.props.help !== undefined ? _react2.default.createElement(
              "span",
              {
                style: {
                  paddingLeft: 10,
                  fontWeight: "normal",
                  cursor: "pointer"
                },
                onClick: this.toggleHelp.bind(this)
              },
              _react2.default.createElement("img", { src: "/icons/help.png" })
            ) : null,
            this.props.previousValue !== undefined && this.props.previousValue !== null && this.props.previousValue.trim().length > 0 || this.props.previousStatusValue !== undefined && this.props.previousStatusValue !== null && this.props.previousStatusValue.trim().length > 0 ? _react2.default.createElement(
              "div",
              {
                onClick: this.togglePrevious.bind(this),
                style: {
                  float: "right",
                  fontSize: "12pt",
                  textDecoration: "underline",
                  fontWeight: "normal",
                  cursor: "pointer"
                }
              },
              this.state.showPrevious ? "Hide " : "Show ",
              "previous text"
            ) : null
          )
        ),
        this.state.showHelp ? _react2.default.createElement(
          "div",
          {
            style: {
              paddingLeft: 10,
              paddingTop: 5,
              paddingBottom: 5,
              fontStyle: "italic"
            }
          },
          _react2.default.createElement(_FormattedContent2.default, { value: this.props.help })
        ) : null,
        this.state.showPrevious ? _react2.default.createElement(
          "div",
          {
            style: {
              display: "flex",
              alignItems: "center",
              paddingLeft: 10,
              paddingTop: 5,
              paddingBottom: 5
            }
          },
          _react2.default.createElement(
            "div",
            { style: { paddingRight: 10 } },
            _react2.default.createElement(_Status2.default, { value: this.props.previousStatusValue })
          ),
          _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(_FormattedContent2.default, { value: this.props.previousValue })
          )
        ) : null,
        _react2.default.createElement(InputField, _extends({}, this.props, {
          help: this.props.description,
          onEditEntry: this.props.onEditEntry !== undefined ? this.onEditEntry.bind(this) : undefined
        }))
      ) : null;
    }
  }]);

  return OrdinaryField;
}(_react2.default.Component);

var Field = function (_React$Component6) {
  _inherits(Field, _React$Component6);

  function Field() {
    _classCallCheck(this, Field);

    return _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).apply(this, arguments));
  }

  _createClass(Field, [{
    key: "render",
    value: function render() {
      return this.props.type === "matrix" ? _react2.default.createElement(_Matrix2.default, this.props) : this.props.type === "multiTable" ? _react2.default.createElement(_MultiTable2.default, this.props) : _react2.default.createElement(OrdinaryField, this.props);
    }
  }]);

  return Field;
}(_react2.default.Component);

exports.default = Field;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 */


var AtomicBlockUtils = __webpack_require__(803);

var BlockMapBuilder = __webpack_require__(120);

var CharacterMetadata = __webpack_require__(43);

var CompositeDraftDecorator = __webpack_require__(819);

var ContentBlock = __webpack_require__(88);

var ContentState = __webpack_require__(225);

var DefaultDraftBlockRenderMap = __webpack_require__(227);

var DefaultDraftInlineStyle = __webpack_require__(349);

var DraftEditor = __webpack_require__(820);

var DraftEditorBlock = __webpack_require__(365);

var DraftEntity = __webpack_require__(158);

var DraftModifier = __webpack_require__(29);

var DraftEntityInstance = __webpack_require__(347);

var EditorState = __webpack_require__(13);

var KeyBindingUtil = __webpack_require__(234);

var RawDraftContentState = __webpack_require__(956);

var RichTextEditorUtil = __webpack_require__(376);

var SelectionState = __webpack_require__(159);

var convertFromDraftStateToRaw = __webpack_require__(957);

var convertFromRawToDraftState = __webpack_require__(960);

var generateRandomKey = __webpack_require__(57);

var getDefaultKeyBinding = __webpack_require__(408);

var getVisibleSelectionRect = __webpack_require__(966);

var convertFromHTML = __webpack_require__(374);

var DraftPublic = {
  Editor: DraftEditor,
  EditorBlock: DraftEditorBlock,
  EditorState: EditorState,
  CompositeDecorator: CompositeDraftDecorator,
  Entity: DraftEntity,
  EntityInstance: DraftEntityInstance,
  BlockMapBuilder: BlockMapBuilder,
  CharacterMetadata: CharacterMetadata,
  ContentBlock: ContentBlock,
  ContentState: ContentState,
  RawDraftContentState: RawDraftContentState,
  SelectionState: SelectionState,
  AtomicBlockUtils: AtomicBlockUtils,
  KeyBindingUtil: KeyBindingUtil,
  Modifier: DraftModifier,
  RichUtils: RichTextEditorUtil,
  DefaultDraftBlockRenderMap: DefaultDraftBlockRenderMap,
  DefaultDraftInlineStyle: DefaultDraftInlineStyle,
  convertFromHTML: convertFromHTML,
  convertFromRaw: convertFromRawToDraftState,
  convertToRaw: convertFromDraftStateToRaw,
  genKey: generateRandomKey,
  getDefaultKeyBinding: getDefaultKeyBinding,
  getVisibleSelectionRect: getVisibleSelectionRect
};
module.exports = DraftPublic;

/***/ }),
/* 39 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(107);
var defined = __webpack_require__(54);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(108);
var createDesc = __webpack_require__(74);
var toIObject = __webpack_require__(40);
var toPrimitive = __webpack_require__(53);
var has = __webpack_require__(39);
var IE8_DOM_DEFINE = __webpack_require__(265);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(19) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(39);
var toObject = __webpack_require__(22);
var IE_PROTO = __webpack_require__(181)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var _require = __webpack_require__(4),
    Map = _require.Map,
    OrderedSet = _require.OrderedSet,
    Record = _require.Record; // Immutable.map is typed such that the value for every key in the map
// must be the same type


var EMPTY_SET = OrderedSet();
var defaultRecord = {
  style: EMPTY_SET,
  entity: null
};
var CharacterMetadataRecord = Record(defaultRecord);

var CharacterMetadata = /*#__PURE__*/function (_CharacterMetadataRec) {
  _inheritsLoose(CharacterMetadata, _CharacterMetadataRec);

  function CharacterMetadata() {
    return _CharacterMetadataRec.apply(this, arguments) || this;
  }

  var _proto = CharacterMetadata.prototype;

  _proto.getStyle = function getStyle() {
    return this.get('style');
  };

  _proto.getEntity = function getEntity() {
    return this.get('entity');
  };

  _proto.hasStyle = function hasStyle(style) {
    return this.getStyle().includes(style);
  };

  CharacterMetadata.applyStyle = function applyStyle(record, style) {
    var withStyle = record.set('style', record.getStyle().add(style));
    return CharacterMetadata.create(withStyle);
  };

  CharacterMetadata.removeStyle = function removeStyle(record, style) {
    var withoutStyle = record.set('style', record.getStyle().remove(style));
    return CharacterMetadata.create(withoutStyle);
  };

  CharacterMetadata.applyEntity = function applyEntity(record, entityKey) {
    var withEntity = record.getEntity() === entityKey ? record : record.set('entity', entityKey);
    return CharacterMetadata.create(withEntity);
  }
  /**
   * Use this function instead of the `CharacterMetadata` constructor.
   * Since most content generally uses only a very small number of
   * style/entity permutations, we can reuse these objects as often as
   * possible.
   */
  ;

  CharacterMetadata.create = function create(config) {
    if (!config) {
      return EMPTY;
    }

    var defaultConfig = {
      style: EMPTY_SET,
      entity: null
    }; // Fill in unspecified properties, if necessary.

    var configMap = Map(defaultConfig).merge(config);
    var existing = pool.get(configMap);

    if (existing) {
      return existing;
    }

    var newCharacter = new CharacterMetadata(configMap);
    pool = pool.set(configMap, newCharacter);
    return newCharacter;
  };

  CharacterMetadata.fromJS = function fromJS(_ref) {
    var style = _ref.style,
        entity = _ref.entity;
    return new CharacterMetadata({
      style: Array.isArray(style) ? OrderedSet(style) : style,
      entity: Array.isArray(entity) ? OrderedSet(entity) : entity
    });
  };

  return CharacterMetadata;
}(CharacterMetadataRecord);

var EMPTY = new CharacterMetadata();
var pool = Map([[Map(defaultRecord), EMPTY]]);
CharacterMetadata.EMPTY = EMPTY;
module.exports = CharacterMetadata;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This file is a fork of ContentBlock adding support for nesting references by
 * providing links to children, parent, prevSibling, and nextSibling.
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var CharacterMetadata = __webpack_require__(43);

var findRangesImmutable = __webpack_require__(121);

var Immutable = __webpack_require__(4);

var List = Immutable.List,
    Map = Immutable.Map,
    OrderedSet = Immutable.OrderedSet,
    Record = Immutable.Record,
    Repeat = Immutable.Repeat;
var EMPTY_SET = OrderedSet();
var defaultRecord = {
  parent: null,
  characterList: List(),
  data: Map(),
  depth: 0,
  key: '',
  text: '',
  type: 'unstyled',
  children: List(),
  prevSibling: null,
  nextSibling: null
};

var haveEqualStyle = function haveEqualStyle(charA, charB) {
  return charA.getStyle() === charB.getStyle();
};

var haveEqualEntity = function haveEqualEntity(charA, charB) {
  return charA.getEntity() === charB.getEntity();
};

var decorateCharacterList = function decorateCharacterList(config) {
  if (!config) {
    return config;
  }

  var characterList = config.characterList,
      text = config.text;

  if (text && !characterList) {
    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
  }

  return config;
};

var ContentBlockNode = /*#__PURE__*/function (_ref) {
  _inheritsLoose(ContentBlockNode, _ref);

  function ContentBlockNode() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultRecord;

    /* eslint-disable-next-line constructor-super */
    return _ref.call(this, decorateCharacterList(props)) || this;
  }

  var _proto = ContentBlockNode.prototype;

  _proto.getKey = function getKey() {
    return this.get('key');
  };

  _proto.getType = function getType() {
    return this.get('type');
  };

  _proto.getText = function getText() {
    return this.get('text');
  };

  _proto.getCharacterList = function getCharacterList() {
    return this.get('characterList');
  };

  _proto.getLength = function getLength() {
    return this.getText().length;
  };

  _proto.getDepth = function getDepth() {
    return this.get('depth');
  };

  _proto.getData = function getData() {
    return this.get('data');
  };

  _proto.getInlineStyleAt = function getInlineStyleAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getStyle() : EMPTY_SET;
  };

  _proto.getEntityAt = function getEntityAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getEntity() : null;
  };

  _proto.getChildKeys = function getChildKeys() {
    return this.get('children');
  };

  _proto.getParentKey = function getParentKey() {
    return this.get('parent');
  };

  _proto.getPrevSiblingKey = function getPrevSiblingKey() {
    return this.get('prevSibling');
  };

  _proto.getNextSiblingKey = function getNextSiblingKey() {
    return this.get('nextSibling');
  };

  _proto.findStyleRanges = function findStyleRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
  };

  _proto.findEntityRanges = function findEntityRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
  };

  return ContentBlockNode;
}(Record(defaultRecord));

module.exports = ContentBlockNode;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 46 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 47 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(27);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 49 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 50 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(12),
    _assign = __webpack_require__(8);

var CallbackQueue = __webpack_require__(383);
var PooledClass = __webpack_require__(92);
var ReactFeatureFlags = __webpack_require__(384);
var ReactReconciler = __webpack_require__(93);
var Transaction = __webpack_require__(167);

var invariant = __webpack_require__(6);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(10);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(0);
var core = __webpack_require__(47);
var fails = __webpack_require__(7);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(48);
var IObject = __webpack_require__(107);
var toObject = __webpack_require__(22);
var toLength = __webpack_require__(16);
var asc = __webpack_require__(197);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var seenKeys = {};
var MULTIPLIER = Math.pow(2, 24);

function generateRandomKey() {
  var key;

  while (key === undefined || seenKeys.hasOwnProperty(key) || !isNaN(+key)) {
    key = Math.floor(Math.random() * MULTIPLIER).toString(32);
  }

  seenKeys[key] = true;
  return key;
}

module.exports = generateRandomKey;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var english = exports.english = {
  general: {
    approach: "Approach",
    controls: "project controls",
    lesson: "Lesson",
    stage: "Stage",
    statement: {
      effect: "effect",
      because: "because",
      event: "event",
      thisWasCausedBy: "This was caused by",
      cause: "cause"
    },
    hours: "Hours (h)",
    expences: "Expenses",
    investment: "Investment",
    total: "Total",
    stageMenu: {
      stageActions: "Stage actions",
      back: " Back",
      move: "Move",
      edit: "Edit",
      selectPhase: "Select phase",
      noPhase: "no phase",
      cancelMove: "Cancel Move",
      requestApproval: "Request Approval",
      approveStage: "Approve Stage",
      retractRequest: "Retract Approval Request",
      endStageReport: "Create End Stage Report",
      raiseException: "Raise Exception",
      registerActuals: "Register actuals",
      prepareClosure: "Prepare project closure",
      changesToApprovedStage: "You have made changes to an already approved stage plan. It will automatically be saved as a new approved version when an exception plan is approved."
    },
    stagePlan: {
      title: "Stage plan",
      budget: "Budget",
      schedule: "Schedule",
      startDate: "Start date",
      endDate: "End date",
      timeTolerance: "Tolerance",
      projectPhase: "Project",
      totalPhase: "Total Project",
      totalStagePrefix: "Total",
      actions: {
        confirmDelete: "Do you want to delete this stage?"
      }
    },
    lessons: {
      onlyProject: "Show only lessons applied on this project",
      source: "Source",
      appliedIn: "Applied in",
      actions: {
        applyLesson: "Apply lesson",
        unapplyLesson: "Unapply lesson",
        editLesson: "Edit lesson",
        confirmDelete: "Do you want to delete this output?"
      },
      keywords: {
        title: "And containing keywords",
        description: "Keywords. Separate by comma (,)"
      },
      filterOptions: {
        time: {
          options: {
            lessThan12Months: "Newer than 12 months",
            oneToThreeYears: "Between 1 and 3 years",
            threeToFiveYears: "Between 3 and 5 years",
            moreThanFiveYears: "Older than 5 years"
          }
        }
      }
    },
    currency: "The currency used in this project is {currency}. You can change the project´s currency in ",
    projectPropertiesLink: "Project Properties",
    stagePlanCurrency: "Cost is shown in {currency}.",
    actuals: "Actual values",
    showingActuals: "Actual values are recorded",
    projectIsCompleted: "Project is completed",
    closureInProgress: "Project closure is in progress",
    phaseTransition: {
      stageOutsidePhases: "Phase transition is disabled, due to stage(s) outside phases.",
      requestToStart: "Request to start",
      projectNotStarted: "Project not started",
      requestComments: "Request Comments",
      readMore: "Read more about",
      cancel: "Cancel",
      submitRequest: "Submit Request",
      requestPending: "Requested to start",
      retractRequest: "Retract Request",
      approveRequest: "Approve Request",
      currentPhase: "Current Phase",
      requestToEnd: "Request to end",
      prepareClosure: "Prepare project closure"
    },
    exceptionPlan: {
      title: "Exception plan",
      readMore: "Read more...",
      approve: "Approve",
      exceptionReport: "Exception Report",
      baselinePlan: "Baseline Plan",
      beforeExceptionAproval: "before exception approval",
      afterExceptionApproval: "after exception approval",
      stageNotFound: "<stage not found>",
      update: "Update",
      requestApproval: "Request Approval",
      cancel: "Cancel",
      missingExceptionReport: "Reference to Exception Report is missing.",
      newBaselinePlan: "New baseline plan",
      fields: {
        summary: {
          title: "Exception Plan Summary",
          help: "What is the cause of the deviation from the agreed plan? What is the consequence? What is the main differences between the exception plan and the currently approved baseline?.",
          description: "Summarize cause and consequence of the exception, how the exception plan differs from existing baseline"
        },
        level: {
          title: "Exception Plan Level",
          options: {
            stage: { title: "Stage" },
            phase: { title: "Phase" },
            project: { title: "Project" }
          }
        },
        report: {
          title: "Exception Report",
          empty: "-- select exception report --"
        }
      }
    },
    baselineHistory: {
      title: "Baseline History",
      close: "Close History",
      hideDetails: "Hide details",
      header: {
        approvedPID: "Approved PID",
        approvedStage: "Approved Stage",
        unknown: "unknown baseline",
        exception: {
          stage: "Stage Exception",
          phase: "Phase Exception",
          project: "Project Exception",
          unknown: "unknown exception"
        }
      },
      noBaseline: "There is no baseline history for this project. The first baseline is set when a Project Initiation Document or Stage Plan is approved.",
      loadingHistory: "Loading history...",
      errorOccuredDurligLoading: "An error occured loading history",
      entry: {
        approvedPID: "Approved Project Initiation Document",
        baselinePlan: "Baseline plan",
        newBaselinePlan: "New baseline plan",
        beforePIDApproval: "before PID approval",
        afterPIDApproval: "after PID approval",
        approvedStagePlan: "Approved stage plan",
        beforeStageApproval: "before stage approval",
        afterStageApproval: "after initial stage approval",
        unknownBaseline: "Unknown baseline type"
      }
    }
  },
  planApproach: {
    title: "Project Approach",
    description: "The project approach is describing in which way the project work will be done. The approach should clarify methods of working, manning approach, technical and regulatory strategies and other relevant aspects influencing how the project will be organized and executed.",
    fields: {
      methods: {
        title: "Methods",
        help: "Any tailoring to project method? What will be scaled down or not used, and why?\n          Any specific methodology or technical method to be used?\n          Any deviations to Standard Operating Procedures or guidelines?\n          Will this project go through a set of defined life-cycle phases?\n          Any guidelines, standards practices used?",
        description: "Describe the tailoring of the project method and any specialist/development/production method or process to be applied for this project."
      },
      resources: {
        title: "Resources",
        help: "Working with partners? If so, who will do what?\n          Using internal or external teams or both? If so, who will do what?\n          How will resources be financed? Strict or loose resource deployment?",
        description: "Describe how we will get the needed people, equipment and money to get the project done."
      },
      technology: {
        title: "Technology",
        help: "Any specific technology to be used, or how is technology platform to be selected?\n          Will it be built on off-the-shelf components or custom-designed?\n          Any specific production site or method selected, or how will it be selected?\n          Any regulatory strategy selected, or how will it be selected?",
        description: "Describe the technology to be used or to build on, and the regulatory strategy relevant for the selected technology."
      },
      rollOut: {
        title: "Roll out strategy",
        help: "Is this a temporary \u201Cstop-gap\u201D or \u201Cever lasting\u201D solution?\n          Any staging of releases? Updates to come? Where to role out/distribute first and last?\n          Announce late or early to receivers/users/market \u2013 and why?",
        description: "Describe the launch, roll out, or distribution strategy for the end product."
      },
      other: {
        title: "Other",
        description: "Any thing else about how the work of the project will be approached?"
      }
    }
  },
  schedule: {
    title: "Schedule",
    fields: {
      schedule: {
        columnHeaders: {
          stage: { title: "Stage" },
          time: { title: "Time" },
          cost: { title: "Cost" }
        },
        columns: {
          name: { title: "" },
          start: { title: "Start" },
          end: { title: "End" },
          timeTolerance: { title: "Tolerance", note: "Time tolerance units: Days = Business Days, Weeks = Work weeks" },
          hours: { title: "Hours (h)" },
          expences: { title: "Expenses" },
          investments: { title: "Investments" },
          sum: { title: "Sum" },
          costTolerance: { title: "Tolerance" }
        },
        options: {
          addEntry: { title: "+ Add stage" }
        }
      }
    }
  },
  lessons: {
    title: "Lessons",
    fields: {
      lessonLog: {
        title: "Lessons",
        columns: {
          no: { title: "Id" },
          title: { title: "Title" },
          source: { title: "Source" },
          priorityLabel: { title: "Priority" },
          recommendations: { title: "Recommendations" }
        },
        options: {
          addEntry: {
            title: "Add lesson"
          }
        }
      }
    }
  },
  summary: {
    title: "Summary",
    fields: {
      title: {
        title: "Title",
        help: "Short summary of the lesson",
        description: "Descriptive title"
      },
      type: {
        title: "Lesson Type",
        help: "Project \u2013 only applies to this project\nProgramme \u2013 applies to the programme which this project is part of\nPortfolio \u2013 applies to the portfolio which this project is part of\nCorporate \u2013 applies to all projects",
        options: {
          project: "Project",
          program: "Programme",
          portfolio: "Portfolio",
          corporate: "Corporate"
        }
      },
      priority: {
        title: "Lesson Priority",
        help: "If this lesson is ignored later in the project or in other projects, how significant will the effect be on the project\u2019s objectives?",
        options: {
          high: "High",
          medium: "Medium",
          low: "Low"
        }
      }
    }
  },
  detail: {
    title: "Details",
    fields: {
      cause: {
        title: "Cause",
        help: "What triggered the event to occur? What was the situation that gave rise to the lesson. Example: technical requirement documentation was not complete",
        description: "Describe the source of the lesson."
      },
      event: {
        title: "Event",
        help: "What event was triggered by the cause. Example: the technical design work couldn\u2019t start",
        description: "Describe the event that caused an impact on the project."
      },
      effect: {
        title: "Effect",
        help: "What was the impact, and what were the consequences for the project\u2019s objectives? Example: the project was delayed by two months",
        description: "Explain the impact(s) on the project objectives."
      },
      description: {
        title: "Detailed Description",
        description: "Describe relevant background, context and facts related to the lesson",
        help: "What information is relevant for someone who consider to apply this lesson? Any additional background information or context? Are there any quantified statistics, measurements or facts related to the lesson?"
      }
    }
  },
  followUp: {
    title: "Follow up",
    fields: {
      indicators: {
        title: "Early warning indicators",
        help: "What triggers should be used to focus attention on this particular area in the future?\n          Under which circumstances should this lesson be applied to avoid negative impact on the project?\n          Was this previously identified as a risk?",
        description: "Describe the indicators which should trigger application of this lesson"
      },
      recommendations: {
        title: "Recommendations",
        help: "If these circumstances (the early warning indicators) should reappear, what is then important to do?\n          What is your advice for the future?",
        description: "Give a recommendation on what to do when this lesson is applied"
      }
    }
  },
  projectControls: {
    title: "Project Controls",
    description: "Project Control defines how the Project Board will maintain enough control of the project and how the Project Manager will maintain sufficient control of work managed by the Team Managers.",
    fields: {
      projectControls: {
        title: "Project Controls",
        help: "What is the frequency and format of communication between Project Manager and Project Board?\n          What is the frequency and format of communication between Team Manager and Project Manager?\n          Is there any guidance on length of stages? Short stages give more control, but also more overhead.\n          When is something escalated for information, for decision or for guidance? When is a flag raised?\n          What tools and processes are used to escalate for information, decisions or guidance?",
        description: "Describe the project level controls needed such as monitoring, escalation and reporting formats and frequency"
      }
    }
  },
  stageDescription: {
    frontPage: "Front Page",
    title: "Description",
    fields: {
      identifier: {
        title: 'Identifier',
        description: '(not in use)'
      },
      name: {
        title: "Name",
        description: "Name of the stage"
      },
      description: {
        title: "Description",
        help: "Where in the project\u2019s lifecycle is this stage (if relevant), and what type of work is done (analysis, design, test etc)?\n          What is the goal of this stage?\n          Briefly summarized, what will this stage include and how will it be done?Which project (and if relevant which lifecycle phase) is this stage a part of?",
        description: "Short description of what this stage is"
      },
      prerequisite: {
        title: "Plan Prerequisite",
        help: "Are there already existing documents or other inputs this plan is built on or this stage will need to start executing?\n          Any deliverables, events or decisions to be concluded for this plan to start?",
        description: "Describe what must be in place to start execution of this stage"
      },
      method: {
        title: "Method",
        values: {
          product: "Product Management",
          project: "Project Managament"
        }
      }
    }
  },
  stageContext: {
    title: "Context",
    fields: {
      externalDependencies: {
        title: "External Dependencies",
        help: "Any ongoing activities outside this project that may influence the stage during execution?\n          Are you dependening on other projects to deliver output or release resources during the execution of this stage?\n          Any actions, events or decisions outside this project's influence that might influence the stage execution?",
        description: "Describe external dependencies"
      },
      assumptions: {
        title: "Planning Assumptions",
        help: "Are there any assumptions made in the plan on access to resources, tools or competencies?\n          Are there made any assumptions or completeness of required input to this stage",
        description: "Describe planning assumptions"
      },
      stageApproach: {
        title: "Stage Approach",
        help: "Any specific methodology or technical method to be used in this stage?\n          Any guidelines, standards practices used?\n          Using internal or external teams or both? If so, who will do what?\n          Any specific technology to be used in this stage?",
        description: "Describe the delivery approache(s) for this stage"
      },
      lessonsIncorporated: {
        title: "Lessons Incorporated",
        help: "Are relevant lessons learned from previous stages used in the planning of this stage?\n          Are relevant lessons learned from other projects used in the planning of this stage?",
        description: "Describe relevant lessons incorporated in the planning and execution of this stage"
      },
      monitorAndControl: {
        title: "Monitor and Control",
        help: "What is the frequency and format of communication between Project Manager and Project Board during the stage?\n          What is the frequency and format of communication between Team Manager and Project Manager?\n          When is something escalated for information, for decision or for guidance? When is a flag raised?\n          What tools and processes are used to escalate information, decisions or guidance?",
        description: "Describe the stage level controls needed such as monitoring, escalation and reporting formats and frequency"
      }
    }
  },
  stageTime: {
    title: "Time",
    fields: {
      period: {
        title: "Stage period"
      },
      timeTolerance: {
        title: "Time Tolerance (value)",
        description: "In number of business days, workweeks or months"
      },
      timeToleranceUnit: {
        title: "Time Tolerance (unit)",
        options: {
          days: "Days",
          weeks: "Weeks",
          months: "Months"
        }
      },
      timeComments: {
        title: "Comments to Time",
        description: "Comments to the time aspect of the stage plan"
      }
    }
  },
  stageCost: {
    title: "Cost",
    fields: {
      budget: {
        title: "Stage budget",
        help: "Hours: Number of hours needed by internal staff, or hour spent by external resources where the policy is to do project accounting in hours.\n          Expenses: Direct expenses received as invoices. This should normally exclude expenses filed as hours. Should not included investments.\n          Investments: Capitalized costs for fixed assets\n          Total: Manually calculated total cost of the stage. Usually total = hours x cost of hours + expenses + investments.",
        columns: {
          element: { title: "Cost element" },
          cost: { title: "Cost" },
          tolerance: { title: "Tolerance" },
          comment: { title: "Comment" }
        }
      }
    }
  },
  stageScheduleScope: {
    title: "Schedule & Scope",
    fields: {
      plan: {
        title: "Stage Scehdule",
        columns: {
          workPackage: { title: "Work Package" },
          owner: { title: "Owner" },
          dueDate: { title: "Due Date" },
          status: { title: "Status" },
          comment: { title: "Comment" }
        },
        samples: [{ workPackage: "Pilot A\n  - Prototype A\n  - Pilot site report", owner: "IT director", dueDate: "2018-12-01", status: "Completed" }, { workPackage: "Marketing\n  - Product Webpage\n  - Launch Plan", owner: "Marketing director", dueDate: "2018-12-12", status: "Started" }, { workPackage: "Cleaning", owner: "Donald Duck", dueDate: "2018-11-20", status: "Not Started" }],
        options: {
          addEntry: { title: "+Add" }
        }
      },
      scheduleComments: {
        title: "To be Delivered",
        description: "Describe/list what will be delivered in this stage, when and by whom"
      }
    }
  },
  actuals: {
    title: "Actuals",
    fields: {
      period: {
        title: "Actual stage period"
      },
      cost: {
        title: "Actual stage cost",
        columns: {
          element: { title: "Cost element" },
          cost: { title: "Cost" },
          comment: { title: "Comment" }
        }
      }
    }
  }
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var norwegian = exports.norwegian = {
  general: {
    approach: "Tilnærming",
    controls: "Prosjektkontroll",
    lesson: "Erfaring",
    stage: "Etappe",
    statement: {
      effect: "effekt",
      because: "fordi",
      event: "hendelse",
      thisWasCausedBy: "Dette var forårsaket av",
      cause: "årsak"
    },
    hours: "Timer",
    expences: "Utgifter",
    investment: "Investeringer",
    total: "Totalt",
    stageMenu: {
      stageActions: "Etappehandlinger",
      back: "Tilbake",
      move: "Flytt",
      edit: "Endre",
      selectPhase: "Velg fase",
      noPhase: "ingen fase",
      cancelMove: "Avbryt flytting",
      requestApproval: "Forespør godkjenning",
      approveStage: "Godkjenn etappe",
      retractRequest: "Trekk tilbake forespørsel om godkjenning",
      endStageReport: "Opprett etapperapport",
      raiseException: "Håndter unntak",
      registerActuals: "Angi faktiske verdier",
      prepareClosure: "Forbered prosjektavslutning",
      changesToApprovedStage: "Du har utført endringer til en allrede godkjent etappeplan. Endringene vil automatisk bli lagret som en ny versjon når en unntaksplan blir godkjent."
    },
    stagePlan: {
      title: "Etappeplan",
      budget: "Budsjett",
      schedule: "Tidsplan",
      startDate: "Startdato",
      endDate: "Sluttdato",
      timeTolerance: "Toleranse",
      projectPhase: "Prosjekt",
      totalPhase: "Totalt for prosjektet",
      totalStagePrefix: "Totalt for ",
      actions: {
        confirmDelete: "Vil du slette denne etappen?"
      }
    },
    lessons: {
      onlyProject: "Vis bare erfaringer brukt i dette prosjektet",
      source: "Kilde",
      appliedIn: "Tatt i bruk av",
      actions: {
        applyLesson: "Bruk erfaringen",
        unapplyLesson: "Avslutt bruk av erfaringen",
        editLesson: "Endre erfaring",
        confirmDelete: "Vil du slette denne erfaringen?"
      },
      keywords: {
        title: "Og inneholder nøkkelord",
        description: "Nøkkelord adskilt med komma (,)"
      },
      filterOptions: {
        time: {
          options: {
            lessThan12Months: "Nyere enn 12 måneder",
            oneToThreeYears: "Mellom 1 og 3 år",
            threeToFiveYears: "Mellom 3 og 5 år",
            moreThanFiveYears: "Eldre enn 5 år"
          }
        }
      }
    },
    currency: "Valuta for dette prosjektet er {currency}. Du kan endre prosjektets valuta i ",
    projectPropertiesLink: "Prosjektegenskaper",
    stagePlanCurrency: "Kostnad er vist i {currency}.",
    actuals: "Faktiske verdier",
    showingActuals: "Faktiske verdier er registrert",
    projectIsCompleted: "Prosjektet er avsluttet",
    closureInProgress: "Prosjektavslutning pågår",
    phaseTransition: {
      stageOutsidePhases: "Det er etappe(r) utenfor fasene. Faseovergang er derfor ikke mulig",
      requestToStart: "Forespør oppstart av",
      projectNotStarted: "Prosjektet er ikke startet",
      requestComments: "Kommentarerer til forespørselen",
      readMore: "Les mer om",
      cancel: "Avbryt",
      submitRequest: "Send forespørsel",
      requestPending: "Venter på godkjenning til å starte",
      retractRequest: "Trekk tilbake forespørselen",
      approveRequest: "Godkjenn forespørsel",
      currentPhase: "Gjeldende fase",
      requestToEnd: "Forespørsel om avslutning av",
      prepareClosure: "Forbered prosjektavslutning"
    },
    exceptionPlan: {
      title: "Unntaksplan",
      readMore: "Se detaljer...",
      approve: "Godkjenn unntaksplan",
      exceptionReport: "Unntaksrapport",
      baselinePlan: "Godkjent plan",
      beforeExceptionAproval: "før godkjenning av unntak",
      afterExceptionApproval: "etter godkjenning av unntak",
      stageNotFound: "<etappe er ikke funnet>",
      update: "Oppdater",
      requestApproval: "Forespør godkjenning",
      cancel: "Avbryt",
      missingExceptionReport: "Referanse til unntaksplan mangler.",
      newBaselinePlan: "Ny godkjent plan",
      fields: {
        summary: {
          title: "Oppsummering av unntaksplanen",
          help: "Hva skyldes avviken fra avtalt plan? Hva er konsekvensene? Hva er hovedforskjellen mellom unntaksplanen og siste godkjente plan?",
          description: "Oppsummer årsak og konsekvenser av unntaket, hvordan unntaksplanen avviker fra godkjent plan."
        },
        level: {
          title: "Unntaksnivå",
          options: {
            stage: { title: "Etappe" },
            phase: { title: "Fase" },
            project: { title: "Prosjekt" }
          }
        },
        report: {
          title: "Unntaksrapport",
          empty: "-- velg unntaksrapport --"
        }
      }
    },
    baselineHistory: {
      title: "Godkjenningshistorikk",
      close: "Lukk historikk",
      hideDetails: "Skjul detaljer",
      header: {
        approvedPID: "Godkjent styringsdoukment",
        approvedStage: "Godkjent etappe",
        unknown: "ukjent godkjenning",
        exception: {
          stage: "Unntak for etappe",
          phase: "Unntak for fase",
          project: "Unntak for prosjekt",
          unknown: "Ukjent unntak"
        }
      },
      noBaseline: "Prosjektet har ikke godkjenningshistorikk. Historikken oppstår når styringsdokumentet eller en etappeplan godkjennes.",
      loadingHistory: "Laster historikk...",
      errorOccuredDurligLoading: "En feil oppstov ed lasting av historikk",
      entry: {
        approvedPID: "Godkjent styringsdokument",
        baselinePlan: "Godkjent plan",
        newBaselinePlan: "Ny godkjent plan",
        beforePIDApproval: "før styringsdokumentet ble godkjent",
        afterPIDApproval: "etter at styringsdokumentet ble godkjent",
        approvedStagePlan: "Godkjent etappeplan",
        beforeStageApproval: "før etappeplanen ble godkjent",
        afterStageApproval: "etter at etappeplanen ble godkjent",
        unknownBaseline: "Ukjent type godkjent plan"
      }
    }
  },
  planApproach: {
    title: "Tilnærming",
    description: "Prosjekttilnærmingen beskriver hvordan prosjektet vil gjennomføre arbeidet. Tilnærmingen skal forklare hvilke arbeidsmetoder som skal brukes, hvordan prosjekt skal bemannes, tekniske og regulatoriske strategier og andre relevante aspekter som påvirker organiseringen og gjennomføringen av prosjektet.",
    fields: {
      methods: {
        title: "Metoder",
        help: "Skal det gj\xF8res tilpassninger til prosjektmetoden? Hva blir skalert ned eller ikke brukt, og hvorfor?\n          Hvilken spesifikk metodikk og teknisk metode skal brukes?\n          Vil det blir gjort avvik fra standard operasjonsprosedyrer eller retningslinjer?\n          Vil dette prosjektet g\xE5 gjennom et sett av definerte livssyklusfaser?\n          Er det retningslinjer eller standard praksis som skal brukes?",
        description: "Beskriv i hvilken grad prosjektmetoden er skreddersydd og bruk av spesialist-, utvikling-, og/eller produksjonsmetoder eller prosesser"
      },
      resources: {
        title: "Ressurser",
        help: "Utf\xF8res arbeidet av eller i samarbeid med partnere? Hvis ja, hvem vil gj\xF8re hva?\n          Skal det bruke interne og/eller eksterne ressurser? Hvis ja, hvem vil gj\xF8re hva?\n          Hvordan skal ressursbruken finansieres? Vil det bli l\xF8s eller streng oppf\xF8lging av ressursbruken?",
        description: "Beskriv hvordan vi får de nødvendige personene, utstyr og penger for å få prosjektet gjennomført."
      },
      technology: {
        title: "Tekologi",
        help: "Skal det brukes en spesifikk teknologi, eller hvordan skal teknologiplattformen velges?\n          Vil det bli bygget p\xE5 hyllevare eller v\xE6re skredders\xF8m?\n          Er det snakk om et spesifikk produksjonssted eller metode som er valgt, eller hvordan vil det bli valgt?\n          Er det valgt reguleringsstrategi, eller hvordan vil den bli valgt?",
        description: "Beskriv teknologien som skal brukes eller bygges videre på, og reguleringsstrategien som er relevant for den valgte teknologien."
      },
      rollOut: {
        title: "Utrullingsstrategi",
        help: "Er dette en midlertidig \"dekke-gap\" eller \"evigvarende\" l\xF8sning?\n          Hvordan tilgjengeliggj\xF8res forskjellige versjoner/utgivelser? Er det planlagt fremtidige oppdateringer? Hvor skal produktene rulles ut, distribueres eller gj\xF8res tilgjengelig f\xF8rst og sist?\n          Skal kunngj\xF8ringer til mottakerne, brukerne og markedet gj\xF8res sent eller tidlig, og hvorfor?",
        description: "Beskriv lansering, utrulling eller distribusjonsstrategi av sluttproduktet."
      },
      other: {
        title: "Annet",
        description: "Er det noe annet som bør nevnes i forhold til hvordan arbeidet i prosjektet vil tilnærmes?"
      }
    }
  },
  schedule: {
    title: "Tidsplan",
    fields: {
      schedule: {
        columnHeaders: {
          stage: { title: "Etappe" },
          time: { title: "Tid" },
          cost: { title: "Kostnad" }
        },
        columns: {
          name: { title: "" },
          start: { title: "Start" },
          end: { title: "Slutt" },
          timeTolerance: { title: "Toleranse" },
          hours: { title: "Timer" },
          expences: { title: "Utgifter" },
          investments: { title: "Investeringer" },
          sum: { title: "Sum" },
          costTolerance: { title: "Toleranse" }
        },
        options: {
          addEntry: { title: "+ Legg til etappe" }
        }
      }
    }
  },
  lessons: {
    title: "Erfaringer",
    fields: {
      lessonLog: {
        title: "Opplevde erfaringer",
        columns: {
          no: { title: "Id" },
          title: { title: "Tittel" },
          source: { title: "Kilde" },
          priorityLabel: { title: "Prioritet" },
          recommendations: { title: "Anbefalinger" }
        },
        options: {
          addEntry: {
            title: "Legg til erfaring"
          }
        }
      }
    }
  },
  summary: {
    title: "Oppsummering",
    fields: {
      title: {
        title: "Tittel",
        help: "Kort oppsummering av det som er erfart",
        description: "Oppsummer erfaringen"
      },
      type: {
        title: "Relevant for",
        options: {
          project: "Kun prosjektet",
          program: "Alle prosjekter i programmet",
          portfolio: "Alle prosjekter i porteføljen",
          corporate: "Alle prosjekter"
        }
      },
      priority: {
        title: "Prioritet",
        help: "Hvis denne erfaringen ignoreres senere i prosjektet eller i andre prosjekter, hvor vesentlig vil effekten v\xE6re p\xE5 prosjektets m\xE5l?",
        options: {
          high: "Høy",
          medium: "Middels",
          low: "Lav"
        }
      }
    }
  },
  detail: {
    title: "Detaljer",
    fields: {
      cause: {
        title: "Årsak",
        help: "Hva utl\xF8ste hendelsen? Hva var situasjonen som ga opphav til erfaringen. Eksempel: Teknisk kravdokumentasjon var ikke fullf\xF8rt",
        description: "Beskriv årsaken til at hendelsen oppstod"
      },
      event: {
        title: "Hendelse",
        help: "Hvilken begivenhet ble utl\xF8st av \xE5rsaken. Eksempel: Det tekniske designarbeidet kunne ikke starte",
        description: "Beskriv hva som skjedde"
      },
      effect: {
        title: "Effekt",
        help: "Hva var effekten, og hvilke konsekvenser medf\xF8rte dette for prosjektets m\xE5l? Eksempel: Prosjektet ble forsinket med to m\xE5neder",
        description: "Beskriv påvirkningen på prosjektmålene (tid, kostnad, kvalitet, omfang, gevinst, risiko)"
      },
      description: {
        title: "Detaljert beskrivelse",
        description: "Beskriv relevant bakgrunn, sammenheng og fakta relatert til erfaringen",
        help: "Hvilken informasjon er relevant for noen som vurderer \xE5 bruke denne erfaringen? Er det n\xF8dvendig med ytterligere bakgrunn eller sammenheng? Finnes det noe kvantifisert statistikk, m\xE5linger eller fakta relatert til denne erfaringen?"
      }
    }
  },
  followUp: {
    title: "Oppfølging",
    fields: {
      indicators: {
        title: "Tidlige varselsindikatorer",
        help: "Hvilke situasjoner b\xF8r brukes til \xE5 fokusere oppmerksomhet p\xE5 dette omr\xE5det i fremtiden?\n          Under hvilke omstendigheter skal denne erfaringen brukes for \xE5 unng\xE5 negativ innvirkning p\xE5 prosjektet?\n          Var dette tidligere identifisert som en risiko?",
        description: "Beskriv hvordan samme eller lignende hendelser kan varsles på forhånd"
      },
      recommendations: {
        title: "Anbefalinger",
        help: "Hvis disse omstendighetene (de tidlige varslingsindikatorene) skulle dukke opp igjen, hva er da viktig \xE5 gj\xF8re?\n          Hva er ditt r\xE5d for fremtiden?",
        description: "Oppsummer hva som bør gjøres fremover"
      }
    }
  },
  projectControls: {
    title: "Prosjektkontroll",
    description: "Prosjektkontroll definerer hvordan styringsgruppen får tilfredsstillende kontroll med prosjektet og hvordan prosjektlederen sikrer tilstrekkelig kontroll med arbeidet gjort i prosjektet.",
    fields: {
      projectControls: {
        title: "Prosjektkontroll",
        help: "Hva er frekvens og format for kommunikasjon mellom prosjektleder og prosjektstyret (styringsgruppen)?\n          Hva er frekvensen og format for kommunikasjon mellom teamleder og prosjektleder?\n          Finnes det noen retningslinjer/anbefalringer p\xE5 lengden av etappene? Korte etapper gir mer kontroll, men ogs\xE5 merarbeid.\n          N\xE5r skal det eskaleres til informasjon, til beslutning eller for \xE5 be om veiledning? N\xE5r skal \"flagget heves\"?\n          Hvilke verkt\xF8y og prosesser brukes for eskalering til informasjon, til beslutning eller for \xE5 be om veiledning?",
        description: "Beskriv nødvendige kontroller på prosjektnivå, for eksempel overvåkning, eskalering og rapporteringsformat og frekvens"
      }
    }
  },
  stageDescription: {
    frontPage: "Forside",
    title: "Etappe",
    fields: {
      identifier: {
        title: 'Identifikator',
        description: '(ikke i bruk)'
      },
      name: {
        title: "Navn",
        description: "Angi en kort tittel på etappen"
      },
      description: {
        title: "Beskrivelse av etappen",
        help: "Hvor i prosjektets livssyklus er denne etappen og hvilket type arbeid er gjort (analyse, design, test, etc)?\n          Hva er m\xE5let med etappen?\n          Kort oppsummert, hva vil denne etappen inneholde og hvordan vil det bli gjort?\n          ",
        description: "Beskriv kort hva denne etappen innebærer"
      },
      prerequisite: {
        title: "Forutsetning for etappen",
        help: "Er det eksisterende dokumentasjon eller annen informasjon denne planen har blitt laget p\xE5 bakgrunn av eller trenger for \xE5 kunne starte?\n          Er det noen leveranser, hendelser eller beslutninger som m\xE5 utf\xF8res for at denne etappen kan begynne?",
        description: "Beskriv hva som må være på plass for at etappen kan starte"
      },
      method: {
        title: "Metode",
        values: {
          product: "Produktledelse",
          project: "Prosjektledelse"
        }
      }
    }
  },
  stageContext: {
    title: "Tilnærming",
    fields: {
      externalDependencies: {
        title: "Eksterne avhengigheter",
        help: "Er det aktiviteter utenfor dette prosjektet som kan p\xE5virke gjennomf\xF8ring av etappen?\n          Er du avhengig av leveranse fra andre prosjekter eller at ressurser andre prosjekter frigj\xF8res for \xE5 gjennomf\xF8re etappen?\n          Er det handlinger, hendelser eller beslutninger utenfor prosjektet som p\xE5virker gjennomf\xF8ring av etappen?",
        description: "Beskriv eksterne avhengigheter"
      },
      assumptions: {
        title: "Antagelser i planleggingen",
        help: "Er det noen antagelser om tilgang til ressurser, verkt\xF8y eller kompetanse?\n          Er det gjort antagelser om grad av ferdigstilling p\xE5 p\xE5krevde elementer for etappen?",
        description: "Beskriv antagelsene som er gjort i planleggingen"
      },
      stageApproach: {
        title: "Tilnærming for etappen",
        help: "Skal en spesifikk metodikk eller teknisk metode brukes i dette etappen?\n          Er det retningslinjer eller standard praksis som skal brukes?\n          Vil det blir brukt interne eller eksterne team, eller begge deler? Hvis ja, hvem skal gj\xF8re hva?\n          Brukes det spesifikk teknologi i denne etappen?",
        description: "Beskriv tilnærming for etappen"
      },
      lessonsIncorporated: {
        title: "Erfaringer som er brukt",
        help: "Er relevante erfaringer fra tidligere brukt i planleggingen av denne etappen?\n          Er relevante erfaringer fra andre prosjekter brukt i planleggingen av denne etappen?",
        description: "Beskriv relevante erfaringer som er brukt i planleggingen og for gjennomførting av etappen"
      },
      monitorAndControl: {
        title: "Overvåkning og styring",
        help: "Hva er frekvensen og formatet for kommunikasjonen mellom prosjektleder og prosjektstyret i etappen?\n          Hva er frekvensen og formatet for kommunikasjon mellom teamleder og prosjektleder?\n          N\xE5r vil noe blie eskalert for informasjon, til beslutning eller for veiledning? N\xE5r vil ett flagg bli hevet?\n          Hvilke verkt\xF8y og prosesser brukes til \xE5 eskalere informasjon, beslutninger eller veiledning?",
        description: "Beskriv kontrollmekanismene for etappen, f.eks overvåkning, eskalering og rapporteringsformater og -frekvens"
      }
    }
  },
  stageTime: {
    title: "Tid",
    fields: {
      period: {
        title: "Etappens periode"
      },
      timeTolerance: {
        title: "Tidstoleranse (verdi)",
        description: "I arbeidsdager, arbeidsuker eller måneder"
      },
      timeToleranceUnit: {
        title: "Tidstoleranse (enhet)",
        options: {
          days: "Dager",
          weeks: "Uker",
          months: "Måneder"
        }
      },
      timeToleranceComment: {
        title: "Tidstoleranse kommentar"
      },
      timeComments: {
        title: "Kommentarer til tid",
        description: "Kommentarer til tidsaspektet av etappen"
      }
    }
  },
  stageCost: {
    title: "Kostnad",
    fields: {
      budget: {
        title: "Etappens budsjett",
        help: "Timer: Antall timer som trengs av internt personale, eller timer brukt av eksterne ressurser hvor tiln\xE6rmingen er \xE5 f\xF8lge opp prosjektkostnaden i timer.\n          Utgifter: Direkte utgifter mottatt som faktura. Dette b\xF8r normalt utelukke utgifter f\xF8rt som timer. B\xF8r ikke inkludere investeringer.\n          Investeringer: Balansef\xF8rte kostnader for anleggsmidler\n          Totalt: Manuelt beregnet total kostnad for etappen. Vanligvis totalt = timer x timekostnad + utgifter + investeringer.",
        columns: {
          element: { title: "Kostnadselement" },
          cost: { title: "Kostnad" },
          tolerance: { title: "Toleranse" },
          comment: { title: "Kommentar" }
        },
        samples: [{ element: "Timer" }, { element: "Utgifter" }, { element: "Investeringer" }]
      }
    }
  },
  stageScheduleScope: {
    title: "Fremdriftsplan og omfang",
    fields: {
      plan: {
        title: "Fremdriftsplan",
        columns: {
          workPackage: { title: "Arbeidspakke" },
          owner: { title: "Eier" },
          dueDate: { title: "Tidsfrist" },
          status: { title: "Status" },
          comment: { title: "Kommentar" }
        },
        samples: [{ workPackage: "Pilot A\n  - Prototype A\n  - Rapport fra pilot", owner: "IT-lederen", dueDate: "2018-12-01", status: "Ferdig" }, { workPackage: "Markedsføring\n  - Produkwebside\n  - Lanseringsplan", owner: "Markedsføringsdirektøren", dueDate: "2018-12-12", status: "Påbegynt" }, { workPackage: "Rydding", owner: "Donald Duck", dueDate: "2018-11-20", status: "Ikke påbegynt" }],
        options: {
          addEntry: { title: "+Legg til" }
        }
      },
      scheduleComments: {
        title: "Planlagte leveranser",
        description: "Beskriv eller list opp hva som vil bli levert i dennne etappen, når og av hvem"
      }
    }
  },
  actuals: {
    title: "Faktisk utførelse",
    fields: {
      period: {
        title: "Faktisk periode for etappen"
      },
      cost: {
        title: "Faktiske kostnader for etappen",
        columns: {
          element: { title: "Kostnadselement" },
          cost: { title: "Kostnad" },
          comment: { title: "Kommentar" }
        }
      }
    }
  }
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(19)) {
  var LIBRARY = __webpack_require__(67);
  var global = __webpack_require__(5);
  var fails = __webpack_require__(7);
  var $export = __webpack_require__(0);
  var $typed = __webpack_require__(141);
  var $buffer = __webpack_require__(205);
  var ctx = __webpack_require__(48);
  var anInstance = __webpack_require__(81);
  var propertyDesc = __webpack_require__(74);
  var hide = __webpack_require__(33);
  var redefineAll = __webpack_require__(83);
  var toInteger = __webpack_require__(50);
  var toLength = __webpack_require__(16);
  var toIndex = __webpack_require__(293);
  var toAbsoluteIndex = __webpack_require__(77);
  var toPrimitive = __webpack_require__(53);
  var has = __webpack_require__(39);
  var classof = __webpack_require__(97);
  var isObject = __webpack_require__(10);
  var toObject = __webpack_require__(22);
  var isArrayIter = __webpack_require__(194);
  var create = __webpack_require__(78);
  var getPrototypeOf = __webpack_require__(42);
  var gOPN = __webpack_require__(79).f;
  var getIterFn = __webpack_require__(196);
  var uid = __webpack_require__(75);
  var wks = __webpack_require__(14);
  var createArrayMethod = __webpack_require__(56);
  var createArrayIncludes = __webpack_require__(131);
  var speciesConstructor = __webpack_require__(110);
  var ArrayIterators = __webpack_require__(199);
  var Iterators = __webpack_require__(99);
  var $iterDetect = __webpack_require__(136);
  var setSpecies = __webpack_require__(80);
  var arrayFill = __webpack_require__(198);
  var arrayCopyWithin = __webpack_require__(282);
  var $DP = __webpack_require__(20);
  var $GOPD = __webpack_require__(41);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(288);
var $export = __webpack_require__(0);
var shared = __webpack_require__(106)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(291))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RiskReport = exports.Risk = exports.RiskTable = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _uuid = __webpack_require__(26);

var _uuid2 = _interopRequireDefault(_uuid);

var _superagent = __webpack_require__(23);

var _superagent2 = _interopRequireDefault(_superagent);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _AreaForm = __webpack_require__(28);

var _AreaForm2 = _interopRequireDefault(_AreaForm);

var _ProjectMenu = __webpack_require__(17);

var _ProjectMenu2 = _interopRequireDefault(_ProjectMenu);

var _PriorityTable = __webpack_require__(224);

var _PriorityTable2 = _interopRequireDefault(_PriorityTable);

var _priority = __webpack_require__(102);

var _priority2 = _interopRequireDefault(_priority);

var _riskResponseLabel = __webpack_require__(256);

var _riskResponseLabel2 = _interopRequireDefault(_riskResponseLabel);

var _RiskForm = __webpack_require__(413);

var _RiskForm2 = _interopRequireDefault(_RiskForm);

var _PresentationView = __webpack_require__(414);

var _PresentationView2 = _interopRequireDefault(_PresentationView);

var _FormattedContent = __webpack_require__(15);

var _FormattedContent2 = _interopRequireDefault(_FormattedContent);

var _sendCommand = __webpack_require__(25);

var _sendCommand2 = _interopRequireDefault(_sendCommand);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(129), __webpack_require__(130)]);

function assignPriority(item) {
  return item.status !== "Closed" ? Object.assign({}, item, { row: parseInt(item.probability), column: parseInt(item.impact) }) : Object.assign({}, item, { row: undefined, column: undefined });
}

var RiskItem = function (_Component) {
  _inherits(RiskItem, _Component);

  function RiskItem() {
    _classCallCheck(this, RiskItem);

    return _possibleConstructorReturn(this, (RiskItem.__proto__ || Object.getPrototypeOf(RiskItem)).apply(this, arguments));
  }

  _createClass(RiskItem, [{
    key: 'render',
    value: function render() {
      return this.props.items.length > 1 ? _react2.default.createElement(
        'div',
        { style: { paddingTop: 2 } },
        _react2.default.createElement(
          'span',
          null,
          '...'
        )
      ) : this.props.items.length === 1 ? _react2.default.createElement(
        'div',
        { style: { paddingTop: 5 } },
        this.props.items[0].no
      ) : null;
    }
  }]);

  return RiskItem;
}(_react.Component);

var RiskTable = exports.RiskTable = function (_Component2) {
  _inherits(RiskTable, _Component2);

  function RiskTable() {
    _classCallCheck(this, RiskTable);

    return _possibleConstructorReturn(this, (RiskTable.__proto__ || Object.getPrototypeOf(RiskTable)).apply(this, arguments));
  }

  _createClass(RiskTable, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      var tableLabels = {
        row: labels.general.probability,
        column: labels.general.impact
      };
      var items = this.props.items.slice(0).filter(function (item) {
        return item.status !== "Closed";
      }).slice(0).map(assignPriority);
      return _react2.default.createElement(_PriorityTable2.default, _extends({}, this.props, { labels: tableLabels, items: items }));
    }
  }]);

  return RiskTable;
}(_react.Component);

var RiskListEntry = function (_Component3) {
  _inherits(RiskListEntry, _Component3);

  function RiskListEntry(props) {
    _classCallCheck(this, RiskListEntry);

    var _this3 = _possibleConstructorReturn(this, (RiskListEntry.__proto__ || Object.getPrototypeOf(RiskListEntry)).call(this, props));

    _this3.state = { hover: false };
    return _this3;
  }

  _createClass(RiskListEntry, [{
    key: 'toggleHover',
    value: function toggleHover(event) {
      event.preventDefault();
      this.setState({ hover: !this.state.hover });
    }
  }, {
    key: 'selectItem',
    value: function selectItem() {
      if (this.props.onSelect !== undefined && this.props.item.readOnly !== true) {
        this.props.onSelect(this.props.item);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var item = this.props.item;
      var bgColor = this.state.hover ? "#f1fbfe" : this.props.backgroundColor;

      return _react2.default.createElement(
        'div',
        { onClick: this.selectItem.bind(this), onMouseEnter: this.toggleHover.bind(this), onMouseLeave: this.toggleHover.bind(this), style: { cursor: item.readOnly !== true ? "pointer" : undefined, display: "table-row", textAlign: "left", backgroundColor: bgColor, borderBottom: "solid 1px #939393", color: item.status === "Closed" ? "lightgrey" : item.readOnly === true ? "#505050" : "#212121", textDecoration: item.status === "Closed" ? "line-through" : "none" } },
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 2, paddingLeft: 7, paddingRight: 5 } },
          _react2.default.createElement(
            'div',
            { style: { display: "table-cell,inline-block", marginTop: 4, padding: 8, borderRadius: "50%", width: 0, hight: 15, backgroundColor: _priority2.default.priorityColor(item, this.props.profile) } },
            ' '
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", padding: 5 } },
          item.no
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", padding: 5 } },
          item.title
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", padding: 5 } },
          item.category
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", padding: 5 } },
          item.cause
        )
      );
    }
  }]);

  return RiskListEntry;
}(_react.Component);

var RiskList = function (_Component4) {
  _inherits(RiskList, _Component4);

  function RiskList() {
    _classCallCheck(this, RiskList);

    return _possibleConstructorReturn(this, (RiskList.__proto__ || Object.getPrototypeOf(RiskList)).apply(this, arguments));
  }

  _createClass(RiskList, [{
    key: 'render',
    value: function render() {
      var _this5 = this;

      var labels = translations.getTranslation(this.props);
      var selectItem = this.props.onSelect;
      var type = "followUp";
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { display: "table", width: "100%", borderCollapse: "collapse" } },
          _react2.default.createElement(
            'div',
            { style: { display: "table-row", pageBreakInside: "avoid", borderBottom: "solid 1px #939393", backgroundColor: "#ffffff", color: "#212121", fontWeight: "bold", textAlign: "left" } },
            _react2.default.createElement('div', { style: { display: "table-cell", paddingTop: 5, paddingBottom: 5, paddingLeft: 10, pageBreakInside: "avoid" } }),
            _react2.default.createElement(
              'div',
              { style: { display: "table-cell", padding: 5, pageBreakInside: "avoid" } },
              labels.views.identify.columns.id
            ),
            _react2.default.createElement(
              'div',
              { style: { display: "table-cell", padding: 5, pageBreakInside: "avoid" } },
              labels.views.identify.columns.title
            ),
            _react2.default.createElement(
              'div',
              { style: { display: "table-cell", padding: 5, pageBreakInside: "avoid" } },
              labels.views.identify.columns.category
            ),
            _react2.default.createElement(
              'div',
              { style: { display: "table-cell", padding: 5, pageBreakInside: "avoid" } },
              labels.views.identify.columns.cause
            )
          ),
          this.props.items.map(function (item, index) {
            return _react2.default.createElement(RiskListEntry, _extends({ key: item.id }, _this5.props, { item: item, onSelect: selectItem, backgroundColor: index % 2 === 1 ? "#f7f7f7" : "white" }));
          })
        )
      );
    }
  }]);

  return RiskList;
}(_react.Component);

var Risk = exports.Risk = function (_Component5) {
  _inherits(Risk, _Component5);

  function Risk(props) {
    _classCallCheck(this, Risk);

    var _this6 = _possibleConstructorReturn(this, (Risk.__proto__ || Object.getPrototypeOf(Risk)).call(this, props));

    var items = _this6.props.risks !== undefined ? _this6.props.risks : [];
    switch (_this6.props.examples) {
      case "true":
        items = [{ id: "1234", no: "1", title: "Lack of commitment", probability: 1, impact: 3, type: "Threat", category: "Budget", proximity: "Imminent", cause: "Missing information", event: "No commitment", effect: "Delay of delivery", response: "Reduce" }, { id: "12345", no: "2", title: "Low availablity of supplier", probability: 4, impact: 3 }, { id: "1245", no: "3", title: "Errors in specification", probability: 3, impact: 4 }, { id: "12645", no: "4", title: "High number of issues", probability: 4, impact: 4 }, { id: "123456", no: "5", title: "Lack of knowledge", probability: 4, impact: 4 }, { id: "21234", no: "6", title: "Lack of commitment 2", probability: 1, impact: 1, type: "Threat", category: "Budget", proximity: "Imminent", cause: "Missing information", event: "No commitment", effect: "Delay of delivery", response: "Reduce" }, { id: "212345", no: "7", title: "Low availablity of supplier 2", probability: 4, impact: 2 }, { id: "21245", no: "8", title: "Errors in specification 2", probability: 3, impact: 3 }, { id: "212645", no: "9", title: "High number of issues 2", probability: 2, impact: 4 }, { id: "2123456", no: "10", title: "Lack of knowledge 2", probability: 1, impact: 5 }];
        break;
      case "priority":
        items = _priority2.default.allItems(function (item, index) {
          return Object.assign({}, item, { id: _uuid2.default.v4(), no: index + 1, title: "Risk " + (index + 1) + " - " + item.classification + " (impact x probability: " + item.row * item.column + ")", type: "threat", impact: item.column, probability: item.row });
        }, _this6.props.profile);
        break;
    }
    _this6.state = {
      manageRisk: false,
      mode: _this6.props.mode !== undefined ? _this6.props.mode : "identify",
      items: items,
      selected: props.selected
    };
    return _this6;
  }

  _createClass(Risk, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.items !== undefined) {
        this.setState({ items: props.items });
      }
    }
  }, {
    key: 'addNewRisk',
    value: function addNewRisk(event) {
      event.preventDefault();
      this.manageRisk({ type: "Threat" });
    }
  }, {
    key: 'manageRisk',
    value: function manageRisk(item) {
      if (this.props.onDetails !== undefined) {
        this.props.onDetails({ show: true });
      }
      this.setState({ selected: item, manageRisk: true });
    }
  }, {
    key: 'appendItem',
    value: function appendItem(command) {
      console.log("Calculated no " + (this.state.items.length + 1));
      var newItem = Object.assign({}, command.item, {
        id: _uuid2.default.v4(),
        //                    no:this.state.items.length+1,
        probability: command.item.probability !== undefined ? parseInt(command.item.probability) : undefined,
        impact: command.item.impact !== undefined ? parseInt(command.item.impact) : undefined
      });
      /*
          this.setState({
            items:this.state.items.concat(newItem)
          });
      */
      var updateRisk = function (items) {
        this.setState({
          items: items,
          selected: Object.assign({}, items.filter(function (item) {
            return item.id === newItem.id;
          })[0], {
            _currentProgress: command.item._progress
          })
        });
        if (this.props.onUpdate !== undefined) {
          this.props.onUpdate(items);
        }
      }.bind(this);

      var command = { type: "addRisk", item: newItem };
      if (this.props.project.isProduct) {
        command = Object.assign({}, command, {
          product: { id: this.props.project.id }
        });
      } else if (this.props.project.isRelease) {
        command = Object.assign({}, command, {
          release: { id: this.props.project.id }
        });
      } else if (this.props.project.isProgramme) {
        command = Object.assign({}, command, {
          programme: { id: this.props.project.id }
        });
      } else {
        command = Object.assign({}, command, {
          project: { id: this.props.project.id }
        });
      }

      (0, _sendCommand2.default)(command).then(function (response) {
        updateRisk(response.items);
      }).catch(function (error) {
        console.log("Got error", error);
        alert("Not able to add risk, please try again");
      });
    }
  }, {
    key: 'updateExisting',
    value: function updateExisting(command) {
      var existingItem = this.state.items.filter(function (item) {
        return item.id === command.item.id;
      })[0];
      var updatedItem = existingItem !== undefined ? Object.assign({}, command.item, {
        no: existingItem.no,
        probability: command.item.probability !== undefined ? parseInt(command.item.probability) : undefined,
        impact: command.item.impact !== undefined ? parseInt(command.item.impact) : undefined
      }) : undefined;
      var updateRisk = function (items) {
        this.setState({
          items: items,
          selected: Object.assign({}, items.filter(function (item) {
            return item.id === command.item.id;
          })[0], {
            _currentProgress: command.item._progress
          })
        });
        if (this.props.onUpdate !== undefined) {
          this.props.onUpdate(items);
        }
      }.bind(this);

      var command = { type: "updateRisk", item: updatedItem };
      if (this.props.project.isProduct) {
        command = Object.assign({}, command, {
          product: { id: this.props.project.id }
        });
      } else if (this.props.project.isRelease) {
        command = Object.assign({}, command, {
          release: { id: this.props.project.id }
        });
      } else if (this.props.project.isProgramme) {
        command = Object.assign({}, command, {
          programme: { id: this.props.project.id }
        });
      } else {
        command = Object.assign({}, command, {
          project: { id: this.props.project.id }
        });
      }

      (0, _sendCommand2.default)(command).then(function (response) {
        updateRisk(response.items);
      }).catch(function (error) {
        console.log("Got error", error);
        alert("Not able to update risk, please try again");
      });
    }
  }, {
    key: 'hideManageForm',
    value: function hideManageForm(command) {
      if (command.type !== "cancel") {
        if (command.item.id === undefined || command.item.id.trim().length === 0) {
          this.appendItem(command);
        } else {
          this.updateExisting(command);
        }
      } else {
        if (this.props.onDetails !== undefined) {
          this.props.onDetails({ show: false });
        }
        this.setState({ manageRisk: false });
      }
    }
  }, {
    key: 'showIdentifyView',
    value: function showIdentifyView(event) {
      event.preventDefault();
      if (this.props.onListView !== undefined) {
        this.props.onListView();
      }
      this.setState({ mode: "identify" });
    }
  }, {
    key: 'showFollowUpView',
    value: function showFollowUpView(event) {
      event.preventDefault();
      if (this.props.onListView !== undefined) {
        this.props.onListView();
      }
      this.setState({ mode: "followUp" });
    }
  }, {
    key: 'showPresentView',
    value: function showPresentView(event) {
      event.preventDefault();
      if (this.props.onPresentation !== undefined) {
        this.props.onPresentation();
      }
      this.setState({ mode: "present" });
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      var items = this.state.items.slice(0).map(assignPriority).sort(_priority2.default.getProfileSort(this.props.profile));
      if (this.props.size !== undefined) {
        items = items.slice(0, this.props.size);
      }
      return _react2.default.createElement(
        'div',
        { style: { marginLeft: 20, paddingTop: 20, fontFamily: "Lato" } },
        this.state.manageRisk ? _react2.default.createElement(_RiskForm2.default, _extends({}, this.props, {
          item: this.state.selected,
          onCommand: this.hideManageForm.bind(this)
        })) : this.state.mode === "present" || this.props.view === "present" || this.props.view === "presentOnly" ? _react2.default.createElement(_PresentationView2.default, _extends({}, this.props, {
          items: items,
          selected: this.state.selected,
          onShowListView: this.showIdentifyView.bind(this),
          onEdit: this.manageRisk.bind(this)
        })) : _react2.default.createElement(
          'div',
          { style: { display: "flex", justifyContent: "center", fontFamily: "Lato", maxWidth: 1016 } },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { style: { backgroundColor: "#f7f7f7", padding: 20, marginBottom: 20, display: "flex", justifyContent: "space-between", flexWrap: "wrap" } },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { style: { fontWeight: "bold", fontSize: 14 } },
                  labels.general.title,
                  ' ',
                  _react2.default.createElement('br', null)
                ),
                _react2.default.createElement(
                  'div',
                  { style: { fontSize: 30, fontWeight: "bold", float: "left" } },
                  labels.riskRegister.title
                ),
                _react2.default.createElement(
                  'div',
                  { style: { minWidth: 200, maxWidth: 450, paddingTop: 50 } },
                  labels.riskRegister.description,
                  ' ',
                  _react2.default.createElement('br', null),
                  _react2.default.createElement('br', null),
                  labels.riskRegister.description2
                )
              ),
              _react2.default.createElement('div', { style: { width: 200 } }),
              _react2.default.createElement(
                'div',
                { style: { float: "right", paddingBottom: 20, paddingRight: 20, paddingTop: 20, backgroundColor: "#f7f7f7" } },
                _react2.default.createElement(RiskTable, _extends({}, this.props, {
                  items: items,
                  onSelect: this.manageRisk.bind(this)
                }))
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { float: "left", marginTop: 30, paddingLeft: 0, width: "100%", maxWidth: 1016 } },
              _react2.default.createElement(
                'div',
                { style: { paddingBottom: 15 } },
                _react2.default.createElement(
                  'div',
                  { style: { display: "flex", justifyContent: "flex-end" } },
                  this.state.mode !== "identify" ? _react2.default.createElement(
                    'div',
                    { onClick: this.showIdentifyView.bind(this), style: { cursor: "pointer", marginRight: 50 } },
                    '[',
                    _react2.default.createElement(
                      'span',
                      { style: { textDecoration: "underline" } },
                      labels.views.identify.title
                    ),
                    ']'
                  ) : _react2.default.createElement(
                    'div',
                    { style: { float: "left", marginRight: 50 } },
                    _react2.default.createElement(
                      'b',
                      null,
                      labels.views.identify.title
                    )
                  ),
                  this.state.mode !== "followUp" ? _react2.default.createElement(
                    'div',
                    { onClick: this.showFollowUpView.bind(this), style: { cursor: "pointer", marginRight: 50 } },
                    '[',
                    _react2.default.createElement(
                      'span',
                      { style: { textDecoration: "underline" } },
                      labels.views.followUp.title
                    ),
                    ']'
                  ) : _react2.default.createElement(
                    'div',
                    { style: { float: "left", marginRight: 50 } },
                    _react2.default.createElement(
                      'b',
                      null,
                      labels.views.followUp.title
                    )
                  ),
                  this.state.mode !== "present" ? _react2.default.createElement(
                    'div',
                    { onClick: this.showPresentView.bind(this), style: { cursor: "pointer", marginRight: 50 } },
                    '[',
                    _react2.default.createElement(
                      'span',
                      { style: { textDecoration: "underline" } },
                      labels.views.present.title
                    ),
                    ']'
                  ) : _react2.default.createElement(
                    'div',
                    { style: { float: "left", marginRight: 50 } },
                    _react2.default.createElement(
                      'b',
                      null,
                      labels.views.present.title
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { onClick: this.addNewRisk.bind(this), style: { float: "right", cursor: "pointer", fontWeight: "bold", textDecoration: "underline" } },
                    '+ ',
                    labels.general.add
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                this.state.mode === "followUp" ? _react2.default.createElement(RiskReportList, _extends({}, this.props, { items: items.filter(function (item) {
                    return item.status !== "Closed";
                  }), onSelect: this.manageRisk.bind(this) })) : _react2.default.createElement(RiskList, _extends({}, this.props, { items: items, onSelect: this.manageRisk.bind(this) }))
              )
            )
          )
        )
      );
    }
  }]);

  return Risk;
}(_react.Component);

var RiskReportEntry = function (_Component6) {
  _inherits(RiskReportEntry, _Component6);

  function RiskReportEntry(props) {
    _classCallCheck(this, RiskReportEntry);

    var _this7 = _possibleConstructorReturn(this, (RiskReportEntry.__proto__ || Object.getPrototypeOf(RiskReportEntry)).call(this, props));

    _this7.state = { hover: false };
    return _this7;
  }

  _createClass(RiskReportEntry, [{
    key: 'toggleHover',
    value: function toggleHover(event) {
      event.preventDefault();
      this.setState({ hover: !this.state.hover });
    }
  }, {
    key: 'selectItem',
    value: function selectItem() {
      if (this.props.onSelect !== undefined && this.props.item.readOnly !== true) {
        this.props.onSelect(this.props.item);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _ref;

      var labels = translations.getTranslation(this.props);
      var item = this.props.item;
      var bgColor = this.state.hover ? "#f1fbfe" : this.props.backgroundColor;
      var comments = item.comments !== undefined ? "<i>" + labels.general.status + ":</i>" + item.comments : "";
      return _react2.default.createElement(
        'div',
        { onClick: this.selectItem.bind(this), onMouseEnter: this.toggleHover.bind(this), onMouseLeave: this.toggleHover.bind(this), style: { cursor: this.props.onSelect !== undefined && item.readOnly !== true ? "pointer" : undefined, display: "table-row", backgroundColor: bgColor, borderBottom: "solid 1px #939393", color: item.readOnly === true ? "#505050" : undefined } },
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 2, paddingLeft: 7, paddingRight: 5 } },
          _react2.default.createElement(
            'div',
            { style: { display: "table-cell,inline-block", marginTop: 4, padding: 8, borderRadius: "50%", width: 0, hight: 15, backgroundColor: _priority2.default.priorityColor(item, this.props.profile) } },
            ' '
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", padding: 5 } },
          item.no
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", padding: 5 } },
          item.title
        ),
        _react2.default.createElement(
          'div',
          { style: (_ref = { display: "table-cell", padding: 5 }, _defineProperty(_ref, 'display', "flex"), _defineProperty(_ref, 'alignItems', "center"), _ref) },
          _react2.default.createElement(
            'i',
            null,
            (0, _riskResponseLabel2.default)(item.response, this.props.language)
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingLeft: 10 } },
            _react2.default.createElement(_FormattedContent2.default, { value: item.action + comments })
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", padding: 5 } },
          item.ownerAndActionee
        )
      );
    }
  }]);

  return RiskReportEntry;
}(_react.Component);

var RiskReportList = function (_Component7) {
  _inherits(RiskReportList, _Component7);

  function RiskReportList() {
    _classCallCheck(this, RiskReportList);

    return _possibleConstructorReturn(this, (RiskReportList.__proto__ || Object.getPrototypeOf(RiskReportList)).apply(this, arguments));
  }

  _createClass(RiskReportList, [{
    key: 'render',
    value: function render() {
      var _this9 = this;

      var labels = translations.getTranslation(this.props).views.followUp.columns;
      return _react2.default.createElement(
        'div',
        { style: { display: "table", borderCollapse: "collapse", width: "100%" } },
        _react2.default.createElement(
          'div',
          { style: { display: "table-row", borderBottom: "solid 1px #939393", pageBreakInside: "avoid", backgroundColor: "#ffffff", color: "#212121", fontWeight: "bold", textAlign: "left" } },
          _react2.default.createElement('div', { style: { display: "table-cell", paddingTop: 5, paddingBottom: 5, paddingLeft: 10, pageBreakInside: "avoid" } }),
          _react2.default.createElement(
            'div',
            { style: { display: "table-cell", padding: 5, pageBreakInside: "avoid" } },
            labels.id
          ),
          _react2.default.createElement(
            'div',
            { style: { display: "table-cell", padding: 5, pageBreakInside: "avoid" } },
            labels.title
          ),
          _react2.default.createElement(
            'div',
            { style: { display: "table-cell", padding: 5, pageBreakInside: "avoid" } },
            labels.solution
          ),
          _react2.default.createElement(
            'div',
            { style: { display: "table-cell", padding: 5, pageBreakInside: "avoid" } },
            labels.ownerAndActionee
          )
        ),
        this.props.items.map(function (risk) {
          return Object.assign({}, risk, {
            ownerAndActionee: (risk.owner !== undefined && risk.owner !== null ? risk.owner : "") + " / " + (risk.actionee !== undefined && risk.actionee !== null ? risk.actionee : "")
          });
        }).map(function (item, index) {
          return _react2.default.createElement(RiskReportEntry, _extends({ key: item.id }, _this9.props, { onSelect: _this9.props.onSelect, backgroundColor: index % 2 === 1 ? "#f7f7f7" : "white", item: item }));
        })
      );
    }
  }]);

  return RiskReportList;
}(_react.Component);

var RiskReport = exports.RiskReport = function (_Component8) {
  _inherits(RiskReport, _Component8);

  function RiskReport() {
    _classCallCheck(this, RiskReport);

    return _possibleConstructorReturn(this, (RiskReport.__proto__ || Object.getPrototypeOf(RiskReport)).apply(this, arguments));
  }

  _createClass(RiskReport, [{
    key: 'render',
    value: function render() {
      var items = this.props.items.slice(0).map(assignPriority).sort(_priority2.default.getProfileSort(this.props.profile)).slice(0, 5);
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(RiskTable, _extends({}, this.props, { items: items })),
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 20 } },
          _react2.default.createElement(RiskReportList, _extends({}, this.props, { items: items }))
        )
      );
    }
  }]);

  return RiskReport;
}(_react.Component);

var RiskPage = function (_Component9) {
  _inherits(RiskPage, _Component9);

  function RiskPage() {
    _classCallCheck(this, RiskPage);

    return _possibleConstructorReturn(this, (RiskPage.__proto__ || Object.getPrototypeOf(RiskPage)).apply(this, arguments));
  }

  _createClass(RiskPage, [{
    key: 'render',
    value: function render() {
      var menu = this.props.showMenu === true ? _react2.default.createElement(_ProjectMenu2.default, this.props) : undefined;
      return _react2.default.createElement(
        _Layout2.default,
        _extends({}, this.props, { projectMenu: menu }),
        _react2.default.createElement(Risk, this.props)
      );
    }
  }]);

  return RiskPage;
}(_react.Component);

exports.default = RiskPage;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var KEY_DELIMITER = '-';
var DraftOffsetKey = {
  encode: function encode(blockKey, decoratorKey, leafKey) {
    return blockKey + KEY_DELIMITER + decoratorKey + KEY_DELIMITER + leafKey;
  },
  decode: function decode(offsetKey) {
    // Extracts the last two parts of offsetKey and captures the rest in blockKeyParts
    var _offsetKey$split$reve = offsetKey.split(KEY_DELIMITER).reverse(),
        leafKey = _offsetKey$split$reve[0],
        decoratorKey = _offsetKey$split$reve[1],
        blockKeyParts = _offsetKey$split$reve.slice(2);

    return {
      // Recomposes the parts of blockKey after reversing them
      blockKey: blockKeyParts.reverse().join(KEY_DELIMITER),
      decoratorKey: parseInt(decoratorKey, 10),
      leafKey: parseInt(leafKey, 10)
    };
  }
};
module.exports = DraftOffsetKey;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(8);

var PooledClass = __webpack_require__(92);

var emptyFunction = __webpack_require__(65);
var warning = __webpack_require__(18);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

/** Proxying after everything set on SyntheticEvent
  * to resolve Proxy issue on some WebKit browsers
  * in which some Event properties are set to undefined (GH#10010)
  */
if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(75)('meta');
var isObject = __webpack_require__(10);
var has = __webpack_require__(39);
var setDesc = __webpack_require__(20).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(7)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(14)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(33)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 */


module.exports = function (name) {
  if (typeof window !== 'undefined' && window.__DRAFT_GKX) {
    return !!window.__DRAFT_GKX[name];
  }

  return false;
};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _draftJs = __webpack_require__(38);

var _clsx = __webpack_require__(128);

var _clsx2 = _interopRequireDefault(_clsx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-children-prop */


exports.default = function (_ref) {
  var blockType = _ref.blockType,
      children = _ref.children;
  return function (_Component) {
    _inherits(BlockStyleButton, _Component);

    function BlockStyleButton() {
      var _ref2;

      var _temp, _this, _ret;

      _classCallCheck(this, BlockStyleButton);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = BlockStyleButton.__proto__ || Object.getPrototypeOf(BlockStyleButton)).call.apply(_ref2, [this].concat(args))), _this), _this.toggleStyle = function (event) {
        event.preventDefault();
        _this.props.setEditorState(_draftJs.RichUtils.toggleBlockType(_this.props.getEditorState(), blockType));
      }, _this.preventBubblingUp = function (event) {
        event.preventDefault();
      }, _this.blockTypeIsActive = function () {
        // if the button is rendered before the editor
        if (!_this.props.getEditorState) {
          return false;
        }

        var editorState = _this.props.getEditorState();
        var type = editorState.getCurrentContent().getBlockForKey(editorState.getSelection().getStartKey()).getType();
        return type === blockType;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(BlockStyleButton, [{
      key: 'render',
      value: function render() {
        var theme = this.props.theme;

        var className = this.blockTypeIsActive() ? (0, _clsx2.default)(theme.button, theme.active) : theme.button;
        return _react2.default.createElement(
          'div',
          {
            className: theme.buttonWrapper,
            onMouseDown: this.preventBubblingUp
          },
          _react2.default.createElement('button', {
            className: className,
            onClick: this.toggleStyle,
            type: 'button',
            children: children
          })
        );
      }
    }]);

    return BlockStyleButton;
  }(_react.Component);
};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var issueTypes = {
  change: "Request for change",
  specification: "Off-specification",
  problem: "Problem / concern"
};

var impact = "Impact";
var options = "Options";
var recommendation = "Recommendation";
var decision = "Decision";

var english = exports.english = {
  general: {
    approach: "approach",
    examineDetails: {
      typeValues: issueTypes,
      description: "Description"
    },
    proposeDetails: {
      impact: "Impact"
    },
    decideDetails: {
      options: options,
      recommendation: recommendation
    },
    implementDetails: {
      decision: decision
    },
    title: "Change",
    priority: "Priority",
    severity: "Severity",
    addIssue: "Add Issue",
    noIssues: "No issues in register",
    documentIssue: "Press \"Add issue\" if you have a change request, an off-specification or a problem/concern to be documented.",
    status: {
      captured: "Captured",
      examined: "Analyze impact",
      proposed: "Consider options",
      decided: "Await decision",
      implemented: "Follow up"
    }
  },
  report: {
    cancel: "Cancel",
    publishReport: "Publish report",
    publishInProgress: "... publish ongoing ...",
    lastIssueReports: "Most Recent Reports",
    columns: {
      id: "Id",
      title: "Title",
      impact: impact,
      recommendation: "Recommendation",
      decision: decision,
      status: "Status"
    },
    menu: {
      issueOptions: "Issue Options",
      createIssueReport: "Create Issue Report",
      createExceptionReport: "Create Exception Report",
      issueReports: "Reports",
      noReports: "No reports are available",
      whenToUseReports: "When to use Reports: ",
      whenToUseReportsIngress: " Use a report when something unplanned occurs and there is a need to inform the Project Board",
      whenToUseIssueReport: "Use Issue Report when you need to keep the Project Board informed or need to ask the Project Board for advice.",
      whenToUseExceptionReport: "Use Exception Report if you need a formal decision from the Project Board."
    }
  },
  issue: "Issue",
  Capture: {
    title: "Capture",
    fields: {
      title: {
        title: "Title",
        description: "Descriptive issue title",
        help: "Short summary of the issue"
      },
      type: {
        title: "Issue Type",
        help: "What is the nature of the issue raised?\n\nRequest for change:\nProposal for a change to a baseline\nNew requirements, added scope etc.\n\nOff-specification:\nSomething is not delivered according to the specifications agreed\nSomething is not reviewed and approved as agreed\n\nProblem/concern:\nOther issue to resolve or escalate",

        options: issueTypes
      },
      description: {
        title: "Description",
        description: "The background and nature of the issue",
        help: "What is the context, the background, the trigger and the nature of the issue?"
      }
    }
  },
  Examine: {
    title: "Examine",
    fields: {
      impact: {
        title: impact,
        description: "Describe impact on objectives, business case and risk",
        help: "What impact does the issue have on:\n\nTime, cost, quality and scope\nBusiness Case and benefits\nOther dependent deliverables\nRisk profile"
      },
      severity: {
        title: "Severity",
        help: "What is the level of impact on objectives?\n\nSevere: Critical objective(s) will not be achieved\nSignificant: Stated objective(s) will fall below acceptable level\nModerate: Stated objective(s) will fall below goals but above minimum acceptable levels\nMinor: Stated objective(s) will fall below goals but well above minimum acceptable levels\nNegligible: No or little impact on achieving objectives",
        options: {
          1: "Negligible",
          2: "Minor",
          3: "Moderate",
          4: "Significant",
          5: "Severe"
        }
      },
      priority: {
        title: "Priority",
        help: "How high is the urgency of getting this issue resolved?",
        options: {
          1: "Very Low",
          2: "Low",
          3: "Medium",
          4: "High",
          5: "Very High"
        }
      }
    }
  },
  Propose: {
    title: "Propose",
    fields: {
      options: {
        title: options,
        description: "List the options identified",
        help: "What alternatives have been considered? Has the effect of each option on time, cost, quality, scope, benefits and risk been evaluated?"
      },
      recommendation: {
        title: recommendation,
        description: "Describe the proposed corrective action and why this is the team's recommendation",
        help: "Which option amongst the alternatives has the best balance between advantage gained and time/cost/risk of implementation? "
      },
      lessonSummary: {
        title: "Lessons Learned (will only show in Exception Report, not in Issue Report)",
        description: "Summary of lessons learned.",
        help: "What did we learn from this issue? Could we have avoided or limited this issue? Could we have dealt with this issue in a better way?"
      }
    }
  },
  Decide: {
    title: "Decide",
    fields: {
      decision: {
        title: decision,
        description: "Describe what was decided, where, how, when..",
        help: "What was decided? Where and when was it decided? In a meeting, by e-mail?"
      },
      decidedBy: {
        title: "Decision made by",
        description: "The name of the final decision maker",
        help: "Who made the final decision? When? Anyone else consulted or included?"
      }
    }
  },
  Implement: {
    title: "Implement",
    fields: {
      status: {
        title: "Status",
        options: {
          Active: "Active",
          Closed: "Closed"
        }
      },
      statusDescription: {
        title: "Description of current status"
      }
    }
  },
  issueRegister: {
    title: "Issue Register",
    description: "The Issue Register is used to capture and maintain information on all of the issues that are being managed formally. All change requests, off-specifications and problems where a formal decision process is needed, should be documented as an issue. ",
    description2: "Add a new issue by selecting 'Add Issue' below. You can maintain an issue by selecting it in the table below."
  },
  changeControlApproach: {
    title: "Change Control Approach",
    description: "The change control approach describes how changes and issues arising will be managed. What will we do to make sure we have sufficient control of changes?",
    fields: {
      process: {
        title: "Process and Procedures",
        help: "How will problems or change requests be captured, recommendations developed and decisions made? For small changed, for large changes?\n          Are there any standard procedures to be followed on change control and issue management?\n          Any planned deviation from these procedures? If so, why?\n          How will we make sure the procedure is followed - that approvals are tracked?\n          Any standards or templates to be used?\n          How will the change process work with 3rd parties?",
        description: "Describe what processes the project will follow to make sure all changes and concerns are managed well"
      },
      tools: {
        title: "Tools and Techniques",
        help: "Which techniques and tools will be used to capture and manage problems and change requests?\n          Which techniques and tools will be used to control versioning of documents, code, drawings, requirements, marketing material, user instructions, training material, plans, team plans etc?\n          Will an issue register be used? If yes, is it the only tool used to track change actions and approvals? If no, what will be used instead or in addition?\n          Any tools or techniques used by 3rd parties involved?",
        description: "Describe what tools or techniques will be applied to make sure all changes and issues are identified, assessed, solutions proposed and decisions made"
      },
      reporting: {
        title: "Reporting",
        help: "When will issues/changes be reported?\n          Where will issues/changes be reported and who will receive the issue reports?",
        description: "The issue reports to be produced, their purpose, timing and recipients"
      },
      timing: {
        title: "Timing of activities",
        help: "When will change control and issue management activities occur?\n          Any specific activities in Initiation or beginning/end of stages?",
        description: "Describe the timing of change control and issue management activities"
      },
      roles: {
        title: "Roles and responsibilities",
        help: "Who is responsible for the change control and issue management procedure? Who makes sure the project complies?\n          Who approves which kinds of changes?\n          Who should report issues and changes and to whom?",
        description: "Define the roles and responsibilities for the activities"
      },
      scales: {
        title: "Scales of severity and priority",
        help: "Who can make decisions on which level of issue severity and priority?\n          Should the program, project or team manager(s) have any change authority on any of these levels?",
        description: "Define who can make decisions on the various levels of issue severity and priority"
      }
    }
  }
};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var issueTypes = {
  change: "Endringsanmodning",
  specification: "Avvik fra spesifikasjon",
  problem: "Problem / bekymring"
};

var impact = "Konsekvens";
var options = "Alternativer";
var recommendation = "Anbefaling";
var decision = "Beslutning";

var norwegian = exports.norwegian = {
  general: {
    approach: "tilnærming",
    examineDetails: {
      description: "Beskrivelse",
      typeValues: issueTypes
    },
    proposeDetails: {
      impact: impact
    },
    decideDetails: {
      options: options,
      recommendation: recommendation
    },
    implementDetails: {
      decision: decision
    },
    title: "Endring",
    priority: "Prioritet",
    severity: "Alvorlighet",
    addIssue: "Ny sak",
    noIssues: "Ingen saker i registeret",
    documentIssue: "Trykk \"Ny sak\" hvis du har en endringsordre, avvik-fra-sepsifikasjonen eller problem/bekymring som må dokumenteres.",
    status: {
      captured: "Registrert",
      examined: "Analyserer konsekvens",
      proposed: "Vurderer alternativer",
      decided: "Avventer beslutning",
      implemented: "Følges opp"
    }
  },
  report: {
    cancel: "Avbryt",
    publishReport: "Publiser rapport",
    publishInProgress: "... publisering pågår ...",
    lastIssueReports: "Siste rapporter",
    columns: {
      id: "Id",
      title: "Tittel",
      impact: impact,
      recommendation: "Anbefaling",
      decision: decision,
      status: "Status"
    },
    menu: {
      issueOptions: "Saksvalg",
      createIssueReport: "Opprett saksrapport",
      createExceptionReport: "Opprett unntaksrapport",
      issueReports: "Rapporter",
      noReports: "Ingen rapporter er tilgjengelig",
      whenToUseReports: "Når brukes rapporter: ",
      whenToUseReportsIngress: " Bruk en rapport når det skjer noe uplanlagt og det er behov for å informere prosjektstyret",
      whenToUseIssueReport: "Bruk en saksrapport når du skal holde prosjektstyret informert eller når du ønsker råd fra prosjektstyret.",
      whenToUseExceptionReport: "Bruk unntaktsrapport hvis du trenger en formell beslutning fra prosjektstyret."
    }
  },
  issue: "Sak",
  Capture: {
    title: "Fange opp",
    fields: {
      title: {
        title: "Tittel",
        description: "Beskrivende sakstittle",
        help: "Kort oppsummering av saken"
      },
      type: {
        title: "Sakstype",
        help: "Hvilken type sak er tatt opp?\n\nForesp\xF8rsel om endring:\nForslag om endring til grunnlinje\nNye krav, tilf\xF8yet omfang etc.\n\nAvvik fra spesifikasjon:\nNoe leveres ikke i henhold til avtalt spesifikasjonen\nNoe er ikke gjennomg\xE5tt og godkjent som avtalt\n\nProblem / bekymring:\nAnnet problem som m\xE5 l\xF8ses eller eskaleres",

        options: issueTypes
      },
      description: {
        title: "Beskrivelse",
        description: "Bakgrunn og årsak til saken",
        help: "Hva er sammenhengen, bakgrunnen, eller utløsende årsak til saken?"
      }
    }
  },
  Examine: {
    title: "Undersøke",
    fields: {
      impact: {
        title: impact,
        description: "Beskriv effekten på mål, begrunnelse og risiko",
        help: "Hvilken innvirkning har saken p\xE5:\n\nTid, kostnad, kvalitet og omfang\nbegrunnelse og gevinster\nAndre avhengige leveranser\nRisikoprofil"
      },
      severity: {
        title: "Alvorlighet",
        help: "Hvilken p\xE5virkning er det p\xE5 m\xE5lene?\n\nAlvorlig: Kritiske m\xE5l vil ikke bli oppn\xE5dd\nVesentlig: Angitte m\xE5l vil falle under akseptabelt niv\xE5\nModerat: Angitte m\xE5l vil falle under m\xE5lsetningen, men over minimum akseptablt niv\xE5\nMindre: Angitte m\xE5l vil falle under m\xE5lsetningen, men godt over minimum akseptable niv\xE5\nUbetydelig: Ingen eller liten innvirkning p\xE5 \xE5 oppn\xE5 m\xE5l",
        options: {
          1: "Ubetydelig",
          2: "Liten",
          3: "Moderat",
          4: "Betydelig",
          5: "Alvorlig"
        }
      },
      priority: {
        title: "Prioritet",
        help: "Hvor mye haster det for å få denne saken løst?",
        options: {
          1: "Veldig lav",
          2: "Lav",
          3: "Middels",
          4: "Høy",
          5: "Veldig høy"
        }
      }
    }
  },
  Propose: {
    title: "Foreslå",
    fields: {
      options: {
        title: options,
        description: "List opp alternativene som er identifisert",
        help: "Hvilke alternativer har blitt vurdert? Har påvirkningen av hvert alternativ blitt vurdert i forhold til tid, kostnad, kvalitet, omfang, gevinst og risiko?"
      },
      recommendation: {
        title: recommendation,
        description: "Beskriv den foreslåtte korrigerende handlingen og hvorfor dette er anbefaling",
        help: "Hvilket alternativ har den beste balansen mellom fordel og tid / kostnad / risiko for implementering?"
      },
      lessonSummary: {
        title: "Erfaringer (vil bare vises i unntaksrapport, ikke i saksrapport)",
        description: "Oppsummer erfaringene som er lært.",
        help: "Hva har vi lært av denne saken? Kunne vi ha unngått eller begrenset denne saken? Kunne vi ha håndtert saken på en bedre måte?"
      }
    }
  },
  Decide: {
    title: "Beslutte",
    fields: {
      decision: {
        title: decision,
        description: "Beskriv hva som ble bestemt, hvor, hvordan, når ..",
        help: "Hva ble det bestemt? Hvor og når ble det bestemt? I et møte, via e-post?"
      },
      decidedBy: {
        title: "Beslutningen er fattet av",
        description: "Navnet på den endelige beslutningstakeren",
        help: "Hvem tok den endelige avgjørelsen? Når? Noen andre konsultert eller inkludert?"
      }
    }
  },
  Implement: {
    title: "Ivertsette",
    fields: {
      status: {
        title: "Status",
        options: {
          Active: "Aktiv",
          Closed: "Lukket"
        }
      },
      statusDescription: {
        title: "Beskrivelse av gjeldende status"
      }
    }
  },
  issueRegister: {
    title: "Saksregister",
    description: "Saksregisteret blir brukt for å dokumentere og vedlikeholde informasjon om alle saker som må formelt behandles. Alle endringsønsker, feil-leveranser og problemer hvor en formell beslutningsprosess er nødvendig, skal dokumenteres som en sak. ",
    description2: "Legg til en ny sak ved å velge 'Ny sak' nedenfor. Du kan vedlikeholde en sak ved å velge den i tabellen nedenfor."
  },
  changeControlApproach: {
    title: "Tilnærming til endringskontroll",
    description: "Tilnærming til endringskontroll beskriver hvordan endringer og situasjoner som oppstår (saker) skal håndteres.",
    fields: {
      process: {
        title: "Prosess og prosedyre",
        help: "Hvordan vil problemer eller endringsforesp\xF8rsler bli identifisert, anbefalinger utviklet og beslutninger tatt? For sm\xE5 endret, for store endringer?\n          Er det noen standard prosedyrer som skal f\xF8lges for \xE5 sikre kontroll p\xE5 endringer og oppf\xF8lging av saker?\n          Finnes det planlagt avvik fra disse prosedyrene? Hvis ja, hvorfor?\n          Hvordan vil vi s\xF8rge for at prosedyren f\xF8lges - at godkjenningene spores?\n          Vil det bli brukt standarder eller maler?\n          Hvordan vil endringsprosessen fungere med tredje part?",
        description: "Beskriv hvilke prosesser som skal følges for å sikre at alle endringer og utfordringer/bekymringer styres godt"
      },
      tools: {
        title: "Verktøy og teknikker",
        help: " Hvilke teknikker og verkt\xF8y vil bli brukt til \xE5 identifisere, strukturere og h\xE5ndtere problemer og endringer?\n          Hvilke teknikker og verkt\xF8y vil bli brukt til \xE5 kontrollere versjonering av dokumenter, kode, tegninger, krav, markedsf\xF8ringsmateriale, brukerveiledning, oppl\xE6ringsmateriell, planer, lagplaner etc.?\n          Vil et register over saker bli brukt? Hvis ja, er det det eneste verkt\xF8yet som brukes til \xE5 spore endringshandlinger og godkjenninger? Hvis nei, hva vil det bli brukt i stedet for eller i tillegg?\n          Hvilke verkt\xF8y eller teknikker brukes av tredjeparter involvert?",
        description: "Beskriv hvilke verktøy eller teknikker prosjektet skal bruke for å sikre at alle endringer og utfordringer/bekymringer identifiseres, vurderes, løsninger foreslås og beslutninger fattes"
      },
      reporting: {
        title: "Rapportering",
        help: "N\xE5r skal det rapporteres om saker / endringer?\n          Hvor skal det rapporteres om saker / endringer og hvem vil motta disse rapportene?",
        description: "Hvilke saksrapporter skal bli produsert, deres formål, timing og mottakere"
      },
      timing: {
        title: "Tidsangivelse av aktiviteter",
        help: "N\xE5r vil det bli utf\xF8rt aktivteter for endringskontroll og probleml\xF8singsaktiviteter?\n          Vil det utf\xF8res spesifikke aktiviteter i Initieringsetappen eller begynnelsen / slutten av etapper?",
        description: "Beskriv tidspunktet aktiviteter for endringskontroll og problemstillinger skal utføres"
      },
      roles: {
        title: "Roler og ansvar",
        help: "Hvem er ansvarlig for endringskontrollen og utstedelsesprosedyren? Hvem s\xF8rger for at prosjektet f\xF8lger rutinene?\n          Hvem godkjenner hvilke typer endringer?\n          Hvem skal rapportere saker og endringer og til hvem?",
        description: "Definer roller og ansvar for aktivitetene"
      },
      scales: {
        title: "Beslutningsmyndighet for alvorlighetsgrad og prioritet",
        help: "Hvem kan ta beslutninger p\xE5 niv\xE5 av saker for alvorlighet og prioritet?\n          Skal program-, prosjekt- eller teamlederen ha noen endringsmyndighet p\xE5 noen av disse niv\xE5ene?",
        description: "Definer hvem som kan ta beslutninger på de ulike nivåene av alvorlighet og prioritet"
      }
    }
  }
};

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 75 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(267);
var enumBugKeys = __webpack_require__(182);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(50);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(3);
var dPs = __webpack_require__(268);
var enumBugKeys = __webpack_require__(182);
var IE_PROTO = __webpack_require__(181)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(179)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(183).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(267);
var hiddenKeys = __webpack_require__(182).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var dP = __webpack_require__(20);
var DESCRIPTORS = __webpack_require__(19);
var SPECIES = __webpack_require__(14)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(48);
var call = __webpack_require__(280);
var isArrayIter = __webpack_require__(194);
var anObject = __webpack_require__(3);
var toLength = __webpack_require__(16);
var getIterFn = __webpack_require__(196);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(34);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(8);

var ReactBaseClasses = __webpack_require__(301);
var ReactChildren = __webpack_require__(651);
var ReactDOMFactories = __webpack_require__(656);
var ReactElement = __webpack_require__(100);
var ReactPropTypes = __webpack_require__(657);
var ReactVersion = __webpack_require__(663);

var createReactClass = __webpack_require__(664);
var onlyChild = __webpack_require__(666);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(148),
    getPrototype = __webpack_require__(689),
    isObjectLike = __webpack_require__(117);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 87 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var CharacterMetadata = __webpack_require__(43);

var findRangesImmutable = __webpack_require__(121);

var Immutable = __webpack_require__(4);

var List = Immutable.List,
    Map = Immutable.Map,
    OrderedSet = Immutable.OrderedSet,
    Record = Immutable.Record,
    Repeat = Immutable.Repeat;
var EMPTY_SET = OrderedSet();
var defaultRecord = {
  key: '',
  type: 'unstyled',
  text: '',
  characterList: List(),
  depth: 0,
  data: Map()
};
var ContentBlockRecord = Record(defaultRecord);

var decorateCharacterList = function decorateCharacterList(config) {
  if (!config) {
    return config;
  }

  var characterList = config.characterList,
      text = config.text;

  if (text && !characterList) {
    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
  }

  return config;
};

var ContentBlock = /*#__PURE__*/function (_ContentBlockRecord) {
  _inheritsLoose(ContentBlock, _ContentBlockRecord);

  function ContentBlock(config) {
    return _ContentBlockRecord.call(this, decorateCharacterList(config)) || this;
  }

  var _proto = ContentBlock.prototype;

  _proto.getKey = function getKey() {
    return this.get('key');
  };

  _proto.getType = function getType() {
    return this.get('type');
  };

  _proto.getText = function getText() {
    return this.get('text');
  };

  _proto.getCharacterList = function getCharacterList() {
    return this.get('characterList');
  };

  _proto.getLength = function getLength() {
    return this.getText().length;
  };

  _proto.getDepth = function getDepth() {
    return this.get('depth');
  };

  _proto.getData = function getData() {
    return this.get('data');
  };

  _proto.getInlineStyleAt = function getInlineStyleAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getStyle() : EMPTY_SET;
  };

  _proto.getEntityAt = function getEntityAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getEntity() : null;
  }
  /**
   * Execute a callback for every contiguous range of styles within the block.
   */
  ;

  _proto.findStyleRanges = function findStyleRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
  }
  /**
   * Execute a callback for every contiguous range of entities within the block.
   */
  ;

  _proto.findEntityRanges = function findEntityRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
  };

  return ContentBlock;
}(ContentBlockRecord);

function haveEqualStyle(charA, charB) {
  return charA.getStyle() === charB.getStyle();
}

function haveEqualEntity(charA, charB) {
  return charA.getEntity() === charB.getEntity();
}

module.exports = ContentBlock;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * This function is used to mark string literals representing CSS class names
 * so that they can be transformed statically. This allows for modularization
 * and minification of CSS class names.
 *
 * In static_upstream, this function is actually implemented, but it should
 * eventually be replaced with something more descriptive, and the transform
 * that is used in the main stack should be ported for use elsewhere.
 *
 * @param string|object className to modularize, or an object of key/values.
 *                      In the object case, the values are conditions that
 *                      determine if the className keys should be included.
 * @param [string ...]  Variable list of classNames in the string case.
 * @return string       Renderable space-separated CSS className.
 */
function cx(classNames) {
  if (typeof classNames == 'object') {
    return Object.keys(classNames).filter(function (className) {
      return classNames[className];
    }).map(replace).join(' ');
  }

  return Array.prototype.map.call(arguments, replace).join(' ');
}

function replace(str) {
  return str.replace(/\//g, '-');
}

module.exports = cx;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
function isElement(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }

  return node.nodeType === Node.ELEMENT_NODE;
}

module.exports = isElement;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * Unicode-enabled replacesments for basic String functions.
 *
 * All the functions in this module assume that the input string is a valid
 * UTF-16 encoding of a Unicode sequence. If it's not the case, the behavior
 * will be undefined.
 *
 * WARNING: Since this module is typechecks-enforced, you may find new bugs
 * when replacing normal String functions with ones provided here.
 */


var invariant = __webpack_require__(9); // These two ranges are consecutive so anything in [HIGH_START, LOW_END] is a
// surrogate code unit.


var SURROGATE_HIGH_START = 0xD800;
var SURROGATE_HIGH_END = 0xDBFF;
var SURROGATE_LOW_START = 0xDC00;
var SURROGATE_LOW_END = 0xDFFF;
var SURROGATE_UNITS_REGEX = /[\uD800-\uDFFF]/;
/**
 * @param {number} codeUnit   A Unicode code-unit, in range [0, 0x10FFFF]
 * @return {boolean}          Whether code-unit is in a surrogate (hi/low) range
 */

function isCodeUnitInSurrogateRange(codeUnit) {
  return SURROGATE_HIGH_START <= codeUnit && codeUnit <= SURROGATE_LOW_END;
}
/**
 * Returns whether the two characters starting at `index` form a surrogate pair.
 * For example, given the string s = "\uD83D\uDE0A", (s, 0) returns true and
 * (s, 1) returns false.
 *
 * @param {string} str
 * @param {number} index
 * @return {boolean}
 */


function isSurrogatePair(str, index) {
  !(0 <= index && index < str.length) ?  false ? invariant(false, 'isSurrogatePair: Invalid index %s for string length %s.', index, str.length) : invariant(false) : void 0;

  if (index + 1 === str.length) {
    return false;
  }

  var first = str.charCodeAt(index);
  var second = str.charCodeAt(index + 1);
  return SURROGATE_HIGH_START <= first && first <= SURROGATE_HIGH_END && SURROGATE_LOW_START <= second && second <= SURROGATE_LOW_END;
}
/**
 * @param {string} str  Non-empty string
 * @return {boolean}    True if the input includes any surrogate code units
 */


function hasSurrogateUnit(str) {
  return SURROGATE_UNITS_REGEX.test(str);
}
/**
 * Return the length of the original Unicode character at given position in the
 * String by looking into the UTF-16 code unit; that is equal to 1 for any
 * non-surrogate characters in BMP ([U+0000..U+D7FF] and [U+E000, U+FFFF]); and
 * returns 2 for the hi/low surrogates ([U+D800..U+DFFF]), which are in fact
 * representing non-BMP characters ([U+10000..U+10FFFF]).
 *
 * Examples:
 * - '\u0020' => 1
 * - '\u3020' => 1
 * - '\uD835' => 2
 * - '\uD835\uDDEF' => 2
 * - '\uDDEF' => 2
 *
 * @param {string} str  Non-empty string
 * @param {number} pos  Position in the string to look for one code unit
 * @return {number}      Number 1 or 2
 */


function getUTF16Length(str, pos) {
  return 1 + isCodeUnitInSurrogateRange(str.charCodeAt(pos));
}
/**
 * Fully Unicode-enabled replacement for String#length
 *
 * @param {string} str  Valid Unicode string
 * @return {number}     The number of Unicode characters in the string
 */


function strlen(str) {
  // Call the native functions if there's no surrogate char
  if (!hasSurrogateUnit(str)) {
    return str.length;
  }

  var len = 0;

  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
    len++;
  }

  return len;
}
/**
 * Fully Unicode-enabled replacement for String#substr()
 *
 * @param {string} str      Valid Unicode string
 * @param {number} start    Location in Unicode sequence to begin extracting
 * @param {?number} length  The number of Unicode characters to extract
 *                          (default: to the end of the string)
 * @return {string}         Extracted sub-string
 */


function substr(str, start, length) {
  start = start || 0;
  length = length === undefined ? Infinity : length || 0; // Call the native functions if there's no surrogate char

  if (!hasSurrogateUnit(str)) {
    return str.substr(start, length);
  } // Obvious cases


  var size = str.length;

  if (size <= 0 || start > size || length <= 0) {
    return '';
  } // Find the actual starting position


  var posA = 0;

  if (start > 0) {
    for (; start > 0 && posA < size; start--) {
      posA += getUTF16Length(str, posA);
    }

    if (posA >= size) {
      return '';
    }
  } else if (start < 0) {
    for (posA = size; start < 0 && 0 < posA; start++) {
      posA -= getUTF16Length(str, posA - 1);
    }

    if (posA < 0) {
      posA = 0;
    }
  } // Find the actual ending position


  var posB = size;

  if (length < size) {
    for (posB = posA; length > 0 && posB < size; length--) {
      posB += getUTF16Length(str, posB);
    }
  }

  return str.substring(posA, posB);
}
/**
 * Fully Unicode-enabled replacement for String#substring()
 *
 * @param {string} str    Valid Unicode string
 * @param {number} start  Location in Unicode sequence to begin extracting
 * @param {?number} end   Location in Unicode sequence to end extracting
 *                        (default: end of the string)
 * @return {string}       Extracted sub-string
 */


function substring(str, start, end) {
  start = start || 0;
  end = end === undefined ? Infinity : end || 0;

  if (start < 0) {
    start = 0;
  }

  if (end < 0) {
    end = 0;
  }

  var length = Math.abs(end - start);
  start = start < end ? start : end;
  return substr(str, start, length);
}
/**
 * Get a list of Unicode code-points from a String
 *
 * @param {string} str        Valid Unicode string
 * @return {array<number>}    A list of code-points in [0..0x10FFFF]
 */


function getCodePoints(str) {
  var codePoints = [];

  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
    codePoints.push(str.codePointAt(pos));
  }

  return codePoints;
}

var UnicodeUtils = {
  getCodePoints: getCodePoints,
  getUTF16Length: getUTF16Length,
  hasSurrogateUnit: hasSurrogateUnit,
  isCodeUnitInSurrogateRange: isCodeUnitInSurrogateRange,
  isSurrogatePair: isSurrogatePair,
  strlen: strlen,
  substring: substring,
  substr: substr
};
module.exports = UnicodeUtils;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(12);

var invariant = __webpack_require__(6);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactRef = __webpack_require__(892);
var ReactInstrumentation = __webpack_require__(45);

var warning = __webpack_require__(18);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _draftJs = __webpack_require__(38);

var _clsx = __webpack_require__(128);

var _clsx2 = _interopRequireDefault(_clsx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-children-prop */


exports.default = function (_ref) {
  var style = _ref.style,
      children = _ref.children;
  return function (_Component) {
    _inherits(InlineStyleButton, _Component);

    function InlineStyleButton() {
      var _ref2;

      var _temp, _this, _ret;

      _classCallCheck(this, InlineStyleButton);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = InlineStyleButton.__proto__ || Object.getPrototypeOf(InlineStyleButton)).call.apply(_ref2, [this].concat(args))), _this), _this.toggleStyle = function (event) {
        event.preventDefault();
        _this.props.setEditorState(_draftJs.RichUtils.toggleInlineStyle(_this.props.getEditorState(), style));
      }, _this.preventBubblingUp = function (event) {
        event.preventDefault();
      }, _this.styleIsActive = function () {
        return _this.props.getEditorState && _this.props.getEditorState().getCurrentInlineStyle().has(style);
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    // we check if this.props.getEditorstate is undefined first in case the button is rendered before the editor


    _createClass(InlineStyleButton, [{
      key: 'render',
      value: function render() {
        var theme = this.props.theme;

        var className = this.styleIsActive() ? (0, _clsx2.default)(theme.button, theme.active) : theme.button;
        return _react2.default.createElement(
          'div',
          {
            className: theme.buttonWrapper,
            onMouseDown: this.preventBubblingUp
          },
          _react2.default.createElement('button', {
            className: className,
            onClick: this.toggleStyle,
            type: 'button',
            children: children
          })
        );
      }
    }]);

    return InlineStyleButton;
  }(_react.Component);
};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssueReport = exports.Change = exports.IssueTable = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _uuid = __webpack_require__(26);

var _uuid2 = _interopRequireDefault(_uuid);

var _superagent = __webpack_require__(23);

var _superagent2 = _interopRequireDefault(_superagent);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _ProjectMenu = __webpack_require__(17);

var _ProjectMenu2 = _interopRequireDefault(_ProjectMenu);

var _IssueForm = __webpack_require__(1029);

var _IssueForm2 = _interopRequireDefault(_IssueForm);

var _PriorityTable = __webpack_require__(224);

var _PriorityTable2 = _interopRequireDefault(_PriorityTable);

var _priority = __webpack_require__(102);

var _priority2 = _interopRequireDefault(_priority);

var _IssueReportList = __webpack_require__(1036);

var _IssueReportList2 = _interopRequireDefault(_IssueReportList);

var _LastIssueReports = __webpack_require__(1037);

var _LastIssueReports2 = _interopRequireDefault(_LastIssueReports);

var _sendCommand = __webpack_require__(25);

var _sendCommand2 = _interopRequireDefault(_sendCommand);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(72), __webpack_require__(73)]);

function assignPriority(item) {
  return item.status !== "Closed" ? Object.assign({}, item, { row: parseInt(item.priority), column: parseInt(item.severity) }) : Object.assign({}, item, { row: undefined, column: undefined });
}

var IssueTable = exports.IssueTable = function (_React$Component) {
  _inherits(IssueTable, _React$Component);

  function IssueTable() {
    _classCallCheck(this, IssueTable);

    return _possibleConstructorReturn(this, (IssueTable.__proto__ || Object.getPrototypeOf(IssueTable)).apply(this, arguments));
  }

  _createClass(IssueTable, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      var tableLabels = {
        row: labels.general.priority,
        column: labels.general.severity
      };
      return _react2.default.createElement(_PriorityTable2.default, _extends({}, this.props, { labels: tableLabels }));
    }
  }]);

  return IssueTable;
}(_react2.default.Component);

var ChangeOverview = function (_React$Component2) {
  _inherits(ChangeOverview, _React$Component2);

  function ChangeOverview() {
    _classCallCheck(this, ChangeOverview);

    return _possibleConstructorReturn(this, (ChangeOverview.__proto__ || Object.getPrototypeOf(ChangeOverview)).apply(this, arguments));
  }

  _createClass(ChangeOverview, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props); //(languageLabels[this.props.language] || languageLabels["english"]);
      return _react2.default.createElement(
        'div',
        { style: { display: "flex", justifyContent: "center", fontFamily: "Lato", flexWrap: "wrap", maxWidth: 1016 } },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { style: { backgroundColor: "#f7f7f7", padding: 20, marginBottom: 20, display: "flex", justifyContent: "space-between", flexWrap: "wrap" } },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { style: { fontWeight: "bold", fontSize: 14 } },
                labels.general.title
              ),
              _react2.default.createElement(
                'div',
                { style: { fontSize: 30, fontWeight: "bold", float: "left" } },
                labels.issueRegister.title
              ),
              _react2.default.createElement(
                'div',
                { style: { minWidth: 200, maxWidth: 300, paddingTop: 50 } },
                labels.issueRegister.description,
                ' ',
                _react2.default.createElement('br', null),
                _react2.default.createElement('br', null),
                labels.issueRegister.description2
              )
            ),
            this.props.hideReports !== true ? _react2.default.createElement(
              'div',
              { style: { paddingLeft: 20, paddingRight: 15, paddingTop: 40, paddingBottom: 20, width: 345 } },
              _react2.default.createElement(_LastIssueReports2.default, this.props)
            ) : _react2.default.createElement(
              'div',
              { style: { width: 344 } },
              ' '
            ),
            _react2.default.createElement(
              'div',
              { style: { float: "right", paddingBottom: 20, paddingRight: 20, paddingTop: 20, backgroundColor: "#f7f7f7" } },
              _react2.default.createElement(IssueTable, _extends({}, this.props, { onSelect: this.props.editIssue }))
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { float: "left", marginTop: 30, paddingLeft: 0, width: "100%", maxWidth: 1016 } },
          _react2.default.createElement(
            'div',
            { style: { textAlign: "right", paddingBottom: 15 } },
            _react2.default.createElement(
              'div',
              { onClick: this.props.addIssue, style: { cursor: "pointer", fontWeight: "bold", textDecoration: "underline" } },
              '+ ',
              labels.general.addIssue
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            this.props.items.length > 0 ? _react2.default.createElement(_IssueReportList2.default, _extends({}, this.props, {
              items: this.props.items.slice(0).sort(_priority2.default.getProfileSort(this.props.profile)),
              onSelect: this.props.editIssue
            })) : _react2.default.createElement(
              'div',
              { style: { maxWidth: 1016, fontFamily: "Verdana, sans-serif" } },
              _react2.default.createElement(
                'b',
                null,
                labels.general.noIssues
              ),
              '. ',
              labels.general.documentIssue
            )
          )
        )
      );
    }
  }]);

  return ChangeOverview;
}(_react2.default.Component);

var Change = exports.Change = function (_Component) {
  _inherits(Change, _Component);

  function Change(props) {
    _classCallCheck(this, Change);

    var _this3 = _possibleConstructorReturn(this, (Change.__proto__ || Object.getPrototypeOf(Change)).call(this, props));

    _this3.state = {
      issues: _this3.props.issues !== undefined ? _this3.props.issues : [],
      showForm: false,
      editIssue: undefined
    };
    return _this3;
  }

  _createClass(Change, [{
    key: 'showForm',
    value: function showForm(event) {
      event.preventDefault();
      if (this.props.onDetails !== undefined) {
        this.props.onDetails({ show: !this.state.showForm });
      }
      this.setState({ showForm: !this.state.showForm, editIssue: undefined });
    }
  }, {
    key: 'editIssue',
    value: function editIssue(item) {
      if (this.props.onDetails !== undefined) {
        this.props.onDetails({ show: true });
      }
      this.setState({ showForm: true, editIssue: this.state.issues.filter(function (issue) {
          return issue.id === item.id || issue.id === item;
        })[0] });
    }
  }, {
    key: 'update',
    value: function update(issue) {
      var _this4 = this;

      if (issue.id !== undefined) {
        var command = { type: "updateIssue", item: Object.assign({}, issue, { reports: undefined }) };
        if (this.props.project.isProduct === true) {
          command = Object.assign({}, command, {
            product: { id: this.props.project.id }
          });
        } else if (this.props.project.isProgramme === true) {
          command = Object.assign({}, command, {
            programme: { id: this.props.project.id }
          });
        } else if (this.props.project.isRelease === true) {
          command = Object.assign({}, command, {
            release: { id: this.props.project.id }
          });
        } else {
          command = Object.assign({}, command, {
            project: { id: this.props.project.id }
          });
        }

        (0, _sendCommand2.default)(command).then(function (response) {
          var selected = response.items.filter(function (updatedIssue) {
            return updatedIssue.id === issue.id;
          })[0];
          if (selected._implemented && issue._progress === "Implement") {
            selected = undefined;
          }
          if (_this4.props.onDetails !== undefined) {
            _this4.props.onDetails({ show: selected !== undefined });
          }
          _this4.setState({ issues: response.items, showForm: selected !== undefined, editIssue: selected });
          if (_this4.props.onUpdate !== undefined) {
            _this4.props.onUpdate(response.items);
          }
        }).catch(function (error) {
          console.log("Got error", error);
          alert("An error occured, please try again");
        });
      } else {
        var id = _uuid2.default.v4();
        var command = { type: "captureIssue", item: Object.assign({}, issue, { id: id }) };
        if (this.props.project.isProduct === true) {
          command = Object.assign({}, command, {
            product: { id: this.props.project.id }
          });
        } else if (this.props.project.isProgramme === true) {
          command = Object.assign({}, command, {
            programme: { id: this.props.project.id }
          });
        } else if (this.props.project.isRelease === true) {
          command = Object.assign({}, command, {
            release: { id: this.props.project.id }
          });
        } else {
          command = Object.assign({}, command, {
            project: { id: this.props.project.id }
          });
        }
        (0, _sendCommand2.default)(command).then(function (response) {
          var selected = response.items.filter(function (updatedIssue) {
            return updatedIssue.id === id;
          })[0];
          _this4.setState({ issues: response.items, editIssue: selected });
          if (_this4.props.onUpdate !== undefined) {
            _this4.props.onUpdate(response.items);
          }
        }).catch(function (error) {
          console.log("Got error", error);
          alert("An error occures, please try again");
        });
      }
    }
  }, {
    key: 'createIssueReport',
    value: function createIssueReport(issue, isExceptionReport) {
      var id = _uuid2.default.v4();
      var command = {
        type: "createIssueReport",
        report: {
          id: id,
          issue: Object.assign({}, issue, { reports: undefined }),
          exception: isExceptionReport
        }
      };
      if (this.props.project.isProduct === true) {
        command = Object.assign({}, command, {
          product: { id: this.props.project.id }
        });
      } else if (this.props.project.isProgramme === true) {
        command = Object.assign({}, command, {
          programme: { id: this.props.project.id }
        });
      } else if (this.props.project.isRelease === true) {
        command = Object.assign({}, command, {
          release: { id: this.props.project.id }
        });
      } else {
        command = Object.assign({}, command, {
          project: { id: this.props.project.id }
        });
      }
      (0, _sendCommand2.default)(command).then(function (response) {
        return window.location = "change/issues/" + issue.id + "/reports/" + id;
      }).catch(function (error) {
        console.log("Got error", error);
        alert("An error occured, please try again");
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var items = this.state.issues.slice(0).map(assignPriority);
      if (this.props.size !== undefined) {
        items = items.sort(_priority2.default.getProfileSort(this.props.profile)).slice(0, this.props.size);
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { marginLeft: 30, paddingTop: 20 } },
          this.state.showForm ? _react2.default.createElement(_IssueForm2.default, _extends({}, this.props, {
            onCancel: this.showForm.bind(this),
            onUpdate: this.update.bind(this),
            item: this.state.editIssue,
            createReport: this.createIssueReport.bind(this),
            hideMenu: this.props.hideMenu
          })) : _react2.default.createElement(ChangeOverview, _extends({}, this.props, {
            items: items,
            addIssue: this.showForm.bind(this),
            editIssue: this.editIssue.bind(this)
          }))
        )
      );
    }
  }]);

  return Change;
}(_react.Component);

var IssueReport = exports.IssueReport = function (_Component2) {
  _inherits(IssueReport, _Component2);

  function IssueReport() {
    _classCallCheck(this, IssueReport);

    return _possibleConstructorReturn(this, (IssueReport.__proto__ || Object.getPrototypeOf(IssueReport)).apply(this, arguments));
  }

  _createClass(IssueReport, [{
    key: 'render',
    value: function render() {
      var items = this.props.items.slice(0).map(assignPriority).sort(_priority2.default.getProfileSort(this.props.profile)).slice(0, 5);
      return _react2.default.createElement(
        'div',
        { style: { maxwidth: 1016 } },
        _react2.default.createElement(IssueTable, _extends({}, this.props, { items: items })),
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 20 } },
          _react2.default.createElement(_IssueReportList2.default, _extends({}, this.props, { items: items }))
        )
      );
    }
  }]);

  return IssueReport;
}(_react.Component);

var ChangePage = function (_Component3) {
  _inherits(ChangePage, _Component3);

  function ChangePage() {
    _classCallCheck(this, ChangePage);

    return _possibleConstructorReturn(this, (ChangePage.__proto__ || Object.getPrototypeOf(ChangePage)).apply(this, arguments));
  }

  _createClass(ChangePage, [{
    key: 'render',
    value: function render() {
      var menu = this.props.showMenu === true ? _react2.default.createElement(_ProjectMenu2.default, this.props) : undefined;
      return _react2.default.createElement(
        _Layout2.default,
        _extends({}, this.props, { projectMenu: menu }),
        _react2.default.createElement(Change, this.props)
      );
    }
  }]);

  return ChangePage;
}(_react.Component);

exports.default = ChangePage;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(20).f;
var has = __webpack_require__(39);
var TAG = __webpack_require__(14)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(49);
var TAG = __webpack_require__(14)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var defined = __webpack_require__(54);
var fails = __webpack_require__(7);
var spaces = __webpack_require__(185);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(8);

var ReactCurrentOwner = __webpack_require__(62);

var warning = __webpack_require__(145);
var canDefineProperty = __webpack_require__(304);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(305);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clone = clone;
exports.addMonths = addMonths;
exports.isSameDay = isSameDay;
exports.isDayBefore = isDayBefore;
exports.isDayAfter = isDayAfter;
exports.isPastDay = isPastDay;
exports.isFutureDay = isFutureDay;
exports.isDayBetween = isDayBetween;
exports.addDayToRange = addDayToRange;
exports.isDayInRange = isDayInRange;
exports.getWeekNumber = getWeekNumber;
/**
 * Clone a date object.
 *
 * @export
 * @param  {Date} d The date to clone
 * @return {Date} The cloned date
 */
function clone(d) {
  return new Date(d.getTime());
}

/**
 * Return `d` as a new date with `n` months added.
 * 
 * @export
 * @param {[type]} d
 * @param {[type]} n
 */
function addMonths(d, n) {
  var newDate = clone(d);
  newDate.setMonth(d.getMonth() + n);
  return newDate;
}

/**
 * Return `true` if two dates are the same day, ignoring the time.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isSameDay(d1, d2) {
  if (!d1 || !d2) {
    return false;
  }
  return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}

/**
 * Returns `true` if the first day is before the second day.
 * 
 * @export
 * @param {Date} d1 
 * @param {Date} d2 
 * @returns {Boolean}
 */
function isDayBefore(d1, d2) {
  var day1 = clone(d1).setHours(0, 0, 0, 0);
  var day2 = clone(d2).setHours(0, 0, 0, 0);
  return day1 < day2;
}

/**
 * Returns `true` if the first day is after the second day.
 * 
 * @export
 * @param {Date} d1 
 * @param {Date} d2 
 * @returns {Boolean}
 */
function isDayAfter(d1, d2) {
  var day1 = clone(d1).setHours(0, 0, 0, 0);
  var day2 = clone(d2).setHours(0, 0, 0, 0);
  return day1 > day2;
}

/**
 * Return `true` if a day is in the past, e.g. yesterday or any day
 * before yesterday.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */
function isPastDay(d) {
  var today = new Date();
  today.setHours(0, 0, 0, 0);
  return isDayBefore(d, today);
}

/**
 * Return `true` if a day is in the future, e.g. tomorrow or any day
 * after tomorrow.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */
function isFutureDay(d) {
  var tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
  tomorrow.setHours(0, 0, 0, 0);
  return d >= tomorrow;
}

/**
 * Return `true` if day `d` is between days `d1` and `d2`,
 * without including them.
 *
 * @export
 * @param  {Date}  d
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isDayBetween(d, d1, d2) {
  var date = clone(d);
  date.setHours(0, 0, 0, 0);
  return isDayAfter(date, d1) && isDayBefore(date, d2) || isDayAfter(date, d2) && isDayBefore(date, d1);
}

/**
 * Add a day to a range and return a new range. A range is an object with
 * `from` and `to` days.
 *
 * @export
 * @param {Date} day
 * @param {Object} range
 * @return {Object} Returns a new range object
 */
function addDayToRange(day) {
  var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { from: null, to: null };
  var from = range.from,
      to = range.to;

  if (!from) {
    from = day;
  } else if (from && to && isSameDay(from, to) && isSameDay(day, from)) {
    from = null;
    to = null;
  } else if (to && isDayBefore(day, from)) {
    from = day;
  } else if (to && isSameDay(day, to)) {
    from = day;
    to = day;
  } else {
    to = day;
    if (isDayBefore(to, from)) {
      to = from;
      from = day;
    }
  }

  return { from: from, to: to };
}

/**
 * Return `true` if a day is included in a range of days.
 *
 * @export
 * @param  {Date}  day
 * @param  {Object}  range
 * @return {Boolean}
 */
function isDayInRange(day, range) {
  var from = range.from,
      to = range.to;

  return from && isSameDay(day, from) || to && isSameDay(day, to) || from && to && isDayBetween(day, from, to);
}

/**
 * Return the year's week number (as per ISO, i.e. with the week starting from monday)
 * for the given day.
 * 
 * @export
 * @param {Date} day 
 * @returns {Number}
 */
function getWeekNumber(day) {
  var date = clone(day);
  date.setHours(0, 0, 0);
  date.setDate(date.getDate() + 4 - (date.getDay() || 7));
  return Math.ceil(((date - new Date(date.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7);
}

exports.default = {
  addDayToRange: addDayToRange,
  addMonths: addMonths,
  clone: clone,
  getWeekNumber: getWeekNumber,
  isDayAfter: isDayAfter,
  isDayBefore: isDayBefore,
  isDayBetween: isDayBetween,
  isDayInRange: isDayInRange,
  isFutureDay: isFutureDay,
  isPastDay: isPastDay,
  isSameDay: isSameDay
};
//# sourceMappingURL=DateUtils.js.map

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.getTableColors = getTableColors;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var mostlyGreenPriority = [{ row: 5, column: 5, classification: "high" }, //1
{ row: 4, column: 5, classification: "high" }, //2
{ row: 5, column: 4, classification: "high" }, //3
{ row: 4, column: 4, classification: "medium" }, //4
{ row: 3, column: 5, classification: "medium" }, //5
{ row: 5, column: 3, classification: "medium" }, //6
{ row: 3, column: 4, classification: "medium" }, //7
{ row: 4, column: 3, classification: "medium" }, //8
{ row: 2, column: 5, classification: "medium" }, //9
{ row: 5, column: 2, classification: "medium" }, //10
{ row: 3, column: 3, classification: "low" }, //11
{ row: 2, column: 4, classification: "low" }, //12
{ row: 4, column: 2, classification: "low" }, //13
{ row: 2, column: 3, classification: "low" }, //14
{ row: 3, column: 2, classification: "low" }, //15
{ row: 1, column: 5, classification: "low" }, //16
{ row: 5, column: 1, classification: "low" }, //17
{ row: 1, column: 4, classification: "low" }, //18
{ row: 2, column: 2, classification: "low" }, //19
{ row: 4, column: 1, classification: "low" }, //20
{ row: 3, column: 1, classification: "low" }, //21
{ row: 1, column: 3, classification: "low" }, //22
{ row: 1, column: 2, classification: "low" }, //23
{ row: 2, column: 1, classification: "low" }, //24
{ row: 1, column: 1, classification: "low" }];

var defaultPriority = [{ row: 5, column: 5, classification: "high" }, //1
{ row: 4, column: 5, classification: "high" }, //2
{ row: 5, column: 4, classification: "high" }, //3
{ row: 3, column: 5, classification: "high" }, //4
{ row: 4, column: 4, classification: "high" }, //5
{ row: 5, column: 3, classification: "high" }, //6
{ row: 2, column: 5, classification: "high" }, //7
{ row: 3, column: 4, classification: "high" }, //8
{ row: 4, column: 3, classification: "medium" }, //9
{ row: 2, column: 4, classification: "medium" }, //10
{ row: 3, column: 3, classification: "medium" }, //11
{ row: 1, column: 5, classification: "medium" }, //12
{ row: 5, column: 2, classification: "medium" }, //13
{ row: 2, column: 3, classification: "medium" }, //14
{ row: 4, column: 2, classification: "medium" }, //15
{ row: 1, column: 4, classification: "medium" }, //16
{ row: 3, column: 2, classification: "medium" }, //17
{ row: 1, column: 3, classification: "low" }, //18
{ row: 2, column: 2, classification: "low" }, //19
{ row: 5, column: 1, classification: "low" }, //20
{ row: 4, column: 1, classification: "low" }, //21
{ row: 1, column: 2, classification: "low" }, //22
{ row: 3, column: 1, classification: "low" }, //23
{ row: 2, column: 1, classification: "low" }, //24
{ row: 1, column: 1, classification: "low" }];

//let priority=mostlyGreenPriority; //defaultPriority;

function sortByColumn(cellA, cellB) {
  return cellA.column < cellB.column ? -1 : cellA.column > cellB.column ? 1 : 0;
}

function getPriorityProfile(profile) {
  return profile !== "mostlyGreen" ? defaultPriority : mostlyGreenPriority;
}

function cellRow(row, profile) {
  var priority = getPriorityProfile(profile);
  return {
    label: row.toString(),
    value: row,
    colors: priority.filter(function (cell) {
      return cell.row === row;
    }).sort(sortByColumn).map(function (cell) {
      return cell.classification;
    })
  };
}

function getTableColors(size, profile) {
  return [5, 4, 3, 2, 1].map(function (row) {
    return cellRow(row, profile);
  });
}

function exposure(item) {
  var row = parseInt(item.row);
  var column = parseInt(item.column);
  return item.status === "Closed" || item.row === undefined || item.column === undefined ? 0 : row * column + column * column * row;
}

function exposurePriority(item, profile) {
  var priority = getPriorityProfile(profile);
  var foundIndex = priority.length;
  var index = 0;
  while (foundIndex === priority.length && index < priority.length) {
    foundIndex = priority[index].row === parseInt(item.row) && priority[index].column === parseInt(item.column) ? index : priority.length;
    index++;
  }
  return foundIndex;
}

function exposureClassification(item, profile) {
  var index = exposurePriority(item, profile);

  var priority = getPriorityProfile(profile);
  return index !== undefined && index >= 0 && index < priority.length ? priority[index].classification : undefined;
}

function _compareValue(a, b) {
  return a > b ? new Compare(a, b, 1) : a < b ? new Compare(a, b, -1) : new Compare(a, b, 0);
}

function _compareStatus(a, b) {
  var getStatus = function getStatus(value) {
    return value !== undefined && value === "Closed" ? 1 : 0;
  };
  return _compareValue(getStatus(a), getStatus(b), 0);
}

var Compare = function () {
  function Compare(a, b, outcome) {
    _classCallCheck(this, Compare);

    this.value = outcome;
    this.log = { evaluate: a + " vs " + b };
  }

  _createClass(Compare, [{
    key: "evaluate",
    value: function evaluate(compare, type) {
      this.value = compare.value;
      this.log = Object.assign({}, this.log, {
        calculations: (this.log.calculations !== undefined ? this.log.calculations : []).concat({ type: type, compares: compare.log, outcome: compare.value })
      });
      return this;
    }
  }, {
    key: "isDefined",
    value: function isDefined() {
      return this.value !== undefined && this.value !== 0;
    }
  }, {
    key: "compareValue",
    value: function compareValue(a, b) {
      return this.isDefined() ? this : this.evaluate(_compareValue(a, b), "value");
    }
  }, {
    key: "compareStatus",
    value: function compareStatus(a, b) {
      return this.isDefined() ? this : this.evaluate(_compareStatus(a, b), "status");
    }
  }]);

  return Compare;
}();

function comparePriority(a, b, profile) {
  var valueA = exposurePriority(a, profile);
  var valueB = exposurePriority(b, profile);

  var outcome = new Compare(a.no + ". " + a.title, b.no + ". " + b.title).compareStatus(a.status, b.status).compareValue(valueA, valueB).compareValue(parseInt(a.no), parseInt(b.no));
  return outcome.value;
}

function getProfileSort(profile) {
  return function (a, b) {
    return comparePriority(a, b, profile);
  };
}

function priorityColor(item, profile) {
  var color = item !== item.row !== undefined && item.column !== undefined ? exposureClassification(item, profile) : item;
  switch (color) {
    case "low":
      return "#47b857";
    case "medium":
      return "#f4c403";
    case "high":
      return "#f85252";
    default:
      return undefined;
  }
}

function allItems(createItem, profile) {
  var priority = getPriorityProfile(profile);
  return priority.map(function (item, index) {
    return createItem(item, index);
  });
}

function assignIssuePriority(item) {
  return item.status !== "Closed" ? Object.assign({}, item, {
    row: parseInt(item.priority),
    column: parseInt(item.severity)
  }) : Object.assign({}, item, { row: undefined, column: undefined });
}

function assignRiskPriority(item) {
  return item.status !== "Closed" ? Object.assign({}, item, {
    row: parseInt(item.probability),
    column: parseInt(item.impact)
  }) : Object.assign({}, item, { row: undefined, column: undefined });
}
module.exports = {
  getTableColors: getTableColors,
  getProfileSort: getProfileSort,
  priorityColor: priorityColor,
  allItems: allItems,
  assignIssuePriority: assignIssuePriority,
  assignRiskPriority: assignRiskPriority
};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(12);

var invariant = __webpack_require__(6);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = __webpack_require__(242);
var setInnerHTML = __webpack_require__(169);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(243);
var setTextContent = __webpack_require__(388);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HighlightReportSlideTitle = exports.TitleAndSummary = exports.ReportMessage = exports.HighlightArea = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Risk = __webpack_require__(63);

var _Change = __webpack_require__(95);

var _FormattedContent = __webpack_require__(15);

var _FormattedContent2 = _interopRequireDefault(_FormattedContent);

var _Status = __webpack_require__(208);

var _Status2 = _interopRequireDefault(_Status);

var _ReportSection = __webpack_require__(416);

var _ReportSection2 = _interopRequireDefault(_ReportSection);

var _formatTime = __webpack_require__(1034);

var _formatTime2 = _interopRequireDefault(_formatTime);

var _formatDate = __webpack_require__(417);

var _formatDate2 = _interopRequireDefault(_formatDate);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(418), __webpack_require__(420)]);

var HighlightArea = exports.HighlightArea = function (_React$Component) {
  _inherits(HighlightArea, _React$Component);

  function HighlightArea() {
    _classCallCheck(this, HighlightArea);

    return _possibleConstructorReturn(this, (HighlightArea.__proto__ || Object.getPrototypeOf(HighlightArea)).apply(this, arguments));
  }

  _createClass(HighlightArea, [{
    key: 'render',
    value: function render() {
      var imageStyle = this.props.settings !== undefined && this.props.settings.image ? this.props.settings.image.style : undefined;
      var imagePrefix = this.props.settings !== undefined && this.props.settings.image ? this.props.settings.image.prefix : undefined;
      return _react2.default.createElement(
        'div',
        { style: { paddingBottom: 10 } },
        _react2.default.createElement(
          'h3',
          null,
          this.props.label,
          ' ',
          _react2.default.createElement(_Status2.default, { style: imageStyle, prefix: imagePrefix, value: this.props.status })
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_FormattedContent2.default, { value: this.props.content })
        )
      );
    }
  }]);

  return HighlightArea;
}(_react2.default.Component);

var HighlightVariable = function (_React$Component2) {
  _inherits(HighlightVariable, _React$Component2);

  function HighlightVariable() {
    _classCallCheck(this, HighlightVariable);

    return _possibleConstructorReturn(this, (HighlightVariable.__proto__ || Object.getPrototypeOf(HighlightVariable)).apply(this, arguments));
  }

  _createClass(HighlightVariable, [{
    key: 'render',
    value: function render() {
      var imageStyle = this.props.settings !== undefined && this.props.settings.image ? this.props.settings.image.style : undefined;
      var imagePrefix = this.props.settings !== undefined && this.props.settings.image ? this.props.settings.image.prefix : undefined;
      return _react2.default.createElement(
        'div',
        { style: { display: "table-row", borderBottom: "solid 1px #4472C4", backgroundColor: this.props.backgroundColor } },
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", padding: 5, paddingBottom: 15, verticalAlign: "top" } },
          _react2.default.createElement(
            'b',
            null,
            this.props.label
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", padding: 5, paddingBottom: 15, textAlign: "center", verticalAlign: "top" } },
          _react2.default.createElement(_Status2.default, { style: imageStyle, prefix: imagePrefix, value: this.props.status })
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", padding: 5, paddingBottom: 15 } },
          _react2.default.createElement(_FormattedContent2.default, { value: this.props.content })
        )
      );
    }
  }]);

  return HighlightVariable;
}(_react2.default.Component);

var ReportMessage = exports.ReportMessage = function (_React$Component3) {
  _inherits(ReportMessage, _React$Component3);

  function ReportMessage() {
    _classCallCheck(this, ReportMessage);

    return _possibleConstructorReturn(this, (ReportMessage.__proto__ || Object.getPrototypeOf(ReportMessage)).apply(this, arguments));
  }

  _createClass(ReportMessage, [{
    key: 'render',
    value: function render() {
      var label = this.props.label !== undefined ? this.props.label : "";
      var timestamp = this.props.timestamp !== undefined ? (0, _formatTime2.default)(this.props.timestamp) : "";
      var message = this.props.message !== undefined ? this.props.message : (label + " " + timestamp).trim();
      return _react2.default.createElement(
        'div',
        { style: { color: "#212121", fontFamily: "Lato", backgroundColor: "#FFEADB", padding: 10, textAlign: "center" } },
        message
      );
    }
  }]);

  return ReportMessage;
}(_react2.default.Component);

var TitleAndSummary = exports.TitleAndSummary = function (_React$Component4) {
  _inherits(TitleAndSummary, _React$Component4);

  function TitleAndSummary() {
    _classCallCheck(this, TitleAndSummary);

    return _possibleConstructorReturn(this, (TitleAndSummary.__proto__ || Object.getPrototypeOf(TitleAndSummary)).apply(this, arguments));
  }

  _createClass(TitleAndSummary, [{
    key: 'render',
    value: function render() {
      var _this5 = this;

      var labels = translations.getTranslation(this.props).report.highlight;
      var date = (0, _formatDate2.default)(this.props.date, labels.undefinedDate);
      var stage = this.props.stage !== undefined && this.props.stage !== null && this.props.project !== undefined && this.props.project.stages !== undefined ? this.props.project.stages.filter(function (stage) {
        return stage.id === _this5.props.stage.id;
      })[0] : undefined;
      var nameAndDate = this.props.endProject === true || stage !== undefined ? _react2.default.createElement(
        'div',
        null,
        this.props.project !== undefined ? _react2.default.createElement(
          'div',
          null,
          this.props.project.name
        ) : null
      ) : (this.props.project !== undefined ? this.props.project.name + " - " : "") + date;
      var title = this.props.endProject ? labels.endProjectReport : stage !== undefined ? labels.endStageReport + " - " + stage.name : labels.title;
      var manager = this.props.manager !== undefined ? this.props.manager : undefined;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { textAlign: "center", marginBottom: 10 } },
          _react2.default.createElement(
            'h2',
            { style: { marginBottom: 0 } },
            _react2.default.createElement(
              'div',
              { style: { fontSize: "120%" } },
              title
            ),
            _react2.default.createElement(
              'div',
              null,
              nameAndDate
            )
          ),
          manager !== undefined ? _react2.default.createElement(
            'div',
            { style: { padding: 5 } },
            labels.managedBy,
            ': ',
            manager.name
          ) : null,
          this.props.endProject === true || stage !== undefined ? _react2.default.createElement(
            'div',
            null,
            labels.start,
            ' ',
            (0, _formatDate2.default)(this.props.from, labels.undefinedDate),
            ', ',
            labels.end,
            ' ',
            (0, _formatDate2.default)(this.props.date, labels.undefinedDate)
          ) : null
        ),
        this.props.type === "draft" ? _react2.default.createElement(ReportMessage, _extends({}, this.props, { label: labels.draftSaved })) : null,
        this.props.type === "preview" ? _react2.default.createElement(ReportMessage, _extends({}, this.props, { label: labels.preview })) : null,
        _react2.default.createElement(HighlightArea, _extends({ settings: this.props.settings, label: labels.summary }, this.props.summary))
      );
    }
  }]);

  return TitleAndSummary;
}(_react2.default.Component);

var PerformanceAspects = function (_React$Component5) {
  _inherits(PerformanceAspects, _React$Component5);

  function PerformanceAspects() {
    _classCallCheck(this, PerformanceAspects);

    return _possibleConstructorReturn(this, (PerformanceAspects.__proto__ || Object.getPrototypeOf(PerformanceAspects)).apply(this, arguments));
  }

  _createClass(PerformanceAspects, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).report.highlight;
      var style = Object.assign({}, { maxWidth: 1016 }, this.props.settings !== undefined ? this.props.settings.style : undefined);
      var aspectsStyle = Object.assign({}, [{}, {}, {}], this.props.settings !== undefined ? this.props.settings.aspectsTable : undefined);
      return _react2.default.createElement(
        'div',
        { style: { pageBreakAfter: "always", marginTop: 20, width: "100%", display: "table", borderSpacing: 10, borderCollapse: "collapse", border: "solid 1px #4472C4" } },
        _react2.default.createElement(
          'div',
          { style: { display: "table-row", backgroundColor: "#4472C4", color: "white", fontWeitgh: "bold" } },
          _react2.default.createElement(
            'div',
            { style: Object.assign({}, { display: "table-cell", width: 100, padding: 5 }, aspectsStyle[0]) },
            labels.aspect
          ),
          _react2.default.createElement(
            'div',
            { style: Object.assign({}, { display: "table-cell", width: 90, padding: 5, textAlign: "center" }, aspectsStyle[1]) },
            labels.status
          ),
          _react2.default.createElement(
            'div',
            { style: Object.assign({}, { display: "table-cell", padding: 5 }, aspectsStyle[2]) },
            labels.description
          )
        ),
        _react2.default.createElement(HighlightVariable, _extends({ settings: this.props.settings, label: labels.benefits }, this.props.benefits)),
        _react2.default.createElement(HighlightVariable, _extends({ settings: this.props.settings, backgroundColor: '#D9E2F3', label: labels.time }, this.props.time)),
        _react2.default.createElement(HighlightVariable, _extends({ settings: this.props.settings, label: labels.cost }, this.props.cost)),
        _react2.default.createElement(HighlightVariable, _extends({ settings: this.props.settings, backgroundColor: '#D9E2F3', label: labels.quality }, this.props.quality)),
        _react2.default.createElement(HighlightVariable, _extends({ settings: this.props.settings, label: labels.scope }, this.props.scope)),
        _react2.default.createElement(HighlightVariable, _extends({ settings: this.props.settings, backgroundColor: '#D9E2F3', label: labels.risk }, this.props.risk))
      );
    }
  }]);

  return PerformanceAspects;
}(_react2.default.Component);

var RiskReportSection = function (_React$Component6) {
  _inherits(RiskReportSection, _React$Component6);

  function RiskReportSection() {
    _classCallCheck(this, RiskReportSection);

    return _possibleConstructorReturn(this, (RiskReportSection.__proto__ || Object.getPrototypeOf(RiskReportSection)).apply(this, arguments));
  }

  _createClass(RiskReportSection, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).report.highlight;

      return _react2.default.createElement(
        'div',
        { style: { paddingTop: 30 } },
        _react2.default.createElement(
          'h2',
          null,
          labels.risk
        ),
        _react2.default.createElement(_Risk.RiskReport, _extends({}, this.props, { items: this.props.risk.items.filter(function (item) {
            return item.status !== "Closed";
          }) })),
        _react2.default.createElement('br', null),
        labels.listLimitedTo,
        _react2.default.createElement(
          'b',
          null,
          ' ',
          labels.top5Risks
        )
      );
    }
  }]);

  return RiskReportSection;
}(_react2.default.Component);

var IssueReportSection = function (_React$Component7) {
  _inherits(IssueReportSection, _React$Component7);

  function IssueReportSection() {
    _classCallCheck(this, IssueReportSection);

    return _possibleConstructorReturn(this, (IssueReportSection.__proto__ || Object.getPrototypeOf(IssueReportSection)).apply(this, arguments));
  }

  _createClass(IssueReportSection, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).report.highlight;

      return _react2.default.createElement(
        'div',
        { style: { paddingTop: 30 } },
        _react2.default.createElement(
          'h2',
          null,
          labels.issues
        ),
        _react2.default.createElement(_Change.IssueReport, _extends({}, this.props, { items: this.props.change.items.filter(function (item) {
            return item.status !== "Closed";
          }) })),
        _react2.default.createElement('br', null),
        labels.listLimitedTo,
        _react2.default.createElement(
          'b',
          null,
          ' ',
          labels.top5Issues
        )
      );
    }
  }]);

  return IssueReportSection;
}(_react2.default.Component);

var HighlightReport = function (_React$Component8) {
  _inherits(HighlightReport, _React$Component8);

  function HighlightReport() {
    _classCallCheck(this, HighlightReport);

    return _possibleConstructorReturn(this, (HighlightReport.__proto__ || Object.getPrototypeOf(HighlightReport)).apply(this, arguments));
  }

  _createClass(HighlightReport, [{
    key: 'render',
    value: function render() {
      var _this10 = this;

      var labels = translations.getTranslation(this.props).report.highlight;
      var style = Object.assign({}, { maxWidth: 1016 }, this.props.settings !== undefined ? this.props.settings.style : undefined);
      var stage = this.props.stage !== undefined && this.props.stage !== null && this.props.project !== undefined && this.props.project.stages !== undefined ? this.props.project.stages.filter(function (stage) {
        return stage.id === _this10.props.stage.id;
      })[0] : undefined;
      var presentationMode = this.props.presentationMode !== undefined ? this.props.presentationMode : false;
      var performedTitle = this.props.endProject ? labels.projectDeliverables : stage !== undefined ? labels.deliveryStatus : labels.currentPeriod + (this.props.from !== undefined && this.props.from !== null ? " (" + labels.from + " " + (0, _formatDate2.default)(this.props.from) + ")" : "");
      var performed = _react2.default.createElement(_ReportSection2.default, { label: performedTitle, value: this.props.performedAchivements });
      var slide = this.props.slideNo === 0 ? _react2.default.createElement(TitleAndSummary, this.props) : this.props.slideNo === 1 ? stage === undefined ? performed : undefined : this.props.slideNo === 2 ? stage === undefined && this.props.endProject !== true ? _react2.default.createElement(_ReportSection2.default, { label: labels.nextPeriod, value: this.props.plannedAchivements }) : undefined : this.props.slideNo === 3 ? _react2.default.createElement(PerformanceAspects, this.props) : this.props.slideNo === 4 ? (this.props.endProject || stage !== undefined) && this.props.teamPerformance !== undefined ? _react2.default.createElement(_ReportSection2.default, { label: labels.teamPerformance, value: this.props.teamPerformance }) : undefined : this.props.slideNo === 5 ? (this.props.endProject || stage !== undefined) && this.props.lessonsDescription !== undefined ? _react2.default.createElement(_ReportSection2.default, { label: labels.lessonsDescription, value: this.props.lessonsDescription }) : undefined : this.props.slideNo === 6 ? stage !== undefined ? performed : undefined : this.props.slideNo === 7 ? (this.props.settings === undefined || this.props.settings !== undefined && this.props.settings.includedRisk !== false) && this.props.risk !== undefined && this.props.risk.items !== undefined && this.props.risk.items !== null && this.props.risk.items.length > 0 && this.props.risk.items.filter(function (item) {
        return item.status !== "Closed";
      }).length > 0 ? _react2.default.createElement(RiskReportSection, this.props) : undefined : this.props.slideNo === 8 ? (this.props.settings === undefined || this.props.settings !== undefined && this.props.settings.includedIssues !== false) && this.props.change !== undefined && this.props.change !== null && this.props.change.items !== undefined && this.props.change.items !== null && this.props.change.items.length > 0 && this.props.change.items.filter(function (item) {
        return item.status !== "Closed";
      }).length > 0 ? _react2.default.createElement(IssueReportSection, this.props) : undefined : undefined;
      return presentationMode !== true ? _react2.default.createElement(
        'div',
        { style: style },
        _react2.default.createElement(TitleAndSummary, this.props),
        stage === undefined ? performed : null,
        stage === undefined && this.props.endProject !== true ? _react2.default.createElement(_ReportSection2.default, { label: labels.nextPeriod, value: this.props.plannedAchivements }) : null,
        _react2.default.createElement(PerformanceAspects, this.props),
        (this.props.endProject || stage !== undefined) && this.props.teamPerformance !== undefined ? _react2.default.createElement(_ReportSection2.default, { label: labels.teamPerformance, value: this.props.teamPerformance }) : null,
        (this.props.endProject || stage !== undefined) && this.props.lessonsDescription !== undefined ? _react2.default.createElement(_ReportSection2.default, { label: labels.lessonsDescription, value: this.props.lessonsDescription }) : null,
        stage !== undefined ? performed : null,
        (this.props.settings === undefined || this.props.settings !== undefined && this.props.settings.includedRisk !== false) && this.props.risk !== undefined && this.props.risk.items !== undefined && this.props.risk.items !== null && this.props.risk.items.length > 0 && this.props.risk.items.filter(function (item) {
          return item.status !== "Closed";
        }).length > 0 ? _react2.default.createElement(RiskReportSection, this.props) : null,
        (this.props.settings === undefined || this.props.settings !== undefined && this.props.settings.includedIssues !== false) && this.props.change !== undefined && this.props.change !== null && this.props.change.items !== undefined && this.props.change.items !== null && this.props.change.items.length > 0 && this.props.change.items.filter(function (item) {
          return item.status !== "Closed";
        }).length > 0 ? _react2.default.createElement(IssueReportSection, this.props) : null
      ) : slide !== undefined ? _react2.default.createElement(
        'div',
        { style: style },
        ' ',
        slide,
        ' '
      ) : null;
    }
  }]);

  return HighlightReport;
}(_react2.default.Component);

exports.default = HighlightReport;

var HighlightReportSlideTitle = exports.HighlightReportSlideTitle = function (_React$Component9) {
  _inherits(HighlightReportSlideTitle, _React$Component9);

  function HighlightReportSlideTitle() {
    _classCallCheck(this, HighlightReportSlideTitle);

    return _possibleConstructorReturn(this, (HighlightReportSlideTitle.__proto__ || Object.getPrototypeOf(HighlightReportSlideTitle)).apply(this, arguments));
  }

  _createClass(HighlightReportSlideTitle, [{
    key: 'render',
    value: function render() {
      var _this12 = this;

      var labels = translations.getTranslation(this.props).report.highlight;
      var stage = this.props.stage !== undefined && this.props.stage !== null && this.props.project !== undefined && this.props.project.stages !== undefined ? this.props.project.stages.filter(function (stage) {
        return stage.id === _this12.props.stage.id;
      })[0] : undefined;
      var performedTitle = this.props.endProject ? labels.projectDeliverables : stage !== undefined ? labels.deliveryStatus : labels.currentPeriod + (this.props.from !== undefined && this.props.from !== null ? " (" + labels.from + " " + (0, _formatDate2.default)(this.props.from) + ")" : "");
      var slideTitle = this.props.slideNo === 0 ? labels.summary : this.props.slideNo === 1 ? stage === undefined ? labels.currentPeriod : undefined : this.props.slideNo === 2 ? stage === undefined && this.props.endProject !== true ? labels.nextPeriod : undefined : this.props.slideNo === 3 ? labels.aspect : this.props.slideNo === 4 ? (this.props.endProject || stage !== undefined) && this.props.teamPerformance !== undefined ? labels.teamPerformance : undefined : this.props.slideNo === 5 ? (this.props.endProject || stage !== undefined) && this.props.lessonsDescription !== undefined ? labels.lessonsDescription : undefined : this.props.slideNo === 6 ? stage !== undefined ? labels.deliveryStatus : undefined : this.props.slideNo === 7 ? (this.props.settings === undefined || this.props.settings !== undefined && this.props.settings.includedRisk !== false) && this.props.risk !== undefined && this.props.risk.items !== undefined && this.props.risk.items !== null && this.props.risk.items.length > 0 && this.props.risk.items.filter(function (item) {
        return item.status !== "Closed";
      }).length > 0 ? labels.risk : undefined : this.props.slideNo === 8 ? (this.props.settings === undefined || this.props.settings !== undefined && this.props.settings.includedIssues !== false) && this.props.change !== undefined && this.props.change !== null && this.props.change.items !== undefined && this.props.change.items !== null && this.props.change.items.length > 0 && this.props.change.items.filter(function (item) {
        return item.status !== "Closed";
      }).length > 0 ? labels.issues : undefined : undefined;
      return slideTitle !== undefined ? _react2.default.createElement(
        'div',
        null,
        slideTitle
      ) : null;
    }
  }]);

  return HighlightReportSlideTitle;
}(_react2.default.Component);

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(47);
var global = __webpack_require__(5);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(67) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(49);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 108 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(3);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(3);
var aFunction = __webpack_require__(27);
var SPECIES = __webpack_require__(14)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var english = exports.english = {
  period: {
    hideCalendar: "Hide calendar",
    from: "From",
    to: "to",
    pleaseSelect: "Please select the",
    firstDay: "first day",
    lastDay: "last day",
    fromUndefinedTo: "From <not defined> to",
    months: undefined,
    weekdaysShort: undefined
  },
  status: {
    green: "Forecast is within tolerances",
    yellow: "Issues or risks have surfaced. If not properly dealt with, the stage or project's forecast can end up breaking the tolerances",
    red: "Forecasting broken tolerances. Exeption plan needed."
  },
  form: {
    cancel: "Close / Cancel",
    add: "Add",
    update: "Update",
    delete: "Delete",
    confirmDeleteMessage: "Do you want to delete this output?",
    cancelDelete: "Cancel",
    changesAreSaved: "Changes are saved!"
  },
  menu: {
    approve: "Approve",
    retractRequest: "Retract request",
    request: "Request",
    recommend: "Recommend",
    retract: "Retract",
    progress: "Progress",
    status: "Status",
    startProject: "Start project",
    pauseProject: "Pause project",
    stopProject: "Stop project",
    startProgramme: "Start programme",
    pauseProgramme: "Pause programme",
    stopProgramme: "Stop programme",
    actions: "Actions",
    editProperties: "Edit properties",
    openLog: "Open log",
    projectSettings: "Project Settings",
    cloneProject: "Clone project",
    prepareProjectClosure: "Prepare Project Closure"
  }
};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var norwegian = exports.norwegian = {
  period: {
    hideCalendar: "Skjul kalender",
    from: "Fra",
    to: "til",
    pleaseSelect: "Vennligst angi",
    firstDay: "første dag",
    lastDay: "siste dag",
    fromUndefinedTo: "Fra <udefinert> til",
    months: ["Januar", "Februar", "Mars", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Desember"],
    weekdaysShort: ["Sø", "Ma", "Ti", "On", "To", "Fr", "Lø"]
  },
  status: {
    green: "Prognoser er innenfor toleransegrensene",
    yellow: "Saker eller risiko har oppstått. Hvis det ikke blir håndtert vil etappen eller prosjektets prognose ende opp med å overskride toleransegrensene",
    red: "Prognosene overskrider toleransegrensene. En unntaksplan er nødvendig."
  },
  form: {
    cancel: "Lukk / Avbryt",
    add: "Legg til",
    update: "Oppdater",
    delete: "Slett",
    confirmDeleteMessage: "Vil du slette denne leveransen?",
    cancelDelete: "Avbryt",
    changesAreSaved: "Endringene er lagret!"
  },
  menu: {
    approve: "Godkjenn",
    retractRequest: "Trekk tilbake forespørsel",
    request: "Forespør",
    recommend: "Anbefal",
    retract: "Trekk tilbake",
    progress: "Fremdrift",
    status: "Status",
    startProject: "Start projekt",
    pauseProject: "Pause prosjekt",
    stopProject: "Stop projekt",
    startProgramme: "Start program",
    pauseProgramme: "Pause program",
    stopProgramme: "Stop program",
    actions: "Handlinger",
    editProperties: "Rediger egenskapene",
    openLog: "Åpne logg",
    projectSettings: "Prosjektinnstillinger",
    cloneProject: "Klone prosjektet",
    prepareProjectClosure: "Forbered prosjektavslutning"
  }
};

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'use strinct';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Area = function (_React$Component) {
  _inherits(Area, _React$Component);

  function Area() {
    _classCallCheck(this, Area);

    return _possibleConstructorReturn(this, (Area.__proto__ || Object.getPrototypeOf(Area)).apply(this, arguments));
  }

  _createClass(Area, [{
    key: 'render',
    value: function render() {
      return this.props.children !== undefined && this.props.children !== null ? _react2.default.createElement(
        'div',
        { className: 'area', style: { padding: 5, paddingBottom: 30, fontFamily: "Lato, Arial, Verdana, Geneva, sans-serif", textAlign: "left" } },
        _react2.default.createElement(
          'div',
          { style: { fontSize: "16pt", fontWeight: "bold", borderBottom: "solid 1px #e9e7e6", marginBottom: 15 } },
          this.props.title
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "flex", justifyContent: "space-between", backgroundColor: "#f7f7f7", flexWrap: "wrap", padding: 40 } },
          this.props.children
        )
      ) : null;
    }
  }]);

  return Area;
}(_react2.default.Component);

exports.default = Area;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(316);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 117 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 118 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(323),
    overRest = __webpack_require__(726),
    setToString = __webpack_require__(728);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var Immutable = __webpack_require__(4);

var OrderedMap = Immutable.OrderedMap;
var BlockMapBuilder = {
  createFromArray: function createFromArray(blocks) {
    return OrderedMap(blocks.map(function (block) {
      return [block.getKey(), block];
    }));
  }
};
module.exports = BlockMapBuilder;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


/**
 * Search through an array to find contiguous stretches of elements that
 * match a specified filter function.
 *
 * When ranges are found, execute a specified `found` function to supply
 * the values to the caller.
 */
function findRangesImmutable(haystack, areEqualFn, filterFn, foundFn) {
  if (!haystack.size) {
    return;
  }

  var cursor = 0;
  haystack.reduce(function (value, nextValue, nextIndex) {
    if (!areEqualFn(value, nextValue)) {
      if (filterFn(value)) {
        foundFn(cursor, nextIndex);
      }

      cursor = nextIndex;
    }

    return nextValue;
  });
  filterFn(haystack.last()) && foundFn(cursor, haystack.count());
}

module.exports = findRangesImmutable;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
function isHTMLElement(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }

  if (!node.ownerDocument.defaultView) {
    return node instanceof HTMLElement;
  }

  if (node instanceof node.ownerDocument.defaultView.HTMLElement) {
    return true;
  }

  return false;
}

module.exports = isHTMLElement;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(29);

var gkx = __webpack_require__(70);

var experimentalTreeDataSupport = gkx('draft_tree_data_support');
/**
 * For a collapsed selection state, remove text based on the specified strategy.
 * If the selection state is not collapsed, remove the entire selected range.
 */

function removeTextWithStrategy(editorState, strategy, direction) {
  var selection = editorState.getSelection();
  var content = editorState.getCurrentContent();
  var target = selection;
  var anchorKey = selection.getAnchorKey();
  var focusKey = selection.getFocusKey();
  var anchorBlock = content.getBlockForKey(anchorKey);

  if (experimentalTreeDataSupport) {
    if (direction === 'forward') {
      if (anchorKey !== focusKey) {
        // For now we ignore forward delete across blocks,
        // if there is demand for this we will implement it.
        return content;
      }
    }
  }

  if (selection.isCollapsed()) {
    if (direction === 'forward') {
      if (editorState.isSelectionAtEndOfContent()) {
        return content;
      }

      if (experimentalTreeDataSupport) {
        var isAtEndOfBlock = selection.getAnchorOffset() === content.getBlockForKey(anchorKey).getLength();

        if (isAtEndOfBlock) {
          var anchorBlockSibling = content.getBlockForKey(anchorBlock.nextSibling);

          if (!anchorBlockSibling || anchorBlockSibling.getLength() === 0) {
            // For now we ignore forward delete at the end of a block,
            // if there is demand for this we will implement it.
            return content;
          }
        }
      }
    } else if (editorState.isSelectionAtStartOfContent()) {
      return content;
    }

    target = strategy(editorState);

    if (target === selection) {
      return content;
    }
  }

  return DraftModifier.removeRange(content, target, direction);
}

module.exports = removeTextWithStrategy;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(125);
var EventPluginUtils = __webpack_require__(236);

var accumulateInto = __webpack_require__(380);
var forEachAccumulated = __webpack_require__(381);
var warning = __webpack_require__(18);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(12);

var EventPluginRegistry = __webpack_require__(235);
var EventPluginUtils = __webpack_require__(236);
var ReactErrorUtils = __webpack_require__(237);

var accumulateInto = __webpack_require__(380);
var forEachAccumulated = __webpack_require__(381);
var invariant = __webpack_require__(6);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(66);

var getEventTarget = __webpack_require__(238);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["clsx"] = clsx;
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ __webpack_exports__["default"] = (clsx);

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var english = exports.english = {
  general: {
    add: "Add Risk",
    title: "Risk",
    probability: "Probability",
    impact: "Impact",
    approach: "Approach",
    riskStatement: "Risk Statement",
    status: "Status",
    statement: {
      if: "If",
      cause: "cause",
      thereIsA: "there is a",
      riskTypeOptions: {
        Threat: "threat",
        Opportunity: "opportunity"
      },
      that: "that",
      event: "event",
      whichWouldResultIn: "which would result in",
      effect: "effect"
    }
  },
  views: {
    identify: {
      title: "Identify view",
      columns: {
        id: "Id",
        title: "Title",
        category: "Category",
        cause: "Cause"
      }
    },
    followUp: {
      title: "Follow up view",
      columns: {
        id: "Id",
        title: "Title",
        solution: "Action",
        ownerAndActionee: "Owner / Actionee"
      }
    },
    present: {
      title: "Presentation view",
      menu: {
        title: "Risk options",
        backToRiskRegister: "Back to Risk Register",
        allRiskItems: "Show all risks",
        allOpenRiskItems: "Show all open risks",
        editRiskItem: "Edit this risk",
        selectRiskItem: "Select a risk to present",
        viewFullScreen: "View full screen",
        viewPDF: "View PDF"
      }
    }
  },
  identify: {
    title: "Identify",
    fields: {
      title: {
        title: "Title",
        description: "Descriptive risk title",
        help: "Short summary of the risk"
      },
      owner: {
        title: "Risk Owner",
        description: "The person who will manage the risk",
        help: "Who should make sure this risk is assessed, planned and action is implemented?"
      },
      type: {
        title: "Type",
        help: "Threat is used to describe an uncertain event that could have a negative impact - Opportunity an event that could have a favourable impact",
        options: {
          Threat: "Threat",
          Opportunity: "Opportunity"
        }
      },
      category: {
        title: "Category",
        help: "Which performance aspect is likely to have the most significant impact if the risk materializes?",
        options: {
          Time: "Time",
          Cost: "Cost",
          Scope: "Scope",
          Quality: "Quality",
          Benefit: "Benefit",
          Risk: "Risk"
        }
      },
      cause: {
        title: "Cause",
        description: "Describe the source of the risk. This part of the risk statement is: if <cause>",
        help: "What will cause the event to occur? What is the event or situation that gives rise to the risk. Example: technical requirement documentation is not complete"
      },
      event: {
        title: "Event",
        description: "Identify the area of uncertainty. This part of the risk statement is: there is a threat/an opportunity that <event>",
        help: "What is the area of uncertainty? Example: the technical design work cannot start"
      },
      effect: {
        title: "Effect",
        description: "Explain the impact(s) on the objectives. This part of the risk statement is: which would result in <effect>",
        help: "If this risk materializes, how will it impact the objectives?  Example: the project will be significantly delayed"
      }
    }
  },
  assess: {
    title: "Assess",
    fields: {
      assessment: {
        categories: {
          inherent: {
            title: "Inherent (original)"
          },
          residual: {
            title: "Residual (remaining)"
          }
        },
        fields: {
          impact: {
            title: "Impact",
            help: "What is the level of impact on objectives?\n\n              Severe: Critical objective(s) will not be achieved\n              Significant: Stated objective(s) will fall below acceptable level\n              Moderate: Stated objective(s) will fall below goals but above minimum acceptable levels\n              Minor: Stated objective(s) will fall below goals but well above minimum acceptable levels\n              Negligible: No or little impact on achieving objectives",
            options: {
              1: "Negligible",
              2: "Minor",
              3: "Moderate",
              4: "Significant",
              5: "Severe"
            }
          },
          probability: {
            title: "Probability",
            help: "What is the probability of this risk materializing?\n\n              80-99% Very Likely\n              60-79% Likely\n              40-59% Possible\n              20-39% Unlikely\n              1-19% Very Unlikely",
            options: {
              1: "Very Unlikely",
              2: "Unlikely",
              3: "Possible",
              4: "Likely",
              5: "Very Likely"
            }
          }
        }
      },
      impact: {
        title: "Impact",
        help: "What is the level of impact on objectives?\n\n          Severe: Critical objective(s) will not be achieved\n          Significant: Stated objective(s) will fall below acceptable level\n          Moderate: Stated objective(s) will fall below goals but above minimum acceptable levels\n          Minor: Stated objective(s) will fall below goals but well above minimum acceptable levels\n          Negligible: No or little impact on achieving objectives",
        options: {
          1: "Negligible",
          2: "Minor",
          3: "Moderate",
          4: "Significant",
          5: "Severe"
        }
      },
      probability: {
        title: "Probability",
        help: "What is the probability of this risk materializing?\n\n          80-99% Very Likely\n          60-79% Likely\n          40-59% Possible\n          20-39% Unlikely\n          1-19% Very Unlikely",
        options: {
          1: "Very Unlikely",
          2: "Unlikely",
          3: "Possible",
          4: "Likely",
          5: "Very Likely"
        }
      },
      proximity: {
        title: "Proximity",
        help: "How close in time is the event that would trigger the risk: Imminent, days, weeks, months or a specific date?"
      }
    }
  },
  plan: {
    title: "Plan",
    fields: {
      response: {
        title: "Response category",
        help: "Whish response is proportional to the risk and offers value for money?\n          Avoid = make a change so that the threat can no longer happen or has no impact\n          Reduce = reduce probability by some form of control and/or reduce impact should it occur\n          Transfer = a third party taking responsibility for parts of the impact\n          Accept = decision is taken to retain the risk\n          Share = share gain or pain with partner\n          Exploit = ensure that the opportunity will happen\n          Enhance = enhance the probability of the event occurring, enhance the impact should it occur\n          Contingent Plans = have fallback plans to deal with impact should the risk occur",
        options: {
          Avoid: "Avoid (threat)",
          Reduce: "Reduce (threat)",
          Transfer: "Transfer (threat/opportunity)",
          Accept: "Accept (threat/opportunity)",
          Share: "Share (threath/opportunity)",
          Enhance: "Enhance (opportunity)",
          Exploit: "Exploit (opportunity)",
          ContingencyPlan: "Prepare contingent plans (threat/opportunity)"
        }
      },
      actionee: { title: "Risk actionee", help: "Who will implement the actions?" },
      action: { title: "Action", help: "What actions will be taken to resolve the risk?" }
    }
  },
  implement: {
    title: "Implement",
    fields: {
      status: {
        title: "Status",
        options: {
          Active: "Active",
          Closed: "Closed"
        }
      },
      comments: { title: "Comments", help: "Comments or current status" }
    }
  },
  riskRegister: {
    title: "Risk Register",
    description: "The risk register provides a record of identified risks, including their status and history. It is used to capture and maintain information on all the identified threaths and opportunities.",
    description2: "Add a new risk by selecting 'Add Risk' below. You can maintain a risk by selecting it in the table below. If the probability of a risk is so to speak 100%, you should convert it to an issue in the issue register (under Change)"
  },
  riskManagementApproach: {
    title: "Risk Management Approach",
    description: "The risk management approach describes how risk will be managed and what level of risk is acceptable. What will we do to make sure the level of uncertainty is managed?",
    fields: {
      process: {
        title: "Process and Procedures",
        help: "Will the project have any rules, routines or processes in place ensuring risks are identified, assessed and mitigated?\n          Are there any standard procedures to be followed? Any planned deviation from these procedures? If so, why?\n          How will we make sure the risk management procedure is followed?\n          Will the risk management process explicitly address information security risks related to classified information or data privacy? ",
        description: "Describe how risks will be: Identified, Assessed, Planned, Implemented"
      },
      tools: {
        title: "Tools and Techniques",
        help: "Any identification techniques to be used (review lessons, checklists, brainstorming, workshops, breakdown structures) ?\n          Any estimation techniques to be used (probability trees, expected value, risk models)?\n          Which tools will be used to manage risk?",
        description: "Describe tools and techniques to be used in risk management"
      },
      reporting: {
        title: "Reporting",
        help: "When will risk be reported? Where will risk be reported and who will receive the risk reports?",
        description: "The reports to be produced, their purpose, timing and recipients"
      },
      timing: {
        title: "Timing of activities",
        help: "When will risk management activities occur?\n          Any specific activities in Initiation or beginning/end of stages?",
        description: "Describe the timing of risk management activities"
      },
      roles: {
        title: "Roles and responsibilities",
        help: "Who makes sure risks are captured? Assessed? Planned? Implemented? Who approves a\n          response? Any policy on who owns which types of risks? Who communicates what?\n          Who calls and organizes risk management activities and reviews?",
        description: "Define the roles and responsibilities for the activities"
      },
      tolerance: {
        title: "Risk Tolerance",
        help: "What is attitude towards taking risk - is the risk appetite high or is it low?\n          What uncertainty level is OK? Are there areas where high uncertainty is accepted and others uncertainty needs to be low?\n          When should a risk be escalated?",
        description: "Define the risk appetite and when a risk should be escalated"
      },
      budget: {
        title: "Risk Budget",
        help: "Do we expect to set aside time, resources or money to deal with risks?\nIf not, where will the resources to deal with risk come from?",
        description: "Describe the risk budget, if any, and how it will be used"
      }
    }
  }
};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var norwegian = exports.norwegian = {
  general: {
    title: "Risiko",
    probability: "Sannsynlighet",
    impact: "Konsekvens",
    add: "Ny risiko",
    approach: "Tilnærming",
    riskStatement: "Risikosetning",
    status: "Status",
    statement: {
      if: "Siden det er",
      cause: "årsak",
      thereIsA: "så er det",
      riskTypeOptions: {
        Threat: "fare",
        Opportunity: "mulighet"
      },
      that: "for at",
      event: "hendelse",
      whichWouldResultIn: "noe som kan medføre at",
      effect: "effekt"
    }
  },
  views: {
    identify: {
      title: "Identifisere",
      columns: {
        id: "Id",
        title: "Tittel",
        category: "Kategori",
        cause: "Årsak"
      }
    },
    followUp: {
      title: "Følge opp",
      columns: {
        id: "Id",
        title: "Tittel",
        solution: "Tiltak",
        ownerAndActionee: "Eier / utfører"
      }
    },
    present: {
      title: "Presentasjon",
      menu: {
        title: "Risikovalg",
        backToRiskRegister: "Til risikoregister",
        allRiskItems: "Vis alle risiki",
        allOpenRiskItems: "Vis alle åpne riski",
        editRiskItem: "Rediger risiko",
        selectRiskItem: "Velg risiko",
        viewFullScreen: "Vis i fullskjerm",
        viewPDF: "Vis som PDF"
      }
    }
  },
  identify: {
    title: "Identifiser",
    fields: {
      title: {
        title: "Tittel",
        description: "Beskrivende risikotittel",
        help: "Kort oppsummering av risikoen"
      },
      owner: {
        title: "Risikoeier",
        description: "Personen som skal håndtere risikoen",
        help: "Hvem bør sørge for at denne risikoen vurderes, planlegges og tiltak gjennomføres?"
      },
      type: {
        title: "Type",
        help: "Trussel er brukt til å beskrive en usikker hendelse som kan ha en negativ innvirkning - Mulighet for en hendelse som kan ha en gunstig innvirkning",
        options: {
          Threat: "Trussel",
          Opportunity: "Mulighet"
        }
      },
      category: {
        title: "Kategori",
        help: "Hvilket ytelsesaspekt vil trolig ha størst betydning hvis risikoen materialiseres?",
        options: {
          Time: "Tid",
          Cost: "Kostnad",
          Scope: "Omfang",
          Quality: "Kvalitet",
          Benefit: "Gevinst",
          Risk: "Risiko"
        }
      },
      cause: {
        title: "Årsak",
        description: "Beskriv kilden til risikoen. Denne delen av risikosetningen er: siden det er <årsak>",
        help: "Hva vil føre til at hendelsen oppstår? Hva er hendelsen eller situasjonen som gir opphav til risikoen. Eksempel: Teknisk kravdokumentasjon er ikke fullført"
      },
      event: {
        title: "Hendelse",
        description: "Identifiser usikkerhetsområdet. Denne delen av risikosetningen er: så er det en fare / en mulighet for at <hendelse>",
        help: "Hva er usikkerhetsområdet? Eksempel: Det tekniske designarbeidet kan ikke starte"
      },
      effect: {
        title: "Effekt",
        description: "Forklar virkningen(e) på målene. Denne delen av risikosetningen er: som kan medføre at <effekt>",
        help: "Hvis denne risikoen materialiseres, hvordan vil den påvirke målene? Eksempel: Betydelig forsinkelse"
      }
    }
  },
  assess: {
    title: "Vurdere",
    fields: {
      assessment: {
        categories: {
          inherent: {
            title: "Opprinnelig"
          },
          residual: {
            title: "Gjenstående"
          }
        },
        fields: {
          impact: {
            title: "Konsekvens",
            help: "Hva er effektniv\xE5et p\xE5 m\xE5lene?\n\n              Alvorlig: Kritiske m\xE5l vil ikke bli oppn\xE5dd\n              Vesentlig: Oppgitte m\xE5l vil falle under akseptabelt niv\xE5\n              Moderat: Oppgitte m\xE5l vil falle under m\xE5lsetningen, men over minimum akseptable niv\xE5er\n              Mindre: Oppgitte m\xE5l vil falle under m\xE5lsetningen, men godt over minimum akseptable niv\xE5er\n              Ubetydelig: Ingen eller liten innvirkning p\xE5 \xE5 oppn\xE5 m\xE5l",
            options: {
              1: "Ubetydelig",
              2: "Mindre",
              3: "Moderat",
              4: "Signifikant",
              5: "Alvorlig"
            }
          },
          probability: {
            title: "Sannsynlighet",
            help: "Hva er sannsynligheten for denne risikoen?\n\n              80-99% Sv\xE6rt sannsynlig\n              60-79% Sannsynlig\n              40-59% mulig\n              20-39% usannsynlig\n              1-19% Sv\xE6rt usannsynlig",
            options: {
              1: "Veldig usannsynlig",
              2: "Usannsynlig",
              3: "Mulig",
              4: "Sannsynlig",
              5: "Veldig sannsynlig"
            }
          }
        }
      },
      impact: {
        title: "Konsekvens",
        help: "Hva er effektniv\xE5et p\xE5 m\xE5lene?\n\n\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 Alvorlig: Kritiske m\xE5l vil ikke bli oppn\xE5dd\n\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 Vesentlig: Oppgitte m\xE5l vil falle under akseptabelt niv\xE5\n\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 Moderat: Oppgitte m\xE5l vil falle under m\xE5lsetningen, men over minimum akseptable niv\xE5er\n\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 Mindre: Oppgitte m\xE5l vil falle under m\xE5lsetningen, men godt over minimum akseptable niv\xE5er\n\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 Ubetydelig: Ingen eller liten innvirkning p\xE5 \xE5 oppn\xE5 m\xE5l",
        options: {
          1: "Ubetydelig",
          2: "Mindre",
          3: "Moderat",
          4: "Signifikant",
          5: "Alvorlig"
        }
      },
      probability: {
        title: "Sannsynlighet",
        help: "Hva er sannsynligheten for denne risikoen?\n\n          80-99% Sv\xE6rt sannsynlig\n          60-79% Sannsynlig\n          40-59% mulig\n          20-39% usannsynlig\n          1-19% Sv\xE6rt usannsynlig",
        options: {
          1: "Veldig usannsynlig",
          2: "Usannsynlig",
          3: "Mulig",
          4: "Sannsynlig",
          5: "Veldig sannsynlig"
        }
      },
      proximity: {
        title: "Nærhet",
        help: "Hvor nært er det at hendelsen utløse risikoen: Umiddelbart, dager, uker, måneder eller en bestemt dato?"
      }
    }
  },
  plan: {
    title: "Planlegge",
    fields: {
      response: {
        title: "Tiltakstype",
        help: "Hvilken respons er proporsjonal med risikoen og gir valuta for pengene?\n          Unng\xE5 = gj\xF8r en endring slik at trusselen ikke lenger kan skje eller har ingen innvirkning\n          Redusere = redusere sannsynligheten med en eller annen form for kontroll og/eller reduser effekten hvis den oppst\xE5r\n          Overf\xF8re = En tredjepart tar ansvar for deler av den \xF8konomiske effekten\n          Akseptere = Beslutning er truffet for \xE5 beholde risikoen\n          Dele = del gevinst eller smerte med partner\n          Utnytte = s\xF8rg for at muligheten vil skje\n          Forbedre = \xF8ke sannsynligheten for at hendelsen oppst\xE5r, \xF8ke virkningen hvis den skulle oppst\xE5\n          Beredskapsplan = har reserveplaner for \xE5 h\xE5ndtere p\xE5virkning dersom risikoen oppst\xE5r",
        options: {
          Avoid: "Unngå (trussel)",
          Reduce: "Redusere (trussel)",
          Transfer: "Overføre (trussel/mulighet)",
          Accept: "Akseptere (trussel/mulighet)",
          Share: "Dele (trussel/mulighet)",
          Exploit: "Utnytte (mulighet)",
          Enhance: "Forbedre (mulighet)",
          ContingencyPlan: "Beredskapsplan (trussel/mulighet)"
        }
      },
      actionee: { title: "Utførende", help: "Hvem vil gjennomføre handlingene?" },
      action: { title: "Tiltak", help: "Hvilke tiltak vil bli tatt for å løse risikoen?" }
    }
  },
  implement: {
    title: "Iverksette",
    fields: {
      status: {
        title: "Status",
        options: {
          Active: "Aktiv",
          Closed: "Lukket"
        }
      },
      comments: { title: "Kommentarer", help: "Kommentarer eller gjeldene status" }
    }
  },
  riskRegister: {
    title: "Risikoregister",
    description: "Risikoregisteret gir en oversikt over identifiserte risiki, inkludert deres status og historie. Risikoregisteret brukes til å dokumentere og vedlikeholde informaiton om all identifisert usikkerhet, både trussler og muligheter",
    description2: "Legg til en ny risiko ved å velge 'Ny risiko' under. Du kan vedlikeholde en risiko ved å velge den i tabellen under. Hvis sannsynligheten for en risiko blir så og si 100%, bør du konvertere den til en sak i saksregisteret (under Endring)"
  },
  riskManagementApproach: {
    title: "Tilnærming til risikoledelse",
    description: "Tilnærming til risikoledelse beskriver hvordan risiko skal håndteres og hvor mye risiko man ønsker å ha.",
    fields: {
      process: {
        title: "Prosess og prosedyrer",
        help: "Vil prosjektet ha regler, rutiner eller prosesser p\xE5 plass som sikrer at risiko identifiseres, vurderes og h\xE5ndteres?\n          Finnes det standard prosedyrer som skal f\xF8lges for \xE5 sikre at risiko blir identifisert, vurdert, planlagt og tiltak ivertsatt? Hvordan er det med planlagte avvik fra disse prosedyrene? Hvis ja, hvorfor?\n          Hvordan skal vi s\xF8rge for at prosessen for risikostyring blir fulgt opp?\n          Vil prosedyren for risikoledelse eksplisitt adressere informasjonssikkerhetsrisiko knyttet til klassifisert informasjon eller datasikkerhet?",
        description: "Beskriv hvordan risiko vil bli: identifisert, vurdert, planlagt og iverksatt"
      },
      tools: {
        title: "Verktøy og teknikker",
        help: "Hvilke identifikasjonsteknikker skal benyttes (gjennomgangsleksjoner, sjekklister, id\xE9myldring, arbeidsm\xF8te, workshops, oppdelingsstrukturer)?\n          Eventuelle estimeringsteknikker som skal brukes (sannsynlighetstr\xE6r, forventet verdi, risikomodeller)?\n          Hvilke verkt\xF8y vil bli brukt til \xE5 h\xE5ndtere risiko?",
        description: "Beskriv verktøy og teknikker som skal brukes i risikostyring av dette prosjektet"
      },
      reporting: {
        title: "Rapportering",
        help: "N\xE5r vil risiko bli rapportert? Hvor vil risikoen bli rapportert og hvem vil motta risikorapportene",
        description: "Beskriv hvilke rapporter som skal produseres, deres formål, timing og mottakere"
      },
      timing: {
        title: "Tidsagivelse av aktiviteter",
        help: "N\xE5r vil risikostyringsaktiviteter utf\xF8res?\n          Skal det utf\xF8res spesifikke aktiviteter i Initieringsetappen eller i begynnelsen / slutten av etapper?",
        description: "Beskriv når risikostyringsaktiviteter vil bli utført"
      },
      roles: {
        title: "Roller og ansvar",
        help: "Hvem s\xF8rger for at risikoen blir notert (identifisert), vurdert, planlagt og implementert? Hvem godkjenner en tilbakemelding? F\xF8lges det en rutine for \xE5 angi hvem som eier og kommuniserer en risiko? Hvem kommuniserer hva?\n          Hvem ringer og organiserer risikostyringsaktiviteter og vurderinger?",
        description: "Definer roles og ansvar for risikoaktivitetene"
      },
      tolerance: {
        title: "Toleranse for risiko",
        help: "Hva er holdningen til \xE5 ta risiko - er risikoappetitten h\xF8y eller er den lav?\n          Hvilket usikkerhetsniv\xE5 er OK? Er det omr\xE5der hvor stor usikkerhet er akseptert og annen usikkerhet m\xE5 v\xE6re lav?\n          N\xE5r skal en risiko bli eskalert?",
        description: "Definer risikoappetiten og når en risiko skal eskaleres"
      },
      budget: {
        title: "Risikobudsjett",
        help: "Forventer vi \xE5 avsette tid, ressurser eller penger til \xE5 takle risiko?\n          Hvis ikke, hvor vil ressursene for \xE5 h\xE5ndtere risiko komme fra?",
        description: "Beskriv  risikobusjettet, hvis det finnes, og hvordan det skal brukes."
      }
    }
  }
};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(40);
var toLength = __webpack_require__(16);
var toAbsoluteIndex = __webpack_require__(77);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 132 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(49);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(50);
var defined = __webpack_require__(54);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(10);
var cof = __webpack_require__(49);
var MATCH = __webpack_require__(14)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(14)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(97);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(284);
var redefine = __webpack_require__(34);
var hide = __webpack_require__(33);
var fails = __webpack_require__(7);
var defined = __webpack_require__(54);
var wks = __webpack_require__(14);
var regexpExec = __webpack_require__(200);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(34);
var redefineAll = __webpack_require__(83);
var meta = __webpack_require__(68);
var forOf = __webpack_require__(82);
var anInstance = __webpack_require__(81);
var isObject = __webpack_require__(10);
var fails = __webpack_require__(7);
var $iterDetect = __webpack_require__(136);
var setToStringTag = __webpack_require__(96);
var inheritIfRequired = __webpack_require__(186);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var hide = __webpack_require__(33);
var uid = __webpack_require__(75);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(67) || !__webpack_require__(7)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(5)[K];
});


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(27);
var ctx = __webpack_require__(48);
var forOf = __webpack_require__(82);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(303);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Proxy object to map classnames when css modules are not used

exports.default = {
  container: 'DayPicker',
  wrapper: 'DayPicker-wrapper',
  interactionDisabled: 'DayPicker--interactionDisabled',
  month: 'DayPicker-Month',

  navBar: 'DayPicker-NavBar',
  navButtonPrev: 'DayPicker-NavButton DayPicker-NavButton--prev',
  navButtonNext: 'DayPicker-NavButton DayPicker-NavButton--next',
  navButtonInteractionDisabled: 'DayPicker-NavButton--interactionDisabled',

  caption: 'DayPicker-Caption',
  weekdays: 'DayPicker-Weekdays',
  weekdaysRow: 'DayPicker-WeekdaysRow',
  weekday: 'DayPicker-Weekday',
  body: 'DayPicker-Body',
  week: 'DayPicker-Week',
  weekNumber: 'DayPicker-WeekNumber',
  day: 'DayPicker-Day',
  footer: 'DayPicker-Footer',
  todayButton: 'DayPicker-TodayButton',

  // default modifiers
  today: 'today',
  selected: 'selected',
  disabled: 'disabled',
  outside: 'outside'
};
//# sourceMappingURL=classNames.js.map

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.cancelEvent = cancelEvent;
exports.getFirstDayOfMonth = getFirstDayOfMonth;
exports.getDaysInMonth = getDaysInMonth;
exports.getModifiersFromProps = getModifiersFromProps;
exports.getFirstDayOfWeekFromProps = getFirstDayOfWeekFromProps;
exports.isRangeOfDates = isRangeOfDates;
exports.getMonthsDiff = getMonthsDiff;
exports.getWeekArray = getWeekArray;
exports.startOfMonth = startOfMonth;
exports.getDayNodes = getDayNodes;
exports.nodeListToArray = nodeListToArray;
exports.hasOwnProp = hasOwnProp;

var _DateUtils = __webpack_require__(101);

var _LocaleUtils = __webpack_require__(209);

var _classNames = __webpack_require__(146);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cancelEvent(e) {
  e.preventDefault();
  e.stopPropagation();
}

function getFirstDayOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1, 12);
}

function getDaysInMonth(d) {
  var resultDate = getFirstDayOfMonth(d);

  resultDate.setMonth(resultDate.getMonth() + 1);
  resultDate.setDate(resultDate.getDate() - 1);

  return resultDate.getDate();
}

function getModifiersFromProps(props) {
  var modifiers = _extends({}, props.modifiers);
  if (props.selectedDays) {
    modifiers[props.classNames.selected] = props.selectedDays;
  }
  if (props.disabledDays) {
    modifiers[props.classNames.disabled] = props.disabledDays;
  }
  return modifiers;
}

function getFirstDayOfWeekFromProps(props) {
  var firstDayOfWeek = props.firstDayOfWeek,
      _props$locale = props.locale,
      locale = _props$locale === undefined ? 'en' : _props$locale,
      _props$localeUtils = props.localeUtils,
      localeUtils = _props$localeUtils === undefined ? {} : _props$localeUtils;

  if (!isNaN(firstDayOfWeek)) {
    return firstDayOfWeek;
  }
  if (localeUtils.getFirstDayOfWeek) {
    return localeUtils.getFirstDayOfWeek(locale);
  }
  return 0;
}

function isRangeOfDates(value) {
  return !!(value && value.from && value.to);
}

function getMonthsDiff(d1, d2) {
  return d2.getMonth() - d1.getMonth() + 12 * (d2.getFullYear() - d1.getFullYear());
}

function getWeekArray(d) {
  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _LocaleUtils.getFirstDayOfWeek)();
  var fixedWeeks = arguments[2];

  var daysInMonth = getDaysInMonth(d);
  var dayArray = [];

  var week = [];
  var weekArray = [];

  for (var i = 1; i <= daysInMonth; i += 1) {
    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i, 12));
  }

  dayArray.forEach(function (day) {
    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
      weekArray.push(week);
      week = [];
    }
    week.push(day);
    if (dayArray.indexOf(day) === dayArray.length - 1) {
      weekArray.push(week);
    }
  });

  // unshift days to start the first week
  var firstWeek = weekArray[0];
  for (var _i = 7 - firstWeek.length; _i > 0; _i -= 1) {
    var outsideDate = (0, _DateUtils.clone)(firstWeek[0]);
    outsideDate.setDate(firstWeek[0].getDate() - 1);
    firstWeek.unshift(outsideDate);
  }

  // push days until the end of the last week
  var lastWeek = weekArray[weekArray.length - 1];
  for (var _i2 = lastWeek.length; _i2 < 7; _i2 += 1) {
    var _outsideDate = (0, _DateUtils.clone)(lastWeek[lastWeek.length - 1]);
    _outsideDate.setDate(lastWeek[lastWeek.length - 1].getDate() + 1);
    lastWeek.push(_outsideDate);
  }

  // add extra weeks to reach 6 weeks
  if (fixedWeeks && weekArray.length < 6) {
    var lastExtraWeek = void 0;

    for (var _i3 = weekArray.length; _i3 < 6; _i3 += 1) {
      lastExtraWeek = weekArray[weekArray.length - 1];
      var lastDay = lastExtraWeek[lastExtraWeek.length - 1];
      var extraWeek = [];

      for (var j = 0; j < 7; j += 1) {
        var _outsideDate2 = (0, _DateUtils.clone)(lastDay);
        _outsideDate2.setDate(lastDay.getDate() + j + 1);
        extraWeek.push(_outsideDate2);
      }

      weekArray.push(extraWeek);
    }
  }

  return weekArray;
}

function startOfMonth(d) {
  var newDate = (0, _DateUtils.clone)(d);
  newDate.setDate(1);
  newDate.setHours(12, 0, 0, 0); // always set noon to avoid time zone issues
  return newDate;
}

function getDayNodes(node, classNames) {
  var outsideClassName = void 0;
  if (classNames === _classNames2.default) {
    // When using CSS modules prefix the modifier as required by the BEM syntax
    outsideClassName = classNames.day + '--' + classNames.outside;
  } else {
    outsideClassName = '' + classNames.outside;
  }
  var dayQuery = classNames.day.replace(/ /g, '.');
  var outsideDayQuery = outsideClassName.replace(/ /g, '.');
  var selector = '.' + dayQuery + ':not(.' + outsideDayQuery + ')';
  return node.querySelectorAll(selector);
}

function nodeListToArray(nodeList) {
  return Array.prototype.slice.call(nodeList, 0);
}

function hasOwnProp(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
//# sourceMappingURL=Helpers.js.map

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(211),
    getRawTag = __webpack_require__(687),
    objectToString = __webpack_require__(688);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.END_DRAG = exports.DROP = exports.HOVER = exports.PUBLISH_DRAG_SOURCE = exports.BEGIN_DRAG = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.beginDrag = beginDrag;
exports.publishDragSource = publishDragSource;
exports.hover = hover;
exports.drop = drop;
exports.endDrag = endDrag;

var _invariant = __webpack_require__(37);

var _invariant2 = _interopRequireDefault(_invariant);

var _isArray = __webpack_require__(87);

var _isArray2 = _interopRequireDefault(_isArray);

var _isObject = __webpack_require__(118);

var _isObject2 = _interopRequireDefault(_isObject);

var _matchesType = __webpack_require__(318);

var _matchesType2 = _interopRequireDefault(_matchesType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BEGIN_DRAG = exports.BEGIN_DRAG = 'dnd-core/BEGIN_DRAG';
var PUBLISH_DRAG_SOURCE = exports.PUBLISH_DRAG_SOURCE = 'dnd-core/PUBLISH_DRAG_SOURCE';
var HOVER = exports.HOVER = 'dnd-core/HOVER';
var DROP = exports.DROP = 'dnd-core/DROP';
var END_DRAG = exports.END_DRAG = 'dnd-core/END_DRAG';

function beginDrag(sourceIds) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { publishSource: true, clientOffset: null };
	var publishSource = options.publishSource,
	    clientOffset = options.clientOffset,
	    getSourceClientOffset = options.getSourceClientOffset;

	(0, _invariant2.default)((0, _isArray2.default)(sourceIds), 'Expected sourceIds to be an array.');

	var monitor = this.getMonitor();
	var registry = this.getRegistry();
	(0, _invariant2.default)(!monitor.isDragging(), 'Cannot call beginDrag while dragging.');

	for (var i = 0; i < sourceIds.length; i++) {
		(0, _invariant2.default)(registry.getSource(sourceIds[i]), 'Expected sourceIds to be registered.');
	}

	var sourceId = null;
	for (var _i = sourceIds.length - 1; _i >= 0; _i--) {
		if (monitor.canDragSource(sourceIds[_i])) {
			sourceId = sourceIds[_i];
			break;
		}
	}
	if (sourceId === null) {
		return;
	}

	var sourceClientOffset = null;
	if (clientOffset) {
		(0, _invariant2.default)(typeof getSourceClientOffset === 'function', 'When clientOffset is provided, getSourceClientOffset must be a function.');
		sourceClientOffset = getSourceClientOffset(sourceId);
	}

	var source = registry.getSource(sourceId);
	var item = source.beginDrag(monitor, sourceId);
	(0, _invariant2.default)((0, _isObject2.default)(item), 'Item must be an object.');

	registry.pinSource(sourceId);

	var itemType = registry.getSourceType(sourceId);
	return {
		type: BEGIN_DRAG,
		itemType: itemType,
		item: item,
		sourceId: sourceId,
		clientOffset: clientOffset,
		sourceClientOffset: sourceClientOffset,
		isSourcePublic: publishSource
	};
}

function publishDragSource() {
	var monitor = this.getMonitor();
	if (!monitor.isDragging()) {
		return;
	}

	return { type: PUBLISH_DRAG_SOURCE };
}

function hover(targetIdsArg) {
	var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	    _ref$clientOffset = _ref.clientOffset,
	    clientOffset = _ref$clientOffset === undefined ? null : _ref$clientOffset;

	(0, _invariant2.default)((0, _isArray2.default)(targetIdsArg), 'Expected targetIds to be an array.');
	var targetIds = targetIdsArg.slice(0);

	var monitor = this.getMonitor();
	var registry = this.getRegistry();
	(0, _invariant2.default)(monitor.isDragging(), 'Cannot call hover while not dragging.');
	(0, _invariant2.default)(!monitor.didDrop(), 'Cannot call hover after drop.');

	// First check invariants.
	for (var i = 0; i < targetIds.length; i++) {
		var targetId = targetIds[i];
		(0, _invariant2.default)(targetIds.lastIndexOf(targetId) === i, 'Expected targetIds to be unique in the passed array.');

		var target = registry.getTarget(targetId);
		(0, _invariant2.default)(target, 'Expected targetIds to be registered.');
	}

	var draggedItemType = monitor.getItemType();

	// Remove those targetIds that don't match the targetType.  This
	// fixes shallow isOver which would only be non-shallow because of
	// non-matching targets.
	for (var _i2 = targetIds.length - 1; _i2 >= 0; _i2--) {
		var _targetId = targetIds[_i2];
		var targetType = registry.getTargetType(_targetId);
		if (!(0, _matchesType2.default)(targetType, draggedItemType)) {
			targetIds.splice(_i2, 1);
		}
	}

	// Finally call hover on all matching targets.
	for (var _i3 = 0; _i3 < targetIds.length; _i3++) {
		var _targetId2 = targetIds[_i3];
		var _target = registry.getTarget(_targetId2);
		_target.hover(monitor, _targetId2);
	}

	return {
		type: HOVER,
		targetIds: targetIds,
		clientOffset: clientOffset
	};
}

function drop() {
	var _this = this;

	var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	var monitor = this.getMonitor();
	var registry = this.getRegistry();
	(0, _invariant2.default)(monitor.isDragging(), 'Cannot call drop while not dragging.');
	(0, _invariant2.default)(!monitor.didDrop(), 'Cannot call drop twice during one drag operation.');

	var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);

	targetIds.reverse();
	targetIds.forEach(function (targetId, index) {
		var target = registry.getTarget(targetId);

		var dropResult = target.drop(monitor, targetId);
		(0, _invariant2.default)(typeof dropResult === 'undefined' || (0, _isObject2.default)(dropResult), 'Drop result must either be an object or undefined.');
		if (typeof dropResult === 'undefined') {
			dropResult = index === 0 ? {} : monitor.getDropResult();
		}

		_this.store.dispatch({
			type: DROP,
			dropResult: _extends({}, options, dropResult)
		});
	});
}

function endDrag() {
	var monitor = this.getMonitor();
	var registry = this.getRegistry();
	(0, _invariant2.default)(monitor.isDragging(), 'Cannot call endDrag while not dragging.');

	var sourceId = monitor.getSourceId();
	var source = registry.getSource(sourceId, true);
	source.endDrag(monitor, sourceId);

	registry.unpinSource();

	return { type: END_DRAG };
}

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(151);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(699),
    getValue = __webpack_require__(703);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(213);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(716);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(219),
    isObjectLike = __webpack_require__(117);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.addSource = addSource;
exports.addTarget = addTarget;
exports.removeSource = removeSource;
exports.removeTarget = removeTarget;
var ADD_SOURCE = exports.ADD_SOURCE = 'dnd-core/ADD_SOURCE';
var ADD_TARGET = exports.ADD_TARGET = 'dnd-core/ADD_TARGET';
var REMOVE_SOURCE = exports.REMOVE_SOURCE = 'dnd-core/REMOVE_SOURCE';
var REMOVE_TARGET = exports.REMOVE_TARGET = 'dnd-core/REMOVE_TARGET';

function addSource(sourceId) {
	return {
		type: ADD_SOURCE,
		sourceId: sourceId
	};
}

function addTarget(targetId) {
	return {
		type: ADD_TARGET,
		targetId: targetId
	};
}

function removeSource(sourceId) {
	return {
		type: REMOVE_SOURCE,
		sourceId: sourceId
	};
}

function removeTarget(targetId) {
	return {
		type: REMOVE_TARGET,
		targetId: targetId
	};
}

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = checkDecoratorArguments;
function checkDecoratorArguments(functionName, signature) {
	if (false) {
		for (var i = 0; i < (arguments.length <= 2 ? 0 : arguments.length - 2); i += 1) {
			var arg = arguments.length <= i + 2 ? undefined : arguments[i + 2];
			if (arg && arg.prototype && arg.prototype.render) {
				// eslint-disable-next-line no-console
				console.error('You seem to be applying the arguments in the wrong order. ' + ('It should be ' + functionName + '(' + signature + ')(Component), not the other way around. ') + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#you-seem-to-be-applying-the-arguments-in-the-wrong-order');
				return;
			}
		}
	}
}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var randomizeBlockMapKeys = __webpack_require__(341);

var removeEntitiesAtEdges = __webpack_require__(342);

var getContentStateFragment = function getContentStateFragment(contentState, selectionState) {
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset(); // Edge entities should be stripped to ensure that we don't preserve
  // invalid partial entities when the fragment is reused. We do, however,
  // preserve entities that are entirely within the selection range.

  var contentWithoutEdgeEntities = removeEntitiesAtEdges(contentState, selectionState);
  var blockMap = contentWithoutEdgeEntities.getBlockMap();
  var blockKeys = blockMap.keySeq();
  var startIndex = blockKeys.indexOf(startKey);
  var endIndex = blockKeys.indexOf(endKey) + 1;
  return randomizeBlockMapKeys(blockMap.slice(startIndex, endIndex).map(function (block, blockKey) {
    var text = block.getText();
    var chars = block.getCharacterList();

    if (startKey === endKey) {
      return block.merge({
        text: text.slice(startOffset, endOffset),
        characterList: chars.slice(startOffset, endOffset)
      });
    }

    if (blockKey === startKey) {
      return block.merge({
        text: text.slice(startOffset),
        characterList: chars.slice(startOffset)
      });
    }

    if (blockKey === endKey) {
      return block.merge({
        text: text.slice(0, endOffset),
        characterList: chars.slice(0, endOffset)
      });
    }

    return block;
  }));
};

module.exports = getContentStateFragment;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
var DraftEntityInstance = __webpack_require__(347);

var Immutable = __webpack_require__(4);

var invariant = __webpack_require__(9);

var uuid = __webpack_require__(815);

var Map = Immutable.Map;
var instances = Map();
var instanceKey = uuid();
/**
 * Temporary utility for generating the warnings
 */

function logWarning(oldMethodCall, newMethodCall) {
  console.warn('WARNING: ' + oldMethodCall + ' will be deprecated soon!\nPlease use "' + newMethodCall + '" instead.');
}

/**
 * A "document entity" is an object containing metadata associated with a
 * piece of text in a ContentBlock.
 *
 * For example, a `link` entity might include a `uri` property. When a
 * ContentBlock is rendered in the browser, text that refers to that link
 * entity may be rendered as an anchor, with the `uri` as the href value.
 *
 * In a ContentBlock, every position in the text may correspond to zero
 * or one entities. This correspondence is tracked using a key string,
 * generated via DraftEntity.create() and used to obtain entity metadata
 * via DraftEntity.get().
 */
var DraftEntity = {
  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getLastCreatedEntityKey' instead.
   * ---
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
  getLastCreatedEntityKey: function getLastCreatedEntityKey() {
    logWarning('DraftEntity.getLastCreatedEntityKey', 'contentState.getLastCreatedEntityKey');
    return DraftEntity.__getLastCreatedEntityKey();
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.createEntity' instead.
   * ---
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
  create: function create(type, mutability, data) {
    logWarning('DraftEntity.create', 'contentState.createEntity');
    return DraftEntity.__create(type, mutability, data);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.addEntity' instead.
   * ---
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
  add: function add(instance) {
    logWarning('DraftEntity.add', 'contentState.addEntity');
    return DraftEntity.__add(instance);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getEntity' instead.
   * ---
   * Retrieve the entity corresponding to the supplied key string.
   */
  get: function get(key) {
    logWarning('DraftEntity.get', 'contentState.getEntity');
    return DraftEntity.__get(key);
  },

  /**
   * Get all the entities in the content state.
   */
  __getAll: function __getAll() {
    return instances;
  },

  /**
   * Load the entity map with the given set of entities.
   */
  __loadWithEntities: function __loadWithEntities(entities) {
    instances = entities;
    instanceKey = uuid();
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.mergeEntityData' instead.
   * ---
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
  mergeData: function mergeData(key, toMerge) {
    logWarning('DraftEntity.mergeData', 'contentState.mergeEntityData');
    return DraftEntity.__mergeData(key, toMerge);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.replaceEntityData' instead.
   * ---
   * Completely replace the data for a given instance.
   */
  replaceData: function replaceData(key, newData) {
    logWarning('DraftEntity.replaceData', 'contentState.replaceEntityData');
    return DraftEntity.__replaceData(key, newData);
  },
  // ***********************************WARNING******************************
  // --- the above public API will be deprecated in the next version of Draft!
  // The methods below this line are private - don't call them directly.

  /**
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
  __getLastCreatedEntityKey: function __getLastCreatedEntityKey() {
    return instanceKey;
  },

  /**
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
  __create: function __create(type, mutability, data) {
    return DraftEntity.__add(new DraftEntityInstance({
      type: type,
      mutability: mutability,
      data: data || {}
    }));
  },

  /**
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
  __add: function __add(instance) {
    instanceKey = uuid();
    instances = instances.set(instanceKey, instance);
    return instanceKey;
  },

  /**
   * Retrieve the entity corresponding to the supplied key string.
   */
  __get: function __get(key) {
    var instance = instances.get(key);
    !!!instance ?  false ? invariant(false, 'Unknown DraftEntity key: %s.', key) : invariant(false) : void 0;
    return instance;
  },

  /**
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
  __mergeData: function __mergeData(key, toMerge) {
    var instance = DraftEntity.__get(key);

    var newData = _objectSpread({}, instance.getData(), toMerge);

    var newInstance = instance.set('data', newData);
    instances = instances.set(key, newInstance);
    return newInstance;
  },

  /**
   * Completely replace the data for a given instance.
   */
  __replaceData: function __replaceData(key, newData) {
    var instance = DraftEntity.__get(key);

    var newInstance = instance.set('data', newData);
    instances = instances.set(key, newInstance);
    return newInstance;
  }
};
module.exports = DraftEntity;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Immutable = __webpack_require__(4);

var Record = Immutable.Record;
var defaultRecord = {
  anchorKey: '',
  anchorOffset: 0,
  focusKey: '',
  focusOffset: 0,
  isBackward: false,
  hasFocus: false
};
/* $FlowFixMe[unclear-type] This comment suppresses an error found when
 * automatically adding a type annotation with the codemod Komodo/Annotate_
 * exports. To see the error delete this comment and run Flow. */

var SelectionStateRecord = Record(defaultRecord);

var SelectionState = /*#__PURE__*/function (_SelectionStateRecord) {
  _inheritsLoose(SelectionState, _SelectionStateRecord);

  function SelectionState() {
    return _SelectionStateRecord.apply(this, arguments) || this;
  }

  var _proto = SelectionState.prototype;

  _proto.serialize = function serialize() {
    return 'Anchor: ' + this.getAnchorKey() + ':' + this.getAnchorOffset() + ', ' + 'Focus: ' + this.getFocusKey() + ':' + this.getFocusOffset() + ', ' + 'Is Backward: ' + String(this.getIsBackward()) + ', ' + 'Has Focus: ' + String(this.getHasFocus());
  };

  _proto.getAnchorKey = function getAnchorKey() {
    return this.get('anchorKey');
  };

  _proto.getAnchorOffset = function getAnchorOffset() {
    return this.get('anchorOffset');
  };

  _proto.getFocusKey = function getFocusKey() {
    return this.get('focusKey');
  };

  _proto.getFocusOffset = function getFocusOffset() {
    return this.get('focusOffset');
  };

  _proto.getIsBackward = function getIsBackward() {
    return this.get('isBackward');
  };

  _proto.getHasFocus = function getHasFocus() {
    return this.get('hasFocus');
  }
  /**
   * Return whether the specified range overlaps with an edge of the
   * SelectionState.
   */
  ;

  _proto.hasEdgeWithin = function hasEdgeWithin(blockKey, start, end) {
    var anchorKey = this.getAnchorKey();
    var focusKey = this.getFocusKey();

    if (anchorKey === focusKey && anchorKey === blockKey) {
      var selectionStart = this.getStartOffset();
      var selectionEnd = this.getEndOffset();
      return start <= selectionStart && selectionStart <= end || // selectionStart is between start and end, or
      start <= selectionEnd && selectionEnd <= end // selectionEnd is between start and end
      ;
    }

    if (blockKey !== anchorKey && blockKey !== focusKey) {
      return false;
    }

    var offsetToCheck = blockKey === anchorKey ? this.getAnchorOffset() : this.getFocusOffset();
    return start <= offsetToCheck && end >= offsetToCheck;
  };

  _proto.isCollapsed = function isCollapsed() {
    return this.getAnchorKey() === this.getFocusKey() && this.getAnchorOffset() === this.getFocusOffset();
  };

  _proto.getStartKey = function getStartKey() {
    return this.getIsBackward() ? this.getFocusKey() : this.getAnchorKey();
  };

  _proto.getStartOffset = function getStartOffset() {
    return this.getIsBackward() ? this.getFocusOffset() : this.getAnchorOffset();
  };

  _proto.getEndKey = function getEndKey() {
    return this.getIsBackward() ? this.getAnchorKey() : this.getFocusKey();
  };

  _proto.getEndOffset = function getEndOffset() {
    return this.getIsBackward() ? this.getAnchorOffset() : this.getFocusOffset();
  };

  SelectionState.createEmpty = function createEmpty(key) {
    return new SelectionState({
      anchorKey: key,
      anchorOffset: 0,
      focusKey: key,
      focusOffset: 0,
      isBackward: false,
      hasFocus: false
    });
  };

  return SelectionState;
}(SelectionStateRecord);

module.exports = SelectionState;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/**
 * Constants to represent text directionality
 *
 * Also defines a *global* direciton, to be used in bidi algorithms as a
 * default fallback direciton, when no better direction is found or provided.
 *
 * NOTE: Use `setGlobalDir()`, or update `initGlobalDir()`, to set the initial
 *       global direction value based on the application.
 *
 * Part of the implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */


var invariant = __webpack_require__(9);

var NEUTRAL = 'NEUTRAL'; // No strong direction

var LTR = 'LTR'; // Left-to-Right direction

var RTL = 'RTL'; // Right-to-Left direction

var globalDir = null; // == Helpers ==

/**
 * Check if a directionality value is a Strong one
 */

function isStrong(dir) {
  return dir === LTR || dir === RTL;
}
/**
 * Get string value to be used for `dir` HTML attribute or `direction` CSS
 * property.
 */


function getHTMLDir(dir) {
  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
  return dir === LTR ? 'ltr' : 'rtl';
}
/**
 * Get string value to be used for `dir` HTML attribute or `direction` CSS
 * property, but returns null if `dir` has same value as `otherDir`.
 * `null`.
 */


function getHTMLDirIfDifferent(dir, otherDir) {
  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
  !isStrong(otherDir) ?  false ? invariant(false, '`otherDir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
  return dir === otherDir ? null : getHTMLDir(dir);
} // == Global Direction ==

/**
 * Set the global direction.
 */


function setGlobalDir(dir) {
  globalDir = dir;
}
/**
 * Initialize the global direction
 */


function initGlobalDir() {
  setGlobalDir(LTR);
}
/**
 * Get the global direction
 */


function getGlobalDir() {
  if (!globalDir) {
    this.initGlobalDir();
  }

  !globalDir ?  false ? invariant(false, 'Global direction not set.') : invariant(false) : void 0;
  return globalDir;
}

var UnicodeBidiDirection = {
  // Values
  NEUTRAL: NEUTRAL,
  LTR: LTR,
  RTL: RTL,
  // Helpers
  isStrong: isStrong,
  getHTMLDir: getHTMLDir,
  getHTMLDirIfDifferent: getHTMLDirIfDifferent,
  // Global Direction
  setGlobalDir: setGlobalDir,
  initGlobalDir: initGlobalDir,
  getGlobalDir: getGlobalDir
};
module.exports = UnicodeBidiDirection;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var getCorrectDocumentFromNode = __webpack_require__(162);

var getSelectionOffsetKeyForNode = __webpack_require__(350);
/**
 * Get the key from the node's nearest offset-aware ancestor.
 */


function findAncestorOffsetKey(node) {
  var searchNode = node;

  while (searchNode && searchNode !== getCorrectDocumentFromNode(node).documentElement) {
    var key = getSelectionOffsetKeyForNode(searchNode);

    if (key != null) {
      return key;
    }

    searchNode = searchNode.parentNode;
  }

  return null;
}

module.exports = findAncestorOffsetKey;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
function getCorrectDocumentFromNode(node) {
  if (!node || !node.ownerDocument) {
    return document;
  }

  return node.ownerDocument;
}

module.exports = getCorrectDocumentFromNode;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
module.exports = {
  BACKSPACE: 8,
  TAB: 9,
  RETURN: 13,
  ALT: 18,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46,
  COMMA: 188,
  PERIOD: 190,
  A: 65,
  Z: 90,
  ZERO: 48,
  NUMPAD_0: 96,
  NUMPAD_9: 105
};

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var getStyleProperty = __webpack_require__(838);
/**
 * @param {DOMNode} element [description]
 * @param {string} name Overflow style property name.
 * @return {boolean} True if the supplied ndoe is scrollable.
 */


function _isNodeScrollable(element, name) {
  var overflow = Style.get(element, name);
  return overflow === 'auto' || overflow === 'scroll';
}
/**
 * Utilities for querying and mutating style properties.
 */


var Style = {
  /**
   * Gets the style property for the supplied node. This will return either the
   * computed style, if available, or the declared style.
   *
   * @param {DOMNode} node
   * @param {string} name Style property name.
   * @return {?string} Style property value.
   */
  get: getStyleProperty,

  /**
   * Determines the nearest ancestor of a node that is scrollable.
   *
   * NOTE: This can be expensive if used repeatedly or on a node nested deeply.
   *
   * @param {?DOMNode} node Node from which to start searching.
   * @return {?DOMWindow|DOMElement} Scroll parent of the supplied node.
   */
  getScrollParent: function getScrollParent(node) {
    if (!node) {
      return null;
    }

    var ownerDocument = node.ownerDocument;

    while (node && node !== ownerDocument.body) {
      if (_isNodeScrollable(node, 'overflow') || _isNodeScrollable(node, 'overflowY') || _isNodeScrollable(node, 'overflowX')) {
        return node;
      }

      node = node.parentNode;
    }

    return ownerDocument.defaultView || ownerDocument.parentWindow;
  }
};
module.exports = Style;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */


var getDocumentScrollElement = __webpack_require__(842);

var getUnboundedScrollPosition = __webpack_require__(843);
/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are bounded. This means that if the scroll position is
 * negative or exceeds the element boundaries (which is possible using inertial
 * scrolling), you will get zero or the maximum scroll position, respectively.
 *
 * If you need the unbound scroll position, use `getUnboundedScrollPosition`.
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */


function getScrollPosition(scrollable) {
  var documentScrollElement = getDocumentScrollElement(scrollable.ownerDocument || scrollable.document);

  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    scrollable = documentScrollElement;
  }

  var scrollPosition = getUnboundedScrollPosition(scrollable);
  var viewport = scrollable === documentScrollElement ? scrollable.ownerDocument.documentElement : scrollable;
  var xMax = scrollable.scrollWidth - viewport.clientWidth;
  var yMax = scrollable.scrollHeight - viewport.clientHeight;
  scrollPosition.x = Math.max(0, Math.min(scrollPosition.x, xMax));
  scrollPosition.y = Math.max(0, Math.min(scrollPosition.y, yMax));
  return scrollPosition;
}

module.exports = getScrollPosition;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


/**
 * Utility method for determining whether or not the value returned
 * from a handler indicates that it was handled.
 */
function isEventHandled(value) {
  return value === 'handled' || value === true;
}

module.exports = isEventHandled;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(12);

var invariant = __webpack_require__(6);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(126);
var ViewportMetrics = __webpack_require__(387);

var getEventModifierState = __webpack_require__(240);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(32);
var DOMNamespaces = __webpack_require__(242);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(243);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(8);

var EventPluginRegistry = __webpack_require__(235);
var ReactEventEmitterMixin = __webpack_require__(913);
var ViewportMetrics = __webpack_require__(387);

var getVendorPrefixedEventName = __webpack_require__(914);
var isEventSupported = __webpack_require__(239);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _clsx = __webpack_require__(128);

var _clsx2 = _interopRequireDefault(_clsx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-children-prop */


exports.default = function (_ref) {
  var alignment = _ref.alignment,
      children = _ref.children;
  return function (_Component) {
    _inherits(BlockAlignmentButton, _Component);

    function BlockAlignmentButton() {
      var _ref2;

      var _temp, _this, _ret;

      _classCallCheck(this, BlockAlignmentButton);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = BlockAlignmentButton.__proto__ || Object.getPrototypeOf(BlockAlignmentButton)).call.apply(_ref2, [this].concat(args))), _this), _this.activate = function (event) {
        event.preventDefault();
        _this.props.setAlignment({ alignment: alignment });
      }, _this.preventBubblingUp = function (event) {
        event.preventDefault();
      }, _this.isActive = function () {
        return _this.props.alignment === alignment;
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(BlockAlignmentButton, [{
      key: 'render',
      value: function render() {
        var theme = this.props.theme;

        var className = this.isActive() ? (0, _clsx2.default)(theme.button, theme.active) : theme.button;
        return _react2.default.createElement(
          'div',
          {
            className: theme.buttonWrapper,
            onMouseDown: this.preventBubblingUp
          },
          _react2.default.createElement('button', {
            className: className,
            onClick: this.activate,
            type: 'button',
            children: children
          })
        );
      }
    }]);

    return BlockAlignmentButton;
  }(_react.Component);
};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var english = exports.english = {
  general: {
    title: "Organization",
    approach: "Approach",
    stakeholdersInDefinition: "Stakeholders as described in Project Definition",
    stakeholder: "stakeholder",
    readMore: "read more",
    hideDetails: "hide details",
    leavePage: "Leave this page",
    addRole: "Add role",
    assignRole: "Assign role",
    addRoleDetails: "add role details",
    cancel: "Cancel",
    update: "Update",
    addStakeholder: "Add stakeholder",
    newStakeholder: "New stakeholder",
    messageEmailFirst: "please provide email first",
    helpName: "Stakeholders full name"
  },

  roles: {
    title: "Role Descriptions",
    headings: {
      name: "Name",
      email: "Email",
      role: "Role",
      details: "Details"
    },
    project: {
      selectRole: "-- select project role --",
      actions: {
        appointExecutive: "Appoint Executive",
        appointProjectManager: "Appoint Project Manager"
      },
      descriptions: {
        board: {
          title: "Project Board",
          ingress: "The board is responsible for the overall direction and management of the project.\n            The board is chaired by business (executive) and balanced with representatives for users and suppliers.",
          details: "A project organization is built on the principle that there will always be three primary stakeholder categories: business, user and supplier.\n            The following roles represent these stakeholder categories on the project board to ensure balanced direction given to the Project Manager",
          responsibility: "The Project Board is responsible for the overall direction and management of the Project.\n            Note that the Project Board is not a democracy controlled by vote. The Project Board is chaired by the Executive who is ultimately responsible"
        },
        assuranceRoles: {
          title: "Assurance Roles",
          ingress: "The main Project Board members might need help, some deputies, to help and direct on a day-to-day basis. These are the assurance roles.",
          details: "The deputy role for Senior Supplier is Supplier Assurance. The deputy role for Senior User is User Assurance. The deputy role for the Executive is Business Assurance."
        },
        teamStructure: {
          title: "Team structure",
          details: "The purpose of the organization theme is to define and establish the project's structure, accountabilities and responsibilities (the who?). The project should have a Project Board chaired by the Executive. The Project Board should have one or several Senior User(s) and Senior Supplier(s) supporting the Executive. There should be a Team Manager for each discipline contributing in the project.",
          additionalInformation: "One person can take several roles if the person has the capacity and competency, and if there is no conflict of interest."
        }
      },
      roles: {
        executive: {
          title: "Executive",
          summary: "representing the business needs. It is considered mandatory to have one, and only one, Executive",
          ingress: "Is the ultimately responsible for the project with focus on achieving the objectives and delivering a product that achieves the benefits.",
          details: "The Executive, sometimes called Sponsor or Project Owner, is ultimately responsible for the project\n            and for decisions in directing the work, supported by Senior User and Senior Supplier.\n            The Executive's role is to ensure that the project is focused throughout its life on achieving its\n            objectives and delivering a product that will achieve the benefits, balancing demands from various stakeholders.  Throughout the project, the Project Owner is responsible for the Business Case.",
          additionalInformation: "Appointing an Executive should be the very fist action."
        },
        seniorUser: {
          title: "Senior User",
          summary: "representing the users of the project output. There can be one or several Senior Users on the Project Board",
          ingress: "Is representing users of the deliveries from the project and ensuring that the forecasted benefits are realized.",
          details: "The Senior User is responsible for specifying the needs of those who will use the project's products, commits user resources and monitors products against such requirements. The Senior User specifies and assures furthermore the benefits and qualities and is held to account by demonstrating that the forecast benefits have in fact been realized."
        },
        seniorSupplier: {
          title: "Senior Supplier",
          summary: "representing those who will create the project's output. There can be one or several Senior Suppliers on the Project Board",
          ingress: "Is representing the suppliers that will deliver the products in the project and accountable for the quality of these.",
          details: "The Senior Supplier represents the interests of those designing, developing, facilitating, procuring and implementing the project&#8217;s products, secures the necessary resources and is accountable for the quality of products delivered by the supplier(s) as well as for the technical integrity."
        },
        projectManager: {
          title: "Project Manager",
          ingress: "Runs the project on a day-to-day basis within constraints given by the board.",
          details: "The Project Manager has the authority to run the project on a day-to-day basis within the given constraints.  The Project Manager's main responsibility is to ensure that the project produces the required products within the specified tolerances of time, cost, quality, scope, risk and benefits - and that the ultimate project's product(s) is capable of achieving the benefits defined in the Business Case.",
          additionalInformation: "The Project Manager should be appointed when the project is starting up."
        },
        teamManager: {
          title: "Team Manager",
          ingress: "Ensures that agreed products are produced in the project as defined by the project manager.",
          details: "The Team Manager ensures production of those products defined by the Project Manager to an appropriate quality, in a timescale and at a cost acceptable to the Project Board. The Team Manager reports to and takes direction from the Project Manager. The Team Manager agrees the work with the Project Manager, plans the team&#8217;s work, supervise the team&#8217;s work and reports on quality and progress. The Team Manager obtains the approval for the completed products delivery."
        }
      },
      executive: "Executive",
      seniorUser: "Senior User",
      seniorSupplier: "Senior Supplier",
      businessAssurance: "Business Assurance",
      projectManager: "Project Manager",
      teamManager: "Team Manager",
      projectSupport: "Project Support",
      changeAuthority: "Change Authority",
      stakeholder: "Stakeholder",
      userAssurance: "User Assurance",
      supplierAssurance: "Supplier Assurance",
      teamMember: "Team Member"
    },
    programme: {
      selectRole: "-- select programme role --",
      actions: {
        appointSRO: "Appoint Senior Responsible Owner",
        appointProgrammeManager: "Appoint Programme Manager"
      },
      descriptions: {
        teamStructure: {
          title: "Team Structure",
          details: "The purpose of the organization theme is to define and establish the programme's structure, accountabilities and responsibilities (the who?). The programme should have a Programme Board chaired by the Senior Responsible Owner.",
          additionalInformation: "The Programme Board should have one or several Business Change Manager(s) responsible for realizing the benefits."
        }
      },
      roles: {
        seniorResponsibleOwner: {
          title: "Senior Responsible Owner",
          details: "The Senior Responsible Owner (SRO) is accountable for the programme, ensuring it meets its objectives.",
          additionalInformation: "The induvidual who fulfills this role must have the seniority and authority to lead the programme board and must be empowered to direct the programme."
        },
        programmeManager: {
          title: "Programme Manager",
          details: "The Programme Manager has day-to-day management of the programme, is planning and designing the programme, is developing governance frameworks and is managing the programme's budget, risks and issues. ",
          additionalInformation: "The Programme Manager reports progress of the programme at regular intervals to the SRO and manages communication with stakeholders"
        }
      },
      seniorResponsibleOwner: "Senior Responsible Owner",
      programmeManager: "Programme Manager",
      businessChangeManager: "Business Change Manager",
      stakeholder: "Stakeholder",
      teamMember: "Team Member"
    },
    product: {
      selectRole: "-- select product role --",
      actions: {
        appointExecutive: "Appoint Executive",
        appointProductManager: "Appoint Product Manager"
      },
      descriptions: {
        teamStructure: {
          title: "Team Structure",
          details: "Efficient product teams need to cover viability, desirability and feasibility. The Product Manager should take care of viability, why something should be done. Someone also needs to be in charge of desirability, how the product needs to be for the user. Somethimes this is a designer",
          additionalInformation: "Feasibility is making sure we know how the product should be made. A senior technical person should take this responsibility. Use the Team Manager role below to document the roles not explicitly listed."
        }
      },
      roles: {
        executive: {
          title: "Executive",
          details: "The Executive the ultimately responsible for the success of the product with focus on achieving the objectives and delivering the benefits. It is considered mandatory to have one, and only one, Executive.",
          additionalInformation: "Appointing an Executive should be the very fist action. The Executive is somethimes called Sponsor or Owner."
        },
        productManager: {
          title: "Product Manager",
          details: "Product management responsibilities range from research on markets, customers and competitors, to developing and maintaining the product vision and roadmap. ",
          additionalInformation: "In this context, the product management responsibility in focus is working with product delivery teams to define, prioritize and test their delivery of product capabilities to maximize value and business impact."
        }
      },
      executive: "Executive",
      productManager: "Product Manager",
      teamManager: "Team Manager",
      stakeholder: "Stakeholder",
      teamMember: "Team Member"
    }
  },

  teamStructure: {
    title: "Team Structure"
  },
  communicationManagementApproach: {
    title: "Communication Management Approach",
    description: "The communication management approach describes how information will be shared in the project team and how the project team will send information to, and receive information from, project stakeholders.",
    fields: {
      process: {
        title: "Communication Procedure",
        help: "Will the project have any rules, routines or processes ensuring relevant information is shared in the project team, with the stakeholders, with the larger organization or with 3rd parties?\n          Are there any standard procedures or policies to be followed on communication? Any planned deviation from these procedures? If so, why?\n          How will we make sure the procedure is followed?\n          Any standards or templates to be used?\n          How will the communication procedure work with 3rd parties?\n          How will the project handle classified information and data privacy?",
        description: "Describe the communication methods and procedures to be used within the project and externally to the project"
      },
      tools: {
        title: "Tools, Techniques and Records",
        help: "Which techniques and communication tools will be used to share information?\n          Will there be any logging of internal or external communication?\n          Will the project use social media, e-mail, blogs, intranets, meetings, workshops, letters, documents ?",
        description: "Describe what tools or techniques the project will apply to make sure all needed information is shared."
      },
      reporting: {
        title: "Reporting",
        help: "When will formal communication occur?\n          Any specific communication activities in Initiation, beginning/end of stages or in closing?",
        description: "The communication reports to be produced, their purpose, timing and recipients."
      },
      timing: {
        title: "Timing of communication",
        help: "When will formal communication occur? When will meetings occour?\n          Any specific communication activities in Initiation, beginning/end of stages or in closing?",
        description: "Describe the timing of formal communication activities"
      },
      roles: {
        title: "Roles and responsibilities",
        help: "Who is responsible for the communication policy/procedure?\n          Who makes decisions on what can be communicated and when?\n          Who is responsible for communicating what to whom?",
        description: "Define the roles and responsibilities for communication"
      }
    }
  },
  stakeholderAnalysis: {
    title: "Stakeholder Analysis",
    fields: {
      stakeholders: {
        title: "Communication to stakeholders",
        columns: {
          name: { title: "Stakeholder" },
          message: { title: "Key messages" },
          requiredInformation: { title: "Information required" },
          providedInformation: { title: "Information provided" },
          frequency: { title: "Frequency" }
        },
        options: {
          addEntry: {
            title: "Add stakeholder"
          }
        }
      }
    }
  },
  stakeholder: {
    title: "Stakeholder",
    fields: {
      name: {
        title: "Stakeholder name",
        help: "Who has a financial stake/interest?\n          Who controls resources?\n          Who will be affected?\n          Any owners or auditors of policies and procedures?\n          Who are the biggest supporters?\n          Who are the biggest non-supporters or naysayers?\n          Any external partners, competitors or users?",
        description: "Name, role or group"
      },
      message: {
        title: "Key messages",
        help: "What is the key message to this stakeholder?",
        description: "The key message to this stakeholder"
      }
    }
  },
  information: {
    title: "Information",
    fields: {
      requiredInformation: {
        title: "Information required from the project",
        help: "What information will this stakeholder ask for?\n          What information do we want this stakeholder to receive?\n          Is there information the stakeholder doesn't want to receive?\n          Is there specific information we don't want to share with this stakeholder?",
        description: "The information communicated from the project to this stakeholder"
      },
      providedInformation: {
        title: "Information required to the project",
        help: "Is the project relying on information from this stakeholder? If so, what type of information is it?",
        description: "The information required to be provided to the project from this stakeholder"
      }
    }
  },
  communication: {
    title: "Communication",
    fields: {
      frequency: {
        title: "Frequency of communication",
        help: "How often should the project communicate with this stakeholder?\n          Will the frequency vary depending on the type of information?",
        description: "Describe the frequency of communication to this stakeholder"
      },
      means: {
        title: "Means of communication",
        help: "What method will be used to communicate with this stakeholder?\n          What will be the communication vehicle? Meetings, digital tools?",
        description: "Means"
      },
      format: {
        title: "Format of communication",
        help: "What format will be used to share the information?\n          Document, presentation, video, pictures, spoken, long, short, content rich/poor?",
        description: "Format"
      }
    }
  }
};

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var norwegian = exports.norwegian = {
  general: {
    title: "Organisasjon",
    approach: "Tilnærming",
    stakeholdersInDefinition: "Interessenter beskrevet i projektdefinisjonen",
    stakeholder: "Interessent",
    readMore: "les mer",
    hideDetails: "skjul detaljer",
    leavePage: "Forlat denne siden",
    addRole: "Legg til rolle",
    assignRole: "Tildel rolle",
    addRoleDetails: "legg til detaljer om rollen",
    cancel: "Avbryt",
    update: "Oppdater",
    addStakeholder: "Legg til interessent",
    newStakeholder: "Ny interessent",
    messageEmailFirst: "vennligst angi epost først",
    helpName: "Interessentens fulle navn"
  },

  roles: {
    title: "Rollebeskrivelser",
    headings: {
      name: "Navn",
      email: "Epost",
      role: "Rolle",
      details: "Detaljer"
    },
    project: {
      selectRole: "-- velg prosjektrolle --",
      actions: {
        appointExecutive: "Utnevn prosjekteier",
        appointProjectManager: "Utnevn prosjektleder"
      },
      descriptions: {
        board: {
          title: "Prosjektstyret",
          ingress: "Prosjektstyret er ansvarlig for den overordnede retningen og styringen av prosjektet.\n            Prosjektstyret ledes av forretningen (prosjekteier) og balanseres med representanter for brukerne og leverand\xF8rene.",
          details: "En prosjektorganisasjon er satt opp med utgangspunkt i prinsippet om at det alltid er tre prim\xE6re interessentkategorier: forretningen, brukere og leverand\xF8rer.\n            F\xF8lgende roller representerer disse interessentkategorienen i prosjektstyret for \xE5 sikre balansert styring til prosjektlederen",
          responsibility: "Prosjektstyret er ansvarlig for den overordnede retningen og ledelse av prosjektet.\n            Legg merke til at prosjektstyret ikke er et demokrati kontrollert ved avstemning. Prosjektstyret er ledet av prosjekteier som sitter med det overordnede ansvaret."
        },
        assuranceRoles: {
          title: "Prosjektsikring",
          ingress: "Medlemmene i prosjektstyret kan trenge hjelp, varamedlemmer, til \xE5 lede arbeidet p\xE5 daglig basis. Dette er sikringsrollene.",
          details: "Stedfortreder for Seniorleverand\xF8r er Leverand\xF8rsikring. Stedfortreder for Seniorbruker er Brukersikring. Stedfortreder for Prosjekteier er Forretningssikring"
        },
        teamStructure: {
          title: "Organisering av prosjektet",
          details: "Hensikten med organisasjonstemaet er \xE5 definere og etablere prosjektets strutktur, ansvar og myndighet (hvem?). Prosjektet skal ha et prosjektstyre ledet av prosjekteieren. Prosjektstyret b\xF8r ha en eller flere seniorbrukere og seniorleverand\xF8rer som st\xF8tter prosjekteieren. Det skal v\xE6re en teamleder for hver disiplin som bidrar i prosjektet.",
          additionalInformation: "En person kan ta flere roller hvis personen har kapasitet og kompetanse, og hvis det ikke medf\xF8rer interessekonflikt."
        }
      },
      roles: {
        executive: {
          title: "Prosjekteier",
          summary: "representer forretningens behov. Det er ansett som obligatorisk å ha en, og bare en, prosjekteier",
          ingress: "Er den endelige ansvarlige for prosjektet med fokus p\xE5 \xE5 oppn\xE5 m\xE5lene og levere et produkt som oppn\xE5r gevinstene.",
          details: "Prosjekteier, enkelte ganger omtalt som sponsor, er til syvende og sist ansvarlig for prosjektet\n            og for beslutninger knyttet til ledelse av arbeidet, st\xF8ttet av seniorbruker og seniorleverand\xF8r.\n            Prosjekteiers rolle er \xE5 sikre at prosjektet er fokusert gjennom livsl\xF8pet p\xE5 \xE5 oppn\xE5 m\xE5lene og \xE5 levere et produkt\n            som sikrer gevinstene med balanserte krav fra ulike interessenter. I hele prosjektets varighet er prosjekteieren ansvarlig for prosjektbegrunnelsen (business case).",
          additionalInformation: "Utnevning av prosjekteier b\xF8r v\xE6re den aller f\xF8rste aktiviteten."
        },
        seniorUser: {
          title: "Seniorbruker",
          summary: "representerer brukerne av prosjektets leveranser. Det kan være en eller mange seniorbrukere i prosjektstyret",
          ingress: "Er representant for brukerne av prosjektets leveranser og sikrer at foventede gevinster er realisert.",
          details: "Seniorbrukeren er ansvarlig for \xE5 spesifisere behovene til de som skal bruke prosjektets produkter,\n            forplikter ressurser fra brukerne og overv\xE5ker produktet mot angitte krav. Seniorbrukeren spesifiserer og forsikrer gevinstene og kvalitetene i prosjektets leveranser, og holdes ansvarlig for at forespeilede gevinster faktisk blir realisert."
        },
        seniorSupplier: {
          title: "Seniorleverandør",
          summary: "representere de som vil lage prosjektets leveranser. Det kan være en eller mange seniorleverandører i prosjektstyret",
          ingress: "Er representant for leverand\xF8rene som skal levere prosjektets produkter og ansvarlig for kvaliteten p\xE5 disse.",
          details: "Seniorleverand\xF8ren representerter interessene til de som designer, utvikler, tilretteleger,\n            anskaffer og implementerer prosjektets produkter, sikrer de n\xF8dvendige ressursene og er anvarlig for\n            kvaliteten p\xE5 produktene som leveres av leverand\xF8ren(e) s\xE5 vel som for den tekniske integriteten."
        },
        projectManager: {
          title: "Projektleder",
          ingress: "F\xF8lger opp prosjektet p\xE5 daglig basis innenfor begrensningene gitt av prosjektstyret.",
          details: "Prosjektleder har myndighet til \xE5 lede prosjektet p\xE5 daglig basis innenfor de gitte\n            begrensningene satt av prosjektstyret. Prosjektlederens hovedansvar er \xE5 sikre at prosjektet\n            produserer de n\xF8dvendige produktene innenfor de angitte toleransene for tid, kostnad, kvalitet, omfang,\n            risiko og gevinster, samt at det endelige produktet er i stand til \xE5 oppn\xE5 gevinstene\n            definert i begrunnelsen for prosjektet.",
          additionalInformation: "Prosjektlederen b\xF8r utnevnes n\xE5r prosjektet starter opp."
        },
        teamManager: {
          title: "Teamleder",
          ingress: "Sikrer at avtalte produkter blir produsert i prosjektet i henhold definisjonen gitt av prosjektlederen.",
          details: "Teamlederen sikrer produksjon av produktene prosjektlederen har definert til en passende kvalitet,\n            innenfor en tidsramme og til en akseptabel pris for prosjektstyret. Teamlederen rapporterer til og\n            ledes av prosjektlederen. Teamlederen kommer til enighet om arbeidet med prosjektlederen, planlegger\n            teamets arbeid, f\xF8rer tilsyn med utf\xF8relsen og rapporterer kvalitet og fremdrift til prosjektlederen.\n            Teamlederen f\xE5r godkjenning p\xE5 fullf\xF8rte produkter."
        }
      },
      executive: "Prosjekteier",
      seniorUser: "Seniorbruker",
      seniorSupplier: "Seniorleverandør",
      businessAssurance: "Forretningssikring",
      projectManager: "Prosjektleder",
      teamManager: "Teamleder",
      projectSupport: "Prosjektstøtte",
      changeAuthority: "Change Authority",
      stakeholder: "Interessent",
      userAssurance: "Brukersikring",
      supplierAssurance: "Leverandørsikring",
      teamMember: "Teammedlem"
    },
    programme: {
      selectRole: "-- velg rolle i programmet --",
      actions: {
        appointSRO: "Utnevn programeier (SRO)",
        appointProgrammeManager: "Utnevn programleder"
      },
      descriptions: {
        teamStructure: {
          title: "Organisering av programmet",
          details: "Hensikten med organisasjonstemaet er \xE5 definere og etablere programmets struktur, ansvar og myndighet (hvem?). Programmet skal ha et programstyre ledet av programeieren (SRO).",
          additionalInformation: "Programstyret b\xF8r ha en eller flere endringsledere (BCM) som er ansvarlige for \xE5 realisere gevinstene."
        }
      },
      roles: {
        seniorResponsibleOwner: {
          title: "Programeier (SRO)",
          details: "Programeieren (SRO) er ansvarlig for programmet og å sikre at målene oppnås.",
          additionalInformation: "Personen som innehar denne rollen må ha ansiennitet og myndighet til å lede programstyret, samt fullmakt til å lede programme."
        },
        programmeManager: {
          title: "Programleder",
          details: "Programlederen har den daglige ledelsen av programmet med \xE5 planlegge og utforme programmet, utvikle styringsrammene, og administrere programmets budsjett, risiko og saker.",
          additionalInformation: "Programlederen rapporterer fremdriften av programmet jevnlig til SRO og håndterer kommunikasjon med interessenter."
        }
      },
      seniorResponsibleOwner: "Programeier (SRO)",
      programmeManager: "Programleder",
      businessChangeManager: "Endringsleder (BCM)",
      stakeholder: "Interessent",
      teamMember: "Teammedlem"
    },
    product: {
      selectRole: "-- velg rolle i produktet --",
      actions: {
        appointExecutive: "Utpek produktansvarlig",
        appointProductManager: "Utpek produktleder"
      },
      descriptions: {
        teamStructure: {
          title: "Organisering av produktet",
          details: "Effektive produktteam m\xE5 dekke levedyktighet, \xF8nskelighet og gjennomf\xF8rbarhet. Produktlederen b\xF8r s\xF8rge for levedyktigheten, hvorfor noe skal gj\xF8res. Det b\xF8r ogs\xE5 settes noen til \xE5 ta ansvar for \xF8nskelighet, hvordan produktet m\xE5 v\xE6re for brukeren. Enkelte ganger er dette en designer.",
          additionalInformation: "Gjennomf\xF8rbarhet er \xE5 s\xF8rge for at vi vet hvordan produktet skal lages. En teknisk seniorperson b\xF8r ta dette ansvaret. Bruk Teamleder-rollen for \xE5 dokumentere rollene som ikke er eksplisitt oppf\xF8rt."
        }
      },
      roles: {
        executive: {
          title: "Produktansvarlig",
          details: "Ansvarlig for produktet ivaretar suksessen til produktet og har fokus på å oppnå målene og levere gevinstene. Det anses som obligatorisk å ha en, og bare en, produktansvarlig.",
          additionalInformation: "Utnevnelse av ansvarlig for produkt bør være det første som gjøres. Ansvarlig for produktet kalles noen ganger for sponsor eller eier."
        },
        productManager: {
          title: "Produktleder",
          details: "Ledelse av produktet spenner fra forskning på markedet, kunder og konkurrenter, til å utvikle og opprettholde produktvisjonen og langtidsplanen.",
          additionalInformation: "I denne sammenheng jobber produktlederen med produktteamet for å definere, prioritere og teste leveranser av produktfunksjoner som skal skape mest mulig verdi og produserer høyest mulig forretningsresultat."
        }
      },
      executive: "Produktansvalig",
      productManager: "Produktleder",
      teamManager: "Teamleder",
      stakeholder: "Interessent",
      teamMember: "Teammedlem"
    }
  },

  teamStructure: {
    title: "Organisering"
  },
  communicationManagementApproach: {
    title: "Tilnærming til kommunikasjon",
    description: "Tilnærming til kommunkasjon beskriver hvordan informasjon formidles til og mottas fra interessenter i prosjektet.",
    fields: {
      process: {
        title: "Kommunikasjonsprosedyre",
        help: "Vil prosjektet ha noen regler, rutiner eller prosesser som sikrer at relevant informasjon deles i prosjektgruppen, med interessentene, med organisasjon eller med tredje part?\n          Er det noen standard prosedyrer eller retningslinjer som skal f\xF8lges for kommunikasjon? Er det planlagt avvik fra disse prosedyrene? Hvis ja, hvorfor?\n          Hvordan skal vi s\xF8rge for at prosedyren f\xF8lges?\n          Er det standarder eller maler som skal brukes?\n          Hvordan fungerer kommunikasjonsprosedyren med tredje part?\n          Hvordan h\xE5ndterer prosjektet klassifisert informasjon og personvern?",
        description: "Beskriv kommunikasjonsmetoder og prosedyrer som skal brukes innenfor prosjektet og eksternt til prosjektet"
      },
      tools: {
        title: "Verktøy og teknikker",
        help: "Hvilke teknikker og kommunikasjonsverkt\xF8y vil bli brukt til \xE5 dele informasjon?\n          Vil det v\xE6re noen logging av intern eller ekstern kommunikasjon?\n          Vil prosjektet bruke sosiale medier, e-post, blogger, intranett, m\xF8ter, workshops, brev, dokumenter?",
        description: "Beskriv hvilke verktøy eller teknikker prosjektet skal bruke for å sikre at all nødvendig informasjon deles."
      },
      reporting: {
        title: "Rapportering",
        help: "N\xE5r gj\xF8res formell kommunikasjon?\n          Hvilke spesifikke kommunikasjonsaktiviteter gj\xF8res ved prosjektoppstarter, start / slutt p\xE5 etappe eller ved prosjektavsluttning?",
        description: "Beskriv kommunikasjonsrapporter som skal bli produsert, deres formål, tidspunkt og mottakere."
      },
      timing: {
        title: "Tidspunkt for kommunikasjon",
        help: "N\xE5r gj\xF8res formell kommunikasjon? N\xE5r holdes m\xF8ter?\n          Skal det gj\xF8res spesielle kommunikasjonsaktiviteter i begynnelsen av prosjektet, begynnelse / slutten av etapper eller ved prosjektavslutning?",
        description: "Beskriv tidspunktet for formelle kommunikasjonsaktiviteter"
      },
      roles: {
        title: "Roller og ansvar",
        help: "Hvem er ansvarlig for kommunikasjonsprosedyren / retningslinjer for kommunkasjon?\n          Hvem bestemmer hva som kan kommuniseres or n\xE5r?\n          Hvem er ansvarlig for \xE5 kommunisere hva til hvem?",
        description: "Definer roller og ansvar for kommunikasjon"
      }
    }
  },
  stakeholderAnalysis: {
    title: "Interessentanalyse",
    fields: {
      stakeholders: {
        title: "Kommunikasjon til interessenter",
        columns: {
          name: { title: "Interessent" },
          message: { title: "Informasjonsbehov" },
          requiredInformation: { title: "Trenger" },
          providedInformation: { title: "Leverer" },
          frequency: { title: "Frekvens" }
        },
        options: {
          addEntry: {
            title: "Legg til interessent"
          }
        },
        samples: [{
          name: "Eksempelinteressent",
          message: "Informasjon om fremdrift",
          requiredInformation: "Statusrapport",
          providedInformation: "Brukerbehov",
          frequency: "Månedlig"
        }]
      }
    }
  },
  stakeholder: {
    title: "Interessent",
    fields: {
      name: {
        title: "Navn på interessent",
        help: "Hvem har finansiell interesse?\n          Hvem styrer ressurser?\n          Hvem vil bli p\xE5virket?\n          Noen som eier eller etterpr\xF8ver retningslinjer og prosedyrer?\n          Hvem er de st\xF8rste tilhengerne?\n          Hvem er de viktigste motstanderne?\n          Eventuelle eksterne partnere, konkurrenter eller brukere?",
        description: "Navn, rolle eller gruppe"
      },
      message: {
        title: "Informasjonsbehov",
        help: "Hva er hovedbudskapet til denne interessenten?",
        description: "Angi hovedbudskapet til interessenten"
      }
    }
  },
  information: {
    title: "Informasjon",
    fields: {
      requiredInformation: {
        title: "Informasjon påkrevd fra prosjektet",
        help: "Hvilken informasjon vil denne interessenten be om?\n          Hvilken informasjon vil vi denne interessenten skal motta?\n          Er det noe informasjon interessenten ikke vil motta?\n          Har prosjektet spesifikk informasjon som ikke skal deles med denne interessenten?",
        description: "Angi informasjon kommunisert fra prosjektet til interessenten"
      },
      providedInformation: {
        title: "Information nødvendig til prosjektet",
        help: "Er prosjektet avhengig av informasjon fra denne interessent? Hvis ja, hvilken type informasjon er det?",
        description: "Angi informasjon som prosjektet trenger fra denne interessenten"
      }
    }
  },
  communication: {
    title: "Kommunikasjon",
    fields: {
      frequency: {
        title: "Frekvens på kommunikasjon",
        help: "Hvor ofte skal prosjektet kommunisere med denne interessenten?\n          Vil frekvensen variere avhengig av typen informasjon?",
        description: "Beskriv kommunikasjonsfrekvensen til interessenten"
      },
      means: {
        title: "Kommunikasjonsmåter",
        help: "Hvilken metode vil bli brukt til \xE5 kommunisere med denne interessenten?\n          Hva blir kommunikasjonsverkt\xF8yet? M\xF8ter, digitale verkt\xF8y?",
        description: "Kommunikasjonsmiddel"
      },
      format: {
        title: "Format på kommunikasjonen",
        help: "Hvilket format vil bli brukt til \xE5 dele informasjonen?\n          Dokument, presentasjon, video, bilder, muntlig, lang, kort, kontekst-rikt/fattig?",
        description: "Format"
      }
    }
  }
};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Index = __webpack_require__(1056);

var _FilterStatus = __webpack_require__(426);

var _FilterStatus2 = _interopRequireDefault(_FilterStatus);

var _superagent = __webpack_require__(23);

var _superagent2 = _interopRequireDefault(_superagent);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } //DragAndDrop.jsx';


var translations = new _translations2.default([__webpack_require__(206), __webpack_require__(207)]);

var PortfolioOverview = function (_React$Component) {
  _inherits(PortfolioOverview, _React$Component);

  function PortfolioOverview() {
    _classCallCheck(this, PortfolioOverview);

    return _possibleConstructorReturn(this, (PortfolioOverview.__proto__ || Object.getPrototypeOf(PortfolioOverview)).apply(this, arguments));
  }

  _createClass(PortfolioOverview, [{
    key: "includedInFilter",
    value: function includedInFilter(filter, portfolio) {
      var userEmailDomain = this.props.user !== undefined ? this.props.user.email.split("@").slice(-1)[0] : undefined;
      var included = filter === undefined || filter !== undefined && filter["portfolio_" + portfolio.id] !== false;
      var accessControl = portfolio.accessControl === undefined || portfolio.accessControl === null || portfolio.accessControl.includes(userEmailDomain);
      return included && accessControl;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var labels = translations.getTranslation(this.props);
      var rowStyle = {
        display: "table-cell",
        borderBottom: "1px solid #ddd",
        padding: 8,
        textAlign: "left"
      };
      var projects = this.props.projects !== undefined ? this.props.projects : [];
      var withoutPortfolio = projects.filter(function (project) {
        return project.portfolio === undefined || project.portfolio === "" || _this2.props.tenant !== undefined && _this2.props.tenant.portfolios.filter(function (portfolio) {
          return portfolio.id === project.portfolio;
        }).length === 0;
      }).length;
      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_FilterStatus2.default, this.props),
        _react2.default.createElement(
          "table",
          {
            style: {
              width: "80%",
              lineHeight: "20px",
              borderCollapse: "collapse",
              borderSpacing: 0,
              marginLeft: "10%",
              marginRight: "10%",
              marginTop: 50,
              fontFamily: "Lato, Arial, 'Helvetica Neue', Helvetica, sans-serif",
              fontSize: "14px"
            }
          },
          _react2.default.createElement(
            "thead",
            null,
            _react2.default.createElement(
              "tr",
              { style: { fontSize: "16px" } },
              _react2.default.createElement(
                "th",
                { style: rowStyle },
                labels.columns.portfolio
              ),
              _react2.default.createElement(
                "th",
                { style: rowStyle },
                labels.columns.numberOfProjects
              )
            )
          ),
          _react2.default.createElement(
            "tbody",
            null,
            this.props.tenant.portfolios.filter(function (portfolio) {
              return _this2.includedInFilter(_this2.props.filter, portfolio);
            }).map(function (portfolio) {
              return _react2.default.createElement(
                "tr",
                { style: { fontSize: "14px" }, key: portfolio.id },
                _react2.default.createElement(
                  "td",
                  { style: rowStyle },
                  _react2.default.createElement(
                    "a",
                    { href: "/portfolio/" + portfolio.id + "/" },
                    portfolio.name
                  )
                ),
                _react2.default.createElement(
                  "td",
                  { style: rowStyle },
                  projects.filter(function (project) {
                    return project.portfolio === portfolio.id && project.isStarted === true;
                  }).length
                )
              );
            }),
            withoutPortfolio > 0 ? _react2.default.createElement(
              "tr",
              null,
              _react2.default.createElement(
                "td",
                { style: rowStyle },
                _react2.default.createElement(
                  "a",
                  { href: "/portfolio/other/" },
                  labels.general.otherPortfolio
                )
              ),
              _react2.default.createElement(
                "td",
                { style: rowStyle },
                withoutPortfolio
              )
            ) : null
          )
        )
      );
    }
  }]);

  return PortfolioOverview;
}(_react2.default.Component);

var Details = function (_React$Component2) {
  _inherits(Details, _React$Component2);

  function Details() {
    _classCallCheck(this, Details);

    return _possibleConstructorReturn(this, (Details.__proto__ || Object.getPrototypeOf(Details)).apply(this, arguments));
  }

  _createClass(Details, [{
    key: "render",
    value: function render() {
      return this.props.tenant.portfolios !== undefined && this.props.tenant.portfolios.length > 0 ? _react2.default.createElement(PortfolioOverview, this.props) : _react2.default.createElement(_Index.ProjectStatus, { tenant: this.props.tenant });
    }
  }]);

  return Details;
}(_react2.default.Component);

var Portfolio = function (_React$Component3) {
  _inherits(Portfolio, _React$Component3);

  function Portfolio(props) {
    _classCallCheck(this, Portfolio);

    var _this4 = _possibleConstructorReturn(this, (Portfolio.__proto__ || Object.getPrototypeOf(Portfolio)).call(this, props));

    var filter = _this4.props.user !== undefined && _this4.props.user.filters !== undefined && _this4.props.tenant !== undefined ? _this4.props.user.filters[_this4.props.tenant.id] : undefined;
    var projects = _this4.props.projects !== undefined ? _this4.props.projects : _this4.props.tenant !== undefined ? _this4.props.tenant.projects : undefined;
    _this4.state = {
      projects: filter !== undefined && projects !== undefined ? projects.filter(function (project) {
        return _this4.includedInFilter(filter, project);
      }) : projects,
      excludedProjects: filter !== undefined && projects !== undefined ? projects.filter(function (project) {
        return !_this4.includedInFilter(filter, project);
      }) : [],
      filter: filter
    };
    return _this4;
  }

  _createClass(Portfolio, [{
    key: "prioritizeProject",
    value: function prioritizeProject(priorization) {
      var projects = this.state.projects;
      var url = this.props.programOverview === true ? "/programmes/" + this.props.programme.id + "/prioritize" + (this.props.programme.useTenantPriority ? "?tenantPriority=true" : "") : "/prioritize" + (this.props.combinedPriority === false ? "?combinedPriority=false" : "");

      _superagent2.default.post(url).send(priorization).end(function (err, response) {
        if (err === null) {
          var prioritizedProjects = JSON.parse(response.text);
          var updatedProjects = prioritizedProjects.map(function (project) {
            var foundProject = projects.filter(function (existingProject) {
              return existingProject.id === project.id;
            })[0];
            return Object.assign({}, foundProject, {
              priority: project.priority
            });
          }).filter(function (project) {
            return project.id !== undefined;
          });
          this.setState({ projects: updatedProjects });
        }
      }.bind(this));
    }
  }, {
    key: "includedInFilter",
    value: function includedInFilter(filter, project) {
      var included = true;
      ["portfolio", "projectType", "category", "department", "state", "location", "phase"].forEach(function (property) {
        var encodedKey = property + "_" + (property === "phase" ? Buffer.from(project[property]).toString("base64") : project[property]);
        return included = included && (project[property] === undefined || filter[encodedKey] !== false);
      });
      return included;
    }
  }, {
    key: "render",
    value: function render() {
      var filter = this.state.filter;
      var projects = this.state.projects;
      return this.props.programOverview !== true && this.props.tenant !== undefined && this.props.tenant.portfolios !== undefined && this.props.tenant.portfolios.length > 0 && this.props.portfolio === undefined ? _react2.default.createElement(PortfolioOverview, _extends({}, this.props, {
        projects: projects,
        filter: filter,
        excludedProjects: this.state.excludedProjects
      })) : _react2.default.createElement(_Index.ProjectStatus, _extends({}, this.props, {
        tenant: this.props.design !== undefined && this.props.tenant === undefined ? Object.assign({}, this.props.tenant, {
          design: this.props.design
        }) : this.props.tenant,
        projects: projects,
        prioritize: this.prioritizeProject.bind(this),
        filter: filter,
        portfolio: this.props.portfolio,
        excludedProjects: this.state.excludedProjects
      }));
    }
  }]);

  return Portfolio;
}(_react2.default.Component);

exports.default = Portfolio;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(423).Buffer))

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewProject = exports.RegisterRelease = exports.RegisterProduct = exports.RegisterProgramme = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _ProjectMenu = __webpack_require__(17);

var _ProjectMenu2 = _interopRequireDefault(_ProjectMenu);

var _Area = __webpack_require__(115);

var _Area2 = _interopRequireDefault(_Area);

var _Field = __webpack_require__(36);

var _Field2 = _interopRequireDefault(_Field);

var _currencies = __webpack_require__(429);

var _currencies2 = _interopRequireDefault(_currencies);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(430), __webpack_require__(431)]);

var ProjectProperties = function (_React$Component) {
  _inherits(ProjectProperties, _React$Component);

  function ProjectProperties(props) {
    _classCallCheck(this, ProjectProperties);

    var _this = _possibleConstructorReturn(this, (ProjectProperties.__proto__ || Object.getPrototypeOf(ProjectProperties)).call(this, props));

    _this.state = {
      programme: _this.props.project !== undefined ? _this.props.project.programme : undefined,
      portfolio: _this.props.project !== undefined ? _this.props.project.portfolio : undefined
    };
    return _this;
  }

  _createClass(ProjectProperties, [{
    key: 'updatePortfolio',
    value: function updatePortfolio(event) {
      this.setState({ portfolio: event.target.value });
    }
  }, {
    key: 'updateProgramme',
    value: function updateProgramme(event) {
      this.setState({ programme: event.target.value !== "" ? event.target.value : undefined });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var labels = translations.getTranslation(this.props);
      return _react2.default.createElement(
        'div',
        { style: { marginTop: 30 } },
        _react2.default.createElement(
          _Area2.default,
          { title: labels.properties.title },
          _react2.default.createElement(_Field2.default, {
            title: labels.properties.fields.name.title,
            name: 'name',
            description: labels.properties.fields.name.description,
            value: this.props.project !== undefined ? this.props.project.name : undefined
          }),
          _react2.default.createElement(_Field2.default, {
            title: labels.properties.fields.identifier.title,
            optional: true,
            name: 'identifier',
            description: labels.properties.fields.identifier.description,
            value: this.props.project !== undefined ? this.props.project.identifier : undefined
          }),
          this.props.tenant !== undefined && this.props.tenant.portfolios !== undefined && this.props.tenant.portfolios.length > 0 ? _react2.default.createElement(_Field2.default, {
            title: labels.properties.fields.portfolio.title,
            name: 'portfolio',
            help: labels.properties.fields.portfolio.help,
            value: this.state.portfolio,
            options: this.props.tenant.portfolios.map(function (portfolio) {
              return { value: portfolio.id, text: portfolio.name };
            }),
            onChange: this.updatePortfolio.bind(this),
            disabled: this.state.programme !== undefined
          }) : null,
          this.props.tenant !== undefined && this.props.tenant.locations !== undefined && this.props.tenant.locations.length > 0 ? _react2.default.createElement(_Field2.default, {
            title: labels.properties.fields.location.title,
            name: 'location',
            help: labels.properties.fields.location.help,
            value: this.props.project !== undefined ? this.props.project.location : undefined,
            options: this.props.tenant.locations.map(function (location) {
              return { value: location.id, text: location.name };
            })
          }) : null,
          this.props.tenant !== undefined && this.props.tenant.projectTypes !== undefined && this.props.tenant.projectTypes.length > 0 ? _react2.default.createElement(_Field2.default, {
            title: labels.properties.fields.projectType.title,
            name: 'projectType',
            help: labels.properties.fields.projectType.help,
            value: this.props.project !== undefined ? this.props.project.projectType : undefined,
            options: this.props.tenant.projectTypes.map(function (item) {
              return { value: item.id, text: item.name };
            })
          }) : null,
          this.props.tenant !== undefined && this.props.tenant.departments !== undefined && this.props.tenant.departments.length > 0 ? _react2.default.createElement(_Field2.default, {
            title: labels.properties.fields.department.title,
            name: 'department',
            help: labels.properties.fields.department.help,
            value: this.props.project !== undefined ? this.props.project.department : undefined,
            options: this.props.tenant.departments.map(function (item) {
              return { value: item.id, text: item.name };
            })
          }) : null,
          this.props.tenant !== undefined && this.props.tenant.categories !== undefined && this.props.tenant.categories.length > 0 ? _react2.default.createElement(_Field2.default, {
            title: labels.properties.fields.category.title,
            name: 'category',
            help: labels.properties.fields.category.help,
            value: this.props.project !== undefined ? this.props.project.category : undefined,
            options: this.props.tenant.categories.map(function (item) {
              return { value: item.id, text: item.name };
            })
          }) : null,
          this.props.tenant !== undefined && this.props.tenant.currencies !== undefined && this.props.tenant.currencies.length > 0 ? _react2.default.createElement(_Field2.default, {
            title: labels.properties.fields.currency.title,
            name: 'currency',
            help: labels.properties.fields.currency.help,
            value: this.props.project !== undefined ? this.props.project.currency : undefined,
            options: this.props.tenant.currencies.map(function (currency) {
              return { value: currency, text: currency + " - " + _currencies2.default.find(function (item) {
                  return item.id === currency;
                }).title };
            })
          }) : null,
          this.props.tenant !== undefined && this.props.tenant.programmes !== undefined && this.props.tenant.programmes.filter(function (programme) {
            return programme.portfolio === _this2.state.portfolio;
          }).length > 0 ? _react2.default.createElement(_Field2.default, {
            title: labels.properties.fields.programme.title,
            name: 'programme',
            help: labels.properties.fields.programme.help,
            value: this.state.programme,
            options: [{ text: labels.programme.noProgramme, value: "" }].concat(this.props.tenant.programmes.filter(function (programme) {
              return programme.portfolio === _this2.state.portfolio;
            }).map(function (item) {
              return { value: item.id, text: labels.programme.yesProgrammePrefix + item.name };
            })),
            optional: true,
            onChange: this.updateProgramme.bind(this)
          }) : null,
          this.state.programme !== undefined ? _react2.default.createElement('input', { type: 'hidden', name: 'portfolio', value: this.state.portfolio }) : null
        )
      );
    }
  }]);

  return ProjectProperties;
}(_react2.default.Component);

var ProjectBackground = function (_React$Component2) {
  _inherits(ProjectBackground, _React$Component2);

  function ProjectBackground() {
    _classCallCheck(this, ProjectBackground);

    return _possibleConstructorReturn(this, (ProjectBackground.__proto__ || Object.getPrototypeOf(ProjectBackground)).apply(this, arguments));
  }

  _createClass(ProjectBackground, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props)[this.props.type !== undefined ? this.props.type : "background"];
      return _react2.default.createElement(
        _Area2.default,
        { title: labels.title },
        this.props.type === "product" ? _react2.default.createElement(_Field2.default, { title: labels.fields.description.title,
          optional: true,
          name: 'description',
          help: labels.fields.description.help,
          description: labels.fields.description.description,
          height: '3',
          value: this.props.project !== undefined ? this.props.project.description : undefined
        }) : null,
        _react2.default.createElement(_Field2.default, { title: labels.fields.background.title,
          optional: true,
          name: 'background',
          help: labels.fields.background.help,
          description: labels.fields.background.description,
          height: '3',
          value: this.props.project !== undefined ? this.props.project.background : undefined
        }),
        this.props.type !== "product" ? _react2.default.createElement(_Field2.default, { title: labels.fields.timing.title,
          optional: true,
          name: 'timing',
          help: labels.fields.timing.help,
          description: labels.fields.timing.description,
          height: '3',
          value: this.props.project !== undefined ? this.props.project.timing : undefined
        }) : null,
        this.props.type !== "programme" && this.props.type !== "product" ? _react2.default.createElement(_Field2.default, {
          title: labels.fields.bigPicture.title,
          optional: true,
          name: 'bigPicture',
          help: labels.fields.bigPicture.help,
          description: labels.fields.bigPicture.description,
          height: '3',
          value: this.props.project !== undefined ? this.props.project.bigPicture : undefined
        }) : this.props.type === "product" ? _react2.default.createElement(_Field2.default, {
          title: labels.fields.vision.title,
          optional: true,
          name: 'vision',
          help: labels.fields.vision.help,
          description: labels.fields.vision.description,
          height: '3',
          value: this.props.project !== undefined ? this.props.project.vision : undefined
        }) : _react2.default.createElement(_Field2.default, {
          title: labels.fields.successFactors.title,
          optional: true,
          name: 'successFactors',
          help: labels.fields.successFactors.help,
          description: labels.fields.successFactors.description,
          height: '3',
          value: this.props.project !== undefined ? this.props.project.successFactors : undefined
        })
      );
    }
  }]);

  return ProjectBackground;
}(_react2.default.Component);

var RegisterProgramme = exports.RegisterProgramme = function (_React$Component3) {
  _inherits(RegisterProgramme, _React$Component3);

  function RegisterProgramme() {
    _classCallCheck(this, RegisterProgramme);

    return _possibleConstructorReturn(this, (RegisterProgramme.__proto__ || Object.getPrototypeOf(RegisterProgramme)).apply(this, arguments));
  }

  _createClass(RegisterProgramme, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).programme;
      return _react2.default.createElement(
        'div',
        { style: { marginTop: 30 } },
        _react2.default.createElement(
          'form',
          { action: '/programmes', method: 'POST' },
          this.props.project !== undefined && this.props.project.id !== undefined ? _react2.default.createElement('input', { type: 'hidden', name: 'id', value: this.props.project.id }) : null,
          this.props.project !== undefined && this.props.backgroundEdit === true ? _react2.default.createElement('input', { type: 'hidden', name: 'edit', value: 'background' }) : null,
          _react2.default.createElement(
            _Area2.default,
            { title: labels.properties.title },
            _react2.default.createElement(_Field2.default, {
              title: labels.fields.name.title,
              name: 'name',
              description: labels.fields.name.description,
              value: this.props.project.name
            }),
            _react2.default.createElement(_Field2.default, {
              title: labels.fields.identifier.title,
              optional: true,
              name: 'identifier',
              description: labels.fields.identifier.description,
              value: this.props.project.identifier
            }),
            this.props.tenant !== undefined && this.props.tenant.portfolios !== undefined && this.props.tenant.portfolios.length > 0 ? _react2.default.createElement(_Field2.default, {
              title: labels.fields.portfolio.title,
              name: 'portfolio',
              help: labels.fields.portfolio.help,
              value: this.props.project.portfolio,
              options: this.props.tenant.portfolios.map(function (portfolio) {
                return { value: portfolio.id, text: portfolio.name };
              })
            }) : null,
            this.props.tenant !== undefined && this.props.tenant.locations !== undefined && this.props.tenant.locations.length > 0 ? _react2.default.createElement(_Field2.default, {
              title: labels.fields.location.title,
              name: 'location',
              help: labels.fields.location.help,
              value: this.props.project !== undefined ? this.props.project.location : undefined,
              options: this.props.tenant.locations.map(function (location) {
                return { value: location.id, text: location.name };
              })
            }) : null,
            this.props.tenant !== undefined && this.props.tenant.departments !== undefined && this.props.tenant.departments.length > 0 ? _react2.default.createElement(_Field2.default, {
              title: labels.fields.department.title,
              name: 'department',
              help: labels.fields.department.help,
              value: this.props.project !== undefined ? this.props.project.department : undefined,
              options: this.props.tenant.departments.map(function (item) {
                return { value: item.id, text: item.name };
              })
            }) : null
          ),
          this.props.backgroundEdit === undefined || this.props.backgroundEdit === true ? _react2.default.createElement(ProjectBackground, _extends({}, this.props, { type: 'programme' })) : null,
          _react2.default.createElement(
            'div',
            { style: { paddingTop: 30, paddingBottom: 80, clear: "left", float: "none" } },
            _react2.default.createElement('input', { className: 'cancel', type: 'submit', name: 'cancel', value: labels.actions.cancel }),
            this.props.project !== undefined && this.props.project.id !== undefined ? _react2.default.createElement('input', { className: 'save', style: { marginLeft: 15 }, type: 'submit', value: labels.actions.update + " " + (this.props.backgroundEdit === true ? labels.actions.background : labels.actions.project) }) : _react2.default.createElement('input', { className: 'save', style: { marginLeft: 15 }, type: 'submit', value: labels.actions.createProgramme })
          )
        )
      );
    }
  }]);

  return RegisterProgramme;
}(_react2.default.Component);

var RegisterProduct = exports.RegisterProduct = function (_React$Component4) {
  _inherits(RegisterProduct, _React$Component4);

  function RegisterProduct() {
    _classCallCheck(this, RegisterProduct);

    return _possibleConstructorReturn(this, (RegisterProduct.__proto__ || Object.getPrototypeOf(RegisterProduct)).apply(this, arguments));
  }

  _createClass(RegisterProduct, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).product;
      return _react2.default.createElement(
        'div',
        { style: { marginTop: 30 } },
        _react2.default.createElement(
          'form',
          { action: '/products', method: 'POST' },
          this.props.project !== undefined && this.props.project.id !== undefined ? _react2.default.createElement('input', { type: 'hidden', name: 'id', value: this.props.project.id }) : null,
          this.props.project !== undefined && this.props.backgroundEdit === true ? _react2.default.createElement('input', { type: 'hidden', name: 'edit', value: 'background' }) : null,
          _react2.default.createElement(
            _Area2.default,
            { title: labels.properties.title },
            _react2.default.createElement(_Field2.default, {
              title: labels.fields.name.title,
              name: 'name',
              description: labels.fields.name.description,
              value: this.props.project.name
            }),
            _react2.default.createElement(_Field2.default, {
              title: labels.fields.identifier.title,
              optional: true,
              name: 'identifier',
              description: labels.fields.identifier.description,
              value: this.props.project.identifier
            }),
            this.props.tenant !== undefined && this.props.tenant.portfolios !== undefined && this.props.tenant.portfolios.length > 0 ? _react2.default.createElement(_Field2.default, {
              title: labels.fields.portfolio.title,
              name: 'portfolio',
              help: labels.fields.portfolio.help,
              value: this.props.project.portfolio,
              options: this.props.tenant.portfolios.map(function (portfolio) {
                return { value: portfolio.id, text: portfolio.name };
              })
            }) : null,
            this.props.tenant !== undefined && this.props.tenant.currencies !== undefined && this.props.tenant.currencies.length > 0 ? _react2.default.createElement(_Field2.default, {
              title: labels.fields.currency.title,
              name: 'currency',
              help: labels.fields.currency.help,
              value: this.props.project !== undefined ? this.props.project.currency : undefined,
              options: this.props.tenant.currencies.map(function (currency) {
                return { value: currency, text: currency + " - " + _currencies2.default.find(function (item) {
                    return item.id === currency;
                  }).title };
              })
            }) : null,
            this.props.tenant !== undefined && this.props.tenant.locations !== undefined && this.props.tenant.locations.length > 0 ? _react2.default.createElement(_Field2.default, {
              title: labels.fields.location.title,
              name: 'location',
              help: labels.fields.location.help,
              value: this.props.project !== undefined ? this.props.project.location : undefined,
              options: this.props.tenant.locations.map(function (location) {
                return { value: location.id, text: location.name };
              })
            }) : null,
            this.props.tenant !== undefined && this.props.tenant.departments !== undefined && this.props.tenant.departments.length > 0 ? _react2.default.createElement(_Field2.default, {
              title: labels.fields.department.title,
              name: 'department',
              help: labels.fields.department.help,
              value: this.props.project !== undefined ? this.props.project.department : undefined,
              options: this.props.tenant.departments.map(function (item) {
                return { value: item.id, text: item.name };
              })
            }) : null
          ),
          this.props.backgroundEdit === undefined || this.props.backgroundEdit === true ? _react2.default.createElement(ProjectBackground, _extends({}, this.props, { type: 'product' })) : null,
          _react2.default.createElement(
            'div',
            { style: { paddingTop: 30, paddingBottom: 80, clear: "left", float: "none" } },
            _react2.default.createElement('input', { className: 'cancel', type: 'submit', name: 'cancel', value: labels.actions.cancel }),
            this.props.project !== undefined && this.props.project.id !== undefined ? _react2.default.createElement('input', { className: 'save', style: { marginLeft: 15 }, type: 'submit', value: labels.actions.update + " " + (this.props.backgroundEdit === true ? labels.actions.background : labels.actions.project) }) : _react2.default.createElement('input', { className: 'save', style: { marginLeft: 15 }, type: 'submit', value: labels.actions.createProgramme })
          )
        )
      );
    }
  }]);

  return RegisterProduct;
}(_react2.default.Component);

var RegisterRelease = exports.RegisterRelease = function (_React$Component5) {
  _inherits(RegisterRelease, _React$Component5);

  function RegisterRelease(props) {
    _classCallCheck(this, RegisterRelease);

    var _this6 = _possibleConstructorReturn(this, (RegisterRelease.__proto__ || Object.getPrototypeOf(RegisterRelease)).call(this, props));

    _this6.state = {
      programme: _this6.props.project !== undefined ? _this6.props.project.programme : undefined,
      portfolio: _this6.props.project !== undefined ? _this6.props.project.portfolio : undefined
    };
    return _this6;
  }

  _createClass(RegisterRelease, [{
    key: 'updatePortfolio',
    value: function updatePortfolio(event) {
      this.setState({ portfolio: event.target.value });
    }
  }, {
    key: 'updateProgramme',
    value: function updateProgramme(event) {
      this.setState({ programme: event.target.value !== "" ? event.target.value : undefined });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var labels = translations.getTranslation(this.props).release;
      return _react2.default.createElement(
        'div',
        { style: { marginTop: 30 } },
        _react2.default.createElement(
          'form',
          { action: '/releases', method: 'POST' },
          this.props.project !== undefined && this.props.project.id !== undefined ? _react2.default.createElement('input', { type: 'hidden', name: 'id', value: this.props.project.id }) : null,
          _react2.default.createElement(
            _Area2.default,
            { title: labels.properties.title },
            _react2.default.createElement(_Field2.default, {
              title: labels.fields.name.title,
              name: 'name',
              description: labels.fields.name.description,
              help: labels.fields.name.help,
              value: this.props.project.name,
              readonly: true
            }),
            _react2.default.createElement(_Field2.default, {
              title: labels.fields.identifier.title,
              optional: true,
              name: 'identifier',
              description: labels.fields.identifier.description,
              value: this.props.project.identifier
            }),
            this.props.tenant !== undefined && this.props.tenant.portfolios !== undefined && this.props.tenant.portfolios.length > 0 ? _react2.default.createElement(_Field2.default, {
              title: labels.fields.portfolio.title,
              name: 'portfolio',
              help: labels.fields.portfolio.help,
              value: this.props.project.portfolio,
              options: this.props.tenant.portfolios.map(function (portfolio) {
                return { value: portfolio.id, text: portfolio.name };
              }),
              disabled: this.state.programme !== undefined
            }) : null,
            this.props.tenant !== undefined && this.props.tenant.programmes !== undefined && this.props.tenant.programmes.filter(function (programme) {
              return programme.portfolio === _this7.state.portfolio;
            }).length > 0 ? _react2.default.createElement(_Field2.default, {
              title: labels.fields.programme.title,
              name: 'programme',
              help: labels.fields.programme.help,
              value: this.state.programme,
              options: [{ text: labels.noProgramme, value: "" }].concat(this.props.tenant.programmes.filter(function (programme) {
                return programme.portfolio === _this7.state.portfolio;
              }).map(function (item) {
                return { value: item.id, text: labels.yesProgrammePrefix + item.name };
              })),
              optional: true,
              onChange: this.updateProgramme.bind(this)
            }) : null,
            this.state.programme !== undefined ? _react2.default.createElement('input', { type: 'hidden', name: 'portfolio', value: this.state.portfolio }) : null
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingTop: 30, paddingBottom: 80, clear: "left", float: "none" } },
            _react2.default.createElement('input', { className: 'cancel', type: 'submit', name: 'cancel', value: labels.actions.cancel }),
            this.props.project !== undefined && this.props.project.id !== undefined ? _react2.default.createElement('input', { className: 'save', style: { marginLeft: 15 }, type: 'submit', value: labels.actions.update + " " + (this.props.backgroundEdit === true ? labels.actions.background : labels.actions.project) }) : _react2.default.createElement('input', { className: 'save', style: { marginLeft: 15 }, type: 'submit', value: labels.actions.createProgramme })
          )
        )
      );
    }
  }]);

  return RegisterRelease;
}(_react2.default.Component);

var SelectProgramOrProject = function (_React$Component6) {
  _inherits(SelectProgramOrProject, _React$Component6);

  function SelectProgramOrProject(props) {
    _classCallCheck(this, SelectProgramOrProject);

    var _this8 = _possibleConstructorReturn(this, (SelectProgramOrProject.__proto__ || Object.getPrototypeOf(SelectProgramOrProject)).call(this, props));

    _this8.state = { name: "", identifier: "" };
    return _this8;
  }

  _createClass(SelectProgramOrProject, [{
    key: 'updateField',
    value: function updateField(event) {
      event.preventDefault();
      this.setState(_defineProperty({}, event.target.name, event.target.value));
    }
  }, {
    key: 'selectProject',
    value: function selectProject(event) {
      event.preventDefault();
      this.setState({ type: "project" });
    }
  }, {
    key: 'selectProgramme',
    value: function selectProgramme(event) {
      event.preventDefault();
      this.setState({ type: "programme" });
    }
  }, {
    key: 'selectProduct',
    value: function selectProduct(event) {
      event.preventDefault();
      this.setState({ type: "product" });
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).initiative;
      return this.state.type === "project" ? _react2.default.createElement(RegisterProject, _extends({}, this.props, {
        project: Object.assign({}, this.props.project, {
          name: this.state.name,
          identifier: this.state.identifier,
          portfolio: this.state.portfolio
        })
      })) : this.state.type === "programme" ? _react2.default.createElement(RegisterProgramme, _extends({}, this.props, {
        project: Object.assign({}, this.props.project, {
          name: this.state.name,
          identifier: this.state.identifier,
          portfolio: this.state.portfolio
        })
      })) : this.state.type === "product" ? _react2.default.createElement(RegisterProduct, _extends({}, this.props, {
        project: Object.assign({}, this.props.project, {
          name: this.state.name,
          identifier: this.state.identifier,
          portfolio: this.state.portfolio
        })
      })) : _react2.default.createElement(
        'div',
        { style: { marginTop: 30 } },
        _react2.default.createElement(
          _Area2.default,
          { title: labels.title },
          _react2.default.createElement(_Field2.default, {
            title: labels.fields.name.title,
            name: 'name',
            description: labels.fields.name.description,
            value: this.state.name,
            onChange: this.updateField.bind(this)
          }),
          _react2.default.createElement(_Field2.default, {
            title: labels.fields.identifier.title,
            optional: true,
            name: 'identifier',
            description: labels.fields.identifier.description,
            value: this.state.identifier,
            onChange: this.updateField.bind(this)
          }),
          this.props.tenant !== undefined && this.props.tenant.portfolios !== undefined && this.props.tenant.portfolios.length > 0 ? _react2.default.createElement(_Field2.default, {
            title: labels.fields.portfolio.title,
            name: 'portfolio',
            help: labels.fields.portfolio.help,
            value: this.state.portfolio,
            options: this.props.tenant.portfolios.map(function (portfolio) {
              return { value: portfolio.id, text: portfolio.name };
            }),
            onChange: this.updateField.bind(this)
          }) : null
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "grid", gridGap: "10px", gridAutoColumns: "1fr", gridAutoRows: "1fr", width: "100%", flexWrap: "wrap", justifyContent: "space-between", fontFamily: "Arial, Verdana, Geneva, sans-serif" } },
          _react2.default.createElement(
            'div',
            { style: { flexBasis: "49%", cursor: "pointer", borderRadius: 2, margin: 2, border: "solid 1px #8faadc", backgroundColor: "#b4c7e7", color: "#203864" }, onClick: this.selectProject.bind(this) },
            _react2.default.createElement(
              'h3',
              null,
              labels.fields.asProject
            ),
            _react2.default.createElement(
              'ul',
              { style: { textAlign: "left" } },
              labels.fields.projectCharacteristics.map(function (item, index) {
                return _react2.default.createElement(
                  'li',
                  { key: index },
                  item
                );
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { gridColumn: "2/2", cursor: "pointer", borderRadius: 2, margin: 2, border: "solid 1px #8faadc", backgroundColor: "#b4c7e7", color: "#203864" }, onClick: this.selectProgramme.bind(this) },
            _react2.default.createElement(
              'h3',
              null,
              labels.fields.asProgramme
            ),
            _react2.default.createElement(
              'ul',
              { style: { textAlign: "left" } },
              labels.fields.programmeCharacteristics.map(function (item, index) {
                return _react2.default.createElement(
                  'li',
                  { key: index },
                  item
                );
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { gridColumn: "1/2", gridRow: "2/2", cursor: "pointer", borderRadius: 2, margin: 2, border: "solid 1px #8faadc", backgroundColor: "#b4c7e7", color: "#203864" }, onClick: this.selectProduct.bind(this) },
            _react2.default.createElement(
              'h3',
              null,
              labels.fields.asProduct
            ),
            _react2.default.createElement(
              'ul',
              { style: { textAlign: "left" } },
              labels.fields.productCharacteristics.map(function (item, index) {
                return _react2.default.createElement(
                  'li',
                  { key: index },
                  item
                );
              })
            )
          )
        )
      );
    }
  }]);

  return SelectProgramOrProject;
}(_react2.default.Component);

var NewProject = exports.NewProject = function (_React$Component7) {
  _inherits(NewProject, _React$Component7);

  function NewProject() {
    _classCallCheck(this, NewProject);

    return _possibleConstructorReturn(this, (NewProject.__proto__ || Object.getPrototypeOf(NewProject)).apply(this, arguments));
  }

  _createClass(NewProject, [{
    key: 'render',
    value: function render() {
      return this.props.version === 2 ? _react2.default.createElement(
        'div',
        { style: { textAlign: "center", display: "flex", justifyContent: "center" } },
        _react2.default.createElement(
          'div',
          { style: { width: 1016 } },
          _react2.default.createElement(SelectProgramOrProject, this.props)
        )
      ) : _react2.default.createElement(RegisterProject, this.props);
    }
  }]);

  return NewProject;
}(_react2.default.Component);

var RegisterProject = function (_React$Component8) {
  _inherits(RegisterProject, _React$Component8);

  function RegisterProject() {
    _classCallCheck(this, RegisterProject);

    return _possibleConstructorReturn(this, (RegisterProject.__proto__ || Object.getPrototypeOf(RegisterProject)).apply(this, arguments));
  }

  _createClass(RegisterProject, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      var type = this.props.project !== undefined ? this.props.project.isProgramme === true ? "programme" : this.props.project.isProduct === true ? "product" : undefined : undefined;
      return _react2.default.createElement(
        'div',
        { style: { textAlign: "center", display: "flex", justifyContent: "center" } },
        _react2.default.createElement(
          'div',
          { style: { width: 1016 } },
          _react2.default.createElement(
            'form',
            { action: this.props.project !== undefined && this.props.project.isProgramme === true ? "/programmes/" : this.props.project !== undefined && this.props.project.isProduct !== undefined ? "/products/" : "/projects/", method: 'POST' },
            this.props.project !== undefined && this.props.project.id !== undefined ? _react2.default.createElement('input', { type: 'hidden', name: 'id', value: this.props.project.id }) : null,
            this.props.project !== undefined && this.props.backgroundEdit !== true ? _react2.default.createElement('input', { type: 'hidden', name: 'edit', value: 'properties' }) : _react2.default.createElement('input', { type: 'hidden', name: 'edit', value: 'background' }),
            this.props.backgroundEdit !== true ? _react2.default.createElement(ProjectProperties, this.props) : null,
            this.props.project === undefined || this.props.project.id === undefined || this.props.backgroundEdit === true ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(ProjectBackground, _extends({}, this.props, {
                type: type }))
            ) : null,
            _react2.default.createElement(
              'div',
              { style: { paddingTop: 30, paddingBottom: 80, clear: "left", float: "none" } },
              _react2.default.createElement('input', { className: 'cancel', type: 'submit', name: 'cancel', value: labels.actions.cancel }),
              this.props.project !== undefined && this.props.project.id !== undefined ? _react2.default.createElement('input', { className: 'save', style: { marginLeft: 15 }, type: 'submit', value: labels.actions.update + " " + (this.props.backgroundEdit === true ? type !== undefined && labels[type].actions.background !== undefined ? labels[type].actions.background : labels.actions.background : labels.actions.project) }) : _react2.default.createElement('input', { className: 'save', style: { marginLeft: 15 }, type: 'submit', value: labels.actions.createProject })
            )
          )
        )
      );
    }
  }]);

  return RegisterProject;
}(_react2.default.Component);

var NewProjectPage = function (_React$Component9) {
  _inherits(NewProjectPage, _React$Component9);

  function NewProjectPage() {
    _classCallCheck(this, NewProjectPage);

    return _possibleConstructorReturn(this, (NewProjectPage.__proto__ || Object.getPrototypeOf(NewProjectPage)).apply(this, arguments));
  }

  _createClass(NewProjectPage, [{
    key: 'render',
    value: function render() {
      var menu = this.props.showMenu === true ? _react2.default.createElement(_ProjectMenu2.default, this.props) : undefined;
      return _react2.default.createElement(
        _Layout2.default,
        _extends({}, this.props, { projectMenu: menu }),
        _react2.default.createElement(NewProject, this.props)
      );
    }
  }]);

  return NewProjectPage;
}(_react2.default.Component);

exports.default = NewProjectPage;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var english = exports.english = {
  definition: "definition",
  aspects: {
    time: "Time",
    scope: "Scope",
    cost: "Cost",
    quality: "Quality",
    risk: "Risk",
    scopeDescription: "Scope described in separate section."
  },
  background: {
    title: "Background",
    fields: {
      background: {
        title: "Why is this project initiated?",
        description: "Justification for the organizational activity (project)",
        help: "What is the business need this project is intended to address?\n        What is the problem we are trying to solve?\n        How do we know it is a problem?\n        Who are we solving the problem for, and how do we know they want this unmet need to be solved?"
      },
      timing: {
        title: "Why now?",
        description: "Justification for the timing",
        help: "What is the trigger that makes us want to do this right now?\n        Any external circumstances or internal factors? Any new insight, new technology or new strategy triggering the timing of this opportunity?"
      },
      bigPicture: {
        title: "The bigger picture",
        description: "Describe how the project is linked to higher level strategies or initiatives",
        help: "Is this project part of a larger strategic initiative?\n        How is it linked to the business strategy?"
      }
    }
  },
  objectives: {
    title: "Objectives",
    fields: {
      benefitsDescription: {
        title: "Key Benefits to be Delivered",
        description: "The planned measurable improvements from this project perceived as an advantage by one or more stakeholders",
        help: "What are the measurable improvements this project will deliver?\n        Which benefits are more important and which are less important?"
      },
      objectivesSummary: {
        title: "Project objectives",
        description: "Drag and drop the performance aspects to place them in the correct prioritized order.\n          If there is no specific objective on an aspect, leave it open. Aspects without objective description will not appear in Brief/PID.",
        help: "What are the performance goals for this project?\nAny ambitions or boundaries the project should use as input to planning?\nWhat are the project\u2019s Key Performance Indicators (KPIs)?\n\nTime:\n-\tIs there a time frame or deadline we need to meet?\n-\tIs there a business reason for this deadline?\nTime Tolerance: How much can the project forecast exceed the time objective before a notification is escalated beyond the Project Board?\n\nScope: (Do not start listing scope details or product features here)\n-\tWhat is it we are aiming to achieve by defining the scope like we are?\n-\tHow far does this project go? In short, what will the project take responsibility for?\n-\tIs the scope wide or narrow? If the scope is wide, why is it wide?\n-\tIf the scope is narrow, why is it narrow?\nScope Tolerance: How much can the scope change before the Project Board notifies the next level (or customer)?\n\nCost:\n- What do we expect or tolerate to spend on this project?\n\u2013 Why do we have this cost objective? What are the reasons behind it?\nCost Tolerance: When will awareness (or approval) of a forecasted change in cost have to be escalated beyond the Project Board?\n\nQuality: (Do not start listing detailed requirements or product features here)\n-\tWhat is the guiding star when defining the key characteristics of the main deliverables in this project?\n-\tWhat is the summarized objective of the key requirements, standards and regulations for the project's output?\nQuality Tolerance: How different can the main deliverables be before the Project Board should involve the next governance level (or the customer)?\n\nRisk: (Do not list specific project risks here)\n-\tWhat is an acceptable risk level for this project?\n-\tHow is the stakeholders\u2019 risk appetite?\n-\tAny specific risk objectives related to regulations, classified information or data privacy?\nRisk Tolerance: What is an acceptable risk level to be dealt with at the Project Board level?\nWhen is the accumulated risk exposure triggering a formal involvement beyond the Project Board?\n\n\nPriorities:\nWhen trade-offs have to be made, which one of the project objectives cannot be sacrificed?\nExplain the consequence of missing each of the priorities. Then, having considered that, which one is the most important driver.\n\xA0",
        columns: {
          pri: { title: "Pri" },
          name: { title: "Performance aspect" },
          description: {
            title: "Objective description"
            /*
            description: {
            time: "Describe when the project should be completed and/or the most important milestones",
            scope: "Describe the objective of scoping the project a certain way. How wide or how narrow will the scope have to be to succeed? Don’t list the scope elements",
            cost: "Define the cost target for this project. If relevant, split into different types of cost",
            quality: "Describe to what extent the project shall meet all (possible) requirements, standards and regulations. Do not list all requirements, but if important above all the rest, one or a few key requirements can be described.",
            risk: "Define if the risk appetite is high or low. Quantify if possible. Don’t list any risks."
            }
            */
          },
          tolerance: { title: "Tolerance" }
        }
      },
      objectives: {
        title: "Comments to objectives",
        description: "Other relevant information related to performance goals for this project"
      }
    }
  },
  scope: {
    title: "Scope",
    fields: {
      projectScope: {
        title: "Scope",
        description: "Drag and drop the scope items in the correct prioritized order",
        help: "What are we designing/making?\xA0\n              Is the project also taking care of:\n              1. Preparing launch?\n              2. Training of users, customers or internal functions?\n              3. Preparing any services or service functions?\n              4. Phasing out any old solutions?\n              5. Migration of data or equipment from old solution?\n              6. Integration with other solutions?\n              7. Preparing efficient production, operation and maintenance?\n              8. Targeting all users, geographies/languages, functions, segments?\n              9. Any follow-up responsibilities after roll-out?",
        samples: [{ text: "Something to build or design? For a specific department, function , geography or use?" }, { text: "Prepare any production/operation environment? Where?" }, { text: "Prepare any service or support functions? Which ones? How?" }, { text: "Roll-out/launch, prepare or train any users, sales organizations, customers? Where?" }],
        columns: {
          text: { title: "Break scope into separate short statements. One per line below." }
        }
      },
      scopeExclusions: {
        title: "Exclusions to scope",
        description: "Describe what the project will not deliver.",
        help: "Are there specific things the project will not deliver? Are there any functions, users, geographies or departments not included?"
      },
      outcomes: {
        title: "Expected Outcomes",
        description: "The result of change, normally affecting real-world behavior and/ or circumstances.",
        help: "How will the project enable your organization to serve its customers or users better? What new things (ability) can our customers (internal and external) do when the project is completed?"
      }
    }
  },
  constraints: {
    title: "Constraints",
    fields: {
      constraints: {
        title: "Constraints",
        description: "Restrictions or limitations the project is bound by",
        help: "Are there things other projects need to deliver into this project?\n          Are there any pre-standing commitments or expectations to other organizations or partners that need to be met? Timing commitments?\xA0\n          Are there any known practical limitations to execute this project?\n          1. The customer is expecting a certain type of solution\n          2. Product price constraint\n          3. Timing constraint \u2013 this opportunity is temporary, as other competitors may move into the market.\n          Will any special information security constraints apply to the project? Will the project deal with classified information?"
      },
      assumptions: {
        title: "Assumptions",
        description: "What is taken as being true for the purpose of planning, but which could change later. An assumption is made where some facts are not yet known or decided.",
        help: "Are there any assumptions about access to resources, tools, technology or competencies?\n              Any assumptions about the quality of existing data or equipment?\n              Any assumptions made about what other solutions will cover?"
      }
    }
  },
  stakeholders: {
    title: "Stakeholders & interfaces",
    fields: {
      stakeholderDescription: {
        title: "Stakeholders",
        description: "The users and any other knows interested parties",
        help: "For whose benefit is the project being undertaken?\n          Who is going to use the project\u2019s products? (Sales, Sourcing, etc.)\n          What customer group or department is the project intended to affect?\n          Who is likely to feel threatened by this project or have strong opinions?\n          Who needs to be happy with the result?\n          Who are the strong supporters of this project?\n          What partners are involved?\xA0\n          What vendors could be involved? "
      },
      interfaces: {
        title: "Interfaces",
        description: "Describe the project’s interfaces",
        help: "Is this project depending on other projects or activities?\n          Is the system or product connected in any way or working with other systems or products?\xA0\n          Are there any non-technical systems the project\u2019s products will need to interface with during their lifecycle or use?"
      }
    }
  },
  messages: {
    updateScope: "Please update scope before you use Project Product Description in 'Quality'.",
    deletedScope: "(deleted: please remove outputs)"
  }
};

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var norwegian = exports.norwegian = {
  definition: "definisjon",
  aspects: {
    time: "Tid",
    scope: "Omfang",
    cost: "Kostnad",
    quality: "Kvalitet",
    risk: "Risiko",
    scopeDescription: "Omfanget er beskrevet i separat seksjon."
  },
  background: {
    title: "Bakgrunn",
    fields: {
      background: {
        title: "Hvorfor er prosjektet satt i gang?",
        description: "Begrunnelse for organisasjonsaktiviteten (prosjekt)",
        help: "Hva er virksomhetenes behov dette prosjektet skal adressere?\n          Hvilket problemet pr\xF8ver vi \xE5 l\xF8se?\n          Hvordan vet vi at det er et problem?\n          Hvem l\xF8ser vi problemet for, og hvordan vet vi at de \xF8nsker \xE5 f\xE5 l\xF8st dette udekkede behovet?"
      },
      timing: {
        title: "Hvorfor nå?",
        description: "Begrunnelse for tidspunktet",
        help: "Hva er som utl\xF8ser at vi vil gj\xF8re dette akkurat n\xE5?\n          Eventuelle eksterne omstendigheter eller interne faktorer? En ny innsikt, ny teknologi eller en ny strategi som p\xE5virker tidspunktet for denne muligheten?"
      },
      bigPicture: {
        title: "Hvordan passer prosjektet i det store bildet?",
        description: "Beskriv hvordan prosjektet er knyttet til strategier på høyere nivå eller initiativ",
        help: "Er dette prosjektet en del av et st\xF8rre strategisk initiativ?\n          Hvordan er det knyttet til bedriftsstrategien?"
      }
    }
  },
  objectives: {
    title: "Mål",
    fields: {
      benefitsDescription: {
        title: "Viktigste gevinster som skal oppnås",
        description: "De planlagte målbare forbedringene fra dette prosjektet som oppfattes som en fordel for en eller flere interessenter",
        help: "Hvilke m\xE5lbare forbedringer vil dette prosjektet levere?\n          Hvilke gevinster er mer eller mindre viktige?"
      },
      objectivesSummary: {
        title: "Resultatmål",
        description: "Dra og slipp ytelsesomr\xE5dene for \xE5 plassere dem i korrekt prioritert rekkef\xF8lge.\n          Hvis det ikke er noe spesifkt m\xE5l p\xE5 et resultatomr\xE5de, la det st\xE5 tomt. Resltatomr\xE5de uten beskrivelse av m\xE5l vil ikke vises i Prosjektforslag eller Styringsdokument.",
        help: "Hva er resultatm\xE5lene for dette prosjektet? Eventuelle ambisjoner eller begrensninger prosjektet skal bruke som innspill til planlegging?\n          Tid: Hva er tidsrammen eller tidsfristen du har i tankene? - Hvorfor har du den fristen eller rammen i tankene?\n          Omfang: Er omfanget stort eller lite? Hvis det er stort, hvorfor er det stort? Hvis det er lite, hvorfor er det lite?\n          Kostnad: Hva ville du forvente \xE5 bruke p\xE5 dette prosjektet? - Hvorfor har du dette kostnadsm\xE5let? Hva er \xE5rsakene til det?\n          Kvalitet: Hva er de viktigste kravene, standarder og forskrifter? Er noen av dem valgfrie?\n          Risiko: Hva er et akseptabelt risikoniv\xE5 for dette prosjektet? Hvordan er interessenternes risikoappetitt? Eventuelle spesifikke risikom\xE5l knyttet til forskrifter, klassifisert informasjon eller personvern?\n\n          Toleranser:\n          Under hvilke forhold ville vi stoppe/avslutte prosjektet?\n          Hvor mye skal en prognose overstige m\xE5lene og planene f\xF8r prosjekteieren skal informere sine overordnede? (tid, kostnad, kvalitet)\n\n          Prioriteringer:\n          N\xE5r m\xE5 avveinger gj\xF8res, hvilken av faktorene for dette prosjektet m\xE5 oppn\xE5s (dvs hva er det som ikke kan ofres)?\n          Forklar konsekvensen av manglende oppfyllelse av hver av prioritetene. Etter \xE5 ha vurder det, hva er den viktigste faktoren?",
        columns: {
          pri: { title: "Pri" },
          description: { title: "Beskrivelse av mål" },
          name: { title: "Resultatområde" },
          tolerance: { title: "Toleranse" }
        }
      },
      objectives: {
        title: "Kommentarer til målene",
        description: "Annen relevant informasjon relatert til resultatmålene for dette prosjektet"
      }
    }
  },
  scope: {
    title: "Omfang",
    fields: {
      projectScope: {
        title: "Omfang",
        description: "Dra og slipp delene av omfanget i korrekt prioritert rekkefølge",
        help: "Hva designer / lager vi?\n          Ivaretar prosjektet ogs\xE5:\n          1. Oppstart?\n          2. Oppl\xE6ring av brukere, kunder eller interne funksjoner?\n          3. Klargj\xF8re tjenester eller tjenestefunksjoner?\n          4. Fase ut noen gamle l\xF8sninger?\n          5. Migrering av data eller utstyr fra gammel l\xF8sning?\n          6. Integrasjon med andre l\xF8sninger?\n          7. Forberedre effektiv drift og vedlikehold?\n          8. Alle brukere, geografiske omr\xE5der / spr\xE5k, funksjoner, segmenter?\n          9. Oppf\xF8lgingsaktiviteter etter oppstart?",
        samples: [{ text: "Bygge eller designe noe? For en spesifikk avdeling, funksjon, geografisk område eller bruk?" }, { text: "Forberede produksjons- eller drifsmiljø? Hvor?" }, { text: "Forbered service- eller støttefunksjoner? Hvilke? Hvordan?" }, { text: "Utrulling / lansering, forberede eller lære opp brukere, salgsorganisasjoner, kunder? Hvor?" }],
        columns: {
          text: { title: "Del opp omfanget i separate korte beskrivelser. En per linje nedenfor." }
        }
      },
      scopeExclusions: {
        title: "Utelukkelser fra omfanget",
        description: "Beskriv hva prosjektet ikke vil levere",
        help: "Er det spesifikke ting som prosjektet ikke vil levere? Er det noen funksjoner, brukere, geografiske områder eller avdelinger som ikke er inkludert?"
      },
      outcomes: {
        title: "Forventet resultat",
        description: "Resultatet av endring, som vanligvis påvirker reell oppførsel og / eller omstendigheter.",
        help: "Hvordan vil prosjektet gjøre det mulig for organisasjonen å betjene sine kunder eller brukere bedre? Hvilke nye ting (evne) kan våre kunder (intern og ekstern) gjøre når prosjektet er ferdig?"
      }
    }
  },
  constraints: {
    title: "Begrensninger",
    fields: {
      constraints: {
        title: "Begrensninger",
        description: "Restriksjoner eller begrensninger prosjektet er bundet av",
        help: "Er det andre ting som andre prosjekter m\xE5 levere inn i dette prosjektet?\n          Er det noen tidligere forpliktelser eller forventninger til andre organisasjoner eller partnere som m\xE5 oppfylles? Tidsforpliktelser?\n          Er det noen kjente praktiske begrensninger for \xE5 gjennomf\xF8re dette prosjektet?\n          1. Kunden forventer en bestemt type l\xF8sning\n          2. Produktprisbegrensning\n          3. Tidsbegrensning - denne muligheten er midlertidig, ettersom andre konkurrenter kan ta markedet.\n          Vil det v\xE6re spesielle sikkerhetsbetingelser for prosjektet? Vil prosjektet h\xE5ndtere klassifisert informasjon?"
      },
      assumptions: {
        title: "Antagelser",
        description: "Hva er det som er annatt å være sant for planlegging, men som kan forandre seg senere? En antagelse er gjort for fakta som ikke er kjent enda eller besluttet.",
        help: "Er det noen antagelser om tilgang til ressurser, verkt\xF8y, teknologi eller kompetanse?\n              Er det noen antagelser om datakvalitet eller utstyr i eksisterende l\xF8sning?\n              Er det noen antagelser om hva andre l\xF8sninger vil dekke?"
      }
    }
  },
  stakeholders: {
    title: "Interessenter & grensesnitt",
    fields: {
      stakeholderDescription: {
        title: "Interessenter",
        description: "Brukerne og andre kjente interesserte parter",
        help: "Hvem f\xE5r fordel av at prosjektet gjennomf\xF8res?\n          Hvem skal bruke prosjektets produkter? (salg, sourcing, etc.)\n          Hvilken kundegruppe eller avdeling er prosjektet ment \xE5 p\xE5virke?\n          Hvem vil sannsynligvis f\xF8le seg truet av dette prosjektet eller har sterke meninger?\n          Hvem trenger \xE5 v\xE6re forn\xF8yd med resultatet?\n          Hvem er sterke st\xF8ttespillere til dette prosjektet?\n          Hvilke partnere er involvert?\n          Hvilke leverand\xF8rer kan v\xE6re involvert?"
      },
      interfaces: {
        title: "Grensesnitt",
        description: "Beskriv prosjektets grensesnitt",
        help: "Er dette prosjektet avhengig av andre prosjekter?\n          Er systemet eller produktet forbundet eller fungerer sammen med andre systemer eller produkter?\n          Er det noen ikke-tekniske systemer som prosjektets produkter vil trenge samhandling med gjennom deres livsyklus eller bruk?"
      }
    }
  },
  messages: {
    updateScope: "Vennligst oppdater omfang før du legger inn prosjektproduktbeskrivelsen under 'Kvalitet'.",
    deletedScope: "(slettet: vennligst fjern tilknyttede leveranser)"
  }
};

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);
var document = __webpack_require__(5).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var core = __webpack_require__(47);
var LIBRARY = __webpack_require__(67);
var wksExt = __webpack_require__(266);
var defineProperty = __webpack_require__(20).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(106)('keys');
var uid = __webpack_require__(75);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 182 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(5).document;
module.exports = document && document.documentElement;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(10);
var anObject = __webpack_require__(3);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(48)(Function.call, __webpack_require__(41).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);
var setPrototypeOf = __webpack_require__(184).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(50);
var defined = __webpack_require__(54);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 188 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 189 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(67);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(34);
var hide = __webpack_require__(33);
var Iterators = __webpack_require__(99);
var $iterCreate = __webpack_require__(191);
var setToStringTag = __webpack_require__(96);
var getPrototypeOf = __webpack_require__(42);
var ITERATOR = __webpack_require__(14)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(78);
var descriptor = __webpack_require__(74);
var setToStringTag = __webpack_require__(96);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(33)(IteratorPrototype, __webpack_require__(14)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(135);
var defined = __webpack_require__(54);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(14)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(99);
var ITERATOR = __webpack_require__(14)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(20);
var createDesc = __webpack_require__(74);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(97);
var ITERATOR = __webpack_require__(14)('iterator');
var Iterators = __webpack_require__(99);
module.exports = __webpack_require__(47).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(537);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(22);
var toAbsoluteIndex = __webpack_require__(77);
var toLength = __webpack_require__(16);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(69);
var step = __webpack_require__(283);
var Iterators = __webpack_require__(99);
var toIObject = __webpack_require__(40);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(190)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(109);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(134)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(48);
var invoke = __webpack_require__(273);
var html = __webpack_require__(183);
var cel = __webpack_require__(179);
var global = __webpack_require__(5);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(49)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var macrotask = __webpack_require__(202).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(49)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(27);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var DESCRIPTORS = __webpack_require__(19);
var LIBRARY = __webpack_require__(67);
var $typed = __webpack_require__(141);
var hide = __webpack_require__(33);
var redefineAll = __webpack_require__(83);
var fails = __webpack_require__(7);
var anInstance = __webpack_require__(81);
var toInteger = __webpack_require__(50);
var toLength = __webpack_require__(16);
var toIndex = __webpack_require__(293);
var gOPN = __webpack_require__(79).f;
var dP = __webpack_require__(20).f;
var arrayFill = __webpack_require__(198);
var setToStringTag = __webpack_require__(96);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var english = exports.english = {
  general: {
    login: "Login",
    profile: "Profile",
    searchCriteria: "Enter search criteria",
    search: "Search",
    addProject: "Add project",
    filterProjects: "Filter projects",
    projectMenu: "Project menu",
    otherPortfolio: "Other",
    unknownTenantName: "Your name",
    sections: {
      programmes: "Programmes",
      projects: "Projects",
      projectsAndReleases: "Projects and Releases",
      releases: "Releases",
      products: "Products and Platforms"
    }
  },
  requestedStageTransition: "Requested",
  requestedPhase: "Requested phase",
  projectStatus: {
    stopped: "stopped",
    paused: "paused"
  },
  columns: {
    portfolio: "Portfolio",
    numberOfProjects: "# Activities",
    priority: "Priority",
    name: "Name",
    status: "Status",
    stage: "Part",
    benefits: "Benefits",
    time: "Time",
    cost: "Cost",
    quality: "Quality",
    scope: "Scope",
    risk: "Risk"
  },
  inactive: {
    hide: "Hide inactive projects",
    show: "Show {0} inactive project{1}",
    projectsPlural: "s"
  },
  prioritize: {
    drop: "Drop your prioritized project or release here"
  },
  empty: "No projects in portfolio, please add a project.",
  programme: {
    columns: {
      name: "Programme Name",
      stage: "Tranche"
    },
    prioritize: {
      drop: "Drop your prioritized programmes here"
    },
    inactive: {
      hide: "Hide inactive programmes",
      show: "Show {0} inactive programme{1}"
    }
  },
  product: {
    noActiveReleases: "No active release",
    columns: {
      name: "Product Name",
      stage: "Release"
    },
    prioritize: {
      drop: "Drop your prioritized products here"
    },
    inactive: {
      hide: "Hide inactive products",
      show: "Show {0} inactive product{1}"
    }
  }
};

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var norwegian = exports.norwegian = {
  general: {
    login: "Logg inn",
    profile: "Profil",
    searchCriteria: "Angi søkekriterie",
    search: "Søk",
    addProject: "Legg til prosjekt",
    filterProjects: "Filtrer prosjekt",
    projectMenu: "Prosjektmeny",
    otherPortfolio: "Annet",
    unknownTenantName: "Ditt navn",
    sections: {
      programmes: "Program",
      projects: "Prosjekter",
      projectsAndReleases: "Prosjekter og oppdateringer",
      releases: "Oppdateringer",
      products: "Produkter og plattformer"
    }
  },
  requestedStageTransition: "Forespurt",
  requestedPhase: "Forespurt fase",
  projectStatus: {
    stopped: "stoppet",
    paused: "pauset"
  },
  columns: {
    portfolio: "Portefølje",
    numberOfProjects: "# Aktiviteter",
    priority: "Prioritet",
    name: "Navn",
    status: "Status",
    stage: "Del",
    benefits: "Gevinst",
    time: "Tid",
    cost: "Kostnad",
    quality: "Kvalitet",
    scope: "Omfang",
    risk: "Risiko"
  },
  inactive: {
    hide: "Skjul inaktive prosjekter",
    show: "Vis {0} inaktive prosjekt{1}",
    projectsPlural: "er"
  },
  prioritize: {
    drop: "Slipp dine prioriterte prosjekter eller oppdateringer her"
  },
  empty: "Ingen prosjekter i porteføljen, vennligst legg til ett prosjekt.",
  programme: {
    columns: {
      name: "Programnavn",
      stage: "Seksjon"
    },
    prioritize: {
      drop: "Slipp dine prioriterte program her"
    },
    inactive: {
      hide: "Skjul inaktive progam",
      show: "Vis {0} inaktive program"
    }
  },
  product: {
    noActiveReleases: "Ingen aktiv oppdatering",
    columns: {
      name: "Produktnavn",
      stage: "Oppdatering"
    },
    prioritize: {
      drop: "Slipp dine prioriterte produkter her"
    },
    inactive: {
      hide: "Skjul inaktive produkter",
      show: "Vis {0} inaktive produkt"
    }
  }
};

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Status = function (_React$Component) {
  _inherits(Status, _React$Component);

  function Status() {
    _classCallCheck(this, Status);

    return _possibleConstructorReturn(this, (Status.__proto__ || Object.getPrototypeOf(Status)).apply(this, arguments));
  }

  _createClass(Status, [{
    key: 'imageLink',
    value: function imageLink(status) {
      var prefix = this.props.prefix !== undefined ? this.props.prefix : "/";
      switch (status) {
        case "green":
          return prefix + "images/greenlight.png";
        case "yellow":
          return prefix + "images/yellowlight.png";
        case "red":
          return prefix + "images/redlight.png";
        default:
          return undefined;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('img', { style: this.props.style, src: this.imageLink(this.props.value) });
    }
  }]);

  return Status;
}(_react2.default.Component);

exports.default = Status;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDay = formatDay;
exports.formatMonthTitle = formatMonthTitle;
exports.formatWeekdayShort = formatWeekdayShort;
exports.formatWeekdayLong = formatWeekdayLong;
exports.getFirstDayOfWeek = getFirstDayOfWeek;
exports.getMonths = getMonths;
var WEEKDAYS_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

var WEEKDAYS_SHORT = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

function formatDay(day) {
  return day.toDateString();
}

function formatMonthTitle(d) {
  return MONTHS[d.getMonth()] + ' ' + d.getFullYear();
}

function formatWeekdayShort(i) {
  return WEEKDAYS_SHORT[i];
}

function formatWeekdayLong(i) {
  return WEEKDAYS_LONG[i];
}

function getFirstDayOfWeek() {
  return 0;
}

function getMonths() {
  return MONTHS;
}

exports.default = {
  formatDay: formatDay,
  formatMonthTitle: formatMonthTitle,
  formatWeekdayShort: formatWeekdayShort,
  formatWeekdayLong: formatWeekdayLong,
  getFirstDayOfWeek: getFirstDayOfWeek,
  getMonths: getMonths
};
//# sourceMappingURL=LocaleUtils.js.map

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DragDropContext = __webpack_require__(315);

Object.defineProperty(exports, 'DragDropContext', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragDropContext).default;
  }
});

var _DragDropContextProvider = __webpack_require__(754);

Object.defineProperty(exports, 'DragDropContextProvider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragDropContextProvider).default;
  }
});

var _DragLayer = __webpack_require__(755);

Object.defineProperty(exports, 'DragLayer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragLayer).default;
  }
});

var _DragSource = __webpack_require__(756);

Object.defineProperty(exports, 'DragSource', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragSource).default;
  }
});

var _DropTarget = __webpack_require__(766);

Object.defineProperty(exports, 'DropTarget', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DropTarget).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(116);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(321),
    setCacheAdd = __webpack_require__(720),
    setCacheHas = __webpack_require__(721);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 213 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(722);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 215 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 216 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 217 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 218 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(322),
    isLength = __webpack_require__(324);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = shallowEqual;
function shallowEqual(objA, objB) {
	if (objA === objB) {
		return true;
	}

	var keysA = Object.keys(objA);
	var keysB = Object.keys(objB);

	if (keysA.length !== keysB.length) {
		return false;
	}

	// Test for A's keys different from B.
	var hasOwn = Object.prototype.hasOwnProperty;
	for (var i = 0; i < keysA.length; i += 1) {
		if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
			return false;
		}

		var valA = objA[keysA[i]];
		var valB = objB[keysA[i]];

		if (valA !== valB) {
			return false;
		}
	}

	return true;
}

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = isDisposable;

function isDisposable(obj) {
  return Boolean(obj && typeof obj.dispose === 'function');
}

module.exports = exports['default'];

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FILE = exports.FILE = '__NATIVE_FILE__';
var URL = exports.URL = '__NATIVE_URL__';
var TEXT = exports.TEXT = '__NATIVE_TEXT__';

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _priority = __webpack_require__(102);

var _priority2 = _interopRequireDefault(_priority);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrioirtyItem = function (_React$Component) {
  _inherits(PrioirtyItem, _React$Component);

  function PrioirtyItem() {
    _classCallCheck(this, PrioirtyItem);

    return _possibleConstructorReturn(this, (PrioirtyItem.__proto__ || Object.getPrototypeOf(PrioirtyItem)).apply(this, arguments));
  }

  _createClass(PrioirtyItem, [{
    key: 'render',
    value: function render() {
      return this.props.items.length > 1 && this.props.showId !== true ? _react2.default.createElement(
        'div',
        { style: { paddingTop: 2 } },
        _react2.default.createElement(
          'span',
          null,
          '...'
        )
      ) : this.props.items.length === 1 || this.props.showId === true ? _react2.default.createElement(
        'div',
        { style: { paddingTop: 5, color: this.props.items[0].readOnly ? "#505050" : undefined } },
        this.props.items[0].no || this.props.no
      ) : null;
    }
  }]);

  return PrioirtyItem;
}(_react2.default.Component);

var PriorityTableEntryDisplay = function (_React$Component2) {
  _inherits(PriorityTableEntryDisplay, _React$Component2);

  function PriorityTableEntryDisplay() {
    _classCallCheck(this, PriorityTableEntryDisplay);

    return _possibleConstructorReturn(this, (PriorityTableEntryDisplay.__proto__ || Object.getPrototypeOf(PriorityTableEntryDisplay)).apply(this, arguments));
  }

  _createClass(PriorityTableEntryDisplay, [{
    key: 'selectItem',
    value: function selectItem() {
      this.props.onSelect(this.props);
    }
  }, {
    key: 'render',
    value: function render() {
      var item = this.props;
      return _react2.default.createElement(
        'div',
        { key: item.id, style: { paddingBottom: 3 } },
        this.props.onSelect !== undefined && this.props.readOnly !== true ? _react2.default.createElement(
          'a',
          { href: '#', onClick: this.selectItem.bind(this) },
          item.no
        ) : item.no,
        ' ',
        item.title,
        item.proximity !== undefined ? _react2.default.createElement(
          'span',
          null,
          ' (',
          item.proximity,
          ')'
        ) : null
      );
    }
  }]);

  return PriorityTableEntryDisplay;
}(_react2.default.Component);

var PriorityMarker = function (_React$Component3) {
  _inherits(PriorityMarker, _React$Component3);

  function PriorityMarker(props) {
    _classCallCheck(this, PriorityMarker);

    var _this3 = _possibleConstructorReturn(this, (PriorityMarker.__proto__ || Object.getPrototypeOf(PriorityMarker)).call(this, props));

    _this3.state = { tip: false };
    return _this3;
  }

  _createClass(PriorityMarker, [{
    key: 'showTip',
    value: function showTip(event) {
      event.preventDefault();
      this.setState({ tip: !this.state.tip });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var border = "solid 1px white";
      var background = "#ffffff";
      var color = "#212121";
      var opacity = 1;
      if (this.props.items.length === 1 && this.props.items[0].style === "faded") {
        border = "dashed 1px grey";
        background = "#e6e6e6";
        color = "grey";
        opacity = 0.7;
      }

      return this.props.items.length > 0 ? _react2.default.createElement(
        'div',
        { onClick: this.props.preventDetails === true ? null : this.showTip.bind(this), style: { cursor: "pointer", position: "relative", display: "inline-block", border: border, borderRadius: 30, height: 30, width: 30, backgroundColor: background, color: color, opacity: opacity, textAlign: "center" } },
        _react2.default.createElement(PrioirtyItem, _extends({}, this.props, { items: this.props.items })),
        this.state.tip ? _react2.default.createElement(
          'div',
          { onClick: this.showTip.bind(this), style: { position: "absolute", border: "1px solid #E5E5E5", boxShadow: "0px 8px 16px rgba(0,0,0,0.15)", borderRadius: 4, textAlign: "left", left: 10, padding: 10, zIndex: 1, width: 250, backgroundColor: "white" } },
          this.props.items.map(function (item, index) {
            return _react2.default.createElement(PriorityTableEntryDisplay, _extends({ key: index }, item, { onSelect: _this4.props.onSelect }));
          })
        ) : null
      ) : null;
    }
  }]);

  return PriorityMarker;
}(_react2.default.Component);

var PriorityCell = function (_React$Component4) {
  _inherits(PriorityCell, _React$Component4);

  function PriorityCell() {
    _classCallCheck(this, PriorityCell);

    return _possibleConstructorReturn(this, (PriorityCell.__proto__ || Object.getPrototypeOf(PriorityCell)).apply(this, arguments));
  }

  _createClass(PriorityCell, [{
    key: 'selected',
    value: function selected(event) {
      if (this.props.onClick !== undefined) {
        this.props.onClick({ target: { value: { row: this.props.row, column: this.props.column } } });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'td',
        { onClick: this.selected.bind(this), style: { textAlign: "center", verticalAlign: "middle", width: this.props.size, height: this.props.size, backgroundColor: _priority2.default.priorityColor(this.props.color, this.props.profile) } },
        _react2.default.createElement(PriorityMarker, this.props)
      );
    }
  }]);

  return PriorityCell;
}(_react2.default.Component);

var PriorityRow = function (_React$Component5) {
  _inherits(PriorityRow, _React$Component5);

  function PriorityRow() {
    _classCallCheck(this, PriorityRow);

    return _possibleConstructorReturn(this, (PriorityRow.__proto__ || Object.getPrototypeOf(PriorityRow)).apply(this, arguments));
  }

  _createClass(PriorityRow, [{
    key: 'render',
    value: function render() {
      var _this7 = this;

      var size = this.props.size;
      var items = this.props.items;
      return _react2.default.createElement(
        'tr',
        null,
        this.props.colors.map(function (cellColor, index) {
          return _react2.default.createElement(PriorityCell, _extends({}, _this7.props, { key: index, size: size, color: cellColor, onSelect: _this7.props.onSelect, items: items.filter(function (item) {
              return item.column === index + 1;
            }), column: index + 1 }));
        })
      );
    }
  }]);

  return PriorityRow;
}(_react2.default.Component);

var PriorityTable = function (_React$Component6) {
  _inherits(PriorityTable, _React$Component6);

  function PriorityTable() {
    _classCallCheck(this, PriorityTable);

    return _possibleConstructorReturn(this, (PriorityTable.__proto__ || Object.getPrototypeOf(PriorityTable)).apply(this, arguments));
  }

  _createClass(PriorityTable, [{
    key: 'render',
    value: function render() {
      var _this9 = this;

      var labels = this.props.labels;
      var size = 40;
      var items = this.props.items.filter(function (item) {
        return item.status !== "Closed";
      });
      var probabilityLabelStyle = Object.assign({}, { width: (size + 4) * 5 + 2, fontWeight: "bold", textAlign: "center", display: "inline-block", transform: "rotate(-90deg)", transformOrigin: "left top 0", WebkitTransform: "rotate(270deg)", MozTransform: "rotate(270deg)", MsTransform: "rotate(270deg)", OTransform: "rotate(270deg)" }, this.props.settings !== undefined ? this.props.settings.riskTable : {});
      var rowCount = 5;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { display: "inline-block", position: "relative", width: 20 } },
          _react2.default.createElement(
            'div',
            { style: probabilityLabelStyle },
            labels.row
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "inline-block" } },
          _react2.default.createElement(
            'table',
            null,
            _react2.default.createElement(
              'tbody',
              null,
              _priority2.default.getTableColors(rowCount, this.props.profile).map(function (row, index) {
                return _react2.default.createElement(PriorityRow, _extends({ key: row.label }, _this9.props, { onSelect: _this9.props.onSelect, id: row.label, label: row.label, size: size, colors: row.colors, row: rowCount - index,
                  items: items.filter(function (item) {
                    return item.row === row.value;
                  }) }));
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { textAlign: "center", fontWeight: "bold" } },
            labels.column
          )
        )
      );
    }
  }]);

  return PriorityTable;
}(_react2.default.Component);

exports.default = PriorityTable;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var BlockMapBuilder = __webpack_require__(120);

var CharacterMetadata = __webpack_require__(43);

var ContentBlock = __webpack_require__(88);

var ContentBlockNode = __webpack_require__(44);

var DraftEntity = __webpack_require__(158);

var SelectionState = __webpack_require__(159);

var generateRandomKey = __webpack_require__(57);

var getOwnObjectValues = __webpack_require__(346);

var gkx = __webpack_require__(70);

var Immutable = __webpack_require__(4);

var sanitizeDraftText = __webpack_require__(348);

var List = Immutable.List,
    Record = Immutable.Record,
    Repeat = Immutable.Repeat,
    ImmutableMap = Immutable.Map,
    OrderedMap = Immutable.OrderedMap;
var defaultRecord = {
  entityMap: null,
  blockMap: null,
  selectionBefore: null,
  selectionAfter: null
};
var ContentStateRecord = Record(defaultRecord);
/* $FlowFixMe[signature-verification-failure] Supressing a `signature-
 * verification-failure` error here. TODO: T65949050 Clean up the branch for
 * this GK */

var ContentBlockNodeRecord = gkx('draft_tree_data_support') ? ContentBlockNode : ContentBlock;

var ContentState = /*#__PURE__*/function (_ContentStateRecord) {
  _inheritsLoose(ContentState, _ContentStateRecord);

  function ContentState() {
    return _ContentStateRecord.apply(this, arguments) || this;
  }

  var _proto = ContentState.prototype;

  _proto.getEntityMap = function getEntityMap() {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity;
  };

  _proto.getBlockMap = function getBlockMap() {
    return this.get('blockMap');
  };

  _proto.getSelectionBefore = function getSelectionBefore() {
    return this.get('selectionBefore');
  };

  _proto.getSelectionAfter = function getSelectionAfter() {
    return this.get('selectionAfter');
  };

  _proto.getBlockForKey = function getBlockForKey(key) {
    var block = this.getBlockMap().get(key);
    return block;
  };

  _proto.getKeyBefore = function getKeyBefore(key) {
    return this.getBlockMap().reverse().keySeq().skipUntil(function (v) {
      return v === key;
    }).skip(1).first();
  };

  _proto.getKeyAfter = function getKeyAfter(key) {
    return this.getBlockMap().keySeq().skipUntil(function (v) {
      return v === key;
    }).skip(1).first();
  };

  _proto.getBlockAfter = function getBlockAfter(key) {
    return this.getBlockMap().skipUntil(function (_, k) {
      return k === key;
    }).skip(1).first();
  };

  _proto.getBlockBefore = function getBlockBefore(key) {
    return this.getBlockMap().reverse().skipUntil(function (_, k) {
      return k === key;
    }).skip(1).first();
  };

  _proto.getBlocksAsArray = function getBlocksAsArray() {
    return this.getBlockMap().toArray();
  };

  _proto.getFirstBlock = function getFirstBlock() {
    return this.getBlockMap().first();
  };

  _proto.getLastBlock = function getLastBlock() {
    return this.getBlockMap().last();
  };

  _proto.getPlainText = function getPlainText(delimiter) {
    return this.getBlockMap().map(function (block) {
      return block ? block.getText() : '';
    }).join(delimiter || '\n');
  };

  _proto.getLastCreatedEntityKey = function getLastCreatedEntityKey() {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity.__getLastCreatedEntityKey();
  };

  _proto.hasText = function hasText() {
    var blockMap = this.getBlockMap();
    return blockMap.size > 1 || // make sure that there are no zero width space chars
    escape(blockMap.first().getText()).replace(/%u200B/g, '').length > 0;
  };

  _proto.createEntity = function createEntity(type, mutability, data) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__create(type, mutability, data);

    return this;
  };

  _proto.mergeEntityData = function mergeEntityData(key, toMerge) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__mergeData(key, toMerge);

    return this;
  };

  _proto.replaceEntityData = function replaceEntityData(key, newData) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__replaceData(key, newData);

    return this;
  };

  _proto.addEntity = function addEntity(instance) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__add(instance);

    return this;
  };

  _proto.getEntity = function getEntity(key) {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity.__get(key);
  };

  _proto.getAllEntities = function getAllEntities() {
    return DraftEntity.__getAll();
  };

  _proto.loadWithEntities = function loadWithEntities(entities) {
    return DraftEntity.__loadWithEntities(entities);
  };

  ContentState.createFromBlockArray = function createFromBlockArray( // TODO: update flow type when we completely deprecate the old entity API
  blocks, entityMap) {
    // TODO: remove this when we completely deprecate the old entity API
    var theBlocks = Array.isArray(blocks) ? blocks : blocks.contentBlocks;
    var blockMap = BlockMapBuilder.createFromArray(theBlocks);
    var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());
    return new ContentState({
      blockMap: blockMap,
      entityMap: entityMap || DraftEntity,
      selectionBefore: selectionState,
      selectionAfter: selectionState
    });
  };

  ContentState.createFromText = function createFromText(text) {
    var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /\r\n?|\n/g;
    var strings = text.split(delimiter);
    var blocks = strings.map(function (block) {
      block = sanitizeDraftText(block);
      return new ContentBlockNodeRecord({
        key: generateRandomKey(),
        text: block,
        type: 'unstyled',
        characterList: List(Repeat(CharacterMetadata.EMPTY, block.length))
      });
    });
    return ContentState.createFromBlockArray(blocks);
  };

  ContentState.fromJS = function fromJS(state) {
    return new ContentState(_objectSpread({}, state, {
      blockMap: OrderedMap(state.blockMap).map(ContentState.createContentBlockFromJS),
      selectionBefore: new SelectionState(state.selectionBefore),
      selectionAfter: new SelectionState(state.selectionAfter)
    }));
  };

  ContentState.createContentBlockFromJS = function createContentBlockFromJS(block) {
    var characterList = block.characterList;
    return new ContentBlockNodeRecord(_objectSpread({}, block, {
      data: ImmutableMap(block.data),
      characterList: characterList != null ? List((Array.isArray(characterList) ? characterList : getOwnObjectValues(characterList)).map(function (c) {
        return CharacterMetadata.fromJS(c);
      })) : undefined
    }));
  };

  return ContentState;
}(ContentStateRecord);

module.exports = ContentState;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/**
 * Basic (stateless) API for text direction detection
 *
 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */


var UnicodeBidiDirection = __webpack_require__(160);

var invariant = __webpack_require__(9);

/**
 * RegExp ranges of characters with a *Strong* Bidi_Class value.
 *
 * Data is based on DerivedBidiClass.txt in UCD version 7.0.0.
 *
 * NOTE: For performance reasons, we only support Unicode's
 *       Basic Multilingual Plane (BMP) for now.
 */
var RANGE_BY_BIDI_TYPE = {
  L: "A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u01BA\u01BB" + "\u01BC-\u01BF\u01C0-\u01C3\u01C4-\u0293\u0294\u0295-\u02AF\u02B0-\u02B8" + "\u02BB-\u02C1\u02D0-\u02D1\u02E0-\u02E4\u02EE\u0370-\u0373\u0376-\u0377" + "\u037A\u037B-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1" + "\u03A3-\u03F5\u03F7-\u0481\u0482\u048A-\u052F\u0531-\u0556\u0559" + "\u055A-\u055F\u0561-\u0587\u0589\u0903\u0904-\u0939\u093B\u093D" + "\u093E-\u0940\u0949-\u094C\u094E-\u094F\u0950\u0958-\u0961\u0964-\u0965" + "\u0966-\u096F\u0970\u0971\u0972-\u0980\u0982-\u0983\u0985-\u098C" + "\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD" + "\u09BE-\u09C0\u09C7-\u09C8\u09CB-\u09CC\u09CE\u09D7\u09DC-\u09DD" + "\u09DF-\u09E1\u09E6-\u09EF\u09F0-\u09F1\u09F4-\u09F9\u09FA\u0A03" + "\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33" + "\u0A35-\u0A36\u0A38-\u0A39\u0A3E-\u0A40\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F" + "\u0A72-\u0A74\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0" + "\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0ABE-\u0AC0\u0AC9\u0ACB-\u0ACC\u0AD0" + "\u0AE0-\u0AE1\u0AE6-\u0AEF\u0AF0\u0B02-\u0B03\u0B05-\u0B0C\u0B0F-\u0B10" + "\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B35-\u0B39\u0B3D\u0B3E\u0B40" + "\u0B47-\u0B48\u0B4B-\u0B4C\u0B57\u0B5C-\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F" + "\u0B70\u0B71\u0B72-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95" + "\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9" + "\u0BBE-\u0BBF\u0BC1-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7" + "\u0BE6-\u0BEF\u0BF0-\u0BF2\u0C01-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10" + "\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C41-\u0C44\u0C58-\u0C59\u0C60-\u0C61" + "\u0C66-\u0C6F\u0C7F\u0C82-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8" + "\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CBE\u0CBF\u0CC0-\u0CC4\u0CC6" + "\u0CC7-\u0CC8\u0CCA-\u0CCB\u0CD5-\u0CD6\u0CDE\u0CE0-\u0CE1\u0CE6-\u0CEF" + "\u0CF1-\u0CF2\u0D02-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D" + "\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D57\u0D60-\u0D61" + "\u0D66-\u0D6F\u0D70-\u0D75\u0D79\u0D7A-\u0D7F\u0D82-\u0D83\u0D85-\u0D96" + "\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD1\u0DD8-\u0DDF" + "\u0DE6-\u0DEF\u0DF2-\u0DF3\u0DF4\u0E01-\u0E30\u0E32-\u0E33\u0E40-\u0E45" + "\u0E46\u0E4F\u0E50-\u0E59\u0E5A-\u0E5B\u0E81-\u0E82\u0E84\u0E87-\u0E88" + "\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7" + "\u0EAA-\u0EAB\u0EAD-\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6" + "\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F01-\u0F03\u0F04-\u0F12\u0F13\u0F14" + "\u0F15-\u0F17\u0F1A-\u0F1F\u0F20-\u0F29\u0F2A-\u0F33\u0F34\u0F36\u0F38" + "\u0F3E-\u0F3F\u0F40-\u0F47\u0F49-\u0F6C\u0F7F\u0F85\u0F88-\u0F8C" + "\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE-\u0FCF\u0FD0-\u0FD4\u0FD5-\u0FD8" + "\u0FD9-\u0FDA\u1000-\u102A\u102B-\u102C\u1031\u1038\u103B-\u103C\u103F" + "\u1040-\u1049\u104A-\u104F\u1050-\u1055\u1056-\u1057\u105A-\u105D\u1061" + "\u1062-\u1064\u1065-\u1066\u1067-\u106D\u106E-\u1070\u1075-\u1081" + "\u1083-\u1084\u1087-\u108C\u108E\u108F\u1090-\u1099\u109A-\u109C" + "\u109E-\u109F\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FB\u10FC" + "\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288" + "\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5" + "\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1360-\u1368" + "\u1369-\u137C\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166D-\u166E" + "\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EB-\u16ED\u16EE-\u16F0" + "\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1735-\u1736" + "\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17B6\u17BE-\u17C5" + "\u17C7-\u17C8\u17D4-\u17D6\u17D7\u17D8-\u17DA\u17DC\u17E0-\u17E9" + "\u1810-\u1819\u1820-\u1842\u1843\u1844-\u1877\u1880-\u18A8\u18AA" + "\u18B0-\u18F5\u1900-\u191E\u1923-\u1926\u1929-\u192B\u1930-\u1931" + "\u1933-\u1938\u1946-\u194F\u1950-\u196D\u1970-\u1974\u1980-\u19AB" + "\u19B0-\u19C0\u19C1-\u19C7\u19C8-\u19C9\u19D0-\u19D9\u19DA\u1A00-\u1A16" + "\u1A19-\u1A1A\u1A1E-\u1A1F\u1A20-\u1A54\u1A55\u1A57\u1A61\u1A63-\u1A64" + "\u1A6D-\u1A72\u1A80-\u1A89\u1A90-\u1A99\u1AA0-\u1AA6\u1AA7\u1AA8-\u1AAD" + "\u1B04\u1B05-\u1B33\u1B35\u1B3B\u1B3D-\u1B41\u1B43-\u1B44\u1B45-\u1B4B" + "\u1B50-\u1B59\u1B5A-\u1B60\u1B61-\u1B6A\u1B74-\u1B7C\u1B82\u1B83-\u1BA0" + "\u1BA1\u1BA6-\u1BA7\u1BAA\u1BAE-\u1BAF\u1BB0-\u1BB9\u1BBA-\u1BE5\u1BE7" + "\u1BEA-\u1BEC\u1BEE\u1BF2-\u1BF3\u1BFC-\u1BFF\u1C00-\u1C23\u1C24-\u1C2B" + "\u1C34-\u1C35\u1C3B-\u1C3F\u1C40-\u1C49\u1C4D-\u1C4F\u1C50-\u1C59" + "\u1C5A-\u1C77\u1C78-\u1C7D\u1C7E-\u1C7F\u1CC0-\u1CC7\u1CD3\u1CE1" + "\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF2-\u1CF3\u1CF5-\u1CF6\u1D00-\u1D2B" + "\u1D2C-\u1D6A\u1D6B-\u1D77\u1D78\u1D79-\u1D9A\u1D9B-\u1DBF\u1E00-\u1F15" + "\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D" + "\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC" + "\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200E" + "\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D" + "\u2124\u2126\u2128\u212A-\u212D\u212F-\u2134\u2135-\u2138\u2139" + "\u213C-\u213F\u2145-\u2149\u214E\u214F\u2160-\u2182\u2183-\u2184" + "\u2185-\u2188\u2336-\u237A\u2395\u249C-\u24E9\u26AC\u2800-\u28FF" + "\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2C7B\u2C7C-\u2C7D\u2C7E-\u2CE4" + "\u2CEB-\u2CEE\u2CF2-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F" + "\u2D70\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE" + "\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005\u3006\u3007" + "\u3021-\u3029\u302E-\u302F\u3031-\u3035\u3038-\u303A\u303B\u303C" + "\u3041-\u3096\u309D-\u309E\u309F\u30A1-\u30FA\u30FC-\u30FE\u30FF" + "\u3105-\u312D\u3131-\u318E\u3190-\u3191\u3192-\u3195\u3196-\u319F" + "\u31A0-\u31BA\u31F0-\u31FF\u3200-\u321C\u3220-\u3229\u322A-\u3247" + "\u3248-\u324F\u3260-\u327B\u327F\u3280-\u3289\u328A-\u32B0\u32C0-\u32CB" + "\u32D0-\u32FE\u3300-\u3376\u337B-\u33DD\u33E0-\u33FE\u3400-\u4DB5" + "\u4E00-\u9FCC\uA000-\uA014\uA015\uA016-\uA48C\uA4D0-\uA4F7\uA4F8-\uA4FD" + "\uA4FE-\uA4FF\uA500-\uA60B\uA60C\uA610-\uA61F\uA620-\uA629\uA62A-\uA62B" + "\uA640-\uA66D\uA66E\uA680-\uA69B\uA69C-\uA69D\uA6A0-\uA6E5\uA6E6-\uA6EF" + "\uA6F2-\uA6F7\uA722-\uA76F\uA770\uA771-\uA787\uA789-\uA78A\uA78B-\uA78E" + "\uA790-\uA7AD\uA7B0-\uA7B1\uA7F7\uA7F8-\uA7F9\uA7FA\uA7FB-\uA801" + "\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA823-\uA824\uA827\uA830-\uA835" + "\uA836-\uA837\uA840-\uA873\uA880-\uA881\uA882-\uA8B3\uA8B4-\uA8C3" + "\uA8CE-\uA8CF\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8F8-\uA8FA\uA8FB\uA900-\uA909" + "\uA90A-\uA925\uA92E-\uA92F\uA930-\uA946\uA952-\uA953\uA95F\uA960-\uA97C" + "\uA983\uA984-\uA9B2\uA9B4-\uA9B5\uA9BA-\uA9BB\uA9BD-\uA9C0\uA9C1-\uA9CD" + "\uA9CF\uA9D0-\uA9D9\uA9DE-\uA9DF\uA9E0-\uA9E4\uA9E6\uA9E7-\uA9EF" + "\uA9F0-\uA9F9\uA9FA-\uA9FE\uAA00-\uAA28\uAA2F-\uAA30\uAA33-\uAA34" + "\uAA40-\uAA42\uAA44-\uAA4B\uAA4D\uAA50-\uAA59\uAA5C-\uAA5F\uAA60-\uAA6F" + "\uAA70\uAA71-\uAA76\uAA77-\uAA79\uAA7A\uAA7B\uAA7D\uAA7E-\uAAAF\uAAB1" + "\uAAB5-\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADC\uAADD\uAADE-\uAADF" + "\uAAE0-\uAAEA\uAAEB\uAAEE-\uAAEF\uAAF0-\uAAF1\uAAF2\uAAF3-\uAAF4\uAAF5" + "\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E" + "\uAB30-\uAB5A\uAB5B\uAB5C-\uAB5F\uAB64-\uAB65\uABC0-\uABE2\uABE3-\uABE4" + "\uABE6-\uABE7\uABE9-\uABEA\uABEB\uABEC\uABF0-\uABF9\uAC00-\uD7A3" + "\uD7B0-\uD7C6\uD7CB-\uD7FB\uE000-\uF8FF\uF900-\uFA6D\uFA70-\uFAD9" + "\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFF6F\uFF70" + "\uFF71-\uFF9D\uFF9E-\uFF9F\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF" + "\uFFD2-\uFFD7\uFFDA-\uFFDC",
  R: "\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u05CF\u05D0-\u05EA\u05EB-\u05EF" + "\u05F0-\u05F2\u05F3-\u05F4\u05F5-\u05FF\u07C0-\u07C9\u07CA-\u07EA" + "\u07F4-\u07F5\u07FA\u07FB-\u07FF\u0800-\u0815\u081A\u0824\u0828" + "\u082E-\u082F\u0830-\u083E\u083F\u0840-\u0858\u085C-\u085D\u085E" + "\u085F-\u089F\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB37\uFB38-\uFB3C" + "\uFB3D\uFB3E\uFB3F\uFB40-\uFB41\uFB42\uFB43-\uFB44\uFB45\uFB46-\uFB4F",
  AL: "\u0608\u060B\u060D\u061B\u061C\u061D\u061E-\u061F\u0620-\u063F\u0640" + "\u0641-\u064A\u066D\u066E-\u066F\u0671-\u06D3\u06D4\u06D5\u06E5-\u06E6" + "\u06EE-\u06EF\u06FA-\u06FC\u06FD-\u06FE\u06FF\u0700-\u070D\u070E\u070F" + "\u0710\u0712-\u072F\u074B-\u074C\u074D-\u07A5\u07B1\u07B2-\u07BF" + "\u08A0-\u08B2\u08B3-\u08E3\uFB50-\uFBB1\uFBB2-\uFBC1\uFBC2-\uFBD2" + "\uFBD3-\uFD3D\uFD40-\uFD4F\uFD50-\uFD8F\uFD90-\uFD91\uFD92-\uFDC7" + "\uFDC8-\uFDCF\uFDF0-\uFDFB\uFDFC\uFDFE-\uFDFF\uFE70-\uFE74\uFE75" + "\uFE76-\uFEFC\uFEFD-\uFEFE"
};
var REGEX_STRONG = new RegExp('[' + RANGE_BY_BIDI_TYPE.L + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
var REGEX_RTL = new RegExp('[' + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
/**
 * Returns the first strong character (has Bidi_Class value of L, R, or AL).
 *
 * @param str  A text block; e.g. paragraph, table cell, tag
 * @return     A character with strong bidi direction, or null if not found
 */

function firstStrongChar(str) {
  var match = REGEX_STRONG.exec(str);
  return match == null ? null : match[0];
}
/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL).
 *
 * @param str  A text block; e.g. paragraph, table cell, tag
 * @return     The resolved direction
 */


function firstStrongCharDir(str) {
  var strongChar = firstStrongChar(str);

  if (strongChar == null) {
    return UnicodeBidiDirection.NEUTRAL;
  }

  return REGEX_RTL.exec(strongChar) ? UnicodeBidiDirection.RTL : UnicodeBidiDirection.LTR;
}
/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
 * direction, if no strong character is found.
 *
 * This function is supposed to be used in respect to Higher-Level Protocol
 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
 *
 * @param str       A text block; e.g. paragraph, table cell, tag
 * @param fallback  Fallback direction, used if no strong direction detected
 *                  for the block (default = NEUTRAL)
 * @return          The resolved direction
 */


function resolveBlockDir(str, fallback) {
  fallback = fallback || UnicodeBidiDirection.NEUTRAL;

  if (!str.length) {
    return fallback;
  }

  var blockDir = firstStrongCharDir(str);
  return blockDir === UnicodeBidiDirection.NEUTRAL ? fallback : blockDir;
}
/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
 * direction, if no strong character is found.
 *
 * NOTE: This function is similar to resolveBlockDir(), but uses the global
 * direction as the fallback, so it *always* returns a Strong direction,
 * making it useful for integration in places that you need to make the final
 * decision, like setting some CSS class.
 *
 * This function is supposed to be used in respect to Higher-Level Protocol
 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                The resolved Strong direction
 */


function getDirection(str, strongFallback) {
  if (!strongFallback) {
    strongFallback = UnicodeBidiDirection.getGlobalDir();
  }

  !UnicodeBidiDirection.isStrong(strongFallback) ?  false ? invariant(false, 'Fallback direction must be a strong direction') : invariant(false) : void 0;
  return resolveBlockDir(str, strongFallback);
}
/**
 * Returns true if getDirection(arguments...) returns LTR.
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                True if the resolved direction is LTR
 */


function isDirectionLTR(str, strongFallback) {
  return getDirection(str, strongFallback) === UnicodeBidiDirection.LTR;
}
/**
 * Returns true if getDirection(arguments...) returns RTL.
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                True if the resolved direction is RTL
 */


function isDirectionRTL(str, strongFallback) {
  return getDirection(str, strongFallback) === UnicodeBidiDirection.RTL;
}

var UnicodeBidi = {
  firstStrongChar: firstStrongChar,
  firstStrongCharDir: firstStrongCharDir,
  resolveBlockDir: resolveBlockDir,
  getDirection: getDirection,
  isDirectionLTR: isDirectionLTR,
  isDirectionRTL: isDirectionRTL
};
module.exports = UnicodeBidi;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var React = __webpack_require__(1);

var cx = __webpack_require__(89);

var _require = __webpack_require__(4),
    Map = _require.Map;

var UL_WRAP = React.createElement("ul", {
  className: cx('public/DraftStyleDefault/ul')
});
var OL_WRAP = React.createElement("ol", {
  className: cx('public/DraftStyleDefault/ol')
});
var PRE_WRAP = React.createElement("pre", {
  className: cx('public/DraftStyleDefault/pre')
});
var DefaultDraftBlockRenderMap = Map({
  'header-one': {
    element: 'h1'
  },
  'header-two': {
    element: 'h2'
  },
  'header-three': {
    element: 'h3'
  },
  'header-four': {
    element: 'h4'
  },
  'header-five': {
    element: 'h5'
  },
  'header-six': {
    element: 'h6'
  },
  section: {
    element: 'section'
  },
  article: {
    element: 'article'
  },
  'unordered-list-item': {
    element: 'li',
    wrapper: UL_WRAP
  },
  'ordered-list-item': {
    element: 'li',
    wrapper: OL_WRAP
  },
  blockquote: {
    element: 'blockquote'
  },
  atomic: {
    element: 'figure'
  },
  'code-block': {
    element: 'pre',
    wrapper: PRE_WRAP
  },
  unstyled: {
    element: 'div',
    aliasedElements: ['p']
  }
});
module.exports = DefaultDraftBlockRenderMap;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var _require = __webpack_require__(358),
    notEmptyKey = _require.notEmptyKey;
/**
 * Return the entity key that should be used when inserting text for the
 * specified target selection, only if the entity is `MUTABLE`. `IMMUTABLE`
 * and `SEGMENTED` entities should not be used for insertion behavior.
 */


function getEntityKeyForSelection(contentState, targetSelection) {
  var entityKey;

  if (targetSelection.isCollapsed()) {
    var key = targetSelection.getAnchorKey();
    var offset = targetSelection.getAnchorOffset();

    if (offset > 0) {
      entityKey = contentState.getBlockForKey(key).getEntityAt(offset - 1);

      if (entityKey !== contentState.getBlockForKey(key).getEntityAt(offset)) {
        return null;
      }

      return filterKey(contentState.getEntityMap(), entityKey);
    }

    return null;
  }

  var startKey = targetSelection.getStartKey();
  var startOffset = targetSelection.getStartOffset();
  var startBlock = contentState.getBlockForKey(startKey);
  entityKey = startOffset === startBlock.getLength() ? null : startBlock.getEntityAt(startOffset);
  return filterKey(contentState.getEntityMap(), entityKey);
}
/**
 * Determine whether an entity key corresponds to a `MUTABLE` entity. If so,
 * return it. If not, return null.
 */


function filterKey(entityMap, entityKey) {
  if (notEmptyKey(entityKey)) {
    var entity = entityMap.__get(entityKey);

    return entity.getMutability() === 'MUTABLE' ? entityKey : null;
  }

  return null;
}

module.exports = getEntityKeyForSelection;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var isTextNode = __webpack_require__(836);
/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */


function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * @param {DOMElement} element
 * @param {DOMDocument} doc
 * @return {boolean}
 */
function _isViewportScrollElement(element, doc) {
  return !!doc && (element === doc.documentElement || element === doc.body);
}
/**
 * Scroll Module. This class contains 4 simple static functions
 * to be used to access Element.scrollTop/scrollLeft properties.
 * To solve the inconsistencies between browsers when either
 * document.body or document.documentElement is supplied,
 * below logic will be used to alleviate the issue:
 *
 * 1. If 'element' is either 'document.body' or 'document.documentElement,
 *    get whichever element's 'scroll{Top,Left}' is larger.
 * 2. If 'element' is either 'document.body' or 'document.documentElement',
 *    set the 'scroll{Top,Left}' on both elements.
 */


var Scroll = {
  /**
   * @param {DOMElement} element
   * @return {number}
   */
  getTop: function getTop(element) {
    var doc = element.ownerDocument;
    return _isViewportScrollElement(element, doc) ? // In practice, they will either both have the same value,
    // or one will be zero and the other will be the scroll position
    // of the viewport. So we can use `X || Y` instead of `Math.max(X, Y)`
    doc.body.scrollTop || doc.documentElement.scrollTop : element.scrollTop;
  },

  /**
   * @param {DOMElement} element
   * @param {number} newTop
   */
  setTop: function setTop(element, newTop) {
    var doc = element.ownerDocument;

    if (_isViewportScrollElement(element, doc)) {
      doc.body.scrollTop = doc.documentElement.scrollTop = newTop;
    } else {
      element.scrollTop = newTop;
    }
  },

  /**
   * @param {DOMElement} element
   * @return {number}
   */
  getLeft: function getLeft(element) {
    var doc = element.ownerDocument;
    return _isViewportScrollElement(element, doc) ? doc.body.scrollLeft || doc.documentElement.scrollLeft : element.scrollLeft;
  },

  /**
   * @param {DOMElement} element
   * @param {number} newLeft
   */
  setLeft: function setLeft(element, newLeft) {
    var doc = element.ownerDocument;

    if (_isViewportScrollElement(element, doc)) {
      doc.body.scrollLeft = doc.documentElement.scrollLeft = newLeft;
    } else {
      element.scrollLeft = newLeft;
    }
  }
};
module.exports = Scroll;

/***/ }),
/* 231 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var warning = __webpack_require__(233);
/**
 * Given a collapsed selection, move the focus `maxDistance` backward within
 * the selected block. If the selection will go beyond the start of the block,
 * move focus to the end of the previous block, but no further.
 *
 * This function is not Unicode-aware, so surrogate pairs will be treated
 * as having length 2.
 */


function moveSelectionBackward(editorState, maxDistance) {
  var selection = editorState.getSelection(); // Should eventually make this an invariant

   false ? warning(selection.isCollapsed(), 'moveSelectionBackward should only be called with a collapsed SelectionState') : void 0;
  var content = editorState.getCurrentContent();
  var key = selection.getStartKey();
  var offset = selection.getStartOffset();
  var focusKey = key;
  var focusOffset = 0;

  if (maxDistance > offset) {
    var keyBefore = content.getKeyBefore(key);

    if (keyBefore == null) {
      focusKey = key;
    } else {
      focusKey = keyBefore;
      var blockBefore = content.getBlockForKey(keyBefore);
      focusOffset = blockBefore.getText().length;
    }
  } else {
    focusOffset = offset - maxDistance;
  }

  return selection.merge({
    focusKey: focusKey,
    focusOffset: focusOffset,
    isBackward: true
  });
}

module.exports = moveSelectionBackward;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var emptyFunction = __webpack_require__(367);
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */


function printWarning(format) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var argIndex = 0;
  var message = 'Warning: ' + format.replace(/%s/g, function () {
    return args[argIndex++];
  });

  if (typeof console !== 'undefined') {
    console.error(message);
  }

  try {
    // --- Welcome to debugging React ---
    // This error was thrown as a convenience so that you can use this stack
    // to find the callsite that caused this warning to fire.
    throw new Error(message);
  } catch (x) {}
}

var warning =  false ? function (condition, format) {
  if (format === undefined) {
    throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
  }

  if (!condition) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      args[_key2 - 2] = arguments[_key2];
    }

    printWarning.apply(void 0, [format].concat(args));
  }
} : emptyFunction;
module.exports = warning;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var UserAgent = __webpack_require__(31);

var isSoftNewlineEvent = __webpack_require__(864);

var isOSX = UserAgent.isPlatform('Mac OS X');
var KeyBindingUtil = {
  /**
   * Check whether the ctrlKey modifier is *not* being used in conjunction with
   * the altKey modifier. If they are combined, the result is an `altGraph`
   * key modifier, which should not be handled by this set of key bindings.
   */
  isCtrlKeyCommand: function isCtrlKeyCommand(e) {
    return !!e.ctrlKey && !e.altKey;
  },
  isOptionKeyCommand: function isOptionKeyCommand(e) {
    return isOSX && e.altKey;
  },
  usesMacOSHeuristics: function usesMacOSHeuristics() {
    return isOSX;
  },
  hasCommandModifier: function hasCommandModifier(e) {
    return isOSX ? !!e.metaKey && !e.altKey : KeyBindingUtil.isCtrlKeyCommand(e);
  },
  isSoftNewlineEvent: isSoftNewlineEvent
};
module.exports = KeyBindingUtil;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(12);

var invariant = __webpack_require__(6);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(12);

var ReactErrorUtils = __webpack_require__(237);

var invariant = __webpack_require__(6);
var warning = __webpack_require__(18);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = function () {
        func(a);
      };
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(32);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMLazyTree = __webpack_require__(104);
var Danger = __webpack_require__(898);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactInstrumentation = __webpack_require__(45);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(243);
var setInnerHTML = __webpack_require__(169);
var setTextContent = __webpack_require__(388);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(12);

var ReactPropTypesSecret = __webpack_require__(916);
var propTypesFactory = __webpack_require__(306);

var React = __webpack_require__(85);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(6);
var warning = __webpack_require__(18);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(12);

var invariant = __webpack_require__(6);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(12),
    _assign = __webpack_require__(8);

var ReactCompositeComponent = __webpack_require__(921);
var ReactEmptyComponent = __webpack_require__(394);
var ReactHostComponent = __webpack_require__(395);

var getNextDebugID = __webpack_require__(922);
var invariant = __webpack_require__(6);
var warning = __webpack_require__(18);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(12);

var ReactCurrentOwner = __webpack_require__(62);
var ReactInstanceMap = __webpack_require__(127);
var ReactInstrumentation = __webpack_require__(45);
var ReactUpdates = __webpack_require__(52);

var invariant = __webpack_require__(6);
var warning = __webpack_require__(18);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(8);

var emptyFunction = __webpack_require__(65);
var warning = __webpack_require__(18);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _draftJs = __webpack_require__(38);

exports.default = {
  createLinkAtSelection: function createLinkAtSelection(editorState, url) {
    var contentState = editorState.getCurrentContent().createEntity('LINK', 'MUTABLE', { url: url });
    var entityKey = contentState.getLastCreatedEntityKey();
    var withLink = _draftJs.RichUtils.toggleLink(editorState, editorState.getSelection(), entityKey);
    return _draftJs.EditorState.forceSelection(withLink, editorState.getSelection());
  },
  removeLinkAtSelection: function removeLinkAtSelection(editorState) {
    var selection = editorState.getSelection();
    return _draftJs.RichUtils.toggleLink(editorState, selection, null);
  },
  getCurrentEntityKey: function getCurrentEntityKey(editorState) {
    var selection = editorState.getSelection();
    var anchorKey = selection.getAnchorKey();
    var contentState = editorState.getCurrentContent();
    var anchorBlock = contentState.getBlockForKey(anchorKey);
    var offset = selection.anchorOffset;
    var index = selection.isBackward ? offset - 1 : offset;
    return anchorBlock.getEntityAt(index);
  },
  getCurrentEntity: function getCurrentEntity(editorState) {
    var contentState = editorState.getCurrentContent();
    var entityKey = this.getCurrentEntityKey(editorState);
    return entityKey ? contentState.getEntity(entityKey) : null;
  },
  hasEntity: function hasEntity(editorState, entityType) {
    var entity = this.getCurrentEntity(editorState);
    return entity && entity.getType() === entityType;
  }
};

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Returns an array of all `ContentBlock` instances within two block keys
 *
 * @param  {object} contentState A draft.js `ContentState` instance
 * @param  {string} anchorKey    The block key to start searching from
 * @param  {string} focusKey     The block key until which to search
 *
 * @return {array} An array containing the found content blocks
 */
/* harmony default export */ __webpack_exports__["a"] = (function (contentState, anchorKey, focusKey) {
  var isSameBlock = anchorKey === focusKey;
  var startingBlock = contentState.getBlockForKey(anchorKey);

  if (!startingBlock) {
    return [];
  }

  var selectedBlocks = [startingBlock];

  if (!isSameBlock) {
    var blockKey = anchorKey;

    while (blockKey !== focusKey) {
      var nextBlock = contentState.getBlockAfter(blockKey);

      if (!nextBlock) {
        selectedBlocks = [];
        break;
      }

      selectedBlocks.push(nextBlock);
      blockKey = nextBlock.getKey();
    }
  }

  return selectedBlocks;
});

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = riskResponseLabel;
function riskResponseLabel(response, language) {
  var languageLabels = {
    norwegian: {
      responses: {
        "Reduce": "Reduseres",
        "Avoid": "Unngås",
        "Transfer": "Overføres",
        "Accept": "Aksepteres",
        "Share": "Deles",
        "Enhance": "Forbedres",
        "Exploit": "Utnyttes",
        "Reject": "Avvises",
        "ContingencyPlan": "Beredskapsplan"
      }
    }
  };
  var labels = languageLabels[language];
  return labels !== undefined && labels.responses !== undefined && labels.responses[response] ? labels.responses[response] : response;
}

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sortByDate;
function sortByDate(reportA, reportB) {
  return new Date(reportA.date).toISOString().slice(0, 10) < new Date(reportB.date).toISOString().slice(0, 10) ? -1 : new Date(reportA.date).toISOString().slice(0, 10) > new Date(reportB.date).toISOString().slice(0, 10) ? 1 : new Date(reportA.timestamp) < new Date(reportB.timestamp) ? -1 : new Date(reportA.timestamp) > new Date(reportB.timestamp) ? 1 : 0;
}

module.exports = sortByDate;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReportContent = exports.Report = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _ProjectMenu = __webpack_require__(17);

var _ProjectMenu2 = _interopRequireDefault(_ProjectMenu);

var _HighlightReport = __webpack_require__(105);

var _HighlightReport2 = _interopRequireDefault(_HighlightReport);

var _Risk = __webpack_require__(63);

var _Change = __webpack_require__(95);

var _sortByDate = __webpack_require__(257);

var _sortByDate2 = _interopRequireDefault(_sortByDate);

var _Slides = __webpack_require__(259);

var _Slides2 = _interopRequireDefault(_Slides);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Report = exports.Report = function (_React$Component) {
  _inherits(Report, _React$Component);

  function Report() {
    _classCallCheck(this, Report);

    return _possibleConstructorReturn(this, (Report.__proto__ || Object.getPrototypeOf(Report)).apply(this, arguments));
  }

  _createClass(Report, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var link = (this.props.project.isRelease !== undefined ? "/releases/" : this.props.project.isProgramme !== undefined ? "/programmes/" : this.props.project.isProduct !== undefined ? "/products/" : "/projects/") + this.props.project.id + "/highlight?version=3";
      var reports = this.props.project.highlights !== undefined ? this.props.project.highlights.filter(function (report) {
        return report.stage === undefined && report.endProject !== true || _this2.props.showEndStage === true || _this2.props.selected !== undefined && report.id === _this2.props.selected;
      }) : undefined;
      var labelsLanguage = {
        norwegian: {
          title: "Statusrapport",
          noReportsAvailable: _react2.default.createElement(
            'i',
            null,
            'Ingen statusrappor er tilgjengelig enda. Statusrapporter skrives i ',
            _react2.default.createElement(
              'a',
              { href: link },
              '"Progress" delen'
            ),
            '.'
          ),
          risks: "Risiko",
          issues: "Saker"
        },
        english: {
          title: "Highlight Report",
          noReportsAvailable: _react2.default.createElement(
            'i',
            null,
            'No highlight report available yet. Highlight reports are written in the ',
            _react2.default.createElement(
              'a',
              { href: link },
              '"Progress" area'
            ),
            '.'
          ),
          risks: "Risks",
          issues: "Issues"
        }
      };
      var labels = labelsLanguage[this.props.language] || labelsLanguage["english"];
      var layout = undefined;
      if (this.props.tenant.design !== undefined) {
        if (this.props.tenant.design.reportLogo !== undefined && this.props.tenant.design.reportLogo !== null) {
          layout = {
            reportLogo: this.props.tenant.design.reportLogo
          };
        } else {
          layout = Object.assign({}, this.props.tenant.design, { useLogo: true });
        }
      }
      var pageNo = "{{page}}";
      var pages = "{{pages}}";
      var style = Object.assign({}, { maxWidth: 1016, textAlign: "left", pageBreakInside: "avoid" }, this.props.settings !== undefined ? this.props.settings.style : undefined);
      var selected = reports !== undefined ? reports.filter(function (report) {
        return report.id === _this2.props.selected;
      })[0] : undefined;
      if (selected === undefined && (this.props.selected === "draft" || this.props.selected === "preview") && this.props.project.draftHighlight !== undefined && this.props.user.id === this.props.project.draftHighlight.updatedBy) {
        selected = Object.assign({}, this.props.project.draftHighlight, {
          summary: this.props.project.draftHighlight.overallStatus,
          date: this.props.project.draftHighlight.statusDate,
          type: this.props.selected,
          risk: Object.assign({}, this.props.project.draftHighlight.risk, {
            items: this.props.project.isProgramme || this.props.project.isProduct ? this.props.risks : this.props.project.risks
          }),
          change: this.props.includeChange ? {
            items: this.props.project.isProgramme || this.props.project.isProduct ? this.props.issues : this.props.project.issues
          } : undefined
        });
      }
      var risk = selected !== undefined ? selected.risk : undefined; //this.props.project.highlights!==undefined ? this.props.project.highlights.slice(-1)[0].risk : undefined;
      var change = this.props.includeChange && selected !== undefined ? selected.change : undefined; //{items:this.props.project.issues} : undefined;
      var slides = [_react2.default.createElement(_HighlightReport2.default, _extends({}, selected, { language: this.props.language, project: this.props.project,
        settings: this.props.settings, profile: this.props.profile, presentationMode: this.props.presentationMode,
        slideNo: 0 })), _react2.default.createElement(_HighlightReport2.default, _extends({}, selected, { language: this.props.language, project: this.props.project,
        settings: this.props.settings, profile: this.props.profile, presentationMode: this.props.presentationMode,
        slideNo: 1 })), _react2.default.createElement(_HighlightReport2.default, _extends({}, selected, { language: this.props.language, project: this.props.project,
        settings: this.props.settings, profile: this.props.profile, presentationMode: this.props.presentationMode,
        slideNo: 2 })), _react2.default.createElement(_HighlightReport2.default, _extends({}, selected, { language: this.props.language, project: this.props.project,
        settings: this.props.settings, profile: this.props.profile, presentationMode: this.props.presentationMode,
        slideNo: 3 })), _react2.default.createElement(_HighlightReport2.default, _extends({}, selected, { language: this.props.language, project: this.props.project,
        settings: this.props.settings, profile: this.props.profile, presentationMode: this.props.presentationMode,
        slideNo: 4 })), _react2.default.createElement(_HighlightReport2.default, _extends({}, selected, { language: this.props.language, project: this.props.project,
        settings: this.props.settings, profile: this.props.profile, presentationMode: this.props.presentationMode,
        slideNo: 5 })), _react2.default.createElement(_HighlightReport2.default, _extends({}, selected, { language: this.props.language, project: this.props.project,
        settings: this.props.settings, profile: this.props.profile, presentationMode: this.props.presentationMode,
        slideNo: 6 })), _react2.default.createElement(_HighlightReport2.default, _extends({}, selected, { language: this.props.language, project: this.props.project,
        settings: this.props.settings, profile: this.props.profile, presentationMode: this.props.presentationMode,
        slideNo: 7 })), _react2.default.createElement(_HighlightReport2.default, _extends({}, selected, { language: this.props.language, project: this.props.project,
        settings: this.props.settings, profile: this.props.profile, presentationMode: this.props.presentationMode,
        slideNo: 8 }))];
      var slideTitles = [_react2.default.createElement(_HighlightReport.HighlightReportSlideTitle, _extends({}, selected, { language: this.props.language, project: this.props.project,
        settings: this.props.settings, profile: this.props.profile, presentationMode: this.props.presentationMode,
        slideNo: 0 })), _react2.default.createElement(_HighlightReport.HighlightReportSlideTitle, _extends({}, selected, { language: this.props.language, project: this.props.project,
        settings: this.props.settings, profile: this.props.profile, presentationMode: this.props.presentationMode,
        slideNo: 1 })), _react2.default.createElement(_HighlightReport.HighlightReportSlideTitle, _extends({}, selected, { language: this.props.language, project: this.props.project,
        settings: this.props.settings, profile: this.props.profile, presentationMode: this.props.presentationMode,
        slideNo: 2 })), _react2.default.createElement(_HighlightReport.HighlightReportSlideTitle, _extends({}, selected, { language: this.props.language, project: this.props.project,
        settings: this.props.settings, profile: this.props.profile, presentationMode: this.props.presentationMode,
        slideNo: 3 })), _react2.default.createElement(_HighlightReport.HighlightReportSlideTitle, _extends({}, selected, { language: this.props.language, project: this.props.project,
        settings: this.props.settings, profile: this.props.profile, presentationMode: this.props.presentationMode,
        slideNo: 4 })), _react2.default.createElement(_HighlightReport.HighlightReportSlideTitle, _extends({}, selected, { language: this.props.language, project: this.props.project,
        settings: this.props.settings, profile: this.props.profile, presentationMode: this.props.presentationMode,
        slideNo: 5 })), _react2.default.createElement(_HighlightReport.HighlightReportSlideTitle, _extends({}, selected, { language: this.props.language, project: this.props.project,
        settings: this.props.settings, profile: this.props.profile, presentationMode: this.props.presentationMode,
        slideNo: 6 })), _react2.default.createElement(_HighlightReport.HighlightReportSlideTitle, _extends({}, selected, { language: this.props.language, project: this.props.project,
        settings: this.props.settings, profile: this.props.profile, presentationMode: this.props.presentationMode,
        slideNo: 7 })), _react2.default.createElement(_HighlightReport.HighlightReportSlideTitle, _extends({}, selected, { language: this.props.language, project: this.props.project,
        settings: this.props.settings, profile: this.props.profile, presentationMode: this.props.presentationMode,
        slideNo: 8 }))];
      return _react2.default.createElement(
        'div',
        { style: { padding: 5, paddingLeft: 10, fontFamily: "Verdana, sans-serif", textAlign: "center" } },
        (reports === undefined || reports.length === 0) && selected === undefined ? _react2.default.createElement(
          'div',
          { style: { display: "inline-block", textAlign: "left" } },
          _react2.default.createElement(
            'h2',
            null,
            labels.title
          ),
          labels.noReportsAvailable
        ) : _react2.default.createElement(
          'div',
          { style: { display: "inline-block", textAlign: "left" } },
          this.props.fullPage && layout !== undefined ? _react2.default.createElement(
            'div',
            { style: { float: "right" } },
            layout.useLogo === undefined ? _react2.default.createElement('img', { src: layout.reportLogo }) : _react2.default.createElement('div', { style: { marginTop: 15, display: "inline-block", height: layout.height, width: layout.width, backgroundImage: "url('" + layout.logo + "')", backgroundPosition: layout.position, backgroundSize: layout.size !== undefined ? layout.size : "contain", backgroundRepeat: "no-repeat" } })
          ) : null,
          this.props.settings !== undefined && this.props.settings.showFooter ? _react2.default.createElement(
            'div',
            { id: 'pageFooter', style: { textAlign: "center", fontSize: "7pt", fontFamily: "Verdana" } },
            pageNo,
            '/',
            pages
          ) : null,
          this.props.presentationMode !== true ? _react2.default.createElement(_HighlightReport2.default, _extends({}, selected, {
            language: this.props.language,
            project: this.props.project,
            settings: this.props.settings,
            profile: this.props.profile,
            presentationMode: this.props.presentationMode
          })) : _react2.default.createElement(_Slides2.default, { slides: slides, slideTitles: slideTitles })
        ),
        _react2.default.createElement('div', { style: { position: "relative", pageBreakAfter: "always", pageBreakInside: "avoid" } }),
        this.props.settings !== undefined && this.props.settings.includedRisk === false && risk !== undefined && risk.items !== undefined && risk.items !== null && risk.items.length > 0 && risk.items.filter(function (item) {
          return item.status !== "Closed";
        }).length > 0 ? _react2.default.createElement(
          'div',
          { style: style },
          _react2.default.createElement(
            'h2',
            null,
            labels.risks
          ),
          _react2.default.createElement(_Risk.RiskReport, _extends({}, this.props, { settings: this.props.settings, items: risk.items.filter(function (item) {
              return item.status !== "Closed";
            }) }))
        ) : null,
        this.props.settings !== undefined && this.props.settings.includedIssues === false && change !== undefined && change.items !== undefined && change.items !== null && change.items.length > 0 && change.items.filter(function (item) {
          return item.status !== "Closed";
        }).length > 0 ? _react2.default.createElement('div', { style: { position: "relative", pageBreakAfter: "always", pageBreakInside: "avoid" } }) : null,
        this.props.settings !== undefined && this.props.settings.includedIssues === false && change !== undefined && change.items !== undefined && change.items !== null && change.items.length > 0 && change.items.filter(function (item) {
          return item.status !== "Closed";
        }).length > 0 ? _react2.default.createElement(
          'div',
          { style: style },
          _react2.default.createElement(
            'h2',
            null,
            labels.issues
          ),
          _react2.default.createElement(_Change.IssueReport, _extends({}, this.props, { settings: this.props.settings, items: change.items.filter(function (item) {
              return item.status !== "Closed";
            }) }))
        ) : null
      );
    }
  }]);

  return Report;
}(_react2.default.Component);

var ReportTitle = function (_React$Component2) {
  _inherits(ReportTitle, _React$Component2);

  function ReportTitle() {
    _classCallCheck(this, ReportTitle);

    return _possibleConstructorReturn(this, (ReportTitle.__proto__ || Object.getPrototypeOf(ReportTitle)).apply(this, arguments));
  }

  _createClass(ReportTitle, [{
    key: 'render',
    value: function render() {
      var report = this.props;
      var date = new Date(report.date).toISOString().substring(0, 10);
      return _react2.default.createElement(
        'span',
        null,
        this.props.isSelected ? _react2.default.createElement(
          'b',
          null,
          date
        ) : date,
        report.type === "draft" ? _react2.default.createElement(
          'span',
          null,
          ' (',
          _react2.default.createElement(
            'i',
            null,
            'draft'
          ),
          ')'
        ) : report.version !== undefined ? _react2.default.createElement(
          'span',
          null,
          ' (v',
          report.version,
          ')'
        ) : undefined
      );
    }
  }]);

  return ReportTitle;
}(_react2.default.Component);

var ArchiveMenu = function (_React$Component3) {
  _inherits(ArchiveMenu, _React$Component3);

  function ArchiveMenu() {
    _classCallCheck(this, ArchiveMenu);

    return _possibleConstructorReturn(this, (ArchiveMenu.__proto__ || Object.getPrototypeOf(ArchiveMenu)).apply(this, arguments));
  }

  _createClass(ArchiveMenu, [{
    key: 'isSameDate',
    value: function isSameDate(previous, current) {
      return new Date(previous.date).toISOString().slice(0, 10) === new Date(current.date).toISOString().slice(0, 10);
    }
  }, {
    key: 'link',
    value: function link(details) {
      return (this.props.project.isProgramme !== undefined ? "/programmes/" : this.props.project.isRelease !== undefined ? "/releases/" : this.props.project.isProduct !== undefined ? "/products/" : "/projects/") + this.props.project.id + details;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var reports = this.props.project.highlights !== undefined ? this.props.project.highlights.slice().sort(_sortByDate2.default).reverse() : [];
      reports = reports.reverse().filter(function (report) {
        return report.stage === undefined && report.endProject !== true || _this5.props.showEndStage || report.id === _this5.props.selected;
      }).map(function (report, index, allReports) {
        return Object.assign({}, report, {
          version: index > 0 && _this5.isSameDate(allReports[index - 1], report) ? allReports.slice(0, index).filter(function (reportEntry) {
            return _this5.isSameDate(reportEntry, report);
          }).length + 1 : undefined
        });
      }).reverse();
      if (this.props.project.draftHighlight !== undefined && this.props.user.id === this.props.project.draftHighlight.updatedBy) {
        reports = [].concat(Object.assign({}, this.props.project.draftHighlight, { date: this.props.project.draftHighlight.statusDate, id: "draft", type: "draft", summary: this.props.project.draftHighlight.overallStatus })).concat(reports);
      }
      return _react2.default.createElement(
        'div',
        { style: { display: "inline-block", float: "right", marginRight: 30, width: 250, borderLeft: "solid lightgrey 1px", paddingTop: 10, paddingLeft: 10, paddingBottom: 150 } },
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 30 } },
          _react2.default.createElement(
            'b',
            null,
            'Report Actions'
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingLeft: 10 } },
            _react2.default.createElement(
              'a',
              { href: "?id=" + this.props.selected + "&fullPage=true&lang=" + this.props.language, target: '_blank' },
              'View full screen'
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingLeft: 10 } },
            _react2.default.createElement(
              'a',
              { href: "?id=" + this.props.selected + "&fullPage=true&pdf=true&lang=" + this.props.language, target: '_blank' },
              'View PDF'
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingLeft: 10 } },
            _react2.default.createElement(
              'a',
              { href: "?id=" + this.props.selected + "&presentationMode=true&lang=" + this.props.language, target: '_blank' },
              'View slide mode'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 15 } },
          _react2.default.createElement(
            'b',
            null,
            'Report Archive'
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingLeft: 10 } },
            reports.length > 0 ? reports.filter(function (report, index, allReports) {
              return index == 0 || !_this5.isSameDate(allReports[index - 1], report) || report.id === _this5.props.selected;
            }).map(function (report) {
              return _react2.default.createElement(
                'div',
                { key: report.id },
                _this5.props.selected === report.id ? _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(ReportTitle, _extends({}, report, { isSelected: true })),
                  report.stage !== undefined || report.endProject === true ? _react2.default.createElement('img', { style: { paddingLeft: 5, height: "10pt" }, src: '/images/Flag_FinishGrey_22x16.gif' }) : null,
                  report.type === "draft" ? _react2.default.createElement(
                    'span',
                    null,
                    ' ',
                    _react2.default.createElement(
                      'a',
                      { href: _this5.link("/highlight") },
                      'edit'
                    )
                  ) : null,
                  report.id === reports[0].id && report.createdBy === _this5.props.user.id && _this5.props.project.draftHighlight === undefined ? _react2.default.createElement(
                    'span',
                    null,
                    ' ',
                    _react2.default.createElement(
                      'a',
                      { href: _this5.link("/highlight?id=" + report.id + (report.stage !== undefined ? "&endStage=true" : "") + (report.endProject === true ? "&endProject=true" : "")) },
                      'edit'
                    )
                  ) : null,
                  reports.filter(function (historicReport) {
                    return _this5.isSameDate(historicReport, report) && (historicReport.version < report.version || historicReport.version === undefined && report.version !== undefined || report.type === "draft" && historicReport.type !== "draft");
                  }).map(function (historicReport) {
                    return _react2.default.createElement(
                      'div',
                      { key: historicReport.id, style: { paddingLeft: 15 } },
                      _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'a',
                          { href: "?id=" + historicReport.id + (_this5.props.showEndStage ? "&showEndStage=true" : "") },
                          _react2.default.createElement(ReportTitle, historicReport)
                        ),
                        historicReport.stage !== undefined ? _react2.default.createElement('img', { style: { paddingLeft: 5, height: "10pt" }, src: '/images/Flag_FinishGrey_22x16.gif' }) : null
                      )
                    );
                  })
                ) : _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'a',
                    { href: "?id=" + report.id + (_this5.props.showEndStage ? "&showEndStage=true" : "") },
                    _react2.default.createElement(ReportTitle, _extends({}, report, { isSelected: false }))
                  ),
                  report.stage !== undefined ? _react2.default.createElement('img', { style: { paddingLeft: 5, height: "10pt" }, src: '/images/Flag_FinishGrey_22x16.gif' }) : null
                )
              );
            }) : _react2.default.createElement(
              'i',
              null,
              'No reports are available'
            )
          )
        )
      );
    }
  }]);

  return ArchiveMenu;
}(_react2.default.Component);

var ReportContent = exports.ReportContent = function (_React$Component4) {
  _inherits(ReportContent, _React$Component4);

  function ReportContent() {
    _classCallCheck(this, ReportContent);

    return _possibleConstructorReturn(this, (ReportContent.__proto__ || Object.getPrototypeOf(ReportContent)).apply(this, arguments));
  }

  _createClass(ReportContent, [{
    key: 'render',
    value: function render() {
      var selected = this.props.selected;
      return this.props.presentationMode ? _react2.default.createElement(Report, _extends({}, this.props, { selected: selected })) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(ArchiveMenu, _extends({}, this.props, { selected: selected })),
        _react2.default.createElement(Report, _extends({}, this.props, { selected: selected }))
      );
    }
  }]);

  return ReportContent;
}(_react2.default.Component);

var ReportPage = function (_React$Component5) {
  _inherits(ReportPage, _React$Component5);

  function ReportPage() {
    _classCallCheck(this, ReportPage);

    return _possibleConstructorReturn(this, (ReportPage.__proto__ || Object.getPrototypeOf(ReportPage)).apply(this, arguments));
  }

  _createClass(ReportPage, [{
    key: 'render',
    value: function render() {
      var menu = this.props.showMenu === true ? _react2.default.createElement(_ProjectMenu2.default, this.props) : undefined;
      var selected = this.props.selected;
      return this.props.fullPage ? _react2.default.createElement(Report, _extends({}, this.props, { selected: selected })) : _react2.default.createElement(
        _Layout2.default,
        _extends({}, this.props, { projectMenu: menu }),
        _react2.default.createElement(ReportContent, this.props)
      );
    }
  }]);

  return ReportPage;
}(_react2.default.Component);

exports.default = ReportPage;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormattedSlide = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _server = __webpack_require__(1039);

var _FormattedContent = __webpack_require__(15);

var _FormattedContent2 = _interopRequireDefault(_FormattedContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormattedSlide = exports.FormattedSlide = function (_React$Component) {
  _inherits(FormattedSlide, _React$Component);

  function FormattedSlide() {
    _classCallCheck(this, FormattedSlide);

    return _possibleConstructorReturn(this, (FormattedSlide.__proto__ || Object.getPrototypeOf(FormattedSlide)).apply(this, arguments));
  }

  _createClass(FormattedSlide, [{
    key: 'render',
    value: function render() {
      var slideType = this.props.slideType !== undefined ? this.props.slideType : "normal";
      return this.props.content !== undefined && this.props.content !== null && (this.props.content.trim !== undefined && this.props.content.trim().length > 0 || this.props.content.trim === undefined) ? slideType === "title" ? _react2.default.createElement(
        'div',
        { style: { textAlign: "center", paddingTop: 100 } },
        _react2.default.createElement(
          'h1',
          null,
          ' ',
          this.props.label,
          ' '
        ),
        _react2.default.createElement(
          'h3',
          null,
          _react2.default.createElement(_FormattedContent2.default, { value: this.props.content })
        )
      ) : slideType === "preformatted" ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          null,
          ' ',
          this.props.label,
          ' '
        ),
        this.props.children
      ) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          null,
          ' ',
          this.props.label,
          ' '
        ),
        _react2.default.createElement(_FormattedContent2.default, { value: this.props.content })
      ) : null;
    }
  }]);

  return FormattedSlide;
}(_react2.default.Component);

var SlideLink = function (_React$Component2) {
  _inherits(SlideLink, _React$Component2);

  function SlideLink(props) {
    _classCallCheck(this, SlideLink);

    var _this2 = _possibleConstructorReturn(this, (SlideLink.__proto__ || Object.getPrototypeOf(SlideLink)).call(this, props));

    _this2.state = { slideNo: _this2.props.slideNo };
    return _this2;
  }

  _createClass(SlideLink, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'a',
          { href: '#', onClick: this.props.setSlide(this, this.props.slideNo) },
          this.props.slideTitles[this.props.index]
        )
      );
    }
  }]);

  return SlideLink;
}(_react2.default.Component);

var Slides = function (_React$Component3) {
  _inherits(Slides, _React$Component3);

  function Slides(props) {
    _classCallCheck(this, Slides);

    var _this3 = _possibleConstructorReturn(this, (Slides.__proto__ || Object.getPrototypeOf(Slides)).call(this, props));

    _this3.state = { slideNo: 0, tableofcontent: false };
    return _this3;
  }

  _createClass(Slides, [{
    key: 'nextSlide',
    value: function nextSlide(event) {
      event.preventDefault();
      this.setState({ slideNo: ++this.state.slideNo });
      while (this.slideIsEmpty(this.props.slides[this.state.slideNo]) && this.state.slideNo < this.props.slides.length - 1) {
        this.setState({ slideNo: ++this.state.slideNo });
      }
    }
  }, {
    key: 'previousSlide',
    value: function previousSlide(event) {
      event.preventDefault();
      this.setState({ slideNo: --this.state.slideNo });
      while (this.slideIsEmpty(this.props.slides[this.state.slideNo]) && this.state.slideNo > 0) {
        this.setState({ slideNo: --this.state.slideNo });
      }
    }
  }, {
    key: 'showToC',
    value: function showToC(event) {
      event.preventDefault();
      this.setState({ tableofcontent: true });
    }
  }, {
    key: 'hideToC',
    value: function hideToC(event) {
      event.preventDefault();
      this.setState({ tableofcontent: false });
    }
  }, {
    key: 'slideIsEmpty',
    value: function slideIsEmpty(slide) {
      return (0, _server.renderToString)(slide).indexOf("</div>") < 0 ? true : false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement(
        'div',
        { style: { marginLeft: 30, marginTop: 30, minWidth: 1256, display: "inline-flex", justifyContent: "space-between", fontFamily: "Lato, Arial, Verdana, Geneva, sans-serif" } },
        _react2.default.createElement(
          'div',
          null,
          this.state.tableofcontent ? _react2.default.createElement(
            'div',
            { style: { border: "1px solid #E5E5E5", boxShadow: "0px 8px 16px rgba(0,0,0,0.15)", borderRadius: 4, backgroundColor: "#ffffff", width: 155, fontSize: 17, fontFamily: "Lato, Arial, Verdana, Geneva, sans-serif", marginTop: 15, marginRight: 10, paddingTop: 5, paddingBottom: 16, paddingLeft: 5, paddingRight: 12 } },
            _react2.default.createElement(
              'a',
              { href: '#', style: { paddingLeft: 5, marginTop: 10, float: "left" }, onClick: this.hideToC.bind(this) },
              _react2.default.createElement('img', { src: '/icons/chevron_left.png' })
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'ol',
              { style: { paddingLeft: 25, paddingTop: 5, paddingRight: 5, paddingBottom: 10, margin: 0 } },
              this.props.slides.map(function (slide, index) {
                return _react2.default.createElement(
                  'div',
                  null,
                  !_this4.slideIsEmpty(slide) ? _react2.default.createElement(
                    'a',
                    { href: '#', style: { paddingTop: 10, textDecoration: "none", fontWeight: index === _this4.state.slideNo ? "bold" : "normal", color: index === _this4.state.slideNo ? "#18586D" : "#212121" }, onClick: function onClick(event) {
                        event.preventDefault();_this4.setState({ slideNo: index });
                      } },
                    _this4.props.slideTitles[index] !== null && _this4.props.slideTitles[index] !== undefined ? _react2.default.createElement(
                      'li',
                      { style: { marginTop: 5 } },
                      _this4.props.slideTitles[index]
                    ) : null
                  ) : null
                );
              })
            )
          ) : this.props.slideTitles !== undefined ? _react2.default.createElement(
            'a',
            { href: '#', style: { paddingLeft: 5, marginTop: 25, float: "left" }, onClick: this.showToC.bind(this) },
            _react2.default.createElement('img', { src: '/icons/menu.png' })
          ) : null
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { style: { paddingTop: 150, minWidth: 130 } },
            this.state.slideNo > 0 ? _react2.default.createElement('input', { className: 'slideNavigation', style: { marginLeft: 10, float: "left" }, onClick: this.previousSlide.bind(this), type: 'button', value: '<' }) : null
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { minWidth: 780, width: "100%" } },
          this.props.slides[this.state.slideNo]
        ),
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 150, minWidth: 120 } },
          this.state.slideNo < this.props.slides.length - 1 ? _react2.default.createElement('input', { className: 'slideNavigation', style: { float: "right" }, onClick: this.nextSlide.bind(this), type: 'button', value: '>' }) : null
        )
      );
    }
  }]);

  return Slides;
}(_react2.default.Component);

exports.default = Slides;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectDetails = exports.StatusSummary = exports.KeyInfo = exports.ActivityView = exports.Themes = exports.Links = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _ProjectMenu = __webpack_require__(17);

var _ProjectMenu2 = _interopRequireDefault(_ProjectMenu);

var _StatusIndicator = __webpack_require__(425);

var _StatusIndicator2 = _interopRequireDefault(_StatusIndicator);

var _Field = __webpack_require__(36);

var _Field2 = _interopRequireDefault(_Field);

var _HighlightReport = __webpack_require__(105);

var _Risk = __webpack_require__(63);

var _Change = __webpack_require__(95);

var _FormattedContent = __webpack_require__(15);

var _FormattedContent2 = _interopRequireDefault(_FormattedContent);

var _ProjectSettings = __webpack_require__(432);

var _getProjectInitiationDocument = __webpack_require__(433);

var _getProjectInitiationDocument2 = _interopRequireDefault(_getProjectInitiationDocument);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(1068), __webpack_require__(1069)]).loadVariants([__webpack_require__(1070), __webpack_require__(1071), __webpack_require__(1072), __webpack_require__(1073)]);

var LinkDetails = function (_React$Component) {
  _inherits(LinkDetails, _React$Component);

  function LinkDetails() {
    _classCallCheck(this, LinkDetails);

    return _possibleConstructorReturn(this, (LinkDetails.__proto__ || Object.getPrototypeOf(LinkDetails)).apply(this, arguments));
  }

  _createClass(LinkDetails, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      var item = this.props;
      switch (this.props.mode) {
        case "editable":
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'a',
              { href: "?editLinks=true&deleteLink=" + item.id, style: { marginLeft: 0, position: "relative", marginRight: 15 } },
              _react2.default.createElement(
                'span',
                { style: { color: "red", position: "absolute", left: -3, top: -1, fontWeight: "bold", fontFamily: "Arial" } },
                'x'
              )
            ),
            _react2.default.createElement(
              'a',
              { href: "?editLinks=true&editLink=" + item.id, style: { textDecoration: "none", color: "black", position: "relative" } },
              _react2.default.createElement(
                'span',
                { style: { marginLeft: 0 } },
                item.text,
                ' '
              ),
              _react2.default.createElement('img', { style: { paddingLeft: 5, verticalAlign: "middle" }, src: '/icons/pen_grey.jpg' })
            )
          );
        case "edit":
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { style: { marginTop: 10, marginBottom: 30, paddingBottom: 15 } },
              _react2.default.createElement(
                'form',
                { method: 'POST' },
                _react2.default.createElement('input', { type: 'hidden', name: 'id', value: item.id }),
                _react2.default.createElement('input', { type: 'hidden', name: 'editLinks', value: 'true' }),
                _react2.default.createElement('input', { style: { width: "100%", marginBottom: 10 }, className: 'input', name: 'text', autoComplete: 'off', defaultValue: item.text, placeholder: labels.link.edit.textPlaceholder }),
                _react2.default.createElement('br', null),
                _react2.default.createElement('input', { style: { width: "100%", marginBottom: 10 }, className: 'input', name: 'link', autoComplete: 'off', defaultValue: item.link, placeholder: labels.link.edit.addressPlaceholder }),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  'div',
                  { style: { float: "right" } },
                  _react2.default.createElement('input', { type: 'submit', className: 'cancel', name: 'cancel', value: labels.link.cancel }),
                  ' ',
                  _react2.default.createElement('input', { type: 'submit', className: 'save', value: labels.link.save })
                )
              )
            )
          );
        default:
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'a',
              { href: item.link, target: '_blank' },
              item.text
            )
          );
      }
    }
  }]);

  return LinkDetails;
}(_react2.default.Component);

var StandardLinkDetails = function (_React$Component2) {
  _inherits(StandardLinkDetails, _React$Component2);

  function StandardLinkDetails() {
    _classCallCheck(this, StandardLinkDetails);

    return _possibleConstructorReturn(this, (StandardLinkDetails.__proto__ || Object.getPrototypeOf(StandardLinkDetails)).apply(this, arguments));
  }

  _createClass(StandardLinkDetails, [{
    key: 'render',
    value: function render() {
      var address = this.props.address;
      var project = this.props.project;
      if (this.props.parameters !== undefined && this.props.parameters.length > 0) {
        this.props.parameters.forEach(function (parameter) {
          address = address.split("{" + parameter.name + "}").join(project[parameter.key]);
        });
      }
      return _react2.default.createElement(LinkDetails, _extends({}, this.props, { text: this.props.title, link: address, mode: 'show' }));
    }
  }]);

  return StandardLinkDetails;
}(_react2.default.Component);

var ShowStandardLinks = function (_React$Component3) {
  _inherits(ShowStandardLinks, _React$Component3);

  function ShowStandardLinks() {
    _classCallCheck(this, ShowStandardLinks);

    return _possibleConstructorReturn(this, (ShowStandardLinks.__proto__ || Object.getPrototypeOf(ShowStandardLinks)).apply(this, arguments));
  }

  _createClass(ShowStandardLinks, [{
    key: 'render',
    value: function render() {
      var _this4 = this;

      return this.props.standardLinks !== undefined ? _react2.default.createElement(
        'div',
        null,
        this.props.standardLinks.map(function (link) {
          return _react2.default.createElement(StandardLinkDetails, _extends({}, _this4.props, { key: link.id }, link, { project: _this4.props }));
        })
      ) : null;
    }
  }]);

  return ShowStandardLinks;
}(_react2.default.Component);

var ShowLinkList = function (_React$Component4) {
  _inherits(ShowLinkList, _React$Component4);

  function ShowLinkList() {
    _classCallCheck(this, ShowLinkList);

    return _possibleConstructorReturn(this, (ShowLinkList.__proto__ || Object.getPrototypeOf(ShowLinkList)).apply(this, arguments));
  }

  _createClass(ShowLinkList, [{
    key: 'render',
    value: function render() {
      var _this6 = this;

      var edit = this.props.edit;
      var mode = this.props.mode;
      return this.props.links !== undefined || this.props.standardLinks !== undefined ? _react2.default.createElement(
        'div',
        { style: { marginTop: 5, paddingTop: 0, paddingLeft: "0.6em", listStyle: "inside", paddingBottom: 0, marginBottom: 10 } },
        this.props.hideStandardLinks !== true ? _react2.default.createElement(ShowStandardLinks, this.props) : null,
        this.props.links !== undefined ? this.props.links.map(function (item) {
          return _react2.default.createElement(LinkDetails, _extends({}, _this6.props, item, {
            key: item.id,
            mode: mode === "edit" ? edit === item.id ? "edit" : "editable" : "show" }));
        }) : null
      ) : _react2.default.createElement('div', null);
    }
  }]);

  return ShowLinkList;
}(_react2.default.Component);

var LinkListEditIcon = function (_React$Component5) {
  _inherits(LinkListEditIcon, _React$Component5);

  function LinkListEditIcon() {
    _classCallCheck(this, LinkListEditIcon);

    return _possibleConstructorReturn(this, (LinkListEditIcon.__proto__ || Object.getPrototypeOf(LinkListEditIcon)).apply(this, arguments));
  }

  _createClass(LinkListEditIcon, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { display: "inline-block", paddingLeft: 5 } },
        _react2.default.createElement(
          'a',
          { href: this.props.url },
          _react2.default.createElement('img', { src: '/icons/pen_grey.jpg' })
        )
      );
    }
  }]);

  return LinkListEditIcon;
}(_react2.default.Component);

var AddLink = function (_React$Component6) {
  _inherits(AddLink, _React$Component6);

  function AddLink() {
    _classCallCheck(this, AddLink);

    return _possibleConstructorReturn(this, (AddLink.__proto__ || Object.getPrototypeOf(AddLink)).apply(this, arguments));
  }

  _createClass(AddLink, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      return this.props.add ? _react2.default.createElement(LinkDetails, _extends({}, this.props, { mode: 'edit', id: undefined })) : _react2.default.createElement(
        'a',
        { href: '?editLinks=true&addLink=true', style: { color: "#70B0E6", paddingLeft: 5 } },
        _react2.default.createElement('img', { style: { height: "0.8em" }, src: '/icons/plus_lightblue.jpg' }),
        labels.link.add
      );
    }
  }]);

  return AddLink;
}(_react2.default.Component);

var DisplayLinks = function (_React$Component7) {
  _inherits(DisplayLinks, _React$Component7);

  function DisplayLinks() {
    _classCallCheck(this, DisplayLinks);

    return _possibleConstructorReturn(this, (DisplayLinks.__proto__ || Object.getPrototypeOf(DisplayLinks)).apply(this, arguments));
  }

  _createClass(DisplayLinks, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      return this.props.mode === "edit" ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'b',
          null,
          labels.link.heading
        ),
        ' (',
        _react2.default.createElement(
          'i',
          null,
          _react2.default.createElement(
            'a',
            { href: '?' },
            labels.link.exitEdit
          )
        ),
        ')',
        _react2.default.createElement(ShowLinkList, _extends({}, this.props, { mode: 'edit', edit: this.props.edit, hideStandardLinks: this.props.isProgramme === true })),
        _react2.default.createElement(AddLink, _extends({}, this.props, { add: this.props.add }))
      ) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'b',
          null,
          labels.link.heading
        ),
        _react2.default.createElement(LinkListEditIcon, { url: '?editLinks=true' }),
        _react2.default.createElement(ShowLinkList, _extends({}, this.props, { hideStandardLinks: this.props.isProgramme === true }))
      );
    }
  }]);

  return DisplayLinks;
}(_react2.default.Component);

var DisplayProjectDetails = function (_React$Component8) {
  _inherits(DisplayProjectDetails, _React$Component8);

  function DisplayProjectDetails() {
    _classCallCheck(this, DisplayProjectDetails);

    return _possibleConstructorReturn(this, (DisplayProjectDetails.__proto__ || Object.getPrototypeOf(DisplayProjectDetails)).apply(this, arguments));
  }

  _createClass(DisplayProjectDetails, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      var executive = this.props.stakeholders !== undefined ? this.props.stakeholders.filter(function (stakeholder) {
        return stakeholder.role === "Excecutive";
      }).map(function (person) {
        return person.name;
      }).join(", ") : undefined;
      var pManager = this.props.stakeholders !== undefined ? this.props.stakeholders.filter(function (stakeholder) {
        return stakeholder.role === "Project Manager" || stakeholder.role === "Product Manager";
      }).map(function (person) {
        return person.name;
      }).join(", ") : undefined;
      return _react2.default.createElement(
        'div',
        { style: { paddingBottom: 15 } },
        this.props.isProduct === true ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'b',
            null,
            this.props.name
          ),
          ' ',
          _react2.default.createElement(_StatusIndicator2.default, this.props.overallStatus)
        ) : null,
        _react2.default.createElement(
          'div',
          { style: { paddingLeft: "0.6em" } },
          this.props.isProduct !== true ? _react2.default.createElement(
            'div',
            null,
            this.props.phase
          ) : null,
          this.props.identifier !== undefined && this.props.identifier.trim().length > 0 ? _react2.default.createElement(
            'div',
            null,
            'ID: ',
            this.props.identifier
          ) : null,
          _react2.default.createElement(
            'div',
            null,
            labels.general.executive,
            ': ',
            executive
          ),
          _react2.default.createElement(
            'div',
            null,
            labels.general.projectManager,
            ': ',
            pManager
          )
        )
      );
    }
  }]);

  return DisplayProjectDetails;
}(_react2.default.Component);

var Links = exports.Links = function (_React$Component9) {
  _inherits(Links, _React$Component9);

  function Links() {
    _classCallCheck(this, Links);

    return _possibleConstructorReturn(this, (Links.__proto__ || Object.getPrototypeOf(Links)).apply(this, arguments));
  }

  _createClass(Links, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      var itemType = this.props.isProgramme === true ? "/programmes/" : this.props.isProduct === true ? "/products/" : this.props.isRelease === true ? "/releases/" : "/projects/";
      return _react2.default.createElement(
        'div',
        { style: { fontFamily: "Lato", display: "inline-block", float: "right", marginRight: 30, width: 250, borderLeft: "solid lightgrey 1px", paddingTop: 10, paddingLeft: 10, paddingBottom: 150 } },
        this.props.isRelease ? _react2.default.createElement(
          'div',
          { style: { paddingBottom: 30, textAlign: "left" } },
          '  ',
          _react2.default.createElement(
            'a',
            { href: "/products/" + this.props.product.id },
            ' ',
            labels.link.goToProduct,
            ' '
          )
        ) : null,
        _react2.default.createElement(DisplayLinks, _extends({}, this.props, { mode: this.props.mode })),
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 10 } },
          _react2.default.createElement(
            'b',
            null,
            labels.reports.heading
          ),
          _react2.default.createElement(
            'ul',
            { style: { marginTop: 5, paddingTop: 0, paddingLeft: "0.6em", listStyle: "none", paddingBottom: 0, marginBottom: 10 } },
            this.props.isProduct !== true && this.props.endProjectReport !== undefined && (this.props.isCompleted || this.props.isClosing === true) ? _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { href: itemType + this.props.id + "/reports?showEndStage=true&id=" + this.props.endProjectReport.id },
                labels.reports.endProjectReport
              )
            ) : null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { href: itemType + this.props.id + "/reports/" },
                labels.reports.highlightReport
              )
            ),
            this.props.isProduct !== true && this.props.briefEnabled ? _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { href: itemType + this.props.id + "/brief/" },
                labels.reports.brief
              )
            ) : null,
            this.props.isProduct !== true && this.props.pidEnabled ? _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'a',
                { href: itemType + this.props.id + "/pid/" },
                labels.reports.pid
              )
            ) : null
          )
        )
      );
    }
  }]);

  return Links;
}(_react2.default.Component);

var ThemeLink = function (_React$Component10) {
  _inherits(ThemeLink, _React$Component10);

  function ThemeLink() {
    _classCallCheck(this, ThemeLink);

    return _possibleConstructorReturn(this, (ThemeLink.__proto__ || Object.getPrototypeOf(ThemeLink)).apply(this, arguments));
  }

  _createClass(ThemeLink, [{
    key: 'render',
    value: function render() {
      return this.props.url !== undefined ? _react2.default.createElement(
        'a',
        { style: { textDecoration: "none", color: "#378187" }, href: this.props.url },
        _react2.default.createElement(
          'div',
          { style: { textAlign: "center", height: 178, width: 180, border: "solid 1px #E5E5E5" } },
          _react2.default.createElement('img', { style: { paddingTop: 40, paddingBottom: 27 }, src: this.props.image }),
          _react2.default.createElement(
            'div',
            { style: { textAlign: "center", verticalAlign: "middle", position: "relative", color: "#212121", backgroundColor: "#E5E5E5", padding: 16, textDecoration: "none", fontSize: "15pt", fontFamily: "Lato, Verdana, Geneva, sans-serif", fontWeight: "normal" } },
            this.props.labels.title
          )
        )
      ) : _react2.default.createElement('img', { src: this.props.image });
    }
  }]);

  return ThemeLink;
}(_react2.default.Component);

var Themes = exports.Themes = function (_React$Component11) {
  _inherits(Themes, _React$Component11);

  function Themes() {
    _classCallCheck(this, Themes);

    return _possibleConstructorReturn(this, (Themes.__proto__ || Object.getPrototypeOf(Themes)).apply(this, arguments));
  }

  _createClass(Themes, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      var access = this.props.access;
      var itemType = this.props.project.isProgramme === true ? "/programmes/" : this.props.project.isProduct === true ? "/products/" : this.props.project.isRelease === true ? "/releases/" : "/projects/";
      var actions = this.props.fullOverview !== undefined ? [
      //      {url:"/projects/"+this.props.project.id+"/brief", image:"/images/mandate_s1.png"},
      { name: "definition", url: itemType + this.props.project.id + "/definition", image: "/images/definition.png", labels: labels.themes.definition }, { name: "businessCase", url: itemType + this.props.project.id + "/businessCase", image: "/images/business_case_s1.png", labels: labels.themes.businessCase }, { name: "organizaton", url: itemType + this.props.project.id + "/organization?show=approach", image: "/images/organization_s1.png", labels: labels.themes.organization }, { name: "quality", url: itemType + this.props.project.id + "/quality?show=approach", image: "/images/quality_s1.png", labels: labels.themes.quality }, { name: "plans", url: itemType + this.props.project.id + "/plan?show=approach", image: "/images/plans_s1.png", labels: labels.themes.plan }, { name: "risk", url: itemType + this.props.project.id + "/risk?show=approach", image: "/images/risk_s1.png", labels: labels.themes.risk }, { name: "change", url: itemType + this.props.project.id + "/change?show=approach", image: "/images/change_s1.png", labels: labels.themes.change }, { name: "progress", url: itemType + this.props.project.id + "/highlight", image: "/images/progress_s1.png", labels: labels.themes.progress }] : [
      //      {url:"/projects/"+this.props.project.id+"/brief", image:"/images/mandate_s1.png"},
      access.isDefinitionEnabled() ? { name: "definition", url: itemType + this.props.project.id + "/definition", image: "/icons/brief_icon_trans.png", labels: labels.themes.definition } : this.props.project.isRelease !== true ? { name: "background", url: itemType + this.props.project.id + "/background", image: "/icons/brief_icon_trans.png", labels: labels.themes.background } : undefined, access.isBusinessCaseEnabled() ? { name: "businessCase", url: itemType + this.props.project.id + "/businessCase", image: "/icons/business_case_icon_trans.png", labels: labels.themes.businessCase } : undefined, this.props.project.isRelease !== true && this.props.user !== undefined ? { name: "organization", url: itemType + this.props.project.id + "/organization" + (access.isPIDEnabled() ? "?show=approach" : ""), image: "/icons/organization_icon_trans.png", labels: labels.themes.organization } : undefined, access.isQualityEnabled() ? { name: "quality", url: itemType + this.props.project.id + "/quality" + (access.isPIDEnabled() ? "?show=approach" : ""), image: "/icons/quality_icon_trans.png", labels: labels.themes.quality } : undefined, this.props.project.isProgramme !== true ? { name: "plans", url: itemType + this.props.project.id + "/plan" + (access.isPIDEnabled() ? "?show=controls" : access.isProjectBriefEnabled() ? "?show=approach" : "?show=lessons"), image: "/icons/plans_icon_trans.png", labels: labels.themes.plan } : undefined, { name: "risk", url: itemType + this.props.project.id + "/risk" + (access.isPIDEnabled() ? "?show=approach" : ""), image: "/icons/risk_icon_trans.png", labels: labels.themes.risk }, { name: "change", url: itemType + this.props.project.id + "/change" + (access.isPIDEnabled() ? "?show=approach" : ""), image: "/icons/change_icon_trans.png", labels: labels.themes.change }, { name: "progress", url: itemType + this.props.project.id + "/highlight", image: "/icons/progress_icon_trans.png", labels: labels.themes.progress }];
      actions = actions.filter(function (item) {
        return item !== undefined;
      });
      var max = actions.length > 4 ? 4 : actions.length;
      var firstRow = actions.slice(0, max);
      var lastRow = actions.length > max ? actions.slice(max, actions.length) : [];
      var displayActions = actions;

      return this.props.style === "small" || this.props.project.isProgramme !== true && this.props.project.isProduct !== true && this.props.project.isRelease !== true ? _react2.default.createElement(
        'div',
        { style: { display: "flex", justifyContent: "space-around" } },
        displayActions.map(function (theme) {
          return _react2.default.createElement(
            'a',
            { key: theme.name, href: theme.url, style: { textDecoration: "none", width: 100 / displayActions.length + "%" } },
            _react2.default.createElement(
              'div',
              { key: theme.labels.title, style: { padding: 20, textAlign: "center" } },
              _react2.default.createElement('img', { src: theme.image }),
              _react2.default.createElement(
                'div',
                { style: _defineProperty({ fontFamily: "Lato, Verdana, Geneva, sans-serif", fontSize: "14pt", color: "#212121", textTransform: "capitalize" }, 'color', "#378187") },
                theme.labels.title
              )
            )
          );
        })
      ) : _react2.default.createElement(
        'tbody',
        null,
        _react2.default.createElement(
          'tr',
          null,
          firstRow.map(function (item) {
            return _react2.default.createElement(
              'td',
              { key: item.image },
              _react2.default.createElement(ThemeLink, item)
            );
          })
        ),
        lastRow.length > 0 ? _react2.default.createElement(
          'tr',
          null,
          lastRow.map(function (item) {
            return _react2.default.createElement(
              'td',
              { key: item.image },
              _react2.default.createElement(ThemeLink, item)
            );
          })
        ) : null
      );
    }
  }]);

  return Themes;
}(_react2.default.Component);

function containFields(object, fields) {
  return fields.reduce(function (check, item) {
    return check + (object !== undefined && object[item] !== undefined && object[item].length > 0 ? 1 : 0);
  }, 0);
}

var ActivityView = exports.ActivityView = function (_React$Component12) {
  _inherits(ActivityView, _React$Component12);

  function ActivityView() {
    _classCallCheck(this, ActivityView);

    return _possibleConstructorReturn(this, (ActivityView.__proto__ || Object.getPrototypeOf(ActivityView)).apply(this, arguments));
  }

  _createClass(ActivityView, [{
    key: 'render',
    value: function render() {
      var labels = this.props.labels;
      var activities = this.props.activities;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { padding: "20px 20px 20px 40px", border: "solid 1px #e9e7e6" } },
          _react2.default.createElement(_Field2.default, {
            labels: this.props.labels,
            name: 'steps',
            optional: true,
            type: 'process',
            title: labels.title,
            help: labels.help,
            value: {
              activities: activities,
              nextStep: this.props.nextStep,
              cancel: this.props.cancel
            },
            project: this.props.project
          })
        ),
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 25, width: "100%", display: this.props.hideThemes ? "none" : undefined } },
          _react2.default.createElement(Themes, _extends({}, this.props, { style: 'small' }))
        )
      );
    }
  }]);

  return ActivityView;
}(_react2.default.Component);

var StartUpProcessOverview = function (_React$Component13) {
  _inherits(StartUpProcessOverview, _React$Component13);

  function StartUpProcessOverview() {
    _classCallCheck(this, StartUpProcessOverview);

    return _possibleConstructorReturn(this, (StartUpProcessOverview.__proto__ || Object.getPrototypeOf(StartUpProcessOverview)).apply(this, arguments));
  }

  _createClass(StartUpProcessOverview, [{
    key: 'stakeholderCount',
    value: function stakeholderCount(roles) {
      var _this16 = this;

      return this.props.project.stakeholders !== undefined ? roles.filter(function (role) {
        return _this16.props.project.stakeholders.filter(function (stakeholder) {
          return stakeholder.role === role;
        }).length > 0;
      }).length : 0;
    }
  }, {
    key: 'appointedExecutiveAndPM',
    value: function appointedExecutiveAndPM() {
      var count = this.stakeholderCount(["Project Manager", "Excecutive"]);
      switch (true) {
        case count === 1:
          return "inProgress";
        case count === 2:
          return "done";
        default:
          return "notStarted";
      }
    }
  }, {
    key: 'appointedManagementTeam',
    value: function appointedManagementTeam() {
      var count = this.stakeholderCount(["Project Manager", "Excecutive", "Senior Supplier", "Senior User", "Team Manager"]);
      switch (true) {
        case count > 0 && count < 5:
          return "inProgress";
        case count === 5:
          return "done";
        default:
          return "notStarted";
      }
    }
  }, {
    key: 'containFields',
    value: function containFields(object, fields) {
      return fields.reduce(function (check, item) {
        return check + (object !== undefined && object[item] !== undefined && object[item].length > 0 ? 1 : 0);
      }, 0);
    }
  }, {
    key: 'preparedBusinessCase',
    value: function preparedBusinessCase() {
      var expectedFields = ["executiveSummary", "benefits", "doSomething", "doNothing", "reasons", "projectPlanSummary", "investmentAppraisal", "risks"];
      return this.props.project.businessCase !== undefined && containFields(this.props.project.businessCase, expectedFields) === expectedFields.length ? "done" : this.props.project.businessCase !== undefined ? "inProgress" : "notStarted";
    }
  }, {
    key: 'definedProject',
    value: function definedProject() {
      var expectedFields = ["background", "timing", "bigPicture", "benefitsDescription", "objectivesSummary", "objectives", "projectScope", "scopeExclusions", "outcomes", "constraints", "assumptions", "stakeholderDescription", "interfaces"];
      var count = containFields(this.props.project, expectedFields);
      return count >= expectedFields.length - 3 ? "done" : count > 0 ? "inProgress" : "notStarted";
    }
  }, {
    key: 'describedProjectProduct',
    value: function describedProjectProduct() {
      var ppd = this.props.project.projectScope;
      return ppd !== undefined && ppd.length > 0 && ppd.filter(function (item) {
        return item.items !== undefined && item.items.length > 0;
      }).length === ppd.length ? "done" : ppd !== undefined && ppd.length > 0 ? "inProgress" : "notStarted";
    }
  }, {
    key: 'selectedApproach',
    value: function selectedApproach() {
      var expectedFields = ["methods", "resources", "technology", "rollOut", "other"];
      var count = containFields(this.props.project.approach, expectedFields);
      return this.props.project.approach !== undefined && count >= expectedFields.length - 1 ? "done" : this.props.project.approach !== undefined ? "inProgress" : "notStarted";
    }
  }, {
    key: 'plannedInitiation',
    value: function plannedInitiation() {
      return this.props.project.stages !== undefined && this.props.project.stages.length > 0 ? "done" : "notStarted";
    }
  }, {
    key: 'capturedLessons',
    value: function capturedLessons() {
      return this.props.project.lessons !== undefined ? "done" : this.props.project.browsedCorporateLessons ? "inProgress" : "notStarted";
    }
  }, {
    key: 'createdBriefDraft',
    value: function createdBriefDraft() {
      return this.props.project.brief !== undefined && this.props.project.brief.type === "draft" ? "done" : "notStarted";
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).startupProcess;
      var access = this.props.access;
      var activities = [{
        name: "appointExecutiveAndPM",
        link: "/organization",
        status: this.appointedExecutiveAndPM()
      }, {
        name: "captureLessons",
        link: "/plan?show=approach#lessons",
        status: this.capturedLessons()
      }, {
        name: "appointManagementTeam",
        link: "/organization",
        status: this.appointedManagementTeam()
      }, access.isBusinessCaseEnabled() ? {
        name: "prepareOutlineBusinessCase",
        link: "/businessCase",
        status: this.preparedBusinessCase()
      } : undefined, {
        name: "defineProject",
        link: "/definition",
        status: this.definedProject()
      }, {
        name: "describeProjectProduct",
        link: "/quality/#ppd",
        status: this.describedProjectProduct()
      }, {
        name: "selectApproach",
        link: "/plan?show=approach#planApproach",
        status: this.selectedApproach()
      }, {
        name: "planInitiation",
        link: "/plan?show=approach#schedule",
        status: this.plannedInitiation()
      }, {
        name: "assembleBrief",
        link: "/brief",
        status: this.createdBriefDraft()
      }].filter(function (item) {
        return item !== undefined;
      });
      var nextStep = {
        link: "/projects/" + this.props.project.id + "/brief/?showApprove=true"
      };
      return _react2.default.createElement(ActivityView, _extends({}, this.props, { activities: activities, labels: labels, nextStep: nextStep }));
    }
  }]);

  return StartUpProcessOverview;
}(_react2.default.Component);

var InitiationProcessOverview = function (_React$Component14) {
  _inherits(InitiationProcessOverview, _React$Component14);

  function InitiationProcessOverview() {
    _classCallCheck(this, InitiationProcessOverview);

    return _possibleConstructorReturn(this, (InitiationProcessOverview.__proto__ || Object.getPrototypeOf(InitiationProcessOverview)).apply(this, arguments));
  }

  _createClass(InitiationProcessOverview, [{
    key: 'describedRiskManagementApproach',
    value: function describedRiskManagementApproach() {
      var expectedFields = ["process", "tools", "reporting", "timing", "roles", "tolerance", "budget"];
      var count = containFields(this.props.project.riskApproach, expectedFields);
      return this.props.project.riskApproach !== undefined && count >= expectedFields.length - 1 ? "done" : this.props.project.riskApproach !== undefined ? "inProgress" : "notStarted";
    }
  }, {
    key: 'describedQualityManagementApproach',
    value: function describedQualityManagementApproach() {
      var expectedFields = ["process", "tools", "reporting", "timing", "roles"];
      var count = containFields(this.props.project.qualityApproach, expectedFields);
      return this.props.project.qualityApproach !== undefined && count >= expectedFields.length - 1 ? "done" : this.props.project.qualityApproach !== undefined ? "inProgress" : "notStarted";
    }
  }, {
    key: 'describedConfigurationManagementApproach',
    value: function describedConfigurationManagementApproach() {
      var expectedFields = ["process", "tools", "reporting", "timing", "roles", "scales"];
      var count = containFields(this.props.project.changeControlApproach, expectedFields);
      return this.props.project.changeControlApproach !== undefined && count >= expectedFields.length - 1 ? "done" : this.props.project.changeControlApproach !== undefined ? "inProgress" : "notStarted";
    }
  }, {
    key: 'describedCommunicationManagementApproach',
    value: function describedCommunicationManagementApproach() {
      var expectedFields = ["process", "tools", "reporting", "timing", "roles"];
      var count = containFields(this.props.project.communicationApproach, expectedFields);
      return this.props.project.communicationApproach !== undefined && count >= expectedFields.length - 1 ? "done" : this.props.project.communicationApproach !== undefined ? "inProgress" : "notStarted";
    }
  }, {
    key: 'definedProjectControls',
    value: function definedProjectControls() {
      return this.props.project.projectControls !== undefined ? this.props.project.projectControls.projectControls !== undefined ? "done" : "inProgress" : "notStarted";
    }
  }, {
    key: 'createdProjectPlan',
    value: function createdProjectPlan() {
      return this.props.project.stages !== undefined ? this.props.project.stages.length > 1 ? "done" : "inProgress" : "notStarted";
    }
  }, {
    key: 'preparedBusinessCase',
    value: function preparedBusinessCase() {
      var expectedFields = ["executiveSummary", "benefits", "doSomething", "doNothing", "reasons", "projectPlanSummary", "investmentAppraisal", "risks"];
      return this.props.project.businessCase !== undefined && containFields(this.props.project.businessCase, expectedFields) === expectedFields.length ? "done" : this.props.project.businessCase !== undefined ? "inProgress" : "notStarted";
    }
  }, {
    key: 'createdPIDDraft',
    value: function createdPIDDraft() {
      return this.props.project.pid !== undefined && this.props.project.pid.type === "draft" ? "done" : "notStarted";
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).initiationProcess;
      var access = this.props.access;
      var activities = [{
        name: "prepareRiskManagementApproach",
        link: "/risk?show=approach#riskManagementApproach",
        status: this.describedRiskManagementApproach()
      }, access.isQualityEnabled() ? {
        name: "prepareQualityManagementApproach",
        link: "/quality?show=approach#qualityManagementApproach",
        status: this.describedQualityManagementApproach()
      } : undefined, {
        name: "prepareConfigurationManagementApproach",
        link: "/change?show=approach#changeControlApproach",
        status: this.describedConfigurationManagementApproach()
      }, {
        name: "prepareCommunicationManagementApproach",
        link: "/organization?show=approach#communicationManagementApproach",
        status: this.describedCommunicationManagementApproach()
      }, {
        name: "setupProjectControls",
        link: "/plan?show=controls#projectControls",
        status: this.definedProjectControls()
      }, {
        name: "createProjectPlan",
        link: "/plan?show=controls#schedule",
        status: this.createdProjectPlan()
      }, access.isBusinessCaseEnabled() ? {
        name: "refineBusinessCase",
        link: "/businessCase",
        status: this.preparedBusinessCase()
      } : undefined, {
        name: "defineProject",
        link: "/definition",
        status: new StartUpProcessOverview(this.props).definedProject()
      }, {
        name: "describeProjectProduct",
        link: "/quality/#ppd",
        status: new StartUpProcessOverview(this.props).describedProjectProduct()
      }, {
        name: "selectApproach",
        link: "/plan?show=approach#planApproach",
        status: new StartUpProcessOverview(this.props).selectedApproach()
      }, {
        name: "assemblePID",
        link: "/pid",
        status: this.createdPIDDraft()
      }].filter(function (item) {
        return item !== undefined && !item.disabled;
      });
      var nextStep = {
        link: "/projects/" + this.props.project.id + "/pid/?showApprove=true"
      };
      return _react2.default.createElement(ActivityView, _extends({}, this.props, { activities: activities, labels: labels, nextStep: nextStep }));
    }
  }]);

  return InitiationProcessOverview;
}(_react2.default.Component);

var CloseProjectProcessOverview = function (_React$Component15) {
  _inherits(CloseProjectProcessOverview, _React$Component15);

  function CloseProjectProcessOverview() {
    _classCallCheck(this, CloseProjectProcessOverview);

    return _possibleConstructorReturn(this, (CloseProjectProcessOverview.__proto__ || Object.getPrototypeOf(CloseProjectProcessOverview)).apply(this, arguments));
  }

  _createClass(CloseProjectProcessOverview, [{
    key: 'createdLessons',
    value: function createdLessons() {
      return this.props.project.lessons !== undefined ? "done" : "notStarted";
    }
  }, {
    key: 'publishedEndProjectReport',
    value: function publishedEndProjectReport() {
      return this.props.project.endProjectReport !== undefined ? "done" : this.props.project.draftEndProject !== undefined ? "inProgress" : "notStarted";
    }
  }, {
    key: 'closedRisks',
    value: function closedRisks() {
      return this.props.project.risks === undefined || this.props.project.risks.filter(function (item) {
        return item.status !== "Closed";
      }).length === 0 ? "done" : "notStarted";
    }
  }, {
    key: 'closedIssues',
    value: function closedIssues() {
      return this.props.project.issues === undefined || this.props.project.issues.filter(function (item) {
        return item.status !== "Closed";
      }).length === 0 ? "done" : "notStarted";
    }
  }, {
    key: 'recommendedClosure',
    value: function recommendedClosure() {
      return this.props.project.recommendedProjectClosure !== undefined ? "done" : "notStarted";
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).closeProcess;
      var access = this.props.access;
      var activities = [{
        /*
              name: "acceptProducts",
              link: "/quality",
              status: "notSupported"
            }, {
        */
        name: "createLessons",
        link: "/plan?show=lessons#lessons",
        status: this.createdLessons()
      }, {
        name: "createEndProjectReport",
        link: this.props.project.endProjectReport === undefined ? "/highlight?endProject=true" : "/reports?showEndStage=true&id=" + this.props.project.endProjectReport.id,
        status: this.publishedEndProjectReport()
      }, {
        name: "closeRiskRegister",
        link: "/risk?show=approach",
        status: this.closedRisks()
      }, {
        name: "closeIssueRegister",
        link: "/change?show=approach",
        status: this.closedIssues()
      }, {
        name: "recommendClosure",
        link: "?showMenu=true",
        status: this.recommendedClosure()
      }].filter(function (item) {
        return item !== undefined;
      });
      var nextStep = this.props.project.recommendedProjectClosure !== undefined ? {
        link: "/projects/" + this.props.project.id + "/approve/close"
      } : undefined;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(ActivityView, _extends({}, this.props, {
          activities: activities,
          labels: labels,
          nextStep: nextStep,
          cancel: { link: "/projects/" + this.props.project.id + "/abort/close" }
        })),
        this.props.project.recommendedProjectClosure !== undefined && this.props.project.endProjectReport !== undefined ? _react2.default.createElement(
          'div',
          { style: { maxWidth: 1016 } },
          _react2.default.createElement(_HighlightReport.TitleAndSummary, _extends({}, this.props, this.props.project.endProjectReport))
        ) : null
      );
    }
  }]);

  return CloseProjectProcessOverview;
}(_react2.default.Component);

var DesignThinkingProcessOverview = function (_React$Component16) {
  _inherits(DesignThinkingProcessOverview, _React$Component16);

  function DesignThinkingProcessOverview() {
    _classCallCheck(this, DesignThinkingProcessOverview);

    return _possibleConstructorReturn(this, (DesignThinkingProcessOverview.__proto__ || Object.getPrototypeOf(DesignThinkingProcessOverview)).apply(this, arguments));
  }

  _createClass(DesignThinkingProcessOverview, [{
    key: 'render',
    value: function render() {
      //    let labels=translations.getTranslation(this.props).closeProcess;
      var labels = {
        title: "Anbefalte aktiviteter ved utforskning av en idé:",
        help: 'Design Thinking er en metodisk tiln\xE6rming til utforskning av id\xE9 med fem destinkte steg. Det er vanlig \xE5 g\xE5 frem og tilbake mellom stegene etterhvert som innsikten \xF8ker.',
        activities: {
          empatize: {
            title: "Emapati",
            help: "Skape innsikt i brukerens situasjon gjennom intervjuer, observasjoner og sette deg inn i brukerens situasjon for å forstå hva de trenger, ønsker, oppfører seg, føler, tenker og hvorfor de oppfører seg, følelser og tanker med interaksjon med produkter i reelle situasjoner. Dette omtales ofte som å 'gå i andres sko'."
          },
          define: {
            title: "Definere",
            help: "Etablere en problembeskrivelse gjennom å samle innsikten fra 'Empati'-arbeidet."
          },
          ideate: {
            title: "Idéutvikling",
            help: "Tenke utenfor boksen og identifiser mulige løsninger på problembeskrivelsen."
          },
          prototype: {
            title: "Prototype",
            help: "Eksperimenter med mulige løsninger gjennom utvikling av raske og billige prototyper."
          },
          test: {
            title: "Teste",
            help: "Prøv ut prototyper på relle brukere i relle situasjoner"
          }
        },
        nextStep: {
          title: "Realiser løsning"
        }
      };

      var access = this.props.access;
      var activities = [{
        name: "empatize",
        link: "",
        status: "notStarted"
      }, {
        name: "define",
        link: "",
        status: "notStarted"
      }, {
        name: "ideate",
        link: "",
        status: "notStarted"
      }, {
        name: "prototype",
        link: "",
        status: "notStarted"
      }, {
        name: "test",
        link: "",
        status: "notStarted"
      }].filter(function (item) {
        return item !== undefined;
      });
      var nextStep = {
        link: "/projects/" + this.props.project.id + "/"
      };
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { maxWidth: 800, paddingBottom: 30, fontStyle: "italic" } },
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_FormattedContent2.default, { value: this.props.project.background })
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_FormattedContent2.default, { value: this.props.project.timing })
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { textAlign: "center" } },
          _react2.default.createElement('img', { src: 'http://www.theagileelephant.com/wp-content/uploads/2018/02/Design-Thinking.png' })
        ),
        _react2.default.createElement(ActivityView, _extends({}, this.props, {
          activities: activities,
          labels: labels,
          nextStep: nextStep,
          hideThemes: true
        }))
      );
    }
  }]);

  return DesignThinkingProcessOverview;
}(_react2.default.Component);

function assignPriority(item) {
  return item.status !== "Closed" ? Object.assign({}, item, { row: parseInt(item.priority), column: parseInt(item.severity) }) : Object.assign({}, item, { row: undefined, column: undefined });
}

var KeyInfo = exports.KeyInfo = function (_React$Component17) {
  _inherits(KeyInfo, _React$Component17);

  function KeyInfo() {
    _classCallCheck(this, KeyInfo);

    return _possibleConstructorReturn(this, (KeyInfo.__proto__ || Object.getPrototypeOf(KeyInfo)).apply(this, arguments));
  }

  _createClass(KeyInfo, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      var executive = this.props.stakeholders !== undefined ? this.props.stakeholders.filter(function (stakeholder) {
        return stakeholder.role === "Excecutive" || stakeholder.role === "Senior Responsible Owner";
      }).map(function (person) {
        return person.name;
      }).join(", ") : undefined;
      var pManager = this.props.stakeholders !== undefined ? this.props.stakeholders.filter(function (stakeholder) {
        return stakeholder.role === "Project Manager" || stakeholder.role === "Product Manager" || stakeholder.role === "Programme Manager";
      }).map(function (person) {
        return person.name;
      }).join(", ") : undefined;
      var executiveLabel = this.props.isProgramme === true ? labels.general.sro : labels.general.executive;
      var pmLabel = this.props.isProgramme === true ? labels.general.programmeManager : labels.general.projectManager;
      return _react2.default.createElement(
        'div',
        { style: { backgroundColor: "#ffffff", border: "1px solid #D1D5DB", borderRadius: "10px", padding: 20, marginBottom: 20, minWidth: 420, float: "right" } },
        _react2.default.createElement(
          'div',
          { style: { fontSize: 22, paddingBottom: 10, width: "100%", textAlign: "center", fontWeight: "bold" } },
          ' ',
          labels.keyInformation.keyInformation,
          ' ',
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table", width: 380, marginLeft: 20, marginRight: 20, marginTop: 10, float: "center", borderCollapse: "collapse" } },
          _react2.default.createElement(
            'div',
            { style: { display: "table-row", borderBottom: "solid 1px #D1D5DB" } },
            _react2.default.createElement(
              'div',
              { style: { display: "table-cell", textAlign: "left", padding: 5 } },
              ' ',
              labels.keyInformation.identifier,
              ': '
            ),
            _react2.default.createElement(
              'div',
              { style: { display: "table-cell", textAlign: "left", padding: 5 } },
              ' ',
              this.props.identifier,
              ' '
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { display: "table-row", borderBottom: "solid 1px #D1D5DB" } },
            _react2.default.createElement(
              'div',
              { style: { display: "table-cell", textAlign: "left", padding: 5 } },
              executiveLabel,
              ':'
            ),
            _react2.default.createElement(
              'div',
              { style: { display: "table-cell", textAlign: "left", padding: 5 } },
              executive,
              '  '
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { display: "table-row", borderBottom: "solid 1px #D1D5DB" } },
            _react2.default.createElement(
              'div',
              { style: { display: "table-cell", textAlign: "left", padding: 5 } },
              pmLabel,
              ':'
            ),
            _react2.default.createElement(
              'div',
              { style: { display: "table-cell", textAlign: "left", padding: 5 } },
              pManager,
              '  '
            )
          ),
          this.props.isProgramme || this.props.isProduct || this.props.isRelease ? null : _react2.default.createElement(
            'div',
            { style: { display: "table-row" } },
            _react2.default.createElement(
              'div',
              { style: { display: "table-cell", textAlign: "left", padding: 5 } },
              labels.keyInformation.projectStage,
              ':'
            ),
            _react2.default.createElement(
              'div',
              { style: { display: "table-cell", textAlign: "left", padding: 5 } },
              this.props.phase,
              '  '
            )
          )
        )
      );
    }
  }]);

  return KeyInfo;
}(_react2.default.Component);

var StatusSummary = exports.StatusSummary = function (_React$Component18) {
  _inherits(StatusSummary, _React$Component18);

  function StatusSummary() {
    _classCallCheck(this, StatusSummary);

    return _possibleConstructorReturn(this, (StatusSummary.__proto__ || Object.getPrototypeOf(StatusSummary)).apply(this, arguments));
  }

  _createClass(StatusSummary, [{
    key: 'render',
    value: function render() {
      var _ref2;

      var labels = translations.getTranslation(this.props);
      var itemType = this.props.isProgramme === true ? "/programmes/" : this.props.isProduct === true ? "/products/" : this.props.isRelease === true ? "/releases/" : "/projects/";
      return _react2.default.createElement(
        'div',
        { style: { backgroundColor: "#ffffff", border: "1px solid #D1D5DB", borderRadius: "10px", padding: 20, marginBottom: 20, marginRight: 80, textAlign: "center", minWidth: 420 } },
        _react2.default.createElement(
          'div',
          { style: { fontSize: 22, paddingBottom: 10, width: "100%", fontWeight: "bold", textAlign: "center" } },
          ' ',
          labels.status.summaryStatus,
          ' \xA0  ',
          _react2.default.createElement(_StatusIndicator2.default, this.props.overallStatus),
          ' ',
          _react2.default.createElement('br', null),
          ' '
        ),
        _react2.default.createElement(
          'a',
          { style: { fontFamily: "Lato", fontStyle: "normal", fontWeight: "bold", fontSize: "14px", lineHight: "20px", color: "#9a9eb1" }, href: itemType + this.props.id + "/reports/" },
          ' ',
          labels.reports.highlightReport
        ),
        _react2.default.createElement(
          'div',
          { style: (_ref2 = { display: "table", marginTop: 20, float: "center" }, _defineProperty(_ref2, 'float', "center"), _defineProperty(_ref2, 'borderCollapse', "collapse"), _ref2) },
          _react2.default.createElement(
            'div',
            { style: { display: "table-row", fontWeight: "bold" } },
            _react2.default.createElement(
              'div',
              { style: { display: "table-cell", width: 60, textAlign: "center", padding: 5 } },
              _react2.default.createElement(_StatusIndicator2.default, this.props.benefits)
            ),
            _react2.default.createElement(
              'div',
              { style: { display: "table-cell", width: 60, textAlign: "center", padding: 5 } },
              _react2.default.createElement(_StatusIndicator2.default, this.props.time),
              ' '
            ),
            _react2.default.createElement(
              'div',
              { style: { display: "table-cell", width: 60, textAlign: "center", padding: 5 } },
              _react2.default.createElement(_StatusIndicator2.default, this.props.cost),
              ' '
            ),
            _react2.default.createElement(
              'div',
              { style: { display: "table-cell", width: 60, textAlign: "center", padding: 5 } },
              _react2.default.createElement(_StatusIndicator2.default, this.props.quality)
            ),
            _react2.default.createElement(
              'div',
              { style: { display: "table-cell", width: 60, textAlign: "center", padding: 5 } },
              _react2.default.createElement(_StatusIndicator2.default, this.props.scope),
              '  '
            ),
            _react2.default.createElement(
              'div',
              { style: { display: "table-cell", width: 60, textAlign: "center", padding: 5 } },
              _react2.default.createElement(_StatusIndicator2.default, this.props.risk),
              ' '
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { display: "table-row", fontWeight: "bold" } },
            _react2.default.createElement(
              'div',
              { style: { display: "table-cell", textAlign: "center", padding: 5 } },
              labels.status.benefits
            ),
            _react2.default.createElement(
              'div',
              { style: { display: "table-cell", textAlign: "center", padding: 5 } },
              labels.status.time,
              '  '
            ),
            _react2.default.createElement(
              'div',
              { style: { display: "table-cell", textAlign: "center", padding: 5 } },
              labels.status.cost,
              ' '
            ),
            _react2.default.createElement(
              'div',
              { style: { display: "table-cell", textAlign: "center", padding: 5 } },
              labels.status.quality
            ),
            _react2.default.createElement(
              'div',
              { style: { display: "table-cell", textAlign: "center", padding: 5 } },
              labels.status.scope,
              '  '
            ),
            _react2.default.createElement(
              'div',
              { style: { display: "table-cell", textAlign: "center", padding: 5 } },
              labels.status.risk,
              '  '
            )
          )
        )
      );
    }
  }]);

  return StatusSummary;
}(_react2.default.Component);

var ProjectDetails = exports.ProjectDetails = function (_React$Component19) {
  _inherits(ProjectDetails, _React$Component19);

  function ProjectDetails() {
    _classCallCheck(this, ProjectDetails);

    return _possibleConstructorReturn(this, (ProjectDetails.__proto__ || Object.getPrototypeOf(ProjectDetails)).apply(this, arguments));
  }

  _createClass(ProjectDetails, [{
    key: 'isBusinessCaseEnabled',
    value: function isBusinessCaseEnabled() {
      return _ProjectSettings.Access.isBusinessCaseEnabled({ project: this.props.project.settings, tenant: this.props.tenant.settings });
      /*
          let disabledInTenant=this.props.tenant.settings!==undefined && this.props.tenant.settings.disableBusinessCase===true;
          let useBusinessCaseInProject=this.props.project.settings!==undefined && this.props.project.settings.useBusinessCase;
          return this.props.project.settings===undefined && !disabledInTenant || useBusinessCaseInProject===true || useBusinessCaseInProject===undefined;
      */
    }
  }, {
    key: 'isQualityEnabled',
    value: function isQualityEnabled() {
      return this.props.project.settings === undefined || this.props.project.settings !== undefined && this.props.project.settings.disabledQuality !== true;
    }
  }, {
    key: 'isDefinitionEnabled',
    value: function isDefinitionEnabled() {
      return this.props.project.settings === undefined || this.props.project.settings !== undefined && this.props.project.settings.disabledDefinition !== true;
    }
  }, {
    key: 'isProjectBriefEnabled',
    value: function isProjectBriefEnabled() {
      var enabledInSettings = this.props.project.settings !== undefined && this.props.project.settings.reports !== undefined && this.props.project.settings.reports.projectBrief;
      return enabledInSettings || this.props.fullOverview !== undefined;
    }
  }, {
    key: 'isPIDEnabled',
    value: function isPIDEnabled() {
      var enabledInSettings = this.props.project.settings !== undefined && this.props.project.settings.reports !== undefined && this.props.project.settings.reports.PID;
      return enabledInSettings || this.props.fullOverview !== undefined;
    }
  }, {
    key: 'hasApprovedBrief',
    value: function hasApprovedBrief() {
      return this.props.project.brief !== undefined && this.props.project.brief.history !== undefined && this.props.project.brief.history.length > 0;
    }
  }, {
    key: 'hasApprovedPID',
    value: function hasApprovedPID() {
      return this.props.project.pid !== undefined && this.props.project.pid.history !== undefined && this.props.project.pid.history.length > 0;
    }
  }, {
    key: 'showStartupProcessView',
    value: function showStartupProcessView() {
      return this.props.showProgress === "startup" || this.isProjectBriefEnabled() && this.props.project.version === 2 && !this.hasApprovedBrief() && !this.hasApprovedPID() && !this.props.project.isCompleted;
    }
  }, {
    key: 'showInitiationProcessView',
    value: function showInitiationProcessView() {
      return !this.props.project.isCompleted && (this.props.showProgress === "initiation" || this.isPIDEnabled() && this.props.project.version === 2 && this.hasApprovedBrief() && !this.hasApprovedPID());
    }
  }, {
    key: 'render',
    value: function render() {
      var _this23 = this;

      var issues = this.props.project.issues !== undefined ? this.props.project.issues : [];
      var issueItems = issues.slice(0).map(assignPriority);

      var portfolio = this.props.portfolio !== undefined ? this.props.portfolio : this.props.project !== undefined && this.props.project.portfolio !== undefined && this.props.tenant.portfolios !== undefined ? this.props.tenant.portfolios.filter(function (portfolio) {
        return portfolio.id === _this23.props.project.portfolio;
      })[0] : undefined;

      var labels = translations.getTranslation(this.props);
      var riskItems = this.props.project.risks !== undefined ? this.props.project.risks : [];

      var access = {
        isBusinessCaseEnabled: this.isBusinessCaseEnabled.bind(this),
        isQualityEnabled: this.isQualityEnabled.bind(this),
        isDefinitionEnabled: this.isDefinitionEnabled.bind(this),
        isProjectBriefEnabled: this.isProjectBriefEnabled.bind(this),
        isPIDEnabled: this.isPIDEnabled.bind(this)
      };
      return _react2.default.createElement(
        'div',
        { style: { marginTop: 40, marginLeft: 30, fontFamily: "Lato" } },
        this.props.project.isStopped ? _react2.default.createElement(
          'span',
          { style: { color: "red", paddingRight: 20 } },
          'STOPPED'
        ) : null,
        this.props.project.isPaused ? _react2.default.createElement(
          'span',
          { style: { color: "red", paddingRight: 20 } },
          'paused'
        ) : null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { style: { fontWeight: "bold", fontSize: 14 } },
            portfolio !== undefined ? portfolio.name : null
          ),
          _react2.default.createElement(
            'div',
            { style: { fontSize: 30, marginBottom: 30, width: "100%", fontWeight: "bold", float: "left" } },
            this.props.project.name
          ),
          _react2.default.createElement(
            'div',
            { style: { display: "inline-block", maxWidth: 1016 } },
            _react2.default.createElement(
              'div',
              { style: { display: this.props.showProgress === "designThinking" ? "none" : "flex", padding: 0, marginBottom: 10, justifyContent: "space-between", flexWrap: "wrap" } },
              _react2.default.createElement(StatusSummary, _extends({}, this.props.project, this.props)),
              _react2.default.createElement(KeyInfo, _extends({}, this.props.project, this.props))
            ),
            this.props.showProgress === "designThinking" ? _react2.default.createElement(DesignThinkingProcessOverview, _extends({}, this.props, { access: access })) : this.props.project.isClosing ? _react2.default.createElement(CloseProjectProcessOverview, _extends({}, this.props, { access: access })) : this.showInitiationProcessView() ? _react2.default.createElement(InitiationProcessOverview, _extends({}, this.props, { access: access })) : this.showStartupProcessView() ? _react2.default.createElement(StartUpProcessOverview, _extends({}, this.props, { access: access })) : _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'table',
                { style: { paddingTop: 20, width: "100%", maxWidth: 1016, borderSpacing: 15 } },
                _react2.default.createElement(
                  'tbody',
                  null,
                  _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement(
                      'td',
                      null,
                      _react2.default.createElement(Themes, _extends({}, this.props, { access: access }))
                    )
                  )
                )
              ),
              this.props.project.isCompleted === true && this.props.project.endProjectReport !== undefined ? _react2.default.createElement(
                'div',
                { style: { maxWidth: 1016 } },
                _react2.default.createElement(_HighlightReport.TitleAndSummary, _extends({}, this.props, this.props.project.endProjectReport))
              ) : null
            ),
            _react2.default.createElement(
              'div',
              { style: { display: this.props.showProgress === "designThinking" ? "none" : "flex", marginTop: 10, justifyContent: "space-evenly", flexWrap: "wrap" } },
              _react2.default.createElement(
                'div',
                { style: { textAlign: "center" } },
                _react2.default.createElement(
                  'b',
                  null,
                  labels.general.risks
                ),
                ' ',
                _react2.default.createElement('br', null),
                ' ',
                _react2.default.createElement('br', null),
                _react2.default.createElement(_Risk.RiskTable, _extends({}, this.props, {
                  items: riskItems
                }))
              ),
              _react2.default.createElement(
                'div',
                { style: { textAlign: "center" } },
                _react2.default.createElement(
                  'b',
                  null,
                  labels.general.issues,
                  ' '
                ),
                _react2.default.createElement('br', null),
                ' ',
                _react2.default.createElement('br', null),
                _react2.default.createElement(_Change.IssueTable, _extends({}, this.props, {
                  items: issueItems
                }))
              )
            )
          ),
          this.props.showProgress !== "designThinking" ? _react2.default.createElement(Links, _extends({}, this.props, this.props.project, {
            standardLinks: this.props.tenant.standardLinks,
            mode: this.props.linkMode,
            edit: this.props.edit,
            add: this.props.add,
            briefEnabled: this.isProjectBriefEnabled(),
            pidEnabled: this.isPIDEnabled()
          })) : null
        ),
        _react2.default.createElement(Performance, this.props)
      );
    }
  }]);

  return ProjectDetails;
}(_react2.default.Component);

var PerformanceDetails = function (_React$Component20) {
  _inherits(PerformanceDetails, _React$Component20);

  function PerformanceDetails() {
    _classCallCheck(this, PerformanceDetails);

    return _possibleConstructorReturn(this, (PerformanceDetails.__proto__ || Object.getPrototypeOf(PerformanceDetails)).apply(this, arguments));
  }

  _createClass(PerformanceDetails, [{
    key: 'render',
    value: function render() {
      var _this25 = this;

      var size = JSON.stringify(this.props).length;
      var sortBySize = function sortBySize(a, b) {
        var sizeA = JSON.stringify(_this25.props[a]).length;
        var sizeB = JSON.stringify(_this25.props[b]).length;
        return sizeA < sizeB ? 1 : sizeA > sizeB ? -1 : 0;
      };
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          Object.keys(this.props).sort(sortBySize).map(function (key) {
            return _react2.default.createElement(
              'div',
              { style: { display: "flex" } },
              _react2.default.createElement(
                'b',
                null,
                key,
                ':'
              ),
              _react2.default.createElement(Performance, _extends({}, _this25.props[key], {
                length: JSON.stringify(_this25.props[key]).length,
                size: size,
                showSizeOfResponse: true
              }))
            );
          })
        )
      );
    }
  }]);

  return PerformanceDetails;
}(_react2.default.Component);

var Performance = function (_React$Component21) {
  _inherits(Performance, _React$Component21);

  function Performance(props) {
    _classCallCheck(this, Performance);

    var _this26 = _possibleConstructorReturn(this, (Performance.__proto__ || Object.getPrototypeOf(Performance)).call(this, props));

    _this26.state = { details: false };
    return _this26;
  }

  _createClass(Performance, [{
    key: 'toggleState',
    value: function toggleState(event) {
      this.setState({ details: !this.state.details });
    }
  }, {
    key: 'render',
    value: function render() {
      return !this.props.showSizeOfResponse ? null : this.state.details ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { cursor: "pointer" }, onClick: this.toggleState.bind(this) },
          '- ',
          JSON.stringify(this.props).length
        ),
        _react2.default.createElement(PerformanceDetails, this.props)
      ) : _react2.default.createElement(
        'div',
        { style: { cursor: "pointer" }, onClick: this.toggleState.bind(this) },
        '+ ',
        this.props.size !== undefined && this.props.length !== undefined ? _react2.default.createElement(
          'span',
          null,
          '(',
          this.props.length,
          this.props.size !== undefined ? ", " + (parseInt(this.props.length) / parseInt(this.props.size) * 100).toFixed(2) + "%" : "",
          ')'
        ) : null
      );
    }
  }]);

  return Performance;
}(_react2.default.Component);

var ProjectDetailsPage = function (_React$Component22) {
  _inherits(ProjectDetailsPage, _React$Component22);

  function ProjectDetailsPage() {
    _classCallCheck(this, ProjectDetailsPage);

    return _possibleConstructorReturn(this, (ProjectDetailsPage.__proto__ || Object.getPrototypeOf(ProjectDetailsPage)).apply(this, arguments));
  }

  _createClass(ProjectDetailsPage, [{
    key: 'render',
    value: function render() {
      var menu = this.props.showMenu === true ? _react2.default.createElement(_ProjectMenu2.default, this.props) : undefined;
      return _react2.default.createElement(
        _Layout2.default,
        _extends({}, this.props, { projectMenu: menu }),
        _react2.default.createElement(ProjectDetails, this.props)
      );
    }
  }]);

  return ProjectDetailsPage;
}(_react2.default.Component);

exports.default = ProjectDetailsPage;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var definition = __webpack_require__(177).english;

var english = exports.english = {
  general: {
    output: "output",
    approach: "Approach",
    scope: definition.scope.fields.projectScope.title
  },
  outputSummary: {
    cover: "To cover",
    projectWillDeliver: "the project will deliver",
    theReceiverWants: "For this output, the receiver and user want",
    willConfirm: "will confirm that we have",
    by: "by"
  },
  output: {
    title: "Output",
    fields: {
      output: {
        title: "Output",
        help: 'When the project is done, which deliverable needs to be ready and handed over to someone else for permanent ownership?',
        description: "Enter a high level output the project needs to deliver as part of this scope element"
      },
      qualityExpectation: {
        title: "Customer's Quality Expectation",
        help: 'Any high level requirements from the user or customer?\n          When the ownership of this deliverable is handed over from the project to the permanent\n          owner, what expectations will the permanent owner have to the characteristics of this output.',
        description: "Descrive the high level requirement for this output"
      }
    }
  },
  acceptance: {
    title: "Acceptance",
    fields: {
      acceptanceCriteria: {
        title: "Acceptance Criteria",
        help: 'What exactly need to be in place for this output to be judged as completed?\n          Which measurement, standard or specific characteristic?\n          Is there any tolerance on this measurement or standard?',
        description: "The measurable definition for acceptance of the required and any tolerance that might apply"
      },
      acceptanceMethod: {
        title: "Acceptance Method",
        help: 'How will we decide that the output is good enough?\n          Will we test, validate, review it or will someone just inspect and confirm?',
        description: "The method used to confirm that the output meets the acceptance criteria"
      },
      acceptanceResponsible: {
        title: "Acceptance Responsible",
        help: 'Who is responsible for confirming acceptance?\n          Who has the authority to say \u201Cyes, this is good enough\u201D?',
        description: "The responsible of confirming"
      }
    }
  },
  dependencies: {
    title: "Dependencies",
    fields: {
      derivation: {
        title: "Derivation",
        help: 'Are there any:\n          - reports used as input ?\n          - mandates, design specifications or more detailed requirement descriptions?\n          - existing product to build on?',
        description: "Describe source product for this output"
      },
      skills: {
        title: "Development skills required",
        help: 'Any special skills needed worth mentioning?\n          Which department, partner or vendor is needed to provide the needed skillset?',
        description: "Give an indication of the skills required and/or which area should supply the resources"
      }
    }
  },
  projectProductDescription: {
    title: "Project Product Description",
    description: 'The Project Product Description defines the final output of the project. It reflects the highest level of requirements. The high level outputs listed here can be further broken down in a product hierarchy to the level needed for planning and controlled execution.',
    fields: {
      scopeDetails: {
        title: "Scope composition",
        columns: {
          output: { title: "Composition / Output" },
          qualityExpectation: { title: "Quality Expectations" },
          acceptanceCriteria: { title: "Acceptance Criteria" },
          acceptanceMethod: { title: "Acceptance Method" }
        },
        samples: [{ output: "&lt;Output 1&gt;" }, { output: "&lt;Output 2&gt;" }],
        empty: {
          message: "Scope is not defined. Please define scope in 'Definition' before you identify outputs."
        },
        options: {
          addEntry: {
            title: "Add output"
          }
        }
      }
    }
  },
  qualityManagementApproach: {
    title: "Quality Management Approach",
    description: "The quality management approach describes how to manage quality, including requirement management. What will we do to make sure the projects' products are “fit for purpose”?",
    fields: {
      process: {
        title: "Process and Procedures",
        help: 'What method will be used to make sure the project:\n               a) captures all relevant needs and requirements? \n               b) correctly prioritizes the needs and requirements?\n               c) develops the correct design to meet those needs and requirements? \n               Are there any standard procedures to be followed on requirement management, testing, approvals etc.? Any planned deviation from these procedures? If so, why? \n               How will we make sure the quality procedure is followed \u2013 that approvals are tracked? \n               Is data privacy relevant for the project\u2019s output, and should the project perform privacy impact assessment(s)?',
        description: "Describe what processes will be followed to make sure all deliverables are fit for purpose."
      },
      tools: {
        title: "Tools and Techniques",
        help: 'Which techniques (interviews, prototypes, workshops etc.) will be used, to ensure we are making the right product? \n              Where will needs and requirements be organized, detailed and prioritized? \n              Where will test plans, protocols and reports be organized and controlled?\n              Any standards or templates to be used?\n              Which techniques will be used to make sure we are making the product right? (reviews,tests) \n              Will a quality register be used? If yes, is it the only tool used to track quality actions and approvals? If no, what will be used instead?',
        description: "Describe what tools or techniques will be applied to make sure all deliverables are fit for purpose."
      },
      reporting: {
        title: "Reporting",
        help: "When will quality be reported? Where will quality be reported and who will receive the quality reports?",
        description: "The reports to be produced, their purpose, timing and recipients."
      },
      timing: {
        title: "Timing of activities",
        help: "When will quality management activities occur? Any specific activities in Initiation or beginning/end of stages?",
        description: "Describe the timing of quality management activities"
      },
      roles: {
        title: "Roles and responsibilities",
        help: 'Who approved Briefs, Plans, Product Descriptions ?\n          Who makes sure detailed requirements are captured? Who approves them?\n          Who calls and organizes quality management activities and reviews?\n          Who makes test/review plans and reports?\n          Who enters what in the quality register and who approves?',
        description: "Define the roles and responsibilities for the activities"
      }
    }
  },
  products: {
    title: "Products"
  },
  qualityRegister: {
    title: "Quality Register"
  }
};

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var definition = __webpack_require__(178).norwegian;

var norwegian = exports.norwegian = {
  general: {
    output: "leveranse",
    approach: "Tilnærming",
    scope: definition.scope.fields.projectScope.title
  },
  outputSummary: {
    cover: "For å dekke",
    projectWillDeliver: "vil prosjektet levere",
    theReceiverWants: "For denne leveransen, ønsker mottakeren og brukeren at",
    willConfirm: "kommer til å bekrefte at vi har",
    by: "ved"
  },
  output: {
    title: "Leveranse",
    fields: {
      output: {
        title: "Leveranse",
        help: 'N\xE5r prosjektet er ferdig, hvilke leveranser m\xE5 v\xE6re laget og klar for overlevering til noen andre for permanent eierskap?',
        description: "Beskriv høynivå leveranse prosjektet må produsere for denne delen av omfanget"
      },
      qualityExpectation: {
        title: "Forventninger til kvalitet",
        help: 'Finnes det overordnet krav fra brukeren eller kunden? N\xE5r eierskap for denne leveransen er overlevert fra prosjektet til permanent eier, hvilke forventninger vil permanent eier ha til egenskapene for denne leveransen?',
        description: "Beskriv generelle krav til denne leveransen"
      }
    }
  },
  acceptance: {
    title: "Akseptanse",
    fields: {
      acceptanceCriteria: {
        title: "Akseptansekriterier",
        help: 'Hva trenger \xE5 v\xE6re p\xE5 plass for at denne leveransen skal bli vurdert til \xE5 v\xE6re levert? Hvilke m\xE5l, standard eller spesifikke egenskaper? Er det noen toleranser for m\xE5lingen eller standardene?',
        description: "Beskriv den målbare definisjonen for akseptanse av krav(ene)"
      },
      acceptanceMethod: {
        title: "Akseptansemetode",
        help: 'Hvordan vil vi beslutte at leveransen er god nok? Vil vi teste, validere, gjennomg\xE5 den eller vil noen bare inspisere og bekrefte?',
        description: "Metoden som skal brukes for å bekrefte at leveransen møter de målbare kravene"
      },
      acceptanceResponsible: {
        title: "Akseptanseansvarlig",
        help: 'Hvem er ansvarlig for \xE5 bekrefte akseptanse? Hvem har autoritet til \xE5 si "Ja, dette er godt nok"?',
        description: "Den som skal bekrefte at kravene er oppnådd"
      }
    }
  },
  dependencies: {
    title: "Avhengigheter",
    fields: {
      derivation: {
        title: "Baseres på",
        help: 'Finnes det noen rapport brukt som innspill/utgangspunkt? Mandat, design spesifikasjon eller mer detaljert beskrivelse av krav? Eksisterende produkt \xE5 bygge videre p\xE5?',
        description: "Beskriv tidligere leveranser som denne leveransen bygger på"
      },
      skills: {
        title: "Nødvendige ferdigheter/kompetanse",
        help: 'Er det noen spesielle ferdigheter som er verdt \xE5 nevne? Hvilken avdeling, partner eller leverand\xF8r er n\xF8dvendig for \xE5 gi den n\xF8dvendige ferdigheten?',
        description: "Gi en indikasjon på hvilken kompetanse or/eller hvilen avdeling/organisasjon som må stille resurser tilgjengelig"
      }
    }
  },
  projectProductDescription: {
    title: "Leveranser",
    fields: {
      scopeDetails: {
        title: "Oppdeling av omfanget",
        optional: true,
        help: 'Del opp dette omfangselementet i de leveransene det inneb\xE6rer.',
        columns: {
          output: { title: "Leveranse" },
          qualityExpectation: { title: "Kvalitetsforventning" },
          acceptanceCriteria: { title: "Akseptansekrav" },
          acceptanceMethod: { title: "Akseptansemetode" }
        },
        samples: [{ output: "Leveranse av eksempel 1" }, { output: "Leveranse av eksempel 2" }],
        empty: {
          message: "Omfang er ikke definert. Vennligst legg inn omfang i 'Definisjon'."
        },
        options: {
          addEntry: {
            title: "Legg til leveranse"
          }
        }
      }
    }
  },
  qualityManagementApproach: {
    title: " Kvalitetstilnærming",
    description: "Kvalitetstilnærmingen beskriver hvordan kvalitet skal håndteres, inkludert kravstyring. Hva skal vi gjøre for å sikre at produkter er \"egnet til formål\"?",
    fields: {
      process: {
        title: "Prosess og prosedyrer",
        help: 'Hvilken metode vil bli brukt til \xE5 s\xF8rge for at prosjektet:\n\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 a) fanger alle relevante behov og krav?\n\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 b) prioriterer behov og krav riktig?\n\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0 c) utvikler riktig l\xF8sning for \xE5 m\xF8te disse behovene og kravene?\n               Er det noen standardprosedyrer som skal f\xF8lges p\xE5 kravstyring, testing, godkjenning etc.? Er det planlagt avvik fra disse prosedyrene? Hvis ja, hvorfor? \n               Hvordan skal vi s\xF8rge for at kvalitetsprosedyren f\xF8lges - at godkjenningene spores? \n               Er datasikkerhet relevant for prosjektets sluttprodukt, og skal prosjektet utf\xF8re konsekvensvurdering av personvern?',
        description: "Beskriv hvilke prosesser prosjektet vil følge for å sikre at alle leveranser passer til formålet."
      },
      tools: {
        title: "Verktøy og teknikker",
        help: 'Hvilke teknikker (intervjuer, prototyper, workshops etc.) vil bli brukt for \xE5 sikre at vi lager det rette produktet? Hvilke teknikker vil bli brukt til \xE5 sikre at vi gj\xF8r produktet riktig? (vurderinger, tester) \n              Hvor skal behov og krav bli organisert, detaljert og prioritert?\n              Hvor blir testplaner, testprotokoller og testrapporter organisert og kontrollert?\n              Eventuelle standarder eller maler som skal brukes?\n              Vil et kvalitetsregister bli brukt? Hvis ja, er det det eneste verkt\xF8yet som brukes til \xE5 spore kvalitetshandlinger og godkjenninger? Hvis nei, hva vil bli brukt i stedet?',
        description: "Beskriv hvilke verktøy eller teknikker som skal brukes for å sikre at alle leveransene passer til formålet."
      },
      reporting: {
        title: "Rapportering",
        help: "Når blir kvaliteten rapportert? Hvor skal kvaliteten rapporteres og hvem vil motta kvalitetsrapporter?",
        description: "Rapporter som skal produseres, deres formål, timing og mottakere."
      },
      timing: {
        title: "Timing av aktiviteter",
        help: "Når skal kvalitetsledelsesaktiviteter gjenomføres? Eventuelle spesifikke aktiviteter i begynnelsen eller begynnelsen / slutten av etapper?",
        description: "Beskriv timingen for kvalitetsstyringsaktiviteter"
      },
      roles: {
        title: "Roller og ansvar",
        help: 'Hvem godkjenner prosjektforslag, planer og produktbeskrivelsene?\n          Hvem s\xF8rger for at detaljerte krav blir tatt? Hvem godkjenner dem?\n          Hvem innkaller og organiserer kvalitetsledelsesaktiviteter og vurderinger?\n          Hvem lager test / vurdering av planer og rapporter?\n          Hvem inng\xE5r hva i kvalitetsregisteret og hvem godkjenner?',
        description: "Definer roller og ansvar for aktivitetene"
      }
    }
  },
  products: {
    title: "Produkter"
  },
  qualityRegister: {
    title: "Kvalitetsregister"
  }
};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Plan = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.formatTimeTolerance = formatTimeTolerance;
exports.setupSchedule = setupSchedule;
exports.addTotalsToSchedule = addTotalsToSchedule;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _uuid = __webpack_require__(26);

var _uuid2 = _interopRequireDefault(_uuid);

var _AreaForm = __webpack_require__(28);

var _AreaForm2 = _interopRequireDefault(_AreaForm);

var _ProjectMenu = __webpack_require__(17);

var _ProjectMenu2 = _interopRequireDefault(_ProjectMenu);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _formDefinition = __webpack_require__(1087);

var _formDefinition2 = _interopRequireDefault(_formDefinition);

var _stageFormDefinition = __webpack_require__(437);

var _stageFormDefinition2 = _interopRequireDefault(_stageFormDefinition);

var _ProjectPlan = __webpack_require__(438);

var _StagePlan = __webpack_require__(439);

var _StagePlan2 = _interopRequireDefault(_StagePlan);

var _LessonDetails = __webpack_require__(1093);

var _LessonDetails2 = _interopRequireDefault(_LessonDetails);

var _PhaseTransition = __webpack_require__(1094);

var _PhaseTransition2 = _interopRequireDefault(_PhaseTransition);

var _ExceptionManagement = __webpack_require__(443);

var _ExceptionManagement2 = _interopRequireDefault(_ExceptionManagement);

var _LessonFilterAdvanced = __webpack_require__(1095);

var _LessonFilterAdvanced2 = _interopRequireDefault(_LessonFilterAdvanced);

var _BaselineHistory = __webpack_require__(1097);

var _BaselineHistory2 = _interopRequireDefault(_BaselineHistory);

var _sendCommand = __webpack_require__(25);

var _sendCommand2 = _interopRequireDefault(_sendCommand);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

var _FormattedContent = __webpack_require__(15);

var _FormattedContent2 = _interopRequireDefault(_FormattedContent);

var _setupStageBudget = __webpack_require__(440);

var _setupStageBudget2 = _interopRequireDefault(_setupStageBudget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(58), __webpack_require__(59)]).loadVariants([__webpack_require__(441), __webpack_require__(442)]);

function parseDate(date) {
  try {
    var parsedDate = date !== undefined && date !== null && date.length > 0 ? new Date(date).toISOString().slice(0, 10) : undefined;
    if (parsedDate !== date) {
      return date;
    } else {
      return parsedDate;
    }
  } catch (error) {
    return date;
  }
}

function formatNumber(value, column, context) {
  return column === "hours" || column === "expences" || column === "investments" || column === "sum" || column === "costTolerance" || column === "cost" || column === "tolerance" ? _react2.default.createElement(
    'div',
    { style: { textAlign: "right" } },
    value !== undefined && value !== null ? value.replace(/\B(?=(\d{3})+(?!\d))/g, context.language !== "norwegian" ? "," : " ") : ""
  ) : _react2.default.createElement(_FormattedContent2.default, { value: value });
}

function stageToTableView(stage, props) {
  return Object.assign({}, stage, {
    start: stage.time !== undefined ? parseDate(stage.time.start) : undefined,
    end: stage.time !== undefined ? parseDate(stage.time.end) : undefined,
    timeTolerance: stage.time !== undefined ? formatTimeTolerance(stage.time, props) : undefined,
    hours: stage.cost.hours,
    expences: stage.cost.expences,
    investments: stage.cost.investment,
    sum: stage.cost.sum,
    costTolerance: stage.cost.tolerance,
    _displayAs: stage.active ? "_highlight" : stage.historic ? "_disabled" : stage.requestedTransitionTo ? "" : "_normal",
    _format: stage.requestedTransitionTo === true || stage.requestedException === true || stage.actuals === true ? function (value, column, context) {
      return column === "name" ? _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(_FormattedContent2.default, { value: value }),
        stage.actuals === true ? _react2.default.createElement(
          'span',
          { style: { float: "right", color: "darkgrey", paddingRight: 5 } },
          '\u2713'
        ) : _react2.default.createElement('img', { src: "/images/" + (stage.requestedTransitionTo === true ? "Flag_FinishGrey_22x16.gif" : "Flag_DarkGrey_22x16.gif"), style: { paddingLeft: 10, height: 19 } })
      ) : formatNumber(value, column, context);
    } : formatNumber
  });
}

function translateTimeTolerance(stageTime, props) {
  var stage = {
    time: stageTime
  };
  if (stage.time.tolerance !== undefined && stage.time.tolerance !== null) {
    try {
      var unit = stage.time.tolerance.split(" ")[1].toLowerCase();
      var number = stage.time.tolerance.split(" ")[0];
      var unitOptions = translations.getTranslation(props).stageTime.fields.timeToleranceUnit.options;
      if (unitOptions[unit] === undefined) {
        if (unitOptions[unit + (unit.slice(-1) !== "s" ? "s" : "")] !== undefined) {
          unit = unit + (unit.slice(-1) !== "s" ? "s" : "");
        };
      }
      if (unitOptions[unit] === undefined) {
        var values = Object.keys(unitOptions).map(function (key) {
          return unitOptions[key];
        }).map(function (value) {
          return value.toLowerCase();
        });
        if (values.includes(unit)) {
          unit = Object.keys(unitOptions)[values.indexOf(unit)];
        } else if (values.includes(unit + "er")) {
          unit = Object.keys(unitOptions)[values.indexOf(unit + "er")];
        }
      }

      if (unitOptions[unit] !== undefined) {
        return { value: number, unit: unit };
      } else {
        stage.timeTolerance = stage.time.tolerance;
        return { value: stage.time.tolerance };
      }
    } catch (error) {
      return { value: stage.time.tolerance };
    }
  } else {
    return { value: stage.time.tolerance };
  }
}

function formatTimeTolerance(stageTime, props) {
  var tolerance = translateTimeTolerance(stageTime, props);
  return formatTolerance(tolerance, props);
}

function formatTolerance(tolerance, props) {
  var labels = translations.getTranslation(props).stageTime.fields.timeToleranceUnit.options;
  var unit = tolerance.unit !== undefined ? " " + labels[tolerance.unit].toLowerCase() : "";
  var formatedTolerance = tolerance.value !== undefined && tolerance.value !== null && tolerance.value !== "null" ? tolerance.value + unit : "";
  return formatedTolerance;
}

var LessonFilterItem = function (_React$Component) {
  _inherits(LessonFilterItem, _React$Component);

  function LessonFilterItem() {
    _classCallCheck(this, LessonFilterItem);

    return _possibleConstructorReturn(this, (LessonFilterItem.__proto__ || Object.getPrototypeOf(LessonFilterItem)).apply(this, arguments));
  }

  _createClass(LessonFilterItem, [{
    key: 'selected',
    value: function selected(event) {
      this.props.onChange({ type: this.props.id, onlyProject: this.props.onlyProject });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        { style: { paddingRight: 20 } },
        _react2.default.createElement('input', { onChange: this.selected.bind(this), defaultChecked: this.props.checked, type: 'radio', id: this.props.id, name: 'lessons' }),
        ' ',
        _react2.default.createElement(
          'label',
          { htmlFor: this.props.id },
          this.props.label
        )
      );
    }
  }]);

  return LessonFilterItem;
}(_react2.default.Component);

var LessonsFilter = function (_React$Component2) {
  _inherits(LessonsFilter, _React$Component2);

  function LessonsFilter() {
    _classCallCheck(this, LessonsFilter);

    return _possibleConstructorReturn(this, (LessonsFilter.__proto__ || Object.getPrototypeOf(LessonsFilter)).apply(this, arguments));
  }

  _createClass(LessonsFilter, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var categoryLabels = translations.getTranslation(this.props).summary.fields.type.options;
      var labels = translations.getTranslation(this.props).general.lessons;
      return _react2.default.createElement(
        'div',
        null,
        ["project", this.props.tenant.portfolios !== undefined && this.props.tenant.portfolios.length > 0 ? "portfolio" : undefined, "corporate"].filter(function (item) {
          return item !== undefined;
        }).map(function (item) {
          return _react2.default.createElement(LessonFilterItem, {
            id: item,
            label: categoryLabels[item],
            checked: item === _this3.props.selected,
            onlyProject: _this3.props.onlyProject,
            onChange: _this3.props.onChange
          });
        }),
        this.props.selected !== "project" ? _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement('input', { onClick: function onClick(event) {
              return _this3.props.onChange({ type: _this3.props.selected, onlyProject: event.target.checked });
            }, type: 'checkbox', id: 'projectOnly', defaultChecked: this.props.onlyProject }),
          _react2.default.createElement(
            'span',
            null,
            ' '
          ),
          _react2.default.createElement(
            'label',
            { htmlFor: 'projectOnly' },
            labels.onlyProject
          )
        ) : null,
        this.props.selected !== "project" && this.props.onlyProject !== true ? _react2.default.createElement(_LessonFilterAdvanced2.default, _extends({}, this.props, {
          onChange: function onChange(filter, keywords) {
            return _this3.props.onChange({
              type: _this3.props.selected,
              onlyProject: _this3.props.onlyProject,
              filter: filter,
              keywords: keywords
            });
          },
          limitToPortfolio: this.props.selected === "portfolio" ? this.props.project.portfolio : undefined
        })) : null
      );
    }
  }]);

  return LessonsFilter;
}(_react2.default.Component);

function setupSchedule(stages, props) {
  var labels = translations.getTranslation(props).general.stagePlan;
  var schedule;
  if (props.planVersion === "2") {
    if (props.projectType === undefined || props.projectType.phases === undefined) {
      schedule = [{
        id: "_project",
        text: labels.projectPhase,
        items: stages !== undefined ? stages.map(function (stage) {
          return stageToTableView(stage, props);
        }) : undefined
      }];
    } else {
      var currentPhaseIndex = -1;
      props.projectType.phases.forEach(function (phase, index) {
        if (props.project.currentPhase !== undefined && props.project.currentPhase.id === phase.id) {
          currentPhaseIndex = index;
        }
      });
      schedule = props.projectType.phases.map(function (phase, index) {
        return Object.assign({}, phase, {
          _displayAs: props.project.currentPhase !== undefined && props.project.currentPhase.id === phase.id ? "_highlight" : props.project.requestedPhase !== undefined && props.project.requestedPhase.id === phase.id ? "_normal" : undefined,
          items: stages !== undefined ? stages.filter(function (stage) {
            return stage.phase !== undefined && stage.phase.id === phase.id;
          }).map(function (stage) {
            return stageToTableView(stage, props);
          }) : [],
          _disableOption: index < currentPhaseIndex ? ["addEntry"] : undefined
        });
      });
      var hasInvalidPhase = function hasInvalidPhase(stage, phasesInProjectType) {
        return stage.phase === undefined || stage.phase.id === undefined || stage.phase !== undefined && stage.phase.id !== undefined && phasesInProjectType !== undefined && phasesInProjectType.filter(function (phase) {
          return phase.id === stage.phase.id;
        }).length === 0;
      };
      if (stages !== undefined && stages.filter(function (stage) {
        return hasInvalidPhase(stage, props.projectType.phases);
      }).length > 0) {
        schedule = [].concat({
          id: "_project",
          text: "(" + labels.projectPhase + ")",
          items: stages.filter(function (stage) {
            return hasInvalidPhase(stage, props.projectType.phases);
          }).map(function (stage) {
            return stageToTableView(stage, props);
          })
        }).concat(schedule);
      }
    }
  }
  return schedule;
}

function addTotalsToSchedule(schedule, props) {
  var labels = translations.getTranslation(props).general.stagePlan;
  var sortByStart = function sortByStart(a, b) {
    return a.time.start < b.time.start ? -1 : a.time.start > b.time.start ? 1 : 0;
  };
  var sortByEnd = function sortByEnd(a, b) {
    return a.time.end > b.time.end ? -1 : a.time.end < b.time.end ? 1 : 0;
  };
  var startOf = function startOf(stages) {
    var sortedStages = (stages !== undefined ? stages : []).filter(function (stage) {
      return stage !== undefined;
    }).filter(function (stage) {
      return stage.time !== undefined && stage.time.start !== undefined && stage.time.start !== null && stage.time.start.trim().length > 0;
    }).slice().sort(sortByStart);
    return sortedStages.length > 0 && sortedStages[0].time !== undefined ? sortedStages[0].time.start : undefined;
  };
  var endOf = function endOf(stages) {
    var sortedStages = (stages !== undefined ? stages : []).filter(function (stage) {
      return stage !== undefined;
    }).filter(function (stage) {
      return stage.time !== undefined && stage.time.end !== undefined && stage.time.end !== null && stage.time.end.trim().length > 0;
    }).slice().sort(sortByEnd);
    return sortedStages.length > 0 && sortedStages[0].time !== undefined ? sortedStages[0].time.end : undefined;
  };
  var sumCost = function sumCost(stages, field) {
    var valueOf = function valueOf(fieldValue) {
      var parsedValue = parseInt(fieldValue);
      var calculatedValue = !isNaN(parsedValue) && fieldValue == parsedValue ? parsedValue : 0;
      return calculatedValue;
    };
    return stages !== undefined ? stages.filter(function (stage) {
      return stage !== undefined;
    }).reduce(function (sum, stage) {
      return sum + valueOf(stage.cost[field]);
    }, 0) + "" : 0;
  };

  var sumTimeTolerance = function sumTimeTolerance(stages) {
    var days = stages.filter(function (stage) {
      return stage !== undefined;
    }).map(function (stage) {
      return translateTimeTolerance(stage.time, props);
    }).filter(function (tolerance) {
      return tolerance.value !== null && tolerance.value !== undefined && tolerance.value !== "null";
    }).map(function (tolerance) {
      return tolerance.unit === "days" ? parseInt(tolerance.value) : tolerance.unit === "weeks" ? parseInt(tolerance.value) * 5 : tolerance.unit === "months" ? parseInt(tolerance.value) * 21.5 : 0;
    }).reduce(function (sum, item) {
      return sum + (isNaN(item) ? 0 : item);
    }, 0);
    var sumTolerance = { value: days.toString(), unit: "days" };
    if (days >= 21) {
      sumTolerance = { value: (days / 21.5).toFixed(1), unit: "months" };
    } else if (days >= 5) {
      sumTolerance = { value: (days / 5).toFixed(1), unit: "weeks" };
    }
    if (sumTolerance.value.indexOf(".0") > 0) {
      sumTolerance.value = sumTolerance.value.split(".")[0];
    }
    if (props.language === "norwegian" && sumTolerance.value.indexOf(".") > 0) {
      sumTolerance.value = sumTolerance.value.replace(".", ",");
    }
    return formatTolerance(sumTolerance, props);
  };

  var updatedSchedule = schedule !== undefined ? schedule.map(function (phase) {
    return Object.assign({}, phase, {
      items: phase.items !== undefined && phase.items.length > 0 ? phase.items.concat({
        id: "_" + phase.id + "_total",
        name: labels.totalStagePrefix + " " + phase.text,
        type: "total",
        start: startOf(phase.items),
        end: endOf(phase.items),
        timeTolerance: sumTimeTolerance(phase.items),
        hours: sumCost(phase.items, "hours"),
        expences: sumCost(phase.items, "expences"),
        investments: sumCost(phase.items, "investment"),
        sum: sumCost(phase.items, "sum"),
        costTolerance: sumCost(phase.items, "tolerance"),
        _format: formatNumber
      }) : phase.items
    });
  }) : undefined;

  var stages = schedule !== undefined ? [].concat.apply([], schedule.map(function (phase) {
    return phase.items;
  })) : undefined;
  var doesNotHavePhases = schedule !== undefined && schedule.length <= 1;
  if (!doesNotHavePhases && updatedSchedule !== undefined) {
    updatedSchedule = updatedSchedule.concat({
      id: "_totals",
      text: "",
      type: "total",
      _hideColumnHeader: ["stage"],
      _disableOption: ["addEntry"],
      items: [{
        id: "_totalStage",
        name: labels.totalPhase,
        start: startOf(stages),
        end: endOf(stages),
        hours: sumCost(stages, "hours"),
        timeTolerance: sumTimeTolerance(stages),
        expences: sumCost(stages, "expences"),
        investments: sumCost(stages, "investment"),
        sum: sumCost(stages, "sum"),
        costTolerance: sumCost(stages, "tolerance"),
        _format: formatNumber
      }]
    });
  }
  return updatedSchedule;
}

function adjustFormForType(formDefinition, type) {
  if (type !== undefined) {
    var updatedForm = formDefinition.filter(function (item) {
      return item._excludedFor === undefined || !item._excludedFor.includes(type);
    }).map(function (area) {
      return Object.assign({}, area, {
        fields: area.fields.filter(function (item) {
          return item._excludedFor === undefined || !item._excludedFor.includes(type);
        })
      });
    });
    return updatedForm;
  } else {
    return formDefinition;
  }
}

function lessonIncludedByFilter(lesson, filter) {
  var age = (new Date().getTime() - new Date(lesson.identified).getTime()) / (1000 * 60 * 60 * 24 * 365);
  var content = [].concat(lesson.source !== undefined && lesson.source.type !== undefined ? "projectType_" + lesson.source.type : "").concat(lesson.source !== undefined && lesson.source.category !== undefined ? "category_" + lesson.source.category : "").concat(lesson.source !== undefined && lesson.source.portfolio !== undefined ? "portfolio_" + lesson.source.portfolio : "").concat(lesson.source !== undefined && lesson.source.location !== undefined ? "location_" + lesson.source.location : "").concat(lesson.source !== undefined && lesson.source.state !== undefined ? "state_" + lesson.source.state : "").concat(age < 1 ? "time_lessThan12Months" : age >= 1 && age < 3 ? "time_oneToThreeYears" : age >= 3 && age < 5 ? "threeToFiveYears" : "time_moreThanfiveYears").filter(function (value) {
    return value.length > 0;
  });
  return content.reduce(function (found, classification) {
    return found && filter[classification] === true;
  }, true);
}

function lessonIncludedByKeywords(lesson, keywords) {
  var searchFor = keywords.split(",");
  var content = [].concat(lesson.title).concat(lesson.effect).concat(lesson.event).concat(lesson.cause).concat(lesson.source !== undefined && lesson.source !== null ? lesson.source.name : "").concat(lesson.indicators).concat(lesson.recommendations).concat(lesson.author !== undefined && lesson.author !== null ? lesson.author.name : "");
  return searchFor.reduce(function (found, criteria) {
    return found && content.reduce(function (foundForCriteria, item) {
      return foundForCriteria || item !== undefined && item.length > 0 && item.toLowerCase().indexOf(criteria.trim().toLowerCase()) >= 0;
    }, false);
  }, true);
}

var Plan = exports.Plan = function (_React$Component3) {
  _inherits(Plan, _React$Component3);

  function Plan(props) {
    _classCallCheck(this, Plan);

    var _this4 = _possibleConstructorReturn(this, (Plan.__proto__ || Object.getPrototypeOf(Plan)).call(this, props));

    var selected = props.project.approach !== undefined && props.showApproach === true ? 1 : 0;
    if (typeof window !== "undefined" && window.location.hash.length > 0) {
      _formDefinition2.default.forEach(function (area, index) {
        if (area.name === window.location.hash.slice(1)) {
          selected = index;
          if (props.showApproach !== true) {
            selected = selected - 1;
          }
        }
      });
    }
    var lastTab = "lessons";
    var visibleTabs = {
      schedule: true,
      lessons: _this4.props.project.isProduct !== true
    };
    if (props.showApproach) {
      visibleTabs.planApproach = true;
    }
    if (props.showControls) {
      visibleTabs.projectControls = true;
      lastTab = "projectControls";
    }
    var priorityLabels = translations.getTranslation(props).summary.fields.priority.options;
    var lessonFilter = { type: "project", onlyProject: true };
    _this4.state = {
      project: props.project,
      visibleTabs: visibleTabs,
      plan: _this4.updateLessonsInPlan(Object.assign({}, props.project.approach, {
        id: props.project.approach !== undefined ? "definedApproach" : undefined,
        lessonLog: [],
        _progress: lastTab,
        stages: props.project.stages,
        projectControls: props.project.projectControls !== undefined ? props.project.projectControls.projectControls : "",
        schedule: _this4.configureSchedule(props.project.stages, props)
      }), props.lessons, lessonFilter),
      browsedCorporateLessons: props.project.browsedCorporateLessons,
      lessons: props.lessons,
      selected: selected,
      lessonFilter: lessonFilter,
      baseline: props.project.plan !== undefined ? props.project.plan.history : undefined
    };
    if (_this4.props.editStage !== undefined) {
      _this4.state = Object.assign(_this4.state, _this4.calculateStateForEditStage(_this4.props.editStage));
    }
    return _this4;
  }

  _createClass(Plan, [{
    key: 'configureSchedule',
    value: function configureSchedule(stages, props) {
      return setupSchedule(stages, props);
    }
  }, {
    key: 'showStagePlan',
    value: function showStagePlan(stageId) {
      this.setState({ showStagePlan: stageId });
    }
  }, {
    key: 'cancelStagePlan',
    value: function cancelStagePlan(event) {
      event.preventDefault();
      this.setState({
        showStagePlan: undefined,
        selected: this.props.showApproach ? 1 : 0
      });
    }
  }, {
    key: 'editFromStagePlan',
    value: function editFromStagePlan(event) {
      var _this5 = this;

      event.preventDefault();
      var id = this.state.showStagePlan;
      this.setState({ showStagePlan: undefined }, function () {
        _this5.editStage(id);
      });
    }
  }, {
    key: 'showDetails',
    value: function showDetails(details) {
      var labels = translations.getTranslation(this.props).general;
      //    console.log("Show details: "+JSON.stringify(details));
      var schedule = "schedule";
      if (details.field.indexOf(schedule) === 0) {
        if (details.item !== undefined && details.item.id !== undefined || this.props.project.isClosing !== true && this.props.project.isCompleted !== true) {
          var phase = details.field.slice(schedule.length + 1);
          if (details.item === undefined || details.item.id === undefined) {
            if (phase === "_totals" || phase === "_project" && this.props.projectType !== undefined && this.props.projectType.phases !== undefined && this.props.projectType.phases.length > 0) {
              alert("Not possible to add stage outside phase");
            } else {
              this.showStageForm(phase);
            }
          } else {
            if (details.item.id !== "__project_total" && details.item.id !== "_totalStage") {
              this.showStagePlan(details.item.id);
            }
            //        this.editStage(details.item.id);
          }
        } else {
          alert(this.props.project.isCompleted ? labels.projectIsCompleted : labels.closureInProgress);
        }
      } else {
        if (details.item.id !== undefined) {
          this.setState({ showLessonDetail: details.item, details: Object.assign({}, details, { item: Object.assign({}, details.item, { _progress: "followUp" }) }) });
        } else {
          this.setState({ details: Object.assign({}, details, { item: Object.assign({}, details.item, { _progress: "summary" }) }) });
        }
      }
    }
  }, {
    key: 'updateLessonDetails',
    value: function updateLessonDetails(content) {
      var _this6 = this;

      var priorityLabels = translations.getTranslation(this.props).summary.fields.priority.options;
      if (content.id !== undefined) {
        var lesson = Object.assign({}, content, { _currentProgress: content._progress, _progress: "followUp" });
        (0, _sendCommand2.default)({ type: "updateLesson", project: { id: this.props.project.id }, lesson: content }).then(function (response) {
          _this6.setState({
            plan: _this6.updateLessonsInPlan(_this6.state.plan, response.lessons, _this6.state.lessonFilter),
            lessons: response.lessons,
            details: content._progress === "followUp" ? undefined : Object.assign({}, _this6.state.details, { item: lesson }),
            selected: content._progress === "followUp" ? 2 : undefined,
            modified: content._progress === "followUp" ? true : undefined
          });
        }).catch(function (error) {
          console.log("Received error on updateLesson: " + error, error);
          alert("An error occured, please try again");
        });
      } else {
        var _lesson = Object.assign({}, content, { id: _uuid2.default.v4(), _currentProgress: content._progress, _progress: "followUp" });
        (0, _sendCommand2.default)({ type: "recordLesson", project: { id: this.props.project.id }, lesson: _lesson }).then(function (response) {
          _this6.setState({
            plan: _this6.updateLessonsInPlan(_this6.state.plan, response.lessons, _this6.state.lessonFilter),
            lessons: response.lessons,
            details: Object.assign({}, _this6.state.details, { item: _lesson }),
            modified: undefined
          });
        }).catch(function (error) {
          console.log("Received error on recordLesson: " + error, error);
          alert("An error occured, please try again");
        });
      }
    }
  }, {
    key: 'showStageForm',
    value: function showStageForm(phaseId) {
      var labels = translations.getTranslation(this.props).general;
      this.setState({ addStage: true, phase: phaseId, stageDetails: { budget: [{ id: "hours", element: labels.hours }, { id: "expences", element: labels.expences }, { id: "investment", element: labels.investment }, { id: "total", element: labels.total }] } });
    }
  }, {
    key: 'calculateStateForEditStage',
    value: function calculateStateForEditStage(stageId, phaseId) {
      var labels = translations.getTranslation(this.props).general;
      var stage = Object.assign({}, this.state.plan.stages.filter(function (stage) {
        return stage.id === stageId;
      })[0]);
      stage.budget = (0, _setupStageBudget2.default)(stage, labels).map(function (item) {
        return Object.assign({}, item, { _format: formatNumber });
      });
      var hasPeriodParsingIssueOccured = false;
      if (stage.time !== undefined) {
        var start = void 0;
        try {
          start = new Date(stage.time.start).toISOString().slice(0, 10);
          hasPeriodParsingIssueOccured = hasPeriodParsingIssueOccured || start !== stage.time.start;
        } catch (error) {
          start = undefined;
          hasPeriodParsingIssueOccured = true;
        }

        var end = void 0;
        try {
          end = new Date(stage.time.end).toISOString().slice(0, 10);
          hasPeriodParsingIssueOccured = hasPeriodParsingIssueOccured || end !== stage.time.end;
        } catch (error) {
          end = undefined;
          hasPeriodParsingIssueOccured = true;
        }

        stage.period = { from: start, to: end };
      }
      if (stage.isRelease === true) {
        hasPeriodParsingIssueOccured = false;
      }
      if (stage.time !== undefined) {
        var translatedTimeTolerance = translateTimeTolerance(stage.time, this.props);
        stage.timeTolerance = translatedTimeTolerance.value;
        stage.timeToleranceUnit = translatedTimeTolerance.unit;
      }
      stage.description = stage.comments;

      return {
        addStage: true,
        phase: stage.phase !== undefined ? stage.phase.id : undefined,
        stageDetails: Object.assign({}, stage, {
          showStagePeriodWarning: hasPeriodParsingIssueOccured
        }),
        modifiedStage: false
      };
    }
  }, {
    key: 'editStage',
    value: function editStage(stageId, phaseId) {
      this.setState(this.calculateStateForEditStage(stageId, phaseId));
    }
  }, {
    key: 'cancelStage',
    value: function cancelStage(event) {
      event.preventDefault();
      this.setState({
        addStage: false,
        selected: this.props.showApproach ? 1 : 0,
        stageDetails: undefined
      });
    }
  }, {
    key: 'cancelStageForm',
    value: function cancelStageForm(event) {
      event.preventDefault();
      var stage = this.state.stageDetails;
      this.setState({
        addStage: false,
        selected: this.props.showApproach ? 1 : 0,
        showStagePlan: this.state.stageDetails !== undefined ? this.state.stageDetails.id : undefined,
        stageDetails: undefined
      });
      if (this.props.editRelease === true) {
        window.location = "/releases/" + stage.id + "/plan";
      }
    }
  }, {
    key: 'reloadStage',
    value: function reloadStage(stage) {
      var stages = this.state.project.stages.map(function (item) {
        return item.id === stage.id ? stage : item;
      });
      this.setState({
        project: Object.assign({}, this.state.project, { stages: stages }),
        stageDetails: Object.assign({}, stage, {
          _currentProgress: stage._progress,
          showStagePeriodWarning: false
        }),
        modifiedStage: undefined,
        plan: Object.assign({}, this.state.plan, {
          schedule: this.configureSchedule(stages, this.props),
          stages: stages
        })
      });
    }
  }, {
    key: 'updatedStage',
    value: function updatedStage(stage) {
      var _this7 = this;

      var id = stage.id !== undefined ? stage.id : _uuid2.default.v4();
      (0, _sendCommand2.default)({
        type: this.props.project.isProduct !== true && this.props.project.isRelease !== true ? stage.id !== undefined ? "updateStage" : "addStage" : stage.id !== undefined ? "updateRelease" : "addRelease",
        stage: Object.assign({}, stage, {
          id: id,
          phase: this.state.stageDetails.phase !== undefined ? this.state.stageDetails.phase : this.state.phase !== "_project" ? { id: this.state.phase } : undefined
        }),
        project: { id: this.props.project.isRelease === true ? this.props.project.product.id : this.props.project.id }
      }).then(function (response) {
        _this7.setState({
          project: Object.assign({}, _this7.state.project, { stages: response.stages }),
          stageDetails: Object.assign({}, response.stages.filter(function (item) {
            return item.id === id;
          })[0], {
            _currentProgress: stage._progress,
            showStagePeriodWarning: false
          }),
          modifiedStage: undefined,
          plan: Object.assign({}, _this7.state.plan, {
            schedule: _this7.configureSchedule(response.stages, _this7.props),
            stages: response.stages
          })
        });
        if (_this7.props.editRelease === true) {
          window.location = "/releases/" + stage.id + "/plan";
        }
      }).catch(function (error) {
        console.log("Received " + error, error);
        alert("An error occured, please try again");
      });
    }
  }, {
    key: 'updateLessonsInPlan',
    value: function updateLessonsInPlan(plan, lessons, lessonFilter) {
      var _this8 = this;

      var priorityLabels = translations.getTranslation(this.props).summary.fields.priority.options;
      var filteredLessons = (lessons !== undefined ? lessons.map(function (lesson) {
        return Object.assign({}, lesson, {
          priorityLabel: priorityLabels[lesson.priority]
        });
      }) : []).filter(function (item) {
        return !lessonFilter.onlyProject || lessonFilter.onlyProject && (item.source.id === _this8.props.project.id || item.applied !== undefined && item.applied.filter(function (appliedBy) {
          return appliedBy.id === _this8.props.project.id;
        }).length > 0);
      }).filter(function (item) {
        return lessonFilter.type === "project" && item.source.id === _this8.props.project.id || lessonFilter.type !== "project" && item.type === lessonFilter.type;
      }).filter(function (item) {
        return lessonFilter.filter !== undefined ? lessonIncludedByFilter(item, lessonFilter.filter) : true;
      }).filter(function (item) {
        return lessonFilter.keywords !== undefined && lessonFilter.keywords.length > 0 ? lessonIncludedByKeywords(item, lessonFilter.keywords) : true;
      }).filter(function (item) {
        return lessonFilter.type !== "portfolio" || lessonFilter.type === "portfolio" && (item.source.portfolio === undefined || item.source.portfolio === _this8.props.project.portfolio);
      }).map(function (item, index) {
        return Object.assign({}, item, {
          no: index + 1,
          _displayAs: lessonFilter.type === "project" ? item.type !== "project" ? "_normal" : "" : item.source.id === _this8.props.project.id ? "_normal" : item.applied !== undefined && item.applied.filter(function (appliedBy) {
            return appliedBy.id === _this8.props.project.id;
          }).length > 0 ? "_highlight" : ""
        });
      });
      return Object.assign({}, plan, {
        lessonLog: filteredLessons
      });
    }
  }, {
    key: 'filterLessons',
    value: function filterLessons(lessonFilter) {
      var _this9 = this;

      if (this.state.browsedCorporateLessons === undefined) {
        if (lessonFilter.type === "corporate" && lessonFilter.onlyProject !== true) {
          (0, _sendCommand2.default)({ type: "browsedCorporateLessons", project: { id: this.props.project.id } }).then(function (response) {
            return _this9.setState({ browsedCorporateLessons: true });
          }).catch(function (error) {
            return console.log("Not able to record project state change");
          });
        }
      }
      this.setState({
        plan: this.updateLessonsInPlan(this.state.plan, this.state.lessons, lessonFilter),
        lessonFilter: lessonFilter,
        modified: true
      });
    }
  }, {
    key: 'updateProject',
    value: function updateProject(project) {
      this.setState({
        project: project,
        plan: Object.assign({}, this.state.plan, {
          schedule: this.configureSchedule(project.stages, Object.assign({}, this.props, {
            project: project
          })),
          stages: project.stages
        }),
        baseline: project.plan !== undefined ? project.plan.history : undefined,
        modified: true
      });
    }
  }, {
    key: 'showContent',
    value: function showContent(area) {
      switch (area) {
        case "schedule":
          return this.props.planVersion !== "2" ? _react2.default.createElement(_ProjectPlan.ProjectPlan, _extends({}, this.props, {
            project: Object.assign({}, this.props.project, { stages: this.state.plan.stages }),
            onSubmit: this.submitPlanChanges.bind(this),
            onAddStage: this.props.planVersion === "2" ? this.showStageForm.bind(this) : undefined,
            onEditStage: this.props.planVersion === "2" ? this.editStage.bind(this) : undefined
          })) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_PhaseTransition2.default, _extends({}, this.props, {
              project: this.state.project,
              schedule: this.state.plan.schedule,
              onUpdate: this.updateProject.bind(this)
            })),
            _react2.default.createElement(_ExceptionManagement2.default, _extends({}, this.props, {
              project: this.state.project,
              schedule: this.state.plan.schedule,
              onUpdate: this.updateProject.bind(this),
              baseline: this.props.project.plan
            }))
          );
        case "lessons":
          return _react2.default.createElement(LessonsFilter, _extends({}, this.props, {
            selected: this.state.lessonFilter.type,
            onlyProject: this.state.lessonFilter.onlyProject,
            onChange: this.filterLessons.bind(this)
          }));
        default:
          var labels = translations.getTranslation(this.props);
          return _react2.default.createElement(
            'i',
            null,
            labels[area].description
          );
      }
    }
  }, {
    key: 'getFormValues',
    value: function getFormValues(form, defaultValues) {
      var formValues = Object.assign({}, defaultValues);
      if (form !== undefined && form !== null) {
        for (var i = 0; i < form.elements.length; i++) {
          var value = form.elements[i].value;
          if (value.trim().length === 0) {
            value = undefined;
          }
          if (form.elements[i].name !== undefined && form.elements[i].name.trim().length > 0) {
            formValues[form.elements[i].name] = value;
          }
        }
      }
      formValues.cancel = undefined;
      formValues.save = undefined;
      return formValues;
    }
  }, {
    key: 'submitPlanChanges',
    value: function submitPlanChanges(event) {
      var _this10 = this;

      event.preventDefault();
      return new Promise(function (resolve, reject) {
        (0, _sendCommand2.default)({ type: "updatePlan", form: _this10.getFormValues(event.target), project: { id: _this10.props.project.id } }).then(function (response) {
          var updatedPlan = Object.assign({}, _this10.state.plan, { stages: response.plan, _currentProgress: "schedule" });
          _this10.setState({ plan: updatedPlan, lastSaved: updatedPlan, selected: 1, modified: true });
          resolve(response.plan);
        }).catch(function (error) {
          return reject(error);
        });
      });
    }

    /*
      submitLesson(event) {
        event.preventDefault();
        this.updateLessonDetails(this.getFormValues(event.target,this.state.details.item));
      }
    */

  }, {
    key: 'canceledDetails',
    value: function canceledDetails() {
      this.setState({ details: undefined, selected: this.props.showApproach ? 2 : 1 });
    }
  }, {
    key: 'saveApproach',
    value: function saveApproach(event) {
      var _this11 = this;

      if (event._progress === "projectControls") {
        var projectControls = event.projectControls;
        (0, _sendCommand2.default)({ type: "updateProjectControls", project: { id: this.props.project.id }, projectControls: projectControls }).then(function (response) {
          _this11.setState({ plan: Object.assign({}, _this11.state.plan, Object.assign({}, { projectControls: response.projectControls }, { id: "definedProjectControls", _currentProgress: "projectControls" })) });
        }).catch(function (error) {
          console.log("Got error " + JSON.stringify(error), error);
          alert("Could not save project controls");
        });
      } else {
        var approach = {
          methods: event.methods,
          resources: event.resources,
          technology: event.technology,
          rollOut: event.rollOut,
          other: event.other
        };
        if (event.id === undefined) {
          (0, _sendCommand2.default)({ type: "defineProjectApproach", project: { id: this.props.project.id }, approach: approach }).then(function (response) {
            _this11.setState({ plan: Object.assign({}, _this11.state.plan, Object.assign({}, response.approach, { id: "definedApproach", _currentProgress: "approach" })) });
          }).catch(function (error) {
            console.log("Got error " + JSON.stringify(error), error);
            alert("Could not save approach");
          });
        } else {
          (0, _sendCommand2.default)({ type: "updateProjectApproach", project: { id: this.props.project.id }, approach: approach }).then(function (response) {
            _this11.setState({ plan: Object.assign({}, _this11.state.plan, Object.assign({}, response.approach, { _currentProgress: "approach" }))
            });
          }).catch(function (error) {
            alert("Could not save approach, " + JSON.stringify(error));
          });
        }
      }
    }
  }, {
    key: 'lessonSummary',
    value: function lessonSummary(tab, details) {
      var labels = translations.getTranslation(this.props).general.statement;
      var containsStatement = details.values.effect !== undefined && details.values.effect.trim().length > 0 || details.values.event !== undefined && details.values.event.trim().length > 0 || details.values.cause !== undefined && details.values.cause.trim().length > 0;
      return _react2.default.createElement(
        'div',
        null,
        tab !== "summary" ? _react2.default.createElement(
          'div',
          { style: { fontWeight: "bold" } },
          details.values.title
        ) : null,
        containsStatement || tab === "detail" ? _react2.default.createElement(
          'div',
          { style: { paddingTop: 5 } },
          _react2.default.createElement(_LessonDetails.LessonStatement, _extends({}, this.props, { lesson: details.values }))
        ) : null
      );
    }
  }, {
    key: 'handleLessonFieldChange',
    value: function handleLessonFieldChange(fieldname) {
      var _this12 = this;

      return function (event) {
        _this12.setState({
          details: Object.assign({}, _this12.state.details, {
            item: Object.assign({}, _this12.state.details.item, _defineProperty({}, event.target.name, event.target.value)) }),
          modified: true
        });
      };
    }
  }, {
    key: 'handleStageFieldChange',
    value: function handleStageFieldChange(fieldname) {
      var _this13 = this;

      return function (event) {
        _this13.setState({
          stageDetails: Object.assign({}, _this13.state.stageDetails, _defineProperty({}, event.target.name, event.target.value)),
          modifiedStage: true
        });
      };
    }
  }, {
    key: 'addTotals',
    value: function addTotals(plan) {
      var updatedSchedule = addTotalsToSchedule(plan.schedule, this.props);
      return Object.assign({}, plan, {
        schedule: updatedSchedule
      });
    }
  }, {
    key: 'moveStage',
    value: function moveStage(stageId, phaseId) {
      var _this14 = this;

      (0, _sendCommand2.default)({ type: "moveStage", stage: { id: stageId }, phase: { id: phaseId }, project: { id: this.props.project.id } }).then(function (response) {
        _this14.setState({
          plan: Object.assign({}, _this14.state.plan, {
            schedule: _this14.configureSchedule(response.stages, _this14.props),
            stages: response.stages
          })
        });
      }).catch(function (error) {
        console.log("Got response: " + error, error);
        alert("An error occured, please try again.");
      });
    }
  }, {
    key: 'applyLesson',
    value: function applyLesson(lessonId) {
      var _this15 = this;

      return new Promise(function (resolve, reject) {
        (0, _sendCommand2.default)({ type: "applyLesson", project: { id: _this15.props.project.id }, lesson: { id: lessonId } }).then(function (response) {
          resolve(response.lessons);
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
  }, {
    key: 'unapplyLesson',
    value: function unapplyLesson(lessonId) {
      var _this16 = this;

      return new Promise(function (resolve, reject) {
        (0, _sendCommand2.default)({ type: "unapplyLesson", project: { id: _this16.props.project.id }, lesson: { id: lessonId } }).then(function (response) {
          resolve(response.lessons);
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
  }, {
    key: 'deleteLesson',
    value: function deleteLesson(lessonId) {
      var _this17 = this;

      return new Promise(function (resolve, reject) {
        (0, _sendCommand2.default)({ type: "deleteLesson", project: { id: _this17.props.project.id }, lesson: { id: lessonId } }).then(function (response) {
          resolve(response.lessons);
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
  }, {
    key: 'deleteStage',
    value: function deleteStage(stageId) {
      var _this18 = this;

      return new Promise(function (resolve, reject) {
        var command = {};
        if (_this18.props.project.isProduct !== true && _this18.props.project.isRelease !== true) {
          command = { type: "deleteStage", forcedDelete: _this18.props.deleteEnabled, project: { id: _this18.props.project.id }, stage: { id: stageId } };
        } else {
          command = { type: "deleteRelease", forcedDelete: _this18.props.deleteEnabled, product: { id: _this18.props.project.id }, release: { id: stageId } };
        }
        (0, _sendCommand2.default)(command).then(function (response) {
          resolve(response.stages);
          resolve(_this18.state.plan.stages.filter(function (stage) {
            return stage.id !== stageId;
          }));
        }).catch(function (error) {
          return reject(error);
        });
      });
    }
  }, {
    key: 'showStagePeriodWarning',
    value: function showStagePeriodWarning(tab) {
      var labels = translations.getTranslation(this.props).general;
      var warning = this.state.stageDetails.showStagePeriodWarning ? _react2.default.createElement(
        'div',
        { style: { color: "#212121", padding: 10, marginTop: 10, fontFamily: "Lato", textAlign: "center", backgroundColor: "#FFEADB" } },
        'Stage period might have been parsed wrongly, please ensure that',
        _react2.default.createElement(
          'span',
          null,
          ' '
        ),
        '"',
        _react2.default.createElement(
          'i',
          null,
          this.state.stageDetails.period.from instanceof Date ? this.state.stageDetails.period.from.toISOString().slice(0, 10) : this.state.stageDetails.period.from,
          ' - ',
          this.state.stageDetails.period.to instanceof Date ? this.state.stageDetails.period.to.toISOString().slice(0, 10) : this.state.stageDetails.period.to
        ),
        '" means the same as "',
        _react2.default.createElement(
          'i',
          null,
          this.state.stageDetails.time.start,
          ' - ',
          this.state.stageDetails.time.end
        ),
        '".'
      ) : null;
      var currency = tab === "stageCost" && this.props.project.currency !== undefined ? _react2.default.createElement(
        'div',
        null,
        labels.currency.replace("{currency}", this.props.project.currency),
        ' ',
        _react2.default.createElement(
          'a',
          { href: "/projects/" + this.props.project.id + "/properties" },
          labels.projectPropertiesLink
        ),
        '.'
      ) : null;
      return currency || warning ? _react2.default.createElement(
        'div',
        null,
        warning,
        currency
      ) : null;
    }
  }, {
    key: 'addCurrencyLabel',
    value: function addCurrencyLabel(area) {
      var currency = this.props.project.currency !== undefined ? this.props.project.currency : undefined;
      return area.name !== "schedule" || currency === undefined ? area : Object.assign({}, area, {
        fields: area.fields.map(function (field) {
          return field.name !== "schedule" ? field : Object.assign({}, field, {
            columnHeaders: field.columnHeaders.map(function (header) {
              return header.name !== "cost" ? header : Object.assign({}, header, {
                title: header.title + " (" + currency + ")"
              });
            })
          });
        })
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this19 = this;

      var labels = translations.getTranslation(this.props).general;
      var areas = translations.createTranslatedForm(_formDefinition2.default, this.props.language, this.props.variant).filter(function (area) {
        return _this19.state.visibleTabs[area.name] === true;
      }).map(function (area) {
        return area.name === "schedule" && _this19.props.planVersion !== "2" ? Object.assign({}, area, { fields: undefined }) : _this19.addCurrencyLabel(area);
      });
      return this.state.showLessonDetail !== undefined ? _react2.default.createElement(
        'div',
        { style: { paddingTop: 20, display: "flex", justifyContent: "center" } },
        _react2.default.createElement(
          'div',
          { style: { width: 1016 } },
          _react2.default.createElement(_LessonDetails2.default, _extends({}, this.props, {
            onCancel: function onCancel() {
              return _this19.setState({
                showLessonDetail: undefined,
                details: undefined,
                selected: _this19.props.showApproach ? 2 : 1
              });
            },
            onEdit: function onEdit() {
              return _this19.setState({ showLessonDetail: undefined });
            },
            onApply: function onApply() {
              return _this19.applyLesson(_this19.state.showLessonDetail.id).then(function (lessons) {
                return _this19.setState({
                  showLessonDetail: undefined,
                  details: undefined,
                  plan: _this19.updateLessonsInPlan(_this19.state.plan, lessons, _this19.state.lessonFilter),
                  lessons: lessons,
                  selected: _this19.props.showApproach ? 2 : 1
                });
              }).catch(function (error) {
                console.log("Got error " + error, error);
                alert("An error occured, please try again");
              });
            },
            onUnapply: function onUnapply() {
              return _this19.unapplyLesson(_this19.state.showLessonDetail.id).then(function (lessons) {
                return _this19.setState({
                  showLessonDetail: undefined,
                  details: undefined,
                  plan: _this19.updateLessonsInPlan(_this19.state.plan, lessons, _this19.state.lessonFilter),
                  lessons: lessons,
                  selected: _this19.props.showApproach ? 2 : 1
                });
              }).catch(function (error) {
                console.log("Got error " + error, error);
                alert("An error occured, please try again");
              });
            },
            onDelete: function onDelete() {
              return _this19.deleteLesson(_this19.state.showLessonDetail.id).then(function (lessons) {
                return _this19.setState({
                  showLessonDetail: undefined,
                  details: undefined,
                  plan: _this19.updateLessonsInPlan(_this19.state.plan, lessons, _this19.state.lessonFilter),
                  lessons: lessons,
                  selected: _this19.props.showApproach ? 2 : 1
                });
              }).catch(function (error) {
                console.log("Got error " + error, error);
                alert("An error occured, please try again");
              });
            },
            lesson: this.state.showLessonDetail
          }))
        )
      ) : this.state.showStagePlan !== undefined ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_StagePlan2.default, _extends({}, this.props, {
          path: "plan/" + (this.props.project.isProduct === true ? "releases/" : "stages/") + this.state.showStagePlan,
          stage: this.state.plan.stages.find(function (stage) {
            return stage.id === _this19.state.showStagePlan;
          }),
          project: this.state.project,
          projectType: this.props.projectType,
          onCancel: this.cancelStagePlan.bind(this),
          onEdit: this.editFromStagePlan.bind(this),
          onMoveStage: this.moveStage.bind(this),
          onUpdate: this.updateProject.bind(this),
          onUpdateStage: this.reloadStage.bind(this)
        }))
      ) : this.state.addStage ? _react2.default.createElement(
        'div',
        { style: { paddingTop: 20, display: "flex", justifyContent: "center" } },
        _react2.default.createElement(
          'div',
          { style: { width: 1016 } },
          _react2.default.createElement(_AreaForm2.default, _extends({ key: 'stage'
          }, this.props, {
            display: 'tab',
            areas: translations.createTranslatedForm(adjustFormForType(_stageFormDefinition2.default, this.props.project.isProduct === true || this.props.project.isRelease === true ? "product" : "project"), this.props.language, this.props.variant),
            item: Object.assign({}, this.state.stageDetails, { _progress: "stageScheduleScope" }),
            selected: 0,
            summary: this.showStagePeriodWarning.bind(this),
            label: labels.stage,
            modified: this.state.modifiedStage,
            confirmDeleteMessage: labels.stagePlan.actions.confirmDelete,
            onDelete: this.props.deleteEnabled || this.state.stageDetails.active !== true && this.state.stageDetails.historic !== true && this.state.stageDetails.requestedTransitionTo !== true ? function (stage) {
              _this19.deleteStage(stage.id).then(function (stages) {
                return _this19.setState({
                  addStage: false,
                  selected: _this19.props.showApproach ? 1 : 0,
                  stageDetails: undefined,
                  plan: Object.assign({}, _this19.state.plan, {
                    schedule: _this19.configureSchedule(stages, _this19.props),
                    stages: stages
                  })
                });
              }).catch(function (error) {
                console.log("Got error " + error, error);
                alert("An error occured, please try again");
              });
            } : undefined,
            onUpdate: this.updatedStage.bind(this),
            handleFieldChange: this.handleStageFieldChange.bind(this),
            onCancel: this.cancelStageForm.bind(this)
          }))
        )
      ) : _react2.default.createElement(
        'div',
        { style: { paddingTop: 20, display: "flex", justifyContent: "center" } },
        _react2.default.createElement(
          'div',
          { style: { width: 1016 } },
          this.state.details !== undefined ? _react2.default.createElement(_AreaForm2.default, _extends({ key: 'details'
          }, this.props, {
            display: 'tab',
            areas: translations.createTranslatedForm(this.state.details.form, this.props.language, this.props.variant),
            item: this.state.details.item,
            selected: 0,
            label: labels.lesson,
            onUpdate: this.updateLessonDetails.bind(this),
            summary: this.lessonSummary.bind(this),
            handleFieldChange: this.handleLessonFieldChange.bind(this),
            modified: this.state.modified,
            onCancel: this.canceledDetails.bind(this)
          })) : _react2.default.createElement(_AreaForm2.default, _extends({}, this.props, {
            areas: areas,
            display: 'tab',
            label: [{ name: "planApproach", label: labels.approach }, { name: "projectControls", label: labels.controls }],
            item: this.addTotals(this.state.plan),
            modified: this.state.modified,
            selected: this.state.selected,
            summary: this.showContent.bind(this),
            onUpdate: this.saveApproach.bind(this),
            onAddEntry: this.showDetails.bind(this),
            onEditEntry: this.showDetails.bind(this),
            onCancel: function onCancel() {
              return window.location = ".";
            },
            details: function details(area) {
              return area === "schedule" ? _react2.default.createElement(_BaselineHistory2.default, _extends({}, _this19.props, { baseline: _this19.state.baseline })) : undefined;
            },
            forceReadOnly: true
          }))
        )
      );
    }
  }]);

  return Plan;
}(_react2.default.Component);

var PlanPage = function (_React$Component4) {
  _inherits(PlanPage, _React$Component4);

  function PlanPage() {
    _classCallCheck(this, PlanPage);

    return _possibleConstructorReturn(this, (PlanPage.__proto__ || Object.getPrototypeOf(PlanPage)).apply(this, arguments));
  }

  _createClass(PlanPage, [{
    key: 'render',
    value: function render() {
      var menu = this.props.showMenu === true ? _react2.default.createElement(_ProjectMenu2.default, this.props) : undefined;
      return _react2.default.createElement(
        _Layout2.default,
        _extends({}, this.props, { projectMenu: menu }),
        _react2.default.createElement(Plan, this.props)
      );
    }
  }]);

  return PlanPage;
}(_react2.default.Component);

exports.default = PlanPage;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Brief = exports.ApprovableReport = exports.BriefDetails = exports.BriefContent = exports.BriefPidSlides = exports.TableRow = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _ProjectMenu = __webpack_require__(17);

var _ProjectMenu2 = _interopRequireDefault(_ProjectMenu);

var _Field = __webpack_require__(36);

var _Field2 = _interopRequireDefault(_Field);

var _Slides = __webpack_require__(259);

var _Slides2 = _interopRequireDefault(_Slides);

var _FormattedContent = __webpack_require__(15);

var _FormattedContent2 = _interopRequireDefault(_FormattedContent);

var _HighlightReport = __webpack_require__(105);

var _getProjectBrief = __webpack_require__(434);

var _getProjectBrief2 = _interopRequireDefault(_getProjectBrief);

var _sendCommand = __webpack_require__(25);

var _sendCommand2 = _interopRequireDefault(_sendCommand);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(1088), __webpack_require__(1089)]).loadVariants([__webpack_require__(1090)]);

var Paragraph = function (_React$Component) {
  _inherits(Paragraph, _React$Component);

  function Paragraph() {
    _classCallCheck(this, Paragraph);

    return _possibleConstructorReturn(this, (Paragraph.__proto__ || Object.getPrototypeOf(Paragraph)).apply(this, arguments));
  }

  _createClass(Paragraph, [{
    key: 'render',
    value: function render() {
      return this.props.value !== undefined && this.props.value !== null && this.props.value.trim().length > 0 ? _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(_FormattedContent2.default, { value: this.props.value })
      ) : null;
    }
  }]);

  return Paragraph;
}(_react2.default.Component);

var Background = function (_React$Component2) {
  _inherits(Background, _React$Component2);

  function Background() {
    _classCallCheck(this, Background);

    return _possibleConstructorReturn(this, (Background.__proto__ || Object.getPrototypeOf(Background)).apply(this, arguments));
  }

  _createClass(Background, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.props.presentationMode ? _react2.default.createElement(
          'h3',
          null,
          this.props.title
        ) : null,
        _react2.default.createElement(Paragraph, { value: this.props.initiated }),
        _react2.default.createElement(Paragraph, { value: this.props.timing }),
        _react2.default.createElement(Paragraph, { value: this.props.bigPicture })
      );
    }
  }]);

  return Background;
}(_react2.default.Component);

var Objectives = function (_React$Component3) {
  _inherits(Objectives, _React$Component3);

  function Objectives() {
    _classCallCheck(this, Objectives);

    return _possibleConstructorReturn(this, (Objectives.__proto__ || Object.getPrototypeOf(Objectives)).apply(this, arguments));
  }

  _createClass(Objectives, [{
    key: 'hasValue',
    value: function hasValue(field) {
      return field !== undefined && field !== null && field.trim().length > 0;
    }
  }, {
    key: 'hasObjective',
    value: function hasObjective(objective) {
      return objective !== undefined && (this.hasValue(objective.description) || this.hasValue(objective.tolerance));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var labels = translations.getTranslation(this.props.language, this.props.variant).definition.objectives;
      var hasObjectives = this.props.benefits !== undefined || this.props.summary !== undefined && this.props.summary.length > 0 && this.props.summary.filter(function (item) {
        return _this4.hasObjective(item);
      }).length > 0;
      return hasObjectives ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h3',
          null,
          this.props.title
        ),
        _react2.default.createElement(Paragraph, { value: this.props.benefits }),
        this.props.summary !== undefined && this.props.summary !== null && this.props.summary.length > 0 && this.props.summary.filter(function (item) {
          return _this4.hasObjective(item);
        }).length > 0 ? _react2.default.createElement(
          'table',
          { style: { fontSize: "inherit", borderCollapse: "collapse", border: "solid 1px lightgrey", width: "100%" } },
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              { style: { backgroundColor: "#e9e7e6" } },
              _react2.default.createElement(
                'th',
                { style: { border: "solid lightgrey 1px", padding: 5, width: 1, whiteSpace: "nowrap", paddingRight: 20 } },
                labels.columns.name.title
              ),
              _react2.default.createElement(
                'th',
                { style: { border: "solid lightgrey 1px", padding: 5 } },
                labels.columns.description.title
              ),
              _react2.default.createElement(
                'th',
                { style: { border: "solid lightgrey 1px", padding: 5 } },
                labels.columns.tolerance.title
              )
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            this.props.summary.map(function (item) {
              return _this4.hasObjective(item) ? _react2.default.createElement(
                'tr',
                { key: item.id },
                _react2.default.createElement(
                  'td',
                  { style: { border: "solid lightgrey 1px", padding: 5, verticalAlign: "top", fontWeight: "bold" } },
                  labels.aspects[item.id]
                ),
                _react2.default.createElement(
                  'td',
                  { style: { border: "solid lightgrey 1px", padding: 5, verticalAlign: "top" } },
                  _react2.default.createElement(_FormattedContent2.default, { value: item.description })
                ),
                _react2.default.createElement(
                  'td',
                  { style: { border: "solid lightgrey 1px", padding: 5, verticalAlign: "top" } },
                  _react2.default.createElement(_FormattedContent2.default, { value: item.tolerance })
                )
              ) : null;
            })
          )
        ) : null,
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 10 } },
          _react2.default.createElement(Paragraph, { value: this.props.comments })
        )
      ) : null;
    }
  }]);

  return Objectives;
}(_react2.default.Component);

var Scope = function (_React$Component4) {
  _inherits(Scope, _React$Component4);

  function Scope() {
    _classCallCheck(this, Scope);

    return _possibleConstructorReturn(this, (Scope.__proto__ || Object.getPrototypeOf(Scope)).apply(this, arguments));
  }

  _createClass(Scope, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props.language, this.props.variant).definition.scope;
      var hasScope = this.props.scope.items !== undefined && this.props.scope.items.length > 0 || this.props.scope.exclusions !== undefined || this.props.outcomes !== undefined;
      return hasScope ? _react2.default.createElement(
        'div',
        null,
        !this.props.presentationMode ? _react2.default.createElement(
          'h3',
          null,
          labels.title
        ) : null,
        this.props.scope.items !== undefined && this.props.scope.items !== null && this.props.scope.items.length > 0 ? _react2.default.createElement(
          'ul',
          null,
          this.props.scope.items.map(function (item, index) {
            return _react2.default.createElement(
              'li',
              { key: index },
              item.text
            );
          })
        ) : null,
        this.props.scope.exclusions !== undefined && this.props.scope.exclusions !== null && this.props.scope.exclusions.trim().length > 0 ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h4',
            null,
            labels.excluded.title
          ),
          _react2.default.createElement(_FormattedContent2.default, { value: this.props.scope.exclusions })
        ) : null,
        this.props.outcomes !== undefined && this.props.outcomes !== null ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h4',
            null,
            labels.outcomes.title
          ),
          _react2.default.createElement(_FormattedContent2.default, { value: this.props.outcomes })
        ) : null
      ) : null;
    }
  }]);

  return Scope;
}(_react2.default.Component);

var Constraints = function (_React$Component5) {
  _inherits(Constraints, _React$Component5);

  function Constraints() {
    _classCallCheck(this, Constraints);

    return _possibleConstructorReturn(this, (Constraints.__proto__ || Object.getPrototypeOf(Constraints)).apply(this, arguments));
  }

  _createClass(Constraints, [{
    key: 'render',
    value: function render() {
      return this.props.constraints !== undefined && this.props.constraints !== null && this.props.constraints.trim().length > 0 ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h3',
          null,
          this.props.title
        ),
        _react2.default.createElement(_FormattedContent2.default, { value: this.props.constraints })
      ) : null;
    }
  }]);

  return Constraints;
}(_react2.default.Component);

var Assumptions = function (_React$Component6) {
  _inherits(Assumptions, _React$Component6);

  function Assumptions() {
    _classCallCheck(this, Assumptions);

    return _possibleConstructorReturn(this, (Assumptions.__proto__ || Object.getPrototypeOf(Assumptions)).apply(this, arguments));
  }

  _createClass(Assumptions, [{
    key: 'render',
    value: function render() {
      return this.props.assumptions !== undefined && this.props.assumptions !== null && this.props.assumptions.trim().length > 0 ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h3',
          null,
          this.props.title
        ),
        _react2.default.createElement(_FormattedContent2.default, { value: this.props.assumptions })
      ) : null;
    }
  }]);

  return Assumptions;
}(_react2.default.Component);

var Stakeholders = function (_React$Component7) {
  _inherits(Stakeholders, _React$Component7);

  function Stakeholders() {
    _classCallCheck(this, Stakeholders);

    return _possibleConstructorReturn(this, (Stakeholders.__proto__ || Object.getPrototypeOf(Stakeholders)).apply(this, arguments));
  }

  _createClass(Stakeholders, [{
    key: 'render',
    value: function render() {
      return this.props.stakeholders !== undefined && this.props.stakeholders !== null && this.props.stakeholders.trim().length > 0 ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h3',
          null,
          this.props.title
        ),
        _react2.default.createElement(_FormattedContent2.default, { value: this.props.stakeholders })
      ) : null;
    }
  }]);

  return Stakeholders;
}(_react2.default.Component);

var Interfaces = function (_React$Component8) {
  _inherits(Interfaces, _React$Component8);

  function Interfaces() {
    _classCallCheck(this, Interfaces);

    return _possibleConstructorReturn(this, (Interfaces.__proto__ || Object.getPrototypeOf(Interfaces)).apply(this, arguments));
  }

  _createClass(Interfaces, [{
    key: 'render',
    value: function render() {
      return this.props.interfaces !== undefined && this.props.interfaces !== null && this.props.interfaces.trim().length > 0 ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h3',
          null,
          this.props.title
        ),
        _react2.default.createElement(_FormattedContent2.default, { value: this.props.interfaces })
      ) : null;
    }
  }]);

  return Interfaces;
}(_react2.default.Component);

var Definition = function (_React$Component9) {
  _inherits(Definition, _React$Component9);

  function Definition() {
    _classCallCheck(this, Definition);

    return _possibleConstructorReturn(this, (Definition.__proto__ || Object.getPrototypeOf(Definition)).apply(this, arguments));
  }

  _createClass(Definition, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props.language, this.props.variant).definition;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          null,
          labels.title
        ),
        _react2.default.createElement(Background, _extends({}, this.props, this.props.background)),
        _react2.default.createElement(Objectives, _extends({}, this.props, this.props.objective, { title: labels.objectives.title })),
        _react2.default.createElement(Scope, this.props),
        _react2.default.createElement(Constraints, _extends({}, this.props, { title: labels.constraints.title })),
        _react2.default.createElement(Assumptions, _extends({}, this.props, { title: labels.assumptions.title })),
        _react2.default.createElement(Stakeholders, _extends({}, this.props, { title: labels.stakeholders.title })),
        _react2.default.createElement(Interfaces, _extends({}, this.props, { title: labels.interfaces.title }))
      );
    }
  }]);

  return Definition;
}(_react2.default.Component);

var ObjectiveTableRow = function (_React$Component10) {
  _inherits(ObjectiveTableRow, _React$Component10);

  function ObjectiveTableRow() {
    _classCallCheck(this, ObjectiveTableRow);

    return _possibleConstructorReturn(this, (ObjectiveTableRow.__proto__ || Object.getPrototypeOf(ObjectiveTableRow)).apply(this, arguments));
  }

  _createClass(ObjectiveTableRow, [{
    key: 'hasValue',
    value: function hasValue(field) {
      return field !== undefined && field !== null && field.trim().length > 0;
    }
  }, {
    key: 'hasObjective',
    value: function hasObjective(objective) {
      return objective !== undefined && (this.hasValue(objective.description) || this.hasValue(objective.tolerance));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this12 = this;

      var labels = translations.getTranslation(this.props.language, this.props.variant).definition.objectives;
      var hasObjectives = this.props.objective.benefits !== undefined && this.props.objective.benefits !== null && this.props.objective.benefits.trim().length > 0 || this.props.objective.summary !== undefined && this.props.objective.summary.filter(function (item) {
        return _this12.hasObjective(item);
      }).length > 0 || this.props.objective.comments !== undefined && this.props.objective.comments !== null && this.props.objective.comments.trim().length > 0;
      return hasObjectives ? _react2.default.createElement(TableRow, {
        label: labels.title,
        content: _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(Paragraph, { value: this.props.objective.benefits }),
          this.props.objective.summary !== undefined ? _react2.default.createElement(
            'div',
            { style: { display: "table", fontSize: "inherit" } },
            this.props.objective.summary.map(function (item) {
              return _this12.hasObjective(item) ? _react2.default.createElement(
                'div',
                { key: item.id, style: { display: "table-row" } },
                _react2.default.createElement(
                  'div',
                  { style: { display: "table-cell" } },
                  _react2.default.createElement(
                    'div',
                    { style: { paddingRight: 5, verticlaAlign: "top" } },
                    _react2.default.createElement(
                      'b',
                      null,
                      labels.aspects[item.id]
                    ),
                    ':'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { style: { display: "table-cell" } },
                  _react2.default.createElement(
                    'div',
                    { style: { display: "flex", flexWrap: "wrap" } },
                    _this12.hasValue(item.description) ? _react2.default.createElement(
                      'div',
                      { style: { paddingRight: 5, paddingBottom: 5 } },
                      _react2.default.createElement(_FormattedContent2.default, { value: item.description })
                    ) : null,
                    _this12.hasValue(item.tolerance) ? _react2.default.createElement(
                      'div',
                      null,
                      labels.columns.tolerance.title,
                      ': ',
                      _react2.default.createElement(_FormattedContent2.default, { value: item.tolerance })
                    ) : null
                  )
                )
              ) : null;
            })
          ) : null,
          this.hasValue(this.props.objective.comments) ? _react2.default.createElement(
            'div',
            { style: { paddingTop: 10, fontStyle: "italic" } },
            _react2.default.createElement(_FormattedContent2.default, { value: this.props.objective.comments })
          ) : null
        )
      }) : null;
    }
  }]);

  return ObjectiveTableRow;
}(_react2.default.Component);

var TableRow = exports.TableRow = function (_React$Component11) {
  _inherits(TableRow, _React$Component11);

  function TableRow() {
    _classCallCheck(this, TableRow);

    return _possibleConstructorReturn(this, (TableRow.__proto__ || Object.getPrototypeOf(TableRow)).apply(this, arguments));
  }

  _createClass(TableRow, [{
    key: 'render',
    value: function render() {
      var cellStyle = { border: "solid 1px lightgrey", padding: 5 };
      return this.props.content !== undefined && this.props.content !== null && (this.props.content.trim !== undefined && this.props.content.trim().length > 0 || this.props.content.trim === undefined) ? _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: Object.assign({}, cellStyle, { verticalAlign: "top", fontWeight: "bold" }) },
          this.props.label
        ),
        _react2.default.createElement(
          'td',
          { style: cellStyle },
          _react2.default.createElement(_FormattedContent2.default, { value: this.props.content })
        )
      ) : null;
    }
  }]);

  return TableRow;
}(_react2.default.Component);

var DefinitionTable = function (_React$Component12) {
  _inherits(DefinitionTable, _React$Component12);

  function DefinitionTable() {
    _classCallCheck(this, DefinitionTable);

    return _possibleConstructorReturn(this, (DefinitionTable.__proto__ || Object.getPrototypeOf(DefinitionTable)).apply(this, arguments));
  }

  _createClass(DefinitionTable, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props.language, this.props.variant).definition;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          null,
          labels.title
        ),
        _react2.default.createElement(
          'table',
          { className: 'briefTable', style: { fontSize: "inherit", borderCollapse: "collapse" }, cellPadding: '0', cellSpacing: '0' },
          _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(TableRow, {
              label: labels.background.title,
              content: _react2.default.createElement(Background, _extends({}, this.props, this.props.background))
            }),
            _react2.default.createElement(ObjectiveTableRow, this.props),
            _react2.default.createElement(TableRow, {
              label: labels.scope.title,
              content: this.props.scope.items !== undefined && this.props.scope.items !== null && this.props.scope.items.length > 0 ? _react2.default.createElement(
                'ul',
                { style: { margin: 0, paddingLeft: 20 } },
                this.props.scope.items.map(function (item, index) {
                  return _react2.default.createElement(
                    'li',
                    { key: index },
                    item.text
                  );
                })
              ) : null
            }),
            _react2.default.createElement(TableRow, {
              label: labels.scope.excluded.title,
              content: this.props.scope.exclusions
            }),
            _react2.default.createElement(TableRow, {
              label: labels.scope.outcomes.title,
              content: this.props.outcomes
            }),
            _react2.default.createElement(TableRow, {
              label: labels.constraints.title,
              content: this.props.constraints
            }),
            _react2.default.createElement(TableRow, {
              label: labels.assumptions.title,
              content: this.props.assumptions
            }),
            _react2.default.createElement(TableRow, {
              label: labels.interfaces.title,
              content: this.props.interfaces
            }),
            _react2.default.createElement(TableRow, {
              label: labels.stakeholders.title,
              content: this.props.stakeholders
            })
          )
        )
      );
    }
  }]);

  return DefinitionTable;
}(_react2.default.Component);

var BenefitsTable = function (_React$Component13) {
  _inherits(BenefitsTable, _React$Component13);

  function BenefitsTable() {
    _classCallCheck(this, BenefitsTable);

    return _possibleConstructorReturn(this, (BenefitsTable.__proto__ || Object.getPrototypeOf(BenefitsTable)).apply(this, arguments));
  }

  _createClass(BenefitsTable, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props.language, this.props.variant).businessCase;
      var businessCase = this.props;
      return businessCase.benefits !== undefined && businessCase.benefits !== null && businessCase.benefits.length > 0 ? _react2.default.createElement(
        'table',
        { style: { fontSize: "inherit", borderCollapse: "collapse", border: "solid 1px lightgrey", width: "100%" } },
        _react2.default.createElement(
          'thead',
          null,
          _react2.default.createElement(
            'tr',
            { style: { backgroundColor: "#e9e7e6" } },
            _react2.default.createElement(
              'th',
              null,
              labels.benefits.columns.title.title
            ),
            _react2.default.createElement(
              'th',
              null,
              labels.benefits.columns.baseline.title
            ),
            _react2.default.createElement(
              'th',
              null,
              labels.benefits.columns.goal.title
            ),
            _react2.default.createElement(
              'th',
              null,
              labels.benefits.columns.accountable.title
            )
          )
        ),
        _react2.default.createElement(
          'tbody',
          null,
          businessCase.benefits.map(function (item) {
            return _react2.default.createElement(
              'tr',
              { key: item.id },
              _react2.default.createElement(
                'td',
                { style: { border: "solid lightgrey 1px", padding: 5 } },
                item.title
              ),
              _react2.default.createElement(
                'td',
                { style: { border: "solid lightgrey 1px", padding: 5 } },
                item.baseline
              ),
              _react2.default.createElement(
                'td',
                { style: { border: "solid lightgrey 1px", padding: 5 } },
                item.goal
              ),
              _react2.default.createElement(
                'td',
                { style: { border: "solid lightgrey 1px", padding: 5 } },
                item.accountable
              )
            );
          })
        )
      ) : null;
    }
  }]);

  return BenefitsTable;
}(_react2.default.Component);

var BusinessCase = function (_React$Component14) {
  _inherits(BusinessCase, _React$Component14);

  function BusinessCase() {
    _classCallCheck(this, BusinessCase);

    return _possibleConstructorReturn(this, (BusinessCase.__proto__ || Object.getPrototypeOf(BusinessCase)).apply(this, arguments));
  }

  _createClass(BusinessCase, [{
    key: 'render',
    value: function render() {
      var _this17 = this;

      var labels = translations.getTranslation(this.props.language, this.props.variant).businessCase;
      var businessCase = this.props;
      var hasBusinessCase = false;
      var reasonAndAlternativesFileds = ["reasons", "doNothing", "doMinimal", "doSomething"];
      var returnOnInvestmentFields = ["projectPlanSummary", "investmentAppraisal", "risks"];
      reasonAndAlternativesFileds.concat(returnOnInvestmentFields).concat("benefits").forEach(function (key) {
        hasBusinessCase = hasBusinessCase || _this17.props[key] !== undefined && (!Array.isArray(_this17.props[key]) || Array.isArray(_this17.props[key]) && _this17.props[key].length > 0);
      });
      return hasBusinessCase ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          null,
          labels.title
        ),
        _react2.default.createElement(_FormattedContent2.default, { value: businessCase.executiveSummary }),
        reasonAndAlternativesFileds.map(function (key) {
          return _react2.default.createElement(Section, { key: key, name: key, header: labels[key], value: businessCase[key] });
        }),
        businessCase.benefits !== undefined && businessCase.benefits !== undefined !== null && businessCase.benefits.length > 0 ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h3',
            null,
            labels.benefits.title
          ),
          _react2.default.createElement(BenefitsTable, this.props)
        ) : null,
        returnOnInvestmentFields.map(function (key) {
          return _react2.default.createElement(Section, { key: key, name: key, header: labels[key], value: businessCase[key] });
        })
      ) : null;
    }
  }]);

  return BusinessCase;
}(_react2.default.Component);

var BusinessCaseWithoutBenefitsTable = function (_React$Component15) {
  _inherits(BusinessCaseWithoutBenefitsTable, _React$Component15);

  function BusinessCaseWithoutBenefitsTable() {
    _classCallCheck(this, BusinessCaseWithoutBenefitsTable);

    return _possibleConstructorReturn(this, (BusinessCaseWithoutBenefitsTable.__proto__ || Object.getPrototypeOf(BusinessCaseWithoutBenefitsTable)).apply(this, arguments));
  }

  _createClass(BusinessCaseWithoutBenefitsTable, [{
    key: 'render',
    value: function render() {
      var _this19 = this;

      var labels = translations.getTranslation(this.props.language, this.props.variant).businessCase;
      var businessCase = this.props;
      var fields = ["executiveSummary", "reasons", "doNothing", "doMinimal", "doSomething", "projectPlanSummary", "investmentAppraisal", "risks"];
      var hasBusinessCase = false;
      fields.concat("benefits").forEach(function (key) {
        hasBusinessCase = hasBusinessCase || _this19.props[key] !== undefined && (!Array.isArray(_this19.props[key]) || Array.isArray(_this19.props[key]) && _this19.props[key].length > 0);
      });
      return hasBusinessCase ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          null,
          labels.title
        ),
        _react2.default.createElement(
          'table',
          { className: 'briefTable', style: { fontSize: "inherit", borderCollapse: "collapse" }, cellPadding: '0', cellSpacing: '0' },
          _react2.default.createElement(
            'tbody',
            null,
            fields.map(function (key) {
              return _react2.default.createElement(TableRow, { key: key, label: labels[key], content: businessCase[key] });
            })
          )
        )
      ) : null;
    }
  }]);

  return BusinessCaseWithoutBenefitsTable;
}(_react2.default.Component);

var DeliverablesHeading = function (_React$Component16) {
  _inherits(DeliverablesHeading, _React$Component16);

  function DeliverablesHeading() {
    _classCallCheck(this, DeliverablesHeading);

    return _possibleConstructorReturn(this, (DeliverablesHeading.__proto__ || Object.getPrototypeOf(DeliverablesHeading)).apply(this, arguments));
  }

  _createClass(DeliverablesHeading, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).projectProductDescription;
      var cellStyle = { border: "solid lightgrey 1px", padding: 5 };
      return _react2.default.createElement(
        'thead',
        null,
        _react2.default.createElement(
          'tr',
          { style: { backgroundColor: "#e9e7e6" } },
          _react2.default.createElement(
            'th',
            { style: cellStyle },
            labels.columns.output.title
          ),
          _react2.default.createElement(
            'th',
            { style: cellStyle },
            labels.columns.qualityExpectation.title
          ),
          _react2.default.createElement(
            'th',
            { style: cellStyle },
            labels.columns.acceptanceCriteria.title
          ),
          _react2.default.createElement(
            'th',
            { style: cellStyle },
            labels.columns.acceptanceMethod.title
          )
        )
      );
    }
  }]);

  return DeliverablesHeading;
}(_react2.default.Component);

var ScopeDeliveriesTableGroup = function (_React$Component17) {
  _inherits(ScopeDeliveriesTableGroup, _React$Component17);

  function ScopeDeliveriesTableGroup() {
    _classCallCheck(this, ScopeDeliveriesTableGroup);

    return _possibleConstructorReturn(this, (ScopeDeliveriesTableGroup.__proto__ || Object.getPrototypeOf(ScopeDeliveriesTableGroup)).apply(this, arguments));
  }

  _createClass(ScopeDeliveriesTableGroup, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).projectProductDescription;
      var outputs = this.props.outputs;
      var cellStyle = { border: "solid lightgrey 1px", padding: 5 };
      return outputs !== undefined && outputs !== null && outputs.length > 0 ? _react2.default.createElement(
        'tbody',
        null,
        outputs.map(function (entry) {
          return _react2.default.createElement(
            'tr',
            { key: entry.id },
            _react2.default.createElement(
              'td',
              { style: cellStyle },
              _react2.default.createElement(_FormattedContent2.default, { value: entry.output })
            ),
            _react2.default.createElement(
              'td',
              { style: cellStyle },
              _react2.default.createElement(_FormattedContent2.default, { value: entry.qualityExpectation })
            ),
            _react2.default.createElement(
              'td',
              { style: cellStyle },
              _react2.default.createElement(_FormattedContent2.default, { value: entry.acceptanceCriteria })
            ),
            _react2.default.createElement(
              'td',
              { style: cellStyle },
              _react2.default.createElement(_FormattedContent2.default, { value: entry.acceptanceMethod })
            )
          );
        })
      ) : null;
    }
  }]);

  return ScopeDeliveriesTableGroup;
}(_react2.default.Component);

var ScopeDeliveriesText = function (_React$Component18) {
  _inherits(ScopeDeliveriesText, _React$Component18);

  function ScopeDeliveriesText() {
    _classCallCheck(this, ScopeDeliveriesText);

    return _possibleConstructorReturn(this, (ScopeDeliveriesText.__proto__ || Object.getPrototypeOf(ScopeDeliveriesText)).apply(this, arguments));
  }

  _createClass(ScopeDeliveriesText, [{
    key: 'hasValue',
    value: function hasValue(value) {
      return value !== undefined && value !== null && value.trim().length > 0;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this23 = this;

      var labels = translations.getTranslation(this.props).projectProductDescription;
      var outputs = this.props.outputs;
      return _react2.default.createElement(
        'div',
        null,
        outputs.map(function (entry, index) {
          return _react2.default.createElement(
            'div',
            { key: entry.id, style: { marginBottom: index + 1 < outputs.length ? 15 : 0 } },
            _react2.default.createElement(
              'table',
              null,
              _react2.default.createElement(
                'tbody',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement('td', { style: { width: 20 } }),
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(_FormattedContent2.default, { value: entry.output })
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'table',
                { style: { fontSize: "inherit" } },
                _react2.default.createElement(
                  'tbody',
                  null,
                  _this23.hasValue(entry.qualityExpectation) ? _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement('td', { style: { width: 40, paddingTop: 5 } }),
                    _react2.default.createElement(
                      'td',
                      { style: { color: "grey", paddingTop: 5, verticalAlign: "top", whiteSpace: "nowrap" } },
                      labels.columns.qualityExpectation.title
                    ),
                    _react2.default.createElement(
                      'td',
                      { style: { paddingLeft: 5, paddingTop: 5 } },
                      _react2.default.createElement(_FormattedContent2.default, { value: entry.qualityExpectation })
                    )
                  ) : null,
                  _this23.hasValue(entry.acceptanceCriteria) ? _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement('td', { style: { width: 40, paddingTop: 5 } }),
                    _react2.default.createElement(
                      'td',
                      { style: { color: "grey", paddingTop: 5, verticalAlign: "top", whiteSpace: "nowrap" } },
                      labels.columns.acceptanceCriteria.title
                    ),
                    _react2.default.createElement(
                      'td',
                      { style: { paddingLeft: 5, paddingTop: 5 } },
                      _react2.default.createElement(_FormattedContent2.default, { value: entry.acceptanceCriteria })
                    )
                  ) : null,
                  _this23.hasValue(entry.acceptanceMethod) ? _react2.default.createElement(
                    'tr',
                    null,
                    _react2.default.createElement('td', { style: { width: 40, paddingTop: 5 } }),
                    _react2.default.createElement(
                      'td',
                      { style: { color: "grey", paddingTop: 5, verticalAlign: "top", whiteSpace: "nowrap" } },
                      labels.columns.acceptanceMethod.title
                    ),
                    _react2.default.createElement(
                      'td',
                      { style: { paddingLeft: 5, paddingTop: 5 } },
                      _react2.default.createElement(_FormattedContent2.default, { value: entry.acceptanceMethod })
                    )
                  ) : null
                )
              )
            )
          );
        })
      );
    }
  }]);

  return ScopeDeliveriesText;
}(_react2.default.Component);

var ProjectProductDescription = function (_React$Component19) {
  _inherits(ProjectProductDescription, _React$Component19);

  function ProjectProductDescription() {
    _classCallCheck(this, ProjectProductDescription);

    return _possibleConstructorReturn(this, (ProjectProductDescription.__proto__ || Object.getPrototypeOf(ProjectProductDescription)).apply(this, arguments));
  }

  _createClass(ProjectProductDescription, [{
    key: 'render',
    value: function render() {
      var _this25 = this;

      var labels = translations.getTranslation(this.props).projectProductDescription;
      var outputs = this.props.items !== undefined && this.props.items !== null ? this.props.items.filter(function (item) {
        return item.items !== undefined && item.items.length > 0;
      }) : [];
      return this.props.items !== undefined && this.props.items !== null && this.props.items.length > 0 && outputs.length > 0 ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          null,
          labels.title
        ),
        this.props.items.map(function (item, index) {
          return _react2.default.createElement(
            'div',
            { key: index },
            _react2.default.createElement(
              'h3',
              null,
              item.text
            ),
            item.items !== undefined && item.items.length > 0 ? _react2.default.createElement(ScopeDeliveriesText, _extends({}, _this25.props, { outputs: item.items })) : _react2.default.createElement(
              'div',
              { style: { paddingLeft: 20 } },
              _react2.default.createElement(
                'i',
                null,
                labels.noOutputs
              )
            )
          );
        })
      ) : null;
    }
  }]);

  return ProjectProductDescription;
}(_react2.default.Component);

var ProjectProductDescriptionTable = function (_React$Component20) {
  _inherits(ProjectProductDescriptionTable, _React$Component20);

  function ProjectProductDescriptionTable() {
    _classCallCheck(this, ProjectProductDescriptionTable);

    return _possibleConstructorReturn(this, (ProjectProductDescriptionTable.__proto__ || Object.getPrototypeOf(ProjectProductDescriptionTable)).apply(this, arguments));
  }

  _createClass(ProjectProductDescriptionTable, [{
    key: 'render',
    value: function render() {
      var _this27 = this;

      var labels = translations.getTranslation(this.props).projectProductDescription;
      var outputs = this.props.items !== undefined && this.props.items !== null ? this.props.items.filter(function (item) {
        return item.items !== undefined && item.items.length > 0;
      }) : [];
      return this.props.items !== undefined && this.props.items !== null && this.props.items.length > 0 && outputs.length > 0 ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          null,
          labels.title
        ),
        this.props.items.map(function (item, index) {
          return _react2.default.createElement(
            'div',
            { key: index },
            _react2.default.createElement(
              'h3',
              null,
              item.text
            ),
            item.items !== undefined ? _react2.default.createElement(
              'table',
              { style: { fontSize: "inherit", borderCollapse: "collapse", border: "solid 1px lightgrey", width: "100%" } },
              _react2.default.createElement(DeliverablesHeading, _this27.props),
              _react2.default.createElement(ScopeDeliveriesTableGroup, _extends({ key: index }, _this27.props, { outputs: item.items }))
            ) : labels.noOutputs
          );
        })
      ) : null;
    }
  }]);

  return ProjectProductDescriptionTable;
}(_react2.default.Component);

var Section = function (_React$Component21) {
  _inherits(Section, _React$Component21);

  function Section() {
    _classCallCheck(this, Section);

    return _possibleConstructorReturn(this, (Section.__proto__ || Object.getPrototypeOf(Section)).apply(this, arguments));
  }

  _createClass(Section, [{
    key: 'render',
    value: function render() {
      return this.props.value !== undefined && this.props.value !== null && this.props.value.trim().length > 0 ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h3',
          null,
          this.props.header !== undefined ? this.props.header : ".(" + this.props.name + ")"
        ),
        _react2.default.createElement(_FormattedContent2.default, { value: this.props.value })
      ) : null;
    }
  }]);

  return Section;
}(_react2.default.Component);

var Approach = function (_React$Component22) {
  _inherits(Approach, _React$Component22);

  function Approach() {
    _classCallCheck(this, Approach);

    return _possibleConstructorReturn(this, (Approach.__proto__ || Object.getPrototypeOf(Approach)).apply(this, arguments));
  }

  _createClass(Approach, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props.language, this.props.variant).approach;
      var approach = this.props.approach;
      var fields = ["methods", "resources", "technology", "rollOut", "other"];
      var hasApproach = false;
      if (approach !== undefined && approach !== null) {
        fields.forEach(function (key) {
          hasApproach = hasApproach || approach[key] !== undefined && approach[key] !== null;
        });
      }
      return hasApproach ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          null,
          labels.title
        ),
        fields.map(function (key) {
          return _react2.default.createElement(Section, { key: key, name: key, header: labels[key], value: approach[key] });
        })
      ) : null;
    }
  }]);

  return Approach;
}(_react2.default.Component);

var ApproachTable = function (_React$Component23) {
  _inherits(ApproachTable, _React$Component23);

  function ApproachTable() {
    _classCallCheck(this, ApproachTable);

    return _possibleConstructorReturn(this, (ApproachTable.__proto__ || Object.getPrototypeOf(ApproachTable)).apply(this, arguments));
  }

  _createClass(ApproachTable, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props.language, this.props.variant).approach;
      var approach = this.props.approach;
      var fields = ["methods", "resources", "technology", "rollOut", "other"];
      var hasApproach = false;
      if (approach !== undefined && approach !== null) {
        fields.forEach(function (key) {
          hasApproach = hasApproach || approach[key] !== undefined && approach[key] !== null;
        });
      }
      return hasApproach ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          null,
          labels.title
        ),
        _react2.default.createElement(
          'table',
          { className: 'briefTable', style: { fontSize: "inherit", borderCollapse: "collapse" }, cellPadding: '0', cellSpacing: '0' },
          _react2.default.createElement(
            'tbody',
            null,
            fields.map(function (key) {
              return _react2.default.createElement(TableRow, { key: key, label: labels[key], content: approach[key] });
            })
          )
        )
      ) : null;
    }
  }]);

  return ApproachTable;
}(_react2.default.Component);

var Organization = function (_React$Component24) {
  _inherits(Organization, _React$Component24);

  function Organization() {
    _classCallCheck(this, Organization);

    return _possibleConstructorReturn(this, (Organization.__proto__ || Object.getPrototypeOf(Organization)).apply(this, arguments));
  }

  _createClass(Organization, [{
    key: 'render',
    value: function render() {
      var stakeholders = this.props.organization ? this.props.organization : [];
      var labels = translations.getTranslation(this.props.language, this.props.variant).organization;
      var projectRoles = [{ id: "Excecutive", name: labels.executive }, { id: "Senior User", name: labels.seniorUser }, { id: "Senior Supplier", name: labels.seniorSupplier }, { id: "Business Assurance", name: labels.businessAssurance }, { id: "User Assurance", name: labels.userAssurance }, { id: "Supplier Assurance", name: labels.supplierAssurance }, { id: "Project Manager", name: labels.projectManager }, { id: "Project Support", name: labels.projectSupport }, { id: "Change Authority", name: labels.changeAuthority }, { id: "Team Manager", name: labels.teamManager }, { id: "Team Member", name: labels.teamMember }, { id: "Stakeholder", name: labels.stakeholder }];
      var sortOrder = projectRoles.map(function (item) {
        return item.id === 'Excecutive' ? 'executive' : item.id.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, chr) {
          return chr.toUpperCase();
        });
      });

      return stakeholders.length > 0 ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          null,
          labels.title
        ),
        _react2.default.createElement(
          'table',
          { style: { fontSize: "inherit", borderCollapse: "collapse", border: "solid 1px lightgrey", width: "100%" } },
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              { style: { backgroundColor: "#e9e7e6" } },
              _react2.default.createElement(
                'th',
                { style: { border: "solid lightgrey 1px", padding: 5 } },
                labels.columns.name
              ),
              _react2.default.createElement(
                'th',
                { style: { border: "solid lightgrey 1px", padding: 5 } },
                labels.columns.role
              ),
              _react2.default.createElement(
                'th',
                { style: { border: "solid lightgrey 1px", padding: 5 } },
                labels.columns.description
              )
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            [].concat.apply([], stakeholders.map(function (stakeholder) {
              return [Object.assign({}, stakeholder, {
                role: stakeholder.role === 'Excecutive' ? 'executive' : stakeholder.role.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, chr) {
                  return chr.toUpperCase();
                }) // to camelCase
              })].concat(stakeholder.additionalRoles !== undefined ? stakeholder.additionalRoles.map(function (item) {
                return Object.assign({}, stakeholder, item);
              }) : []);
            })).map(function (item) {
              return Object.assign({}, item, { index: sortOrder.indexOf(item.role) });
            }).slice().sort(function (a, b) {
              return sortOrder.indexOf(a.role) - sortOrder.indexOf(b.role);
            }).map(function (person, index) {
              return _react2.default.createElement(
                'tr',
                { key: index },
                _react2.default.createElement(
                  'td',
                  { style: { border: "solid lightgrey 1px", padding: 5, verticalAlign: "top" } },
                  person.name
                ),
                _react2.default.createElement(
                  'td',
                  { style: { border: "solid lightgrey 1px", padding: 5, verticalAlign: "top" } },
                  labels[person.role]
                ),
                _react2.default.createElement(
                  'td',
                  { style: { border: "solid lightgrey 1px", padding: 5, verticalAlign: "top" } },
                  person.details
                )
              );
            })
          )
        )
      ) : null;
    }
  }]);

  return Organization;
}(_react2.default.Component);

var ApproveForm = function (_React$Component25) {
  _inherits(ApproveForm, _React$Component25);

  function ApproveForm(props) {
    _classCallCheck(this, ApproveForm);

    var _this32 = _possibleConstructorReturn(this, (ApproveForm.__proto__ || Object.getPrototypeOf(ApproveForm)).call(this, props));

    _this32.state = { approvedBy: "" };
    return _this32;
  }

  _createClass(ApproveForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.element.scrollIntoView(true);
    }
  }, {
    key: 'updateApprovedBy',
    value: function updateApprovedBy(event) {
      this.setState({ approvedBy: event.target.value, message: undefined });
    }
  }, {
    key: 'approve',
    value: function approve(event) {
      event.preventDefault();
      if (this.state.approvedBy.trim().length === 0) {
        this.setState({ message: "required field" });
      } else if (this.props.onApprove !== undefined) {
        this.props.onApprove(this.state.approvedBy);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).approval;
      return _react2.default.createElement(
        'div',
        { ref: 'element', style: { marginTop: 30, border: "solid 1px red", padding: 30, marginBottom: 20 } },
        _react2.default.createElement(_Field2.default, {
          onChange: this.updateApprovedBy.bind(this),
          title: labels.fields.approvedBy.title,
          value: this.state.approvedBy,
          description: labels.fields.approvedBy.description
        }),
        this.state.message !== undefined ? _react2.default.createElement(
          'div',
          { style: { marginTop: -15, paddingBottom: 5, color: "red", fontSize: "80%" } },
          labels.thisFieldIsRequired
        ) : null,
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 15, paddingBottom: 20 } },
          _react2.default.createElement('input', { onClick: this.props.onCancel, className: 'cancel', type: 'button', value: labels.cancel }),
          _react2.default.createElement('input', { onClick: this.approve.bind(this), className: 'save', type: 'button', value: this.props.approveLabel })
        )
      );
    }
  }]);

  return ApproveForm;
}(_react2.default.Component);

var BriefPidSlides = exports.BriefPidSlides = function (_React$Component26) {
  _inherits(BriefPidSlides, _React$Component26);

  function BriefPidSlides() {
    _classCallCheck(this, BriefPidSlides);

    return _possibleConstructorReturn(this, (BriefPidSlides.__proto__ || Object.getPrototypeOf(BriefPidSlides)).apply(this, arguments));
  }

  _createClass(BriefPidSlides, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      var pidSlides = this.props.pidSlides !== undefined ? this.props.pidSlides : [];
      var pidSlideTitles = this.props.pidSlideTitles !== undefined ? this.props.pidSlideTitles : [];
      var definitionLabels = translations.getTranslation(this.props.language, this.props.variant).definition;
      var date = this.props.date !== undefined ? new Date(Date.parse(this.props.date)).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10);
      var nameAndDate = (this.props.project !== undefined ? this.props.project.name + " - " : "") + date;
      var briefSlides = [_react2.default.createElement(_Slides.FormattedSlide, { label: this.props.title, content: nameAndDate, slideType: 'title' }), _react2.default.createElement(
        _Slides.FormattedSlide,
        { label: definitionLabels.background.title, content: this.props.doc.definition.background, slideType: 'preformatted' },
        _react2.default.createElement(Background, _extends({}, this.props, this.props.doc.definition.background, { title: '' }))
      ), _react2.default.createElement(
        _Slides.FormattedSlide,
        { label: definitionLabels.objectives.title, content: this.props.doc.definition.objective, slideType: 'preformatted' },
        _react2.default.createElement(Objectives, _extends({}, this.props, this.props.doc.definition.objective, { title: '' }))
      ), _react2.default.createElement(
        _Slides.FormattedSlide,
        { label: definitionLabels.scope.title, content: this.props.doc.definition.scope.items[0], slideType: 'preformatted' },
        _react2.default.createElement(Scope, _extends({}, this.props, this.props.doc.definition, { title: '' }))
      ), _react2.default.createElement(_Slides.FormattedSlide, { label: definitionLabels.constraints.title, content: this.props.doc.definition.constraints }), _react2.default.createElement(_Slides.FormattedSlide, { label: definitionLabels.assumptions.title, content: this.props.doc.definition.assumptions }), _react2.default.createElement(_Slides.FormattedSlide, { label: definitionLabels.stakeholders.title, content: this.props.doc.definition.stakeholders }), _react2.default.createElement(_Slides.FormattedSlide, { label: definitionLabels.interfaces.title, content: this.props.doc.definition.interfaces }), _react2.default.createElement(BusinessCase, _extends({}, this.props, this.props.doc.businessCase)), _react2.default.createElement(ProjectProductDescription, _extends({}, this.props, { items: this.props.doc.projectProductDescription })), _react2.default.createElement(Approach, _extends({}, this.props, { approach: this.props.doc.approach })), _react2.default.createElement(Organization, _extends({}, this.props, { organization: this.props.doc.organization }))];

      var briefSlideTitles = [labels.brief.frontPage, definitionLabels.background.title, definitionLabels.objectives.title, definitionLabels.scope.title, definitionLabels.constraints.title, definitionLabels.assumptions.title, definitionLabels.stakeholders.title, definitionLabels.interfaces.title, labels.businessCase.title, labels.projectProductDescription.title, labels.approach.title, labels.organization.title];
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Slides2.default, { slides: briefSlides.concat(pidSlides), slideTitles: briefSlideTitles.concat(pidSlideTitles) })
      );
    }
  }]);

  return BriefPidSlides;
}(_react2.default.Component);

var BriefContent = exports.BriefContent = function (_React$Component27) {
  _inherits(BriefContent, _React$Component27);

  function BriefContent() {
    _classCallCheck(this, BriefContent);

    return _possibleConstructorReturn(this, (BriefContent.__proto__ || Object.getPrototypeOf(BriefContent)).apply(this, arguments));
  }

  _createClass(BriefContent, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);

      return this.props.showTable ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(DefinitionTable, _extends({}, this.props, this.props.brief.definition)),
        _react2.default.createElement(BusinessCaseWithoutBenefitsTable, _extends({}, this.props, this.props.brief.businessCase)),
        this.props.brief.businessCase !== undefined && this.props.brief.businessCase !== null && this.props.brief.businessCase.benefits !== undefined && this.props.brief.businessCase.benefits.length > 0 ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h3',
            null,
            labels.businessCase.benefits.title
          ),
          _react2.default.createElement(BenefitsTable, _extends({}, this.props, this.props.brief.businessCase))
        ) : null,
        _react2.default.createElement(ProjectProductDescriptionTable, _extends({}, this.props, { items: this.props.brief.projectProductDescription })),
        _react2.default.createElement(ApproachTable, _extends({}, this.props, { approach: this.props.brief.approach })),
        _react2.default.createElement(Organization, _extends({}, this.props, { organization: this.props.brief.organization }))
      ) : !this.props.presentationMode ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(Definition, _extends({}, this.props, this.props.brief.definition)),
        _react2.default.createElement(BusinessCase, _extends({}, this.props, this.props.brief.businessCase)),
        _react2.default.createElement(ProjectProductDescription, _extends({}, this.props, { items: this.props.brief.projectProductDescription })),
        _react2.default.createElement(Approach, _extends({}, this.props, { approach: this.props.brief.approach })),
        _react2.default.createElement(Organization, _extends({}, this.props, { organization: this.props.brief.organization }))
      ) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(BriefPidSlides, _extends({}, this.props, { doc: this.props.brief }))
      );
    }
  }]);

  return BriefContent;
}(_react2.default.Component);

var BriefDetails = exports.BriefDetails = function (_React$Component28) {
  _inherits(BriefDetails, _React$Component28);

  function BriefDetails() {
    _classCallCheck(this, BriefDetails);

    return _possibleConstructorReturn(this, (BriefDetails.__proto__ || Object.getPrototypeOf(BriefDetails)).apply(this, arguments));
  }

  _createClass(BriefDetails, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      var date = this.props.brief !== undefined ? this.props.brief.date : undefined;
      var type = this.props.brief !== undefined ? this.props.brief.type : undefined;
      return _react2.default.createElement(
        ApprovableReport,
        _extends({}, this.props, {
          date: date,
          title: labels.brief.title,
          type: type,
          current: this.props.project.brief,
          selected: this.props.brief,
          report: 'Brief',
          approveLabel: labels.approval.approve,
          disabledActions: this.props.project.pid !== undefined && this.props.project.pid.history !== undefined,
          pidFollowUp: this.props.hasPreview && this.props.project.pid !== undefined && this.props.project.pid.history !== undefined
        }),
        _react2.default.createElement(BriefContent, _extends({}, this.props, { title: labels.brief.title }))
      );
    }
  }]);

  return BriefDetails;
}(_react2.default.Component);

var ApprovableReport = exports.ApprovableReport = function (_React$Component29) {
  _inherits(ApprovableReport, _React$Component29);

  function ApprovableReport(props) {
    _classCallCheck(this, ApprovableReport);

    var _this36 = _possibleConstructorReturn(this, (ApprovableReport.__proto__ || Object.getPrototypeOf(ApprovableReport)).call(this, props));

    _this36.state = { showApproval: _this36.props.showApproval === true };
    return _this36;
  }

  _createClass(ApprovableReport, [{
    key: 'showApprove',
    value: function showApprove() {
      this.setState({ showApproval: true });
    }
  }, {
    key: 'approveProjectBrief',
    value: function approveProjectBrief(approvedBy) {
      this.setState({ showApproval: undefined });
      if (this.props.report !== undefined) {
        var command = { type: "approve" + this.props.report + "Preview", approvedBy: approvedBy, project: { id: this.props.project.id } };
        if (this.props.selected.type === "draft") {
          command.type = "approve" + this.props.report;
          command.version = this.props.selected.version;
        }
        (0, _sendCommand2.default)(command).then(function () {
          window.scrollTo(0, 0);
          window.location.reload();
        }).catch(function () {
          alert("Failed to approve report");
        });
      } else {
        alert("No report type specified");
      }
    }
  }, {
    key: 'cancelApproval',
    value: function cancelApproval(event) {
      event.preventDefault();
      this.setState({ showApproval: undefined });
      window.scrollTo(0, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var date = this.props.date !== undefined ? new Date(Date.parse(this.props.date)).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10);
      var nameAndDate = (this.props.project !== undefined ? this.props.project.name + " - " : "") + date;
      var labels = translations.getTranslation(this.props);
      var approved = this.props.type !== "draft" && this.props.type !== "preview" && this.props.selected.approved !== undefined ? this.props.selected.approved : undefined;
      var reportStyle = { textAlign: "left", maxWidth: 1016 };
      var style = Object.assign({}, reportStyle, this.props.settings !== undefined ? this.props.settings.style : undefined);
      return _react2.default.createElement(
        'div',
        null,
        !this.props.presentationMode ? _react2.default.createElement(
          'div',
          { style: { textAlign: "center" } },
          !this.props.fullPage ? _react2.default.createElement(
            'div',
            { style: { textAlign: "left" } },
            _react2.default.createElement(BriefMenu, _extends({}, this.props, { onApprove: this.showApprove.bind(this) }))
          ) : null,
          _react2.default.createElement(
            'div',
            { style: { display: "inline-block", padding: 5, paddingLeft: 10, fontFamily: "Verdana, sans-serif", justifyContent: "center" } },
            _react2.default.createElement(
              'div',
              { className: 'report', style: style },
              _react2.default.createElement(
                'h1',
                { style: { textAlign: "center" } },
                _react2.default.createElement(
                  'div',
                  null,
                  this.props.title
                ),
                _react2.default.createElement(
                  'div',
                  { style: { fontSize: "80%" } },
                  nameAndDate
                )
              ),
              this.props.type === "preview" ? _react2.default.createElement(_HighlightReport.ReportMessage, { message: labels.brief.messagePreview }) : null,
              this.props.type === "draft" ? _react2.default.createElement(_HighlightReport.ReportMessage, { message: labels.brief.messageDraft }) : null,
              this.props.children,
              approved !== undefined ? _react2.default.createElement(
                'div',
                { style: { paddingTop: 30, paddingBottom: 30, textAlign: "center" } },
                labels.approval.fields.approvedBy.title,
                ' ',
                approved.user !== undefined ? approved.user.name : "(anonymous)",
                ' ',
                date,
                approved.description !== undefined && approved.description !== null && approved.description.trim().length > 0 ? _react2.default.createElement(
                  'span',
                  null,
                  ' (',
                  approved.description,
                  ')'
                ) : null
              ) : null,
              this.state.showApproval ? _react2.default.createElement(ApproveForm, _extends({}, this.props, {
                onCancel: this.cancelApproval.bind(this),
                onApprove: this.approveProjectBrief.bind(this)
              })) : null
            )
          )
        ) : _react2.default.createElement(
          'div',
          { style: { textAlign: "center", paddingRight: 300 } },
          _react2.default.createElement(
            'div',
            { style: { display: "inline-block", padding: 5, paddingLeft: 10, fontFamily: "Verdana, sans-serif", justifyContent: "center" } },
            _react2.default.createElement(
              'div',
              { className: 'report', style: style },
              this.props.children
            )
          )
        )
      );
    }
  }]);

  return ApprovableReport;
}(_react2.default.Component);

function ignoreUndefinedAndInvariants(key, value) {
  if (value === undefined || value === null) {
    return undefined;
  } else {
    switch (key) {
      case "date":
      case "type":
      case "history":
      case "version":
        return undefined;
      default:
        return value;
    }
  }
}

var BriefVersion = function (_React$Component30) {
  _inherits(BriefVersion, _React$Component30);

  function BriefVersion() {
    _classCallCheck(this, BriefVersion);

    return _possibleConstructorReturn(this, (BriefVersion.__proto__ || Object.getPrototypeOf(BriefVersion)).apply(this, arguments));
  }

  _createClass(BriefVersion, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).menu;
      var version = this.props.minorVersion !== undefined && this.props.minorVersion !== null && this.props.majorVersion !== undefined && this.props.majorVersion !== null ? this.props.majorVersion + "." + this.props.minorVersion : "1." + this.props.version;
      return _react2.default.createElement(
        'div',
        { style: { fontWeight: this.props.selected ? "bold" : "normal" } },
        _react2.default.createElement(
          'span',
          null,
          version
        ),
        _react2.default.createElement(
          'span',
          null,
          ' '
        ),
        this.props.type === "draft" ? labels.draft : "",
        this.props.date !== undefined ? _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'span',
            null,
            ' ('
          ),
          new Date(Date.parse(this.props.date)).toISOString().slice(0, 10),
          _react2.default.createElement(
            'span',
            null,
            ')'
          )
        ) : null
      );
    }
  }]);

  return BriefVersion;
}(_react2.default.Component);

var BriefMenu = function (_React$Component31) {
  _inherits(BriefMenu, _React$Component31);

  function BriefMenu() {
    _classCallCheck(this, BriefMenu);

    return _possibleConstructorReturn(this, (BriefMenu.__proto__ || Object.getPrototypeOf(BriefMenu)).apply(this, arguments));
  }

  _createClass(BriefMenu, [{
    key: 'createDraft',
    value: function createDraft(event) {
      event.preventDefault();
      if (this.props.report !== undefined) {
        var command = "create" + this.props.report + "Draft";
        (0, _sendCommand2.default)({ type: command, project: { id: this.props.project.id } }).then(function () {
          window.location.reload();
        }).catch(function (error) {
          console.log("Got error " + JSON.stringify(error), error);
          alert("Failed to create draft");
        });
      } else {
        alert("No report type specified");
      }
    }
  }, {
    key: 'approvePreview',
    value: function approvePreview(event) {
      event.preventDefault();
      if (this.props.onApprove !== undefined) {
        this.props.onApprove();
      }
    }
  }, {
    key: 'url',
    value: function url(parameters, withTable) {
      var version = this.props.selected !== undefined && (parameters == undefined || parameters.indexOf("version=") < 0) ? this.props.selected.version : undefined;
      return (this.props.path !== undefined ? this.props.path : "") + "?" + (this.props.showTable && withTable !== false ? "showTable=true&" : "") + (version !== undefined ? "version=" + version + "&" : "") + parameters;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this39 = this;

      var labels = translations.getTranslation(this.props).menu;
      var selected = this.props.selected;
      var current = this.props.current;

      var type = selected !== undefined ? selected.type : undefined;
      var version = selected !== undefined ? selected.version : undefined;

      var hasCurrent = current !== undefined;
      var hasHistory = hasCurrent && current.history !== undefined && current.history.length > 0;
      var currentType = hasCurrent ? current.type : undefined;
      var currentVersion = hasCurrent ? current.version : undefined;
      var history = hasCurrent ? current.history : [];

      return _react2.default.createElement(
        'div',
        { style: { display: "inline-block", float: "right", marginRight: 30, width: 250, borderLeft: "solid lightgrey 1px", paddingTop: 10, paddingLeft: 10, paddingBottom: 150 } },
        this.props.menuTopItems !== undefined ? this.props.menuTopItems : null,
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 15, display: this.props.hideReportDisplayMenu === true ? "none" : undefined } },
          _react2.default.createElement(
            'b',
            null,
            labels.reportActions
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingLeft: 10 } },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'a',
                { href: this.url("fullPage=true"), target: '_blank' },
                labels.viewFullScreen
              )
            ),
            this.props.definedTableView !== false && !this.props.showTable ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'a',
                { href: this.url("showTable=true") },
                labels.tableView
              )
            ) : null,
            this.props.definedTableView !== false && this.props.showTable ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'a',
                { href: this.url("", false) },
                labels.reportView
              )
            ) : null,
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'a',
                { href: this.url("fullPage=true&pdf=true"), target: '_blank' },
                labels.viewPDF
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'a',
                { href: this.url("fullPage=true&docx=true"), target: '_blank' },
                labels.viewWord
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'a',
                { href: this.url("presentationMode=true"), target: '_blank' },
                labels.viewSlideMode
              )
            ),
            this.props.disabledActions !== true ? _react2.default.createElement(
              'div',
              null,
              type === "preview" && (hasCurrent && currentType !== "draft" || !hasCurrent) ? _react2.default.createElement(
                'div',
                { onClick: this.createDraft.bind(this), style: { cursor: "pointer", textDecoration: "underline" } },
                labels.createDraft
              ) : null,
              type === "preview" && currentType === "draft" ? _react2.default.createElement(
                'div',
                { onClick: this.createDraft.bind(this), style: { cursor: "pointer", textDecoration: "underline" } },
                labels.updateDraft
              ) : null,
              type === "preview" || type === "draft" ? _react2.default.createElement(
                'div',
                { onClick: this.approvePreview.bind(this), style: { cursor: "pointer", textDecoration: "underline" } },
                labels.approve
              ) : null
            ) : null
          )
        ),
        this.props.menuReportActions !== undefined ? this.props.menuReportActions : null,
        hasCurrent !== undefined ? _react2.default.createElement(
          'div',
          { style: { paddingTop: 15 } },
          _react2.default.createElement(
            'b',
            null,
            labels.documentArchive
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingLeft: 10 } },
            this.props.hasPreview && (this.props.disabledActions !== true || this.props.showCurrent === true) ? type === "preview" ? _react2.default.createElement(
              'div',
              { style: { fontWeight: type === "preview" ? "bold" : "normal" } },
              labels.current
            ) : _react2.default.createElement(
              'a',
              { href: this.url("version=") },
              _react2.default.createElement(
                'div',
                { style: { fontWeight: type === "preview" ? "bold" : "normal" } },
                labels.current
              )
            ) : null,
            currentType === "draft" ? type === "draft" ? _react2.default.createElement(BriefVersion, _extends({}, this.props, current, { selected: currentType === "draft" })) : _react2.default.createElement(
              'a',
              { href: this.url("version=" + currentVersion + "-DRAFT") },
              _react2.default.createElement(BriefVersion, _extends({}, this.props, current, { selected: type === "draft" }))
            ) : null,
            hasHistory ? history.slice().reverse().map(function (item) {
              return version === item.version ? _react2.default.createElement(BriefVersion, _extends({ key: item.version }, item, { selected: version === item.version })) : _react2.default.createElement(
                'a',
                { key: item.version, href: _this39.url("version=" + item.version) },
                _react2.default.createElement(BriefVersion, _extends({}, item, { selected: version === item.version }))
              );
            }) : null
          )
        ) : null,
        this.props.pidFollowUp && type === "draft" ? _react2.default.createElement(
          'div',
          { style: { paddingTop: 15, paddingLeft: 10, fontSize: "80%", color: "#ff9999" } },
          labels.briefDetailsIsFollowedUpInPID
        ) : null,
        _react2.default.createElement(
          'div',
          { style: { display: "none", paddingTop: 15 } },
          _react2.default.createElement(
            'b',
            null,
            'Table of Content'
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingLeft: 10 } },
            _react2.default.createElement(
              'div',
              { style: { cursor: "pointer", textDecoration: "underline" } },
              'Definition'
            ),
            _react2.default.createElement(
              'div',
              { style: { cursor: "pointer", textDecoration: "underline" } },
              'Project Product Description'
            )
          )
        )
      );
    }
  }]);

  return BriefMenu;
}(_react2.default.Component);

var Brief = exports.Brief = function (_React$Component32) {
  _inherits(Brief, _React$Component32);

  function Brief() {
    _classCallCheck(this, Brief);

    return _possibleConstructorReturn(this, (Brief.__proto__ || Object.getPrototypeOf(Brief)).apply(this, arguments));
  }

  _createClass(Brief, [{
    key: 'render',
    value: function render() {
      var _this41 = this;

      var brief = (0, _getProjectBrief2.default)(this.props.project);
      var hasPreview = this.props.project.brief === undefined || this.props.project.brief !== undefined && JSON.stringify(brief, ignoreUndefinedAndInvariants) !== JSON.stringify(this.props.project.brief, ignoreUndefinedAndInvariants);
      if (hasPreview && (this.props.project.pid === undefined || this.props.project.pid !== undefined && this.props.project.pid.history === undefined)) {
        brief = Object.assign({}, brief, { type: "preview" });
      } else if (this.props.project.brief !== undefined) {
        brief = this.props.project.brief;
      }
      if (this.props.selected !== undefined) {
        if (this.props.selected.indexOf("-DRAFT") > 0 && this.props.project.brief.type === "draft" && this.props.project.brief.version === parseInt(this.props.selected)) {
          brief = this.props.project.brief;
        } else if (this.props.project.brief !== undefined && this.props.project.brief.history !== undefined) {
          var foundBrief = this.props.project.brief.history.filter(function (item) {
            return item.version === parseInt(_this41.props.selected);
          })[0];
          if (foundBrief !== undefined) {
            brief = foundBrief;
          }
        }
      }
      return _react2.default.createElement(BriefDetails, _extends({}, this.props, { brief: brief, hasPreview: hasPreview }));
    }
  }]);

  return Brief;
}(_react2.default.Component);

var BriefPage = function (_React$Component33) {
  _inherits(BriefPage, _React$Component33);

  function BriefPage() {
    _classCallCheck(this, BriefPage);

    return _possibleConstructorReturn(this, (BriefPage.__proto__ || Object.getPrototypeOf(BriefPage)).apply(this, arguments));
  }

  _createClass(BriefPage, [{
    key: 'render',
    value: function render() {
      var menu = this.props.showMenu === true ? _react2.default.createElement(_ProjectMenu2.default, this.props) : undefined;
      var selected = this.props.selected;
      return this.props.fullPage ? _react2.default.createElement(
        'html',
        null,
        _react2.default.createElement(
          'head',
          null,
          _react2.default.createElement('meta', { 'http-equiv': 'Content-Type', content: 'text/html; charset=UTF-8' })
        ),
        _react2.default.createElement(
          'body',
          null,
          _react2.default.createElement(Brief, this.props)
        )
      ) : _react2.default.createElement(
        _Layout2.default,
        _extends({}, this.props, { projectMenu: menu }),
        _react2.default.createElement(Brief, this.props)
      );
    }
  }]);

  return BriefPage;
}(_react2.default.Component);

exports.default = BriefPage;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(19) && !__webpack_require__(7)(function () {
  return Object.defineProperty(__webpack_require__(179)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(14);


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(39);
var toIObject = __webpack_require__(40);
var arrayIndexOf = __webpack_require__(131)(false);
var IE_PROTO = __webpack_require__(181)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(20);
var anObject = __webpack_require__(3);
var getKeys = __webpack_require__(76);

module.exports = __webpack_require__(19) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(40);
var gOPN = __webpack_require__(79).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(19);
var getKeys = __webpack_require__(76);
var gOPS = __webpack_require__(132);
var pIE = __webpack_require__(108);
var toObject = __webpack_require__(22);
var IObject = __webpack_require__(107);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(7)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 271 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(27);
var isObject = __webpack_require__(10);
var invoke = __webpack_require__(273);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 273 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(5).parseInt;
var $trim = __webpack_require__(98).trim;
var ws = __webpack_require__(185);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(5).parseFloat;
var $trim = __webpack_require__(98).trim;

module.exports = 1 / $parseFloat(__webpack_require__(185) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(49);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(10);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 278 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(188);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(3);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(27);
var toObject = __webpack_require__(22);
var IObject = __webpack_require__(107);
var toLength = __webpack_require__(16);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(22);
var toAbsoluteIndex = __webpack_require__(77);
var toLength = __webpack_require__(16);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(200);
__webpack_require__(0)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(19) && /./g.flags != 'g') __webpack_require__(20).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(109)
});


/***/ }),
/* 286 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(3);
var isObject = __webpack_require__(10);
var newPromiseCapability = __webpack_require__(204);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(289);
var validate = __webpack_require__(84);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(140)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(20).f;
var create = __webpack_require__(78);
var redefineAll = __webpack_require__(83);
var ctx = __webpack_require__(48);
var anInstance = __webpack_require__(81);
var forOf = __webpack_require__(82);
var $iterDefine = __webpack_require__(190);
var step = __webpack_require__(283);
var setSpecies = __webpack_require__(80);
var DESCRIPTORS = __webpack_require__(19);
var fastKey = __webpack_require__(68).fastKey;
var validate = __webpack_require__(84);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(289);
var validate = __webpack_require__(84);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(140)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var each = __webpack_require__(56)(0);
var redefine = __webpack_require__(34);
var meta = __webpack_require__(68);
var assign = __webpack_require__(270);
var weak = __webpack_require__(292);
var isObject = __webpack_require__(10);
var validate = __webpack_require__(84);
var NATIVE_WEAK_MAP = __webpack_require__(84);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(140)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(83);
var getWeak = __webpack_require__(68).getWeak;
var anObject = __webpack_require__(3);
var isObject = __webpack_require__(10);
var anInstance = __webpack_require__(81);
var forOf = __webpack_require__(82);
var createArrayMethod = __webpack_require__(56);
var $has = __webpack_require__(39);
var validate = __webpack_require__(84);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(50);
var toLength = __webpack_require__(16);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(79);
var gOPS = __webpack_require__(132);
var anObject = __webpack_require__(3);
var Reflect = __webpack_require__(5).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(133);
var isObject = __webpack_require__(10);
var toLength = __webpack_require__(16);
var ctx = __webpack_require__(48);
var IS_CONCAT_SPREADABLE = __webpack_require__(14)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(16);
var repeat = __webpack_require__(187);
var defined = __webpack_require__(54);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(19);
var getKeys = __webpack_require__(76);
var toIObject = __webpack_require__(40);
var isEnum = __webpack_require__(108).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(97);
var from = __webpack_require__(299);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(82);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 300 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(111),
    _assign = __webpack_require__(8);

var ReactNoopUpdateQueue = __webpack_require__(302);

var canDefineProperty = __webpack_require__(304);
var emptyObject = __webpack_require__(649);
var invariant = __webpack_require__(112);
var lowPriorityWarning = __webpack_require__(650);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(145);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(658);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RoleDescription = function (_React$Component) {
  _inherits(RoleDescription, _React$Component);

  function RoleDescription() {
    _classCallCheck(this, RoleDescription);

    return _possibleConstructorReturn(this, (RoleDescription.__proto__ || Object.getPrototypeOf(RoleDescription)).apply(this, arguments));
  }

  _createClass(RoleDescription, [{
    key: "render",
    value: function render() {
      switch (this.props.role) {
        case "projectManager":
          return _react2.default.createElement(
            "span",
            null,
            "I'm a Project Manager"
          );
        case "departmentManager":
          return _react2.default.createElement(
            "span",
            null,
            "I'm a Department Manager"
          );
        case "portfolioManager":
          return _react2.default.createElement(
            "span",
            null,
            "I'm a Portfolio Manager"
          );
        case "programManager":
          return _react2.default.createElement(
            "span",
            null,
            "I'm a Program Manager"
          );
        case "ceo":
          return _react2.default.createElement(
            "span",
            null,
            "I'm a CEO"
          );
        case "dagligTjener":
          return _react2.default.createElement(
            "span",
            null,
            "I'm Kate"
          );
        default:
          return _react2.default.createElement(
            "span",
            null,
            "I'm ",
            this.props.role
          );
      }
    }
  }]);

  return RoleDescription;
}(_react2.default.Component);

var Demo = function (_React$Component2) {
  _inherits(Demo, _React$Component2);

  function Demo(props) {
    _classCallCheck(this, Demo);

    var _this2 = _possibleConstructorReturn(this, (Demo.__proto__ || Object.getPrototypeOf(Demo)).call(this, props));

    _this2.state = {};
    return _this2;
  }

  _createClass(Demo, [{
    key: "startTour",
    value: function startTour(event) {
      event.preventDefault();
      this.setState({ start: !this.state.start });
    }
  }, {
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        {
          style: {
            position: "relative",
            border: "solid 3px red",
            color: "red",
            textAlign: "center",
            margin: 5,
            padding: 5
          }
        },
        _react2.default.createElement(
          "span",
          { style: { float: "left" } },
          "DEMO!"
        ),
        this.props.environment === undefined || this.props.environment.demo === undefined ? _react2.default.createElement(
          "a",
          { href: "#", onClick: this.startTour.bind(this) },
          "Start your tour"
        ) : _react2.default.createElement(
          "span",
          null,
          _react2.default.createElement(RoleDescription, { role: this.props.environment.demo.role })
        ),
        _react2.default.createElement(
          "span",
          { style: { float: "right" } },
          "DEMO!"
        ),
        this.state.start ? _react2.default.createElement(
          "div",
          {
            style: {
              position: "absolute",
              textAlign: "left",
              color: "black",
              padding: 15,
              zIndex: 1,
              backgroundColor: "white",
              boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)",
              border: "solid black 1px"
            }
          },
          _react2.default.createElement(
            "b",
            null,
            "Tour menu"
          ),
          _react2.default.createElement(
            "ul",
            null,
            _react2.default.createElement(
              "li",
              { style: { paddingBottom: 10 } },
              _react2.default.createElement(
                "a",
                { href: "http://progreto.eu" },
                "Documentation"
              )
            ),
            _react2.default.createElement(
              "li",
              { style: { paddingBottom: 10 } },
              _react2.default.createElement(
                "a",
                { href: "/demo/alex.moore@demo.progreto.com" },
                "I am Alex Moore, project manager at ",
                _react2.default.createElement("br", null),
                "Independent Vibes Records",
                _react2.default.createElement("br", null),
                "(Axelos Sample Exam)"
              )
            ),
            _react2.default.createElement(
              "li",
              null,
              _react2.default.createElement(
                "a",
                { href: "/demo/projectManager" },
                "I am a project manager"
              )
            ),
            _react2.default.createElement(
              "li",
              null,
              _react2.default.createElement(
                "a",
                { href: "/demo/departmentManager" },
                "I am a department manager"
              )
            ),
            _react2.default.createElement(
              "li",
              null,
              _react2.default.createElement(
                "a",
                { href: "/demo/portfolioManager" },
                "I am a portfolio manager"
              )
            ),
            _react2.default.createElement(
              "li",
              null,
              _react2.default.createElement(
                "a",
                { href: "/demo/programManager" },
                "I am a program manager"
              )
            ),
            _react2.default.createElement(
              "li",
              null,
              _react2.default.createElement(
                "a",
                { href: "/demo/ceo" },
                "I am a CEO"
              )
            ),
            _react2.default.createElement(
              "li",
              null,
              _react2.default.createElement(
                "a",
                { href: "/demo/dagligTjener" },
                "I am a \"",
                _react2.default.createElement(
                  "i",
                  null,
                  "daglig tjener"
                ),
                "\""
              )
            )
          )
        ) : null
      );
    }
  }]);

  return Demo;
}(_react2.default.Component);

exports.default = Demo;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */

function isObject(obj) {
  return null !== obj && 'object' === typeof obj;
}

module.exports = isObject;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(24);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classNames = __webpack_require__(146);

var _classNames2 = _interopRequireDefault(_classNames);

var _keys = __webpack_require__(311);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Navbar = function (_Component) {
  _inherits(Navbar, _Component);

  function Navbar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Navbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call.apply(_ref, [this].concat(args))), _this), _this.handleNextClick = function () {
      if (_this.props.onNextClick) {
        _this.props.onNextClick();
      }
    }, _this.handlePreviousClick = function () {
      if (_this.props.onPreviousClick) {
        _this.props.onPreviousClick();
      }
    }, _this.handleNextKeyDown = function (e) {
      if (e.keyCode !== _keys.ENTER && e.keyCode !== _keys.SPACE) {
        return;
      }
      e.preventDefault();
      _this.handleNextClick();
    }, _this.handlePreviousKeyDown = function (e) {
      if (e.keyCode !== _keys.ENTER && e.keyCode !== _keys.SPACE) {
        return;
      }
      e.preventDefault();
      _this.handlePreviousClick();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Navbar, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.labels !== this.props.labels || nextProps.dir !== this.props.dir || this.props.showPreviousButton !== nextProps.showPreviousButton || this.props.showNextButton !== nextProps.showNextButton;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          className = _props.className,
          showPreviousButton = _props.showPreviousButton,
          showNextButton = _props.showNextButton,
          labels = _props.labels,
          dir = _props.dir;


      var previousClickHandler = void 0;
      var nextClickHandler = void 0;
      var previousKeyDownHandler = void 0;
      var nextKeyDownHandler = void 0;
      var shouldShowPrevious = void 0;
      var shouldShowNext = void 0;

      if (dir === 'rtl') {
        previousClickHandler = this.handleNextClick;
        nextClickHandler = this.handlePreviousClick;
        previousKeyDownHandler = this.handleNextKeyDown;
        nextKeyDownHandler = this.handlePreviousKeyDown;
        shouldShowNext = showPreviousButton;
        shouldShowPrevious = showNextButton;
      } else {
        previousClickHandler = this.handlePreviousClick;
        nextClickHandler = this.handleNextClick;
        previousKeyDownHandler = this.handlePreviousKeyDown;
        nextKeyDownHandler = this.handleNextKeyDown;
        shouldShowNext = showNextButton;
        shouldShowPrevious = showPreviousButton;
      }

      var previousClassName = shouldShowPrevious ? classNames.navButtonPrev : classNames.navButtonPrev + ' ' + classNames.navButtonInteractionDisabled;

      var nextClassName = shouldShowNext ? classNames.navButtonNext : classNames.navButtonNext + ' ' + classNames.navButtonInteractionDisabled;

      var previousButton = _react2.default.createElement('span', {
        tabIndex: '0',
        role: 'button',
        'aria-label': labels.previousMonth,
        key: 'previous',
        className: previousClassName,
        onKeyDown: shouldShowPrevious ? previousKeyDownHandler : undefined,
        onClick: shouldShowPrevious ? previousClickHandler : undefined
      });

      var nextButton = _react2.default.createElement('span', {
        tabIndex: '0',
        role: 'button',
        'aria-label': labels.nextMonth,
        key: 'right',
        className: nextClassName,
        onKeyDown: shouldShowNext ? nextKeyDownHandler : undefined,
        onClick: shouldShowNext ? nextClickHandler : undefined
      });

      return _react2.default.createElement(
        'div',
        { className: className || classNames.navBar },
        dir === 'rtl' ? [nextButton, previousButton] : [previousButton, nextButton]
      );
    }
  }]);

  return Navbar;
}(_react.Component);

Navbar.defaultProps = {
  classNames: _classNames2.default,
  dir: 'ltr',
  labels: {
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month'
  },
  showPreviousButton: true,
  showNextButton: true
};
exports.default = Navbar;
Navbar.propTypes =  false ? {
  classNames: _propTypes2.default.shape({
    navBar: _propTypes2.default.string.isRequired,
    navButtonPrev: _propTypes2.default.string.isRequired,
    navButtonNext: _propTypes2.default.string.isRequired
  }),
  className: _propTypes2.default.string,
  showPreviousButton: _propTypes2.default.bool,
  showNextButton: _propTypes2.default.bool,
  onPreviousClick: _propTypes2.default.func,
  onNextClick: _propTypes2.default.func,
  dir: _propTypes2.default.string,
  labels: _propTypes2.default.shape({
    previousMonth: _propTypes2.default.string.isRequired,
    nextMonth: _propTypes2.default.string.isRequired
  })
} : {};
//# sourceMappingURL=Navbar.js.map

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LEFT = exports.LEFT = 37;
var UP = exports.UP = 38;
var RIGHT = exports.RIGHT = 39;
var DOWN = exports.DOWN = 40;
var ENTER = exports.ENTER = 13;
var SPACE = exports.SPACE = 32;
var ESC = exports.ESC = 27;
//# sourceMappingURL=keys.js.map

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dayMatchesModifier = dayMatchesModifier;
exports.getModifiersForDay = getModifiersForDay;

var _DateUtils = __webpack_require__(101);

var _Helpers = __webpack_require__(147);

/**
 * Return `true` if a date matches the specified modifier.
 * 
 * @export
 * @param {Date} day
 * @param {Any} modifier 
 * @return {Boolean}
 */
function dayMatchesModifier(day, modifier) {
  if (!modifier) {
    return false;
  }
  var arr = Array.isArray(modifier) ? modifier : [modifier];
  return arr.some(function (mod) {
    if (!mod) {
      return false;
    }
    if (mod instanceof Date) {
      return (0, _DateUtils.isSameDay)(day, mod);
    }
    if ((0, _Helpers.isRangeOfDates)(mod)) {
      return (0, _DateUtils.isDayInRange)(day, mod);
    }
    if (mod.after && mod.before && (0, _DateUtils.isDayAfter)(mod.before, mod.after)) {
      return (0, _DateUtils.isDayAfter)(day, mod.after) && (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.after && mod.before && ((0, _DateUtils.isDayAfter)(mod.after, mod.before) || (0, _DateUtils.isSameDay)(mod.after, mod.before))) {
      return (0, _DateUtils.isDayAfter)(day, mod.after) || (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.after) {
      return (0, _DateUtils.isDayAfter)(day, mod.after);
    }
    if (mod.before) {
      return (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.daysOfWeek) {
      return mod.daysOfWeek.some(function (dayOfWeek) {
        return day.getDay() === dayOfWeek;
      });
    }
    if (typeof mod === 'function') {
      return mod(day);
    }
    return false;
  });
}

/**
 * Return the modifiers matching the given day for the given
 * object of modifiers.
 * 
 * @export
 * @param {Date} day
 * @param {Object} [modifiersObj={}] 
 * @return {Array}
 */
function getModifiersForDay(day) {
  var modifiersObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.keys(modifiersObj).reduce(function (modifiers, modifierName) {
    var value = modifiersObj[modifierName];
    if (dayMatchesModifier(day, value)) {
      modifiers.push(modifierName);
    }
    return modifiers;
  }, []);
}

exports.default = { dayMatchesModifier: dayMatchesModifier, getModifiersForDay: getModifiersForDay };
//# sourceMappingURL=ModifiersUtils.js.map

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(24);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Weekday = function (_Component) {
  _inherits(Weekday, _Component);

  function Weekday() {
    _classCallCheck(this, Weekday);

    return _possibleConstructorReturn(this, (Weekday.__proto__ || Object.getPrototypeOf(Weekday)).apply(this, arguments));
  }

  _createClass(Weekday, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props !== nextProps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          weekday = _props.weekday,
          className = _props.className,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          localeUtils = _props.localeUtils,
          locale = _props.locale;

      var title = void 0;
      if (weekdaysLong) {
        title = weekdaysLong[weekday];
      } else {
        title = localeUtils.formatWeekdayLong(weekday, locale);
      }
      var content = void 0;
      if (weekdaysShort) {
        content = weekdaysShort[weekday];
      } else {
        content = localeUtils.formatWeekdayShort(weekday, locale);
      }

      return _react2.default.createElement(
        'div',
        { className: className, role: 'columnheader' },
        _react2.default.createElement(
          'abbr',
          { title: title },
          content
        )
      );
    }
  }]);

  return Weekday;
}(_react.Component);

exports.default = Weekday;
Weekday.propTypes =  false ? {
  weekday: _propTypes2.default.number,
  className: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.object,

  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string)
} : {};
//# sourceMappingURL=Weekday.js.map

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDnd = __webpack_require__(210);

var _reactDndHtml5Backend = __webpack_require__(771);

var _reactDndHtml5Backend2 = _interopRequireDefault(_reactDndHtml5Backend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DragAndDropContent = function (_React$Component) {
  _inherits(DragAndDropContent, _React$Component);

  function DragAndDropContent() {
    _classCallCheck(this, DragAndDropContent);

    return _possibleConstructorReturn(this, (DragAndDropContent.__proto__ || Object.getPrototypeOf(DragAndDropContent)).apply(this, arguments));
  }

  _createClass(DragAndDropContent, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.props.children
      );
    }
  }]);

  return DragAndDropContent;
}(_react2.default.Component);

exports.default = (0, _reactDnd.DragDropContext)(_reactDndHtml5Backend2.default)(DragAndDropContent);

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.unpackBackendForEs5Users = exports.createChildContext = exports.CHILD_CONTEXT_TYPES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = DragDropContext;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(24);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dndCore = __webpack_require__(684);

var _invariant = __webpack_require__(37);

var _invariant2 = _interopRequireDefault(_invariant);

var _hoistNonReactStatics = __webpack_require__(220);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _checkDecoratorArguments = __webpack_require__(156);

var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CHILD_CONTEXT_TYPES = exports.CHILD_CONTEXT_TYPES = {
	dragDropManager: _propTypes2.default.object.isRequired
};

var createChildContext = exports.createChildContext = function createChildContext(backend, context) {
	return {
		dragDropManager: new _dndCore.DragDropManager(backend, context)
	};
};

var unpackBackendForEs5Users = exports.unpackBackendForEs5Users = function unpackBackendForEs5Users(backendOrModule) {
	// Auto-detect ES6 default export for people still using ES5
	var backend = backendOrModule;
	if ((typeof backend === 'undefined' ? 'undefined' : _typeof(backend)) === 'object' && typeof backend.default === 'function') {
		backend = backend.default;
	}
	(0, _invariant2.default)(typeof backend === 'function', 'Expected the backend to be a function or an ES6 module exporting a default function. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-drop-context.html');
	return backend;
};

function DragDropContext(backendOrModule) {
	_checkDecoratorArguments2.default.apply(undefined, ['DragDropContext', 'backend'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params

	var backend = unpackBackendForEs5Users(backendOrModule);
	var childContext = createChildContext(backend);

	return function decorateContext(DecoratedComponent) {
		var _class, _temp;

		var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';

		var DragDropContextContainer = (_temp = _class = function (_Component) {
			_inherits(DragDropContextContainer, _Component);

			function DragDropContextContainer() {
				_classCallCheck(this, DragDropContextContainer);

				return _possibleConstructorReturn(this, (DragDropContextContainer.__proto__ || Object.getPrototypeOf(DragDropContextContainer)).apply(this, arguments));
			}

			_createClass(DragDropContextContainer, [{
				key: 'getDecoratedComponentInstance',
				value: function getDecoratedComponentInstance() {
					(0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can not be a stateless component.');
					return this.child;
				}
			}, {
				key: 'getManager',
				value: function getManager() {
					return childContext.dragDropManager;
				}
			}, {
				key: 'getChildContext',
				value: function getChildContext() {
					return childContext;
				}
			}, {
				key: 'render',
				value: function render() {
					var _this2 = this;

					return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, {
						ref: function ref(child) {
							_this2.child = child;
						}
					}));
				}
			}]);

			return DragDropContextContainer;
		}(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragDropContext(' + displayName + ')', _class.childContextTypes = CHILD_CONTEXT_TYPES, _temp);


		return (0, _hoistNonReactStatics2.default)(DragDropContextContainer, DecoratedComponent);
	};
}

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = dragOffset;
exports.getSourceClientOffset = getSourceClientOffset;
exports.getDifferenceFromInitialOffset = getDifferenceFromInitialOffset;

var _dragDrop = __webpack_require__(149);

var initialState = {
	initialSourceClientOffset: null,
	initialClientOffset: null,
	clientOffset: null
};

function areOffsetsEqual(offsetA, offsetB) {
	if (offsetA === offsetB) {
		return true;
	}
	return offsetA && offsetB && offsetA.x === offsetB.x && offsetA.y === offsetB.y;
}

function dragOffset() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case _dragDrop.BEGIN_DRAG:
			return {
				initialSourceClientOffset: action.sourceClientOffset,
				initialClientOffset: action.clientOffset,
				clientOffset: action.clientOffset
			};
		case _dragDrop.HOVER:
			if (areOffsetsEqual(state.clientOffset, action.clientOffset)) {
				return state;
			}
			return _extends({}, state, {
				clientOffset: action.clientOffset
			});
		case _dragDrop.END_DRAG:
		case _dragDrop.DROP:
			return initialState;
		default:
			return state;
	}
}

function getSourceClientOffset(state) {
	var clientOffset = state.clientOffset,
	    initialClientOffset = state.initialClientOffset,
	    initialSourceClientOffset = state.initialSourceClientOffset;

	if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
		return null;
	}
	return {
		x: clientOffset.x + initialSourceClientOffset.x - initialClientOffset.x,
		y: clientOffset.y + initialSourceClientOffset.y - initialClientOffset.y
	};
}

function getDifferenceFromInitialOffset(state) {
	var clientOffset = state.clientOffset,
	    initialClientOffset = state.initialClientOffset;

	if (!clientOffset || !initialClientOffset) {
		return null;
	}
	return {
		x: clientOffset.x - initialClientOffset.x,
		y: clientOffset.y - initialClientOffset.y
	};
}

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = matchesType;

var _isArray = __webpack_require__(87);

var _isArray2 = _interopRequireDefault(_isArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function matchesType(targetType, draggedItemType) {
	if ((0, _isArray2.default)(targetType)) {
		return targetType.some(function (t) {
			return t === draggedItemType;
		});
	} else {
		return targetType === draggedItemType;
	}
}

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(320),
    baseRest = __webpack_require__(119),
    isArrayLikeObject = __webpack_require__(154);

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, values)
    : [];
});

module.exports = without;


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(212),
    arrayIncludes = __webpack_require__(214),
    arrayIncludesWith = __webpack_require__(215),
    arrayMap = __webpack_require__(216),
    baseUnary = __webpack_require__(217),
    cacheHas = __webpack_require__(218);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(696),
    mapCacheDelete = __webpack_require__(715),
    mapCacheGet = __webpack_require__(717),
    mapCacheHas = __webpack_require__(718),
    mapCacheSet = __webpack_require__(719);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(148),
    isObject = __webpack_require__(118);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 323 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 324 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = dirtyHandlerIds;
exports.areDirty = areDirty;

var _xor = __webpack_require__(734);

var _xor2 = _interopRequireDefault(_xor);

var _intersection = __webpack_require__(742);

var _intersection2 = _interopRequireDefault(_intersection);

var _dragDrop = __webpack_require__(149);

var _registry = __webpack_require__(155);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NONE = [];
var ALL = [];

function dirtyHandlerIds() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NONE;
	var action = arguments[1];
	var dragOperation = arguments[2];

	switch (action.type) {
		case _dragDrop.HOVER:
			break;
		case _registry.ADD_SOURCE:
		case _registry.ADD_TARGET:
		case _registry.REMOVE_TARGET:
		case _registry.REMOVE_SOURCE:
			return NONE;
		case _dragDrop.BEGIN_DRAG:
		case _dragDrop.PUBLISH_DRAG_SOURCE:
		case _dragDrop.END_DRAG:
		case _dragDrop.DROP:
		default:
			return ALL;
	}

	var targetIds = action.targetIds;
	var prevTargetIds = dragOperation.targetIds;

	var result = (0, _xor2.default)(targetIds, prevTargetIds);

	var didChange = false;
	if (result.length === 0) {
		for (var i = 0; i < targetIds.length; i++) {
			if (targetIds[i] !== prevTargetIds[i]) {
				didChange = true;
				break;
			}
		}
	} else {
		didChange = true;
	}

	if (!didChange) {
		return NONE;
	}

	var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
	var innermostTargetId = targetIds[targetIds.length - 1];

	if (prevInnermostTargetId !== innermostTargetId) {
		if (prevInnermostTargetId) {
			result.push(prevInnermostTargetId);
		}
		if (innermostTargetId) {
			result.push(innermostTargetId);
		}
	}

	return result;
}

function areDirty(state, handlerIds) {
	if (state === NONE) {
		return false;
	}

	if (state === ALL || typeof handlerIds === 'undefined') {
		return true;
	}

	return (0, _intersection2.default)(handlerIds, state).length > 0;
}

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(737),
    isFlattenable = __webpack_require__(738);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(739),
    isObjectLike = __webpack_require__(117);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(212),
    arrayIncludes = __webpack_require__(214),
    arrayIncludesWith = __webpack_require__(215),
    cacheHas = __webpack_require__(218),
    createSet = __webpack_require__(740),
    setToArray = __webpack_require__(330);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 329 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 330 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = shallowEqualScalar;
function shallowEqualScalar(objA, objB) {
	if (objA === objB) {
		return true;
	}

	if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
		return false;
	}

	var keysA = Object.keys(objA);
	var keysB = Object.keys(objB);

	if (keysA.length !== keysB.length) {
		return false;
	}

	// Test for A's keys different from B.
	var hasOwn = Object.prototype.hasOwnProperty;
	for (var i = 0; i < keysA.length; i += 1) {
		if (!hasOwn.call(objB, keysA[i])) {
			return false;
		}

		var valA = objA[keysA[i]];
		var valB = objB[keysA[i]];

		if (valA !== valB || (typeof valA === 'undefined' ? 'undefined' : _typeof(valA)) === 'object' || (typeof valB === 'undefined' ? 'undefined' : _typeof(valB)) === 'object') {
			return false;
		}
	}

	return true;
}

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = decorateHandler;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(24);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _disposables = __webpack_require__(757);

var _isPlainObject = __webpack_require__(86);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _invariant = __webpack_require__(37);

var _invariant2 = _interopRequireDefault(_invariant);

var _hoistNonReactStatics = __webpack_require__(220);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _shallowEqual = __webpack_require__(221);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _shallowEqualScalar = __webpack_require__(331);

var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isClassComponent = function isClassComponent(Comp) {
	return Boolean(Comp && Comp.prototype && typeof Comp.prototype.render === 'function');
};

function decorateHandler(_ref) {
	var _class, _temp;

	var DecoratedComponent = _ref.DecoratedComponent,
	    createHandler = _ref.createHandler,
	    createMonitor = _ref.createMonitor,
	    createConnector = _ref.createConnector,
	    registerHandler = _ref.registerHandler,
	    containerDisplayName = _ref.containerDisplayName,
	    getType = _ref.getType,
	    collect = _ref.collect,
	    options = _ref.options;
	var _options$arePropsEqua = options.arePropsEqual,
	    arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;

	var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';

	var DragDropContainer = (_temp = _class = function (_Component) {
		_inherits(DragDropContainer, _Component);

		_createClass(DragDropContainer, [{
			key: 'getHandlerId',
			value: function getHandlerId() {
				return this.handlerId;
			}
		}, {
			key: 'getDecoratedComponentInstance',
			value: function getDecoratedComponentInstance() {
				return this.decoratedComponentInstance;
			}
		}, {
			key: 'shouldComponentUpdate',
			value: function shouldComponentUpdate(nextProps, nextState) {
				return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
			}
		}]);

		function DragDropContainer(props, context) {
			_classCallCheck(this, DragDropContainer);

			var _this = _possibleConstructorReturn(this, (DragDropContainer.__proto__ || Object.getPrototypeOf(DragDropContainer)).call(this, props, context));

			_this.handleChange = _this.handleChange.bind(_this);
			_this.handleChildRef = _this.handleChildRef.bind(_this);

			(0, _invariant2.default)(_typeof(_this.context.dragDropManager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);

			_this.manager = _this.context.dragDropManager;
			_this.handlerMonitor = createMonitor(_this.manager);
			_this.handlerConnector = createConnector(_this.manager.getBackend());
			_this.handler = createHandler(_this.handlerMonitor);

			_this.disposable = new _disposables.SerialDisposable();
			_this.receiveProps(props);
			_this.state = _this.getCurrentState();
			_this.dispose();
			return _this;
		}

		_createClass(DragDropContainer, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.isCurrentlyMounted = true;
				this.disposable = new _disposables.SerialDisposable();
				this.currentType = null;
				this.receiveProps(this.props);
				this.handleChange();
			}
		}, {
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(nextProps) {
				if (!arePropsEqual(nextProps, this.props)) {
					this.receiveProps(nextProps);
					this.handleChange();
				}
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				this.dispose();
				this.isCurrentlyMounted = false;
			}
		}, {
			key: 'receiveProps',
			value: function receiveProps(props) {
				this.handler.receiveProps(props);
				this.receiveType(getType(props));
			}
		}, {
			key: 'receiveType',
			value: function receiveType(type) {
				if (type === this.currentType) {
					return;
				}

				this.currentType = type;

				var _registerHandler = registerHandler(type, this.handler, this.manager),
				    handlerId = _registerHandler.handlerId,
				    unregister = _registerHandler.unregister;

				this.handlerId = handlerId;
				this.handlerMonitor.receiveHandlerId(handlerId);
				this.handlerConnector.receiveHandlerId(handlerId);

				var globalMonitor = this.manager.getMonitor();
				var unsubscribe = globalMonitor.subscribeToStateChange(this.handleChange, { handlerIds: [handlerId] });

				this.disposable.setDisposable(new _disposables.CompositeDisposable(new _disposables.Disposable(unsubscribe), new _disposables.Disposable(unregister)));
			}
		}, {
			key: 'handleChange',
			value: function handleChange() {
				if (!this.isCurrentlyMounted) {
					return;
				}

				var nextState = this.getCurrentState();
				if (!(0, _shallowEqual2.default)(nextState, this.state)) {
					this.setState(nextState);
				}
			}
		}, {
			key: 'dispose',
			value: function dispose() {
				this.disposable.dispose();
				this.handlerConnector.receiveHandlerId(null);
			}
		}, {
			key: 'handleChildRef',
			value: function handleChildRef(component) {
				this.decoratedComponentInstance = component;
				this.handler.receiveComponent(component);
			}
		}, {
			key: 'getCurrentState',
			value: function getCurrentState() {
				var nextState = collect(this.handlerConnector.hooks, this.handlerMonitor);

				if (false) {
					(0, _invariant2.default)((0, _isPlainObject2.default)(nextState), 'Expected `collect` specified as the second argument to ' + '%s for %s to return a plain object of props to inject. ' + 'Instead, received %s.', containerDisplayName, displayName, nextState);
				}

				return nextState;
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
					ref: isClassComponent(DecoratedComponent) ? this.handleChildRef : null
				}));
			}
		}]);

		return DragDropContainer;
	}(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = containerDisplayName + '(' + displayName + ')', _class.contextTypes = {
		dragDropManager: _propTypes2.default.object.isRequired
	}, _temp);


	return (0, _hoistNonReactStatics2.default)(DragDropContainer, DecoratedComponent);
}

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = wrapConnectorHooks;

var _react = __webpack_require__(1);

var _cloneWithRef = __webpack_require__(765);

var _cloneWithRef2 = _interopRequireDefault(_cloneWithRef);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function throwIfCompositeComponentElement(element) {
	// Custom components can no longer be wrapped directly in React DnD 2.0
	// so that we don't need to depend on findDOMNode() from react-dom.
	if (typeof element.type === 'string') {
		return;
	}

	var displayName = element.type.displayName || element.type.name || 'the component';

	throw new Error('Only native element nodes can now be passed to React DnD connectors.' + ('You can either wrap ' + displayName + ' into a <div>, or turn it into a ') + 'drag source or a drop target itself.');
}

function wrapHookToRecognizeElement(hook) {
	return function () {
		var elementOrNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		// When passed a node, call the hook straight away.
		if (!(0, _react.isValidElement)(elementOrNode)) {
			var node = elementOrNode;
			hook(node, options);
			return undefined;
		}

		// If passed a ReactElement, clone it and attach this function as a ref.
		// This helps us achieve a neat API where user doesn't even know that refs
		// are being used under the hood.
		var element = elementOrNode;
		throwIfCompositeComponentElement(element);

		// When no options are passed, use the hook directly
		var ref = options ? function (node) {
			return hook(node, options);
		} : hook;

		return (0, _cloneWithRef2.default)(element, ref);
	};
}

function wrapConnectorHooks(hooks) {
	var wrappedHooks = {};

	Object.keys(hooks).forEach(function (key) {
		var hook = hooks[key];
		var wrappedHook = wrapHookToRecognizeElement(hook);
		wrappedHooks[key] = function () {
			return wrappedHook;
		};
	});

	return wrappedHooks;
}

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = areOptionsEqual;

var _shallowEqual = __webpack_require__(221);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function areOptionsEqual(nextOptions, currentOptions) {
	if (currentOptions === nextOptions) {
		return true;
	}

	return currentOptions !== null && nextOptions !== null && (0, _shallowEqual2.default)(currentOptions, nextOptions);
}

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = isValidType;

var _isArray = __webpack_require__(87);

var _isArray2 = _interopRequireDefault(_isArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isValidType(type, allowArray) {
	return typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol' || allowArray && (0, _isArray2.default)(type) && type.every(function (t) {
		return isValidType(t, false);
	});
}

/***/ }),
/* 336 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 337 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSafari = exports.isFirefox = undefined;

var _memoize = __webpack_require__(789);

var _memoize2 = _interopRequireDefault(_memoize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isFirefox = exports.isFirefox = (0, _memoize2.default)(function () {
  return (/firefox/i.test(navigator.userAgent)
  );
});
var isSafari = exports.isSafari = (0, _memoize2.default)(function () {
  return Boolean(window.safari);
});

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDnd = __webpack_require__(210);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DragAndDropTarget = function (_React$Component) {
  _inherits(DragAndDropTarget, _React$Component);

  function DragAndDropTarget() {
    _classCallCheck(this, DragAndDropTarget);

    return _possibleConstructorReturn(this, (DragAndDropTarget.__proto__ || Object.getPrototypeOf(DragAndDropTarget)).apply(this, arguments));
  }

  _createClass(DragAndDropTarget, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          connectDropTarget = _props.connectDropTarget,
          isOver = _props.isOver;

      return connectDropTarget(_react2.default.createElement(
        'div',
        { style: { backgroundColor: isOver ? "grey" : undefined } },
        this.props.children
      ));
    }
  }]);

  return DragAndDropTarget;
}(_react2.default.Component);

var prioritizedTarget = {
  drop: function drop(props) {
    return { position: props.position };
  }
};

function collect(connect, monitor) {
  return {
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
  };
}

exports.default = (0, _reactDnd.DropTarget)('project', prioritizedTarget, collect)(DragAndDropTarget);

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(24);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDnd = __webpack_require__(210);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DragAndDropSource = function (_React$Component) {
  _inherits(DragAndDropSource, _React$Component);

  function DragAndDropSource() {
    _classCallCheck(this, DragAndDropSource);

    return _possibleConstructorReturn(this, (DragAndDropSource.__proto__ || Object.getPrototypeOf(DragAndDropSource)).apply(this, arguments));
  }

  _createClass(DragAndDropSource, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          connectDragSource = _props.connectDragSource,
          isDragging = _props.isDragging;

      return connectDragSource(_react2.default.createElement(
        'div',
        { style: { opacity: isDragging ? 0.5 : 1.0, color: isDragging ? "red" : "black" } },
        this.props.children
      ));
    }
  }]);

  return DragAndDropSource;
}(_react2.default.Component);

DragAndDropSource.propTypes = {
  connectDragSource: _propTypes2.default.func.isRequired,
  isDragging: _propTypes2.default.bool.isRequired
};

var projectSource = {
  beginDrag: function beginDrag(props) {
    // Return the data describing the dragged item
    var item = { id: props.id, position: props.position };
    return item;
  },
  endDrag: function endDrag(props, monitor, component) {
    if (!monitor.didDrop()) {
      return;
    }

    // When dropped on a compatible target, do something
    var item = monitor.getItem();
    var dropResult = monitor.getDropResult();
    props.prioritize(item, dropResult);
  }
};

function collect(connect, monitor) {
  return {
    // Call this function inside render()
    // to let React DnD handle the drag events:
    connectDragSource: connect.dragSource(),
    // You can ask the monitor about the current drag state:
    isDragging: monitor.isDragging()
  };
}

exports.default = (0, _reactDnd.DragSource)('project', projectSource, collect)(DragAndDropSource);

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var ContentBlockNode = __webpack_require__(44);

var generateRandomKey = __webpack_require__(57);

var Immutable = __webpack_require__(4);

var OrderedMap = Immutable.OrderedMap;

var randomizeContentBlockNodeKeys = function randomizeContentBlockNodeKeys(blockMap) {
  var newKeysRef = {}; // we keep track of root blocks in order to update subsequent sibling links

  var lastRootBlock;
  return OrderedMap(blockMap.withMutations(function (blockMapState) {
    blockMapState.forEach(function (block, index) {
      var oldKey = block.getKey();
      var nextKey = block.getNextSiblingKey();
      var prevKey = block.getPrevSiblingKey();
      var childrenKeys = block.getChildKeys();
      var parentKey = block.getParentKey(); // new key that we will use to build linking

      var key = generateRandomKey(); // we will add it here to re-use it later

      newKeysRef[oldKey] = key;

      if (nextKey) {
        var nextBlock = blockMapState.get(nextKey);

        if (nextBlock) {
          blockMapState.setIn([nextKey, 'prevSibling'], key);
        } else {
          // this can happen when generating random keys for fragments
          blockMapState.setIn([oldKey, 'nextSibling'], null);
        }
      }

      if (prevKey) {
        var prevBlock = blockMapState.get(prevKey);

        if (prevBlock) {
          blockMapState.setIn([prevKey, 'nextSibling'], key);
        } else {
          // this can happen when generating random keys for fragments
          blockMapState.setIn([oldKey, 'prevSibling'], null);
        }
      }

      if (parentKey && blockMapState.get(parentKey)) {
        var parentBlock = blockMapState.get(parentKey);
        var parentChildrenList = parentBlock.getChildKeys();
        blockMapState.setIn([parentKey, 'children'], parentChildrenList.set(parentChildrenList.indexOf(block.getKey()), key));
      } else {
        // blocks will then be treated as root block nodes
        blockMapState.setIn([oldKey, 'parent'], null);

        if (lastRootBlock) {
          blockMapState.setIn([lastRootBlock.getKey(), 'nextSibling'], key);
          blockMapState.setIn([oldKey, 'prevSibling'], newKeysRef[lastRootBlock.getKey()]);
        }

        lastRootBlock = blockMapState.get(oldKey);
      }

      childrenKeys.forEach(function (childKey) {
        var childBlock = blockMapState.get(childKey);

        if (childBlock) {
          blockMapState.setIn([childKey, 'parent'], key);
        } else {
          blockMapState.setIn([oldKey, 'children'], block.getChildKeys().filter(function (child) {
            return child !== childKey;
          }));
        }
      });
    });
  }).toArray().map(function (block) {
    return [newKeysRef[block.getKey()], block.set('key', newKeysRef[block.getKey()])];
  }));
};

var randomizeContentBlockKeys = function randomizeContentBlockKeys(blockMap) {
  return OrderedMap(blockMap.toArray().map(function (block) {
    var key = generateRandomKey();
    return [key, block.set('key', key)];
  }));
};

var randomizeBlockMapKeys = function randomizeBlockMapKeys(blockMap) {
  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;

  if (!isTreeBasedBlockMap) {
    return randomizeContentBlockKeys(blockMap);
  }

  return randomizeContentBlockNodeKeys(blockMap);
};

module.exports = randomizeBlockMapKeys;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var CharacterMetadata = __webpack_require__(43);

var findRangesImmutable = __webpack_require__(121);

var invariant = __webpack_require__(9);

function removeEntitiesAtEdges(contentState, selectionState) {
  var blockMap = contentState.getBlockMap();
  var entityMap = contentState.getEntityMap();
  var updatedBlocks = {};
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var startBlock = blockMap.get(startKey);
  var updatedStart = removeForBlock(entityMap, startBlock, startOffset);

  if (updatedStart !== startBlock) {
    updatedBlocks[startKey] = updatedStart;
  }

  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var endBlock = blockMap.get(endKey);

  if (startKey === endKey) {
    endBlock = updatedStart;
  }

  var updatedEnd = removeForBlock(entityMap, endBlock, endOffset);

  if (updatedEnd !== endBlock) {
    updatedBlocks[endKey] = updatedEnd;
  }

  if (!Object.keys(updatedBlocks).length) {
    return contentState.set('selectionAfter', selectionState);
  }

  return contentState.merge({
    blockMap: blockMap.merge(updatedBlocks),
    selectionAfter: selectionState
  });
}
/**
 * Given a list of characters and an offset that is in the middle of an entity,
 * returns the start and end of the entity that is overlapping the offset.
 * Note: This method requires that the offset be in an entity range.
 */


function getRemovalRange(characters, entityKey, offset) {
  var removalRange; // Iterates through a list looking for ranges of matching items
  // based on the 'isEqual' callback.
  // Then instead of returning the result, call the 'found' callback
  // with each range.
  // Then filters those ranges based on the 'filter' callback
  //
  // Here we use it to find ranges of characters with the same entity key.

  findRangesImmutable(characters, // the list to iterate through
  function (a, b) {
    return a.getEntity() === b.getEntity();
  }, // 'isEqual' callback
  function (element) {
    return element.getEntity() === entityKey;
  }, // 'filter' callback
  function (start, end) {
    // 'found' callback
    if (start <= offset && end >= offset) {
      // this entity overlaps the offset index
      removalRange = {
        start: start,
        end: end
      };
    }
  });
  !(typeof removalRange === 'object') ?  false ? invariant(false, 'Removal range must exist within character list.') : invariant(false) : void 0;
  return removalRange;
}

function removeForBlock(entityMap, block, offset) {
  var chars = block.getCharacterList();
  var charBefore = offset > 0 ? chars.get(offset - 1) : undefined;
  var charAfter = offset < chars.count() ? chars.get(offset) : undefined;
  var entityBeforeCursor = charBefore ? charBefore.getEntity() : undefined;
  var entityAfterCursor = charAfter ? charAfter.getEntity() : undefined;

  if (entityAfterCursor && entityAfterCursor === entityBeforeCursor) {
    var entity = entityMap.__get(entityAfterCursor);

    if (entity.getMutability() !== 'MUTABLE') {
      var _getRemovalRange = getRemovalRange(chars, entityAfterCursor, offset),
          start = _getRemovalRange.start,
          end = _getRemovalRange.end;

      var current;

      while (start < end) {
        current = chars.get(start);
        chars = chars.set(start, CharacterMetadata.applyEntity(current, null));
        start++;
      }

      return block.set('characterList', chars);
    }
  }

  return block;
}

module.exports = removeEntitiesAtEdges;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


/**
 * Maintain persistence for target list when appending and prepending.
 */
function insertIntoList(targetListArg, toInsert, offset) {
  var targetList = targetListArg;

  if (offset === targetList.count()) {
    toInsert.forEach(function (c) {
      targetList = targetList.push(c);
    });
  } else if (offset === 0) {
    toInsert.reverse().forEach(function (c) {
      targetList = targetList.unshift(c);
    });
  } else {
    var head = targetList.slice(0, offset);
    var tail = targetList.slice(offset);
    targetList = head.concat(toInsert, tail).toList();
  }

  return targetList;
}

module.exports = insertIntoList;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var Immutable = __webpack_require__(4);

var Map = Immutable.Map;

function modifyBlockForContentState(contentState, selectionState, operation) {
  var startKey = selectionState.getStartKey();
  var endKey = selectionState.getEndKey();
  var blockMap = contentState.getBlockMap();
  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(operation);
  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = modifyBlockForContentState;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */
var ContentBlockNode = __webpack_require__(44);

var getNextDelimiterBlockKey = function getNextDelimiterBlockKey(block, blockMap) {
  var isExperimentalTreeBlock = block instanceof ContentBlockNode;

  if (!isExperimentalTreeBlock) {
    return null;
  }

  var nextSiblingKey = block.getNextSiblingKey();

  if (nextSiblingKey) {
    return nextSiblingKey;
  }

  var parent = block.getParentKey();

  if (!parent) {
    return null;
  }

  var nextNonDescendantBlock = blockMap.get(parent);

  while (nextNonDescendantBlock && !nextNonDescendantBlock.getNextSiblingKey()) {
    var parentKey = nextNonDescendantBlock.getParentKey();
    nextNonDescendantBlock = parentKey ? blockMap.get(parentKey) : null;
  }

  if (!nextNonDescendantBlock) {
    return null;
  }

  return nextNonDescendantBlock.getNextSiblingKey();
};

module.exports = getNextDelimiterBlockKey;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * 
 * @typechecks
 * @format
 */

/**
 * Retrieve an object's own values as an array. If you want the values in the
 * protoype chain, too, use getObjectValuesIncludingPrototype.
 *
 * If you are looking for a function that creates an Array instance based
 * on an "Array-like" object, use createArrayFrom instead.
 *
 * @param {object} obj An object.
 * @return {array}     The object's values.
 */
function getOwnObjectValues(obj) {
  return Object.keys(obj).map(function (key) {
    return obj[key];
  });
}

module.exports = getOwnObjectValues;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @legacyServerCallableInstance
 * @format
 * 
 * @emails oncall+draft_js
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Immutable = __webpack_require__(4);

var Record = Immutable.Record;
var DraftEntityInstanceRecord = Record({
  type: 'TOKEN',
  mutability: 'IMMUTABLE',
  data: Object
});
/**
 * An instance of a document entity, consisting of a `type` and relevant
 * `data`, metadata about the entity.
 *
 * For instance, a "link" entity might provide a URI, and a "mention"
 * entity might provide the mentioned user's ID. These pieces of data
 * may be used when rendering the entity as part of a ContentBlock DOM
 * representation. For a link, the data would be used as an href for
 * the rendered anchor. For a mention, the ID could be used to retrieve
 * a hovercard.
 */

var DraftEntityInstance = /*#__PURE__*/function (_DraftEntityInstanceR) {
  _inheritsLoose(DraftEntityInstance, _DraftEntityInstanceR);

  function DraftEntityInstance() {
    return _DraftEntityInstanceR.apply(this, arguments) || this;
  }

  var _proto = DraftEntityInstance.prototype;

  _proto.getType = function getType() {
    return this.get('type');
  };

  _proto.getMutability = function getMutability() {
    return this.get('mutability');
  };

  _proto.getData = function getData() {
    return this.get('data');
  };

  return DraftEntityInstance;
}(DraftEntityInstanceRecord);

module.exports = DraftEntityInstance;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var REGEX_BLOCK_DELIMITER = new RegExp('\r', 'g');

function sanitizeDraftText(input) {
  return input.replace(REGEX_BLOCK_DELIMITER, '');
}

module.exports = sanitizeDraftText;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


module.exports = {
  BOLD: {
    fontWeight: 'bold'
  },
  CODE: {
    fontFamily: 'monospace',
    wordWrap: 'break-word'
  },
  ITALIC: {
    fontStyle: 'italic'
  },
  STRIKETHROUGH: {
    textDecoration: 'line-through'
  },
  UNDERLINE: {
    textDecoration: 'underline'
  }
};

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

/**
 * Get offset key from a node or it's child nodes. Return the first offset key
 * found on the DOM tree of given node.
 */

var isElement = __webpack_require__(90);

function getSelectionOffsetKeyForNode(node) {
  if (isElement(node)) {
    var castedNode = node;
    var offsetKey = castedNode.getAttribute('data-offset-key');

    if (offsetKey) {
      return offsetKey;
    }

    for (var ii = 0; ii < castedNode.childNodes.length; ii++) {
      var childOffsetKey = getSelectionOffsetKeyForNode(castedNode.childNodes[ii]);

      if (childOffsetKey) {
        return childOffsetKey;
      }
    }
  }

  return null;
}

module.exports = getSelectionOffsetKeyForNode;

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
function getWindowForNode(node) {
  if (!node || !node.ownerDocument || !node.ownerDocument.defaultView) {
    return window;
  }

  return node.ownerDocument.defaultView;
}

module.exports = getWindowForNode;

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftJsDebugLogging = __webpack_require__(353);

var EditorState = __webpack_require__(13);

var getContentEditableContainer = __webpack_require__(354);

var getDraftEditorSelection = __webpack_require__(355);

function editOnSelect(editor) {
  if (editor._blockSelectEvents || editor._latestEditorState !== editor.props.editorState) {
    if (editor._blockSelectEvents) {
      var _editorState = editor.props.editorState;

      var selectionState = _editorState.getSelection();

      DraftJsDebugLogging.logBlockedSelectionEvent({
        // For now I don't think we need any other info
        anonymizedDom: 'N/A',
        extraParams: JSON.stringify({
          stacktrace: new Error().stack
        }),
        selectionState: JSON.stringify(selectionState.toJS())
      });
    }

    return;
  }

  var editorState = editor.props.editorState;
  var documentSelection = getDraftEditorSelection(editorState, getContentEditableContainer(editor));
  var updatedSelectionState = documentSelection.selectionState;

  if (updatedSelectionState !== editorState.getSelection()) {
    if (documentSelection.needsRecovery) {
      editorState = EditorState.forceSelection(editorState, updatedSelectionState);
    } else {
      editorState = EditorState.acceptSelection(editorState, updatedSelectionState);
    }

    editor.update(editorState);
  }
}

module.exports = editOnSelect;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


module.exports = {
  logBlockedSelectionEvent: function logBlockedSelectionEvent() {
    return null;
  },
  logSelectionStateFailure: function logSelectionStateFailure() {
    return null;
  }
};

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var invariant = __webpack_require__(9);

var isHTMLElement = __webpack_require__(122);

function getContentEditableContainer(editor) {
  var editorNode = editor.editorContainer;
  !editorNode ?  false ? invariant(false, 'Missing editorNode') : invariant(false) : void 0;
  !isHTMLElement(editorNode.firstChild) ?  false ? invariant(false, 'editorNode.firstChild is not an HTMLElement') : invariant(false) : void 0;
  var htmlElement = editorNode.firstChild;
  return htmlElement;
}

module.exports = getContentEditableContainer;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var getDraftEditorSelectionWithNodes = __webpack_require__(356);
/**
 * Convert the current selection range to an anchor/focus pair of offset keys
 * and values that can be interpreted by components.
 */


function getDraftEditorSelection(editorState, root) {
  var selection = root.ownerDocument.defaultView.getSelection();
  var anchorNode = selection.anchorNode,
      anchorOffset = selection.anchorOffset,
      focusNode = selection.focusNode,
      focusOffset = selection.focusOffset,
      rangeCount = selection.rangeCount;

  if ( // No active selection.
  rangeCount === 0 || // No selection, ever. As in, the user hasn't selected anything since
  // opening the document.
  anchorNode == null || focusNode == null) {
    return {
      selectionState: editorState.getSelection().set('hasFocus', false),
      needsRecovery: false
    };
  }

  return getDraftEditorSelectionWithNodes(editorState, root, anchorNode, anchorOffset, focusNode, focusOffset);
}

module.exports = getDraftEditorSelection;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var findAncestorOffsetKey = __webpack_require__(161);

var getSelectionOffsetKeyForNode = __webpack_require__(350);

var getUpdatedSelectionState = __webpack_require__(357);

var invariant = __webpack_require__(9);

var isElement = __webpack_require__(90);

var nullthrows = __webpack_require__(30);

/**
 * Convert the current selection range to an anchor/focus pair of offset keys
 * and values that can be interpreted by components.
 */
function getDraftEditorSelectionWithNodes(editorState, root, anchorNode, anchorOffset, focusNode, focusOffset) {
  var anchorIsTextNode = anchorNode.nodeType === Node.TEXT_NODE;
  var focusIsTextNode = focusNode.nodeType === Node.TEXT_NODE; // If the selection range lies only on text nodes, the task is simple.
  // Find the nearest offset-aware elements and use the
  // offset values supplied by the selection range.

  if (anchorIsTextNode && focusIsTextNode) {
    return {
      selectionState: getUpdatedSelectionState(editorState, nullthrows(findAncestorOffsetKey(anchorNode)), anchorOffset, nullthrows(findAncestorOffsetKey(focusNode)), focusOffset),
      needsRecovery: false
    };
  }

  var anchorPoint = null;
  var focusPoint = null;
  var needsRecovery = true; // An element is selected. Convert this selection range into leaf offset
  // keys and offset values for consumption at the component level. This
  // is common in Firefox, where select-all and triple click behavior leads
  // to entire elements being selected.
  //
  // Note that we use the `needsRecovery` parameter in the callback here. This
  // is because when certain elements are selected, the behavior for subsequent
  // cursor movement (e.g. via arrow keys) is uncertain and may not match
  // expectations at the component level. For example, if an entire <div> is
  // selected and the user presses the right arrow, Firefox keeps the selection
  // on the <div>. If we allow subsequent keypresses to insert characters
  // natively, they will be inserted into a browser-created text node to the
  // right of that <div>. This is obviously undesirable.
  //
  // With the `needsRecovery` flag, we inform the caller that it is responsible
  // for manually setting the selection state on the rendered document to
  // ensure proper selection state maintenance.

  if (anchorIsTextNode) {
    anchorPoint = {
      key: nullthrows(findAncestorOffsetKey(anchorNode)),
      offset: anchorOffset
    };
    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
  } else if (focusIsTextNode) {
    focusPoint = {
      key: nullthrows(findAncestorOffsetKey(focusNode)),
      offset: focusOffset
    };
    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
  } else {
    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset); // If the selection is collapsed on an empty block, don't force recovery.
    // This way, on arrow key selection changes, the browser can move the
    // cursor from a non-zero offset on one block, through empty blocks,
    // to a matching non-zero offset on other text blocks.

    if (anchorNode === focusNode && anchorOffset === focusOffset) {
      needsRecovery = !!anchorNode.firstChild && anchorNode.firstChild.nodeName !== 'BR';
    }
  }

  return {
    selectionState: getUpdatedSelectionState(editorState, anchorPoint.key, anchorPoint.offset, focusPoint.key, focusPoint.offset),
    needsRecovery: needsRecovery
  };
}
/**
 * Identify the first leaf descendant for the given node.
 */


function getFirstLeaf(node) {
  while (node.firstChild && ( // data-blocks has no offset
  isElement(node.firstChild) && node.firstChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.firstChild))) {
    node = node.firstChild;
  }

  return node;
}
/**
 * Identify the last leaf descendant for the given node.
 */


function getLastLeaf(node) {
  while (node.lastChild && ( // data-blocks has no offset
  isElement(node.lastChild) && node.lastChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.lastChild))) {
    node = node.lastChild;
  }

  return node;
}

function getPointForNonTextNode(editorRoot, startNode, childOffset) {
  var node = startNode;
  var offsetKey = findAncestorOffsetKey(node);
  !(offsetKey != null || editorRoot && (editorRoot === node || editorRoot.firstChild === node)) ?  false ? invariant(false, 'Unknown node in selection range.') : invariant(false) : void 0; // If the editorRoot is the selection, step downward into the content
  // wrapper.

  if (editorRoot === node) {
    node = node.firstChild;
    !isElement(node) ?  false ? invariant(false, 'Invalid DraftEditorContents node.') : invariant(false) : void 0;
    var castedNode = node; // assignment only added for flow :/
    // otherwise it throws in line 200 saying that node can be null or undefined

    node = castedNode;
    !(node.getAttribute('data-contents') === 'true') ?  false ? invariant(false, 'Invalid DraftEditorContents structure.') : invariant(false) : void 0;

    if (childOffset > 0) {
      childOffset = node.childNodes.length;
    }
  } // If the child offset is zero and we have an offset key, we're done.
  // If there's no offset key because the entire editor is selected,
  // find the leftmost ("first") leaf in the tree and use that as the offset
  // key.


  if (childOffset === 0) {
    var key = null;

    if (offsetKey != null) {
      key = offsetKey;
    } else {
      var firstLeaf = getFirstLeaf(node);
      key = nullthrows(getSelectionOffsetKeyForNode(firstLeaf));
    }

    return {
      key: key,
      offset: 0
    };
  }

  var nodeBeforeCursor = node.childNodes[childOffset - 1];
  var leafKey = null;
  var textLength = null;

  if (!getSelectionOffsetKeyForNode(nodeBeforeCursor)) {
    // Our target node may be a leaf or a text node, in which case we're
    // already where we want to be and can just use the child's length as
    // our offset.
    leafKey = nullthrows(offsetKey);
    textLength = getTextContentLength(nodeBeforeCursor);
  } else {
    // Otherwise, we'll look at the child to the left of the cursor and find
    // the last leaf node in its subtree.
    var lastLeaf = getLastLeaf(nodeBeforeCursor);
    leafKey = nullthrows(getSelectionOffsetKeyForNode(lastLeaf));
    textLength = getTextContentLength(lastLeaf);
  }

  return {
    key: leafKey,
    offset: textLength
  };
}
/**
 * Return the length of a node's textContent, regarding single newline
 * characters as zero-length. This allows us to avoid problems with identifying
 * the correct selection offset for empty blocks in IE, in which we
 * render newlines instead of break tags.
 */


function getTextContentLength(node) {
  var textContent = node.textContent;
  return textContent === '\n' ? 0 : textContent.length;
}

module.exports = getDraftEditorSelectionWithNodes;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftOffsetKey = __webpack_require__(64);

var nullthrows = __webpack_require__(30);

function getUpdatedSelectionState(editorState, anchorKey, anchorOffset, focusKey, focusOffset) {
  var selection = nullthrows(editorState.getSelection());

  if (!anchorKey || !focusKey) {
    // If we cannot make sense of the updated selection state, stick to the current one.
    if (false) {
      /* eslint-disable-next-line */
      console.warn('Invalid selection state.', arguments, editorState.toJS());
    }

    return selection;
  }

  var anchorPath = DraftOffsetKey.decode(anchorKey);
  var anchorBlockKey = anchorPath.blockKey;
  var anchorLeafBlockTree = editorState.getBlockTree(anchorBlockKey);
  var anchorLeaf = anchorLeafBlockTree && anchorLeafBlockTree.getIn([anchorPath.decoratorKey, 'leaves', anchorPath.leafKey]);
  var focusPath = DraftOffsetKey.decode(focusKey);
  var focusBlockKey = focusPath.blockKey;
  var focusLeafBlockTree = editorState.getBlockTree(focusBlockKey);
  var focusLeaf = focusLeafBlockTree && focusLeafBlockTree.getIn([focusPath.decoratorKey, 'leaves', focusPath.leafKey]);

  if (!anchorLeaf || !focusLeaf) {
    // If we cannot make sense of the updated selection state, stick to the current one.
    if (false) {
      /* eslint-disable-next-line */
      console.warn('Invalid selection state.', arguments, editorState.toJS());
    }

    return selection;
  }

  var anchorLeafStart = anchorLeaf.get('start');
  var focusLeafStart = focusLeaf.get('start');
  var anchorBlockOffset = anchorLeaf ? anchorLeafStart + anchorOffset : null;
  var focusBlockOffset = focusLeaf ? focusLeafStart + focusOffset : null;
  var areEqual = selection.getAnchorKey() === anchorBlockKey && selection.getAnchorOffset() === anchorBlockOffset && selection.getFocusKey() === focusBlockKey && selection.getFocusOffset() === focusBlockOffset;

  if (areEqual) {
    return selection;
  }

  var isBackward = false;

  if (anchorBlockKey === focusBlockKey) {
    var anchorLeafEnd = anchorLeaf.get('end');
    var focusLeafEnd = focusLeaf.get('end');

    if (focusLeafStart === anchorLeafStart && focusLeafEnd === anchorLeafEnd) {
      isBackward = focusOffset < anchorOffset;
    } else {
      isBackward = focusLeafStart < anchorLeafStart;
    }
  } else {
    var startKey = editorState.getCurrentContent().getBlockMap().keySeq().skipUntil(function (v) {
      return v === anchorBlockKey || v === focusBlockKey;
    }).first();
    isBackward = startKey === focusBlockKey;
  }

  return selection.merge({
    anchorKey: anchorBlockKey,
    anchorOffset: anchorBlockOffset,
    focusKey: focusBlockKey,
    focusOffset: focusBlockOffset,
    isBackward: isBackward
  });
}

module.exports = getUpdatedSelectionState;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Provides utilities for handling draftjs keys.
 *
 * @emails oncall+draft_js
 * 
 * @format
 */


function notEmptyKey(key) {
  return key != null && key != '';
}

module.exports = {
  notEmptyKey: notEmptyKey
};

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var _assign = __webpack_require__(8);

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DraftEditorTextNode = __webpack_require__(834);

var React = __webpack_require__(1);

var invariant = __webpack_require__(9);

var isHTMLBRElement = __webpack_require__(360);

var setDraftEditorSelection = __webpack_require__(835).setDraftEditorSelection;

/**
 * All leaf nodes in the editor are spans with single text nodes. Leaf
 * elements are styled based on the merging of an optional custom style map
 * and a default style map.
 *
 * `DraftEditorLeaf` also provides a wrapper for calling into the imperative
 * DOM Selection API. In this way, top-level components can declaratively
 * maintain the selection state.
 */
var DraftEditorLeaf = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorLeaf, _React$Component);

  function DraftEditorLeaf() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "leaf", void 0);

    return _this;
  }

  var _proto = DraftEditorLeaf.prototype;

  _proto._setSelection = function _setSelection() {
    var selection = this.props.selection; // If selection state is irrelevant to the parent block, no-op.

    if (selection == null || !selection.getHasFocus()) {
      return;
    }

    var _this$props = this.props,
        block = _this$props.block,
        start = _this$props.start,
        text = _this$props.text;
    var blockKey = block.getKey();
    var end = start + text.length;

    if (!selection.hasEdgeWithin(blockKey, start, end)) {
      return;
    } // Determine the appropriate target node for selection. If the child
    // is not a text node, it is a <br /> spacer. In this case, use the
    // <span> itself as the selection target.


    var node = this.leaf;
    !node ?  false ? invariant(false, 'Missing node') : invariant(false) : void 0;
    var child = node.firstChild;
    !child ?  false ? invariant(false, 'Missing child') : invariant(false) : void 0;
    var targetNode;

    if (child.nodeType === Node.TEXT_NODE) {
      targetNode = child;
    } else if (isHTMLBRElement(child)) {
      targetNode = node;
    } else {
      targetNode = child.firstChild;
      !targetNode ?  false ? invariant(false, 'Missing targetNode') : invariant(false) : void 0;
    }

    setDraftEditorSelection(selection, targetNode, blockKey, start, end);
  };

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var leafNode = this.leaf;
    !leafNode ?  false ? invariant(false, 'Missing leafNode') : invariant(false) : void 0;
    var shouldUpdate = leafNode.textContent !== nextProps.text || nextProps.styleSet !== this.props.styleSet || nextProps.forceSelection;
    return shouldUpdate;
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this._setSelection();
  };

  _proto.componentDidMount = function componentDidMount() {
    this._setSelection();
  };

  _proto.render = function render() {
    var _this2 = this;

    var block = this.props.block;
    var text = this.props.text; // If the leaf is at the end of its block and ends in a soft newline, append
    // an extra line feed character. Browsers collapse trailing newline
    // characters, which leaves the cursor in the wrong place after a
    // shift+enter. The extra character repairs this.

    if (text.endsWith('\n') && this.props.isLast) {
      text += '\n';
    }

    var _this$props2 = this.props,
        customStyleMap = _this$props2.customStyleMap,
        customStyleFn = _this$props2.customStyleFn,
        offsetKey = _this$props2.offsetKey,
        styleSet = _this$props2.styleSet;
    var styleObj = styleSet.reduce(function (map, styleName) {
      var mergedStyles = {};
      var style = customStyleMap[styleName];

      if (style !== undefined && map.textDecoration !== style.textDecoration) {
        // .trim() is necessary for IE9/10/11 and Edge
        mergedStyles.textDecoration = [map.textDecoration, style.textDecoration].join(' ').trim();
      }

      return _assign(map, style, mergedStyles);
    }, {});

    if (customStyleFn) {
      var newStyles = customStyleFn(styleSet, block);
      styleObj = _assign(styleObj, newStyles);
    }

    return React.createElement("span", {
      "data-offset-key": offsetKey,
      ref: function ref(_ref) {
        return _this2.leaf = _ref;
      },
      style: styleObj
    }, React.createElement(DraftEditorTextNode, null, text));
  };

  return DraftEditorLeaf;
}(React.Component);

module.exports = DraftEditorLeaf;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
var isElement = __webpack_require__(90);

function isHTMLBRElement(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }

  return isElement(node) && node.nodeName === 'BR';
}

module.exports = isHTMLBRElement;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


module.exports = {
  initODS: function initODS() {},
  handleExtensionCausedError: function handleExtensionCausedError() {}
};

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc)
/*?DOMElement*/
{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);

  if (typeof doc === 'undefined') {
    return null;
  }

  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var getElementRect = __webpack_require__(841);
/**
 * Gets an element's position in pixels relative to the viewport. The returned
 * object represents the position of the element's top left corner.
 *
 * @param {DOMElement} element
 * @return {object}
 */


function getElementPosition(element) {
  var rect = getElementRect(element);
  return {
    x: rect.left,
    y: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };
}

module.exports = getElementPosition;

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks
 */
function getViewportWidth() {
  var width;

  if (document.documentElement) {
    width = document.documentElement.clientWidth;
  }

  if (!width && document.body) {
    width = document.body.clientWidth;
  }

  return width || 0;
}

function getViewportHeight() {
  var height;

  if (document.documentElement) {
    height = document.documentElement.clientHeight;
  }

  if (!height && document.body) {
    height = document.body.clientHeight;
  }

  return height || 0;
}
/**
 * Gets the viewport dimensions including any scrollbars.
 */


function getViewportDimensions() {
  return {
    width: window.innerWidth || getViewportWidth(),
    height: window.innerHeight || getViewportHeight()
  };
}
/**
 * Gets the viewport dimensions excluding any scrollbars.
 */


getViewportDimensions.withoutScrollbars = function () {
  return {
    width: getViewportWidth(),
    height: getViewportHeight()
  };
};

module.exports = getViewportDimensions;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var _assign = __webpack_require__(8);

function _extends() { _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DraftEditorLeaf = __webpack_require__(359);

var DraftOffsetKey = __webpack_require__(64);

var React = __webpack_require__(1);

var Scroll = __webpack_require__(230);

var Style = __webpack_require__(164);

var UnicodeBidi = __webpack_require__(226);

var UnicodeBidiDirection = __webpack_require__(160);

var cx = __webpack_require__(89);

var getElementPosition = __webpack_require__(363);

var getScrollPosition = __webpack_require__(165);

var getViewportDimensions = __webpack_require__(364);

var invariant = __webpack_require__(9);

var isHTMLElement = __webpack_require__(122);

var nullthrows = __webpack_require__(30);

var SCROLL_BUFFER = 10;

/**
 * Return whether a block overlaps with either edge of the `SelectionState`.
 */
var isBlockOnSelectionEdge = function isBlockOnSelectionEdge(selection, key) {
  return selection.getAnchorKey() === key || selection.getFocusKey() === key;
};
/**
 * The default block renderer for a `DraftEditor` component.
 *
 * A `DraftEditorBlock` is able to render a given `ContentBlock` to its
 * appropriate decorator and inline style components.
 */


var DraftEditorBlock = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorBlock, _React$Component);

  function DraftEditorBlock() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "_node", void 0);

    return _this;
  }

  var _proto = DraftEditorBlock.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.block !== nextProps.block || this.props.tree !== nextProps.tree || this.props.direction !== nextProps.direction || isBlockOnSelectionEdge(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection;
  }
  /**
   * When a block is mounted and overlaps the selection state, we need to make
   * sure that the cursor is visible to match native behavior. This may not
   * be the case if the user has pressed `RETURN` or pasted some content, since
   * programmatically creating these new blocks and setting the DOM selection
   * will miss out on the browser natively scrolling to that position.
   *
   * To replicate native behavior, if the block overlaps the selection state
   * on mount, force the scroll position. Check the scroll state of the scroll
   * parent, and adjust it to align the entire block to the bottom of the
   * scroll parent.
   */
  ;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.preventScroll) {
      return;
    }

    var selection = this.props.selection;
    var endKey = selection.getEndKey();

    if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
      return;
    }

    var blockNode = this._node;

    if (blockNode == null) {
      return;
    }

    var scrollParent = Style.getScrollParent(blockNode);
    var scrollPosition = getScrollPosition(scrollParent);
    var scrollDelta;

    if (scrollParent === window) {
      var nodePosition = getElementPosition(blockNode);
      var nodeBottom = nodePosition.y + nodePosition.height;
      var viewportHeight = getViewportDimensions().height;
      scrollDelta = nodeBottom - viewportHeight;

      if (scrollDelta > 0) {
        window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER);
      }
    } else {
      !isHTMLElement(blockNode) ?  false ? invariant(false, 'blockNode is not an HTMLElement') : invariant(false) : void 0;
      var blockBottom = blockNode.offsetHeight + blockNode.offsetTop;
      var pOffset = scrollParent.offsetTop + scrollParent.offsetHeight;
      var scrollBottom = pOffset + scrollPosition.y;
      scrollDelta = blockBottom - scrollBottom;

      if (scrollDelta > 0) {
        Scroll.setTop(scrollParent, Scroll.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER);
      }
    }
  };

  _proto._renderChildren = function _renderChildren() {
    var _this2 = this;

    var block = this.props.block;
    var blockKey = block.getKey();
    var text = block.getText();
    var lastLeafSet = this.props.tree.size - 1;
    var hasSelection = isBlockOnSelectionEdge(this.props.selection, blockKey);
    return this.props.tree.map(function (leafSet, ii) {
      var leavesForLeafSet = leafSet.get('leaves'); // T44088704

      if (leavesForLeafSet.size === 0) {
        return null;
      }

      var lastLeaf = leavesForLeafSet.size - 1;
      var leaves = leavesForLeafSet.map(function (leaf, jj) {
        var offsetKey = DraftOffsetKey.encode(blockKey, ii, jj);
        var start = leaf.get('start');
        var end = leaf.get('end');
        return React.createElement(DraftEditorLeaf, {
          key: offsetKey,
          offsetKey: offsetKey,
          block: block,
          start: start,
          selection: hasSelection ? _this2.props.selection : null,
          forceSelection: _this2.props.forceSelection,
          text: text.slice(start, end),
          styleSet: block.getInlineStyleAt(start),
          customStyleMap: _this2.props.customStyleMap,
          customStyleFn: _this2.props.customStyleFn,
          isLast: ii === lastLeafSet && jj === lastLeaf
        });
      }).toArray();
      var decoratorKey = leafSet.get('decoratorKey');

      if (decoratorKey == null) {
        return leaves;
      }

      if (!_this2.props.decorator) {
        return leaves;
      }

      var decorator = nullthrows(_this2.props.decorator);
      var DecoratorComponent = decorator.getComponentForKey(decoratorKey);

      if (!DecoratorComponent) {
        return leaves;
      }

      var decoratorProps = decorator.getPropsForKey(decoratorKey);
      var decoratorOffsetKey = DraftOffsetKey.encode(blockKey, ii, 0);
      var start = leavesForLeafSet.first().get('start');
      var end = leavesForLeafSet.last().get('end');
      var decoratedText = text.slice(start, end);
      var entityKey = block.getEntityAt(leafSet.get('start')); // Resetting dir to the same value on a child node makes Chrome/Firefox
      // confused on cursor movement. See http://jsfiddle.net/d157kLck/3/

      var dir = UnicodeBidiDirection.getHTMLDirIfDifferent(UnicodeBidi.getDirection(decoratedText), _this2.props.direction);
      var commonProps = {
        contentState: _this2.props.contentState,
        decoratedText: decoratedText,
        dir: dir,
        start: start,
        end: end,
        blockKey: blockKey,
        entityKey: entityKey,
        offsetKey: decoratorOffsetKey
      };
      return React.createElement(DecoratorComponent, _extends({}, decoratorProps, commonProps, {
        key: decoratorOffsetKey
      }), leaves);
    }).toArray();
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props = this.props,
        direction = _this$props.direction,
        offsetKey = _this$props.offsetKey;
    var className = cx({
      'public/DraftStyleDefault/block': true,
      'public/DraftStyleDefault/ltr': direction === 'LTR',
      'public/DraftStyleDefault/rtl': direction === 'RTL'
    });
    return React.createElement("div", {
      "data-offset-key": offsetKey,
      className: className,
      ref: function ref(_ref) {
        return _this3._node = _ref;
      }
    }, this._renderChildren());
  };

  return DraftEditorBlock;
}(React.Component);

module.exports = DraftEditorBlock;

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var PhotosMimeType = __webpack_require__(847);

var createArrayFromMixed = __webpack_require__(848);

var emptyFunction = __webpack_require__(367);

var CR_LF_REGEX = new RegExp("\r\n", 'g');
var LF_ONLY = "\n";
var RICH_TEXT_TYPES = {
  'text/rtf': 1,
  'text/html': 1
};
/**
 * If DataTransferItem is a file then return the Blob of data.
 *
 * @param {object} item
 * @return {?blob}
 */

function getFileFromDataTransfer(item) {
  if (item.kind == 'file') {
    return item.getAsFile();
  }
}

var DataTransfer =
/*#__PURE__*/
function () {
  /**
   * @param {object} data
   */
  function DataTransfer(data) {
    this.data = data; // Types could be DOMStringList or array

    this.types = data.types ? createArrayFromMixed(data.types) : [];
  }
  /**
   * Is this likely to be a rich text data transfer?
   *
   * @return {boolean}
   */


  var _proto = DataTransfer.prototype;

  _proto.isRichText = function isRichText() {
    // If HTML is available, treat this data as rich text. This way, we avoid
    // using a pasted image if it is packaged with HTML -- this may occur with
    // pastes from MS Word, for example.  However this is only rich text if
    // there's accompanying text.
    if (this.getHTML() && this.getText()) {
      return true;
    } // When an image is copied from a preview window, you end up with two
    // DataTransferItems one of which is a file's metadata as text.  Skip those.


    if (this.isImage()) {
      return false;
    }

    return this.types.some(function (type) {
      return RICH_TEXT_TYPES[type];
    });
  };
  /**
   * Get raw text.
   *
   * @return {?string}
   */


  _proto.getText = function getText() {
    var text;

    if (this.data.getData) {
      if (!this.types.length) {
        text = this.data.getData('Text');
      } else if (this.types.indexOf('text/plain') != -1) {
        text = this.data.getData('text/plain');
      }
    }

    return text ? text.replace(CR_LF_REGEX, LF_ONLY) : null;
  };
  /**
   * Get HTML paste data
   *
   * @return {?string}
   */


  _proto.getHTML = function getHTML() {
    if (this.data.getData) {
      if (!this.types.length) {
        return this.data.getData('Text');
      } else if (this.types.indexOf('text/html') != -1) {
        return this.data.getData('text/html');
      }
    }
  };
  /**
   * Is this a link data transfer?
   *
   * @return {boolean}
   */


  _proto.isLink = function isLink() {
    return this.types.some(function (type) {
      return type.indexOf('Url') != -1 || type.indexOf('text/uri-list') != -1 || type.indexOf('text/x-moz-url');
    });
  };
  /**
   * Get a link url.
   *
   * @return {?string}
   */


  _proto.getLink = function getLink() {
    if (this.data.getData) {
      if (this.types.indexOf('text/x-moz-url') != -1) {
        var url = this.data.getData('text/x-moz-url').split('\n');
        return url[0];
      }

      return this.types.indexOf('text/uri-list') != -1 ? this.data.getData('text/uri-list') : this.data.getData('url');
    }

    return null;
  };
  /**
   * Is this an image data transfer?
   *
   * @return {boolean}
   */


  _proto.isImage = function isImage() {
    var isImage = this.types.some(function (type) {
      // Firefox will have a type of application/x-moz-file for images during
      // dragging
      return type.indexOf('application/x-moz-file') != -1;
    });

    if (isImage) {
      return true;
    }

    var items = this.getFiles();

    for (var i = 0; i < items.length; i++) {
      var type = items[i].type;

      if (!PhotosMimeType.isImage(type)) {
        return false;
      }
    }

    return true;
  };

  _proto.getCount = function getCount() {
    if (this.data.hasOwnProperty('items')) {
      return this.data.items.length;
    } else if (this.data.hasOwnProperty('mozItemCount')) {
      return this.data.mozItemCount;
    } else if (this.data.files) {
      return this.data.files.length;
    }

    return null;
  };
  /**
   * Get files.
   *
   * @return {array}
   */


  _proto.getFiles = function getFiles() {
    if (this.data.items) {
      // createArrayFromMixed doesn't properly handle DataTransferItemLists.
      return Array.prototype.slice.call(this.data.items).map(getFileFromDataTransfer).filter(emptyFunction.thatReturnsArgument);
    } else if (this.data.files) {
      return Array.prototype.slice.call(this.data.files);
    } else {
      return [];
    }
  };
  /**
   * Are there any files to fetch?
   *
   * @return {boolean}
   */


  _proto.hasFiles = function hasFiles() {
    return this.getFiles().length > 0;
  };

  return DataTransfer;
}();

module.exports = DataTransfer;

/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */


var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);

emptyFunction.thatReturnsThis = function () {
  return this;
};

emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var invariant = __webpack_require__(9);

var TEXT_CLIPPING_REGEX = /\.textClipping$/;
var TEXT_TYPES = {
  'text/plain': true,
  'text/html': true,
  'text/rtf': true
}; // Somewhat arbitrary upper bound on text size. Let's not lock up the browser.

var TEXT_SIZE_UPPER_BOUND = 5000;
/**
 * Extract the text content from a file list.
 */

function getTextContentFromFiles(files, callback) {
  var readCount = 0;
  var results = [];
  files.forEach(function (
  /*blob*/
  file) {
    readFile(file, function (
    /*string*/
    text) {
      readCount++;
      text && results.push(text.slice(0, TEXT_SIZE_UPPER_BOUND));

      if (readCount == files.length) {
        callback(results.join('\r'));
      }
    });
  });
}
/**
 * todo isaac: Do work to turn html/rtf into a content fragment.
 */


function readFile(file, callback) {
  if (!global.FileReader || file.type && !(file.type in TEXT_TYPES)) {
    callback('');
    return;
  }

  if (file.type === '') {
    var _contents = ''; // Special-case text clippings, which have an empty type but include
    // `.textClipping` in the file name. `readAsText` results in an empty
    // string for text clippings, so we force the file name to serve
    // as the text value for the file.

    if (TEXT_CLIPPING_REGEX.test(file.name)) {
      _contents = file.name.replace(TEXT_CLIPPING_REGEX, '');
    }

    callback(_contents);
    return;
  }

  var reader = new FileReader();

  reader.onload = function () {
    var result = reader.result;
    !(typeof result === 'string') ?  false ? invariant(false, 'We should be calling "FileReader.readAsText" which returns a string') : invariant(false) : void 0;
    callback(result);
  };

  reader.onerror = function () {
    callback('');
  };

  reader.readAsText(file);
}

module.exports = getTextContentFromFiles;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var getContentStateFragment = __webpack_require__(157);

function getFragmentFromSelection(editorState) {
  var selectionState = editorState.getSelection();

  if (selectionState.isCollapsed()) {
    return null;
  }

  return getContentStateFragment(editorState.getCurrentContent(), selectionState);
}

module.exports = getFragmentFromSelection;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(13);

var UnicodeUtils = __webpack_require__(91);

var moveSelectionBackward = __webpack_require__(232);

var removeTextWithStrategy = __webpack_require__(123);
/**
 * Remove the selected range. If the cursor is collapsed, remove the preceding
 * character. This operation is Unicode-aware, so removing a single character
 * will remove a surrogate pair properly as well.
 */


function keyCommandPlainBackspace(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var content = strategyState.getCurrentContent();
    var key = selection.getAnchorKey();
    var offset = selection.getAnchorOffset();
    var charBehind = content.getBlockForKey(key).getText()[offset - 1];
    return moveSelectionBackward(strategyState, charBehind ? UnicodeUtils.getUTF16Length(charBehind, 0) : 1);
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  var selection = editorState.getSelection();
  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'backspace-character' : 'remove-range');
}

module.exports = keyCommandPlainBackspace;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var UserAgent = __webpack_require__(31);

var invariant = __webpack_require__(9);

var isChrome = UserAgent.isBrowser('Chrome'); // In Chrome, the client rects will include the entire bounds of all nodes that
// begin (have a start tag) within the selection, even if the selection does
// not overlap the entire node. To resolve this, we split the range at each
// start tag and join the client rects together.
// https://code.google.com/p/chromium/issues/detail?id=324437

/* eslint-disable consistent-return */

function getRangeClientRectsChrome(range) {
  var tempRange = range.cloneRange();
  var clientRects = [];

  for (var ancestor = range.endContainer; ancestor != null; ancestor = ancestor.parentNode) {
    // If we've climbed up to the common ancestor, we can now use the
    // original start point and stop climbing the tree.
    var atCommonAncestor = ancestor === range.commonAncestorContainer;

    if (atCommonAncestor) {
      tempRange.setStart(range.startContainer, range.startOffset);
    } else {
      tempRange.setStart(tempRange.endContainer, 0);
    }

    var rects = Array.from(tempRange.getClientRects());
    clientRects.push(rects);

    if (atCommonAncestor) {
      var _ref;

      clientRects.reverse();
      return (_ref = []).concat.apply(_ref, clientRects);
    }

    tempRange.setEndBefore(ancestor);
  }

   true ?  false ? invariant(false, 'Found an unexpected detached subtree when getting range client rects.') : invariant(false) : void 0;
}
/* eslint-enable consistent-return */

/**
 * Like range.getClientRects() but normalizes for browser bugs.
 */


var getRangeClientRects = isChrome ? getRangeClientRectsChrome : function (range) {
  return Array.from(range.getClientRects());
};
module.exports = getRangeClientRects;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var TokenizeUtil = __webpack_require__(869);

var punctuation = TokenizeUtil.getPunctuation(); // The apostrophe and curly single quotes behave in a curious way: when
// surrounded on both sides by word characters, they behave as word chars; when
// either neighbor is punctuation or an end of the string, they behave as
// punctuation.

var CHAMELEON_CHARS = "['\u2018\u2019]"; // Remove the underscore, which should count as part of the removable word. The
// "chameleon chars" also count as punctuation in this regex.

var WHITESPACE_AND_PUNCTUATION = '\\s|(?![_])' + punctuation;
var DELETE_STRING = '^' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)';
var DELETE_REGEX = new RegExp(DELETE_STRING);
var BACKSPACE_STRING = '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '$';
var BACKSPACE_REGEX = new RegExp(BACKSPACE_STRING);

function getRemovableWord(text, isBackward) {
  var matches = isBackward ? BACKSPACE_REGEX.exec(text) : DELETE_REGEX.exec(text);
  return matches ? matches[0] : text;
}

var DraftRemovableWord = {
  getBackward: function getBackward(text) {
    return getRemovableWord(text, true);
  },
  getForward: function getForward(text) {
    return getRemovableWord(text, false);
  }
};
module.exports = DraftRemovableWord;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var warning = __webpack_require__(233);
/**
 * Given a collapsed selection, move the focus `maxDistance` forward within
 * the selected block. If the selection will go beyond the end of the block,
 * move focus to the start of the next block, but no further.
 *
 * This function is not Unicode-aware, so surrogate pairs will be treated
 * as having length 2.
 */


function moveSelectionForward(editorState, maxDistance) {
  var selection = editorState.getSelection(); // Should eventually make this an invariant

   false ? warning(selection.isCollapsed(), 'moveSelectionForward should only be called with a collapsed SelectionState') : void 0;
  var key = selection.getStartKey();
  var offset = selection.getStartOffset();
  var content = editorState.getCurrentContent();
  var focusKey = key;
  var focusOffset;
  var block = content.getBlockForKey(key);

  if (maxDistance > block.getText().length - offset) {
    focusKey = content.getKeyAfter(key);
    focusOffset = 0;
  } else {
    focusOffset = offset + maxDistance;
  }

  return selection.merge({
    focusKey: focusKey,
    focusOffset: focusOffset
  });
}

module.exports = moveSelectionForward;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var _knownListItemDepthCl;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CharacterMetadata = __webpack_require__(43);

var ContentBlock = __webpack_require__(88);

var ContentBlockNode = __webpack_require__(44);

var DefaultDraftBlockRenderMap = __webpack_require__(227);

var DraftEntity = __webpack_require__(158);

var URI = __webpack_require__(879);

var cx = __webpack_require__(89);

var generateRandomKey = __webpack_require__(57);

var getSafeBodyFromHTML = __webpack_require__(375);

var gkx = __webpack_require__(70);

var _require = __webpack_require__(4),
    List = _require.List,
    Map = _require.Map,
    OrderedSet = _require.OrderedSet;

var isHTMLAnchorElement = __webpack_require__(880);

var isHTMLBRElement = __webpack_require__(360);

var isHTMLElement = __webpack_require__(122);

var isHTMLImageElement = __webpack_require__(881);

var experimentalTreeDataSupport = gkx('draft_tree_data_support');
var NBSP = '&nbsp;';
var SPACE = ' '; // used for replacing characters in HTML

var REGEX_CR = new RegExp('\r', 'g');
var REGEX_LF = new RegExp('\n', 'g');
var REGEX_LEADING_LF = new RegExp('^\n', 'g');
var REGEX_NBSP = new RegExp(NBSP, 'g');
var REGEX_CARRIAGE = new RegExp('&#13;?', 'g');
var REGEX_ZWS = new RegExp('&#8203;?', 'g'); // https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight

var boldValues = ['bold', 'bolder', '500', '600', '700', '800', '900'];
var notBoldValues = ['light', 'lighter', 'normal', '100', '200', '300', '400'];
var anchorAttr = ['className', 'href', 'rel', 'target', 'title'];
var imgAttr = ['alt', 'className', 'height', 'src', 'width'];
var knownListItemDepthClasses = (_knownListItemDepthCl = {}, _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth0'), 0), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth1'), 1), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth2'), 2), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth3'), 3), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth4'), 4), _knownListItemDepthCl);
var HTMLTagToRawInlineStyleMap = Map({
  b: 'BOLD',
  code: 'CODE',
  del: 'STRIKETHROUGH',
  em: 'ITALIC',
  i: 'ITALIC',
  s: 'STRIKETHROUGH',
  strike: 'STRIKETHROUGH',
  strong: 'BOLD',
  u: 'UNDERLINE',
  mark: 'HIGHLIGHT'
});

/**
 * Build a mapping from HTML tags to draftjs block types
 * out of a BlockRenderMap.
 *
 * The BlockTypeMap for the default BlockRenderMap looks like this:
 *   Map({
 *     h1: 'header-one',
 *     h2: 'header-two',
 *     h3: 'header-three',
 *     h4: 'header-four',
 *     h5: 'header-five',
 *     h6: 'header-six',
 *     blockquote: 'blockquote',
 *     figure: 'atomic',
 *     pre: ['code-block'],
 *     div: 'unstyled',
 *     p: 'unstyled',
 *     li: ['ordered-list-item', 'unordered-list-item'],
 *   })
 */
var buildBlockTypeMap = function buildBlockTypeMap(blockRenderMap) {
  var blockTypeMap = {};
  blockRenderMap.mapKeys(function (blockType, desc) {
    var elements = [desc.element];

    if (desc.aliasedElements !== undefined) {
      elements.push.apply(elements, desc.aliasedElements);
    }

    elements.forEach(function (element) {
      if (blockTypeMap[element] === undefined) {
        blockTypeMap[element] = blockType;
      } else if (typeof blockTypeMap[element] === 'string') {
        blockTypeMap[element] = [blockTypeMap[element], blockType];
      } else {
        blockTypeMap[element].push(blockType);
      }
    });
  });
  return Map(blockTypeMap);
};

var detectInlineStyle = function detectInlineStyle(node) {
  if (isHTMLElement(node)) {
    var element = node; // Currently only used to detect preformatted inline code

    if (element.style.fontFamily.includes('monospace')) {
      return 'CODE';
    }
  }

  return null;
};
/**
 * If we're pasting from one DraftEditor to another we can check to see if
 * existing list item depth classes are being used and preserve this style
 */


var getListItemDepth = function getListItemDepth(node) {
  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  Object.keys(knownListItemDepthClasses).some(function (depthClass) {
    if (node.classList.contains(depthClass)) {
      depth = knownListItemDepthClasses[depthClass];
    }
  });
  return depth;
};
/**
 * Return true if the provided HTML Element can be used to build a
 * Draftjs-compatible link.
 */


var isValidAnchor = function isValidAnchor(node) {
  if (!isHTMLAnchorElement(node)) {
    return false;
  }

  var anchorNode = node;

  if (!anchorNode.href || anchorNode.protocol !== 'http:' && anchorNode.protocol !== 'https:' && anchorNode.protocol !== 'mailto:' && anchorNode.protocol !== 'tel:') {
    return false;
  }

  try {
    // Just checking whether we can actually create a URI
    var _ = new URI(anchorNode.href);

    return true; // We need our catch statements to have arguments, else
    // UglifyJS (which we use for our OSS builds) will crash.
    // eslint-disable-next-line fb-www/no-unused-catch-bindings
  } catch (_) {
    return false;
  }
};
/**
 * Return true if the provided HTML Element can be used to build a
 * Draftjs-compatible image.
 */


var isValidImage = function isValidImage(node) {
  if (!isHTMLImageElement(node)) {
    return false;
  }

  var imageNode = node;
  return !!(imageNode.attributes.getNamedItem('src') && imageNode.attributes.getNamedItem('src').value);
};
/**
 * Try to guess the inline style of an HTML element based on its css
 * styles (font-weight, font-style and text-decoration).
 */


var styleFromNodeAttributes = function styleFromNodeAttributes(node, style) {
  if (!isHTMLElement(node)) {
    return style;
  }

  var htmlElement = node;
  var fontWeight = htmlElement.style.fontWeight;
  var fontStyle = htmlElement.style.fontStyle;
  var textDecoration = htmlElement.style.textDecoration;
  return style.withMutations(function (style) {
    if (boldValues.indexOf(fontWeight) >= 0) {
      style.add('BOLD');
    } else if (notBoldValues.indexOf(fontWeight) >= 0) {
      style.remove('BOLD');
    }

    if (fontStyle === 'italic') {
      style.add('ITALIC');
    } else if (fontStyle === 'normal') {
      style.remove('ITALIC');
    }

    if (textDecoration === 'underline') {
      style.add('UNDERLINE');
    }

    if (textDecoration === 'line-through') {
      style.add('STRIKETHROUGH');
    }

    if (textDecoration === 'none') {
      style.remove('UNDERLINE');
      style.remove('STRIKETHROUGH');
    }
  });
};
/**
 * Determine if a nodeName is a list type, 'ul' or 'ol'
 */


var isListNode = function isListNode(nodeName) {
  return nodeName === 'ul' || nodeName === 'ol';
};
/**
 *  ContentBlockConfig is a mutable data structure that holds all
 *  the information required to build a ContentBlock and an array of
 *  all the child nodes (childConfigs).
 *  It is being used a temporary data structure by the
 *  ContentBlocksBuilder class.
 */


/**
 * ContentBlocksBuilder builds a list of ContentBlocks and an Entity Map
 * out of one (or several) HTMLElement(s).
 *
 * The algorithm has two passes: first it builds a tree of ContentBlockConfigs
 * by walking through the HTML nodes and their children, then it walks the
 * ContentBlockConfigs tree to compute parents/siblings and create
 * the actual ContentBlocks.
 *
 * Typical usage is:
 *     new ContentBlocksBuilder()
 *        .addDOMNode(someHTMLNode)
 *        .addDOMNode(someOtherHTMLNode)
 *       .getContentBlocks();
 *
 */
var ContentBlocksBuilder = /*#__PURE__*/function () {
  // Most of the method in the class depend on the state of the content builder
  // (i.e. currentBlockType, currentDepth, currentEntity etc.). Though it may
  // be confusing at first, it made the code simpler than the alternative which
  // is to pass those values around in every call.
  // The following attributes are used to accumulate text and styles
  // as we are walking the HTML node tree.
  // Describes the future ContentState as a tree of content blocks
  // The content blocks generated from the blockConfigs
  // Entity map use to store links and images found in the HTML nodes
  // Map HTML tags to draftjs block types and disambiguation function
  function ContentBlocksBuilder(blockTypeMap, disambiguate) {
    _defineProperty(this, "characterList", List());

    _defineProperty(this, "currentBlockType", 'unstyled');

    _defineProperty(this, "currentDepth", 0);

    _defineProperty(this, "currentEntity", null);

    _defineProperty(this, "currentText", '');

    _defineProperty(this, "wrapper", null);

    _defineProperty(this, "blockConfigs", []);

    _defineProperty(this, "contentBlocks", []);

    _defineProperty(this, "entityMap", DraftEntity);

    _defineProperty(this, "blockTypeMap", void 0);

    _defineProperty(this, "disambiguate", void 0);

    this.clear();
    this.blockTypeMap = blockTypeMap;
    this.disambiguate = disambiguate;
  }
  /**
   * Clear the internal state of the ContentBlocksBuilder
   */


  var _proto = ContentBlocksBuilder.prototype;

  _proto.clear = function clear() {
    this.characterList = List();
    this.blockConfigs = [];
    this.currentBlockType = 'unstyled';
    this.currentDepth = 0;
    this.currentEntity = null;
    this.currentText = '';
    this.entityMap = DraftEntity;
    this.wrapper = null;
    this.contentBlocks = [];
  }
  /**
   * Add an HTMLElement to the ContentBlocksBuilder
   */
  ;

  _proto.addDOMNode = function addDOMNode(node) {
    var _this$blockConfigs;

    this.contentBlocks = [];
    this.currentDepth = 0; // Converts the HTML node to block config

    (_this$blockConfigs = this.blockConfigs).push.apply(_this$blockConfigs, this._toBlockConfigs([node], OrderedSet())); // There might be some left over text in the builder's
    // internal state, if so make a ContentBlock out of it.


    this._trimCurrentText();

    if (this.currentText !== '') {
      this.blockConfigs.push(this._makeBlockConfig());
    } // for chaining


    return this;
  }
  /**
   * Return the ContentBlocks and the EntityMap that corresponds
   * to the previously added HTML nodes.
   */
  ;

  _proto.getContentBlocks = function getContentBlocks() {
    if (this.contentBlocks.length === 0) {
      if (experimentalTreeDataSupport) {
        this._toContentBlocks(this.blockConfigs);
      } else {
        this._toFlatContentBlocks(this.blockConfigs);
      }
    }

    return {
      contentBlocks: this.contentBlocks,
      entityMap: this.entityMap
    };
  } // ***********************************WARNING******************************
  // The methods below this line are private - don't call them directly.

  /**
   * Generate a new ContentBlockConfig out of the current internal state
   * of the builder, then clears the internal state.
   */
  ;

  _proto._makeBlockConfig = function _makeBlockConfig() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var key = config.key || generateRandomKey();

    var block = _objectSpread({
      key: key,
      type: this.currentBlockType,
      text: this.currentText,
      characterList: this.characterList,
      depth: this.currentDepth,
      parent: null,
      children: List(),
      prevSibling: null,
      nextSibling: null,
      childConfigs: []
    }, config);

    this.characterList = List();
    this.currentBlockType = 'unstyled';
    this.currentText = '';
    return block;
  }
  /**
   * Converts an array of HTML elements to a multi-root tree of content
   * block configs. Some text content may be left in the builders internal
   * state to enable chaining sucessive calls.
   */
  ;

  _proto._toBlockConfigs = function _toBlockConfigs(nodes, style) {
    var blockConfigs = [];

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var nodeName = node.nodeName.toLowerCase();

      if (nodeName === 'body' || isListNode(nodeName)) {
        // body, ol and ul are 'block' type nodes so create a block config
        // with the text accumulated so far (if any)
        this._trimCurrentText();

        if (this.currentText !== '') {
          blockConfigs.push(this._makeBlockConfig());
        } // body, ol and ul nodes are ignored, but their children are inlined in
        // the parent block config.


        var wasCurrentDepth = this.currentDepth;
        var wasWrapper = this.wrapper;

        if (isListNode(nodeName)) {
          this.wrapper = nodeName;

          if (isListNode(wasWrapper)) {
            this.currentDepth++;
          }
        }

        blockConfigs.push.apply(blockConfigs, this._toBlockConfigs(Array.from(node.childNodes), style));
        this.currentDepth = wasCurrentDepth;
        this.wrapper = wasWrapper;
        continue;
      }

      var blockType = this.blockTypeMap.get(nodeName);

      if (blockType !== undefined) {
        // 'block' type node means we need to create a block config
        // with the text accumulated so far (if any)
        this._trimCurrentText();

        if (this.currentText !== '') {
          blockConfigs.push(this._makeBlockConfig());
        }

        var _wasCurrentDepth = this.currentDepth;
        var _wasWrapper = this.wrapper;
        this.wrapper = nodeName === 'pre' ? 'pre' : this.wrapper;

        if (typeof blockType !== 'string') {
          blockType = this.disambiguate(nodeName, this.wrapper) || blockType[0] || 'unstyled';
        }

        if (!experimentalTreeDataSupport && isHTMLElement(node) && (blockType === 'unordered-list-item' || blockType === 'ordered-list-item')) {
          var htmlElement = node;
          this.currentDepth = getListItemDepth(htmlElement, this.currentDepth);
        }

        var key = generateRandomKey();

        var childConfigs = this._toBlockConfigs(Array.from(node.childNodes), style);

        this._trimCurrentText();

        blockConfigs.push(this._makeBlockConfig({
          key: key,
          childConfigs: childConfigs,
          type: blockType
        }));
        this.currentDepth = _wasCurrentDepth;
        this.wrapper = _wasWrapper;
        continue;
      }

      if (nodeName === '#text') {
        this._addTextNode(node, style);

        continue;
      }

      if (nodeName === 'br') {
        this._addBreakNode(node, style);

        continue;
      }

      if (isValidImage(node)) {
        this._addImgNode(node, style);

        continue;
      }

      if (isValidAnchor(node)) {
        this._addAnchorNode(node, blockConfigs, style);

        continue;
      }

      var newStyle = style;

      if (HTMLTagToRawInlineStyleMap.has(nodeName)) {
        newStyle = newStyle.add(HTMLTagToRawInlineStyleMap.get(nodeName));
      }

      newStyle = styleFromNodeAttributes(node, newStyle);
      var inlineStyle = detectInlineStyle(node);

      if (inlineStyle != null) {
        newStyle = newStyle.add(inlineStyle);
      }

      blockConfigs.push.apply(blockConfigs, this._toBlockConfigs(Array.from(node.childNodes), newStyle));
    }

    return blockConfigs;
  }
  /**
   * Append a string of text to the internal buffer.
   */
  ;

  _proto._appendText = function _appendText(text, style) {
    var _this$characterList;

    this.currentText += text;
    var characterMetadata = CharacterMetadata.create({
      style: style,
      entity: this.currentEntity
    });
    this.characterList = (_this$characterList = this.characterList).push.apply(_this$characterList, Array(text.length).fill(characterMetadata));
  }
  /**
   * Trim the text in the internal buffer.
   */
  ;

  _proto._trimCurrentText = function _trimCurrentText() {
    var l = this.currentText.length;
    var begin = l - this.currentText.trimLeft().length;
    var end = this.currentText.trimRight().length; // We should not trim whitespaces for which an entity is defined.

    var entity = this.characterList.findEntry(function (characterMetadata) {
      return characterMetadata.getEntity() !== null;
    });
    begin = entity !== undefined ? Math.min(begin, entity[0]) : begin;
    entity = this.characterList.reverse().findEntry(function (characterMetadata) {
      return characterMetadata.getEntity() !== null;
    });
    end = entity !== undefined ? Math.max(end, l - entity[0]) : end;

    if (begin > end) {
      this.currentText = '';
      this.characterList = List();
    } else {
      this.currentText = this.currentText.slice(begin, end);
      this.characterList = this.characterList.slice(begin, end);
    }
  }
  /**
   * Add the content of an HTML text node to the internal state
   */
  ;

  _proto._addTextNode = function _addTextNode(node, style) {
    var text = node.textContent;
    var trimmedText = text.trim(); // If we are not in a pre block and the trimmed content is empty,
    // normalize to a single space.

    if (trimmedText === '' && this.wrapper !== 'pre') {
      text = ' ';
    }

    if (this.wrapper !== 'pre') {
      // Trim leading line feed, which is invisible in HTML
      text = text.replace(REGEX_LEADING_LF, ''); // Can't use empty string because MSWord

      text = text.replace(REGEX_LF, SPACE);
    }

    this._appendText(text, style);
  };

  _proto._addBreakNode = function _addBreakNode(node, style) {
    if (!isHTMLBRElement(node)) {
      return;
    }

    this._appendText('\n', style);
  }
  /**
   * Add the content of an HTML img node to the internal state
   */
  ;

  _proto._addImgNode = function _addImgNode(node, style) {
    if (!isHTMLImageElement(node)) {
      return;
    }

    var image = node;
    var entityConfig = {};
    imgAttr.forEach(function (attr) {
      var imageAttribute = image.getAttribute(attr);

      if (imageAttribute) {
        entityConfig[attr] = imageAttribute;
      }
    }); // TODO: T15530363 update this when we remove DraftEntity entirely

    this.currentEntity = this.entityMap.__create('IMAGE', 'IMMUTABLE', entityConfig); // The child text node cannot just have a space or return as content (since
    // we strip those out), unless the image is for presentation only.
    // See https://github.com/facebook/draft-js/issues/231 for some context.

    if (gkx('draftjs_fix_paste_for_img')) {
      if (image.getAttribute('role') !== 'presentation') {
        this._appendText("\uD83D\uDCF7", style);
      }
    } else {
      this._appendText("\uD83D\uDCF7", style);
    }

    this.currentEntity = null;
  }
  /**
   * Add the content of an HTML 'a' node to the internal state. Child nodes
   * (if any) are converted to Block Configs and appended to the provided
   * blockConfig array.
   */
  ;

  _proto._addAnchorNode = function _addAnchorNode(node, blockConfigs, style) {
    // The check has already been made by isValidAnchor but
    // we have to do it again to keep flow happy.
    if (!isHTMLAnchorElement(node)) {
      return;
    }

    var anchor = node;
    var entityConfig = {};
    anchorAttr.forEach(function (attr) {
      var anchorAttribute = anchor.getAttribute(attr);

      if (anchorAttribute) {
        entityConfig[attr] = anchorAttribute;
      }
    });
    entityConfig.url = new URI(anchor.href).toString(); // TODO: T15530363 update this when we remove DraftEntity completely

    this.currentEntity = this.entityMap.__create('LINK', 'MUTABLE', entityConfig || {});
    blockConfigs.push.apply(blockConfigs, this._toBlockConfigs(Array.from(node.childNodes), style));
    this.currentEntity = null;
  }
  /**
   * Walk the BlockConfig tree, compute parent/children/siblings,
   * and generate the corresponding ContentBlockNode
   */
  ;

  _proto._toContentBlocks = function _toContentBlocks(blockConfigs) {
    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var l = blockConfigs.length - 1;

    for (var i = 0; i <= l; i++) {
      var config = blockConfigs[i];
      config.parent = parent;
      config.prevSibling = i > 0 ? blockConfigs[i - 1].key : null;
      config.nextSibling = i < l ? blockConfigs[i + 1].key : null;
      config.children = List(config.childConfigs.map(function (child) {
        return child.key;
      }));
      this.contentBlocks.push(new ContentBlockNode(_objectSpread({}, config)));

      this._toContentBlocks(config.childConfigs, config.key);
    }
  }
  /**
   * Remove 'useless' container nodes from the block config hierarchy, by
   * replacing them with their children.
   */
  ;

  _proto._hoistContainersInBlockConfigs = function _hoistContainersInBlockConfigs(blockConfigs) {
    var _this = this;

    var hoisted = List(blockConfigs).flatMap(function (blockConfig) {
      // Don't mess with useful blocks
      if (blockConfig.type !== 'unstyled' || blockConfig.text !== '') {
        return [blockConfig];
      }

      return _this._hoistContainersInBlockConfigs(blockConfig.childConfigs);
    });
    return hoisted;
  } // ***********************************************************************
  // The two methods below are used for backward compatibility when
  // experimentalTreeDataSupport is disabled.

  /**
   * Same as _toContentBlocks but replaces nested blocks by their
   * text content.
   */
  ;

  _proto._toFlatContentBlocks = function _toFlatContentBlocks(blockConfigs) {
    var _this2 = this;

    var cleanConfigs = this._hoistContainersInBlockConfigs(blockConfigs);

    cleanConfigs.forEach(function (config) {
      var _this2$_extractTextFr = _this2._extractTextFromBlockConfigs(config.childConfigs),
          text = _this2$_extractTextFr.text,
          characterList = _this2$_extractTextFr.characterList;

      _this2.contentBlocks.push(new ContentBlock(_objectSpread({}, config, {
        text: config.text + text,
        characterList: config.characterList.concat(characterList)
      })));
    });
  }
  /**
   * Extract the text and the associated inline styles form an
   * array of content block configs.
   */
  ;

  _proto._extractTextFromBlockConfigs = function _extractTextFromBlockConfigs(blockConfigs) {
    var l = blockConfigs.length - 1;
    var text = '';
    var characterList = List();

    for (var i = 0; i <= l; i++) {
      var config = blockConfigs[i];
      text += config.text;
      characterList = characterList.concat(config.characterList);

      if (text !== '' && config.type !== 'unstyled') {
        text += '\n';
        characterList = characterList.push(characterList.last());
      }

      var children = this._extractTextFromBlockConfigs(config.childConfigs);

      text += children.text;
      characterList = characterList.concat(children.characterList);
    }

    return {
      text: text,
      characterList: characterList
    };
  };

  return ContentBlocksBuilder;
}();
/**
 * Converts an HTML string to an array of ContentBlocks and an EntityMap
 * suitable to initialize the internal state of a Draftjs component.
 */


var convertFromHTMLToContentBlocks = function convertFromHTMLToContentBlocks(html) {
  var DOMBuilder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getSafeBodyFromHTML;
  var blockRenderMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DefaultDraftBlockRenderMap;
  // Be ABSOLUTELY SURE that the dom builder you pass here won't execute
  // arbitrary code in whatever environment you're running this in. For an
  // example of how we try to do this in-browser, see getSafeBodyFromHTML.
  // Remove funky characters from the HTML string
  html = html.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE).replace(REGEX_CARRIAGE, '').replace(REGEX_ZWS, ''); // Build a DOM tree out of the HTML string

  var safeBody = DOMBuilder(html);

  if (!safeBody) {
    return null;
  } // Build a BlockTypeMap out of the BlockRenderMap


  var blockTypeMap = buildBlockTypeMap(blockRenderMap); // Select the proper block type for the cases where the blockRenderMap
  // uses multiple block types for the same html tag.

  var disambiguate = function disambiguate(tag, wrapper) {
    if (tag === 'li') {
      return wrapper === 'ol' ? 'ordered-list-item' : 'unordered-list-item';
    }

    return null;
  };

  return new ContentBlocksBuilder(blockTypeMap, disambiguate).addDOMNode(safeBody).getContentBlocks();
};

module.exports = convertFromHTMLToContentBlocks;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var UserAgent = __webpack_require__(31);

var invariant = __webpack_require__(9);

var isOldIE = UserAgent.isBrowser('IE <= 9'); // Provides a dom node that will not execute scripts
// https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation.createHTMLDocument
// https://developer.mozilla.org/en-US/Add-ons/Code_snippets/HTML_to_DOM

function getSafeBodyFromHTML(html) {
  var doc;
  var root = null; // Provides a safe context

  if (!isOldIE && document.implementation && document.implementation.createHTMLDocument) {
    doc = document.implementation.createHTMLDocument('foo');
    !doc.documentElement ?  false ? invariant(false, 'Missing doc.documentElement') : invariant(false) : void 0;
    doc.documentElement.innerHTML = html;
    root = doc.getElementsByTagName('body')[0];
  }

  return root;
}

module.exports = getSafeBodyFromHTML;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(29);

var EditorState = __webpack_require__(13);

var adjustBlockDepthForContentState = __webpack_require__(882);

var nullthrows = __webpack_require__(30);

var RichTextEditorUtil = {
  currentBlockContainsLink: function currentBlockContainsLink(editorState) {
    var selection = editorState.getSelection();
    var contentState = editorState.getCurrentContent();
    var entityMap = contentState.getEntityMap();
    return contentState.getBlockForKey(selection.getAnchorKey()).getCharacterList().slice(selection.getStartOffset(), selection.getEndOffset()).some(function (v) {
      var entity = v.getEntity();
      return !!entity && entityMap.__get(entity).getType() === 'LINK';
    });
  },
  getCurrentBlockType: function getCurrentBlockType(editorState) {
    var selection = editorState.getSelection();
    return editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
  },
  getDataObjectForLinkURL: function getDataObjectForLinkURL(uri) {
    return {
      url: uri.toString()
    };
  },
  handleKeyCommand: function handleKeyCommand(editorState, command, eventTimeStamp) {
    switch (command) {
      case 'bold':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'BOLD');

      case 'italic':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'ITALIC');

      case 'underline':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'UNDERLINE');

      case 'code':
        return RichTextEditorUtil.toggleCode(editorState);

      case 'backspace':
      case 'backspace-word':
      case 'backspace-to-start-of-line':
        return RichTextEditorUtil.onBackspace(editorState);

      case 'delete':
      case 'delete-word':
      case 'delete-to-end-of-block':
        return RichTextEditorUtil.onDelete(editorState);

      default:
        // they may have custom editor commands; ignore those
        return null;
    }
  },
  insertSoftNewline: function insertSoftNewline(editorState) {
    var contentState = DraftModifier.insertText(editorState.getCurrentContent(), editorState.getSelection(), '\n', editorState.getCurrentInlineStyle(), null);
    var newEditorState = EditorState.push(editorState, contentState, 'insert-characters');
    return EditorState.forceSelection(newEditorState, contentState.getSelectionAfter());
  },

  /**
   * For collapsed selections at the start of styled blocks, backspace should
   * just remove the existing style.
   */
  onBackspace: function onBackspace(editorState) {
    var selection = editorState.getSelection();

    if (!selection.isCollapsed() || selection.getAnchorOffset() || selection.getFocusOffset()) {
      return null;
    } // First, try to remove a preceding atomic block.


    var content = editorState.getCurrentContent();
    var startKey = selection.getStartKey();
    var blockBefore = content.getBlockBefore(startKey);

    if (blockBefore && blockBefore.getType() === 'atomic') {
      var blockMap = content.getBlockMap()["delete"](blockBefore.getKey());
      var withoutAtomicBlock = content.merge({
        blockMap: blockMap,
        selectionAfter: selection
      });

      if (withoutAtomicBlock !== content) {
        return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
      }
    } // If that doesn't succeed, try to remove the current block style.


    var withoutBlockStyle = RichTextEditorUtil.tryToRemoveBlockStyle(editorState);

    if (withoutBlockStyle) {
      return EditorState.push(editorState, withoutBlockStyle, 'change-block-type');
    }

    return null;
  },
  onDelete: function onDelete(editorState) {
    var selection = editorState.getSelection();

    if (!selection.isCollapsed()) {
      return null;
    }

    var content = editorState.getCurrentContent();
    var startKey = selection.getStartKey();
    var block = content.getBlockForKey(startKey);
    var length = block.getLength(); // The cursor is somewhere within the text. Behave normally.

    if (selection.getStartOffset() < length) {
      return null;
    }

    var blockAfter = content.getBlockAfter(startKey);

    if (!blockAfter || blockAfter.getType() !== 'atomic') {
      return null;
    }

    var atomicBlockTarget = selection.merge({
      focusKey: blockAfter.getKey(),
      focusOffset: blockAfter.getLength()
    });
    var withoutAtomicBlock = DraftModifier.removeRange(content, atomicBlockTarget, 'forward');

    if (withoutAtomicBlock !== content) {
      return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
    }

    return null;
  },
  onTab: function onTab(event, editorState, maxDepth) {
    var selection = editorState.getSelection();
    var key = selection.getAnchorKey();

    if (key !== selection.getFocusKey()) {
      return editorState;
    }

    var content = editorState.getCurrentContent();
    var block = content.getBlockForKey(key);
    var type = block.getType();

    if (type !== 'unordered-list-item' && type !== 'ordered-list-item') {
      return editorState;
    }

    event.preventDefault();
    var depth = block.getDepth();

    if (!event.shiftKey && depth === maxDepth) {
      return editorState;
    }

    var withAdjustment = adjustBlockDepthForContentState(content, selection, event.shiftKey ? -1 : 1, maxDepth);
    return EditorState.push(editorState, withAdjustment, 'adjust-depth');
  },
  toggleBlockType: function toggleBlockType(editorState, blockType) {
    var selection = editorState.getSelection();
    var startKey = selection.getStartKey();
    var endKey = selection.getEndKey();
    var content = editorState.getCurrentContent();
    var target = selection; // Triple-click can lead to a selection that includes offset 0 of the
    // following block. The `SelectionState` for this case is accurate, but
    // we should avoid toggling block type for the trailing block because it
    // is a confusing interaction.

    if (startKey !== endKey && selection.getEndOffset() === 0) {
      var blockBefore = nullthrows(content.getBlockBefore(endKey));
      endKey = blockBefore.getKey();
      target = target.merge({
        anchorKey: startKey,
        anchorOffset: selection.getStartOffset(),
        focusKey: endKey,
        focusOffset: blockBefore.getLength(),
        isBackward: false
      });
    }

    var hasAtomicBlock = content.getBlockMap().skipWhile(function (_, k) {
      return k !== startKey;
    }).reverse().skipWhile(function (_, k) {
      return k !== endKey;
    }).some(function (v) {
      return v.getType() === 'atomic';
    });

    if (hasAtomicBlock) {
      return editorState;
    }

    var typeToSet = content.getBlockForKey(startKey).getType() === blockType ? 'unstyled' : blockType;
    return EditorState.push(editorState, DraftModifier.setBlockType(content, target, typeToSet), 'change-block-type');
  },
  toggleCode: function toggleCode(editorState) {
    var selection = editorState.getSelection();
    var anchorKey = selection.getAnchorKey();
    var focusKey = selection.getFocusKey();

    if (selection.isCollapsed() || anchorKey !== focusKey) {
      return RichTextEditorUtil.toggleBlockType(editorState, 'code-block');
    }

    return RichTextEditorUtil.toggleInlineStyle(editorState, 'CODE');
  },

  /**
   * Toggle the specified inline style for the selection. If the
   * user's selection is collapsed, apply or remove the style for the
   * internal state. If it is not collapsed, apply the change directly
   * to the document state.
   */
  toggleInlineStyle: function toggleInlineStyle(editorState, inlineStyle) {
    var selection = editorState.getSelection();
    var currentStyle = editorState.getCurrentInlineStyle(); // If the selection is collapsed, toggle the specified style on or off and
    // set the result as the new inline style override. This will then be
    // used as the inline style for the next character to be inserted.

    if (selection.isCollapsed()) {
      return EditorState.setInlineStyleOverride(editorState, currentStyle.has(inlineStyle) ? currentStyle.remove(inlineStyle) : currentStyle.add(inlineStyle));
    } // If characters are selected, immediately apply or remove the
    // inline style on the document state itself.


    var content = editorState.getCurrentContent();
    var newContent; // If the style is already present for the selection range, remove it.
    // Otherwise, apply it.

    if (currentStyle.has(inlineStyle)) {
      newContent = DraftModifier.removeInlineStyle(content, selection, inlineStyle);
    } else {
      newContent = DraftModifier.applyInlineStyle(content, selection, inlineStyle);
    }

    return EditorState.push(editorState, newContent, 'change-inline-style');
  },
  toggleLink: function toggleLink(editorState, targetSelection, entityKey) {
    var withoutLink = DraftModifier.applyEntity(editorState.getCurrentContent(), targetSelection, entityKey);
    return EditorState.push(editorState, withoutLink, 'apply-entity');
  },

  /**
   * When a collapsed cursor is at the start of a styled block, changes block
   * type to 'unstyled'. Returns null if selection does not meet that criteria.
   */
  tryToRemoveBlockStyle: function tryToRemoveBlockStyle(editorState) {
    var selection = editorState.getSelection();
    var offset = selection.getAnchorOffset();

    if (selection.isCollapsed() && offset === 0) {
      var key = selection.getAnchorKey();
      var content = editorState.getCurrentContent();
      var block = content.getBlockForKey(key);
      var type = block.getType();
      var blockBefore = content.getBlockBefore(key);

      if (type === 'code-block' && blockBefore && blockBefore.getType() === 'code-block' && blockBefore.getLength() !== 0) {
        return null;
      }

      if (type !== 'unstyled') {
        return DraftModifier.setBlockType(content, selection, 'unstyled');
      }
    }

    return null;
  }
};
module.exports = RichTextEditorUtil;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(885);


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(886);
var BeforeInputEventPlugin = __webpack_require__(887);
var ChangeEventPlugin = __webpack_require__(891);
var DefaultEventPluginOrder = __webpack_require__(894);
var EnterLeaveEventPlugin = __webpack_require__(895);
var HTMLDOMPropertyConfig = __webpack_require__(896);
var ReactComponentBrowserEnvironment = __webpack_require__(897);
var ReactDOMComponent = __webpack_require__(903);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactDOMEmptyComponent = __webpack_require__(927);
var ReactDOMTreeTraversal = __webpack_require__(928);
var ReactDOMTextComponent = __webpack_require__(929);
var ReactDefaultBatchingStrategy = __webpack_require__(399);
var ReactEventListener = __webpack_require__(930);
var ReactInjection = __webpack_require__(932);
var ReactReconcileTransaction = __webpack_require__(933);
var SVGDOMPropertyConfig = __webpack_require__(939);
var SelectEventPlugin = __webpack_require__(940);
var SimpleEventPlugin = __webpack_require__(941);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(12);

var invariant = __webpack_require__(6);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(32);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(12);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(92);

var invariant = __webpack_require__(6);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(21);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  inst._wrapperState.valueTracker = null;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(32);
var escapeTextContentForBrowser = __webpack_require__(170);
var setInnerHTML = __webpack_require__(169);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(103);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactInstrumentation = __webpack_require__(45);

var quoteAttributeValueForBrowser = __webpack_require__(912);
var warning = __webpack_require__(18);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(8);

var LinkedValueUtils = __webpack_require__(244);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactUpdates = __webpack_require__(52);

var warning = __webpack_require__(18);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(12);

var React = __webpack_require__(85);

var invariant = __webpack_require__(6);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(12);

var invariant = __webpack_require__(6);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(12);

var ReactCurrentOwner = __webpack_require__(62);
var REACT_ELEMENT_TYPE = __webpack_require__(923);

var getIteratorFn = __webpack_require__(924);
var invariant = __webpack_require__(6);
var KeyEscapeUtils = __webpack_require__(250);
var warning = __webpack_require__(18);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(111);

var ReactCurrentOwner = __webpack_require__(62);

var invariant = __webpack_require__(112);
var warning = __webpack_require__(145);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(8);

var PooledClass = __webpack_require__(92);
var Transaction = __webpack_require__(167);
var ReactInstrumentation = __webpack_require__(45);
var ReactServerUpdateQueue = __webpack_require__(926);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(8);

var ReactUpdates = __webpack_require__(52);
var Transaction = __webpack_require__(167);

var emptyFunction = __webpack_require__(65);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(65);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMSelection = __webpack_require__(934);

var containsNode = __webpack_require__(936);
var focusNode = __webpack_require__(389);
var getActiveElement = __webpack_require__(402);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(12);

var DOMLazyTree = __webpack_require__(104);
var DOMProperty = __webpack_require__(103);
var React = __webpack_require__(85);
var ReactBrowserEventEmitter = __webpack_require__(171);
var ReactCurrentOwner = __webpack_require__(62);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactDOMContainerInfo = __webpack_require__(404);
var ReactDOMFeatureFlags = __webpack_require__(951);
var ReactFeatureFlags = __webpack_require__(384);
var ReactInstanceMap = __webpack_require__(127);
var ReactInstrumentation = __webpack_require__(45);
var ReactMarkupChecksum = __webpack_require__(405);
var ReactReconciler = __webpack_require__(93);
var ReactUpdateQueue = __webpack_require__(251);
var ReactUpdates = __webpack_require__(52);

var emptyObject = __webpack_require__(247);
var instantiateReactComponent = __webpack_require__(246);
var invariant = __webpack_require__(6);
var setInnerHTML = __webpack_require__(169);
var shouldUpdateReactComponent = __webpack_require__(249);
var warning = __webpack_require__(18);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var validateDOMNesting = __webpack_require__(252);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var adler32 = __webpack_require__(952);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactNodeTypes = __webpack_require__(393);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var KeyBindingUtil = __webpack_require__(234);

var Keys = __webpack_require__(163);

var UserAgent = __webpack_require__(31);

var isOSX = UserAgent.isPlatform('Mac OS X'); // Firefox on OSX had a bug resulting in navigation instead of cursor movement.
// This bug was fixed in Firefox 29. Feature detection is virtually impossible
// so we just check the version number. See #342765.

var shouldFixFirefoxMovement = isOSX && UserAgent.isBrowser('Firefox < 29');
var hasCommandModifier = KeyBindingUtil.hasCommandModifier,
    isCtrlKeyCommand = KeyBindingUtil.isCtrlKeyCommand;

function shouldRemoveWord(e) {
  return isOSX && e.altKey || isCtrlKeyCommand(e);
}
/**
 * Get the appropriate undo/redo command for a Z key command.
 */


function getZCommand(e) {
  if (!hasCommandModifier(e)) {
    return null;
  }

  return e.shiftKey ? 'redo' : 'undo';
}

function getDeleteCommand(e) {
  // Allow default "cut" behavior for PCs on Shift + Delete.
  if (!isOSX && e.shiftKey) {
    return null;
  }

  return shouldRemoveWord(e) ? 'delete-word' : 'delete';
}

function getBackspaceCommand(e) {
  if (hasCommandModifier(e) && isOSX) {
    return 'backspace-to-start-of-line';
  }

  return shouldRemoveWord(e) ? 'backspace-word' : 'backspace';
}
/**
 * Retrieve a bound key command for the given event.
 */


function getDefaultKeyBinding(e) {
  switch (e.keyCode) {
    case 66:
      // B
      return hasCommandModifier(e) ? 'bold' : null;

    case 68:
      // D
      return isCtrlKeyCommand(e) ? 'delete' : null;

    case 72:
      // H
      return isCtrlKeyCommand(e) ? 'backspace' : null;

    case 73:
      // I
      return hasCommandModifier(e) ? 'italic' : null;

    case 74:
      // J
      return hasCommandModifier(e) ? 'code' : null;

    case 75:
      // K
      return isOSX && isCtrlKeyCommand(e) ? 'secondary-cut' : null;

    case 77:
      // M
      return isCtrlKeyCommand(e) ? 'split-block' : null;

    case 79:
      // O
      return isCtrlKeyCommand(e) ? 'split-block' : null;

    case 84:
      // T
      return isOSX && isCtrlKeyCommand(e) ? 'transpose-characters' : null;

    case 85:
      // U
      return hasCommandModifier(e) ? 'underline' : null;

    case 87:
      // W
      return isOSX && isCtrlKeyCommand(e) ? 'backspace-word' : null;

    case 89:
      // Y
      if (isCtrlKeyCommand(e)) {
        return isOSX ? 'secondary-paste' : 'redo';
      }

      return null;

    case 90:
      // Z
      return getZCommand(e) || null;

    case Keys.RETURN:
      return 'split-block';

    case Keys.DELETE:
      return getDeleteCommand(e);

    case Keys.BACKSPACE:
      return getBackspaceCommand(e);
    // LEFT/RIGHT handlers serve as a workaround for a Firefox bug.

    case Keys.LEFT:
      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-start-of-block' : null;

    case Keys.RIGHT:
      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-end-of-block' : null;

    default:
      return null;
  }
}

module.exports = getDefaultKeyBinding;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftStringKey = {
  stringify: function stringify(key) {
    return '_' + String(key);
  },
  unstringify: function unstringify(key) {
    return key.slice(1);
  }
};
module.exports = DraftStringKey;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlignBlockRightButton = exports.AlignBlockLeftButton = exports.AlignBlockCenterButton = exports.AlignBlockDefaultButton = exports.CodeBlockButton = exports.BlockquoteButton = exports.OrderedListButton = exports.UnorderedListButton = exports.HeadlineThreeButton = exports.HeadlineTwoButton = exports.HeadlineOneButton = exports.UnderlineButton = exports.CodeButton = exports.SubButton = exports.SupButton = exports.BoldButton = exports.ItalicButton = exports.createInlineStyleButton = exports.createBlockStyleButton = undefined;

var _createBlockStyleButton = __webpack_require__(71);

var _createBlockStyleButton2 = _interopRequireDefault(_createBlockStyleButton);

var _createInlineStyleButton = __webpack_require__(94);

var _createInlineStyleButton2 = _interopRequireDefault(_createInlineStyleButton);

var _ItalicButton = __webpack_require__(983);

var _ItalicButton2 = _interopRequireDefault(_ItalicButton);

var _BoldButton = __webpack_require__(984);

var _BoldButton2 = _interopRequireDefault(_BoldButton);

var _CodeButton = __webpack_require__(985);

var _CodeButton2 = _interopRequireDefault(_CodeButton);

var _UnderlineButton = __webpack_require__(986);

var _UnderlineButton2 = _interopRequireDefault(_UnderlineButton);

var _HeadlineOneButton = __webpack_require__(987);

var _HeadlineOneButton2 = _interopRequireDefault(_HeadlineOneButton);

var _HeadlineTwoButton = __webpack_require__(988);

var _HeadlineTwoButton2 = _interopRequireDefault(_HeadlineTwoButton);

var _HeadlineThreeButton = __webpack_require__(989);

var _HeadlineThreeButton2 = _interopRequireDefault(_HeadlineThreeButton);

var _UnorderedListButton = __webpack_require__(990);

var _UnorderedListButton2 = _interopRequireDefault(_UnorderedListButton);

var _OrderedListButton = __webpack_require__(991);

var _OrderedListButton2 = _interopRequireDefault(_OrderedListButton);

var _BlockquoteButton = __webpack_require__(992);

var _BlockquoteButton2 = _interopRequireDefault(_BlockquoteButton);

var _CodeBlockButton = __webpack_require__(993);

var _CodeBlockButton2 = _interopRequireDefault(_CodeBlockButton);

var _AlignBlockDefaultButton = __webpack_require__(994);

var _AlignBlockDefaultButton2 = _interopRequireDefault(_AlignBlockDefaultButton);

var _AlignBlockCenterButton = __webpack_require__(995);

var _AlignBlockCenterButton2 = _interopRequireDefault(_AlignBlockCenterButton);

var _AlignBlockLeftButton = __webpack_require__(996);

var _AlignBlockLeftButton2 = _interopRequireDefault(_AlignBlockLeftButton);

var _AlignBlockRightButton = __webpack_require__(997);

var _AlignBlockRightButton2 = _interopRequireDefault(_AlignBlockRightButton);

var _SubButton = __webpack_require__(998);

var _SubButton2 = _interopRequireDefault(_SubButton);

var _SupButton = __webpack_require__(999);

var _SupButton2 = _interopRequireDefault(_SupButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.createBlockStyleButton = _createBlockStyleButton2.default;
exports.createInlineStyleButton = _createInlineStyleButton2.default;
exports.ItalicButton = _ItalicButton2.default;
exports.BoldButton = _BoldButton2.default;
exports.SupButton = _SupButton2.default;
exports.SubButton = _SubButton2.default;
exports.CodeButton = _CodeButton2.default;
exports.UnderlineButton = _UnderlineButton2.default;
exports.HeadlineOneButton = _HeadlineOneButton2.default;
exports.HeadlineTwoButton = _HeadlineTwoButton2.default;
exports.HeadlineThreeButton = _HeadlineThreeButton2.default;
exports.UnorderedListButton = _UnorderedListButton2.default;
exports.OrderedListButton = _OrderedListButton2.default;
exports.BlockquoteButton = _BlockquoteButton2.default;
exports.CodeBlockButton = _CodeBlockButton2.default;
exports.AlignBlockDefaultButton = _AlignBlockDefaultButton2.default;
exports.AlignBlockCenterButton = _AlignBlockCenterButton2.default;
exports.AlignBlockLeftButton = _AlignBlockLeftButton2.default;
exports.AlignBlockRightButton = _AlignBlockRightButton2.default;

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Constants__ = __webpack_require__(412);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Constants__["c"]; });
/* unused harmony reexport Constants */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getEntityRanges__ = __webpack_require__(1016);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__getEntityRanges__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getSelectedBlocks__ = __webpack_require__(255);
/* unused harmony reexport getSelectedBlocks */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__selectionContainsEntity__ = __webpack_require__(1017);
/* unused harmony reexport selectionContainsEntity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__callModifierForSelectedBlocks__ = __webpack_require__(1018);
/* unused harmony reexport callModifierForSelectedBlocks */







/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BLOCK_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ENTITY_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INLINE_STYLE; });
var BLOCK_TYPE = {
  // This is used to represent a normal text block (paragraph).
  UNSTYLED: 'unstyled',
  HEADER_ONE: 'header-one',
  HEADER_TWO: 'header-two',
  HEADER_THREE: 'header-three',
  HEADER_FOUR: 'header-four',
  HEADER_FIVE: 'header-five',
  HEADER_SIX: 'header-six',
  UNORDERED_LIST_ITEM: 'unordered-list-item',
  ORDERED_LIST_ITEM: 'ordered-list-item',
  BLOCKQUOTE: 'blockquote',
  PULLQUOTE: 'pullquote',
  CODE: 'code-block',
  ATOMIC: 'atomic'
};
var ENTITY_TYPE = {
  LINK: 'LINK',
  IMAGE: 'IMAGE',
  EMBED: 'embed'
};
var INLINE_STYLE = {
  BOLD: 'BOLD',
  CODE: 'CODE',
  ITALIC: 'ITALIC',
  STRIKETHROUGH: 'STRIKETHROUGH',
  UNDERLINE: 'UNDERLINE'
};
/* unused harmony default export */ var _unused_webpack_default_export = ({
  BLOCK_TYPE: BLOCK_TYPE,
  ENTITY_TYPE: ENTITY_TYPE,
  INLINE_STYLE: INLINE_STYLE
});

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RiskStatement = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _AreaForm = __webpack_require__(28);

var _AreaForm2 = _interopRequireDefault(_AreaForm);

var _riskResponseLabel = __webpack_require__(256);

var _riskResponseLabel2 = _interopRequireDefault(_riskResponseLabel);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

var _FormattedContent = __webpack_require__(15);

var _FormattedContent2 = _interopRequireDefault(_FormattedContent);

var _formDefinition = __webpack_require__(1028);

var _formDefinition2 = _interopRequireDefault(_formDefinition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(129), __webpack_require__(130)]);

var RiskStatement = exports.RiskStatement = function (_React$Component) {
  _inherits(RiskStatement, _React$Component);

  function RiskStatement() {
    _classCallCheck(this, RiskStatement);

    return _possibleConstructorReturn(this, (RiskStatement.__proto__ || Object.getPrototypeOf(RiskStatement)).apply(this, arguments));
  }

  _createClass(RiskStatement, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).general.statement;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 5, fontStyle: "italic", minHeight: "30pt" } },
          labels.if,
          ' ',
          _react2.default.createElement(
            'span',
            { style: { fontStyle: "normal" } },
            '"',
            this.props.cause,
            '"'
          ),
          ' (',
          labels.cause,
          ')',
          _react2.default.createElement(
            'span',
            null,
            ', '
          ),
          this.props.expanded ? _react2.default.createElement('div', { style: { paddingTop: 20 } }) : null,
          labels.thereIsA,
          ' ',
          labels.riskTypeOptions[this.props.type],
          ' ',
          labels.that,
          ' ',
          _react2.default.createElement(
            'span',
            { style: { fontStyle: "normal" } },
            '"',
            this.props.event,
            '"'
          ),
          ' (',
          labels.event,
          ')',
          _react2.default.createElement(
            'span',
            null,
            ', '
          ),
          this.props.expanded ? _react2.default.createElement('div', { style: { paddingTop: 20 } }) : null,
          labels.whichWouldResultIn,
          ' ',
          _react2.default.createElement(
            'span',
            { style: { fontStyle: "normal" } },
            '"',
            this.props.effect,
            '"'
          ),
          ' (',
          labels.effect,
          ').'
        )
      );
    }
  }]);

  return RiskStatement;
}(_react2.default.Component);

var IdentifySummary = function (_React$Component2) {
  _inherits(IdentifySummary, _React$Component2);

  function IdentifySummary() {
    _classCallCheck(this, IdentifySummary);

    return _possibleConstructorReturn(this, (IdentifySummary.__proto__ || Object.getPrototypeOf(IdentifySummary)).apply(this, arguments));
  }

  _createClass(IdentifySummary, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { height: "10pt" } },
          _react2.default.createElement(
            'b',
            null,
            this.props.no !== undefined ? this.props.no + ". " : "",
            this.props.title
          )
        ),
        _react2.default.createElement(RiskStatement, this.props)
      );
    }
  }]);

  return IdentifySummary;
}(_react2.default.Component);

var ImplementSummary = function (_React$Component3) {
  _inherits(ImplementSummary, _React$Component3);

  function ImplementSummary() {
    _classCallCheck(this, ImplementSummary);

    return _possibleConstructorReturn(this, (ImplementSummary.__proto__ || Object.getPrototypeOf(ImplementSummary)).apply(this, arguments));
  }

  _createClass(ImplementSummary, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(IdentifySummary, this.props),
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 10 } },
          _react2.default.createElement(
            'div',
            { style: { fontWeight: "bold" } },
            'Plan'
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_FormattedContent2.default, { value: this.props.action }),
            ' (',
            (0, _riskResponseLabel2.default)(this.props.response, this.props.language),
            ')'
          )
        )
      );
    }
  }]);

  return ImplementSummary;
}(_react2.default.Component);

var RiskForm = function (_React$Component4) {
  _inherits(RiskForm, _React$Component4);

  function RiskForm(props) {
    _classCallCheck(this, RiskForm);

    var _this4 = _possibleConstructorReturn(this, (RiskForm.__proto__ || Object.getPrototypeOf(RiskForm)).call(this, props));

    _this4.state = { item: props.item };
    return _this4;
  }

  _createClass(RiskForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState({ modified: undefined, item: props.item });
    }
  }, {
    key: 'handleFieldChange',
    value: function handleFieldChange(fieldName) {
      var _this5 = this;

      return function (event) {
        _this5.setState({
          item: Object.assign({}, _this5.state.item, _defineProperty({}, fieldName, event.target.value)),
          modified: true
        });
      };
    }
  }, {
    key: 'submitForm',
    value: function submitForm(event) {
      event.preventDefault();
      var formValues = {};
      for (var i = 0; i < event.target.elements.length; i++) {
        var value = event.target.elements[i].value;
        if (value.trim().length === 0) {
          value = undefined;
        }
        formValues[event.target.elements[i].name] = value;
      }
      formValues.cancel = undefined;
      formValues.save = undefined;
      this.props.onCommand({ type: "update", item: formValues });
    }
  }, {
    key: 'update',
    value: function update(item) {
      console.log("Update");
      this.props.onCommand({ type: "update", item: item });
    }
  }, {
    key: 'cancelForm',
    value: function cancelForm(event) {
      event.preventDefault();
      this.props.onCommand({ type: "cancel" });
    }
  }, {
    key: 'summary',
    value: function summary(tab, details) {
      var content = undefined;
      var value = details.values;
      var oldValues = details.oldValues;
      switch (tab) {
        case "identify":
        case "assess":
        case "plan":
          content = _react2.default.createElement(IdentifySummary, _extends({}, this.state.item, { language: this.props.language }));
          break;
        case "implement":
          content = _react2.default.createElement(ImplementSummary, _extends({}, this.state.item, { language: this.props.language }));
          break;
      }
      return content !== undefined ? _react2.default.createElement(
        'div',
        { style: { fontFamily: "Arial", fontSize: "10pt", padding: 10 } },
        content
      ) : null;
    }
  }, {
    key: 'trialDefinition',
    value: function trialDefinition(definition, useTrial) {
      var includeField = function includeField(field) {
        return field.name !== "assessment" && field.name !== "impact" && field.name !== "probability" ? true : field.name === "assessment" && useTrial === true ? true : useTrial !== true && field.name !== "assessment" ? true : false;
      };
      var updateField = function updateField(field) {
        return includeField(field) ? field : undefined;
      };
      var updateArea = function updateArea(area) {
        return area.name === "assess" ? Object.assign({}, area, {
          fields: area.fields.filter(function (field) {
            return updateField(field);
          })
        }) : area;
      };
      return definition.map(function (area) {
        return updateArea(area);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var item = this.state.item !== undefined ? Object.assign({}, this.state.item) : {};
      if (this.props.trial) {
        if (item.assessment === undefined) {
          item.assessment = {
            no: item.no,
            hideCategories: item.inherentRisk === undefined && item.impact === undefined && item.probability === undefined,
            category: item.inherentRisk === undefined ? "inherent" : "residual",
            inherent: item.inherentRisk !== undefined ? item.inherentRisk : {
              impact: item.impact,
              probability: item.probability
            },
            residual: {
              impact: item.impact,
              probability: item.probability
            }
          };
        }
        if (item.no !== undefined && item.assessment !== undefined && item.no !== item.assessment.no) {
          //Ensure no is set on assessment after save of new item
          item.assessment.no = item.no;
        }
        item.assessment.hide = item.status === "Closed";
      }
      var closedDate = item.status === "Closed" && item.closed !== undefined ? ["Closed at " + item.closed.substring(0, 10)] : undefined;
      var areas = translations.createTranslatedForm(this.trialDefinition(_formDefinition2.default, this.props.trial), this.props.language, this.props.variant);
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { display: "flex", justifyContent: "center" } },
          _react2.default.createElement(
            'div',
            { style: { flexBasis: "100%", maxWidth: 1016, minWidth: 250 } },
            _react2.default.createElement(_AreaForm2.default, _extends({}, this.props, {
              areas: areas,
              display: 'tab',
              item: Object.assign({}, item, {
                _progress: item.id !== undefined ? "implement" : "identify"
              }),
              onUpdate: this.update.bind(this),
              onCancel: this.cancelForm.bind(this),
              summary: this.summary.bind(this),
              modified: this.state.modified,
              updatedItem: item,
              handleFieldChange: this.handleFieldChange.bind(this),
              label: 'Risk'
            }))
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "none", paddingTop: 30, paddingBottom: 80, clear: "left", float: "none" } },
          _react2.default.createElement('input', { className: 'cancel', type: 'button', onClick: this.cancelForm.bind(this), name: 'cancel', value: 'Cancel' }),
          _react2.default.createElement('input', { className: 'save', style: { marginLeft: 15 }, type: 'submit', name: 'save', value: item.id === undefined ? "Add risk" : "Update risk" })
        )
      );
    }
  }]);

  return RiskForm;
}(_react2.default.Component);

exports.default = RiskForm;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _priority = __webpack_require__(102);

var _priority2 = _interopRequireDefault(_priority);

var _riskResponseLabel = __webpack_require__(256);

var _riskResponseLabel2 = _interopRequireDefault(_riskResponseLabel);

var _Risk = __webpack_require__(63);

var _RiskForm = __webpack_require__(413);

var _FormattedContent = __webpack_require__(15);

var _FormattedContent2 = _interopRequireDefault(_FormattedContent);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(129), __webpack_require__(130)]);

var PresentationView = function (_React$Component) {
  _inherits(PresentationView, _React$Component);

  function PresentationView(props) {
    _classCallCheck(this, PresentationView);

    var _this = _possibleConstructorReturn(this, (PresentationView.__proto__ || Object.getPrototypeOf(PresentationView)).call(this, props));

    _this.state = { selected: props.items.filter(function (item) {
        return item.id === props.selected;
      })[0],
      showClosed: _this.props.showClosed };
    return _this;
  }

  _createClass(PresentationView, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var reportStyle = { textAlign: "left", maxWidth: 1016 };
      var style = Object.assign({}, reportStyle, this.props.settings !== undefined ? this.props.settings.style : undefined);
      return _react2.default.createElement(
        'div',
        null,
        this.props.fullPage !== true ? _react2.default.createElement(
          'div',
          { style: { textAlign: "center" } },
          _react2.default.createElement(
            'div',
            { style: { textAlign: "left" } },
            _react2.default.createElement(PresentationMenu, _extends({}, this.props, {
              selected: this.state.selected,
              showClosed: this.state.showClosed,
              onSelect: function onSelect(item) {
                return _this2.setState({ selected: item });
              },
              onShowAll: function onShowAll(event) {
                event.preventDefault();_this2.setState({ selected: undefined, showClosed: true });
              },
              onShowAllOpen: function onShowAllOpen(event) {
                event.preventDefault();_this2.setState({ selected: undefined, showClosed: false });
              },
              onEdit: function onEdit(event) {
                event.preventDefault();if (_this2.state.selected !== undefined) _this2.props.onEdit(_this2.state.selected);
              }
            }))
          )
        ) : null,
        _react2.default.createElement(
          'div',
          { style: { display: "inline-block", padding: 5, paddingLeft: 10, fontFamily: "Verdana, sans-serif", justifyContent: "center" } },
          _react2.default.createElement(
            'div',
            { className: 'report', style: style },
            this.props.items.map(function (item) {
              return _this2.state.selected === undefined || item.id === _this2.state.selected.id ? _this2.state.showClosed === false && item.status === "Closed" && _this2.state.selected === undefined ? null : _react2.default.createElement(PresentRisk, _extends({ key: item.id }, _this2.props, { item: item })) : null;
            })
          )
        )
      );
    }
  }]);

  return PresentationView;
}(_react2.default.Component);

exports.default = PresentationView;

var PresentRisk = function (_React$Component2) {
  _inherits(PresentRisk, _React$Component2);

  function PresentRisk() {
    _classCallCheck(this, PresentRisk);

    return _possibleConstructorReturn(this, (PresentRisk.__proto__ || Object.getPrototypeOf(PresentRisk)).apply(this, arguments));
  }

  _createClass(PresentRisk, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      return _react2.default.createElement(
        'div',
        { style: { paddingBottom: 100 } },
        _react2.default.createElement(
          'div',
          { style: { fontWeight: "bold", paddingBottom: 20 } },
          this.props.item.title
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "flex", flexWrap: "wrap" } },
          this.props.item.status !== "Closed" ? _react2.default.createElement(
            'div',
            { style: { paddingRight: 40, paddingBottom: 20 } },
            _react2.default.createElement(_Risk.RiskTable, _extends({}, this.props, { items: [this.props.item] }))
          ) : null,
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { style: { display: "table", borderCollapse: "collapse", border: "solid 1px #f7f7f7", width: "100%" } },
              _react2.default.createElement(DetailsRow, { label: labels.identify.fields.owner.title, value: this.props.item.owner }),
              _react2.default.createElement(DetailsRow, { label: labels.identify.fields.type.title, value: labels.identify.fields.type.options[this.props.item.type] }),
              _react2.default.createElement(DetailsRow, { label: labels.identify.fields.category.title, value: labels.identify.fields.category.options[this.props.item.category] }),
              _react2.default.createElement(DetailsRow, { label: labels.assess.fields.proximity.title, value: this.props.item.proximity }),
              _react2.default.createElement(DetailsRow, { label: labels.plan.fields.response.title, value: labels.plan.fields.response.options[this.props.item.response] }),
              _react2.default.createElement(DetailsRow, { label: labels.plan.fields.actionee.title, value: this.props.item.actionee }),
              _react2.default.createElement(DetailsRow, { label: labels.implement.fields.status.title, value: labels.implement.fields.status.options[this.props.item.status] })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 15 } },
          _react2.default.createElement(
            'b',
            null,
            labels.general.riskStatement
          ),
          _react2.default.createElement(_RiskForm.RiskStatement, _extends({}, this.props, this.props.item, { expanded: true }))
        ),
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 15 } },
          _react2.default.createElement(
            'div',
            { style: { fontWeight: "bold" } },
            labels.plan.fields.action.title
          ),
          _react2.default.createElement(
            'div',
            { style: { display: "flex", alignItems: "center" } },
            _react2.default.createElement(_FormattedContent2.default, { value: this.props.item.action }),
            _react2.default.createElement(
              'div',
              { style: { paddingLeft: 10 } },
              '(',
              _react2.default.createElement(
                'i',
                null,
                (0, _riskResponseLabel2.default)(this.props.item.response, this.props.language)
              ),
              ')'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 15 } },
          _react2.default.createElement(
            'div',
            { style: { fontWeight: "bold" } },
            labels.implement.fields.comments.title
          ),
          _react2.default.createElement(_FormattedContent2.default, { value: this.props.item.comments })
        ),
        _react2.default.createElement('div', { style: { position: "relative", pageBreakAfter: "always", pageBreakInside: "avoid" } })
      );
    }
  }]);

  return PresentRisk;
}(_react2.default.Component);

var DetailsRow = function (_React$Component3) {
  _inherits(DetailsRow, _React$Component3);

  function DetailsRow() {
    _classCallCheck(this, DetailsRow);

    return _possibleConstructorReturn(this, (DetailsRow.__proto__ || Object.getPrototypeOf(DetailsRow)).apply(this, arguments));
  }

  _createClass(DetailsRow, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { display: "table-row" } },
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", padding: 5, paddingRight: 20, fontWeight: "bold", border: "solid lightgrey 1px", backgroundColor: "#e9e7e6" } },
          this.props.label
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", padding: 5, paddingRight: 20, border: "solid lightgrey 1px" } },
          this.props.value
        )
      );
    }
  }]);

  return DetailsRow;
}(_react2.default.Component);

var PresentationMenu = function (_React$Component4) {
  _inherits(PresentationMenu, _React$Component4);

  function PresentationMenu() {
    _classCallCheck(this, PresentationMenu);

    return _possibleConstructorReturn(this, (PresentationMenu.__proto__ || Object.getPrototypeOf(PresentationMenu)).apply(this, arguments));
  }

  _createClass(PresentationMenu, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).views.present.menu;
      return _react2.default.createElement(
        'div',
        { style: { display: "inline-block", float: "right", marginRight: 30, width: 250, borderLeft: "solid lightgrey 1px", paddingTop: 10, paddingLeft: 10, paddingBottom: 150 } },
        this.props.view !== "presentOnly" ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { style: { paddingLeft: 10, paddingBottom: 20 } },
            _react2.default.createElement(
              'a',
              { href: '#', onClick: this.props.onShowListView },
              '<- ',
              labels.backToRiskRegister
            )
          ),
          _react2.default.createElement(
            'b',
            null,
            labels.title
          ),
          _react2.default.createElement(
            'div',
            { style: { display: "none", paddingLeft: 10 } },
            _react2.default.createElement(
              'a',
              { href: "risk?details=presentation" + (this.props.selected !== undefined ? "&selected=" + this.props.selected.id : "") + "&fullPage=true", target: '_blank' },
              labels.viewFullScreen
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingLeft: 10, paddingBottom: 10 } },
            _react2.default.createElement(
              'a',
              { href: "risk?details=presentation" + (this.props.selected !== undefined ? "&selected=" + this.props.selected.id : "") + "&fullPage=true&pdf=true&showClosed=" + this.props.showClosed, target: '_blank' },
              labels.viewPDF
            )
          ),
          this.props.showClosed !== true || this.props.selected !== undefined ? _react2.default.createElement(
            'div',
            { style: { paddingLeft: 10 } },
            _react2.default.createElement(
              'a',
              { href: '#', onClick: this.props.onShowAll },
              labels.allRiskItems
            )
          ) : null,
          this.props.showClosed === true || this.props.selected !== undefined ? _react2.default.createElement(
            'div',
            { style: { paddingLeft: 10 } },
            _react2.default.createElement(
              'a',
              { href: '#', onClick: this.props.onShowAllOpen },
              'Show open risks'
            )
          ) : null,
          this.props.selected !== undefined && this.props.selected.readOnly !== true ? _react2.default.createElement(
            'div',
            { style: { paddingLeft: 10, paddingTop: 10 } },
            _react2.default.createElement(
              'a',
              { href: '#', onClick: this.props.onEdit },
              labels.editRiskItem
            )
          ) : null
        ) : null,
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 15 } },
          _react2.default.createElement(
            'div',
            { style: { fontWeight: "bold" } },
            ' ',
            labels.selectRiskItem,
            ': '
          ),
          _react2.default.createElement(RiskList, this.props)
        )
      );
    }
  }]);

  return PresentationMenu;
}(_react2.default.Component);

var RiskListEntry = function (_React$Component5) {
  _inherits(RiskListEntry, _React$Component5);

  function RiskListEntry(props) {
    _classCallCheck(this, RiskListEntry);

    var _this6 = _possibleConstructorReturn(this, (RiskListEntry.__proto__ || Object.getPrototypeOf(RiskListEntry)).call(this, props));

    _this6.state = { hover: false };
    return _this6;
  }

  _createClass(RiskListEntry, [{
    key: 'toggleHover',
    value: function toggleHover(event) {
      event.preventDefault();
      this.setState({ hover: !this.state.hover });
    }
  }, {
    key: 'selectItem',
    value: function selectItem() {
      if (this.props.onSelect !== undefined) {
        this.props.onSelect(this.props.item);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var item = this.props.item;
      var bgColor = this.state.hover ? "#f1fbfe" : this.props.backgroundColor;
      return _react2.default.createElement(
        'div',
        {
          onClick: this.selectItem.bind(this),
          onMouseEnter: this.toggleHover.bind(this),
          onMouseLeave: this.toggleHover.bind(this),
          style: {
            cursor: "pointer", display: "table-row", textAlign: "left",
            backgroundColor: bgColor,
            borderBottom: "solid 1px #939393",
            color: item.status === "Closed" ? "lightgrey" : "#212121",
            textDecoration: item.status === "Closed" ? "line-through" : "none" }
        },
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 2, paddingLeft: 1, paddingRight: 5 } },
          _react2.default.createElement(
            'div',
            { style: { display: "table-cell,inline-block", marginTop: 4, padding: 8, borderRadius: "50%", width: 0, hight: 15, backgroundColor: _priority2.default.priorityColor(item, this.props.profile) } },
            ' '
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", fontWeight: "normal", textAlign: "center", padding: 5 } },
          item.no
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", padding: 5 } },
          item.title
        )
      );
    }
  }]);

  return RiskListEntry;
}(_react2.default.Component);

var RiskList = function (_React$Component6) {
  _inherits(RiskList, _React$Component6);

  function RiskList() {
    _classCallCheck(this, RiskList);

    return _possibleConstructorReturn(this, (RiskList.__proto__ || Object.getPrototypeOf(RiskList)).apply(this, arguments));
  }

  _createClass(RiskList, [{
    key: 'render',
    value: function render() {
      var _this8 = this;

      var labels = translations.getTranslation(this.props);
      var selectItem = this.props.onSelect;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { display: "table", width: "100%", borderCollapse: "collapse", borderBottom: "solid 1px #939393" } },
          _react2.default.createElement(
            'div',
            { style: { display: "table-row", pageBreakInside: "avoid", backgroundColor: "#ffffff", color: "#ffffff", fontWeight: "bold", textAlign: "left" } },
            _react2.default.createElement('div', { style: { display: "table-cell", paddingTop: 5, paddingBottom: 5, paddingLeft: 5, pageBreakInside: "avoid" } }),
            _react2.default.createElement('div', { style: { display: "table-cell", padding: 5, pageBreakInside: "avoid" } }),
            _react2.default.createElement('div', { style: { display: "table-cell", padding: 5, pageBreakInside: "avoid" } })
          ),
          this.props.items.map(function (item, index) {
            return _react2.default.createElement(RiskListEntry, _extends({
              key: item.id
            }, _this8.props, {
              item: item,
              onSelect: selectItem,
              backgroundColor: _this8.props.selected !== undefined && item.id === _this8.props.selected.id ? "#d4e9f2" : index % 2 === 1 ? "#f7f7f7" : "white"
            }));
          })
        )
      );
    }
  }]);

  return RiskList;
}(_react2.default.Component);

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _FormattedContent = __webpack_require__(15);

var _FormattedContent2 = _interopRequireDefault(_FormattedContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var diff = __webpack_require__(1030);

var Removed = function (_React$Component) {
  _inherits(Removed, _React$Component);

  function Removed() {
    _classCallCheck(this, Removed);

    return _possibleConstructorReturn(this, (Removed.__proto__ || Object.getPrototypeOf(Removed)).apply(this, arguments));
  }

  _createClass(Removed, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        { style: { backgroundColor: "#FFE7E7", textDecoration: "line-through" } },
        _react2.default.createElement(_FormattedContent2.default, { value: this.props.value })
      );
    }
  }]);

  return Removed;
}(_react2.default.Component);

var Added = function (_React$Component2) {
  _inherits(Added, _React$Component2);

  function Added() {
    _classCallCheck(this, Added);

    return _possibleConstructorReturn(this, (Added.__proto__ || Object.getPrototypeOf(Added)).apply(this, arguments));
  }

  _createClass(Added, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        { style: { backgroundColor: "#DDFADE" } },
        _react2.default.createElement(_FormattedContent2.default, { value: this.props.value })
      );
    }
  }]);

  return Added;
}(_react2.default.Component);

var Diff = function (_React$Component3) {
  _inherits(Diff, _React$Component3);

  function Diff() {
    _classCallCheck(this, Diff);

    return _possibleConstructorReturn(this, (Diff.__proto__ || Object.getPrototypeOf(Diff)).apply(this, arguments));
  }

  _createClass(Diff, [{
    key: 'render',
    value: function render() {
      if (this.props.newValue !== undefined && this.props.newValue !== null && this.props.value === this.props.newValue) {
        return _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(_FormattedContent2.default, { value: this.props.value })
        );
      } else {
        if (this.props.value !== undefined && this.props.value !== null && this.props.newValue !== undefined && this.props.newValue !== null) {
          var difference = diff.diffWords(this.props.value, this.props.newValue);
          return _react2.default.createElement(
            'span',
            null,
            difference.map(function (part, index) {
              return part.added ? _react2.default.createElement(Added, { key: index, value: part.value }) : part.removed ? _react2.default.createElement(Removed, { key: index, value: part.value }) : _react2.default.createElement(
                'span',
                { key: index },
                _react2.default.createElement(_FormattedContent2.default, { value: part.value })
              );
            })
          );
        } else {
          return _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(Removed, { value: this.props.value })
            ),
            _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(Added, { value: this.props.newValue })
            )
          );
        }
      }
    }
  }]);

  return Diff;
}(_react2.default.Component);

exports.default = Diff;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _FormattedContent = __webpack_require__(15);

var _FormattedContent2 = _interopRequireDefault(_FormattedContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReportSection = function (_React$Component) {
  _inherits(ReportSection, _React$Component);

  function ReportSection() {
    _classCallCheck(this, ReportSection);

    return _possibleConstructorReturn(this, (ReportSection.__proto__ || Object.getPrototypeOf(ReportSection)).apply(this, arguments));
  }

  _createClass(ReportSection, [{
    key: 'render',
    value: function render() {
      return this.props.optionalIfEmpty === true && (this.props.value === undefined || this.props.value.trim().length === 0 || this.props.value === "<p></p>" || this.props.value === "<ul></ul>") ? null : _react2.default.createElement(
        'div',
        { style: { display: "table", width: "100%", marginTop: 15, paddingTop: 15, borderCollapse: "collapse", border: "solid 1px #4472C4" } },
        _react2.default.createElement(
          'div',
          { style: { display: "table-row", backgroundColor: "#4472C4", color: "white", fontWeitgh: "bold" } },
          _react2.default.createElement(
            'div',
            { style: { display: "table-cell", width: "100%", padding: 5 } },
            this.props.label
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table-row" } },
          _react2.default.createElement(
            'div',
            { style: { display: "table-cell" } },
            _react2.default.createElement(
              'div',
              { style: { padding: 5, paddingBottom: 15 } },
              _react2.default.createElement(_FormattedContent2.default, { value: this.props.value })
            )
          )
        )
      );
    }
  }]);

  return ReportSection;
}(_react2.default.Component);

exports.default = ReportSection;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatDate;
function formatDate(date, emptyValue) {
  return date !== undefined ? new Date(Date.parse(date)).toISOString().substring(0, 10) : emptyValue;
}

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var endStageReport_fields = __webpack_require__(419).english_endStage;

var english = exports.english = {
  log: {
    eventLog: "Event Log",
    logDescription: "Who did what, when? The event log is showing all events throughout the history of the activity. You can filter on content of the 'Event' column by entering a key word to filter on.",
    eventFilter: "Enter event filter",
    applyFilter: "Apply Filter",
    filterExamples: "E.g.: Add, Risk, Issue, Person, Role",
    filteredOn: "Event column now filtered on '",
    date: "Date",
    event: "Event",
    details: "Details",
    performedBy: "Performed by"
  },
  projectChanged: {
    types: {
      updatedProjectBackground: "Why is the project initiated?",
      updatedProjectTiming: "Why now?",
      updatedProjectBigPicture: "The bigger picture",
      changedProjectName: "name",
      changedProjectIdentifier: "identifier",
      changedProjectLocation: "location",
      changedProjectDepartment: "department",
      changedProjectPortfolio: "portfolio",
      changedProjectCategory: "category",
      changedProjectType: "project type",

      changedProgrammeName: "name",
      changedProgrammeIdentifier: "identifier",
      changedProgrammePortfolio: "portfolio",
      changedProgrammeLocation: "location",
      changedProgrammeDepartment: "department",
      updatedProgrammeBackground: "Justification and context",
      updatedProgrammeTiming: "Why now?",
      updatedProgrammeSuccessFactors: "Success Factors",

      updatedProjectCurrency: "Currency",

      changedProductName: "name",
      changedProductIdentifier: "identifier",
      changedProductPortfolio: "portfolio",
      changedProductDepartment: "department",
      changedProductLocation: "location",
      updatedProductDefinitionDescription: "description",
      updatedProductDefinitionBackground: "background",
      updatedProductDefinitionVision: "vision",

      changedReleasePortfolio: "portfolio",
      changedReleaseIdentifier: "identifier",

      unknownType: "(unknown)"
    },
    changed: "Changed",
    to: "to",
    previous: "previous value"
  },
  report: {
    highlight: {
      title: "Highlight Report",
      endStageReport: "End Stage Report",
      endProjectReport: "End Project Report",
      projectDeliverables: "Delivered by this project",
      summary: "Summary",
      benefits: "Benefits",
      time: "Time",
      cost: "Cost",
      quality: "Quality",
      scope: "Scope",
      risk: "Risk",
      currentPeriod: "This period",
      nextPeriod: "Next period",
      aspect: "Aspect",
      status: "Status",
      description: "Description",
      from: "from",
      issues: "Issues",
      draftSaved: "Draft saved",
      preview: "Preview",
      teamPerformance: "Team performance",
      lessonsDescription: "Lessons",
      undefinedDate: "<not defined>",
      deliveryStatus: endStageReport_fields.Overview.fields.performedAchivements.title,
      start: "Start",
      end: "End",
      managedBy: "Managed by",
      listLimitedTo: "In this report, the above list is limited to the",
      top5Risks: "top 5 risks",
      top5Issues: "top 5 issues"
    },
    issue: {
      title: "Issue Report",
      exceptionTitle: "Exception Report",
      impact: "Impact",
      type: "Issue Type",
      typeValues: {
        change: "Request for change",
        specification: "Off-specification",
        problem: "Problem / concern"
      },
      severity: "Severity",
      severityValues: ["Undefined", "Negligible", "Minor", "Moderate", "Significant", "Severe"],
      priority: "Priority",
      priorityValues: ["Undefined", "Very Low", "Low", "Medium", "High", "Very High"],
      options: "Options",
      recommendation: "Recommendation",
      lessonSummary: "Lessons",
      decision: "Decision",
      decidedBy: "Decision made by",
      status: "Status",
      closed: "Closed",
      active: "Active",
      previewGenerated: "Preview generated"
    }
  }
};

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var english_endStage = exports.english_endStage = {
  Overview: {
    fields: {
      period: {
        title: "Stage period",
        help: "Select the actual period for this Stage. Double click on a date in the calendar to make it the starting date of the stage. Single click on a date to make it the end date."
      },
      summary: {
        help: "What was the main intention or goal with this stage and did we achieve it? Did we have any breakthroughs or major failures?",
        description: "Describe main objectives of this stage and to what extent these objectives were met"
      },
      performedAchivements: {
        title: "Delivered this Stage",
        help: "What did we deliver this stage? Is there something we planned to deliver, but did not complete?",
        description: "Describe the products delivered during this stage"

      },

      benefits: {
        help: "With this stage completed, are we on track to deliver the desired return of investment? If not, what is the difference and why? Any new benefits added to, or removed from, the business case during this stage?",
        description: "Describe how the planned benefits and the business case have been impacted by the execution of this stage"
      },
      time: {
        help: "What was the duration planned for this stage? Did we stay within the time constraints? If not, what was the main reason?\n              Did we use any of the time tolerance for the stage?\n              Did we have any formal exceptions changing the duration of the stage plan - if so, what was the change and why?\n              How are we now forecasting remaining time for the project, and how does that forecast compare to the baseline project plan?",
        description: "Describe the time objective for this stage and to what extent the execution of the stage happened within the planned time"
      },
      cost: {
        help: "What was the cost planned for this stage? Did we stay within the planned cost? If not, what was the main reason?\n              Did we use any of the cost tolerance for the stage?\n              Did we have any formal exceptions changing the stage cost - if so, what was the change and why?\n              How are we now forecasting remaining cost for the project and how does that compare to the baseline project cost?",
        description: "Summarize what the planned cost was for the stage, what the actual cost ended up being and explain any deviance"
      },

      quality: {
        help: "Did we have the needed clarity on requirements, formats or other quality criteria for the planned stage deliverables?\n          Have products delivered this stage met the agreed requirements or quality criteria?\n          If not, which products failed to meet which criteria and why?\n          Have the acceptance methods (testing, reviews...) for the products this stage been applied as agreed?\n          How are we now judging the overall quality delivered in the project, and will we meet the needed quality level for the end project product?",
        description: "Describe to what extent the deliverables this stage met the requirements, formats or other quality criteria agreed up front"
      },
      scope: {
        help: "Did we in this stage have sufficient clarity on what to deliver?\n              Did we deliver the products planned for? Did we do more or did we do less?\n              Did we change any scope during this stage?\n              Do we have sufficient clarity on what to deliver for the rest of the project - if not, what is missing?",
        description: "Describe to what extent this stage delivered the products planned for"
      },

      risk: {
        help: "Have we managed to keep the risk level at the appropriate level during this stage? Has the total risk exposure increased or decreased for the project during this stage? Were new severe risks identified this stage? Were any important risk mitigations implemented?",
        description: "Describe how the risk level for the project has changed during this stage"
      },

      teamPerformance: {
        help: "Has there been sufficient clarity on roles and responsibilities this stage? Did the team have the skills and capacity needed? Did we have any changes to the team during the stage? If so, how did it affect the performance? Any particular good performance in the team to be recognized?",
        description: "Describe the project team’s performance, in particular, recognition of good performance."
      },
      lessonsDescription: {
        help: "What went well, what went badly and what are the recommendations for future stages and projects of similar nature? What are the key lessons learned? How should these lessons be stored and reused?",
        description: "Summarize the lessons learned in this stage."
      }
    }
  }
};

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var endStageReport_fields = __webpack_require__(421).norwegian_endStage;

var norwegian = exports.norwegian = {
  log: {
    eventLog: "Hendelseslogg",
    logDescription: "Hvem gjorde hva, når? Hendelsesloggen viser alle hendelser som har vært gjennom aktivitetens historie. Du kan filtrere innholdet i 'Hendelse'-kolonnen ved å legge inn nøkkelord å filtrere på.",
    eventFilter: "Legg inn hendelsesfilter",
    applyFilter: "Bruk filter",
    filterExamples: "F.eks.: Add, Risk, Issue, Person, Role",
    filteredOn: "Hendelseskolonnen er filtrert på '",
    date: "Dato",
    event: "Hendelse",
    details: "Detaljer",
    performedBy: "Utført av"
  },
  projectChanged: {
    types: {
      updatedProjectBackground: "Hvorfor ble prosjektet startet", //Reuse label from add project ?
      updatedProjectTiming: "Hvorfor nå?", //Reuse label from add project ?
      updatedProjectBigPicture: "Det større bildet", //Reuse label from add project ?
      changedProjectName: "navn",
      changedProjectIdentifier: "identifikator",
      changedProjectLocation: "sted",
      changedProjectDepartment: "avdeling",
      changedProjectPortfolio: "portefølje",
      changedProjectCategory: "kategori",
      changedProjectType: "prosjektype",

      changedProgrammeName: "navn",
      changedProgrammeIdentifier: "identikator",
      changedProgrammePortfolio: "portefølje",
      changedProgrammeLocation: "sted",
      changedProgrammeDepartment: "avdeling",
      updatedProgrammeBackground: "Begrunnelse og sammenheng",
      updatedProgrammeTiming: "Hvorfor nå?",
      updatedProgrammeSuccessFactors: "Suksessfaktorer",

      updatedProjectCurrency: "Valuta",

      changedProductName: "navn",
      changedProductIdentifier: "identifikator",
      changedProductPortfolio: "portefølje",
      changedProductLocation: "sted",
      changedProductDepartment: "avdeling",
      updatedProductDefinitionDescription: "beskrivelse",
      updatedProductDefinitionBackground: "bakgrunn",
      updatedProductDefinitionVision: "visjon",

      changedReleasePortfolio: "portefølje",
      changedReleaseIdentifier: "identifikator",

      unknownType: "(ukjent)"
    },
    changed: "Endret",
    to: "til",
    previous: "tidligere verdi"
  },
  report: {
    highlight: {
      title: "Statusrapport",
      endStageReport: "Etapperapport",
      endProjectReport: "Sluttrapport",
      projectDeliverables: "Leveranser fra prosjektet",
      summary: "Oppsummering",
      benefits: "Gevinster",
      time: "Tid",
      cost: "Kostnad",
      quality: "Kvalitet",
      scope: "Omfang",
      risk: "Risiko",
      currentPeriod: "Denne perioden",
      nextPeriod: "Neste periode",
      aspect: "Aspekt",
      status: "Status",
      description: "Beskrivelse",
      from: "fra",
      issues: "Saker",
      draftSaved: "Utlast lagret",
      preview: "Forhåndsvisning",
      teamPerformance: "Teamets prestasjoner",
      lessonsDescription: "Erfaringer",
      undefinedDate: "<ikke definert>",
      deliveryStatus: endStageReport_fields.Overview.fields.performedAchivements.title,
      start: "Start",
      end: "Slutt",
      managedBy: "Ledet av",
      listLimitedTo: "I denne rapporten, er listen over begrenset til",
      top5Risks: "top 5 riski",
      top5Issues: "top 5 saker"
    },
    issue: {
      title: "Saksrapport",
      exceptionTitle: "Unntaksrapport",
      impact: "Konsekvens",
      severity: "Alvorlighet",
      type: "Sakstype",
      typeValues: {
        change: "Endringsanmodning",
        specification: "Avvik fra spesifikasjon",
        problem: "Problem / utfordring"
      },
      severityValues: ["Udefinert", "Ubetydelig", "Liten", "Moderat", "Betydelig", "Alvorlig"],
      priority: "Prioritet",
      priorityValues: ["Undefined", "Veldig lav", "Lav", "Middels", "Høy", "Veldig høy"],
      options: "Alternativer",
      recommendation: "Anbefaling",
      lessonSummary: "Erfaringer",
      decision: "Beslutning",
      decidedBy: "Beslutningen er fattet av",
      status: "Status",
      closed: "Lukket",
      active: "Aktiv",
      previewGenerated: "Forhåndsvisning generert"
    }
  }
};

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var norwegian_endStage = exports.norwegian_endStage = {
  Overview: {
    fields: {
      period: {
        title: "Etappens tidsperiode",
        help: "Angi faktisk tidsperiod for denne etappen. Dobbeltklikk på en dato i kalenderen for å angi startdato. Enkeltklikk på en dato for å angi sluttdato."
      },
      summary: {
        help: "Hva var intensjonen eller målet med denne etappen, og oppnådde vi det? Hadde vi noen gjennombrudd eller store feil?",
        description: "Beskriv målet med denne etappen og i hvilken grad målet har blitt oppnådd"
      },
      performedAchivements: {
        title: "Levert i denne etappen",
        help: "Hvilke arbeidspakker ble gjennomført eller fullført i denne etappen? Hvilke produkter ble levert i løpet av etappen? Var det noen planlagte produkter som ikke ble fullført i denne etappen? Har det blitt gjort noen korrigerende tiltak i løpet av etappen?",
        description: "Beskriv produktene som er levert i denne etappen"

      },

      benefits: {
        help: "Er vi på rett spor for å levere den ønskede avkastningen på investeringen etter at denne etappen er fullført? Hvis ikke, hva er forskjellen og hvorfor? Er det lagt til nye gevinster eller fjernet noen gevinster fra prosjektbegrunnelsen i løpet av denne etappen?",
        description: "Beskriv hvordan de planlagte gevinstene og prosjektbegrunnelsen har blitt påvirket i løpet av etappen"
      },
      time: {
        help: "Hva var den planlagte tidsperioden for denne etappen? Holdt vi oss innenfor tidsgrensen? Hvis ikke, hva var hovedårsaken? Brukte vi noe av toleransen for tid i denne etappen? Oppstod det noen saker som enderet tidsperioden for etappen - i så fall, hva endret vi fra-til og hvorfor? Hvordan er prognosen på gjenstående tid på prosjektet, og hvordan er dette i forhold til sist godkjente prosjektplan?",
        description: "Beskriv målene for tid i denne etappen og i hvilken grad etappen ble gjennomført innenfor planlagt tidsperiode"
      },
      cost: {
        help: "Hva var den planlagte kostnaden for denne etappen? Holdt vi oss innenfor den planlagte kostnaden? Hvis ikke, hva var hovedårsaken? Brukte vi noe av toleransen for kostand i denne etappen? Oppstod det noen saker som endret kostnaden for etappen - i så fall, hva endret vi fra-til og hvorfor? Hva er prognosen på gjenstående kostand for prosjektet, og hvordan er dette i forhold til sist godkjente prosjektplan?",
        description: "Oppsummer den planlagte kostnaden for etappen, hva den faktiske kostnaden endte opp med å bli og forklar eventuelle avvik"
      },

      quality: {
        help: "Hadde vi n\xF8dvendig klarhet i krav, formater eller andre kvalitetskriterier for de planlagte leveransene i etappen?\n          Har leverte produkter i denne etappen oppfylt de avtalte kravene eller kvalitetskriteriene?\n          Hvis ikke, hvilke produkter oppfylte ikke kriteriene og hvorfor?\n          Har akseptmetodene (testing, vurderinger ...) for produktene i denne etappen blitt brukt som avtalt? Hvordan vurderer vi n\xE5 den samlede kvaliteten som leveres i prosjektet, og vil vi oppn\xE5 det n\xF8dvendige kvalitetsniv\xE5et for prosjektets leveranser?",
        description: "Beskriv i hvilken grad leveransene i denne etappen har oppfylt kravene, formater eller andre kvalitetskriterier som ble avtalt før oppstart av etappen"
      },
      scope: {
        help: "Hadde vi tilstrekkelig klarhet i hva som skulle leveres n\xE5r denne etappen? Har vi levert de planlagte produktene? Gjorde vi mer eller mindre? Endret vi noe omfang i l\xF8pet av denne etappen? Har vi tilstrekkelig klarhet i hva som skal leveres for resten av prosjektet - hvis ikke, hva mangler?",
        description: "Beskriv i hvilken grad denne etappen leverte de planlagte produktene"
      },

      risk: {
        help: "Har vi klart å holde risikonivået på ønsket nivå i løpet av denne etappen? Har den totale risikoeksponeringen økt eller blitt redusert for prosjektet i denne etappen? Har det blitt identifisert nye alvorlige risiki i denne etappen? Har det blitt gjennomført vesentlige risikoreduserende tiltak i løpet av denne etappen?",
        description: "Beskriv hvordan risikonivået for prosjektet har endret seg i løpet av denne etappen"
      }
    }
  }
};

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Organization = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _uuid = __webpack_require__(26);

var _uuid2 = _interopRequireDefault(_uuid);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _Area = __webpack_require__(115);

var _Area2 = _interopRequireDefault(_Area);

var _Field = __webpack_require__(36);

var _Field2 = _interopRequireDefault(_Field);

var _ProjectMenu = __webpack_require__(17);

var _ProjectMenu2 = _interopRequireDefault(_ProjectMenu);

var _superagent = __webpack_require__(23);

var _superagent2 = _interopRequireDefault(_superagent);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(173), __webpack_require__(174)]);

var Person = function (_React$Component) {
  _inherits(Person, _React$Component);

  function Person(props) {
    _classCallCheck(this, Person);

    var _this = _possibleConstructorReturn(this, (Person.__proto__ || Object.getPrototypeOf(Person)).call(this, props));

    _this.state = { role: props.role, selectRole: false, editDetails: false, details: props.details };
    return _this;
  }

  _createClass(Person, [{
    key: 'assignRole',
    value: function assignRole(event) {
      event.preventDefault();
      this.setState({ selectRole: true });
    }
  }, {
    key: 'editDetails',
    value: function editDetails(event) {
      event.preventDefault();
      this.setState({ editDetails: true });
    }
  }, {
    key: 'cancelRoleUpdate',
    value: function cancelRoleUpdate() {
      this.setState({ selectRole: false });
    }
  }, {
    key: 'cancelDetailsUpdate',
    value: function cancelDetailsUpdate() {
      this.setState({ editDetails: false });
    }
  }, {
    key: 'updatedRole',
    value: function updatedRole(event) {
      event.preventDefault();
      var value = event.target.value;
      var updateUI = function () {
        this.setState({ selectRole: false, role: value, details: undefined });
      }.bind(this);
      if (this.props.onCommand !== undefined) {
        this.props.onCommand({
          type: "assignRole", person: { id: this.props.id }, role: { text: value }
        }, updateUI);
      }
    }
  }, {
    key: 'updatedDetails',
    value: function updatedDetails(event) {
      event.preventDefault();
      var value = event.target.details.value;
      var updateUI = function () {
        this.setState({ editDetails: false, details: value });
      }.bind(this);
      if (this.props.onCommand !== undefined) {
        this.props.onCommand({
          type: "setRoleDetails", person: { id: this.props.id }, role: { text: this.state.role }, details: value
        }, updateUI);
      }
    }
  }, {
    key: 'deleteRole',
    value: function deleteRole(event) {
      event.preventDefault();
      this.setState({ confirmDelete: true });
      console.log("Please confirm that you want to remove " + this.props.name + " with role " + this.state.role + " - " + this.state.details);
    }
  }, {
    key: 'confirmedDelete',
    value: function confirmedDelete(event) {
      event.preventDefault();
      var updateUI = function () {
        this.setState({ confirmDelete: false });
      }.bind(this);
      if (this.props.onCommand !== undefined) {
        this.props.onCommand({
          type: "deleteRole", person: { id: this.props.id }, role: { text: this.state.role }, details: this.state.details
        }, updateUI);
      }
    }
  }, {
    key: 'cancelDelete',
    value: function cancelDelete(event) {
      event.preventDefault();
      this.setState({ confirmDelete: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var labels = translations.getTranslation(this.props);
      var roles = this.props.type === "product" ? [{ id: "Excecutive", name: labels.roles.product.executive }, { id: "Product Manager", name: labels.roles.product.productManager }, { id: "Team Manager", name: labels.roles.product.teamManager }, { id: "Stakeholder", name: labels.roles.product.stakeholder }, { id: "Team Member", name: labels.roles.product.teamMember }] : this.props.type === "programme" ? [{ id: "Senior Responsible Owner", name: labels.roles.programme.seniorResponsibleOwner }, { id: "Programme Manager", name: labels.roles.programme.programmeManager }, { id: "Business Change Manager", name: labels.roles.programme.businessChangeManager }, { id: "Stakeholder", name: labels.roles.programme.stakeholder }, { id: "Team Member", name: labels.roles.programme.teamMember }] : [{ id: "Excecutive", name: labels.roles.project.executive }, { id: "Senior User", name: labels.roles.project.seniorUser }, { id: "Senior Supplier", name: labels.roles.project.seniorSupplier }, { id: "Business Assurance", name: labels.roles.project.businessAssurance }, { id: "Project Manager", name: labels.roles.project.projectManager }, { id: "Team Manager", name: labels.roles.project.teamManager }, { id: "Project Support", name: labels.roles.project.projectSupport }, { id: "Change Authority", name: labels.roles.project.changeAuthority }, { id: "Stakeholder", name: labels.roles.project.stakeholder }, { id: "User Assurance", name: labels.roles.project.userAssurance }, { id: "Supplier Assurance", name: labels.roles.project.supplierAssurance }, { id: "Team Member", name: labels.roles.project.teamMember }];

      return _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: { paddingBottom: 10 } },
          this.state.confirmDelete ? _react2.default.createElement(
            'div',
            { style: { position: "relative" } },
            _react2.default.createElement(
              'div',
              { style: { position: "absolute", border: "solid 1px black", backgroundColor: "white", padding: 20, minWidth: 300 } },
              _react2.default.createElement(
                'div',
                { style: { paddingBottom: 10 } },
                'Do you want to remove ',
                _react2.default.createElement(
                  'b',
                  null,
                  this.props.name
                ),
                ' with role ',
                _react2.default.createElement(
                  'b',
                  null,
                  this.state.role,
                  ' ',
                  this.props.details !== undefined ? " - " + this.props.details : ""
                ),
                '?'
              ),
              _react2.default.createElement('input', { className: 'cancel', onClick: this.cancelDelete.bind(this), type: 'button', value: labels.general.cancel }),
              _react2.default.createElement('input', { className: 'save', onClick: this.confirmedDelete.bind(this), type: 'button', value: 'Remove role' })
            )
          ) : this.state.role !== undefined ? _react2.default.createElement(
            'a',
            { href: '#', onClick: this.deleteRole.bind(this), style: { marginLeft: 0, position: "relative", marginRight: 15 } },
            _react2.default.createElement(
              'span',
              { style: { color: "red", position: "absolute", left: -3, top: -1, fontWeight: "bold", fontFamily: "Arial" } },
              'x'
            )
          ) : null
        ),
        _react2.default.createElement(
          'td',
          { style: { paddingRight: 20, paddingBottom: 10 } },
          this.props.name
        ),
        _react2.default.createElement(
          'td',
          { style: { paddingRight: 20, paddingBottom: 10 } },
          this.props.email
        ),
        _react2.default.createElement(
          'td',
          { style: { paddingBottom: 10 } },
          this.state.selectRole ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              { style: { display: "inline-block" } },
              _react2.default.createElement(
                'select',
                { className: 'input',
                  defaultValue: this.state.role,
                  onChange: this.updatedRole.bind(this),
                  style: { fontFamily: "lato, Arial, Verdana, Geneva, sans-serif", fontSize: "12pt" } },
                (this.state.role === undefined ? [{ id: "Dummy", name: labels.roles[this.props.type].selectRole }] : []).concat(roles).map(function (role) {
                  return _react2.default.createElement(
                    'option',
                    { key: role.id, value: role.id },
                    role.name
                  );
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { display: "inline-block", verticalAlign: "middle" } },
              _react2.default.createElement('input', { className: 'cancel', style: { marginLeft: 10 }, onClick: this.cancelRoleUpdate.bind(this), type: 'button', value: labels.general.cancel })
            )
          ) : this.state.role !== undefined ? _react2.default.createElement(
            'div',
            { style: { display: 'flex' } },
            _react2.default.createElement(
              'div',
              null,
              roles.find(function (role) {
                return role.id === _this2.state.role;
              }) !== undefined ? roles.find(function (role) {
                return role.id === _this2.state.role;
              }).name : null,
              this.props.additionalRoles !== undefined && this.props.additionalRoles.length > 0 ? _react2.default.createElement(
                'div',
                null,
                this.props.additionalRoles.map(function (item) {
                  return _react2.default.createElement(
                    'div',
                    { style: { paddingTop: 3, color: 'grey' } },
                    roles.find(function (role) {
                      return role.id === item.role // camelCase to Title Case
                      .replace(/([A-Z])/g, function (match) {
                        return ' ' + match;
                      }).replace(/^./, function (match) {
                        return match.toUpperCase();
                      }).trim();
                    }).name,
                    '  ',
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '*'
                    )
                  );
                })
              ) : null
            ),
            _react2.default.createElement('span', { style: { paddingLeft: 5 } }),
            !this.state.editDetails ? _react2.default.createElement(
              'a',
              { href: '#', onClick: this.assignRole.bind(this) },
              _react2.default.createElement('img', { style: { verticalAlign: "middle" }, src: '/icons/pen_grey.jpg' })
            ) : null
          ) : _react2.default.createElement(
            'a',
            { href: '#', onClick: this.assignRole.bind(this) },
            labels.general.assignRole
          )
        ),
        _react2.default.createElement(
          'td',
          { style: { paddingBottom: 10 } },
          this.state.editDetails ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'form',
              { onSubmit: this.updatedDetails.bind(this) },
              _react2.default.createElement(
                'div',
                { style: { paddingBottom: 10, display: "inline-block" } },
                _react2.default.createElement('input', { name: 'details', className: 'input', defaultValue: this.state.details, style: { fontFamily: "Lato,Arial, Verdana, Geneva, sans-serif", fontSize: "12pt" } })
              ),
              _react2.default.createElement(
                'div',
                { style: { display: "inline-block", verticalAlign: "middle" } },
                _react2.default.createElement('input', { className: 'cancel', style: { marginLeft: 10 }, onClick: this.cancelDetailsUpdate.bind(this), type: 'button', value: labels.general.cancel }),
                _react2.default.createElement('input', { className: 'save', style: { marginLeft: 10 }, type: 'submit', value: labels.general.update })
              )
            )
          ) : this.state.role !== undefined && !this.state.selectRole ? this.state.details ? _react2.default.createElement(
            'div',
            { style: { display: 'flex' } },
            _react2.default.createElement(
              'div',
              null,
              this.state.details,
              this.props.additionalRoles !== undefined && this.props.additionalRoles.length > 0 ? _react2.default.createElement(
                'div',
                null,
                this.props.additionalRoles.map(function (item) {
                  return _react2.default.createElement(
                    'div',
                    { style: { paddingTop: 3, color: 'grey' } },
                    item.details,
                    ' ',
                    _react2.default.createElement(
                      'span',
                      { style: { color: 'red' } },
                      '*'
                    )
                  );
                })
              ) : null
            ),
            _react2.default.createElement(
              'a',
              { href: '#', onClick: this.editDetails.bind(this) },
              _react2.default.createElement('img', { style: { verticalAlign: "middle" }, src: '/icons/pen_grey.jpg' })
            )
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'a',
              { href: '#', onClick: this.editDetails.bind(this) },
              labels.general.addRoleDetails
            ),
            this.props.additionalRoles !== undefined && this.props.additionalRoles.length > 0 ? _react2.default.createElement(
              'div',
              null,
              this.props.additionalRoles.map(function (item) {
                return _react2.default.createElement(
                  'div',
                  { style: { paddingTop: 3, color: 'grey' } },
                  item.details,
                  ' ',
                  _react2.default.createElement(
                    'span',
                    { style: { color: 'red' } },
                    '*'
                  )
                );
              })
            ) : null
          ) : _react2.default.createElement('div', null)
        )
      );
    }
  }]);

  return Person;
}(_react2.default.Component);

var AddPersonForm = function (_React$Component2) {
  _inherits(AddPersonForm, _React$Component2);

  function AddPersonForm(props) {
    _classCallCheck(this, AddPersonForm);

    var _this3 = _possibleConstructorReturn(this, (AddPersonForm.__proto__ || Object.getPrototypeOf(AddPersonForm)).call(this, props));

    _this3.state = { email: "", name: "", lockName: true };
    return _this3;
  }

  _createClass(AddPersonForm, [{
    key: 'updateEmail',
    value: function updateEmail(event) {
      var newValue = event.target.value.trim();
      var newState = { id: undefined };
      if (newValue.slice(-1) === ";") {
        newValue = newValue.slice(0, -1);
      }
      if (newValue[newValue.length - 1] === ">" && event.target.value.indexOf("<") > 0) {
        newState.name = newValue.substring(0, newValue.indexOf("<") - 1);
        newState.email = newValue.substring(newValue.indexOf("<") + 1, newValue.length - 1);
        newState.lockName = undefined;
      } else {
        var validEmail = newValue.indexOf("@") > 0 && newValue.lastIndexOf(".") > newValue.indexOf("@");
        newState.email = newValue;
        newState.lockName = !validEmail ? true : undefined;
      }
      if (this.props.lookupPerson !== undefined) {
        this.props.lookupPerson(newState.email, function (person) {
          newState.name = person.name;
          newState.id = person.id;
          newState.lockName = true;
          this.setState(newState);
        }.bind(this));
      }
      this.setState(newState);
    }
  }, {
    key: 'updateName',
    value: function updateName(event) {
      this.setState({ name: event.target.value });
    }
  }, {
    key: 'addPerson',
    value: function addPerson(event) {
      this.props.onCommand({ type: "addPerson", person: { id: this.state.id === undefined ? _uuid2.default.v4() : this.state.id, name: this.state.name, email: this.state.email } });
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      return _react2.default.createElement(
        'form',
        null,
        _react2.default.createElement(
          _Area2.default,
          { title: labels.general.newStakeholder },
          _react2.default.createElement(_Field2.default, {
            title: labels.roles.headings.email,
            controlled: true,
            onChange: this.updateEmail.bind(this), value: this.state.email
          }),
          _react2.default.createElement(_Field2.default, {
            title: labels.roles.headings.name,
            onChange: this.updateName.bind(this), help: this.state.lockName ? labels.general.messageEmailFirst : labels.general.helpName, value: this.state.name,
            controlled: true,
            disabled: this.state.lockName
          })
        ),
        _react2.default.createElement('input', { className: 'cancel', onClick: this.props.cancel, type: 'button', value: labels.general.cancel }),
        _react2.default.createElement('input', { className: 'save', onClick: this.addPerson.bind(this), type: 'button', value: labels.general.addStakeholder })
      );
    }
  }]);

  return AddPersonForm;
}(_react2.default.Component);

var Description = function (_React$Component3) {
  _inherits(Description, _React$Component3);

  function Description(props) {
    _classCallCheck(this, Description);

    var _this4 = _possibleConstructorReturn(this, (Description.__proto__ || Object.getPrototypeOf(Description)).call(this, props));

    _this4.state = { showDetails: false };
    return _this4;
  }

  _createClass(Description, [{
    key: 'toggleDisplay',
    value: function toggleDisplay(event) {
      event.preventDefault();
      this.setState({ showDetails: !this.state.showDetails });
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).general;
      return _react2.default.createElement(
        'div',
        { style: { paddingBottom: 10 } },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'strong',
            null,
            this.props.title
          ),
          this.state.showDetails ? _react2.default.createElement(
            'span',
            null,
            ' [',
            _react2.default.createElement(
              'a',
              { onClick: this.toggleDisplay.bind(this), href: '#' },
              labels.hideDetails
            ),
            ']'
          ) : null
        ),
        this.state.showDetails ? _react2.default.createElement(
          'div',
          { style: { border: "solid 1px lightgrey", borderRadius: 5, padding: 10 } },
          this.props.children
        ) : _react2.default.createElement(
          'div',
          null,
          this.props.ingress,
          _react2.default.createElement(
            'span',
            null,
            ' [',
            _react2.default.createElement(
              'a',
              { onClick: this.toggleDisplay.bind(this), href: '#' },
              labels.readMore
            ),
            ']'
          )
        )
      );
    }
  }]);

  return Description;
}(_react2.default.Component);

var RoleDescriptions = function (_React$Component4) {
  _inherits(RoleDescriptions, _React$Component4);

  function RoleDescriptions() {
    _classCallCheck(this, RoleDescriptions);

    return _possibleConstructorReturn(this, (RoleDescriptions.__proto__ || Object.getPrototypeOf(RoleDescriptions)).apply(this, arguments));
  }

  _createClass(RoleDescriptions, [{
    key: 'render',
    value: function render() {
      var _this6 = this;

      var labels = translations.getTranslation(this.props).roles;
      return _react2.default.createElement(
        'div',
        { style: { marginLeft: 30, marginTop: 55, maxWidth: 630, minWidth: 300 } },
        _react2.default.createElement(
          'h3',
          null,
          labels.title
        ),
        _react2.default.createElement(
          Description,
          _extends({}, this.props, labels.project.descriptions.board),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              null,
              labels.project.descriptions.board.details
            ),
            _react2.default.createElement(
              'ul',
              null,
              ["executive", "seniorUser", "seniorSupplier"].map(function (role) {
                return _react2.default.createElement(
                  'li',
                  { key: role },
                  labels.project.roles[role].title,
                  ' - ',
                  labels.project.roles[role].summary
                );
              })
            ),
            _react2.default.createElement(
              'div',
              { style: { paddingBottom: 10 } },
              labels.project.descriptions.board.responsibility
            ),
            ["executive", "seniorUser", "seniorSupplier"].map(function (role) {
              return _react2.default.createElement(
                Description,
                _extends({ key: role }, _this6.props, labels.project.roles[role]),
                _react2.default.createElement(
                  'div',
                  null,
                  labels.project.roles[role].details
                )
              );
            })
          )
        ),
        _react2.default.createElement(
          Description,
          _extends({}, this.props, labels.project.roles.projectManager),
          labels.project.roles.projectManager.details
        ),
        _react2.default.createElement(
          Description,
          _extends({}, this.props, labels.project.roles.teamManager),
          labels.project.roles.teamManager.details
        ),
        _react2.default.createElement(
          Description,
          _extends({}, this.props, labels.project.descriptions.assuranceRoles),
          labels.project.descriptions.assuranceRoles.details
        )
      );
    }
  }]);

  return RoleDescriptions;
}(_react2.default.Component);

var Organization = exports.Organization = function (_React$Component5) {
  _inherits(Organization, _React$Component5);

  function Organization(props) {
    _classCallCheck(this, Organization);

    var _this7 = _possibleConstructorReturn(this, (Organization.__proto__ || Object.getPrototypeOf(Organization)).call(this, props));

    var stakeholders = _this7.props.project !== undefined && _this7.props.project.stakeholders !== undefined ? _this7.props.project.stakeholders : [];
    var user = _this7.props.user;
    if (stakeholders.filter(function (person) {
      return person.id === user.id;
    }).length === 0 && user !== undefined) {
      stakeholders = stakeholders.concat(user);
    }
    _this7.state = { showForm: false, persons: stakeholders };
    return _this7;
  }

  _createClass(Organization, [{
    key: 'showForm',
    value: function showForm(event) {
      event.preventDefault();
      this.setState({ showForm: true });
    }
  }, {
    key: 'sendCommand',
    value: function sendCommand(command, success) {
      _superagent2.default.post("/").send(command).end(function (error, response) {
        if (error === null && response.status === 200 && response.text === "OK") {
          console.log("Success for command '" + command.type + "'");
          success();
        } else {
          console.log("Error: " + error + ", got " + response.status + " with message " + response.text);
          alert("An error occoured, please try again.");
        }
      });
    }
  }, {
    key: 'onCommand',
    value: function onCommand(command, success) {
      switch (command.type) {
        case "addPerson":
          if (this.state.persons.filter(function (person) {
            return person.id === command.person.id;
          }).length > 0) {
            alert("Person can only have one role in the " + (this.props.project.isProduct === true ? "product" : this.props.project.isProgramme === true ? "programme" : "project"));
          } else {
            this.addPerson(command.person);
          }
          break;
        case "assignRole":
        case "setRoleDetails":
        case "deleteRole":
          var enrichedCommand = Object.assign({}, command, { tenant: { id: this.props.tenant.id } });
          if (this.props.project.isProduct === true) {
            enrichedCommand.product = { id: this.props.project.id };
          } else {
            if (this.props.project.isProgramme === true) {
              enrichedCommand.programme = { id: this.props.project.id };
            } else {
              enrichedCommand.project = { id: this.props.project.id };
            }
          }
          this.sendCommand(enrichedCommand, function () {
            if (command.type === "deleteRole") {
              this.setState({ persons: this.state.persons.filter(function (person) {
                  return person.id !== command.person.id;
                }) });
            } else {
              this.setState({ persons: this.state.persons.map(function (person) {
                  return person.id === command.person.id ? Object.assign({}, person, { role: command.role.text, details: command.details }) : person;
                }) });
            }
            success();
          }.bind(this));
          break;
        default:
          alert("Not supported");
      }
    }
  }, {
    key: 'addPerson',
    value: function addPerson(person) {
      var tenant = this.props.tenant;
      var updateUI = function () {
        this.setState({
          showForm: false,
          persons: this.state.persons.concat(person)
        });
      }.bind(this);

      var project = this.props.project;
      var command = { type: "addPerson", person: person, tenant: { id: tenant.id } };
      if (this.props.project.isProduct === true) {
        command.product = { id: project.id };
      } else {
        if (this.props.project.isProgramme === true) {
          command.programme = { id: project.id };
          console.log("Added programme person " + person.name);
        } else {
          command.project = { id: project.id };
        }
      }
      console.log("Added  " + person.name);
      this.sendCommand(command, updateUI);
    }
  }, {
    key: 'lookupPerson',
    value: function lookupPerson(email, found) {
      _superagent2.default.get("/emails/" + email).send({ email: email }).end(function (err, response) {
        if (err === null) {
          var persons = JSON.parse(response.text);
          if (persons.length > 0) {
            found(persons[0]);
          }
        }
      });
    }
  }, {
    key: 'hideForm',
    value: function hideForm() {
      this.setState({ showForm: false });
    }
  }, {
    key: 'goToHome',
    value: function goToHome() {
      {
        window.location.replace((this.props.project.isProduct === true ? "/products/" : this.props.project.isProgramme === true ? "/programmes/" : "/projects/") + this.props.project.id);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      var labels = translations.getTranslation(this.props);
      var commandHandler = this.onCommand.bind(this);
      return _react2.default.createElement(
        'div',
        { style: { marginLeft: 30, display: "flex", flexWrap: "wrap", justifyContent: "flex-start", fontFamily: "Lato, Arial, Verdana, Geneva, sans-serif", maxWidth: 1016 } },
        _react2.default.createElement(OrganizationThemePresentation, _extends({}, this.props, { persons: this.state.persons })),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { style: { marginLeft: 20, fontSize: "12pt", width: "100%" } },
            _react2.default.createElement(
              'table',
              null,
              _react2.default.createElement(
                'thead',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement('th', null),
                  _react2.default.createElement(
                    'th',
                    null,
                    labels.roles.headings.name
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    labels.roles.headings.email
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    labels.roles.headings.role
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    labels.roles.headings.details
                  )
                )
              ),
              _react2.default.createElement(
                'tbody',
                null,
                this.state.persons.map(function (person) {
                  return _react2.default.createElement(Person, _extends({}, _this8.props, { key: person.id }, person, { type: _this8.props.project.isProduct === true ? "product" : _this8.props.project.isProgramme === true ? "programme" : "project", onCommand: commandHandler }));
                })
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { paddingTop: 30, paddingBottom: 15, maxWidth: 1016, fontSize: "12pt" } },
              this.state.showForm ? _react2.default.createElement(AddPersonForm, _extends({}, this.props, { lookupPerson: this.lookupPerson.bind(this), onCommand: commandHandler, cancel: this.hideForm.bind(this) })) : _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('input', { className: 'cancel', onClick: this.goToHome.bind(this), name: 'cancel', value: labels.general.leavePage }),
                _react2.default.createElement('input', { className: 'save', style: { marginLeft: 10 }, onClick: this.showForm.bind(this), type: 'button', value: labels.general.addRole })
              )
            )
          )
        ),
        this.props.project.isProduct !== true && this.props.project.isProgramme !== true ? _react2.default.createElement(RoleDescriptions, this.props) : null
      );
    }
  }]);

  return Organization;
}(_react2.default.Component);

var OrganizationThemePresentation = function (_React$Component6) {
  _inherits(OrganizationThemePresentation, _React$Component6);

  function OrganizationThemePresentation() {
    _classCallCheck(this, OrganizationThemePresentation);

    return _possibleConstructorReturn(this, (OrganizationThemePresentation.__proto__ || Object.getPrototypeOf(OrganizationThemePresentation)).apply(this, arguments));
  }

  _createClass(OrganizationThemePresentation, [{
    key: 'render',
    value: function render() {
      var _this10 = this;

      var labels = translations.getTranslation(this.props);
      var title = labels.roles.project.actions.appointExecutive; //"Appoint Executive";

      var initiativeC = this.props.project.isProduct === true ? "Product" : this.props.project.isProgramme === true ? "Programme" : "Project";
      var description = labels.roles.project.roles.executive.details;
      var description2 = labels.roles.project.roles.executive.additionalInformation;

      if (this.props.project.isProduct === true) {
        title = labels.roles.product.actions.appointExecutive;
        description = labels.roles.product.roles.executive.details;
        description2 = labels.roles.product.roles.executive.additionalInformation;
      } else if (this.props.project.isProgramme === true) {
        title = labels.roles.programme.actions.appointSRO;
        description = labels.roles.programme.roles.seniorResponsibleOwner.details;
        description2 = labels.roles.programme.roles.seniorResponsibleOwner.additionalInformation;
      }
      if (this.props.persons !== undefined && this.props.persons.filter(function (person) {
        return person.role === "Excecutive" || person.role === "Senior Responsible Owner";
      }).length > 0) {
        if (this.props.persons !== undefined && this.props.persons.filter(function (person) {
          return person.role === "Project Manager" && _this10.props.project.isProduct !== true || person.role === "Product Manager" && _this10.props.project.isProduct === true || person.role === "Programme Manager" && _this10.props.project.isProgramme === true;
        }).length > 0) {
          if (this.props.project.isProduct === true) {
            title = labels.roles.product.descriptions.teamStructure.title;
            description = labels.roles.product.descriptions.teamStructure.details;
            description2 = labels.roles.product.descriptions.teamStructure.additionalInformation;
          } else {
            if (this.props.project.isProgramme === true) {
              title = labels.roles.programme.descriptions.teamStructure.title;
              description = labels.roles.programme.descriptions.teamStructure.details;
              description2 = labels.roles.programme.descriptions.teamStructure.additionalInformation;
            } else {
              title = labels.roles.project.descriptions.teamStructure.title;
              description = labels.roles.project.descriptions.teamStructure.details;
              description2 = labels.roles.project.descriptions.teamStructure.additionalInformation;
            }
          }
        } else {
          if (this.props.project.isProduct === true) {
            title = labels.roles.product.actions.appointProductManager;
            description = labels.roles.product.roles.productManager.details;
            description2 = labels.roles.product.roles.productManager.additionalInformation;
          } else {
            if (this.props.project.isProgramme === true) {
              title = labels.roles.programme.actions.appointProgrammeManager;
              description = labels.roles.programme.roles.programmeManager.details;
              description2 = labels.roles.programme.roles.programmeManager.additionalInformation;
            } else {
              title = labels.roles.project.actions.appointProjectManager;
              description = labels.roles.project.roles.projectManager.details;
              description2 = labels.roles.project.roles.projectManager.additionalInformation;
            }
          }
        }
      }
      return _react2.default.createElement(
        'div',
        { style: { backgroundColor: "#f7f7f7", padding: 20, marginBottom: 30, marginTop: 20, width: "100%" } },
        _react2.default.createElement(
          'div',
          { style: { fontWeight: "bold", fontSize: 14 } },
          labels.general.title,
          _react2.default.createElement('br', null)
        ),
        _react2.default.createElement(
          'div',
          { style: { fontSize: 30, fontWeight: "bold" } },
          title
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "flex", justifyContent: "space-between" } },
          _react2.default.createElement(
            'div',
            { style: { minWidth: 200, maxWidth: 550, paddingTop: 20 } },
            _react2.default.createElement(
              'p',
              null,
              description
            ),
            _react2.default.createElement(
              'p',
              null,
              description2
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingLeft: 10, paddingBottom: 20, paddingRight: 30, paddingTop: 1 } },
            _react2.default.createElement('img', { src: '/images/orgtheme.png' })
          )
        )
      );
    }
  }]);

  return OrganizationThemePresentation;
}(_react2.default.Component);

var OrganizationPage = function (_React$Component7) {
  _inherits(OrganizationPage, _React$Component7);

  function OrganizationPage() {
    _classCallCheck(this, OrganizationPage);

    return _possibleConstructorReturn(this, (OrganizationPage.__proto__ || Object.getPrototypeOf(OrganizationPage)).apply(this, arguments));
  }

  _createClass(OrganizationPage, [{
    key: 'render',
    value: function render() {
      var menu = this.props.showMenu === true ? _react2.default.createElement(_ProjectMenu2.default, this.props) : undefined;
      return _react2.default.createElement(
        _Layout2.default,
        _extends({}, this.props, { projectMenu: menu }),
        _react2.default.createElement(Organization, this.props)
      );
    }
  }]);

  return OrganizationPage;
}(_react2.default.Component);

exports.default = OrganizationPage;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(1053)
var ieee754 = __webpack_require__(1054)
var isArray = __webpack_require__(1055)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Flag = function (_React$Component) {
  _inherits(Flag, _React$Component);

  function Flag() {
    _classCallCheck(this, Flag);

    return _possibleConstructorReturn(this, (Flag.__proto__ || Object.getPrototypeOf(Flag)).apply(this, arguments));
  }

  _createClass(Flag, [{
    key: 'render',
    value: function render() {
      var flag = _react2.default.createElement('span', null);
      if (this.props.requestedPhase !== undefined || this.props.requestedStageTransition !== undefined && this.props.requestedStageTransition !== false || this.props.recommendedProjectClosure !== undefined) {
        flag = _react2.default.createElement('img', { src: '/images/Flag_FinishGrey_22x16.gif', style: { height: 19 } });
      } else if (this.props.requestedStageException !== undefined && this.props.requestedStageException !== false) {
        flag = _react2.default.createElement('img', { src: '/images/Flag_DarkGrey_22x16.gif', style: { height: 19 } });
      }
      return flag;
    }
  }]);

  return Flag;
}(_react2.default.Component);

exports.default = Flag;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StatusIndicator = function (_React$Component) {
  _inherits(StatusIndicator, _React$Component);

  function StatusIndicator() {
    _classCallCheck(this, StatusIndicator);

    return _possibleConstructorReturn(this, (StatusIndicator.__proto__ || Object.getPrototypeOf(StatusIndicator)).apply(this, arguments));
  }

  _createClass(StatusIndicator, [{
    key: 'render',
    value: function render() {
      switch (this.props.status) {
        case "green":
          return _react2.default.createElement('img', { style: { verticalAlign: "bottom" }, src: '/images/greenlight.png' });
          break;
        case "yellow":
          return _react2.default.createElement('img', { style: { verticalAlign: "bottom" }, src: '/images/yellowlight.png' });
          break;
        case "red":
          return _react2.default.createElement('img', { style: { verticalAlign: "bottom" }, src: '/images/redlight.png' });
          break;
        default:
          return _react2.default.createElement('span', null);
      }
    }
  }]);

  return StatusIndicator;
}(_react2.default.Component);

exports.default = StatusIndicator;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FilterStatus = function (_React$Component) {
  _inherits(FilterStatus, _React$Component);

  function FilterStatus() {
    _classCallCheck(this, FilterStatus);

    return _possibleConstructorReturn(this, (FilterStatus.__proto__ || Object.getPrototypeOf(FilterStatus)).apply(this, arguments));
  }

  _createClass(FilterStatus, [{
    key: 'render',
    value: function render() {
      var activeFiltered = this.props.excludedProjects.filter(function (project) {
        return project.isStarted;
      }).length;
      var inactiveFiltered = this.props.excludedProjects.filter(function (project) {
        return !project.isStarted;
      }).length;
      return this.props.filter !== undefined && this.props.excludedProjects !== undefined && this.props.excludedProjects.length > 0 ? _react2.default.createElement(
        'div',
        { style: { color: "#212121", padding: 10, marginTop: 10, marginLeft: 30, marginRight: 30, fontFamily: "Lato", textAlign: "center", backgroundColor: "#FFEADB" } },
        activeFiltered > 0 ? activeFiltered + " active" : "",
        inactiveFiltered > 0 && activeFiltered > 0 ? " and " : "",
        inactiveFiltered > 0 ? inactiveFiltered + " inactive" : "",
        ' project(s) are hidden with current filter'
      ) : null;
    }
  }]);

  return FilterStatus;
}(_react2.default.Component);

exports.default = FilterStatus;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _SettingsForUsage = __webpack_require__(428);

var _SettingsForUsage2 = _interopRequireDefault(_SettingsForUsage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BusinessCaseSettings = function (_React$Component) {
  _inherits(BusinessCaseSettings, _React$Component);

  function BusinessCaseSettings() {
    _classCallCheck(this, BusinessCaseSettings);

    return _possibleConstructorReturn(this, (BusinessCaseSettings.__proto__ || Object.getPrototypeOf(BusinessCaseSettings)).apply(this, arguments));
  }

  _createClass(BusinessCaseSettings, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_SettingsForUsage2.default, _extends({}, this.props, {
        image: '/images/business_case_s1.png',
        area: 'businessCase',
        label: 'Business Case',
        help: 'Turn on or off use of Business Case.'
      }));
    }
  }]);

  return BusinessCaseSettings;
}(_react2.default.Component);

exports.default = BusinessCaseSettings;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SettingsForUsage = function (_React$Component) {
  _inherits(SettingsForUsage, _React$Component);

  function SettingsForUsage(props) {
    _classCallCheck(this, SettingsForUsage);

    var _this = _possibleConstructorReturn(this, (SettingsForUsage.__proto__ || Object.getPrototypeOf(SettingsForUsage)).call(this, props));

    _this.state = _this.loadSettings(props);
    return _this;
  }

  _createClass(SettingsForUsage, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState(this.loadSettings(props));
    }
  }, {
    key: 'loadSettings',
    value: function loadSettings(props) {
      return {
        edit: false,
        enabled: props.settings !== undefined && props.settings.enabled !== undefined ? props.settings.enabled : true
      };
    }
  }, {
    key: 'changeSettings',
    value: function changeSettings(event) {
      event.preventDefault();
      this.setState({ edit: !this.state.edit });
    }
  }, {
    key: 'enableBusinessCase',
    value: function enableBusinessCase(event) {
      this.setState({ enabled: true });
    }
  }, {
    key: 'disableBusinessCase',
    value: function disableBusinessCase(event) {
      this.setState({ enabled: false });
    }
  }, {
    key: 'cancelChange',
    value: function cancelChange(event) {
      event.preventDefault();
      this.setState(this.loadSettings(this.props));
    }
  }, {
    key: 'updateSettings',
    value: function updateSettings(event) {
      event.preventDefault();
      this.setState({ edit: false });
      if (this.props.onUpdate !== undefined) {
        this.props.onUpdate({
          area: this.props.area,
          use: this.state.enabled
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { display: "flex", paddingBottom: 20 } },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('img', { src: this.props.image })
        ),
        this.state.edit ? _react2.default.createElement(
          'div',
          { style: { paddingLeft: 30 } },
          'Use ',
          this.props.label,
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('input', { onChange: this.disableBusinessCase.bind(this), type: 'radio', name: 'businessCase', value: 'no', defaultChecked: !this.state.enabled, id: 'no' }),
              _react2.default.createElement(
                'span',
                null,
                ' '
              ),
              _react2.default.createElement(
                'label',
                { htmlFor: 'no' },
                'No'
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('input', { onChange: this.enableBusinessCase.bind(this), type: 'radio', name: 'businessCase', value: 'yes', defaultChecked: this.state.enabled, id: 'yes' }),
              _react2.default.createElement(
                'span',
                null,
                ' '
              ),
              _react2.default.createElement(
                'label',
                { htmlFor: 'yes' },
                'Yes'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingTop: 15 } },
            _react2.default.createElement('input', { type: 'button', onClick: this.cancelChange.bind(this), className: 'cancel', value: 'Cancel' }),
            _react2.default.createElement('input', { onClick: this.updateSettings.bind(this), type: 'submit', className: 'save', value: 'Update' })
          )
        ) : _react2.default.createElement(
          'div',
          { style: { paddingLeft: 30 } },
          _react2.default.createElement(
            'div',
            null,
            this.state.enabled ? "Use" : "Not use",
            ' ',
            this.props.label,
            '.'
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingTop: 10 } },
            _react2.default.createElement(
              'i',
              null,
              this.props.help,
              '.'
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingTop: 15 } },
            _react2.default.createElement(
              'a',
              { href: '#', onClick: this.changeSettings.bind(this) },
              'Change'
            )
          )
        )
      );
    }
  }]);

  return SettingsForUsage;
}(_react2.default.Component);

exports.default = SettingsForUsage;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = [{ id: "AED", title: "United Arab Emirates Dirham" }, { id: "AFN", title: "Afghanistan Afghani" }, { id: "ALL", title: "Albania Lek" }, { id: "AMD", title: "Armenia Dram" }, { id: "ANG", title: "Netherlands Antilles Guilder" }, { id: "AOA", title: "Angola Kwanza" }, { id: "ARS", title: "Argentina Peso" }, { id: "AUD", title: "Australia Dollar" }, { id: "AWG", title: "Aruba Guilder" }, { id: "AZN", title: "Azerbaijan Manat" }, { id: "BAM", title: "Bosnia and Herzegovina Convertible Marka" }, { id: "BBD", title: "Barbados Dollar" }, { id: "BDT", title: "Bangladesh Taka" }, { id: "BGN", title: "Bulgaria Lev" }, { id: "BHD", title: "Bahrain Dinar" }, { id: "BIF", title: "Burundi Franc" }, { id: "BMD", title: "Bermuda Dollar" }, { id: "BND", title: "Brunei Darussalam Dollar" }, { id: "BOB", title: "Bolivia Bolíviano" }, { id: "BRL", title: "Brazil Real" }, { id: "BSD", title: "Bahamas Dollar" }, { id: "BTN", title: "Bhutan Ngultrum" }, { id: "BWP", title: "Botswana Pula" }, { id: "BYN", title: "Belarus Ruble" }, { id: "BZD", title: "Belize Dollar" }, { id: "CAD", title: "Canada Dollar" }, { id: "CDF", title: "Congo/Kinshasa Franc" }, { id: "CHF", title: "Switzerland Franc" }, { id: "CLP", title: "Chile Peso" }, { id: "CNY", title: "China Yuan Renminbi" }, { id: "COP", title: "Colombia Peso" }, { id: "CRC", title: "Costa Rica Colon" }, { id: "CUC", title: "Cuba Convertible Peso" }, { id: "CUP", title: "Cuba Peso" }, { id: "CVE", title: "Cape Verde Escudo" }, { id: "CZK", title: "Czech Republic Koruna" }, { id: "DJF", title: "Djibouti Franc" }, { id: "DKK", title: "Denmark Krone" }, { id: "DOP", title: "Dominican Republic Peso" }, { id: "DZD", title: "Algeria Dinar" }, { id: "EGP", title: "Egypt Pound" }, { id: "ERN", title: "Eritrea Nakfa" }, { id: "ETB", title: "Ethiopia Birr" }, { id: "EUR", title: "Euro Member Countries" }, { id: "FJD", title: "Fiji Dollar" }, { id: "FKP", title: "Falkland Islands (Malvinas) Pound" }, { id: "GBP", title: "United Kingdom Pound" }, { id: "GEL", title: "Georgia Lari" }, { id: "GGP", title: "Guernsey Pound" }, { id: "GHS", title: "Ghana Cedi" }, { id: "GIP", title: "Gibraltar Pound" }, { id: "GMD", title: "Gambia Dalasi" }, { id: "GNF", title: "Guinea Franc" }, { id: "GTQ", title: "Guatemala Quetzal" }, { id: "GYD", title: "Guyana Dollar" }, { id: "HKD", title: "Hong Kong Dollar" }, { id: "HNL", title: "Honduras Lempira" }, { id: "HRK", title: "Croatia Kuna" }, { id: "HTG", title: "Haiti Gourde" }, { id: "HUF", title: "Hungary Forint" }, { id: "IDR", title: "Indonesia Rupiah" }, { id: "ILS", title: "Israel Shekel" }, { id: "IMP", title: "Isle of Man Pound" }, { id: "INR", title: "India Rupee" }, { id: "IQD", title: "Iraq Dinar" }, { id: "IRR", title: "Iran Rial" }, { id: "ISK", title: "Iceland Krona" }, { id: "JEP", title: "Jersey Pound" }, { id: "JMD", title: "Jamaica Dollar" }, { id: "JOD", title: "Jordan Dinar" }, { id: "JPY", title: "Japan Yen" }, { id: "KES", title: "Kenya Shilling" }, { id: "KGS", title: "Kyrgyzstan Som" }, { id: "KHR", title: "Cambodia Riel" }, { id: "KMF", title: "Comorian Franc" }, { id: "KPW", title: "Korea (North) Won" }, { id: "KRW", title: "Korea (South) Won" }, { id: "KWD", title: "Kuwait Dinar" }, { id: "KYD", title: "Cayman Islands Dollar" }, { id: "KZT", title: "Kazakhstan Tenge" }, { id: "LAK", title: "Laos Kip" }, { id: "LBP", title: "Lebanon Pound" }, { id: "LKR", title: "Sri Lanka Rupee" }, { id: "LRD", title: "Liberia Dollar" }, { id: "LSL", title: "Lesotho Loti" }, { id: "LYD", title: "Libya Dinar" }, { id: "MAD", title: "Morocco Dirham" }, { id: "MDL", title: "Moldova Leu" }, { id: "MGA", title: "Madagascar Ariary" }, { id: "MKD", title: "Macedonia Denar" }, { id: "MMK", title: "Myanmar (Burma) Kyat" }, { id: "MNT", title: "Mongolia Tughrik" }, { id: "MOP", title: "Macau Pataca" }, { id: "MRU", title: "Mauritania Ouguiya" }, { id: "MUR", title: "Mauritius Rupee" }, { id: "MVR", title: "Maldives (Maldive Islands) Rufiyaa" }, { id: "MWK", title: "Malawi Kwacha" }, { id: "MXN", title: "Mexico Peso" }, { id: "MYR", title: "Malaysia Ringgit" }, { id: "MZN", title: "Mozambique Metical" }, { id: "NAD", title: "Namibia Dollar" }, { id: "NGN", title: "Nigeria Naira" }, { id: "NIO", title: "Nicaragua Cordoba" }, { id: "NOK", title: "Norway Krone" }, { id: "NPR", title: "Nepal Rupee" }, { id: "NZD", title: "New Zealand Dollar" }, { id: "OMR", title: "Oman Rial" }, { id: "PAB", title: "Panama Balboa" }, { id: "PEN", title: "Peru Sol" }, { id: "PGK", title: "Papua New Guinea Kina" }, { id: "PHP", title: "Philippines Peso" }, { id: "PKR", title: "Pakistan Rupee" }, { id: "PLN", title: "Poland Zloty" }, { id: "PYG", title: "Paraguay Guarani" }, { id: "QAR", title: "Qatar Riyal" }, { id: "RON", title: "Romania Leu" }, { id: "RSD", title: "Serbia Dinar" }, { id: "RUB", title: "Russia Ruble" }, { id: "RWF", title: "Rwanda Franc" }, { id: "SAR", title: "Saudi Arabia Riyal" }, { id: "SBD", title: "Solomon Islands Dollar" }, { id: "SCR", title: "Seychelles Rupee" }, { id: "SDG", title: "Sudan Pound" }, { id: "SEK", title: "Sweden Krona" }, { id: "SGD", title: "Singapore Dollar" }, { id: "SHP", title: "Saint Helena Pound" }, { id: "SLL", title: "Sierra Leone Leone" }, { id: "SOS", title: "Somalia Shilling" }, { id: "SPL", title: "*Seborga Luigino" }, { id: "SRD", title: "Suriname Dollar" }, { id: "STN", title: "São Tomé and Príncipe Dobra" }, { id: "SVC", title: "El Salvador Colon" }, { id: "SYP", title: "Syria Pound" }, { id: "SZL", title: "eSwatini Lilangeni" }, { id: "THB", title: "Thailand Baht" }, { id: "TJS", title: "Tajikistan Somoni" }, { id: "TMT", title: "Turkmenistan Manat" }, { id: "TND", title: "Tunisia Dinar" }, { id: "TOP", title: "Tonga Pa'anga" }, { id: "TRY", title: "Turkey Lira" }, { id: "TTD", title: "Trinidad and Tobago Dollar" }, { id: "TVD", title: "Tuvalu Dollar" }, { id: "TWD", title: "Taiwan New Dollar" }, { id: "TZS", title: "Tanzania Shilling" }, { id: "UAH", title: "Ukraine Hryvnia" }, { id: "UGX", title: "Uganda Shilling" }, { id: "USD", title: "United States Dollar" }, { id: "UYU", title: "Uruguay Peso" }, { id: "UZS", title: "Uzbekistan Som" }, { id: "VEF", title: "Venezuela Bolívar" }, { id: "VND", title: "Viet Nam Dong" }, { id: "VUV", title: "Vanuatu Vatu" }, { id: "WST", title: "Samoa Tala" }, { id: "XAF", title: "Communauté Financière Africaine (BEAC) CFA Franc BEAC" }, { id: "XCD", title: "East Caribbean Dollar" }, { id: "XDR", title: "International Monetary Fund (IMF) Special Drawing Rights" }, { id: "XOF", title: "Communauté Financière Africaine (BCEAO) Franc" }];

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var definition = __webpack_require__(177).english;

var english = exports.english = {
  initiative: {
    title: "Properties",
    fields: {
      name: {
        title: "Name",
        description: "Descriptive name"
      },
      identifier: {
        title: "Identifier",
        description: "Number, identifier or short name"
      },
      portfolio: {
        title: "Portfolio",
        help: "Select the Portfolio where the initiative should be governed"
      },
      asProject: "Define New Project",
      projectCharacteristics: ["Driven by deliverables", "Finite - defined start and finish", "Bounded and scoped deliverables", "Delivery of a product", "Benefits usually realised after project closes", "Shorter Timescale"],
      asProgramme: "Define New Programme",
      programmeCharacteristics: ["Driven by vision of end state", "No pre defined path", "Changes to business capability", "Co-ordinated outputs delivery - includes projects not directly delivering benefits", "Benefits realised during and after the programme", "Longer Timescale"],
      asProduct: "Define New Product",
      productCharacteristics: ["Manage product through its lifecycle", "Driven by product strategy", "Organize releases on roadmap", "Timescale is the product's lifetime"]
    }
  },
  programme: {
    noProgramme: "No - Not part of a programme",
    yesProgrammePrefix: "Yes - ",
    properties: {
      title: "Programme Properties"
    },
    title: "Background",
    fields: {
      name: {
        title: "Programme Name",
        description: "Descriptive name of the programme"
      },
      identifier: {
        title: "Identifier",
        description: "Programme Number, identifier or short name"
      },
      portfolio: {
        title: "Portfolio",
        help: "Select the Portfolio where the programme should be governed"
      },
      location: {
        title: "Location",
        help: "From where is the programme managed?"
      },
      department: {
        title: "Department",
        help: "Which department or line organization owns this programme?"
      },
      background: {
        title: "Justificaton and context",
        description: "Describe the current situation, the planned improvement and how it fits into overall corporate missions and goals",
        help: 'What is the current situation?\n          What is the intended improvement this program will deliver?\n          Which organizations are involved, and how will the organizations be improved?\n          How does this programme fit into corporate missions and goals?'
      },
      timing: {
        title: "Why now?",
        description: "Justification for the timing",
        help: 'What is the trigger that makes us want to do this right now?\n        Any external circumstances or internal factors? Any new insight, new technology or new strategy triggering the timing of this opportunity?'
      },
      successFactors: {
        title: "Success factors",
        description: "Describe what success looks like, what the criteria are and what boundaries and constraints exists",
        help: 'What are the critical success factors against which the programme will be assessed?\n          Any expectations on timelines, cost, benefits or potential constraints?'
      }
    },
    actions: {
      cancel: "Cancel",
      createProgramme: "Create Programme",
      update: "Update",
      background: "background",
      project: "programme"
    }
  },
  product: {
    properties: {
      title: "Product properties"
    },
    title: "Definition",
    fields: {
      name: {
        title: "Product Name",
        description: "Descriptive name of the product"
      },
      identifier: {
        title: "Identifier",
        description: "Product Number, identifier or short name"
      },
      portfolio: {
        title: "Portfolio",
        help: "Select the Portfolio where the product should be governed"
      },
      location: {
        title: "Location",
        help: "From where is the product managed?"
      },
      department: {
        title: "Department",
        help: "Which department or line organization owns this product?"
      },
      currency: {
        title: "Currency"
      },
      description: {
        title: "Description",
        description: "Describe what type of product this is, what the product does for the users, which problems it solves, which processes it supports and how it is structured.",
        help: 'What type of product is this? Is there a category name? Who is using this product and what will it do for them? Which needs does it meet or which problems does it solve? Which process areas does it cover? What is the composition of the product? Is it part of a bigger system, product line or platform? Which part of the organization is developing or maintaining it?'
      },
      background: {
        title: "Background",
        description: "Describe the history of the product and why is was introduced.",
        help: 'What originally triggered the making of this product? Why was this product, and not an alternative or existing solution, preferred?'
      },
      vision: {
        title: "Vision",
        description: "Summarize a vision statement or positioning statement for this product describing the end goal.",
        help: 'What is the end goal of the investment in this product \u2013 for you, the user or the customer? What will the roadmap in the end lead to? What is setting the strategic direction for the roadmap?'
      }
    },
    actions: {
      cancel: "Cancel",
      createProgramme: "Create Product",
      update: "Update",
      project: "product",
      background: "definition"
    }
  },
  release: {
    noProgramme: "No - Not part of a programme",
    yesProgrammePrefix: "Yes - ",
    properties: {
      title: "Release properties"
    },
    fields: {
      name: {
        title: "Release Name",
        description: "Descriptive name of the release",
        help: "Updated as part of the release plan"
      },
      identifier: {
        title: "Identifier",
        description: "Release Number, identifier or short name"
      },
      portfolio: {
        title: "Portfolio",
        help: "Select the Portfolio where the release should be governed"
      },
      programme: {
        title: "Is this release part of a programme?",
        help: "Select which programme this release is part of (if any)"
      }
    },
    actions: {
      cancel: "Cancel",
      createProgramme: "Create Release",
      update: "Update",
      project: "release"
    }
  },
  properties: {
    title: "Project Properties",
    fields: {
      name: {
        title: "Project Name",
        description: "Descriptive name"
      },
      identifier: {
        title: "Project Identifier",
        description: "Project number, identifier or short name"
      },
      portfolio: {
        title: "Project Portfolio",
        help: "Select the Portfolio where the project should be governed"
      },
      location: {
        title: "Location",
        help: "From where is the project managed?"
      },
      department: {
        title: "Department",
        help: "Which department or line organization owns this project?"
      },
      projectType: {
        title: "Project Type",
        help: "Different types of projects can have different types of design methods or life cycle phases"
      },
      category: {
        title: "Project Category",
        help: "What is the size or complexity level of the project?"
      },
      currency: {
        title: "Currency"
      },
      programme: {
        title: "Is this project part of a programme?",
        help: "Select which programme this project is part of (if any)"
      }
    }
  },
  background: definition.background,
  actions: {
    cancel: "Cancel",
    createProject: "Create Project",
    update: "Update",
    background: "background",
    project: "project"
  },
  clone: {
    title: "Clone project"
  }
};

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var definition = __webpack_require__(178).norwegian;

var norwegian = exports.norwegian = {
  initiative: {
    title: "Egenskaper",
    fields: {
      name: {
        title: "Navn",
        description: "Beskrivende navn"
      },
      identifier: {
        title: "Identifikator",
        description: "Nummer, identifikator eller kort navn"
      },
      portfolio: {
        title: "Portefølje",
        help: "Velg hvilken portefølje initiativet skal styres i"
      },
      asProject: "Definer nytt prosjekt",
      projectCharacteristics: ["Drevet av leveranser", "Midlertidig - definert start og slutt", "Avgrenset og angitte leveranser", "Levering av et produkt", "Gevinster oppstår vanligvis etter at prosjektet avsluttes", "Kortere tidshorisont"],
      asProgramme: "Definer nytt program",
      programmeCharacteristics: ["Drevet av en vision on sluttilstanden", "Ingen forhåndsdefinert sti", "Endringer i forretningsevne", "Koordinerte leveranser - inkluderer prosjekter som ikke gir direkte gevinster", "Gevinster realiseres underveis og etter programmet", "Lenger tidshorisont"],
      asProduct: "Definer nytt produkt",
      productCharacteristics: ["Følge opp produktet gjennom hele livsløpet", "Drevet av produktstrategi", "Organisere oppdateringer (release) i langtidsplan (roadmap)", "Tidshorisonten er produktets levetid"] }
  },
  programme: {
    noProgramme: "Nei - Ikke del av et program",
    yesProgrammePrefix: "Ja - ",
    properties: {
      title: "Programegenskaper"
    },
    title: "Bakgrunn",
    fields: {
      name: {
        title: "Programnavn",
        description: "Beskrivende navn"
      },
      identifier: {
        title: "Programidentifikator",
        description: "Programnummer, identifikator eller kort navn"
      },
      portfolio: {
        title: "Portefølje",
        help: "Velg hvilken portefølje programmet skal styres i"
      },
      location: {
        title: "Sted",
        help: "Angi stedet programmet styres fra"
      },
      department: {
        title: "Avdeling",
        help: "Angi hvilken avdeling som eier programmet"
      },
      background: {
        title: "Begrunnelse og sammenheng",
        description: "Beskriv den nåværende situasjonen, den planlagte forbedringen og hvordan den passer til organisasjonens overordende oppdrag og mål",
        help: 'Hva er den n\xE5v\xE6rende situasjonen?\n          Hva er den tiltenkte forbedringen dette programmet vil levere?\n          Hvilke organisasjoner er involvert, og hvordan skal organisasjonene forbedres?\n          Hvordan passer dette programmet inn i organisasjonens oppdrag og m\xE5l?'
      },
      timing: {
        title: "Hvorfor nå?",
        description: "Begrunnelse for tidspunktet",
        help: 'Hva er som utl\xF8ser at vi vil gj\xF8re dette akkurat n\xE5?\n          Eventuelle eksterne omstendigheter eller interne faktorer? En ny innsikt, ny teknologi eller en ny strategi som p\xE5virker tidspunktet for denne muligheten?'
      },
      successFactors: {
        title: "Suksessfaktorer",
        description: "Beskriv hvordan suksess som ser ut, hva er kriteriene og hvilke grenser og begrensninger som finnes",
        help: 'Hva er de kritiske suksessfaktorene som programmet vil bli vurdert mot?\n          Hvilke forventninger finnes til tidsperspektiv, kostnader, gevinster eller potensielle begrensninger?'
      }
    },
    actions: {
      cancel: "Avbryt",
      createProgramme: "Opprett program",
      update: "Oppdater",
      background: "bakgrunn",
      project: "program"
    }
  },
  product: {
    properties: {
      title: "Produktegenskaper"
    },
    title: "Definisjon",
    fields: {
      name: {
        title: "Produktnavn",
        description: "Beskrivende navn på produktet"
      },
      identifier: {
        title: "Produktidentifikator",
        description: "Produktnummer, identifikator eller kortnavn"
      },
      portfolio: {
        title: "Portefølje",
        help: "Velg porteføljen produktet skal følges opp i"
      },
      currency: {
        title: "Valuta"
      },
      location: {
        title: "Sted",
        help: "Angi stedet productet styres fra"
      },
      department: {
        title: "Avdeling",
        help: "Angi hvilken avdeling som eier productet"
      },
      description: {
        title: "Beskrivelse",
        description: "Beskriv hva slags produkt dette er, hva produktet gjør for brukerne, hvilke problemer det løser, hvilke prosesser det støttes og hvordan det er strukturert.",
        help: 'Hvilken type produkt er dette? Er det et kategorinavn? Hvem bruker dette produktet og hva skal det gj\xF8re for dem? Hvilke behov m\xF8ter det eller hvilke problemer l\xF8ser det? Hvilke prosessomr\xE5der dekker det? Hva er sammensetningen av produktet? Er det en del av et st\xF8rre system, produktlinje eller plattform? Hvilken del av organisasjonen utvikler eller opprettholder det?'
      },
      background: {
        title: "Bakgrunn",
        description: "Beskriv produktets historie og hvorfor ble det introdusert.",
        help: 'Hva utl\xF8ste opprinnelig produksjonen av dette produktet? Hvorfor var dette produktet foretrukket, og ikke et alternativ eller en eksisterende l\xF8sning?'
      },
      vision: {
        title: "Visjon",
        description: "Oppsummer en visjonen eller beskrivelse av produktets sluttmål.",
        help: 'Hva er sluttm\xE5l for investeringen i dette produktet - for deg, brukeren eller kunden? Hva vil langtidsplanen til slutt f\xF8re til? Hva setter den strategiske retningen for utviklingen?'
      }
    },
    actions: {
      cancel: "Avbryt",
      createProgramme: "Opprett produkt",
      update: "Oppdater",
      project: "produkt",
      background: "definisjon"
    }
  },
  release: {
    noProgramme: "Nei - Ikke del av et program",
    yesProgrammePrefix: "Ja - ",
    properties: {
      title: "Egenskaper for oppdatering"
    },
    fields: {
      name: {
        title: "Navn på oppdateringen",
        description: "Beskrivende navn for oppdateringen",
        help: "Navnet vedlikeholdes i planen for oppdateringen"
      },
      identifier: {
        title: "Identifikator",
        description: "Oppdateringsnummer, identifikator eller kortnavn"
      },
      portfolio: {
        title: "Portefølje",
        help: "Velg porteføljen produktet skal følges opp i"
      },
      programme: {
        title: "Er oppdateringen del av et program?",
        help: "Velg programmet oppdateringen er en del av (hvis noe)"
      }
    },
    actions: {
      cancel: "Avbryt",
      createProgramme: "Opprett oppdatering",
      update: "Oppdater",
      project: "oppdatering"
    }
  },
  properties: {
    title: "Prosjektegenskaper",
    fields: {
      name: {
        title: "Prosjektnavn",
        description: "Beskrivende navn"
      },
      identifier: {
        title: "Projektidentifikator",
        description: "Prosjektnummer, identifikator eller kort navn"
      },
      portfolio: {
        title: "Portefølje",
        help: "Velg hvilken portefølje prosjektet skal styres i"
      },
      location: {
        title: "Sted",
        help: "Angi stedet prosjektet styres fra"
      },
      department: {
        title: "Avdeling",
        help: "Angi hvilken avdeling som eier prosjektet"
      },
      projectType: {
        title: "Prosjekttype",
        help: "Forskjellige prosjekt-typer kan ha forskjellige design metoder eller livssyklus-faser "
      },
      category: {
        title: "Kategori",
        help: "Angi størrelsen på prosjektet"
      },
      currency: {
        title: "Valuta"
      },
      programme: {
        title: "Er prosjektet del av et program?",
        help: "Velg programmet prosjektet er en del av (hvis noe)"
      }
    }
  },
  background: definition.background,
  actions: {
    cancel: "Avbryt",
    createProject: "Opprett prosjekt",
    update: "Oppdater",
    background: "bakgrunn",
    project: "prosjekt"
  },
  clone: {
    title: "Klone prosjekt"
  }
};

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectSettings = exports.Access = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _superagent = __webpack_require__(23);

var _superagent2 = _interopRequireDefault(_superagent);

var _ProjectMenu = __webpack_require__(17);

var _ProjectMenu2 = _interopRequireDefault(_ProjectMenu);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _BusinessCaseSettings = __webpack_require__(427);

var _BusinessCaseSettings2 = _interopRequireDefault(_BusinessCaseSettings);

var _SettingsForUsage = __webpack_require__(428);

var _SettingsForUsage2 = _interopRequireDefault(_SettingsForUsage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefinitionSettings = function (_React$Component) {
  _inherits(DefinitionSettings, _React$Component);

  function DefinitionSettings(props) {
    _classCallCheck(this, DefinitionSettings);

    var _this = _possibleConstructorReturn(this, (DefinitionSettings.__proto__ || Object.getPrototypeOf(DefinitionSettings)).call(this, props));

    _this.state = _this.loadSettings(props);
    return _this;
  }

  _createClass(DefinitionSettings, [{
    key: 'loadSettings',
    value: function loadSettings(props) {
      return {
        edit: false,
        enabled: props.settings !== undefined && props.settings.show !== undefined ? props.settings.show : "definition",
        showBrief: props.settings !== undefined && props.settings.showBrief,
        showPID: props.settings !== undefined && props.settings.showPID
      };
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState(this.loadSettings(props));
    }
  }, {
    key: 'selectBackground',
    value: function selectBackground(event) {
      this.setState({ enabled: "background", showBrief: false });
    }
  }, {
    key: 'selectDefinition',
    value: function selectDefinition(event) {
      this.setState({ enabled: "definition" });
    }
  }, {
    key: 'enableBrief',
    value: function enableBrief(event) {
      this.setState({ showBrief: event.target.checked });
    }
  }, {
    key: 'enablePID',
    value: function enablePID(event) {
      this.setState({ showPID: event.target.checked });
    }
  }, {
    key: 'changeSettings',
    value: function changeSettings(event) {
      event.preventDefault();
      this.setState({ edit: !this.state.edit });
    }
  }, {
    key: 'cancelChange',
    value: function cancelChange(event) {
      event.preventDefault();
      this.setState(this.loadSettings(this.props));
    }
  }, {
    key: 'updateSettings',
    value: function updateSettings(event) {
      event.preventDefault();
      this.setState({ edit: false });
      if (this.props.onUpdate !== undefined) {
        this.props.onUpdate({
          area: "definition",
          definition: {
            show: this.state.enabled,
            showBrief: this.state.showBrief,
            showPID: this.state.showPID
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var url = this.state.enabled === "definition" ? "/images/definition.png" : "/images/background.png";
      return _react2.default.createElement(
        'div',
        { style: { display: "flex", paddingBottom: 20 } },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('img', { src: url })
        ),
        this.state.edit ? _react2.default.createElement(
          'div',
          { style: { paddingLeft: 30 } },
          'Use',
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('input', { onChange: this.selectBackground.bind(this), type: 'radio', name: 'definition', value: 'background', defaultChecked: this.state.enabled !== "definition", id: 'background' }),
              _react2.default.createElement(
                'span',
                null,
                ' '
              ),
              _react2.default.createElement(
                'label',
                { htmlFor: 'background' },
                'Background only'
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('input', { onChange: this.selectDefinition.bind(this), type: 'radio', name: 'definition', value: 'background', defaultChecked: this.state.enabled === "definition", id: 'definition' }),
              _react2.default.createElement(
                'span',
                null,
                ' '
              ),
              _react2.default.createElement(
                'label',
                { htmlFor: 'definition' },
                'Definition'
              )
            )
          ),
          this.state.enabled === "definition" ? _react2.default.createElement(
            'div',
            { style: { paddingLeft: 20, paddingTop: 20 } },
            _react2.default.createElement(
              'b',
              null,
              'Enable document generation'
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('input', { onClick: this.enableBrief.bind(this), type: 'checkbox', defaultChecked: this.state.showBrief, id: 'brief' }),
              ' ',
              _react2.default.createElement(
                'label',
                { htmlFor: 'brief' },
                'Project Brief'
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('input', { onClick: this.enablePID.bind(this), type: 'checkbox', defaultChecked: this.state.showPID, id: 'pid' }),
              ' ',
              _react2.default.createElement(
                'label',
                { htmlFor: 'pid' },
                'Project Initiation Document'
              )
            )
          ) : null,
          _react2.default.createElement(
            'div',
            { style: { paddingTop: 15 } },
            _react2.default.createElement('input', { type: 'button', onClick: this.cancelChange.bind(this), className: 'cancel', value: 'Cancel' }),
            _react2.default.createElement('input', { onClick: this.updateSettings.bind(this), type: 'submit', className: 'save', value: 'Update' })
          )
        ) : _react2.default.createElement(
          'div',
          { style: { paddingLeft: 30 } },
          _react2.default.createElement(
            'div',
            null,
            'Use ',
            this.state.enabled === "definition" ? "Definition" : "Background",
            this.state.enabled === "definition" && (this.state.showBrief || this.state.showPID) ? _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'span',
                null,
                ' with enabled '
              ),
              [this.state.showBrief ? "Project Brief" : undefined, this.state.showPID ? "Project Initiation Document" : undefined].filter(function (item) {
                return item !== undefined;
              }).map(function (item) {
                return "\"" + item + "\"";
              }).join(", "),
              _react2.default.createElement(
                'span',
                null,
                '.'
              )
            ) : null
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingTop: 10 } },
            _react2.default.createElement(
              'i',
              null,
              'Switch between ',
              _react2.default.createElement(
                'b',
                null,
                'Background'
              ),
              ' and ',
              _react2.default.createElement(
                'b',
                null,
                'Definition'
              ),
              '. With ',
              _react2.default.createElement(
                'b',
                null,
                'Definition'
              ),
              ' it is possible to enable "',
              _react2.default.createElement(
                'b',
                null,
                'Project Brief'
              ),
              '" and ',
              _react2.default.createElement(
                'b',
                null,
                'Project Initiation Document'
              ),
              '.'
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingTop: 15 } },
            _react2.default.createElement(
              'a',
              { href: '#', onClick: this.changeSettings.bind(this) },
              'Change'
            )
          )
        )
      );
    }
  }]);

  return DefinitionSettings;
}(_react2.default.Component);

var QualitySettings = function (_React$Component2) {
  _inherits(QualitySettings, _React$Component2);

  function QualitySettings() {
    _classCallCheck(this, QualitySettings);

    return _possibleConstructorReturn(this, (QualitySettings.__proto__ || Object.getPrototypeOf(QualitySettings)).apply(this, arguments));
  }

  _createClass(QualitySettings, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_SettingsForUsage2.default, _extends({}, this.props, {
        image: '/images/quality_s1.png',
        area: 'quality',
        label: 'Quality',
        help: 'Turn on or off use of Quality'
      }));
    }
  }]);

  return QualitySettings;
}(_react2.default.Component);

var Access = exports.Access = {
  isBusinessCaseEnabled: function isBusinessCaseEnabled(settings) {
    var projectSettings = settings.project;
    var tenantSettings = settings.tenant;
    var disabledInTenant = tenantSettings !== undefined && tenantSettings.disableBusinessCase === true;
    var useBusinessCaseInProject = projectSettings !== undefined && projectSettings.useBusinessCase !== undefined && projectSettings.useBusinessCase;
    var businessCaseEnabled = projectSettings === undefined || projectSettings !== undefined && projectSettings.useBusinessCase === undefined && !disabledInTenant || useBusinessCaseInProject === true || useBusinessCaseInProject === undefined;
    //    console.log("businessCase "+businessCaseEnabled+" (form "+JSON.stringify(settings)+", disabledInTenant: "+disabledInTenant+")");
    return businessCaseEnabled;
  }
};

var ProjectSettings = exports.ProjectSettings = function (_React$Component3) {
  _inherits(ProjectSettings, _React$Component3);

  function ProjectSettings(props) {
    _classCallCheck(this, ProjectSettings);

    var _this3 = _possibleConstructorReturn(this, (ProjectSettings.__proto__ || Object.getPrototypeOf(ProjectSettings)).call(this, props));

    _this3.state = _this3.loadSettings({ project: props.project.settings, tenant: props.tenantSettings });
    return _this3;
  }

  _createClass(ProjectSettings, [{
    key: 'loadSettings',
    value: function loadSettings(settings) {
      var projectSettings = settings.project;
      var tenantSettings = settings.tenant;
      return {
        definition: {
          show: projectSettings !== undefined && projectSettings.disabledDefinition ? "background" : "definition",
          showBrief: projectSettings !== undefined && projectSettings.reports !== undefined && projectSettings.reports.projectBrief,
          showPID: projectSettings !== undefined && projectSettings.reports !== undefined && projectSettings.reports.PID
        },
        businessCase: {
          enabled: Access.isBusinessCaseEnabled(settings)
        },
        quality: {
          enabled: projectSettings !== undefined && projectSettings.disabledQuality ? false : true
        }
      };
    }
  }, {
    key: 'updateSettings',
    value: function updateSettings(newSettings) {
      var _this4 = this;

      var commands = [];
      console.log("Update settings of " + newSettings.area + ": " + JSON.stringify(newSettings));
      if (newSettings.area === "definition") {
        if (this.state.definition.show !== newSettings.definition.show && newSettings.definition.show === "background") {
          commands = commands.concat({ type: "disableDefinition" });
        } else {
          if (newSettings.definition.show === "definition" && this.state.definition.show !== "definition") {
            commands = commands.concat({ type: "enableDefinition" });
          }
          if (newSettings.definition.show === "definition" && newSettings.definition.showBrief && !this.state.definition.showBrief) {
            commands = commands.concat({ type: "enableProjectBrief" });
          }
          if (newSettings.definition.show === "definition" && this.state.definition.show === "definition" && this.state.definition.showBrief && !newSettings.definition.showBrief) {
            commands = commands.concat({ type: "disableProjectBrief" });
          }
          if (newSettings.definition.show === "definition" && newSettings.definition.showPID && !this.state.definition.showPID) {
            commands = commands.concat({ type: "enableProjectInitiationDocument" });
          }
          if (newSettings.definition.show === "definition" && this.state.definition.show === "definition" && this.state.definition.showPID && !newSettings.definition.showPID) {
            commands = commands.concat({ type: "disableProjectInitiationDocument" });
          }
        }
      } else if (newSettings.area === "businessCase") {
        if (this.state.businessCase.enabled !== newSettings.use) {
          commands = commands.concat({ type: newSettings.use ? "enableBusinessCase" : "disableBusinessCase" });
        }
      } else if (newSettings.area === "quality") {
        if (this.state.quality.enabled !== newSettings.use) {
          commands = commands.concat({ type: newSettings.use ? "enableQuality" : "disableQuality" });
        }
      } else {
        alert("Settings for " + newSettings.area + " is not supported.");
        this.setState(this.loadSettings(this.props.settings));
      }
      if (commands.length > 0) {
        this.sendCommand({ type: "updateProjectSettings", commands: commands, project: { id: this.props.project.id } }).then(function (settings) {
          return _this4.setState(_this4.loadSettings(settings));
        }).catch(function (details) {
          alert("Could not update settings. " + JSON.stringify(details));
          _this4.setState(_this4.loadSettings(_this4.props.settings));
        });
      }
    }

    //Modified from Change.js

  }, {
    key: 'sendCommand',
    value: function sendCommand(command) {
      return new Promise(function (resolve, reject) {
        _superagent2.default.post("/").send(command).end(function (error, response) {
          if (error === null && response.status === 200) {
            var message = JSON.parse(response.text);
            if (message.status === "OK") {
              console.log("Success for command '" + command.type + "'");
              resolve(message.settings);
            } else {
              console.log("Error: " + message.message);
              reject(message.message);
            }
          } else {
            console.log("Error: " + error + ", got " + response.status + " with message " + response.text);
            reject(response.text);
          }
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { display: "flex", padding: 30, justifyContent: "center", fontFamily: "Lato" } },
        _react2.default.createElement(
          'div',
          { style: { width: 1016 } },
          _react2.default.createElement(DefinitionSettings, _extends({}, this.props, { settings: this.state.definition, onUpdate: this.updateSettings.bind(this) })),
          _react2.default.createElement(_BusinessCaseSettings2.default, _extends({}, this.props, { settings: this.state.businessCase, onUpdate: this.updateSettings.bind(this) })),
          _react2.default.createElement(QualitySettings, _extends({}, this.props, { settings: this.state.quality, onUpdate: this.updateSettings.bind(this) }))
        )
      );
    }
  }]);

  return ProjectSettings;
}(_react2.default.Component);

var ProjectSettingsPage = function (_React$Component4) {
  _inherits(ProjectSettingsPage, _React$Component4);

  function ProjectSettingsPage() {
    _classCallCheck(this, ProjectSettingsPage);

    return _possibleConstructorReturn(this, (ProjectSettingsPage.__proto__ || Object.getPrototypeOf(ProjectSettingsPage)).apply(this, arguments));
  }

  _createClass(ProjectSettingsPage, [{
    key: 'render',
    value: function render() {
      var menu = this.props.showMenu === true ? _react2.default.createElement(_ProjectMenu2.default, this.props) : undefined;
      return _react2.default.createElement(
        _Layout2.default,
        _extends({}, this.props, { projectMenu: menu }),
        _react2.default.createElement(ProjectSettings, this.props)
      );
    }
  }]);

  return ProjectSettingsPage;
}(_react2.default.Component);

exports.default = ProjectSettingsPage;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getProjectInitiationDocument;

var _getProjectBrief = __webpack_require__(434);

var _getProjectBrief2 = _interopRequireDefault(_getProjectBrief);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getProjectInitiationDocument(project) {
  var version = project.pid !== undefined && project.pid.history !== undefined ? project.pid.history.filter(function (item) {
    return project.currentStage !== undefined && item.stage === project.currentStage.id || project.currentState === undefined && (item.stage === undefined || item.stage === null);
  }).length : 0;
  if (project.approvedStages === undefined && version === 0) {
    version = 1;
  }
  return Object.assign({}, (0, _getProjectBrief2.default)(project), {
    qualityManagementApproach: project.qualityApproach,
    riskManagementApproach: project.riskApproach,
    changeControlApproach: project.changeControlApproach,
    communicationManagementApproach: Object.assign({}, project.communicationApproach, { stakeholderCommunication: project.stakeholderCommunication }),
    plan: project.stages,
    projectControls: project.projectControls,
    stage: project.currentStage !== undefined ? project.currentStage.id : undefined,
    version: project.pid !== undefined && project.pid.history !== undefined ? project.pid.history.length : 0,
    minorVersion: version,
    majorVersion: project.approvedStages !== undefined ? project.approvedStages : 0
  });
}

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getProjectBrief;

var _getProjectDefinition = __webpack_require__(1067);

var _getProjectDefinition2 = _interopRequireDefault(_getProjectDefinition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getProjectBrief(project) {
  var definition = (0, _getProjectDefinition2.default)(project);
  definition.scope.items = definition.scope.items !== undefined ? definition.scope.items.map(function (item) {
    return { id: item.id, text: item.text };
  }) : [];
  return {
    definition: definition,
    businessCase: project.businessCase,
    projectProductDescription: project.projectScope,
    organization: project.stakeholders !== undefined && project.stakeholders.length > 0 ? project.stakeholders : undefined,
    approach: project.approach,
    version: project.brief !== undefined && project.brief.history !== undefined ? project.brief.history.length : 0
  };
}

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var english = exports.english = {
  general: {
    benefit: "Benefit",
    businessCase: "Business Case"
  },
  strategy: {
    title: "Strategy and Objectives",
    fields: {
      reasons: {
        title: "Reasons",
        help: "Which part of the business strategy is supported by the outputs of this project?\n          If this project is part of a programme, which programme objectives are supported by this project\u2019s outputs?",
        description: "The reason for undertaking the project and how the project will enable strategies and objectives"
      }
    }
  },
  summary: {
    title: "Summary",
    fields: {
      executiveSummary: {
        title: "Excecutive Summary",
        help: "What is the main reason why a change is needed?\n          What are the key outputs a project will deliver, and what are the most important benefits this will bring?\n          What is the total investment cost and the high level project timeline?\n          What do we know about the return of the investment?",
        description: "Highlight of important benefits, return on investment and other keypoints"
      }
    }
  },
  options: {
    title: "Options",
    fields: {
      doNothing: {
        title: "Do nothing",
        help: "What is the current situation like?\n          What are the consequences if nothing is done?\n          What is the lost opportunity if nothing is done?\n          Any time or money wasted with current situation?\n          How can we be sure \u201Cdoing nothing\u201D is a bad option?",
        description: "What will happen if nothing is done"
      },
      doMinimal: {
        title: "Do minimal",
        help: "What is the minimum scope that would make a difference to the current situation?\n          Is there a small step that can be made first, and then more can be done later?",
        description: "Describe the minimal business option"
      },
      doSomething: {
        title: "Do something",
        help: "Have several other options been investigated? If no \u2013 why not? If yes, what are they?\n          What main benefits do each option give?\n          What complexity level or investment level would be needed for each option?",
        description: "List the options evaluated. Describe which option was selected and why"
      }
    }
  },
  benefits: {
    title: "Benefits",
    fields: {
      benefits: {
        title: "Key benefits",
        help: "Benefits are measurable results through the use of the project\u2019s outputs. You can look at benefits as Key Performance Indicators (KPIs) to be used, also after the project is closed, to measure the progress of the business case. Can you measure improved efficiency, lower cost, better data or product quality, increased usage, better stability, better response time, better customer satisfaction, increased compliance or increased market share?",
        columns: {
          no: { title: "Id" },
          title: { title: "Benefit" },
          baseline: { title: "Baseline" },
          goal: { title: "Goal" },
          accountable: { title: "Accountable" }
        },
        options: {
          addEntry: {
            title: "Add benefit"
          }
        }
      }
    }
  },
  returnOnInvestment: {
    title: "Return on Investment",
    fields: {
      projectPlanSummary: {
        title: "Summary of the project plan",
        help: "What is the total investment of the project?\n          How long will the project last? Over which period will the benefits be realized?\n          What will be the cost on ongoing operation and maintenance?",
        description: "The total investment over which time period"
      },
      investmentAppraisal: {
        title: "Investment Appraisal",
        help: "What is the value of the benefits and how does it compare to the total investments needed?\n          Where will the investment funding come from? Where will maintenance cost come from?\n          Can you quantify the return on investment by describing when the investment will be paid\n          back, what the net present value is, or what the internal rate of return is?",
        description: "Compare total investment with planned benefits. Return on Investment. Net present value. etc."
      },
      risks: {
        title: "Major risks",
        help: "Are there any specific risks to the project and the business case?\n          If so, what is the likely impact those risks?\n          What should be done to mitigate those risks?",
        description: "Key risk associated with the project together with the likely impact and plans should they occur."
      }
    }
  },
  benefitDetails: {
    title: "Benefit details",
    fields: {
      title: {
        title: "Benefit title",
        description: "Short descriptive name of the benefit"
      },
      accountable: {
        title: "Accountable",
        help: "Who needs to follow up and make sure this benefit is realized \u2013 also after the project is done?",
        description: "Name of the accountable for the benefit"
      },
      measurement: {
        title: "How and when this benefit can be measured",
        help: "Is there a technique used to measure this benefit? Any tools or methods?\n          When should this benefit be measured? During the project? After the project?\n          Should a baseline be measured before the project is executed?",
        description: "Describe how this benefit can be measured and when it should be measured"
      },
      actions: {
        title: "Management actions and resources",
        help: "Are there any management actions required to ensure the project\u2019s outcomes are achieved?\n          Any resources (people, money, tools etc.) needed to follow up benefit measurements and benefit realization?",
        description: "Management actions required to realize benefits and needed resources"
      },
      baseline: {
        title: "Baseline",
        help: "What is the measurable value of this benefit before the project is executed?",
        description: "The measurable value before the project"
      },
      goal: {
        title: "Goal",
        help: "What is the measurable end goal of this benefit linked to the business case?",
        description: "Measurable goal"
      }
    }
  }
};

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var norwegian = exports.norwegian = {
  general: {
    benefit: "Gevinst",
    businessCase: "Begrunnelse"
  },
  strategy: {
    title: "Strategi og mål",
    fields: {
      reasons: {
        title: "Grunner til å gjennomføre",
        help: "Hvilken del av forretningsstrategien st\xF8ttes av leveransene fra dette prosjektet?\n          Hvis dette prosjektet er en del av et program, hvilke programm\xE5l er st\xF8ttet av prosjektets leveranser?",
        description: "Grunnen til å gjennomføre prosjektet og hvordan prosjektet vil muliggjøre strategier og nå mål"
      }
    }
  },
  summary: {
    title: "Oppsummering",
    fields: {
      executiveSummary: {
        title: "Sammendrag",
        help: "Hva er hovedgrunnen til at en endring er n\xF8dvendig?\n          Hva er de viktigste leveransene prosjektet m\xE5 levere, og hva er de viktigste gevinstene dette vil bringe?\n          Hva er den samlede investeringskostnaden og prosjektplanets tidslinje p\xE5 h\xF8yt niv\xE5?\n          Hva vet vi om avkastningen av investeringen?",
        description: "Fremhev viktige gevinster, avkastning på investeringen og andre nøkkelpunkter"
      }
    }
  },
  options: {
    title: "Alternativer",
    fields: {
      doNothing: {
        title: "Konsekvens av å ikke gjøre noe",
        help: "Hvordan er den n\xE5v\xE6rende situasjonen?\n          Hva er konsekvensene dersom ingenting blir gjort?\n          Finnes det en tapt mulighet, dersom ingenting blir gjort?\n          Blir tid eller penger sl\xF8st bort med dagens situasjon?\n          Hvordan kan vi v\xE6re sikre p\xE5 at \"\xE5 gj\xF8re ingenting\" er et d\xE5rlig alternativ?",
        description: "Beskriv hva som skjer dersom ingenting blir gjort"
      },
      doMinimal: {
        title: "Gjøre minimalt",
        help: "Hva er det minste omfanget som vil gj\xF8re en forskjell i forhold til den n\xE5v\xE6rende situasjonen?\n          Er det et lite skritt som kan gj\xF8res f\xF8rst, og s\xE5 kan flere gj\xF8res senere?",
        description: "Beskriv hva som er det minimale som kan gjøres"
      },
      doSomething: {
        title: "Vurderte alternativer",
        help: "Har flere andre alternativer blitt unders\xF8kt? Hvis nei - hvorfor ikke? Hvis ja, hvilke alternativer er unders\xF8kt?\n          Hvilke hovedfordeler gir hvert alternativ?\n          Hvilket kompleksitetsniv\xE5 eller investeringsniv\xE5 vil v\xE6re n\xF8dvendig for hvert alternativ?",
        description: "List opp alternativer som er evaluert. Beskriv hvilket alternativ som er valgt og begrunnelsen."
      }
    }
  },
  benefits: {
    title: "Gevinster",
    fields: {
      benefits: {
        title: "Overordnede gevinster",
        help: "Gevinster er m\xE5lbare resultater ved bruk av prosjektets leveranser. Du kan se p\xE5 gevinster som n\xF8kkelparametre (engelsk: KPI) som skal brukes, ogs\xE5 etter at prosjektet er avsluttet, for \xE5 m\xE5le fremdriften i begrunnelsen for prosjektet. Kan du m\xE5le forbedret effektivitet, lavere kostnad, bedre data eller \xF8kt produktkvalitet, \xF8kt bruk, bedre stabilitet, bedre responstid, bedre kundetilfredshet, \xF8kt etterlevelse eller \xF8kt markedsandel?",
        columns: {
          no: { title: "Id" },
          title: { title: "Gevinst" },
          baseline: { title: "Nå-verdi" },
          goal: { title: "Mål" },
          accountable: { title: "Ansvarlig" }
        },
        options: {
          addEntry: {
            title: "Legg til gevinst"
          }
        }
      }
    }
  },
  returnOnInvestment: {
    title: "Avkastning",
    fields: {
      projectPlanSummary: {
        title: "Oppsummering av prosjektplanen",
        help: "Hva er prosjektets totale investering?\n          Hvor lenge skal prosjektet vare? I hvilken periode vil gevinstene bli realisert?\n          Hva blir kostnaden ved p\xE5g\xE5ende drift og vedlikehold?",
        description: "Beskriv total investering og forventet tidsperiode for prosjektet"
      },
      investmentAppraisal: {
        title: "Investeringsvurdering",
        help: "Hva er verdien av gevinstene, og hvordan er den sammenlignet med de totale investeringene som trengs?\n          Hvor kommer investeringsfinansieringen fra? Hvor kommer vedlikeholdskostnaden fra?\n          Kan du kvantifisere avkastningen p\xE5 investeringen ved \xE5 beskrive n\xE5r investeringen vil bli betalt\n          tilbake, hva er n\xE5tidsverdien, eller hva er den interne avkastningen?",
        description: "Sammenlign samlede investeringer med planlagte gevinster. Avkastning på investeringen. Netto nåverdi. etc."
      },
      risks: {
        title: "Overordnet risiko",
        help: "Er det noen spesifikke risikoer for prosjektet og forretningssaken?\n          I s\xE5 fall, hva er den sannsynlige effekten de risikerer?\n          Hva skal gj\xF8res for \xE5 redusere disse risikoene?",
        description: "Risiko knyttet til prosjektet sammen med sannsynlig innvirkning og planer dersom de skulle forekomme."
      }
    }
  },
  benefitDetails: {
    title: "Gevinstdetaljer",
    fields: {
      title: {
        title: "Gevinsttittel",
        description: "Kort beskrivende navn på gevinsten"
      },
      accountable: {
        title: "Ansvarlig",
        help: "Hvem m\xE5 f\xF8lge opp og s\xF8rge for at denne gevinsten blir realisert - ogs\xE5 etter at prosjektet er ferdig?",
        description: "Navn på den ansvarlige for gevinsten"
      },
      measurement: {
        title: "Hvordan og når kan gevinsten bli målt",
        help: "Er det en teknikk som brukes til \xE5 m\xE5le denne gevinsten? Eventuelle verkt\xF8y eller metoder?\n          N\xE5r skal denne fordelen m\xE5les? Underveis i prosjektet? Etter prosjektet er avsluttet?\n          Skal en n\xE5verdi m\xE5les f\xF8r prosjektet gjenomf\xF8res?",
        description: "Beskriv hvordan denne fordelen kan måles og når den skal måles"
      },
      actions: {
        title: "Tiltak fra ledelsen og ressurser",
        help: "Er det noen ledelsesaktiviteter som kreves for \xE5 sikre at prosjektets resultater blir oppn\xE5dd?\n          Eventuelle ressurser (folk, penger, verkt\xF8y etc.) beh\xF8vde \xE5 f\xF8lge opp fordelsm\xE5linger og nytteverdi?",
        description: "Angi hvilke aktiviteter ledelsen må iverksette for å realisere fordeler og hvilke ressurser som er nødvendig."
      },
      baseline: {
        title: "Nå-verdi",
        help: "Hva er den m\xE5lbare verdien av denne fordelen f\xF8r prosjektet utf\xF8res?",
        description: "Målbar verdi før prosjektet gjennomføres"
      },
      goal: {
        title: "Mål",
        help: "Hva er m\xE5lbart sluttm\xE5l for denne fordelen knyttet til forretningssaken?",
        description: "Målbart mål"
      }
    }
  }
};

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  name: "stageDescription",
  fields: [{ name: "name" }, { name: "identifier", optional: true, _excludedFor: ["project"] }, { name: "description", height: 2 }, { name: "prerequisite", height: 2, _excludedFor: ["product"] }]
}, {
  name: "stageContext",
  _excludedFor: ["product"],
  fields: [{ name: "externalDependencies", height: 2 }, { name: "assumptions", height: 2 }, { name: "stageApproach", height: 2 }, { name: "lessonsIncorporated", height: 2 }, { name: "monitorAndControl", height: 2 }]
}, {
  name: "stageTime",
  fields: [{ name: "period", type: "period" }, { name: "timeTolerance" }, { name: "timeToleranceUnit", options: [{ value: "days" }, { value: "weeks" }, { value: "months" }] }, { name: "timeComments", height: 2 }]
}, {
  name: "stageCost",
  fields: [{ name: "budget", type: "table",
    options: {
      summaryRow: true
    },
    columns: [{ name: "element" }, { name: "cost", editable: "true" }, { name: "tolerance", editable: "true" }, { name: "comment", editable: "true" }]
  }]
}, {
  name: "stageScheduleScope",
  fields: [{ name: "scheduleComments", height: 3
    /*
          { name: "plan", type:"table",
            columns: [
              { name: "workPackage" },
              { name: "owner" },
              { name: "dueDate" },
              { name: "status" },
              { name: "comment" }
            ],
            options: {
              addEntry: [
                { name: "workPackage ", fields: [ {name: "product" } ]}
              ]
            }
          }
    */
  }]
}];

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectPlan = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _ProjectMenu = __webpack_require__(17);

var _ProjectMenu2 = _interopRequireDefault(_ProjectMenu);

var _Flag = __webpack_require__(424);

var _Flag2 = _interopRequireDefault(_Flag);

var _Plan = __webpack_require__(263);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(58), __webpack_require__(59)]);

var Stage = function (_React$Component) {
  _inherits(Stage, _React$Component);

  function Stage() {
    _classCallCheck(this, Stage);

    return _possibleConstructorReturn(this, (Stage.__proto__ || Object.getPrototypeOf(Stage)).apply(this, arguments));
  }

  _createClass(Stage, [{
    key: 'asNumber',
    value: function asNumber(value) {
      var floatNumber = parseFloat(value);
      return isNaN(floatNumber) ? value : floatNumber.toLocaleString();
    }
  }, {
    key: 'editStage',
    value: function editStage(event) {
      event.preventDefault();
      if (this.props.onEdit !== undefined) {
        this.props.onEdit(this.props.id);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var baseStyle = this.props.id === "_totalStage" ? { backgroundColor: "#EEEEEE", borderTop: "double black 4px", borderBottom: " solid black 1px", paddingTop: 5, paddingBottom: 5, fontWeight: "bold" } : this.props.type === "total" ? { backgroundColor: "#EEEEEE", borderTop: "solid grey 2px", borderBottom: " solid grey 1px", paddingTop: 5, paddingBottom: 5, fontWeight: "bold" } : {};
      var timeStyle = Object.assign({}, baseStyle, { textAlign: "center", paddingRight: 10, whiteSpace: "nowrap" });
      var costStyle = Object.assign({}, baseStyle, { textAlign: "right", paddingLeft: 10, whiteSpace: "nowrap" });
      var titleStyle = Object.assign({}, baseStyle, { textAlign: "left", paddingLeft: 5 });
      if (this.props.active) {
        timeStyle.backgroundColor = "lightgrey";
        costStyle.backgroundColor = "lightgrey";
        titleStyle.backgroundColor = "lightgrey";
      } else if (this.props.historic) {
        timeStyle.color = "grey";
        costStyle.color = "grey";
        titleStyle.color = "grey";
      } else if (this.props.requestedTransitionTo) {
        timeStyle.fontWeight = "bold";
        costStyle.fontWeight = "bold";
        titleStyle.fontWeight = "bold";
      }
      return _react2.default.createElement(
        'tbody',
        null,
        _react2.default.createElement(
          'tr',
          { style: { borderSpacing: 10 } },
          _react2.default.createElement(
            'th',
            { style: titleStyle },
            this.props.name,
            this.props.requestedException ? _react2.default.createElement(
              'span',
              { style: { float: "right", paddingRight: 15 } },
              _react2.default.createElement(_Flag2.default, { requestedStageException: this.props.requestedException, requestedStageTransition: this.props.requestedTransitionTo })
            ) : null
          ),
          _react2.default.createElement('td', { style: titleStyle }),
          _react2.default.createElement(
            'td',
            { style: Object.assign({}, timeStyle, { minWidth: 75 * this.props.size !== undefined ? this.props.size : 1 }) },
            this.props.time.start
          ),
          _react2.default.createElement(
            'td',
            { style: Object.assign({}, timeStyle, { minWidth: 75 * this.props.size !== undefined ? this.props.size : 1 }) },
            this.props.time.end
          ),
          _react2.default.createElement(
            'td',
            { style: timeStyle },
            this.props.time.tolerance
          ),
          _react2.default.createElement('td', { style: costStyle }),
          _react2.default.createElement(
            'td',
            { style: costStyle },
            this.asNumber(this.props.cost.hours)
          ),
          _react2.default.createElement(
            'td',
            { style: costStyle },
            this.asNumber(this.props.cost.expences)
          ),
          _react2.default.createElement(
            'td',
            { style: costStyle },
            this.asNumber(this.props.cost.investments)
          ),
          _react2.default.createElement(
            'td',
            { style: costStyle },
            this.asNumber(this.props.cost.sum)
          ),
          _react2.default.createElement(
            'td',
            { style: costStyle },
            this.asNumber(this.props.cost.tolerance)
          ),
          _react2.default.createElement(
            'td',
            null,
            this.props.showInReport !== true && this.props.historic === undefined ? _react2.default.createElement(
              'a',
              { onClick: this.editStage.bind(this), href: "?edit=" + this.props.id },
              _react2.default.createElement('img', { src: '/icons/pen_grey.jpg' })
            ) : _react2.default.createElement('span', null)
          )
        ),
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement('td', { colSpan: '11', style: { borderTop: "solid lightgrey 1px", paddingBottom: 10 } }),
          _react2.default.createElement('td', null)
        )
      );
    }
  }]);

  return Stage;
}(_react2.default.Component);

var StageForm = function (_React$Component2) {
  _inherits(StageForm, _React$Component2);

  function StageForm() {
    _classCallCheck(this, StageForm);

    return _possibleConstructorReturn(this, (StageForm.__proto__ || Object.getPrototypeOf(StageForm)).apply(this, arguments));
  }

  _createClass(StageForm, [{
    key: 'render',
    value: function render() {
      var updateActionLabel = this.props.requestedException ? "Approve" : this.props.active ? "Request" : this.props.requestedTransitionTo ? "Update request" : "Save";
      return _react2.default.createElement(
        'tbody',
        null,
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'td',
            { style: { textAlign: "left" } },
            _react2.default.createElement('input', { type: 'hidden', name: 'id', value: this.props.id }),
            _react2.default.createElement('input', { className: 'input', placeholder: 'Name', name: 'name', defaultValue: this.props.name }),
            this.props.requestedException ? _react2.default.createElement(
              'span',
              { style: { float: "right", paddingRight: 15 } },
              _react2.default.createElement(_Flag2.default, { requestedStageException: this.props.requestedException, requestedStageTransition: this.props.requestedTransitionTo })
            ) : null
          ),
          _react2.default.createElement('td', null),
          _react2.default.createElement(
            'td',
            { style: { textAlign: "center" } },
            _react2.default.createElement('input', { size: '12', name: 'time_start', placeholder: 'start date',
              defaultValue: this.props.time !== undefined ? this.props.time.start : "" })
          ),
          _react2.default.createElement(
            'td',
            { style: { textAlign: "center" } },
            _react2.default.createElement('input', { size: '12', name: 'time_end', placeholder: 'end date',
              defaultValue: this.props.time !== undefined ? this.props.time.end : "" })
          ),
          _react2.default.createElement(
            'td',
            { style: { textAlign: "center" } },
            _react2.default.createElement('input', { size: '12', name: 'time_tolerance', placeholder: 'tolerance',
              defaultValue: this.props.time !== undefined ? this.props.time.tolerance : "" })
          ),
          _react2.default.createElement('td', null),
          _react2.default.createElement(
            'td',
            { style: { textAlign: "right" } },
            _react2.default.createElement('input', { size: '12', name: 'cost_hours', placeholder: 'hours', style: { textAlign: "right" },
              defaultValue: this.props.cost !== undefined ? this.props.cost.hours : "" })
          ),
          _react2.default.createElement(
            'td',
            { style: { textAlign: "right" } },
            _react2.default.createElement('input', { size: '12', name: 'cost_expences', placeholder: 'expences', style: { textAlign: "right" },
              defaultValue: this.props.cost !== undefined ? this.props.cost.expences : "" })
          ),
          _react2.default.createElement(
            'td',
            { style: { textAlign: "right" } },
            _react2.default.createElement('input', { size: '12', name: 'cost_investment', placeholder: 'investment', style: { textAlign: "right" },
              defaultValue: this.props.cost !== undefined ? this.props.cost.investment : "" })
          ),
          _react2.default.createElement(
            'td',
            { style: { textAlign: "right" } },
            _react2.default.createElement('input', { size: '12', name: 'cost_sum', placeholder: 'sum', style: { textAlign: "right" },
              defaultValue: this.props.cost !== undefined ? this.props.cost.sum : "" })
          ),
          _react2.default.createElement(
            'td',
            { style: { textAlign: "right" } },
            _react2.default.createElement('input', { size: '12', name: 'cost_tolerance', placeholder: 'tolerance', style: { textAlign: "right" },
              defaultValue: this.props.cost !== undefined ? this.props.cost.tolerance : "" })
          )
        ),
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement('td', { colSpan: '2' }),
          _react2.default.createElement(
            'td',
            { colSpan: '3', style: { color: "grey", verticalAlign: "top", paddingTop: 20 } },
            'Note:',
            _react2.default.createElement(
              'ul',
              { style: { marginTop: 0 } },
              _react2.default.createElement(
                'li',
                null,
                'Dates should follow yyyy-mm-dd format for',
                _react2.default.createElement('br', null),
                ' correct sorting'
              ),
              _react2.default.createElement(
                'li',
                { style: { marginTop: "1em" } },
                'Tolerance units are igored. Tolerance numbers',
                _react2.default.createElement('br', null),
                ' are summarized without unit conversion.'
              )
            )
          ),
          _react2.default.createElement('td', null),
          _react2.default.createElement(
            'td',
            { colSpan: '5', style: { paddingTop: 20, paddingBottom: 15 } },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('textarea', { style: { float: "right" }, cols: '70', rows: '8', name: 'comments', placeholder: 'Comments', defaultValue: this.props.comments })
            ),
            _react2.default.createElement(
              'div',
              { style: { paddingTop: 15, float: "right" } },
              this.props.requestedTransitionTo && updateActionLabel === "Update request" ? _react2.default.createElement(
                'p',
                null,
                'Requested transition to, update request.'
              ) : _react2.default.createElement('span', null),
              _react2.default.createElement('input', { onClick: this.props.onCancel, className: 'cancel', type: 'submit', name: 'cancel', value: 'Cancel' }),
              _react2.default.createElement(
                'span',
                { style: { paddingRight: 30 } },
                ' '
              ),
              _react2.default.createElement('input', { style: { marginRight: 0 }, className: 'save', type: 'submit', name: 'action', value: updateActionLabel })
            )
          )
        ),
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement('td', { colSpan: '11', style: { borderTop: "solid lightgrey 1px", paddingBottom: 10 } })
        )
      );
    }
  }]);

  return StageForm;
}(_react2.default.Component);

var ProjectTotal = function (_React$Component3) {
  _inherits(ProjectTotal, _React$Component3);

  function ProjectTotal() {
    _classCallCheck(this, ProjectTotal);

    return _possibleConstructorReturn(this, (ProjectTotal.__proto__ || Object.getPrototypeOf(ProjectTotal)).apply(this, arguments));
  }

  _createClass(ProjectTotal, [{
    key: 'intValue',
    value: function intValue(value) {
      var intValue = parseFloat(value);
      return isNaN(intValue) ? 0 : intValue;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var baseStyle = { backgroundColor: "#EEEEEE", borderTop: "double black 3px", borderBottom: " solid black 1px", paddingTop: 5, paddingBottom: 5, fontWeight: "bold" };
      var timeStyle = Object.assign({}, baseStyle, { textAlign: "center", paddingRight: 10, whiteSpace: "nowrap" });
      var costStyle = Object.assign({}, baseStyle, { textAlign: "right", paddingLeft: 10, whiteSpace: "nowrap" });
      var titleStyle = Object.assign({}, baseStyle, { textAlign: "left", paddingLeft: 5 });
      var minDate = this.props.project.stages !== undefined ? this.props.project.stages.map(function (stage) {
        return stage.time.start;
      }).sort()[0] : "";
      var maxDate = this.props.project.stages !== undefined ? this.props.project.stages.map(function (stage) {
        return stage.time.end;
      }).sort().reverse()[0] : "";
      var sumTimeTolerance = this.props.project.stages !== undefined ? this.props.project.stages.reduce(function (a, b) {
        return a + _this4.intValue(b.time.tolerance);
      }, 0) : "";
      var sumHours = this.props.project.stages !== undefined ? this.props.project.stages.reduce(function (a, b) {
        return a + _this4.intValue(b.cost.hours);
      }, 0) : 0;
      var sumExpences = this.props.project.stages !== undefined ? this.props.project.stages.reduce(function (a, b) {
        return a + _this4.intValue(b.cost.expences);
      }, 0) : 0;
      var sumInvestment = this.props.project.stages !== undefined ? this.props.project.stages.reduce(function (a, b) {
        return a + _this4.intValue(b.cost.investment);
      }, 0) : 0;
      var sumCost = this.props.project.stages !== undefined ? this.props.project.stages.reduce(function (a, b) {
        return a + _this4.intValue(b.cost.sum);
      }, 0) : 0;
      var sumCostTolerance = this.props.project.stages !== undefined ? this.props.project.stages.reduce(function (a, b) {
        return a + _this4.intValue(b.cost.tolerance);
      }, 0) : 0;
      return _react2.default.createElement(
        'tbody',
        null,
        _react2.default.createElement(
          'tr',
          { style: { borderSpacing: 10 } },
          _react2.default.createElement(
            'th',
            { colSpan: '2', style: titleStyle },
            'Complete project'
          ),
          _react2.default.createElement(
            'td',
            { style: timeStyle },
            minDate
          ),
          _react2.default.createElement(
            'td',
            { style: timeStyle },
            maxDate
          ),
          _react2.default.createElement(
            'td',
            { style: timeStyle },
            sumTimeTolerance
          ),
          _react2.default.createElement('td', { style: costStyle }),
          _react2.default.createElement(
            'td',
            { style: costStyle },
            sumHours.toLocaleString()
          ),
          _react2.default.createElement(
            'td',
            { style: costStyle },
            sumExpences.toLocaleString()
          ),
          _react2.default.createElement(
            'td',
            { style: costStyle },
            sumInvestment.toLocaleString()
          ),
          _react2.default.createElement(
            'td',
            { style: costStyle },
            sumCost.toLocaleString()
          ),
          _react2.default.createElement(
            'td',
            { style: costStyle },
            sumCostTolerance.toLocaleString()
          ),
          _react2.default.createElement('td', { style: timeStyle })
        )
      );
    }
  }]);

  return ProjectTotal;
}(_react2.default.Component);

function convertScheduleToPlan1Stages(schedule) {
  return schedule.map(function (phase) {
    return Object.assign({}, phase, {
      items: phase.items.map(function (stage) {
        return Object.assign({}, stage, {
          time: {
            start: stage.start,
            end: stage.end,
            tolerance: stage.timeTolerance
          },
          cost: {
            hours: stage.hours,
            expences: stage.expences,
            investments: stage.investments,
            sum: stage.sum,
            tolerance: stage.costTolerance
          }
        });
      })
    });
  });
}

var ProjectPlan = exports.ProjectPlan = function (_React$Component4) {
  _inherits(ProjectPlan, _React$Component4);

  function ProjectPlan(props) {
    _classCallCheck(this, ProjectPlan);

    var _this5 = _possibleConstructorReturn(this, (ProjectPlan.__proto__ || Object.getPrototypeOf(ProjectPlan)).call(this, props));

    _this5.state = { stages: _this5.props.project.stages };
    return _this5;
  }

  _createClass(ProjectPlan, [{
    key: 'addRow',
    value: function addRow(event) {
      event.preventDefault();
      if (this.props.onAddStage !== undefined) {
        this.props.onAddStage();
      }
      this.setState({ addRowEnabled: true, editStage: undefined });
    }
  }, {
    key: 'cancelEdit',
    value: function cancelEdit(event) {
      event.preventDefault();
      this.setState({ addRowEnabled: false, editStage: undefined });
    }
  }, {
    key: 'editStage',
    value: function editStage(stageId) {
      if (this.props.onEditStage !== undefined) {
        this.props.onEditStage(stageId);
      } else {
        this.setState({ addRowEnabled: false, editStage: stageId });
      }
    }
  }, {
    key: 'submitForm',
    value: function submitForm(event) {
      var _this6 = this;

      if (this.props.onSubmit !== undefined) {
        this.props.onSubmit(event).then(function (stages) {
          _this6.setState({ stages: stages, addRowEnabled: false, editStage: undefined });
        }).catch(function (error) {
          alert("Could not update plan, please try again. \nDetails: " + JSON.stringify(error));
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var labels = translations.getTranslation(this.props).schedule.fields.schedule;
      var currency = this.props.project.currency;
      return _react2.default.createElement(
        'div',
        { style: { marginLeft: 20 } },
        this.props.showInReport !== true ? _react2.default.createElement(
          'h2',
          null,
          'Project plan'
        ) : null,
        _react2.default.createElement(
          'form',
          { method: 'POST', action: './plan', onSubmit: this.submitForm.bind(this) },
          _react2.default.createElement(
            'table',
            { style: { fontSize: this.props.fontSize === undefined ? "inherit" : this.props.fontSize }, cellPadding: '0', cellSpacing: '0' },
            _react2.default.createElement(
              'thead',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement('th', { style: { width: 300, backgroundColor: "#EEEEEE" } }),
                _react2.default.createElement('th', { style: { width: 50 } }),
                _react2.default.createElement(
                  'th',
                  { colSpan: '3', style: { fontWeight: "normal", fontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif", background: "#EEEEEE", textAlign: "center", color: "grey", fontSize: "140%" } },
                  labels.columnHeaders.time.title
                ),
                _react2.default.createElement('th', { style: { width: 50 } }),
                _react2.default.createElement(
                  'th',
                  { colSpan: '5', style: { fontWeight: "normal", fontFamily: "Arial, Helvetica Neue, Helvetica, sans-serif", background: "#EEEEEE", textAlign: "center", color: "grey", fontSize: "140%" } },
                  labels.columnHeaders.cost.title,
                  currency !== undefined ? _react2.default.createElement(
                    'span',
                    null,
                    ' (',
                    currency,
                    ')'
                  ) : null
                ),
                _react2.default.createElement('th', null)
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement('th', { colSpan: '2' }),
                _react2.default.createElement(
                  'th',
                  { style: { paddingTop: 10, borderBottom: "solid grey 1px", paddingRight: 10 } },
                  labels.columns.start.title
                ),
                _react2.default.createElement(
                  'th',
                  { style: { paddingTop: 10, borderBottom: "solid grey 1px", paddingRight: 10 } },
                  labels.columns.end.title
                ),
                _react2.default.createElement(
                  'th',
                  { style: { paddingTop: 10, borderBottom: "solid grey 1px" } },
                  labels.columns.timeTolerance.title,
                  this.props.showInReport === true && labels.columns.timeTolerance.note !== undefined ? " *" : null
                ),
                _react2.default.createElement('th', null),
                _react2.default.createElement(
                  'th',
                  { style: { paddingTop: 10, borderBottom: "solid grey 1px", paddingRight: 10 } },
                  labels.columns.hours.title
                ),
                _react2.default.createElement(
                  'th',
                  { style: { paddingTop: 10, borderBottom: "solid grey 1px", paddingRight: 10 } },
                  labels.columns.expences.title
                ),
                _react2.default.createElement(
                  'th',
                  { style: { paddingTop: 10, borderBottom: "solid grey 1px", paddingRight: 10 } },
                  labels.columns.investments.title
                ),
                _react2.default.createElement(
                  'th',
                  { style: { paddingTop: 10, borderBottom: "solid grey 1px", paddingRight: 10 } },
                  labels.columns.sum.title
                ),
                _react2.default.createElement(
                  'th',
                  { style: { paddingTop: 10, borderBottom: "solid grey 1px" } },
                  labels.columns.costTolerance.title
                ),
                _react2.default.createElement('th', null)
              ),
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement('td', { colSpan: '12', style: { paddingTop: 10 } })
              )
            ),
            this.state.stages !== undefined && this.props.planVersion !== "2" ? this.state.stages.map(function (stage) {
              return stage.id === _this7.props.edit || stage.id === _this7.state.editStage ? _react2.default.createElement(StageForm, _extends({ key: stage.id }, stage, { onCancel: _this7.cancelEdit.bind(_this7) })) : _react2.default.createElement(Stage, _extends({ key: stage.id }, stage, { onEdit: _this7.editStage.bind(_this7), showInReport: _this7.props.showInReport }));
            }) : _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement('td', { colSpan: '12', style: { paddingLeft: 15 } })
              )
            ),
            this.props.add && this.props.planVersion !== "2" || this.state.addRowEnabled ? _react2.default.createElement(StageForm, { onCancel: this.cancelEdit.bind(this) }) : null,
            this.props.planVersion !== "2" ? _react2.default.createElement(ProjectTotal, this.props) : null,
            this.props.planVersion !== "2" && this.props.showInReport !== true && this.props.project.state !== "completed" && (this.props.project.requestedStageTransition === undefined || this.props.project.requestedStageTransition !== undefined && this.props.project.requestedStageTransition.stage) !== undefined ? _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { colSpan: '12', style: { paddingTop: 20 } },
                  _react2.default.createElement(
                    'a',
                    { onClick: this.addRow.bind(this), href: '?add=true' },
                    'Add row'
                  )
                )
              )
            ) : null,
            this.props.planVersion === "2" ? convertScheduleToPlan1Stages((0, _Plan.addTotalsToSchedule)((0, _Plan.setupSchedule)(this.state.stages, this.props), this.props)).map(function (phase) {
              return [_react2.default.createElement(
                'tbody',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    { colSpan: '12', style: { paddingTop: 20, paddingBottom: 5, fontWeight: "bold", fontSize: "120%" } },
                    phase.text
                  )
                )
              )].concat(phase.items.filter(function (stage) {
                return stage !== undefined;
              }).map(function (stage) {
                return _react2.default.createElement(Stage, _extends({ key: stage.id }, stage, { showInReport: _this7.props.showInReport }));
              }));
            }) : null
          ),
          this.props.showInReport === true && labels.columns.timeTolerance.note !== undefined ? _react2.default.createElement(
            'div',
            { style: { fontSize: this.props.fontSize === undefined ? "inherit" : this.props.fontSize } },
            '* ',
            labels.columns.timeTolerance.note
          ) : null
        )
      );
    }
  }]);

  return ProjectPlan;
}(_react2.default.Component);

var ProjectPlanPage = function (_React$Component5) {
  _inherits(ProjectPlanPage, _React$Component5);

  function ProjectPlanPage() {
    _classCallCheck(this, ProjectPlanPage);

    return _possibleConstructorReturn(this, (ProjectPlanPage.__proto__ || Object.getPrototypeOf(ProjectPlanPage)).apply(this, arguments));
  }

  _createClass(ProjectPlanPage, [{
    key: 'render',
    value: function render() {
      var menu = this.props.showMenu === true ? _react2.default.createElement(_ProjectMenu2.default, this.props) : undefined;
      return _react2.default.createElement(
        _Layout2.default,
        _extends({}, this.props, { projectMenu: menu }),
        _react2.default.createElement(ProjectPlan, this.props)
      );
    }
  }]);

  return ProjectPlanPage;
}(_react2.default.Component);

exports.default = ProjectPlanPage;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StagePlanContent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _superagent = __webpack_require__(23);

var _superagent2 = _interopRequireDefault(_superagent);

var _ProjectBrief = __webpack_require__(264);

var _Report = __webpack_require__(258);

var _FormattedContent = __webpack_require__(15);

var _FormattedContent2 = _interopRequireDefault(_FormattedContent);

var _AreaForm = __webpack_require__(28);

var _AreaForm2 = _interopRequireDefault(_AreaForm);

var _sendCommand = __webpack_require__(25);

var _sendCommand2 = _interopRequireDefault(_sendCommand);

var _Slides = __webpack_require__(259);

var _Slides2 = _interopRequireDefault(_Slides);

var _ReleaseImplementationMethod = __webpack_require__(1091);

var _ReleaseImplementationMethod2 = _interopRequireDefault(_ReleaseImplementationMethod);

var _ReleaseFlow = __webpack_require__(1092);

var _ReleaseFlow2 = _interopRequireDefault(_ReleaseFlow);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

var _Plan = __webpack_require__(263);

var _setupStageBudget = __webpack_require__(440);

var _setupStageBudget2 = _interopRequireDefault(_setupStageBudget);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(58), __webpack_require__(59)]).loadVariants([__webpack_require__(441), __webpack_require__(442)]);

function formatBudgetNumber(value, context) {
  return value !== undefined && value !== null ? value.replace(/\B(?=(\d{3})+(?!\d))/g, context.language !== "norwegian" ? "," : " ") : "";
}

var Budget = function (_React$Component) {
  _inherits(Budget, _React$Component);

  function Budget() {
    _classCallCheck(this, Budget);

    return _possibleConstructorReturn(this, (Budget.__proto__ || Object.getPrototypeOf(Budget)).apply(this, arguments));
  }

  _createClass(Budget, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var labels = translations.getTranslation(this.props).stageCost.fields.budget.columns;
      var headings = translations.getTranslation(this.props).general;
      return this.props.budget !== undefined ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'table',
          { style: { fontSize: "inherit", borderCollapse: "collapse", border: "solid 1px lightgrey", width: "100%" } },
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              { style: { backgroundColor: "#e9e7e6" } },
              Object.keys(labels).map(function (key, index) {
                return _react2.default.createElement(
                  'th',
                  { key: index, style: { border: "solid lightgrey 1px", padding: 5 } },
                  labels[key].title
                );
              })
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            this.props.budget.map(function (item, rowIndex) {
              return hasBudgetElement(item) ? _react2.default.createElement(
                'tr',
                { key: item.id, style: { fontWeight: rowIndex + 1 === _this2.props.budget.length ? "bold" : "normal" } },
                Object.keys(labels).map(function (key, index) {
                  return _react2.default.createElement(
                    'td',
                    { key: index, style: { border: "solid lightgrey 1px", padding: 5, textAlign: key === "cost" || key === "tolerance" ? "right" : undefined } },
                    key === "element" ? headings[item.id] : formatBudgetNumber(item[key], _this2.props)
                  );
                })
              ) : null;
            })
          )
        ),
        this.props.project.currency !== undefined ? _react2.default.createElement(
          'div',
          { style: { paddingTop: 10 } },
          _react2.default.createElement(
            'i',
            null,
            headings.stagePlanCurrency.replace("{currency}", this.props.project.currency)
          )
        ) : null
      ) : null;
    }
  }]);

  return Budget;
}(_react2.default.Component);

var Schedule = function (_React$Component2) {
  _inherits(Schedule, _React$Component2);

  function Schedule() {
    _classCallCheck(this, Schedule);

    return _possibleConstructorReturn(this, (Schedule.__proto__ || Object.getPrototypeOf(Schedule)).apply(this, arguments));
  }

  _createClass(Schedule, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).general.stagePlan;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          null,
          labels.startDate,
          ': ',
          this.props.stage.time.start
        ),
        _react2.default.createElement(
          'span',
          { style: { paddingLeft: 20 } },
          labels.endDate,
          ': ',
          this.props.stage.time.end
        ),
        this.props.stage.time.tolerance !== undefined && this.props.stage.time.tolerance !== null || this.props.stage.timeComments !== undefined && this.props.stage.timeComments !== null ? _react2.default.createElement(
          'div',
          null,
          labels.timeTolerance,
          _react2.default.createElement(
            'span',
            null,
            ' '
          ),
          (0, _Plan.formatTimeTolerance)(this.props.stage.time, this.props),
          this.props.stage.timeComments !== undefined ? _react2.default.createElement(
            'div',
            { style: { paddingTop: 10 } },
            _react2.default.createElement(_FormattedContent2.default, { value: this.props.stage.timeComments })
          ) : null
        ) : null
      );
    }
  }]);

  return Schedule;
}(_react2.default.Component);

function hasFieldValue(field) {
  var hasFieldValue = field !== undefined && field !== null && field.trim().length !== 0;
  return hasFieldValue;
}

function hasBudgetElement(element) {
  var hasBudgetElement = element !== undefined && element !== null && (hasFieldValue(element.cost) || hasFieldValue(element.tolerance) || hasFieldValue(element.comment));
  return hasBudgetElement;
}

function hasBudget(budget) {
  var hasRows = [];
  if (budget !== undefined && budget !== null) {
    hasRows = hasRows.concat(budget.filter(function (elementRow) {
      return hasBudgetElement(elementRow);
    }).map(function (elementRow) {
      return elementRow.id;
    }));
  }
  return budget !== undefined && budget !== null && hasRows.length > 0;
}

var StagePlanSlides = function (_React$Component3) {
  _inherits(StagePlanSlides, _React$Component3);

  function StagePlanSlides() {
    _classCallCheck(this, StagePlanSlides);

    return _possibleConstructorReturn(this, (StagePlanSlides.__proto__ || Object.getPrototypeOf(StagePlanSlides)).apply(this, arguments));
  }

  _createClass(StagePlanSlides, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      var plan1Comments = this.props.stage.planVersion === 1 && this.props.stage.comments !== undefined && this.props.stage.comments !== this.props.stage.description ? this.props.stage.comments : null;
      var budget = this.props.stage.budget !== undefined && this.props.stage.planVersion > 1 ? this.props.stage.budget : (0, _setupStageBudget2.default)(this.props.stage);
      var date = this.props.date !== undefined ? new Date(Date.parse(this.props.date)).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10);
      var nameAndDate = (this.props.project !== undefined ? this.props.project.name + " - " : "") + date;

      var stagePlanSlides = [_react2.default.createElement(_Slides.FormattedSlide, {
        label: this.props.title,
        content: nameAndDate,
        slideType: 'title'
      }), _react2.default.createElement(_Slides.FormattedSlide, {
        label: labels.stageDescription.fields.description.title,
        content: this.props.stage.description
      }), _react2.default.createElement(_Slides.FormattedSlide, {
        label: labels.stageDescription.fields.prerequisite.title,
        content: this.props.stage.prerequisite
      }), _react2.default.createElement(_Slides.FormattedSlide, {
        label: labels.stageContext.fields.externalDependencies.title,
        content: this.props.stage.externalDependencies
      }), _react2.default.createElement(_Slides.FormattedSlide, {
        label: labels.stageContext.fields.assumptions.title,
        content: this.props.stage.assumptions
      }), _react2.default.createElement(_Slides.FormattedSlide, {
        label: labels.stageContext.fields.stageApproach.title,
        content: this.props.stage.stageApproach
      }), _react2.default.createElement(_Slides.FormattedSlide, {
        label: labels.stageContext.fields.lessonsIncorporated.title,
        content: this.props.stage.lessonsIncorporated
      }), _react2.default.createElement(_Slides.FormattedSlide, {
        label: labels.stageContext.fields.monitorAndControl.title,
        content: this.props.stage.monitorAndControl
      }), _react2.default.createElement(_Slides.FormattedSlide, {
        label: labels.general.stagePlan.budget,
        content: hasBudget(budget) ? _react2.default.createElement(Budget, _extends({}, this.props, { budget: budget })) : undefined
      }), _react2.default.createElement(_Slides.FormattedSlide, {
        label: labels.general.stagePlan.schedule,
        content: _react2.default.createElement(Schedule, _extends({}, this.props, { stage: this.props.stage }))
      }), _react2.default.createElement(_Slides.FormattedSlide, {
        label: labels.stageScheduleScope.fields.scheduleComments.title,
        content: this.props.stage.scheduleComments })];
      var stagePlanSlideTitles = [labels.stageDescription.frontPage, labels.stageDescription.fields.description.title, labels.stageDescription.fields.prerequisite.title, labels.stageContext.fields.externalDependencies.title, labels.stageContext.fields.assumptions.title, labels.stageContext.fields.stageApproach.title, labels.stageContext.fields.lessonsIncorporated.title, labels.stageContext.fields.monitorAndControl.title, labels.general.stagePlan.budget, labels.general.stagePlan.schedule, labels.stageScheduleScope.fields.scheduleComments.title];
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Slides2.default, { slides: stagePlanSlides, slideTitles: stagePlanSlideTitles })
      );
    }
  }]);

  return StagePlanSlides;
}(_react2.default.Component);

var StagePlanContent = exports.StagePlanContent = function (_React$Component4) {
  _inherits(StagePlanContent, _React$Component4);

  function StagePlanContent() {
    _classCallCheck(this, StagePlanContent);

    return _possibleConstructorReturn(this, (StagePlanContent.__proto__ || Object.getPrototypeOf(StagePlanContent)).apply(this, arguments));
  }

  _createClass(StagePlanContent, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      var plan1Comments = this.props.stage.planVersion === 1 && this.props.stage.comments !== undefined && this.props.stage.comments !== this.props.stage.description ? this.props.stage.comments : undefined;
      var budget = this.props.stage.budget !== undefined && this.props.stage.planVersion > 1 ? this.props.stage.budget : (0, _setupStageBudget2.default)(this.props.stage);
      return !this.props.presentationMode ? _react2.default.createElement(
        'div',
        { style: { paddingTop: 5 } },
        _react2.default.createElement(
          'table',
          { className: 'briefTable', style: { fontSize: "inherit", borderCollapse: "collapse" }, cellPadding: '0', cellSpacing: '0' },
          _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(_ProjectBrief.TableRow, {
              label: labels.stageDescription.fields.description.title,
              content: this.props.stage.description
            }),
            this.props.project.isProduct === true || this.props.stage.isRelease === true ? _react2.default.createElement(_ProjectBrief.TableRow, {
              label: labels.stageDescription.fields.method.title,
              content: labels.stageDescription.fields.method.values[this.props.stage.method]
            }) : null,
            _react2.default.createElement(_ProjectBrief.TableRow, {
              label: labels.stageDescription.fields.prerequisite.title,
              content: this.props.stage.prerequisite
            }),
            _react2.default.createElement(_ProjectBrief.TableRow, {
              label: labels.stageContext.fields.externalDependencies.title,
              content: this.props.stage.externalDependencies
            }),
            _react2.default.createElement(_ProjectBrief.TableRow, {
              label: labels.stageContext.fields.assumptions.title,
              content: this.props.stage.assumptions
            }),
            _react2.default.createElement(_ProjectBrief.TableRow, {
              label: labels.stageContext.fields.stageApproach.title,
              content: this.props.stage.stageApproach
            }),
            _react2.default.createElement(_ProjectBrief.TableRow, {
              label: labels.stageContext.fields.lessonsIncorporated.title,
              content: this.props.stage.lessonsIncorporated
            }),
            _react2.default.createElement(_ProjectBrief.TableRow, {
              label: labels.stageContext.fields.monitorAndControl.title,
              content: this.props.stage.monitorAndControl
            }),
            _react2.default.createElement(_ProjectBrief.TableRow, {
              label: labels.general.stagePlan.budget,
              content: hasBudget(budget) ? _react2.default.createElement(Budget, _extends({}, this.props, { budget: budget })) : undefined
            }),
            _react2.default.createElement(_ProjectBrief.TableRow, {
              label: labels.general.stagePlan.schedule,
              content: _react2.default.createElement(Schedule, _extends({}, this.props, { stage: this.props.stage }))
            })
          )
        ),
        plan1Comments !== undefined ? _react2.default.createElement(
          'div',
          { style: { paddingTop: 15 } },
          _react2.default.createElement(
            'i',
            null,
            _react2.default.createElement(_FormattedContent2.default, { value: plan1Comments })
          )
        ) : null,
        _react2.default.createElement(
          'h3',
          null,
          labels.stageScheduleScope.fields.scheduleComments.title
        ),
        _react2.default.createElement(_FormattedContent2.default, { value: this.props.stage.scheduleComments })
      ) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(StagePlanSlides, this.props)
      );
    }
  }]);

  return StagePlanContent;
}(_react2.default.Component);

var BackMenu = function (_React$Component5) {
  _inherits(BackMenu, _React$Component5);

  function BackMenu() {
    _classCallCheck(this, BackMenu);

    return _possibleConstructorReturn(this, (BackMenu.__proto__ || Object.getPrototypeOf(BackMenu)).apply(this, arguments));
  }

  _createClass(BackMenu, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).general.stageMenu;
      return _react2.default.createElement(
        'div',
        { style: { paddingBottom: 20 } },
        _react2.default.createElement(
          'a',
          { href: "../../" + (this.props.project.isRelease === true ? "" : "plan?show=approach&planVersion=2#schedule"), onClick: this.props.onCancel },
          '<- ',
          labels.back
        )
      );
    }
  }]);

  return BackMenu;
}(_react2.default.Component);

var MoveStageAction = function (_React$Component6) {
  _inherits(MoveStageAction, _React$Component6);

  function MoveStageAction(props) {
    _classCallCheck(this, MoveStageAction);

    var _this7 = _possibleConstructorReturn(this, (MoveStageAction.__proto__ || Object.getPrototypeOf(MoveStageAction)).call(this, props));

    _this7.state = { inAction: false };
    return _this7;
  }

  _createClass(MoveStageAction, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState({ inAction: false });
    }
  }, {
    key: 'toggleView',
    value: function toggleView(event) {
      event.preventDefault();
      this.setState({ inAction: !this.state.inAction });
    }
  }, {
    key: 'moveStage',
    value: function moveStage(event) {
      event.preventDefault();
      if (this.props.onMoveStage !== undefined) {
        this.props.onMoveStage(this.props.stage.id, event.target.value);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).general.stageMenu;
      return this.props.projectType === undefined || this.props.projectType.phases === undefined ? null //<div>No phases for project type</div>
      : this.state.inAction ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'b',
          null,
          labels.move
        ),
        _react2.default.createElement(
          'div',
          { style: { paddingLeft: 10 } },
          labels.selectPhase,
          ':',
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'select',
              { value: this.props.stage.phase !== undefined ? this.props.stage.phase.id : undefined, onChange: this.moveStage.bind(this) },
              this.props.stage.phase === undefined || this.props.stage.phase.id === undefined ? _react2.default.createElement(
                'option',
                { value: '' },
                '- ',
                labels.noPhase,
                ' - '
              ) : null,
              this.props.projectType.phases.map(function (phase) {
                return _react2.default.createElement(
                  'option',
                  { key: phase.id, value: phase.id },
                  phase.text
                );
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingTop: 10 } },
            _react2.default.createElement(
              'a',
              { onClick: this.toggleView.bind(this), href: '#' },
              labels.cancelMove
            )
          )
        )
      ) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'a',
          { href: '#', onClick: this.toggleView.bind(this) },
          labels.move
        )
      );
    }
  }]);

  return MoveStageAction;
}(_react2.default.Component);

var ProjectClosure = function (_React$Component7) {
  _inherits(ProjectClosure, _React$Component7);

  function ProjectClosure(props) {
    _classCallCheck(this, ProjectClosure);

    var _this8 = _possibleConstructorReturn(this, (ProjectClosure.__proto__ || Object.getPrototypeOf(ProjectClosure)).call(this, props));

    _this8.state = { displayClosure: false };
    return _this8;
  }

  _createClass(ProjectClosure, [{
    key: 'selectClosure',
    value: function selectClosure(event) {
      event.preventDefault();
      this.setState({ displayClosure: !this.state.displayClosure });
    }
  }, {
    key: 'confirmClosure',
    value: function confirmClosure(event) {
      event.preventDefault();
      if (this.props.onConfirm !== undefined) {
        this.props.onConfirm(); //{type:event.target.elements.closure.value});
      }
      this.setState({ displayClosure: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).general.stageMenu;
      return this.state.displayClosure ? _react2.default.createElement(
        'div',
        { style: { paddingTop: 15 } },
        _react2.default.createElement(
          'form',
          { onSubmit: this.confirmClosure.bind(this) },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'b',
              null,
              'Project Closure'
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingTop: 5 } },
            'Select closure approach:'
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('input', { name: 'closure', type: 'radio', value: 'planned', id: 'plannedClosure' }),
            ' ',
            _react2.default.createElement(
              'label',
              { htmlFor: 'plannedClosure' },
              'Planned closure'
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('input', { name: 'closure', type: 'radio', value: 'unplanned', id: 'prematureClosure' }),
            ' ',
            _react2.default.createElement(
              'label',
              { htmlFor: 'prematureClosure' },
              'Premature closure'
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingTop: 10 } },
            _react2.default.createElement('input', { className: 'save', type: 'submit', value: 'Prepare closure' }),
            _react2.default.createElement(
              'a',
              { onClick: this.selectClosure.bind(this), href: '#' },
              'Cancel'
            )
          )
        )
      ) : _react2.default.createElement(
        'div',
        { style: { paddingTop: 10 } },
        _react2.default.createElement(
          'a',
          { onClick: this.confirmClosure.bind(this), href: '#' },
          labels.prepareClosure
        )
      );
    }
  }]);

  return ProjectClosure;
}(_react2.default.Component);

var StageTransition = function (_React$Component8) {
  _inherits(StageTransition, _React$Component8);

  function StageTransition(props) {
    _classCallCheck(this, StageTransition);

    var _this9 = _possibleConstructorReturn(this, (StageTransition.__proto__ || Object.getPrototypeOf(StageTransition)).call(this, props));

    var nextStage = _this9.findNextStage(props.project);
    var pendingApproval = _this9.props.project.requestedStageTransition !== undefined && _this9.props.project.requestedStageTransition.stage !== undefined && _this9.props.project.requestedStageTransition.stage.id === _this9.props.stage.id;
    var isNextStage = nextStage !== undefined && nextStage.id === _this9.props.stage.id;
    var isCurrentStage = _this9.props.project.currentStage !== undefined && _this9.props.project.currentStage.id === _this9.props.stage.id;
    _this9.state = {
      status: pendingApproval ? "pendingApproval" : isNextStage ? "nextStage" : isCurrentStage ? "currentStage" : undefined,
      lastStage: isCurrentStage && nextStage === undefined
    };
    return _this9;
  }

  _createClass(StageTransition, [{
    key: 'findNextStage',
    value: function findNextStage(project) {
      var nextStage = undefined;
      if (project.stages !== undefined && project.stages.length > 0) {
        var currentIndex = -1;
        if (project.currentStage !== undefined) {
          project.stages.forEach(function (stage, index) {
            if (stage.id === project.currentStage.id) {
              currentIndex = index;
            }
          });
        }
        if (currentIndex + 1 < project.stages.length) {
          nextStage = project.stages[currentIndex + 1];
        } else {
          var closeProject = true;
        }
      }
      return nextStage;
    }
  }, {
    key: 'requestStageApproval',
    value: function requestStageApproval() {
      var _this10 = this;

      var action = "request";
      _superagent2.default.get("/projects/" + this.props.project.id + "/" + action + "/" + this.props.stage.id + "?redirect=false").then(function (response) {
        _this10.setState({ status: "pendingApproval" });
        if (_this10.props.onUpdate !== undefined) {
          _this10.props.onUpdate(JSON.parse(response.text).project);
        }
      }).catch(function (error) {
        console.log("Received error", error);
        alert("An error occured, please try again");
      });
    }
  }, {
    key: 'approveStage',
    value: function approveStage() {
      var _this11 = this;

      var action = "approve";
      _superagent2.default.get("/projects/" + this.props.project.id + "/" + action + "/" + this.props.stage.id + "?redirect=false").then(function (response) {
        _this11.setState({ status: "currentStage" });
        if (_this11.props.onUpdate !== undefined) {
          _this11.props.onUpdate(JSON.parse(response.text).project);
        }
      }).catch(function (error) {
        console.log("Received error", error);
        alert("An error occured, please try again");
      });
    }
  }, {
    key: 'retractStageApproval',
    value: function retractStageApproval() {
      var _this12 = this;

      var action = "retract";
      _superagent2.default.get("/projects/" + this.props.project.id + "/" + action + "/" + this.props.stage.id + "?redirect=false").then(function (response) {
        _this12.setState({ status: "nextStage" });
        if (_this12.props.onUpdate !== undefined) {
          _this12.props.onUpdate(JSON.parse(response.text).project);
        }
      }).catch(function (error) {
        console.log("Received error", error);
        alert("An error occured, please try again");
      });
    }
  }, {
    key: 'prepareClosure',
    value: function prepareClosure(details) {
      var _this13 = this;

      (0, _sendCommand2.default)({ type: "prepareProjectClosure", project: { id: this.props.project.id } }).then(function () {
        return window.location = "/projects/" + _this13.props.project.id;
      }).catch(function (error) {
        console.log("[ERROR] not able to prepare closure, got ", error);
        alert("An error occured, please try again");
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).general.stageMenu;
      var status = this.state.status;
      return status === "pendingApproval" ? _react2.default.createElement(
        'div',
        { id: 'nextStageWithPendingRequest' },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'a',
            { onClick: this.approveStage.bind(this), href: '#' },
            labels.approveStage
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'a',
            { onClick: this.retractStageApproval.bind(this), href: '#' },
            labels.retractRequest
          )
        )
      ) : status === "nextStage" ? _react2.default.createElement(
        'div',
        { id: 'nextStageWithoutPendingRequest' },
        _react2.default.createElement(
          'a',
          { onClick: this.requestStageApproval.bind(this), href: '#' },
          labels.requestApproval
        )
      ) : status === "currentStage" ? _react2.default.createElement(
        'div',
        { id: 'currentStage' },
        this.props.report === undefined && !this.props.project.isClosing ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'a',
            { href: "/projects/" + this.props.project.id + "/highlight?endStage=true" },
            labels.endStageReport
          )
        ) : null,
        this.props.closureEnabled === true && !this.props.project.isClosing ? _react2.default.createElement(ProjectClosure, _extends({}, this.props, { onConfirm: this.prepareClosure.bind(this) })) : null,
        this.props.stage.approved === undefined ? _react2.default.createElement(
          'div',
          { style: { color: "#212121", marginTop: 10, fontFamily: "Lato", backgroundColor: "#FFEADB", padding: 5 } },
          labels.changesToApprovedStage
        ) : null
      ) : _react2.default.createElement('div', { id: 'notCurrentNorNextStage' });
    }
  }]);

  return StageTransition;
}(_react2.default.Component);

var RaiseException = function (_React$Component9) {
  _inherits(RaiseException, _React$Component9);

  function RaiseException() {
    _classCallCheck(this, RaiseException);

    return _possibleConstructorReturn(this, (RaiseException.__proto__ || Object.getPrototypeOf(RaiseException)).apply(this, arguments));
  }

  _createClass(RaiseException, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).general.stageMenu;
      var isCurrentStage = this.props.project.currentStage !== undefined && this.props.project.currentStage.id === this.props.stage.id;
      return isCurrentStage ? _react2.default.createElement(
        'div',
        { style: { display: "normal", color: "grey" } },
        _react2.default.createElement(
          'a',
          { href: "/projects/" + this.props.project.id + "/change?show=approach" },
          labels.raiseException
        )
      ) : null;
    }
  }]);

  return RaiseException;
}(_react2.default.Component);

var ReportActions = function (_React$Component10) {
  _inherits(ReportActions, _React$Component10);

  function ReportActions() {
    _classCallCheck(this, ReportActions);

    return _possibleConstructorReturn(this, (ReportActions.__proto__ || Object.getPrototypeOf(ReportActions)).apply(this, arguments));
  }

  _createClass(ReportActions, [{
    key: 'edit',
    value: function edit(event) {
      if (this.props.onEdit) {
        this.props.onEdit(event);
      } else if (this.props.disableEdit === "reloadPlan") {
        event.preventDefault();
        window.location = (this.props.stage.isRelease ? "/releases/" + this.props.stage.id : "/projects/" + this.props.project.id) + "/plan?editStage=" + this.props.stage.id;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).general.stageMenu;
      return _react2.default.createElement(
        'div',
        { style: { paddingTop: 15 } },
        _react2.default.createElement(
          'b',
          null,
          labels.stageActions
        ),
        _react2.default.createElement(
          'div',
          { style: { paddingLeft: 10 } },
          this.props.deleteEnabled || this.props.disableEdit !== true && this.props.stage.historic !== true ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'a',
              { href: '#', onClick: this.edit.bind(this) },
              labels.edit
            )
          ) : null,
          this.props.hideActuals === false && this.props.stage.historic === true || this.props.project.isClosing ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'a',
              { onClick: this.props.onActuals, href: '#' },
              labels.registerActuals
            )
          ) : null,
          _react2.default.createElement(MoveStageAction, this.props),
          this.props.project.isProduct === true || this.props.stage.isRelease === true ? _react2.default.createElement(_ReleaseFlow2.default, _extends({}, this.props, { release: this.props.stage })) : _react2.default.createElement(StageTransition, this.props)
        ),
        this.props.report !== undefined ? _react2.default.createElement(
          'div',
          { style: { paddingTop: 15 } },
          _react2.default.createElement(
            'b',
            null,
            'End Stage Report'
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingLeft: 10 } },
            _react2.default.createElement(
              'a',
              { href: "/projects/" + this.props.project.id + "/reports?id=" + this.props.report.id + "&showEndStage=true" },
              'View in archive'
            )
          )
        ) : null
      );
    }
  }]);

  return ReportActions;
}(_react2.default.Component);

function formatNumber(value, column, context) {
  return column === "hours" || column === "expences" || column === "investments" || column === "sum" || column === "costTolerance" || column === "cost" || column === "tolerance" ? _react2.default.createElement(
    'div',
    { style: { textAlign: "right" } },
    value !== undefined && value !== null ? value.replace(/\B(?=(\d{3})+(?!\d))/g, context.language !== "norwegian" ? "," : " ") : ""
  ) : _react2.default.createElement(_FormattedContent2.default, { value: value });
}

var Actuals = function (_React$Component11) {
  _inherits(Actuals, _React$Component11);

  function Actuals(props) {
    _classCallCheck(this, Actuals);

    var _this16 = _possibleConstructorReturn(this, (Actuals.__proto__ || Object.getPrototypeOf(Actuals)).call(this, props));

    var labels = translations.getTranslation(props).general;
    _this16.state = {
      actuals: {
        id: "actuals",
        period: {
          from: props.stage.time.start !== null && props.stage.time.start !== undefined && props.stage.time.start.length > 0 ? props.stage.time.start : undefined,
          to: props.stage.time.end !== null && props.stage.time.end !== undefined && props.stage.time.end.trim().length > 0 ? props.stage.time.end : undefined
        },
        cost: (0, _setupStageBudget2.default)(props.stage, labels).map(function (item) {
          return Object.assign({}, item, { _format: formatNumber });
        })
      }
    };
    return _this16;
  }

  _createClass(Actuals, [{
    key: 'onUpdate',
    value: function onUpdate(event) {
      if (this.props.onUpdate !== undefined) {
        this.props.onUpdate(this.state.actuals);
      }
    }
  }, {
    key: 'handleFieldChange',
    value: function handleFieldChange(fieldName) {
      var _this17 = this;

      return function (event) {
        _this17.setState({
          actuals: Object.assign({}, _this17.state.actuals, _defineProperty({}, event.target.name, event.target.value))
        });
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var form = [{
        name: "actuals",
        fields: [{ name: "period", type: "period" }, { name: "cost", type: "table",
          options: {
            summaryRow: true
          },
          columns: [{ name: "element" }, { name: "cost", editable: "true" }, { name: "comment", editable: "true" }]
        }]
      }];
      var areas = translations.createTranslatedForm(form, this.props.language, this.props.variant);
      var labels = translations.getTranslation(this.props).general;
      return _react2.default.createElement(
        'div',
        { style: { minWidth: 800 } },
        _react2.default.createElement(_AreaForm2.default, _extends({}, this.props, {
          display: 'tab',
          areas: areas,
          item: this.state.actuals,
          onCancel: this.props.onCancel,
          onUpdate: this.onUpdate.bind(this),
          label: labels.actuals,
          handleFieldChange: this.handleFieldChange.bind(this),
          modified: true,
          selected: 0
        })),
        _react2.default.createElement('div', { style: { paddingTop: 50, borderBottom: "solid 3px grey" } })
      );
    }
  }]);

  return Actuals;
}(_react2.default.Component);

var StagePlan = function (_React$Component12) {
  _inherits(StagePlan, _React$Component12);

  function StagePlan(props) {
    _classCallCheck(this, StagePlan);

    var _this18 = _possibleConstructorReturn(this, (StagePlan.__proto__ || Object.getPrototypeOf(StagePlan)).call(this, props));

    _this18.state = {
      stage: props.stage,
      registerActuals: false
    };
    return _this18;
  }

  _createClass(StagePlan, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState({ stage: props.stage });
    }
  }, {
    key: 'toggleActuals',
    value: function toggleActuals(event) {
      this.setState({ registerActuals: !this.state.registerActuals });
    }
  }, {
    key: 'updateActuals',
    value: function updateActuals(actuals) {
      var _this19 = this;

      var command = {
        type: "assignActuals",
        period: actuals.period,
        cost: actuals.cost.map(function (item) {
          return { id: item.id, cost: item.cost, comment: item.comment };
        })
      };
      if (this.props.project.isRelease === true) {
        command = Object.assign({}, command, {
          product: { id: this.props.stage.product.id },
          release: { id: this.props.stage.id }
        });
      } else if (this.props.project.isProduct === true) {
        command = Object.assign({}, command, {
          product: { id: this.props.project.id },
          release: { id: this.props.stage.id }
        });
      } else {
        command = Object.assign({}, command, {
          project: { id: this.props.project.id },
          stage: { id: this.props.stage.id }
        });
      }
      (0, _sendCommand2.default)(command).then(function (response) {
        _this19.setState({ stage: response.stage, registerActuals: false });
        if (_this19.props.onUpdateStage !== undefined) {
          _this19.props.onUpdateStage(response.stage);
        }
      }).catch(function (error) {
        console.log("[ERROR] Not able to save actuals, got ", error);
        alert("An error occured, please try again");
      });
    }
  }, {
    key: 'makeActive',
    value: function makeActive(event) {
      event.preventDefault();
      console.log("Show implementation selector");
      this.setState({ implementationMethodVisible: true });
    }
  }, {
    key: 'setImplementationMethod',
    value: function setImplementationMethod(method, projectId) {
      var _this20 = this;

      (0, _sendCommand2.default)({
        type: "startReleaseWithMethod",
        product: { id: this.props.project.id },
        release: { id: this.props.stage.id },
        method: method,
        implementationProject: method === "project" ? { id: projectId } : undefined
      }).then(function (response) {
        _this20.setState({ implementationMethodVisible: false, stage: response.release });
        if (_this20.props.onUpdateStage !== undefined) {
          _this20.props.onUpdateStage(response.release);
        }
      }).catch(function (error) {
        console.log("Got error", error);
        alert("An error occured, please try again");
      });
    }
  }, {
    key: 'completeRelease',
    value: function completeRelease() {
      var _this21 = this;

      (0, _sendCommand2.default)({ type: "completeRelease", release: { id: this.props.stage.id }, product: { id: this.props.stage.product.id } }).then(function (response) {
        _this21.setState({ stage: response.release });
        if (_this21.props.onUpdateStage !== undefined) {
          _this21.props.onUpdateStage(response.release);
        }
      }).catch(function (error) {
        console.log("[ERROR] Not able to complete release, got " + error);
        alert("An error occured, please try again");
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this22 = this;

      var date = this.state.stage.active === true || this.state.stage.historic === true && this.state.stage.history !== undefined ? new Date(this.state.stage.history.slice(-1)[0].approved.date).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10);
      var selected = this.props.selected !== undefined && this.props.selected.length > 0 && this.state.stage.history !== undefined ? this.state.stage.history.filter(function (item) {
        return item.version == _this22.props.selected;
      })[0] : this.state.stage;
      var nameAndDate = (this.props.project !== undefined ? this.props.project.name + " - " : "") + date;
      var type = this.props.pid !== undefined ? this.props.pid.type : undefined;
      var labels = translations.getTranslation(this.props);
      return this.state.implementationMethodVisible ? _react2.default.createElement(
        'div',
        { style: { textAlign: "center" } },
        _react2.default.createElement(
          'div',
          { style: { display: "inline-block", textAlign: "left", maxWidth: 1016 } },
          _react2.default.createElement(_ReleaseImplementationMethod2.default, _extends({}, this.props, {
            product: this.props.project,
            onCancel: function onCancel(event) {
              return _this22.setState({ implementationMethodVisible: false });
            },
            onChange: this.setImplementationMethod.bind(this)
          }))
        )
      ) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _ProjectBrief.ApprovableReport,
          _extends({}, this.props, {
            menuTopItems: _react2.default.createElement(BackMenu, this.props),
            hideReportDisplayMenu: false,
            definedTableView: false,
            disabledActions: true,
            showCurrent: true,
            menuReportActions: _react2.default.createElement(ReportActions, _extends({}, this.props, { stage: selected, report: this.props.stage.report, hideActuals: this.state.registerActuals, onActuals: this.toggleActuals.bind(this), activate: this.makeActive.bind(this), onComplete: this.completeRelease.bind(this) })),
            title: labels.general.stagePlan.title + " - " + this.props.stage.name //labels.pid.title}
            , date: selected.approved !== undefined ? selected.approved.date : new Date(),
            type: selected.approved === undefined && this.props.project.isRelease !== true && this.props.project.isProduct !== true ? "preview" : "",
            selected: Object.assign({}, selected, {
              type: selected.approved === undefined ? "preview" : ""
            }),
            hasPreview: this.props.stage.version === undefined,
            current: Object.assign({}, this.state.stage, {
              history: this.state.stage.history !== undefined ? this.state.stage.history.map(function (item) {
                return Object.assign({}, item, { date: item.approved.date
                });
              }) : undefined

            })
            //        report="StagePlan"
            //        approveLabel={labels.approval.approve}
          }),
          this.state.stage.actuals === true ? _react2.default.createElement(
            'div',
            { style: { marginTop: 10, border: "solid 1px grey", padding: 5, textAlign: "center", backgroundColor: "lightgrey", color: "black", fontWeight: "bold" } },
            labels.general.showingActuals
          ) : null,
          this.state.registerActuals ? _react2.default.createElement(Actuals, _extends({}, this.props, {
            stage: this.state.stage,
            onCancel: this.toggleActuals.bind(this),
            onUpdate: this.updateActuals.bind(this)
          })) : null,
          _react2.default.createElement(StagePlanContent, _extends({}, this.props, { stage: selected, title: labels.general.stagePlan.title + " - " + this.props.stage.name, date: selected.approved !== undefined ? selected.approved.date : new Date() })),
          !this.props.presentationMode && selected.approved !== undefined && selected.approved.exception !== undefined ? _react2.default.createElement(
            'div',
            { style: { paddingTop: 30 } },
            'Version 1.',
            selected.version,
            ': Automatically approved with approval of exception',
            _react2.default.createElement(
              'div',
              { style: { paddingLeft: 10 } },
              _react2.default.createElement(_FormattedContent2.default, { value: selected.approved.exception.summary })
            )
          ) : null
        ),
         false ? _react2.default.createElement(
          'div',
          { style: { paddingTop: 50 } },
          _react2.default.createElement('hr', null),
          _react2.default.createElement(
            'div',
            { style: { display: "inline-block", float: "right", marginRight: 30, width: 250, borderLeft: "solid lightgrey 1px", paddingTop: 10, paddingLeft: 10, paddingBottom: 150 } },
            _react2.default.createElement(
              'div',
              { style: { paddingTop: 30 } },
              _react2.default.createElement(
                'a',
                { href: "/projects/" + this.props.project.id + "/reports?id=" + this.state.stage.report.id + "&showEndStage=true" },
                'View in archive'
              )
            )
          ),
          _react2.default.createElement(_Report.Report, _extends({}, this.props, {
            selected: this.state.stage.report.id,
            showEndStage: true
          }))
        ) : null
      );
    }
  }]);

  return StagePlan;
}(_react2.default.Component);

exports.default = StagePlan;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setupStageBudget;
function setupStageBudget(stage, labels) {
  var lookupInBudget = function lookupInBudget(budget, element, field) {
    var item = budget !== undefined ? budget.filter(function (item) {
      return item.id === element;
    })[0] : undefined;
    return item !== undefined ? item[field] : undefined;
  };

  var budget = [{
    id: "hours",
    element: labels !== undefined ? labels.hours : "hours",
    cost: stage.cost.hours !== null ? stage.cost.hours : undefined,
    tolerance: lookupInBudget(stage.budget, "hours", "tolerance"),
    comment: lookupInBudget(stage.budget, "hours", "comment")
  }, {
    id: "expences",
    element: labels !== undefined ? labels.expences : "expences",
    cost: stage.cost.expences !== null ? stage.cost.expences : undefined,
    tolerance: lookupInBudget(stage.budget, "expences", "tolerance"),
    comment: lookupInBudget(stage.budget, "expences", "comment")
  }, { id: "investment",
    element: labels !== undefined ? labels.investment : "investment",
    cost: stage.cost.investment !== null ? stage.cost.investment : undefined,
    tolerance: lookupInBudget(stage.budget, "investment", "tolerance"),
    comment: lookupInBudget(stage.budget, "investment", "comment")
  }, {
    id: "total",
    element: labels !== undefined ? labels.total : "total",
    cost: stage.cost.sum !== null ? stage.cost.sum : undefined,
    tolerance: stage.cost.tolerance !== undefined ? stage.cost.tolerance : undefined,
    comment: lookupInBudget(stage.budget, "total", "comment")
  }];
  return budget;
}

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var english_productPlan = exports.english_productPlan = {
  general: {
    stage: "Release",
    stageMenu: {
      stageActions: "Release actions"
    },
    stagePlan: {
      title: "Release plan",
      projectPhase: "Product"
    }
  },
  schedule: {
    title: "Roadmap",
    fields: {
      schedule: {
        columnHeaders: {
          stage: { title: "Release" }
        },
        options: {
          addEntry: { title: "+ Add release" }
        }
      }
    }
  },
  stageDescription: {
    fields: {
      identifier: {
        title: 'Release identifier',
        description: 'Unique identifier for the release'
      },
      name: {
        description: "Name of the release"
      },
      description: {
        help: "Where in the product\u2019s lifecycle is this release (if relevant)?\n          What is the goal of this release?\n          Briefly summarized, what will this release include and how will it be done? ",
        description: "Short description of what this release is"
      }
    }
  },
  stageTime: {
    fields: {
      period: {
        title: "Release period"
      },
      timeComments: {
        description: "Comments to the time aspect of the release plan"
      }
    }
  },
  stageCost: {
    fields: {
      budget: {
        title: "Release budget",
        help: "Hours: Number of hours needed by internal staff, or hour spent by external resources where the policy is to do project accounting in hours.\n          Expenses: Direct expenses received as invoices. This should normally exclude expenses filed as hours. Should not included investments.\n          Investments: Capitalized costs for fixed assets\n          Total: Manually calculated total cost of the release. Usually total = hours x cost of hours + expenses + investments."
      }
    }
  },
  stageScheduleScope: {
    fields: {
      scheduleComments: {
        description: "Describe/list what will be delivered in this release, when and by whom"
      }
    }
  }
};

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var norwegian_productPlan = exports.norwegian_productPlan = {
  general: {
    stage: "Oppdatering",
    stageMenu: {
      stageActions: "Handlinger for oppdateringen"
    },
    stagePlan: {
      title: "Plan for oppdatering",
      projectPhase: "Produkt"
    }
  },
  schedule: {
    title: "Langtidsplan",
    fields: {
      schedule: {
        columnHeaders: {
          stage: { title: "Oppdatering" }
        },
        options: {
          addEntry: { title: "+ Legg til oppdatering" }
        }
      }
    }
  },
  stageDescription: {
    title: "Oppdateringen",
    fields: {
      identifier: {
        title: 'Oppdateringsidentifikator',
        description: 'Unik idenfikator for oppdateringen'
      },
      name: {
        description: "Navn på oppdateringen"
      },
      description: {
        title: "Beskrivelse",
        help: "Hvor i produktets livssyklus er denne oppdateringen?\n          Hva er m\xE5let med oppdateringen?\n          Kort oppsummert, hva vil denne oppdateringen inneholde og hvordan vil det bli gjort?",
        description: "Beskriv kort hva denne oppdateringen innebærer"
      }
    }
  },
  stageTime: {
    fields: {
      period: {
        title: "Tidsperiode for oppdateringen"
      },
      timeComments: {
        description: "Kommentarer til tidsaspektet av oppdateringen"
      }
    }
  },
  stageCost: {
    fields: {
      budget: {
        title: "Oppdateringsnes budsjett",
        help: "Timer: Antall timer som trengs av internt personale, eller timer brukt av eksterne ressurser hvor tiln\xE6rmingen er \xE5 f\xF8lge opp prosjektkostanden i timer.\n          Utgifter: Direkte utgifter mottatt som faktura. Dette b\xF8r normalt utelukke utgifter f\xF8rt som timer. B\xF8r ikke inkludere investeringer.\n          Investeringer: Balansef\xF8rte kostnader for anleggsmidler\n          Totalt: Manuelt beregnet total kostnad for oppdateringen. Vanligvis totalt = timer x timekostnad + utgifter + investeringer."
      }
    }
  },
  stageScheduleScope: {
    fields: {
      scheduleComments: {
        description: "Beskriv eller list opp hva som vil bli levert i dennne oppdateringen, når og av hvem"
      }
    }
  }
};

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _uuid = __webpack_require__(26);

var _uuid2 = _interopRequireDefault(_uuid);

var _Field = __webpack_require__(36);

var _Field2 = _interopRequireDefault(_Field);

var _FormattedContent = __webpack_require__(15);

var _FormattedContent2 = _interopRequireDefault(_FormattedContent);

var _sendCommand = __webpack_require__(25);

var _sendCommand2 = _interopRequireDefault(_sendCommand);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(58), __webpack_require__(59)]);

var ExceptionManagement = function (_React$Component) {
  _inherits(ExceptionManagement, _React$Component);

  function ExceptionManagement(props) {
    _classCallCheck(this, ExceptionManagement);

    var _this = _possibleConstructorReturn(this, (ExceptionManagement.__proto__ || Object.getPrototypeOf(ExceptionManagement)).call(this, props));

    _this.state = { showDetails: props.showDetails === true };
    return _this;
  }

  _createClass(ExceptionManagement, [{
    key: 'showDetails',
    value: function showDetails(event) {
      event.preventDefault();
      this.setState({ showDetails: true });
    }
  }, {
    key: 'raiseException',
    value: function raiseException(event) {
      var _this2 = this;

      event.preventDefault();
      if (this.state.edit === true) {
        (0, _sendCommand2.default)({
          type: "updateExceptionPlanRequest",
          id: this.props.project.requestedStageException.id,
          project: { id: this.props.project.id },
          summary: event.target.elements.summary.value,
          level: event.target.elements.level.value,
          exceptionReport: event.target.elements.report.value.trim().length > 0 ? event.target.elements.report.value : undefined
        }).then(function (response) {
          if (_this2.props.onUpdate !== undefined) {
            _this2.props.onUpdate(response.project);
          }
          window.location = "plan";
        }).catch(function (error) {
          console.log("[ERROR] An error occured", error);
          alert("An error occured, please try again");
        });
      } else {
        (0, _sendCommand2.default)({
          type: "raiseException",
          id: _uuid2.default.v4(),
          project: { id: this.props.project.id },
          summary: event.target.elements.summary.value,
          level: event.target.elements.level.value,
          exceptionReport: event.target.elements.report.value.trim().length > 0 ? event.target.elements.report.value : undefined
        }).then(function (response) {
          if (_this2.props.onUpdate !== undefined) {
            _this2.props.onUpdate(response.project);
          }
          window.location = "plan";
        }).catch(function (error) {
          console.log("[ERROR] An error occured", error);
          alert("An error occured, please try again");
        });
      }
    }
  }, {
    key: 'approveException',
    value: function approveException(event) {
      var _this3 = this;

      event.preventDefault();
      var command = {
        type: "approveException",
        id: this.props.project.requestedStageException.id,
        project: { id: this.props.project.id }
      };
      if (this.props.project.requestedStageException.stage !== undefined) {
        command.stage = { id: this.props.project.requestedStageException.stage.id };
      }
      (0, _sendCommand2.default)(command).then(function (response) {
        if (_this3.props.onUpdate !== undefined) {
          _this3.props.onUpdate(response.project);
        }
      }).catch(function (error) {
        console.log("[ERROR] An error occured", error);
        alert("An error occured, please try again");
      });
    }
  }, {
    key: 'cancelException',
    value: function cancelException(event) {
      event.preventDefault();
      window.location = "plan";
    }
  }, {
    key: 'edit',
    value: function edit(event) {
      event.preventDefault();
      this.setState({ edit: true });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var labels = translations.getTranslation(this.props).general.exceptionPlan;
      var summary = this.props.project.requestedStageException !== undefined && this.props.project.requestedStageException !== null && this.props.project.requestedStageException.summary !== undefined && this.props.project.requestedStageException.summary !== null ? this.props.project.requestedStageException.summary : "";
      var truncated = false;
      if (this.state.showDetails === false && summary.trim().length > 144) {
        summary = summary.slice(0, 143);
        summary = summary.slice(0, summary.lastIndexOf(" ")).trim() + "...";
      }
      var level = this.props.project.requestedStageException !== undefined && this.props.project.requestedStageException.level !== undefined ? this.props.project.requestedStageException.level : "stage";
      var exceptionReport = this.props.project.requestedStageException !== undefined && this.props.project.requestedStageException.exceptionReport !== undefined && this.props.project.requestedStageException.exceptionReport !== null ? this.props.project.requestedStageException.exceptionReport.id : undefined;
      var exceptionStage = this.props.project.requestedStageException !== undefined ? this.props.project.stages.find(function (stage) {
        return stage.id === _this4.props.project.requestedStageException.stage.id;
      }) : undefined;
      var exceptionLevels = [].concat(this.props.project.currentStage !== undefined ? "stage" : undefined).concat(this.props.project.currentPhase !== undefined ? "phase" : undefined).concat("project")
      //      .concat(this.props.project.programme!==undefined ? {value: "programme", text:"Programme"} : undefined)
      .filter(function (item) {
        return item !== undefined;
      }).map(function (item) {
        return {
          value: item,
          text: labels.fields.level.options[item].title || "(." + item + ")"
        };
      });
      var exceptionReports = [{ value: "", text: labels.fields.report.empty }].concat([].concat.apply([], this.props.project.issues !== undefined ? this.props.project.issues.map(function (issue) {
        return issue.reports !== undefined ? issue.reports.map(function (report) {
          return report.exception ? Object.assign({}, report, { issue: issue }) : undefined;
        }) : undefined;
      }) : undefined).filter(function (item) {
        return item !== undefined && item !== null;
      }).map(function (report) {
        return { value: report.id, text: new Date(report.date).toISOString().slice(0, 10) + " " + report.issue.title };
      }));
      return this.props.raiseException === true && this.props.project.currentStage !== undefined || this.state.edit === true ? _react2.default.createElement(
        'form',
        { onSubmit: this.raiseException.bind(this) },
        _react2.default.createElement(
          'div',
          { style: { fontFamily: "Lato", marginBottom: 20 } },
          _react2.default.createElement(
            'h2',
            null,
            _react2.default.createElement('img', { style: { paddingRight: 10, verticalAlign: "middle" }, src: '/images/Flag_DarkGrey_22x16.gif' }),
            labels.title
          ),
          _react2.default.createElement(
            'div',
            { style: { backgroundColor: "#f7f7f7", padding: 30 } },
            _react2.default.createElement(_Field2.default, {
              title: labels.fields.level.title,
              name: 'level',
              options: exceptionLevels,
              value: level
            }),
            _react2.default.createElement(_Field2.default, {
              title: labels.fields.report.title,
              name: 'report',
              options: exceptionReports,
              optional: true,
              value: exceptionReport
            }),
            _react2.default.createElement(_Field2.default, {
              title: labels.fields.summary.title,
              name: 'summary',
              help: labels.fields.summary.help,
              description: labels.fields.summary.description,
              height: '3',
              value: summary })
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingTop: 15, paddingBottom: 20 } },
            _react2.default.createElement('input', { onClick: this.cancelException.bind(this), className: 'cancel', type: 'button', value: labels.cancel }),
            _react2.default.createElement('input', { className: 'save', type: 'submit', value: this.state.edit === true ? labels.update : labels.requestApproval })
          )
        )
      ) : this.props.project.requestedStageException !== undefined ? _react2.default.createElement(
        'div',
        { style: { paddingBottom: 20, fontFamily: "Lato" } },
        this.props.viewOnly !== true ? _react2.default.createElement('img', { style: { paddingRight: 10, verticalAlign: "middle" }, src: '/images/Flag_DarkGrey_22x16.gif' }) : null,
        _react2.default.createElement(
          'b',
          null,
          labels.title
        ),
        _react2.default.createElement(
          'span',
          null,
          ' '
        ),
        this.props.project.requestedStageException.level === undefined || this.props.project.requestedStageException.level === "stage" ? _react2.default.createElement(
          'span',
          null,
          '(',
          labels.fields.level.options.stage.title,
          ': ',
          this.props.project.requestedStageException !== undefined ? ": " + exceptionStage.name : labels.stageNotFound,
          ')'
        ) : _react2.default.createElement(
          'span',
          null,
          '(',
          labels.fields.level.options[this.props.project.requestedStageException.level].title,
          ')'
        ),
        _react2.default.createElement(
          'span',
          null,
          ' '
        ),
        this.props.viewOnly !== true && this.props.project.requestedStageException.id !== undefined ? _react2.default.createElement(
          'a',
          { onClick: this.edit.bind(this), href: '#' },
          _react2.default.createElement('img', { src: '/icons/pen_grey.jpg' })
        ) : null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_FormattedContent2.default, { value: summary })
        ),
        this.state.showDetails === true && this.props.project.requestedStageException.exceptionReport !== undefined && this.props.project.requestedStageException.exceptionReport !== null ? _react2.default.createElement(
          'div',
          { style: { paddingTop: 5, paddingBottom: 5 } },
          _react2.default.createElement(
            'a',
            { target: '_blank', href: "/projects/" + this.props.project.id + "/change/issues/" + this.props.project.requestedStageException.exceptionReport.issue.id + "/reports/" + this.props.project.requestedStageException.exceptionReport.id },
            labels.exceptionReport
          )
        ) : this.props.project.requestedStageException.exceptionReport === undefined || this.props.project.requestedStageException.exceptionReport === null ? _react2.default.createElement(
          'div',
          { style: { fontWeight: "bold", color: "red", paddingTop: 5, paddingBottom: 5 } },
          labels.missingExceptionReport
        ) : null,
        this.state.showDetails === true && this.props.baseline !== undefined ? _react2.default.createElement(
          'div',
          { style: { paddingBottom: 5 } },
          _react2.default.createElement(
            'a',
            { target: '_blank', href: "/projects/" + this.props.project.id + "/plan/baseline/" + this.props.baseline.version + "/" },
            labels.baselinePlan
          ),
          ' ',
          labels.beforeExceptionAproval
        ) : null,
        this.state.showDetails === true && this.props.approved !== undefined ? _react2.default.createElement(
          'div',
          { style: { paddingBottom: 5 } },
          _react2.default.createElement(
            'a',
            { target: '_blank', href: "/projects/" + this.props.project.id + "/plan/baseline/" + this.props.approved.version + "/" },
            labels.newBaselinePlan
          ),
          ' ',
          labels.afterExceptionApproval
        ) : null,
        this.props.viewOnly !== true && this.state.showDetails === true ? _react2.default.createElement(
          'div',
          { style: { paddingTop: 15, paddingBottom: 20 } },
          _react2.default.createElement('input', { onClick: this.approveException.bind(this), className: 'save', type: 'submit', value: labels.approve })
        ) : this.props.viewOnly !== true ? _react2.default.createElement(
          'div',
          { style: { float: "right" } },
          _react2.default.createElement(
            'a',
            { onClick: this.showDetails.bind(this), href: '#' },
            labels.readMore
          )
        ) : null
      ) : null;
    }
  }]);

  return ExceptionManagement;
}(_react2.default.Component);

exports.default = ExceptionManagement;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(445);
module.exports = __webpack_require__(647);


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(446);

__webpack_require__(643);

__webpack_require__(644);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(447);
__webpack_require__(450);
__webpack_require__(451);
__webpack_require__(452);
__webpack_require__(453);
__webpack_require__(454);
__webpack_require__(455);
__webpack_require__(456);
__webpack_require__(457);
__webpack_require__(458);
__webpack_require__(459);
__webpack_require__(460);
__webpack_require__(461);
__webpack_require__(462);
__webpack_require__(463);
__webpack_require__(464);
__webpack_require__(465);
__webpack_require__(466);
__webpack_require__(467);
__webpack_require__(468);
__webpack_require__(469);
__webpack_require__(470);
__webpack_require__(471);
__webpack_require__(472);
__webpack_require__(473);
__webpack_require__(474);
__webpack_require__(475);
__webpack_require__(476);
__webpack_require__(477);
__webpack_require__(478);
__webpack_require__(479);
__webpack_require__(480);
__webpack_require__(481);
__webpack_require__(482);
__webpack_require__(483);
__webpack_require__(484);
__webpack_require__(485);
__webpack_require__(486);
__webpack_require__(487);
__webpack_require__(488);
__webpack_require__(489);
__webpack_require__(490);
__webpack_require__(491);
__webpack_require__(492);
__webpack_require__(493);
__webpack_require__(494);
__webpack_require__(495);
__webpack_require__(496);
__webpack_require__(497);
__webpack_require__(498);
__webpack_require__(499);
__webpack_require__(500);
__webpack_require__(501);
__webpack_require__(502);
__webpack_require__(503);
__webpack_require__(504);
__webpack_require__(505);
__webpack_require__(506);
__webpack_require__(507);
__webpack_require__(508);
__webpack_require__(509);
__webpack_require__(510);
__webpack_require__(511);
__webpack_require__(512);
__webpack_require__(513);
__webpack_require__(514);
__webpack_require__(515);
__webpack_require__(516);
__webpack_require__(517);
__webpack_require__(518);
__webpack_require__(519);
__webpack_require__(520);
__webpack_require__(521);
__webpack_require__(522);
__webpack_require__(523);
__webpack_require__(524);
__webpack_require__(525);
__webpack_require__(527);
__webpack_require__(528);
__webpack_require__(530);
__webpack_require__(531);
__webpack_require__(532);
__webpack_require__(533);
__webpack_require__(534);
__webpack_require__(535);
__webpack_require__(536);
__webpack_require__(538);
__webpack_require__(539);
__webpack_require__(540);
__webpack_require__(541);
__webpack_require__(542);
__webpack_require__(543);
__webpack_require__(544);
__webpack_require__(545);
__webpack_require__(546);
__webpack_require__(547);
__webpack_require__(548);
__webpack_require__(549);
__webpack_require__(550);
__webpack_require__(199);
__webpack_require__(551);
__webpack_require__(284);
__webpack_require__(552);
__webpack_require__(285);
__webpack_require__(553);
__webpack_require__(554);
__webpack_require__(555);
__webpack_require__(556);
__webpack_require__(557);
__webpack_require__(288);
__webpack_require__(290);
__webpack_require__(291);
__webpack_require__(558);
__webpack_require__(559);
__webpack_require__(560);
__webpack_require__(561);
__webpack_require__(562);
__webpack_require__(563);
__webpack_require__(564);
__webpack_require__(565);
__webpack_require__(566);
__webpack_require__(567);
__webpack_require__(568);
__webpack_require__(569);
__webpack_require__(570);
__webpack_require__(571);
__webpack_require__(572);
__webpack_require__(573);
__webpack_require__(574);
__webpack_require__(575);
__webpack_require__(576);
__webpack_require__(577);
__webpack_require__(578);
__webpack_require__(579);
__webpack_require__(580);
__webpack_require__(581);
__webpack_require__(582);
__webpack_require__(583);
__webpack_require__(584);
__webpack_require__(585);
__webpack_require__(586);
__webpack_require__(587);
__webpack_require__(588);
__webpack_require__(589);
__webpack_require__(590);
__webpack_require__(591);
__webpack_require__(592);
__webpack_require__(593);
__webpack_require__(594);
__webpack_require__(595);
__webpack_require__(596);
__webpack_require__(597);
__webpack_require__(598);
__webpack_require__(599);
__webpack_require__(600);
__webpack_require__(601);
__webpack_require__(602);
__webpack_require__(603);
__webpack_require__(604);
__webpack_require__(605);
__webpack_require__(606);
__webpack_require__(607);
__webpack_require__(608);
__webpack_require__(609);
__webpack_require__(610);
__webpack_require__(611);
__webpack_require__(612);
__webpack_require__(613);
__webpack_require__(614);
__webpack_require__(615);
__webpack_require__(616);
__webpack_require__(617);
__webpack_require__(618);
__webpack_require__(619);
__webpack_require__(620);
__webpack_require__(621);
__webpack_require__(622);
__webpack_require__(623);
__webpack_require__(624);
__webpack_require__(625);
__webpack_require__(626);
__webpack_require__(627);
__webpack_require__(628);
__webpack_require__(629);
__webpack_require__(630);
__webpack_require__(631);
__webpack_require__(632);
__webpack_require__(633);
__webpack_require__(634);
__webpack_require__(635);
__webpack_require__(636);
__webpack_require__(637);
__webpack_require__(638);
__webpack_require__(639);
__webpack_require__(640);
__webpack_require__(641);
__webpack_require__(642);
module.exports = __webpack_require__(47);


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(5);
var has = __webpack_require__(39);
var DESCRIPTORS = __webpack_require__(19);
var $export = __webpack_require__(0);
var redefine = __webpack_require__(34);
var META = __webpack_require__(68).KEY;
var $fails = __webpack_require__(7);
var shared = __webpack_require__(106);
var setToStringTag = __webpack_require__(96);
var uid = __webpack_require__(75);
var wks = __webpack_require__(14);
var wksExt = __webpack_require__(266);
var wksDefine = __webpack_require__(180);
var enumKeys = __webpack_require__(449);
var isArray = __webpack_require__(133);
var anObject = __webpack_require__(3);
var isObject = __webpack_require__(10);
var toObject = __webpack_require__(22);
var toIObject = __webpack_require__(40);
var toPrimitive = __webpack_require__(53);
var createDesc = __webpack_require__(74);
var _create = __webpack_require__(78);
var gOPNExt = __webpack_require__(269);
var $GOPD = __webpack_require__(41);
var $GOPS = __webpack_require__(132);
var $DP = __webpack_require__(20);
var $keys = __webpack_require__(76);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(79).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(108).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(67)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(33)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(106)('native-function-to-string', Function.toString);


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(76);
var gOPS = __webpack_require__(132);
var pIE = __webpack_require__(108);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(78) });


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(19), 'Object', { defineProperty: __webpack_require__(20).f });


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(19), 'Object', { defineProperties: __webpack_require__(268) });


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(40);
var $getOwnPropertyDescriptor = __webpack_require__(41).f;

__webpack_require__(55)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(22);
var $getPrototypeOf = __webpack_require__(42);

__webpack_require__(55)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(22);
var $keys = __webpack_require__(76);

__webpack_require__(55)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(55)('getOwnPropertyNames', function () {
  return __webpack_require__(269).f;
});


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(10);
var meta = __webpack_require__(68).onFreeze;

__webpack_require__(55)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(10);
var meta = __webpack_require__(68).onFreeze;

__webpack_require__(55)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(10);
var meta = __webpack_require__(68).onFreeze;

__webpack_require__(55)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(10);

__webpack_require__(55)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(10);

__webpack_require__(55)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(10);

__webpack_require__(55)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(0);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(270) });


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { is: __webpack_require__(271) });


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(0);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(184).set });


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(97);
var test = {};
test[__webpack_require__(14)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(34)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(0);

$export($export.P, 'Function', { bind: __webpack_require__(272) });


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(20).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(19) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(10);
var getPrototypeOf = __webpack_require__(42);
var HAS_INSTANCE = __webpack_require__(14)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(20).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(274);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(275);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(5);
var has = __webpack_require__(39);
var cof = __webpack_require__(49);
var inheritIfRequired = __webpack_require__(186);
var toPrimitive = __webpack_require__(53);
var fails = __webpack_require__(7);
var gOPN = __webpack_require__(79).f;
var gOPD = __webpack_require__(41).f;
var dP = __webpack_require__(20).f;
var $trim = __webpack_require__(98).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(78)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(19) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(34)(global, NUMBER, $Number);
}


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toInteger = __webpack_require__(50);
var aNumberValue = __webpack_require__(276);
var repeat = __webpack_require__(187);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(7)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $fails = __webpack_require__(7);
var aNumberValue = __webpack_require__(276);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(0);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(0);
var _isFinite = __webpack_require__(5).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', { isInteger: __webpack_require__(277) });


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(0);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(0);
var isInteger = __webpack_require__(277);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(0);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseFloat = __webpack_require__(275);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $parseInt = __webpack_require__(274);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(0);
var log1p = __webpack_require__(278);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(0);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(0);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(0);
var sign = __webpack_require__(188);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(0);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(0);
var $expm1 = __webpack_require__(189);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { fround: __webpack_require__(279) });


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(0);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(0);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(7)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { log1p: __webpack_require__(278) });


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', { sign: __webpack_require__(188) });


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(189);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(7)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(0);
var expm1 = __webpack_require__(189);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toAbsoluteIndex = __webpack_require__(77);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(40);
var toLength = __webpack_require__(16);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(98)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(134)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(190)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $at = __webpack_require__(134)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(16);
var context = __webpack_require__(192);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(193)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(0);
var context = __webpack_require__(192);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(193)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(187)
});


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(0);
var toLength = __webpack_require__(16);
var context = __webpack_require__(192);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(193)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(35)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(35)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(35)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(35)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(35)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(35)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(35)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(35)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(35)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(35)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(35)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(35)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(35)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(0);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(22);
var toPrimitive = __webpack_require__(53);

$export($export.P + $export.F * __webpack_require__(7)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(0);
var toISOString = __webpack_require__(526);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(7);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(34)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(14)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(33)(proto, TO_PRIMITIVE, __webpack_require__(529));


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(3);
var toPrimitive = __webpack_require__(53);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(0);

$export($export.S, 'Array', { isArray: __webpack_require__(133) });


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(48);
var $export = __webpack_require__(0);
var toObject = __webpack_require__(22);
var call = __webpack_require__(280);
var isArrayIter = __webpack_require__(194);
var toLength = __webpack_require__(16);
var createProperty = __webpack_require__(195);
var getIterFn = __webpack_require__(196);

$export($export.S + $export.F * !__webpack_require__(136)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var createProperty = __webpack_require__(195);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(7)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(0);
var toIObject = __webpack_require__(40);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(107) != Object || !__webpack_require__(51)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var html = __webpack_require__(183);
var cof = __webpack_require__(49);
var toAbsoluteIndex = __webpack_require__(77);
var toLength = __webpack_require__(16);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(7)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var aFunction = __webpack_require__(27);
var toObject = __webpack_require__(22);
var fails = __webpack_require__(7);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(51)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $forEach = __webpack_require__(56)(0);
var STRICT = __webpack_require__(51)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(10);
var isArray = __webpack_require__(133);
var SPECIES = __webpack_require__(14)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $map = __webpack_require__(56)(1);

$export($export.P + $export.F * !__webpack_require__(51)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $filter = __webpack_require__(56)(2);

$export($export.P + $export.F * !__webpack_require__(51)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $some = __webpack_require__(56)(3);

$export($export.P + $export.F * !__webpack_require__(51)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $every = __webpack_require__(56)(4);

$export($export.P + $export.F * !__webpack_require__(51)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(281);

$export($export.P + $export.F * !__webpack_require__(51)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $reduce = __webpack_require__(281);

$export($export.P + $export.F * !__webpack_require__(51)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $indexOf = __webpack_require__(131)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(51)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toIObject = __webpack_require__(40);
var toInteger = __webpack_require__(50);
var toLength = __webpack_require__(16);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(51)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { copyWithin: __webpack_require__(282) });

__webpack_require__(69)('copyWithin');


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(0);

$export($export.P, 'Array', { fill: __webpack_require__(198) });

__webpack_require__(69)('fill');


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(56)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(69)(KEY);


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(0);
var $find = __webpack_require__(56)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(69)(KEY);


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(80)('Array');


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(5);
var inheritIfRequired = __webpack_require__(186);
var dP = __webpack_require__(20).f;
var gOPN = __webpack_require__(79).f;
var isRegExp = __webpack_require__(135);
var $flags = __webpack_require__(109);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(19) && (!CORRECT_NEW || __webpack_require__(7)(function () {
  re2[__webpack_require__(14)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(34)(global, 'RegExp', $RegExp);
}

__webpack_require__(80)('RegExp');


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(285);
var anObject = __webpack_require__(3);
var $flags = __webpack_require__(109);
var DESCRIPTORS = __webpack_require__(19);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(34)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(7)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(3);
var toLength = __webpack_require__(16);
var advanceStringIndex = __webpack_require__(201);
var regExpExec = __webpack_require__(137);

// @@match logic
__webpack_require__(138)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(3);
var toObject = __webpack_require__(22);
var toLength = __webpack_require__(16);
var toInteger = __webpack_require__(50);
var advanceStringIndex = __webpack_require__(201);
var regExpExec = __webpack_require__(137);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(138)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(3);
var sameValue = __webpack_require__(271);
var regExpExec = __webpack_require__(137);

// @@search logic
__webpack_require__(138)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(135);
var anObject = __webpack_require__(3);
var speciesConstructor = __webpack_require__(110);
var advanceStringIndex = __webpack_require__(201);
var toLength = __webpack_require__(16);
var callRegExpExec = __webpack_require__(137);
var regexpExec = __webpack_require__(200);
var fails = __webpack_require__(7);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(138)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(67);
var global = __webpack_require__(5);
var ctx = __webpack_require__(48);
var classof = __webpack_require__(97);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(10);
var aFunction = __webpack_require__(27);
var anInstance = __webpack_require__(81);
var forOf = __webpack_require__(82);
var speciesConstructor = __webpack_require__(110);
var task = __webpack_require__(202).set;
var microtask = __webpack_require__(203)();
var newPromiseCapabilityModule = __webpack_require__(204);
var perform = __webpack_require__(286);
var userAgent = __webpack_require__(139);
var promiseResolve = __webpack_require__(287);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(14)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(83)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(96)($Promise, PROMISE);
__webpack_require__(80)(PROMISE);
Wrapper = __webpack_require__(47)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(136)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(292);
var validate = __webpack_require__(84);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(140)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var $typed = __webpack_require__(141);
var buffer = __webpack_require__(205);
var anObject = __webpack_require__(3);
var toAbsoluteIndex = __webpack_require__(77);
var toLength = __webpack_require__(16);
var isObject = __webpack_require__(10);
var ArrayBuffer = __webpack_require__(5).ArrayBuffer;
var speciesConstructor = __webpack_require__(110);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(7)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(80)(ARRAY_BUFFER);


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
$export($export.G + $export.W + $export.F * !__webpack_require__(141).ABV, {
  DataView: __webpack_require__(205).DataView
});


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(60)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(60)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(60)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(60)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(60)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(60)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(60)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(60)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(60)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(0);
var aFunction = __webpack_require__(27);
var anObject = __webpack_require__(3);
var rApply = (__webpack_require__(5).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(7)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(0);
var create = __webpack_require__(78);
var aFunction = __webpack_require__(27);
var anObject = __webpack_require__(3);
var isObject = __webpack_require__(10);
var fails = __webpack_require__(7);
var bind = __webpack_require__(272);
var rConstruct = (__webpack_require__(5).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(20);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(3);
var toPrimitive = __webpack_require__(53);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(7)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(0);
var gOPD = __webpack_require__(41).f;
var anObject = __webpack_require__(3);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(3);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(191)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(41);
var getPrototypeOf = __webpack_require__(42);
var has = __webpack_require__(39);
var $export = __webpack_require__(0);
var isObject = __webpack_require__(10);
var anObject = __webpack_require__(3);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(41);
var $export = __webpack_require__(0);
var anObject = __webpack_require__(3);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(0);
var getProto = __webpack_require__(42);
var anObject = __webpack_require__(3);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(3);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(0);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(294) });


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(0);
var anObject = __webpack_require__(3);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(20);
var gOPD = __webpack_require__(41);
var getPrototypeOf = __webpack_require__(42);
var has = __webpack_require__(39);
var $export = __webpack_require__(0);
var createDesc = __webpack_require__(74);
var anObject = __webpack_require__(3);
var isObject = __webpack_require__(10);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(0);
var setProto = __webpack_require__(184);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(0);
var $includes = __webpack_require__(131)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(69)('includes');


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(295);
var toObject = __webpack_require__(22);
var toLength = __webpack_require__(16);
var aFunction = __webpack_require__(27);
var arraySpeciesCreate = __webpack_require__(197);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(69)('flatMap');


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(0);
var flattenIntoArray = __webpack_require__(295);
var toObject = __webpack_require__(22);
var toLength = __webpack_require__(16);
var toInteger = __webpack_require__(50);
var arraySpeciesCreate = __webpack_require__(197);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(69)('flatten');


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(0);
var $at = __webpack_require__(134)(true);
var $fails = __webpack_require__(7);

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});

$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(296);
var userAgent = __webpack_require__(139);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(0);
var $pad = __webpack_require__(296);
var userAgent = __webpack_require__(139);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(98)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(98)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(0);
var defined = __webpack_require__(54);
var toLength = __webpack_require__(16);
var isRegExp = __webpack_require__(135);
var getFlags = __webpack_require__(109);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(191)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('asyncIterator');


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('observable');


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(0);
var ownKeys = __webpack_require__(294);
var toIObject = __webpack_require__(40);
var gOPD = __webpack_require__(41);
var createProperty = __webpack_require__(195);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $values = __webpack_require__(297)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(0);
var $entries = __webpack_require__(297)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(22);
var aFunction = __webpack_require__(27);
var $defineProperty = __webpack_require__(20);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(19) && $export($export.P + __webpack_require__(142), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(22);
var aFunction = __webpack_require__(27);
var $defineProperty = __webpack_require__(20);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(19) && $export($export.P + __webpack_require__(142), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(22);
var toPrimitive = __webpack_require__(53);
var getPrototypeOf = __webpack_require__(42);
var getOwnPropertyDescriptor = __webpack_require__(41).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(19) && $export($export.P + __webpack_require__(142), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(0);
var toObject = __webpack_require__(22);
var toPrimitive = __webpack_require__(53);
var getPrototypeOf = __webpack_require__(42);
var getOwnPropertyDescriptor = __webpack_require__(41).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(19) && $export($export.P + __webpack_require__(142), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(298)('Map') });


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(0);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(298)('Set') });


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(143)('Map');


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(143)('Set');


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(143)('WeakMap');


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(143)('WeakSet');


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(144)('Map');


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(144)('Set');


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(144)('WeakMap');


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(144)('WeakSet');


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.G, { global: __webpack_require__(5) });


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(0);

$export($export.S, 'System', { global: __webpack_require__(5) });


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(0);
var cof = __webpack_require__(49);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var scale = __webpack_require__(300);
var fround = __webpack_require__(279);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(0);

$export($export.S, 'Math', { scale: __webpack_require__(300) });


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(0);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(0);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(0);
var core = __webpack_require__(47);
var global = __webpack_require__(5);
var speciesConstructor = __webpack_require__(110);
var promiseResolve = __webpack_require__(287);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(0);
var newPromiseCapability = __webpack_require__(204);
var perform = __webpack_require__(286);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(61);
var anObject = __webpack_require__(3);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(61);
var anObject = __webpack_require__(3);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(61);
var anObject = __webpack_require__(3);
var getPrototypeOf = __webpack_require__(42);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(290);
var from = __webpack_require__(299);
var metadata = __webpack_require__(61);
var anObject = __webpack_require__(3);
var getPrototypeOf = __webpack_require__(42);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(61);
var anObject = __webpack_require__(3);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(61);
var anObject = __webpack_require__(3);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(61);
var anObject = __webpack_require__(3);
var getPrototypeOf = __webpack_require__(42);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(61);
var anObject = __webpack_require__(3);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(61);
var anObject = __webpack_require__(3);
var aFunction = __webpack_require__(27);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(0);
var microtask = __webpack_require__(203)();
var process = __webpack_require__(5).process;
var isNode = __webpack_require__(49)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(0);
var global = __webpack_require__(5);
var core = __webpack_require__(47);
var microtask = __webpack_require__(203)();
var OBSERVABLE = __webpack_require__(14)('observable');
var aFunction = __webpack_require__(27);
var anObject = __webpack_require__(3);
var anInstance = __webpack_require__(81);
var redefineAll = __webpack_require__(83);
var hide = __webpack_require__(33);
var forOf = __webpack_require__(82);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(80)('Observable');


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(5);
var $export = __webpack_require__(0);
var userAgent = __webpack_require__(139);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(0);
var $task = __webpack_require__(202);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(199);
var getKeys = __webpack_require__(76);
var redefine = __webpack_require__(34);
var global = __webpack_require__(5);
var hide = __webpack_require__(33);
var Iterators = __webpack_require__(99);
var wks = __webpack_require__(14);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(645);
module.exports = __webpack_require__(47).RegExp.escape;


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(0);
var $re = __webpack_require__(646)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _HighlightReport = __webpack_require__(648);

var _Organization = __webpack_require__(422);

var _Risk = __webpack_require__(63);

var _Change = __webpack_require__(95);

var _Portfolio = __webpack_require__(175);

var _Portfolio2 = _interopRequireDefault(_Portfolio);

var _ProjectMenu = __webpack_require__(17);

var _ProjectMenu2 = _interopRequireDefault(_ProjectMenu);

var _AccountCreated = __webpack_require__(1058);

var _TemplateOverview = __webpack_require__(1062);

var _Report = __webpack_require__(258);

var _NewProject = __webpack_require__(176);

var _ProgrammeProperties = __webpack_require__(1063);

var _ProductProperties = __webpack_require__(1064);

var _ReleaseProperties = __webpack_require__(1065);

var _ProductDetails = __webpack_require__(1066);

var _NewExtremeProject = __webpack_require__(1074);

var _Layout = __webpack_require__(11);

var _ProjectDefinition = __webpack_require__(1078);

var _ProjectProductDescription = __webpack_require__(1081);

var _BusinessCase = __webpack_require__(1084);

var _Plan = __webpack_require__(263);

var _Approach = __webpack_require__(1098);

var _Approach2 = __webpack_require__(1100);

var _Approach3 = __webpack_require__(1102);

var _ProjectSettings = __webpack_require__(432);

var _ProjectBrief = __webpack_require__(264);

var _InitiationDocument = __webpack_require__(1104);

var _ProgrammeDetails = __webpack_require__(1107);

var _StagePlan = __webpack_require__(439);

var _StagePlan2 = _interopRequireDefault(_StagePlan);

var _ProjectDetails = __webpack_require__(260);

var _ReportRisk = __webpack_require__(1110);

var _Demo = __webpack_require__(308);

var _Demo2 = _interopRequireDefault(_Demo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReactDOM = __webpack_require__(377);
var React = __webpack_require__(1);

//import {EnableSAML2} from './views/admin/EnableSAML2.jsx';

function renderComponent(component, id) {
  if (document.getElementById(id) !== null) {
    ReactDOM.render(component, document.getElementById(id));
  }
}

renderComponent(React.createElement(_ProjectMenu2.default, window.APP_DATA), 'projectMenu');
renderComponent(React.createElement(_HighlightReport.HighlightReport, window.APP_DATA), 'highlight');
renderComponent(React.createElement(_Portfolio2.default, window.APP_DATA), 'index');
renderComponent(React.createElement(_Organization.Organization, window.APP_DATA), 'organization');
renderComponent(React.createElement(_Risk.Risk, window.APP_DATA), 'risk');
renderComponent(React.createElement(_Change.Change, window.APP_DATA), 'change');
renderComponent(React.createElement(_AccountCreated.AccountCreated, window.APP_DATA), 'accountCreated');
renderComponent(React.createElement(_TemplateOverview.TemplateOverview, window.APP_DATA), 'templates');
renderComponent(React.createElement(_Report.ReportContent, window.APP_DATA), 'report');
renderComponent(React.createElement(_NewProject.NewProject, window.APP_DATA), 'newProject');
renderComponent(React.createElement(_NewProject.NewProject, window.APP_DATA), 'projectProperties');
renderComponent(React.createElement(_ProgrammeProperties.ProgrammeProperties, window.APP_DATA), 'programmeProperties');
renderComponent(React.createElement(_NewExtremeProject.NewExtremeProject, window.APP_DATA), 'newExtremeProject');
renderComponent(React.createElement(_Layout.Search, window.APP_DATA), 'search');
renderComponent(React.createElement(_ProjectDefinition.ProjectDefinition, window.APP_DATA), 'definition');
renderComponent(React.createElement(_ProjectProductDescription.ProjectProductDescription, window.APP_DATA), 'quality');
renderComponent(React.createElement(_BusinessCase.BusinessCase, window.APP_DATA), 'businessCase');
renderComponent(React.createElement(_Plan.Plan, window.APP_DATA), 'plan');
renderComponent(React.createElement(_Approach.RiskManagementApproach, window.APP_DATA), 'riskApproach');
renderComponent(React.createElement(_Approach2.ChangeControlApproach, window.APP_DATA), 'changeApproach');
renderComponent(React.createElement(_Approach3.CommunicationManagementApproach, window.APP_DATA), 'communicationManagementApproach');
renderComponent(React.createElement(_ProjectSettings.ProjectSettings, window.APP_DATA), 'projectSettings');
renderComponent(React.createElement(_ProjectBrief.Brief, window.APP_DATA), 'brief');
renderComponent(React.createElement(_InitiationDocument.InitiationDocument, window.APP_DATA), 'pid');
renderComponent(React.createElement(_Demo2.default, window.APP_DATA), 'demo');
renderComponent(React.createElement(_ProgrammeDetails.ProgrammeDetails, window.APP_DATA), 'programme');
renderComponent(React.createElement(_StagePlan2.default, window.APP_DATA), 'stagePlanView');
renderComponent(React.createElement(_ProjectDetails.ProjectDetails, window.APP_DATA), 'projectDetails');
renderComponent(React.createElement(_ProductProperties.ProductProperties, window.APP_DATA), 'productProperties');
renderComponent(React.createElement(_ReleaseProperties.ReleaseProperties, window.APP_DATA), 'releaseProperties');
renderComponent(React.createElement(_ProductDetails.ProductDetails, window.APP_DATA), 'product');
renderComponent(React.createElement(_ReportRisk.PortfolioReportRisk, window.APP_DATA), 'portfolioReportRisk');

//renderComponent(<EnableSAML2 {...window.APP_DATA}/>,'enableSAML2');

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HighlightReport = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(24);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _ProjectMenu = __webpack_require__(17);

var _ProjectMenu2 = _interopRequireDefault(_ProjectMenu);

var _Status = __webpack_require__(208);

var _Status2 = _interopRequireDefault(_Status);

var _Risk = __webpack_require__(63);

var _Change = __webpack_require__(95);

var _sortByDate = __webpack_require__(257);

var _sortByDate2 = _interopRequireDefault(_sortByDate);

var _TabReport = __webpack_require__(1038);

var _TabReport2 = _interopRequireDefault(_TabReport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HighlightReport = exports.HighlightReport = function (_React$Component) {
  _inherits(HighlightReport, _React$Component);

  function HighlightReport() {
    _classCallCheck(this, HighlightReport);

    return _possibleConstructorReturn(this, (HighlightReport.__proto__ || Object.getPrototypeOf(HighlightReport)).apply(this, arguments));
  }

  _createClass(HighlightReport, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var summary = undefined;
      var lastReport = this.props.endProject ? undefined : this.props.project !== undefined && this.props.project.highlights !== undefined ? this.props.project.highlights.slice().filter(function (report) {
        return report.stage === undefined;
      }).sort(_sortByDate2.default).reverse()[0] : {
        summary: { content: "<no previous status summary available>" },
        benefits: { content: "<no previous benefits report available>" },
        cost: { content: "<no previous cost report available>" },
        scope: { content: "<no previous scope report available>" },
        time: { content: "<no previous time report available>" },
        quality: { content: "<no previous quality report available>" },
        risk: { content: "<no previous risk report available>" },
        plannedAchivements: "",
        date: undefined
      };

      var date = new Date();
      var version = this.props.version;
      var endStageReport = this.props.endStage && this.props.project.currentStage !== undefined;
      var from = lastReport !== undefined && lastReport.date !== undefined ? lastReport.date : undefined;;
      if (endStageReport && this.props.project.currentStage.time !== undefined && this.props.project.currentStage.time.start !== undefined) {
        try {
          from = new Date(this.props.project.currentStage.time.start).toISOString().slice(0, 10);
        } catch (error) {
          console.log("[WARN] Invalid start date for stage on end stage report");
        }
      }

      var performed = lastReport !== undefined ? lastReport.plannedAchivements : undefined;
      if (endStageReport) {
        var comments = this.props.project.currentStage.comments;
        var products = this.props.project.currentStage.scheduleComments;
        if (products !== undefined && products !== null && products.trim().length > 0) {
          performed = products;
        } else if (comments !== undefined && comments !== null && comments.trim().length > 0) {
          performed = this.props.project.currentStage.comments.trim();
        }
      }

      var report = {
        overallStatus: {
          status: "green"
        },
        benefits: {
          status: "green"
        },
        time: {
          status: "green"
        },
        cost: {
          status: "green"
        },
        quality: {
          status: "green"
        },
        scope: {
          status: "green"
        },
        risk: {
          status: "green"
        },
        date: date,
        from: from !== undefined ? new Date(from) : undefined,
        performedAchivements: performed
      };
      if (this.props.endProject) {
        if (this.props.project.draftEndProject !== undefined) {
          report = this.props.project.draftEndProject;
          report.from = new Date(report.fromDate);
          report.date = new Date(report.statusDate);
          console.log("Report: " + JSON.stringify(report));
        } else {
          //TODO: Create utility, since these functions are copied from plan
          var sortByStart = function sortByStart(a, b) {
            return a.time.start < b.time.start ? -1 : a.time.start > b.time.start ? 1 : 0;
          };
          var sortByEnd = function sortByEnd(a, b) {
            return a.time.end > b.time.end ? -1 : a.time.end < b.time.end ? 1 : 0;
          };
          var startOf = function startOf(stages) {
            var sortedStages = (stages !== undefined ? stages : []).filter(function (stage) {
              return stage !== undefined;
            }).filter(function (stage) {
              return stage.time !== undefined && stage.time.start !== undefined && stage.time.start !== null && stage.time.start.trim().length > 0;
            }).slice().sort(sortByStart);
            return sortedStages.length > 0 && sortedStages[0].time !== undefined ? sortedStages[0].time.start : undefined;
          };
          var endOf = function endOf(stages) {
            var sortedStages = (stages !== undefined ? stages : []).filter(function (stage) {
              return stage !== undefined;
            }).filter(function (stage) {
              return stage.time !== undefined && stage.time.end !== undefined && stage.time.end !== null && stage.time.end.trim().length > 0;
            }).slice().sort(sortByEnd);
            return sortedStages.length > 0 && sortedStages[0].time !== undefined ? sortedStages[0].time.end : undefined;
          };
          report.from = startOf(this.props.project.stages);
          report.date = endOf(this.props.project.stages);
        }
      } else if (endStageReport) {
        if (this.props.project.draftEndStage !== undefined) {
          report = this.props.project.draftEndStage;
          report.isSavedDraft = true;
          report.date = new Date(report.statusDate);
          report.from = report.fromDate !== undefined && report.fromDate !== null ? new Date(report.fromDate) : undefined;
        }
      } else if (this.props.project.draftHighlight !== undefined) {
        report = this.props.project.draftHighlight;
        report.isSavedDraft = true;
        report.date = new Date(report.statusDate);
        report.from = report.fromDate !== undefined && report.fromDate !== null ? new Date(report.fromDate) : undefined;
      }
      if (this.props.id !== undefined) {
        var publishedReport = this.props.project !== undefined && this.props.project.highlights !== undefined ? this.props.project.highlights.slice().sort(_sortByDate2.default).reverse()[0] : undefined;
        if (publishedReport !== undefined && this.props.id === publishedReport.id && publishedReport.createdBy === this.props.user.id) {
          lastReport = this.props.project.highlights.filter(function (r) {
            return r.id !== _this2.props.id && new Date(r.date).toISOString().slice(0, 10) < new Date(publishedReport.date).toISOString().slice(0, 10);
          }).sort(_sortByDate2.default).slice(-1)[0];
          report = Object.assign({}, publishedReport, {
            id: undefined,
            overallStatus: publishedReport.summary,
            replaces: this.props.id
          });
        }
      }
      if (endStageReport) {
        lastReport = undefined;
      }
      var variant = this.props.endProject ? "endProject" + (this.props.variant !== undefined ? "#" + this.props.variant : "") : this.props.endStage ? "endStage" + (this.props.variant !== undefined ? "#" + this.props.variant : "") : this.props.project.isRelease === true ? "release" + (this.props.variant !== undefined ? "#" + this.props.variant : "") : this.props.project.isProduct === true ? "product" + (this.props.variant !== undefined ? "#" + this.props.variant : "") : this.props.variant;
      return _react2.default.createElement(
        'div',
        { style: { paddingTop: 20 } },
        _react2.default.createElement(_TabReport2.default, _extends({}, this.props, {
          variant: variant,
          endStage: endStageReport,
          report: report,
          onCancel: function onCancel() {
            return window.location = ".";
          },
          lastReport: lastReport
        }))
      );
    }
  }]);

  return HighlightReport;
}(_react2.default.Component);

var HighlightReportPage = function (_React$Component2) {
  _inherits(HighlightReportPage, _React$Component2);

  function HighlightReportPage() {
    _classCallCheck(this, HighlightReportPage);

    return _possibleConstructorReturn(this, (HighlightReportPage.__proto__ || Object.getPrototypeOf(HighlightReportPage)).apply(this, arguments));
  }

  _createClass(HighlightReportPage, [{
    key: 'render',
    value: function render() {
      var menu = this.props.showMenu === true ? _react2.default.createElement(_ProjectMenu2.default, this.props) : undefined;
      return _react2.default.createElement(
        _Layout2.default,
        _extends({}, this.props, { projectMenu: menu }),
        _react2.default.createElement(HighlightReport, this.props)
      );
    }
  }]);

  return HighlightReportPage;
}(_react2.default.Component);

exports.default = HighlightReportPage;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(652);
var ReactElement = __webpack_require__(100);

var emptyFunction = __webpack_require__(303);
var traverseAllChildren = __webpack_require__(653);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(111);

var invariant = __webpack_require__(112);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(111);

var ReactCurrentOwner = __webpack_require__(62);
var REACT_ELEMENT_TYPE = __webpack_require__(305);

var getIteratorFn = __webpack_require__(654);
var invariant = __webpack_require__(112);
var KeyEscapeUtils = __webpack_require__(655);
var warning = __webpack_require__(145);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(100);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(100),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(306);

module.exports = factory(isValidElement);

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__(659);
var assign = __webpack_require__(8);

var ReactPropTypesSecret = __webpack_require__(307);
var has = __webpack_require__(661);
var checkPropTypes = __webpack_require__(662);

var printWarning = function() {};

if (false) {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (false) {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(660);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports = Function.call.bind(Object.prototype.hasOwnProperty);


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (false) {
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
  var has = require('./lib/has');

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (false) {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.7.0';


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(301),
    Component = _require.Component;

var _require2 = __webpack_require__(100),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(302);
var factory = __webpack_require__(665);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(8);

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(111);

var ReactElement = __webpack_require__(100);

var invariant = __webpack_require__(112);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(307);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function keepOnlyPortfolioInformation(project) {
  return {
    id: project.id,
    name: project.name,
    priority: project.priority,
    isStarted: project.isStarted,
    isPaused: project.isPaused,
    isStopped: project.isStopped,
    phase: project.phase,
    projectType: project.projectType,
    overallStatus: project.overallStatus,
    portfolio: project.portfolio,
    category: project.category,
    location: project.location,
    department: project.department,
    state: project.state,
    benefits: project.benefits,
    time: project.time,
    cost: project.cost,
    quality: project.quality,
    scope: project.scope,
    risk: project.risk !== undefined ? {
      status: project.risk.status,
      content: project.risk.content
    } : undefined,
    statusDate: project.statusDate,
    reportedBy: project.reportedBy,
    requestedStageException: project.requestedStageException,
    requestedStageTransition: project.requestedStageTransition,
    recommendedProjectClosure: project.recommendedProjectClosure,
    requestedPhase: project.requestedPhase,
    currentPhase: project.currentPhase,
    isProgramme: project.isProgramme,
    isProduct: project.isProduct,
    isRelease: project.isRelease,
    programme: project.programme,
    releases: project.isProduct && project.releases !== undefined ? project.releases.filter(function (release) {
      return release.active;
    }).map(function (release) {
      return {
        name: release.name,
        active: release.active,
        activated: release.activated
      };
    }) : undefined
  };
}

function strippedTenant(tenant, includeStakeholders) {
  return tenant !== undefined ? Object.assign({}, tenant, {
    projects:  false ? tenant.projects.map(function (project) {
      return keepOnlyPortfolioInformation(project);
    }) : undefined,
    stakeholders: includeStakeholders === true ? tenant.stakeholders : undefined,
    lessons: undefined
  }) : undefined;
}

function strippedProject(project) {
  return project !== undefined ? Object.assign({}, project, {
    plan: project.plan !== undefined ? Object.assign({}, project.plan, {
      history: project.plan.history !== undefined ? project.plan.history.map(function (item) {
        return Object.assign({}, item, {
          stages: undefined
        });
      }) : undefined
    }) : undefined
  }) : undefined;
}

function stripHistory(project) {
  return Object({"NODE_ENV":"production"}).OPTIMIZE_PROJECT_HISTORY === "true" ? Object.assign({}, project, {
    plan: project.plan !== undefined ? Object.assign({}, project.plan, {
      history: undefined
    }) : undefined
  }) : project;
}

module.exports.keepOnlyPortfolioInformation = keepOnlyPortfolioInformation;
module.exports.strippedTenant = strippedTenant;
module.exports.strippetProject = strippedProject;
module.exports.stripHistory = stripHistory;

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * Expose `Emitter`.
 */

if (true) {
  module.exports = Emitter;
}

/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */

function Emitter(obj) {
  if (obj) return mixin(obj);
};

/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in Emitter.prototype) {
    obj[key] = Emitter.prototype[key];
  }
  return obj;
}

/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.on =
Emitter.prototype.addEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};
  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
    .push(fn);
  return this;
};

/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.once = function(event, fn){
  function on() {
    this.off(event, on);
    fn.apply(this, arguments);
  }

  on.fn = fn;
  this.on(event, on);
  return this;
};

/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */

Emitter.prototype.off =
Emitter.prototype.removeListener =
Emitter.prototype.removeAllListeners =
Emitter.prototype.removeEventListener = function(event, fn){
  this._callbacks = this._callbacks || {};

  // all
  if (0 == arguments.length) {
    this._callbacks = {};
    return this;
  }

  // specific event
  var callbacks = this._callbacks['$' + event];
  if (!callbacks) return this;

  // remove all handlers
  if (1 == arguments.length) {
    delete this._callbacks['$' + event];
    return this;
  }

  // remove specific handler
  var cb;
  for (var i = 0; i < callbacks.length; i++) {
    cb = callbacks[i];
    if (cb === fn || cb.fn === fn) {
      callbacks.splice(i, 1);
      break;
    }
  }

  // Remove event specific arrays for event types that no
  // one is subscribed for to avoid memory leak.
  if (callbacks.length === 0) {
    delete this._callbacks['$' + event];
  }

  return this;
};

/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */

Emitter.prototype.emit = function(event){
  this._callbacks = this._callbacks || {};

  var args = new Array(arguments.length - 1)
    , callbacks = this._callbacks['$' + event];

  for (var i = 1; i < arguments.length; i++) {
    args[i - 1] = arguments[i];
  }

  if (callbacks) {
    callbacks = callbacks.slice(0);
    for (var i = 0, len = callbacks.length; i < len; ++i) {
      callbacks[i].apply(this, args);
    }
  }

  return this;
};

/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */

Emitter.prototype.listeners = function(event){
  this._callbacks = this._callbacks || {};
  return this._callbacks['$' + event] || [];
};

/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */

Emitter.prototype.hasListeners = function(event){
  return !! this.listeners(event).length;
};


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module of mixed-in functions shared between node and client code
 */
var isObject = __webpack_require__(309);

/**
 * Expose `RequestBase`.
 */

module.exports = RequestBase;

/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */

function RequestBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in RequestBase.prototype) {
    obj[key] = RequestBase.prototype[key];
  }
  return obj;
}

/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.clearTimeout = function _clearTimeout(){
  clearTimeout(this._timer);
  clearTimeout(this._responseTimeoutTimer);
  delete this._timer;
  delete this._responseTimeoutTimer;
  return this;
};

/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.parse = function parse(fn){
  this._parser = fn;
  return this;
};

/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.responseType = function(val){
  this._responseType = val;
  return this;
};

/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */

RequestBase.prototype.serialize = function serialize(fn){
  this._serializer = fn;
  return this;
};

/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, deadline}
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.timeout = function timeout(options){
  if (!options || 'object' !== typeof options) {
    this._timeout = options;
    this._responseTimeout = 0;
    return this;
  }

  for(var option in options) {
    switch(option) {
      case 'deadline':
        this._timeout = options.deadline;
        break;
      case 'response':
        this._responseTimeout = options.response;
        break;
      default:
        console.warn("Unknown timeout option", option);
    }
  }
  return this;
};

/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @param {Function} [fn]
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.retry = function retry(count, fn){
  // Default to 1 if no count passed or true
  if (arguments.length === 0 || count === true) count = 1;
  if (count <= 0) count = 0;
  this._maxRetries = count;
  this._retries = 0;
  this._retryCallback = fn;
  return this;
};

var ERROR_CODES = [
  'ECONNRESET',
  'ETIMEDOUT',
  'EADDRINFO',
  'ESOCKETTIMEDOUT'
];

/**
 * Determine if a request should be retried.
 * (Borrowed from segmentio/superagent-retry)
 *
 * @param {Error} err
 * @param {Response} [res]
 * @returns {Boolean}
 */
RequestBase.prototype._shouldRetry = function(err, res) {
  if (!this._maxRetries || this._retries++ >= this._maxRetries) {
    return false;
  }
  if (this._retryCallback) {
    try {
      var override = this._retryCallback(err, res);
      if (override === true) return true;
      if (override === false) return false;
      // undefined falls back to defaults
    } catch(e) {
      console.error(e);
    }
  }
  if (res && res.status && res.status >= 500 && res.status != 501) return true;
  if (err) {
    if (err.code && ~ERROR_CODES.indexOf(err.code)) return true;
    // Superagent timeout
    if (err.timeout && err.code == 'ECONNABORTED') return true;
    if (err.crossDomain) return true;
  }
  return false;
};

/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */

RequestBase.prototype._retry = function() {

  this.clearTimeout();

  // node
  if (this.req) {
    this.req = null;
    this.req = this.request();
  }

  this._aborted = false;
  this.timedout = false;

  return this._end();
};

/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */

RequestBase.prototype.then = function then(resolve, reject) {
  if (!this._fullfilledPromise) {
    var self = this;
    if (this._endCalled) {
      console.warn("Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises");
    }
    this._fullfilledPromise = new Promise(function(innerResolve, innerReject) {
      self.end(function(err, res) {
        if (err) innerReject(err);
        else innerResolve(res);
      });
    });
  }
  return this._fullfilledPromise.then(resolve, reject);
};

RequestBase.prototype['catch'] = function(cb) {
  return this.then(undefined, cb);
};

/**
 * Allow for extension
 */

RequestBase.prototype.use = function use(fn) {
  fn(this);
  return this;
};

RequestBase.prototype.ok = function(cb) {
  if ('function' !== typeof cb) throw Error("Callback required");
  this._okCallback = cb;
  return this;
};

RequestBase.prototype._isResponseOK = function(res) {
  if (!res) {
    return false;
  }

  if (this._okCallback) {
    return this._okCallback(res);
  }

  return res.status >= 200 && res.status < 300;
};

/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

RequestBase.prototype.get = function(field){
  return this._header[field.toLowerCase()];
};

/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */

RequestBase.prototype.getHeader = RequestBase.prototype.get;

/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.set = function(field, val){
  if (isObject(field)) {
    for (var key in field) {
      this.set(key, field[key]);
    }
    return this;
  }
  this._header[field.toLowerCase()] = val;
  this.header[field] = val;
  return this;
};

/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */
RequestBase.prototype.unset = function(field){
  delete this._header[field.toLowerCase()];
  delete this.header[field];
  return this;
};

/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */
RequestBase.prototype.field = function(name, val) {
  // name should be either a string or an object.
  if (null === name || undefined === name) {
    throw new Error('.field(name, val) name can not be empty');
  }

  if (this._data) {
    console.error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObject(name)) {
    for (var key in name) {
      this.field(key, name[key]);
    }
    return this;
  }

  if (Array.isArray(val)) {
    for (var i in val) {
      this.field(name, val[i]);
    }
    return this;
  }

  // val should be defined now
  if (null === val || undefined === val) {
    throw new Error('.field(name, val) val can not be empty');
  }
  if ('boolean' === typeof val) {
    val = '' + val;
  }
  this._getFormData().append(name, val);
  return this;
};

/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */
RequestBase.prototype.abort = function(){
  if (this._aborted) {
    return this;
  }
  this._aborted = true;
  this.xhr && this.xhr.abort(); // browser
  this.req && this.req.abort(); // node
  this.clearTimeout();
  this.emit('abort');
  return this;
};

RequestBase.prototype._auth = function(user, pass, options, base64Encoder) {
  switch (options.type) {
    case 'basic':
      this.set('Authorization', 'Basic ' + base64Encoder(user + ':' + pass));
      break;

    case 'auto':
      this.username = user;
      this.password = pass;
      break;

    case 'bearer': // usage would be .auth(accessToken, { type: 'bearer' })
      this.set('Authorization', 'Bearer ' + user);
      break;
  }
  return this;
};

/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */

RequestBase.prototype.withCredentials = function(on) {
  // This is browser-only functionality. Node side is no-op.
  if (on == undefined) on = true;
  this._withCredentials = on;
  return this;
};

/**
 * Set the max redirects to `n`. Does noting in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.redirects = function(n){
  this._maxRedirects = n;
  return this;
};

/**
 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
 * Default 200MB.
 *
 * @param {Number} n
 * @return {Request} for chaining
 */
RequestBase.prototype.maxResponseSize = function(n){
  if ('number' !== typeof n) {
    throw TypeError("Invalid argument");
  }
  this._maxResponseSize = n;
  return this;
};

/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */

RequestBase.prototype.toJSON = function() {
  return {
    method: this.method,
    url: this.url,
    data: this._data,
    headers: this._header,
  };
};

/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.send = function(data){
  var isObj = isObject(data);
  var type = this._header['content-type'];

  if (this._formData) {
    console.error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
  }

  if (isObj && !this._data) {
    if (Array.isArray(data)) {
      this._data = [];
    } else if (!this._isHost(data)) {
      this._data = {};
    }
  } else if (data && this._data && this._isHost(this._data)) {
    throw Error("Can't merge these send calls");
  }

  // merge
  if (isObj && isObject(this._data)) {
    for (var key in data) {
      this._data[key] = data[key];
    }
  } else if ('string' == typeof data) {
    // default to x-www-form-urlencoded
    if (!type) this.type('form');
    type = this._header['content-type'];
    if ('application/x-www-form-urlencoded' == type) {
      this._data = this._data
        ? this._data + '&' + data
        : data;
    } else {
      this._data = (this._data || '') + data;
    }
  } else {
    this._data = data;
  }

  if (!isObj || this._isHost(data)) {
    return this;
  }

  // default to json
  if (!type) this.type('json');
  return this;
};

/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */

RequestBase.prototype.sortQuery = function(sort) {
  // _sort default to true but otherwise can be a function or boolean
  this._sort = typeof sort === 'undefined' ? true : sort;
  return this;
};

/**
 * Compose querystring to append to req.url
 *
 * @api private
 */
RequestBase.prototype._finalizeQueryString = function(){
  var query = this._query.join('&');
  if (query) {
    this.url += (this.url.indexOf('?') >= 0 ? '&' : '?') + query;
  }
  this._query.length = 0; // Makes the call idempotent

  if (this._sort) {
    var index = this.url.indexOf('?');
    if (index >= 0) {
      var queryArr = this.url.substring(index + 1).split('&');
      if ('function' === typeof this._sort) {
        queryArr.sort(this._sort);
      } else {
        queryArr.sort();
      }
      this.url = this.url.substring(0, index) + '?' + queryArr.join('&');
    }
  }
};

// For backwards compat only
RequestBase.prototype._appendQueryString = function() {console.trace("Unsupported");}

/**
 * Invoke callback with timeout error.
 *
 * @api private
 */

RequestBase.prototype._timeoutError = function(reason, timeout, errno){
  if (this._aborted) {
    return;
  }
  var err = new Error(reason + timeout + 'ms exceeded');
  err.timeout = timeout;
  err.code = 'ECONNABORTED';
  err.errno = errno;
  this.timedout = true;
  this.abort();
  this.callback(err);
};

RequestBase.prototype._setTimeouts = function() {
  var self = this;

  // deadline
  if (this._timeout && !this._timer) {
    this._timer = setTimeout(function(){
      self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
  }
  // response timeout
  if (this._responseTimeout && !this._responseTimeoutTimer) {
    this._responseTimeoutTimer = setTimeout(function(){
      self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
  }
};


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Module dependencies.
 */

var utils = __webpack_require__(672);

/**
 * Expose `ResponseBase`.
 */

module.exports = ResponseBase;

/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */

function ResponseBase(obj) {
  if (obj) return mixin(obj);
}

/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */

function mixin(obj) {
  for (var key in ResponseBase.prototype) {
    obj[key] = ResponseBase.prototype[key];
  }
  return obj;
}

/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */

ResponseBase.prototype.get = function(field) {
  return this.header[field.toLowerCase()];
};

/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */

ResponseBase.prototype._setHeaderProperties = function(header){
    // TODO: moar!
    // TODO: make this a util

    // content-type
    var ct = header['content-type'] || '';
    this.type = utils.type(ct);

    // params
    var params = utils.params(ct);
    for (var key in params) this[key] = params[key];

    this.links = {};

    // links
    try {
        if (header.link) {
            this.links = utils.parseLinks(header.link);
        }
    } catch (err) {
        // ignore
    }
};

/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */

ResponseBase.prototype._setStatusProperties = function(status){
    var type = status / 100 | 0;

    // status / class
    this.status = this.statusCode = status;
    this.statusType = type;

    // basics
    this.info = 1 == type;
    this.ok = 2 == type;
    this.redirect = 3 == type;
    this.clientError = 4 == type;
    this.serverError = 5 == type;
    this.error = (4 == type || 5 == type)
        ? this.toError()
        : false;

    // sugar
    this.created = 201 == status;
    this.accepted = 202 == status;
    this.noContent = 204 == status;
    this.badRequest = 400 == status;
    this.unauthorized = 401 == status;
    this.notAcceptable = 406 == status;
    this.forbidden = 403 == status;
    this.notFound = 404 == status;
    this.unprocessableEntity = 422 == status;
};


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

exports.type = function(str){
  return str.split(/ *; */).shift();
};

/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.params = function(str){
  return str.split(/ *; */).reduce(function(obj, str){
    var parts = str.split(/ *= */);
    var key = parts.shift();
    var val = parts.shift();

    if (key && val) obj[key] = val;
    return obj;
  }, {});
};

/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */

exports.parseLinks = function(str){
  return str.split(/ *, */).reduce(function(obj, str){
    var parts = str.split(/ *; */);
    var url = parts[0].slice(1, -1);
    var rel = parts[1].split(/ *= */)[1].slice(1, -1);
    obj[rel] = url;
    return obj;
  }, {});
};

/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */

exports.cleanHeader = function(header, changesOrigin){
  delete header['content-type'];
  delete header['content-length'];
  delete header['transfer-encoding'];
  delete header['host'];
  // secuirty
  if (changesOrigin) {
    delete header['authorization'];
    delete header['cookie'];
  }
  return header;
};


/***/ }),
/* 673 */
/***/ (function(module, exports) {

function Agent() {
  this._defaults = [];
}

["use", "on", "once", "set", "query", "type", "accept", "auth", "withCredentials", "sortQuery", "retry", "ok", "redirects",
 "timeout", "buffer", "serialize", "parse", "ca", "key", "pfx", "cert"].forEach(function(fn) {
  /** Default setting for all requests from this agent */
  Agent.prototype[fn] = function(/*varargs*/) {
    this._defaults.push({fn:fn, arguments:arguments});
    return this;
  }
});

Agent.prototype._setDefaults = function(req) {
    this._defaults.forEach(function(def) {
      req[def.fn].apply(req, def.arguments);
    });
};

module.exports = Agent;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
var rng;

var crypto = global.crypto || global.msCrypto; // for IE 11
if (crypto && crypto.getRandomValues) {
  // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
  // Moderately fast, high quality
  var _rnds8 = new Uint8Array(16);
  rng = function whatwgRNG() {
    crypto.getRandomValues(_rnds8);
    return _rnds8;
  };
}

if (!rng) {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var  _rnds = new Array(16);
  rng = function() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return _rnds;
  };
}

module.exports = rng;


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDayPicker = __webpack_require__(676);

var _reactDayPicker2 = _interopRequireDefault(_reactDayPicker);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(113), __webpack_require__(114)]);

var Period = function (_React$Component) {
  _inherits(Period, _React$Component);

  function Period(props) {
    _classCallCheck(this, Period);

    var _this = _possibleConstructorReturn(this, (Period.__proto__ || Object.getPrototypeOf(Period)).call(this, props));

    var from = props.value !== undefined ? props.value.from !== undefined ? props.value.from : typeof props.value === "string" ? new Date(props.value.split(" to ")[0]) : undefined : undefined;
    var to = props.value !== undefined ? props.value.to !== undefined ? props.value.to : typeof props.value === "string" ? new Date(props.value.split(" to ")[1]) : undefined : undefined;
    _this.state = {
      from: from !== undefined ? new Date(from) : null,
      to: to !== undefined ? new Date(to) : null,
      edit: !from || !to
    };
    return _this;
  }

  _createClass(Period, [{
    key: 'handleDayClick',
    value: function handleDayClick(day) {
      var range = _reactDayPicker.DateUtils.addDayToRange(day, this.state);
      this.setState(range);
      if (this.props.onChange !== undefined) {
        this.props.onChange({ target: { name: this.props.name, value: range } });
      }
    }
  }, {
    key: 'handleResetClick',
    value: function handleResetClick(e) {
      e.preventDefault();
      this.setState({ edit: !this.state.edit });
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).period;
      var _state = this.state,
          from = _state.from,
          to = _state.to,
          edit = _state.edit;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('input', { type: 'hidden', name: this.props.name, value: from && to ? new Date(from).toISOString().slice(0, 10) + " to " + new Date(to).toISOString().slice(0, 10) : "" }),
        _react2.default.createElement(
          'div',
          { style: { paddingTop: edit ? 3 : 0 } },
          !from && !to && _react2.default.createElement(
            'span',
            null,
            labels.pleaseSelect,
            ' ',
            _react2.default.createElement(
              'strong',
              null,
              labels.firstDay
            ),
            '.'
          ),
          from && !to && _react2.default.createElement(
            'span',
            null,
            labels.pleaseSelect,
            ' ',
            _react2.default.createElement(
              'strong',
              null,
              labels.lastDay
            ),
            '.'
          ),
          !from && to && _react2.default.createElement(
            'span',
            null,
            labels.fromUndefinedTo,
            ' ',
            new Date(to).toISOString().slice(0, 10)
          ),
          from && to && _react2.default.createElement(
            'span',
            null,
            labels.from,
            ' ',
            new Date(from).toISOString().slice(0, 10),
            ' ',
            labels.to,
            ' ',
            new Date(to).toISOString().slice(0, 10),
            ' '
          ),
          !edit && _react2.default.createElement(
            'a',
            { style: { display: "inline-block", verticalAlign: "middle" }, href: '.', onClick: this.handleResetClick.bind(this) },
            _react2.default.createElement('img', { src: '/icons/pen_grey_tran.png' })
          )
        ),
        edit && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_reactDayPicker2.default, {
            numberOfMonths: 2,
            selectedDays: [from, { from: from, to: to }],
            onDayClick: this.handleDayClick.bind(this),
            fixedWeeks: true,
            month: from !== null ? new Date(from) : undefined,
            months: labels.months,
            weekdaysShort: labels.weekdaysShort,
            firstDayOfWeek: 1,
            showWeekNumbers: true
          }),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'a',
              { href: '.', onClick: this.handleResetClick.bind(this) },
              labels.hideCalendar
            )
          )
        )
      );
    }
  }]);

  return Period;
}(_react2.default.Component);

exports.default = Period;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable no-var */
/* eslint-env node */

var DayPicker = __webpack_require__(677);
var DateUtils = __webpack_require__(101);
var LocaleUtils = __webpack_require__(209);
var ModifiersUtils = __webpack_require__(312);
var Weekday = __webpack_require__(313).default;
var Navbar = __webpack_require__(310).default;
var PropTypes = __webpack_require__(682);

module.exports = DayPicker.default || DayPicker;
module.exports.DateUtils = DateUtils.default || DateUtils;
module.exports.LocaleUtils = LocaleUtils.default || LocaleUtils;
module.exports.ModifiersUtils = ModifiersUtils.default || ModifiersUtils;
module.exports.WeekdayPropTypes = Weekday.propTypes;
module.exports.NavbarPropTypes = Navbar.propTypes;
module.exports.PropTypes = PropTypes;


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(24);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Caption = __webpack_require__(678);

var _Caption2 = _interopRequireDefault(_Caption);

var _Navbar = __webpack_require__(310);

var _Navbar2 = _interopRequireDefault(_Navbar);

var _Month = __webpack_require__(679);

var _Month2 = _interopRequireDefault(_Month);

var _Weekday = __webpack_require__(313);

var _Weekday2 = _interopRequireDefault(_Weekday);

var _Helpers = __webpack_require__(147);

var Helpers = _interopRequireWildcard(_Helpers);

var _DateUtils = __webpack_require__(101);

var DateUtils = _interopRequireWildcard(_DateUtils);

var _LocaleUtils = __webpack_require__(209);

var LocaleUtils = _interopRequireWildcard(_LocaleUtils);

var _classNames = __webpack_require__(146);

var _classNames2 = _interopRequireDefault(_classNames);

var _keys = __webpack_require__(311);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DayPicker = function (_Component) {
  _inherits(DayPicker, _Component);

  function DayPicker(props) {
    _classCallCheck(this, DayPicker);

    var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = _this.getStateFromProps(props);
    return _this;
  }

  _createClass(DayPicker, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.month !== nextProps.month) {
        this.setState(this.getStateFromProps(nextProps));
      }
    }
  }, {
    key: 'getNextNavigableMonth',
    value: function getNextNavigableMonth() {
      return DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
    }
  }, {
    key: 'getPreviousNavigableMonth',
    value: function getPreviousNavigableMonth() {
      return DateUtils.addMonths(this.state.currentMonth, -1);
    }
  }, {
    key: 'allowPreviousMonth',
    value: function allowPreviousMonth() {
      var previousMonth = DateUtils.addMonths(this.state.currentMonth, -1);
      return this.allowMonth(previousMonth);
    }
  }, {
    key: 'allowNextMonth',
    value: function allowNextMonth() {
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
      return this.allowMonth(nextMonth);
    }
  }, {
    key: 'allowMonth',
    value: function allowMonth(d) {
      var _props = this.props,
          fromMonth = _props.fromMonth,
          toMonth = _props.toMonth,
          canChangeMonth = _props.canChangeMonth;

      if (!canChangeMonth || fromMonth && Helpers.getMonthsDiff(fromMonth, d) < 0 || toMonth && Helpers.getMonthsDiff(toMonth, d) > 0) {
        return false;
      }
      return true;
    }
  }, {
    key: 'allowYearChange',
    value: function allowYearChange() {
      return this.props.canChangeMonth;
    }
  }, {
    key: 'showMonth',
    value: function showMonth(d, callback) {
      var _this2 = this;

      if (!this.allowMonth(d)) {
        return;
      }
      this.setState({ currentMonth: Helpers.startOfMonth(d) }, function () {
        if (callback) {
          callback();
        }
        if (_this2.props.onMonthChange) {
          _this2.props.onMonthChange(_this2.state.currentMonth);
        }
      });
    }
  }, {
    key: 'showNextYear',
    value: function showNextYear() {
      if (!this.allowYearChange()) {
        return;
      }
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, 12);
      this.showMonth(nextMonth);
    }
  }, {
    key: 'showPreviousYear',
    value: function showPreviousYear() {
      if (!this.allowYearChange()) {
        return;
      }
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, -12);
      this.showMonth(nextMonth);
    }
  }, {
    key: 'focusFirstDayOfMonth',
    value: function focusFirstDayOfMonth() {
      Helpers.getDayNodes(this.dayPicker, this.props.classNames)[0].focus();
    }
  }, {
    key: 'focusLastDayOfMonth',
    value: function focusLastDayOfMonth() {
      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      dayNodes[dayNodes.length - 1].focus();
    }
  }, {
    key: 'focusPreviousDay',
    value: function focusPreviousDay(dayNode) {
      var _this3 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);

      if (dayNodeIndex === 0) {
        this.showPreviousMonth(function () {
          return _this3.focusLastDayOfMonth();
        });
      } else {
        dayNodes[dayNodeIndex - 1].focus();
      }
    }
  }, {
    key: 'focusNextDay',
    value: function focusNextDay(dayNode) {
      var _this4 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);

      if (dayNodeIndex === dayNodes.length - 1) {
        this.showNextMonth(function () {
          return _this4.focusFirstDayOfMonth();
        });
      } else {
        dayNodes[dayNodeIndex + 1].focus();
      }
    }
  }, {
    key: 'focusNextWeek',
    value: function focusNextWeek(dayNode) {
      var _this5 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      var isInLastWeekOfMonth = dayNodeIndex > dayNodes.length - 8;

      if (isInLastWeekOfMonth) {
        this.showNextMonth(function () {
          var daysAfterIndex = dayNodes.length - dayNodeIndex;
          var nextMonthDayNodeIndex = 7 - daysAfterIndex;
          Helpers.getDayNodes(_this5.dayPicker, _this5.props.classNames)[nextMonthDayNodeIndex].focus();
        });
      } else {
        dayNodes[dayNodeIndex + 7].focus();
      }
    }
  }, {
    key: 'focusPreviousWeek',
    value: function focusPreviousWeek(dayNode) {
      var _this6 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      var isInFirstWeekOfMonth = dayNodeIndex <= 6;

      if (isInFirstWeekOfMonth) {
        this.showPreviousMonth(function () {
          var previousMonthDayNodes = Helpers.getDayNodes(_this6.dayPicker, _this6.props.classNames);
          var startOfLastWeekOfMonth = previousMonthDayNodes.length - 7;
          var previousMonthDayNodeIndex = startOfLastWeekOfMonth + dayNodeIndex;
          previousMonthDayNodes[previousMonthDayNodeIndex].focus();
        });
      } else {
        dayNodes[dayNodeIndex - 7].focus();
      }
    }

    // Event handlers

  }, {
    key: 'handleOutsideDayClick',
    value: function handleOutsideDayClick(day) {
      var currentMonth = this.state.currentMonth;
      var numberOfMonths = this.props.numberOfMonths;

      var diffInMonths = Helpers.getMonthsDiff(currentMonth, day);
      if (diffInMonths > 0 && diffInMonths >= numberOfMonths) {
        this.showNextMonth();
      } else if (diffInMonths < 0) {
        this.showPreviousMonth();
      }
    }
  }, {
    key: 'renderNavbar',
    value: function renderNavbar() {
      var _props2 = this.props,
          labels = _props2.labels,
          locale = _props2.locale,
          localeUtils = _props2.localeUtils,
          canChangeMonth = _props2.canChangeMonth,
          navbarElement = _props2.navbarElement,
          attributes = _objectWithoutProperties(_props2, ['labels', 'locale', 'localeUtils', 'canChangeMonth', 'navbarElement']);

      if (!canChangeMonth) return null;

      var props = {
        classNames: this.props.classNames,
        className: this.props.classNames.navBar,
        nextMonth: this.getNextNavigableMonth(),
        previousMonth: this.getPreviousNavigableMonth(),
        showPreviousButton: this.allowPreviousMonth(),
        showNextButton: this.allowNextMonth(),
        onNextClick: this.showNextMonth,
        onPreviousClick: this.showPreviousMonth,
        dir: attributes.dir,
        labels: labels,
        locale: locale,
        localeUtils: localeUtils
      };
      return _react2.default.isValidElement(navbarElement) ? _react2.default.cloneElement(navbarElement, props) : _react2.default.createElement(navbarElement, props);
    }
  }, {
    key: 'renderMonths',
    value: function renderMonths() {
      var months = [];
      var firstDayOfWeek = Helpers.getFirstDayOfWeekFromProps(this.props);

      for (var i = 0; i < this.props.numberOfMonths; i += 1) {
        var month = DateUtils.addMonths(this.state.currentMonth, i);

        months.push(_react2.default.createElement(_Month2.default, _extends({
          key: i
        }, this.props, {
          month: month,
          footer: this.props.todayButton && this.renderTodayButton(),
          firstDayOfWeek: firstDayOfWeek,
          onDayKeyDown: this.handleDayKeyDown,
          onDayClick: this.handleDayClick
        })));
      }

      if (this.props.reverseMonths) {
        months.reverse();
      }
      return months;
    }
  }, {
    key: 'renderTodayButton',
    value: function renderTodayButton() {
      return _react2.default.createElement(
        'button',
        {
          type: 'button',
          tabIndex: 0,
          className: this.props.classNames.todayButton,
          'aria-label': this.props.todayButton,
          onClick: this.handleTodayButtonClick
        },
        this.props.todayButton
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var className = this.props.classNames.container;

      if (!this.props.onDayClick) {
        className = className + ' ' + this.props.classNames.interactionDisabled;
      }
      if (this.props.className) {
        className = className + ' ' + this.props.className;
      }
      return _react2.default.createElement(
        'div',
        _extends({}, this.props.containerProps, {
          className: className,
          ref: function ref(el) {
            return _this7.dayPicker = el;
          },
          role: 'application',
          lang: this.props.locale
        }),
        _react2.default.createElement(
          'div',
          {
            className: this.props.classNames.wrapper,
            tabIndex: this.props.canChangeMonth && this.props.tabIndex ? this.props.tabIndex : -1,
            onKeyDown: this.handleKeyDown,
            onFocus: this.props.onFocus,
            onBlur: this.props.onBlur
          },
          this.renderNavbar(),
          this.renderMonths()
        )
      );
    }
  }]);

  return DayPicker;
}(_react.Component);

DayPicker.VERSION = '6.2.1';
DayPicker.defaultProps = {
  classNames: _classNames2.default,
  tabIndex: 0,
  initialMonth: new Date(),
  numberOfMonths: 1,
  labels: {
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month'
  },
  locale: 'en',
  localeUtils: LocaleUtils,
  enableOutsideDays: false,
  fixedWeeks: false,
  canChangeMonth: true,
  reverseMonths: false,
  pagedNavigation: false,
  showWeekNumbers: false,
  renderDay: function renderDay(day) {
    return day.getDate();
  },
  weekdayElement: _react2.default.createElement(_Weekday2.default, null),
  navbarElement: _react2.default.createElement(_Navbar2.default, { classNames: _classNames2.default }),
  captionElement: _react2.default.createElement(_Caption2.default, { classNames: _classNames2.default })
};

var _initialiseProps = function _initialiseProps() {
  var _this8 = this;

  this.getStateFromProps = function (props) {
    var initialMonth = Helpers.startOfMonth(props.month || props.initialMonth);
    var currentMonth = initialMonth;

    if (props.pagedNavigation && props.numberOfMonths > 1 && props.fromMonth) {
      var diffInMonths = Helpers.getMonthsDiff(props.fromMonth, currentMonth);
      currentMonth = DateUtils.addMonths(props.fromMonth, Math.floor(diffInMonths / props.numberOfMonths) * props.numberOfMonths);
    }
    return { currentMonth: currentMonth };
  };

  this.dayPicker = null;

  this.showNextMonth = function (callback) {
    if (!_this8.allowNextMonth()) {
      return;
    }
    var deltaMonths = _this8.props.pagedNavigation ? _this8.props.numberOfMonths : 1;
    var nextMonth = DateUtils.addMonths(_this8.state.currentMonth, deltaMonths);
    _this8.showMonth(nextMonth, callback);
  };

  this.showPreviousMonth = function (callback) {
    if (!_this8.allowPreviousMonth()) {
      return;
    }
    var deltaMonths = _this8.props.pagedNavigation ? _this8.props.numberOfMonths : 1;
    var previousMonth = DateUtils.addMonths(_this8.state.currentMonth, -deltaMonths);
    _this8.showMonth(previousMonth, callback);
  };

  this.handleKeyDown = function (e) {
    e.persist();

    switch (e.keyCode) {
      case _keys.LEFT:
        _this8.showPreviousMonth();
        break;
      case _keys.RIGHT:
        _this8.showNextMonth();
        break;
      case _keys.UP:
        _this8.showPreviousYear();
        break;
      case _keys.DOWN:
        _this8.showNextYear();
        break;
      default:
        break;
    }

    if (_this8.props.onKeyDown) {
      _this8.props.onKeyDown(e);
    }
  };

  this.handleDayKeyDown = function (day, modifiers, e) {
    e.persist();
    switch (e.keyCode) {
      case _keys.LEFT:
        Helpers.cancelEvent(e);
        _this8.focusPreviousDay(e.target);
        break;
      case _keys.RIGHT:
        Helpers.cancelEvent(e);
        _this8.focusNextDay(e.target);
        break;
      case _keys.UP:
        Helpers.cancelEvent(e);
        _this8.focusPreviousWeek(e.target);
        break;
      case _keys.DOWN:
        Helpers.cancelEvent(e);
        _this8.focusNextWeek(e.target);
        break;
      case _keys.ENTER:
      case _keys.SPACE:
        Helpers.cancelEvent(e);
        if (_this8.props.onDayClick) {
          _this8.handleDayClick(day, modifiers, e);
        }
        break;
      default:
        break;
    }
    if (_this8.props.onDayKeyDown) {
      _this8.props.onDayKeyDown(day, modifiers, e);
    }
  };

  this.handleDayClick = function (day, modifiers, e) {
    e.persist();
    if (modifiers[_this8.props.classNames.outside]) {
      _this8.handleOutsideDayClick(day);
    }
    if (_this8.props.onDayClick) {
      _this8.props.onDayClick(day, modifiers, e);
    }
  };

  this.handleTodayButtonClick = function (e) {
    _this8.showMonth(new Date());
    e.target.blur();
  };
};

exports.default = DayPicker;
DayPicker.propTypes =  false ? {
  // Rendering months
  initialMonth: _propTypes2.default.instanceOf(Date),
  month: _propTypes2.default.instanceOf(Date),
  numberOfMonths: _propTypes2.default.number,
  fromMonth: _propTypes2.default.instanceOf(Date),
  toMonth: _propTypes2.default.instanceOf(Date),
  canChangeMonth: _propTypes2.default.bool,
  reverseMonths: _propTypes2.default.bool,
  pagedNavigation: _propTypes2.default.bool,
  todayButton: _propTypes2.default.string,
  showWeekNumbers: _propTypes2.default.bool,

  // Modifiers
  selectedDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),
  disabledDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),

  modifiers: _propTypes2.default.object,
  modifiersStyles: _propTypes2.default.object,

  // Localization
  dir: _propTypes2.default.string,
  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
  labels: _propTypes2.default.shape({
    nextMonth: _propTypes2.default.string.isRequired,
    previousMonth: _propTypes2.default.string.isRequired
  }).isRequired,
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.shape({
    formatMonthTitle: _propTypes2.default.func,
    formatWeekdayShort: _propTypes2.default.func,
    formatWeekdayLong: _propTypes2.default.func,
    getFirstDayOfWeek: _propTypes2.default.func
  }),
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),

  // Customization
  enableOutsideDays: _propTypes2.default.bool,
  fixedWeeks: _propTypes2.default.bool,

  // CSS and HTML
  classNames: _propTypes2.default.shape({
    body: _propTypes2.default.string,
    container: _propTypes2.default.string,
    day: _propTypes2.default.string.isRequired,
    disabled: _propTypes2.default.string.isRequired,
    footer: _propTypes2.default.string,
    interactionDisabled: _propTypes2.default.string,
    month: _propTypes2.default.string,
    navBar: _propTypes2.default.string,
    outside: _propTypes2.default.string.isRequired,
    selected: _propTypes2.default.string.isRequired,
    today: _propTypes2.default.string.isRequired,
    todayButton: _propTypes2.default.string,
    week: _propTypes2.default.string,
    wrapper: _propTypes2.default.string
  }),
  className: _propTypes2.default.string,
  containerProps: _propTypes2.default.object,
  tabIndex: _propTypes2.default.number,

  // Custom elements
  renderDay: _propTypes2.default.func,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
  navbarElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),

  // Events
  onBlur: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onDayClick: _propTypes2.default.func,
  onDayKeyDown: _propTypes2.default.func,
  onDayMouseEnter: _propTypes2.default.func,
  onDayMouseLeave: _propTypes2.default.func,
  onDayMouseDown: _propTypes2.default.func,
  onDayMouseUp: _propTypes2.default.func,
  onDayTouchStart: _propTypes2.default.func,
  onDayTouchEnd: _propTypes2.default.func,
  onDayFocus: _propTypes2.default.func,
  onMonthChange: _propTypes2.default.func,
  onCaptionClick: _propTypes2.default.func,
  onWeekClick: _propTypes2.default.func
} : {};
//# sourceMappingURL=DayPicker.js.map

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(24);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Caption = function (_Component) {
  _inherits(Caption, _Component);

  function Caption() {
    _classCallCheck(this, Caption);

    return _possibleConstructorReturn(this, (Caption.__proto__ || Object.getPrototypeOf(Caption)).apply(this, arguments));
  }

  _createClass(Caption, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.locale !== this.props.locale || nextProps.classNames !== this.props.classNames || nextProps.date.getMonth() !== this.props.date.getMonth() || nextProps.date.getFullYear() !== this.props.date.getFullYear();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          date = _props.date,
          months = _props.months,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          onClick = _props.onClick;

      return _react2.default.createElement(
        'div',
        { className: classNames.caption, role: 'heading' },
        _react2.default.createElement(
          'div',
          { onClick: onClick },
          months ? months[date.getMonth()] + ' ' + date.getFullYear() : localeUtils.formatMonthTitle(date, locale)
        )
      );
    }
  }]);

  return Caption;
}(_react.Component);

exports.default = Caption;
Caption.propTypes =  false ? {
  date: _propTypes2.default.instanceOf(Date),
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  classNames: _propTypes2.default.shape({
    caption: _propTypes2.default.string.isRequired
  }).isRequired
} : {};
//# sourceMappingURL=Caption.js.map

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(24);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Weekdays = __webpack_require__(680);

var _Weekdays2 = _interopRequireDefault(_Weekdays);

var _Day = __webpack_require__(681);

var _Day2 = _interopRequireDefault(_Day);

var _ModifiersUtils = __webpack_require__(312);

var ModifiersUtils = _interopRequireWildcard(_ModifiersUtils);

var _Helpers = __webpack_require__(147);

var Helpers = _interopRequireWildcard(_Helpers);

var _DateUtils = __webpack_require__(101);

var DateUtils = _interopRequireWildcard(_DateUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Month = function (_Component) {
  _inherits(Month, _Component);

  function Month() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Month);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Month.__proto__ || Object.getPrototypeOf(Month)).call.apply(_ref, [this].concat(args))), _this), _this.renderDay = function (day) {
      var monthNumber = _this.props.month.getMonth();
      var propModifiers = Helpers.getModifiersFromProps(_this.props);
      var dayModifiers = ModifiersUtils.getModifiersForDay(day, propModifiers);
      if (DateUtils.isSameDay(day, new Date()) && !Object.prototype.hasOwnProperty.call(propModifiers, _this.props.classNames.today)) {
        dayModifiers.push(_this.props.classNames.today);
      }
      if (day.getMonth() !== monthNumber) {
        dayModifiers.push(_this.props.classNames.outside);
      }

      var isOutside = day.getMonth() !== monthNumber;
      var tabIndex = -1;
      // Focus on the first day of the month
      if (_this.props.onDayClick && !isOutside && day.getDate() === 1) {
        tabIndex = _this.props.tabIndex;
      }
      var key = '' + day.getFullYear() + day.getMonth() + day.getDate();
      var modifiers = {};
      dayModifiers.forEach(function (modifier) {
        modifiers[modifier] = true;
      });

      return _react2.default.createElement(
        _Day2.default,
        {
          key: '' + (isOutside ? 'outside-' : '') + key,
          classNames: _this.props.classNames,
          day: day,
          modifiers: modifiers,
          modifiersStyles: _this.props.modifiersStyles,
          empty: isOutside && !_this.props.enableOutsideDays && !_this.props.fixedWeeks,
          tabIndex: tabIndex,
          ariaLabel: _this.props.localeUtils.formatDay(day, _this.props.locale),
          ariaDisabled: isOutside || dayModifiers.indexOf('disabled') > -1,
          ariaSelected: dayModifiers.indexOf('selected') > -1,
          onClick: _this.props.onDayClick,
          onFocus: _this.props.onDayFocus,
          onKeyDown: _this.props.onDayKeyDown,
          onMouseEnter: _this.props.onDayMouseEnter,
          onMouseLeave: _this.props.onDayMouseLeave,
          onMouseDown: _this.props.onDayMouseDown,
          onMouseUp: _this.props.onDayMouseUp,
          onTouchEnd: _this.props.onDayTouchEnd,
          onTouchStart: _this.props.onDayTouchStart
        },
        _this.props.renderDay(day, modifiers)
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Month, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          classNames = _props.classNames,
          month = _props.month,
          months = _props.months,
          fixedWeeks = _props.fixedWeeks,
          captionElement = _props.captionElement,
          weekdayElement = _props.weekdayElement,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          firstDayOfWeek = _props.firstDayOfWeek,
          onCaptionClick = _props.onCaptionClick,
          footer = _props.footer,
          showWeekNumbers = _props.showWeekNumbers,
          onWeekClick = _props.onWeekClick;


      var captionProps = {
        date: month,
        classNames: classNames,
        months: months,
        localeUtils: localeUtils,
        locale: locale,
        onClick: onCaptionClick ? function (e) {
          return onCaptionClick(month, e);
        } : undefined
      };
      var caption = _react2.default.isValidElement(captionElement) ? _react2.default.cloneElement(captionElement, captionProps) : _react2.default.createElement(captionElement, captionProps);

      var weeks = Helpers.getWeekArray(month, firstDayOfWeek, fixedWeeks);

      return _react2.default.createElement(
        'div',
        { className: classNames.month, role: 'grid' },
        caption,
        _react2.default.createElement(_Weekdays2.default, {
          classNames: classNames,
          weekdaysShort: weekdaysShort,
          weekdaysLong: weekdaysLong,
          firstDayOfWeek: firstDayOfWeek,
          showWeekNumbers: showWeekNumbers,
          locale: locale,
          localeUtils: localeUtils,
          weekdayElement: weekdayElement
        }),
        _react2.default.createElement(
          'div',
          { className: classNames.body, role: 'rowgroup' },
          weeks.map(function (week) {
            var weekNumber = void 0;
            if (showWeekNumbers) {
              weekNumber = DateUtils.getWeekNumber(week[0]);
            }
            return _react2.default.createElement(
              'div',
              {
                key: week[0].getTime(),
                className: classNames.week,
                role: 'row'
              },
              showWeekNumbers && _react2.default.createElement(
                'div',
                {
                  className: classNames.weekNumber,
                  tabIndex: 0,
                  role: 'gridcell',
                  onClick: function onClick(e) {
                    return onWeekClick(weekNumber, week, e);
                  }
                },
                weekNumber
              ),
              week.map(_this2.renderDay)
            );
          })
        ),
        footer && _react2.default.createElement(
          'div',
          { className: classNames.footer },
          footer
        )
      );
    }
  }]);

  return Month;
}(_react.Component);

exports.default = Month;
Month.propTypes =  false ? {
  classNames: _propTypes2.default.shape({
    body: _propTypes2.default.string.isRequired,
    month: _propTypes2.default.string.isRequired,
    outside: _propTypes2.default.string.isRequired,
    today: _propTypes2.default.string.isRequired,
    week: _propTypes2.default.string.isRequired
  }).isRequired,
  tabIndex: _propTypes2.default.number,

  month: _propTypes2.default.instanceOf(Date).isRequired,
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),

  modifiersStyles: _propTypes2.default.object,

  enableOutsideDays: _propTypes2.default.bool,

  renderDay: _propTypes2.default.func.isRequired,

  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)]).isRequired,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)]),

  footer: _propTypes2.default.node,
  fixedWeeks: _propTypes2.default.bool,
  showWeekNumbers: _propTypes2.default.bool,

  locale: _propTypes2.default.string.isRequired,
  localeUtils: _propTypes2.default.object.isRequired,
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
  firstDayOfWeek: _propTypes2.default.number.isRequired,

  onCaptionClick: _propTypes2.default.func,
  onDayClick: _propTypes2.default.func,
  onDayFocus: _propTypes2.default.func,
  onDayKeyDown: _propTypes2.default.func,
  onDayMouseEnter: _propTypes2.default.func,
  onDayMouseLeave: _propTypes2.default.func,
  onDayMouseDown: _propTypes2.default.func,
  onDayMouseUp: _propTypes2.default.func,
  onDayTouchEnd: _propTypes2.default.func,
  onDayTouchStart: _propTypes2.default.func,
  onWeekClick: _propTypes2.default.func
} : {};
//# sourceMappingURL=Month.js.map

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(24);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Weekdays = function (_Component) {
  _inherits(Weekdays, _Component);

  function Weekdays() {
    _classCallCheck(this, Weekdays);

    return _possibleConstructorReturn(this, (Weekdays.__proto__ || Object.getPrototypeOf(Weekdays)).apply(this, arguments));
  }

  _createClass(Weekdays, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props !== nextProps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          firstDayOfWeek = _props.firstDayOfWeek,
          showWeekNumbers = _props.showWeekNumbers,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          weekdayElement = _props.weekdayElement;

      var days = [];
      for (var i = 0; i < 7; i += 1) {
        var weekday = (i + firstDayOfWeek) % 7;
        var elementProps = {
          key: i,
          className: classNames.weekday,
          weekday: weekday,
          weekdaysLong: weekdaysLong,
          weekdaysShort: weekdaysShort,
          localeUtils: localeUtils,
          locale: locale
        };
        var element = _react2.default.isValidElement(weekdayElement) ? _react2.default.cloneElement(weekdayElement, elementProps) : _react2.default.createElement(weekdayElement, elementProps);
        days.push(element);
      }

      return _react2.default.createElement(
        'div',
        { className: classNames.weekdays, role: 'rowgroup' },
        _react2.default.createElement(
          'div',
          { className: classNames.weekdaysRow, role: 'row' },
          showWeekNumbers && _react2.default.createElement('div', { className: classNames.weekday }),
          days
        )
      );
    }
  }]);

  return Weekdays;
}(_react.Component);

exports.default = Weekdays;
Weekdays.propTypes =  false ? {
  classNames: _propTypes2.default.shape({
    weekday: _propTypes2.default.string.isRequired,
    weekdays: _propTypes2.default.string.isRequired,
    weekdaysRow: _propTypes2.default.string.isRequired
  }).isRequired,

  firstDayOfWeek: _propTypes2.default.number.isRequired,
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
  showWeekNumbers: _propTypes2.default.bool,
  locale: _propTypes2.default.string.isRequired,
  localeUtils: _propTypes2.default.object.isRequired,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)])
} : {};
//# sourceMappingURL=Weekdays.js.map

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(8);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _propTypes = __webpack_require__(24);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DateUtils = __webpack_require__(101);

var _Helpers = __webpack_require__(147);

var _classNames = __webpack_require__(146);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/no-static-element-interactions, react/forbid-prop-types */

function handleEvent(handler, day, modifiers) {
  if (!handler) {
    return undefined;
  }
  return function (e) {
    e.persist();
    handler(day, modifiers, e);
  };
}

var Day = function (_Component) {
  _inherits(Day, _Component);

  function Day() {
    _classCallCheck(this, Day);

    return _possibleConstructorReturn(this, (Day.__proto__ || Object.getPrototypeOf(Day)).apply(this, arguments));
  }

  _createClass(Day, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var _this2 = this;

      var propNames = Object.keys(this.props);
      var nextPropNames = Object.keys(nextProps);
      if (propNames.length !== nextPropNames.length) {
        return true;
      }
      return propNames.some(function (name) {
        if (name === 'modifiers' || name === 'modifiersStyles' || name === 'classNames') {
          var prop = _this2.props[name];
          var nextProp = nextProps[name];
          var modifiers = Object.keys(prop);
          var nextModifiers = Object.keys(nextProp);
          if (modifiers.length !== nextModifiers.length) {
            return true;
          }
          return modifiers.some(function (mod) {
            return !(0, _Helpers.hasOwnProp)(nextProp, mod) || prop[mod] !== nextProp[mod];
          });
        }
        if (name === 'day') {
          return !(0, _DateUtils.isSameDay)(_this2.props[name], nextProps[name]);
        }
        return !(0, _Helpers.hasOwnProp)(nextProps, name) || _this2.props[name] !== nextProps[name];
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          modifiersStyles = _props.modifiersStyles,
          day = _props.day,
          tabIndex = _props.tabIndex,
          empty = _props.empty,
          modifiers = _props.modifiers,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          onMouseUp = _props.onMouseUp,
          onMouseDown = _props.onMouseDown,
          onClick = _props.onClick,
          onKeyDown = _props.onKeyDown,
          onTouchStart = _props.onTouchStart,
          onTouchEnd = _props.onTouchEnd,
          onFocus = _props.onFocus,
          ariaLabel = _props.ariaLabel,
          ariaDisabled = _props.ariaDisabled,
          ariaSelected = _props.ariaSelected,
          children = _props.children;


      var className = classNames.day;
      if (classNames !== _classNames2.default) {
        // When using CSS modules prefix the modifier as required by the BEM syntax
        className += ' ' + Object.keys(modifiers).join(' ');
      } else {
        className += Object.keys(modifiers).map(function (modifier) {
          return ' ' + className + '--' + modifier;
        }).join('');
      }

      var style = void 0;
      if (modifiersStyles) {
        Object.keys(modifiers).filter(function (modifier) {
          return !!modifiersStyles[modifier];
        }).forEach(function (modifier) {
          style = (0, _objectAssign2.default)({}, style, modifiersStyles[modifier]);
        });
      }

      if (empty) {
        return _react2.default.createElement('div', { 'aria-disabled': true, className: className, style: style });
      }
      return _react2.default.createElement(
        'div',
        {
          className: className,
          tabIndex: tabIndex,
          style: style,
          role: 'gridcell',
          'aria-label': ariaLabel,
          'aria-disabled': ariaDisabled,
          'aria-selected': ariaSelected,
          onClick: handleEvent(onClick, day, modifiers),
          onKeyDown: handleEvent(onKeyDown, day, modifiers),
          onMouseEnter: handleEvent(onMouseEnter, day, modifiers),
          onMouseLeave: handleEvent(onMouseLeave, day, modifiers),
          onMouseUp: handleEvent(onMouseUp, day, modifiers),
          onMouseDown: handleEvent(onMouseDown, day, modifiers),
          onTouchEnd: handleEvent(onTouchEnd, day, modifiers),
          onTouchStart: handleEvent(onTouchStart, day, modifiers),
          onFocus: handleEvent(onFocus, day, modifiers)
        },
        children
      );
    }
  }]);

  return Day;
}(_react.Component);

Day.defaultProps = {
  tabIndex: -1
};
Day.defaultProps = {
  modifiers: {},
  modifiersStyles: {},
  empty: false
};
exports.default = Day;
Day.propTypes =  false ? {
  classNames: _propTypes2.default.shape({
    day: _propTypes2.default.string.isRequired
  }).isRequired,

  day: _propTypes2.default.instanceOf(Date).isRequired,
  children: _propTypes2.default.node.isRequired,

  ariaDisabled: _propTypes2.default.bool,
  ariaLabel: _propTypes2.default.string,
  ariaSelected: _propTypes2.default.bool,
  empty: _propTypes2.default.bool,
  modifiers: _propTypes2.default.object,
  modifiersStyles: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onMouseDown: _propTypes2.default.func,
  onMouseUp: _propTypes2.default.func,
  onTouchEnd: _propTypes2.default.func,
  onTouchStart: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  tabIndex: _propTypes2.default.number
} : {};
//# sourceMappingURL=Day.js.map

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModifierPropType = undefined;

var _propTypes = __webpack_require__(24);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrimitiveTypes = {
  localeUtils: _propTypes2.default.shape({
    formatMonthTitle: _propTypes2.default.func,
    formatWeekdayShort: _propTypes2.default.func,
    formatWeekdayLong: _propTypes2.default.func,
    getFirstDayOfWeek: _propTypes2.default.func
  }),
  range: _propTypes2.default.shape({
    from: _propTypes2.default.instanceOf(Date),
    to: _propTypes2.default.instanceOf(Date)
  }),
  after: _propTypes2.default.shape({
    after: _propTypes2.default.instanceOf(Date)
  }),
  before: _propTypes2.default.shape({
    before: _propTypes2.default.instanceOf(Date)
  })
};

var ModifierPropType = exports.ModifierPropType = _propTypes2.default.oneOfType([PrimitiveTypes.after, PrimitiveTypes.before, PrimitiveTypes.range, _propTypes2.default.func, _propTypes2.default.array]);

exports.default = PrimitiveTypes;
//# sourceMappingURL=PropTypes.js.map

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _uuid = __webpack_require__(26);

var _uuid2 = _interopRequireDefault(_uuid);

var _DragAndDropContent = __webpack_require__(314);

var _DragAndDropContent2 = _interopRequireDefault(_DragAndDropContent);

var _DragAndDropTarget = __webpack_require__(339);

var _DragAndDropTarget2 = _interopRequireDefault(_DragAndDropTarget);

var _DragAndDropSource = __webpack_require__(340);

var _DragAndDropSource2 = _interopRequireDefault(_DragAndDropSource);

var _FormattedContent = __webpack_require__(15);

var _FormattedContent2 = _interopRequireDefault(_FormattedContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var height = 20;

var EditCell = function (_React$Component) {
  _inherits(EditCell, _React$Component);

  function EditCell(props) {
    _classCallCheck(this, EditCell);

    var _this = _possibleConstructorReturn(this, (EditCell.__proto__ || Object.getPrototypeOf(EditCell)).call(this, props));

    _this.state = { value: _this.props.sample ? "" : _this.props.value,
      height: height * _this.props.height };
    return _this;
  }

  _createClass(EditCell, [{
    key: 'onChange',
    value: function onChange(event) {
      this.setState({ value: event.target.value });
      if (this.props.onUpdate !== undefined) {
        this.props.onUpdate({ preventDefault: event.preventDefault, target: { name: this.props.name, value: event.target.value } });
      }
      this.calculateSize();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.calculateSize();
    }
  }, {
    key: 'calculateSize',
    value: function calculateSize() {
      this._textarea.style.height = 'auto';
      if (this._textarea.scrollHeight > height * this.props.height) {
        this._textarea.style.height = this._textarea.scrollHeight + 2 + 'px';
      } else {
        this._textarea.style.height = height * this.props.height + 'px';
      }
    }
  }, {
    key: 'expand',
    value: function expand(event) {
      this.calculateSize();
      if (this.props.onChange !== undefined) {
        this.props.onChange(event);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('textarea', { autoFocus: true,
            ref: function ref(_ref) {
              return _this2._textarea = _ref;
            },
            onChange: this.onChange.bind(this),
            style: { width: "100%", resize: "none", minHeight: 15, fontFamily: "Lato, Arial, Verdana, Geneva, sans-serif", borderStyle: "none", fontSize: "12pt" },
            defaultValue: this.props.sample ? "" : this.props.value,
            placeholder: this.props.sample ? this.props.value : "" })
        )
      );
    }
  }]);

  return EditCell;
}(_react2.default.Component);

var DisplayValue = function (_React$Component2) {
  _inherits(DisplayValue, _React$Component2);

  function DisplayValue() {
    _classCallCheck(this, DisplayValue);

    return _possibleConstructorReturn(this, (DisplayValue.__proto__ || Object.getPrototypeOf(DisplayValue)).apply(this, arguments));
  }

  _createClass(DisplayValue, [{
    key: 'render',
    value: function render() {
      var languageLabels = {
        norwegian: {
          empty: "(tom linje)"
        },
        english: {
          empty: "(empty line)"
        }
      };
      var labels = languageLabels[this.props.language] || languageLabels["english"];
      var style = this.props.type === "date" ? { whiteSpace: "nowrap" } : {};
      switch (this.props.displayAs) {
        case "_disabled":
          style = Object.assign({}, style, { color: "#D5D5D5", fontStyle: "italic" });
          break;
        case "_highlight":
          style = Object.assign({}, style, { color: "black", fontWeight: "bold" });
          break;
        case "_normal":
          style = Object.assign({}, style, { color: "#757575" });
          break;

        default:
          if (this.props.sample !== undefined) {
            style = { color: "#757575" };
          }
      }
      return this.props.priority ? _react2.default.createElement(
        'div',
        { style: Object.assign({}, style, { textAlign: "center", verticalAlign: "top" }) },
        this.props.pri
      ) : _react2.default.createElement(
        'div',
        { style: style },
        this.props.editable && this.props.sample !== true ? _react2.default.createElement(
          'div',
          { style: { float: "right", cursor: "pointer" } },
          _react2.default.createElement('img', { src: '/icons/pen_grey_tran.png' })
        ) : null,
        this.props.format !== undefined ? this.props.format(this.props.value, this.props.name, this.props) : this.props.value !== undefined && this.props.value !== null && this.props.value.length > 0 ? _react2.default.createElement(_FormattedContent2.default, { value: this.props.value }) : this.props.includeEmptyLine ? _react2.default.createElement(
          'i',
          null,
          labels.empty
        ) : undefined
      );
    }
  }]);

  return DisplayValue;
}(_react2.default.Component);

var DisplayCell = function (_React$Component3) {
  _inherits(DisplayCell, _React$Component3);

  function DisplayCell(props) {
    _classCallCheck(this, DisplayCell);

    var _this4 = _possibleConstructorReturn(this, (DisplayCell.__proto__ || Object.getPrototypeOf(DisplayCell)).call(this, props));

    _this4.state = {
      edit: false,
      value: _this4.props.value
    };
    return _this4;
  }

  _createClass(DisplayCell, [{
    key: 'render',
    value: function render() {
      return this.props.dragable && this.props.sample === undefined ? _react2.default.createElement(
        _DragAndDropTarget2.default,
        { position: this.props.pri - 1 },
        _react2.default.createElement(
          _DragAndDropSource2.default,
          { prioritize: this.props.prioritize, id: this.props.id },
          _react2.default.createElement(DisplayValue, this.props)
        )
      ) : _react2.default.createElement(DisplayValue, this.props);
    }
  }]);

  return DisplayCell;
}(_react2.default.Component);

var TableCell = function (_React$Component4) {
  _inherits(TableCell, _React$Component4);

  function TableCell(props) {
    _classCallCheck(this, TableCell);

    var _this5 = _possibleConstructorReturn(this, (TableCell.__proto__ || Object.getPrototypeOf(TableCell)).call(this, props));

    _this5.state = { edit: false };
    return _this5;
  }

  _createClass(TableCell, [{
    key: 'edit',
    value: function edit(event) {
      if (this.props.entryEditable) {
        this.props.onEditEntry();
      } else {
        this.setState({ edit: !this.state.edit });
      }
    }
  }, {
    key: 'update',
    value: function update(event) {
      if (this.props.onUpdate !== undefined) {
        this.props.onUpdate(event);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var cursor = this.props.dragable && this.props.sample !== true && !this.props.entryEditable ? "normal" : this.props.editable && !this.state.edit ? "text" : this.props.entryEditable ? "pointer" : "normal";
      var useSummaryRow = this.props.options !== undefined ? this.props.options.summaryRow : undefined;
      var borderColor = "#d9d9d9";
      var cellColor = this.props.lastRow && !this.props.editable && useSummaryRow !== undefined || !this.props.editable && !this.props.entryEditable ? "#f0f0f0" : "#ffffff";
      return _react2.default.createElement(
        'div',
        { onClick: this.props.editable && !this.state.edit || this.props.entryEditable ? this.edit.bind(this) : undefined,
          style: { backgroundColor: cellColor, verticalAlign: "top", display: "table-cell", cursor: cursor, padding: 5, height: 20, borderRight: this.props.last ? undefined : "solid 1px " + borderColor, borderTop: "solid 1px #d9d9d9", borderRadius: this.props.lastRow && this.props.first && this.props.last ? "0 0 5px 5px" : this.props.lastRow && this.props.last ? "0 0 5px 0px" : this.props.lastRow && this.props.first ? "0 0 0 5px" : 0 } },
        (this.props.editable || this.props.entryEditable) && !this.props.forceReadOnly && this.state.edit ? _react2.default.createElement(EditCell, _extends({}, this.props, { cancel: this.edit.bind(this), onUpdate: this.update.bind(this), height: '1' })) : _react2.default.createElement(DisplayCell, this.props)
      );
    }
  }]);

  return TableCell;
}(_react2.default.Component);

var TableRow = function (_React$Component5) {
  _inherits(TableRow, _React$Component5);

  function TableRow(props) {
    _classCallCheck(this, TableRow);

    var _this6 = _possibleConstructorReturn(this, (TableRow.__proto__ || Object.getPrototypeOf(TableRow)).call(this, props));

    _this6.state = {
      value: props.value.content
    };
    return _this6;
  }

  _createClass(TableRow, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState({
        value: props.value.content
      });
    }
  }, {
    key: 'updateValue',
    value: function updateValue(event) {
      var _this7 = this;

      event.preventDefault();
      var updated = Object.assign({}, this.state.value, _defineProperty({}, event.target.name, event.target.value));
      this.setState({ value: updated }, function () {
        if (_this7.props.onChange) {
          var newItem = { id: _this7.props.value.id, content: updated };
          _this7.props.onChange(newItem);
        }
      });
    }
  }, {
    key: 'onEditEntry',
    value: function onEditEntry() {
      if (this.props.onEditEntry !== undefined) {
        this.props.onEditEntry(this.state.value);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      var useSummaryRow = this.props.options !== undefined ? this.props.options.summaryRow : undefined;
      var background = this.props.lastRow && useSummaryRow !== undefined ? "#d8d8d8" : "#ffffff";
      return _react2.default.createElement(
        'div',
        { style: { display: "table-row", backgroundColor: background } },
        this.props.columns.map(function (column, index) {
          return _react2.default.createElement(TableCell, _extends({
            key: index
          }, _this8.props, column, {
            index: index,
            first: index === 0,
            last: index + 1 === _this8.props.columns.length,
            id: _this8.props.value.id,
            name: column.name,
            onUpdate: _this8.updateValue.bind(_this8),
            value: _this8.state.value !== undefined ? _this8.state.value[column.name] : undefined,
            displayAs: _this8.props.value !== undefined && _this8.props.value.content !== undefined ? _this8.props.value.content._displayAs : undefined,
            format: _this8.props.value !== undefined && _this8.props.value.content !== undefined ? _this8.props.value.content._format : undefined,
            sample: _this8.props.value.sample,
            onEditEntry: _this8.props.onEditEntry !== undefined ? _this8.onEditEntry.bind(_this8) : undefined
          }));
        })
      );
    }
  }]);

  return TableRow;
}(_react2.default.Component);

var Table = function (_React$Component6) {
  _inherits(Table, _React$Component6);

  function Table(props) {
    _classCallCheck(this, Table);

    var _this9 = _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).call(this, props));

    _this9.state = { items: _this9.ensureEmptyLine(_this9.loadRows(props)),
      forceUpdate: _this9.props.forceReadOnly !== undefined ? _this9.props.forceReadOnly : false };
    return _this9;
  }

  _createClass(Table, [{
    key: 'loadRows',
    value: function loadRows(props) {
      return props.value !== undefined ? props.value.map(function (item, index) {
        return {
          id: _uuid2.default.v4(),
          content: item
        };
      }) : [];
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState({ items: this.ensureEmptyLine(this.loadRows(props)) });
    }
  }, {
    key: 'ensureEmptyLine',
    value: function ensureEmptyLine(values) {
      return this.props.includeEmptyLine ? values.concat({ id: _uuid2.default.v4(), content: undefined }) : values; //values===undefined ? [] : values;
    }
  }, {
    key: 'isEmpty',
    value: function isEmpty(values) {
      var _this10 = this;

      return values === undefined || values.length === 0 || values.filter(function (entry) {
        return _this10.containValue(entry);
      }).length === 0;
    }
  }, {
    key: 'emptyLines',
    value: function emptyLines(values) {
      var _this11 = this;

      return values.filter(function (entry) {
        return !_this11.containValue(entry);
      });
    }
  }, {
    key: 'containValue',
    value: function containValue(entry) {
      return entry.content !== undefined && Object.keys(entry.content).filter(function (field) {
        return entry.content[field] !== undefined && entry.content[field] !== null && entry.content[field].length > 0 && field !== "id";
      }).length > 0;
    }
  }, {
    key: 'prioritizeLine',
    value: function prioritizeLine(item, target) {
      var _this12 = this;

      var before = target.position > 0 ? this.state.items.slice(0, target.position).filter(function (entry) {
        return entry.id !== item.id;
      }) : [];
      var selected = this.state.items.filter(function (entry) {
        return entry.id === item.id;
      })[0];
      var after = this.state.items.slice(target.position).filter(function (entry) {
        return entry.id !== item.id;
      });
      var updatedItems = [].concat(before, selected, after);
      this.setState({ items: updatedItems });
      if (this.props.onChange !== undefined) {
        this.props.onChange({
          target: {
            name: this.props.name,
            value: updatedItems.filter(function (entry) {
              return _this12.containValue(entry);
            }).map(function (item) {
              return item.content;
            })
          },
          details: {
            action: "prioritize",
            item: selected.content.id,
            position: target.position
          }
        });
      }
      this.setState({ forceUpdate: true });
      this.forceUpdate();
      this.setState({ forceUpdate: false });
    }
  }, {
    key: 'updateLine',
    value: function updateLine(item) {
      var _this13 = this;

      var updatedItems = this.state.items.map(function (entry) {
        return entry.id === item.id ? item : entry;
      }).filter(function (entry) {
        return _this13.containValue(entry);
      });
      this.setState({ items: this.ensureEmptyLine(updatedItems) });
      if (this.props.onChange !== undefined) {
        this.props.onChange({ target: { name: this.props.name, value: updatedItems.map(function (item) {
              return item.content;
            }) } });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this14 = this;

      var headers = [];
      if (this.props.columnHeaders !== undefined) {
        this.props.columnHeaders.forEach(function (header) {
          if (_this14.props._hideColumnHeader !== undefined && _this14.props._hideColumnHeader.includes(header.name)) {
            headers = headers.concat(Object.assign({}, header, { title: "" }));
          } else {
            headers = headers.concat(header);
          }
          for (var index = 1; index < header.columns; index++) {
            headers = headers.concat(undefined);
          }
        });
      }
      return _react2.default.createElement(
        _DragAndDropContent2.default,
        null,
        _react2.default.createElement(
          'div',
          { style: { width: "100%", display: "table", marginBottom: 10, border: "solid 1px #d9d9d9", borderRadius: 0 } },
          this.props.columnHeaders !== undefined ? _react2.default.createElement(
            'div',
            { style: { display: "table-row", backgroundColor: "#7F7F7F", color: "white" } },
            this.props.columns.map(function (column, index) {
              return _react2.default.createElement(
                'div',
                { key: index, style: { display: "table-cell", fontWeight: "bold", padding: 5, borderRight: index + 1 < _this14.props.columns.length ? headers[index + 1] !== undefined ? "solid 1px white" : undefined : undefined, borderBottom: "solid 4px white", borderMargin: 4, borderRadius: _this14.props.columns.length === 1 ? "0 0 0 0" : index === 0 ? "0 0 0 0" : index + 1 === _this14.props.columns.length ? "0 0 0 0" : 0 } },
                headers[index] !== undefined ? headers[index].title !== undefined ? headers[index].title : ".(" + headers[index].name + ")" : null
              );
            })
          ) : null,
          _react2.default.createElement(
            'div',
            { style: { display: "table-row", backgroundColor: "#7F7F7F", color: "white" } },
            this.props.columns.map(function (column, index) {
              return _react2.default.createElement(
                'div',
                { key: index, style: { display: "table-cell", width: column.priority ? 40 : undefined, padding: 5, borderRight: index + 1 < _this14.props.columns.length ? "solid 1px white" : undefined, borderRadius: _this14.props.columnHeaders === undefined ? _this14.props.columns.length === 1 ? "0 0 0 0" : index === 0 ? "0 0 0 0" : index + 1 === _this14.props.columns.length ? "0 0 0 0" : 0 : undefined } },
                column.title !== undefined ? column.title : ".(" + column.name + ")"
              );
            })
          ),
          this.isEmpty(this.state.items) && this.props.samples !== undefined ? this.props.samples.map(function (item, index, items) {
            return _react2.default.createElement(TableRow, _extends({
              key: index
            }, _this14.props, {
              value: item.id !== undefined ? { id: item.id, content: item, sample: true } : _this14.state.items !== undefined && _this14.state.items.length > 0 ? { id: _this14.emptyLines(_this14.state.items)[0].id, content: item, sample: true } : { id: _uuid2.default.v4(), content: item, sample: true },
              pri: index + 1,
              onChange: _this14.updateLine.bind(_this14),
              lastRow: index + 1 === items.length
            }));
          }) : this.state.items.map(function (item, index, items) {
            return _react2.default.createElement(TableRow, _extends({
              key: index
            }, _this14.props, {
              value: item,
              pri: index + 1,
              prioritize: _this14.prioritizeLine.bind(_this14),
              onChange: _this14.updateLine.bind(_this14),
              lastRow: index + 1 === items.length,
              entryEditable: _this14.props.onEditEntry !== undefined && _this14.props.options !== undefined && _this14.props.options.edit !== undefined,
              forceReadOnly: _this14.state.forceUpdate
            }));
          })
        ),
        this.props.description !== undefined ? _react2.default.createElement(
          'div',
          { style: { fontStyle: "italic", paddingLeft: 15, paddingRight: 15 } },
          _react2.default.createElement(_FormattedContent2.default, { value: this.props.description })
        ) : null
      );
    }
  }]);

  return Table;
}(_react2.default.Component);

exports.default = Table;

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DragDropManager = __webpack_require__(685);

Object.defineProperty(exports, 'DragDropManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragDropManager).default;
  }
});

var _DragSource = __webpack_require__(751);

Object.defineProperty(exports, 'DragSource', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DragSource).default;
  }
});

var _DropTarget = __webpack_require__(752);

Object.defineProperty(exports, 'DropTarget', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DropTarget).default;
  }
});

var _createTestBackend = __webpack_require__(753);

Object.defineProperty(exports, 'createTestBackend', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createTestBackend).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _createStore = __webpack_require__(686);

var _createStore2 = _interopRequireDefault(_createStore);

var _reducers = __webpack_require__(694);

var _reducers2 = _interopRequireDefault(_reducers);

var _dragDrop = __webpack_require__(149);

var dragDropActions = _interopRequireWildcard(_dragDrop);

var _DragDropMonitor = __webpack_require__(746);

var _DragDropMonitor2 = _interopRequireDefault(_DragDropMonitor);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DragDropManager = function () {
	function DragDropManager(createBackend) {
		var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		_classCallCheck(this, DragDropManager);

		var store = (0, _createStore2.default)(_reducers2.default);
		this.context = context;
		this.store = store;
		this.monitor = new _DragDropMonitor2.default(store);
		this.registry = this.monitor.registry;
		this.backend = createBackend(this);

		store.subscribe(this.handleRefCountChange.bind(this));
	}

	_createClass(DragDropManager, [{
		key: 'handleRefCountChange',
		value: function handleRefCountChange() {
			var shouldSetUp = this.store.getState().refCount > 0;
			if (shouldSetUp && !this.isSetUp) {
				this.backend.setup();
				this.isSetUp = true;
			} else if (!shouldSetUp && this.isSetUp) {
				this.backend.teardown();
				this.isSetUp = false;
			}
		}
	}, {
		key: 'getContext',
		value: function getContext() {
			return this.context;
		}
	}, {
		key: 'getMonitor',
		value: function getMonitor() {
			return this.monitor;
		}
	}, {
		key: 'getBackend',
		value: function getBackend() {
			return this.backend;
		}
	}, {
		key: 'getRegistry',
		value: function getRegistry() {
			return this.registry;
		}
	}, {
		key: 'getActions',
		value: function getActions() {
			var manager = this;
			var dispatch = this.store.dispatch;


			function bindActionCreator(actionCreator) {
				return function () {
					for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
						args[_key] = arguments[_key];
					}

					var action = actionCreator.apply(manager, args);
					if (typeof action !== 'undefined') {
						dispatch(action);
					}
				};
			}

			return Object.keys(dragDropActions).filter(function (key) {
				return typeof dragDropActions[key] === 'function';
			}).reduce(function (boundActions, key) {
				var action = dragDropActions[key];
				boundActions[key] = bindActionCreator(action); // eslint-disable-line no-param-reassign
				return boundActions;
			}, {});
		}
	}]);

	return DragDropManager;
}();

exports.default = DragDropManager;

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ActionTypes = undefined;
exports['default'] = createStore;

var _isPlainObject = __webpack_require__(86);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _symbolObservable = __webpack_require__(691);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = exports.ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!(0, _isPlainObject2['default'])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[_symbolObservable2['default']] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
}

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(211);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 688 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(690);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 690 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(693);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["default"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(46), __webpack_require__(692)(module)))

/***/ }),
/* 692 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = reduce;

var _dragOffset = __webpack_require__(317);

var _dragOffset2 = _interopRequireDefault(_dragOffset);

var _dragOperation = __webpack_require__(695);

var _dragOperation2 = _interopRequireDefault(_dragOperation);

var _refCount = __webpack_require__(733);

var _refCount2 = _interopRequireDefault(_refCount);

var _dirtyHandlerIds = __webpack_require__(325);

var _dirtyHandlerIds2 = _interopRequireDefault(_dirtyHandlerIds);

var _stateId = __webpack_require__(745);

var _stateId2 = _interopRequireDefault(_stateId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function reduce() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var action = arguments[1];

	return {
		dirtyHandlerIds: (0, _dirtyHandlerIds2.default)(state.dirtyHandlerIds, action, state.dragOperation),
		dragOffset: (0, _dragOffset2.default)(state.dragOffset, action),
		refCount: (0, _refCount2.default)(state.refCount, action),
		dragOperation: (0, _dragOperation2.default)(state.dragOperation, action),
		stateId: (0, _stateId2.default)(state.stateId)
	};
}

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = dragOperation;

var _without = __webpack_require__(319);

var _without2 = _interopRequireDefault(_without);

var _dragDrop = __webpack_require__(149);

var _registry = __webpack_require__(155);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
	itemType: null,
	item: null,
	sourceId: null,
	targetIds: [],
	dropResult: null,
	didDrop: false,
	isSourcePublic: null
};

function dragOperation() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	var action = arguments[1];

	switch (action.type) {
		case _dragDrop.BEGIN_DRAG:
			return _extends({}, state, {
				itemType: action.itemType,
				item: action.item,
				sourceId: action.sourceId,
				isSourcePublic: action.isSourcePublic,
				dropResult: null,
				didDrop: false
			});
		case _dragDrop.PUBLISH_DRAG_SOURCE:
			return _extends({}, state, {
				isSourcePublic: true
			});
		case _dragDrop.HOVER:
			return _extends({}, state, {
				targetIds: action.targetIds
			});
		case _registry.REMOVE_TARGET:
			if (state.targetIds.indexOf(action.targetId) === -1) {
				return state;
			}
			return _extends({}, state, {
				targetIds: (0, _without2.default)(state.targetIds, action.targetId)
			});
		case _dragDrop.DROP:
			return _extends({}, state, {
				dropResult: action.dropResult,
				didDrop: true,
				targetIds: []
			});
		case _dragDrop.END_DRAG:
			return _extends({}, state, {
				itemType: null,
				item: null,
				sourceId: null,
				dropResult: null,
				didDrop: false,
				isSourcePublic: null,
				targetIds: []
			});
		default:
			return state;
	}
}

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(697),
    ListCache = __webpack_require__(708),
    Map = __webpack_require__(714);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(698),
    hashDelete = __webpack_require__(704),
    hashGet = __webpack_require__(705),
    hashHas = __webpack_require__(706),
    hashSet = __webpack_require__(707);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(150);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(322),
    isMasked = __webpack_require__(700),
    isObject = __webpack_require__(118),
    toSource = __webpack_require__(702);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(701);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(116);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 702 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 703 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 704 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(150);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(150);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(150);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(709),
    listCacheDelete = __webpack_require__(710),
    listCacheGet = __webpack_require__(711),
    listCacheHas = __webpack_require__(712),
    listCacheSet = __webpack_require__(713);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 709 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(152);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(152);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(152);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(152);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(151),
    root = __webpack_require__(116);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(153);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 716 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(153);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(153);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(153);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 720 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 721 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(723),
    baseIsNaN = __webpack_require__(724),
    strictIndexOf = __webpack_require__(725);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 723 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 724 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 725 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(727);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 727 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(729),
    shortOut = __webpack_require__(732);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(730),
    defineProperty = __webpack_require__(731),
    identity = __webpack_require__(323);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 730 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(151);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 732 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = refCount;

var _registry = __webpack_require__(155);

function refCount() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	var action = arguments[1];

	switch (action.type) {
		case _registry.ADD_SOURCE:
		case _registry.ADD_TARGET:
			return state + 1;
		case _registry.REMOVE_SOURCE:
		case _registry.REMOVE_TARGET:
			return state - 1;
		default:
			return state;
	}
}

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(735),
    baseRest = __webpack_require__(119),
    baseXor = __webpack_require__(736),
    isArrayLikeObject = __webpack_require__(154);

/**
 * Creates an array of unique values that is the
 * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
 * of the given arrays. The order of result values is determined by the order
 * they occur in the arrays.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.without
 * @example
 *
 * _.xor([2, 1], [2, 3]);
 * // => [1, 3]
 */
var xor = baseRest(function(arrays) {
  return baseXor(arrayFilter(arrays, isArrayLikeObject));
});

module.exports = xor;


/***/ }),
/* 735 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(320),
    baseFlatten = __webpack_require__(326),
    baseUniq = __webpack_require__(328);

/**
 * The base implementation of methods like `_.xor`, without support for
 * iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of values.
 */
function baseXor(arrays, iteratee, comparator) {
  var length = arrays.length;
  if (length < 2) {
    return length ? baseUniq(arrays[0]) : [];
  }
  var index = -1,
      result = Array(length);

  while (++index < length) {
    var array = arrays[index],
        othIndex = -1;

    while (++othIndex < length) {
      if (othIndex != index) {
        result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
      }
    }
  }
  return baseUniq(baseFlatten(result, 1), iteratee, comparator);
}

module.exports = baseXor;


/***/ }),
/* 737 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(211),
    isArguments = __webpack_require__(327),
    isArray = __webpack_require__(87);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(148),
    isObjectLike = __webpack_require__(117);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(741),
    noop = __webpack_require__(329),
    setToArray = __webpack_require__(330);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(151),
    root = __webpack_require__(116);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(216),
    baseIntersection = __webpack_require__(743),
    baseRest = __webpack_require__(119),
    castArrayLikeObject = __webpack_require__(744);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(212),
    arrayIncludes = __webpack_require__(214),
    arrayIncludesWith = __webpack_require__(215),
    arrayMap = __webpack_require__(216),
    baseUnary = __webpack_require__(217),
    cacheHas = __webpack_require__(218);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(154);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = stateId;
function stateId() {
	var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

	return state + 1;
}

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _invariant = __webpack_require__(37);

var _invariant2 = _interopRequireDefault(_invariant);

var _isArray = __webpack_require__(87);

var _isArray2 = _interopRequireDefault(_isArray);

var _matchesType = __webpack_require__(318);

var _matchesType2 = _interopRequireDefault(_matchesType);

var _HandlerRegistry = __webpack_require__(747);

var _HandlerRegistry2 = _interopRequireDefault(_HandlerRegistry);

var _dragOffset = __webpack_require__(317);

var _dirtyHandlerIds = __webpack_require__(325);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DragDropMonitor = function () {
	function DragDropMonitor(store) {
		_classCallCheck(this, DragDropMonitor);

		this.store = store;
		this.registry = new _HandlerRegistry2.default(store);
	}

	_createClass(DragDropMonitor, [{
		key: 'subscribeToStateChange',
		value: function subscribeToStateChange(listener) {
			var _this = this;

			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
			var handlerIds = options.handlerIds;

			(0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');
			(0, _invariant2.default)(typeof handlerIds === 'undefined' || (0, _isArray2.default)(handlerIds), 'handlerIds, when specified, must be an array of strings.');

			var prevStateId = this.store.getState().stateId;
			var handleChange = function handleChange() {
				var state = _this.store.getState();
				var currentStateId = state.stateId;
				try {
					var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, _dirtyHandlerIds.areDirty)(state.dirtyHandlerIds, handlerIds);

					if (!canSkipListener) {
						listener();
					}
				} finally {
					prevStateId = currentStateId;
				}
			};

			return this.store.subscribe(handleChange);
		}
	}, {
		key: 'subscribeToOffsetChange',
		value: function subscribeToOffsetChange(listener) {
			var _this2 = this;

			(0, _invariant2.default)(typeof listener === 'function', 'listener must be a function.');

			var previousState = this.store.getState().dragOffset;
			var handleChange = function handleChange() {
				var nextState = _this2.store.getState().dragOffset;
				if (nextState === previousState) {
					return;
				}

				previousState = nextState;
				listener();
			};

			return this.store.subscribe(handleChange);
		}
	}, {
		key: 'canDragSource',
		value: function canDragSource(sourceId) {
			var source = this.registry.getSource(sourceId);
			(0, _invariant2.default)(source, 'Expected to find a valid source.');

			if (this.isDragging()) {
				return false;
			}

			return source.canDrag(this, sourceId);
		}
	}, {
		key: 'canDropOnTarget',
		value: function canDropOnTarget(targetId) {
			var target = this.registry.getTarget(targetId);
			(0, _invariant2.default)(target, 'Expected to find a valid target.');

			if (!this.isDragging() || this.didDrop()) {
				return false;
			}

			var targetType = this.registry.getTargetType(targetId);
			var draggedItemType = this.getItemType();
			return (0, _matchesType2.default)(targetType, draggedItemType) && target.canDrop(this, targetId);
		}
	}, {
		key: 'isDragging',
		value: function isDragging() {
			return Boolean(this.getItemType());
		}
	}, {
		key: 'isDraggingSource',
		value: function isDraggingSource(sourceId) {
			var source = this.registry.getSource(sourceId, true);
			(0, _invariant2.default)(source, 'Expected to find a valid source.');

			if (!this.isDragging() || !this.isSourcePublic()) {
				return false;
			}

			var sourceType = this.registry.getSourceType(sourceId);
			var draggedItemType = this.getItemType();
			if (sourceType !== draggedItemType) {
				return false;
			}

			return source.isDragging(this, sourceId);
		}
	}, {
		key: 'isOverTarget',
		value: function isOverTarget(targetId) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { shallow: false };
			var shallow = options.shallow;

			if (!this.isDragging()) {
				return false;
			}

			var targetType = this.registry.getTargetType(targetId);
			var draggedItemType = this.getItemType();
			if (!(0, _matchesType2.default)(targetType, draggedItemType)) {
				return false;
			}

			var targetIds = this.getTargetIds();
			if (!targetIds.length) {
				return false;
			}

			var index = targetIds.indexOf(targetId);
			if (shallow) {
				return index === targetIds.length - 1;
			} else {
				return index > -1;
			}
		}
	}, {
		key: 'getItemType',
		value: function getItemType() {
			return this.store.getState().dragOperation.itemType;
		}
	}, {
		key: 'getItem',
		value: function getItem() {
			return this.store.getState().dragOperation.item;
		}
	}, {
		key: 'getSourceId',
		value: function getSourceId() {
			return this.store.getState().dragOperation.sourceId;
		}
	}, {
		key: 'getTargetIds',
		value: function getTargetIds() {
			return this.store.getState().dragOperation.targetIds;
		}
	}, {
		key: 'getDropResult',
		value: function getDropResult() {
			return this.store.getState().dragOperation.dropResult;
		}
	}, {
		key: 'didDrop',
		value: function didDrop() {
			return this.store.getState().dragOperation.didDrop;
		}
	}, {
		key: 'isSourcePublic',
		value: function isSourcePublic() {
			return this.store.getState().dragOperation.isSourcePublic;
		}
	}, {
		key: 'getInitialClientOffset',
		value: function getInitialClientOffset() {
			return this.store.getState().dragOffset.initialClientOffset;
		}
	}, {
		key: 'getInitialSourceClientOffset',
		value: function getInitialSourceClientOffset() {
			return this.store.getState().dragOffset.initialSourceClientOffset;
		}
	}, {
		key: 'getClientOffset',
		value: function getClientOffset() {
			return this.store.getState().dragOffset.clientOffset;
		}
	}, {
		key: 'getSourceClientOffset',
		value: function getSourceClientOffset() {
			return (0, _dragOffset.getSourceClientOffset)(this.store.getState().dragOffset);
		}
	}, {
		key: 'getDifferenceFromInitialOffset',
		value: function getDifferenceFromInitialOffset() {
			return (0, _dragOffset.getDifferenceFromInitialOffset)(this.store.getState().dragOffset);
		}
	}]);

	return DragDropMonitor;
}();

exports.default = DragDropMonitor;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _invariant = __webpack_require__(37);

var _invariant2 = _interopRequireDefault(_invariant);

var _isArray = __webpack_require__(87);

var _isArray2 = _interopRequireDefault(_isArray);

var _asap = __webpack_require__(748);

var _asap2 = _interopRequireDefault(_asap);

var _registry = __webpack_require__(155);

var _getNextUniqueId = __webpack_require__(750);

var _getNextUniqueId2 = _interopRequireDefault(_getNextUniqueId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HandlerRoles = {
	SOURCE: 'SOURCE',
	TARGET: 'TARGET'
};

function validateSourceContract(source) {
	(0, _invariant2.default)(typeof source.canDrag === 'function', 'Expected canDrag to be a function.');
	(0, _invariant2.default)(typeof source.beginDrag === 'function', 'Expected beginDrag to be a function.');
	(0, _invariant2.default)(typeof source.endDrag === 'function', 'Expected endDrag to be a function.');
}

function validateTargetContract(target) {
	(0, _invariant2.default)(typeof target.canDrop === 'function', 'Expected canDrop to be a function.');
	(0, _invariant2.default)(typeof target.hover === 'function', 'Expected hover to be a function.');
	(0, _invariant2.default)(typeof target.drop === 'function', 'Expected beginDrag to be a function.');
}

function validateType(type, allowArray) {
	if (allowArray && (0, _isArray2.default)(type)) {
		type.forEach(function (t) {
			return validateType(t, false);
		});
		return;
	}

	(0, _invariant2.default)(typeof type === 'string' || (typeof type === 'undefined' ? 'undefined' : _typeof(type)) === 'symbol', allowArray ? 'Type can only be a string, a symbol, or an array of either.' : 'Type can only be a string or a symbol.');
}

function getNextHandlerId(role) {
	var id = (0, _getNextUniqueId2.default)().toString();
	switch (role) {
		case HandlerRoles.SOURCE:
			return 'S' + id;
		case HandlerRoles.TARGET:
			return 'T' + id;
		default:
			(0, _invariant2.default)(false, 'Unknown role: ' + role);
	}
}

function parseRoleFromHandlerId(handlerId) {
	switch (handlerId[0]) {
		case 'S':
			return HandlerRoles.SOURCE;
		case 'T':
			return HandlerRoles.TARGET;
		default:
			(0, _invariant2.default)(false, 'Cannot parse handler ID: ' + handlerId);
	}
}

var HandlerRegistry = function () {
	function HandlerRegistry(store) {
		_classCallCheck(this, HandlerRegistry);

		this.store = store;

		this.types = {};
		this.handlers = {};

		this.pinnedSourceId = null;
		this.pinnedSource = null;
	}

	_createClass(HandlerRegistry, [{
		key: 'addSource',
		value: function addSource(type, source) {
			validateType(type);
			validateSourceContract(source);

			var sourceId = this.addHandler(HandlerRoles.SOURCE, type, source);
			this.store.dispatch((0, _registry.addSource)(sourceId));
			return sourceId;
		}
	}, {
		key: 'addTarget',
		value: function addTarget(type, target) {
			validateType(type, true);
			validateTargetContract(target);

			var targetId = this.addHandler(HandlerRoles.TARGET, type, target);
			this.store.dispatch((0, _registry.addTarget)(targetId));
			return targetId;
		}
	}, {
		key: 'addHandler',
		value: function addHandler(role, type, handler) {
			var id = getNextHandlerId(role);
			this.types[id] = type;
			this.handlers[id] = handler;

			return id;
		}
	}, {
		key: 'containsHandler',
		value: function containsHandler(handler) {
			var _this = this;

			return Object.keys(this.handlers).some(function (key) {
				return _this.handlers[key] === handler;
			});
		}
	}, {
		key: 'getSource',
		value: function getSource(sourceId, includePinned) {
			(0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');

			var isPinned = includePinned && sourceId === this.pinnedSourceId;
			var source = isPinned ? this.pinnedSource : this.handlers[sourceId];

			return source;
		}
	}, {
		key: 'getTarget',
		value: function getTarget(targetId) {
			(0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
			return this.handlers[targetId];
		}
	}, {
		key: 'getSourceType',
		value: function getSourceType(sourceId) {
			(0, _invariant2.default)(this.isSourceId(sourceId), 'Expected a valid source ID.');
			return this.types[sourceId];
		}
	}, {
		key: 'getTargetType',
		value: function getTargetType(targetId) {
			(0, _invariant2.default)(this.isTargetId(targetId), 'Expected a valid target ID.');
			return this.types[targetId];
		}
	}, {
		key: 'isSourceId',
		value: function isSourceId(handlerId) {
			var role = parseRoleFromHandlerId(handlerId);
			return role === HandlerRoles.SOURCE;
		}
	}, {
		key: 'isTargetId',
		value: function isTargetId(handlerId) {
			var role = parseRoleFromHandlerId(handlerId);
			return role === HandlerRoles.TARGET;
		}
	}, {
		key: 'removeSource',
		value: function removeSource(sourceId) {
			var _this2 = this;

			(0, _invariant2.default)(this.getSource(sourceId), 'Expected an existing source.');
			this.store.dispatch((0, _registry.removeSource)(sourceId));

			(0, _asap2.default)(function () {
				delete _this2.handlers[sourceId];
				delete _this2.types[sourceId];
			});
		}
	}, {
		key: 'removeTarget',
		value: function removeTarget(targetId) {
			var _this3 = this;

			(0, _invariant2.default)(this.getTarget(targetId), 'Expected an existing target.');
			this.store.dispatch((0, _registry.removeTarget)(targetId));

			(0, _asap2.default)(function () {
				delete _this3.handlers[targetId];
				delete _this3.types[targetId];
			});
		}
	}, {
		key: 'pinSource',
		value: function pinSource(sourceId) {
			var source = this.getSource(sourceId);
			(0, _invariant2.default)(source, 'Expected an existing source.');

			this.pinnedSourceId = sourceId;
			this.pinnedSource = source;
		}
	}, {
		key: 'unpinSource',
		value: function unpinSource() {
			(0, _invariant2.default)(this.pinnedSource, 'No source is pinned at the time.');

			this.pinnedSourceId = null;
			this.pinnedSource = null;
		}
	}]);

	return HandlerRegistry;
}();

exports.default = HandlerRegistry;

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// rawAsap provides everything we need except exception management.
var rawAsap = __webpack_require__(749);
// RawTasks are recycled to reduce GC churn.
var freeTasks = [];
// We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.
var pendingErrors = [];
var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
    if (pendingErrors.length) {
        throw pendingErrors.shift();
    }
}

/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */
module.exports = asap;
function asap(task) {
    var rawTask;
    if (freeTasks.length) {
        rawTask = freeTasks.pop();
    } else {
        rawTask = new RawTask();
    }
    rawTask.task = task;
    rawAsap(rawTask);
}

// We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.
function RawTask() {
    this.task = null;
}

// The sole purpose of wrapping the task is to catch the exception and recycle
// the task object after its single use.
RawTask.prototype.call = function () {
    try {
        this.task.call();
    } catch (error) {
        if (asap.onerror) {
            // This hook exists purely for testing purposes.
            // Its name will be periodically randomized to break any code that
            // depends on its existence.
            asap.onerror(error);
        } else {
            // In a web browser, exceptions are not fatal. However, to avoid
            // slowing down the queue of pending tasks, we rethrow the error in a
            // lower priority turn.
            pendingErrors.push(error);
            requestErrorThrow();
        }
    } finally {
        this.task = null;
        freeTasks[freeTasks.length] = this;
    }
};


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = getNextUniqueId;
var nextUniqueId = 0;

function getNextUniqueId() {
	return nextUniqueId++;
}

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DragSource = function () {
	function DragSource() {
		_classCallCheck(this, DragSource);
	}

	_createClass(DragSource, [{
		key: "canDrag",
		value: function canDrag() {
			return true;
		}
	}, {
		key: "isDragging",
		value: function isDragging(monitor, handle) {
			return handle === monitor.getSourceId();
		}
	}, {
		key: "endDrag",
		value: function endDrag() {}
	}]);

	return DragSource;
}();

exports.default = DragSource;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DropTarget = function () {
	function DropTarget() {
		_classCallCheck(this, DropTarget);
	}

	_createClass(DropTarget, [{
		key: "canDrop",
		value: function canDrop() {
			return true;
		}
	}, {
		key: "hover",
		value: function hover() {}
	}, {
		key: "drop",
		value: function drop() {}
	}]);

	return DropTarget;
}();

exports.default = DropTarget;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createBackend;

var _noop = __webpack_require__(329);

var _noop2 = _interopRequireDefault(_noop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TestBackend = function () {
	function TestBackend(manager) {
		_classCallCheck(this, TestBackend);

		this.actions = manager.getActions();
	}

	_createClass(TestBackend, [{
		key: 'setup',
		value: function setup() {
			this.didCallSetup = true;
		}
	}, {
		key: 'teardown',
		value: function teardown() {
			this.didCallTeardown = true;
		}
	}, {
		key: 'connectDragSource',
		value: function connectDragSource() {
			return _noop2.default;
		}
	}, {
		key: 'connectDragPreview',
		value: function connectDragPreview() {
			return _noop2.default;
		}
	}, {
		key: 'connectDropTarget',
		value: function connectDropTarget() {
			return _noop2.default;
		}
	}, {
		key: 'simulateBeginDrag',
		value: function simulateBeginDrag(sourceIds, options) {
			this.actions.beginDrag(sourceIds, options);
		}
	}, {
		key: 'simulatePublishDragSource',
		value: function simulatePublishDragSource() {
			this.actions.publishDragSource();
		}
	}, {
		key: 'simulateHover',
		value: function simulateHover(targetIds, options) {
			this.actions.hover(targetIds, options);
		}
	}, {
		key: 'simulateDrop',
		value: function simulateDrop() {
			this.actions.drop();
		}
	}, {
		key: 'simulateEndDrag',
		value: function simulateEndDrag() {
			this.actions.endDrag();
		}
	}]);

	return TestBackend;
}();

function createBackend(manager) {
	return new TestBackend(manager);
}

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__(1);

var _propTypes = __webpack_require__(24);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DragDropContext = __webpack_require__(315);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * This class is a React-Component based version of the DragDropContext.
 * This is an alternative to decorating an application component with an ES7 decorator.
 */
var DragDropContextProvider = (_temp = _class = function (_Component) {
	_inherits(DragDropContextProvider, _Component);

	function DragDropContextProvider(props, context) {
		_classCallCheck(this, DragDropContextProvider);

		/**
   * This property determines which window global to use for creating the DragDropManager.
   * If a window has been injected explicitly via props, that is used first. If it is available
   * as a context value, then use that, otherwise use the browser global.
   */
		var _this = _possibleConstructorReturn(this, (DragDropContextProvider.__proto__ || Object.getPrototypeOf(DragDropContextProvider)).call(this, props, context));

		var getWindow = function getWindow() {
			if (props && props.window) {
				return props.window;
			} else if (context && context.window) {
				return context.window;
			} else if (typeof window !== 'undefined') {
				return window;
			}
			return undefined;
		};

		_this.backend = (0, _DragDropContext.unpackBackendForEs5Users)(props.backend);
		_this.childContext = (0, _DragDropContext.createChildContext)(_this.backend, {
			window: getWindow()
		});
		return _this;
	}

	_createClass(DragDropContextProvider, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.backend !== this.props.backend || nextProps.window !== this.props.window) {
				throw new Error('DragDropContextProvider backend and window props must not change.');
			}
		}
	}, {
		key: 'getChildContext',
		value: function getChildContext() {
			return this.childContext;
		}
	}, {
		key: 'render',
		value: function render() {
			return _react.Children.only(this.props.children);
		}
	}]);

	return DragDropContextProvider;
}(_react.Component), _class.propTypes = {
	backend: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object]).isRequired,
	children: _propTypes2.default.element.isRequired,
	window: _propTypes2.default.object // eslint-disable-line react/forbid-prop-types
}, _class.defaultProps = {
	window: undefined
}, _class.childContextTypes = _DragDropContext.CHILD_CONTEXT_TYPES, _class.displayName = 'DragDropContextProvider', _class.contextTypes = {
	window: _propTypes2.default.object
}, _temp);
exports.default = DragDropContextProvider;

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = DragLayer;

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(24);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = __webpack_require__(220);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _isPlainObject = __webpack_require__(86);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _invariant = __webpack_require__(37);

var _invariant2 = _interopRequireDefault(_invariant);

var _shallowEqual = __webpack_require__(221);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _shallowEqualScalar = __webpack_require__(331);

var _shallowEqualScalar2 = _interopRequireDefault(_shallowEqualScalar);

var _checkDecoratorArguments = __webpack_require__(156);

var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function DragLayer(collect) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	_checkDecoratorArguments2.default.apply(undefined, ['DragLayer', 'collect[, options]'].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line prefer-rest-params
	(0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the first argument to DragLayer to be a function that collects props to inject into the component. ', 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', collect);
	(0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the second argument to DragLayer to be a plain object when specified. ' + 'Instead, received %s. Read more: http://react-dnd.github.io/react-dnd/docs-drag-layer.html', options);

	return function decorateLayer(DecoratedComponent) {
		var _class, _temp;

		var _options$arePropsEqua = options.arePropsEqual,
		    arePropsEqual = _options$arePropsEqua === undefined ? _shallowEqualScalar2.default : _options$arePropsEqua;

		var displayName = DecoratedComponent.displayName || DecoratedComponent.name || 'Component';

		var DragLayerContainer = (_temp = _class = function (_Component) {
			_inherits(DragLayerContainer, _Component);

			_createClass(DragLayerContainer, [{
				key: 'getDecoratedComponentInstance',
				value: function getDecoratedComponentInstance() {
					(0, _invariant2.default)(this.child, 'In order to access an instance of the decorated component it can not be a stateless component.');
					return this.child;
				}
			}, {
				key: 'shouldComponentUpdate',
				value: function shouldComponentUpdate(nextProps, nextState) {
					return !arePropsEqual(nextProps, this.props) || !(0, _shallowEqual2.default)(nextState, this.state);
				}
			}]);

			function DragLayerContainer(props, context) {
				_classCallCheck(this, DragLayerContainer);

				var _this = _possibleConstructorReturn(this, (DragLayerContainer.__proto__ || Object.getPrototypeOf(DragLayerContainer)).call(this, props));

				_this.handleChange = _this.handleChange.bind(_this);

				_this.manager = context.dragDropManager;
				(0, _invariant2.default)(_typeof(_this.manager) === 'object', 'Could not find the drag and drop manager in the context of %s. ' + 'Make sure to wrap the top-level component of your app with DragDropContext. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-troubleshooting.html#could-not-find-the-drag-and-drop-manager-in-the-context', displayName, displayName);

				_this.state = _this.getCurrentState();
				return _this;
			}

			_createClass(DragLayerContainer, [{
				key: 'componentDidMount',
				value: function componentDidMount() {
					this.isCurrentlyMounted = true;

					var monitor = this.manager.getMonitor();
					this.unsubscribeFromOffsetChange = monitor.subscribeToOffsetChange(this.handleChange);
					this.unsubscribeFromStateChange = monitor.subscribeToStateChange(this.handleChange);

					this.handleChange();
				}
			}, {
				key: 'componentWillUnmount',
				value: function componentWillUnmount() {
					this.isCurrentlyMounted = false;

					this.unsubscribeFromOffsetChange();
					this.unsubscribeFromStateChange();
				}
			}, {
				key: 'handleChange',
				value: function handleChange() {
					if (!this.isCurrentlyMounted) {
						return;
					}

					var nextState = this.getCurrentState();
					if (!(0, _shallowEqual2.default)(nextState, this.state)) {
						this.setState(nextState);
					}
				}
			}, {
				key: 'getCurrentState',
				value: function getCurrentState() {
					var monitor = this.manager.getMonitor();
					return collect(monitor, this.props);
				}
			}, {
				key: 'render',
				value: function render() {
					var _this2 = this;

					return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, this.state, {
						ref: function ref(child) {
							_this2.child = child;
						}
					}));
				}
			}]);

			return DragLayerContainer;
		}(_react.Component), _class.DecoratedComponent = DecoratedComponent, _class.displayName = 'DragLayer(' + displayName + ')', _class.contextTypes = {
			dragDropManager: _propTypes2.default.object.isRequired
		}, _temp);


		return (0, _hoistNonReactStatics2.default)(DragLayerContainer, DecoratedComponent);
	};
}

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = DragSource;

var _invariant = __webpack_require__(37);

var _invariant2 = _interopRequireDefault(_invariant);

var _isPlainObject = __webpack_require__(86);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _checkDecoratorArguments = __webpack_require__(156);

var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);

var _decorateHandler = __webpack_require__(332);

var _decorateHandler2 = _interopRequireDefault(_decorateHandler);

var _registerSource = __webpack_require__(761);

var _registerSource2 = _interopRequireDefault(_registerSource);

var _createSourceFactory = __webpack_require__(762);

var _createSourceFactory2 = _interopRequireDefault(_createSourceFactory);

var _createSourceMonitor = __webpack_require__(763);

var _createSourceMonitor2 = _interopRequireDefault(_createSourceMonitor);

var _createSourceConnector = __webpack_require__(764);

var _createSourceConnector2 = _interopRequireDefault(_createSourceConnector);

var _isValidType = __webpack_require__(335);

var _isValidType2 = _interopRequireDefault(_isValidType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DragSource(type, spec, collect) {
	var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

	_checkDecoratorArguments2.default.apply(undefined, ['DragSource', 'type, spec, collect[, options]'].concat(Array.prototype.slice.call(arguments)));
	var getType = type;
	if (typeof type !== 'function') {
		(0, _invariant2.default)((0, _isValidType2.default)(type), 'Expected "type" provided as the first argument to DragSource to be ' + 'a string, or a function that returns a string given the current props. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', type);
		getType = function getType() {
			return type;
		};
	}
	(0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DragSource to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', spec);
	var createSource = (0, _createSourceFactory2.default)(spec);
	(0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DragSource to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);
	(0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DragSource to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', collect);

	return function decorateSource(DecoratedComponent) {
		return (0, _decorateHandler2.default)({
			connectBackend: function connectBackend(backend, sourceId) {
				return backend.connectDragSource(sourceId);
			},
			containerDisplayName: 'DragSource',
			createHandler: createSource,
			registerHandler: _registerSource2.default,
			createMonitor: _createSourceMonitor2.default,
			createConnector: _createSourceConnector2.default,
			DecoratedComponent: DecoratedComponent,
			getType: getType,
			collect: collect,
			options: options
		});
	};
}

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _isDisposable2 = __webpack_require__(222);

var _isDisposable3 = _interopRequireDefault(_isDisposable2);

exports.isDisposable = _isDisposable3['default'];

var _Disposable2 = __webpack_require__(758);

var _Disposable3 = _interopRequireDefault(_Disposable2);

exports.Disposable = _Disposable3['default'];

var _CompositeDisposable2 = __webpack_require__(759);

var _CompositeDisposable3 = _interopRequireDefault(_CompositeDisposable2);

exports.CompositeDisposable = _CompositeDisposable3['default'];

var _SerialDisposable2 = __webpack_require__(760);

var _SerialDisposable3 = _interopRequireDefault(_SerialDisposable2);

exports.SerialDisposable = _SerialDisposable3['default'];

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var noop = function noop() {};

/**
 * The basic disposable.
 */

var Disposable = (function () {
  _createClass(Disposable, null, [{
    key: "empty",
    value: { dispose: noop },
    enumerable: true
  }]);

  function Disposable(action) {
    _classCallCheck(this, Disposable);

    this.isDisposed = false;
    this.action = action || noop;
  }

  Disposable.prototype.dispose = function dispose() {
    if (!this.isDisposed) {
      this.action.call(null);
      this.isDisposed = true;
    }
  };

  return Disposable;
})();

exports["default"] = Disposable;
module.exports = exports["default"];

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _isDisposable = __webpack_require__(222);

var _isDisposable2 = _interopRequireDefault(_isDisposable);

/**
 * Represents a group of disposable resources that are disposed together.
 */

var CompositeDisposable = (function () {
  function CompositeDisposable() {
    for (var _len = arguments.length, disposables = Array(_len), _key = 0; _key < _len; _key++) {
      disposables[_key] = arguments[_key];
    }

    _classCallCheck(this, CompositeDisposable);

    if (Array.isArray(disposables[0]) && disposables.length === 1) {
      disposables = disposables[0];
    }

    for (var i = 0; i < disposables.length; i++) {
      if (!_isDisposable2['default'](disposables[i])) {
        throw new Error('Expected a disposable');
      }
    }

    this.disposables = disposables;
    this.isDisposed = false;
  }

  /**
   * Adds a disposable to the CompositeDisposable or disposes the disposable if the CompositeDisposable is disposed.
   * @param {Disposable} item Disposable to add.
   */

  CompositeDisposable.prototype.add = function add(item) {
    if (this.isDisposed) {
      item.dispose();
    } else {
      this.disposables.push(item);
    }
  };

  /**
   * Removes and disposes the first occurrence of a disposable from the CompositeDisposable.
   * @param {Disposable} item Disposable to remove.
   * @returns {Boolean} true if found; false otherwise.
   */

  CompositeDisposable.prototype.remove = function remove(item) {
    if (this.isDisposed) {
      return false;
    }

    var index = this.disposables.indexOf(item);
    if (index === -1) {
      return false;
    }

    this.disposables.splice(index, 1);
    item.dispose();
    return true;
  };

  /**
   * Disposes all disposables in the group and removes them from the group.
   */

  CompositeDisposable.prototype.dispose = function dispose() {
    if (this.isDisposed) {
      return;
    }

    var len = this.disposables.length;
    var currentDisposables = new Array(len);
    for (var i = 0; i < len; i++) {
      currentDisposables[i] = this.disposables[i];
    }

    this.isDisposed = true;
    this.disposables = [];
    this.length = 0;

    for (var i = 0; i < len; i++) {
      currentDisposables[i].dispose();
    }
  };

  return CompositeDisposable;
})();

exports['default'] = CompositeDisposable;
module.exports = exports['default'];

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _isDisposable = __webpack_require__(222);

var _isDisposable2 = _interopRequireDefault(_isDisposable);

var SerialDisposable = (function () {
  function SerialDisposable() {
    _classCallCheck(this, SerialDisposable);

    this.isDisposed = false;
    this.current = null;
  }

  /**
   * Gets the underlying disposable.
   * @return The underlying disposable.
   */

  SerialDisposable.prototype.getDisposable = function getDisposable() {
    return this.current;
  };

  /**
   * Sets the underlying disposable.
   * @param {Disposable} value The new underlying disposable.
   */

  SerialDisposable.prototype.setDisposable = function setDisposable() {
    var value = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];

    if (value != null && !_isDisposable2['default'](value)) {
      throw new Error('Expected either an empty value or a valid disposable');
    }

    var isDisposed = this.isDisposed;
    var previous = undefined;

    if (!isDisposed) {
      previous = this.current;
      this.current = value;
    }

    if (previous) {
      previous.dispose();
    }

    if (isDisposed && value) {
      value.dispose();
    }
  };

  /**
   * Disposes the underlying disposable as well as all future replacements.
   */

  SerialDisposable.prototype.dispose = function dispose() {
    if (this.isDisposed) {
      return;
    }

    this.isDisposed = true;
    var previous = this.current;
    this.current = null;

    if (previous) {
      previous.dispose();
    }
  };

  return SerialDisposable;
})();

exports['default'] = SerialDisposable;
module.exports = exports['default'];

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = registerSource;
function registerSource(type, source, manager) {
	var registry = manager.getRegistry();
	var sourceId = registry.addSource(type, source);

	function unregisterSource() {
		registry.removeSource(sourceId);
	}

	return {
		handlerId: sourceId,
		unregister: unregisterSource
	};
}

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createSourceFactory;

var _invariant = __webpack_require__(37);

var _invariant2 = _interopRequireDefault(_invariant);

var _isPlainObject = __webpack_require__(86);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ALLOWED_SPEC_METHODS = ['canDrag', 'beginDrag', 'isDragging', 'endDrag'];
var REQUIRED_SPEC_METHODS = ['beginDrag'];

function createSourceFactory(spec) {
	Object.keys(spec).forEach(function (key) {
		(0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drag source specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', ALLOWED_SPEC_METHODS.join(', '), key);
		(0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
	});
	REQUIRED_SPEC_METHODS.forEach(function (key) {
		(0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drag source specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', key, key, spec[key]);
	});

	var Source = function () {
		function Source(monitor) {
			_classCallCheck(this, Source);

			this.monitor = monitor;
			this.props = null;
			this.component = null;
		}

		_createClass(Source, [{
			key: 'receiveProps',
			value: function receiveProps(props) {
				this.props = props;
			}
		}, {
			key: 'receiveComponent',
			value: function receiveComponent(component) {
				this.component = component;
			}
		}, {
			key: 'canDrag',
			value: function canDrag() {
				if (!spec.canDrag) {
					return true;
				}

				return spec.canDrag(this.props, this.monitor);
			}
		}, {
			key: 'isDragging',
			value: function isDragging(globalMonitor, sourceId) {
				if (!spec.isDragging) {
					return sourceId === globalMonitor.getSourceId();
				}

				return spec.isDragging(this.props, this.monitor);
			}
		}, {
			key: 'beginDrag',
			value: function beginDrag() {
				var item = spec.beginDrag(this.props, this.monitor, this.component);
				if (false) {
					(0, _invariant2.default)((0, _isPlainObject2.default)(item), 'beginDrag() must return a plain object that represents the dragged item. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source.html', item);
				}
				return item;
			}
		}, {
			key: 'endDrag',
			value: function endDrag() {
				if (!spec.endDrag) {
					return;
				}

				spec.endDrag(this.props, this.monitor, this.component);
			}
		}]);

		return Source;
	}();

	return function createSource(monitor) {
		return new Source(monitor);
	};
}

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createSourceMonitor;

var _invariant = __webpack_require__(37);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var isCallingCanDrag = false;
var isCallingIsDragging = false;

var SourceMonitor = function () {
	function SourceMonitor(manager) {
		_classCallCheck(this, SourceMonitor);

		this.internalMonitor = manager.getMonitor();
	}

	_createClass(SourceMonitor, [{
		key: 'receiveHandlerId',
		value: function receiveHandlerId(sourceId) {
			this.sourceId = sourceId;
		}
	}, {
		key: 'canDrag',
		value: function canDrag() {
			(0, _invariant2.default)(!isCallingCanDrag, 'You may not call monitor.canDrag() inside your canDrag() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');

			try {
				isCallingCanDrag = true;
				return this.internalMonitor.canDragSource(this.sourceId);
			} finally {
				isCallingCanDrag = false;
			}
		}
	}, {
		key: 'isDragging',
		value: function isDragging() {
			(0, _invariant2.default)(!isCallingIsDragging, 'You may not call monitor.isDragging() inside your isDragging() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drag-source-monitor.html');

			try {
				isCallingIsDragging = true;
				return this.internalMonitor.isDraggingSource(this.sourceId);
			} finally {
				isCallingIsDragging = false;
			}
		}
	}, {
		key: 'getItemType',
		value: function getItemType() {
			return this.internalMonitor.getItemType();
		}
	}, {
		key: 'getItem',
		value: function getItem() {
			return this.internalMonitor.getItem();
		}
	}, {
		key: 'getDropResult',
		value: function getDropResult() {
			return this.internalMonitor.getDropResult();
		}
	}, {
		key: 'didDrop',
		value: function didDrop() {
			return this.internalMonitor.didDrop();
		}
	}, {
		key: 'getInitialClientOffset',
		value: function getInitialClientOffset() {
			return this.internalMonitor.getInitialClientOffset();
		}
	}, {
		key: 'getInitialSourceClientOffset',
		value: function getInitialSourceClientOffset() {
			return this.internalMonitor.getInitialSourceClientOffset();
		}
	}, {
		key: 'getSourceClientOffset',
		value: function getSourceClientOffset() {
			return this.internalMonitor.getSourceClientOffset();
		}
	}, {
		key: 'getClientOffset',
		value: function getClientOffset() {
			return this.internalMonitor.getClientOffset();
		}
	}, {
		key: 'getDifferenceFromInitialOffset',
		value: function getDifferenceFromInitialOffset() {
			return this.internalMonitor.getDifferenceFromInitialOffset();
		}
	}]);

	return SourceMonitor;
}();

function createSourceMonitor(manager) {
	return new SourceMonitor(manager);
}

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = createSourceConnector;

var _wrapConnectorHooks = __webpack_require__(333);

var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);

var _areOptionsEqual = __webpack_require__(334);

var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createSourceConnector(backend) {
	var currentHandlerId = void 0;

	var currentDragSourceNode = void 0;
	var currentDragSourceOptions = void 0;
	var disconnectCurrentDragSource = void 0;

	var currentDragPreviewNode = void 0;
	var currentDragPreviewOptions = void 0;
	var disconnectCurrentDragPreview = void 0;

	function reconnectDragSource() {
		if (disconnectCurrentDragSource) {
			disconnectCurrentDragSource();
			disconnectCurrentDragSource = null;
		}

		if (currentHandlerId && currentDragSourceNode) {
			disconnectCurrentDragSource = backend.connectDragSource(currentHandlerId, currentDragSourceNode, currentDragSourceOptions);
		}
	}

	function reconnectDragPreview() {
		if (disconnectCurrentDragPreview) {
			disconnectCurrentDragPreview();
			disconnectCurrentDragPreview = null;
		}

		if (currentHandlerId && currentDragPreviewNode) {
			disconnectCurrentDragPreview = backend.connectDragPreview(currentHandlerId, currentDragPreviewNode, currentDragPreviewOptions);
		}
	}

	function receiveHandlerId(handlerId) {
		if (handlerId === currentHandlerId) {
			return;
		}

		currentHandlerId = handlerId;
		reconnectDragSource();
		reconnectDragPreview();
	}

	var hooks = (0, _wrapConnectorHooks2.default)({
		dragSource: function connectDragSource(node, options) {
			if (node === currentDragSourceNode && (0, _areOptionsEqual2.default)(options, currentDragSourceOptions)) {
				return;
			}

			currentDragSourceNode = node;
			currentDragSourceOptions = options;

			reconnectDragSource();
		},

		dragPreview: function connectDragPreview(node, options) {
			if (node === currentDragPreviewNode && (0, _areOptionsEqual2.default)(options, currentDragPreviewOptions)) {
				return;
			}

			currentDragPreviewNode = node;
			currentDragPreviewOptions = options;

			reconnectDragPreview();
		}
	});

	return {
		receiveHandlerId: receiveHandlerId,
		hooks: hooks
	};
}

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = cloneWithRef;

var _invariant = __webpack_require__(37);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cloneWithRef(element, newRef) {
	var previousRef = element.ref;
	(0, _invariant2.default)(typeof previousRef !== 'string', 'Cannot connect React DnD to an element with an existing string ref. ' + 'Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. ' + 'Read more: https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute');

	if (!previousRef) {
		// When there is no ref on the element, use the new ref directly
		return (0, _react.cloneElement)(element, {
			ref: newRef
		});
	}

	return (0, _react.cloneElement)(element, {
		ref: function ref(node) {
			newRef(node);

			if (previousRef) {
				previousRef(node);
			}
		}
	});
}

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = DropTarget;

var _invariant = __webpack_require__(37);

var _invariant2 = _interopRequireDefault(_invariant);

var _isPlainObject = __webpack_require__(86);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _checkDecoratorArguments = __webpack_require__(156);

var _checkDecoratorArguments2 = _interopRequireDefault(_checkDecoratorArguments);

var _decorateHandler = __webpack_require__(332);

var _decorateHandler2 = _interopRequireDefault(_decorateHandler);

var _registerTarget = __webpack_require__(767);

var _registerTarget2 = _interopRequireDefault(_registerTarget);

var _createTargetFactory = __webpack_require__(768);

var _createTargetFactory2 = _interopRequireDefault(_createTargetFactory);

var _createTargetMonitor = __webpack_require__(769);

var _createTargetMonitor2 = _interopRequireDefault(_createTargetMonitor);

var _createTargetConnector = __webpack_require__(770);

var _createTargetConnector2 = _interopRequireDefault(_createTargetConnector);

var _isValidType = __webpack_require__(335);

var _isValidType2 = _interopRequireDefault(_isValidType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function DropTarget(type, spec, collect) {
	var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

	_checkDecoratorArguments2.default.apply(undefined, ['DropTarget', 'type, spec, collect[, options]'].concat(Array.prototype.slice.call(arguments)));
	var getType = type;
	if (typeof type !== 'function') {
		(0, _invariant2.default)((0, _isValidType2.default)(type, true), 'Expected "type" provided as the first argument to DropTarget to be ' + 'a string, an array of strings, or a function that returns either given ' + 'the current props. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', type);
		getType = function getType() {
			return type;
		};
	}
	(0, _invariant2.default)((0, _isPlainObject2.default)(spec), 'Expected "spec" provided as the second argument to DropTarget to be ' + 'a plain object. Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', spec);
	var createTarget = (0, _createTargetFactory2.default)(spec);
	(0, _invariant2.default)(typeof collect === 'function', 'Expected "collect" provided as the third argument to DropTarget to be ' + 'a function that returns a plain object of props to inject. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);
	(0, _invariant2.default)((0, _isPlainObject2.default)(options), 'Expected "options" provided as the fourth argument to DropTarget to be ' + 'a plain object when specified. ' + 'Instead, received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', collect);

	return function decorateTarget(DecoratedComponent) {
		return (0, _decorateHandler2.default)({
			connectBackend: function connectBackend(backend, targetId) {
				return backend.connectDropTarget(targetId);
			},
			containerDisplayName: 'DropTarget',
			createHandler: createTarget,
			registerHandler: _registerTarget2.default,
			createMonitor: _createTargetMonitor2.default,
			createConnector: _createTargetConnector2.default,
			DecoratedComponent: DecoratedComponent,
			getType: getType,
			collect: collect,
			options: options
		});
	};
}

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = registerTarget;
function registerTarget(type, target, manager) {
	var registry = manager.getRegistry();
	var targetId = registry.addTarget(type, target);

	function unregisterTarget() {
		registry.removeTarget(targetId);
	}

	return {
		handlerId: targetId,
		unregister: unregisterTarget
	};
}

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createTargetFactory;

var _invariant = __webpack_require__(37);

var _invariant2 = _interopRequireDefault(_invariant);

var _isPlainObject = __webpack_require__(86);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ALLOWED_SPEC_METHODS = ['canDrop', 'hover', 'drop'];

function createTargetFactory(spec) {
	Object.keys(spec).forEach(function (key) {
		(0, _invariant2.default)(ALLOWED_SPEC_METHODS.indexOf(key) > -1, 'Expected the drop target specification to only have ' + 'some of the following keys: %s. ' + 'Instead received a specification with an unexpected "%s" key. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', ALLOWED_SPEC_METHODS.join(', '), key);
		(0, _invariant2.default)(typeof spec[key] === 'function', 'Expected %s in the drop target specification to be a function. ' + 'Instead received a specification with %s: %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', key, key, spec[key]);
	});

	var Target = function () {
		function Target(monitor) {
			_classCallCheck(this, Target);

			this.monitor = monitor;
			this.props = null;
			this.component = null;
		}

		_createClass(Target, [{
			key: 'receiveProps',
			value: function receiveProps(props) {
				this.props = props;
			}
		}, {
			key: 'receiveMonitor',
			value: function receiveMonitor(monitor) {
				this.monitor = monitor;
			}
		}, {
			key: 'receiveComponent',
			value: function receiveComponent(component) {
				this.component = component;
			}
		}, {
			key: 'canDrop',
			value: function canDrop() {
				if (!spec.canDrop) {
					return true;
				}

				return spec.canDrop(this.props, this.monitor);
			}
		}, {
			key: 'hover',
			value: function hover() {
				if (!spec.hover) {
					return;
				}

				spec.hover(this.props, this.monitor, this.component);
			}
		}, {
			key: 'drop',
			value: function drop() {
				if (!spec.drop) {
					return undefined;
				}

				var dropResult = spec.drop(this.props, this.monitor, this.component);
				if (false) {
					(0, _invariant2.default)(typeof dropResult === 'undefined' || (0, _isPlainObject2.default)(dropResult), 'drop() must either return undefined, or an object that represents the drop result. ' + 'Instead received %s. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target.html', dropResult);
				}
				return dropResult;
			}
		}]);

		return Target;
	}();

	return function createTarget(monitor) {
		return new Target(monitor);
	};
}

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createTargetMonitor;

var _invariant = __webpack_require__(37);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var isCallingCanDrop = false;

var TargetMonitor = function () {
	function TargetMonitor(manager) {
		_classCallCheck(this, TargetMonitor);

		this.internalMonitor = manager.getMonitor();
	}

	_createClass(TargetMonitor, [{
		key: 'receiveHandlerId',
		value: function receiveHandlerId(targetId) {
			this.targetId = targetId;
		}
	}, {
		key: 'canDrop',
		value: function canDrop() {
			(0, _invariant2.default)(!isCallingCanDrop, 'You may not call monitor.canDrop() inside your canDrop() implementation. ' + 'Read more: http://react-dnd.github.io/react-dnd/docs-drop-target-monitor.html');

			try {
				isCallingCanDrop = true;
				return this.internalMonitor.canDropOnTarget(this.targetId);
			} finally {
				isCallingCanDrop = false;
			}
		}
	}, {
		key: 'isOver',
		value: function isOver(options) {
			return this.internalMonitor.isOverTarget(this.targetId, options);
		}
	}, {
		key: 'getItemType',
		value: function getItemType() {
			return this.internalMonitor.getItemType();
		}
	}, {
		key: 'getItem',
		value: function getItem() {
			return this.internalMonitor.getItem();
		}
	}, {
		key: 'getDropResult',
		value: function getDropResult() {
			return this.internalMonitor.getDropResult();
		}
	}, {
		key: 'didDrop',
		value: function didDrop() {
			return this.internalMonitor.didDrop();
		}
	}, {
		key: 'getInitialClientOffset',
		value: function getInitialClientOffset() {
			return this.internalMonitor.getInitialClientOffset();
		}
	}, {
		key: 'getInitialSourceClientOffset',
		value: function getInitialSourceClientOffset() {
			return this.internalMonitor.getInitialSourceClientOffset();
		}
	}, {
		key: 'getSourceClientOffset',
		value: function getSourceClientOffset() {
			return this.internalMonitor.getSourceClientOffset();
		}
	}, {
		key: 'getClientOffset',
		value: function getClientOffset() {
			return this.internalMonitor.getClientOffset();
		}
	}, {
		key: 'getDifferenceFromInitialOffset',
		value: function getDifferenceFromInitialOffset() {
			return this.internalMonitor.getDifferenceFromInitialOffset();
		}
	}]);

	return TargetMonitor;
}();

function createTargetMonitor(manager) {
	return new TargetMonitor(manager);
}

/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = createTargetConnector;

var _wrapConnectorHooks = __webpack_require__(333);

var _wrapConnectorHooks2 = _interopRequireDefault(_wrapConnectorHooks);

var _areOptionsEqual = __webpack_require__(334);

var _areOptionsEqual2 = _interopRequireDefault(_areOptionsEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createTargetConnector(backend) {
	var currentHandlerId = void 0;

	var currentDropTargetNode = void 0;
	var currentDropTargetOptions = void 0;
	var disconnectCurrentDropTarget = void 0;

	function reconnectDropTarget() {
		if (disconnectCurrentDropTarget) {
			disconnectCurrentDropTarget();
			disconnectCurrentDropTarget = null;
		}

		if (currentHandlerId && currentDropTargetNode) {
			disconnectCurrentDropTarget = backend.connectDropTarget(currentHandlerId, currentDropTargetNode, currentDropTargetOptions);
		}
	}

	function receiveHandlerId(handlerId) {
		if (handlerId === currentHandlerId) {
			return;
		}

		currentHandlerId = handlerId;
		reconnectDropTarget();
	}

	var hooks = (0, _wrapConnectorHooks2.default)({
		dropTarget: function connectDropTarget(node, options) {
			if (node === currentDropTargetNode && (0, _areOptionsEqual2.default)(options, currentDropTargetOptions)) {
				return;
			}

			currentDropTargetNode = node;
			currentDropTargetOptions = options;

			reconnectDropTarget();
		}
	});

	return {
		receiveHandlerId: receiveHandlerId,
		hooks: hooks
	};
}

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getEmptyImage = exports.NativeTypes = undefined;
exports.default = createHTML5Backend;

var _HTML5Backend = __webpack_require__(772);

var _HTML5Backend2 = _interopRequireDefault(_HTML5Backend);

var _getEmptyImage = __webpack_require__(793);

var _getEmptyImage2 = _interopRequireDefault(_getEmptyImage);

var _NativeTypes = __webpack_require__(223);

var NativeTypes = _interopRequireWildcard(_NativeTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.NativeTypes = NativeTypes;
exports.getEmptyImage = _getEmptyImage2.default;
function createHTML5Backend(manager) {
	return new _HTML5Backend2.default(manager);
}

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint-disable no-underscore-dangle */


var _defaults = __webpack_require__(773);

var _defaults2 = _interopRequireDefault(_defaults);

var _shallowEqual = __webpack_require__(786);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _EnterLeaveCounter = __webpack_require__(787);

var _EnterLeaveCounter2 = _interopRequireDefault(_EnterLeaveCounter);

var _BrowserDetector = __webpack_require__(338);

var _OffsetUtils = __webpack_require__(790);

var _NativeDragSources = __webpack_require__(792);

var _NativeTypes = __webpack_require__(223);

var NativeTypes = _interopRequireWildcard(_NativeTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HTML5Backend = function () {
	function HTML5Backend(manager) {
		_classCallCheck(this, HTML5Backend);

		this.actions = manager.getActions();
		this.monitor = manager.getMonitor();
		this.registry = manager.getRegistry();
		this.context = manager.getContext();

		this.sourcePreviewNodes = {};
		this.sourcePreviewNodeOptions = {};
		this.sourceNodes = {};
		this.sourceNodeOptions = {};
		this.enterLeaveCounter = new _EnterLeaveCounter2.default();

		this.dragStartSourceIds = [];
		this.dropTargetIds = [];
		this.dragEnterTargetIds = [];
		this.currentNativeSource = null;
		this.currentNativeHandle = null;
		this.currentDragSourceNode = null;
		this.currentDragSourceNodeOffset = null;
		this.currentDragSourceNodeOffsetChanged = false;
		this.altKeyPressed = false;
		this.mouseMoveTimeoutTimer = null;

		this.getSourceClientOffset = this.getSourceClientOffset.bind(this);
		this.handleTopDragStart = this.handleTopDragStart.bind(this);
		this.handleTopDragStartCapture = this.handleTopDragStartCapture.bind(this);
		this.handleTopDragEndCapture = this.handleTopDragEndCapture.bind(this);
		this.handleTopDragEnter = this.handleTopDragEnter.bind(this);
		this.handleTopDragEnterCapture = this.handleTopDragEnterCapture.bind(this);
		this.handleTopDragLeaveCapture = this.handleTopDragLeaveCapture.bind(this);
		this.handleTopDragOver = this.handleTopDragOver.bind(this);
		this.handleTopDragOverCapture = this.handleTopDragOverCapture.bind(this);
		this.handleTopDrop = this.handleTopDrop.bind(this);
		this.handleTopDropCapture = this.handleTopDropCapture.bind(this);
		this.handleSelectStart = this.handleSelectStart.bind(this);
		this.endDragIfSourceWasRemovedFromDOM = this.endDragIfSourceWasRemovedFromDOM.bind(this);
		this.endDragNativeItem = this.endDragNativeItem.bind(this);
		this.asyncEndDragNativeItem = this.asyncEndDragNativeItem.bind(this);
		this.isNodeInDocument = this.isNodeInDocument.bind(this);
	}

	_createClass(HTML5Backend, [{
		key: 'setup',
		value: function setup() {
			if (this.window === undefined) {
				return;
			}

			if (this.window.__isReactDndBackendSetUp) {
				throw new Error('Cannot have two HTML5 backends at the same time.');
			}
			this.window.__isReactDndBackendSetUp = true;
			this.addEventListeners(this.window);
		}
	}, {
		key: 'teardown',
		value: function teardown() {
			if (this.window === undefined) {
				return;
			}

			this.window.__isReactDndBackendSetUp = false;
			this.removeEventListeners(this.window);
			this.clearCurrentDragSourceNode();
			if (this.asyncEndDragFrameId) {
				this.window.cancelAnimationFrame(this.asyncEndDragFrameId);
			}
		}
	}, {
		key: 'addEventListeners',
		value: function addEventListeners(target) {
			// SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
			if (!target.addEventListener) {
				return;
			}
			target.addEventListener('dragstart', this.handleTopDragStart);
			target.addEventListener('dragstart', this.handleTopDragStartCapture, true);
			target.addEventListener('dragend', this.handleTopDragEndCapture, true);
			target.addEventListener('dragenter', this.handleTopDragEnter);
			target.addEventListener('dragenter', this.handleTopDragEnterCapture, true);
			target.addEventListener('dragleave', this.handleTopDragLeaveCapture, true);
			target.addEventListener('dragover', this.handleTopDragOver);
			target.addEventListener('dragover', this.handleTopDragOverCapture, true);
			target.addEventListener('drop', this.handleTopDrop);
			target.addEventListener('drop', this.handleTopDropCapture, true);
		}
	}, {
		key: 'removeEventListeners',
		value: function removeEventListeners(target) {
			// SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
			if (!target.removeEventListener) {
				return;
			}
			target.removeEventListener('dragstart', this.handleTopDragStart);
			target.removeEventListener('dragstart', this.handleTopDragStartCapture, true);
			target.removeEventListener('dragend', this.handleTopDragEndCapture, true);
			target.removeEventListener('dragenter', this.handleTopDragEnter);
			target.removeEventListener('dragenter', this.handleTopDragEnterCapture, true);
			target.removeEventListener('dragleave', this.handleTopDragLeaveCapture, true);
			target.removeEventListener('dragover', this.handleTopDragOver);
			target.removeEventListener('dragover', this.handleTopDragOverCapture, true);
			target.removeEventListener('drop', this.handleTopDrop);
			target.removeEventListener('drop', this.handleTopDropCapture, true);
		}
	}, {
		key: 'connectDragPreview',
		value: function connectDragPreview(sourceId, node, options) {
			var _this = this;

			this.sourcePreviewNodeOptions[sourceId] = options;
			this.sourcePreviewNodes[sourceId] = node;

			return function () {
				delete _this.sourcePreviewNodes[sourceId];
				delete _this.sourcePreviewNodeOptions[sourceId];
			};
		}
	}, {
		key: 'connectDragSource',
		value: function connectDragSource(sourceId, node, options) {
			var _this2 = this;

			this.sourceNodes[sourceId] = node;
			this.sourceNodeOptions[sourceId] = options;

			var handleDragStart = function handleDragStart(e) {
				return _this2.handleDragStart(e, sourceId);
			};
			var handleSelectStart = function handleSelectStart(e) {
				return _this2.handleSelectStart(e, sourceId);
			};

			node.setAttribute('draggable', true);
			node.addEventListener('dragstart', handleDragStart);
			node.addEventListener('selectstart', handleSelectStart);

			return function () {
				delete _this2.sourceNodes[sourceId];
				delete _this2.sourceNodeOptions[sourceId];

				node.removeEventListener('dragstart', handleDragStart);
				node.removeEventListener('selectstart', handleSelectStart);
				node.setAttribute('draggable', false);
			};
		}
	}, {
		key: 'connectDropTarget',
		value: function connectDropTarget(targetId, node) {
			var _this3 = this;

			var handleDragEnter = function handleDragEnter(e) {
				return _this3.handleDragEnter(e, targetId);
			};
			var handleDragOver = function handleDragOver(e) {
				return _this3.handleDragOver(e, targetId);
			};
			var handleDrop = function handleDrop(e) {
				return _this3.handleDrop(e, targetId);
			};

			node.addEventListener('dragenter', handleDragEnter);
			node.addEventListener('dragover', handleDragOver);
			node.addEventListener('drop', handleDrop);

			return function () {
				node.removeEventListener('dragenter', handleDragEnter);
				node.removeEventListener('dragover', handleDragOver);
				node.removeEventListener('drop', handleDrop);
			};
		}
	}, {
		key: 'getCurrentSourceNodeOptions',
		value: function getCurrentSourceNodeOptions() {
			var sourceId = this.monitor.getSourceId();
			var sourceNodeOptions = this.sourceNodeOptions[sourceId];

			return (0, _defaults2.default)(sourceNodeOptions || {}, {
				dropEffect: this.altKeyPressed ? 'copy' : 'move'
			});
		}
	}, {
		key: 'getCurrentDropEffect',
		value: function getCurrentDropEffect() {
			if (this.isDraggingNativeItem()) {
				// It makes more sense to default to 'copy' for native resources
				return 'copy';
			}

			return this.getCurrentSourceNodeOptions().dropEffect;
		}
	}, {
		key: 'getCurrentSourcePreviewNodeOptions',
		value: function getCurrentSourcePreviewNodeOptions() {
			var sourceId = this.monitor.getSourceId();
			var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions[sourceId];

			return (0, _defaults2.default)(sourcePreviewNodeOptions || {}, {
				anchorX: 0.5,
				anchorY: 0.5,
				captureDraggingState: false
			});
		}
	}, {
		key: 'getSourceClientOffset',
		value: function getSourceClientOffset(sourceId) {
			return (0, _OffsetUtils.getNodeClientOffset)(this.sourceNodes[sourceId]);
		}
	}, {
		key: 'isDraggingNativeItem',
		value: function isDraggingNativeItem() {
			var itemType = this.monitor.getItemType();
			return Object.keys(NativeTypes).some(function (key) {
				return NativeTypes[key] === itemType;
			});
		}
	}, {
		key: 'beginDragNativeItem',
		value: function beginDragNativeItem(type) {
			this.clearCurrentDragSourceNode();

			var SourceType = (0, _NativeDragSources.createNativeDragSource)(type);
			this.currentNativeSource = new SourceType();
			this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
			this.actions.beginDrag([this.currentNativeHandle]);
		}
	}, {
		key: 'asyncEndDragNativeItem',
		value: function asyncEndDragNativeItem() {
			this.asyncEndDragFrameId = this.window.requestAnimationFrame(this.endDragNativeItem);
		}
	}, {
		key: 'endDragNativeItem',
		value: function endDragNativeItem() {
			if (!this.isDraggingNativeItem()) {
				return;
			}

			this.actions.endDrag();
			this.registry.removeSource(this.currentNativeHandle);
			this.currentNativeHandle = null;
			this.currentNativeSource = null;
		}
	}, {
		key: 'isNodeInDocument',
		value: function isNodeInDocument(node) {
			// Check the node either in the main document or in the current context
			return document.body.contains(node) || this.window ? this.window.document.body.contains(node) : false;
		}
	}, {
		key: 'endDragIfSourceWasRemovedFromDOM',
		value: function endDragIfSourceWasRemovedFromDOM() {
			var node = this.currentDragSourceNode;
			if (this.isNodeInDocument(node)) {
				return;
			}

			if (this.clearCurrentDragSourceNode()) {
				this.actions.endDrag();
			}
		}
	}, {
		key: 'setCurrentDragSourceNode',
		value: function setCurrentDragSourceNode(node) {
			var _this4 = this;

			this.clearCurrentDragSourceNode();
			this.currentDragSourceNode = node;
			this.currentDragSourceNodeOffset = (0, _OffsetUtils.getNodeClientOffset)(node);
			this.currentDragSourceNodeOffsetChanged = false;

			// A timeout of > 0 is necessary to resolve Firefox issue referenced
			// See:
			//   * https://github.com/react-dnd/react-dnd/pull/928
			//   * https://github.com/react-dnd/react-dnd/issues/869
			var MOUSE_MOVE_TIMEOUT = 1000;

			// Receiving a mouse event in the middle of a dragging operation
			// means it has ended and the drag source node disappeared from DOM,
			// so the browser didn't dispatch the dragend event.
			//
			// We need to wait before we start listening for mousemove events.
			// This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
			// immediately in some browsers.
			//
			// See:
			//   * https://github.com/react-dnd/react-dnd/pull/928
			//   * https://github.com/react-dnd/react-dnd/issues/869
			//
			this.mouseMoveTimeoutTimer = setTimeout(function () {
				_this4.mouseMoveTimeoutId = null;
				return _this4.window.addEventListener('mousemove', _this4.endDragIfSourceWasRemovedFromDOM, true);
			}, MOUSE_MOVE_TIMEOUT);
		}
	}, {
		key: 'clearCurrentDragSourceNode',
		value: function clearCurrentDragSourceNode() {
			if (this.currentDragSourceNode) {
				this.currentDragSourceNode = null;
				this.currentDragSourceNodeOffset = null;
				this.currentDragSourceNodeOffsetChanged = false;
				this.window.clearTimeout(this.mouseMoveTimeoutTimer);
				this.window.removeEventListener('mousemove', this.endDragIfSourceWasRemovedFromDOM, true);
				this.mouseMoveTimeoutTimer = null;
				return true;
			}

			return false;
		}
	}, {
		key: 'checkIfCurrentDragSourceRectChanged',
		value: function checkIfCurrentDragSourceRectChanged() {
			var node = this.currentDragSourceNode;
			if (!node) {
				return false;
			}

			if (this.currentDragSourceNodeOffsetChanged) {
				return true;
			}

			this.currentDragSourceNodeOffsetChanged = !(0, _shallowEqual2.default)((0, _OffsetUtils.getNodeClientOffset)(node), this.currentDragSourceNodeOffset);

			return this.currentDragSourceNodeOffsetChanged;
		}
	}, {
		key: 'handleTopDragStartCapture',
		value: function handleTopDragStartCapture() {
			this.clearCurrentDragSourceNode();
			this.dragStartSourceIds = [];
		}
	}, {
		key: 'handleDragStart',
		value: function handleDragStart(e, sourceId) {
			this.dragStartSourceIds.unshift(sourceId);
		}
	}, {
		key: 'handleTopDragStart',
		value: function handleTopDragStart(e) {
			var _this5 = this;

			var dragStartSourceIds = this.dragStartSourceIds;

			this.dragStartSourceIds = null;

			var clientOffset = (0, _OffsetUtils.getEventClientOffset)(e);

			// Avoid crashing if we missed a drop event or our previous drag died
			if (this.monitor.isDragging()) {
				this.actions.endDrag();
			}

			// Don't publish the source just yet (see why below)
			this.actions.beginDrag(dragStartSourceIds, {
				publishSource: false,
				getSourceClientOffset: this.getSourceClientOffset,
				clientOffset: clientOffset
			});

			var dataTransfer = e.dataTransfer;

			var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);

			if (this.monitor.isDragging()) {
				if (typeof dataTransfer.setDragImage === 'function') {
					// Use custom drag image if user specifies it.
					// If child drag source refuses drag but parent agrees,
					// use parent's node as drag image. Neither works in IE though.
					var sourceId = this.monitor.getSourceId();
					var sourceNode = this.sourceNodes[sourceId];
					var dragPreview = this.sourcePreviewNodes[sourceId] || sourceNode;

					var _getCurrentSourcePrev = this.getCurrentSourcePreviewNodeOptions(),
					    anchorX = _getCurrentSourcePrev.anchorX,
					    anchorY = _getCurrentSourcePrev.anchorY,
					    offsetX = _getCurrentSourcePrev.offsetX,
					    offsetY = _getCurrentSourcePrev.offsetY;

					var anchorPoint = { anchorX: anchorX, anchorY: anchorY };
					var offsetPoint = { offsetX: offsetX, offsetY: offsetY };
					var dragPreviewOffset = (0, _OffsetUtils.getDragPreviewOffset)(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);

					dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
				}

				try {
					// Firefox won't drag without setting data
					dataTransfer.setData('application/json', {});
				} catch (err) {}
				// IE doesn't support MIME types in setData


				// Store drag source node so we can check whether
				// it is removed from DOM and trigger endDrag manually.
				this.setCurrentDragSourceNode(e.target);

				// Now we are ready to publish the drag source.. or are we not?

				var _getCurrentSourcePrev2 = this.getCurrentSourcePreviewNodeOptions(),
				    captureDraggingState = _getCurrentSourcePrev2.captureDraggingState;

				if (!captureDraggingState) {
					// Usually we want to publish it in the next tick so that browser
					// is able to screenshot the current (not yet dragging) state.
					//
					// It also neatly avoids a situation where render() returns null
					// in the same tick for the source element, and browser freaks out.
					setTimeout(function () {
						return _this5.actions.publishDragSource();
					});
				} else {
					// In some cases the user may want to override this behavior, e.g.
					// to work around IE not supporting custom drag previews.
					//
					// When using a custom drag layer, the only way to prevent
					// the default drag preview from drawing in IE is to screenshot
					// the dragging state in which the node itself has zero opacity
					// and height. In this case, though, returning null from render()
					// will abruptly end the dragging, which is not obvious.
					//
					// This is the reason such behavior is strictly opt-in.
					this.actions.publishDragSource();
				}
			} else if (nativeType) {
				// A native item (such as URL) dragged from inside the document
				this.beginDragNativeItem(nativeType);
			} else if (!dataTransfer.types && (!e.target.hasAttribute || !e.target.hasAttribute('draggable'))) {
				// Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
				// Just let it drag. It's a native type (URL or text) and will be picked up in
				// dragenter handler.
				return; // eslint-disable-line no-useless-return
			} else {
				// If by this time no drag source reacted, tell browser not to drag.
				e.preventDefault();
			}
		}
	}, {
		key: 'handleTopDragEndCapture',
		value: function handleTopDragEndCapture() {
			if (this.clearCurrentDragSourceNode()) {
				// Firefox can dispatch this event in an infinite loop
				// if dragend handler does something like showing an alert.
				// Only proceed if we have not handled it already.
				this.actions.endDrag();
			}
		}
	}, {
		key: 'handleTopDragEnterCapture',
		value: function handleTopDragEnterCapture(e) {
			this.dragEnterTargetIds = [];

			var isFirstEnter = this.enterLeaveCounter.enter(e.target);
			if (!isFirstEnter || this.monitor.isDragging()) {
				return;
			}

			var dataTransfer = e.dataTransfer;

			var nativeType = (0, _NativeDragSources.matchNativeItemType)(dataTransfer);

			if (nativeType) {
				// A native item (such as file or URL) dragged from outside the document
				this.beginDragNativeItem(nativeType);
			}
		}
	}, {
		key: 'handleDragEnter',
		value: function handleDragEnter(e, targetId) {
			this.dragEnterTargetIds.unshift(targetId);
		}
	}, {
		key: 'handleTopDragEnter',
		value: function handleTopDragEnter(e) {
			var _this6 = this;

			var dragEnterTargetIds = this.dragEnterTargetIds;

			this.dragEnterTargetIds = [];

			if (!this.monitor.isDragging()) {
				// This is probably a native item type we don't understand.
				return;
			}

			this.altKeyPressed = e.altKey;

			if (!(0, _BrowserDetector.isFirefox)()) {
				// Don't emit hover in `dragenter` on Firefox due to an edge case.
				// If the target changes position as the result of `dragenter`, Firefox
				// will still happily dispatch `dragover` despite target being no longer
				// there. The easy solution is to only fire `hover` in `dragover` on FF.
				this.actions.hover(dragEnterTargetIds, {
					clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
				});
			}

			var canDrop = dragEnterTargetIds.some(function (targetId) {
				return _this6.monitor.canDropOnTarget(targetId);
			});

			if (canDrop) {
				// IE requires this to fire dragover events
				e.preventDefault();
				e.dataTransfer.dropEffect = this.getCurrentDropEffect();
			}
		}
	}, {
		key: 'handleTopDragOverCapture',
		value: function handleTopDragOverCapture() {
			this.dragOverTargetIds = [];
		}
	}, {
		key: 'handleDragOver',
		value: function handleDragOver(e, targetId) {
			this.dragOverTargetIds.unshift(targetId);
		}
	}, {
		key: 'handleTopDragOver',
		value: function handleTopDragOver(e) {
			var _this7 = this;

			var dragOverTargetIds = this.dragOverTargetIds;

			this.dragOverTargetIds = [];

			if (!this.monitor.isDragging()) {
				// This is probably a native item type we don't understand.
				// Prevent default "drop and blow away the whole document" action.
				e.preventDefault();
				e.dataTransfer.dropEffect = 'none';
				return;
			}

			this.altKeyPressed = e.altKey;

			this.actions.hover(dragOverTargetIds, {
				clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
			});

			var canDrop = dragOverTargetIds.some(function (targetId) {
				return _this7.monitor.canDropOnTarget(targetId);
			});

			if (canDrop) {
				// Show user-specified drop effect.
				e.preventDefault();
				e.dataTransfer.dropEffect = this.getCurrentDropEffect();
			} else if (this.isDraggingNativeItem()) {
				// Don't show a nice cursor but still prevent default
				// "drop and blow away the whole document" action.
				e.preventDefault();
				e.dataTransfer.dropEffect = 'none';
			} else if (this.checkIfCurrentDragSourceRectChanged()) {
				// Prevent animating to incorrect position.
				// Drop effect must be other than 'none' to prevent animation.
				e.preventDefault();
				e.dataTransfer.dropEffect = 'move';
			}
		}
	}, {
		key: 'handleTopDragLeaveCapture',
		value: function handleTopDragLeaveCapture(e) {
			if (this.isDraggingNativeItem()) {
				e.preventDefault();
			}

			var isLastLeave = this.enterLeaveCounter.leave(e.target);
			if (!isLastLeave) {
				return;
			}

			if (this.isDraggingNativeItem()) {
				this.endDragNativeItem();
			}
		}
	}, {
		key: 'handleTopDropCapture',
		value: function handleTopDropCapture(e) {
			this.dropTargetIds = [];
			e.preventDefault();

			if (this.isDraggingNativeItem()) {
				this.currentNativeSource.mutateItemByReadingDataTransfer(e.dataTransfer);
			}

			this.enterLeaveCounter.reset();
		}
	}, {
		key: 'handleDrop',
		value: function handleDrop(e, targetId) {
			this.dropTargetIds.unshift(targetId);
		}
	}, {
		key: 'handleTopDrop',
		value: function handleTopDrop(e) {
			var dropTargetIds = this.dropTargetIds;

			this.dropTargetIds = [];

			this.actions.hover(dropTargetIds, {
				clientOffset: (0, _OffsetUtils.getEventClientOffset)(e)
			});
			this.actions.drop({ dropEffect: this.getCurrentDropEffect() });

			if (this.isDraggingNativeItem()) {
				this.endDragNativeItem();
			} else {
				this.endDragIfSourceWasRemovedFromDOM();
			}
		}
	}, {
		key: 'handleSelectStart',
		value: function handleSelectStart(e) {
			var target = e.target;

			// Only IE requires us to explicitly say
			// we want drag drop operation to start

			if (typeof target.dragDrop !== 'function') {
				return;
			}

			// Inputs and textareas should be selectable
			if (target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
				return;
			}

			// For other targets, ask IE
			// to enable drag and drop
			e.preventDefault();
			target.dragDrop();
		}
	}, {
		key: 'window',
		get: function get() {
			if (this.context && this.context.window) {
				return this.context.window;
			} else if (typeof window !== 'undefined') {
				return window;
			}
			return undefined;
		}
	}]);

	return HTML5Backend;
}();

exports.default = HTML5Backend;

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(119),
    eq = __webpack_require__(213),
    isIterateeCall = __webpack_require__(774),
    keysIn = __webpack_require__(775);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */
var defaults = baseRest(function(object, sources) {
  object = Object(object);

  var index = -1;
  var length = sources.length;
  var guard = length > 2 ? sources[2] : undefined;

  if (guard && isIterateeCall(sources[0], sources[1], guard)) {
    length = 1;
  }

  while (++index < length) {
    var source = sources[index];
    var props = keysIn(source);
    var propsIndex = -1;
    var propsLength = props.length;

    while (++propsIndex < propsLength) {
      var key = props[propsIndex];
      var value = object[key];

      if (value === undefined ||
          (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        object[key] = source[key];
      }
    }
  }

  return object;
});

module.exports = defaults;


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(213),
    isArrayLike = __webpack_require__(219),
    isIndex = __webpack_require__(336),
    isObject = __webpack_require__(118);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(776),
    baseKeysIn = __webpack_require__(783),
    isArrayLike = __webpack_require__(219);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(777),
    isArguments = __webpack_require__(327),
    isArray = __webpack_require__(87),
    isBuffer = __webpack_require__(778),
    isIndex = __webpack_require__(336),
    isTypedArray = __webpack_require__(780);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 777 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(116),
    stubFalse = __webpack_require__(779);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(337)(module)))

/***/ }),
/* 779 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(781),
    baseUnary = __webpack_require__(217),
    nodeUtil = __webpack_require__(782);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(148),
    isLength = __webpack_require__(324),
    isObjectLike = __webpack_require__(117);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(316);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(337)(module)))

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(118),
    isPrototype = __webpack_require__(784),
    nativeKeysIn = __webpack_require__(785);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 784 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 785 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = shallowEqual;
function shallowEqual(objA, objB) {
	if (objA === objB) {
		return true;
	}

	var keysA = Object.keys(objA);
	var keysB = Object.keys(objB);

	if (keysA.length !== keysB.length) {
		return false;
	}

	// Test for A's keys different from B.
	var hasOwn = Object.prototype.hasOwnProperty;
	for (var i = 0; i < keysA.length; i += 1) {
		if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
			return false;
		}

		var valA = objA[keysA[i]];
		var valB = objB[keysA[i]];

		if (valA !== valB) {
			return false;
		}
	}

	return true;
}

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _union = __webpack_require__(788);

var _union2 = _interopRequireDefault(_union);

var _without = __webpack_require__(319);

var _without2 = _interopRequireDefault(_without);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EnterLeaveCounter = function () {
	function EnterLeaveCounter() {
		_classCallCheck(this, EnterLeaveCounter);

		this.entered = [];
	}

	_createClass(EnterLeaveCounter, [{
		key: 'enter',
		value: function enter(enteringNode) {
			var previousLength = this.entered.length;

			var isNodeEntered = function isNodeEntered(node) {
				return document.documentElement.contains(node) && (!node.contains || node.contains(enteringNode));
			};

			this.entered = (0, _union2.default)(this.entered.filter(isNodeEntered), [enteringNode]);

			return previousLength === 0 && this.entered.length > 0;
		}
	}, {
		key: 'leave',
		value: function leave(leavingNode) {
			var previousLength = this.entered.length;

			this.entered = (0, _without2.default)(this.entered.filter(function (node) {
				return document.documentElement.contains(node);
			}), leavingNode);

			return previousLength > 0 && this.entered.length === 0;
		}
	}, {
		key: 'reset',
		value: function reset() {
			this.entered = [];
		}
	}]);

	return EnterLeaveCounter;
}();

exports.default = EnterLeaveCounter;

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(326),
    baseRest = __webpack_require__(119),
    baseUniq = __webpack_require__(328),
    isArrayLikeObject = __webpack_require__(154);

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

module.exports = union;


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(321);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getNodeClientOffset = getNodeClientOffset;
exports.getEventClientOffset = getEventClientOffset;
exports.getDragPreviewOffset = getDragPreviewOffset;

var _BrowserDetector = __webpack_require__(338);

var _MonotonicInterpolant = __webpack_require__(791);

var _MonotonicInterpolant2 = _interopRequireDefault(_MonotonicInterpolant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint
   no-mixed-operators: off
*/
var ELEMENT_NODE = 1;

function getNodeClientOffset(node) {
	var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;

	if (!el) {
		return null;
	}

	var _el$getBoundingClient = el.getBoundingClientRect(),
	    top = _el$getBoundingClient.top,
	    left = _el$getBoundingClient.left;

	return { x: left, y: top };
}

function getEventClientOffset(e) {
	return {
		x: e.clientX,
		y: e.clientY
	};
}

function isImageNode(node) {
	return node.nodeName === 'IMG' && ((0, _BrowserDetector.isFirefox)() || !document.documentElement.contains(node));
}

function getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
	var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
	var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;

	// Work around @2x coordinate discrepancies in browsers
	if ((0, _BrowserDetector.isSafari)() && isImage) {
		dragPreviewHeight /= window.devicePixelRatio;
		dragPreviewWidth /= window.devicePixelRatio;
	}
	return { dragPreviewWidth: dragPreviewWidth, dragPreviewHeight: dragPreviewHeight };
}

function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
	// The browsers will use the image intrinsic size under different conditions.
	// Firefox only cares if it's an image, but WebKit also wants it to be detached.
	var isImage = isImageNode(dragPreview);
	var dragPreviewNode = isImage ? sourceNode : dragPreview;
	var dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
	var offsetFromDragPreview = {
		x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
		y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
	};
	var sourceWidth = sourceNode.offsetWidth,
	    sourceHeight = sourceNode.offsetHeight;
	var anchorX = anchorPoint.anchorX,
	    anchorY = anchorPoint.anchorY;

	var _getDragPreviewSize = getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight),
	    dragPreviewWidth = _getDragPreviewSize.dragPreviewWidth,
	    dragPreviewHeight = _getDragPreviewSize.dragPreviewHeight;

	var calculateYOffset = function calculateYOffset() {
		var interpolantY = new _MonotonicInterpolant2.default([0, 0.5, 1], [
		// Dock to the top
		offsetFromDragPreview.y,
		// Align at the center
		offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
		// Dock to the bottom
		offsetFromDragPreview.y + dragPreviewHeight - sourceHeight]);
		var y = interpolantY.interpolate(anchorY);
		// Work around Safari 8 positioning bug
		if ((0, _BrowserDetector.isSafari)() && isImage) {
			// We'll have to wait for @3x to see if this is entirely correct
			y += (window.devicePixelRatio - 1) * dragPreviewHeight;
		}
		return y;
	};

	var calculateXOffset = function calculateXOffset() {
		// Interpolate coordinates depending on anchor point
		// If you know a simpler way to do this, let me know
		var interpolantX = new _MonotonicInterpolant2.default([0, 0.5, 1], [
		// Dock to the left
		offsetFromDragPreview.x,
		// Align at the center
		offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
		// Dock to the right
		offsetFromDragPreview.x + dragPreviewWidth - sourceWidth]);
		return interpolantX.interpolate(anchorX);
	};

	// Force offsets if specified in the options.
	var offsetX = offsetPoint.offsetX,
	    offsetY = offsetPoint.offsetY;

	var isManualOffsetX = offsetX === 0 || offsetX;
	var isManualOffsetY = offsetY === 0 || offsetY;
	return {
		x: isManualOffsetX ? offsetX : calculateXOffset(),
		y: isManualOffsetY ? offsetY : calculateYOffset()
	};
}

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint
   no-plusplus: off,
   no-mixed-operators: off
*/
var MonotonicInterpolant = function () {
	function MonotonicInterpolant(xs, ys) {
		_classCallCheck(this, MonotonicInterpolant);

		var length = xs.length;

		// Rearrange xs and ys so that xs is sorted
		var indexes = [];
		for (var i = 0; i < length; i++) {
			indexes.push(i);
		}
		indexes.sort(function (a, b) {
			return xs[a] < xs[b] ? -1 : 1;
		});

		// Get consecutive differences and slopes
		var dys = [];
		var dxs = [];
		var ms = [];
		var dx = void 0;
		var dy = void 0;
		for (var _i = 0; _i < length - 1; _i++) {
			dx = xs[_i + 1] - xs[_i];
			dy = ys[_i + 1] - ys[_i];
			dxs.push(dx);
			dys.push(dy);
			ms.push(dy / dx);
		}

		// Get degree-1 coefficients
		var c1s = [ms[0]];
		for (var _i2 = 0; _i2 < dxs.length - 1; _i2++) {
			var _m = ms[_i2];
			var mNext = ms[_i2 + 1];
			if (_m * mNext <= 0) {
				c1s.push(0);
			} else {
				dx = dxs[_i2];
				var dxNext = dxs[_i2 + 1];
				var common = dx + dxNext;
				c1s.push(3 * common / ((common + dxNext) / _m + (common + dx) / mNext));
			}
		}
		c1s.push(ms[ms.length - 1]);

		// Get degree-2 and degree-3 coefficients
		var c2s = [];
		var c3s = [];
		var m = void 0;
		for (var _i3 = 0; _i3 < c1s.length - 1; _i3++) {
			m = ms[_i3];
			var c1 = c1s[_i3];
			var invDx = 1 / dxs[_i3];
			var _common = c1 + c1s[_i3 + 1] - m - m;
			c2s.push((m - c1 - _common) * invDx);
			c3s.push(_common * invDx * invDx);
		}

		this.xs = xs;
		this.ys = ys;
		this.c1s = c1s;
		this.c2s = c2s;
		this.c3s = c3s;
	}

	_createClass(MonotonicInterpolant, [{
		key: "interpolate",
		value: function interpolate(x) {
			var xs = this.xs,
			    ys = this.ys,
			    c1s = this.c1s,
			    c2s = this.c2s,
			    c3s = this.c3s;

			// The rightmost point in the dataset should give an exact result

			var i = xs.length - 1;
			if (x === xs[i]) {
				return ys[i];
			}

			// Search for the interval x is in, returning the corresponding y if x is one of the original xs
			var low = 0;
			var high = c3s.length - 1;
			var mid = void 0;
			while (low <= high) {
				mid = Math.floor(0.5 * (low + high));
				var xHere = xs[mid];
				if (xHere < x) {
					low = mid + 1;
				} else if (xHere > x) {
					high = mid - 1;
				} else {
					return ys[mid];
				}
			}
			i = Math.max(0, high);

			// Interpolate
			var diff = x - xs[i];
			var diffSq = diff * diff;
			return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
		}
	}]);

	return MonotonicInterpolant;
}();

exports.default = MonotonicInterpolant;

/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _nativeTypesConfig;

exports.createNativeDragSource = createNativeDragSource;
exports.matchNativeItemType = matchNativeItemType;

var _NativeTypes = __webpack_require__(223);

var NativeTypes = _interopRequireWildcard(_NativeTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineEnumerableProperties(obj, descs) { for (var key in descs) { var desc = descs[key]; desc.configurable = desc.enumerable = true; if ("value" in desc) desc.writable = true; Object.defineProperty(obj, key, desc); } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getDataFromDataTransfer(dataTransfer, typesToTry, defaultValue) {
	var result = typesToTry.reduce(function (resultSoFar, typeToTry) {
		return resultSoFar || dataTransfer.getData(typeToTry);
	}, null);

	return result != null // eslint-disable-line eqeqeq
	? result : defaultValue;
}

var nativeTypesConfig = (_nativeTypesConfig = {}, _defineProperty(_nativeTypesConfig, NativeTypes.FILE, {
	exposeProperty: 'files',
	matchesTypes: ['Files'],
	getData: function getData(dataTransfer) {
		return Array.prototype.slice.call(dataTransfer.files);
	}
}), _defineProperty(_nativeTypesConfig, NativeTypes.URL, {
	exposeProperty: 'urls',
	matchesTypes: ['Url', 'text/uri-list'],
	getData: function getData(dataTransfer, matchesTypes) {
		return getDataFromDataTransfer(dataTransfer, matchesTypes, '').split('\n');
	}
}), _defineProperty(_nativeTypesConfig, NativeTypes.TEXT, {
	exposeProperty: 'text',
	matchesTypes: ['Text', 'text/plain'],
	getData: function getData(dataTransfer, matchesTypes) {
		return getDataFromDataTransfer(dataTransfer, matchesTypes, '');
	}
}), _nativeTypesConfig);

function createNativeDragSource(type) {
	var _nativeTypesConfig$ty = nativeTypesConfig[type],
	    exposeProperty = _nativeTypesConfig$ty.exposeProperty,
	    matchesTypes = _nativeTypesConfig$ty.matchesTypes,
	    getData = _nativeTypesConfig$ty.getData;


	return function () {
		function NativeDragSource() {
			var _item, _mutatorMap;

			_classCallCheck(this, NativeDragSource);

			this.item = (_item = {}, _mutatorMap = {}, _mutatorMap[exposeProperty] = _mutatorMap[exposeProperty] || {}, _mutatorMap[exposeProperty].get = function () {
				// eslint-disable-next-line no-console
				console.warn('Browser doesn\'t allow reading "' + exposeProperty + '" until the drop event.');
				return null;
			}, _defineEnumerableProperties(_item, _mutatorMap), _item);
		}

		_createClass(NativeDragSource, [{
			key: 'mutateItemByReadingDataTransfer',
			value: function mutateItemByReadingDataTransfer(dataTransfer) {
				delete this.item[exposeProperty];
				this.item[exposeProperty] = getData(dataTransfer, matchesTypes);
			}
		}, {
			key: 'canDrag',
			value: function canDrag() {
				return true;
			}
		}, {
			key: 'beginDrag',
			value: function beginDrag() {
				return this.item;
			}
		}, {
			key: 'isDragging',
			value: function isDragging(monitor, handle) {
				return handle === monitor.getSourceId();
			}
		}, {
			key: 'endDrag',
			value: function endDrag() {}
		}]);

		return NativeDragSource;
	}();
}

function matchNativeItemType(dataTransfer) {
	var dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);

	return Object.keys(nativeTypesConfig).filter(function (nativeItemType) {
		var matchesTypes = nativeTypesConfig[nativeItemType].matchesTypes;

		return matchesTypes.some(function (t) {
			return dataTransferTypes.indexOf(t) > -1;
		});
	})[0] || null;
}

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = getEmptyImage;
var emptyImage = void 0;
function getEmptyImage() {
	if (!emptyImage) {
		emptyImage = new Image();
		emptyImage.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
	}

	return emptyImage;
}

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Field = __webpack_require__(36);

var _Field2 = _interopRequireDefault(_Field);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MultiTable = function (_React$Component) {
  _inherits(MultiTable, _React$Component);

  function MultiTable() {
    _classCallCheck(this, MultiTable);

    return _possibleConstructorReturn(this, (MultiTable.__proto__ || Object.getPrototypeOf(MultiTable)).apply(this, arguments));
  }

  _createClass(MultiTable, [{
    key: 'addEntry',
    value: function addEntry(details) {
      if (this.props.addEntry !== undefined && this.props.addEntry.handler !== undefined) {
        this.props.addEntry.handler(Object.assign({}, details, { type: this.props.type }));
      }
    }
  }, {
    key: 'editEntry',
    value: function editEntry(details) {
      if (this.props.onEditEntry !== undefined) {
        this.props.onEditEntry(Object.assign({}, details, { type: this.props.type }));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { style: { width: "100%" } },
        this.props.value !== undefined && this.props.value.length > 0 ? this.props.value.map(function (item) {
          return _react2.default.createElement(
            'div',
            { key: item.id, style: { border: item._displayAs === "_highlight" ? (item.simulated === true ? "dashed" : "solid") + " 2px #8BC34A" : item._displayAs === "_normal" ? "solid 2px orange" : undefined, marginBottom: 3 } },
            _react2.default.createElement(_Field2.default, _extends({}, _this2.props, {
              value: item.items,
              showFlag: item._displayAs === "_normal",
              title: item.text,
              help: item.description,
              name: _this2.props.name + "." + item.id,
              _hideColumnHeader: item._hideColumnHeader,
              _disableOption: item._disableOption,
              type: 'table',
              addEntry: Object.assign({}, _this2.props.addEntry, { handler: _this2.addEntry.bind(_this2) }),
              onEditEntry: _this2.editEntry.bind(_this2)
            }))
          );
        }) : _react2.default.createElement(
          'i',
          null,
          this.props.empty !== undefined && this.props.empty.message ? this.props.empty.message : ".(empty.message)"
        )
      );
    }
  }]);

  return MultiTable;
}(_react2.default.Component);

exports.default = MultiTable;

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _PriorityTable = __webpack_require__(224);

var _PriorityTable2 = _interopRequireDefault(_PriorityTable);

var _Field = __webpack_require__(36);

var _Field2 = _interopRequireDefault(_Field);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Matrix = function (_React$Component) {
  _inherits(Matrix, _React$Component);

  function Matrix(props) {
    _classCallCheck(this, Matrix);

    var _this = _possibleConstructorReturn(this, (Matrix.__proto__ || Object.getPrototypeOf(Matrix)).call(this, props));

    _this.state = _this.loadState(props);
    return _this;
  }

  _createClass(Matrix, [{
    key: 'loadState',
    value: function loadState(props) {
      var defaultCategory = undefined;
      if (props.categories !== undefined) {
        if (props.value.category !== undefined) {
          defaultCategory = props.categories.filter(function (category) {
            return category.name === props.value.category;
          })[0];
        }
        if (defaultCategory === undefined) {
          defaultCategory = props.categories[0];
        }
      }
      return {
        row: props.fields.filter(function (field) {
          return field.matrixType === "row";
        })[0],
        column: props.fields.filter(function (field) {
          return field.matrixType === "column";
        })[0],
        category: defaultCategory,
        value: props.value
      };
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState(this.loadState(props));
    }
  }, {
    key: 'updateField',
    value: function updateField(event) {
      var newValue = Object.assign({}, this.state.value);
      if (this.state.category) {
        newValue[this.state.category.name][event.target.name] = event.target.value;
        newValue.category = this.state.category.name;
      }
      this.updateMatrixState(newValue);
    }
  }, {
    key: 'updateMatrixState',
    value: function updateMatrixState(newValue) {
      var _this2 = this;

      this.setState({ value: newValue }, function () {
        var newEvent = {
          target: {
            name: _this2.props.name,
            value: newValue
          }
        };
        if (_this2.props.onChange) {
          _this2.props.onChange(newEvent);
        }
      });
    }
  }, {
    key: 'changeCategory',
    value: function changeCategory(event) {
      this.setState({ category: this.props.categories.filter(function (category) {
          return category.name === event.target.value;
        })[0] });
    }
  }, {
    key: 'changePriority',
    value: function changePriority(event) {
      var newValue = Object.assign({}, this.state.value);
      var category = this.state.category;
      var row = this.state.row;
      var column = this.state.column;
      newValue.category = category.name;
      if (newValue[category.name] === undefined) {
        newValue[category.name] = {};
      }
      newValue[category.name][this.state.row.name] = event.target.value.row;
      newValue[category.name][this.state.column.name] = event.target.value.column;
      this.updateMatrixState(newValue);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var row = this.state.row;
      var column = this.state.column;
      var tableLabels = {
        row: this.state.row.title,
        column: this.state.column.title
      };
      var items = this.props.categories.map(function (category) {
        return {
          row: _this3.state.value[category.name] !== undefined ? parseInt(_this3.state.value[category.name][row.name]) : undefined,
          column: _this3.state.value[category.name] !== undefined ? parseInt(_this3.state.value[category.name][column.name]) : undefined,
          no: _this3.props.value.no,
          title: category.title,
          style: category.name === _this3.state.category.name ? "" : "faded"
        };
      });
      return this.state.value.hide !== true ? _react2.default.createElement(
        'div',
        { style: { display: "flex", flexWrap: "wrap", justifyContent: "space-between", width: "100%" } },
        _react2.default.createElement(
          'div',
          { style: { textAlign: "center" } },
          _react2.default.createElement(_PriorityTable2.default, _extends({ onClick: this.changePriority.bind(this), showId: true, preventDetails: true }, this.props, { labels: tableLabels, items: items, no: this.props.value.no }))
        ),
        _react2.default.createElement(
          'div',
          { className: 'field' },
          this.props.categories && this.props.value.hideCategories !== true ? _react2.default.createElement(
            'div',
            { style: { paddingBottom: 15 } },
            this.props.categories.map(function (category) {
              return _react2.default.createElement(
                'div',
                { style: { paddingBottom: 5 }, key: category.name },
                _react2.default.createElement('input', { onChange: _this3.changeCategory.bind(_this3), type: 'radio', name: 'matrixCategory', id: "category." + category.name, defaultChecked: category.name === _this3.state.category.name, value: category.name }),
                ' ',
                _react2.default.createElement(
                  'label',
                  { htmlFor: "category." + category.name },
                  category.title
                )
              );
            })
          ) : null,
          this.props.fields.map(function (field, index) {
            return _react2.default.createElement(_Field2.default, _extends({ onChange: _this3.updateField.bind(_this3), key: index }, field, { controlled: true, value: _this3.state.value[_this3.state.category.name] !== undefined ? _this3.state.value[_this3.state.category.name][field.name] : "" }));
          })
        )
      ) : null;
    }
  }]);

  return Matrix;
}(_react2.default.Component);

exports.default = Matrix;

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(113), __webpack_require__(114)]).loadVariants([__webpack_require__(797), __webpack_require__(798), __webpack_require__(799), __webpack_require__(800)]);

var StatusItem = function (_React$Component) {
  _inherits(StatusItem, _React$Component);

  function StatusItem() {
    _classCallCheck(this, StatusItem);

    return _possibleConstructorReturn(this, (StatusItem.__proto__ || Object.getPrototypeOf(StatusItem)).apply(this, arguments));
  }

  _createClass(StatusItem, [{
    key: 'selectStatus',
    value: function selectStatus(event) {
      this.props.selectStatus(this.props.color);
      event.preventDefault();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { display: "table-row" } },
        _react2.default.createElement(
          'a',
          { onClick: this.selectStatus.bind(this), href: '#', style: { display: "table-cell" } },
          _react2.default.createElement('img', { src: this.props.imageUrl })
        ),
        _react2.default.createElement(
          'div',
          { style: Object.assign({}, { display: "table-cell" }, this.props.style) },
          this.props.description
        )
      );
    }
  }]);

  return StatusItem;
}(_react2.default.Component);

var StatusSelector = function (_React$Component2) {
  _inherits(StatusSelector, _React$Component2);

  function StatusSelector(props) {
    _classCallCheck(this, StatusSelector);

    var _this2 = _possibleConstructorReturn(this, (StatusSelector.__proto__ || Object.getPrototypeOf(StatusSelector)).call(this, props));

    _this2.state = { color: _this2.props.value !== undefined ? _this2.props.value : "green" };
    return _this2;
  }

  _createClass(StatusSelector, [{
    key: 'getStatusImage',
    value: function getStatusImage(status) {
      switch (status) {
        case "green":
          return "greenlight.png";
        case "yellow":
          return "yellowlight.png";
        case "red":
          return "redlight.png";
      }
    }
  }, {
    key: 'selectStatus',
    value: function selectStatus(color) {
      this.setState({ color: color });
      this.changeStatus(undefined);
      if (this.props.onChange !== undefined) {
        this.props.onChange({
          target: {
            name: this.props.name + "_status",
            value: color
          }
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ hideSelect: true });
    }
  }, {
    key: 'changeStatus',
    value: function changeStatus(event) {
      if (event !== undefined) {
        event.preventDefault();
      }
      this.setState({ showOptions: !this.state.showOptions });
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: this.props.style === undefined ? { float: "right" } : undefined },
          this.state.hideSelect ? _react2.default.createElement(
            'div',
            { style: { position: "relative", marginRight: 20 } },
            this.state.showOptions ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'a',
                { href: '#', onClick: this.changeStatus.bind(this) },
                _react2.default.createElement('img', { src: "/images/" + this.getStatusImage(this.state.color) })
              ),
              _react2.default.createElement('input', { type: 'hidden', name: this.props.name + "_status", value: this.state.color }),
              _react2.default.createElement(
                'div',
                { style: { display: "table", zIndex: 1, position: "absolute", textAlign: "left", top: this.props.style !== undefined ? this.props.style.top : -30, right: this.props.style !== undefined ? this.props.style.right : -20, left: this.props.style !== undefined ? this.props.style.left : undefined, width: 300, border: "solid black 1px", borderRadius: 10, backgroundColor: "lightGrey", padding: this.props.style !== undefined ? this.props.style.padding : undefined } },
                ["green", "yellow", "red"].map(function (color) {
                  return _react2.default.createElement(StatusItem, { key: color,
                    color: color,
                    imageUrl: "/images/" + this.getStatusImage(color),
                    description: labels.status[color],
                    selectStatus: this.selectStatus.bind(this),
                    style: this.props.style !== undefined ? this.props.style.item : undefined
                  });
                }.bind(this))
              )
            ) : _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'a',
                { href: '#', onClick: this.changeStatus.bind(this) },
                _react2.default.createElement('img', { src: "/images/" + this.getStatusImage(this.state.color) })
              ),
              _react2.default.createElement('input', { type: 'hidden', name: this.props.name + "_status", value: this.state.color })
            )
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'select',
              { name: this.props.name + "_status" },
              _react2.default.createElement(
                'option',
                { value: 'green' },
                'Green'
              ),
              _react2.default.createElement(
                'option',
                { value: 'yellow' },
                'Yellow'
              ),
              _react2.default.createElement(
                'option',
                { value: 'red' },
                'Red'
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { display: "inline-block", opacity: "0.4", border: "solid grey 1px", borderRadius: 10, padding: 2 } },
              _react2.default.createElement('img', { src: '/images/green_14x18.gif' }),
              _react2.default.createElement('img', { src: '/images/yellow_18x16.gif' }),
              _react2.default.createElement('img', { src: '/images/red_18x18.gif' })
            )
          )
        )
      );
    }
  }]);

  return StatusSelector;
}(_react2.default.Component);

exports.default = StatusSelector;

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var english_endStage = exports.english_endStage = {
  status: {
    green: "Completed within tolerances",
    yellow: "Issues or risks have surfaced. If not properly dealt with, the project's forecast can end up breaking the tolerances",
    red: "Broken tolerances for this stage. Exeption plan for the project might be needed."
  }
};

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var norwegian_endStage = exports.norwegian_endStage = {
  status: {
    green: "Etappen er gjennomført innenfor toleransegrensene",
    yellow: "Saker eller risiko har oppstått. Hvis det ikke blir håndtert vil prosjektets prognose ende opp med å overskride toleransegrensene",
    red: "Etappen har overskredet toleransegrensene. En unntaksplan for prosjektet er muligens nødvendig."
  }
};

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var english_endProject = exports.english_endProject = {
  status: {
    green: "The project delivered within tolerances",
    yellow: "The project mostly delivered within tolerances and few exception plans were needed.",
    red: "The project broke tolerances repeatedly and many exception plans were needed."
  }
};

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var norwegian_endProject = exports.norwegian_endProject = {
  status: {
    green: "Prosjektet er levert innenfor toleransegrensene.",
    yellow: "Prosjektet er hovedsaklig levert innenfor toleransegrensene, men noen få unntaksplaner har vært nødvendig.",
    red: "Prosjektet har brutt toleransegrensene flere ganger og mange unntaksplaner har vært nødvendig."
  }
};

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _FormattedContent = __webpack_require__(15);

var _FormattedContent2 = _interopRequireDefault(_FormattedContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ActivityStatusOld = function (_React$Component) {
  _inherits(ActivityStatusOld, _React$Component);

  function ActivityStatusOld() {
    _classCallCheck(this, ActivityStatusOld);

    return _possibleConstructorReturn(this, (ActivityStatusOld.__proto__ || Object.getPrototypeOf(ActivityStatusOld)).apply(this, arguments));
  }

  _createClass(ActivityStatusOld, [{
    key: 'render',
    value: function render() {
      var statusColor = this.props.status === "done" ? "#4b9e39" : this.props.status === "inProgress" ? "#fed400" : undefined;
      return _react2.default.createElement(
        'a',
        { style: { color: "black", textDecoration: "none", margin: 10 }, href: this.props.url },
        _react2.default.createElement(
          'div',
          { style: { color: this.props.status === "notSupported" ? "lightgrey" : "black", marginBottom: 40, textAlign: "center", padding: 15, borderRadius: 50, border: "solid grey 2px", backgroundColor: statusColor } },
          _react2.default.createElement(
            'div',
            { style: { textAlign: "center", width: 225, height: 40, display: "table-cell", verticalAlign: "middle" } },
            this.props.title !== undefined ? this.props.title : ".(" + this.props.name + ")"
          )
        )
      );
    }
  }]);

  return ActivityStatusOld;
}(_react2.default.Component);

var ActivityStatusChecklist = function (_React$Component2) {
  _inherits(ActivityStatusChecklist, _React$Component2);

  function ActivityStatusChecklist(props) {
    _classCallCheck(this, ActivityStatusChecklist);

    var _this2 = _possibleConstructorReturn(this, (ActivityStatusChecklist.__proto__ || Object.getPrototypeOf(ActivityStatusChecklist)).call(this, props));

    _this2.state = { showHelp: false };
    return _this2;
  }

  _createClass(ActivityStatusChecklist, [{
    key: 'toggleHelp',
    value: function toggleHelp(event) {
      event.preventDefault();
      this.setState({ showHelp: !this.state.showHelp });
    }
  }, {
    key: 'render',
    value: function render() {
      var statusColor = this.props.status === "done" ? "#4b9e39" : this.props.status === "inProgress" ? "#fed400" : undefined;
      return _react2.default.createElement(
        'div',
        { style: { width: "48%", paddingBottom: 15 } },
        _react2.default.createElement(
          'span',
          { style: { display: "inline-block", verticalAlign: "bottom", borderRadius: "50%", border: "solid 1px " + (this.props.status === "notSupported" ? "lightgrey" : "black"), width: "1em", height: "1em", backgroundColor: statusColor } },
          ' '
        ),
        _react2.default.createElement(
          'span',
          null,
          ' '
        ),
        _react2.default.createElement(
          'a',
          { style: { color: this.props.status === "notSupported" ? "lightgrey" : "black" }, href: this.props.url },
          this.props.title !== undefined ? this.props.title : ".(" + this.props.name + ")"
        ),
        this.props.help !== undefined ? _react2.default.createElement(
          'span',
          { style: { paddingLeft: 10, fontWeight: "normal", cursor: "pointer" }, onClick: this.toggleHelp.bind(this) },
          _react2.default.createElement('img', { src: '/icons/help.png' })
        ) : null,
        this.state.showHelp ? _react2.default.createElement(
          'div',
          { style: { paddingLeft: 10, paddingTop: 5, paddingBottom: 5, fontStyle: "italic" } },
          _react2.default.createElement(_FormattedContent2.default, { value: this.props.help })
        ) : null
      );
    }
  }]);

  return ActivityStatusChecklist;
}(_react2.default.Component);

var ActivityStatus = function (_React$Component3) {
  _inherits(ActivityStatus, _React$Component3);

  function ActivityStatus() {
    _classCallCheck(this, ActivityStatus);

    return _possibleConstructorReturn(this, (ActivityStatus.__proto__ || Object.getPrototypeOf(ActivityStatus)).apply(this, arguments));
  }

  _createClass(ActivityStatus, [{
    key: 'render',
    value: function render() {
      return false ? _react2.default.createElement(ActivityStatusOld, this.props) : _react2.default.createElement(ActivityStatusChecklist, this.props);
    }
  }]);

  return ActivityStatus;
}(_react2.default.Component);

var ProcessView = function (_React$Component4) {
  _inherits(ProcessView, _React$Component4);

  function ProcessView() {
    _classCallCheck(this, ProcessView);

    return _possibleConstructorReturn(this, (ProcessView.__proto__ || Object.getPrototypeOf(ProcessView)).apply(this, arguments));
  }

  _createClass(ProcessView, [{
    key: 'render',
    value: function render() {
      var _this5 = this;

      var labels = this.props.labels;
      var activities = this.props.value.activities;
      return _react2.default.createElement(
        'div',
        { style: { fontFamily: "Lato, Arial" } },
        _react2.default.createElement(
          'div',
          { style: { maxWidth: 1016, marginLeft: 60, paddingTop: 10, display: "flex", flexWrap: "wrap", justifyContent: "space-between" } },
          activities.map(function (activity) {
            return _react2.default.createElement(ActivityStatus, {
              key: activity.name,
              name: activity.name,
              title: labels !== undefined && labels.activities[activity.name] !== undefined ? labels.activities[activity.name].title : undefined,
              help: labels !== undefined && labels.activities[activity.name] !== undefined ? labels.activities[activity.name].help : undefined,
              status: activity.status,
              url: (_this5.props.project.isProgramme ? "/programmes/" : "/projects/") + _this5.props.project.id + activity.link
            });
          })
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "flex", paddingTop: 25, marginRight: 80, justifyContent: "space-between" } },
          this.props.value.cancel !== undefined ? _react2.default.createElement(
            'div',
            { style: { paddingTop: 10 } },
            _react2.default.createElement(
              'a',
              { style: { color: "black" }, href: this.props.value.cancel.link },
              labels !== undefined && labels.cancel !== undefined ? labels.cancel.title : ".(cancel)"
            )
          ) : _react2.default.createElement('div', null),
          this.props.value.nextStep !== undefined ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'a',
              { style: { color: "black", textDecoration: "none" }, href: this.props.value.nextStep.link },
              _react2.default.createElement(
                'div',
                { style: {
                    textAlign: "center",
                    border: "2px solid #2B809D",
                    backgroundColor: "#ffffff",
                    borderRadius: 8,
                    color: "#266980",
                    height: 40,
                    fontFamily: "Lato, Arial",
                    fontSize: "19px",
                    fontWeight: "bold",
                    padding: "5px",
                    paddingLeft: "20px",
                    paddingRight: "20px",
                    lineHeight: "23px",
                    boxSizing: "border-box",

                    position: "relative" } },
                _react2.default.createElement(
                  'div',
                  null,
                  labels !== undefined && labels.nextStep !== undefined ? labels.nextStep.title : ".(nextStep)"
                )
              )
            )
          ) : _react2.default.createElement('div', null)
        )
      );
    }
  }]);

  return ProcessView;
}(_react2.default.Component);

exports.default = ProcessView;

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _draftJs = __webpack_require__(38);

var _draftJsPluginsEditor = __webpack_require__(968);

var _draftJsPluginsEditor2 = _interopRequireDefault(_draftJsPluginsEditor);

var _draftJsInlineToolbarPlugin = __webpack_require__(980);

var _draftJsInlineToolbarPlugin2 = _interopRequireDefault(_draftJsInlineToolbarPlugin);

var _draftJsAnchorPlugin = __webpack_require__(1001);

var _draftJsAnchorPlugin2 = _interopRequireDefault(_draftJsAnchorPlugin);

var _draftJsButtons = __webpack_require__(410);

var _draftJsExportHtml = __webpack_require__(1011);

var _draftJsImportHtml = __webpack_require__(1019);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//Copied from FormattedContent
function translateToHTML(content) {
  return content !== undefined && content !== null ? content.startsWith("<p>") ? content : content.replace(/\*/g, "<li/>").replace(/\r\n/g, "<br/>").replace(/\n/g, "<br/>") : "";
}

var RichTextEditor = function (_React$Component) {
  _inherits(RichTextEditor, _React$Component);

  function RichTextEditor(props) {
    _classCallCheck(this, RichTextEditor);

    var _this = _possibleConstructorReturn(this, (RichTextEditor.__proto__ || Object.getPrototypeOf(RichTextEditor)).call(this, props));

    var htmlContent;
    try {
      htmlContent = (0, _draftJsImportHtml.stateFromHTML)(translateToHTML(props.value));
    } catch (error) {}
    _this.state = {
      editorState: props.value !== undefined ? _draftJs.EditorState.createWithContent(htmlContent !== undefined ? htmlContent : _draftJs.ContentState.createFromText(props.value)) : _draftJs.EditorState.createEmpty()
    };
    _this.onChange = function (editorState) {
      _this.setState({ editorState: editorState }, function () {
        var formattedContent = _this.state.editorState.getCurrentContent().hasText() ? (0, _draftJsExportHtml.stateToHTML)(_this.state.editorState.getCurrentContent()) : ""; // this.state.editorState.getCurrentContent().getPlainText();
        if (_this.props.onChange !== undefined) {
          if ((_this.props.value === undefined && formattedContent !== "" || _this.props.value !== undefined) && _this.props.value !== formattedContent) {
            _this.props.onChange({ target: {
                name: _this.props.name,
                value: formattedContent
              } });
          }
        }
        if (_this._content !== undefined) {
          _this._content.value = formattedContent;
        }
      });
    };

    _this._linkPlugin = (0, _draftJsAnchorPlugin2.default)();
    _this._inlineToolbarPlugin = (0, _draftJsInlineToolbarPlugin2.default)();
    return _this;
  }

  _createClass(RichTextEditor, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var isEmpty = (0, _draftJsExportHtml.stateToHTML)(this.state.editorState.getCurrentContent()) === "<p><br></p>";
      return _react2.default.createElement(
        'div',
        { className: 'richTextEditor', style: Object.assign({}, this.props.style, { position: "relative", zIndex: 0 }) },
        isEmpty ? _react2.default.createElement(
          'div',
          { style: { paddingTop: 7, zIndex: -1, position: "absolute", color: "grey", userSelect: "none" } },
          this.props.help
        ) : null,
        _react2.default.createElement(_draftJsPluginsEditor2.default, {
          editorState: this.state.editorState,
          onChange: this.onChange,
          plugins: [this._inlineToolbarPlugin, this._linkPlugin],
          spellCheck: true
        }),
        isEmpty ? _react2.default.createElement(
          'div',
          { style: { zIndex: 0, visibility: "hidden" } },
          this.props.help
        ) : null,
        _react2.default.createElement(
          this._inlineToolbarPlugin.InlineToolbar,
          null,
          function (externalProps) {
            return _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_draftJsButtons.BoldButton, externalProps),
              _react2.default.createElement(_draftJsButtons.ItalicButton, externalProps),
              _react2.default.createElement(_draftJsButtons.UnderlineButton, externalProps),
              _react2.default.createElement(_this2._linkPlugin.LinkButton, externalProps),
              _react2.default.createElement(_draftJsInlineToolbarPlugin.Separator, externalProps),
              _react2.default.createElement(_draftJsButtons.UnorderedListButton, externalProps),
              _react2.default.createElement(_draftJsButtons.OrderedListButton, externalProps)
            );
          }
        ),
        _react2.default.createElement('textarea', { ref: function ref(_ref) {
            return _this2._content = _ref;
          }, type: 'hidden', style: { display: "none", width: "100%", color: "grey", marginTop: 10, height: 150 }, readOnly: true, name: this.props.name, defaultValue: this.state.editorState.getCurrentContent().getPlainText() })
      );
    }
  }]);

  return RichTextEditor;
}(_react2.default.Component);

exports.default = RichTextEditor;

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BlockMapBuilder = __webpack_require__(120);

var CharacterMetadata = __webpack_require__(43);

var ContentBlock = __webpack_require__(88);

var ContentBlockNode = __webpack_require__(44);

var DraftModifier = __webpack_require__(29);

var EditorState = __webpack_require__(13);

var generateRandomKey = __webpack_require__(57);

var gkx = __webpack_require__(70);

var Immutable = __webpack_require__(4);

var moveBlockInContentState = __webpack_require__(818);

var experimentalTreeDataSupport = gkx('draft_tree_data_support');
var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
var List = Immutable.List,
    Repeat = Immutable.Repeat;
var AtomicBlockUtils = {
  insertAtomicBlock: function insertAtomicBlock(editorState, entityKey, character) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();
    var afterRemoval = DraftModifier.removeRange(contentState, selectionState, 'backward');
    var targetSelection = afterRemoval.getSelectionAfter();
    var afterSplit = DraftModifier.splitBlock(afterRemoval, targetSelection);
    var insertionTarget = afterSplit.getSelectionAfter();
    var asAtomicBlock = DraftModifier.setBlockType(afterSplit, insertionTarget, 'atomic');
    var charData = CharacterMetadata.create({
      entity: entityKey
    });
    var atomicBlockConfig = {
      key: generateRandomKey(),
      type: 'atomic',
      text: character,
      characterList: List(Repeat(charData, character.length))
    };
    var atomicDividerBlockConfig = {
      key: generateRandomKey(),
      type: 'unstyled'
    };

    if (experimentalTreeDataSupport) {
      atomicBlockConfig = _objectSpread({}, atomicBlockConfig, {
        nextSibling: atomicDividerBlockConfig.key
      });
      atomicDividerBlockConfig = _objectSpread({}, atomicDividerBlockConfig, {
        prevSibling: atomicBlockConfig.key
      });
    }

    var fragmentArray = [new ContentBlockRecord(atomicBlockConfig), new ContentBlockRecord(atomicDividerBlockConfig)];
    var fragment = BlockMapBuilder.createFromArray(fragmentArray);
    var withAtomicBlock = DraftModifier.replaceWithFragment(asAtomicBlock, insertionTarget, fragment);
    var newContent = withAtomicBlock.merge({
      selectionBefore: selectionState,
      selectionAfter: withAtomicBlock.getSelectionAfter().set('hasFocus', true)
    });
    return EditorState.push(editorState, newContent, 'insert-fragment');
  },
  moveAtomicBlock: function moveAtomicBlock(editorState, atomicBlock, targetRange, insertionMode) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();
    var withMovedAtomicBlock;

    if (insertionMode === 'before' || insertionMode === 'after') {
      var targetBlock = contentState.getBlockForKey(insertionMode === 'before' ? targetRange.getStartKey() : targetRange.getEndKey());
      withMovedAtomicBlock = moveBlockInContentState(contentState, atomicBlock, targetBlock, insertionMode);
    } else {
      var afterRemoval = DraftModifier.removeRange(contentState, targetRange, 'backward');
      var selectionAfterRemoval = afterRemoval.getSelectionAfter();

      var _targetBlock = afterRemoval.getBlockForKey(selectionAfterRemoval.getFocusKey());

      if (selectionAfterRemoval.getStartOffset() === 0) {
        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'before');
      } else if (selectionAfterRemoval.getEndOffset() === _targetBlock.getLength()) {
        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'after');
      } else {
        var afterSplit = DraftModifier.splitBlock(afterRemoval, selectionAfterRemoval);
        var selectionAfterSplit = afterSplit.getSelectionAfter();

        var _targetBlock2 = afterSplit.getBlockForKey(selectionAfterSplit.getFocusKey());

        withMovedAtomicBlock = moveBlockInContentState(afterSplit, atomicBlock, _targetBlock2, 'before');
      }
    }

    var newContent = withMovedAtomicBlock.merge({
      selectionBefore: selectionState,
      selectionAfter: withMovedAtomicBlock.getSelectionAfter().set('hasFocus', true)
    });
    return EditorState.push(editorState, newContent, 'move-block');
  }
};
module.exports = AtomicBlockUtils;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var CharacterMetadata = __webpack_require__(43);

var _require = __webpack_require__(4),
    Map = _require.Map;

var ContentStateInlineStyle = {
  add: function add(contentState, selectionState, inlineStyle) {
    return modifyInlineStyle(contentState, selectionState, inlineStyle, true);
  },
  remove: function remove(contentState, selectionState, inlineStyle) {
    return modifyInlineStyle(contentState, selectionState, inlineStyle, false);
  }
};

function modifyInlineStyle(contentState, selectionState, inlineStyle, addOrRemove) {
  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var newBlocks = blockMap.skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
    var sliceStart;
    var sliceEnd;

    if (startKey === endKey) {
      sliceStart = startOffset;
      sliceEnd = endOffset;
    } else {
      sliceStart = blockKey === startKey ? startOffset : 0;
      sliceEnd = blockKey === endKey ? endOffset : block.getLength();
    }

    var chars = block.getCharacterList();
    var current;

    while (sliceStart < sliceEnd) {
      current = chars.get(sliceStart);
      chars = chars.set(sliceStart, addOrRemove ? CharacterMetadata.applyStyle(current, inlineStyle) : CharacterMetadata.removeStyle(current, inlineStyle));
      sliceStart++;
    }

    return block.set('characterList', chars);
  });
  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = ContentStateInlineStyle;

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var applyEntityToContentBlock = __webpack_require__(806);

var Immutable = __webpack_require__(4);

function applyEntityToContentState(contentState, selectionState, entityKey) {
  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var newBlocks = blockMap.skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).toOrderedMap().merge(Immutable.OrderedMap([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
    var sliceStart = blockKey === startKey ? startOffset : 0;
    var sliceEnd = blockKey === endKey ? endOffset : block.getLength();
    return applyEntityToContentBlock(block, sliceStart, sliceEnd, entityKey);
  });
  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = applyEntityToContentState;

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var CharacterMetadata = __webpack_require__(43);

function applyEntityToContentBlock(contentBlock, startArg, end, entityKey) {
  var start = startArg;
  var characterList = contentBlock.getCharacterList();

  while (start < end) {
    characterList = characterList.set(start, CharacterMetadata.applyEntity(characterList.get(start), entityKey));
    start++;
  }

  return contentBlock.set('characterList', characterList);
}

module.exports = applyEntityToContentBlock;

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftEntitySegments = __webpack_require__(808);

var getRangesForDraftEntity = __webpack_require__(809);

var invariant = __webpack_require__(9);
/**
 * Given a SelectionState and a removal direction, determine the entire range
 * that should be removed from a ContentState. This is based on any entities
 * within the target, with their `mutability` values taken into account.
 *
 * For instance, if we are attempting to remove part of an "immutable" entity
 * range, the entire entity must be removed. The returned `SelectionState`
 * will be adjusted accordingly.
 */


function getCharacterRemovalRange(entityMap, startBlock, endBlock, selectionState, direction) {
  var start = selectionState.getStartOffset();
  var end = selectionState.getEndOffset();
  var startEntityKey = startBlock.getEntityAt(start);
  var endEntityKey = endBlock.getEntityAt(end - 1);

  if (!startEntityKey && !endEntityKey) {
    return selectionState;
  }

  var newSelectionState = selectionState;

  if (startEntityKey && startEntityKey === endEntityKey) {
    newSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, true, true);
  } else if (startEntityKey && endEntityKey) {
    var startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
    var endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
    newSelectionState = newSelectionState.merge({
      anchorOffset: startSelectionState.getAnchorOffset(),
      focusOffset: endSelectionState.getFocusOffset(),
      isBackward: false
    });
  } else if (startEntityKey) {
    var _startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);

    newSelectionState = newSelectionState.merge({
      anchorOffset: _startSelectionState.getStartOffset(),
      isBackward: false
    });
  } else if (endEntityKey) {
    var _endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);

    newSelectionState = newSelectionState.merge({
      focusOffset: _endSelectionState.getEndOffset(),
      isBackward: false
    });
  }

  return newSelectionState;
}

function getEntityRemovalRange(entityMap, block, selectionState, direction, entityKey, isEntireSelectionWithinEntity, isEntityAtStart) {
  var start = selectionState.getStartOffset();
  var end = selectionState.getEndOffset();

  var entity = entityMap.__get(entityKey);

  var mutability = entity.getMutability();
  var sideToConsider = isEntityAtStart ? start : end; // `MUTABLE` entities can just have the specified range of text removed
  // directly. No adjustments are needed.

  if (mutability === 'MUTABLE') {
    return selectionState;
  } // Find the entity range that overlaps with our removal range.


  var entityRanges = getRangesForDraftEntity(block, entityKey).filter(function (range) {
    return sideToConsider <= range.end && sideToConsider >= range.start;
  });
  !(entityRanges.length == 1) ?  false ? invariant(false, 'There should only be one entity range within this removal range.') : invariant(false) : void 0;
  var entityRange = entityRanges[0]; // For `IMMUTABLE` entity types, we will remove the entire entity range.

  if (mutability === 'IMMUTABLE') {
    return selectionState.merge({
      anchorOffset: entityRange.start,
      focusOffset: entityRange.end,
      isBackward: false
    });
  } // For `SEGMENTED` entity types, determine the appropriate segment to
  // remove.


  if (!isEntireSelectionWithinEntity) {
    if (isEntityAtStart) {
      end = entityRange.end;
    } else {
      start = entityRange.start;
    }
  }

  var removalRange = DraftEntitySegments.getRemovalRange(start, end, block.getText().slice(entityRange.start, entityRange.end), entityRange.start, direction);
  return selectionState.merge({
    anchorOffset: removalRange.start,
    focusOffset: removalRange.end,
    isBackward: false
  });
}

module.exports = getCharacterRemovalRange;

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


/**
 * Identify the range to delete from a segmented entity.
 *
 * Rules:
 *
 *  Example: 'John F. Kennedy'
 *
 *   - Deletion from within any non-whitespace (i.e. ['John', 'F.', 'Kennedy'])
 *     will return the range of that text.
 *
 *       'John F. Kennedy' -> 'John F.'
 *                  ^
 *
 *   - Forward deletion of whitespace will remove the following section:
 *
 *       'John F. Kennedy' -> 'John Kennedy'
 *            ^
 *
 *   - Backward deletion of whitespace will remove the previous section:
 *
 *       'John F. Kennedy' -> 'F. Kennedy'
 *            ^
 */
var DraftEntitySegments = {
  getRemovalRange: function getRemovalRange(selectionStart, selectionEnd, text, entityStart, direction) {
    var segments = text.split(' ');
    segments = segments.map(function (
    /*string*/
    segment,
    /*number*/
    ii) {
      if (direction === 'forward') {
        if (ii > 0) {
          return ' ' + segment;
        }
      } else if (ii < segments.length - 1) {
        return segment + ' ';
      }

      return segment;
    });
    var segmentStart = entityStart;
    var segmentEnd;
    var segment;
    var removalStart = null;
    var removalEnd = null;

    for (var jj = 0; jj < segments.length; jj++) {
      segment = segments[jj];
      segmentEnd = segmentStart + segment.length; // Our selection overlaps this segment.

      if (selectionStart < segmentEnd && segmentStart < selectionEnd) {
        if (removalStart !== null) {
          removalEnd = segmentEnd;
        } else {
          removalStart = segmentStart;
          removalEnd = segmentEnd;
        }
      } else if (removalStart !== null) {
        break;
      }

      segmentStart = segmentEnd;
    }

    var entityEnd = entityStart + text.length;
    var atStart = removalStart === entityStart;
    var atEnd = removalEnd === entityEnd;

    if (!atStart && atEnd || atStart && !atEnd) {
      if (direction === 'forward') {
        if (removalEnd !== entityEnd) {
          removalEnd++;
        }
      } else if (removalStart !== entityStart) {
        removalStart--;
      }
    }

    return {
      start: removalStart,
      end: removalEnd
    };
  }
};
module.exports = DraftEntitySegments;

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var invariant = __webpack_require__(9);
/**
 * Obtain the start and end positions of the range that has the
 * specified entity applied to it.
 *
 * Entity keys are applied only to contiguous stretches of text, so this
 * method searches for the first instance of the entity key and returns
 * the subsequent range.
 */


function getRangesForDraftEntity(block, key) {
  var ranges = [];
  block.findEntityRanges(function (c) {
    return c.getEntity() === key;
  }, function (start, end) {
    ranges.push({
      start: start,
      end: end
    });
  });
  !!!ranges.length ?  false ? invariant(false, 'Entity key not found in this range.') : invariant(false) : void 0;
  return ranges;
}

module.exports = getRangesForDraftEntity;

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var BlockMapBuilder = __webpack_require__(120);

var ContentBlockNode = __webpack_require__(44);

var Immutable = __webpack_require__(4);

var insertIntoList = __webpack_require__(343);

var invariant = __webpack_require__(9);

var randomizeBlockMapKeys = __webpack_require__(341);

var List = Immutable.List;

var updateExistingBlock = function updateExistingBlock(contentState, selectionState, blockMap, fragmentBlock, targetKey, targetOffset) {
  var mergeBlockData = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'REPLACE_WITH_NEW_DATA';
  var targetBlock = blockMap.get(targetKey);
  var text = targetBlock.getText();
  var chars = targetBlock.getCharacterList();
  var finalKey = targetKey;
  var finalOffset = targetOffset + fragmentBlock.getText().length;
  var data = null;

  switch (mergeBlockData) {
    case 'MERGE_OLD_DATA_TO_NEW_DATA':
      data = fragmentBlock.getData().merge(targetBlock.getData());
      break;

    case 'REPLACE_WITH_NEW_DATA':
      data = fragmentBlock.getData();
      break;
  }

  var type = targetBlock.getType();

  if (text && type === 'unstyled') {
    type = fragmentBlock.getType();
  }

  var newBlock = targetBlock.merge({
    text: text.slice(0, targetOffset) + fragmentBlock.getText() + text.slice(targetOffset),
    characterList: insertIntoList(chars, fragmentBlock.getCharacterList(), targetOffset),
    type: type,
    data: data
  });
  return contentState.merge({
    blockMap: blockMap.set(targetKey, newBlock),
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: finalKey,
      anchorOffset: finalOffset,
      focusKey: finalKey,
      focusOffset: finalOffset,
      isBackward: false
    })
  });
};
/**
 * Appends text/characterList from the fragment first block to
 * target block.
 */


var updateHead = function updateHead(block, targetOffset, fragment) {
  var text = block.getText();
  var chars = block.getCharacterList(); // Modify head portion of block.

  var headText = text.slice(0, targetOffset);
  var headCharacters = chars.slice(0, targetOffset);
  var appendToHead = fragment.first();
  return block.merge({
    text: headText + appendToHead.getText(),
    characterList: headCharacters.concat(appendToHead.getCharacterList()),
    type: headText ? block.getType() : appendToHead.getType(),
    data: appendToHead.getData()
  });
};
/**
 * Appends offset text/characterList from the target block to the last
 * fragment block.
 */


var updateTail = function updateTail(block, targetOffset, fragment) {
  // Modify tail portion of block.
  var text = block.getText();
  var chars = block.getCharacterList(); // Modify head portion of block.

  var blockSize = text.length;
  var tailText = text.slice(targetOffset, blockSize);
  var tailCharacters = chars.slice(targetOffset, blockSize);
  var prependToTail = fragment.last();
  return prependToTail.merge({
    text: prependToTail.getText() + tailText,
    characterList: prependToTail.getCharacterList().concat(tailCharacters),
    data: prependToTail.getData()
  });
};

var getRootBlocks = function getRootBlocks(block, blockMap) {
  var headKey = block.getKey();
  var rootBlock = block;
  var rootBlocks = []; // sometimes the fragment head block will not be part of the blockMap itself this can happen when
  // the fragment head is used to update the target block, however when this does not happen we need
  // to make sure that we include it on the rootBlocks since the first block of a fragment is always a
  // fragment root block

  if (blockMap.get(headKey)) {
    rootBlocks.push(headKey);
  }

  while (rootBlock && rootBlock.getNextSiblingKey()) {
    var lastSiblingKey = rootBlock.getNextSiblingKey();

    if (!lastSiblingKey) {
      break;
    }

    rootBlocks.push(lastSiblingKey);
    rootBlock = blockMap.get(lastSiblingKey);
  }

  return rootBlocks;
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockMap, targetBlock, fragmentHeadBlock) {
  return blockMap.withMutations(function (blockMapState) {
    var targetKey = targetBlock.getKey();
    var headKey = fragmentHeadBlock.getKey();
    var targetNextKey = targetBlock.getNextSiblingKey();
    var targetParentKey = targetBlock.getParentKey();
    var fragmentRootBlocks = getRootBlocks(fragmentHeadBlock, blockMap);
    var lastRootFragmentBlockKey = fragmentRootBlocks[fragmentRootBlocks.length - 1];

    if (blockMapState.get(headKey)) {
      // update the fragment head when it is part of the blockMap otherwise
      blockMapState.setIn([targetKey, 'nextSibling'], headKey);
      blockMapState.setIn([headKey, 'prevSibling'], targetKey);
    } else {
      // update the target block that had the fragment head contents merged into it
      blockMapState.setIn([targetKey, 'nextSibling'], fragmentHeadBlock.getNextSiblingKey());
      blockMapState.setIn([fragmentHeadBlock.getNextSiblingKey(), 'prevSibling'], targetKey);
    } // update the last root block fragment


    blockMapState.setIn([lastRootFragmentBlockKey, 'nextSibling'], targetNextKey); // update the original target next block

    if (targetNextKey) {
      blockMapState.setIn([targetNextKey, 'prevSibling'], lastRootFragmentBlockKey);
    } // update fragment parent links


    fragmentRootBlocks.forEach(function (blockKey) {
      return blockMapState.setIn([blockKey, 'parent'], targetParentKey);
    }); // update targetBlock parent child links

    if (targetParentKey) {
      var targetParent = blockMap.get(targetParentKey);
      var originalTargetParentChildKeys = targetParent.getChildKeys();
      var targetBlockIndex = originalTargetParentChildKeys.indexOf(targetKey);
      var insertionIndex = targetBlockIndex + 1;
      var newChildrenKeysArray = originalTargetParentChildKeys.toArray(); // insert fragment children

      newChildrenKeysArray.splice.apply(newChildrenKeysArray, [insertionIndex, 0].concat(fragmentRootBlocks));
      blockMapState.setIn([targetParentKey, 'children'], List(newChildrenKeysArray));
    }
  });
};

var insertFragment = function insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset) {
  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;
  var newBlockArr = [];
  var fragmentSize = fragment.size;
  var target = blockMap.get(targetKey);
  var head = fragment.first();
  var tail = fragment.last();
  var finalOffset = tail.getLength();
  var finalKey = tail.getKey();
  var shouldNotUpdateFromFragmentBlock = isTreeBasedBlockMap && (!target.getChildKeys().isEmpty() || !head.getChildKeys().isEmpty());
  blockMap.forEach(function (block, blockKey) {
    if (blockKey !== targetKey) {
      newBlockArr.push(block);
      return;
    }

    if (shouldNotUpdateFromFragmentBlock) {
      newBlockArr.push(block);
    } else {
      newBlockArr.push(updateHead(block, targetOffset, fragment));
    } // Insert fragment blocks after the head and before the tail.


    fragment // when we are updating the target block with the head fragment block we skip the first fragment
    // head since its contents have already been merged with the target block otherwise we include
    // the whole fragment
    .slice(shouldNotUpdateFromFragmentBlock ? 0 : 1, fragmentSize - 1).forEach(function (fragmentBlock) {
      return newBlockArr.push(fragmentBlock);
    }); // update tail

    newBlockArr.push(updateTail(block, targetOffset, fragment));
  });
  var updatedBlockMap = BlockMapBuilder.createFromArray(newBlockArr);

  if (isTreeBasedBlockMap) {
    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, blockMap, target, head);
  }

  return contentState.merge({
    blockMap: updatedBlockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: finalKey,
      anchorOffset: finalOffset,
      focusKey: finalKey,
      focusOffset: finalOffset,
      isBackward: false
    })
  });
};

var insertFragmentIntoContentState = function insertFragmentIntoContentState(contentState, selectionState, fragmentBlockMap) {
  var mergeBlockData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'REPLACE_WITH_NEW_DATA';
  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertFragment` should only be called with a collapsed selection state.') : invariant(false) : void 0;
  var blockMap = contentState.getBlockMap();
  var fragment = randomizeBlockMapKeys(fragmentBlockMap);
  var targetKey = selectionState.getStartKey();
  var targetOffset = selectionState.getStartOffset();
  var targetBlock = blockMap.get(targetKey);

  if (targetBlock instanceof ContentBlockNode) {
    !targetBlock.getChildKeys().isEmpty() ?  false ? invariant(false, '`insertFragment` should not be called when a container node is selected.') : invariant(false) : void 0;
  } // When we insert a fragment with a single block we simply update the target block
  // with the contents of the inserted fragment block


  if (fragment.size === 1) {
    return updateExistingBlock(contentState, selectionState, blockMap, fragment.first(), targetKey, targetOffset, mergeBlockData);
  }

  return insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset);
};

module.exports = insertFragmentIntoContentState;

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var Immutable = __webpack_require__(4);

var insertIntoList = __webpack_require__(343);

var invariant = __webpack_require__(9);

var Repeat = Immutable.Repeat;

function insertTextIntoContentState(contentState, selectionState, text, characterMetadata) {
  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertText` should only be called with a collapsed range.') : invariant(false) : void 0;
  var len = null;

  if (text != null) {
    len = text.length;
  }

  if (len == null || len === 0) {
    return contentState;
  }

  var blockMap = contentState.getBlockMap();
  var key = selectionState.getStartKey();
  var offset = selectionState.getStartOffset();
  var block = blockMap.get(key);
  var blockText = block.getText();
  var newBlock = block.merge({
    text: blockText.slice(0, offset) + text + blockText.slice(offset, block.getLength()),
    characterList: insertIntoList(block.getCharacterList(), Repeat(characterMetadata, len).toList(), offset)
  });
  var newOffset = offset + len;
  return contentState.merge({
    blockMap: blockMap.set(key, newBlock),
    selectionAfter: selectionState.merge({
      anchorOffset: newOffset,
      focusOffset: newOffset
    })
  });
}

module.exports = insertTextIntoContentState;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var ContentBlockNode = __webpack_require__(44);

var getNextDelimiterBlockKey = __webpack_require__(345);

var Immutable = __webpack_require__(4);

var List = Immutable.List,
    Map = Immutable.Map;

var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};
/**
 * Ancestors needs to be preserved when there are non selected
 * children to make sure we do not leave any orphans behind
 */


var getAncestorsKeys = function getAncestorsKeys(blockKey, blockMap) {
  var parents = [];

  if (!blockKey) {
    return parents;
  }

  var blockNode = blockMap.get(blockKey);

  while (blockNode && blockNode.getParentKey()) {
    var parentKey = blockNode.getParentKey();

    if (parentKey) {
      parents.push(parentKey);
    }

    blockNode = parentKey ? blockMap.get(parentKey) : null;
  }

  return parents;
};
/**
 * Get all next delimiter keys until we hit a root delimiter and return
 * an array of key references
 */


var getNextDelimitersBlockKeys = function getNextDelimitersBlockKeys(block, blockMap) {
  var nextDelimiters = [];

  if (!block) {
    return nextDelimiters;
  }

  var nextDelimiter = getNextDelimiterBlockKey(block, blockMap);

  while (nextDelimiter && blockMap.get(nextDelimiter)) {
    var _block = blockMap.get(nextDelimiter);

    nextDelimiters.push(nextDelimiter); // we do not need to keep checking all root node siblings, just the first occurance

    nextDelimiter = _block.getParentKey() ? getNextDelimiterBlockKey(_block, blockMap) : null;
  }

  return nextDelimiters;
};

var getNextValidSibling = function getNextValidSibling(block, blockMap, originalBlockMap) {
  if (!block) {
    return null;
  } // note that we need to make sure we refer to the original block since this
  // function is called within a withMutations


  var nextValidSiblingKey = originalBlockMap.get(block.getKey()).getNextSiblingKey();

  while (nextValidSiblingKey && !blockMap.get(nextValidSiblingKey)) {
    nextValidSiblingKey = originalBlockMap.get(nextValidSiblingKey).getNextSiblingKey() || null;
  }

  return nextValidSiblingKey;
};

var getPrevValidSibling = function getPrevValidSibling(block, blockMap, originalBlockMap) {
  if (!block) {
    return null;
  } // note that we need to make sure we refer to the original block since this
  // function is called within a withMutations


  var prevValidSiblingKey = originalBlockMap.get(block.getKey()).getPrevSiblingKey();

  while (prevValidSiblingKey && !blockMap.get(prevValidSiblingKey)) {
    prevValidSiblingKey = originalBlockMap.get(prevValidSiblingKey).getPrevSiblingKey() || null;
  }

  return prevValidSiblingKey;
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, startBlock, endBlock, originalBlockMap) {
  return blockMap.withMutations(function (blocks) {
    // update start block if its retained
    transformBlock(startBlock.getKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
        prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
      });
    }); // update endblock if its retained

    transformBlock(endBlock.getKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
        prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
      });
    }); // update start block parent ancestors

    getAncestorsKeys(startBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
      return transformBlock(parentKey, blocks, function (block) {
        return block.merge({
          children: block.getChildKeys().filter(function (key) {
            return blocks.get(key);
          }),
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    }); // update start block next - can only happen if startBlock == endBlock

    transformBlock(startBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: startBlock.getPrevSiblingKey()
      });
    }); // update start block prev

    transformBlock(startBlock.getPrevSiblingKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(block, blocks, originalBlockMap)
      });
    }); // update end block next

    transformBlock(endBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
      });
    }); // update end block prev

    transformBlock(endBlock.getPrevSiblingKey(), blocks, function (block) {
      return block.merge({
        nextSibling: endBlock.getNextSiblingKey()
      });
    }); // update end block parent ancestors

    getAncestorsKeys(endBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
      transformBlock(parentKey, blocks, function (block) {
        return block.merge({
          children: block.getChildKeys().filter(function (key) {
            return blocks.get(key);
          }),
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    }); // update next delimiters all the way to a root delimiter

    getNextDelimitersBlockKeys(endBlock, originalBlockMap).forEach(function (delimiterKey) {
      return transformBlock(delimiterKey, blocks, function (block) {
        return block.merge({
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    }); // if parent (startBlock) was deleted

    if (blockMap.get(startBlock.getKey()) == null && blockMap.get(endBlock.getKey()) != null && endBlock.getParentKey() === startBlock.getKey() && endBlock.getPrevSiblingKey() == null) {
      var prevSiblingKey = startBlock.getPrevSiblingKey(); // endBlock becomes next sibling of parent's prevSibling

      transformBlock(endBlock.getKey(), blocks, function (block) {
        return block.merge({
          prevSibling: prevSiblingKey
        });
      });
      transformBlock(prevSiblingKey, blocks, function (block) {
        return block.merge({
          nextSibling: endBlock.getKey()
        });
      }); // Update parent for previous parent's children, and children for that parent

      var prevSibling = prevSiblingKey ? blockMap.get(prevSiblingKey) : null;
      var newParentKey = prevSibling ? prevSibling.getParentKey() : null;
      startBlock.getChildKeys().forEach(function (childKey) {
        transformBlock(childKey, blocks, function (block) {
          return block.merge({
            parent: newParentKey // set to null if there is no parent

          });
        });
      });

      if (newParentKey != null) {
        var newParent = blockMap.get(newParentKey);
        transformBlock(newParentKey, blocks, function (block) {
          return block.merge({
            children: newParent.getChildKeys().concat(startBlock.getChildKeys())
          });
        });
      } // last child of deleted parent should point to next sibling


      transformBlock(startBlock.getChildKeys().find(function (key) {
        var block = blockMap.get(key);
        return block.getNextSiblingKey() === null;
      }), blocks, function (block) {
        return block.merge({
          nextSibling: startBlock.getNextSiblingKey()
        });
      });
    }
  });
};

var removeRangeFromContentState = function removeRangeFromContentState(contentState, selectionState) {
  if (selectionState.isCollapsed()) {
    return contentState;
  }

  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var startBlock = blockMap.get(startKey);
  var endBlock = blockMap.get(endKey); // we assume that ContentBlockNode and ContentBlocks are not mixed together

  var isExperimentalTreeBlock = startBlock instanceof ContentBlockNode; // used to retain blocks that should not be deleted to avoid orphan children

  var parentAncestors = [];

  if (isExperimentalTreeBlock) {
    var endBlockchildrenKeys = endBlock.getChildKeys();
    var endBlockAncestors = getAncestorsKeys(endKey, blockMap); // endBlock has unselected siblings so we can not remove its ancestors parents

    if (endBlock.getNextSiblingKey()) {
      parentAncestors = parentAncestors.concat(endBlockAncestors);
    } // endBlock has children so can not remove this block or any of its ancestors


    if (!endBlockchildrenKeys.isEmpty()) {
      parentAncestors = parentAncestors.concat(endBlockAncestors.concat([endKey]));
    } // we need to retain all ancestors of the next delimiter block


    parentAncestors = parentAncestors.concat(getAncestorsKeys(getNextDelimiterBlockKey(endBlock, blockMap), blockMap));
  }

  var characterList;

  if (startBlock === endBlock) {
    characterList = removeFromList(startBlock.getCharacterList(), startOffset, endOffset);
  } else {
    characterList = startBlock.getCharacterList().slice(0, startOffset).concat(endBlock.getCharacterList().slice(endOffset));
  }

  var modifiedStart = startBlock.merge({
    text: startBlock.getText().slice(0, startOffset) + endBlock.getText().slice(endOffset),
    characterList: characterList
  }); // If cursor (collapsed) is at the start of the first child, delete parent
  // instead of child

  var shouldDeleteParent = isExperimentalTreeBlock && startOffset === 0 && endOffset === 0 && endBlock.getParentKey() === startKey && endBlock.getPrevSiblingKey() == null;
  var newBlocks = shouldDeleteParent ? Map([[startKey, null]]) : blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).filter(function (_, k) {
    return parentAncestors.indexOf(k) === -1;
  }).concat(Map([[endKey, null]])).map(function (_, k) {
    return k === startKey ? modifiedStart : null;
  });
  var updatedBlockMap = blockMap.merge(newBlocks).filter(function (block) {
    return !!block;
  }); // Only update tree block pointers if the range is across blocks

  if (isExperimentalTreeBlock && startBlock !== endBlock) {
    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, startBlock, endBlock, blockMap);
  }

  return contentState.merge({
    blockMap: updatedBlockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: startKey,
      anchorOffset: startOffset,
      focusKey: startKey,
      focusOffset: startOffset,
      isBackward: false
    })
  });
};
/**
 * Maintain persistence for target list when removing characters on the
 * head and tail of the character list.
 */


var removeFromList = function removeFromList(targetList, startOffset, endOffset) {
  if (startOffset === 0) {
    while (startOffset < endOffset) {
      targetList = targetList.shift();
      startOffset++;
    }
  } else if (endOffset === targetList.count()) {
    while (endOffset > startOffset) {
      targetList = targetList.pop();
      endOffset--;
    }
  } else {
    var head = targetList.slice(0, startOffset);
    var tail = targetList.slice(endOffset);
    targetList = head.concat(tail).toList();
  }

  return targetList;
};

module.exports = removeRangeFromContentState;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var ContentBlockNode = __webpack_require__(44);

var generateRandomKey = __webpack_require__(57);

var Immutable = __webpack_require__(4);

var invariant = __webpack_require__(9);

var modifyBlockForContentState = __webpack_require__(344);

var List = Immutable.List,
    Map = Immutable.Map;

var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlock, belowBlock) {
  return blockMap.withMutations(function (blocks) {
    var originalBlockKey = originalBlock.getKey();
    var belowBlockKey = belowBlock.getKey(); // update block parent

    transformBlock(originalBlock.getParentKey(), blocks, function (block) {
      var parentChildrenList = block.getChildKeys();
      var insertionIndex = parentChildrenList.indexOf(originalBlockKey) + 1;
      var newChildrenArray = parentChildrenList.toArray();
      newChildrenArray.splice(insertionIndex, 0, belowBlockKey);
      return block.merge({
        children: List(newChildrenArray)
      });
    }); // update original next block

    transformBlock(originalBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: belowBlockKey
      });
    }); // update original block

    transformBlock(originalBlockKey, blocks, function (block) {
      return block.merge({
        nextSibling: belowBlockKey
      });
    }); // update below block

    transformBlock(belowBlockKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalBlockKey
      });
    });
  });
};

var splitBlockInContentState = function splitBlockInContentState(contentState, selectionState) {
  !selectionState.isCollapsed() ?  false ? invariant(false, 'Selection range must be collapsed.') : invariant(false) : void 0;
  var key = selectionState.getAnchorKey();
  var blockMap = contentState.getBlockMap();
  var blockToSplit = blockMap.get(key);
  var text = blockToSplit.getText();

  if (!text) {
    var blockType = blockToSplit.getType();

    if (blockType === 'unordered-list-item' || blockType === 'ordered-list-item') {
      return modifyBlockForContentState(contentState, selectionState, function (block) {
        return block.merge({
          type: 'unstyled',
          depth: 0
        });
      });
    }
  }

  var offset = selectionState.getAnchorOffset();
  var chars = blockToSplit.getCharacterList();
  var keyBelow = generateRandomKey();
  var isExperimentalTreeBlock = blockToSplit instanceof ContentBlockNode;
  var blockAbove = blockToSplit.merge({
    text: text.slice(0, offset),
    characterList: chars.slice(0, offset)
  });
  var blockBelow = blockAbove.merge({
    key: keyBelow,
    text: text.slice(offset),
    characterList: chars.slice(offset),
    data: Map()
  });
  var blocksBefore = blockMap.toSeq().takeUntil(function (v) {
    return v === blockToSplit;
  });
  var blocksAfter = blockMap.toSeq().skipUntil(function (v) {
    return v === blockToSplit;
  }).rest();
  var newBlocks = blocksBefore.concat([[key, blockAbove], [keyBelow, blockBelow]], blocksAfter).toOrderedMap();

  if (isExperimentalTreeBlock) {
    !blockToSplit.getChildKeys().isEmpty() ?  false ? invariant(false, 'ContentBlockNode must not have children') : invariant(false) : void 0;
    newBlocks = updateBlockMapLinks(newBlocks, blockAbove, blockBelow);
  }

  return contentState.merge({
    blockMap: newBlocks,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: keyBelow,
      anchorOffset: 0,
      focusKey: keyBelow,
      focusOffset: 0,
      isBackward: false
    })
  });
};

module.exports = splitBlockInContentState;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var findRangesImmutable = __webpack_require__(121);

var getOwnObjectValues = __webpack_require__(346);

var Immutable = __webpack_require__(4);

var List = Immutable.List,
    Repeat = Immutable.Repeat,
    Record = Immutable.Record;

var returnTrue = function returnTrue() {
  return true;
};

var defaultLeafRange = {
  start: null,
  end: null
};
var LeafRange = Record(defaultLeafRange);
var defaultDecoratorRange = {
  start: null,
  end: null,
  decoratorKey: null,
  leaves: null
};
var DecoratorRange = Record(defaultDecoratorRange);
var BlockTree = {
  /**
   * Generate a block tree for a given ContentBlock/decorator pair.
   */
  generate: function generate(contentState, block, decorator) {
    var textLength = block.getLength();

    if (!textLength) {
      return List.of(new DecoratorRange({
        start: 0,
        end: 0,
        decoratorKey: null,
        leaves: List.of(new LeafRange({
          start: 0,
          end: 0
        }))
      }));
    }

    var leafSets = [];
    var decorations = decorator ? decorator.getDecorations(block, contentState) : List(Repeat(null, textLength));
    var chars = block.getCharacterList();
    findRangesImmutable(decorations, areEqual, returnTrue, function (start, end) {
      leafSets.push(new DecoratorRange({
        start: start,
        end: end,
        decoratorKey: decorations.get(start),
        leaves: generateLeaves(chars.slice(start, end).toList(), start)
      }));
    });
    return List(leafSets);
  },
  fromJS: function fromJS(_ref) {
    var leaves = _ref.leaves,
        other = _objectWithoutPropertiesLoose(_ref, ["leaves"]);

    return new DecoratorRange(_objectSpread({}, other, {
      leaves: leaves != null ? List(Array.isArray(leaves) ? leaves : getOwnObjectValues(leaves)).map(function (leaf) {
        return LeafRange(leaf);
      }) : null
    }));
  }
};
/**
 * Generate LeafRange records for a given character list.
 */

function generateLeaves(characters, offset) {
  var leaves = [];
  var inlineStyles = characters.map(function (c) {
    return c.getStyle();
  }).toList();
  findRangesImmutable(inlineStyles, areEqual, returnTrue, function (start, end) {
    leaves.push(new LeafRange({
      start: start + offset,
      end: end + offset
    }));
  });
  return List(leaves);
}

function areEqual(a, b) {
  return a === b;
}

module.exports = BlockTree;

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @typechecks
 * 
 * @format
 */

/*eslint-disable no-bitwise */

/**
 * Based on the rfc4122-compliant solution posted at
 * http://stackoverflow.com/questions/105034
 */
function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

module.exports = uuid;

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var UnicodeBidiService = __webpack_require__(817);

var Immutable = __webpack_require__(4);

var nullthrows = __webpack_require__(30);

var OrderedMap = Immutable.OrderedMap;
var bidiService;
var EditorBidiService = {
  getDirectionMap: function getDirectionMap(content, prevBidiMap) {
    if (!bidiService) {
      bidiService = new UnicodeBidiService();
    } else {
      bidiService.reset();
    }

    var blockMap = content.getBlockMap();
    var nextBidi = blockMap.valueSeq().map(function (block) {
      return nullthrows(bidiService).getDirection(block.getText());
    });
    var bidiMap = OrderedMap(blockMap.keySeq().zip(nextBidi));

    if (prevBidiMap != null && Immutable.is(prevBidiMap, bidiMap)) {
      return prevBidiMap;
    }

    return bidiMap;
  }
};
module.exports = EditorBidiService;

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/**
 * Stateful API for text direction detection
 *
 * This class can be used in applications where you need to detect the
 * direction of a sequence of text blocks, where each direction shall be used
 * as the fallback direction for the next one.
 *
 * NOTE: A default direction, if not provided, is set based on the global
 *       direction, as defined by `UnicodeBidiDirection`.
 *
 * == Example ==
 * ```
 * var UnicodeBidiService = require('UnicodeBidiService');
 *
 * var bidiService = new UnicodeBidiService();
 *
 * ...
 *
 * bidiService.reset();
 * for (var para in paragraphs) {
 *   var dir = bidiService.getDirection(para);
 *   ...
 * }
 * ```
 *
 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UnicodeBidi = __webpack_require__(226);

var UnicodeBidiDirection = __webpack_require__(160);

var invariant = __webpack_require__(9);

var UnicodeBidiService =
/*#__PURE__*/
function () {
  /**
   * Stateful class for paragraph direction detection
   *
   * @param defaultDir  Default direction of the service
   */
  function UnicodeBidiService(defaultDir) {
    _defineProperty(this, "_defaultDir", void 0);

    _defineProperty(this, "_lastDir", void 0);

    if (!defaultDir) {
      defaultDir = UnicodeBidiDirection.getGlobalDir();
    } else {
      !UnicodeBidiDirection.isStrong(defaultDir) ?  false ? invariant(false, 'Default direction must be a strong direction (LTR or RTL)') : invariant(false) : void 0;
    }

    this._defaultDir = defaultDir;
    this.reset();
  }
  /**
   * Reset the internal state
   *
   * Instead of creating a new instance, you can just reset() your instance
   * everytime you start a new loop.
   */


  var _proto = UnicodeBidiService.prototype;

  _proto.reset = function reset() {
    this._lastDir = this._defaultDir;
  };
  /**
   * Returns the direction of a block of text, and remembers it as the
   * fall-back direction for the next paragraph.
   *
   * @param str  A text block, e.g. paragraph, table cell, tag
   * @return     The resolved direction
   */


  _proto.getDirection = function getDirection(str) {
    this._lastDir = UnicodeBidi.getDirection(str, this._lastDir);
    return this._lastDir;
  };

  return UnicodeBidiService;
}();

module.exports = UnicodeBidiService;

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var ContentBlockNode = __webpack_require__(44);

var getNextDelimiterBlockKey = __webpack_require__(345);

var Immutable = __webpack_require__(4);

var invariant = __webpack_require__(9);

var OrderedMap = Immutable.OrderedMap,
    List = Immutable.List;

var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockToBeMoved, originalTargetBlock, insertionMode, isExperimentalTreeBlock) {
  if (!isExperimentalTreeBlock) {
    return blockMap;
  } // possible values of 'insertionMode' are: 'after', 'before'


  var isInsertedAfterTarget = insertionMode === 'after';
  var originalBlockKey = originalBlockToBeMoved.getKey();
  var originalTargetKey = originalTargetBlock.getKey();
  var originalParentKey = originalBlockToBeMoved.getParentKey();
  var originalNextSiblingKey = originalBlockToBeMoved.getNextSiblingKey();
  var originalPrevSiblingKey = originalBlockToBeMoved.getPrevSiblingKey();
  var newParentKey = originalTargetBlock.getParentKey();
  var newNextSiblingKey = isInsertedAfterTarget ? originalTargetBlock.getNextSiblingKey() : originalTargetKey;
  var newPrevSiblingKey = isInsertedAfterTarget ? originalTargetKey : originalTargetBlock.getPrevSiblingKey();
  return blockMap.withMutations(function (blocks) {
    // update old parent
    transformBlock(originalParentKey, blocks, function (block) {
      var parentChildrenList = block.getChildKeys();
      return block.merge({
        children: parentChildrenList["delete"](parentChildrenList.indexOf(originalBlockKey))
      });
    }); // update old prev

    transformBlock(originalPrevSiblingKey, blocks, function (block) {
      return block.merge({
        nextSibling: originalNextSiblingKey
      });
    }); // update old next

    transformBlock(originalNextSiblingKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalPrevSiblingKey
      });
    }); // update new next

    transformBlock(newNextSiblingKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalBlockKey
      });
    }); // update new prev

    transformBlock(newPrevSiblingKey, blocks, function (block) {
      return block.merge({
        nextSibling: originalBlockKey
      });
    }); // update new parent

    transformBlock(newParentKey, blocks, function (block) {
      var newParentChildrenList = block.getChildKeys();
      var targetBlockIndex = newParentChildrenList.indexOf(originalTargetKey);
      var insertionIndex = isInsertedAfterTarget ? targetBlockIndex + 1 : targetBlockIndex !== 0 ? targetBlockIndex - 1 : 0;
      var newChildrenArray = newParentChildrenList.toArray();
      newChildrenArray.splice(insertionIndex, 0, originalBlockKey);
      return block.merge({
        children: List(newChildrenArray)
      });
    }); // update block

    transformBlock(originalBlockKey, blocks, function (block) {
      return block.merge({
        nextSibling: newNextSiblingKey,
        prevSibling: newPrevSiblingKey,
        parent: newParentKey
      });
    });
  });
};

var moveBlockInContentState = function moveBlockInContentState(contentState, blockToBeMoved, targetBlock, insertionMode) {
  !(insertionMode !== 'replace') ?  false ? invariant(false, 'Replacing blocks is not supported.') : invariant(false) : void 0;
  var targetKey = targetBlock.getKey();
  var blockKey = blockToBeMoved.getKey();
  !(blockKey !== targetKey) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;
  var blockMap = contentState.getBlockMap();
  var isExperimentalTreeBlock = blockToBeMoved instanceof ContentBlockNode;
  var blocksToBeMoved = [blockToBeMoved];
  var blockMapWithoutBlocksToBeMoved = blockMap["delete"](blockKey);

  if (isExperimentalTreeBlock) {
    blocksToBeMoved = [];
    blockMapWithoutBlocksToBeMoved = blockMap.withMutations(function (blocks) {
      var nextSiblingKey = blockToBeMoved.getNextSiblingKey();
      var nextDelimiterBlockKey = getNextDelimiterBlockKey(blockToBeMoved, blocks);
      blocks.toSeq().skipUntil(function (block) {
        return block.getKey() === blockKey;
      }).takeWhile(function (block) {
        var key = block.getKey();
        var isBlockToBeMoved = key === blockKey;
        var hasNextSiblingAndIsNotNextSibling = nextSiblingKey && key !== nextSiblingKey;
        var doesNotHaveNextSiblingAndIsNotDelimiter = !nextSiblingKey && block.getParentKey() && (!nextDelimiterBlockKey || key !== nextDelimiterBlockKey);
        return !!(isBlockToBeMoved || hasNextSiblingAndIsNotNextSibling || doesNotHaveNextSiblingAndIsNotDelimiter);
      }).forEach(function (block) {
        blocksToBeMoved.push(block);
        blocks["delete"](block.getKey());
      });
    });
  }

  var blocksBefore = blockMapWithoutBlocksToBeMoved.toSeq().takeUntil(function (v) {
    return v === targetBlock;
  });
  var blocksAfter = blockMapWithoutBlocksToBeMoved.toSeq().skipUntil(function (v) {
    return v === targetBlock;
  }).skip(1);
  var slicedBlocks = blocksToBeMoved.map(function (block) {
    return [block.getKey(), block];
  });
  var newBlocks = OrderedMap();

  if (insertionMode === 'before') {
    var blockBefore = contentState.getBlockBefore(targetKey);
    !(!blockBefore || blockBefore.getKey() !== blockToBeMoved.getKey()) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;
    newBlocks = blocksBefore.concat([].concat(slicedBlocks, [[targetKey, targetBlock]]), blocksAfter).toOrderedMap();
  } else if (insertionMode === 'after') {
    var blockAfter = contentState.getBlockAfter(targetKey);
    !(!blockAfter || blockAfter.getKey() !== blockKey) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;
    newBlocks = blocksBefore.concat([[targetKey, targetBlock]].concat(slicedBlocks), blocksAfter).toOrderedMap();
  }

  return contentState.merge({
    blockMap: updateBlockMapLinks(newBlocks, blockToBeMoved, targetBlock, insertionMode, isExperimentalTreeBlock),
    selectionBefore: contentState.getSelectionAfter(),
    selectionAfter: contentState.getSelectionAfter().merge({
      anchorKey: blockKey,
      focusKey: blockKey
    })
  });
};

module.exports = moveBlockInContentState;

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Immutable = __webpack_require__(4);

var List = Immutable.List;
var DELIMITER = '.';
/**
 * A CompositeDraftDecorator traverses through a list of DraftDecorator
 * instances to identify sections of a ContentBlock that should be rendered
 * in a "decorated" manner. For example, hashtags, mentions, and links may
 * be intended to stand out visually, be rendered as anchors, etc.
 *
 * The list of decorators supplied to the constructor will be used in the
 * order they are provided. This allows the caller to specify a priority for
 * string matching, in case of match collisions among decorators.
 *
 * For instance, I may have a link with a `#` in its text. Though this section
 * of text may match our hashtag decorator, it should not be treated as a
 * hashtag. I should therefore list my link DraftDecorator
 * before my hashtag DraftDecorator when constructing this composite
 * decorator instance.
 *
 * Thus, when a collision like this is encountered, the earlier match is
 * preserved and the new match is discarded.
 */

var CompositeDraftDecorator = /*#__PURE__*/function () {
  function CompositeDraftDecorator(decorators) {
    _defineProperty(this, "_decorators", void 0);

    // Copy the decorator array, since we use this array order to determine
    // precedence of decoration matching. If the array is mutated externally,
    // we don't want to be affected here.
    this._decorators = decorators.slice();
  }

  var _proto = CompositeDraftDecorator.prototype;

  _proto.getDecorations = function getDecorations(block, contentState) {
    var decorations = Array(block.getText().length).fill(null);

    this._decorators.forEach(function (
    /*object*/
    decorator,
    /*number*/
    ii) {
      var counter = 0;
      var strategy = decorator.strategy;

      var callback = function callback(
      /*number*/
      start,
      /*number*/
      end) {
        // Find out if any of our matching range is already occupied
        // by another decorator. If so, discard the match. Otherwise, store
        // the component key for rendering.
        if (canOccupySlice(decorations, start, end)) {
          occupySlice(decorations, start, end, ii + DELIMITER + counter);
          counter++;
        }
      };

      strategy(block, callback, contentState);
    });

    return List(decorations);
  };

  _proto.getComponentForKey = function getComponentForKey(key) {
    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
    return this._decorators[componentKey].component;
  };

  _proto.getPropsForKey = function getPropsForKey(key) {
    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
    return this._decorators[componentKey].props;
  };

  return CompositeDraftDecorator;
}();
/**
 * Determine whether we can occupy the specified slice of the decorations
 * array.
 */


function canOccupySlice(decorations, start, end) {
  for (var ii = start; ii < end; ii++) {
    if (decorations[ii] != null) {
      return false;
    }
  }

  return true;
}
/**
 * Splice the specified component into our decoration array at the desired
 * range.
 */


function occupySlice(targetArr, start, end, componentKey) {
  for (var ii = start; ii < end; ii++) {
    targetArr[ii] = componentKey;
  }
}

module.exports = CompositeDraftDecorator;

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @preventMunge
 * @emails oncall+draft_js
 */


var _assign = __webpack_require__(8);

function _extends() { _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DefaultDraftBlockRenderMap = __webpack_require__(227);

var DefaultDraftInlineStyle = __webpack_require__(349);

var DraftEditorCompositionHandler = __webpack_require__(821);

var DraftEditorContents = __webpack_require__(829);

var DraftEditorDragHandler = __webpack_require__(846);

var DraftEditorEditHandler = __webpack_require__(849);

var flushControlled = __webpack_require__(884);

var DraftEditorPlaceholder = __webpack_require__(955);

var DraftEffects = __webpack_require__(361);

var EditorState = __webpack_require__(13);

var React = __webpack_require__(1);

var Scroll = __webpack_require__(230);

var Style = __webpack_require__(164);

var UserAgent = __webpack_require__(31);

var cx = __webpack_require__(89);

var generateRandomKey = __webpack_require__(57);

var getDefaultKeyBinding = __webpack_require__(408);

var getScrollPosition = __webpack_require__(165);

var gkx = __webpack_require__(70);

var invariant = __webpack_require__(9);

var isHTMLElement = __webpack_require__(122);

var nullthrows = __webpack_require__(30);

var isIE = UserAgent.isBrowser('IE'); // IE does not support the `input` event on contentEditable, so we can't
// observe spellcheck behavior.

var allowSpellCheck = !isIE; // Define a set of handler objects to correspond to each possible `mode`
// of editor behavior.

var handlerMap = {
  edit: DraftEditorEditHandler,
  composite: DraftEditorCompositionHandler,
  drag: DraftEditorDragHandler,
  cut: null,
  render: null
};
var didInitODS = false;

var UpdateDraftEditorFlags = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(UpdateDraftEditorFlags, _React$Component);

  function UpdateDraftEditorFlags() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = UpdateDraftEditorFlags.prototype;

  _proto.render = function render() {
    return null;
  };

  _proto.componentDidMount = function componentDidMount() {
    this._update();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this._update();
  };

  _proto._update = function _update() {
    var editor = this.props.editor;
    /**
     * Sometimes a render triggers a 'focus' or other event, and that will
     * schedule a second render pass.
     * In order to make sure the second render pass gets the latest editor
     * state, we update it here.
     * Example:
     * render #1
     * +
     * |
     * | cWU -> Nothing ... latestEditorState = STALE_STATE :(
     * |
     * | render -> this.props.editorState = FRESH_STATE
     * | +         *and* set latestEditorState = FRESH_STATE
     *   |
     * | |
     * | +--> triggers 'focus' event, calling 'handleFocus' with latestEditorState
     * |                                                +
     * |                                                |
     * +>cdU -> latestEditorState = FRESH_STATE         | the 'handleFocus' call schedules render #2
     *                                                  | with latestEditorState, which is FRESH_STATE
     *                                                  |
     * render #2 <--------------------------------------+
     * +
     * |
     * | cwU -> nothing updates
     * |
     * | render -> this.props.editorState = FRESH_STATE which was passed in above
     * |
     * +>cdU fires and resets latestEditorState = FRESH_STATE
     * ---
     * Note that if we don't set latestEditorState in 'render' in the above
     * diagram, then STALE_STATE gets passed to render #2.
     */

    editor._latestEditorState = this.props.editorState;
    /**
     * The reason we set this 'blockSelectEvents' flag is that  IE will fire a
     * 'selectionChange' event when we programmatically change the selection,
     * meaning it would trigger a new select event while we are in the middle
     * of updating.
     * We found that the 'selection.addRange' was what triggered the stray
     * selectionchange event in IE.
     * To be clear - we have not been able to reproduce specific bugs related
     * to this stray selection event, but have recorded logs that some
     * conditions do cause it to get bumped into during editOnSelect.
     */

    editor._blockSelectEvents = true;
  };

  return UpdateDraftEditorFlags;
}(React.Component);
/**
 * `DraftEditor` is the root editor component. It composes a `contentEditable`
 * div, and provides a wide variety of useful function props for managing the
 * state of the editor. See `DraftEditorProps` for details.
 */


var DraftEditor = /*#__PURE__*/function (_React$Component2) {
  _inheritsLoose(DraftEditor, _React$Component2);

  /**
   * Define proxies that can route events to the current handler.
   */
  function DraftEditor(props) {
    var _this;

    _this = _React$Component2.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "_blockSelectEvents", void 0);

    _defineProperty(_assertThisInitialized(_this), "_clipboard", void 0);

    _defineProperty(_assertThisInitialized(_this), "_handler", void 0);

    _defineProperty(_assertThisInitialized(_this), "_dragCount", void 0);

    _defineProperty(_assertThisInitialized(_this), "_internalDrag", void 0);

    _defineProperty(_assertThisInitialized(_this), "_editorKey", void 0);

    _defineProperty(_assertThisInitialized(_this), "_placeholderAccessibilityID", void 0);

    _defineProperty(_assertThisInitialized(_this), "_latestEditorState", void 0);

    _defineProperty(_assertThisInitialized(_this), "_latestCommittedEditorState", void 0);

    _defineProperty(_assertThisInitialized(_this), "_pendingStateFromBeforeInput", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onBeforeInput", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onBlur", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onCharacterData", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onCompositionEnd", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onCompositionStart", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onCopy", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onCut", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onDragEnd", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onDragOver", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onDragStart", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onDrop", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onInput", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onFocus", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onKeyDown", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onKeyPress", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onKeyUp", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onMouseDown", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onMouseUp", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onPaste", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onSelect", void 0);

    _defineProperty(_assertThisInitialized(_this), "editor", void 0);

    _defineProperty(_assertThisInitialized(_this), "editorContainer", void 0);

    _defineProperty(_assertThisInitialized(_this), "focus", void 0);

    _defineProperty(_assertThisInitialized(_this), "blur", void 0);

    _defineProperty(_assertThisInitialized(_this), "setMode", void 0);

    _defineProperty(_assertThisInitialized(_this), "exitCurrentMode", void 0);

    _defineProperty(_assertThisInitialized(_this), "restoreEditorDOM", void 0);

    _defineProperty(_assertThisInitialized(_this), "setClipboard", void 0);

    _defineProperty(_assertThisInitialized(_this), "getClipboard", void 0);

    _defineProperty(_assertThisInitialized(_this), "getEditorKey", void 0);

    _defineProperty(_assertThisInitialized(_this), "update", void 0);

    _defineProperty(_assertThisInitialized(_this), "onDragEnter", void 0);

    _defineProperty(_assertThisInitialized(_this), "onDragLeave", void 0);

    _defineProperty(_assertThisInitialized(_this), "_handleEditorContainerRef", function (node) {
      _this.editorContainer = node; // Instead of having a direct ref on the child, we'll grab it here.
      // This is safe as long as the rendered structure is static (which it is).
      // This lets the child support ref={props.editorRef} without merging refs.

      _this.editor = node !== null ? node.firstChild : null;
    });

    _defineProperty(_assertThisInitialized(_this), "focus", function (scrollPosition) {
      var editorState = _this.props.editorState;
      var alreadyHasFocus = editorState.getSelection().getHasFocus();
      var editorNode = _this.editor;

      if (!editorNode) {
        // once in a while people call 'focus' in a setTimeout, and the node has
        // been deleted, so it can be null in that case.
        return;
      }

      var scrollParent = Style.getScrollParent(editorNode);

      var _ref = scrollPosition || getScrollPosition(scrollParent),
          x = _ref.x,
          y = _ref.y;

      !isHTMLElement(editorNode) ?  false ? invariant(false, 'editorNode is not an HTMLElement') : invariant(false) : void 0;
      editorNode.focus(); // Restore scroll position

      if (scrollParent === window) {
        window.scrollTo(x, y);
      } else {
        Scroll.setTop(scrollParent, y);
      } // On Chrome and Safari, calling focus on contenteditable focuses the
      // cursor at the first character. This is something you don't expect when
      // you're clicking on an input element but not directly on a character.
      // Put the cursor back where it was before the blur.


      if (!alreadyHasFocus) {
        _this.update(EditorState.forceSelection(editorState, editorState.getSelection()));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "blur", function () {
      var editorNode = _this.editor;

      if (!editorNode) {
        return;
      }

      !isHTMLElement(editorNode) ?  false ? invariant(false, 'editorNode is not an HTMLElement') : invariant(false) : void 0;
      editorNode.blur();
    });

    _defineProperty(_assertThisInitialized(_this), "setMode", function (mode) {
      var _this$props = _this.props,
          onPaste = _this$props.onPaste,
          onCut = _this$props.onCut,
          onCopy = _this$props.onCopy;

      var editHandler = _objectSpread({}, handlerMap.edit);

      if (onPaste) {
        /* $FlowFixMe[incompatible-type] (>=0.117.0 site=www,mobile) This comment
         * suppresses an error found when Flow v0.117 was deployed. To see the
         * error delete this comment and run Flow. */
        editHandler.onPaste = onPaste;
      }

      if (onCut) {
        editHandler.onCut = onCut;
      }

      if (onCopy) {
        editHandler.onCopy = onCopy;
      }

      var handler = _objectSpread({}, handlerMap, {
        edit: editHandler
      });

      _this._handler = handler[mode];
    });

    _defineProperty(_assertThisInitialized(_this), "exitCurrentMode", function () {
      _this.setMode('edit');
    });

    _defineProperty(_assertThisInitialized(_this), "restoreEditorDOM", function (scrollPosition) {
      _this.setState({
        contentsKey: _this.state.contentsKey + 1
      }, function () {
        _this.focus(scrollPosition);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setClipboard", function (clipboard) {
      _this._clipboard = clipboard;
    });

    _defineProperty(_assertThisInitialized(_this), "getClipboard", function () {
      return _this._clipboard;
    });

    _defineProperty(_assertThisInitialized(_this), "update", function (editorState) {
      _this._latestEditorState = editorState;

      _this.props.onChange(editorState);
    });

    _defineProperty(_assertThisInitialized(_this), "onDragEnter", function () {
      _this._dragCount++;
    });

    _defineProperty(_assertThisInitialized(_this), "onDragLeave", function () {
      _this._dragCount--;

      if (_this._dragCount === 0) {
        _this.exitCurrentMode();
      }
    });

    _this._blockSelectEvents = false;
    _this._clipboard = null;
    _this._handler = null;
    _this._dragCount = 0;
    _this._editorKey = props.editorKey || generateRandomKey();
    _this._placeholderAccessibilityID = 'placeholder-' + _this._editorKey;
    _this._latestEditorState = props.editorState;
    _this._latestCommittedEditorState = props.editorState;
    _this._onBeforeInput = _this._buildHandler('onBeforeInput');
    _this._onBlur = _this._buildHandler('onBlur');
    _this._onCharacterData = _this._buildHandler('onCharacterData');
    _this._onCompositionEnd = _this._buildHandler('onCompositionEnd');
    _this._onCompositionStart = _this._buildHandler('onCompositionStart');
    _this._onCopy = _this._buildHandler('onCopy');
    _this._onCut = _this._buildHandler('onCut');
    _this._onDragEnd = _this._buildHandler('onDragEnd');
    _this._onDragOver = _this._buildHandler('onDragOver');
    _this._onDragStart = _this._buildHandler('onDragStart');
    _this._onDrop = _this._buildHandler('onDrop');
    _this._onInput = _this._buildHandler('onInput');
    _this._onFocus = _this._buildHandler('onFocus');
    _this._onKeyDown = _this._buildHandler('onKeyDown');
    _this._onKeyPress = _this._buildHandler('onKeyPress');
    _this._onKeyUp = _this._buildHandler('onKeyUp');
    _this._onMouseDown = _this._buildHandler('onMouseDown');
    _this._onMouseUp = _this._buildHandler('onMouseUp');
    _this._onPaste = _this._buildHandler('onPaste');
    _this._onSelect = _this._buildHandler('onSelect');

    _this.getEditorKey = function () {
      return _this._editorKey;
    };

    if (false) {
      ['onDownArrow', 'onEscape', 'onLeftArrow', 'onRightArrow', 'onTab', 'onUpArrow'].forEach(function (propName) {
        if (props.hasOwnProperty(propName)) {
          // eslint-disable-next-line no-console
          console.warn("Supplying an `".concat(propName, "` prop to `DraftEditor` has ") + 'been deprecated. If your handler needs access to the keyboard ' + 'event, supply a custom `keyBindingFn` prop that falls back to ' + 'the default one (eg. https://is.gd/wHKQ3W).');
        }
      });
    } // See `restoreEditorDOM()`.


    _this.state = {
      contentsKey: 0
    };
    return _this;
  }
  /**
   * Build a method that will pass the event to the specified handler method.
   * This allows us to look up the correct handler function for the current
   * editor mode, if any has been specified.
   */


  var _proto2 = DraftEditor.prototype;

  _proto2._buildHandler = function _buildHandler(eventName) {
    var _this2 = this;

    // Wrap event handlers in `flushControlled`. In sync mode, this is
    // effectively a no-op. In async mode, this ensures all updates scheduled
    // inside the handler are flushed before React yields to the browser.
    return function (e) {
      if (!_this2.props.readOnly) {
        var method = _this2._handler && _this2._handler[eventName];

        if (method) {
          if (flushControlled) {
            flushControlled(function () {
              return method(_this2, e);
            });
          } else {
            method(_this2, e);
          }
        }
      }
    };
  };

  _proto2._showPlaceholder = function _showPlaceholder() {
    return !!this.props.placeholder && !this.props.editorState.isInCompositionMode() && !this.props.editorState.getCurrentContent().hasText();
  };

  _proto2._renderPlaceholder = function _renderPlaceholder() {
    if (this._showPlaceholder()) {
      var placeHolderProps = {
        text: nullthrows(this.props.placeholder),
        editorState: this.props.editorState,
        textAlignment: this.props.textAlignment,
        accessibilityID: this._placeholderAccessibilityID
      };
      /* $FlowFixMe[incompatible-type] (>=0.112.0 site=www,mobile) This comment
       * suppresses an error found when Flow v0.112 was deployed. To see the
       * error delete this comment and run Flow. */

      return React.createElement(DraftEditorPlaceholder, placeHolderProps);
    }

    return null;
  }
  /**
   * returns ariaDescribedBy prop with '{{editor_id_placeholder}}' replaced with
   * the DOM id of the placeholder (if it exists)
   * @returns aria-describedby attribute value
   */
  ;

  _proto2._renderARIADescribedBy = function _renderARIADescribedBy() {
    var describedBy = this.props.ariaDescribedBy || '';
    var placeholderID = this._showPlaceholder() ? this._placeholderAccessibilityID : '';
    return describedBy.replace('{{editor_id_placeholder}}', placeholderID) || undefined;
  };

  _proto2.render = function render() {
    var _this$props2 = this.props,
        blockRenderMap = _this$props2.blockRenderMap,
        blockRendererFn = _this$props2.blockRendererFn,
        blockStyleFn = _this$props2.blockStyleFn,
        customStyleFn = _this$props2.customStyleFn,
        customStyleMap = _this$props2.customStyleMap,
        editorState = _this$props2.editorState,
        preventScroll = _this$props2.preventScroll,
        readOnly = _this$props2.readOnly,
        textAlignment = _this$props2.textAlignment,
        textDirectionality = _this$props2.textDirectionality;
    var rootClass = cx({
      'DraftEditor/root': true,
      'DraftEditor/alignLeft': textAlignment === 'left',
      'DraftEditor/alignRight': textAlignment === 'right',
      'DraftEditor/alignCenter': textAlignment === 'center'
    });
    var contentStyle = {
      outline: 'none',
      // fix parent-draggable Safari bug. #1326
      userSelect: 'text',
      WebkitUserSelect: 'text',
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word'
    }; // The aria-expanded and aria-haspopup properties should only be rendered
    // for a combobox.

    /* $FlowFixMe[prop-missing] (>=0.68.0 site=www,mobile) This comment
     * suppresses an error found when Flow v0.68 was deployed. To see the error
     * delete this comment and run Flow. */

    var ariaRole = this.props.role || 'textbox';
    var ariaExpanded = ariaRole === 'combobox' ? !!this.props.ariaExpanded : null;
    var editorContentsProps = {
      blockRenderMap: blockRenderMap,
      blockRendererFn: blockRendererFn,
      blockStyleFn: blockStyleFn,
      customStyleMap: _objectSpread({}, DefaultDraftInlineStyle, customStyleMap),
      customStyleFn: customStyleFn,
      editorKey: this._editorKey,
      editorState: editorState,
      preventScroll: preventScroll,
      textDirectionality: textDirectionality
    };
    return React.createElement("div", {
      className: rootClass
    }, this._renderPlaceholder(), React.createElement("div", {
      className: cx('DraftEditor/editorContainer'),
      ref: this._handleEditorContainerRef
    }, React.createElement("div", {
      "aria-activedescendant": readOnly ? null : this.props.ariaActiveDescendantID,
      "aria-autocomplete": readOnly ? null : this.props.ariaAutoComplete,
      "aria-controls": readOnly ? null : this.props.ariaControls,
      "aria-describedby": this._renderARIADescribedBy(),
      "aria-expanded": readOnly ? null : ariaExpanded,
      "aria-label": this.props.ariaLabel,
      "aria-labelledby": this.props.ariaLabelledBy,
      "aria-multiline": this.props.ariaMultiline,
      "aria-owns": readOnly ? null : this.props.ariaOwneeID,
      autoCapitalize: this.props.autoCapitalize,
      autoComplete: this.props.autoComplete,
      autoCorrect: this.props.autoCorrect,
      className: cx({
        // Chrome's built-in translation feature mutates the DOM in ways
        // that Draft doesn't expect (ex: adding <font> tags inside
        // DraftEditorLeaf spans) and causes problems. We add notranslate
        // here which makes its autotranslation skip over this subtree.
        notranslate: !readOnly,
        'public/DraftEditor/content': true
      }),
      contentEditable: !readOnly,
      "data-testid": this.props.webDriverTestID,
      onBeforeInput: this._onBeforeInput,
      onBlur: this._onBlur,
      onCompositionEnd: this._onCompositionEnd,
      onCompositionStart: this._onCompositionStart,
      onCopy: this._onCopy,
      onCut: this._onCut,
      onDragEnd: this._onDragEnd,
      onDragEnter: this.onDragEnter,
      onDragLeave: this.onDragLeave,
      onDragOver: this._onDragOver,
      onDragStart: this._onDragStart,
      onDrop: this._onDrop,
      onFocus: this._onFocus,
      onInput: this._onInput,
      onKeyDown: this._onKeyDown,
      onKeyPress: this._onKeyPress,
      onKeyUp: this._onKeyUp,
      onMouseUp: this._onMouseUp,
      onPaste: this._onPaste,
      onSelect: this._onSelect,
      ref: this.props.editorRef,
      role: readOnly ? null : ariaRole,
      spellCheck: allowSpellCheck && this.props.spellCheck,
      style: contentStyle,
      suppressContentEditableWarning: true,
      tabIndex: this.props.tabIndex
    }, React.createElement(UpdateDraftEditorFlags, {
      editor: this,
      editorState: editorState
    }), React.createElement(DraftEditorContents, _extends({}, editorContentsProps, {
      key: 'contents' + this.state.contentsKey
    })))));
  };

  _proto2.componentDidMount = function componentDidMount() {
    this._blockSelectEvents = false;

    if (!didInitODS && gkx('draft_ods_enabled')) {
      didInitODS = true;
      DraftEffects.initODS();
    }

    this.setMode('edit');
    /**
     * IE has a hardcoded "feature" that attempts to convert link text into
     * anchors in contentEditable DOM. This breaks the editor's expectations of
     * the DOM, and control is lost. Disable it to make IE behave.
     * See: http://blogs.msdn.com/b/ieinternals/archive/2010/09/15/
     * ie9-beta-minor-change-list.aspx
     */

    if (isIE) {
      // editor can be null after mounting
      // https://stackoverflow.com/questions/44074747/componentdidmount-called-before-ref-callback
      if (!this.editor) {
        global.execCommand('AutoUrlDetect', false, false);
      } else {
        this.editor.ownerDocument.execCommand('AutoUrlDetect', false, false);
      }
    }
  };

  _proto2.componentDidUpdate = function componentDidUpdate() {
    this._blockSelectEvents = false;
    this._latestEditorState = this.props.editorState;
    this._latestCommittedEditorState = this.props.editorState;
  }
  /**
   * Used via `this.focus()`.
   *
   * Force focus back onto the editor node.
   *
   * We attempt to preserve scroll position when focusing. You can also pass
   * a specified scroll position (for cases like `cut` behavior where it should
   * be restored to a known position).
   */
  ;

  return DraftEditor;
}(React.Component);

_defineProperty(DraftEditor, "defaultProps", {
  ariaDescribedBy: '{{editor_id_placeholder}}',
  blockRenderMap: DefaultDraftBlockRenderMap,
  blockRendererFn: function blockRendererFn() {
    return null;
  },
  blockStyleFn: function blockStyleFn() {
    return '';
  },
  keyBindingFn: getDefaultKeyBinding,
  readOnly: false,
  spellCheck: false,
  stripPastedStyles: false
});

module.exports = DraftEditor;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DOMObserver = __webpack_require__(822);

var DraftModifier = __webpack_require__(29);

var DraftOffsetKey = __webpack_require__(64);

var EditorState = __webpack_require__(13);

var Keys = __webpack_require__(163);

var UserAgent = __webpack_require__(31);

var editOnSelect = __webpack_require__(352);

var getContentEditableContainer = __webpack_require__(354);

var getDraftEditorSelection = __webpack_require__(355);

var getEntityKeyForSelection = __webpack_require__(228);

var nullthrows = __webpack_require__(30);

var isIE = UserAgent.isBrowser('IE');
/**
 * Millisecond delay to allow `compositionstart` to fire again upon
 * `compositionend`.
 *
 * This is used for Korean input to ensure that typing can continue without
 * the editor trying to render too quickly. More specifically, Safari 7.1+
 * triggers `compositionstart` a little slower than Chrome/FF, which
 * leads to composed characters being resolved and re-render occurring
 * sooner than we want.
 */

var RESOLVE_DELAY = 20;
/**
 * A handful of variables used to track the current composition and its
 * resolution status. These exist at the module level because it is not
 * possible to have compositions occurring in multiple editors simultaneously,
 * and it simplifies state management with respect to the DraftEditor component.
 */

var resolved = false;
var stillComposing = false;
var domObserver = null;

function startDOMObserver(editor) {
  if (!domObserver) {
    domObserver = new DOMObserver(getContentEditableContainer(editor));
    domObserver.start();
  }
}

var DraftEditorCompositionHandler = {
  /**
   * A `compositionstart` event has fired while we're still in composition
   * mode. Continue the current composition session to prevent a re-render.
   */
  onCompositionStart: function onCompositionStart(editor) {
    stillComposing = true;
    startDOMObserver(editor);
  },

  /**
   * Attempt to end the current composition session.
   *
   * Defer handling because browser will still insert the chars into active
   * element after `compositionend`. If a `compositionstart` event fires
   * before `resolveComposition` executes, our composition session will
   * continue.
   *
   * The `resolved` flag is useful because certain IME interfaces fire the
   * `compositionend` event multiple times, thus queueing up multiple attempts
   * at handling the composition. Since handling the same composition event
   * twice could break the DOM, we only use the first event. Example: Arabic
   * Google Input Tools on Windows 8.1 fires `compositionend` three times.
   */
  onCompositionEnd: function onCompositionEnd(editor) {
    resolved = false;
    stillComposing = false;
    setTimeout(function () {
      if (!resolved) {
        DraftEditorCompositionHandler.resolveComposition(editor);
      }
    }, RESOLVE_DELAY);
  },
  onSelect: editOnSelect,

  /**
   * In Safari, keydown events may fire when committing compositions. If
   * the arrow keys are used to commit, prevent default so that the cursor
   * doesn't move, otherwise it will jump back noticeably on re-render.
   */
  onKeyDown: function onKeyDown(editor, e) {
    if (!stillComposing) {
      // If a keydown event is received after compositionend but before the
      // 20ms timer expires (ex: type option-E then backspace, or type A then
      // backspace in 2-Set Korean), we should immediately resolve the
      // composition and reinterpret the key press in edit mode.
      DraftEditorCompositionHandler.resolveComposition(editor);

      editor._onKeyDown(e);

      return;
    }

    if (e.which === Keys.RIGHT || e.which === Keys.LEFT) {
      e.preventDefault();
    }
  },

  /**
   * Keypress events may fire when committing compositions. In Firefox,
   * pressing RETURN commits the composition and inserts extra newline
   * characters that we do not want. `preventDefault` allows the composition
   * to be committed while preventing the extra characters.
   */
  onKeyPress: function onKeyPress(_editor, e) {
    if (e.which === Keys.RETURN) {
      e.preventDefault();
    }
  },

  /**
   * Attempt to insert composed characters into the document.
   *
   * If we are still in a composition session, do nothing. Otherwise, insert
   * the characters into the document and terminate the composition session.
   *
   * If no characters were composed -- for instance, the user
   * deleted all composed characters and committed nothing new --
   * force a re-render. We also re-render when the composition occurs
   * at the beginning of a leaf, to ensure that if the browser has
   * created a new text node for the composition, we will discard it.
   *
   * Resetting innerHTML will move focus to the beginning of the editor,
   * so we update to force it back to the correct place.
   */
  resolveComposition: function resolveComposition(editor) {
    if (stillComposing) {
      return;
    }

    var mutations = nullthrows(domObserver).stopAndFlushMutations();
    domObserver = null;
    resolved = true;
    var editorState = EditorState.set(editor._latestEditorState, {
      inCompositionMode: false
    });
    editor.exitCurrentMode();

    if (!mutations.size) {
      editor.update(editorState);
      return;
    } // TODO, check if Facebook still needs this flag or if it could be removed.
    // Since there can be multiple mutations providing a `composedChars` doesn't
    // apply well on this new model.
    // if (
    //   gkx('draft_handlebeforeinput_composed_text') &&
    //   editor.props.handleBeforeInput &&
    //   isEventHandled(
    //     editor.props.handleBeforeInput(
    //       composedChars,
    //       editorState,
    //       event.timeStamp,
    //     ),
    //   )
    // ) {
    //   return;
    // }


    var contentState = editorState.getCurrentContent();
    mutations.forEach(function (composedChars, offsetKey) {
      var _DraftOffsetKey$decod = DraftOffsetKey.decode(offsetKey),
          blockKey = _DraftOffsetKey$decod.blockKey,
          decoratorKey = _DraftOffsetKey$decod.decoratorKey,
          leafKey = _DraftOffsetKey$decod.leafKey;

      var _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]),
          start = _editorState$getBlock.start,
          end = _editorState$getBlock.end;

      var replacementRange = editorState.getSelection().merge({
        anchorKey: blockKey,
        focusKey: blockKey,
        anchorOffset: start,
        focusOffset: end,
        isBackward: false
      });
      var entityKey = getEntityKeyForSelection(contentState, replacementRange);
      var currentStyle = contentState.getBlockForKey(blockKey).getInlineStyleAt(start);
      contentState = DraftModifier.replaceText(contentState, replacementRange, composedChars, currentStyle, entityKey); // We need to update the editorState so the leaf node ranges are properly
      // updated and multiple mutations are correctly applied.

      editorState = EditorState.set(editorState, {
        currentContent: contentState
      });
    }); // When we apply the text changes to the ContentState, the selection always
    // goes to the end of the field, but it should just stay where it is
    // after compositionEnd.

    var documentSelection = getDraftEditorSelection(editorState, getContentEditableContainer(editor));
    var compositionEndSelectionState = documentSelection.selectionState;
    editor.restoreEditorDOM(); // See:
    // - https://github.com/facebook/draft-js/issues/2093
    // - https://github.com/facebook/draft-js/pull/2094
    // Apply this fix only in IE for now. We can test it in
    // other browsers in the future to ensure no regressions

    var editorStateWithUpdatedSelection = isIE ? EditorState.forceSelection(editorState, compositionEndSelectionState) : EditorState.acceptSelection(editorState, compositionEndSelectionState);
    editor.update(EditorState.push(editorStateWithUpdatedSelection, contentState, 'insert-characters'));
  }
};
module.exports = DraftEditorCompositionHandler;

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UserAgent = __webpack_require__(31);

var findAncestorOffsetKey = __webpack_require__(161);

var getWindowForNode = __webpack_require__(351);

var Immutable = __webpack_require__(4);

var invariant = __webpack_require__(9);

var nullthrows = __webpack_require__(30);

var Map = Immutable.Map;
// Heavily based on Prosemirror's DOMObserver https://github.com/ProseMirror/prosemirror-view/blob/master/src/domobserver.js
var DOM_OBSERVER_OPTIONS = {
  subtree: true,
  characterData: true,
  childList: true,
  characterDataOldValue: false,
  attributes: false
}; // IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified

var USE_CHAR_DATA = UserAgent.isBrowser('IE <= 11');

var DOMObserver = /*#__PURE__*/function () {
  function DOMObserver(container) {
    var _this = this;

    _defineProperty(this, "observer", void 0);

    _defineProperty(this, "container", void 0);

    _defineProperty(this, "mutations", void 0);

    _defineProperty(this, "onCharData", void 0);

    this.container = container;
    this.mutations = Map();
    var containerWindow = getWindowForNode(container);

    if (containerWindow.MutationObserver && !USE_CHAR_DATA) {
      this.observer = new containerWindow.MutationObserver(function (mutations) {
        return _this.registerMutations(mutations);
      });
    } else {
      this.onCharData = function (e) {
        !(e.target instanceof Node) ?  false ? invariant(false, 'Expected target to be an instance of Node') : invariant(false) : void 0;

        _this.registerMutation({
          type: 'characterData',
          target: e.target
        });
      };
    }
  }

  var _proto = DOMObserver.prototype;

  _proto.start = function start() {
    if (this.observer) {
      this.observer.observe(this.container, DOM_OBSERVER_OPTIONS);
    } else {
      /* $FlowFixMe[incompatible-call] (>=0.68.0 site=www,mobile) This event
       * type is not defined by Flow's standard library */
      this.container.addEventListener('DOMCharacterDataModified', this.onCharData);
    }
  };

  _proto.stopAndFlushMutations = function stopAndFlushMutations() {
    var observer = this.observer;

    if (observer) {
      this.registerMutations(observer.takeRecords());
      observer.disconnect();
    } else {
      /* $FlowFixMe[incompatible-call] (>=0.68.0 site=www,mobile) This event
       * type is not defined by Flow's standard library */
      this.container.removeEventListener('DOMCharacterDataModified', this.onCharData);
    }

    var mutations = this.mutations;
    this.mutations = Map();
    return mutations;
  };

  _proto.registerMutations = function registerMutations(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      this.registerMutation(mutations[i]);
    }
  };

  _proto.getMutationTextContent = function getMutationTextContent(mutation) {
    var type = mutation.type,
        target = mutation.target,
        removedNodes = mutation.removedNodes;

    if (type === 'characterData') {
      // When `textContent` is '', there is a race condition that makes
      // getting the offsetKey from the target not possible.
      // These events are also followed by a `childList`, which is the one
      // we are able to retrieve the offsetKey and apply the '' text.
      if (target.textContent !== '') {
        // IE 11 considers the enter keypress that concludes the composition
        // as an input char. This strips that newline character so the draft
        // state does not receive spurious newlines.
        if (USE_CHAR_DATA) {
          return target.textContent.replace('\n', '');
        }

        return target.textContent;
      }
    } else if (type === 'childList') {
      if (removedNodes && removedNodes.length) {
        // `characterData` events won't happen or are ignored when
        // removing the last character of a leaf node, what happens
        // instead is a `childList` event with a `removedNodes` array.
        // For this case the textContent should be '' and
        // `DraftModifier.replaceText` will make sure the content is
        // updated properly.
        return '';
      } else if (target.textContent !== '') {
        // Typing Chinese in an empty block in MS Edge results in a
        // `childList` event with non-empty textContent.
        // See https://github.com/facebook/draft-js/issues/2082
        return target.textContent;
      }
    }

    return null;
  };

  _proto.registerMutation = function registerMutation(mutation) {
    var textContent = this.getMutationTextContent(mutation);

    if (textContent != null) {
      var offsetKey = nullthrows(findAncestorOffsetKey(mutation.target));
      this.mutations = this.mutations.set(offsetKey, textContent);
    }
  };

  return DOMObserver;
}();

module.exports = DOMObserver;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * Usage note:
 * This module makes a best effort to export the same data we would internally.
 * At Facebook we use a server-generated module that does the parsing and
 * exports the data for the client to use. We can't rely on a server-side
 * implementation in open source so instead we make use of an open source
 * library to do the heavy lifting and then make some adjustments as necessary.
 * It's likely there will be some differences. Some we can smooth over.
 * Others are going to be harder.
 */


var UAParser = __webpack_require__(824);

var UNKNOWN = 'Unknown';
var PLATFORM_MAP = {
  'Mac OS': 'Mac OS X'
};
/**
 * Convert from UAParser platform name to what we expect.
 */

function convertPlatformName(name) {
  return PLATFORM_MAP[name] || name;
}
/**
 * Get the version number in parts. This is very naive. We actually get major
 * version as a part of UAParser already, which is generally good enough, but
 * let's get the minor just in case.
 */


function getBrowserVersion(version) {
  if (!version) {
    return {
      major: '',
      minor: ''
    };
  }

  var parts = version.split('.');
  return {
    major: parts[0],
    minor: parts[1]
  };
}
/**
 * Get the UA data fom UAParser and then convert it to the format we're
 * expecting for our APIS.
 */


var parser = new UAParser();
var results = parser.getResult(); // Do some conversion first.

var browserVersionData = getBrowserVersion(results.browser.version);
var uaData = {
  browserArchitecture: results.cpu.architecture || UNKNOWN,
  browserFullVersion: results.browser.version || UNKNOWN,
  browserMinorVersion: browserVersionData.minor || UNKNOWN,
  browserName: results.browser.name || UNKNOWN,
  browserVersion: results.browser.major || UNKNOWN,
  deviceName: results.device.model || UNKNOWN,
  engineName: results.engine.name || UNKNOWN,
  engineVersion: results.engine.version || UNKNOWN,
  platformArchitecture: results.cpu.architecture || UNKNOWN,
  platformName: convertPlatformName(results.os.name) || UNKNOWN,
  platformVersion: results.os.version || UNKNOWN,
  platformFullVersion: results.os.version || UNKNOWN
};
module.exports = uaData;

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/////////////////////////////////////////////////////////////////////////////////
/* UAParser.js v0.7.33
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License *//*
   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
   Supports browser & node.js environment. 
   Demo   : https://faisalman.github.io/ua-parser-js
   Source : https://github.com/faisalman/ua-parser-js */
/////////////////////////////////////////////////////////////////////////////////

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '0.7.33',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major',
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded',
        UA_MAX_LENGTH = 350;

    var AMAZON  = 'Amazon',
        APPLE   = 'Apple',
        ASUS    = 'ASUS',
        BLACKBERRY = 'BlackBerry',
        BROWSER = 'Browser',
        CHROME  = 'Chrome',
        EDGE    = 'Edge',
        FIREFOX = 'Firefox',
        GOOGLE  = 'Google',
        HUAWEI  = 'Huawei',
        LG      = 'LG',
        MICROSOFT = 'Microsoft',
        MOTOROLA  = 'Motorola',
        OPERA   = 'Opera',
        SAMSUNG = 'Samsung',
        SHARP   = 'Sharp',
        SONY    = 'Sony',
        XIAOMI  = 'Xiaomi',
        ZEBRA   = 'Zebra',
        FACEBOOK   = 'Facebook';

    ///////////
    // Helper
    //////////

    var extend = function (regexes, extensions) {
            var mergedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    mergedRegexes[i] = regexes[i];
                }
            }
            return mergedRegexes;
        },
        enumerize = function (arr) {
            var enums = {};
            for (var i=0; i<arr.length; i++) {
                enums[arr[i].toUpperCase()] = arr[i];
            }
            return enums;
        },
        has = function (str1, str2) {
            return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
        },
        lowerize = function (str) {
            return str.toLowerCase();
        },
        majorize = function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
        },
        trim = function (str, len) {
            if (typeof(str) === STR_TYPE) {
                str = str.replace(/^\s\s*/, EMPTY);
                return typeof(len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
            }
    };

    ///////////////
    // Map helper
    //////////////

    var rgxMapper = function (ua, arrays) {

            var i = 0, j, k, p, q, matches, match;

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length === 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length === 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length === 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
        },

        strMapper = function (str, map) {

            for (var i in map) {
                // check if current value is array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
    };

    ///////////////
    // String map
    //////////////

    // Safari < 3.0
    var oldSafariMap = {
            '1.0'   : '/8',
            '1.2'   : '/1',
            '1.3'   : '/3',
            '2.0'   : '/412',
            '2.0.2' : '/416',
            '2.0.3' : '/417',
            '2.0.4' : '/419',
            '?'     : '/'
        },
        windowsVersionMap = {
            'ME'        : '4.90',
            'NT 3.11'   : 'NT3.51',
            'NT 4.0'    : 'NT4.0',
            '2000'      : 'NT 5.0',
            'XP'        : ['NT 5.1', 'NT 5.2'],
            'Vista'     : 'NT 6.0',
            '7'         : 'NT 6.1',
            '8'         : 'NT 6.2',
            '8.1'       : 'NT 6.3',
            '10'        : ['NT 6.4', 'NT 10.0'],
            'RT'        : 'ARM'
    };

    //////////////
    // Regex map
    /////////////

    var regexes = {

        browser : [[

            /\b(?:crmo|crios)\/([\w\.]+)/i                                      // Chrome for Android/iOS
            ], [VERSION, [NAME, 'Chrome']], [
            /edg(?:e|ios|a)?\/([\w\.]+)/i                                       // Microsoft Edge
            ], [VERSION, [NAME, 'Edge']], [

            // Presto based
            /(opera mini)\/([-\w\.]+)/i,                                        // Opera Mini
            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,                 // Opera Mobi/Tablet
            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i                           // Opera
            ], [NAME, VERSION], [
            /opios[\/ ]+([\w\.]+)/i                                             // Opera mini on iphone >= 8.0
            ], [VERSION, [NAME, OPERA+' Mini']], [
            /\bopr\/([\w\.]+)/i                                                 // Opera Webkit
            ], [VERSION, [NAME, OPERA]], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,      // Lunascape/Maxthon/Netfront/Jasmine/Blazer
            // Trident based
            /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,               // Avant/IEMobile/SlimBrowser
            /(ba?idubrowser)[\/ ]?([\w\.]+)/i,                                  // Baidu Browser
            /(?:ms|\()(ie) ([\w\.]+)/i,                                         // Internet Explorer

            // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                                                                                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
            /(weibo)__([\d\.]+)/i                                               // Weibo
            ], [NAME, VERSION], [
            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i                 // UCBrowser
            ], [VERSION, [NAME, 'UC'+BROWSER]], [
            /microm.+\bqbcore\/([\w\.]+)/i,                                     // WeChat Desktop for Windows Built-in Browser
            /\bqbcore\/([\w\.]+).+microm/i
            ], [VERSION, [NAME, 'WeChat(Win) Desktop']], [
            /micromessenger\/([\w\.]+)/i                                        // WeChat
            ], [VERSION, [NAME, 'WeChat']], [
            /konqueror\/([\w\.]+)/i                                             // Konqueror
            ], [VERSION, [NAME, 'Konqueror']], [
            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i                       // IE11
            ], [VERSION, [NAME, 'IE']], [
            /yabrowser\/([\w\.]+)/i                                             // Yandex
            ], [VERSION, [NAME, 'Yandex']], [
            /(avast|avg)\/([\w\.]+)/i                                           // Avast/AVG Secure Browser
            ], [[NAME, /(.+)/, '$1 Secure '+BROWSER], VERSION], [
            /\bfocus\/([\w\.]+)/i                                               // Firefox Focus
            ], [VERSION, [NAME, FIREFOX+' Focus']], [
            /\bopt\/([\w\.]+)/i                                                 // Opera Touch
            ], [VERSION, [NAME, OPERA+' Touch']], [
            /coc_coc\w+\/([\w\.]+)/i                                            // Coc Coc Browser
            ], [VERSION, [NAME, 'Coc Coc']], [
            /dolfin\/([\w\.]+)/i                                                // Dolphin
            ], [VERSION, [NAME, 'Dolphin']], [
            /coast\/([\w\.]+)/i                                                 // Opera Coast
            ], [VERSION, [NAME, OPERA+' Coast']], [
            /miuibrowser\/([\w\.]+)/i                                           // MIUI Browser
            ], [VERSION, [NAME, 'MIUI '+BROWSER]], [
            /fxios\/([-\w\.]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, FIREFOX]], [
            /\bqihu|(qi?ho?o?|360)browser/i                                     // 360
            ], [[NAME, '360 '+BROWSER]], [
            /(oculus|samsung|sailfish|huawei)browser\/([\w\.]+)/i
            ], [[NAME, /(.+)/, '$1 '+BROWSER], VERSION], [                      // Oculus/Samsung/Sailfish/Huawei Browser
            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [
            /(electron)\/([\w\.]+) safari/i,                                    // Electron-based App
            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,                   // Tesla
            /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i            // QQBrowser/Baidu App/2345 Browser
            ], [NAME, VERSION], [
            /(metasr)[\/ ]?([\w\.]+)/i,                                         // SouGouBrowser
            /(lbbrowser)/i,                                                     // LieBao Browser
            /\[(linkedin)app\]/i                                                // LinkedIn App for iOS & Android
            ], [NAME], [

            // WebView
            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i       // Facebook App for iOS & Android
            ], [[NAME, FACEBOOK], VERSION], [
            /safari (line)\/([\w\.]+)/i,                                        // Line App for iOS
            /\b(line)\/([\w\.]+)\/iab/i,                                        // Line App for Android
            /(chromium|instagram)[\/ ]([-\w\.]+)/i                              // Chromium/Instagram
            ], [NAME, VERSION], [
            /\bgsa\/([\w\.]+) .*safari\//i                                      // Google Search Appliance on iOS
            ], [VERSION, [NAME, 'GSA']], [

            /headlesschrome(?:\/([\w\.]+)| )/i                                  // Chrome Headless
            ], [VERSION, [NAME, CHROME+' Headless']], [

            / wv\).+(chrome)\/([\w\.]+)/i                                       // Chrome WebView
            ], [[NAME, CHROME+' WebView'], VERSION], [

            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i           // Android Browser
            ], [VERSION, [NAME, 'Android '+BROWSER]], [

            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i       // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i                      // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [
            /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i                // Safari & Safari Mobile
            ], [VERSION, NAME], [
            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i                      // Safari < 3.0
            ], [NAME, [VERSION, strMapper, oldSafariMap]], [

            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape\d?)\/([-\w\.]+)/i                              // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /mobile vr; rv:([\w\.]+)\).+firefox/i                               // Firefox Reality
            ], [VERSION, [NAME, FIREFOX+' Reality']], [
            /ekiohf.+(flow)\/([\w\.]+)/i,                                       // Flow
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(firefox)\/([\w\.]+)/i,                                            // Other Firefox-based
            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,                         // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
            /(links) \(([\w\.]+)/i                                              // Links
            ], [NAME, VERSION], [
            
            /(cobalt)\/([\w\.]+)/i                                              // Cobalt
            ], [NAME, [VERSION, /master.|lts./, ""]]
        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i                     // AMD64 (x64)
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32 (x86)
            ], [[ARCHITECTURE, 'ia32']], [

            /\b(aarch64|arm(v?8e?l?|_?64))\b/i                                 // ARM64
            ], [[ARCHITECTURE, 'arm64']], [

            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i                                   // ARMHF
            ], [[ARCHITECTURE, 'armhf']], [

            // PocketPC mistakenly identified as PowerPC
            /windows (ce|mobile); ppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i                            // PowerPC
            ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, lowerize]]
        ],

        device : [[

            //////////////////////////
            // MOBILES & TABLETS
            // Ordered by popularity
            /////////////////////////

            // Samsung
            /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [
            /\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,
            /samsung[- ]([-\w]+)/i,
            /sec-(sgh\w+)/i
            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [

            // Apple
            /\((ip(?:hone|od)[\w ]*);/i                                         // iPod/iPhone
            ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [
            /\((ipad);[-\w\),; ]+apple/i,                                       // iPad
            /applecoremedia\/[\w\.]+ \((ipad)/i,
            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [
            /(macintosh);/i
            ], [MODEL, [VENDOR, APPLE]], [

            // Huawei
            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [
            /(?:huawei|honor)([-\w ]+)[;\)]/i,
            /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [

            // Xiaomi
            /\b(poco[\w ]+)(?: bui|\))/i,                                       // Xiaomi POCO
            /\b; (\w+) build\/hm\1/i,                                           // Xiaomi Hongmi 'numeric' models
            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,                             // Xiaomi Hongmi
            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,                   // Xiaomi Redmi
            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
            ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [
            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i                        // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [

            // OPPO
            /; (\w+) bui.+ oppo/i,
            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [

            // Vivo
            /vivo (\w+)(?: bui|\))/i,
            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [

            // Realme
            /\b(rmx[12]\d{3})(?: bui|;|\))/i
            ], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [

            // Motorola
            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
            /\bmot(?:orola)?[- ](\w*)/i,
            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [
            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [

            // LG
            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [
            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
            /\blg-?([\d\w]+) bui/i
            ], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [

            // Lenovo
            /(ideatab[-\w ]+)/i,
            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            // Nokia
            /(?:maemo|nokia).*(n900|lumia \d+)/i,
            /nokia[-_ ]?([-\w\.]*)/i
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [

            // Google
            /(pixel c)\b/i                                                      // Google Pixel C
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [
            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i                         // Google Pixel
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [

            // Sony
            /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [
            /sony tablet [ps]/i,
            /\b(?:sony)?sgp\w+(?: bui|\))/i
            ], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [

            // OnePlus
            / (kb2005|in20[12]5|be20[12][59])\b/i,
            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            // Amazon
            /(alexa)webm/i,
            /(kf[a-z]{2}wi)( bui|\))/i,                                         // Kindle Fire without Silk
            /(kf[a-z]+)( bui|\)).+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [
            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i                     // Fire Phone
            ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [

            // BlackBerry
            /(playbook);[-\w\),; ]+(rim)/i                                      // BlackBerry PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [
            /\b((?:bb[a-f]|st[hv])100-\d)/i,
            /\(bb10; (\w+)/i                                                    // BlackBerry 10
            ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [

            // Asus
            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [
            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [

            // HTC
            /(nexus 9)/i                                                        // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,                         // HTC

            // ZTE
            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
            /(alcatel|geeksphone|nexian|panasonic|sony(?!-bra))[-_ ]?([-\w]*)/i         // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            // Acer
            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            // Meizu
            /droid.+; (m[1-5] note) bui/i,
            /\bmz-([-\w]{2,})/i
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [

            // Sharp
            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ], [MODEL, [VENDOR, SHARP], [TYPE, MOBILE]], [

            // MIXED
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
                                                                                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp) ([\w ]+\w)/i,                                                 // HP iPAQ
            /(asus)-?(\w+)/i,                                                   // Asus
            /(microsoft); (lumia[\w ]+)/i,                                      // Microsoft Lumia
            /(lenovo)[-_ ]?([-\w]+)/i,                                          // Lenovo
            /(jolla)/i,                                                         // Jolla
            /(oppo) ?([\w ]+) bui/i                                             // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /(archos) (gamepad2?)/i,                                            // Archos
            /(hp).+(touchpad(?!.+tablet)|tablet)/i,                             // HP TouchPad
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(nook)[\w ]+build\/(\w+)/i,                                        // Nook
            /(dell) (strea[kpr\d ]*[\dko])/i,                                   // Dell Streak
            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,                                  // Le Pan Tablets
            /(trinity)[- ]*(t\d{3}) bui/i,                                      // Trinity Tablets
            /(gigaset)[- ]+(q\w{1,9}) bui/i,                                    // Gigaset Tablets
            /(vodafone) ([\w ]+)(?:\)| bui)/i                                   // Vodafone
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(surface duo)/i                                                    // Surface Duo
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [
            /droid [\d\.]+; (fp\du?)(?: b|\))/i                                 // Fairphone
            ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [
            /(u304aa)/i                                                         // AT&T
            ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [
            /\bsie-(\w*)/i                                                      // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
            /\b(rct\w+) b/i                                                     // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
            /\b(venue[\d ]{2,7}) b/i                                            // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
            /\b(q(?:mv|ta)\w+) b/i                                              // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i                       // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [
            /\b(tm\d{3}\w+) b/i
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
            /\b(k88) b/i                                                        // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
            /\b(nx\d{3}j) b/i                                                   // ZTE Nubia
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
            /\b(gen\d{3}) b.+49h/i                                              // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
            /\b(zur\d{3}) b/i                                                   // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
            /\b((zeki)?tb.*\b) b/i                                              // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
            /\b([yr]\d{2}) b/i,
            /\b(dragon[- ]+touch |dt)(\w{5}) b/i                                // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
            /\b(ns-?\w{0,9}) b/i                                                // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
            /\b((nxa|next)-?\w{0,9}) b/i                                        // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i                  // Voice Xtreme Phones
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [
            /\b(lvtel\-)?(v1[12]) b/i                                           // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
            /\b(ph-1) /i                                                        // Essential PH-1
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [
            /\b(v(100md|700na|7011|917g).*\b) b/i                               // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
            /\b(trio[-\w\. ]+) b/i                                              // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
            /\btu_(1491) b/i                                                    // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
            /(shield[\w ]+) b/i                                                 // Nvidia Shield Tablets
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [
            /(sprint) (\w+)/i                                                   // Sprint Phones
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [
            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i             // Zebra
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [
            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [

            ///////////////////
            // CONSOLES
            ///////////////////

            /(ouya)/i,                                                          // Ouya
            /(nintendo) ([wids3utch]+)/i                                        // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
            /droid.+; (shield) bui/i                                            // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
            /(playstation [345portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [
            /\b(xbox(?: one)?(?!; xbox))[\); ]/i                                // Microsoft Xbox
            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [

            ///////////////////
            // SMARTTVS
            ///////////////////

            /smart-tv.+(samsung)/i                                              // Samsung
            ], [VENDOR, [TYPE, SMARTTV]], [
            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [
            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i        // LG SmartTV
            ], [[VENDOR, LG], [TYPE, SMARTTV]], [
            /(apple) ?tv/i                                                      // Apple TV
            ], [VENDOR, [MODEL, APPLE+' TV'], [TYPE, SMARTTV]], [
            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, CHROME+'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [
            /droid.+aft(\w)( bui|\))/i                                          // Fire TV
            ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [
            /\(dtv[\);].+(aquos)/i,
            /(aquos-tv[\w ]+)\)/i                                               // Sharp
            ], [MODEL, [VENDOR, SHARP], [TYPE, SMARTTV]],[
            /(bravia[\w ]+)( bui|\))/i                                              // Sony
            ], [MODEL, [VENDOR, SONY], [TYPE, SMARTTV]], [
            /(mitv-\w{5}) bui/i                                                 // Xiaomi
            ], [MODEL, [VENDOR, XIAOMI], [TYPE, SMARTTV]], [
            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,                          // Roku
            /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i               // HbbTV devices
            ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [
            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i                   // SmartTV from Unidentified Vendors
            ], [[TYPE, SMARTTV]], [

            ///////////////////
            // WEARABLES
            ///////////////////

            /((pebble))app/i                                                    // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
            /droid.+; (glass) \d/i                                              // Google Glass
            ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [
            /droid.+; (wt63?0{2,3})\)/i
            ], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [
            /(quest( 2)?)/i                                                     // Oculus Quest
            ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [

            ///////////////////
            // EMBEDDED
            ///////////////////

            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i                              // Tesla
            ], [VENDOR, [TYPE, EMBEDDED]], [

            ////////////////////
            // MIXED (GENERIC)
            ///////////////////

            /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i           // Android Phones from Unidentified Vendors
            ], [MODEL, [TYPE, MOBILE]], [
            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i       // Android Tablets from Unidentified Vendors
            ], [MODEL, [TYPE, TABLET]], [
            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i                      // Unidentifiable Tablet
            ], [[TYPE, TABLET]], [
            /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i    // Unidentifiable Mobile
            ], [[TYPE, MOBILE]], [
            /(android[-\w\. ]{0,9});.+buil/i                                    // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]
        ],

        engine : [[

            /windows.+ edge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, EDGE+'HTML']], [

            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
            ], [VERSION, [NAME, 'Blink']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
            /ekioh(flow)\/([\w\.]+)/i,                                          // Flow
            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,                           // KHTML/Tasman/Links
            /(icab)[\/ ]([23]\.[\d\.]+)/i                                       // iCab
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9})\b.+(gecko)/i                                     // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows
            /microsoft (windows) (vista|xp)/i                                   // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows) nt 6\.2; (arm)/i,                                        // Windows RT
            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,            // Windows Phone
            /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
            ], [NAME, [VERSION, strMapper, windowsVersionMap]], [
            /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, strMapper, windowsVersionMap]], [

            // iOS/macOS
            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,              // iOS
            /cfnetwork\/.+darwin/i
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
            /(mac os x) ?([\w\. ]*)/i,
            /(macintosh|mac_powerpc\b)(?!.+haiku)/i                             // Mac OS
            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

            // Mobile OSes
            /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i                    // Android-x86/HarmonyOS
            ], [VERSION, NAME], [                                               // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
            /(blackberry)\w*\/([\w\.]*)/i,                                      // Blackberry
            /(tizen|kaios)[\/ ]([\w\.]+)/i,                                     // Tizen/KaiOS
            /\((series40);/i                                                    // Series 40
            ], [NAME, VERSION], [
            /\(bb(10);/i                                                        // BlackBerry 10
            ], [VERSION, [NAME, BLACKBERRY]], [
            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i         // Symbian
            ], [VERSION, [NAME, 'Symbian']], [
            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
            ], [VERSION, [NAME, FIREFOX+' OS']], [
            /web0s;.+rt(tv)/i,
            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i                              // WebOS
            ], [VERSION, [NAME, 'webOS']], [

            // Google Chromecast
            /crkey\/([\d\.]+)/i                                                 // Google Chromecast
            ], [VERSION, [NAME, CHROME+'cast']], [
            /(cros) [\w]+ ([\w\.]+\w)/i                                         // Chromium OS
            ], [[NAME, 'Chromium OS'], VERSION],[

            // Console
            /(nintendo|playstation) ([wids345portablevuch]+)/i,                 // Nintendo/Playstation
            /(xbox); +xbox ([^\);]+)/i,                                         // Microsoft Xbox (360, One, X, S, Series X, Series S)

            // Other
            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,                            // Joli/Palm
            /(mint)[\/\(\) ]?(\w*)/i,                                           // Mint
            /(mageia|vectorlinux)[; ]/i,                                        // Mageia/VectorLinux
            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                                                                                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
            /(hurd|linux) ?([\w\.]*)/i,                                         // Hurd/Linux
            /(gnu) ?([\w\.]*)/i,                                                // GNU
            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
            /(haiku) (\w+)/i                                                    // Haiku
            ], [NAME, VERSION], [
            /(sunos) ?([\w\.\d]*)/i                                             // Solaris
            ], [[NAME, 'Solaris'], VERSION], [
            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,                              // Solaris
            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,                                  // AIX
            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,            // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX
            /(unix) ?([\w\.]*)/i                                                // UNIX
            ], [NAME, VERSION]
        ]
    };

    /////////////////
    // Constructor
    ////////////////

    var UAParser = function (ua, extensions) {

        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(ua, extensions).getResult();
        }

        var _ua = ua || ((typeof window !== UNDEF_TYPE && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;

        this.getBrowser = function () {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser.major = majorize(_browser.version);
            return _browser;
        };
        this.getCPU = function () {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function () {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            return _device;
        };
        this.getEngine = function () {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function () {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            return _os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return _ua;
        };
        this.setUA = function (ua) {
            _ua = (typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH) ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER =  enumerize([NAME, VERSION, MAJOR]);
    UAParser.CPU = enumerize([ARCHITECTURE]);
    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);

    ///////////
    // Export
    //////////

    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if (typeof module !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if ("function" === FUNC_TYPE && __webpack_require__(825)) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
                return UAParser;
            }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (typeof window !== UNDEF_TYPE) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),
/* 825 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var invariant = __webpack_require__(9);

var componentRegex = /\./;
var orRegex = /\|\|/;
var rangeRegex = /\s+\-\s+/;
var modifierRegex = /^(<=|<|=|>=|~>|~|>|)?\s*(.+)/;
var numericRegex = /^(\d*)(.*)/;
/**
 * Splits input `range` on "||" and returns true if any subrange matches
 * `version`.
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */

function checkOrExpression(range, version) {
  var expressions = range.split(orRegex);

  if (expressions.length > 1) {
    return expressions.some(function (range) {
      return VersionRange.contains(range, version);
    });
  } else {
    range = expressions[0].trim();
    return checkRangeExpression(range, version);
  }
}
/**
 * Splits input `range` on " - " (the surrounding whitespace is required) and
 * returns true if version falls between the two operands.
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */


function checkRangeExpression(range, version) {
  var expressions = range.split(rangeRegex);
  !(expressions.length > 0 && expressions.length <= 2) ?  false ? invariant(false, 'the "-" operator expects exactly 2 operands') : invariant(false) : void 0;

  if (expressions.length === 1) {
    return checkSimpleExpression(expressions[0], version);
  } else {
    var startVersion = expressions[0],
        endVersion = expressions[1];
    !(isSimpleVersion(startVersion) && isSimpleVersion(endVersion)) ?  false ? invariant(false, 'operands to the "-" operator must be simple (no modifiers)') : invariant(false) : void 0;
    return checkSimpleExpression('>=' + startVersion, version) && checkSimpleExpression('<=' + endVersion, version);
  }
}
/**
 * Checks if `range` matches `version`. `range` should be a "simple" range (ie.
 * not a compound range using the " - " or "||" operators).
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */


function checkSimpleExpression(range, version) {
  range = range.trim();

  if (range === '') {
    return true;
  }

  var versionComponents = version.split(componentRegex);

  var _getModifierAndCompon = getModifierAndComponents(range),
      modifier = _getModifierAndCompon.modifier,
      rangeComponents = _getModifierAndCompon.rangeComponents;

  switch (modifier) {
    case '<':
      return checkLessThan(versionComponents, rangeComponents);

    case '<=':
      return checkLessThanOrEqual(versionComponents, rangeComponents);

    case '>=':
      return checkGreaterThanOrEqual(versionComponents, rangeComponents);

    case '>':
      return checkGreaterThan(versionComponents, rangeComponents);

    case '~':
    case '~>':
      return checkApproximateVersion(versionComponents, rangeComponents);

    default:
      return checkEqual(versionComponents, rangeComponents);
  }
}
/**
 * Checks whether `a` is less than `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkLessThan(a, b) {
  return compareComponents(a, b) === -1;
}
/**
 * Checks whether `a` is less than or equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkLessThanOrEqual(a, b) {
  var result = compareComponents(a, b);
  return result === -1 || result === 0;
}
/**
 * Checks whether `a` is equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkEqual(a, b) {
  return compareComponents(a, b) === 0;
}
/**
 * Checks whether `a` is greater than or equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkGreaterThanOrEqual(a, b) {
  var result = compareComponents(a, b);
  return result === 1 || result === 0;
}
/**
 * Checks whether `a` is greater than `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkGreaterThan(a, b) {
  return compareComponents(a, b) === 1;
}
/**
 * Checks whether `a` is "reasonably close" to `b` (as described in
 * https://www.npmjs.org/doc/misc/semver.html). For example, if `b` is "1.3.1"
 * then "reasonably close" is defined as ">= 1.3.1 and < 1.4".
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkApproximateVersion(a, b) {
  var lowerBound = b.slice();
  var upperBound = b.slice();

  if (upperBound.length > 1) {
    upperBound.pop();
  }

  var lastIndex = upperBound.length - 1;
  var numeric = parseInt(upperBound[lastIndex], 10);

  if (isNumber(numeric)) {
    upperBound[lastIndex] = numeric + 1 + '';
  }

  return checkGreaterThanOrEqual(a, lowerBound) && checkLessThan(a, upperBound);
}
/**
 * Extracts the optional modifier (<, <=, =, >=, >, ~, ~>) and version
 * components from `range`.
 *
 * For example, given `range` ">= 1.2.3" returns an object with a `modifier` of
 * `">="` and `components` of `[1, 2, 3]`.
 *
 * @param {string} range
 * @returns {object}
 */


function getModifierAndComponents(range) {
  var rangeComponents = range.split(componentRegex);
  var matches = rangeComponents[0].match(modifierRegex);
  !matches ?  false ? invariant(false, 'expected regex to match but it did not') : invariant(false) : void 0;
  return {
    modifier: matches[1],
    rangeComponents: [matches[2]].concat(rangeComponents.slice(1))
  };
}
/**
 * Determines if `number` is a number.
 *
 * @param {mixed} number
 * @returns {boolean}
 */


function isNumber(number) {
  return !isNaN(number) && isFinite(number);
}
/**
 * Tests whether `range` is a "simple" version number without any modifiers
 * (">", "~" etc).
 *
 * @param {string} range
 * @returns {boolean}
 */


function isSimpleVersion(range) {
  return !getModifierAndComponents(range).modifier;
}
/**
 * Zero-pads array `array` until it is at least `length` long.
 *
 * @param {array} array
 * @param {number} length
 */


function zeroPad(array, length) {
  for (var i = array.length; i < length; i++) {
    array[i] = '0';
  }
}
/**
 * Normalizes `a` and `b` in preparation for comparison by doing the following:
 *
 * - zero-pads `a` and `b`
 * - marks any "x", "X" or "*" component in `b` as equivalent by zero-ing it out
 *   in both `a` and `b`
 * - marks any final "*" component in `b` as a greedy wildcard by zero-ing it
 *   and all of its successors in `a`
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {array<array<string>>}
 */


function normalizeVersions(a, b) {
  a = a.slice();
  b = b.slice();
  zeroPad(a, b.length); // mark "x" and "*" components as equal

  for (var i = 0; i < b.length; i++) {
    var matches = b[i].match(/^[x*]$/i);

    if (matches) {
      b[i] = a[i] = '0'; // final "*" greedily zeros all remaining components

      if (matches[0] === '*' && i === b.length - 1) {
        for (var j = i; j < a.length; j++) {
          a[j] = '0';
        }
      }
    }
  }

  zeroPad(b, a.length);
  return [a, b];
}
/**
 * Returns the numerical -- not the lexicographical -- ordering of `a` and `b`.
 *
 * For example, `10-alpha` is greater than `2-beta`.
 *
 * @param {string} a
 * @param {string} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */


function compareNumeric(a, b) {
  var aPrefix = a.match(numericRegex)[1];
  var bPrefix = b.match(numericRegex)[1];
  var aNumeric = parseInt(aPrefix, 10);
  var bNumeric = parseInt(bPrefix, 10);

  if (isNumber(aNumeric) && isNumber(bNumeric) && aNumeric !== bNumeric) {
    return compare(aNumeric, bNumeric);
  } else {
    return compare(a, b);
  }
}
/**
 * Returns the ordering of `a` and `b`.
 *
 * @param {string|number} a
 * @param {string|number} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */


function compare(a, b) {
  !(typeof a === typeof b) ?  false ? invariant(false, '"a" and "b" must be of the same type') : invariant(false) : void 0;

  if (a > b) {
    return 1;
  } else if (a < b) {
    return -1;
  } else {
    return 0;
  }
}
/**
 * Compares arrays of version components.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */


function compareComponents(a, b) {
  var _normalizeVersions = normalizeVersions(a, b),
      aNormalized = _normalizeVersions[0],
      bNormalized = _normalizeVersions[1];

  for (var i = 0; i < bNormalized.length; i++) {
    var result = compareNumeric(aNormalized[i], bNormalized[i]);

    if (result) {
      return result;
    }
  }

  return 0;
}

var VersionRange = {
  /**
   * Checks whether `version` satisfies the `range` specification.
   *
   * We support a subset of the expressions defined in
   * https://www.npmjs.org/doc/misc/semver.html:
   *
   *    version   Must match version exactly
   *    =version  Same as just version
   *    >version  Must be greater than version
   *    >=version Must be greater than or equal to version
   *    <version  Must be less than version
   *    <=version Must be less than or equal to version
   *    ~version  Must be at least version, but less than the next significant
   *              revision above version:
   *              "~1.2.3" is equivalent to ">= 1.2.3 and < 1.3"
   *    ~>version Equivalent to ~version
   *    1.2.x     Must match "1.2.x", where "x" is a wildcard that matches
   *              anything
   *    1.2.*     Similar to "1.2.x", but "*" in the trailing position is a
   *              "greedy" wildcard, so will match any number of additional
   *              components:
   *              "1.2.*" will match "1.2.1", "1.2.1.1", "1.2.1.1.1" etc
   *    *         Any version
   *    ""        (Empty string) Same as *
   *    v1 - v2   Equivalent to ">= v1 and <= v2"
   *    r1 || r2  Passes if either r1 or r2 are satisfied
   *
   * @param {string} range
   * @param {string} version
   * @returns {boolean}
   */
  contains: function contains(range, version) {
    return checkOrExpression(range.trim(), version.trim());
  }
};
module.exports = VersionRange;

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var hasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * Executes the provided `callback` once for each enumerable own property in the
 * object and constructs a new object from the results. The `callback` is
 * invoked with three arguments:
 *
 *  - the property value
 *  - the property name
 *  - the object being traversed
 *
 * Properties that are added after the call to `mapObject` will not be visited
 * by `callback`. If the values of existing properties are changed, the value
 * passed to `callback` will be the value at the time `mapObject` visits them.
 * Properties that are deleted before being visited are not visited.
 *
 * @grep function objectMap()
 * @grep function objMap()
 *
 * @param {?object} object
 * @param {function} callback
 * @param {*} context
 * @return {?object}
 */

function mapObject(object, callback, context) {
  if (!object) {
    return null;
  }

  var result = {};

  for (var name in object) {
    if (hasOwnProperty.call(object, name)) {
      result[name] = callback.call(context, object[name], name, object);
    }
  }

  return result;
}

module.exports = mapObject;

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */

/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }

    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 */


var gkx = __webpack_require__(70);

var experimentalTreeDataSupport = gkx('draft_tree_data_support');
module.exports = experimentalTreeDataSupport ? __webpack_require__(830) : __webpack_require__(844);

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This file is a fork of DraftEditorContents.react.js for tree nodes
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */


var _assign = __webpack_require__(8);

function _extends() { _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DraftEditorBlockNode = __webpack_require__(831);

var DraftOffsetKey = __webpack_require__(64);

var React = __webpack_require__(1);

var nullthrows = __webpack_require__(30);

/**
 * `DraftEditorContents` is the container component for all block components
 * rendered for a `DraftEditor`. It is optimized to aggressively avoid
 * re-rendering blocks whenever possible.
 *
 * This component is separate from `DraftEditor` because certain props
 * (for instance, ARIA props) must be allowed to update without affecting
 * the contents of the editor.
 */
var DraftEditorContentsExperimental = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorContentsExperimental, _React$Component);

  function DraftEditorContentsExperimental() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DraftEditorContentsExperimental.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var prevEditorState = this.props.editorState;
    var nextEditorState = nextProps.editorState;
    var prevDirectionMap = prevEditorState.getDirectionMap();
    var nextDirectionMap = nextEditorState.getDirectionMap(); // Text direction has changed for one or more blocks. We must re-render.

    if (prevDirectionMap !== nextDirectionMap) {
      return true;
    }

    var didHaveFocus = prevEditorState.getSelection().getHasFocus();
    var nowHasFocus = nextEditorState.getSelection().getHasFocus();

    if (didHaveFocus !== nowHasFocus) {
      return true;
    }

    var nextNativeContent = nextEditorState.getNativelyRenderedContent();
    var wasComposing = prevEditorState.isInCompositionMode();
    var nowComposing = nextEditorState.isInCompositionMode(); // If the state is unchanged or we're currently rendering a natively
    // rendered state, there's nothing new to be done.

    if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
      return false;
    }

    var prevContent = prevEditorState.getCurrentContent();
    var nextContent = nextEditorState.getCurrentContent();
    var prevDecorator = prevEditorState.getDecorator();
    var nextDecorator = nextEditorState.getDecorator();
    return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        blockRenderMap = _this$props.blockRenderMap,
        blockRendererFn = _this$props.blockRendererFn,
        blockStyleFn = _this$props.blockStyleFn,
        customStyleMap = _this$props.customStyleMap,
        customStyleFn = _this$props.customStyleFn,
        editorState = _this$props.editorState,
        editorKey = _this$props.editorKey,
        textDirectionality = _this$props.textDirectionality;
    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var forceSelection = editorState.mustForceSelection();
    var decorator = editorState.getDecorator();
    var directionMap = nullthrows(editorState.getDirectionMap());
    var blocksAsArray = content.getBlocksAsArray();
    var rootBlock = blocksAsArray[0];
    var processedBlocks = [];
    var nodeBlock = rootBlock;

    while (nodeBlock) {
      var blockKey = nodeBlock.getKey();
      var blockProps = {
        blockRenderMap: blockRenderMap,
        blockRendererFn: blockRendererFn,
        blockStyleFn: blockStyleFn,
        contentState: content,
        customStyleFn: customStyleFn,
        customStyleMap: customStyleMap,
        decorator: decorator,
        editorKey: editorKey,
        editorState: editorState,
        forceSelection: forceSelection,
        selection: selection,
        block: nodeBlock,
        direction: textDirectionality ? textDirectionality : directionMap.get(blockKey),
        tree: editorState.getBlockTree(blockKey)
      };
      var configForType = blockRenderMap.get(nodeBlock.getType()) || blockRenderMap.get('unstyled');
      var wrapperTemplate = configForType.wrapper;
      processedBlocks.push({
        /* $FlowFixMe[incompatible-type] (>=0.112.0 site=www,mobile) This
         * comment suppresses an error found when Flow v0.112 was deployed. To
         * see the error delete this comment and run Flow. */
        block: React.createElement(DraftEditorBlockNode, _extends({
          key: blockKey
        }, blockProps)),
        wrapperTemplate: wrapperTemplate,
        key: blockKey,
        offsetKey: DraftOffsetKey.encode(blockKey, 0, 0)
      });
      var nextBlockKey = nodeBlock.getNextSiblingKey();
      nodeBlock = nextBlockKey ? content.getBlockForKey(nextBlockKey) : null;
    } // Group contiguous runs of blocks that have the same wrapperTemplate


    var outputBlocks = [];

    for (var ii = 0; ii < processedBlocks.length;) {
      var info = processedBlocks[ii];

      if (info.wrapperTemplate) {
        var blocks = [];

        do {
          blocks.push(processedBlocks[ii].block);
          ii++;
        } while (ii < processedBlocks.length && processedBlocks[ii].wrapperTemplate === info.wrapperTemplate);

        var wrapperElement = React.cloneElement(info.wrapperTemplate, {
          key: info.key + '-wrap',
          'data-offset-key': info.offsetKey
        }, blocks);
        outputBlocks.push(wrapperElement);
      } else {
        outputBlocks.push(info.block);
        ii++;
      }
    }

    return React.createElement("div", {
      "data-contents": "true"
    }, outputBlocks);
  };

  return DraftEditorContentsExperimental;
}(React.Component);

module.exports = DraftEditorContentsExperimental;

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This file is a fork of DraftEditorBlock.react.js and DraftEditorContents.react.js
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */


var _assign = __webpack_require__(8);

function _extends() { _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DraftEditorNode = __webpack_require__(832);

var DraftOffsetKey = __webpack_require__(64);

var React = __webpack_require__(1);

var Scroll = __webpack_require__(230);

var Style = __webpack_require__(164);

var getElementPosition = __webpack_require__(363);

var getScrollPosition = __webpack_require__(165);

var getViewportDimensions = __webpack_require__(364);

var Immutable = __webpack_require__(4);

var invariant = __webpack_require__(9);

var isHTMLElement = __webpack_require__(122);

var SCROLL_BUFFER = 10;
var List = Immutable.List; // we should harden up the bellow flow types to make them more strict

/**
 * Return whether a block overlaps with either edge of the `SelectionState`.
 */
var isBlockOnSelectionEdge = function isBlockOnSelectionEdge(selection, key) {
  return selection.getAnchorKey() === key || selection.getFocusKey() === key;
};
/**
 * We will use this helper to identify blocks that need to be wrapped but have siblings that
 * also share the same wrapper element, this way we can do the wrapping once the last sibling
 * is added.
 */


var shouldNotAddWrapperElement = function shouldNotAddWrapperElement(block, contentState) {
  var nextSiblingKey = block.getNextSiblingKey();
  return nextSiblingKey ? contentState.getBlockForKey(nextSiblingKey).getType() === block.getType() : false;
};

var applyWrapperElementToSiblings = function applyWrapperElementToSiblings(wrapperTemplate, Element, nodes) {
  var wrappedSiblings = []; // we check back until we find a sibling that does not have same wrapper

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = nodes.reverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var sibling = _step.value;

      if (sibling.type !== Element) {
        break;
      }

      wrappedSiblings.push(sibling);
    } // we now should remove from acc the wrappedSiblings and add them back under same wrap

  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  nodes.splice(nodes.indexOf(wrappedSiblings[0]), wrappedSiblings.length + 1);
  var childrenIs = wrappedSiblings.reverse();
  var key = childrenIs[0].key;
  nodes.push(React.cloneElement(wrapperTemplate, {
    key: "".concat(key, "-wrap"),
    'data-offset-key': DraftOffsetKey.encode(key, 0, 0)
  }, childrenIs));
  return nodes;
};

var getDraftRenderConfig = function getDraftRenderConfig(block, blockRenderMap) {
  var configForType = blockRenderMap.get(block.getType()) || blockRenderMap.get('unstyled');
  var wrapperTemplate = configForType.wrapper;
  var Element = configForType.element || blockRenderMap.get('unstyled').element;
  return {
    Element: Element,
    wrapperTemplate: wrapperTemplate
  };
};

var getCustomRenderConfig = function getCustomRenderConfig(block, blockRendererFn) {
  var customRenderer = blockRendererFn(block);

  if (!customRenderer) {
    return {};
  }

  var CustomComponent = customRenderer.component,
      customProps = customRenderer.props,
      customEditable = customRenderer.editable;
  return {
    CustomComponent: CustomComponent,
    customProps: customProps,
    customEditable: customEditable
  };
};

var getElementPropsConfig = function getElementPropsConfig(block, editorKey, offsetKey, blockStyleFn, customConfig, ref) {
  var elementProps = {
    'data-block': true,
    'data-editor': editorKey,
    'data-offset-key': offsetKey,
    key: block.getKey(),
    ref: ref
  };
  var customClass = blockStyleFn(block);

  if (customClass) {
    elementProps.className = customClass;
  }

  if (customConfig.customEditable !== undefined) {
    elementProps = _objectSpread({}, elementProps, {
      contentEditable: customConfig.customEditable,
      suppressContentEditableWarning: true
    });
  }

  return elementProps;
};

var DraftEditorBlockNode = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorBlockNode, _React$Component);

  function DraftEditorBlockNode() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "wrapperRef", React.createRef());

    return _this;
  }

  var _proto = DraftEditorBlockNode.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var _this$props = this.props,
        block = _this$props.block,
        direction = _this$props.direction,
        tree = _this$props.tree;
    var isContainerNode = !block.getChildKeys().isEmpty();
    var blockHasChanged = block !== nextProps.block || tree !== nextProps.tree || direction !== nextProps.direction || isBlockOnSelectionEdge(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection; // if we have children at this stage we always re-render container nodes
    // else if its a root node we avoid re-rendering by checking for block updates

    return isContainerNode || blockHasChanged;
  }
  /**
   * When a block is mounted and overlaps the selection state, we need to make
   * sure that the cursor is visible to match native behavior. This may not
   * be the case if the user has pressed `RETURN` or pasted some content, since
   * programatically creating these new blocks and setting the DOM selection
   * will miss out on the browser natively scrolling to that position.
   *
   * To replicate native behavior, if the block overlaps the selection state
   * on mount, force the scroll position. Check the scroll state of the scroll
   * parent, and adjust it to align the entire block to the bottom of the
   * scroll parent.
   */
  ;

  _proto.componentDidMount = function componentDidMount() {
    var selection = this.props.selection;
    var endKey = selection.getEndKey();

    if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
      return;
    }

    var blockNode = this.wrapperRef.current;

    if (!blockNode) {
      // This Block Node was rendered without a wrapper element.
      return;
    }

    var scrollParent = Style.getScrollParent(blockNode);
    var scrollPosition = getScrollPosition(scrollParent);
    var scrollDelta;

    if (scrollParent === window) {
      var nodePosition = getElementPosition(blockNode);
      var nodeBottom = nodePosition.y + nodePosition.height;
      var viewportHeight = getViewportDimensions().height;
      scrollDelta = nodeBottom - viewportHeight;

      if (scrollDelta > 0) {
        window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER);
      }
    } else {
      !isHTMLElement(blockNode) ?  false ? invariant(false, 'blockNode is not an HTMLElement') : invariant(false) : void 0;
      var htmlBlockNode = blockNode;
      var blockBottom = htmlBlockNode.offsetHeight + htmlBlockNode.offsetTop;
      var scrollBottom = scrollParent.offsetHeight + scrollPosition.y;
      scrollDelta = blockBottom - scrollBottom;

      if (scrollDelta > 0) {
        Scroll.setTop(scrollParent, Scroll.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER);
      }
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        block = _this$props2.block,
        blockRenderMap = _this$props2.blockRenderMap,
        blockRendererFn = _this$props2.blockRendererFn,
        blockStyleFn = _this$props2.blockStyleFn,
        contentState = _this$props2.contentState,
        decorator = _this$props2.decorator,
        editorKey = _this$props2.editorKey,
        editorState = _this$props2.editorState,
        customStyleFn = _this$props2.customStyleFn,
        customStyleMap = _this$props2.customStyleMap,
        direction = _this$props2.direction,
        forceSelection = _this$props2.forceSelection,
        selection = _this$props2.selection,
        tree = _this$props2.tree;
    var children = null;

    if (block.children.size) {
      children = block.children.reduce(function (acc, key) {
        var offsetKey = DraftOffsetKey.encode(key, 0, 0);
        var child = contentState.getBlockForKey(key);
        var customConfig = getCustomRenderConfig(child, blockRendererFn);
        var Component = customConfig.CustomComponent || DraftEditorBlockNode;

        var _getDraftRenderConfig = getDraftRenderConfig(child, blockRenderMap),
            Element = _getDraftRenderConfig.Element,
            wrapperTemplate = _getDraftRenderConfig.wrapperTemplate;

        var elementProps = getElementPropsConfig(child, editorKey, offsetKey, blockStyleFn, customConfig, null);

        var childProps = _objectSpread({}, _this2.props, {
          tree: editorState.getBlockTree(key),
          blockProps: customConfig.customProps,
          offsetKey: offsetKey,
          block: child
        });

        acc.push(React.createElement(Element, elementProps, React.createElement(Component, childProps)));

        if (!wrapperTemplate || shouldNotAddWrapperElement(child, contentState)) {
          return acc;
        } // if we are here it means we are the last block
        // that has a wrapperTemplate so we should wrap itself
        // and all other previous siblings that share the same wrapper


        applyWrapperElementToSiblings(wrapperTemplate, Element, acc);
        return acc;
      }, []);
    }

    var blockKey = block.getKey();
    var offsetKey = DraftOffsetKey.encode(blockKey, 0, 0);
    var customConfig = getCustomRenderConfig(block, blockRendererFn);
    var Component = customConfig.CustomComponent;
    var blockNode = Component != null ? React.createElement(Component, _extends({}, this.props, {
      tree: editorState.getBlockTree(blockKey),
      blockProps: customConfig.customProps,
      offsetKey: offsetKey,
      block: block
    })) : React.createElement(DraftEditorNode, {
      block: block,
      children: children,
      contentState: contentState,
      customStyleFn: customStyleFn,
      customStyleMap: customStyleMap,
      decorator: decorator,
      direction: direction,
      forceSelection: forceSelection,
      hasSelection: isBlockOnSelectionEdge(selection, blockKey),
      selection: selection,
      tree: tree
    });

    if (block.getParentKey()) {
      return blockNode;
    }

    var _getDraftRenderConfig2 = getDraftRenderConfig(block, blockRenderMap),
        Element = _getDraftRenderConfig2.Element;

    var elementProps = getElementPropsConfig(block, editorKey, offsetKey, blockStyleFn, customConfig, this.wrapperRef); // root block nodes needs to be wrapped

    return React.createElement(Element, elementProps, blockNode);
  };

  return DraftEditorBlockNode;
}(React.Component);

module.exports = DraftEditorBlockNode;

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DraftEditorDecoratedLeaves = __webpack_require__(833);

var DraftEditorLeaf = __webpack_require__(359);

var DraftOffsetKey = __webpack_require__(64);

var Immutable = __webpack_require__(4);

var React = __webpack_require__(1);

var cx = __webpack_require__(89);

var List = Immutable.List;

var DraftEditorNode = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorNode, _React$Component);

  function DraftEditorNode() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DraftEditorNode.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        block = _this$props.block,
        contentState = _this$props.contentState,
        customStyleFn = _this$props.customStyleFn,
        customStyleMap = _this$props.customStyleMap,
        decorator = _this$props.decorator,
        direction = _this$props.direction,
        forceSelection = _this$props.forceSelection,
        hasSelection = _this$props.hasSelection,
        selection = _this$props.selection,
        tree = _this$props.tree;
    var blockKey = block.getKey();
    var text = block.getText();
    var lastLeafSet = tree.size - 1;
    var children = this.props.children || tree.map(function (leafSet, ii) {
      var decoratorKey = leafSet.get('decoratorKey');
      var leavesForLeafSet = leafSet.get('leaves');
      var lastLeaf = leavesForLeafSet.size - 1;
      var Leaves = leavesForLeafSet.map(function (leaf, jj) {
        var offsetKey = DraftOffsetKey.encode(blockKey, ii, jj);
        var start = leaf.get('start');
        var end = leaf.get('end');
        return React.createElement(DraftEditorLeaf, {
          key: offsetKey,
          offsetKey: offsetKey,
          block: block,
          start: start,
          selection: hasSelection ? selection : null,
          forceSelection: forceSelection,
          text: text.slice(start, end),
          styleSet: block.getInlineStyleAt(start),
          customStyleMap: customStyleMap,
          customStyleFn: customStyleFn,
          isLast: decoratorKey === lastLeafSet && jj === lastLeaf
        });
      }).toArray();

      if (!decoratorKey || !decorator) {
        return Leaves;
      }

      return React.createElement(DraftEditorDecoratedLeaves, {
        block: block,
        children: Leaves,
        contentState: contentState,
        decorator: decorator,
        decoratorKey: decoratorKey,
        direction: direction,
        leafSet: leafSet,
        text: text,
        key: ii
      });
    }).toArray();
    return React.createElement("div", {
      "data-offset-key": DraftOffsetKey.encode(blockKey, 0, 0),
      className: cx({
        'public/DraftStyleDefault/block': true,
        'public/DraftStyleDefault/ltr': direction === 'LTR',
        'public/DraftStyleDefault/rtl': direction === 'RTL'
      })
    }, children);
  };

  return DraftEditorNode;
}(React.Component);

module.exports = DraftEditorNode;

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */


var _assign = __webpack_require__(8);

function _extends() { _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DraftOffsetKey = __webpack_require__(64);

var React = __webpack_require__(1);

var UnicodeBidi = __webpack_require__(226);

var UnicodeBidiDirection = __webpack_require__(160);

var DraftEditorDecoratedLeaves = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorDecoratedLeaves, _React$Component);

  function DraftEditorDecoratedLeaves() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DraftEditorDecoratedLeaves.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        block = _this$props.block,
        children = _this$props.children,
        contentState = _this$props.contentState,
        decorator = _this$props.decorator,
        decoratorKey = _this$props.decoratorKey,
        direction = _this$props.direction,
        leafSet = _this$props.leafSet,
        text = _this$props.text;
    var blockKey = block.getKey();
    var leavesForLeafSet = leafSet.get('leaves');
    var DecoratorComponent = decorator.getComponentForKey(decoratorKey);
    var decoratorProps = decorator.getPropsForKey(decoratorKey);
    var decoratorOffsetKey = DraftOffsetKey.encode(blockKey, parseInt(decoratorKey, 10), 0);
    var decoratedText = text.slice(leavesForLeafSet.first().get('start'), leavesForLeafSet.last().get('end')); // Resetting dir to the same value on a child node makes Chrome/Firefox
    // confused on cursor movement. See http://jsfiddle.net/d157kLck/3/

    var dir = UnicodeBidiDirection.getHTMLDirIfDifferent(UnicodeBidi.getDirection(decoratedText), direction);
    return React.createElement(DecoratorComponent, _extends({}, decoratorProps, {
      contentState: contentState,
      decoratedText: decoratedText,
      dir: dir,
      key: decoratorOffsetKey,
      entityKey: block.getEntityAt(leafSet.get('start')),
      offsetKey: decoratorOffsetKey
    }), children);
  };

  return DraftEditorDecoratedLeaves;
}(React.Component);

module.exports = DraftEditorDecoratedLeaves;

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = __webpack_require__(1);

var UserAgent = __webpack_require__(31);

var invariant = __webpack_require__(9);

var isElement = __webpack_require__(90); // In IE, spans with <br> tags render as two newlines. By rendering a span
// with only a newline character, we can be sure to render a single line.


var useNewlineChar = UserAgent.isBrowser('IE <= 11');
/**
 * Check whether the node should be considered a newline.
 */

function isNewline(node) {
  return useNewlineChar ? node.textContent === '\n' : node.tagName === 'BR';
}
/**
 * Placeholder elements for empty text content.
 *
 * What is this `data-text` attribute, anyway? It turns out that we need to
 * put an attribute on the lowest-level text node in order to preserve correct
 * spellcheck handling. If the <span> is naked, Chrome and Safari may do
 * bizarre things to do the DOM -- split text nodes, create extra spans, etc.
 * If the <span> has an attribute, this appears not to happen.
 * See http://jsfiddle.net/9khdavod/ for the failure case, and
 * http://jsfiddle.net/7pg143f7/ for the fixed case.
 */


var NEWLINE_A = function NEWLINE_A(ref) {
  return useNewlineChar ? React.createElement("span", {
    key: "A",
    "data-text": "true",
    ref: ref
  }, '\n') : React.createElement("br", {
    key: "A",
    "data-text": "true",
    ref: ref
  });
};

var NEWLINE_B = function NEWLINE_B(ref) {
  return useNewlineChar ? React.createElement("span", {
    key: "B",
    "data-text": "true",
    ref: ref
  }, '\n') : React.createElement("br", {
    key: "B",
    "data-text": "true",
    ref: ref
  });
};

/**
 * The lowest-level component in a `DraftEditor`, the text node component
 * replaces the default React text node implementation. This allows us to
 * perform custom handling of newline behavior and avoid re-rendering text
 * nodes with DOM state that already matches the expectations of our immutable
 * editor state.
 */
var DraftEditorTextNode = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorTextNode, _React$Component);

  function DraftEditorTextNode(props) {
    var _this;

    _this = _React$Component.call(this, props) || this; // By flipping this flag, we also keep flipping keys which forces
    // React to remount this node every time it rerenders.

    _defineProperty(_assertThisInitialized(_this), "_forceFlag", void 0);

    _defineProperty(_assertThisInitialized(_this), "_node", void 0);

    _this._forceFlag = false;
    return _this;
  }

  var _proto = DraftEditorTextNode.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var node = this._node;
    var shouldBeNewline = nextProps.children === '';
    !isElement(node) ?  false ? invariant(false, 'node is not an Element') : invariant(false) : void 0;
    var elementNode = node;

    if (shouldBeNewline) {
      return !isNewline(elementNode);
    }

    return elementNode.textContent !== nextProps.children;
  };

  _proto.componentDidMount = function componentDidMount() {
    this._forceFlag = !this._forceFlag;
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this._forceFlag = !this._forceFlag;
  };

  _proto.render = function render() {
    var _this2 = this;

    if (this.props.children === '') {
      return this._forceFlag ? NEWLINE_A(function (ref) {
        return _this2._node = ref;
      }) : NEWLINE_B(function (ref) {
        return _this2._node = ref;
      });
    }

    return React.createElement("span", {
      key: this._forceFlag ? 'A' : 'B',
      "data-text": "true",
      ref: function ref(_ref) {
        return _this2._node = _ref;
      }
    }, this.props.children);
  };

  return DraftEditorTextNode;
}(React.Component);

module.exports = DraftEditorTextNode;

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftEffects = __webpack_require__(361);

var DraftJsDebugLogging = __webpack_require__(353);

var UserAgent = __webpack_require__(31);

var containsNode = __webpack_require__(229);

var getActiveElement = __webpack_require__(362);

var getCorrectDocumentFromNode = __webpack_require__(162);

var invariant = __webpack_require__(9);

var isElement = __webpack_require__(90);

var isIE = UserAgent.isBrowser('IE');

function getAnonymizedDOM(node, getNodeLabels) {
  if (!node) {
    return '[empty]';
  }

  var anonymized = anonymizeTextWithin(node, getNodeLabels);

  if (anonymized.nodeType === Node.TEXT_NODE) {
    return anonymized.textContent;
  }

  !isElement(anonymized) ?  false ? invariant(false, 'Node must be an Element if it is not a text node.') : invariant(false) : void 0;
  var castedElement = anonymized;
  return castedElement.outerHTML;
}

function anonymizeTextWithin(node, getNodeLabels) {
  var labels = getNodeLabels !== undefined ? getNodeLabels(node) : [];

  if (node.nodeType === Node.TEXT_NODE) {
    var length = node.textContent.length;
    return getCorrectDocumentFromNode(node).createTextNode('[text ' + length + (labels.length ? ' | ' + labels.join(', ') : '') + ']');
  }

  var clone = node.cloneNode();

  if (clone.nodeType === 1 && labels.length) {
    clone.setAttribute('data-labels', labels.join(', '));
  }

  var childNodes = node.childNodes;

  for (var ii = 0; ii < childNodes.length; ii++) {
    clone.appendChild(anonymizeTextWithin(childNodes[ii], getNodeLabels));
  }

  return clone;
}

function getAnonymizedEditorDOM(node, getNodeLabels) {
  // grabbing the DOM content of the Draft editor
  var currentNode = node; // this should only be used after checking with isElement

  var castedNode = currentNode;

  while (currentNode) {
    if (isElement(currentNode) && castedNode.hasAttribute('contenteditable')) {
      // found the Draft editor container
      return getAnonymizedDOM(currentNode, getNodeLabels);
    } else {
      currentNode = currentNode.parentNode;
      castedNode = currentNode;
    }
  }

  return 'Could not find contentEditable parent of node';
}

function getNodeLength(node) {
  return node.nodeValue === null ? node.childNodes.length : node.nodeValue.length;
}
/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 */


function setDraftEditorSelection(selectionState, node, blockKey, nodeStart, nodeEnd) {
  // It's possible that the editor has been removed from the DOM but
  // our selection code doesn't know it yet. Forcing selection in
  // this case may lead to errors, so just bail now.
  var documentObject = getCorrectDocumentFromNode(node);

  if (!containsNode(documentObject.documentElement, node)) {
    return;
  }

  var selection = documentObject.defaultView.getSelection();
  var anchorKey = selectionState.getAnchorKey();
  var anchorOffset = selectionState.getAnchorOffset();
  var focusKey = selectionState.getFocusKey();
  var focusOffset = selectionState.getFocusOffset();
  var isBackward = selectionState.getIsBackward(); // IE doesn't support backward selection. Swap key/offset pairs.

  if (!selection.extend && isBackward) {
    var tempKey = anchorKey;
    var tempOffset = anchorOffset;
    anchorKey = focusKey;
    anchorOffset = focusOffset;
    focusKey = tempKey;
    focusOffset = tempOffset;
    isBackward = false;
  }

  var hasAnchor = anchorKey === blockKey && nodeStart <= anchorOffset && nodeEnd >= anchorOffset;
  var hasFocus = focusKey === blockKey && nodeStart <= focusOffset && nodeEnd >= focusOffset; // If the selection is entirely bound within this node, set the selection
  // and be done.

  if (hasAnchor && hasFocus) {
    selection.removeAllRanges();
    addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
    addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
    return;
  }

  if (!isBackward) {
    // If the anchor is within this node, set the range start.
    if (hasAnchor) {
      selection.removeAllRanges();
      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
    } // If the focus is within this node, we can assume that we have
    // already set the appropriate start range on the selection, and
    // can simply extend the selection.


    if (hasFocus) {
      addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
    }
  } else {
    // If this node has the focus, set the selection range to be a
    // collapsed range beginning here. Later, when we encounter the anchor,
    // we'll use this information to extend the selection.
    if (hasFocus) {
      selection.removeAllRanges();
      addPointToSelection(selection, node, focusOffset - nodeStart, selectionState);
    } // If this node has the anchor, we may assume that the correct
    // focus information is already stored on the selection object.
    // We keep track of it, reset the selection range, and extend it
    // back to the focus point.


    if (hasAnchor) {
      var storedFocusNode = selection.focusNode;
      var storedFocusOffset = selection.focusOffset;
      selection.removeAllRanges();
      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
      addFocusToSelection(selection, storedFocusNode, storedFocusOffset, selectionState);
    }
  }
}
/**
 * Extend selection towards focus point.
 */


function addFocusToSelection(selection, node, offset, selectionState) {
  var activeElement = getActiveElement();
  var extend = selection.extend; // containsNode returns false if node is null.
  // Let's refine the type of this value out here so flow knows.

  if (extend && node != null && containsNode(activeElement, node)) {
    // If `extend` is called while another element has focus, an error is
    // thrown. We therefore disable `extend` if the active element is somewhere
    // other than the node we are selecting. This should only occur in Firefox,
    // since it is the only browser to support multiple selections.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=921444.
    // logging to catch bug that is being reported in t16250795
    if (offset > getNodeLength(node)) {
      // the call to 'selection.extend' is about to throw
      DraftJsDebugLogging.logSelectionStateFailure({
        anonymizedDom: getAnonymizedEditorDOM(node),
        extraParams: JSON.stringify({
          offset: offset
        }),
        selectionState: JSON.stringify(selectionState.toJS())
      });
    } // logging to catch bug that is being reported in t18110632


    var nodeWasFocus = node === selection.focusNode;

    try {
      // Fixes some reports of "InvalidStateError: Failed to execute 'extend' on
      // 'Selection': This Selection object doesn't have any Ranges."
      // Note: selection.extend does not exist in IE.
      if (selection.rangeCount > 0 && selection.extend) {
        selection.extend(node, offset);
      }
    } catch (e) {
      DraftJsDebugLogging.logSelectionStateFailure({
        anonymizedDom: getAnonymizedEditorDOM(node, function (n) {
          var labels = [];

          if (n === activeElement) {
            labels.push('active element');
          }

          if (n === selection.anchorNode) {
            labels.push('selection anchor node');
          }

          if (n === selection.focusNode) {
            labels.push('selection focus node');
          }

          return labels;
        }),
        extraParams: JSON.stringify({
          activeElementName: activeElement ? activeElement.nodeName : null,
          nodeIsFocus: node === selection.focusNode,
          nodeWasFocus: nodeWasFocus,
          selectionRangeCount: selection.rangeCount,
          selectionAnchorNodeName: selection.anchorNode ? selection.anchorNode.nodeName : null,
          selectionAnchorOffset: selection.anchorOffset,
          selectionFocusNodeName: selection.focusNode ? selection.focusNode.nodeName : null,
          selectionFocusOffset: selection.focusOffset,
          message: e ? '' + e : null,
          offset: offset
        }, null, 2),
        selectionState: JSON.stringify(selectionState.toJS(), null, 2)
      }); // allow the error to be thrown -
      // better than continuing in a broken state

      throw e;
    }
  } else {
    // IE doesn't support extend. This will mean no backward selection.
    // Extract the existing selection range and add focus to it.
    // Additionally, clone the selection range. IE11 throws an
    // InvalidStateError when attempting to access selection properties
    // after the range is detached.
    if (node && selection.rangeCount > 0) {
      var range = selection.getRangeAt(0);
      range.setEnd(node, offset);
      selection.addRange(range.cloneRange());
    }
  }
}

function addPointToSelection(selection, node, offset, selectionState) {
  var range = getCorrectDocumentFromNode(node).createRange(); // logging to catch bug that is being reported in t16250795

  if (offset > getNodeLength(node)) {
    // in this case we know that the call to 'range.setStart' is about to throw
    DraftJsDebugLogging.logSelectionStateFailure({
      anonymizedDom: getAnonymizedEditorDOM(node),
      extraParams: JSON.stringify({
        offset: offset
      }),
      selectionState: JSON.stringify(selectionState.toJS())
    });
    DraftEffects.handleExtensionCausedError();
  }

  range.setStart(node, offset); // IE sometimes throws Unspecified Error when trying to addRange

  if (isIE) {
    try {
      selection.addRange(range);
    } catch (e) {
      if (false) {
        /* eslint-disable-next-line no-console */
        console.warn('Call to selection.addRange() threw exception: ', e);
      }
    }
  } else {
    selection.addRange(range);
  }
}

module.exports = {
  setDraftEditorSelection: setDraftEditorSelection,
  addFocusToSelection: addFocusToSelection
};

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var isNode = __webpack_require__(837);
/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */


function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var camelize = __webpack_require__(839);

var hyphenate = __webpack_require__(840);

function asString(value)
/*?string*/
{
  return value == null ? value : String(value);
}

function getStyleProperty(
/*DOMNode*/
node,
/*string*/
name)
/*?string*/
{
  var computedStyle; // W3C Standard

  if (window.getComputedStyle) {
    // In certain cases such as within an iframe in FF3, this returns null.
    computedStyle = window.getComputedStyle(node, null);

    if (computedStyle) {
      return asString(computedStyle.getPropertyValue(hyphenate(name)));
    }
  } // Safari


  if (document.defaultView && document.defaultView.getComputedStyle) {
    computedStyle = document.defaultView.getComputedStyle(node, null); // A Safari bug causes this to return null for `display: none` elements.

    if (computedStyle) {
      return asString(computedStyle.getPropertyValue(hyphenate(name)));
    }

    if (name === 'display') {
      return 'none';
    }
  } // Internet Explorer


  if (node.currentStyle) {
    if (name === 'float') {
      return asString(node.currentStyle.cssFloat || node.currentStyle.styleFloat);
    }

    return asString(node.currentStyle[camelize(name)]);
  }

  return asString(node.style && node.style[camelize(name)]);
}

module.exports = getStyleProperty;

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var _hyphenPattern = /-(.)/g;
/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */

function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var _uppercasePattern = /([A-Z])/g;
/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */

function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var containsNode = __webpack_require__(229);
/**
 * Gets an element's bounding rect in pixels relative to the viewport.
 *
 * @param {DOMElement} elem
 * @return {object}
 */


function getElementRect(elem) {
  var docElem = elem.ownerDocument.documentElement; // FF 2, Safari 3 and Opera 9.5- do not support getBoundingClientRect().
  // IE9- will throw if the element is not in the document.

  if (!('getBoundingClientRect' in elem) || !containsNode(docElem, elem)) {
    return {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
  } // Subtracts clientTop/Left because IE8- added a 2px border to the
  // <html> element (see http://fburl.com/1493213). IE 7 in
  // Quicksmode does not report clientLeft/clientTop so there
  // will be an unaccounted offset of 2px when in quirksmode


  var rect = elem.getBoundingClientRect();
  return {
    left: Math.round(rect.left) - docElem.clientLeft,
    right: Math.round(rect.right) - docElem.clientLeft,
    top: Math.round(rect.top) - docElem.clientTop,
    bottom: Math.round(rect.bottom) - docElem.clientTop
  };
}

module.exports = getElementRect;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */


var isWebkit = typeof navigator !== 'undefined' && navigator.userAgent.indexOf('AppleWebKit') > -1;
/**
 * Gets the element with the document scroll properties such as `scrollLeft` and
 * `scrollHeight`. This may differ across different browsers.
 *
 * NOTE: The return value can be null if the DOM is not yet ready.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */

function getDocumentScrollElement(doc) {
  doc = doc || document;

  if (doc.scrollingElement) {
    return doc.scrollingElement;
  }

  return !isWebkit && doc.compatMode === 'CSS1Compat' ? doc.documentElement : doc.body;
}

module.exports = getDocumentScrollElement;

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }

  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var _assign = __webpack_require__(8);

function _extends() { _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DraftEditorBlock = __webpack_require__(365);

var DraftOffsetKey = __webpack_require__(64);

var React = __webpack_require__(1);

var cx = __webpack_require__(89);

var joinClasses = __webpack_require__(845);

var nullthrows = __webpack_require__(30);

/**
 * Provide default styling for list items. This way, lists will be styled with
 * proper counters and indentation even if the caller does not specify
 * their own styling at all. If more than five levels of nesting are needed,
 * the necessary CSS classes can be provided via `blockStyleFn` configuration.
 */
var getListItemClasses = function getListItemClasses(type, depth, shouldResetCount, direction) {
  return cx({
    'public/DraftStyleDefault/unorderedListItem': type === 'unordered-list-item',
    'public/DraftStyleDefault/orderedListItem': type === 'ordered-list-item',
    'public/DraftStyleDefault/reset': shouldResetCount,
    'public/DraftStyleDefault/depth0': depth === 0,
    'public/DraftStyleDefault/depth1': depth === 1,
    'public/DraftStyleDefault/depth2': depth === 2,
    'public/DraftStyleDefault/depth3': depth === 3,
    'public/DraftStyleDefault/depth4': depth >= 4,
    'public/DraftStyleDefault/listLTR': direction === 'LTR',
    'public/DraftStyleDefault/listRTL': direction === 'RTL'
  });
};
/**
 * `DraftEditorContents` is the container component for all block components
 * rendered for a `DraftEditor`. It is optimized to aggressively avoid
 * re-rendering blocks whenever possible.
 *
 * This component is separate from `DraftEditor` because certain props
 * (for instance, ARIA props) must be allowed to update without affecting
 * the contents of the editor.
 */


var DraftEditorContents = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorContents, _React$Component);

  function DraftEditorContents() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DraftEditorContents.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var prevEditorState = this.props.editorState;
    var nextEditorState = nextProps.editorState;
    var prevDirectionMap = prevEditorState.getDirectionMap();
    var nextDirectionMap = nextEditorState.getDirectionMap(); // Text direction has changed for one or more blocks. We must re-render.

    if (prevDirectionMap !== nextDirectionMap) {
      return true;
    }

    var didHaveFocus = prevEditorState.getSelection().getHasFocus();
    var nowHasFocus = nextEditorState.getSelection().getHasFocus();

    if (didHaveFocus !== nowHasFocus) {
      return true;
    }

    var nextNativeContent = nextEditorState.getNativelyRenderedContent();
    var wasComposing = prevEditorState.isInCompositionMode();
    var nowComposing = nextEditorState.isInCompositionMode(); // If the state is unchanged or we're currently rendering a natively
    // rendered state, there's nothing new to be done.

    if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
      return false;
    }

    var prevContent = prevEditorState.getCurrentContent();
    var nextContent = nextEditorState.getCurrentContent();
    var prevDecorator = prevEditorState.getDecorator();
    var nextDecorator = nextEditorState.getDecorator();
    return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        blockRenderMap = _this$props.blockRenderMap,
        blockRendererFn = _this$props.blockRendererFn,
        blockStyleFn = _this$props.blockStyleFn,
        customStyleMap = _this$props.customStyleMap,
        customStyleFn = _this$props.customStyleFn,
        editorState = _this$props.editorState,
        editorKey = _this$props.editorKey,
        preventScroll = _this$props.preventScroll,
        textDirectionality = _this$props.textDirectionality;
    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var forceSelection = editorState.mustForceSelection();
    var decorator = editorState.getDecorator();
    var directionMap = nullthrows(editorState.getDirectionMap());
    var blocksAsArray = content.getBlocksAsArray();
    var processedBlocks = [];
    var currentDepth = null;
    var lastWrapperTemplate = null;

    for (var ii = 0; ii < blocksAsArray.length; ii++) {
      var _block = blocksAsArray[ii];

      var key = _block.getKey();

      var blockType = _block.getType();

      var customRenderer = blockRendererFn(_block);
      var CustomComponent = void 0,
          customProps = void 0,
          customEditable = void 0;

      if (customRenderer) {
        CustomComponent = customRenderer.component;
        customProps = customRenderer.props;
        customEditable = customRenderer.editable;
      }

      var direction = textDirectionality ? textDirectionality : directionMap.get(key);
      var offsetKey = DraftOffsetKey.encode(key, 0, 0);
      var componentProps = {
        contentState: content,
        block: _block,
        blockProps: customProps,
        blockStyleFn: blockStyleFn,
        customStyleMap: customStyleMap,
        customStyleFn: customStyleFn,
        decorator: decorator,
        direction: direction,
        forceSelection: forceSelection,
        offsetKey: offsetKey,
        preventScroll: preventScroll,
        selection: selection,
        tree: editorState.getBlockTree(key)
      };
      var configForType = blockRenderMap.get(blockType) || blockRenderMap.get('unstyled');
      var wrapperTemplate = configForType.wrapper;
      var Element = configForType.element || blockRenderMap.get('unstyled').element;

      var depth = _block.getDepth();

      var _className = '';

      if (blockStyleFn) {
        _className = blockStyleFn(_block);
      } // List items are special snowflakes, since we handle nesting and
      // counters manually.


      if (Element === 'li') {
        var shouldResetCount = lastWrapperTemplate !== wrapperTemplate || currentDepth === null || depth > currentDepth;
        _className = joinClasses(_className, getListItemClasses(blockType, depth, shouldResetCount, direction));
      }

      var Component = CustomComponent || DraftEditorBlock;
      var childProps = {
        className: _className,
        'data-block': true,
        'data-editor': editorKey,
        'data-offset-key': offsetKey,
        key: key
      };

      if (customEditable !== undefined) {
        childProps = _objectSpread({}, childProps, {
          contentEditable: customEditable,
          suppressContentEditableWarning: true
        });
      }

      var child = React.createElement(Element, childProps,
      /* $FlowFixMe[incompatible-type] (>=0.112.0 site=www,mobile) This
       * comment suppresses an error found when Flow v0.112 was deployed. To
       * see the error delete this comment and run Flow. */
      React.createElement(Component, _extends({}, componentProps, {
        key: key
      })));
      processedBlocks.push({
        block: child,
        wrapperTemplate: wrapperTemplate,
        key: key,
        offsetKey: offsetKey
      });

      if (wrapperTemplate) {
        currentDepth = _block.getDepth();
      } else {
        currentDepth = null;
      }

      lastWrapperTemplate = wrapperTemplate;
    } // Group contiguous runs of blocks that have the same wrapperTemplate


    var outputBlocks = [];

    for (var _ii = 0; _ii < processedBlocks.length;) {
      var info = processedBlocks[_ii];

      if (info.wrapperTemplate) {
        var blocks = [];

        do {
          blocks.push(processedBlocks[_ii].block);
          _ii++;
        } while (_ii < processedBlocks.length && processedBlocks[_ii].wrapperTemplate === info.wrapperTemplate);

        var wrapperElement = React.cloneElement(info.wrapperTemplate, {
          key: info.key + '-wrap',
          'data-offset-key': info.offsetKey
        }, blocks);
        outputBlocks.push(wrapperElement);
      } else {
        outputBlocks.push(info.block);
        _ii++;
      }
    }

    return React.createElement("div", {
      "data-contents": "true"
    }, outputBlocks);
  };

  return DraftEditorContents;
}(React.Component);

module.exports = DraftEditorContents;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */

/**
 * Combines multiple className strings into one.
 */

function joinClasses(className) {
  var newClassName = className || '';
  var argLength = arguments.length;

  if (argLength > 1) {
    for (var index = 1; index < argLength; index++) {
      var nextClass = arguments[index];

      if (nextClass) {
        newClassName = (newClassName ? newClassName + ' ' : '') + nextClass;
      }
    }
  }

  return newClassName;
}

module.exports = joinClasses;

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DataTransfer = __webpack_require__(366);

var DraftModifier = __webpack_require__(29);

var EditorState = __webpack_require__(13);

var findAncestorOffsetKey = __webpack_require__(161);

var getCorrectDocumentFromNode = __webpack_require__(162);

var getTextContentFromFiles = __webpack_require__(368);

var getUpdatedSelectionState = __webpack_require__(357);

var getWindowForNode = __webpack_require__(351);

var isEventHandled = __webpack_require__(166);

var nullthrows = __webpack_require__(30);
/**
 * Get a SelectionState for the supplied mouse event.
 */


function getSelectionForEvent(event, editorState) {
  var node = null;
  var offset = null;
  var eventTargetDocument = getCorrectDocumentFromNode(event.currentTarget);
  /* $FlowFixMe[prop-missing] (>=0.68.0 site=www,mobile) This comment
   * suppresses an error found when Flow v0.68 was deployed. To see the error
   * delete this comment and run Flow. */

  if (typeof eventTargetDocument.caretRangeFromPoint === 'function') {
    /* $FlowFixMe[incompatible-use] (>=0.68.0 site=www,mobile) This comment
     * suppresses an error found when Flow v0.68 was deployed. To see the error
     * delete this comment and run Flow. */
    var dropRange = eventTargetDocument.caretRangeFromPoint(event.x, event.y);
    node = dropRange.startContainer;
    offset = dropRange.startOffset;
  } else if (event.rangeParent) {
    node = event.rangeParent;
    offset = event.rangeOffset;
  } else {
    return null;
  }

  node = nullthrows(node);
  offset = nullthrows(offset);
  var offsetKey = nullthrows(findAncestorOffsetKey(node));
  return getUpdatedSelectionState(editorState, offsetKey, offset, offsetKey, offset);
}

var DraftEditorDragHandler = {
  /**
   * Drag originating from input terminated.
   */
  onDragEnd: function onDragEnd(editor) {
    editor.exitCurrentMode();
    endDrag(editor);
  },

  /**
   * Handle data being dropped.
   */
  onDrop: function onDrop(editor, e) {
    var data = new DataTransfer(e.nativeEvent.dataTransfer);
    var editorState = editor._latestEditorState;
    var dropSelection = getSelectionForEvent(e.nativeEvent, editorState);
    e.preventDefault();
    editor._dragCount = 0;
    editor.exitCurrentMode();

    if (dropSelection == null) {
      return;
    }

    var files = data.getFiles();

    if (files.length > 0) {
      if (editor.props.handleDroppedFiles && isEventHandled(editor.props.handleDroppedFiles(dropSelection, files))) {
        return;
      }
      /* $FlowFixMe[incompatible-call] This comment suppresses an error found
       * DataTransfer was typed. getFiles() returns an array of <Files extends
       * Blob>, not Blob */


      getTextContentFromFiles(files, function (fileText) {
        fileText && editor.update(insertTextAtSelection(editorState, dropSelection, fileText));
      });
      return;
    }

    var dragType = editor._internalDrag ? 'internal' : 'external';

    if (editor.props.handleDrop && isEventHandled(editor.props.handleDrop(dropSelection, data, dragType))) {// handled
    } else if (editor._internalDrag) {
      editor.update(moveText(editorState, dropSelection));
    } else {
      editor.update(insertTextAtSelection(editorState, dropSelection, data.getText()));
    }

    endDrag(editor);
  }
};

function endDrag(editor) {
  editor._internalDrag = false; // Fix issue #1383
  // Prior to React v16.5.0 onDrop breaks onSelect event:
  // https://github.com/facebook/react/issues/11379.
  // Dispatching a mouseup event on DOM node will make it go back to normal.

  var editorNode = editor.editorContainer;

  if (editorNode) {
    var mouseUpEvent = new MouseEvent('mouseup', {
      view: getWindowForNode(editorNode),
      bubbles: true,
      cancelable: true
    });
    editorNode.dispatchEvent(mouseUpEvent);
  }
}

function moveText(editorState, targetSelection) {
  var newContentState = DraftModifier.moveText(editorState.getCurrentContent(), editorState.getSelection(), targetSelection);
  return EditorState.push(editorState, newContentState, 'insert-fragment');
}
/**
 * Insert text at a specified selection.
 */


function insertTextAtSelection(editorState, selection, text) {
  var newContentState = DraftModifier.insertText(editorState.getCurrentContent(), selection, text, editorState.getCurrentInlineStyle());
  return EditorState.push(editorState, newContentState, 'insert-fragment');
}

module.exports = DraftEditorDragHandler;

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var PhotosMimeType = {
  isImage: function isImage(mimeString) {
    return getParts(mimeString)[0] === 'image';
  },
  isJpeg: function isJpeg(mimeString) {
    var parts = getParts(mimeString);
    return PhotosMimeType.isImage(mimeString) && ( // see http://fburl.com/10972194
    parts[1] === 'jpeg' || parts[1] === 'pjpeg');
  }
};

function getParts(mimeString) {
  return mimeString.split('/');
}

module.exports = PhotosMimeType;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var invariant = __webpack_require__(9);
/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */


function toArray(obj) {
  var length = obj.length; // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).

  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0; // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.

  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {// IE < 9 does not support Array#slice on collections objects
    }
  } // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.


  var ret = Array(length);

  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }

  return ret;
}
/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */


function hasArrayNature(obj) {
  return (// not null/false
    !!obj && ( // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') && // quacks like an array
    'length' in obj && // not window
    !('setInterval' in obj) && // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && ( // a real array
    Array.isArray(obj) || // arguments
    'callee' in obj || // HTMLCollection/NodeList
    'item' in obj)
  );
}
/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */


function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var UserAgent = __webpack_require__(31);

var onBeforeInput = __webpack_require__(850);

var onBlur = __webpack_require__(854);

var onCompositionStart = __webpack_require__(855);

var onCopy = __webpack_require__(856);

var onCut = __webpack_require__(857);

var onDragOver = __webpack_require__(859);

var onDragStart = __webpack_require__(860);

var onFocus = __webpack_require__(861);

var onInput = __webpack_require__(862);

var onKeyDown = __webpack_require__(863);

var onPaste = __webpack_require__(877);

var onSelect = __webpack_require__(352);

var isChrome = UserAgent.isBrowser('Chrome');
var isFirefox = UserAgent.isBrowser('Firefox');
var selectionHandler = isChrome || isFirefox ? onSelect : function (e) {};
var DraftEditorEditHandler = {
  onBeforeInput: onBeforeInput,
  onBlur: onBlur,
  onCompositionStart: onCompositionStart,
  onCopy: onCopy,
  onCut: onCut,
  onDragOver: onDragOver,
  onDragStart: onDragStart,
  onFocus: onFocus,
  onInput: onInput,
  onKeyDown: onKeyDown,
  onPaste: onPaste,
  onSelect: onSelect,
  // In certain cases, contenteditable on chrome does not fire the onSelect
  // event, causing problems with cursor positioning. Therefore, the selection
  // state update handler is added to more events to ensure that the selection
  // state is always synced with the actual cursor positions.
  onMouseUp: selectionHandler,
  onKeyUp: selectionHandler
};
module.exports = DraftEditorEditHandler;

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(29);

var EditorState = __webpack_require__(13);

var UserAgent = __webpack_require__(31);

var getEntityKeyForSelection = __webpack_require__(228);

var isEventHandled = __webpack_require__(166);

var isSelectionAtLeafStart = __webpack_require__(851);

var nullthrows = __webpack_require__(30);

var setImmediate = __webpack_require__(852); // When nothing is focused, Firefox regards two characters, `'` and `/`, as
// commands that should open and focus the "quickfind" search bar. This should
// *never* happen while a contenteditable is focused, but as of v28, it
// sometimes does, even when the keypress event target is the contenteditable.
// This breaks the input. Special case these characters to ensure that when
// they are typed, we prevent default on the event to make sure not to
// trigger quickfind.


var FF_QUICKFIND_CHAR = "'";
var FF_QUICKFIND_LINK_CHAR = '/';
var isFirefox = UserAgent.isBrowser('Firefox');

function mustPreventDefaultForCharacter(character) {
  return isFirefox && (character == FF_QUICKFIND_CHAR || character == FF_QUICKFIND_LINK_CHAR);
}
/**
 * Replace the current selection with the specified text string, with the
 * inline style and entity key applied to the newly inserted text.
 */


function replaceText(editorState, text, inlineStyle, entityKey, forceSelection) {
  var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), text, inlineStyle, entityKey);
  return EditorState.push(editorState, contentState, 'insert-characters', forceSelection);
}
/**
 * When `onBeforeInput` executes, the browser is attempting to insert a
 * character into the editor. Apply this character data to the document,
 * allowing native insertion if possible.
 *
 * Native insertion is encouraged in order to limit re-rendering and to
 * preserve spellcheck highlighting, which disappears or flashes if re-render
 * occurs on the relevant text nodes.
 */


function editOnBeforeInput(editor, e) {
  if (editor._pendingStateFromBeforeInput !== undefined) {
    editor.update(editor._pendingStateFromBeforeInput);
    editor._pendingStateFromBeforeInput = undefined;
  }

  var editorState = editor._latestEditorState;
  var chars = e.data; // In some cases (ex: IE ideographic space insertion) no character data
  // is provided. There's nothing to do when this happens.

  if (!chars) {
    return;
  } // Allow the top-level component to handle the insertion manually. This is
  // useful when triggering interesting behaviors for a character insertion,
  // Simple examples: replacing a raw text ':)' with a smile emoji or image
  // decorator, or setting a block to be a list item after typing '- ' at the
  // start of the block.


  if (editor.props.handleBeforeInput && isEventHandled(editor.props.handleBeforeInput(chars, editorState, e.timeStamp))) {
    e.preventDefault();
    return;
  } // If selection is collapsed, conditionally allow native behavior. This
  // reduces re-renders and preserves spellcheck highlighting. If the selection
  // is not collapsed, we will re-render.


  var selection = editorState.getSelection();
  var selectionStart = selection.getStartOffset();
  var anchorKey = selection.getAnchorKey();

  if (!selection.isCollapsed()) {
    e.preventDefault();
    editor.update(replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection()), true));
    return;
  }

  var newEditorState = replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection()), false); // Bunch of different cases follow where we need to prevent native insertion.

  var mustPreventNative = false;

  if (!mustPreventNative) {
    // Browsers tend to insert text in weird places in the DOM when typing at
    // the start of a leaf, so we'll handle it ourselves.
    mustPreventNative = isSelectionAtLeafStart(editor._latestCommittedEditorState);
  }

  if (!mustPreventNative) {
    // Let's say we have a decorator that highlights hashtags. In many cases
    // we need to prevent native behavior and rerender ourselves --
    // particularly, any case *except* where the inserted characters end up
    // anywhere except exactly where you put them.
    //
    // Using [] to denote a decorated leaf, some examples:
    //
    // 1. 'hi #' and append 'f'
    // desired rendering: 'hi [#f]'
    // native rendering would be: 'hi #f' (incorrect)
    //
    // 2. 'x [#foo]' and insert '#' before 'f'
    // desired rendering: 'x #[#foo]'
    // native rendering would be: 'x [##foo]' (incorrect)
    //
    // 3. '[#foobar]' and insert ' ' between 'foo' and 'bar'
    // desired rendering: '[#foo] bar'
    // native rendering would be: '[#foo bar]' (incorrect)
    //
    // 4. '[#foo]' and delete '#' [won't use this beforeinput codepath though]
    // desired rendering: 'foo'
    // native rendering would be: '[foo]' (incorrect)
    //
    // 5. '[#foo]' and append 'b'
    // desired rendering: '[#foob]'
    // native rendering would be: '[#foob]'
    // (native insertion here would be ok for decorators like simple spans,
    // but not more complex decorators. To be safe, we need to prevent it.)
    //
    // It is safe to allow native insertion if and only if the full list of
    // decorator ranges matches what we expect native insertion to give, and
    // the range lengths have not changed. We don't need to compare the content
    // because the only possible mutation to consider here is inserting plain
    // text and decorators can't affect text content.
    var oldBlockTree = editorState.getBlockTree(anchorKey);
    var newBlockTree = newEditorState.getBlockTree(anchorKey);
    mustPreventNative = oldBlockTree.size !== newBlockTree.size || oldBlockTree.zip(newBlockTree).some(function (_ref) {
      var oldLeafSet = _ref[0],
          newLeafSet = _ref[1];
      // selectionStart is guaranteed to be selectionEnd here
      var oldStart = oldLeafSet.get('start');
      var adjustedStart = oldStart + (oldStart >= selectionStart ? chars.length : 0);
      var oldEnd = oldLeafSet.get('end');
      var adjustedEnd = oldEnd + (oldEnd >= selectionStart ? chars.length : 0);
      var newStart = newLeafSet.get('start');
      var newEnd = newLeafSet.get('end');
      var newDecoratorKey = newLeafSet.get('decoratorKey');
      return (// Different decorators
        oldLeafSet.get('decoratorKey') !== newDecoratorKey || // Different number of inline styles
        oldLeafSet.get('leaves').size !== newLeafSet.get('leaves').size || // Different effective decorator position
        adjustedStart !== newStart || adjustedEnd !== newEnd || // Decorator already existed and its length changed
        newDecoratorKey != null && newEnd - newStart !== oldEnd - oldStart
      );
    });
  }

  if (!mustPreventNative) {
    mustPreventNative = mustPreventDefaultForCharacter(chars);
  }

  if (!mustPreventNative) {
    mustPreventNative = nullthrows(newEditorState.getDirectionMap()).get(anchorKey) !== nullthrows(editorState.getDirectionMap()).get(anchorKey);
  }

  if (mustPreventNative) {
    e.preventDefault();
    newEditorState = EditorState.set(newEditorState, {
      forceSelection: true
    });
    editor.update(newEditorState);
    return;
  } // We made it all the way! Let the browser do its thing and insert the char.


  newEditorState = EditorState.set(newEditorState, {
    nativelyRenderedContent: newEditorState.getCurrentContent()
  }); // The native event is allowed to occur. To allow user onChange handlers to
  // change the inserted text, we wait until the text is actually inserted
  // before we actually update our state. That way when we rerender, the text
  // we see in the DOM will already have been inserted properly.

  editor._pendingStateFromBeforeInput = newEditorState;
  setImmediate(function () {
    if (editor._pendingStateFromBeforeInput !== undefined) {
      editor.update(editor._pendingStateFromBeforeInput);
      editor._pendingStateFromBeforeInput = undefined;
    }
  });
}

module.exports = editOnBeforeInput;

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function isSelectionAtLeafStart(editorState) {
  var selection = editorState.getSelection();
  var anchorKey = selection.getAnchorKey();
  var blockTree = editorState.getBlockTree(anchorKey);
  var offset = selection.getStartOffset();
  var isAtStart = false;
  blockTree.some(function (leafSet) {
    if (offset === leafSet.get('start')) {
      isAtStart = true;
      return true;
    }

    if (offset < leafSet.get('end')) {
      return leafSet.get('leaves').some(function (leaf) {
        var leafStart = leaf.get('start');

        if (offset === leafStart) {
          isAtStart = true;
          return true;
        }

        return false;
      });
    }

    return false;
  });
  return isAtStart;
}

module.exports = isSelectionAtLeafStart;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
 // setimmediate adds setImmediate to the global. We want to make sure we export
// the actual function.

__webpack_require__(853);

module.exports = global.setImmediate;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46)))

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(46), __webpack_require__(231)))

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(13);

var containsNode = __webpack_require__(229);

var getActiveElement = __webpack_require__(362);

function editOnBlur(editor, e) {
  // In a contentEditable element, when you select a range and then click
  // another active element, this does trigger a `blur` event but will not
  // remove the DOM selection from the contenteditable.
  // This is consistent across all browsers, but we prefer that the editor
  // behave like a textarea, where a `blur` event clears the DOM selection.
  // We therefore force the issue to be certain, checking whether the active
  // element is `body` to force it when blurring occurs within the window (as
  // opposed to clicking to another tab or window).
  var ownerDocument = e.currentTarget.ownerDocument;

  if ( // This ESLint rule conflicts with `sketchy-null-bool` flow check
  // eslint-disable-next-line no-extra-boolean-cast
  !Boolean(editor.props.preserveSelectionOnBlur) && getActiveElement(ownerDocument) === ownerDocument.body) {
    var _selection = ownerDocument.defaultView.getSelection();

    var editorNode = editor.editor;

    if (_selection.rangeCount === 1 && containsNode(editorNode, _selection.anchorNode) && containsNode(editorNode, _selection.focusNode)) {
      _selection.removeAllRanges();
    }
  }

  var editorState = editor._latestEditorState;
  var currentSelection = editorState.getSelection();

  if (!currentSelection.getHasFocus()) {
    return;
  }

  var selection = currentSelection.set('hasFocus', false);
  editor.props.onBlur && editor.props.onBlur(e);
  editor.update(EditorState.acceptSelection(editorState, selection));
}

module.exports = editOnBlur;

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(13);
/**
 * The user has begun using an IME input system. Switching to `composite` mode
 * allows handling composition input and disables other edit behavior.
 */


function editOnCompositionStart(editor, e) {
  editor.setMode('composite');
  editor.update(EditorState.set(editor._latestEditorState, {
    inCompositionMode: true
  })); // Allow composition handler to interpret the compositionstart event

  editor._onCompositionStart(e);
}

module.exports = editOnCompositionStart;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var getFragmentFromSelection = __webpack_require__(369);
/**
 * If we have a selection, create a ContentState fragment and store
 * it in our internal clipboard. Subsequent paste events will use this
 * fragment if no external clipboard data is supplied.
 */


function editOnCopy(editor, e) {
  var editorState = editor._latestEditorState;
  var selection = editorState.getSelection(); // No selection, so there's nothing to copy.

  if (selection.isCollapsed()) {
    e.preventDefault();
    return;
  }

  editor.setClipboard(getFragmentFromSelection(editor._latestEditorState));
}

module.exports = editOnCopy;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(29);

var EditorState = __webpack_require__(13);

var Style = __webpack_require__(164);

var getFragmentFromSelection = __webpack_require__(369);

var getScrollPosition = __webpack_require__(165);

var isNode = __webpack_require__(858);
/**
 * On `cut` events, native behavior is allowed to occur so that the system
 * clipboard is set properly. This means that we need to take steps to recover
 * the editor DOM state after the `cut` has occurred in order to maintain
 * control of the component.
 *
 * In addition, we can keep a copy of the removed fragment, including all
 * styles and entities, for use as an internal paste.
 */


function editOnCut(editor, e) {
  var editorState = editor._latestEditorState;
  var selection = editorState.getSelection();
  var element = e.target;
  var scrollPosition; // No selection, so there's nothing to cut.

  if (selection.isCollapsed()) {
    e.preventDefault();
    return;
  } // Track the current scroll position so that it can be forced back in place
  // after the editor regains control of the DOM.


  if (isNode(element)) {
    var node = element;
    scrollPosition = getScrollPosition(Style.getScrollParent(node));
  }

  var fragment = getFragmentFromSelection(editorState);
  editor.setClipboard(fragment); // Set `cut` mode to disable all event handling temporarily.

  editor.setMode('cut'); // Let native `cut` behavior occur, then recover control.

  setTimeout(function () {
    editor.restoreEditorDOM(scrollPosition);
    editor.exitCurrentMode();
    editor.update(removeFragment(editorState));
  }, 0);
}

function removeFragment(editorState) {
  var newContent = DraftModifier.removeRange(editorState.getCurrentContent(), editorState.getSelection(), 'forward');
  return EditorState.push(editorState, newContent, 'remove-range');
}

module.exports = editOnCut;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
function isInstanceOfNode(target) {
  // we changed the name because of having duplicate module provider (fbjs)
  if (!target || !('ownerDocument' in target)) {
    return false;
  }

  if ('ownerDocument' in target) {
    var node = target;

    if (!node.ownerDocument.defaultView) {
      return node instanceof Node;
    }

    if (node instanceof node.ownerDocument.defaultView.Node) {
      return true;
    }
  }

  return false;
}

module.exports = isInstanceOfNode;

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


/**
 * Drag behavior has begun from outside the editor element.
 */
function editOnDragOver(editor, e) {
  editor.setMode('drag');
  e.preventDefault();
}

module.exports = editOnDragOver;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


/**
 * A `dragstart` event has begun within the text editor component.
 */
function editOnDragStart(editor) {
  editor._internalDrag = true;
  editor.setMode('drag');
}

module.exports = editOnDragStart;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(13);

var UserAgent = __webpack_require__(31);

function editOnFocus(editor, e) {
  var editorState = editor._latestEditorState;
  var currentSelection = editorState.getSelection();

  if (currentSelection.getHasFocus()) {
    return;
  }

  var selection = currentSelection.set('hasFocus', true);
  editor.props.onFocus && editor.props.onFocus(e); // When the tab containing this text editor is hidden and the user does a
  // find-in-page in a _different_ tab, Chrome on Mac likes to forget what the
  // selection was right after sending this focus event and (if you let it)
  // moves the cursor back to the beginning of the editor, so we force the
  // selection here instead of simply accepting it in order to preserve the
  // old cursor position. See https://crbug.com/540004.
  // But it looks like this is fixed in Chrome 60.0.3081.0.
  // Other browsers also don't have this bug, so we prefer to acceptSelection
  // when possible, to ensure that unfocusing and refocusing a Draft editor
  // doesn't preserve the selection, matching how textareas work.

  if (UserAgent.isBrowser('Chrome < 60.0.3081.0')) {
    editor.update(EditorState.forceSelection(editorState, selection));
  } else {
    editor.update(EditorState.acceptSelection(editorState, selection));
  }
}

module.exports = editOnFocus;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(29);

var DraftOffsetKey = __webpack_require__(64);

var EditorState = __webpack_require__(13);

var UserAgent = __webpack_require__(31);

var _require = __webpack_require__(358),
    notEmptyKey = _require.notEmptyKey;

var findAncestorOffsetKey = __webpack_require__(161);

var keyCommandPlainBackspace = __webpack_require__(370);

var nullthrows = __webpack_require__(30);

var isGecko = UserAgent.isEngine('Gecko');
var DOUBLE_NEWLINE = '\n\n';

function onInputType(inputType, editorState) {
  switch (inputType) {
    case 'deleteContentBackward':
      return keyCommandPlainBackspace(editorState);
  }

  return editorState;
}
/**
 * This function serves two purposes
 *
 * 1. To update the editorState and call onChange method with the new
 * editorState. This editorState is calculated in editOnBeforeInput but the
 * onChange method is not called with the new state until this method does it.
 * It is done to handle a specific case where certain character inputs might
 * be replaced with something else. E.g. snippets ('rc' might be replaced
 * with boilerplate code for react component). More information on the
 * exact problem can be found here -
 * https://github.com/facebook/draft-js/commit/07892ba479bd4dfc6afd1e0ed179aaf51cd138b1
 *
 * 2. intended to handle spellcheck and autocorrect changes,
 * which occur in the DOM natively without any opportunity to observe or
 * interpret the changes before they occur.
 *
 * The `input` event fires in contentEditable elements reliably for non-IE
 * browsers, immediately after changes occur to the editor DOM. Since our other
 * handlers override or otherwise handle cover other varieties of text input,
 * the DOM state should match the model in all controlled input cases. Thus,
 * when an `input` change leads to a DOM/model mismatch, the change should be
 * due to a spellcheck change, and we can incorporate it into our model.
 */


function editOnInput(editor, e) {
  if (editor._pendingStateFromBeforeInput !== undefined) {
    editor.update(editor._pendingStateFromBeforeInput);
    editor._pendingStateFromBeforeInput = undefined;
  } // at this point editor is not null for sure (after input)


  var castedEditorElement = editor.editor;
  var domSelection = castedEditorElement.ownerDocument.defaultView.getSelection();
  var anchorNode = domSelection.anchorNode,
      isCollapsed = domSelection.isCollapsed;
  var isNotTextOrElementNode = (anchorNode === null || anchorNode === void 0 ? void 0 : anchorNode.nodeType) !== Node.TEXT_NODE && (anchorNode === null || anchorNode === void 0 ? void 0 : anchorNode.nodeType) !== Node.ELEMENT_NODE;

  if (anchorNode == null || isNotTextOrElementNode) {
    // TODO: (t16149272) figure out context for this change
    return;
  }

  if (anchorNode.nodeType === Node.TEXT_NODE && (anchorNode.previousSibling !== null || anchorNode.nextSibling !== null)) {
    // When typing at the beginning of a visual line, Chrome splits the text
    // nodes into two. Why? No one knows. This commit is suspicious:
    // https://chromium.googlesource.com/chromium/src/+/a3b600981286b135632371477f902214c55a1724
    // To work around, we'll merge the sibling text nodes back into this one.
    var span = anchorNode.parentNode;

    if (span == null) {
      // Handle null-parent case.
      return;
    }

    anchorNode.nodeValue = span.textContent;

    for (var child = span.firstChild; child != null; child = child.nextSibling) {
      if (child !== anchorNode) {
        span.removeChild(child);
      }
    }
  }

  var domText = anchorNode.textContent;
  var editorState = editor._latestEditorState;
  var offsetKey = nullthrows(findAncestorOffsetKey(anchorNode));

  var _DraftOffsetKey$decod = DraftOffsetKey.decode(offsetKey),
      blockKey = _DraftOffsetKey$decod.blockKey,
      decoratorKey = _DraftOffsetKey$decod.decoratorKey,
      leafKey = _DraftOffsetKey$decod.leafKey;

  var _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]),
      start = _editorState$getBlock.start,
      end = _editorState$getBlock.end;

  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(blockKey);
  var modelText = block.getText().slice(start, end); // Special-case soft newlines here. If the DOM text ends in a soft newline,
  // we will have manually inserted an extra soft newline in DraftEditorLeaf.
  // We want to remove this extra newline for the purpose of our comparison
  // of DOM and model text.

  if (domText.endsWith(DOUBLE_NEWLINE)) {
    domText = domText.slice(0, -1);
  } // No change -- the DOM is up to date. Nothing to do here.


  if (domText === modelText) {
    // This can be buggy for some Android keyboards because they don't fire
    // standard onkeydown/pressed events and only fired editOnInput
    // so domText is already changed by the browser and ends up being equal
    // to modelText unexpectedly.
    // Newest versions of Android support the dom-inputevent-inputtype
    // and we can use the `inputType` to properly apply the state changes.

    /* $FlowFixMe[prop-missing] inputType is only defined on a draft of a
     * standard. https://w3c.github.io/input-events/#dom-inputevent-inputtype
     */
    var inputType = e.nativeEvent.inputType;

    if (inputType) {
      var newEditorState = onInputType(inputType, editorState);

      if (newEditorState !== editorState) {
        editor.restoreEditorDOM();
        editor.update(newEditorState);
        return;
      }
    }

    return;
  }

  var selection = editorState.getSelection(); // We'll replace the entire leaf with the text content of the target.

  var targetRange = selection.merge({
    anchorOffset: start,
    focusOffset: end,
    isBackward: false
  });
  var entityKey = block.getEntityAt(start);
  var entity = notEmptyKey(entityKey) ? content.getEntity(entityKey) : null;
  var entityType = entity != null ? entity.getMutability() : null;
  var preserveEntity = entityType === 'MUTABLE'; // Immutable or segmented entities cannot properly be handled by the
  // default browser undo, so we have to use a different change type to
  // force using our internal undo method instead of falling through to the
  // native browser undo.

  var changeType = preserveEntity ? 'spellcheck-change' : 'apply-entity';
  var newContent = DraftModifier.replaceText(content, targetRange, domText, block.getInlineStyleAt(start), preserveEntity ? block.getEntityAt(start) : null);
  var anchorOffset, focusOffset, startOffset, endOffset;

  if (isGecko) {
    // Firefox selection does not change while the context menu is open, so
    // we preserve the anchor and focus values of the DOM selection.
    anchorOffset = domSelection.anchorOffset;
    focusOffset = domSelection.focusOffset;
    startOffset = start + Math.min(anchorOffset, focusOffset);
    endOffset = startOffset + Math.abs(anchorOffset - focusOffset);
    anchorOffset = startOffset;
    focusOffset = endOffset;
  } else {
    // Browsers other than Firefox may adjust DOM selection while the context
    // menu is open, and Safari autocorrect is prone to providing an inaccurate
    // DOM selection. Don't trust it. Instead, use our existing SelectionState
    // and adjust it based on the number of characters changed during the
    // mutation.
    var charDelta = domText.length - modelText.length;
    startOffset = selection.getStartOffset();
    endOffset = selection.getEndOffset();
    anchorOffset = isCollapsed ? endOffset + charDelta : startOffset;
    focusOffset = endOffset + charDelta;
  } // Segmented entities are completely or partially removed when their
  // text content changes. For this case we do not want any text to be selected
  // after the change, so we are not merging the selection.


  var contentWithAdjustedDOMSelection = newContent.merge({
    selectionBefore: content.getSelectionAfter(),
    selectionAfter: selection.merge({
      anchorOffset: anchorOffset,
      focusOffset: focusOffset
    })
  });
  editor.update(EditorState.push(editorState, contentWithAdjustedDOMSelection, changeType));
}

module.exports = editOnInput;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(29);

var EditorState = __webpack_require__(13);

var KeyBindingUtil = __webpack_require__(234);

var Keys = __webpack_require__(163);

var SecondaryClipboard = __webpack_require__(865);

var UserAgent = __webpack_require__(31);

var isEventHandled = __webpack_require__(166);

var keyCommandBackspaceToStartOfLine = __webpack_require__(866);

var keyCommandBackspaceWord = __webpack_require__(868);

var keyCommandDeleteWord = __webpack_require__(870);

var keyCommandInsertNewline = __webpack_require__(871);

var keyCommandMoveSelectionToEndOfBlock = __webpack_require__(872);

var keyCommandMoveSelectionToStartOfBlock = __webpack_require__(873);

var keyCommandPlainBackspace = __webpack_require__(370);

var keyCommandPlainDelete = __webpack_require__(874);

var keyCommandTransposeCharacters = __webpack_require__(875);

var keyCommandUndo = __webpack_require__(876);

var isOptionKeyCommand = KeyBindingUtil.isOptionKeyCommand;
var isChrome = UserAgent.isBrowser('Chrome');
/**
 * Map a `DraftEditorCommand` command value to a corresponding function.
 */

function onKeyCommand(command, editorState, e) {
  switch (command) {
    case 'redo':
      return EditorState.redo(editorState);

    case 'delete':
      return keyCommandPlainDelete(editorState);

    case 'delete-word':
      return keyCommandDeleteWord(editorState);

    case 'backspace':
      return keyCommandPlainBackspace(editorState);

    case 'backspace-word':
      return keyCommandBackspaceWord(editorState);

    case 'backspace-to-start-of-line':
      return keyCommandBackspaceToStartOfLine(editorState, e);

    case 'split-block':
      return keyCommandInsertNewline(editorState);

    case 'transpose-characters':
      return keyCommandTransposeCharacters(editorState);

    case 'move-selection-to-start-of-block':
      return keyCommandMoveSelectionToStartOfBlock(editorState);

    case 'move-selection-to-end-of-block':
      return keyCommandMoveSelectionToEndOfBlock(editorState);

    case 'secondary-cut':
      return SecondaryClipboard.cut(editorState);

    case 'secondary-paste':
      return SecondaryClipboard.paste(editorState);

    default:
      return editorState;
  }
}
/**
 * Intercept keydown behavior to handle keys and commands manually, if desired.
 *
 * Keydown combinations may be mapped to `DraftCommand` values, which may
 * correspond to command functions that modify the editor or its contents.
 *
 * See `getDefaultKeyBinding` for defaults. Alternatively, the top-level
 * component may provide a custom mapping via the `keyBindingFn` prop.
 */


function editOnKeyDown(editor, e) {
  var keyCode = e.which;
  var editorState = editor._latestEditorState;

  function callDeprecatedHandler(handlerName) {
    var deprecatedHandler = editor.props[handlerName];

    if (deprecatedHandler) {
      deprecatedHandler(e);
      return true;
    } else {
      return false;
    }
  }

  switch (keyCode) {
    case Keys.RETURN:
      e.preventDefault(); // The top-level component may manually handle newline insertion. If
      // no special handling is performed, fall through to command handling.

      if (editor.props.handleReturn && isEventHandled(editor.props.handleReturn(e, editorState))) {
        return;
      }

      break;

    case Keys.ESC:
      e.preventDefault();

      if (callDeprecatedHandler('onEscape')) {
        return;
      }

      break;

    case Keys.TAB:
      if (callDeprecatedHandler('onTab')) {
        return;
      }

      break;

    case Keys.UP:
      if (callDeprecatedHandler('onUpArrow')) {
        return;
      }

      break;

    case Keys.RIGHT:
      if (callDeprecatedHandler('onRightArrow')) {
        return;
      }

      break;

    case Keys.DOWN:
      if (callDeprecatedHandler('onDownArrow')) {
        return;
      }

      break;

    case Keys.LEFT:
      if (callDeprecatedHandler('onLeftArrow')) {
        return;
      }

      break;

    case Keys.SPACE:
      // Prevent Chrome on OSX behavior where option + space scrolls.
      if (isChrome && isOptionKeyCommand(e)) {
        e.preventDefault();
      }

  }

  var command = editor.props.keyBindingFn(e); // If no command is specified, allow keydown event to continue.

  if (command == null || command === '') {
    if (keyCode === Keys.SPACE && isChrome && isOptionKeyCommand(e)) {
      // The default keydown event has already been prevented in order to stop
      // Chrome from scrolling. Insert a nbsp into the editor as OSX would for
      // other browsers.
      var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), "\xA0");
      editor.update(EditorState.push(editorState, contentState, 'insert-characters'));
    }

    return;
  }

  if (command === 'undo') {
    // Since undo requires some special updating behavior to keep the editor
    // in sync, handle it separately.
    keyCommandUndo(e, editorState, editor.update);
    return;
  } // At this point, we know that we're handling a command of some kind, so
  // we don't want to insert a character following the keydown.


  e.preventDefault(); // Allow components higher up the tree to handle the command first.

  if (editor.props.handleKeyCommand && isEventHandled(editor.props.handleKeyCommand(command, editorState, e.timeStamp))) {
    return;
  }

  var newState = onKeyCommand(command, editorState, e);

  if (newState !== editorState) {
    editor.update(newState);
  }
}

module.exports = editOnKeyDown;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var Keys = __webpack_require__(163);

function isSoftNewlineEvent(e) {
  return e.which === Keys.RETURN && (e.getModifierState('Shift') || e.getModifierState('Alt') || e.getModifierState('Control'));
}

module.exports = isSoftNewlineEvent;

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(29);

var EditorState = __webpack_require__(13);

var getContentStateFragment = __webpack_require__(157);

var nullthrows = __webpack_require__(30);

var clipboard = null;
/**
 * Some systems offer a "secondary" clipboard to allow quick internal cut
 * and paste behavior. For instance, Ctrl+K (cut) and Ctrl+Y (paste).
 */

var SecondaryClipboard = {
  cut: function cut(editorState) {
    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var targetRange = null;

    if (selection.isCollapsed()) {
      var anchorKey = selection.getAnchorKey();
      var blockEnd = content.getBlockForKey(anchorKey).getLength();

      if (blockEnd === selection.getAnchorOffset()) {
        var keyAfter = content.getKeyAfter(anchorKey);

        if (keyAfter == null) {
          return editorState;
        }

        targetRange = selection.set('focusKey', keyAfter).set('focusOffset', 0);
      } else {
        targetRange = selection.set('focusOffset', blockEnd);
      }
    } else {
      targetRange = selection;
    }

    targetRange = nullthrows(targetRange); // TODO: This should actually append to the current state when doing
    // successive ^K commands without any other cursor movement

    clipboard = getContentStateFragment(content, targetRange);
    var afterRemoval = DraftModifier.removeRange(content, targetRange, 'forward');

    if (afterRemoval === content) {
      return editorState;
    }

    return EditorState.push(editorState, afterRemoval, 'remove-range');
  },
  paste: function paste(editorState) {
    if (!clipboard) {
      return editorState;
    }

    var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), clipboard);
    return EditorState.push(editorState, newContent, 'insert-fragment');
  }
};
module.exports = SecondaryClipboard;

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(13);

var expandRangeToStartOfLine = __webpack_require__(867);

var getDraftEditorSelectionWithNodes = __webpack_require__(356);

var moveSelectionBackward = __webpack_require__(232);

var removeTextWithStrategy = __webpack_require__(123);

function keyCommandBackspaceToStartOfLine(editorState, e) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();

    if (selection.isCollapsed() && selection.getAnchorOffset() === 0) {
      return moveSelectionBackward(strategyState, 1);
    }

    var ownerDocument = e.currentTarget.ownerDocument;
    var domSelection = ownerDocument.defaultView.getSelection(); // getRangeAt can technically throw if there's no selection, but we know
    // there is one here because text editor has focus (the cursor is a
    // selection of length 0). Therefore, we don't need to wrap this in a
    // try-catch block.

    var range = domSelection.getRangeAt(0);
    range = expandRangeToStartOfLine(range);
    return getDraftEditorSelectionWithNodes(strategyState, null, range.endContainer, range.endOffset, range.startContainer, range.startOffset).selectionState;
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState.push(editorState, afterRemoval, 'remove-range');
}

module.exports = keyCommandBackspaceToStartOfLine;

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
var UnicodeUtils = __webpack_require__(91);

var getCorrectDocumentFromNode = __webpack_require__(162);

var getRangeClientRects = __webpack_require__(371);

var invariant = __webpack_require__(9);
/**
 * Return the computed line height, in pixels, for the provided element.
 */


function getLineHeightPx(element) {
  var computed = getComputedStyle(element);
  var correctDocument = getCorrectDocumentFromNode(element);
  var div = correctDocument.createElement('div');
  div.style.fontFamily = computed.fontFamily;
  div.style.fontSize = computed.fontSize;
  div.style.fontStyle = computed.fontStyle;
  div.style.fontWeight = computed.fontWeight;
  div.style.lineHeight = computed.lineHeight;
  div.style.position = 'absolute';
  div.textContent = 'M';
  var documentBody = correctDocument.body;
  !documentBody ?  false ? invariant(false, 'Missing document.body') : invariant(false) : void 0; // forced layout here

  documentBody.appendChild(div);
  var rect = div.getBoundingClientRect();
  documentBody.removeChild(div);
  return rect.height;
}
/**
 * Return whether every ClientRect in the provided list lies on the same line.
 *
 * We assume that the rects on the same line all contain the baseline, so the
 * lowest top line needs to be above the highest bottom line (i.e., if you were
 * to project the rects onto the y-axis, their intersection would be nonempty).
 *
 * In addition, we require that no two boxes are lineHeight (or more) apart at
 * either top or bottom, which helps protect against false positives for fonts
 * with extremely large glyph heights (e.g., with a font size of 17px, Zapfino
 * produces rects of height 58px!).
 */


function areRectsOnOneLine(rects, lineHeight) {
  var minTop = Infinity;
  var minBottom = Infinity;
  var maxTop = -Infinity;
  var maxBottom = -Infinity;

  for (var ii = 0; ii < rects.length; ii++) {
    var rect = rects[ii];

    if (rect.width === 0 || rect.width === 1) {
      // When a range starts or ends a soft wrap, many browsers (Chrome, IE,
      // Safari) include an empty rect on the previous or next line. When the
      // text lies in a container whose position is not integral (e.g., from
      // margin: auto), Safari makes these empty rects have width 1 (instead of
      // 0). Having one-pixel-wide characters seems unlikely (and most browsers
      // report widths in subpixel precision anyway) so it's relatively safe to
      // skip over them.
      continue;
    }

    minTop = Math.min(minTop, rect.top);
    minBottom = Math.min(minBottom, rect.bottom);
    maxTop = Math.max(maxTop, rect.top);
    maxBottom = Math.max(maxBottom, rect.bottom);
  }

  return maxTop <= minBottom && maxTop - minTop < lineHeight && maxBottom - minBottom < lineHeight;
}
/**
 * Return the length of a node, as used by Range offsets.
 */


function getNodeLength(node) {
  // http://www.w3.org/TR/dom/#concept-node-length
  switch (node.nodeType) {
    case Node.DOCUMENT_TYPE_NODE:
      return 0;

    case Node.TEXT_NODE:
    case Node.PROCESSING_INSTRUCTION_NODE:
    case Node.COMMENT_NODE:
      return node.length;

    default:
      return node.childNodes.length;
  }
}
/**
 * Given a collapsed range, move the start position backwards as far as
 * possible while the range still spans only a single line.
 */


function expandRangeToStartOfLine(range) {
  !range.collapsed ?  false ? invariant(false, 'expandRangeToStartOfLine: Provided range is not collapsed.') : invariant(false) : void 0;
  range = range.cloneRange();
  var containingElement = range.startContainer;

  if (containingElement.nodeType !== 1) {
    containingElement = containingElement.parentNode;
  }

  var lineHeight = getLineHeightPx(containingElement); // Imagine our text looks like:
  //   <div><span>once upon a time, there was a <em>boy
  //   who lived</em> </span><q><strong>under^ the
  //   stairs</strong> in a small closet.</q></div>
  // where the caret represents the cursor. First, we crawl up the tree until
  // the range spans multiple lines (setting the start point to before
  // "<strong>", then before "<div>"), then at each level we do a search to
  // find the latest point which is still on a previous line. We'll find that
  // the break point is inside the span, then inside the <em>, then in its text
  // node child, the actual break point before "who".

  var bestContainer = range.endContainer;
  var bestOffset = range.endOffset;
  range.setStart(range.startContainer, 0);

  while (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
    bestContainer = range.startContainer;
    bestOffset = range.startOffset;
    !bestContainer.parentNode ?  false ? invariant(false, 'Found unexpected detached subtree when traversing.') : invariant(false) : void 0;
    range.setStartBefore(bestContainer);

    if (bestContainer.nodeType === 1 && getComputedStyle(bestContainer).display !== 'inline') {
      // The start of the line is never in a different block-level container.
      break;
    }
  } // In the above example, range now spans from "<div>" to "under",
  // bestContainer is <div>, and bestOffset is 1 (index of <q> inside <div>)].
  // Picking out which child to recurse into here is a special case since we
  // don't want to check past <q> -- once we find that the final range starts
  // in <span>, we can look at all of its children (and all of their children)
  // to find the break point.
  // At all times, (bestContainer, bestOffset) is the latest single-line start
  // point that we know of.


  var currentContainer = bestContainer;
  var maxIndexToConsider = bestOffset - 1;

  do {
    var nodeValue = currentContainer.nodeValue;
    var ii = maxIndexToConsider;

    for (; ii >= 0; ii--) {
      if (nodeValue != null && ii > 0 && UnicodeUtils.isSurrogatePair(nodeValue, ii - 1)) {
        // We're in the middle of a surrogate pair -- skip over so we never
        // return a range with an endpoint in the middle of a code point.
        continue;
      }

      range.setStart(currentContainer, ii);

      if (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
        bestContainer = currentContainer;
        bestOffset = ii;
      } else {
        break;
      }
    }

    if (ii === -1 || currentContainer.childNodes.length === 0) {
      // If ii === -1, then (bestContainer, bestOffset), which is equal to
      // (currentContainer, 0), was a single-line start point but a start
      // point before currentContainer wasn't, so the line break seems to
      // have occurred immediately after currentContainer's start tag
      //
      // If currentContainer.childNodes.length === 0, we're already at a
      // terminal node (e.g., text node) and should return our current best.
      break;
    }

    currentContainer = currentContainer.childNodes[ii];
    maxIndexToConsider = getNodeLength(currentContainer);
  } while (true);

  range.setStart(bestContainer, bestOffset);
  return range;
}

module.exports = expandRangeToStartOfLine;

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftRemovableWord = __webpack_require__(372);

var EditorState = __webpack_require__(13);

var moveSelectionBackward = __webpack_require__(232);

var removeTextWithStrategy = __webpack_require__(123);
/**
 * Delete the word that is left of the cursor, as well as any spaces or
 * punctuation after the word.
 */


function keyCommandBackspaceWord(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var offset = selection.getStartOffset(); // If there are no words before the cursor, remove the preceding newline.

    if (offset === 0) {
      return moveSelectionBackward(strategyState, 1);
    }

    var key = selection.getStartKey();
    var content = strategyState.getCurrentContent();
    var text = content.getBlockForKey(key).getText().slice(0, offset);
    var toRemove = DraftRemovableWord.getBackward(text);
    return moveSelectionBackward(strategyState, toRemove.length || 1);
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState.push(editorState, afterRemoval, 'remove-range');
}

module.exports = keyCommandBackspaceWord;

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * @stub
 * 
 */
 // \u00a1-\u00b1\u00b4-\u00b8\u00ba\u00bb\u00bf
//             is latin supplement punctuation except fractions and superscript
//             numbers
// \u2010-\u2027\u2030-\u205e
//             is punctuation from the general punctuation block:
//             weird quotes, commas, bullets, dashes, etc.
// \u30fb\u3001\u3002\u3008-\u3011\u3014-\u301f
//             is CJK punctuation
// \uff1a-\uff1f\uff01-\uff0f\uff3b-\uff40\uff5b-\uff65
//             is some full-width/half-width punctuation
// \u2E2E\u061f\u066a-\u066c\u061b\u060c\u060d\uFD3e\uFD3F
//             is some Arabic punctuation marks
// \u1801\u0964\u104a\u104b
//             is misc. other language punctuation marks

var PUNCTUATION = '[.,+*?$|#{}()\'\\^\\-\\[\\]\\\\\\/!@%"~=<>_:;' + "\u30FB\u3001\u3002\u3008-\u3011\u3014-\u301F\uFF1A-\uFF1F\uFF01-\uFF0F" + "\uFF3B-\uFF40\uFF5B-\uFF65\u2E2E\u061F\u066A-\u066C\u061B\u060C\u060D" + "\uFD3E\uFD3F\u1801\u0964\u104A\u104B\u2010-\u2027\u2030-\u205E" + "\xA1-\xB1\xB4-\xB8\xBA\xBB\xBF]";
module.exports = {
  getPunctuation: function getPunctuation() {
    return PUNCTUATION;
  }
};

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftRemovableWord = __webpack_require__(372);

var EditorState = __webpack_require__(13);

var moveSelectionForward = __webpack_require__(373);

var removeTextWithStrategy = __webpack_require__(123);
/**
 * Delete the word that is right of the cursor, as well as any spaces or
 * punctuation before the word.
 */


function keyCommandDeleteWord(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var offset = selection.getStartOffset();
    var key = selection.getStartKey();
    var content = strategyState.getCurrentContent();
    var text = content.getBlockForKey(key).getText().slice(offset);
    var toRemove = DraftRemovableWord.getForward(text); // If there are no words in front of the cursor, remove the newline.

    return moveSelectionForward(strategyState, toRemove.length || 1);
  }, 'forward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState.push(editorState, afterRemoval, 'remove-range');
}

module.exports = keyCommandDeleteWord;

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(29);

var EditorState = __webpack_require__(13);

function keyCommandInsertNewline(editorState) {
  var contentState = DraftModifier.splitBlock(editorState.getCurrentContent(), editorState.getSelection());
  return EditorState.push(editorState, contentState, 'split-block');
}

module.exports = keyCommandInsertNewline;

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(13);
/**
 * See comment for `moveSelectionToStartOfBlock`.
 */


function keyCommandMoveSelectionToEndOfBlock(editorState) {
  var selection = editorState.getSelection();
  var endKey = selection.getEndKey();
  var content = editorState.getCurrentContent();
  var textLength = content.getBlockForKey(endKey).getLength();
  return EditorState.set(editorState, {
    selection: selection.merge({
      anchorKey: endKey,
      anchorOffset: textLength,
      focusKey: endKey,
      focusOffset: textLength,
      isBackward: false
    }),
    forceSelection: true
  });
}

module.exports = keyCommandMoveSelectionToEndOfBlock;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(13);
/**
 * Collapse selection at the start of the first selected block. This is used
 * for Firefox versions that attempt to navigate forward/backward instead of
 * moving the cursor. Other browsers are able to move the cursor natively.
 */


function keyCommandMoveSelectionToStartOfBlock(editorState) {
  var selection = editorState.getSelection();
  var startKey = selection.getStartKey();
  return EditorState.set(editorState, {
    selection: selection.merge({
      anchorKey: startKey,
      anchorOffset: 0,
      focusKey: startKey,
      focusOffset: 0,
      isBackward: false
    }),
    forceSelection: true
  });
}

module.exports = keyCommandMoveSelectionToStartOfBlock;

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(13);

var UnicodeUtils = __webpack_require__(91);

var moveSelectionForward = __webpack_require__(373);

var removeTextWithStrategy = __webpack_require__(123);
/**
 * Remove the selected range. If the cursor is collapsed, remove the following
 * character. This operation is Unicode-aware, so removing a single character
 * will remove a surrogate pair properly as well.
 */


function keyCommandPlainDelete(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var content = strategyState.getCurrentContent();
    var key = selection.getAnchorKey();
    var offset = selection.getAnchorOffset();
    var charAhead = content.getBlockForKey(key).getText()[offset];
    return moveSelectionForward(strategyState, charAhead ? UnicodeUtils.getUTF16Length(charAhead, 0) : 1);
  }, 'forward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  var selection = editorState.getSelection();
  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'delete-character' : 'remove-range');
}

module.exports = keyCommandPlainDelete;

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(29);

var EditorState = __webpack_require__(13);

var getContentStateFragment = __webpack_require__(157);
/**
 * Transpose the characters on either side of a collapsed cursor, or
 * if the cursor is at the end of the block, transpose the last two
 * characters.
 */


function keyCommandTransposeCharacters(editorState) {
  var selection = editorState.getSelection();

  if (!selection.isCollapsed()) {
    return editorState;
  }

  var offset = selection.getAnchorOffset();

  if (offset === 0) {
    return editorState;
  }

  var blockKey = selection.getAnchorKey();
  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(blockKey);
  var length = block.getLength(); // Nothing to transpose if there aren't two characters.

  if (length <= 1) {
    return editorState;
  }

  var removalRange;
  var finalSelection;

  if (offset === length) {
    // The cursor is at the end of the block. Swap the last two characters.
    removalRange = selection.set('anchorOffset', offset - 1);
    finalSelection = selection;
  } else {
    removalRange = selection.set('focusOffset', offset + 1);
    finalSelection = removalRange.set('anchorOffset', offset + 1);
  } // Extract the character to move as a fragment. This preserves its
  // styling and entity, if any.


  var movedFragment = getContentStateFragment(content, removalRange);
  var afterRemoval = DraftModifier.removeRange(content, removalRange, 'backward'); // After the removal, the insertion target is one character back.

  var selectionAfter = afterRemoval.getSelectionAfter();
  var targetOffset = selectionAfter.getAnchorOffset() - 1;
  var targetRange = selectionAfter.merge({
    anchorOffset: targetOffset,
    focusOffset: targetOffset
  });
  var afterInsert = DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
  var newEditorState = EditorState.push(editorState, afterInsert, 'insert-fragment');
  return EditorState.acceptSelection(newEditorState, finalSelection);
}

module.exports = keyCommandTransposeCharacters;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(13);

function keyCommandUndo(e, editorState, updateFn) {
  var undoneState = EditorState.undo(editorState); // If the last change to occur was a spellcheck change, allow the undo
  // event to fall through to the browser. This allows the browser to record
  // the unwanted change, which should soon lead it to learn not to suggest
  // the correction again.

  if (editorState.getLastChangeType() === 'spellcheck-change') {
    var nativelyRenderedContent = undoneState.getCurrentContent();
    updateFn(EditorState.set(undoneState, {
      nativelyRenderedContent: nativelyRenderedContent
    }));
    return;
  } // Otheriwse, manage the undo behavior manually.


  e.preventDefault();

  if (!editorState.getNativelyRenderedContent()) {
    updateFn(undoneState);
    return;
  } // Trigger a re-render with the current content state to ensure that the
  // component tree has up-to-date props for comparison.


  updateFn(EditorState.set(editorState, {
    nativelyRenderedContent: null
  })); // Wait to ensure that the re-render has occurred before performing
  // the undo action.

  setTimeout(function () {
    updateFn(undoneState);
  }, 0);
}

module.exports = keyCommandUndo;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var BlockMapBuilder = __webpack_require__(120);

var CharacterMetadata = __webpack_require__(43);

var DataTransfer = __webpack_require__(366);

var DraftModifier = __webpack_require__(29);

var DraftPasteProcessor = __webpack_require__(878);

var EditorState = __webpack_require__(13);

var RichTextEditorUtil = __webpack_require__(376);

var getEntityKeyForSelection = __webpack_require__(228);

var getTextContentFromFiles = __webpack_require__(368);

var isEventHandled = __webpack_require__(166);

var splitTextIntoTextBlocks = __webpack_require__(883);
/**
 * Paste content.
 */


function editOnPaste(editor, e) {
  e.preventDefault();
  var data = new DataTransfer(e.clipboardData); // Get files, unless this is likely to be a string the user wants inline.

  if (!data.isRichText()) {
    var files = data.getFiles();
    var defaultFileText = data.getText();

    if (files.length > 0) {
      // Allow customized paste handling for images, etc. Otherwise, fall
      // through to insert text contents into the editor.
      if (editor.props.handlePastedFiles && isEventHandled(editor.props.handlePastedFiles(files))) {
        return;
      }
      /* $FlowFixMe[incompatible-call] This comment suppresses an error found
       * DataTransfer was typed. getFiles() returns an array of <Files extends
       * Blob>, not Blob */


      getTextContentFromFiles(files, function (
      /*string*/
      fileText) {
        fileText = fileText || defaultFileText;

        if (!fileText) {
          return;
        }

        var editorState = editor._latestEditorState;
        var blocks = splitTextIntoTextBlocks(fileText);
        var character = CharacterMetadata.create({
          style: editorState.getCurrentInlineStyle(),
          entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
        });
        var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);
        var text = DraftPasteProcessor.processText(blocks, character, currentBlockType);
        var fragment = BlockMapBuilder.createFromArray(text);
        var withInsertedText = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
        editor.update(EditorState.push(editorState, withInsertedText, 'insert-fragment'));
      });
      return;
    }
  }

  var textBlocks = [];
  var text = data.getText();
  var html = data.getHTML();
  var editorState = editor._latestEditorState;

  if (editor.props.formatPastedText) {
    var _editor$props$formatP = editor.props.formatPastedText(text, html),
        formattedText = _editor$props$formatP.text,
        formattedHtml = _editor$props$formatP.html;

    text = formattedText;
    html = formattedHtml;
  }

  if (editor.props.handlePastedText && isEventHandled(editor.props.handlePastedText(text, html, editorState))) {
    return;
  }

  if (text) {
    textBlocks = splitTextIntoTextBlocks(text);
  }

  if (!editor.props.stripPastedStyles) {
    // If the text from the paste event is rich content that matches what we
    // already have on the internal clipboard, assume that we should just use
    // the clipboard fragment for the paste. This will allow us to preserve
    // styling and entities, if any are present. Note that newlines are
    // stripped during comparison -- this is because copy/paste within the
    // editor in Firefox and IE will not include empty lines. The resulting
    // paste will preserve the newlines correctly.
    var internalClipboard = editor.getClipboard();

    if (!editor.props.formatPastedText && data.isRichText() && internalClipboard) {
      var _html;

      if ( // If the editorKey is present in the pasted HTML, it should be safe to
      // assume this is an internal paste.
      ((_html = html) === null || _html === void 0 ? void 0 : _html.indexOf(editor.getEditorKey())) !== -1 || // The copy may have been made within a single block, in which case the
      // editor key won't be part of the paste. In this case, just check
      // whether the pasted text matches the internal clipboard.
      textBlocks.length === 1 && internalClipboard.size === 1 && internalClipboard.first().getText() === text) {
        editor.update(insertFragment(editor._latestEditorState, internalClipboard));
        return;
      }
    } else if (internalClipboard && data.types.includes('com.apple.webarchive') && !data.types.includes('text/html') && areTextBlocksAndClipboardEqual(textBlocks, internalClipboard)) {
      // Safari does not properly store text/html in some cases.
      // Use the internalClipboard if present and equal to what is on
      // the clipboard. See https://bugs.webkit.org/show_bug.cgi?id=19893.
      editor.update(insertFragment(editor._latestEditorState, internalClipboard));
      return;
    } // If there is html paste data, try to parse that.


    if (html) {
      var htmlFragment = DraftPasteProcessor.processHTML(html, editor.props.blockRenderMap);

      if (htmlFragment) {
        var contentBlocks = htmlFragment.contentBlocks,
            entityMap = htmlFragment.entityMap;

        if (contentBlocks) {
          var htmlMap = BlockMapBuilder.createFromArray(contentBlocks);
          editor.update(insertFragment(editor._latestEditorState, htmlMap, entityMap));
          return;
        }
      }
    } // Otherwise, create a new fragment from our pasted text. Also
    // empty the internal clipboard, since it's no longer valid.


    editor.setClipboard(null);
  }

  if (textBlocks.length) {
    var character = CharacterMetadata.create({
      style: editorState.getCurrentInlineStyle(),
      entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
    });
    var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);
    var textFragment = DraftPasteProcessor.processText(textBlocks, character, currentBlockType);
    var textMap = BlockMapBuilder.createFromArray(textFragment);
    editor.update(insertFragment(editor._latestEditorState, textMap));
  }
}

function insertFragment(editorState, fragment, entityMap) {
  var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment); // TODO: merge the entity map once we stop using DraftEntity
  // like this:
  // const mergedEntityMap = newContent.getEntityMap().merge(entityMap);

  return EditorState.push(editorState, newContent.set('entityMap', entityMap), 'insert-fragment');
}

function areTextBlocksAndClipboardEqual(textBlocks, blockMap) {
  return textBlocks.length === blockMap.size && blockMap.valueSeq().every(function (block, ii) {
    return block.getText() === textBlocks[ii];
  });
}

module.exports = editOnPaste;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ContentBlock = __webpack_require__(88);

var ContentBlockNode = __webpack_require__(44);

var convertFromHTMLToContentBlocks = __webpack_require__(374);

var generateRandomKey = __webpack_require__(57);

var getSafeBodyFromHTML = __webpack_require__(375);

var gkx = __webpack_require__(70);

var Immutable = __webpack_require__(4);

var sanitizeDraftText = __webpack_require__(348);

var List = Immutable.List,
    Repeat = Immutable.Repeat;
var experimentalTreeDataSupport = gkx('draft_tree_data_support');
var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
var DraftPasteProcessor = {
  processHTML: function processHTML(html, blockRenderMap) {
    return convertFromHTMLToContentBlocks(html, getSafeBodyFromHTML, blockRenderMap);
  },
  processText: function processText(textBlocks, character, type) {
    return textBlocks.reduce(function (acc, textLine, index) {
      textLine = sanitizeDraftText(textLine);
      var key = generateRandomKey();
      var blockNodeConfig = {
        key: key,
        type: type,
        text: textLine,
        characterList: List(Repeat(character, textLine.length))
      }; // next block updates previous block

      if (experimentalTreeDataSupport && index !== 0) {
        var prevSiblingIndex = index - 1; // update previous block

        var previousBlock = acc[prevSiblingIndex] = acc[prevSiblingIndex].merge({
          nextSibling: key
        });
        blockNodeConfig = _objectSpread({}, blockNodeConfig, {
          prevSibling: previousBlock.getKey()
        });
      }

      acc.push(new ContentBlockRecord(blockNodeConfig));
      return acc;
    }, []);
  }
};
module.exports = DraftPasteProcessor;

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var URI =
/*#__PURE__*/
function () {
  function URI(uri) {
    _defineProperty(this, "_uri", void 0);

    this._uri = uri;
  }

  var _proto = URI.prototype;

  _proto.toString = function toString() {
    return this._uri;
  };

  return URI;
}();

module.exports = URI;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
var isElement = __webpack_require__(90);

function isHTMLAnchorElement(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }

  return isElement(node) && node.nodeName === 'A';
}

module.exports = isHTMLAnchorElement;

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
var isElement = __webpack_require__(90);

function isHTMLImageElement(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }

  return isElement(node) && node.nodeName === 'IMG';
}

module.exports = isHTMLImageElement;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function adjustBlockDepthForContentState(contentState, selectionState, adjustment, maxDepth) {
  var startKey = selectionState.getStartKey();
  var endKey = selectionState.getEndKey();
  var blockMap = contentState.getBlockMap();
  var blocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat([[endKey, blockMap.get(endKey)]]).map(function (block) {
    var depth = block.getDepth() + adjustment;
    depth = Math.max(0, Math.min(depth, maxDepth));
    return block.set('depth', depth);
  });
  blockMap = blockMap.merge(blocks);
  return contentState.merge({
    blockMap: blockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = adjustBlockDepthForContentState;

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var NEWLINE_REGEX = /\r\n?|\n/g;

function splitTextIntoTextBlocks(text) {
  return text.split(NEWLINE_REGEX);
}

module.exports = splitTextIntoTextBlocks;

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
var ReactDOMComet = __webpack_require__(377);

var flushControlled = ReactDOMComet.unstable_flushControlled;
module.exports = flushControlled;

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(21);
var ReactDefaultInjection = __webpack_require__(379);
var ReactMount = __webpack_require__(403);
var ReactReconciler = __webpack_require__(93);
var ReactUpdates = __webpack_require__(52);
var ReactVersion = __webpack_require__(406);

var findDOMNode = __webpack_require__(953);
var getHostComponentFromComposite = __webpack_require__(407);
var renderSubtreeIntoContainer = __webpack_require__(954);
var warning = __webpack_require__(18);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(124);
var ExecutionEnvironment = __webpack_require__(32);
var FallbackCompositionState = __webpack_require__(888);
var SyntheticCompositionEvent = __webpack_require__(889);
var SyntheticInputEvent = __webpack_require__(890);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(8);

var PooledClass = __webpack_require__(92);

var getTextContentAccessor = __webpack_require__(382);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(66);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(66);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(125);
var EventPropagators = __webpack_require__(124);
var ExecutionEnvironment = __webpack_require__(32);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactUpdates = __webpack_require__(52);
var SyntheticEvent = __webpack_require__(66);

var inputValueTracking = __webpack_require__(385);
var getEventTarget = __webpack_require__(238);
var isEventSupported = __webpack_require__(239);
var isTextInputElement = __webpack_require__(386);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactOwner = __webpack_require__(893);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(12);

var invariant = __webpack_require__(6);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(124);
var ReactDOMComponentTree = __webpack_require__(21);
var SyntheticMouseEvent = __webpack_require__(168);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(103);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    controlsList: 0,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(241);
var ReactDOMIDOperations = __webpack_require__(902);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(12);

var DOMLazyTree = __webpack_require__(104);
var ExecutionEnvironment = __webpack_require__(32);

var createNodesFromMarkup = __webpack_require__(899);
var emptyFunction = __webpack_require__(65);
var invariant = __webpack_require__(6);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(32);

var createArrayFromMixed = __webpack_require__(900);
var getMarkupWrap = __webpack_require__(901);
var invariant = __webpack_require__(6);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var invariant = __webpack_require__(6);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(32);

var invariant = __webpack_require__(6);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(241);
var ReactDOMComponentTree = __webpack_require__(21);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(12),
    _assign = __webpack_require__(8);

var AutoFocusUtils = __webpack_require__(904);
var CSSPropertyOperations = __webpack_require__(905);
var DOMLazyTree = __webpack_require__(104);
var DOMNamespaces = __webpack_require__(242);
var DOMProperty = __webpack_require__(103);
var DOMPropertyOperations = __webpack_require__(391);
var EventPluginHub = __webpack_require__(125);
var EventPluginRegistry = __webpack_require__(235);
var ReactBrowserEventEmitter = __webpack_require__(171);
var ReactDOMComponentFlags = __webpack_require__(378);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactDOMInput = __webpack_require__(915);
var ReactDOMOption = __webpack_require__(917);
var ReactDOMSelect = __webpack_require__(392);
var ReactDOMTextarea = __webpack_require__(918);
var ReactInstrumentation = __webpack_require__(45);
var ReactMultiChild = __webpack_require__(919);
var ReactServerRenderingTransaction = __webpack_require__(398);

var emptyFunction = __webpack_require__(65);
var escapeTextContentForBrowser = __webpack_require__(170);
var invariant = __webpack_require__(6);
var isEventSupported = __webpack_require__(239);
var shallowEqual = __webpack_require__(248);
var inputValueTracking = __webpack_require__(385);
var validateDOMNesting = __webpack_require__(252);
var warning = __webpack_require__(18);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);

        // We also check that we haven't missed a value update, such as a
        // Radio group shifting the checked value to another named radio input.
        inputValueTracking.updateValueIfChanged(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(21);

var focusNode = __webpack_require__(389);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(390);
var ExecutionEnvironment = __webpack_require__(32);
var ReactInstrumentation = __webpack_require__(45);

var camelizeStyleName = __webpack_require__(906);
var dangerousStyleValue = __webpack_require__(908);
var hyphenateStyleName = __webpack_require__(909);
var memoizeStringOnly = __webpack_require__(911);
var warning = __webpack_require__(18);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var camelize = __webpack_require__(907);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(390);
var warning = __webpack_require__(18);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(910);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(170);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(125);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(32);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(12),
    _assign = __webpack_require__(8);

var DOMPropertyOperations = __webpack_require__(391);
var LinkedValueUtils = __webpack_require__(244);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactUpdates = __webpack_require__(52);

var invariant = __webpack_require__(6);
var warning = __webpack_require__(18);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(8);

var React = __webpack_require__(85);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactDOMSelect = __webpack_require__(392);

var warning = __webpack_require__(18);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(12),
    _assign = __webpack_require__(8);

var LinkedValueUtils = __webpack_require__(244);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactUpdates = __webpack_require__(52);

var invariant = __webpack_require__(6);
var warning = __webpack_require__(18);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(12);

var ReactComponentEnvironment = __webpack_require__(245);
var ReactInstanceMap = __webpack_require__(127);
var ReactInstrumentation = __webpack_require__(45);

var ReactCurrentOwner = __webpack_require__(62);
var ReactReconciler = __webpack_require__(93);
var ReactChildReconciler = __webpack_require__(920);

var emptyFunction = __webpack_require__(65);
var flattenChildren = __webpack_require__(925);
var invariant = __webpack_require__(6);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactReconciler = __webpack_require__(93);

var instantiateReactComponent = __webpack_require__(246);
var KeyEscapeUtils = __webpack_require__(250);
var shouldUpdateReactComponent = __webpack_require__(249);
var traverseAllChildren = __webpack_require__(396);
var warning = __webpack_require__(18);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && Object({"NODE_ENV":"production"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(397);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(231)))

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(12),
    _assign = __webpack_require__(8);

var React = __webpack_require__(85);
var ReactComponentEnvironment = __webpack_require__(245);
var ReactCurrentOwner = __webpack_require__(62);
var ReactErrorUtils = __webpack_require__(237);
var ReactInstanceMap = __webpack_require__(127);
var ReactInstrumentation = __webpack_require__(45);
var ReactNodeTypes = __webpack_require__(393);
var ReactReconciler = __webpack_require__(93);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(247);
var invariant = __webpack_require__(6);
var shallowEqual = __webpack_require__(248);
var shouldUpdateReactComponent = __webpack_require__(249);
var warning = __webpack_require__(18);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(250);
var traverseAllChildren = __webpack_require__(396);
var warning = __webpack_require__(18);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && Object({"NODE_ENV":"production"}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(397);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(231)))

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(251);

var warning = __webpack_require__(18);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(8);

var DOMLazyTree = __webpack_require__(104);
var ReactDOMComponentTree = __webpack_require__(21);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(12);

var invariant = __webpack_require__(6);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(12),
    _assign = __webpack_require__(8);

var DOMChildrenOperations = __webpack_require__(241);
var DOMLazyTree = __webpack_require__(104);
var ReactDOMComponentTree = __webpack_require__(21);

var escapeTextContentForBrowser = __webpack_require__(170);
var invariant = __webpack_require__(6);
var validateDOMNesting = __webpack_require__(252);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(8);

var EventListener = __webpack_require__(400);
var ExecutionEnvironment = __webpack_require__(32);
var PooledClass = __webpack_require__(92);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactUpdates = __webpack_require__(52);

var getEventTarget = __webpack_require__(238);
var getUnboundedScrollPosition = __webpack_require__(931);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(103);
var EventPluginHub = __webpack_require__(125);
var EventPluginUtils = __webpack_require__(236);
var ReactComponentEnvironment = __webpack_require__(245);
var ReactEmptyComponent = __webpack_require__(394);
var ReactBrowserEventEmitter = __webpack_require__(171);
var ReactHostComponent = __webpack_require__(395);
var ReactUpdates = __webpack_require__(52);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(8);

var CallbackQueue = __webpack_require__(383);
var PooledClass = __webpack_require__(92);
var ReactBrowserEventEmitter = __webpack_require__(171);
var ReactInputSelection = __webpack_require__(401);
var ReactInstrumentation = __webpack_require__(45);
var Transaction = __webpack_require__(167);
var ReactUpdateQueue = __webpack_require__(251);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(32);

var getNodeForCharacterOffset = __webpack_require__(935);
var getTextContentAccessor = __webpack_require__(382);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(937);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(938);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(124);
var ExecutionEnvironment = __webpack_require__(32);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactInputSelection = __webpack_require__(401);
var SyntheticEvent = __webpack_require__(66);

var getActiveElement = __webpack_require__(402);
var isTextInputElement = __webpack_require__(386);
var shallowEqual = __webpack_require__(248);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(12);

var EventListener = __webpack_require__(400);
var EventPropagators = __webpack_require__(124);
var ReactDOMComponentTree = __webpack_require__(21);
var SyntheticAnimationEvent = __webpack_require__(942);
var SyntheticClipboardEvent = __webpack_require__(943);
var SyntheticEvent = __webpack_require__(66);
var SyntheticFocusEvent = __webpack_require__(944);
var SyntheticKeyboardEvent = __webpack_require__(945);
var SyntheticMouseEvent = __webpack_require__(168);
var SyntheticDragEvent = __webpack_require__(947);
var SyntheticTouchEvent = __webpack_require__(948);
var SyntheticTransitionEvent = __webpack_require__(949);
var SyntheticUIEvent = __webpack_require__(126);
var SyntheticWheelEvent = __webpack_require__(950);

var emptyFunction = __webpack_require__(65);
var getEventCharCode = __webpack_require__(253);
var invariant = __webpack_require__(6);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(66);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(66);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(126);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(126);

var getEventCharCode = __webpack_require__(253);
var getEventKey = __webpack_require__(946);
var getEventModifierState = __webpack_require__(240);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var getEventCharCode = __webpack_require__(253);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(168);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(126);

var getEventModifierState = __webpack_require__(240);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(66);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(168);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(12);

var ReactCurrentOwner = __webpack_require__(62);
var ReactDOMComponentTree = __webpack_require__(21);
var ReactInstanceMap = __webpack_require__(127);

var getHostComponentFromComposite = __webpack_require__(407);
var invariant = __webpack_require__(6);
var warning = __webpack_require__(18);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactMount = __webpack_require__(403);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var React = __webpack_require__(1);

var cx = __webpack_require__(89);

/**
 * This component is responsible for rendering placeholder text for the
 * `DraftEditor` component.
 *
 * Override placeholder style via CSS.
 */
var DraftEditorPlaceholder = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorPlaceholder, _React$Component);

  function DraftEditorPlaceholder() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DraftEditorPlaceholder.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.text !== nextProps.text || this.props.editorState.getSelection().getHasFocus() !== nextProps.editorState.getSelection().getHasFocus();
  };

  _proto.render = function render() {
    var hasFocus = this.props.editorState.getSelection().getHasFocus();
    var className = cx({
      'public/DraftEditorPlaceholder/root': true,
      'public/DraftEditorPlaceholder/hasFocus': hasFocus
    });
    var contentStyle = {
      whiteSpace: 'pre-wrap'
    };
    return React.createElement("div", {
      className: className
    }, React.createElement("div", {
      className: cx('public/DraftEditorPlaceholder/inner'),
      id: this.props.accessibilityID,
      style: contentStyle
    }, this.props.text));
  };

  return DraftEditorPlaceholder;
}(React.Component);

module.exports = DraftEditorPlaceholder;

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ContentBlock = __webpack_require__(88);

var ContentBlockNode = __webpack_require__(44);

var DraftStringKey = __webpack_require__(409);

var encodeEntityRanges = __webpack_require__(958);

var encodeInlineStyleRanges = __webpack_require__(959);

var invariant = __webpack_require__(9);

var createRawBlock = function createRawBlock(block, entityStorageMap) {
  return {
    key: block.getKey(),
    text: block.getText(),
    type: block.getType(),
    depth: block.getDepth(),
    inlineStyleRanges: encodeInlineStyleRanges(block),
    entityRanges: encodeEntityRanges(block, entityStorageMap),
    data: block.getData().toObject()
  };
};

var insertRawBlock = function insertRawBlock(block, entityMap, rawBlocks, blockCacheRef) {
  if (block instanceof ContentBlock) {
    rawBlocks.push(createRawBlock(block, entityMap));
    return;
  }

  !(block instanceof ContentBlockNode) ?  false ? invariant(false, 'block is not a BlockNode') : invariant(false) : void 0;
  var parentKey = block.getParentKey();

  var rawBlock = blockCacheRef[block.getKey()] = _objectSpread({}, createRawBlock(block, entityMap), {
    children: []
  });

  if (parentKey) {
    blockCacheRef[parentKey].children.push(rawBlock);
    return;
  }

  rawBlocks.push(rawBlock);
};

var encodeRawBlocks = function encodeRawBlocks(contentState, rawState) {
  var entityMap = rawState.entityMap;
  var rawBlocks = [];
  var blockCacheRef = {};
  var entityCacheRef = {};
  var entityStorageKey = 0;
  contentState.getBlockMap().forEach(function (block) {
    block.findEntityRanges(function (character) {
      return character.getEntity() !== null;
    }, function (start) {
      var entityKey = block.getEntityAt(start); // Stringify to maintain order of otherwise numeric keys.

      var stringifiedEntityKey = DraftStringKey.stringify(entityKey); // This makes this function resilient to two entities
      // erroneously having the same key

      if (entityCacheRef[stringifiedEntityKey]) {
        return;
      }

      entityCacheRef[stringifiedEntityKey] = entityKey; // we need the `any` casting here since this is a temporary state
      // where we will later on flip the entity map and populate it with
      // real entity, at this stage we just need to map back the entity
      // key used by the BlockNode

      entityMap[stringifiedEntityKey] = "".concat(entityStorageKey);
      entityStorageKey++;
    });
    insertRawBlock(block, entityMap, rawBlocks, blockCacheRef);
  });
  return {
    blocks: rawBlocks,
    entityMap: entityMap
  };
}; // Flip storage map so that our storage keys map to global
// DraftEntity keys.


var encodeRawEntityMap = function encodeRawEntityMap(contentState, rawState) {
  var blocks = rawState.blocks,
      entityMap = rawState.entityMap;
  var rawEntityMap = {};
  Object.keys(entityMap).forEach(function (key, index) {
    var entity = contentState.getEntity(DraftStringKey.unstringify(key));
    rawEntityMap[index] = {
      type: entity.getType(),
      mutability: entity.getMutability(),
      data: entity.getData()
    };
  });
  return {
    blocks: blocks,
    entityMap: rawEntityMap
  };
};

var convertFromDraftStateToRaw = function convertFromDraftStateToRaw(contentState) {
  var rawDraftContentState = {
    entityMap: {},
    blocks: []
  }; // add blocks

  rawDraftContentState = encodeRawBlocks(contentState, rawDraftContentState); // add entities

  rawDraftContentState = encodeRawEntityMap(contentState, rawDraftContentState);
  return rawDraftContentState;
};

module.exports = convertFromDraftStateToRaw;

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftStringKey = __webpack_require__(409);

var UnicodeUtils = __webpack_require__(91);

var strlen = UnicodeUtils.strlen;
/**
 * Convert to UTF-8 character counts for storage.
 */

function encodeEntityRanges(block, storageMap) {
  var encoded = [];
  block.findEntityRanges(function (character) {
    return !!character.getEntity();
  }, function (
  /*number*/
  start,
  /*number*/
  end) {
    var text = block.getText();
    var key = block.getEntityAt(start);
    encoded.push({
      offset: strlen(text.slice(0, start)),
      length: strlen(text.slice(start, end)),
      // Encode the key as a number for range storage.
      key: Number(storageMap[DraftStringKey.stringify(key)])
    });
  });
  return encoded;
}

module.exports = encodeEntityRanges;

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var UnicodeUtils = __webpack_require__(91);

var findRangesImmutable = __webpack_require__(121);

var areEqual = function areEqual(a, b) {
  return a === b;
};

var isTruthy = function isTruthy(a) {
  return !!a;
};

var EMPTY_ARRAY = [];
/**
 * Helper function for getting encoded styles for each inline style. Convert
 * to UTF-8 character counts for storage.
 */

function getEncodedInlinesForType(block, styleList, styleToEncode) {
  var ranges = []; // Obtain an array with ranges for only the specified style.

  var filteredInlines = styleList.map(function (style) {
    return style.has(styleToEncode);
  }).toList();
  findRangesImmutable(filteredInlines, areEqual, // We only want to keep ranges with nonzero style values.
  isTruthy, function (start, end) {
    var text = block.getText();
    ranges.push({
      offset: UnicodeUtils.strlen(text.slice(0, start)),
      length: UnicodeUtils.strlen(text.slice(start, end)),
      style: styleToEncode
    });
  });
  return ranges;
}
/*
 * Retrieve the encoded arrays of inline styles, with each individual style
 * treated separately.
 */


function encodeInlineStyleRanges(block) {
  var styleList = block.getCharacterList().map(function (c) {
    return c.getStyle();
  }).toList();
  var ranges = styleList.flatten().toSet().map(function (style) {
    return getEncodedInlinesForType(block, styleList, style);
  });
  return Array.prototype.concat.apply(EMPTY_ARRAY, ranges.toJS());
}

module.exports = encodeInlineStyleRanges;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ContentBlock = __webpack_require__(88);

var ContentBlockNode = __webpack_require__(44);

var ContentState = __webpack_require__(225);

var DraftEntity = __webpack_require__(158);

var DraftTreeAdapter = __webpack_require__(961);

var DraftTreeInvariants = __webpack_require__(962);

var SelectionState = __webpack_require__(159);

var createCharacterList = __webpack_require__(963);

var decodeEntityRanges = __webpack_require__(964);

var decodeInlineStyleRanges = __webpack_require__(965);

var generateRandomKey = __webpack_require__(57);

var gkx = __webpack_require__(70);

var Immutable = __webpack_require__(4);

var invariant = __webpack_require__(9);

var experimentalTreeDataSupport = gkx('draft_tree_data_support');
var List = Immutable.List,
    Map = Immutable.Map,
    OrderedMap = Immutable.OrderedMap;

var decodeBlockNodeConfig = function decodeBlockNodeConfig(block, entityMap) {
  var key = block.key,
      type = block.type,
      data = block.data,
      text = block.text,
      depth = block.depth;
  var blockNodeConfig = {
    text: text,
    depth: depth || 0,
    type: type || 'unstyled',
    key: key || generateRandomKey(),
    data: Map(data),
    characterList: decodeCharacterList(block, entityMap)
  };
  return blockNodeConfig;
};

var decodeCharacterList = function decodeCharacterList(block, entityMap) {
  var text = block.text,
      rawEntityRanges = block.entityRanges,
      rawInlineStyleRanges = block.inlineStyleRanges;
  var entityRanges = rawEntityRanges || [];
  var inlineStyleRanges = rawInlineStyleRanges || []; // Translate entity range keys to the DraftEntity map.

  return createCharacterList(decodeInlineStyleRanges(text, inlineStyleRanges), decodeEntityRanges(text, entityRanges.filter(function (range) {
    return entityMap.hasOwnProperty(range.key);
  }).map(function (range) {
    return _objectSpread({}, range, {
      key: entityMap[range.key]
    });
  })));
};

var addKeyIfMissing = function addKeyIfMissing(block) {
  return _objectSpread({}, block, {
    key: block.key || generateRandomKey()
  });
};
/**
 * Node stack is responsible to ensure we traverse the tree only once
 * in depth order, while also providing parent refs to inner nodes to
 * construct their links.
 */


var updateNodeStack = function updateNodeStack(stack, nodes, parentRef) {
  var nodesWithParentRef = nodes.map(function (block) {
    return _objectSpread({}, block, {
      parentRef: parentRef
    });
  }); // since we pop nodes from the stack we need to insert them in reverse

  return stack.concat(nodesWithParentRef.reverse());
};
/**
 * This will build a tree draft content state by creating the node
 * reference links into a single tree walk. Each node has a link
 * reference to "parent", "children", "nextSibling" and "prevSibling"
 * blockMap will be created using depth ordering.
 */


var decodeContentBlockNodes = function decodeContentBlockNodes(blocks, entityMap) {
  return blocks // ensure children have valid keys to enable sibling links
  .map(addKeyIfMissing).reduce(function (blockMap, block, index) {
    !Array.isArray(block.children) ?  false ? invariant(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant(false) : void 0; // ensure children have valid keys to enable sibling links

    var children = block.children.map(addKeyIfMissing); // root level nodes

    var contentBlockNode = new ContentBlockNode(_objectSpread({}, decodeBlockNodeConfig(block, entityMap), {
      prevSibling: index === 0 ? null : blocks[index - 1].key,
      nextSibling: index === blocks.length - 1 ? null : blocks[index + 1].key,
      children: List(children.map(function (child) {
        return child.key;
      }))
    })); // push root node to blockMap

    blockMap = blockMap.set(contentBlockNode.getKey(), contentBlockNode); // this stack is used to ensure we visit all nodes respecting depth ordering

    var stack = updateNodeStack([], children, contentBlockNode); // start computing children nodes

    while (stack.length > 0) {
      // we pop from the stack and start processing this node
      var node = stack.pop(); // parentRef already points to a converted ContentBlockNode

      var parentRef = node.parentRef;
      var siblings = parentRef.getChildKeys();

      var _index = siblings.indexOf(node.key);

      var isValidBlock = Array.isArray(node.children);

      if (!isValidBlock) {
        !isValidBlock ?  false ? invariant(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant(false) : void 0;
        break;
      } // ensure children have valid keys to enable sibling links


      var _children = node.children.map(addKeyIfMissing);

      var _contentBlockNode = new ContentBlockNode(_objectSpread({}, decodeBlockNodeConfig(node, entityMap), {
        parent: parentRef.getKey(),
        children: List(_children.map(function (child) {
          return child.key;
        })),
        prevSibling: _index === 0 ? null : siblings.get(_index - 1),
        nextSibling: _index === siblings.size - 1 ? null : siblings.get(_index + 1)
      })); // push node to blockMap


      blockMap = blockMap.set(_contentBlockNode.getKey(), _contentBlockNode); // this stack is used to ensure we visit all nodes respecting depth ordering

      stack = updateNodeStack(stack, _children, _contentBlockNode);
    }

    return blockMap;
  }, OrderedMap());
};

var decodeContentBlocks = function decodeContentBlocks(blocks, entityMap) {
  return OrderedMap(blocks.map(function (block) {
    var contentBlock = new ContentBlock(decodeBlockNodeConfig(block, entityMap));
    return [contentBlock.getKey(), contentBlock];
  }));
};

var decodeRawBlocks = function decodeRawBlocks(rawState, entityMap) {
  var isTreeRawBlock = rawState.blocks.find(function (block) {
    return Array.isArray(block.children) && block.children.length > 0;
  });
  var rawBlocks = experimentalTreeDataSupport && !isTreeRawBlock ? DraftTreeAdapter.fromRawStateToRawTreeState(rawState).blocks : rawState.blocks;

  if (!experimentalTreeDataSupport) {
    return decodeContentBlocks(isTreeRawBlock ? DraftTreeAdapter.fromRawTreeStateToRawState(rawState).blocks : rawBlocks, entityMap);
  }

  var blockMap = decodeContentBlockNodes(rawBlocks, entityMap); // in dev mode, check that the tree invariants are met

  if (false) {
    !DraftTreeInvariants.isValidTree(blockMap) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Should be a valid tree') : invariant(false) : void 0;
  }

  return blockMap;
};

var decodeRawEntityMap = function decodeRawEntityMap(rawState) {
  var rawEntityMap = rawState.entityMap;
  var entityMap = {}; // TODO: Update this once we completely remove DraftEntity

  Object.keys(rawEntityMap).forEach(function (rawEntityKey) {
    var _rawEntityMap$rawEnti = rawEntityMap[rawEntityKey],
        type = _rawEntityMap$rawEnti.type,
        mutability = _rawEntityMap$rawEnti.mutability,
        data = _rawEntityMap$rawEnti.data; // get the key reference to created entity

    entityMap[rawEntityKey] = DraftEntity.__create(type, mutability, data || {});
  });
  return entityMap;
};

var convertFromRawToDraftState = function convertFromRawToDraftState(rawState) {
  !Array.isArray(rawState.blocks) ?  false ? invariant(false, 'invalid RawDraftContentState') : invariant(false) : void 0; // decode entities

  var entityMap = decodeRawEntityMap(rawState); // decode blockMap

  var blockMap = decodeRawBlocks(rawState, entityMap); // create initial selection

  var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());
  return new ContentState({
    blockMap: blockMap,
    entityMap: entityMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
};

module.exports = convertFromRawToDraftState;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */
var generateRandomKey = __webpack_require__(57);

var invariant = __webpack_require__(9);

var traverseInDepthOrder = function traverseInDepthOrder(blocks, fn) {
  var stack = [].concat(blocks).reverse();

  while (stack.length) {
    var _block = stack.pop();

    fn(_block);
    var children = _block.children;
    !Array.isArray(children) ?  false ? invariant(false, 'Invalid tree raw block') : invariant(false) : void 0;
    stack = stack.concat([].concat(children.reverse()));
  }
};

var isListBlock = function isListBlock(block) {
  if (!(block && block.type)) {
    return false;
  }

  var type = block.type;
  return type === 'unordered-list-item' || type === 'ordered-list-item';
};

var addDepthToChildren = function addDepthToChildren(block) {
  if (Array.isArray(block.children)) {
    block.children = block.children.map(function (child) {
      return child.type === block.type ? _objectSpread({}, child, {
        depth: (block.depth || 0) + 1
      }) : child;
    });
  }
};
/**
 * This adapter is intended to be be used as an adapter to draft tree data
 *
 * draft state <=====> draft tree state
 */


var DraftTreeAdapter = {
  /**
   * Converts from a tree raw state back to draft raw state
   */
  fromRawTreeStateToRawState: function fromRawTreeStateToRawState(draftTreeState) {
    var blocks = draftTreeState.blocks;
    var transformedBlocks = [];
    !Array.isArray(blocks) ?  false ? invariant(false, 'Invalid raw state') : invariant(false) : void 0;

    if (!Array.isArray(blocks) || !blocks.length) {
      return draftTreeState;
    }

    traverseInDepthOrder(blocks, function (block) {
      var newBlock = _objectSpread({}, block);

      if (isListBlock(block)) {
        newBlock.depth = newBlock.depth || 0;
        addDepthToChildren(block); // if it's a non-leaf node, we don't do anything else

        if (block.children != null && block.children.length > 0) {
          return;
        }
      }

      delete newBlock.children;
      transformedBlocks.push(newBlock);
    });
    draftTreeState.blocks = transformedBlocks;
    return _objectSpread({}, draftTreeState, {
      blocks: transformedBlocks
    });
  },

  /**
   * Converts from draft raw state to tree draft state
   */
  fromRawStateToRawTreeState: function fromRawStateToRawTreeState(draftState) {
    var transformedBlocks = [];
    var parentStack = [];
    draftState.blocks.forEach(function (block) {
      var isList = isListBlock(block);
      var depth = block.depth || 0;

      var treeBlock = _objectSpread({}, block, {
        children: []
      });

      if (!isList) {
        transformedBlocks.push(treeBlock);
        return;
      }

      var lastParent = parentStack[0]; // block is non-nested & there are no nested blocks, directly push block

      if (lastParent == null && depth === 0) {
        transformedBlocks.push(treeBlock); // block is first nested block or previous nested block is at a lower level
      } else if (lastParent == null || lastParent.depth < depth - 1) {
        // create new parent block
        var newParent = {
          key: generateRandomKey(),
          text: '',
          depth: depth - 1,
          type: block.type,
          children: [],
          entityRanges: [],
          inlineStyleRanges: []
        };
        parentStack.unshift(newParent);

        if (depth === 1) {
          // add as a root-level block
          transformedBlocks.push(newParent);
        } else if (lastParent != null) {
          // depth > 1 => also add as previous parent's child
          lastParent.children.push(newParent);
        }

        newParent.children.push(treeBlock);
      } else if (lastParent.depth === depth - 1) {
        // add as child of last parent
        lastParent.children.push(treeBlock);
      } else {
        // pop out parents at levels above this one from the parent stack
        while (lastParent != null && lastParent.depth >= depth) {
          parentStack.shift();
          lastParent = parentStack[0];
        }

        if (depth > 0) {
          lastParent.children.push(treeBlock);
        } else {
          transformedBlocks.push(treeBlock);
        }
      }
    });
    return _objectSpread({}, draftState, {
      blocks: transformedBlocks
    });
  }
};
module.exports = DraftTreeAdapter;

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */
var warning = __webpack_require__(233);

var DraftTreeInvariants = {
  /**
   * Check if the block is valid
   */
  isValidBlock: function isValidBlock(block, blockMap) {
    var key = block.getKey(); // is its parent's child

    var parentKey = block.getParentKey();

    if (parentKey != null) {
      var parent = blockMap.get(parentKey);

      if (!parent.getChildKeys().includes(key)) {
         false ? warning(true, 'Tree is missing parent -> child pointer on %s', key) : void 0;
        return false;
      }
    } // is its children's parent


    var children = block.getChildKeys().map(function (k) {
      return blockMap.get(k);
    });

    if (!children.every(function (c) {
      return c.getParentKey() === key;
    })) {
       false ? warning(true, 'Tree is missing child -> parent pointer on %s', key) : void 0;
      return false;
    } // is its previous sibling's next sibling


    var prevSiblingKey = block.getPrevSiblingKey();

    if (prevSiblingKey != null) {
      var prevSibling = blockMap.get(prevSiblingKey);

      if (prevSibling.getNextSiblingKey() !== key) {
         false ? warning(true, "Tree is missing nextSibling pointer on %s's prevSibling", key) : void 0;
        return false;
      }
    } // is its next sibling's previous sibling


    var nextSiblingKey = block.getNextSiblingKey();

    if (nextSiblingKey != null) {
      var nextSibling = blockMap.get(nextSiblingKey);

      if (nextSibling.getPrevSiblingKey() !== key) {
         false ? warning(true, "Tree is missing prevSibling pointer on %s's nextSibling", key) : void 0;
        return false;
      }
    } // no 2-node cycles


    if (nextSiblingKey !== null && prevSiblingKey !== null) {
      if (prevSiblingKey === nextSiblingKey) {
         false ? warning(true, 'Tree has a two-node cycle at %s', key) : void 0;
        return false;
      }
    } // if it's a leaf node, it has text but no children


    if (block.text != '') {
      if (block.getChildKeys().size > 0) {
         false ? warning(true, 'Leaf node %s has children', key) : void 0;
        return false;
      }
    }

    return true;
  },

  /**
   * Checks that this is a connected tree on all the blocks
   * starting from the first block, traversing nextSibling and child pointers
   * should be a tree (preorder traversal - parent, then children)
   * num of connected node === number of blocks
   */
  isConnectedTree: function isConnectedTree(blockMap) {
    // exactly one node has no previous sibling + no parent
    var eligibleFirstNodes = blockMap.toArray().filter(function (block) {
      return block.getParentKey() == null && block.getPrevSiblingKey() == null;
    });

    if (eligibleFirstNodes.length !== 1) {
       false ? warning(true, 'Tree is not connected. More or less than one first node') : void 0;
      return false;
    }

    var firstNode = eligibleFirstNodes.shift();
    var nodesSeen = 0;
    var currentKey = firstNode.getKey();
    var visitedStack = [];

    while (currentKey != null) {
      var currentNode = blockMap.get(currentKey);
      var childKeys = currentNode.getChildKeys();
      var nextSiblingKey = currentNode.getNextSiblingKey(); // if the node has children, add parent's next sibling to stack and go to children

      if (childKeys.size > 0) {
        if (nextSiblingKey != null) {
          visitedStack.unshift(nextSiblingKey);
        }

        var children = childKeys.map(function (k) {
          return blockMap.get(k);
        });

        var _firstNode = children.find(function (block) {
          return block.getPrevSiblingKey() == null;
        });

        if (_firstNode == null) {
           false ? warning(true, '%s has no first child', currentKey) : void 0;
          return false;
        }

        currentKey = _firstNode.getKey(); // TODO(T32490138): Deal with multi-node cycles here
      } else {
        if (currentNode.getNextSiblingKey() != null) {
          currentKey = currentNode.getNextSiblingKey();
        } else {
          currentKey = visitedStack.shift();
        }
      }

      nodesSeen++;
    }

    if (nodesSeen !== blockMap.size) {
       false ? warning(true, 'Tree is not connected. %s nodes were seen instead of %s', nodesSeen, blockMap.size) : void 0;
      return false;
    }

    return true;
  },

  /**
   * Checks that the block map is a connected tree with valid blocks
   */
  isValidTree: function isValidTree(blockMap) {
    var _this = this;

    var blocks = blockMap.toArray();

    if (!blocks.every(function (block) {
      return _this.isValidBlock(block, blockMap);
    })) {
      return false;
    }

    return this.isConnectedTree(blockMap);
  }
};
module.exports = DraftTreeInvariants;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var CharacterMetadata = __webpack_require__(43);

var Immutable = __webpack_require__(4);

var List = Immutable.List;

function createCharacterList(inlineStyles, entities) {
  var characterArray = inlineStyles.map(function (style, ii) {
    var entity = entities[ii];
    return CharacterMetadata.create({
      style: style,
      entity: entity
    });
  });
  return List(characterArray);
}

module.exports = createCharacterList;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var UnicodeUtils = __webpack_require__(91);

var substr = UnicodeUtils.substr;
/**
 * Convert to native JavaScript string lengths to determine ranges.
 */

function decodeEntityRanges(text, ranges) {
  var entities = Array(text.length).fill(null);

  if (ranges) {
    ranges.forEach(function (range) {
      // Using Unicode-enabled substrings converted to JavaScript lengths,
      // fill the output array with entity keys.
      var start = substr(text, 0, range.offset).length;
      var end = start + substr(text, range.offset, range.length).length;

      for (var ii = start; ii < end; ii++) {
        entities[ii] = range.key;
      }
    });
  }

  return entities;
}

module.exports = decodeEntityRanges;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var UnicodeUtils = __webpack_require__(91);

var _require = __webpack_require__(4),
    OrderedSet = _require.OrderedSet;

var substr = UnicodeUtils.substr;
var EMPTY_SET = OrderedSet();
/**
 * Convert to native JavaScript string lengths to determine ranges.
 */

function decodeInlineStyleRanges(text, ranges) {
  var styles = Array(text.length).fill(EMPTY_SET);

  if (ranges) {
    ranges.forEach(function (range) {
      var cursor = substr(text, 0, range.offset).length;
      var end = cursor + substr(text, range.offset, range.length).length;

      while (cursor < end) {
        styles[cursor] = styles[cursor].add(range.style);
        cursor++;
      }
    });
  }

  return styles;
}

module.exports = decodeInlineStyleRanges;

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var getRangeBoundingClientRect = __webpack_require__(967);
/**
 * Return the bounding ClientRect for the visible DOM selection, if any.
 * In cases where there are no selected ranges or the bounding rect is
 * temporarily invalid, return null.
 *
 * When using from an iframe, you should pass the iframe window object
 */


function getVisibleSelectionRect(global) {
  var selection = global.getSelection();

  if (!selection.rangeCount) {
    return null;
  }

  var range = selection.getRangeAt(0);
  var boundingRect = getRangeBoundingClientRect(range);
  var top = boundingRect.top,
      right = boundingRect.right,
      bottom = boundingRect.bottom,
      left = boundingRect.left; // When a re-render leads to a node being removed, the DOM selection will
  // temporarily be placed on an ancestor node, which leads to an invalid
  // bounding rect. Discard this state.

  if (top === 0 && right === 0 && bottom === 0 && left === 0) {
    return null;
  }

  return boundingRect;
}

module.exports = getVisibleSelectionRect;

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var getRangeClientRects = __webpack_require__(371);

/**
 * Like range.getBoundingClientRect() but normalizes for browser bugs.
 */
function getRangeBoundingClientRect(range) {
  // "Return a DOMRect object describing the smallest rectangle that includes
  // the first rectangle in list and all of the remaining rectangles of which
  // the height or width is not zero."
  // http://www.w3.org/TR/cssom-view/#dom-range-getboundingclientrect
  var rects = getRangeClientRects(range);
  var top = 0;
  var right = 0;
  var bottom = 0;
  var left = 0;

  if (rects.length) {
    // If the first rectangle has 0 width, we use the second, this is needed
    // because Chrome renders a 0 width rectangle when the selection contains
    // a line break.
    if (rects.length > 1 && rects[0].width === 0) {
      var _rects$ = rects[1];
      top = _rects$.top;
      right = _rects$.right;
      bottom = _rects$.bottom;
      left = _rects$.left;
    } else {
      var _rects$2 = rects[0];
      top = _rects$2.top;
      right = _rects$2.right;
      bottom = _rects$2.bottom;
      left = _rects$2.left;
    }

    for (var ii = 1; ii < rects.length; ii++) {
      var rect = rects[ii];

      if (rect.height !== 0 && rect.width !== 0) {
        top = Math.min(top, rect.top);
        right = Math.max(right, rect.right);
        bottom = Math.max(bottom, rect.bottom);
        left = Math.min(left, rect.left);
      }
    }
  }

  return {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: right - left,
    height: bottom - top
  };
}

module.exports = getRangeBoundingClientRect;

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeDecorators = exports.createEditorStateWithText = exports.default = undefined;

var _createEditorStateWithText = __webpack_require__(969);

var _createEditorStateWithText2 = _interopRequireDefault(_createEditorStateWithText);

var _composeDecorators = __webpack_require__(970);

var _composeDecorators2 = _interopRequireDefault(_composeDecorators);

var _Editor = __webpack_require__(971);

var _Editor2 = _interopRequireDefault(_Editor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Editor2.default;

// eslint-disable-next-line import/no-named-as-default

var createEditorStateWithText = exports.createEditorStateWithText = _createEditorStateWithText2.default;
var composeDecorators = exports.composeDecorators = _composeDecorators2.default;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _draftJs = __webpack_require__(38);

exports.default = function (text) {
  return _draftJs.EditorState.createWithContent(_draftJs.ContentState.createFromText(text));
}; /**
    * Create an editor state with some text in it already
    */

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// This code originally has been copied from Recompose
// https://github.com/acdlite/recompose/blob/master/src/packages/recompose/compose.js
exports.default = function () {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  var last = funcs[funcs.length - 1];
  return function () {
    var result = last.apply(undefined, arguments);
    for (var i = funcs.length - 2; i >= 0; i -= 1) {
      var f = funcs[i];
      result = f(result);
    }
    return result;
  };
};

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(24);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _draftJs = __webpack_require__(38);

var _immutable = __webpack_require__(4);

var _proxies = __webpack_require__(972);

var _proxies2 = _interopRequireDefault(_proxies);

var _moveSelectionToEnd = __webpack_require__(973);

var _moveSelectionToEnd2 = _interopRequireDefault(_moveSelectionToEnd);

var _resolveDecorators = __webpack_require__(974);

var _resolveDecorators2 = _interopRequireDefault(_resolveDecorators);

var _defaultKeyBindings = __webpack_require__(978);

var _defaultKeyBindings2 = _interopRequireDefault(_defaultKeyBindings);

var _defaultKeyCommands = __webpack_require__(979);

var _defaultKeyCommands2 = _interopRequireDefault(_defaultKeyCommands);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-continue,no-restricted-syntax */


var getDecoratorLength = function getDecoratorLength(obj) {
  var decorators = void 0;

  if (obj.decorators != null) {
    decorators = obj.decorators;
  } else if (obj._decorators != null) {
    decorators = obj._decorators;
  }

  return decorators.size != null ? decorators.size : decorators.length;
};

/**
 * The main editor component
 */

var PluginEditor = function (_Component) {
  _inherits(PluginEditor, _Component);

  function PluginEditor(props) {
    _classCallCheck(this, PluginEditor);

    var _this = _possibleConstructorReturn(this, (PluginEditor.__proto__ || Object.getPrototypeOf(PluginEditor)).call(this, props));

    _initialiseProps.call(_this);

    var plugins = [_this.props].concat(_toConsumableArray(_this.resolvePlugins()));
    plugins.forEach(function (plugin) {
      if (typeof plugin.initialize !== 'function') return;
      plugin.initialize(_this.getPluginMethods());
    });

    // attach proxy methods like `focus` or `blur`
    _proxies2.default.forEach(function (method) {
      _this[method] = function () {
        var _this$editor;

        return (_this$editor = _this.editor)[method].apply(_this$editor, arguments);
      };
    });

    _this.state = {}; // TODO for Nik: ask ben why this is relevent
    return _this;
  }

  _createClass(PluginEditor, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var decorator = (0, _resolveDecorators2.default)(this.props, this.getEditorState, this.onChange);

      var editorState = _draftJs.EditorState.set(this.props.editorState, { decorator: decorator });
      this.onChange((0, _moveSelectionToEnd2.default)(editorState));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(next) {
      var curr = this.props;
      var currDec = curr.editorState.getDecorator();
      var nextDec = next.editorState.getDecorator();

      // If there is not current decorator, there's nothing to carry over to the next editor state
      if (!currDec) return;
      // If the current decorator is the same as the new one, don't call onChange to avoid infinite loops
      if (currDec === nextDec) return;
      // If the old and the new decorator are the same, but no the same object, also don't call onChange to avoid infinite loops
      if (currDec && nextDec && getDecoratorLength(currDec) === getDecoratorLength(nextDec)) return;

      var editorState = _draftJs.EditorState.set(next.editorState, { decorator: currDec });
      this.onChange((0, _moveSelectionToEnd2.default)(editorState));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this2 = this;

      this.resolvePlugins().forEach(function (plugin) {
        if (plugin.willUnmount) {
          plugin.willUnmount({
            getEditorState: _this2.getEditorState,
            setEditorState: _this2.onChange
          });
        }
      });
    }

    // Cycle through the plugins, changing the editor state with what the plugins
    // changed (or didn't)


    // TODO further down in render we use readOnly={this.props.readOnly || this.state.readOnly}. Ask Ben why readOnly is here just from the props? Why would plugins use this instead of just taking it from getProps?

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var pluginHooks = this.createPluginHooks();
      var customStyleMap = this.resolveCustomStyleMap();
      var accessibilityProps = this.resolveAccessibilityProps();
      var blockRenderMap = this.resolveblockRenderMap();
      return _react2.default.createElement(_draftJs.Editor, _extends({}, this.props, accessibilityProps, pluginHooks, {
        readOnly: this.props.readOnly || this.state.readOnly,
        customStyleMap: customStyleMap,
        blockRenderMap: blockRenderMap,
        onChange: this.onChange,
        editorState: this.props.editorState,
        ref: function ref(element) {
          _this3.editor = element;
        }
      }));
    }
  }]);

  return PluginEditor;
}(_react.Component);

PluginEditor.propTypes = {
  editorState: _propTypes2.default.object.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  plugins: _propTypes2.default.array,
  defaultKeyBindings: _propTypes2.default.bool,
  defaultKeyCommands: _propTypes2.default.bool,
  defaultBlockRenderMap: _propTypes2.default.bool,
  customStyleMap: _propTypes2.default.object,
  // eslint-disable-next-line react/no-unused-prop-types
  decorators: _propTypes2.default.array
};
PluginEditor.defaultProps = {
  defaultBlockRenderMap: true,
  defaultKeyBindings: true,
  defaultKeyCommands: true,
  customStyleMap: {},
  plugins: [],
  decorators: []
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onChange = function (editorState) {
    var newEditorState = editorState;
    _this4.resolvePlugins().forEach(function (plugin) {
      if (plugin.onChange) {
        newEditorState = plugin.onChange(newEditorState, _this4.getPluginMethods());
      }
    });

    if (_this4.props.onChange) {
      _this4.props.onChange(newEditorState, _this4.getPluginMethods());
    }
  };

  this.getPlugins = function () {
    return _this4.props.plugins.slice(0);
  };

  this.getProps = function () {
    return _extends({}, _this4.props);
  };

  this.getReadOnly = function () {
    return _this4.props.readOnly;
  };

  this.setReadOnly = function (readOnly) {
    if (readOnly !== _this4.state.readOnly) _this4.setState({ readOnly: readOnly });
  };

  this.getEditorRef = function () {
    return _this4.editor;
  };

  this.getEditorState = function () {
    return _this4.props.editorState;
  };

  this.getPluginMethods = function () {
    return {
      getPlugins: _this4.getPlugins,
      getProps: _this4.getProps,
      setEditorState: _this4.onChange,
      getEditorState: _this4.getEditorState,
      getReadOnly: _this4.getReadOnly,
      setReadOnly: _this4.setReadOnly,
      getEditorRef: _this4.getEditorRef
    };
  };

  this.createEventHooks = function (methodName, plugins) {
    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var newArgs = [].slice.apply(args);
      newArgs.push(_this4.getPluginMethods());

      return plugins.some(function (plugin) {
        return typeof plugin[methodName] === 'function' && plugin[methodName].apply(plugin, _toConsumableArray(newArgs)) === true;
      });
    };
  };

  this.createHandleHooks = function (methodName, plugins) {
    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var newArgs = [].slice.apply(args);
      newArgs.push(_this4.getPluginMethods());

      return plugins.some(function (plugin) {
        return typeof plugin[methodName] === 'function' && plugin[methodName].apply(plugin, _toConsumableArray(newArgs)) === 'handled';
      }) ? 'handled' : 'not-handled';
    };
  };

  this.createFnHooks = function (methodName, plugins) {
    return function () {
      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      var newArgs = [].slice.apply(args);

      newArgs.push(_this4.getPluginMethods());

      if (methodName === 'blockRendererFn') {
        var block = { props: {} };
        plugins.forEach(function (plugin) {
          if (typeof plugin[methodName] !== 'function') return;
          var result = plugin[methodName].apply(plugin, _toConsumableArray(newArgs));
          if (result !== undefined && result !== null) {
            var pluginProps = result.props,
                pluginRest = _objectWithoutProperties(result, ['props']); // eslint-disable-line no-use-before-define


            var _block = block,
                props = _block.props,
                rest = _objectWithoutProperties(_block, ['props']); // eslint-disable-line no-use-before-define


            block = _extends({}, rest, pluginRest, { props: _extends({}, props, pluginProps) });
          }
        });

        return block.component ? block : false;
      } else if (methodName === 'blockStyleFn') {
        var styles = void 0;
        plugins.forEach(function (plugin) {
          if (typeof plugin[methodName] !== 'function') return;
          var result = plugin[methodName].apply(plugin, _toConsumableArray(newArgs));
          if (result !== undefined && result !== null) {
            styles = (styles ? styles + ' ' : '') + result;
          }
        });

        return styles || '';
      }

      var result = void 0;
      var wasHandled = plugins.some(function (plugin) {
        if (typeof plugin[methodName] !== 'function') return false;
        result = plugin[methodName].apply(plugin, _toConsumableArray(newArgs));
        return result !== undefined;
      });
      return wasHandled ? result : false;
    };
  };

  this.createPluginHooks = function () {
    var pluginHooks = {};
    var eventHookKeys = [];
    var handleHookKeys = [];
    var fnHookKeys = [];
    var plugins = [_this4.props].concat(_toConsumableArray(_this4.resolvePlugins()));

    plugins.forEach(function (plugin) {
      Object.keys(plugin).forEach(function (attrName) {
        if (attrName === 'onChange') return;

        // if `attrName` has been added as a hook key already, ignore this one
        if (eventHookKeys.indexOf(attrName) !== -1 || fnHookKeys.indexOf(attrName) !== -1) return;

        var isEventHookKey = attrName.indexOf('on') === 0;
        if (isEventHookKey) {
          eventHookKeys.push(attrName);
          return;
        }

        var isHandleHookKey = attrName.indexOf('handle') === 0;
        if (isHandleHookKey) {
          handleHookKeys.push(attrName);
          return;
        }

        // checks if `attrName` ends with 'Fn'
        var isFnHookKey = attrName.length - 2 === attrName.indexOf('Fn');
        if (isFnHookKey) {
          fnHookKeys.push(attrName);
        }
      });
    });

    eventHookKeys.forEach(function (attrName) {
      pluginHooks[attrName] = _this4.createEventHooks(attrName, plugins);
    });

    handleHookKeys.forEach(function (attrName) {
      pluginHooks[attrName] = _this4.createHandleHooks(attrName, plugins);
    });

    fnHookKeys.forEach(function (attrName) {
      pluginHooks[attrName] = _this4.createFnHooks(attrName, plugins);
    });

    return pluginHooks;
  };

  this.resolvePlugins = function () {
    var plugins = _this4.props.plugins.slice(0);
    if (_this4.props.defaultKeyBindings === true) {
      plugins.push(_defaultKeyBindings2.default);
    }
    if (_this4.props.defaultKeyCommands === true) {
      plugins.push(_defaultKeyCommands2.default);
    }

    return plugins;
  };

  this.resolveCustomStyleMap = function () {
    return _this4.props.plugins.filter(function (plug) {
      return plug.customStyleMap !== undefined;
    }).map(function (plug) {
      return plug.customStyleMap;
    }).concat([_this4.props.customStyleMap]).reduce(function (styles, style) {
      return _extends({}, styles, style);
    }, {});
  };

  this.resolveblockRenderMap = function () {
    var blockRenderMap = _this4.props.plugins.filter(function (plug) {
      return plug.blockRenderMap !== undefined;
    }).reduce(function (maps, plug) {
      return maps.merge(plug.blockRenderMap);
    }, (0, _immutable.Map)({}));
    if (_this4.props.defaultBlockRenderMap) {
      blockRenderMap = _draftJs.DefaultDraftBlockRenderMap.merge(blockRenderMap);
    }
    if (_this4.props.blockRenderMap) {
      blockRenderMap = blockRenderMap.merge(_this4.props.blockRenderMap);
    }
    return blockRenderMap;
  };

  this.resolveAccessibilityProps = function () {
    var accessibilityProps = {};
    var plugins = [_this4.props].concat(_toConsumableArray(_this4.resolvePlugins()));
    plugins.forEach(function (plugin) {
      if (typeof plugin.getAccessibilityProps !== 'function') return;
      var props = plugin.getAccessibilityProps();
      var popupProps = {};

      if (accessibilityProps.ariaHasPopup === undefined) {
        popupProps.ariaHasPopup = props.ariaHasPopup;
      } else if (props.ariaHasPopup === 'true') {
        popupProps.ariaHasPopup = 'true';
      }

      if (accessibilityProps.ariaExpanded === undefined) {
        popupProps.ariaExpanded = props.ariaExpanded;
      } else if (props.ariaExpanded === true) {
        popupProps.ariaExpanded = true;
      }

      accessibilityProps = _extends({}, accessibilityProps, props, popupProps);
    });

    return accessibilityProps;
  };
};

exports.default = PluginEditor;

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// the list of available proxies can be found here: https://github.com/facebook/draft-js/blob/master/src/component/base/DraftEditor.react.js#L120
var proxies = ['focus', 'blur', 'setMode', 'exitCurrentMode', 'restoreEditorDOM', 'setRenderGuard', 'removeRenderGuard', 'setClipboard', 'getClipboard', 'getEditorKey', 'update', 'onDragEnter', 'onDragLeave'];

exports.default = proxies;

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _draftJs = __webpack_require__(38);

/**
 * Returns a new EditorState where the Selection is at the end.
 *
 * This ensures to mimic the textarea behaviour where the Selection is placed at
 * the end. This is needed when blocks (like stickers or other media) are added
 * without the editor having had focus yet. It still works to place the
 * Selection at a specific location by clicking on the text.
 */
var moveSelectionToEnd = function moveSelectionToEnd(editorState) {
  var content = editorState.getCurrentContent();
  var blockMap = content.getBlockMap();

  var key = blockMap.last().getKey();
  var length = blockMap.last().getLength();

  var selection = new _draftJs.SelectionState({
    anchorKey: key,
    anchorOffset: length,
    focusKey: key,
    focusOffset: length
  });

  return _draftJs.EditorState.acceptSelection(editorState, selection);
};

exports.default = moveSelectionToEnd;

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(4);

var _createCompositeDecorator = __webpack_require__(975);

var _createCompositeDecorator2 = _interopRequireDefault(_createCompositeDecorator);

var _MultiDecorator = __webpack_require__(977);

var _MultiDecorator2 = _interopRequireDefault(_MultiDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Return true if decorator implements the DraftDecoratorType interface
// @see https://github.com/facebook/draft-js/blob/master/src/model/decorators/DraftDecoratorType.js
var decoratorIsCustom = function decoratorIsCustom(decorator) {
  return typeof decorator.getDecorations === 'function' && typeof decorator.getComponentForKey === 'function' && typeof decorator.getPropsForKey === 'function';
};

var getDecoratorsFromProps = function getDecoratorsFromProps(_ref) {
  var decorators = _ref.decorators,
      plugins = _ref.plugins;
  return (0, _immutable.List)([{ decorators: decorators }].concat(_toConsumableArray(plugins))).filter(function (plugin) {
    return plugin.decorators !== undefined;
  }).flatMap(function (plugin) {
    return plugin.decorators;
  });
};

var resolveDecorators = function resolveDecorators(props, getEditorState, onChange) {
  var decorators = getDecoratorsFromProps(props);
  var compositeDecorator = (0, _createCompositeDecorator2.default)(decorators.filter(function (decorator) {
    return !decoratorIsCustom(decorator);
  }), getEditorState, onChange);

  var customDecorators = decorators.filter(function (decorator) {
    return decoratorIsCustom(decorator);
  });

  return new _MultiDecorator2.default(customDecorators.push(compositeDecorator));
};

exports.default = resolveDecorators;

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * Creates a composite decorator based on the provided plugins
                                                                                                                                                                                                                                                                   */

var _immutable = __webpack_require__(4);

var _draftJs = __webpack_require__(38);

var _decorateComponentWithProps = __webpack_require__(976);

var _decorateComponentWithProps2 = _interopRequireDefault(_decorateComponentWithProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (decorators, getEditorState, setEditorState) {
  var convertedDecorators = (0, _immutable.List)(decorators).map(function (decorator) {
    return _extends({}, decorator, {
      component: (0, _decorateComponentWithProps2.default)(decorator.component, { getEditorState: getEditorState, setEditorState: setEditorState })
    });
  }).toJS();

  return new _draftJs.CompositeDecorator(convertedDecorators);
};

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

/* eslint-disable space-before-keywords */

exports.default = function (EmbeddedComponent, props) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      _classCallCheck(this, _class);

      return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
    }

    _createClass(_class, [{
      key: 'render',
      value: function render() {
        return _react2.default.createElement(EmbeddedComponent, _extends({}, this.props, props));
      }
    }]);

    return _class;
  }(_react.Component), _class.displayName = 'Decorated(' + getDisplayName(EmbeddedComponent) + ')', _temp;
};

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _immutable = __webpack_require__(4);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KEY_SEPARATOR = '-';

var MultiDecorator = function () {
  function MultiDecorator(decorators) {
    _classCallCheck(this, MultiDecorator);

    this.decorators = _immutable2.default.List(decorators);
  }

  /**
   * Return list of decoration IDs per character
   *
   * @param {ContentBlock} block
   * @return {List<String>}
   */


  _createClass(MultiDecorator, [{
    key: 'getDecorations',
    value: function getDecorations(block, contentState) {
      var decorations = new Array(block.getText().length).fill(null);

      this.decorators.forEach(function (decorator, i) {
        var subDecorations = decorator.getDecorations(block, contentState);

        subDecorations.forEach(function (key, offset) {
          if (!key) {
            return;
          }

          decorations[offset] = i + KEY_SEPARATOR + key;
        });
      });

      return _immutable2.default.List(decorations);
    }

    /**
     * Return component to render a decoration
     *
     * @param {String} key
     * @return {Function}
     */

  }, {
    key: 'getComponentForKey',
    value: function getComponentForKey(key) {
      var decorator = this.getDecoratorForKey(key);
      return decorator.getComponentForKey(MultiDecorator.getInnerKey(key));
    }

    /**
     * Return props to render a decoration
     *
     * @param {String} key
     * @return {Object}
     */

  }, {
    key: 'getPropsForKey',
    value: function getPropsForKey(key) {
      var decorator = this.getDecoratorForKey(key);
      return decorator.getPropsForKey(MultiDecorator.getInnerKey(key));
    }

    /**
     * Return a decorator for a specific key
     *
     * @param {String} key
     * @return {Decorator}
     */

  }, {
    key: 'getDecoratorForKey',
    value: function getDecoratorForKey(key) {
      var parts = key.split(KEY_SEPARATOR);
      var index = Number(parts[0]);

      return this.decorators.get(index);
    }

    /**
     * Return inner key for a decorator
     *
     * @param {String} key
     * @return {String}
     */

  }], [{
    key: 'getInnerKey',
    value: function getInnerKey(key) {
      var parts = key.split(KEY_SEPARATOR);
      return parts.slice(1).join(KEY_SEPARATOR);
    }
  }]);

  return MultiDecorator;
}();

module.exports = MultiDecorator;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _draftJs = __webpack_require__(38);

exports.default = {
  keyBindingFn: function keyBindingFn(event) {
    return (0, _draftJs.getDefaultKeyBinding)(event);
  }
};

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _draftJs = __webpack_require__(38);

exports.default = {
  // handle delete commands
  handleKeyCommand: function handleKeyCommand(command, editorState, _ref) {
    var setEditorState = _ref.setEditorState;

    var newState = void 0;
    switch (command) {
      case 'backspace':
      case 'backspace-word':
      case 'backspace-to-start-of-line':
        newState = _draftJs.RichUtils.onBackspace(editorState);
        break;
      case 'delete':
      case 'delete-word':
      case 'delete-to-end-of-block':
        newState = _draftJs.RichUtils.onDelete(editorState);
        break;
      default:
        return 'not-handled';
    }

    if (newState != null) {
      setEditorState(newState);
      return 'handled';
    }

    return 'not-handled';
  }
};

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Separator = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _createStore = __webpack_require__(981);

var _createStore2 = _interopRequireDefault(_createStore);

var _Toolbar = __webpack_require__(982);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

var _Separator = __webpack_require__(1000);

var _Separator2 = _interopRequireDefault(_Separator);

var _buttonStyles = {
  "buttonWrapper": "draftJsToolbar__buttonWrapper__1Dmqh",
  "button": "draftJsToolbar__button__qi1gf",
  "active": "draftJsToolbar__active__3qcpF"
};

var _buttonStyles2 = _interopRequireDefault(_buttonStyles);

var _toolbarStyles = {
  "toolbar": "draftJsToolbar__toolbar__dNtBH"
};

var _toolbarStyles2 = _interopRequireDefault(_toolbarStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var defaultTheme = { buttonStyles: _buttonStyles2.default, toolbarStyles: _toolbarStyles2.default };

  var store = (0, _createStore2.default)({
    isVisible: false
  });

  var _config$theme = config.theme,
      theme = _config$theme === undefined ? defaultTheme : _config$theme;


  var InlineToolbar = function InlineToolbar(props) {
    return _react2.default.createElement(_Toolbar2.default, _extends({}, props, { store: store, theme: theme }));
  };

  return {
    initialize: function initialize(_ref) {
      var getEditorState = _ref.getEditorState,
          setEditorState = _ref.setEditorState,
          getEditorRef = _ref.getEditorRef;

      store.updateItem('getEditorState', getEditorState);
      store.updateItem('setEditorState', setEditorState);
      store.updateItem('getEditorRef', getEditorRef);
    },
    // Re-Render the text-toolbar on selection change
    onChange: function onChange(editorState) {
      store.updateItem('selection', editorState.getSelection());
      return editorState;
    },
    InlineToolbar: InlineToolbar
  };
};

exports.Separator = _Separator2.default;

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createStore = function createStore(initialState) {
  var state = initialState || {};
  var listeners = {};

  var subscribeToItem = function subscribeToItem(key, callback) {
    listeners[key] = listeners[key] || [];
    listeners[key].push(callback);
  };

  var unsubscribeFromItem = function unsubscribeFromItem(key, callback) {
    listeners[key] = listeners[key].filter(function (listener) {
      return listener !== callback;
    });
  };

  var updateItem = function updateItem(key, item) {
    state = _extends({}, state, _defineProperty({}, key, item));
    if (listeners[key]) {
      listeners[key].forEach(function (listener) {
        return listener(state[key]);
      });
    }
  };

  var getItem = function getItem(key) {
    return state[key];
  };

  return {
    subscribeToItem: subscribeToItem,
    unsubscribeFromItem: unsubscribeFromItem,
    updateItem: updateItem,
    getItem: getItem
  };
};

exports.default = createStore;

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _draftJs = __webpack_require__(38);

var _draftJsButtons = __webpack_require__(410);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-array-index-key */


var Toolbar = function (_React$Component) {
  _inherits(Toolbar, _React$Component);

  function Toolbar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Toolbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isVisible: false,
      position: undefined,

      /**
       * If this is set, the toolbar will render this instead of the children
       * prop and will also be shown when the editor loses focus.
       * @type {Component}
       */
      overrideContent: undefined
    }, _this.onOverrideContent = function (overrideContent) {
      _this.setState({ overrideContent: overrideContent });
    }, _this.onSelectionChanged = function () {
      // need to wait a tick for window.getSelection() to be accurate
      // when focusing editor with already present selection
      setTimeout(function () {
        if (!_this.toolbar) return;

        // The editor root should be two levels above the node from
        // `getEditorRef`. In case this changes in the future, we
        // attempt to find the node dynamically by traversing upwards.
        var editorRef = _this.props.store.getItem('getEditorRef')();
        if (!editorRef) return;

        // This keeps backwards compatibility with React 15
        var editorRoot = editorRef.refs && editorRef.refs.editor ? editorRef.refs.editor : editorRef.editor;
        while (editorRoot.className.indexOf('DraftEditor-root') === -1) {
          editorRoot = editorRoot.parentNode;
        }
        var editorRootRect = editorRoot.getBoundingClientRect();

        var selectionRect = (0, _draftJs.getVisibleSelectionRect)(window);
        if (!selectionRect) return;

        // The toolbar shouldn't be positioned directly on top of the selected text,
        // but rather with a small offset so the caret doesn't overlap with the text.
        var extraTopOffset = -5;

        var position = {
          top: editorRoot.offsetTop - _this.toolbar.offsetHeight + (selectionRect.top - editorRootRect.top) + extraTopOffset,
          left: editorRoot.offsetLeft + (selectionRect.left - editorRootRect.left) + selectionRect.width / 2
        };
        _this.setState({ position: position });
      });
    }, _this.handleToolbarRef = function (node) {
      _this.toolbar = node;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Toolbar, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.store.subscribeToItem('selection', this.onSelectionChanged);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.store.unsubscribeFromItem('selection', this.onSelectionChanged);
    }

    /**
     * This can be called by a child in order to render custom content instead
     * of the children prop. It's the responsibility of the callee to call
     * this function again with `undefined` in order to reset `overrideContent`.
     * @param {Component} overrideContent
     */

  }, {
    key: 'getStyle',
    value: function getStyle() {
      var store = this.props.store;
      var _state = this.state,
          overrideContent = _state.overrideContent,
          position = _state.position;

      var selection = store.getItem('getEditorState')().getSelection();
      // overrideContent could for example contain a text input, hence we always show overrideContent
      // TODO: Test readonly mode and possibly set isVisible to false if the editor is readonly
      var isVisible = !selection.isCollapsed() && selection.getHasFocus() || overrideContent;
      var style = _extends({}, position);

      if (isVisible) {
        style.visibility = 'visible';
        style.transform = 'translate(-50%) scale(1)';
        style.transition = 'transform 0.15s cubic-bezier(.3,1.2,.2,1)';
      } else {
        style.transform = 'translate(-50%) scale(0)';
        style.visibility = 'hidden';
      }

      return style;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          theme = _props.theme,
          store = _props.store;
      var OverrideContent = this.state.overrideContent;

      var childrenProps = {
        theme: theme.buttonStyles,
        getEditorState: store.getItem('getEditorState'),
        setEditorState: store.getItem('setEditorState'),
        onOverrideContent: this.onOverrideContent
      };

      return _react2.default.createElement(
        'div',
        {
          className: theme.toolbarStyles.toolbar,
          style: this.getStyle(),
          ref: this.handleToolbarRef
        },
        OverrideContent ? _react2.default.createElement(OverrideContent, childrenProps) : this.props.children(childrenProps)
      );
    }
  }]);

  return Toolbar;
}(_react2.default.Component);

Toolbar.defaultProps = {
  children: function children(externalProps) {
    return (
      // may be use React.Fragment instead of div to improve perfomance after React 16
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_draftJsButtons.ItalicButton, externalProps),
        _react2.default.createElement(_draftJsButtons.BoldButton, externalProps),
        _react2.default.createElement(_draftJsButtons.UnderlineButton, externalProps),
        _react2.default.createElement(_draftJsButtons.CodeButton, externalProps)
      )
    );
  }
};
exports.default = Toolbar;

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _createInlineStyleButton = __webpack_require__(94);

var _createInlineStyleButton2 = _interopRequireDefault(_createInlineStyleButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createInlineStyleButton2.default)({
  style: 'ITALIC',
  children: _react2.default.createElement(
    'svg',
    { height: '24', viewBox: '0 0 24 24', width: '24', xmlns: 'http://www.w3.org/2000/svg' },
    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
    _react2.default.createElement('path', { d: 'M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z' })
  )
});

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _createInlineStyleButton = __webpack_require__(94);

var _createInlineStyleButton2 = _interopRequireDefault(_createInlineStyleButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createInlineStyleButton2.default)({
  style: 'BOLD',
  children: _react2.default.createElement(
    'svg',
    { height: '24', viewBox: '0 0 24 24', width: '24', xmlns: 'http://www.w3.org/2000/svg' },
    _react2.default.createElement('path', { d: 'M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z' }),
    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
  )
});

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _createInlineStyleButton = __webpack_require__(94);

var _createInlineStyleButton2 = _interopRequireDefault(_createInlineStyleButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createInlineStyleButton2.default)({
  style: 'CODE',
  children: _react2.default.createElement(
    'svg',
    { height: '24', viewBox: '0 0 24 24', width: '24', xmlns: 'http://www.w3.org/2000/svg' },
    _react2.default.createElement('path', { d: 'M0 0h24v24H0V0z', fill: 'none' }),
    _react2.default.createElement('path', { d: 'M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z' })
  )
});

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _createInlineStyleButton = __webpack_require__(94);

var _createInlineStyleButton2 = _interopRequireDefault(_createInlineStyleButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createInlineStyleButton2.default)({
  style: 'UNDERLINE',
  children: _react2.default.createElement(
    'svg',
    { height: '24', viewBox: '0 0 24 24', width: '24', xmlns: 'http://www.w3.org/2000/svg' },
    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
    _react2.default.createElement('path', { d: 'M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z' })
  )
});

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createBlockStyleButton = __webpack_require__(71);

var _createBlockStyleButton2 = _interopRequireDefault(_createBlockStyleButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createBlockStyleButton2.default)({
  blockType: 'header-one',
  children: 'H1'
});

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createBlockStyleButton = __webpack_require__(71);

var _createBlockStyleButton2 = _interopRequireDefault(_createBlockStyleButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createBlockStyleButton2.default)({
  blockType: 'header-two',
  children: 'H2'
});

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createBlockStyleButton = __webpack_require__(71);

var _createBlockStyleButton2 = _interopRequireDefault(_createBlockStyleButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createBlockStyleButton2.default)({
  blockType: 'header-three',
  children: 'H3'
});

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _createBlockStyleButton = __webpack_require__(71);

var _createBlockStyleButton2 = _interopRequireDefault(_createBlockStyleButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createBlockStyleButton2.default)({
  blockType: 'unordered-list-item',
  children: _react2.default.createElement(
    'svg',
    { height: '24', viewBox: '0 0 24 24', width: '24', xmlns: 'http://www.w3.org/2000/svg' },
    _react2.default.createElement('path', { d: 'M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z' }),
    _react2.default.createElement('path', { d: 'M0 0h24v24H0V0z', fill: 'none' })
  )
});

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _createBlockStyleButton = __webpack_require__(71);

var _createBlockStyleButton2 = _interopRequireDefault(_createBlockStyleButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createBlockStyleButton2.default)({
  blockType: 'ordered-list-item',
  children: _react2.default.createElement(
    'svg',
    { height: '24', viewBox: '0 0 24 24', width: '24', xmlns: 'http://www.w3.org/2000/svg' },
    _react2.default.createElement('path', { d: 'M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z' }),
    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
  )
});

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _createBlockStyleButton = __webpack_require__(71);

var _createBlockStyleButton2 = _interopRequireDefault(_createBlockStyleButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createBlockStyleButton2.default)({
  blockType: 'blockquote',
  children: _react2.default.createElement(
    'svg',
    { height: '24', viewBox: '0 0 24 24', width: '24', xmlns: 'http://www.w3.org/2000/svg' },
    _react2.default.createElement('path', { d: 'M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z' }),
    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
  )
});

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _createBlockStyleButton = __webpack_require__(71);

var _createBlockStyleButton2 = _interopRequireDefault(_createBlockStyleButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createBlockStyleButton2.default)({
  blockType: 'code-block',
  children: _react2.default.createElement(
    'svg',
    { height: '24', viewBox: '0 0 24 24', width: '24', xmlns: 'http://www.w3.org/2000/svg' },
    _react2.default.createElement('path', { d: 'M0 0h24v24H0V0z', fill: 'none' }),
    _react2.default.createElement('path', { d: 'M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z' })
  )
});

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _createBlockAlignmentButton = __webpack_require__(172);

var _createBlockAlignmentButton2 = _interopRequireDefault(_createBlockAlignmentButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createBlockAlignmentButton2.default)({
  alignment: 'default',
  children: _react2.default.createElement(
    'svg',
    { height: '24', viewBox: '0 0 24 24', width: '24', xmlns: 'http://www.w3.org/2000/svg' },
    _react2.default.createElement('path', { d: 'M3,21 L21,21 L21,19 L3,19 L3,21 Z M3,3 L3,5 L21,5 L21,3 L3,3 Z M3,7 L3,17 L17,17 L17,7 L3,7 Z' }),
    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
  )
});

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _createBlockAlignmentButton = __webpack_require__(172);

var _createBlockAlignmentButton2 = _interopRequireDefault(_createBlockAlignmentButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createBlockAlignmentButton2.default)({
  alignment: 'center',
  children: _react2.default.createElement(
    'svg',
    { height: '24', viewBox: '0 0 24 24', width: '24', xmlns: 'http://www.w3.org/2000/svg' },
    _react2.default.createElement('path', { d: 'M3,21 L21,21 L21,19 L3,19 L3,21 Z M3,3 L3,5 L21,5 L21,3 L3,3 Z M5,7 L5,17 L19,17 L19,7 L5,7 Z' }),
    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
  )
});

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _createBlockAlignmentButton = __webpack_require__(172);

var _createBlockAlignmentButton2 = _interopRequireDefault(_createBlockAlignmentButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createBlockAlignmentButton2.default)({
  alignment: 'left',
  children: _react2.default.createElement(
    'svg',
    { height: '24', viewBox: '0 0 24 24', width: '24', xmlns: 'http://www.w3.org/2000/svg' },
    _react2.default.createElement('path', { d: 'M21,15 L15,15 L15,17 L21,17 L21,15 Z M21,7 L15,7 L15,9 L21,9 L21,7 Z M15,13 L21,13 L21,11 L15,11 L15,13 Z M3,21 L21,21 L21,19 L3,19 L3,21 Z M3,3 L3,5 L21,5 L21,3 L3,3 Z M3,7 L3,17 L13,17 L13,7 L3,7 Z' }),
    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
  )
});

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _createBlockAlignmentButton = __webpack_require__(172);

var _createBlockAlignmentButton2 = _interopRequireDefault(_createBlockAlignmentButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createBlockAlignmentButton2.default)({
  alignment: 'right',
  children: _react2.default.createElement(
    'svg',
    { height: '24', viewBox: '0 0 24 24', width: '24', xmlns: 'http://www.w3.org/2000/svg' },
    _react2.default.createElement('path', { d: 'M9,15 L3,15 L3,17 L9,17 L9,15 Z M9,7 L3,7 L3,9 L9,9 L9,7 Z M3,13 L9,13 L9,11 L3,11 L3,13 Z M3,21 L21,21 L21,19 L3,19 L3,21 Z M3,3 L3,5 L21,5 L21,3 L3,3 Z M11,7 L11,17 L21,17 L21,7 L11,7 Z' }),
    _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
  )
});

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _createInlineStyleButton = __webpack_require__(94);

var _createInlineStyleButton2 = _interopRequireDefault(_createInlineStyleButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createInlineStyleButton2.default)({
  style: 'SUBSCRIPT',
  children: _react2.default.createElement(
    'div',
    null,
    'x',
    _react2.default.createElement(
      'sub',
      null,
      '2'
    )
  )
});

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _createInlineStyleButton = __webpack_require__(94);

var _createInlineStyleButton2 = _interopRequireDefault(_createInlineStyleButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createInlineStyleButton2.default)({
  style: 'SUPERSCRIPT',
  children: _react2.default.createElement(
    'div',
    null,
    'x',
    _react2.default.createElement(
      'sup',
      null,
      '2'
    )
  )
});

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _separatorStyles = {
  "separator": "draftJsToolbar__separator__3U7qt"
};

var _separatorStyles2 = _interopRequireDefault(_separatorStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? _separatorStyles2.default.separator : _ref$className;
  return _react2.default.createElement('div', { className: className });
};

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _draftJsPluginsUtils = __webpack_require__(254);

var _draftJsPluginsUtils2 = _interopRequireDefault(_draftJsPluginsUtils);

var _Link = __webpack_require__(1002);

var _Link2 = _interopRequireDefault(_Link);

var _LinkButton = __webpack_require__(1003);

var _LinkButton2 = _interopRequireDefault(_LinkButton);

var _linkStrategy = __webpack_require__(1010);

var _linkStrategy2 = _interopRequireDefault(_linkStrategy);

var _linkStyles = {
  "input": "draftJsMentionPlugin__input__1Wxng",
  "inputInvalid": "draftJsMentionPlugin__inputInvalid__X9hHv",
  "link": "draftJsMentionPlugin__link__TQHAX"
};

var _linkStyles2 = _interopRequireDefault(_linkStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var defaultTheme = _linkStyles2.default;

  var _config$theme = config.theme,
      theme = _config$theme === undefined ? defaultTheme : _config$theme,
      placeholder = config.placeholder,
      Link = config.Link,
      linkTarget = config.linkTarget;


  var store = {
    getEditorState: undefined,
    setEditorState: undefined
  };

  var DecoratedDefaultLink = function DecoratedDefaultLink(props) {
    return _react2.default.createElement(_Link2.default, _extends({}, props, { className: theme.link, target: linkTarget }));
  };

  var DecoratedLinkButton = function DecoratedLinkButton(props) {
    return _react2.default.createElement(_LinkButton2.default, _extends({}, props, {
      ownTheme: theme,
      store: store,
      placeholder: placeholder,
      onRemoveLinkAtSelection: function onRemoveLinkAtSelection() {
        return store.setEditorState(_draftJsPluginsUtils2.default.removeLinkAtSelection(store.getEditorState()));
      }
    }));
  };

  return {
    initialize: function initialize(_ref) {
      var getEditorState = _ref.getEditorState,
          setEditorState = _ref.setEditorState;

      store.getEditorState = getEditorState;
      store.setEditorState = setEditorState;
    },

    decorators: [{
      strategy: _linkStrategy2.default,
      matchesEntityType: _linkStrategy.matchesEntityType,
      component: Link || DecoratedDefaultLink
    }],

    LinkButton: DecoratedLinkButton
  };
};

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(24);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node.isRequired,
  entityKey: _propTypes2.default.string,
  getEditorState: _propTypes2.default.func.isRequired
};

var Link = function Link(_ref) {
  var children = _ref.children,
      className = _ref.className,
      entityKey = _ref.entityKey,
      getEditorState = _ref.getEditorState,
      target = _ref.target;

  var entity = getEditorState().getCurrentContent().getEntity(entityKey);
  var entityData = entity ? entity.get('data') : undefined;
  var href = entityData && entityData.url || undefined;

  return _react2.default.createElement(
    'a',
    {
      className: className,
      title: href,
      href: href,
      target: target,
      rel: 'noopener noreferrer'
    },
    children
  );
};

Link.propTypes = propTypes;
exports.default = Link;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(24);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clsx = __webpack_require__(128);

var _clsx2 = _interopRequireDefault(_clsx);

var _draftJsPluginsUtils = __webpack_require__(254);

var _draftJsPluginsUtils2 = _interopRequireDefault(_draftJsPluginsUtils);

var _AddLinkForm = __webpack_require__(1004);

var _AddLinkForm2 = _interopRequireDefault(_AddLinkForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkButton = function (_Component) {
  _inherits(LinkButton, _Component);

  function LinkButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LinkButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LinkButton.__proto__ || Object.getPrototypeOf(LinkButton)).call.apply(_ref, [this].concat(args))), _this), _this.onMouseDown = function (event) {
      event.preventDefault();
    }, _this.onAddLinkClick = function (e) {
      e.preventDefault();
      e.stopPropagation();
      var _this$props = _this.props,
          ownTheme = _this$props.ownTheme,
          placeholder = _this$props.placeholder,
          onOverrideContent = _this$props.onOverrideContent;

      var content = function content(props) {
        return _react2.default.createElement(_AddLinkForm2.default, _extends({}, props, { placeholder: placeholder, theme: ownTheme }));
      };
      onOverrideContent(content);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LinkButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          theme = _props.theme,
          onRemoveLinkAtSelection = _props.onRemoveLinkAtSelection;

      var hasLinkSelected = _draftJsPluginsUtils2.default.hasEntity(this.props.store.getEditorState(), 'LINK');
      var className = hasLinkSelected ? (0, _clsx2.default)(theme.button, theme.active) : theme.button;

      return _react2.default.createElement(
        'div',
        {
          className: theme.buttonWrapper,
          onMouseDown: this.onMouseDown
        },
        _react2.default.createElement(
          'button',
          {
            className: className,
            onClick: hasLinkSelected ? onRemoveLinkAtSelection : this.onAddLinkClick,
            type: 'button'
          },
          _react2.default.createElement(
            'svg',
            { height: '24', viewBox: '0 0 24 24', width: '24', xmlns: 'http://www.w3.org/2000/svg' },
            _react2.default.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' }),
            _react2.default.createElement('path', { d: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z' })
          )
        )
      );
    }
  }]);

  return LinkButton;
}(_react.Component);

LinkButton.propTypes = {
  placeholder: _propTypes2.default.string,
  store: _propTypes2.default.object.isRequired,
  ownTheme: _propTypes2.default.object.isRequired,
  onRemoveLinkAtSelection: _propTypes2.default.func.isRequired
};
exports.default = LinkButton;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(24);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clsx = __webpack_require__(128);

var _clsx2 = _interopRequireDefault(_clsx);

var _draftJsPluginsUtils = __webpack_require__(254);

var _draftJsPluginsUtils2 = _interopRequireDefault(_draftJsPluginsUtils);

var _URLUtils = __webpack_require__(1005);

var _URLUtils2 = _interopRequireDefault(_URLUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddLinkForm = function (_Component) {
  _inherits(AddLinkForm, _Component);

  function AddLinkForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AddLinkForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddLinkForm.__proto__ || Object.getPrototypeOf(AddLinkForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      value: '',
      isInvalid: false
    }, _this.onRef = function (node) {
      _this.input = node;
    }, _this.onChange = function (_ref2) {
      var value = _ref2.target.value;

      var nextState = { value: value };
      if (_this.state.isInvalid && _URLUtils2.default.isUrl(_URLUtils2.default.normalizeUrl(value))) {
        nextState.isInvalid = false;
      }
      _this.setState(nextState);
    }, _this.onClose = function () {
      return _this.props.onOverrideContent(undefined);
    }, _this.onKeyDown = function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        _this.submit();
      } else if (e.key === 'Escape') {
        e.preventDefault();
        _this.onClose();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AddLinkForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.input.focus();
    }
  }, {
    key: 'submit',
    value: function submit() {
      var _props = this.props,
          getEditorState = _props.getEditorState,
          setEditorState = _props.setEditorState;
      var url = this.state.value;

      if (!_URLUtils2.default.isMail(_URLUtils2.default.normaliseMail(url))) {
        url = _URLUtils2.default.normalizeUrl(url);
        if (!_URLUtils2.default.isUrl(url)) {
          this.setState({ isInvalid: true });
          return;
        }
      } else {
        url = _URLUtils2.default.normaliseMail(url);
      }
      setEditorState(_draftJsPluginsUtils2.default.createLinkAtSelection(getEditorState(), url));
      this.input.blur();
      this.onClose();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          theme = _props2.theme,
          placeholder = _props2.placeholder;
      var _state = this.state,
          value = _state.value,
          isInvalid = _state.isInvalid;

      var className = isInvalid ? (0, _clsx2.default)(theme.input, theme.inputInvalid) : theme.input;

      return _react2.default.createElement('input', {
        className: className,
        onBlur: this.onClose,
        onChange: this.onChange,
        onKeyDown: this.onKeyDown,
        placeholder: placeholder,
        ref: this.onRef,
        type: 'text',
        value: value
      });
    }
  }]);

  return AddLinkForm;
}(_react.Component);

AddLinkForm.propTypes = {
  getEditorState: _propTypes2.default.func.isRequired,
  setEditorState: _propTypes2.default.func.isRequired,
  onOverrideContent: _propTypes2.default.func.isRequired,
  theme: _propTypes2.default.object.isRequired,
  placeholder: _propTypes2.default.string
};
AddLinkForm.defaultProps = {
  placeholder: 'Enter a URL and press enter'
};
exports.default = AddLinkForm;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _prependHttp = __webpack_require__(1006);

var _prependHttp2 = _interopRequireDefault(_prependHttp);

var _urlRegex = __webpack_require__(1007);

var _urlRegex2 = _interopRequireDefault(_urlRegex);

var _mailRegex = __webpack_require__(1009);

var _mailRegex2 = _interopRequireDefault(_mailRegex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  isUrl: function isUrl(text) {
    return (0, _urlRegex2.default)().test(text);
  },
  isMail: function isMail(text) {
    return (0, _mailRegex2.default)().test(text);
  },
  normaliseMail: function normaliseMail(email) {
    if (email.toLowerCase().startsWith('mailto:')) {
      return email;
    }
    return 'mailto:' + email;
  },
  normalizeUrl: function normalizeUrl(url) {
    return (0, _prependHttp2.default)(url);
  }
};

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (url) {
	if (typeof url !== 'string') {
		throw new TypeError('Expected a string, got ' + typeof url);
	}

	url = url.trim();

	if (/^\.*\/|^(?!localhost)\w+:/.test(url)) {
		return url;
	}

	return url.replace(/^(?!(?:\w+:)?\/\/)/, 'http://');
};


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tlds = __webpack_require__(1008);

var _tlds2 = _interopRequireDefault(_tlds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var v4 = '(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])(?:\\.(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])){3}'; /* eslint-disable  arrow-body-style */
/* eslint-disable  no-confusing-arrow */

var v6seg = '[0-9a-fA-F]{1,4}';
var v6 = ('\n(\n(?:' + v6seg + ':){7}(?:' + v6seg + '|:)|                                // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8\n(?:' + v6seg + ':){6}(?:' + v4 + '|:' + v6seg + '|:)|                         // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4\n(?:' + v6seg + ':){5}(?::' + v4 + '|(:' + v6seg + '){1,2}|:)|                 // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4\n(?:' + v6seg + ':){4}(?:(:' + v6seg + '){0,1}:' + v4 + '|(:' + v6seg + '){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4\n(?:' + v6seg + ':){3}(?:(:' + v6seg + '){0,2}:' + v4 + '|(:' + v6seg + '){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4\n(?:' + v6seg + ':){2}(?:(:' + v6seg + '){0,3}:' + v4 + '|(:' + v6seg + '){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4\n(?:' + v6seg + ':){1}(?:(:' + v6seg + '){0,4}:' + v4 + '|(:' + v6seg + '){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4\n(?::((?::' + v6seg + '){0,5}:' + v4 + '|(?::' + v6seg + '){1,7}|:))           // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4\n)(%[0-9a-zA-Z]{1,})?                                           // %eth0            %1\n').replace(/\s*\/\/.*$/gm, '').replace(/\n/g, '').trim();

var ipRegex = function ipRegex(opts) {
  return opts && opts.exact ? new RegExp('(?:^' + v4 + '$)|(?:^' + v6 + '$)') : new RegExp('(?:' + v4 + ')|(?:' + v6 + ')', 'g');
};

ipRegex.v4 = function (opts) {
  return opts && opts.exact ? new RegExp('^' + v4 + '$') : new RegExp(v4, 'g');
};
ipRegex.v6 = function (opts) {
  return opts && opts.exact ? new RegExp('^' + v6 + '$') : new RegExp(v6, 'g');
};

exports.default = function (_opts) {
  var opts = Object.assign({ strict: true }, _opts);
  var protocol = '(?:(?:[a-z]+:)?//)' + (opts.strict ? '' : '?');
  var auth = '(?:\\S+(?::\\S*)?@)?';
  var ip = ipRegex.v4().source;
  var host = '(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)';
  var domain = '(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*';
  var tld = '(?:\\.' + (opts.strict ? '(?:[a-z\\u00a1-\\uffff]{2,})' : '(?:' + _tlds2.default.sort(function (a, b) {
    return b.length - a.length;
  }).join('|') + ')') + ')\\.?';
  var port = '(?::\\d{2,5})?';
  var path = '(?:[/?#][^\\s"]*)?';
  var regex = '(?:' + protocol + '|www\\.)' + auth + '(?:localhost|' + ip + '|' + host + domain + tld + ')' + port + path;

  return opts.exact ? new RegExp('(?:^' + regex + '$)', 'i') : new RegExp(regex, 'ig');
};

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

module.exports = ["aaa","aarp","abarth","abb","abbott","abbvie","abc","able","abogado","abudhabi","ac","academy","accenture","accountant","accountants","aco","actor","ad","ads","adult","ae","aeg","aero","aetna","af","afl","africa","ag","agakhan","agency","ai","aig","airbus","airforce","airtel","akdn","al","alfaromeo","alibaba","alipay","allfinanz","allstate","ally","alsace","alstom","am","amazon","americanexpress","americanfamily","amex","amfam","amica","amsterdam","analytics","android","anquan","anz","ao","aol","apartments","app","apple","aq","aquarelle","ar","arab","aramco","archi","army","arpa","art","arte","as","asda","asia","associates","at","athleta","attorney","au","auction","audi","audible","audio","auspost","author","auto","autos","avianca","aw","aws","ax","axa","az","azure","ba","baby","baidu","banamex","bananarepublic","band","bank","bar","barcelona","barclaycard","barclays","barefoot","bargains","baseball","basketball","bauhaus","bayern","bb","bbc","bbt","bbva","bcg","bcn","bd","be","beats","beauty","beer","bentley","berlin","best","bestbuy","bet","bf","bg","bh","bharti","bi","bible","bid","bike","bing","bingo","bio","biz","bj","black","blackfriday","blockbuster","blog","bloomberg","blue","bm","bms","bmw","bn","bnpparibas","bo","boats","boehringer","bofa","bom","bond","boo","book","booking","bosch","bostik","boston","bot","boutique","box","br","bradesco","bridgestone","broadway","broker","brother","brussels","bs","bt","build","builders","business","buy","buzz","bv","bw","by","bz","bzh","ca","cab","cafe","cal","call","calvinklein","cam","camera","camp","canon","capetown","capital","capitalone","car","caravan","cards","care","career","careers","cars","casa","case","cash","casino","cat","catering","catholic","cba","cbn","cbre","cbs","cc","cd","center","ceo","cern","cf","cfa","cfd","cg","ch","chanel","channel","charity","chase","chat","cheap","chintai","christmas","chrome","church","ci","cipriani","circle","cisco","citadel","citi","citic","city","cityeats","ck","cl","claims","cleaning","click","clinic","clinique","clothing","cloud","club","clubmed","cm","cn","co","coach","codes","coffee","college","cologne","com","comcast","commbank","community","company","compare","computer","comsec","condos","construction","consulting","contact","contractors","cooking","cookingchannel","cool","coop","corsica","country","coupon","coupons","courses","cpa","cr","credit","creditcard","creditunion","cricket","crown","crs","cruise","cruises","cu","cuisinella","cv","cw","cx","cy","cymru","cyou","cz","dabur","dad","dance","data","date","dating","datsun","day","dclk","dds","de","deal","dealer","deals","degree","delivery","dell","deloitte","delta","democrat","dental","dentist","desi","design","dev","dhl","diamonds","diet","digital","direct","directory","discount","discover","dish","diy","dj","dk","dm","dnp","do","docs","doctor","dog","domains","dot","download","drive","dtv","dubai","dunlop","dupont","durban","dvag","dvr","dz","earth","eat","ec","eco","edeka","edu","education","ee","eg","email","emerck","energy","engineer","engineering","enterprises","epson","equipment","er","ericsson","erni","es","esq","estate","et","etisalat","eu","eurovision","eus","events","exchange","expert","exposed","express","extraspace","fage","fail","fairwinds","faith","family","fan","fans","farm","farmers","fashion","fast","fedex","feedback","ferrari","ferrero","fi","fiat","fidelity","fido","film","final","finance","financial","fire","firestone","firmdale","fish","fishing","fit","fitness","fj","fk","flickr","flights","flir","florist","flowers","fly","fm","fo","foo","food","foodnetwork","football","ford","forex","forsale","forum","foundation","fox","fr","free","fresenius","frl","frogans","frontdoor","frontier","ftr","fujitsu","fun","fund","furniture","futbol","fyi","ga","gal","gallery","gallo","gallup","game","games","gap","garden","gay","gb","gbiz","gd","gdn","ge","gea","gent","genting","george","gf","gg","ggee","gh","gi","gift","gifts","gives","giving","gl","glass","gle","global","globo","gm","gmail","gmbh","gmo","gmx","gn","godaddy","gold","goldpoint","golf","goo","goodyear","goog","google","gop","got","gov","gp","gq","gr","grainger","graphics","gratis","green","gripe","grocery","group","gs","gt","gu","guardian","gucci","guge","guide","guitars","guru","gw","gy","hair","hamburg","hangout","haus","hbo","hdfc","hdfcbank","health","healthcare","help","helsinki","here","hermes","hgtv","hiphop","hisamitsu","hitachi","hiv","hk","hkt","hm","hn","hockey","holdings","holiday","homedepot","homegoods","homes","homesense","honda","horse","hospital","host","hosting","hot","hoteles","hotels","hotmail","house","how","hr","hsbc","ht","hu","hughes","hyatt","hyundai","ibm","icbc","ice","icu","id","ie","ieee","ifm","ikano","il","im","imamat","imdb","immo","immobilien","in","inc","industries","infiniti","info","ing","ink","institute","insurance","insure","int","international","intuit","investments","io","ipiranga","iq","ir","irish","is","ismaili","ist","istanbul","it","itau","itv","jaguar","java","jcb","je","jeep","jetzt","jewelry","jio","jll","jm","jmp","jnj","jo","jobs","joburg","jot","joy","jp","jpmorgan","jprs","juegos","juniper","kaufen","kddi","ke","kerryhotels","kerrylogistics","kerryproperties","kfh","kg","kh","ki","kia","kids","kim","kinder","kindle","kitchen","kiwi","km","kn","koeln","komatsu","kosher","kp","kpmg","kpn","kr","krd","kred","kuokgroup","kw","ky","kyoto","kz","la","lacaixa","lamborghini","lamer","lancaster","lancia","land","landrover","lanxess","lasalle","lat","latino","latrobe","law","lawyer","lb","lc","lds","lease","leclerc","lefrak","legal","lego","lexus","lgbt","li","lidl","life","lifeinsurance","lifestyle","lighting","like","lilly","limited","limo","lincoln","linde","link","lipsy","live","living","lk","llc","llp","loan","loans","locker","locus","lol","london","lotte","lotto","love","lpl","lplfinancial","lr","ls","lt","ltd","ltda","lu","lundbeck","luxe","luxury","lv","ly","ma","macys","madrid","maif","maison","makeup","man","management","mango","map","market","marketing","markets","marriott","marshalls","maserati","mattel","mba","mc","mckinsey","md","me","med","media","meet","melbourne","meme","memorial","men","menu","merckmsd","mg","mh","miami","microsoft","mil","mini","mint","mit","mitsubishi","mk","ml","mlb","mls","mm","mma","mn","mo","mobi","mobile","moda","moe","moi","mom","monash","money","monster","mormon","mortgage","moscow","moto","motorcycles","mov","movie","mp","mq","mr","ms","msd","mt","mtn","mtr","mu","museum","music","mutual","mv","mw","mx","my","mz","na","nab","nagoya","name","natura","navy","nba","nc","ne","nec","net","netbank","netflix","network","neustar","new","news","next","nextdirect","nexus","nf","nfl","ng","ngo","nhk","ni","nico","nike","nikon","ninja","nissan","nissay","nl","no","nokia","northwesternmutual","norton","now","nowruz","nowtv","np","nr","nra","nrw","ntt","nu","nyc","nz","obi","observer","office","okinawa","olayan","olayangroup","oldnavy","ollo","om","omega","one","ong","onl","online","ooo","open","oracle","orange","org","organic","origins","osaka","otsuka","ott","ovh","pa","page","panasonic","paris","pars","partners","parts","party","passagens","pay","pccw","pe","pet","pf","pfizer","pg","ph","pharmacy","phd","philips","phone","photo","photography","photos","physio","pics","pictet","pictures","pid","pin","ping","pink","pioneer","pizza","pk","pl","place","play","playstation","plumbing","plus","pm","pn","pnc","pohl","poker","politie","porn","post","pr","pramerica","praxi","press","prime","pro","prod","productions","prof","progressive","promo","properties","property","protection","pru","prudential","ps","pt","pub","pw","pwc","py","qa","qpon","quebec","quest","racing","radio","re","read","realestate","realtor","realty","recipes","red","redstone","redumbrella","rehab","reise","reisen","reit","reliance","ren","rent","rentals","repair","report","republican","rest","restaurant","review","reviews","rexroth","rich","richardli","ricoh","ril","rio","rip","ro","rocher","rocks","rodeo","rogers","room","rs","rsvp","ru","rugby","ruhr","run","rw","rwe","ryukyu","sa","saarland","safe","safety","sakura","sale","salon","samsclub","samsung","sandvik","sandvikcoromant","sanofi","sap","sarl","sas","save","saxo","sb","sbi","sbs","sc","sca","scb","schaeffler","schmidt","scholarships","school","schule","schwarz","science","scot","sd","se","search","seat","secure","security","seek","select","sener","services","seven","sew","sex","sexy","sfr","sg","sh","shangrila","sharp","shaw","shell","shia","shiksha","shoes","shop","shopping","shouji","show","showtime","si","silk","sina","singles","site","sj","sk","ski","skin","sky","skype","sl","sling","sm","smart","smile","sn","sncf","so","soccer","social","softbank","software","sohu","solar","solutions","song","sony","soy","spa","space","sport","spot","sr","srl","ss","st","stada","staples","star","statebank","statefarm","stc","stcgroup","stockholm","storage","store","stream","studio","study","style","su","sucks","supplies","supply","support","surf","surgery","suzuki","sv","swatch","swiss","sx","sy","sydney","systems","sz","tab","taipei","talk","taobao","target","tatamotors","tatar","tattoo","tax","taxi","tc","tci","td","tdk","team","tech","technology","tel","temasek","tennis","teva","tf","tg","th","thd","theater","theatre","tiaa","tickets","tienda","tiffany","tips","tires","tirol","tj","tjmaxx","tjx","tk","tkmaxx","tl","tm","tmall","tn","to","today","tokyo","tools","top","toray","toshiba","total","tours","town","toyota","toys","tr","trade","trading","training","travel","travelchannel","travelers","travelersinsurance","trust","trv","tt","tube","tui","tunes","tushu","tv","tvs","tw","tz","ua","ubank","ubs","ug","uk","unicom","university","uno","uol","ups","us","uy","uz","va","vacations","vana","vanguard","vc","ve","vegas","ventures","verisign","vermögensberater","vermögensberatung","versicherung","vet","vg","vi","viajes","video","vig","viking","villas","vin","vip","virgin","visa","vision","viva","vivo","vlaanderen","vn","vodka","volkswagen","volvo","vote","voting","voto","voyage","vu","vuelos","wales","walmart","walter","wang","wanggou","watch","watches","weather","weatherchannel","webcam","weber","website","wed","wedding","weibo","weir","wf","whoswho","wien","wiki","williamhill","win","windows","wine","winners","wme","wolterskluwer","woodside","work","works","world","wow","ws","wtc","wtf","xbox","xerox","xfinity","xihuan","xin","xxx","xyz","yachts","yahoo","yamaxun","yandex","ye","yodobashi","yoga","yokohama","you","youtube","yt","yun","za","zappos","zara","zero","zip","zm","zone","zuerich","zw","ελ","ευ","бг","бел","дети","ею","католик","ком","мкд","мон","москва","онлайн","орг","рус","рф","сайт","срб","укр","қаз","հայ","ישראל","קום","ابوظبي","اتصالات","ارامكو","الاردن","البحرين","الجزائر","السعودية","العليان","المغرب","امارات","ایران","بارت","بازار","بيتك","بھارت","تونس","سودان","سورية","شبكة","عراق","عرب","عمان","فلسطين","قطر","كاثوليك","كوم","مصر","مليسيا","موريتانيا","موقع","همراه","پاکستان","ڀارت","कॉम","नेट","भारत","भारतम्","भारोत","संगठन","বাংলা","ভারত","ভাৰত","ਭਾਰਤ","ભારત","ଭାରତ","இந்தியா","இலங்கை","சிங்கப்பூர்","భారత్","ಭಾರತ","ഭാരതം","ලංකා","คอม","ไทย","ລາວ","გე","みんな","アマゾン","クラウド","グーグル","コム","ストア","セール","ファッション","ポイント","世界","中信","中国","中國","中文网","亚马逊","企业","佛山","信息","健康","八卦","公司","公益","台湾","台灣","商城","商店","商标","嘉里","嘉里大酒店","在线","大拿","天主教","娱乐","家電","广东","微博","慈善","我爱你","手机","招聘","政务","政府","新加坡","新闻","时尚","書籍","机构","淡马锡","游戏","澳門","点看","移动","组织机构","网址","网店","网站","网络","联通","谷歌","购物","通販","集团","電訊盈科","飞利浦","食品","餐厅","香格里拉","香港","닷넷","닷컴","삼성","한국"]

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return (/^((mailto:[^<>()/[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
  );
};

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = strategy;
var matchesEntityType = exports.matchesEntityType = function matchesEntityType(type) {
  return type === 'LINK';
};

function strategy(contentBlock, cb, contentState) {
  if (!contentState) return;
  contentBlock.findEntityRanges(function (character) {
    var entityKey = character.getEntity();
    return entityKey !== null && matchesEntityType(contentState.getEntity(entityKey).getType());
  }, cb);
}

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stateToHTML__ = __webpack_require__(1012);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stateToHTML", function() { return __WEBPACK_IMPORTED_MODULE_0__stateToHTML__["a"]; });


/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = stateToHTML;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_combineOrderedStyles__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_normalizeAttributes__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_styleToCSS__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__ = __webpack_require__(411);
var _DEFAULT_STYLE_MAP, _ENTITY_ATTR_MAP, _DATA_TO_ATTR;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var BOLD = __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["c" /* INLINE_STYLE */].BOLD,
    CODE = __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["c" /* INLINE_STYLE */].CODE,
    ITALIC = __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["c" /* INLINE_STYLE */].ITALIC,
    STRIKETHROUGH = __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["c" /* INLINE_STYLE */].STRIKETHROUGH,
    UNDERLINE = __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["c" /* INLINE_STYLE */].UNDERLINE;
var INDENT = '  ';
var BREAK = '<br>';
var DATA_ATTRIBUTE = /^data-([a-z0-9-]+)$/;
var DEFAULT_STYLE_MAP = (_DEFAULT_STYLE_MAP = {}, _defineProperty(_DEFAULT_STYLE_MAP, BOLD, {
  element: 'strong'
}), _defineProperty(_DEFAULT_STYLE_MAP, CODE, {
  element: 'code'
}), _defineProperty(_DEFAULT_STYLE_MAP, ITALIC, {
  element: 'em'
}), _defineProperty(_DEFAULT_STYLE_MAP, STRIKETHROUGH, {
  element: 'del'
}), _defineProperty(_DEFAULT_STYLE_MAP, UNDERLINE, {
  element: 'u'
}), _DEFAULT_STYLE_MAP); // Order: inner-most style to outer-most.
// Examle: <em><strong>foo</strong></em>

var DEFAULT_STYLE_ORDER = [BOLD, ITALIC, UNDERLINE, STRIKETHROUGH, CODE]; // Map entity data to element attributes.

var ENTITY_ATTR_MAP = (_ENTITY_ATTR_MAP = {}, _defineProperty(_ENTITY_ATTR_MAP, __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["b" /* ENTITY_TYPE */].LINK, {
  url: 'href',
  href: 'href',
  rel: 'rel',
  target: 'target',
  title: 'title',
  className: 'class'
}), _defineProperty(_ENTITY_ATTR_MAP, __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["b" /* ENTITY_TYPE */].IMAGE, {
  src: 'src',
  height: 'height',
  width: 'width',
  alt: 'alt',
  className: 'class'
}), _ENTITY_ATTR_MAP); // Map entity data to element attributes.

var DATA_TO_ATTR = (_DATA_TO_ATTR = {}, _defineProperty(_DATA_TO_ATTR, __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["b" /* ENTITY_TYPE */].LINK, function (entityType, entity) {
  var attrMap = ENTITY_ATTR_MAP.hasOwnProperty(entityType) ? ENTITY_ATTR_MAP[entityType] : {};
  var data = entity.getData();
  var attrs = {};

  for (var _i = 0, _Object$keys = Object.keys(data); _i < _Object$keys.length; _i++) {
    var dataKey = _Object$keys[_i];
    var dataValue = data[dataKey];

    if (attrMap.hasOwnProperty(dataKey)) {
      var attrKey = attrMap[dataKey];
      attrs[attrKey] = dataValue;
    } else if (DATA_ATTRIBUTE.test(dataKey)) {
      attrs[dataKey] = dataValue;
    }
  }

  return attrs;
}), _defineProperty(_DATA_TO_ATTR, __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["b" /* ENTITY_TYPE */].IMAGE, function (entityType, entity) {
  var attrMap = ENTITY_ATTR_MAP.hasOwnProperty(entityType) ? ENTITY_ATTR_MAP[entityType] : {};
  var data = entity.getData();
  var attrs = {};

  for (var _i2 = 0, _Object$keys2 = Object.keys(data); _i2 < _Object$keys2.length; _i2++) {
    var dataKey = _Object$keys2[_i2];
    var dataValue = data[dataKey];

    if (attrMap.hasOwnProperty(dataKey)) {
      var attrKey = attrMap[dataKey];
      attrs[attrKey] = dataValue;
    } else if (DATA_ATTRIBUTE.test(dataKey)) {
      attrs[dataKey] = dataValue;
    }
  }

  return attrs;
}), _DATA_TO_ATTR); // The reason this returns an array is because a single block might get wrapped
// in two tags.

function getTags(blockType, defaultBlockTag) {
  switch (blockType) {
    case __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].HEADER_ONE:
      return ['h1'];

    case __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].HEADER_TWO:
      return ['h2'];

    case __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].HEADER_THREE:
      return ['h3'];

    case __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].HEADER_FOUR:
      return ['h4'];

    case __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].HEADER_FIVE:
      return ['h5'];

    case __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].HEADER_SIX:
      return ['h6'];

    case __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].UNORDERED_LIST_ITEM:
    case __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].ORDERED_LIST_ITEM:
      return ['li'];

    case __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].BLOCKQUOTE:
      return ['blockquote'];

    case __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].CODE:
      return ['pre', 'code'];

    case __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].ATOMIC:
      return ['figure'];

    default:
      if (defaultBlockTag === null) {
        return [];
      }

      return [defaultBlockTag || 'p'];
  }
}

function getWrapperTag(blockType) {
  switch (blockType) {
    case __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].UNORDERED_LIST_ITEM:
      return 'ul';

    case __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].ORDERED_LIST_ITEM:
      return 'ol';

    default:
      return null;
  }
}

var MarkupGenerator =
/*#__PURE__*/
function () {
  // These are related to state.
  // These are related to user-defined options.
  function MarkupGenerator(contentState, options) {
    _classCallCheck(this, MarkupGenerator);

    _defineProperty(this, "blocks", void 0);

    _defineProperty(this, "contentState", void 0);

    _defineProperty(this, "currentBlock", void 0);

    _defineProperty(this, "indentLevel", void 0);

    _defineProperty(this, "output", void 0);

    _defineProperty(this, "totalBlocks", void 0);

    _defineProperty(this, "wrapperTag", void 0);

    _defineProperty(this, "options", void 0);

    _defineProperty(this, "inlineStyles", void 0);

    _defineProperty(this, "inlineStyleFn", void 0);

    _defineProperty(this, "styleOrder", void 0);

    if (options == null) {
      options = {};
    }

    this.contentState = contentState;
    this.options = options;

    var _combineOrderedStyles = Object(__WEBPACK_IMPORTED_MODULE_0__helpers_combineOrderedStyles__["a" /* default */])(options.inlineStyles, [DEFAULT_STYLE_MAP, DEFAULT_STYLE_ORDER]),
        _combineOrderedStyles2 = _slicedToArray(_combineOrderedStyles, 2),
        inlineStyles = _combineOrderedStyles2[0],
        styleOrder = _combineOrderedStyles2[1];

    this.inlineStyles = inlineStyles;
    this.inlineStyleFn = options.inlineStyleFn;
    this.styleOrder = styleOrder;
  }

  _createClass(MarkupGenerator, [{
    key: "generate",
    value: function generate() {
      this.output = [];
      this.blocks = this.contentState.getBlocksAsArray();
      this.totalBlocks = this.blocks.length;
      this.currentBlock = 0;
      this.indentLevel = 0;
      this.wrapperTag = null;

      while (this.currentBlock < this.totalBlocks) {
        this.processBlock();
      }

      this.closeWrapperTag();
      return this.output.join('').trim();
    }
  }, {
    key: "processBlock",
    value: function processBlock() {
      var _this$options = this.options,
          blockRenderers = _this$options.blockRenderers,
          defaultBlockTag = _this$options.defaultBlockTag;
      var block = this.blocks[this.currentBlock];
      var blockType = block.getType();
      var newWrapperTag = getWrapperTag(blockType);

      if (this.wrapperTag !== newWrapperTag) {
        if (this.wrapperTag) {
          this.closeWrapperTag();
        }

        if (newWrapperTag) {
          this.openWrapperTag(newWrapperTag);
        }
      }

      this.indent(); // Allow blocks to be rendered using a custom renderer.

      var customRenderer = blockRenderers != null && blockRenderers.hasOwnProperty(blockType) ? blockRenderers[blockType] : null;
      var customRendererOutput = customRenderer ? customRenderer(block) : null; // Renderer can return null, which will cause processing to continue as normal.

      if (customRendererOutput != null) {
        this.output.push(customRendererOutput);
        this.output.push('\n');
        this.currentBlock += 1;
        return;
      }

      this.writeStartTag(block, defaultBlockTag);
      this.output.push(this.renderBlockContent(block)); // Look ahead and see if we will nest list.

      var nextBlock = this.getNextBlock();

      if (canHaveDepth(blockType) && nextBlock && nextBlock.getDepth() === block.getDepth() + 1) {
        this.output.push('\n'); // This is a litle hacky: temporarily stash our current wrapperTag and
        // render child list(s).

        var thisWrapperTag = this.wrapperTag;
        this.wrapperTag = null;
        this.indentLevel += 1;
        this.currentBlock += 1;
        this.processBlocksAtDepth(nextBlock.getDepth());
        this.wrapperTag = thisWrapperTag;
        this.indentLevel -= 1;
        this.indent();
      } else {
        this.currentBlock += 1;
      }

      this.writeEndTag(block, defaultBlockTag);
    }
  }, {
    key: "processBlocksAtDepth",
    value: function processBlocksAtDepth(depth) {
      var block = this.blocks[this.currentBlock];

      while (block && block.getDepth() === depth) {
        this.processBlock();
        block = this.blocks[this.currentBlock];
      }

      this.closeWrapperTag();
    }
  }, {
    key: "getNextBlock",
    value: function getNextBlock() {
      return this.blocks[this.currentBlock + 1];
    }
  }, {
    key: "writeStartTag",
    value: function writeStartTag(block, defaultBlockTag) {
      var tags = getTags(block.getType(), defaultBlockTag);
      var attrString;

      if (this.options.blockStyleFn) {
        var _ref = this.options.blockStyleFn(block) || {},
            attributes = _ref.attributes,
            _style = _ref.style; // Normalize `className` -> `class`, etc.


        attributes = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_normalizeAttributes__["a" /* default */])(attributes);

        if (_style != null) {
          var styleAttr = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_styleToCSS__["a" /* default */])(_style);
          attributes = attributes == null ? {
            style: styleAttr
          } : _objectSpread({}, attributes, {
            style: styleAttr
          });
        }

        attrString = stringifyAttrs(attributes);
      } else {
        attrString = '';
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = tags[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var tag = _step.value;
          this.output.push("<".concat(tag).concat(attrString, ">"));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "writeEndTag",
    value: function writeEndTag(block, defaultBlockTag) {
      var tags = getTags(block.getType(), defaultBlockTag);

      if (tags.length === 1) {
        this.output.push("</".concat(tags[0], ">\n"));
      } else {
        var output = [];
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = tags[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var tag = _step2.value;
            output.unshift("</".concat(tag, ">"));
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
              _iterator2["return"]();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        this.output.push(output.join('') + '\n');
      }
    }
  }, {
    key: "openWrapperTag",
    value: function openWrapperTag(wrapperTag) {
      this.wrapperTag = wrapperTag;
      this.indent();
      this.output.push("<".concat(wrapperTag, ">\n"));
      this.indentLevel += 1;
    }
  }, {
    key: "closeWrapperTag",
    value: function closeWrapperTag() {
      var wrapperTag = this.wrapperTag;

      if (wrapperTag) {
        this.indentLevel -= 1;
        this.indent();
        this.output.push("</".concat(wrapperTag, ">\n"));
        this.wrapperTag = null;
      }
    }
  }, {
    key: "indent",
    value: function indent() {
      this.output.push(INDENT.repeat(this.indentLevel));
    }
  }, {
    key: "withCustomInlineStyles",
    value: function withCustomInlineStyles(content, styleSet) {
      if (!this.inlineStyleFn) {
        return content;
      }

      var renderConfig = this.inlineStyleFn(styleSet);

      if (!renderConfig) {
        return content;
      }

      var _renderConfig$element = renderConfig.element,
          element = _renderConfig$element === void 0 ? 'span' : _renderConfig$element,
          attributes = renderConfig.attributes,
          style = renderConfig.style;
      var attrString = stringifyAttrs(_objectSpread({}, attributes, {
        style: style && Object(__WEBPACK_IMPORTED_MODULE_2__helpers_styleToCSS__["a" /* default */])(style)
      }));
      return "<".concat(element).concat(attrString, ">").concat(content, "</").concat(element, ">");
    }
  }, {
    key: "renderBlockContent",
    value: function renderBlockContent(block) {
      var _this = this;

      var blockType = block.getType();
      var text = block.getText();

      if (text === '') {
        // Prevent element collapse if completely empty.
        return BREAK;
      }

      text = this.preserveWhitespace(text);
      var charMetaList = block.getCharacterList();
      var entityPieces = Object(__WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["d" /* getEntityRanges */])(text, charMetaList);
      return entityPieces.map(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            entityKey = _ref3[0],
            stylePieces = _ref3[1];

        var content = stylePieces.map(function (_ref4) {
          var _ref5 = _slicedToArray(_ref4, 2),
              text = _ref5[0],
              styleSet = _ref5[1];

          var content = encodeContent(text);
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = _this.styleOrder[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _styleName = _step3.value;

              // If our block type is CODE then don't wrap inline code elements.
              if (_styleName === CODE && blockType === __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].CODE) {
                continue;
              }

              if (styleSet.has(_styleName)) {
                var _this$inlineStyles$_s = _this.inlineStyles[_styleName],
                    element = _this$inlineStyles$_s.element,
                    attributes = _this$inlineStyles$_s.attributes,
                    _style2 = _this$inlineStyles$_s.style;

                if (element == null) {
                  element = 'span';
                } // Normalize `className` -> `class`, etc.


                attributes = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_normalizeAttributes__["a" /* default */])(attributes);

                if (_style2 != null) {
                  var styleAttr = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_styleToCSS__["a" /* default */])(_style2);
                  attributes = attributes == null ? {
                    style: styleAttr
                  } : _objectSpread({}, attributes, {
                    style: styleAttr
                  });
                }

                var attrString = stringifyAttrs(attributes);
                content = "<".concat(element).concat(attrString, ">").concat(content, "</").concat(element, ">");
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3["return"] != null) {
                _iterator3["return"]();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          return _this.withCustomInlineStyles(content, styleSet);
        }).join('');
        var entity = entityKey ? _this.contentState.getEntity(entityKey) : null; // Note: The `toUpperCase` below is for compatability with some libraries that use lower-case for image blocks.

        var entityType = entity == null ? null : entity.getType().toUpperCase();
        var entityStyle;

        if (entity != null && _this.options.entityStyleFn && (entityStyle = _this.options.entityStyleFn(entity))) {
          var _entityStyle = entityStyle,
              element = _entityStyle.element,
              attributes = _entityStyle.attributes,
              _style3 = _entityStyle.style;

          if (element == null) {
            element = 'span';
          } // Normalize `className` -> `class`, etc.


          attributes = Object(__WEBPACK_IMPORTED_MODULE_1__helpers_normalizeAttributes__["a" /* default */])(attributes);

          if (_style3 != null) {
            var styleAttr = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_styleToCSS__["a" /* default */])(_style3);
            attributes = attributes == null ? {
              style: styleAttr
            } : _objectSpread({}, attributes, {
              style: styleAttr
            });
          }

          var attrString = stringifyAttrs(attributes);
          return "<".concat(element).concat(attrString, ">").concat(content, "</").concat(element, ">");
        } else if (entityType != null && entityType === __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["b" /* ENTITY_TYPE */].LINK) {
          var attrs = DATA_TO_ATTR.hasOwnProperty(entityType) ? DATA_TO_ATTR[entityType](entityType, entity) : null;

          var _attrString = stringifyAttrs(attrs);

          return "<a".concat(_attrString, ">").concat(content, "</a>");
        } else if (entityType != null && entityType === __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["b" /* ENTITY_TYPE */].IMAGE) {
          var _attrs = DATA_TO_ATTR.hasOwnProperty(entityType) ? DATA_TO_ATTR[entityType](entityType, entity) : null;

          var _attrString2 = stringifyAttrs(_attrs);

          return "<img".concat(_attrString2, "/>");
        } else {
          return content;
        }
      }).join('');
    }
  }, {
    key: "preserveWhitespace",
    value: function preserveWhitespace(text) {
      var length = text.length; // Prevent leading/trailing/consecutive whitespace collapse.

      var newText = new Array(length);

      for (var i = 0; i < length; i++) {
        if (text[i] === ' ' && (i === 0 || i === length - 1 || text[i - 1] === ' ')) {
          newText[i] = '\xA0';
        } else {
          newText[i] = text[i];
        }
      }

      return newText.join('');
    }
  }]);

  return MarkupGenerator;
}();

function stringifyAttrs(attrs) {
  if (attrs == null) {
    return '';
  }

  var parts = [];

  for (var _i3 = 0, _Object$keys3 = Object.keys(attrs); _i3 < _Object$keys3.length; _i3++) {
    var name = _Object$keys3[_i3];
    var value = attrs[name];

    if (value != null) {
      parts.push(" ".concat(name, "=\"").concat(encodeAttr(value + ''), "\""));
    }
  }

  return parts.join('');
}

function canHaveDepth(blockType) {
  switch (blockType) {
    case __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].UNORDERED_LIST_ITEM:
    case __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].ORDERED_LIST_ITEM:
      return true;

    default:
      return false;
  }
}

function encodeContent(text) {
  return text.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('\xA0').join('&nbsp;').split('\n').join(BREAK + '\n');
}

function encodeAttr(text) {
  return text.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('"').join('&quot;');
}

function stateToHTML(content, options) {
  return new MarkupGenerator(content, options).generate();
}

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function combineOrderedStyles(customMap, defaults) {
  if (customMap == null) {
    return defaults;
  }

  var _defaults = _slicedToArray(defaults, 2),
      defaultStyleMap = _defaults[0],
      defaultStyleOrder = _defaults[1];

  var styleMap = _objectSpread({}, defaultStyleMap);

  var styleOrder = _toConsumableArray(defaultStyleOrder);

  for (var _i2 = 0, _Object$keys = Object.keys(customMap); _i2 < _Object$keys.length; _i2++) {
    var _styleName = _Object$keys[_i2];

    if (defaultStyleMap.hasOwnProperty(_styleName)) {
      var defaultStyles = defaultStyleMap[_styleName];
      styleMap[_styleName] = _objectSpread({}, defaultStyles, {}, customMap[_styleName]);
    } else {
      styleMap[_styleName] = customMap[_styleName];
      styleOrder.push(_styleName);
    }
  }

  return [styleMap, styleOrder];
}

/* harmony default export */ __webpack_exports__["a"] = (combineOrderedStyles);

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Lifted from: https://github.com/facebook/react/blob/master/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
var ATTR_NAME_MAP = {
  acceptCharset: 'accept-charset',
  className: 'class',
  htmlFor: 'for',
  httpEquiv: 'http-equiv'
};

function normalizeAttributes(attributes) {
  if (attributes == null) {
    return attributes;
  }

  var normalized = {};
  var didNormalize = false;

  for (var _i = 0, _Object$keys = Object.keys(attributes); _i < _Object$keys.length; _i++) {
    var name = _Object$keys[_i];
    var newName = name;

    if (ATTR_NAME_MAP.hasOwnProperty(name)) {
      newName = ATTR_NAME_MAP[name];
      didNormalize = true;
    }

    normalized[newName] = attributes[name];
  }

  return didNormalize ? normalized : attributes;
}

/* harmony default export */ __webpack_exports__["a"] = (normalizeAttributes);

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var VENDOR_PREFIX = /^(moz|ms|o|webkit)-/;
var NUMERIC_STRING = /^\d+$/;
var UPPERCASE_PATTERN = /([A-Z])/g; // Lifted from:
// https://github.com/facebook/react/blob/ab4ddf64939aebbbc8d31be1022efd56e834c95c/src/renderers/dom/shared/CSSProperty.js

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
}; // Lifted from: https://github.com/facebook/react/blob/master/src/renderers/dom/shared/CSSPropertyOperations.js

function processStyleName(name) {
  return name.replace(UPPERCASE_PATTERN, '-$1').toLowerCase().replace(VENDOR_PREFIX, '-$1-');
} // Lifted from: https://github.com/facebook/react/blob/master/src/renderers/dom/shared/dangerousStyleValue.js


function processStyleValue(name, value) {
  var isNumeric;

  if (typeof value === 'string') {
    isNumeric = NUMERIC_STRING.test(value);
  } else {
    isNumeric = true;
    value = String(value);
  }

  if (!isNumeric || value === '0' || isUnitlessNumber[name] === true) {
    return value;
  } else {
    return value + 'px';
  }
}

function styleToCSS(styleDescr) {
  return Object.keys(styleDescr).map(function (name) {
    var styleValue = processStyleValue(name, styleDescr[name]);
    var styleName = processStyleName(name);
    return "".concat(styleName, ": ").concat(styleValue);
  }).join('; ');
}

/* harmony default export */ __webpack_exports__["a"] = (styleToCSS);

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EMPTY_SET */
/* harmony export (immutable) */ __webpack_exports__["a"] = getEntityRanges;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);

var EMPTY_SET = new __WEBPACK_IMPORTED_MODULE_0_immutable__["OrderedSet"]();
function getEntityRanges(text, charMetaList) {
  var charEntity = null;
  var prevCharEntity = null;
  var ranges = [];
  var rangeStart = 0;

  for (var i = 0, len = text.length; i < len; i++) {
    prevCharEntity = charEntity;
    var meta = charMetaList.get(i);
    charEntity = meta ? meta.getEntity() : null;

    if (i > 0 && charEntity !== prevCharEntity) {
      ranges.push([prevCharEntity, getStyleRanges(text.slice(rangeStart, i), charMetaList.slice(rangeStart, i))]);
      rangeStart = i;
    }
  }

  ranges.push([charEntity, getStyleRanges(text.slice(rangeStart), charMetaList.slice(rangeStart))]);
  return ranges;
}

function getStyleRanges(text, charMetaList) {
  var charStyle = EMPTY_SET;
  var prevCharStyle = EMPTY_SET;
  var ranges = [];
  var rangeStart = 0;

  for (var i = 0, len = text.length; i < len; i++) {
    prevCharStyle = charStyle;
    var meta = charMetaList.get(i);
    charStyle = meta ? meta.getStyle() : EMPTY_SET;

    if (i > 0 && !Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["is"])(charStyle, prevCharStyle)) {
      ranges.push([text.slice(rangeStart, i), prevCharStyle]);
      rangeStart = i;
    }
  }

  ranges.push([text.slice(rangeStart), charStyle]);
  return ranges;
}

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getSelectedBlocks__ = __webpack_require__(255);

/* unused harmony default export */ var _unused_webpack_default_export = (function (strategy) {
  return function (editorState, selection) {
    var contentState = editorState.getCurrentContent();
    var currentSelection = selection || editorState.getSelection();
    var startKey = currentSelection.getStartKey();
    var endKey = currentSelection.getEndKey();
    var startOffset = currentSelection.getStartOffset();
    var endOffset = currentSelection.getEndOffset();
    var isSameBlock = startKey === endKey;
    var selectedBlocks = Object(__WEBPACK_IMPORTED_MODULE_0__getSelectedBlocks__["a" /* default */])(contentState, startKey, endKey);
    var entityFound = false; // We have to shift the offset to not get false positives when selecting
    // a character just before or after an entity

    var finalStartOffset = startOffset + 1;
    var finalEndOffset = endOffset - 1;
    selectedBlocks.forEach(function (block) {
      strategy(block, function (start, end) {
        if (entityFound) {
          return;
        }

        var blockKey = block.getKey();

        if (isSameBlock && (end < finalStartOffset || start > finalEndOffset)) {
          return;
        } else if (blockKey === startKey && end < finalStartOffset) {
          return;
        } else if (blockKey === endKey && start > finalEndOffset) {
          return;
        }

        entityFound = true;
      }, contentState);
    });
    return entityFound;
  };
});

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_draft_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_draft_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_draft_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSelectedBlocks__ = __webpack_require__(255);


/**
 * Calls a provided `modifier` function with a selection for each
 * selected block in the current editor selection. Passes through additional
 * arguments to the modifier.
 *
 * Note: At the moment it will retain the original selection and override
 * possible selection changes from modifiers
 *
 * @param  {object} editorState The current draft.js editor state object
 *
 * @param  {function} modifier  A modifier function to be executed.
 *                              Must have the signature (editorState, selection, ...)
 *
 * @param  {mixed} ...args      Additional arguments to be passed through to the modifier
 *
 * @return {object} The new editor state
 */

/* unused harmony default export */ var _unused_webpack_default_export = (function (editorState, modifier) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var contentState = editorState.getCurrentContent();
  var currentSelection = editorState.getSelection();
  var startKey = currentSelection.getStartKey();
  var endKey = currentSelection.getEndKey();
  var startOffset = currentSelection.getStartOffset();
  var endOffset = currentSelection.getEndOffset();
  var isSameBlock = startKey === endKey;
  var selectedBlocks = Object(__WEBPACK_IMPORTED_MODULE_1__getSelectedBlocks__["a" /* default */])(contentState, startKey, endKey);
  var finalEditorState = editorState;
  selectedBlocks.forEach(function (block) {
    var currentBlockKey = block.getKey();
    var selectionStart = startOffset;
    var selectionEnd = endOffset;

    if (currentBlockKey === startKey) {
      selectionStart = startOffset;
      selectionEnd = isSameBlock ? endOffset : block.getText().length;
    } else if (currentBlockKey === endKey) {
      selectionStart = isSameBlock ? startOffset : 0;
      selectionEnd = endOffset;
    } else {
      selectionStart = 0;
      selectionEnd = block.getText().length;
    }

    var selection = new __WEBPACK_IMPORTED_MODULE_0_draft_js__["SelectionState"]({
      anchorKey: currentBlockKey,
      anchorOffset: selectionStart,
      focusKey: currentBlockKey,
      focusOffset: selectionEnd
    });
    finalEditorState = modifier.apply(void 0, [finalEditorState, selection].concat(args));
  });
  return __WEBPACK_IMPORTED_MODULE_0_draft_js__["EditorState"].forceSelection(finalEditorState, currentSelection);
});

/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stateFromHTML__ = __webpack_require__(1020);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stateFromHTML", function() { return __WEBPACK_IMPORTED_MODULE_0__stateFromHTML__["a"]; });


/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = stateFromHTML;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_draft_js_import_element__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parseHTML__ = __webpack_require__(1027);
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



var defaultOptions = {};
function stateFromHTML(html, options) {
  var _ref = options || defaultOptions,
      parser = _ref.parser,
      otherOptions = _objectWithoutProperties(_ref, ["parser"]);

  if (parser == null) {
    parser = __WEBPACK_IMPORTED_MODULE_1__parseHTML__["a" /* default */];
  }

  var element = parser(html);
  return Object(__WEBPACK_IMPORTED_MODULE_0_draft_js_import_element__["a" /* stateFromElement */])(element, otherOptions);
}

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stateFromElement__ = __webpack_require__(1022);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__stateFromElement__["a"]; });


/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = stateFromElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_replaceTextWithMeta__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_draft_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_draft_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_draft_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_synthetic_dom__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_Constants__ = __webpack_require__(1026);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var DATA_URL = /^data:/i;
var NO_STYLE = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["OrderedSet"])();
var NO_ENTITY = null;
var EMPTY_BLOCK = new __WEBPACK_IMPORTED_MODULE_1_draft_js__["ContentBlock"]({
  key: Object(__WEBPACK_IMPORTED_MODULE_1_draft_js__["genKey"])(),
  text: '',
  type: __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].UNSTYLED,
  characterList: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(),
  depth: 0
});
var LINE_BREAKS = /(\r\n|\r|\n)/g; // We use `\r` because that character is always stripped from source (normalized
// to `\n`), so it's safe to assume it will only appear in the text content when
// we put it there as a placeholder.

var SOFT_BREAK_PLACEHOLDER = '\r';
var ZERO_WIDTH_SPACE = "\u200B";
var DATA_ATTRIBUTE = /^data-([a-z0-9-]+)$/; // Map element attributes to entity data.

var ELEM_ATTR_MAP = {
  a: {
    href: 'url',
    rel: 'rel',
    target: 'target',
    title: 'title'
  },
  img: {
    src: 'src',
    alt: 'alt',
    width: 'width',
    height: 'height'
  }
};

var getEntityData = function getEntityData(tagName, element) {
  var data = {};

  if (ELEM_ATTR_MAP.hasOwnProperty(tagName)) {
    var attrMap = ELEM_ATTR_MAP[tagName];

    for (var i = 0; i < element.attributes.length; i++) {
      var _element$attributes$i = element.attributes[i],
          name = _element$attributes$i.name,
          value = _element$attributes$i.value;

      if (typeof value === 'string') {
        var strVal = value;

        if (attrMap.hasOwnProperty(name)) {
          var newName = attrMap[name];
          data[newName] = strVal;
        } else if (DATA_ATTRIBUTE.test(name)) {
          data[name] = strVal;
        }
      }
    }
  }

  return data;
}; // Functions to create entities from elements.


var ElementToEntity = {
  a: function a(generator, tagName, element) {
    var data = getEntityData(tagName, element); // Don't add `<a>` elements with invalid href.

    if (isAllowedHref(data.url)) {
      return generator.createEntity(__WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["b" /* ENTITY_TYPE */].LINK, data);
    }
  },
  img: function img(generator, tagName, element) {
    var data = getEntityData(tagName, element); // Don't add `<img>` elements with no src.

    if (data.src != null) {
      return generator.createEntity(__WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["b" /* ENTITY_TYPE */].IMAGE, data);
    }
  }
};

var ContentGenerator =
/*#__PURE__*/
function () {
  // This will be passed to the customInlineFn to allow it
  // to return a Style() or Entity().
  function ContentGenerator() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, ContentGenerator);

    _defineProperty(this, "contentStateForEntities", void 0);

    _defineProperty(this, "blockStack", void 0);

    _defineProperty(this, "blockList", void 0);

    _defineProperty(this, "depth", void 0);

    _defineProperty(this, "options", void 0);

    _defineProperty(this, "inlineCreators", {
      Style: function (_Style) {
        function Style(_x) {
          return _Style.apply(this, arguments);
        }

        Style.toString = function () {
          return _Style.toString();
        };

        return Style;
      }(function (style) {
        return {
          type: 'STYLE',
          style: style
        };
      }),
      Entity: function Entity(type, data) {
        var mutability = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'MUTABLE';
        return {
          type: 'ENTITY',
          entityKey: _this.createEntity(type, toStringMap(data), mutability)
        };
      }
    });

    this.options = options;
    this.contentStateForEntities = __WEBPACK_IMPORTED_MODULE_1_draft_js__["ContentState"].createFromBlockArray([]); // This represents the hierarchy as we traverse nested elements; for
    // example [body, ul, li] where we must know li's parent type (ul or ol).

    this.blockStack = []; // This is a linear list of blocks that will form the output; for example
    // [p, li, li, blockquote].

    this.blockList = [];
    this.depth = 0;
  }

  _createClass(ContentGenerator, [{
    key: "process",
    value: function process(element) {
      this.processBlockElement(element);
      var contentBlocks = [];
      this.blockList.forEach(function (block) {
        var _concatFragments = concatFragments(block.textFragments),
            text = _concatFragments.text,
            characterMeta = _concatFragments.characterMeta;

        var includeEmptyBlock = false; // If the block contains only a soft break then don't discard the block,
        // but discard the soft break.

        if (text === SOFT_BREAK_PLACEHOLDER) {
          includeEmptyBlock = true;
          text = '';
        }

        if (block.tagName === 'pre') {
          var _trimLeadingNewline = trimLeadingNewline(text, characterMeta);

          text = _trimLeadingNewline.text;
          characterMeta = _trimLeadingNewline.characterMeta;
        } else {
          var _collapseWhiteSpace = collapseWhiteSpace(text, characterMeta);

          text = _collapseWhiteSpace.text;
          characterMeta = _collapseWhiteSpace.characterMeta;
        } // Previously we were using a placeholder for soft breaks. Now that we
        // have collapsed whitespace we can change it back to normal line breaks.


        text = text.split(SOFT_BREAK_PLACEHOLDER).join('\n'); // Discard empty blocks (unless otherwise specified).

        if (text.length || includeEmptyBlock) {
          contentBlocks.push(new __WEBPACK_IMPORTED_MODULE_1_draft_js__["ContentBlock"]({
            key: Object(__WEBPACK_IMPORTED_MODULE_1_draft_js__["genKey"])(),
            text: text,
            type: block.type,
            characterList: characterMeta.toList(),
            depth: block.depth,
            data: block.data ? Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])(block.data) : Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()
          }));
        }
      });

      if (!contentBlocks.length) {
        contentBlocks = [EMPTY_BLOCK];
      }

      return __WEBPACK_IMPORTED_MODULE_1_draft_js__["ContentState"].createFromBlockArray(contentBlocks, this.contentStateForEntities.getEntityMap());
    }
  }, {
    key: "getBlockTypeFromTagName",
    value: function getBlockTypeFromTagName(tagName) {
      var blockTypes = this.options.blockTypes;

      if (blockTypes && blockTypes[tagName]) {
        return blockTypes[tagName];
      }

      switch (tagName) {
        case 'li':
          {
            var parent = this.blockStack.slice(-1)[0];
            return parent.tagName === 'ol' ? __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].ORDERED_LIST_ITEM : __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].UNORDERED_LIST_ITEM;
          }

        case 'blockquote':
          {
            return __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].BLOCKQUOTE;
          }

        case 'h1':
          {
            return __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].HEADER_ONE;
          }

        case 'h2':
          {
            return __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].HEADER_TWO;
          }

        case 'h3':
          {
            return __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].HEADER_THREE;
          }

        case 'h4':
          {
            return __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].HEADER_FOUR;
          }

        case 'h5':
          {
            return __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].HEADER_FIVE;
          }

        case 'h6':
          {
            return __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].HEADER_SIX;
          }

        case 'pre':
          {
            return __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].CODE;
          }

        case 'figure':
          {
            return __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].ATOMIC;
          }

        default:
          {
            return __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].UNSTYLED;
          }
      }
    }
  }, {
    key: "processBlockElement",
    value: function processBlockElement(element) {
      if (!element) {
        return;
      }

      var customBlockFn = this.options.customBlockFn;
      var tagName = element.nodeName.toLowerCase();
      var type;
      var data;

      if (customBlockFn) {
        var customBlock = customBlockFn(element);

        if (customBlock != null) {
          type = customBlock.type;
          data = customBlock.data;
        }
      }

      var isCustomType = true;

      if (type == null) {
        isCustomType = false;
        type = this.getBlockTypeFromTagName(tagName);
      }

      if (type === __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].CODE) {
        var language = element.getAttribute('data-language');

        if (language) {
          data = _objectSpread({}, data, {
            language: language
          });
        }
      }

      var hasDepth = canHaveDepth(type);
      var allowRender = !__WEBPACK_IMPORTED_MODULE_5__lib_Constants__["c" /* SPECIAL_ELEMENTS */].hasOwnProperty(tagName);

      if (!isCustomType && !hasSemanticMeaning(type)) {
        var parent = this.blockStack.slice(-1)[0];

        if (parent) {
          type = parent.type;
        }
      }

      var block = {
        tagName: tagName,
        textFragments: [],
        type: type,
        styleStack: [NO_STYLE],
        entityStack: [NO_ENTITY],
        depth: hasDepth ? this.depth : 0,
        data: data
      };

      if (allowRender) {
        this.blockList.push(block);

        if (hasDepth) {
          this.depth += 1;
        }
      }

      this.blockStack.push(block);

      if (element.childNodes != null) {
        Array.from(element.childNodes).forEach(this.processNode, this);
      }

      this.blockStack.pop();

      if (allowRender && hasDepth) {
        this.depth -= 1;
      }
    }
  }, {
    key: "processInlineElement",
    value: function processInlineElement(element) {
      var tagName = element.nodeName.toLowerCase();

      if (tagName === 'br') {
        this.processText(SOFT_BREAK_PLACEHOLDER);
        return;
      }

      var block = this.blockStack.slice(-1)[0];
      var style = block.styleStack.slice(-1)[0];
      var entityKey = block.entityStack.slice(-1)[0];
      var customInlineFn = this.options.customInlineFn;
      var customInline = customInlineFn ? customInlineFn(element, this.inlineCreators) : null;

      if (customInline != null) {
        switch (customInline.type) {
          case 'STYLE':
            {
              style = style.add(customInline.style);
              break;
            }

          case 'ENTITY':
            {
              entityKey = customInline.entityKey;
              break;
            }
        }
      } else {
        style = addStyleFromTagName(style, tagName, this.options.elementStyles);

        if (ElementToEntity.hasOwnProperty(tagName)) {
          // If the to-entity function returns nothing, use the existing entity.
          entityKey = ElementToEntity[tagName](this, tagName, element) || entityKey;
        }
      }

      block.styleStack.push(style);
      block.entityStack.push(entityKey);

      if (element.childNodes != null) {
        Array.from(element.childNodes).forEach(this.processNode, this);
      }

      if (__WEBPACK_IMPORTED_MODULE_5__lib_Constants__["b" /* SELF_CLOSING_ELEMENTS */].hasOwnProperty(tagName)) {
        this.processText("\xA0");
      }

      block.entityStack.pop();
      block.styleStack.pop();
    }
  }, {
    key: "processTextNode",
    value: function processTextNode(node) {
      var text = node.nodeValue; // This is important because we will use \r as a placeholder for a soft break.

      text = text.replace(LINE_BREAKS, '\n'); // Replace zero-width space (we use it as a placeholder in markdown) with a
      // soft break.
      // TODO: The import-markdown package should correctly turn breaks into <br>
      // elements so we don't need to include this hack.

      text = text.split(ZERO_WIDTH_SPACE).join(SOFT_BREAK_PLACEHOLDER);
      this.processText(text);
    }
  }, {
    key: "processText",
    value: function processText(text) {
      var block = this.blockStack.slice(-1)[0];
      var style = block.styleStack.slice(-1)[0];
      var entity = block.entityStack.slice(-1)[0];
      var charMetadata = __WEBPACK_IMPORTED_MODULE_1_draft_js__["CharacterMetadata"].create({
        style: style,
        entity: entity
      });
      var seq = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Repeat"])(charMetadata, text.length);
      block.textFragments.push({
        text: text,
        characterMeta: seq
      });
    }
  }, {
    key: "processNode",
    value: function processNode(node) {
      if (node.nodeType === __WEBPACK_IMPORTED_MODULE_4_synthetic_dom__["a" /* NODE_TYPE_ELEMENT */]) {
        // $FlowIssue
        var _element = node;

        var _tagName = _element.nodeName.toLowerCase();

        if (__WEBPACK_IMPORTED_MODULE_5__lib_Constants__["a" /* INLINE_ELEMENTS */].hasOwnProperty(_tagName)) {
          this.processInlineElement(_element);
        } else {
          this.processBlockElement(_element);
        }
      } else if (node.nodeType === __WEBPACK_IMPORTED_MODULE_4_synthetic_dom__["b" /* NODE_TYPE_TEXT */]) {
        this.processTextNode(node);
      }
    }
  }, {
    key: "createEntity",
    value: function createEntity(type, data) {
      var mutability = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'MUTABLE';
      this.contentStateForEntities = this.contentStateForEntities.createEntity(type, mutability, data);
      return this.contentStateForEntities.getLastCreatedEntityKey();
    }
  }]);

  return ContentGenerator;
}();

function trimLeadingNewline(text, characterMeta) {
  if (text.charAt(0) === '\n') {
    text = text.slice(1);
    characterMeta = characterMeta.slice(1);
  }

  return {
    text: text,
    characterMeta: characterMeta
  };
}

function trimLeadingSpace(text, characterMeta) {
  while (text.charAt(0) === ' ') {
    text = text.slice(1);
    characterMeta = characterMeta.slice(1);
  }

  return {
    text: text,
    characterMeta: characterMeta
  };
}

function trimTrailingSpace(text, characterMeta) {
  while (text.slice(-1) === ' ') {
    text = text.slice(0, -1);
    characterMeta = characterMeta.slice(0, -1);
  }

  return {
    text: text,
    characterMeta: characterMeta
  };
}

function collapseWhiteSpace(text, characterMeta) {
  text = text.replace(/[ \t\n]/g, ' ');

  var _trimLeadingSpace = trimLeadingSpace(text, characterMeta);

  text = _trimLeadingSpace.text;
  characterMeta = _trimLeadingSpace.characterMeta;

  var _trimTrailingSpace = trimTrailingSpace(text, characterMeta);

  text = _trimTrailingSpace.text;
  characterMeta = _trimTrailingSpace.characterMeta;
  var i = text.length;

  while (i--) {
    if (text.charAt(i) === ' ' && text.charAt(i - 1) === ' ') {
      text = text.slice(0, i) + text.slice(i + 1);
      characterMeta = characterMeta.slice(0, i).concat(characterMeta.slice(i + 1));
    }
  } // There could still be one space on either side of a softbreak.


  var _replaceTextWithMeta = Object(__WEBPACK_IMPORTED_MODULE_0__lib_replaceTextWithMeta__["a" /* default */])({
    text: text,
    characterMeta: characterMeta
  }, SOFT_BREAK_PLACEHOLDER + ' ', SOFT_BREAK_PLACEHOLDER);

  text = _replaceTextWithMeta.text;
  characterMeta = _replaceTextWithMeta.characterMeta;

  var _replaceTextWithMeta2 = Object(__WEBPACK_IMPORTED_MODULE_0__lib_replaceTextWithMeta__["a" /* default */])({
    text: text,
    characterMeta: characterMeta
  }, ' ' + SOFT_BREAK_PLACEHOLDER, SOFT_BREAK_PLACEHOLDER);

  text = _replaceTextWithMeta2.text;
  characterMeta = _replaceTextWithMeta2.characterMeta;
  return {
    text: text,
    characterMeta: characterMeta
  };
}

function canHaveDepth(blockType) {
  switch (blockType) {
    case __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].UNORDERED_LIST_ITEM:
    case __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].ORDERED_LIST_ITEM:
      {
        return true;
      }

    default:
      {
        return false;
      }
  }
}

function concatFragments(fragments) {
  var text = '';
  var characterMeta = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Seq"])();
  fragments.forEach(function (textFragment) {
    text = text + textFragment.text;
    characterMeta = characterMeta.concat(textFragment.characterMeta);
  });
  return {
    text: text,
    characterMeta: characterMeta
  };
}

function addStyleFromTagName(styleSet, tagName, elementStyles) {
  switch (tagName) {
    case 'b':
    case 'strong':
      {
        return styleSet.add(__WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["c" /* INLINE_STYLE */].BOLD);
      }

    case 'i':
    case 'em':
      {
        return styleSet.add(__WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["c" /* INLINE_STYLE */].ITALIC);
      }

    case 'u':
    case 'ins':
      {
        return styleSet.add(__WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["c" /* INLINE_STYLE */].UNDERLINE);
      }

    case 'code':
      {
        return styleSet.add(__WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["c" /* INLINE_STYLE */].CODE);
      }

    case 's':
    case 'del':
      {
        return styleSet.add(__WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["c" /* INLINE_STYLE */].STRIKETHROUGH);
      }

    default:
      {
        // Allow custom styles to be provided.
        if (elementStyles && elementStyles[tagName]) {
          return styleSet.add(elementStyles[tagName]);
        }

        return styleSet;
      }
  }
}

function hasSemanticMeaning(blockType) {
  return blockType !== __WEBPACK_IMPORTED_MODULE_3_draft_js_utils__["a" /* BLOCK_TYPE */].UNSTYLED;
}

function toStringMap(input) {
  var result = {};

  if (input !== null && _typeof(input) === 'object' && !Array.isArray(input)) {
    var obj = input;

    for (var _i = 0, _Object$keys = Object.keys(obj); _i < _Object$keys.length; _i++) {
      var _key = _Object$keys[_i];
      var value = obj[_key];

      if (typeof value === 'string') {
        result[_key] = value;
      }
    }
  }

  return result;
}

function isAllowedHref(input) {
  if (input == null || input.match(DATA_URL)) {
    return false;
  } else {
    return true;
  }
}

function stateFromElement(element, options) {
  return new ContentGenerator(options).process(element);
}
/* unused harmony default export */ var _unused_webpack_default_export = (stateFromElement);

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = replaceTextWithMeta;
function replaceTextWithMeta(subject, searchText, replaceText) {
  var text = subject.text,
      characterMeta = subject.characterMeta;
  var searchTextLength = searchText.length;
  var replaceTextLength = replaceText.length;
  var resultTextParts = []; // Get empty set of same kind as characterMeta.

  var resultCharMeta = characterMeta.slice(0, 0);
  var lastEndIndex = 0;
  var index = text.indexOf(searchText);

  while (index !== -1) {
    resultTextParts.push(text.slice(lastEndIndex, index) + replaceText);
    resultCharMeta = resultCharMeta.concat(characterMeta.slice(lastEndIndex, index), // Use the metadata of the first char we are replacing.
    repeatSeq(characterMeta.slice(index, index + 1), replaceTextLength));
    lastEndIndex = index + searchTextLength;
    index = text.indexOf(searchText, lastEndIndex);
  }

  resultTextParts.push(text.slice(lastEndIndex));
  resultCharMeta = resultCharMeta.concat(characterMeta.slice(lastEndIndex));
  return {
    text: resultTextParts.join(''),
    characterMeta: resultCharMeta
  };
}

function repeatSeq(seq, count) {
  var result = seq.slice(0, 0);

  while (count-- > 0) {
    result = result.concat(seq);
  }

  return result;
}

/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SyntheticDOM__ = __webpack_require__(1025);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SyntheticDOM__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__SyntheticDOM__["b"]; });


/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NODE_TYPE_ELEMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NODE_TYPE_TEXT; });
/* unused harmony export NODE_TYPE_FRAGMENT */
/* unused harmony export SELF_CLOSING */
/* unused harmony export Node */
/* unused harmony export TextNode */
/* unused harmony export ElementNode */
/* unused harmony export FragmentNode */
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var EMPTY_ATTR_LIST = [];
var NODE_TYPE_ELEMENT = 1;
var NODE_TYPE_TEXT = 3;
var NODE_TYPE_FRAGMENT = 11;
var SELF_CLOSING = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
};
var Node =
/*#__PURE__*/
function () {
  function Node() {
    _classCallCheck(this, Node);

    _defineProperty(this, "nodeType", void 0);

    _defineProperty(this, "nodeName", void 0);

    _defineProperty(this, "nodeValue", void 0);

    _defineProperty(this, "childNodes", void 0);
  }

  _createClass(Node, [{
    key: "toString",
    value: function toString(isXHTML) {
      return isXHTML ? '' : '';
    }
  }]);

  return Node;
}();
var TextNode =
/*#__PURE__*/
function (_Node) {
  _inherits(TextNode, _Node);

  function TextNode(value) {
    var _this;

    _classCallCheck(this, TextNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextNode).apply(this, arguments));
    _this.nodeType = NODE_TYPE_TEXT;
    _this.nodeName = '#text';
    _this.nodeValue = value;
    return _this;
  } // eslint-disable-next-line no-unused-vars


  _createClass(TextNode, [{
    key: "toString",
    value: function toString(isXHTML) {
      return escape(this.nodeValue);
    }
  }]);

  return TextNode;
}(Node);
var ElementNode =
/*#__PURE__*/
function (_Node2) {
  _inherits(ElementNode, _Node2);

  function ElementNode(name, attributes, childNodes) {
    var _this2;

    _classCallCheck(this, ElementNode);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(ElementNode).apply(this, arguments));

    _defineProperty(_assertThisInitialized(_this2), "_name", void 0);

    _defineProperty(_assertThisInitialized(_this2), "_attrMap", void 0);

    _defineProperty(_assertThisInitialized(_this2), "_isSelfClosing", void 0);

    _defineProperty(_assertThisInitialized(_this2), "childNodes", void 0);

    _defineProperty(_assertThisInitialized(_this2), "attributes", void 0);

    if (attributes == null) {
      attributes = EMPTY_ATTR_LIST;
    }

    var isSelfClosing = SELF_CLOSING[name] === true;
    _this2.nodeType = NODE_TYPE_ELEMENT;
    _this2._name = name.toLowerCase();
    _this2.attributes = attributes;
    _this2._attrMap = new Map(attributes.map(function (attr) {
      return [attr.name, attr];
    }));
    _this2.nodeName = name.toUpperCase();
    _this2.childNodes = [];
    _this2._isSelfClosing = isSelfClosing;

    if (!isSelfClosing && childNodes) {
      childNodes.forEach(_this2.appendChild, _assertThisInitialized(_this2));
    }

    return _this2;
  }

  _createClass(ElementNode, [{
    key: "appendChild",
    value: function appendChild(node) {
      if (node.nodeType === NODE_TYPE_FRAGMENT && node.childNodes) {
        var _this$childNodes;

        this.childNodes && (_this$childNodes = this.childNodes).push.apply(_this$childNodes, _toConsumableArray(node.childNodes));
      } else {
        this.childNodes && this.childNodes.push(node);
      }
    }
  }, {
    key: "getAttribute",
    value: function getAttribute(name) {
      var attr = this._attrMap.get(name);

      if (attr) {
        return attr.value;
      }
    }
  }, {
    key: "toString",
    value: function toString(isXHTML) {
      var attributes = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.attributes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _step$value = _step.value,
              name = _step$value.name,
              value = _step$value.value;
          attributes.push(name + (value ? '="' + escapeAttr(value) + '"' : ''));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var attrString = attributes.length ? ' ' + attributes.join(' ') : '';

      if (this._isSelfClosing) {
        return '<' + this._name + attrString + (isXHTML ? '/>' : '>');
      }

      var childNodes = this.childNodes ? this.childNodes.map(function (node) {
        return node.toString(isXHTML);
      }).join('') : '';
      return '<' + this._name + attrString + '>' + childNodes + '</' + this._name + '>';
    }
  }, {
    key: "tagName",
    get: function get() {
      return this.nodeName;
    }
  }, {
    key: "className",
    get: function get() {
      return this.getAttribute('class') || '';
    }
  }]);

  return ElementNode;
}(Node);
var FragmentNode =
/*#__PURE__*/
function (_Node3) {
  _inherits(FragmentNode, _Node3);

  function FragmentNode(childNodes) {
    var _this3;

    _classCallCheck(this, FragmentNode);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(FragmentNode).apply(this, arguments));

    _defineProperty(_assertThisInitialized(_this3), "childNodes", void 0);

    _this3.nodeType = NODE_TYPE_FRAGMENT;
    _this3.childNodes = [];

    if (childNodes) {
      childNodes.forEach(_this3.appendChild, _assertThisInitialized(_this3));
    }

    return _this3;
  }

  _createClass(FragmentNode, [{
    key: "appendChild",
    value: function appendChild(node) {
      if (node.nodeType === NODE_TYPE_FRAGMENT && node.childNodes) {
        var _this$childNodes2;

        this.childNodes && (_this$childNodes2 = this.childNodes).push.apply(_this$childNodes2, _toConsumableArray(node.childNodes));
      } else {
        this.childNodes && this.childNodes.push(node);
      }
    }
  }, {
    key: "toString",
    value: function toString(isXHTML) {
      var childNodes = this.childNodes;
      return childNodes ? childNodes.map(function (node) {
        return node.toString(isXHTML);
      }).join('') : '';
    }
  }]);

  return FragmentNode;
}(Node);

function escape(html) {
  return html.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function escapeAttr(html) {
  return html.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INLINE_ELEMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SPECIAL_ELEMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SELF_CLOSING_ELEMENTS; });
var INLINE_ELEMENTS = {
  a: 1,
  abbr: 1,
  area: 1,
  audio: 1,
  b: 1,
  bdi: 1,
  bdo: 1,
  br: 1,
  button: 1,
  canvas: 1,
  cite: 1,
  code: 1,
  command: 1,
  datalist: 1,
  del: 1,
  dfn: 1,
  em: 1,
  embed: 1,
  i: 1,
  iframe: 1,
  img: 1,
  input: 1,
  ins: 1,
  kbd: 1,
  keygen: 1,
  label: 1,
  map: 1,
  mark: 1,
  meter: 1,
  noscript: 1,
  object: 1,
  output: 1,
  progress: 1,
  q: 1,
  ruby: 1,
  s: 1,
  samp: 1,
  script: 1,
  select: 1,
  small: 1,
  span: 1,
  strong: 1,
  sub: 1,
  sup: 1,
  textarea: 1,
  time: 1,
  u: 1,
  "var": 1,
  video: 1,
  wbr: 1,
  acronym: 1,
  applet: 1,
  basefont: 1,
  big: 1,
  font: 1,
  isindex: 1,
  strike: 1,
  style: 1,
  tt: 1
}; // These elements are special because they cannot contain text as a direct
// child (some cannot contain childNodes at all).

var SPECIAL_ELEMENTS = {
  area: 1,
  base: 1,
  br: 1,
  col: 1,
  colgroup: 1,
  command: 1,
  dl: 1,
  embed: 1,
  head: 1,
  hgroup: 1,
  hr: 1,
  iframe: 1,
  img: 1,
  input: 1,
  keygen: 1,
  link: 1,
  meta: 1,
  ol: 1,
  optgroup: 1,
  option: 1,
  param: 1,
  script: 1,
  select: 1,
  source: 1,
  style: 1,
  table: 1,
  tbody: 1,
  textarea: 1,
  tfoot: 1,
  thead: 1,
  title: 1,
  tr: 1,
  track: 1,
  ul: 1,
  wbr: 1,
  basefont: 1,
  dialog: 1,
  dir: 1,
  isindex: 1
}; // These elements are special because they cannot contain childNodes.
// TODO: This is not an exhaustive list.

var SELF_CLOSING_ELEMENTS = {
  img: 1
};

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseHTML;
function parseHTML(html) {
  var doc;

  if (typeof DOMParser !== 'undefined') {
    var parser = new DOMParser();
    doc = parser.parseFromString(html, 'text/html');
  } else {
    doc = document.implementation.createHTMLDocument('');

    if (doc.documentElement) {
      doc.documentElement.innerHTML = html;
    }
  } // This makes Flow happy


  return doc.body || doc.createElement('body');
}

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  name: "identify",
  fields: [{
    name: "title"
  }, {
    optional: true,
    name: "owner"
  }, {
    name: "type",
    options: [{ value: "Threat" }, { value: "Opportunity" }]
  }, {
    name: "category",
    options: [{ value: "Time" }, { value: "Cost" }, { value: "Scope" }, { value: "Quality" }, { value: "Benefit" }, { value: "Risk" }]
  }, {
    optional: true,
    name: "cause",
    height: 2,
    plainText: true
  }, {
    optional: true,
    name: "event",
    height: 2,
    plainText: true
  }, {
    optional: true,
    name: "effect",
    height: 2,
    plainText: true
  }]
}, {
  name: "assess",
  fields: [{ name: "assessment",
    type: "matrix",
    categories: [{ name: "inherent" }, { name: "residual" }],
    fields: [{
      name: "impact",
      matrixType: "column",
      options: [{ value: 1 }, { value: 2 }, { value: 3 }, { value: 4 }, { value: 5 }].reverse(), defaultValue: "1"
    }, {
      name: "probability",
      matrixType: "row",
      options: [{ value: 1 }, { value: 2 }, { value: 3 }, { value: 4 }, { value: 5 }].reverse(), defaultValue: "1"
    }]
  }, { name: "impact",
    options: [{ value: 1 }, { value: 2 }, { value: 3 }, { value: 4 }, { value: 5 }].reverse(), defaultValue: "1"
  }, {
    name: "probability",
    options: [{ value: 1 }, { value: 2 }, { value: 3 }, { value: 4 }, { value: 5 }].reverse(), defaultValue: "1"
  }, {
    optional: true,
    name: "proximity"
  }]
}, {
  name: "plan",
  fields: [{
    name: "response",
    options: [{ value: "Avoid" }, { value: "Reduce" }, { value: "Transfer" }, { value: "Accept" }, { value: "Share" }, { value: "Enhance" }, { value: "Exploit" }, { value: "ContingencyPlan" }]
  }, { name: "actionee" }, { name: "action", height: 3 }]
}, {
  name: "implement",
  fields: [{ name: "status", options: [{ value: "Active" }, { value: "Closed" }] }, { name: "comments", height: 3 }]
}];

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _AreaForm = __webpack_require__(28);

var _AreaForm2 = _interopRequireDefault(_AreaForm);

var _Diff = __webpack_require__(415);

var _Diff2 = _interopRequireDefault(_Diff);

var _IssueMenu = __webpack_require__(1031);

var _IssueMenu2 = _interopRequireDefault(_IssueMenu);

var _IssueReportPreview = __webpack_require__(1032);

var _IssueReportPreview2 = _interopRequireDefault(_IssueReportPreview);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

var _formDefinition = __webpack_require__(1035);

var _formDefinition2 = _interopRequireDefault(_formDefinition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(72), __webpack_require__(73)]);

var ExamineSummary = function (_React$Component) {
  _inherits(ExamineSummary, _React$Component);

  function ExamineSummary() {
    _classCallCheck(this, ExamineSummary);

    return _possibleConstructorReturn(this, (ExamineSummary.__proto__ || Object.getPrototypeOf(ExamineSummary)).apply(this, arguments));
  }

  _createClass(ExamineSummary, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).general.examineDetails;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { fontSize: "12pt" } },
          _react2.default.createElement(
            'b',
            null,
            this.props.no !== undefined ? this.props.no + ". " : null,
            _react2.default.createElement(_Diff2.default, { newValue: this.props.title, value: this.props._original.title })
          )
        ),
        _react2.default.createElement(
          'div',
          null,
          '(',
          _react2.default.createElement(_Diff2.default, { newValue: labels.typeValues[this.props.type], value: labels.typeValues[this.props._original.type] }),
          ')'
        ),
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 5 } },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'b',
              null,
              labels.description,
              ':'
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'i',
              null,
              _react2.default.createElement(_Diff2.default, { newValue: this.props.description, value: this.props._original.description })
            )
          )
        )
      );
    }
  }]);

  return ExamineSummary;
}(_react2.default.Component);

var ProposeSummary = function (_React$Component2) {
  _inherits(ProposeSummary, _React$Component2);

  function ProposeSummary() {
    _classCallCheck(this, ProposeSummary);

    return _possibleConstructorReturn(this, (ProposeSummary.__proto__ || Object.getPrototypeOf(ProposeSummary)).apply(this, arguments));
  }

  _createClass(ProposeSummary, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).general.proposeDetails;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(ExamineSummary, this.props),
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 5 } },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'b',
              null,
              labels.impact,
              ':'
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'i',
              null,
              _react2.default.createElement(_Diff2.default, { newValue: this.props.impact, value: this.props._original.impact })
            )
          )
        )
      );
    }
  }]);

  return ProposeSummary;
}(_react2.default.Component);

var DecideSummary = function (_React$Component3) {
  _inherits(DecideSummary, _React$Component3);

  function DecideSummary() {
    _classCallCheck(this, DecideSummary);

    return _possibleConstructorReturn(this, (DecideSummary.__proto__ || Object.getPrototypeOf(DecideSummary)).apply(this, arguments));
  }

  _createClass(DecideSummary, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).general.decideDetails;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(ProposeSummary, this.props),
        this.props.options !== undefined || this.props._original.options !== undefined ? _react2.default.createElement(
          'div',
          { style: { paddingTop: 5 } },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'b',
              null,
              labels.options,
              ':'
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'i',
              null,
              _react2.default.createElement(_Diff2.default, { newValue: this.props.options, value: this.props._original.options })
            )
          )
        ) : null,
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 5 } },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'b',
              null,
              labels.recommendation,
              ':'
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'i',
              null,
              _react2.default.createElement(_Diff2.default, { newValue: this.props.recommendation, value: this.props._original.recommendation })
            )
          )
        )
      );
    }
  }]);

  return DecideSummary;
}(_react2.default.Component);

var ImplementSummary = function (_React$Component4) {
  _inherits(ImplementSummary, _React$Component4);

  function ImplementSummary() {
    _classCallCheck(this, ImplementSummary);

    return _possibleConstructorReturn(this, (ImplementSummary.__proto__ || Object.getPrototypeOf(ImplementSummary)).apply(this, arguments));
  }

  _createClass(ImplementSummary, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).general.implementDetails;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(ExamineSummary, this.props),
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 5 } },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'b',
              null,
              labels.decision,
              ':'
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'i',
              null,
              _react2.default.createElement(_Diff2.default, { newValue: this.props.decision, value: this.props._original.decision })
            )
          )
        )
      );
    }
  }]);

  return ImplementSummary;
}(_react2.default.Component);

var IssueForm = function (_React$Component5) {
  _inherits(IssueForm, _React$Component5);

  function IssueForm(props) {
    _classCallCheck(this, IssueForm);

    var _this5 = _possibleConstructorReturn(this, (IssueForm.__proto__ || Object.getPrototypeOf(IssueForm)).call(this, props));

    _this5.state = { showPreview: false, item: props.item };
    return _this5;
  }

  _createClass(IssueForm, [{
    key: 'tabSummary',
    value: function tabSummary(tab, details) {
      var content = undefined;
      var values = details.values;
      var originalValues = details.oldValues;
      switch (tab) {
        case "Examine":
          content = _react2.default.createElement(ExamineSummary, _extends({}, values, { _original: originalValues, language: this.props.language }));
          break;
        case "Propose":
          content = _react2.default.createElement(ProposeSummary, _extends({}, values, { _original: originalValues, language: this.props.language }));
          break;
        case "Decide":
          content = _react2.default.createElement(DecideSummary, _extends({}, values, { _original: originalValues, language: this.props.language }));
          break;
        case "Implement":
          content = _react2.default.createElement(ImplementSummary, _extends({}, values, { _original: originalValues, language: this.props.language }));
          break;
        default:
          content = undefined;
      }
      return content !== undefined ? _react2.default.createElement(
        'div',
        { style: { fontFamily: "Arial", fontSize: "10pt", padding: 10 } },
        content
      ) : null;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState({ modified: undefined, item: props.item });
    }
  }, {
    key: 'showReportPreview',
    value: function showReportPreview(event) {
      event.preventDefault();
      this.setState({ showPreview: !this.state.showPreview, reportType: undefined });
    }
  }, {
    key: 'showExceptionReportPreview',
    value: function showExceptionReportPreview(event) {
      event.preventDefault();
      this.setState({ showPreview: !this.state.showPreview, reportType: "exception" });
    }
  }, {
    key: 'createIssueReport',
    value: function createIssueReport(event) {
      event.preventDefault();
      if (this.props.createReport !== undefined) {
        this.props.createReport(this.props.item, this.state.reportType === "exception");
      } else {
        window.alert("Publish is not supported");
        this.setState({ showPreview: !this.state.showPreview });
      }
    }
  }, {
    key: 'handleFieldChange',
    value: function handleFieldChange(fieldName) {
      var _this6 = this;

      return function (event) {
        _this6.setState({
          item: Object.assign({}, _this6.state.item, _defineProperty({}, event.target.name, event.target.value)),
          modified: true
        });
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props.language, this.props.variant);
      var areas = translations.createTranslatedForm(_formDefinition2.default, this.props.language, this.props.variant);
      return _react2.default.createElement(
        'div',
        null,
        this.state.showPreview ? _react2.default.createElement(_IssueReportPreview2.default, _extends({}, this.props, {
          cancel: this.showReportPreview.bind(this),
          publish: this.createIssueReport.bind(this),
          issue: this.props.item,
          exception: this.state.reportType === "exception"
        })) : _react2.default.createElement(
          'div',
          null,
          this.props.item !== undefined && this.props.hideMenu !== true ? _react2.default.createElement(_IssueMenu2.default, _extends({}, this.props, this.props.item, {
            createReport: this.showReportPreview.bind(this),
            createExceptionReport: this.showExceptionReportPreview.bind(this)
          })) : null,
          _react2.default.createElement(
            'div',
            { style: { display: "flex", justifyContent: "center" } },
            _react2.default.createElement(
              'div',
              { style: { backgroundColor: "white", padding: 20, borderRadius: 10, width: 1016 } },
              _react2.default.createElement(_AreaForm2.default, _extends({}, this.props, {
                areas: areas,
                display: 'tab',
                label: labels.issue,
                summary: this.tabSummary.bind(this),
                updatedItem: this.state.item,
                modified: this.state.modified,
                handleFieldChange: this.handleFieldChange.bind(this)
              }))
            )
          )
        )
      );
    }
  }]);

  return IssueForm;
}(_react2.default.Component);

exports.default = IssueForm;

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

/*!

 diff v3.5.0

Software License Agreement (BSD License)

Copyright (c) 2009-2015, Kevin Decker <kpdecker@gmail.com>

All rights reserved.

Redistribution and use of this software in source and binary forms, with or without modification,
are permitted provided that the following conditions are met:

* Redistributions of source code must retain the above
  copyright notice, this list of conditions and the
  following disclaimer.

* Redistributions in binary form must reproduce the above
  copyright notice, this list of conditions and the
  following disclaimer in the documentation and/or other
  materials provided with the distribution.

* Neither the name of Kevin Decker nor the names of its
  contributors may be used to endorse or promote products
  derived from this software without specific prior
  written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR
IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR
CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER
IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT
OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
@license
*/
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["JsDiff"] = factory();
	else
		root["JsDiff"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';

	exports.__esModule = true;
	exports.canonicalize = exports.convertChangesToXML = exports.convertChangesToDMP = exports.merge = exports.parsePatch = exports.applyPatches = exports.applyPatch = exports.createPatch = exports.createTwoFilesPatch = exports.structuredPatch = exports.diffArrays = exports.diffJson = exports.diffCss = exports.diffSentences = exports.diffTrimmedLines = exports.diffLines = exports.diffWordsWithSpace = exports.diffWords = exports.diffChars = exports.Diff = undefined;

	/*istanbul ignore end*/var /*istanbul ignore start*/_base = __webpack_require__(1) /*istanbul ignore end*/;

	/*istanbul ignore start*/var _base2 = _interopRequireDefault(_base);

	/*istanbul ignore end*/var /*istanbul ignore start*/_character = __webpack_require__(2) /*istanbul ignore end*/;

	var /*istanbul ignore start*/_word = __webpack_require__(3) /*istanbul ignore end*/;

	var /*istanbul ignore start*/_line = __webpack_require__(5) /*istanbul ignore end*/;

	var /*istanbul ignore start*/_sentence = __webpack_require__(6) /*istanbul ignore end*/;

	var /*istanbul ignore start*/_css = __webpack_require__(7) /*istanbul ignore end*/;

	var /*istanbul ignore start*/_json = __webpack_require__(8) /*istanbul ignore end*/;

	var /*istanbul ignore start*/_array = __webpack_require__(9) /*istanbul ignore end*/;

	var /*istanbul ignore start*/_apply = __webpack_require__(10) /*istanbul ignore end*/;

	var /*istanbul ignore start*/_parse = __webpack_require__(11) /*istanbul ignore end*/;

	var /*istanbul ignore start*/_merge = __webpack_require__(13) /*istanbul ignore end*/;

	var /*istanbul ignore start*/_create = __webpack_require__(14) /*istanbul ignore end*/;

	var /*istanbul ignore start*/_dmp = __webpack_require__(16) /*istanbul ignore end*/;

	var /*istanbul ignore start*/_xml = __webpack_require__(17) /*istanbul ignore end*/;

	/*istanbul ignore start*/function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	/* See LICENSE file for terms of use */

	/*
	 * Text diff implementation.
	 *
	 * This library supports the following APIS:
	 * JsDiff.diffChars: Character by character diff
	 * JsDiff.diffWords: Word (as defined by \b regex) diff which ignores whitespace
	 * JsDiff.diffLines: Line based diff
	 *
	 * JsDiff.diffCss: Diff targeted at CSS content
	 *
	 * These methods are based on the implementation proposed in
	 * "An O(ND) Difference Algorithm and its Variations" (Myers, 1986).
	 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.4.6927
	 */
	exports. /*istanbul ignore end*/Diff = _base2['default'];
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffChars = _character.diffChars;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffWords = _word.diffWords;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffWordsWithSpace = _word.diffWordsWithSpace;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffLines = _line.diffLines;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffTrimmedLines = _line.diffTrimmedLines;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffSentences = _sentence.diffSentences;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffCss = _css.diffCss;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffJson = _json.diffJson;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffArrays = _array.diffArrays;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/structuredPatch = _create.structuredPatch;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/createTwoFilesPatch = _create.createTwoFilesPatch;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/createPatch = _create.createPatch;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/applyPatch = _apply.applyPatch;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/applyPatches = _apply.applyPatches;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/parsePatch = _parse.parsePatch;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/merge = _merge.merge;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/convertChangesToDMP = _dmp.convertChangesToDMP;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/convertChangesToXML = _xml.convertChangesToXML;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/canonicalize = _json.canonicalize;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	/*istanbul ignore start*/'use strict';

	exports.__esModule = true;
	exports['default'] = /*istanbul ignore end*/Diff;
	function Diff() {}

	Diff.prototype = {
	  /*istanbul ignore start*/ /*istanbul ignore end*/diff: function diff(oldString, newString) {
	    /*istanbul ignore start*/var /*istanbul ignore end*/options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	    var callback = options.callback;
	    if (typeof options === 'function') {
	      callback = options;
	      options = {};
	    }
	    this.options = options;

	    var self = this;

	    function done(value) {
	      if (callback) {
	        setTimeout(function () {
	          callback(undefined, value);
	        }, 0);
	        return true;
	      } else {
	        return value;
	      }
	    }

	    // Allow subclasses to massage the input prior to running
	    oldString = this.castInput(oldString);
	    newString = this.castInput(newString);

	    oldString = this.removeEmpty(this.tokenize(oldString));
	    newString = this.removeEmpty(this.tokenize(newString));

	    var newLen = newString.length,
	        oldLen = oldString.length;
	    var editLength = 1;
	    var maxEditLength = newLen + oldLen;
	    var bestPath = [{ newPos: -1, components: [] }];

	    // Seed editLength = 0, i.e. the content starts with the same values
	    var oldPos = this.extractCommon(bestPath[0], newString, oldString, 0);
	    if (bestPath[0].newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
	      // Identity per the equality and tokenizer
	      return done([{ value: this.join(newString), count: newString.length }]);
	    }

	    // Main worker method. checks all permutations of a given edit length for acceptance.
	    function execEditLength() {
	      for (var diagonalPath = -1 * editLength; diagonalPath <= editLength; diagonalPath += 2) {
	        var basePath = /*istanbul ignore start*/void 0 /*istanbul ignore end*/;
	        var addPath = bestPath[diagonalPath - 1],
	            removePath = bestPath[diagonalPath + 1],
	            _oldPos = (removePath ? removePath.newPos : 0) - diagonalPath;
	        if (addPath) {
	          // No one else is going to attempt to use this value, clear it
	          bestPath[diagonalPath - 1] = undefined;
	        }

	        var canAdd = addPath && addPath.newPos + 1 < newLen,
	            canRemove = removePath && 0 <= _oldPos && _oldPos < oldLen;
	        if (!canAdd && !canRemove) {
	          // If this path is a terminal then prune
	          bestPath[diagonalPath] = undefined;
	          continue;
	        }

	        // Select the diagonal that we want to branch from. We select the prior
	        // path whose position in the new string is the farthest from the origin
	        // and does not pass the bounds of the diff graph
	        if (!canAdd || canRemove && addPath.newPos < removePath.newPos) {
	          basePath = clonePath(removePath);
	          self.pushComponent(basePath.components, undefined, true);
	        } else {
	          basePath = addPath; // No need to clone, we've pulled it from the list
	          basePath.newPos++;
	          self.pushComponent(basePath.components, true, undefined);
	        }

	        _oldPos = self.extractCommon(basePath, newString, oldString, diagonalPath);

	        // If we have hit the end of both strings, then we are done
	        if (basePath.newPos + 1 >= newLen && _oldPos + 1 >= oldLen) {
	          return done(buildValues(self, basePath.components, newString, oldString, self.useLongestToken));
	        } else {
	          // Otherwise track this path as a potential candidate and continue.
	          bestPath[diagonalPath] = basePath;
	        }
	      }

	      editLength++;
	    }

	    // Performs the length of edit iteration. Is a bit fugly as this has to support the
	    // sync and async mode which is never fun. Loops over execEditLength until a value
	    // is produced.
	    if (callback) {
	      (function exec() {
	        setTimeout(function () {
	          // This should not happen, but we want to be safe.
	          /* istanbul ignore next */
	          if (editLength > maxEditLength) {
	            return callback();
	          }

	          if (!execEditLength()) {
	            exec();
	          }
	        }, 0);
	      })();
	    } else {
	      while (editLength <= maxEditLength) {
	        var ret = execEditLength();
	        if (ret) {
	          return ret;
	        }
	      }
	    }
	  },
	  /*istanbul ignore start*/ /*istanbul ignore end*/pushComponent: function pushComponent(components, added, removed) {
	    var last = components[components.length - 1];
	    if (last && last.added === added && last.removed === removed) {
	      // We need to clone here as the component clone operation is just
	      // as shallow array clone
	      components[components.length - 1] = { count: last.count + 1, added: added, removed: removed };
	    } else {
	      components.push({ count: 1, added: added, removed: removed });
	    }
	  },
	  /*istanbul ignore start*/ /*istanbul ignore end*/extractCommon: function extractCommon(basePath, newString, oldString, diagonalPath) {
	    var newLen = newString.length,
	        oldLen = oldString.length,
	        newPos = basePath.newPos,
	        oldPos = newPos - diagonalPath,
	        commonCount = 0;
	    while (newPos + 1 < newLen && oldPos + 1 < oldLen && this.equals(newString[newPos + 1], oldString[oldPos + 1])) {
	      newPos++;
	      oldPos++;
	      commonCount++;
	    }

	    if (commonCount) {
	      basePath.components.push({ count: commonCount });
	    }

	    basePath.newPos = newPos;
	    return oldPos;
	  },
	  /*istanbul ignore start*/ /*istanbul ignore end*/equals: function equals(left, right) {
	    if (this.options.comparator) {
	      return this.options.comparator(left, right);
	    } else {
	      return left === right || this.options.ignoreCase && left.toLowerCase() === right.toLowerCase();
	    }
	  },
	  /*istanbul ignore start*/ /*istanbul ignore end*/removeEmpty: function removeEmpty(array) {
	    var ret = [];
	    for (var i = 0; i < array.length; i++) {
	      if (array[i]) {
	        ret.push(array[i]);
	      }
	    }
	    return ret;
	  },
	  /*istanbul ignore start*/ /*istanbul ignore end*/castInput: function castInput(value) {
	    return value;
	  },
	  /*istanbul ignore start*/ /*istanbul ignore end*/tokenize: function tokenize(value) {
	    return value.split('');
	  },
	  /*istanbul ignore start*/ /*istanbul ignore end*/join: function join(chars) {
	    return chars.join('');
	  }
	};

	function buildValues(diff, components, newString, oldString, useLongestToken) {
	  var componentPos = 0,
	      componentLen = components.length,
	      newPos = 0,
	      oldPos = 0;

	  for (; componentPos < componentLen; componentPos++) {
	    var component = components[componentPos];
	    if (!component.removed) {
	      if (!component.added && useLongestToken) {
	        var value = newString.slice(newPos, newPos + component.count);
	        value = value.map(function (value, i) {
	          var oldValue = oldString[oldPos + i];
	          return oldValue.length > value.length ? oldValue : value;
	        });

	        component.value = diff.join(value);
	      } else {
	        component.value = diff.join(newString.slice(newPos, newPos + component.count));
	      }
	      newPos += component.count;

	      // Common case
	      if (!component.added) {
	        oldPos += component.count;
	      }
	    } else {
	      component.value = diff.join(oldString.slice(oldPos, oldPos + component.count));
	      oldPos += component.count;

	      // Reverse add and remove so removes are output first to match common convention
	      // The diffing algorithm is tied to add then remove output and this is the simplest
	      // route to get the desired output with minimal overhead.
	      if (componentPos && components[componentPos - 1].added) {
	        var tmp = components[componentPos - 1];
	        components[componentPos - 1] = components[componentPos];
	        components[componentPos] = tmp;
	      }
	    }
	  }

	  // Special case handle for when one terminal is ignored (i.e. whitespace).
	  // For this case we merge the terminal into the prior string and drop the change.
	  // This is only available for string mode.
	  var lastComponent = components[componentLen - 1];
	  if (componentLen > 1 && typeof lastComponent.value === 'string' && (lastComponent.added || lastComponent.removed) && diff.equals('', lastComponent.value)) {
	    components[componentLen - 2].value += lastComponent.value;
	    components.pop();
	  }

	  return components;
	}

	function clonePath(path) {
	  return { newPos: path.newPos, components: path.components.slice(0) };
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';

	exports.__esModule = true;
	exports.characterDiff = undefined;
	exports. /*istanbul ignore end*/diffChars = diffChars;

	var /*istanbul ignore start*/_base = __webpack_require__(1) /*istanbul ignore end*/;

	/*istanbul ignore start*/var _base2 = _interopRequireDefault(_base);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	/*istanbul ignore end*/var characterDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/characterDiff = new /*istanbul ignore start*/_base2['default'] /*istanbul ignore end*/();
	function diffChars(oldStr, newStr, options) {
	  return characterDiff.diff(oldStr, newStr, options);
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kaWZmL2NoYXJhY3Rlci5qcyJdLCJuYW1lcyI6WyJkaWZmQ2hhcnMiLCJjaGFyYWN0ZXJEaWZmIiwib2xkU3RyIiwibmV3U3RyIiwib3B0aW9ucyIsImRpZmYiXSwibWFwcGluZ3MiOiI7Ozs7Z0NBR2dCQSxTLEdBQUFBLFM7O0FBSGhCOzs7Ozs7dUJBRU8sSUFBTUMseUZBQWdCLHdFQUF0QjtBQUNBLFNBQVNELFNBQVQsQ0FBbUJFLE1BQW5CLEVBQTJCQyxNQUEzQixFQUFtQ0MsT0FBbkMsRUFBNEM7QUFBRSxTQUFPSCxjQUFjSSxJQUFkLENBQW1CSCxNQUFuQixFQUEyQkMsTUFBM0IsRUFBbUNDLE9BQW5DLENBQVA7QUFBcUQiLCJmaWxlIjoiY2hhcmFjdGVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IERpZmYgZnJvbSAnLi9iYXNlJztcblxuZXhwb3J0IGNvbnN0IGNoYXJhY3RlckRpZmYgPSBuZXcgRGlmZigpO1xuZXhwb3J0IGZ1bmN0aW9uIGRpZmZDaGFycyhvbGRTdHIsIG5ld1N0ciwgb3B0aW9ucykgeyByZXR1cm4gY2hhcmFjdGVyRGlmZi5kaWZmKG9sZFN0ciwgbmV3U3RyLCBvcHRpb25zKTsgfVxuIl19


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';

	exports.__esModule = true;
	exports.wordDiff = undefined;
	exports. /*istanbul ignore end*/diffWords = diffWords;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffWordsWithSpace = diffWordsWithSpace;

	var /*istanbul ignore start*/_base = __webpack_require__(1) /*istanbul ignore end*/;

	/*istanbul ignore start*/var _base2 = _interopRequireDefault(_base);

	/*istanbul ignore end*/var /*istanbul ignore start*/_params = __webpack_require__(4) /*istanbul ignore end*/;

	/*istanbul ignore start*/function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	/*istanbul ignore end*/ // Based on https://en.wikipedia.org/wiki/Latin_script_in_Unicode
	//
	// Ranges and exceptions:
	// Latin-1 Supplement, 0080–00FF
	//  - U+00D7  × Multiplication sign
	//  - U+00F7  ÷ Division sign
	// Latin Extended-A, 0100–017F
	// Latin Extended-B, 0180–024F
	// IPA Extensions, 0250–02AF
	// Spacing Modifier Letters, 02B0–02FF
	//  - U+02C7  ˇ &#711;  Caron
	//  - U+02D8  ˘ &#728;  Breve
	//  - U+02D9  ˙ &#729;  Dot Above
	//  - U+02DA  ˚ &#730;  Ring Above
	//  - U+02DB  ˛ &#731;  Ogonek
	//  - U+02DC  ˜ &#732;  Small Tilde
	//  - U+02DD  ˝ &#733;  Double Acute Accent
	// Latin Extended Additional, 1E00–1EFF
	var extendedWordChars = /^[A-Za-z\xC0-\u02C6\u02C8-\u02D7\u02DE-\u02FF\u1E00-\u1EFF]+$/;

	var reWhitespace = /\S/;

	var wordDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/wordDiff = new /*istanbul ignore start*/_base2['default'] /*istanbul ignore end*/();
	wordDiff.equals = function (left, right) {
	  if (this.options.ignoreCase) {
	    left = left.toLowerCase();
	    right = right.toLowerCase();
	  }
	  return left === right || this.options.ignoreWhitespace && !reWhitespace.test(left) && !reWhitespace.test(right);
	};
	wordDiff.tokenize = function (value) {
	  var tokens = value.split(/(\s+|\b)/);

	  // Join the boundary splits that we do not consider to be boundaries. This is primarily the extended Latin character set.
	  for (var i = 0; i < tokens.length - 1; i++) {
	    // If we have an empty string in the next field and we have only word chars before and after, merge
	    if (!tokens[i + 1] && tokens[i + 2] && extendedWordChars.test(tokens[i]) && extendedWordChars.test(tokens[i + 2])) {
	      tokens[i] += tokens[i + 2];
	      tokens.splice(i + 1, 2);
	      i--;
	    }
	  }

	  return tokens;
	};

	function diffWords(oldStr, newStr, options) {
	  options = /*istanbul ignore start*/(0, _params.generateOptions) /*istanbul ignore end*/(options, { ignoreWhitespace: true });
	  return wordDiff.diff(oldStr, newStr, options);
	}

	function diffWordsWithSpace(oldStr, newStr, options) {
	  return wordDiff.diff(oldStr, newStr, options);
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	/*istanbul ignore start*/'use strict';

	exports.__esModule = true;
	exports. /*istanbul ignore end*/generateOptions = generateOptions;
	function generateOptions(options, defaults) {
	  if (typeof options === 'function') {
	    defaults.callback = options;
	  } else if (options) {
	    for (var name in options) {
	      /* istanbul ignore else */
	      if (options.hasOwnProperty(name)) {
	        defaults[name] = options[name];
	      }
	    }
	  }
	  return defaults;
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlsL3BhcmFtcy5qcyJdLCJuYW1lcyI6WyJnZW5lcmF0ZU9wdGlvbnMiLCJvcHRpb25zIiwiZGVmYXVsdHMiLCJjYWxsYmFjayIsIm5hbWUiLCJoYXNPd25Qcm9wZXJ0eSJdLCJtYXBwaW5ncyI6Ijs7O2dDQUFnQkEsZSxHQUFBQSxlO0FBQVQsU0FBU0EsZUFBVCxDQUF5QkMsT0FBekIsRUFBa0NDLFFBQWxDLEVBQTRDO0FBQ2pELE1BQUksT0FBT0QsT0FBUCxLQUFtQixVQUF2QixFQUFtQztBQUNqQ0MsYUFBU0MsUUFBVCxHQUFvQkYsT0FBcEI7QUFDRCxHQUZELE1BRU8sSUFBSUEsT0FBSixFQUFhO0FBQ2xCLFNBQUssSUFBSUcsSUFBVCxJQUFpQkgsT0FBakIsRUFBMEI7QUFDeEI7QUFDQSxVQUFJQSxRQUFRSSxjQUFSLENBQXVCRCxJQUF2QixDQUFKLEVBQWtDO0FBQ2hDRixpQkFBU0UsSUFBVCxJQUFpQkgsUUFBUUcsSUFBUixDQUFqQjtBQUNEO0FBQ0Y7QUFDRjtBQUNELFNBQU9GLFFBQVA7QUFDRCIsImZpbGUiOiJwYXJhbXMuanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZnVuY3Rpb24gZ2VuZXJhdGVPcHRpb25zKG9wdGlvbnMsIGRlZmF1bHRzKSB7XG4gIGlmICh0eXBlb2Ygb3B0aW9ucyA9PT0gJ2Z1bmN0aW9uJykge1xuICAgIGRlZmF1bHRzLmNhbGxiYWNrID0gb3B0aW9ucztcbiAgfSBlbHNlIGlmIChvcHRpb25zKSB7XG4gICAgZm9yIChsZXQgbmFtZSBpbiBvcHRpb25zKSB7XG4gICAgICAvKiBpc3RhbmJ1bCBpZ25vcmUgZWxzZSAqL1xuICAgICAgaWYgKG9wdGlvbnMuaGFzT3duUHJvcGVydHkobmFtZSkpIHtcbiAgICAgICAgZGVmYXVsdHNbbmFtZV0gPSBvcHRpb25zW25hbWVdO1xuICAgICAgfVxuICAgIH1cbiAgfVxuICByZXR1cm4gZGVmYXVsdHM7XG59XG4iXX0=


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';

	exports.__esModule = true;
	exports.lineDiff = undefined;
	exports. /*istanbul ignore end*/diffLines = diffLines;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/diffTrimmedLines = diffTrimmedLines;

	var /*istanbul ignore start*/_base = __webpack_require__(1) /*istanbul ignore end*/;

	/*istanbul ignore start*/var _base2 = _interopRequireDefault(_base);

	/*istanbul ignore end*/var /*istanbul ignore start*/_params = __webpack_require__(4) /*istanbul ignore end*/;

	/*istanbul ignore start*/function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	/*istanbul ignore end*/var lineDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/lineDiff = new /*istanbul ignore start*/_base2['default'] /*istanbul ignore end*/();
	lineDiff.tokenize = function (value) {
	  var retLines = [],
	      linesAndNewlines = value.split(/(\n|\r\n)/);

	  // Ignore the final empty token that occurs if the string ends with a new line
	  if (!linesAndNewlines[linesAndNewlines.length - 1]) {
	    linesAndNewlines.pop();
	  }

	  // Merge the content and line separators into single tokens
	  for (var i = 0; i < linesAndNewlines.length; i++) {
	    var line = linesAndNewlines[i];

	    if (i % 2 && !this.options.newlineIsToken) {
	      retLines[retLines.length - 1] += line;
	    } else {
	      if (this.options.ignoreWhitespace) {
	        line = line.trim();
	      }
	      retLines.push(line);
	    }
	  }

	  return retLines;
	};

	function diffLines(oldStr, newStr, callback) {
	  return lineDiff.diff(oldStr, newStr, callback);
	}
	function diffTrimmedLines(oldStr, newStr, callback) {
	  var options = /*istanbul ignore start*/(0, _params.generateOptions) /*istanbul ignore end*/(callback, { ignoreWhitespace: true });
	  return lineDiff.diff(oldStr, newStr, options);
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';

	exports.__esModule = true;
	exports.sentenceDiff = undefined;
	exports. /*istanbul ignore end*/diffSentences = diffSentences;

	var /*istanbul ignore start*/_base = __webpack_require__(1) /*istanbul ignore end*/;

	/*istanbul ignore start*/var _base2 = _interopRequireDefault(_base);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	/*istanbul ignore end*/var sentenceDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/sentenceDiff = new /*istanbul ignore start*/_base2['default'] /*istanbul ignore end*/();
	sentenceDiff.tokenize = function (value) {
	  return value.split(/(\S.+?[.!?])(?=\s+|$)/);
	};

	function diffSentences(oldStr, newStr, callback) {
	  return sentenceDiff.diff(oldStr, newStr, callback);
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kaWZmL3NlbnRlbmNlLmpzIl0sIm5hbWVzIjpbImRpZmZTZW50ZW5jZXMiLCJzZW50ZW5jZURpZmYiLCJ0b2tlbml6ZSIsInZhbHVlIiwic3BsaXQiLCJvbGRTdHIiLCJuZXdTdHIiLCJjYWxsYmFjayIsImRpZmYiXSwibWFwcGluZ3MiOiI7Ozs7Z0NBUWdCQSxhLEdBQUFBLGE7O0FBUmhCOzs7Ozs7dUJBR08sSUFBTUMsdUZBQWUsd0VBQXJCO0FBQ1BBLGFBQWFDLFFBQWIsR0FBd0IsVUFBU0MsS0FBVCxFQUFnQjtBQUN0QyxTQUFPQSxNQUFNQyxLQUFOLENBQVksdUJBQVosQ0FBUDtBQUNELENBRkQ7O0FBSU8sU0FBU0osYUFBVCxDQUF1QkssTUFBdkIsRUFBK0JDLE1BQS9CLEVBQXVDQyxRQUF2QyxFQUFpRDtBQUFFLFNBQU9OLGFBQWFPLElBQWIsQ0FBa0JILE1BQWxCLEVBQTBCQyxNQUExQixFQUFrQ0MsUUFBbEMsQ0FBUDtBQUFxRCIsImZpbGUiOiJzZW50ZW5jZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBEaWZmIGZyb20gJy4vYmFzZSc7XG5cblxuZXhwb3J0IGNvbnN0IHNlbnRlbmNlRGlmZiA9IG5ldyBEaWZmKCk7XG5zZW50ZW5jZURpZmYudG9rZW5pemUgPSBmdW5jdGlvbih2YWx1ZSkge1xuICByZXR1cm4gdmFsdWUuc3BsaXQoLyhcXFMuKz9bLiE/XSkoPz1cXHMrfCQpLyk7XG59O1xuXG5leHBvcnQgZnVuY3Rpb24gZGlmZlNlbnRlbmNlcyhvbGRTdHIsIG5ld1N0ciwgY2FsbGJhY2spIHsgcmV0dXJuIHNlbnRlbmNlRGlmZi5kaWZmKG9sZFN0ciwgbmV3U3RyLCBjYWxsYmFjayk7IH1cbiJdfQ==


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';

	exports.__esModule = true;
	exports.cssDiff = undefined;
	exports. /*istanbul ignore end*/diffCss = diffCss;

	var /*istanbul ignore start*/_base = __webpack_require__(1) /*istanbul ignore end*/;

	/*istanbul ignore start*/var _base2 = _interopRequireDefault(_base);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	/*istanbul ignore end*/var cssDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/cssDiff = new /*istanbul ignore start*/_base2['default'] /*istanbul ignore end*/();
	cssDiff.tokenize = function (value) {
	  return value.split(/([{}:;,]|\s+)/);
	};

	function diffCss(oldStr, newStr, callback) {
	  return cssDiff.diff(oldStr, newStr, callback);
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kaWZmL2Nzcy5qcyJdLCJuYW1lcyI6WyJkaWZmQ3NzIiwiY3NzRGlmZiIsInRva2VuaXplIiwidmFsdWUiLCJzcGxpdCIsIm9sZFN0ciIsIm5ld1N0ciIsImNhbGxiYWNrIiwiZGlmZiJdLCJtYXBwaW5ncyI6Ijs7OztnQ0FPZ0JBLE8sR0FBQUEsTzs7QUFQaEI7Ozs7Ozt1QkFFTyxJQUFNQyw2RUFBVSx3RUFBaEI7QUFDUEEsUUFBUUMsUUFBUixHQUFtQixVQUFTQyxLQUFULEVBQWdCO0FBQ2pDLFNBQU9BLE1BQU1DLEtBQU4sQ0FBWSxlQUFaLENBQVA7QUFDRCxDQUZEOztBQUlPLFNBQVNKLE9BQVQsQ0FBaUJLLE1BQWpCLEVBQXlCQyxNQUF6QixFQUFpQ0MsUUFBakMsRUFBMkM7QUFBRSxTQUFPTixRQUFRTyxJQUFSLENBQWFILE1BQWIsRUFBcUJDLE1BQXJCLEVBQTZCQyxRQUE3QixDQUFQO0FBQWdEIiwiZmlsZSI6ImNzcy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBEaWZmIGZyb20gJy4vYmFzZSc7XG5cbmV4cG9ydCBjb25zdCBjc3NEaWZmID0gbmV3IERpZmYoKTtcbmNzc0RpZmYudG9rZW5pemUgPSBmdW5jdGlvbih2YWx1ZSkge1xuICByZXR1cm4gdmFsdWUuc3BsaXQoLyhbe306OyxdfFxccyspLyk7XG59O1xuXG5leHBvcnQgZnVuY3Rpb24gZGlmZkNzcyhvbGRTdHIsIG5ld1N0ciwgY2FsbGJhY2spIHsgcmV0dXJuIGNzc0RpZmYuZGlmZihvbGRTdHIsIG5ld1N0ciwgY2FsbGJhY2spOyB9XG4iXX0=


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';

	exports.__esModule = true;
	exports.jsonDiff = undefined;

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	exports. /*istanbul ignore end*/diffJson = diffJson;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/canonicalize = canonicalize;

	var /*istanbul ignore start*/_base = __webpack_require__(1) /*istanbul ignore end*/;

	/*istanbul ignore start*/var _base2 = _interopRequireDefault(_base);

	/*istanbul ignore end*/var /*istanbul ignore start*/_line = __webpack_require__(5) /*istanbul ignore end*/;

	/*istanbul ignore start*/function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	/*istanbul ignore end*/var objectPrototypeToString = Object.prototype.toString;

	var jsonDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/jsonDiff = new /*istanbul ignore start*/_base2['default'] /*istanbul ignore end*/();
	// Discriminate between two lines of pretty-printed, serialized JSON where one of them has a
	// dangling comma and the other doesn't. Turns out including the dangling comma yields the nicest output:
	jsonDiff.useLongestToken = true;

	jsonDiff.tokenize = /*istanbul ignore start*/_line.lineDiff /*istanbul ignore end*/.tokenize;
	jsonDiff.castInput = function (value) {
	  /*istanbul ignore start*/var _options = /*istanbul ignore end*/this.options,
	      undefinedReplacement = _options.undefinedReplacement,
	      _options$stringifyRep = _options.stringifyReplacer,
	      stringifyReplacer = _options$stringifyRep === undefined ? function (k, v) /*istanbul ignore start*/{
	    return (/*istanbul ignore end*/typeof v === 'undefined' ? undefinedReplacement : v
	    );
	  } : _options$stringifyRep;


	  return typeof value === 'string' ? value : JSON.stringify(canonicalize(value, null, null, stringifyReplacer), stringifyReplacer, '  ');
	};
	jsonDiff.equals = function (left, right) {
	  return (/*istanbul ignore start*/_base2['default'] /*istanbul ignore end*/.prototype.equals.call(jsonDiff, left.replace(/,([\r\n])/g, '$1'), right.replace(/,([\r\n])/g, '$1'))
	  );
	};

	function diffJson(oldObj, newObj, options) {
	  return jsonDiff.diff(oldObj, newObj, options);
	}

	// This function handles the presence of circular references by bailing out when encountering an
	// object that is already on the "stack" of items being processed. Accepts an optional replacer
	function canonicalize(obj, stack, replacementStack, replacer, key) {
	  stack = stack || [];
	  replacementStack = replacementStack || [];

	  if (replacer) {
	    obj = replacer(key, obj);
	  }

	  var i = /*istanbul ignore start*/void 0 /*istanbul ignore end*/;

	  for (i = 0; i < stack.length; i += 1) {
	    if (stack[i] === obj) {
	      return replacementStack[i];
	    }
	  }

	  var canonicalizedObj = /*istanbul ignore start*/void 0 /*istanbul ignore end*/;

	  if ('[object Array]' === objectPrototypeToString.call(obj)) {
	    stack.push(obj);
	    canonicalizedObj = new Array(obj.length);
	    replacementStack.push(canonicalizedObj);
	    for (i = 0; i < obj.length; i += 1) {
	      canonicalizedObj[i] = canonicalize(obj[i], stack, replacementStack, replacer, key);
	    }
	    stack.pop();
	    replacementStack.pop();
	    return canonicalizedObj;
	  }

	  if (obj && obj.toJSON) {
	    obj = obj.toJSON();
	  }

	  if ( /*istanbul ignore start*/(typeof /*istanbul ignore end*/obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj !== null) {
	    stack.push(obj);
	    canonicalizedObj = {};
	    replacementStack.push(canonicalizedObj);
	    var sortedKeys = [],
	        _key = /*istanbul ignore start*/void 0 /*istanbul ignore end*/;
	    for (_key in obj) {
	      /* istanbul ignore else */
	      if (obj.hasOwnProperty(_key)) {
	        sortedKeys.push(_key);
	      }
	    }
	    sortedKeys.sort();
	    for (i = 0; i < sortedKeys.length; i += 1) {
	      _key = sortedKeys[i];
	      canonicalizedObj[_key] = canonicalize(obj[_key], stack, replacementStack, replacer, _key);
	    }
	    stack.pop();
	    replacementStack.pop();
	  } else {
	    canonicalizedObj = obj;
	  }
	  return canonicalizedObj;
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';

	exports.__esModule = true;
	exports.arrayDiff = undefined;
	exports. /*istanbul ignore end*/diffArrays = diffArrays;

	var /*istanbul ignore start*/_base = __webpack_require__(1) /*istanbul ignore end*/;

	/*istanbul ignore start*/var _base2 = _interopRequireDefault(_base);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	/*istanbul ignore end*/var arrayDiff = /*istanbul ignore start*/exports. /*istanbul ignore end*/arrayDiff = new /*istanbul ignore start*/_base2['default'] /*istanbul ignore end*/();
	arrayDiff.tokenize = function (value) {
	  return value.slice();
	};
	arrayDiff.join = arrayDiff.removeEmpty = function (value) {
	  return value;
	};

	function diffArrays(oldArr, newArr, callback) {
	  return arrayDiff.diff(oldArr, newArr, callback);
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kaWZmL2FycmF5LmpzIl0sIm5hbWVzIjpbImRpZmZBcnJheXMiLCJhcnJheURpZmYiLCJ0b2tlbml6ZSIsInZhbHVlIiwic2xpY2UiLCJqb2luIiwicmVtb3ZlRW1wdHkiLCJvbGRBcnIiLCJuZXdBcnIiLCJjYWxsYmFjayIsImRpZmYiXSwibWFwcGluZ3MiOiI7Ozs7Z0NBVWdCQSxVLEdBQUFBLFU7O0FBVmhCOzs7Ozs7dUJBRU8sSUFBTUMsaUZBQVksd0VBQWxCO0FBQ1BBLFVBQVVDLFFBQVYsR0FBcUIsVUFBU0MsS0FBVCxFQUFnQjtBQUNuQyxTQUFPQSxNQUFNQyxLQUFOLEVBQVA7QUFDRCxDQUZEO0FBR0FILFVBQVVJLElBQVYsR0FBaUJKLFVBQVVLLFdBQVYsR0FBd0IsVUFBU0gsS0FBVCxFQUFnQjtBQUN2RCxTQUFPQSxLQUFQO0FBQ0QsQ0FGRDs7QUFJTyxTQUFTSCxVQUFULENBQW9CTyxNQUFwQixFQUE0QkMsTUFBNUIsRUFBb0NDLFFBQXBDLEVBQThDO0FBQUUsU0FBT1IsVUFBVVMsSUFBVixDQUFlSCxNQUFmLEVBQXVCQyxNQUF2QixFQUErQkMsUUFBL0IsQ0FBUDtBQUFrRCIsImZpbGUiOiJhcnJheS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBEaWZmIGZyb20gJy4vYmFzZSc7XG5cbmV4cG9ydCBjb25zdCBhcnJheURpZmYgPSBuZXcgRGlmZigpO1xuYXJyYXlEaWZmLnRva2VuaXplID0gZnVuY3Rpb24odmFsdWUpIHtcbiAgcmV0dXJuIHZhbHVlLnNsaWNlKCk7XG59O1xuYXJyYXlEaWZmLmpvaW4gPSBhcnJheURpZmYucmVtb3ZlRW1wdHkgPSBmdW5jdGlvbih2YWx1ZSkge1xuICByZXR1cm4gdmFsdWU7XG59O1xuXG5leHBvcnQgZnVuY3Rpb24gZGlmZkFycmF5cyhvbGRBcnIsIG5ld0FyciwgY2FsbGJhY2spIHsgcmV0dXJuIGFycmF5RGlmZi5kaWZmKG9sZEFyciwgbmV3QXJyLCBjYWxsYmFjayk7IH1cbiJdfQ==


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';

	exports.__esModule = true;
	exports. /*istanbul ignore end*/applyPatch = applyPatch;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/applyPatches = applyPatches;

	var /*istanbul ignore start*/_parse = __webpack_require__(11) /*istanbul ignore end*/;

	var /*istanbul ignore start*/_distanceIterator = __webpack_require__(12) /*istanbul ignore end*/;

	/*istanbul ignore start*/var _distanceIterator2 = _interopRequireDefault(_distanceIterator);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	/*istanbul ignore end*/function applyPatch(source, uniDiff) {
	  /*istanbul ignore start*/var /*istanbul ignore end*/options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	  if (typeof uniDiff === 'string') {
	    uniDiff = /*istanbul ignore start*/(0, _parse.parsePatch) /*istanbul ignore end*/(uniDiff);
	  }

	  if (Array.isArray(uniDiff)) {
	    if (uniDiff.length > 1) {
	      throw new Error('applyPatch only works with a single input.');
	    }

	    uniDiff = uniDiff[0];
	  }

	  // Apply the diff to the input
	  var lines = source.split(/\r\n|[\n\v\f\r\x85]/),
	      delimiters = source.match(/\r\n|[\n\v\f\r\x85]/g) || [],
	      hunks = uniDiff.hunks,
	      compareLine = options.compareLine || function (lineNumber, line, operation, patchContent) /*istanbul ignore start*/{
	    return (/*istanbul ignore end*/line === patchContent
	    );
	  },
	      errorCount = 0,
	      fuzzFactor = options.fuzzFactor || 0,
	      minLine = 0,
	      offset = 0,
	      removeEOFNL = /*istanbul ignore start*/void 0 /*istanbul ignore end*/,
	      addEOFNL = /*istanbul ignore start*/void 0 /*istanbul ignore end*/;

	  /**
	   * Checks if the hunk exactly fits on the provided location
	   */
	  function hunkFits(hunk, toPos) {
	    for (var j = 0; j < hunk.lines.length; j++) {
	      var line = hunk.lines[j],
	          operation = line.length > 0 ? line[0] : ' ',
	          content = line.length > 0 ? line.substr(1) : line;

	      if (operation === ' ' || operation === '-') {
	        // Context sanity check
	        if (!compareLine(toPos + 1, lines[toPos], operation, content)) {
	          errorCount++;

	          if (errorCount > fuzzFactor) {
	            return false;
	          }
	        }
	        toPos++;
	      }
	    }

	    return true;
	  }

	  // Search best fit offsets for each hunk based on the previous ones
	  for (var i = 0; i < hunks.length; i++) {
	    var hunk = hunks[i],
	        maxLine = lines.length - hunk.oldLines,
	        localOffset = 0,
	        toPos = offset + hunk.oldStart - 1;

	    var iterator = /*istanbul ignore start*/(0, _distanceIterator2['default']) /*istanbul ignore end*/(toPos, minLine, maxLine);

	    for (; localOffset !== undefined; localOffset = iterator()) {
	      if (hunkFits(hunk, toPos + localOffset)) {
	        hunk.offset = offset += localOffset;
	        break;
	      }
	    }

	    if (localOffset === undefined) {
	      return false;
	    }

	    // Set lower text limit to end of the current hunk, so next ones don't try
	    // to fit over already patched text
	    minLine = hunk.offset + hunk.oldStart + hunk.oldLines;
	  }

	  // Apply patch hunks
	  var diffOffset = 0;
	  for (var _i = 0; _i < hunks.length; _i++) {
	    var _hunk = hunks[_i],
	        _toPos = _hunk.oldStart + _hunk.offset + diffOffset - 1;
	    diffOffset += _hunk.newLines - _hunk.oldLines;

	    if (_toPos < 0) {
	      // Creating a new file
	      _toPos = 0;
	    }

	    for (var j = 0; j < _hunk.lines.length; j++) {
	      var line = _hunk.lines[j],
	          operation = line.length > 0 ? line[0] : ' ',
	          content = line.length > 0 ? line.substr(1) : line,
	          delimiter = _hunk.linedelimiters[j];

	      if (operation === ' ') {
	        _toPos++;
	      } else if (operation === '-') {
	        lines.splice(_toPos, 1);
	        delimiters.splice(_toPos, 1);
	        /* istanbul ignore else */
	      } else if (operation === '+') {
	        lines.splice(_toPos, 0, content);
	        delimiters.splice(_toPos, 0, delimiter);
	        _toPos++;
	      } else if (operation === '\\') {
	        var previousOperation = _hunk.lines[j - 1] ? _hunk.lines[j - 1][0] : null;
	        if (previousOperation === '+') {
	          removeEOFNL = true;
	        } else if (previousOperation === '-') {
	          addEOFNL = true;
	        }
	      }
	    }
	  }

	  // Handle EOFNL insertion/removal
	  if (removeEOFNL) {
	    while (!lines[lines.length - 1]) {
	      lines.pop();
	      delimiters.pop();
	    }
	  } else if (addEOFNL) {
	    lines.push('');
	    delimiters.push('\n');
	  }
	  for (var _k = 0; _k < lines.length - 1; _k++) {
	    lines[_k] = lines[_k] + delimiters[_k];
	  }
	  return lines.join('');
	}

	// Wrapper that supports multiple file patches via callbacks.
	function applyPatches(uniDiff, options) {
	  if (typeof uniDiff === 'string') {
	    uniDiff = /*istanbul ignore start*/(0, _parse.parsePatch) /*istanbul ignore end*/(uniDiff);
	  }

	  var currentIndex = 0;
	  function processIndex() {
	    var index = uniDiff[currentIndex++];
	    if (!index) {
	      return options.complete();
	    }

	    options.loadFile(index, function (err, data) {
	      if (err) {
	        return options.complete(err);
	      }

	      var updatedContent = applyPatch(data, index, options);
	      options.patched(index, updatedContent, function (err) {
	        if (err) {
	          return options.complete(err);
	        }

	        processIndex();
	      });
	    });
	  }
	  processIndex();
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	/*istanbul ignore start*/'use strict';

	exports.__esModule = true;
	exports. /*istanbul ignore end*/parsePatch = parsePatch;
	function parsePatch(uniDiff) {
	  /*istanbul ignore start*/var /*istanbul ignore end*/options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	  var diffstr = uniDiff.split(/\r\n|[\n\v\f\r\x85]/),
	      delimiters = uniDiff.match(/\r\n|[\n\v\f\r\x85]/g) || [],
	      list = [],
	      i = 0;

	  function parseIndex() {
	    var index = {};
	    list.push(index);

	    // Parse diff metadata
	    while (i < diffstr.length) {
	      var line = diffstr[i];

	      // File header found, end parsing diff metadata
	      if (/^(\-\-\-|\+\+\+|@@)\s/.test(line)) {
	        break;
	      }

	      // Diff index
	      var header = /^(?:Index:|diff(?: -r \w+)+)\s+(.+?)\s*$/.exec(line);
	      if (header) {
	        index.index = header[1];
	      }

	      i++;
	    }

	    // Parse file headers if they are defined. Unified diff requires them, but
	    // there's no technical issues to have an isolated hunk without file header
	    parseFileHeader(index);
	    parseFileHeader(index);

	    // Parse hunks
	    index.hunks = [];

	    while (i < diffstr.length) {
	      var _line = diffstr[i];

	      if (/^(Index:|diff|\-\-\-|\+\+\+)\s/.test(_line)) {
	        break;
	      } else if (/^@@/.test(_line)) {
	        index.hunks.push(parseHunk());
	      } else if (_line && options.strict) {
	        // Ignore unexpected content unless in strict mode
	        throw new Error('Unknown line ' + (i + 1) + ' ' + JSON.stringify(_line));
	      } else {
	        i++;
	      }
	    }
	  }

	  // Parses the --- and +++ headers, if none are found, no lines
	  // are consumed.
	  function parseFileHeader(index) {
	    var fileHeader = /^(---|\+\+\+)\s+(.*)$/.exec(diffstr[i]);
	    if (fileHeader) {
	      var keyPrefix = fileHeader[1] === '---' ? 'old' : 'new';
	      var data = fileHeader[2].split('\t', 2);
	      var fileName = data[0].replace(/\\\\/g, '\\');
	      if (/^".*"$/.test(fileName)) {
	        fileName = fileName.substr(1, fileName.length - 2);
	      }
	      index[keyPrefix + 'FileName'] = fileName;
	      index[keyPrefix + 'Header'] = (data[1] || '').trim();

	      i++;
	    }
	  }

	  // Parses a hunk
	  // This assumes that we are at the start of a hunk.
	  function parseHunk() {
	    var chunkHeaderIndex = i,
	        chunkHeaderLine = diffstr[i++],
	        chunkHeader = chunkHeaderLine.split(/@@ -(\d+)(?:,(\d+))? \+(\d+)(?:,(\d+))? @@/);

	    var hunk = {
	      oldStart: +chunkHeader[1],
	      oldLines: +chunkHeader[2] || 1,
	      newStart: +chunkHeader[3],
	      newLines: +chunkHeader[4] || 1,
	      lines: [],
	      linedelimiters: []
	    };

	    var addCount = 0,
	        removeCount = 0;
	    for (; i < diffstr.length; i++) {
	      // Lines starting with '---' could be mistaken for the "remove line" operation
	      // But they could be the header for the next file. Therefore prune such cases out.
	      if (diffstr[i].indexOf('--- ') === 0 && i + 2 < diffstr.length && diffstr[i + 1].indexOf('+++ ') === 0 && diffstr[i + 2].indexOf('@@') === 0) {
	        break;
	      }
	      var operation = diffstr[i].length == 0 && i != diffstr.length - 1 ? ' ' : diffstr[i][0];

	      if (operation === '+' || operation === '-' || operation === ' ' || operation === '\\') {
	        hunk.lines.push(diffstr[i]);
	        hunk.linedelimiters.push(delimiters[i] || '\n');

	        if (operation === '+') {
	          addCount++;
	        } else if (operation === '-') {
	          removeCount++;
	        } else if (operation === ' ') {
	          addCount++;
	          removeCount++;
	        }
	      } else {
	        break;
	      }
	    }

	    // Handle the empty block count case
	    if (!addCount && hunk.newLines === 1) {
	      hunk.newLines = 0;
	    }
	    if (!removeCount && hunk.oldLines === 1) {
	      hunk.oldLines = 0;
	    }

	    // Perform optional sanity checking
	    if (options.strict) {
	      if (addCount !== hunk.newLines) {
	        throw new Error('Added line count did not match for hunk at line ' + (chunkHeaderIndex + 1));
	      }
	      if (removeCount !== hunk.oldLines) {
	        throw new Error('Removed line count did not match for hunk at line ' + (chunkHeaderIndex + 1));
	      }
	    }

	    return hunk;
	  }

	  while (i < diffstr.length) {
	    parseIndex();
	  }

	  return list;
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	/*istanbul ignore start*/"use strict";

	exports.__esModule = true;

	exports["default"] = /*istanbul ignore end*/function (start, minLine, maxLine) {
	  var wantForward = true,
	      backwardExhausted = false,
	      forwardExhausted = false,
	      localOffset = 1;

	  return function iterator() {
	    if (wantForward && !forwardExhausted) {
	      if (backwardExhausted) {
	        localOffset++;
	      } else {
	        wantForward = false;
	      }

	      // Check if trying to fit beyond text length, and if not, check it fits
	      // after offset location (or desired location on first iteration)
	      if (start + localOffset <= maxLine) {
	        return localOffset;
	      }

	      forwardExhausted = true;
	    }

	    if (!backwardExhausted) {
	      if (!forwardExhausted) {
	        wantForward = true;
	      }

	      // Check if trying to fit before text beginning, and if not, check it fits
	      // before offset location
	      if (minLine <= start - localOffset) {
	        return -localOffset++;
	      }

	      backwardExhausted = true;
	      return iterator();
	    }

	    // We tried to fit hunk before text beginning and beyond text length, then
	    // hunk can't fit on the text. Return undefined
	  };
	};
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';

	exports.__esModule = true;
	exports. /*istanbul ignore end*/calcLineCount = calcLineCount;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/merge = merge;

	var /*istanbul ignore start*/_create = __webpack_require__(14) /*istanbul ignore end*/;

	var /*istanbul ignore start*/_parse = __webpack_require__(11) /*istanbul ignore end*/;

	var /*istanbul ignore start*/_array = __webpack_require__(15) /*istanbul ignore end*/;

	/*istanbul ignore start*/function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	/*istanbul ignore end*/function calcLineCount(hunk) {
	  /*istanbul ignore start*/var _calcOldNewLineCount = /*istanbul ignore end*/calcOldNewLineCount(hunk.lines),
	      oldLines = _calcOldNewLineCount.oldLines,
	      newLines = _calcOldNewLineCount.newLines;

	  if (oldLines !== undefined) {
	    hunk.oldLines = oldLines;
	  } else {
	    delete hunk.oldLines;
	  }

	  if (newLines !== undefined) {
	    hunk.newLines = newLines;
	  } else {
	    delete hunk.newLines;
	  }
	}

	function merge(mine, theirs, base) {
	  mine = loadPatch(mine, base);
	  theirs = loadPatch(theirs, base);

	  var ret = {};

	  // For index we just let it pass through as it doesn't have any necessary meaning.
	  // Leaving sanity checks on this to the API consumer that may know more about the
	  // meaning in their own context.
	  if (mine.index || theirs.index) {
	    ret.index = mine.index || theirs.index;
	  }

	  if (mine.newFileName || theirs.newFileName) {
	    if (!fileNameChanged(mine)) {
	      // No header or no change in ours, use theirs (and ours if theirs does not exist)
	      ret.oldFileName = theirs.oldFileName || mine.oldFileName;
	      ret.newFileName = theirs.newFileName || mine.newFileName;
	      ret.oldHeader = theirs.oldHeader || mine.oldHeader;
	      ret.newHeader = theirs.newHeader || mine.newHeader;
	    } else if (!fileNameChanged(theirs)) {
	      // No header or no change in theirs, use ours
	      ret.oldFileName = mine.oldFileName;
	      ret.newFileName = mine.newFileName;
	      ret.oldHeader = mine.oldHeader;
	      ret.newHeader = mine.newHeader;
	    } else {
	      // Both changed... figure it out
	      ret.oldFileName = selectField(ret, mine.oldFileName, theirs.oldFileName);
	      ret.newFileName = selectField(ret, mine.newFileName, theirs.newFileName);
	      ret.oldHeader = selectField(ret, mine.oldHeader, theirs.oldHeader);
	      ret.newHeader = selectField(ret, mine.newHeader, theirs.newHeader);
	    }
	  }

	  ret.hunks = [];

	  var mineIndex = 0,
	      theirsIndex = 0,
	      mineOffset = 0,
	      theirsOffset = 0;

	  while (mineIndex < mine.hunks.length || theirsIndex < theirs.hunks.length) {
	    var mineCurrent = mine.hunks[mineIndex] || { oldStart: Infinity },
	        theirsCurrent = theirs.hunks[theirsIndex] || { oldStart: Infinity };

	    if (hunkBefore(mineCurrent, theirsCurrent)) {
	      // This patch does not overlap with any of the others, yay.
	      ret.hunks.push(cloneHunk(mineCurrent, mineOffset));
	      mineIndex++;
	      theirsOffset += mineCurrent.newLines - mineCurrent.oldLines;
	    } else if (hunkBefore(theirsCurrent, mineCurrent)) {
	      // This patch does not overlap with any of the others, yay.
	      ret.hunks.push(cloneHunk(theirsCurrent, theirsOffset));
	      theirsIndex++;
	      mineOffset += theirsCurrent.newLines - theirsCurrent.oldLines;
	    } else {
	      // Overlap, merge as best we can
	      var mergedHunk = {
	        oldStart: Math.min(mineCurrent.oldStart, theirsCurrent.oldStart),
	        oldLines: 0,
	        newStart: Math.min(mineCurrent.newStart + mineOffset, theirsCurrent.oldStart + theirsOffset),
	        newLines: 0,
	        lines: []
	      };
	      mergeLines(mergedHunk, mineCurrent.oldStart, mineCurrent.lines, theirsCurrent.oldStart, theirsCurrent.lines);
	      theirsIndex++;
	      mineIndex++;

	      ret.hunks.push(mergedHunk);
	    }
	  }

	  return ret;
	}

	function loadPatch(param, base) {
	  if (typeof param === 'string') {
	    if (/^@@/m.test(param) || /^Index:/m.test(param)) {
	      return (/*istanbul ignore start*/(0, _parse.parsePatch) /*istanbul ignore end*/(param)[0]
	      );
	    }

	    if (!base) {
	      throw new Error('Must provide a base reference or pass in a patch');
	    }
	    return (/*istanbul ignore start*/(0, _create.structuredPatch) /*istanbul ignore end*/(undefined, undefined, base, param)
	    );
	  }

	  return param;
	}

	function fileNameChanged(patch) {
	  return patch.newFileName && patch.newFileName !== patch.oldFileName;
	}

	function selectField(index, mine, theirs) {
	  if (mine === theirs) {
	    return mine;
	  } else {
	    index.conflict = true;
	    return { mine: mine, theirs: theirs };
	  }
	}

	function hunkBefore(test, check) {
	  return test.oldStart < check.oldStart && test.oldStart + test.oldLines < check.oldStart;
	}

	function cloneHunk(hunk, offset) {
	  return {
	    oldStart: hunk.oldStart, oldLines: hunk.oldLines,
	    newStart: hunk.newStart + offset, newLines: hunk.newLines,
	    lines: hunk.lines
	  };
	}

	function mergeLines(hunk, mineOffset, mineLines, theirOffset, theirLines) {
	  // This will generally result in a conflicted hunk, but there are cases where the context
	  // is the only overlap where we can successfully merge the content here.
	  var mine = { offset: mineOffset, lines: mineLines, index: 0 },
	      their = { offset: theirOffset, lines: theirLines, index: 0 };

	  // Handle any leading content
	  insertLeading(hunk, mine, their);
	  insertLeading(hunk, their, mine);

	  // Now in the overlap content. Scan through and select the best changes from each.
	  while (mine.index < mine.lines.length && their.index < their.lines.length) {
	    var mineCurrent = mine.lines[mine.index],
	        theirCurrent = their.lines[their.index];

	    if ((mineCurrent[0] === '-' || mineCurrent[0] === '+') && (theirCurrent[0] === '-' || theirCurrent[0] === '+')) {
	      // Both modified ...
	      mutualChange(hunk, mine, their);
	    } else if (mineCurrent[0] === '+' && theirCurrent[0] === ' ') {
	      /*istanbul ignore start*/var _hunk$lines;

	      /*istanbul ignore end*/ // Mine inserted
	      /*istanbul ignore start*/(_hunk$lines = /*istanbul ignore end*/hunk.lines).push. /*istanbul ignore start*/apply /*istanbul ignore end*/( /*istanbul ignore start*/_hunk$lines /*istanbul ignore end*/, /*istanbul ignore start*/_toConsumableArray( /*istanbul ignore end*/collectChange(mine)));
	    } else if (theirCurrent[0] === '+' && mineCurrent[0] === ' ') {
	      /*istanbul ignore start*/var _hunk$lines2;

	      /*istanbul ignore end*/ // Theirs inserted
	      /*istanbul ignore start*/(_hunk$lines2 = /*istanbul ignore end*/hunk.lines).push. /*istanbul ignore start*/apply /*istanbul ignore end*/( /*istanbul ignore start*/_hunk$lines2 /*istanbul ignore end*/, /*istanbul ignore start*/_toConsumableArray( /*istanbul ignore end*/collectChange(their)));
	    } else if (mineCurrent[0] === '-' && theirCurrent[0] === ' ') {
	      // Mine removed or edited
	      removal(hunk, mine, their);
	    } else if (theirCurrent[0] === '-' && mineCurrent[0] === ' ') {
	      // Their removed or edited
	      removal(hunk, their, mine, true);
	    } else if (mineCurrent === theirCurrent) {
	      // Context identity
	      hunk.lines.push(mineCurrent);
	      mine.index++;
	      their.index++;
	    } else {
	      // Context mismatch
	      conflict(hunk, collectChange(mine), collectChange(their));
	    }
	  }

	  // Now push anything that may be remaining
	  insertTrailing(hunk, mine);
	  insertTrailing(hunk, their);

	  calcLineCount(hunk);
	}

	function mutualChange(hunk, mine, their) {
	  var myChanges = collectChange(mine),
	      theirChanges = collectChange(their);

	  if (allRemoves(myChanges) && allRemoves(theirChanges)) {
	    // Special case for remove changes that are supersets of one another
	    if ( /*istanbul ignore start*/(0, _array.arrayStartsWith) /*istanbul ignore end*/(myChanges, theirChanges) && skipRemoveSuperset(their, myChanges, myChanges.length - theirChanges.length)) {
	      /*istanbul ignore start*/var _hunk$lines3;

	      /*istanbul ignore end*/ /*istanbul ignore start*/(_hunk$lines3 = /*istanbul ignore end*/hunk.lines).push. /*istanbul ignore start*/apply /*istanbul ignore end*/( /*istanbul ignore start*/_hunk$lines3 /*istanbul ignore end*/, /*istanbul ignore start*/_toConsumableArray( /*istanbul ignore end*/myChanges));
	      return;
	    } else if ( /*istanbul ignore start*/(0, _array.arrayStartsWith) /*istanbul ignore end*/(theirChanges, myChanges) && skipRemoveSuperset(mine, theirChanges, theirChanges.length - myChanges.length)) {
	      /*istanbul ignore start*/var _hunk$lines4;

	      /*istanbul ignore end*/ /*istanbul ignore start*/(_hunk$lines4 = /*istanbul ignore end*/hunk.lines).push. /*istanbul ignore start*/apply /*istanbul ignore end*/( /*istanbul ignore start*/_hunk$lines4 /*istanbul ignore end*/, /*istanbul ignore start*/_toConsumableArray( /*istanbul ignore end*/theirChanges));
	      return;
	    }
	  } else if ( /*istanbul ignore start*/(0, _array.arrayEqual) /*istanbul ignore end*/(myChanges, theirChanges)) {
	    /*istanbul ignore start*/var _hunk$lines5;

	    /*istanbul ignore end*/ /*istanbul ignore start*/(_hunk$lines5 = /*istanbul ignore end*/hunk.lines).push. /*istanbul ignore start*/apply /*istanbul ignore end*/( /*istanbul ignore start*/_hunk$lines5 /*istanbul ignore end*/, /*istanbul ignore start*/_toConsumableArray( /*istanbul ignore end*/myChanges));
	    return;
	  }

	  conflict(hunk, myChanges, theirChanges);
	}

	function removal(hunk, mine, their, swap) {
	  var myChanges = collectChange(mine),
	      theirChanges = collectContext(their, myChanges);
	  if (theirChanges.merged) {
	    /*istanbul ignore start*/var _hunk$lines6;

	    /*istanbul ignore end*/ /*istanbul ignore start*/(_hunk$lines6 = /*istanbul ignore end*/hunk.lines).push. /*istanbul ignore start*/apply /*istanbul ignore end*/( /*istanbul ignore start*/_hunk$lines6 /*istanbul ignore end*/, /*istanbul ignore start*/_toConsumableArray( /*istanbul ignore end*/theirChanges.merged));
	  } else {
	    conflict(hunk, swap ? theirChanges : myChanges, swap ? myChanges : theirChanges);
	  }
	}

	function conflict(hunk, mine, their) {
	  hunk.conflict = true;
	  hunk.lines.push({
	    conflict: true,
	    mine: mine,
	    theirs: their
	  });
	}

	function insertLeading(hunk, insert, their) {
	  while (insert.offset < their.offset && insert.index < insert.lines.length) {
	    var line = insert.lines[insert.index++];
	    hunk.lines.push(line);
	    insert.offset++;
	  }
	}
	function insertTrailing(hunk, insert) {
	  while (insert.index < insert.lines.length) {
	    var line = insert.lines[insert.index++];
	    hunk.lines.push(line);
	  }
	}

	function collectChange(state) {
	  var ret = [],
	      operation = state.lines[state.index][0];
	  while (state.index < state.lines.length) {
	    var line = state.lines[state.index];

	    // Group additions that are immediately after subtractions and treat them as one "atomic" modify change.
	    if (operation === '-' && line[0] === '+') {
	      operation = '+';
	    }

	    if (operation === line[0]) {
	      ret.push(line);
	      state.index++;
	    } else {
	      break;
	    }
	  }

	  return ret;
	}
	function collectContext(state, matchChanges) {
	  var changes = [],
	      merged = [],
	      matchIndex = 0,
	      contextChanges = false,
	      conflicted = false;
	  while (matchIndex < matchChanges.length && state.index < state.lines.length) {
	    var change = state.lines[state.index],
	        match = matchChanges[matchIndex];

	    // Once we've hit our add, then we are done
	    if (match[0] === '+') {
	      break;
	    }

	    contextChanges = contextChanges || change[0] !== ' ';

	    merged.push(match);
	    matchIndex++;

	    // Consume any additions in the other block as a conflict to attempt
	    // to pull in the remaining context after this
	    if (change[0] === '+') {
	      conflicted = true;

	      while (change[0] === '+') {
	        changes.push(change);
	        change = state.lines[++state.index];
	      }
	    }

	    if (match.substr(1) === change.substr(1)) {
	      changes.push(change);
	      state.index++;
	    } else {
	      conflicted = true;
	    }
	  }

	  if ((matchChanges[matchIndex] || '')[0] === '+' && contextChanges) {
	    conflicted = true;
	  }

	  if (conflicted) {
	    return changes;
	  }

	  while (matchIndex < matchChanges.length) {
	    merged.push(matchChanges[matchIndex++]);
	  }

	  return {
	    merged: merged,
	    changes: changes
	  };
	}

	function allRemoves(changes) {
	  return changes.reduce(function (prev, change) {
	    return prev && change[0] === '-';
	  }, true);
	}
	function skipRemoveSuperset(state, removeChanges, delta) {
	  for (var i = 0; i < delta; i++) {
	    var changeContent = removeChanges[removeChanges.length - delta + i].substr(1);
	    if (state.lines[state.index + i] !== ' ' + changeContent) {
	      return false;
	    }
	  }

	  state.index += delta;
	  return true;
	}

	function calcOldNewLineCount(lines) {
	  var oldLines = 0;
	  var newLines = 0;

	  lines.forEach(function (line) {
	    if (typeof line !== 'string') {
	      var myCount = calcOldNewLineCount(line.mine);
	      var theirCount = calcOldNewLineCount(line.theirs);

	      if (oldLines !== undefined) {
	        if (myCount.oldLines === theirCount.oldLines) {
	          oldLines += myCount.oldLines;
	        } else {
	          oldLines = undefined;
	        }
	      }

	      if (newLines !== undefined) {
	        if (myCount.newLines === theirCount.newLines) {
	          newLines += myCount.newLines;
	        } else {
	          newLines = undefined;
	        }
	      }
	    } else {
	      if (newLines !== undefined && (line[0] === '+' || line[0] === ' ')) {
	        newLines++;
	      }
	      if (oldLines !== undefined && (line[0] === '-' || line[0] === ' ')) {
	        oldLines++;
	      }
	    }
	  });

	  return { oldLines: oldLines, newLines: newLines };
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	/*istanbul ignore start*/'use strict';

	exports.__esModule = true;
	exports. /*istanbul ignore end*/structuredPatch = structuredPatch;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/createTwoFilesPatch = createTwoFilesPatch;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/createPatch = createPatch;

	var /*istanbul ignore start*/_line = __webpack_require__(5) /*istanbul ignore end*/;

	/*istanbul ignore start*/function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

	/*istanbul ignore end*/function structuredPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options) {
	  if (!options) {
	    options = {};
	  }
	  if (typeof options.context === 'undefined') {
	    options.context = 4;
	  }

	  var diff = /*istanbul ignore start*/(0, _line.diffLines) /*istanbul ignore end*/(oldStr, newStr, options);
	  diff.push({ value: '', lines: [] }); // Append an empty value to make cleanup easier

	  function contextLines(lines) {
	    return lines.map(function (entry) {
	      return ' ' + entry;
	    });
	  }

	  var hunks = [];
	  var oldRangeStart = 0,
	      newRangeStart = 0,
	      curRange = [],
	      oldLine = 1,
	      newLine = 1;

	  /*istanbul ignore start*/var _loop = function _loop( /*istanbul ignore end*/i) {
	    var current = diff[i],
	        lines = current.lines || current.value.replace(/\n$/, '').split('\n');
	    current.lines = lines;

	    if (current.added || current.removed) {
	      /*istanbul ignore start*/var _curRange;

	      /*istanbul ignore end*/ // If we have previous context, start with that
	      if (!oldRangeStart) {
	        var prev = diff[i - 1];
	        oldRangeStart = oldLine;
	        newRangeStart = newLine;

	        if (prev) {
	          curRange = options.context > 0 ? contextLines(prev.lines.slice(-options.context)) : [];
	          oldRangeStart -= curRange.length;
	          newRangeStart -= curRange.length;
	        }
	      }

	      // Output our changes
	      /*istanbul ignore start*/(_curRange = /*istanbul ignore end*/curRange).push. /*istanbul ignore start*/apply /*istanbul ignore end*/( /*istanbul ignore start*/_curRange /*istanbul ignore end*/, /*istanbul ignore start*/_toConsumableArray( /*istanbul ignore end*/lines.map(function (entry) {
	        return (current.added ? '+' : '-') + entry;
	      })));

	      // Track the updated file position
	      if (current.added) {
	        newLine += lines.length;
	      } else {
	        oldLine += lines.length;
	      }
	    } else {
	      // Identical context lines. Track line changes
	      if (oldRangeStart) {
	        // Close out any changes that have been output (or join overlapping)
	        if (lines.length <= options.context * 2 && i < diff.length - 2) {
	          /*istanbul ignore start*/var _curRange2;

	          /*istanbul ignore end*/ // Overlapping
	          /*istanbul ignore start*/(_curRange2 = /*istanbul ignore end*/curRange).push. /*istanbul ignore start*/apply /*istanbul ignore end*/( /*istanbul ignore start*/_curRange2 /*istanbul ignore end*/, /*istanbul ignore start*/_toConsumableArray( /*istanbul ignore end*/contextLines(lines)));
	        } else {
	          /*istanbul ignore start*/var _curRange3;

	          /*istanbul ignore end*/ // end the range and output
	          var contextSize = Math.min(lines.length, options.context);
	          /*istanbul ignore start*/(_curRange3 = /*istanbul ignore end*/curRange).push. /*istanbul ignore start*/apply /*istanbul ignore end*/( /*istanbul ignore start*/_curRange3 /*istanbul ignore end*/, /*istanbul ignore start*/_toConsumableArray( /*istanbul ignore end*/contextLines(lines.slice(0, contextSize))));

	          var hunk = {
	            oldStart: oldRangeStart,
	            oldLines: oldLine - oldRangeStart + contextSize,
	            newStart: newRangeStart,
	            newLines: newLine - newRangeStart + contextSize,
	            lines: curRange
	          };
	          if (i >= diff.length - 2 && lines.length <= options.context) {
	            // EOF is inside this hunk
	            var oldEOFNewline = /\n$/.test(oldStr);
	            var newEOFNewline = /\n$/.test(newStr);
	            if (lines.length == 0 && !oldEOFNewline) {
	              // special case: old has no eol and no trailing context; no-nl can end up before adds
	              curRange.splice(hunk.oldLines, 0, '\\ No newline at end of file');
	            } else if (!oldEOFNewline || !newEOFNewline) {
	              curRange.push('\\ No newline at end of file');
	            }
	          }
	          hunks.push(hunk);

	          oldRangeStart = 0;
	          newRangeStart = 0;
	          curRange = [];
	        }
	      }
	      oldLine += lines.length;
	      newLine += lines.length;
	    }
	  };

	  for (var i = 0; i < diff.length; i++) {
	    /*istanbul ignore start*/_loop( /*istanbul ignore end*/i);
	  }

	  return {
	    oldFileName: oldFileName, newFileName: newFileName,
	    oldHeader: oldHeader, newHeader: newHeader,
	    hunks: hunks
	  };
	}

	function createTwoFilesPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options) {
	  var diff = structuredPatch(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options);

	  var ret = [];
	  if (oldFileName == newFileName) {
	    ret.push('Index: ' + oldFileName);
	  }
	  ret.push('===================================================================');
	  ret.push('--- ' + diff.oldFileName + (typeof diff.oldHeader === 'undefined' ? '' : '\t' + diff.oldHeader));
	  ret.push('+++ ' + diff.newFileName + (typeof diff.newHeader === 'undefined' ? '' : '\t' + diff.newHeader));

	  for (var i = 0; i < diff.hunks.length; i++) {
	    var hunk = diff.hunks[i];
	    ret.push('@@ -' + hunk.oldStart + ',' + hunk.oldLines + ' +' + hunk.newStart + ',' + hunk.newLines + ' @@');
	    ret.push.apply(ret, hunk.lines);
	  }

	  return ret.join('\n') + '\n';
	}

	function createPatch(fileName, oldStr, newStr, oldHeader, newHeader, options) {
	  return createTwoFilesPatch(fileName, fileName, oldStr, newStr, oldHeader, newHeader, options);
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 15 */
/***/ (function(module, exports) {

	/*istanbul ignore start*/"use strict";

	exports.__esModule = true;
	exports. /*istanbul ignore end*/arrayEqual = arrayEqual;
	/*istanbul ignore start*/exports. /*istanbul ignore end*/arrayStartsWith = arrayStartsWith;
	function arrayEqual(a, b) {
	  if (a.length !== b.length) {
	    return false;
	  }

	  return arrayStartsWith(a, b);
	}

	function arrayStartsWith(array, start) {
	  if (start.length > array.length) {
	    return false;
	  }

	  for (var i = 0; i < start.length; i++) {
	    if (start[i] !== array[i]) {
	      return false;
	    }
	  }

	  return true;
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlsL2FycmF5LmpzIl0sIm5hbWVzIjpbImFycmF5RXF1YWwiLCJhcnJheVN0YXJ0c1dpdGgiLCJhIiwiYiIsImxlbmd0aCIsImFycmF5Iiwic3RhcnQiLCJpIl0sIm1hcHBpbmdzIjoiOzs7Z0NBQWdCQSxVLEdBQUFBLFU7eURBUUFDLGUsR0FBQUEsZTtBQVJULFNBQVNELFVBQVQsQ0FBb0JFLENBQXBCLEVBQXVCQyxDQUF2QixFQUEwQjtBQUMvQixNQUFJRCxFQUFFRSxNQUFGLEtBQWFELEVBQUVDLE1BQW5CLEVBQTJCO0FBQ3pCLFdBQU8sS0FBUDtBQUNEOztBQUVELFNBQU9ILGdCQUFnQkMsQ0FBaEIsRUFBbUJDLENBQW5CLENBQVA7QUFDRDs7QUFFTSxTQUFTRixlQUFULENBQXlCSSxLQUF6QixFQUFnQ0MsS0FBaEMsRUFBdUM7QUFDNUMsTUFBSUEsTUFBTUYsTUFBTixHQUFlQyxNQUFNRCxNQUF6QixFQUFpQztBQUMvQixXQUFPLEtBQVA7QUFDRDs7QUFFRCxPQUFLLElBQUlHLElBQUksQ0FBYixFQUFnQkEsSUFBSUQsTUFBTUYsTUFBMUIsRUFBa0NHLEdBQWxDLEVBQXVDO0FBQ3JDLFFBQUlELE1BQU1DLENBQU4sTUFBYUYsTUFBTUUsQ0FBTixDQUFqQixFQUEyQjtBQUN6QixhQUFPLEtBQVA7QUFDRDtBQUNGOztBQUVELFNBQU8sSUFBUDtBQUNEIiwiZmlsZSI6ImFycmF5LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGZ1bmN0aW9uIGFycmF5RXF1YWwoYSwgYikge1xuICBpZiAoYS5sZW5ndGggIT09IGIubGVuZ3RoKSB7XG4gICAgcmV0dXJuIGZhbHNlO1xuICB9XG5cbiAgcmV0dXJuIGFycmF5U3RhcnRzV2l0aChhLCBiKTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGFycmF5U3RhcnRzV2l0aChhcnJheSwgc3RhcnQpIHtcbiAgaWYgKHN0YXJ0Lmxlbmd0aCA+IGFycmF5Lmxlbmd0aCkge1xuICAgIHJldHVybiBmYWxzZTtcbiAgfVxuXG4gIGZvciAobGV0IGkgPSAwOyBpIDwgc3RhcnQubGVuZ3RoOyBpKyspIHtcbiAgICBpZiAoc3RhcnRbaV0gIT09IGFycmF5W2ldKSB7XG4gICAgICByZXR1cm4gZmFsc2U7XG4gICAgfVxuICB9XG5cbiAgcmV0dXJuIHRydWU7XG59XG4iXX0=


/***/ }),
/* 16 */
/***/ (function(module, exports) {

	/*istanbul ignore start*/"use strict";

	exports.__esModule = true;
	exports. /*istanbul ignore end*/convertChangesToDMP = convertChangesToDMP;
	// See: http://code.google.com/p/google-diff-match-patch/wiki/API
	function convertChangesToDMP(changes) {
	  var ret = [],
	      change = /*istanbul ignore start*/void 0 /*istanbul ignore end*/,
	      operation = /*istanbul ignore start*/void 0 /*istanbul ignore end*/;
	  for (var i = 0; i < changes.length; i++) {
	    change = changes[i];
	    if (change.added) {
	      operation = 1;
	    } else if (change.removed) {
	      operation = -1;
	    } else {
	      operation = 0;
	    }

	    ret.push([operation, change.value]);
	  }
	  return ret;
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb252ZXJ0L2RtcC5qcyJdLCJuYW1lcyI6WyJjb252ZXJ0Q2hhbmdlc1RvRE1QIiwiY2hhbmdlcyIsInJldCIsImNoYW5nZSIsIm9wZXJhdGlvbiIsImkiLCJsZW5ndGgiLCJhZGRlZCIsInJlbW92ZWQiLCJwdXNoIiwidmFsdWUiXSwibWFwcGluZ3MiOiI7OztnQ0FDZ0JBLG1CLEdBQUFBLG1CO0FBRGhCO0FBQ08sU0FBU0EsbUJBQVQsQ0FBNkJDLE9BQTdCLEVBQXNDO0FBQzNDLE1BQUlDLE1BQU0sRUFBVjtBQUFBLE1BQ0lDLHdDQURKO0FBQUEsTUFFSUMsMkNBRko7QUFHQSxPQUFLLElBQUlDLElBQUksQ0FBYixFQUFnQkEsSUFBSUosUUFBUUssTUFBNUIsRUFBb0NELEdBQXBDLEVBQXlDO0FBQ3ZDRixhQUFTRixRQUFRSSxDQUFSLENBQVQ7QUFDQSxRQUFJRixPQUFPSSxLQUFYLEVBQWtCO0FBQ2hCSCxrQkFBWSxDQUFaO0FBQ0QsS0FGRCxNQUVPLElBQUlELE9BQU9LLE9BQVgsRUFBb0I7QUFDekJKLGtCQUFZLENBQUMsQ0FBYjtBQUNELEtBRk0sTUFFQTtBQUNMQSxrQkFBWSxDQUFaO0FBQ0Q7O0FBRURGLFFBQUlPLElBQUosQ0FBUyxDQUFDTCxTQUFELEVBQVlELE9BQU9PLEtBQW5CLENBQVQ7QUFDRDtBQUNELFNBQU9SLEdBQVA7QUFDRCIsImZpbGUiOiJkbXAuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBTZWU6IGh0dHA6Ly9jb2RlLmdvb2dsZS5jb20vcC9nb29nbGUtZGlmZi1tYXRjaC1wYXRjaC93aWtpL0FQSVxuZXhwb3J0IGZ1bmN0aW9uIGNvbnZlcnRDaGFuZ2VzVG9ETVAoY2hhbmdlcykge1xuICBsZXQgcmV0ID0gW10sXG4gICAgICBjaGFuZ2UsXG4gICAgICBvcGVyYXRpb247XG4gIGZvciAobGV0IGkgPSAwOyBpIDwgY2hhbmdlcy5sZW5ndGg7IGkrKykge1xuICAgIGNoYW5nZSA9IGNoYW5nZXNbaV07XG4gICAgaWYgKGNoYW5nZS5hZGRlZCkge1xuICAgICAgb3BlcmF0aW9uID0gMTtcbiAgICB9IGVsc2UgaWYgKGNoYW5nZS5yZW1vdmVkKSB7XG4gICAgICBvcGVyYXRpb24gPSAtMTtcbiAgICB9IGVsc2Uge1xuICAgICAgb3BlcmF0aW9uID0gMDtcbiAgICB9XG5cbiAgICByZXQucHVzaChbb3BlcmF0aW9uLCBjaGFuZ2UudmFsdWVdKTtcbiAgfVxuICByZXR1cm4gcmV0O1xufVxuIl19


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	/*istanbul ignore start*/'use strict';

	exports.__esModule = true;
	exports. /*istanbul ignore end*/convertChangesToXML = convertChangesToXML;
	function convertChangesToXML(changes) {
	  var ret = [];
	  for (var i = 0; i < changes.length; i++) {
	    var change = changes[i];
	    if (change.added) {
	      ret.push('<ins>');
	    } else if (change.removed) {
	      ret.push('<del>');
	    }

	    ret.push(escapeHTML(change.value));

	    if (change.added) {
	      ret.push('</ins>');
	    } else if (change.removed) {
	      ret.push('</del>');
	    }
	  }
	  return ret.join('');
	}

	function escapeHTML(s) {
	  var n = s;
	  n = n.replace(/&/g, '&amp;');
	  n = n.replace(/</g, '&lt;');
	  n = n.replace(/>/g, '&gt;');
	  n = n.replace(/"/g, '&quot;');

	  return n;
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ })
/******/ ])
});
;

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(72), __webpack_require__(73)]);

var IssueMenu = function (_React$Component) {
  _inherits(IssueMenu, _React$Component);

  function IssueMenu() {
    _classCallCheck(this, IssueMenu);

    return _possibleConstructorReturn(this, (IssueMenu.__proto__ || Object.getPrototypeOf(IssueMenu)).apply(this, arguments));
  }

  _createClass(IssueMenu, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var labels = translations.getTranslation(this.props).report.menu;

      var reports = this.props.reports; //{id: uuid.v4(),date:new Date()}];
      return _react2.default.createElement(
        'div',
        { style: { display: "inline-block", float: "right", marginRight: 30, width: 250, borderLeft: "solid lightgrey 1px", paddingTop: 10, paddingLeft: 10, paddingBottom: 150 } },
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 15 } },
          _react2.default.createElement(
            'b',
            null,
            labels.issueOptions
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingLeft: 10 } },
            _react2.default.createElement(
              'div',
              { style: { cursor: "pointer", textDecoration: "underline" }, onClick: this.props.createReport },
              labels.createIssueReport
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingLeft: 10 } },
            _react2.default.createElement(
              'div',
              { style: { cursor: "pointer", textDecoration: "underline" }, onClick: this.props.createExceptionReport },
              labels.createExceptionReport
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 15 } },
          _react2.default.createElement(
            'b',
            null,
            labels.issueReports
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingLeft: 10 } },
            reports !== undefined && reports.length > 0 ? reports.map(function (report) {
              return _react2.default.createElement(
                'div',
                { key: report.id },
                _this2.props.selected === report.id ? _react2.default.createElement(
                  'b',
                  null,
                  new Date(report.date).toISOString().substring(0, 10)
                ) : _react2.default.createElement(
                  'a',
                  { href: "change/issues/" + _this2.props.id + "/reports/" + report.id },
                  new Date(report.date).toISOString().substring(0, 10)
                ),
                report.exception ? _react2.default.createElement('img', { style: { paddingLeft: 5, height: "10pt" }, src: '/images/Flag_DarkGrey_22x16.gif' }) : null
              );
            }) : _react2.default.createElement(
              'i',
              null,
              labels.noReports
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { marginTop: 30, backgroundColor: "#f7f7f7", padding: 10 } },
          _react2.default.createElement(
            'b',
            null,
            labels.whenToUseReports
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          labels.whenToUseReportsIngress,
          ' ',
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          labels.whenToUseIssueReport,
          ' ',
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null),
          labels.whenToUseExceptionReport
        )
      );
    }
  }]);

  return IssueMenu;
}(_react2.default.Component);

exports.default = IssueMenu;

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _IssueDetailsReport = __webpack_require__(1033);

var _IssueDetailsReport2 = _interopRequireDefault(_IssueDetailsReport);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(72), __webpack_require__(73)]);

var IssueReportPreview = function (_React$Component) {
  _inherits(IssueReportPreview, _React$Component);

  function IssueReportPreview(props) {
    _classCallCheck(this, IssueReportPreview);

    var _this = _possibleConstructorReturn(this, (IssueReportPreview.__proto__ || Object.getPrototypeOf(IssueReportPreview)).call(this, props));

    _this.state = { disabled: false };
    return _this;
  }

  _createClass(IssueReportPreview, [{
    key: 'publish',
    value: function publish(event) {
      this.setState({ disabled: true });
      this.props.publish(event);
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).report;
      return _react2.default.createElement(
        'div',
        { style: { display: "flex", justifyContent: "center" } },
        _react2.default.createElement(
          'div',
          { style: { fontFamily: "Verdana, sans-serif", padding: 5 } },
          _react2.default.createElement(_IssueDetailsReport2.default, _extends({}, this.props, {
            type: 'preview',
            timestamp: new Date(),
            date: new Date(),
            issue: this.props.issue
          })),
          _react2.default.createElement(
            'div',
            { style: { paddingTop: 35 } },
            _react2.default.createElement('input', { onClick: this.props.cancel, type: 'button', className: 'cancel', value: labels.cancel }),
            _react2.default.createElement('input', { disabled: this.state.disabled, onClick: this.publish.bind(this), type: 'button', className: 'save', value: !this.state.disabled ? labels.publishReport : labels.publishInProgress })
          )
        )
      );
    }
  }]);

  return IssueReportPreview;
}(_react2.default.Component);

exports.default = IssueReportPreview;

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IssueDetails = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Diff = __webpack_require__(415);

var _Diff2 = _interopRequireDefault(_Diff);

var _FormattedContent = __webpack_require__(15);

var _FormattedContent2 = _interopRequireDefault(_FormattedContent);

var _HighlightReport = __webpack_require__(105);

var _ReportSection = __webpack_require__(416);

var _ReportSection2 = _interopRequireDefault(_ReportSection);

var _formatDate = __webpack_require__(417);

var _formatDate2 = _interopRequireDefault(_formatDate);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(418), __webpack_require__(420)]);

function issueDescription(issue, labels) {
  var description = issue !== undefined && issue.description !== undefined && issue.description !== null ? issue.description : "";
  if (issue !== undefined && issue.type !== undefined) {
    description = description.concat("\n");
    description = description.concat("\n" + labels.type + ": " + labels.typeValues[issue.type]);
  }
  return description;
}

function issueImpact(issue, labels) {
  var impact = issue.impact !== undefined && issue.impact !== null ? issue.impact : "";
  if (impact !== undefined && issue.severity !== undefined && issue.priority !== undefined) {
    impact = impact.concat("\n");
    impact = impact.concat("\n" + labels.severity + ": " + labels.severityValues[issue.severity]);
    impact = impact.concat("\n" + labels.priority + ": " + labels.priorityValues[issue.priority]);
  }
  return impact;
}

function issueDecision(issue, labels) {
  var decision = issue.decision !== undefined && issue.decision !== null ? issue.decision : "";
  if (decision !== undefined && issue.decidedBy !== undefined && issue.deciedBy !== null) {
    decision = decision.concat("\n");
    decision = decision.concat("\n" + labels.decidedBy + " " + issue.decidedBy);
  }
  return decision;
}

function issueStatus(issue, labels) {
  var status = issue.status === "Closed" ? labels.closed : labels.active;
  if (issue.statusDescription !== undefined && issue.statusDescription !== null) {
    status = status.concat("\n\n").concat(issue.statusDescription);
  }
  return status;
}

var IssueDetailsReport = function (_React$Component) {
  _inherits(IssueDetailsReport, _React$Component);

  function IssueDetailsReport() {
    _classCallCheck(this, IssueDetailsReport);

    return _possibleConstructorReturn(this, (IssueDetailsReport.__proto__ || Object.getPrototypeOf(IssueDetailsReport)).apply(this, arguments));
  }

  _createClass(IssueDetailsReport, [{
    key: 'render',
    value: function render() {
      var date = (0, _formatDate2.default)(this.props.date, "<not defined>");
      var nameAndDate = (this.props.project !== undefined ? this.props.project.name + " - " : "") + date;
      var labels = translations.getTranslation(this.props).report.issue;
      var style = Object.assign({}, { maxWidth: 1016 }, this.props.settings !== undefined ? this.props.settings.style : undefined);
      return _react2.default.createElement(
        'div',
        { style: style },
        _react2.default.createElement(
          'h2',
          { style: { textAlign: "center" } },
          _react2.default.createElement(
            'div',
            { style: { fontSize: "120%" } },
            this.props.exception ? labels.exceptionTitle : labels.title
          ),
          _react2.default.createElement(
            'div',
            null,
            nameAndDate
          )
        ),
        this.props.type === "preview" ? _react2.default.createElement(_HighlightReport.ReportMessage, _extends({}, this.props, { label: labels.previewGenerated })) : null,
        _react2.default.createElement(
          'div',
          { style: { paddingBottom: 10 } },
          _react2.default.createElement(
            'h3',
            null,
            this.props.issue.title
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_FormattedContent2.default, { value: issueDescription(this.props.issue, labels) })
          )
        ),
        _react2.default.createElement(_ReportSection2.default, { label: labels.impact, value: issueImpact(this.props.issue, labels) }),
        _react2.default.createElement(_ReportSection2.default, { label: labels.options, value: this.props.issue.options }),
        _react2.default.createElement(_ReportSection2.default, { label: labels.recommendation, value: this.props.issue.recommendation }),
        _react2.default.createElement(_ReportSection2.default, { label: labels.decision, optionalIfEmpty: true, value: issueDecision(this.props.issue, labels) }),
        _react2.default.createElement(_ReportSection2.default, { label: labels.status, optionalIfEmpty: this.props.exception ? true : false, value: issueStatus(this.props.issue, labels) }),
        this.props.exception ? _react2.default.createElement(_ReportSection2.default, { label: labels.lessonSummary, value: this.props.issue.lessonSummary }) : null
      );
    }
  }]);

  return IssueDetailsReport;
}(_react2.default.Component);

exports.default = IssueDetailsReport;

var IssueEventDetails = function (_React$Component2) {
  _inherits(IssueEventDetails, _React$Component2);

  function IssueEventDetails() {
    _classCallCheck(this, IssueEventDetails);

    return _possibleConstructorReturn(this, (IssueEventDetails.__proto__ || Object.getPrototypeOf(IssueEventDetails)).apply(this, arguments));
  }

  _createClass(IssueEventDetails, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var labels = translations.getTranslation(this.props).report.issue;
      var beforeIssue = this.props.beforeState.issues !== undefined ? this.props.beforeState.issues.filter(function (issue) {
        return issue.id === _this3.props.item.id;
      })[0] : undefined;
      var afterIssue = this.props.afterState.issues.filter(function (issue) {
        return issue.id === _this3.props.item.id;
      })[0];
      switch (this.props.type) {
        case "capturedIssue":
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'b',
              null,
              afterIssue.no,
              '. ',
              afterIssue.title
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_FormattedContent2.default, { value: issueDescription(afterIssue, labels) })
            )
          );
        case "updatedCapturedIssue":
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'b',
              null,
              afterIssue.no,
              '. ',
              _react2.default.createElement(_Diff2.default, { newValue: afterIssue.title, value: beforeIssue.title })
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_Diff2.default, {
                value: issueDescription(beforeIssue, labels),
                newValue: issueDescription(afterIssue, labels)
              })
            )
          );
        case "examinedIssue":
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'b',
              null,
              afterIssue.no,
              '. ',
              afterIssue.title
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Impact'
              ),
              ':',
              _react2.default.createElement('br', null),
              _react2.default.createElement(_FormattedContent2.default, { value: issueImpact(afterIssue, labels) })
            )
          );
        case "updatedExaminedIssue":
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'b',
              null,
              afterIssue.no,
              '. ',
              afterIssue.title
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Impact'
              ),
              ':',
              _react2.default.createElement('br', null),
              _react2.default.createElement(_Diff2.default, {
                value: issueImpact(beforeIssue, labels),
                newValue: issueImpact(afterIssue, labels)
              })
            )
          );
        case "proposedIssue":
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'b',
              null,
              afterIssue.no,
              '. ',
              afterIssue.title
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Options'
              ),
              ':',
              _react2.default.createElement('br', null),
              _react2.default.createElement(_FormattedContent2.default, { value: afterIssue.options })
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Recommendation'
              ),
              ':',
              _react2.default.createElement('br', null),
              _react2.default.createElement(_FormattedContent2.default, { value: afterIssue.recommendation })
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Lessons'
              ),
              ':',
              _react2.default.createElement('br', null),
              _react2.default.createElement(_FormattedContent2.default, { value: afterIssue.lessonSummary })
            )
          );
        case "updatedProposedIssue":
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'b',
              null,
              afterIssue.no,
              '. ',
              afterIssue.title
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Options'
              ),
              ':',
              _react2.default.createElement('br', null),
              _react2.default.createElement(_Diff2.default, {
                value: beforeIssue.options,
                newValue: afterIssue.options
              })
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Recommendation'
              ),
              ':',
              _react2.default.createElement('br', null),
              _react2.default.createElement(_Diff2.default, {
                value: beforeIssue.recommendation,
                newValue: afterIssue.recommendation
              })
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Lessons'
              ),
              ':',
              _react2.default.createElement('br', null),
              _react2.default.createElement(_Diff2.default, {
                value: beforeIssue.lessonSummary,
                newValue: afterIssue.lessonSummary
              })
            )
          );
        case "decidedIssue":
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'b',
              null,
              afterIssue.no,
              '. ',
              afterIssue.title
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Decision'
              ),
              ':',
              _react2.default.createElement('br', null),
              _react2.default.createElement(_FormattedContent2.default, { value: issueDecision(afterIssue, labels) })
            )
          );
        case "updatedDecidedIssue":
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'b',
              null,
              afterIssue.no,
              '. ',
              afterIssue.title
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Decision'
              ),
              ':',
              _react2.default.createElement('br', null),
              _react2.default.createElement(_Diff2.default, {
                value: issueDecision(beforeIssue, labels),
                newValue: issueDecision(afterIssue, labels)
              })
            )
          );
        case "implementedIssue":
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'b',
              null,
              afterIssue.no,
              '. ',
              afterIssue.title
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Status'
              ),
              ':',
              _react2.default.createElement('br', null),
              _react2.default.createElement(_Diff2.default, {
                value: issueStatus(beforeIssue, labels),
                newValue: issueStatus(afterIssue, labels)
              })
            )
          );
        case "closedIssue":
        case "reopenedIssue":
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'b',
              null,
              afterIssue.no,
              '. ',
              afterIssue.title
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Status'
              ),
              ':',
              _react2.default.createElement('br', null),
              _react2.default.createElement(_FormattedContent2.default, { value: issueStatus(afterIssue, labels) })
            )
          );

        default:
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'b',
              null,
              afterIssue.no,
              '. ',
              afterIssue.title
            ),
            _react2.default.createElement(
              'div',
              null,
              JSON.stringify(Object.assign({}, this.props, { profile: undefined, project: undefined, beforeState: undefined, afterState: undefined }))
            )
          );
      }
    }
  }]);

  return IssueEventDetails;
}(_react2.default.Component);

var IssueDetails = exports.IssueDetails = function (_React$Component3) {
  _inherits(IssueDetails, _React$Component3);

  function IssueDetails() {
    _classCallCheck(this, IssueDetails);

    return _possibleConstructorReturn(this, (IssueDetails.__proto__ || Object.getPrototypeOf(IssueDetails)).apply(this, arguments));
  }

  _createClass(IssueDetails, [{
    key: 'render',
    value: function render() {
      var _this5 = this;

      var issue = this.props.afterState !== undefined && this.props.afterState.issues !== undefined ? this.props.afterState.issues.filter(function (issue) {
        return issue.id === _this5.props.item.id;
      })[0] : undefined;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(IssueEventDetails, this.props)
      );
    }
  }]);

  return IssueDetails;
}(_react2.default.Component);

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatTime;
function formatTime(time, emptyValue) {
  return time !== undefined ? new Date(time).toISOString().substring(0, 19).replace("T", " ").concat(" GMT") : emptyValue;
}

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  name: "Capture",
  fields: [{ name: "title" }, { name: "type",
    options: [{ value: "change" }, { value: "specification" }, { value: "problem" }]
  }, {
    name: "description",
    height: 5
  }]
}, { name: "Examine",
  fields: [{
    name: "impact",
    height: 5
  }, {
    name: "severity",
    options: [{ value: 1 }, { value: 2 }, { value: 3 }, { value: 4 }, { value: 5 }].reverse(),
    defaultValue: 3
  }, {
    name: "priority",

    options: [{ value: 1 }, { value: 2 }, { value: 3 }, { value: 4 }, { value: 5 }].reverse(),
    defaultValue: 3
  }]
}, { name: "Propose",
  fields: [{
    name: "options",
    optional: true, height: 5
  }, {
    name: "recommendation",
    height: 5
  }, {
    name: "lessonSummary",
    height: 5,
    optional: true
  }]
}, {
  name: "Decide",
  fields: [{
    name: "decision",
    height: 5
  }, {
    name: "decidedBy"
  }]
}, {
  name: "Implement",
  fields: [{ name: "status", options: [{ value: "Active" }, { value: "Closed" }] }, { name: "statusDescription", height: 5 }] }];

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _priority = __webpack_require__(102);

var _priority2 = _interopRequireDefault(_priority);

var _FormattedContent = __webpack_require__(15);

var _FormattedContent2 = _interopRequireDefault(_FormattedContent);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(72), __webpack_require__(73)]);

var IssueReportEntry = function (_Component) {
  _inherits(IssueReportEntry, _Component);

  function IssueReportEntry(props) {
    _classCallCheck(this, IssueReportEntry);

    var _this = _possibleConstructorReturn(this, (IssueReportEntry.__proto__ || Object.getPrototypeOf(IssueReportEntry)).call(this, props));

    _this.state = { hover: false };
    return _this;
  }

  _createClass(IssueReportEntry, [{
    key: 'toggleHover',
    value: function toggleHover(event) {
      event.preventDefault();
      this.setState({ hover: !this.state.hover });
    }
  }, {
    key: 'selectItem',
    value: function selectItem() {
      if (!this.props.item.readOnly && this.props.onSelect !== undefined) {
        this.props.onSelect(this.props.item);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).general.status;
      var item = this.props.item;
      var bgColor = this.state.hover ? "#f1fbfe" : this.props.backgroundColor;
      var status = function () {
        switch (item._progress) {
          case "Capture":
            return labels.captured;
          case "Examine":
            return labels.examined;
          case "Propose":
            return labels.proposed;
          case "Decide":
            return labels.decided;
          case "Implement":
            return labels.implemented;
        }
      }();
      return _react2.default.createElement(
        'div',
        { onClick: this.selectItem.bind(this), onMouseEnter: this.toggleHover.bind(this), onMouseLeave: this.toggleHover.bind(this), style: { cursor: item.readOnly !== true ? "pointer" : undefined, display: "table-row", backgroundColor: bgColor, borderBottom: "solid 1px #939393", color: item.status === "Closed" ? "lightgrey" : item.readOnly ? "#505050" : "#212121", textDecoration: item.status === "Closed" ? "line-through" : "none" } },
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 2, paddingLeft: 7, paddingRight: 5 } },
          _react2.default.createElement(
            'div',
            { style: { display: "table-cell,inline-block", marginTop: 4, padding: 8, borderRadius: "50%", width: 0, hight: 15, backgroundColor: _priority2.default.priorityColor(item, this.props.profile) } },
            ' '
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", textAlign: "center", padding: 5 } },
          item.no
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", padding: 5 } },
          item.title
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", padding: 5 } },
          _react2.default.createElement(_FormattedContent2.default, { value: item.impact })
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", padding: 5 } },
          _react2.default.createElement(_FormattedContent2.default, { value: item.recommendation })
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", padding: 5 } },
          _react2.default.createElement(_FormattedContent2.default, { value: item.decision })
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", padding: 5 } },
          status,
          item._progress === "Implement" && item.statusUpdated !== undefined ? _react2.default.createElement(
            'div',
            { style: { paddingTop: 5 } },
            _react2.default.createElement(
              'b',
              null,
              new Date(item.statusUpdated).toISOString().slice(0, 10)
            ),
            ':',
            _react2.default.createElement(_FormattedContent2.default, { value: item.statusDescription })
          ) : null
        )
      );
    }
  }]);

  return IssueReportEntry;
}(_react.Component);

var IssueReportList = function (_Component2) {
  _inherits(IssueReportList, _Component2);

  function IssueReportList() {
    _classCallCheck(this, IssueReportList);

    return _possibleConstructorReturn(this, (IssueReportList.__proto__ || Object.getPrototypeOf(IssueReportList)).apply(this, arguments));
  }

  _createClass(IssueReportList, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var labels = translations.getTranslation(this.props).report.columns;
      return _react2.default.createElement(
        'div',
        { style: { display: "table", borderCollapse: "collapse", width: "100%" } },
        _react2.default.createElement(
          'div',
          { style: { display: "table-row", borderBottom: "solid 1px #939393", pageBreakInside: "avoid", backgroundColor: "#ffffff", color: "#212121", fontWeight: "bold", textAlign: "left" } },
          _react2.default.createElement('div', { style: { display: "table-cell", paddingTop: 5, paddingBottom: 5, paddingLeft: 10, pageBreakInside: "avoid" } }),
          _react2.default.createElement(
            'div',
            { style: { display: "table-cell", padding: 5, pageBreakInside: "avoid" } },
            labels.id
          ),
          _react2.default.createElement(
            'div',
            { style: { display: "table-cell", padding: 5, pageBreakInside: "avoid" } },
            labels.title
          ),
          _react2.default.createElement(
            'div',
            { style: { display: "table-cell", padding: 5, pageBreakInside: "avoid" } },
            labels.impact
          ),
          _react2.default.createElement(
            'div',
            { style: { display: "table-cell", padding: 5, pageBreakInside: "avoid" } },
            labels.recommendation
          ),
          _react2.default.createElement(
            'div',
            { style: { display: "table-cell", padding: 5, pageBreakInside: "avoid" } },
            labels.decision
          ),
          _react2.default.createElement(
            'div',
            { style: { display: "table-cell", padding: 5, pageBreakInside: "avoid" } },
            labels.status
          )
        ),
        this.props.items.map(function (item, index) {
          return _react2.default.createElement(IssueReportEntry, _extends({ key: index }, _this3.props, { language: _this3.props.language, onSelect: _this3.props.onSelect, backgroundColor: index % 2 === 1 ? "#f7f7f7" : "white", item: item }));
        })
      );
    }
  }]);

  return IssueReportList;
}(_react.Component);

exports.default = IssueReportList;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

'use srict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _sortByDate = __webpack_require__(257);

var _sortByDate2 = _interopRequireDefault(_sortByDate);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(72), __webpack_require__(73)]);

var LastIssueReports = function (_React$Component) {
  _inherits(LastIssueReports, _React$Component);

  function LastIssueReports() {
    _classCallCheck(this, LastIssueReports);

    return _possibleConstructorReturn(this, (LastIssueReports.__proto__ || Object.getPrototypeOf(LastIssueReports)).apply(this, arguments));
  }

  _createClass(LastIssueReports, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).report;
      var reports = this.props.issues !== undefined ? [].concat.apply([], this.props.issues.map(function (issue) {
        return issue.reports;
      })).filter(function (report) {
        return report !== null && report !== undefined;
      }).sort(_sortByDate2.default).reverse().slice(0, 8) : [];
      return reports.length > 0 ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { fontSize: "110%", paddingBottom: 5 } },
          _react2.default.createElement(
            'b',
            null,
            labels.lastIssueReports
          )
        ),
        reports.map(function (report) {
          return _react2.default.createElement(
            'div',
            { style: { paddingBottom: 3 }, key: report.id },
            '[',
            report.date !== undefined ? new Date(Date.parse(report.date)).toISOString().slice(0, 10) : "",
            ']',
            _react2.default.createElement(
              'span',
              null,
              ' '
            ),
            _react2.default.createElement(
              'a',
              { style: { fontStyle: report.project !== undefined ? "italic" : undefined }, href: (report.project !== undefined ? "/projects/" + report.project.id + "/" : "") + "change/issues/" + report.issue.id + "/reports/" + report.id },
              report.issue.no,
              '. ',
              report.issue.title
            ),
            report.exception ? _react2.default.createElement('img', { style: { paddingLeft: 5, height: "10pt" }, src: '/images/Flag_DarkGrey_22x16.gif' }) : null
          );
        })
      ) : null;
    }
  }]);

  return LastIssueReports;
}(_react2.default.Component);

exports.default = LastIssueReports;

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _superagent = __webpack_require__(23);

var _superagent2 = _interopRequireDefault(_superagent);

var _AreaForm = __webpack_require__(28);

var _AreaForm2 = _interopRequireDefault(_AreaForm);

var _FormattedContent = __webpack_require__(15);

var _FormattedContent2 = _interopRequireDefault(_FormattedContent);

var _Risk = __webpack_require__(63);

var _Change = __webpack_require__(95);

var _Report = __webpack_require__(258);

var _ReportMenu = __webpack_require__(1043);

var _ReportMenu2 = _interopRequireDefault(_ReportMenu);

var _uuid = __webpack_require__(26);

var _uuid2 = _interopRequireDefault(_uuid);

var _formDefinition = __webpack_require__(1044);

var _formDefinition2 = _interopRequireDefault(_formDefinition);

var _sendCommand = __webpack_require__(25);

var _sendCommand2 = _interopRequireDefault(_sendCommand);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(1045), __webpack_require__(1046)]).loadVariants([__webpack_require__(419), __webpack_require__(421), __webpack_require__(1047), __webpack_require__(1048), __webpack_require__(1049), __webpack_require__(1050), __webpack_require__(1051), __webpack_require__(1052)]);

var ReportActions = function (_React$Component) {
  _inherits(ReportActions, _React$Component);

  function ReportActions(props) {
    _classCallCheck(this, ReportActions);

    var _this = _possibleConstructorReturn(this, (ReportActions.__proto__ || Object.getPrototypeOf(ReportActions)).call(this, props));

    _this.state = { savedDraft: false };
    return _this;
  }

  _createClass(ReportActions, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState({ savedDraft: false });
    }
  }, {
    key: 'saveDraft',
    value: function saveDraft(event) {
      if (this.state.savedDraft) {
        event.preventDefault();
      } else {
        this.setState({ savedDraft: true });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).report;
      return _react2.default.createElement(
        'div',
        { style: { height: 40 } },
        _react2.default.createElement('input', { onClick: this.props.onCancel, name: 'cancel', className: 'cancel', value: labels.cancel, type: 'button' }),
        this.state.savedDraft ? _react2.default.createElement('input', { name: 'savedDraft', type: 'hidden', value: 'true' }) : null,
        _react2.default.createElement('input', { onClick: this.saveDraft.bind(this), className: 'save', value: this.state.savedDraft ? labels.inProgress : labels.saveDraft, type: 'submit' })
      );
    }
  }]);

  return ReportActions;
}(_react2.default.Component);

var ReportPreview = function (_React$Component2) {
  _inherits(ReportPreview, _React$Component2);

  function ReportPreview(props) {
    _classCallCheck(this, ReportPreview);

    var _this2 = _possibleConstructorReturn(this, (ReportPreview.__proto__ || Object.getPrototypeOf(ReportPreview)).call(this, props));

    _this2.state = { published: false };
    return _this2;
  }

  _createClass(ReportPreview, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState({ published: false });
    }
  }, {
    key: 'publish',
    value: function publish(event) {
      if (this.state.published) {
        event.preventDefault();
      } else {
        this.setState({ published: true });
      }
      if (this.props.publishReport !== undefined) {
        this.props.publishReport(event);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).report;
      var highlightReport = {};
      if (this.props.values !== undefined) {
        var values = this.props.values;
        var from = undefined;
        var to = undefined;
        if (values.period !== undefined) {
          if (values.period.from !== undefined) {
            from = values.period.from;
          }
          if (values.period.to !== undefined) {
            to = values.period.to;
          }
          if (typeof values.period === "string") {
            var parts = values.period.split(" to ");
            if (parts.length > 0) {
              from = parts[0];
            }
            if (parts.length > 1) {
              to = parts[1];
            }
          }
        }
        highlightReport = {
          overallStatus: {
            content: values.summary,
            status: values.summary_status
          },
          endProject: this.props.endProject,
          stage: this.props.endStage && this.props.project.currentStage !== undefined ? { id: this.props.project.currentStage.id } : null,
          performedAchivements: values.performedAchivements,
          plannedAchivements: values.plannedAchivements,
          benefits: {
            content: values.benefits,
            status: values.benefits_status
          },
          time: {
            content: values.time,
            status: values.time_status
          },
          cost: {
            content: values.cost,
            status: values.cost_status
          },
          quality: {
            content: values.quality,
            status: values.quality_status
          },
          scope: {
            content: values.scope,
            status: values.scope_status
          },
          risk: {
            content: values.risk,
            status: values.risk_status
          },
          teamPerformance: values.teamPerformance,
          lessonsDescription: values.lessonsDescription,
          updatedBy: this.props.user.id,
          from: from,
          date: to,
          statusDate: to
        };
      } else {
        highlightReport = this.props.report;
      }

      return _react2.default.createElement(
        'div',
        { className: 'report', style: { fontSize: "12pt" } },
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 10, paddingBottom: 35 } },
          this.state.published ? _react2.default.createElement('input', { type: 'hidden', name: 'published', value: 'true' }) : null,
          _react2.default.createElement('input', { onClick: this.publish.bind(this), type: 'submit', className: 'save', value: !this.state.published ? labels.publishReport : labels.publishInProgress })
        ),
        _react2.default.createElement(_Report.Report, _extends({}, this.props, {
          selected: this.props.values !== undefined ? "preview" : "draft",
          project: this.props.values !== undefined ? Object.assign({}, this.props.project, {
            issues: this.props.issues,
            risks: this.props.risks,
            draftHighlight: highlightReport
          }) : this.props.project,
          tenant: this.props.tenant,
          user: this.props.user
        })),
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 35, paddingBottom: 55 } },
          this.state.published ? _react2.default.createElement('input', { type: 'hidden', name: 'published', value: 'true' }) : null,
          _react2.default.createElement('input', { onClick: this.publish.bind(this), type: 'submit', className: 'save', value: !this.state.published ? labels.publishReport : labels.publishInProgress })
        )
      );
    }
  }]);

  return ReportPreview;
}(_react2.default.Component);

var StageDetails = function (_React$Component3) {
  _inherits(StageDetails, _React$Component3);

  function StageDetails() {
    _classCallCheck(this, StageDetails);

    return _possibleConstructorReturn(this, (StageDetails.__proto__ || Object.getPrototypeOf(StageDetails)).apply(this, arguments));
  }

  _createClass(StageDetails, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'b',
          null,
          this.props.name
        ),
        _react2.default.createElement(
          'span',
          null,
          ', ',
          this.props.time.start,
          ' - ',
          this.props.time.end,
          ' (',
          this.props.time.tolerance,
          ')'
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'i',
            null,
            _react2.default.createElement(_FormattedContent2.default, { value: this.props.comments })
          )
        )
      );
    }
  }]);

  return StageDetails;
}(_react2.default.Component);

var TabReport = function (_React$Component4) {
  _inherits(TabReport, _React$Component4);

  function TabReport(props) {
    _classCallCheck(this, TabReport);

    var _this4 = _possibleConstructorReturn(this, (TabReport.__proto__ || Object.getPrototypeOf(TabReport)).call(this, props));

    _this4.state = {
      showPreview: false,
      report: _this4.asFormFields(_this4.props.report, _this4.props.lastReport),
      lastSavedReport: _this4.props.report,
      issues: _this4.props.issues !== undefined ? _this4.props.issues : _this4.props.project !== undefined && _this4.props.project.issues !== undefined ? _this4.props.project.issues : [],
      risks: _this4.props.risks !== undefined ? _this4.props.risks : _this4.props.project !== undefined && _this4.props.project.risks !== undefined ? _this4.props.project.risks : []
    };
    _this4.warningOnLeave = _this4.changeWarningOnLeave.bind(_this4);
    return _this4;
  }

  _createClass(TabReport, [{
    key: 'asFormFields',
    value: function asFormFields(report, lastReport) {
      return Object.assign({}, {}, {
        _currentProgress: report._currentProgress,
        period: { from: report.from, to: report.date },
        summary: report.overallStatus.content,
        summary_status: report.overallStatus.status,
        performedAchivements: report.performedAchivements,
        plannedAchivements: report.plannedAchivements,
        benefits: report.benefits.content,
        benefits_status: report.benefits.status,
        time: report.time.content,
        time_status: report.time.status,
        cost: report.cost.content,
        cost_status: report.cost.status,
        quality: report.quality.content,
        quality_status: report.quality.status,
        scope: report.scope.content,
        scope_status: report.scope.status,
        risk: report.risk.content,
        risk_status: report.risk.status,
        teamPerformance: report.teamPerformance,
        lessonsDescription: report.lessonsDescription,
        previousValues: lastReport !== undefined ? {
          summary: lastReport.summary !== undefined ? lastReport.summary.content : undefined,
          summary_status: lastReport.summary !== undefined ? lastReport.summary.status : undefined,
          performedAchivements: lastReport.performedAchivements,
          plannedAchivements: lastReport.plannedAchivements,
          benefits: lastReport.benefits !== undefined ? lastReport.benefits.content : undefined,
          benefits_status: lastReport.benefits !== undefined ? lastReport.benefits.status : undefined,
          time: lastReport.time !== undefined ? lastReport.time.content : undefined,
          time_status: lastReport.time !== undefined ? lastReport.time.status : undefined,
          cost: lastReport.cost !== undefined ? lastReport.cost.content : undefined,
          cost_status: lastReport.cost !== undefined ? lastReport.cost.status : undefined,
          quality: lastReport.quality !== undefined ? lastReport.quality.content : undefined,
          quality_status: lastReport.quality !== undefined ? lastReport.quality.status : undefined,
          scope: lastReport.scope !== undefined ? lastReport.scope.content : undefined,
          scope_status: lastReport.scope !== undefined ? lastReport.scope.status : undefined,
          risk: lastReport.risk !== undefined ? lastReport.risk.content : undefined,
          risk_status: lastReport.risk !== undefined ? lastReport.risk.status : undefined
        } : undefined,
        _progress: "Preview"
      });
    }
  }, {
    key: 'summary',
    value: function summary(tab, values, originalValues) {
      var content = undefined;
      switch (tab) {
        case "Plan":
          if (this.props.endProject) {
            content = null;
          } else {
            content = this.props.project.currentStage !== undefined ? _react2.default.createElement(StageDetails, this.props.project.currentStage) : undefined;
          }
          break;
        default:
          if (this.props.endProject) {
            content = null;
          } else if (this.props.endStage && this.props.project.currentStage !== undefined) {
            content = _react2.default.createElement(StageDetails, this.props.project.currentStage);
          } else {
            content = undefined;
          }
      }
      return content !== undefined ? _react2.default.createElement(
        'div',
        { style: { fontFamily: "Arial", fontSize: "10pt", padding: 10, textAlign: "left" } },
        content
      ) : null;
    }
  }, {
    key: 'updateIssues',
    value: function updateIssues(issues) {
      this.setState({ issues: issues, modified: true });
    }
  }, {
    key: 'updateRisks',
    value: function updateRisks(risks) {
      this.setState({ risks: risks, modified: true });
    }
  }, {
    key: 'details',
    value: function details(tab, values, originalValues) {
      var content = undefined;
      var labels = translations.getTranslation(this.props).report;
      switch (tab) {
        case "Preview":
          content = _react2.default.createElement(ReportPreview, _extends({}, this.props, { values: values, issues: this.state.issues, risks: this.state.risks, publishReport: this.publishReport.bind(this) }));
          break;

        case "Overview":
          content = this.props.endProject ? undefined : _react2.default.createElement(
            'div',
            null,
            this.state.risks.filter(function (item) {
              return item.status !== "Closed";
            }).length > 0 ? _react2.default.createElement(
              'div',
              { style: { paddingBottom: 50, textAlign: "left" } },
              _react2.default.createElement('br', null),
              labels.listLimitedTo,
              _react2.default.createElement(
                'b',
                null,
                ' ',
                labels.top5Risks
              ),
              ':',
              _react2.default.createElement(_Risk.Risk, _extends({}, this.props, {
                project: this.props.project,
                mode: 'followUp',
                size: 5,
                risks: this.state.risks.filter(function (item) {
                  return item.status !== "Closed";
                }),
                onUpdate: this.updateRisks.bind(this)
              }))
            ) : null,
            this.state.issues.filter(function (item) {
              return item.status !== "Closed";
            }).length > 0 ? _react2.default.createElement(
              'div',
              { style: { textAlign: "left" } },
              _react2.default.createElement('br', null),
              labels.listLimitedTo,
              _react2.default.createElement(
                'b',
                null,
                ' ',
                labels.top5Issues
              ),
              ':',
              _react2.default.createElement(_Change.Change, _extends({}, this.props, {
                hideReports: true,
                project: this.props.project,
                mode: 'followUp',
                size: 5,
                issues: this.state.issues.filter(function (item) {
                  return item.status !== "Closed";
                }),
                hideMenu: true,
                onUpdate: this.updateIssues.bind(this)
              }))
            ) : null
          );
          break;

        default:
          content = undefined;
      }
      return content !== undefined ? _react2.default.createElement(
        'div',
        { style: { borderTop: "solid 5px #8faadc", marginTop: 15, fontFamily: "Arial", fontSize: "10pt" } },
        content
      ) : null;
    }
  }, {
    key: 'showReportPreview',
    value: function showReportPreview(event) {
      event.preventDefault();
      this.setState({ showPreview: !this.state.showPreview });
    }

    /*
      sendCommand(command,success) {
        request
          .post("/")
          .send(command)
          .end(function(error, response) {
            if (error===null && response.status===200) {
              var message=JSON.parse(response.text);
              if (message.status==="OK") {
                console.log("Success for command '"+command.type+"'");
                success(message.report);
              } else {
                console.log("Error: "+message.message);
                window.alert("Not able to save or publish highlight report");
              }
            } else {
              console.log("Error: "+error+", got "+response.status+" with message "+response.text);
              window.alert("Not able to save or publish highlight report");
            }
          });
      }
    */

  }, {
    key: 'getHighlightReport',
    value: function getHighlightReport(form) {
      var fromDate = undefined;
      var toDate = undefined;
      if (typeof form.period === "string") {
        var parts = form.period.split(" to ");
        fromDate = parts.length > 0 ? parts[0] : undefined;
        toDate = parts.length > 1 ? parts[1] : undefined;
      } else {
        if (form.period !== undefined) {
          fromDate = form.period.from;
          toDate = form.period.to;
        } else {
          fromDate = undefined;
          toDate = new Date();
        }
      }
      var currentManager = this.props.project !== undefined && this.props.project.stakeholders !== undefined ? this.props.project.stakeholders.find(function (stakeholder) {
        return stakeholder.role === "Project Manager" || stakeholder.role === "Product Manager";
      }) : undefined;
      var report = {
        id: this.props.report.id !== undefined ? this.props.report.id : _uuid2.default.v4(),
        stage: this.props.endStage && this.props.project.currentStage !== undefined ? { id: this.props.project.currentStage.id } : undefined,
        from: fromDate,
        date: toDate,
        manager: currentManager,
        summary: {
          status: form.summary_status,
          content: form.summary
        },
        performedAchivements: form.performedAchivements,
        plannedAchivements: form.plannedAchivements,
        benefits: {
          status: form.benefits_status,
          content: form.benefits
        },
        time: {
          status: form.time_status,
          content: form.time
        },
        cost: {
          status: form.cost_status,
          content: form.cost
        },
        quality: {
          status: form.quality_status,
          content: form.quality
        },
        scope: {
          status: form.scope_status,
          content: form.scope
        },
        risk: {
          status: form.risk_status,
          content: form.risk
        }
      };
      if (this.props.endProject || this.props.endStage) {
        report.teamPerformance = form.teamPerformance;
        report.lessonsDescription = form.lessonsDescription;
      }
      return report;
    }
  }, {
    key: 'publishReport',
    value: function publishReport() {
      var _this5 = this;

      var command = {
        type: this.props.endProject ? "publishEndProjectReport" : this.props.endStage ? "publishEndStageReport" : "publishHighlightReport",
        report: this.getHighlightReport(this.state.report)
      };
      if (this.props.project.isProduct) {
        command = Object.assign({}, command, {
          product: { id: this.props.project.id }
        });
      } else if (this.props.project.isProgramme) {
        command = Object.assign({}, command, {
          programme: { id: this.props.project.id }
        });
      } else if (this.props.project.isRelease) {
        command = Object.assign({}, command, {
          release: { id: this.props.project.id }
        });
      } else {
        command = Object.assign({}, command, {
          project: { id: this.props.project.id }
        });
      }
      (0, _sendCommand2.default)(command).then(function (response) {
        _this5.setState({ published: true }, function () {
          return window.location = (_this5.props.project.isProduct ? "/products/" : _this5.props.project.isProgramme ? "/programmes/" : _this5.props.project.isRelease ? "/releases/" : "/projects/") + _this5.props.project.id + "/reports/?id=" + command.report.id + (_this5.props.endStage ? "&showEndStage=true" : "");
        });
        window.removeEventListener("beforeunload", _this5.changeWarningOnLeave.bind(_this5));
      }).catch(function (error) {
        console.log("Got error", error);
        _this5.setState({ modified: false });
        alert("Not able to publish report, please try again");
      });
    }
  }, {
    key: 'update',
    value: function update(reportForm) {
      var _this6 = this;

      if (reportForm.savedDraft === "true") {
        var command = {
          type: this.props.endProject ? "saveEndProjectReportDraft" : this.props.endStage ? "saveEndStageReportDraft" : "saveHighlightReportDraft",
          report: this.getHighlightReport(reportForm)
        };
        if (this.props.project.isProduct) {
          command = Object.assign({}, command, {
            product: { id: this.props.project.id }
          });
        } else if (this.props.project.isProgramme) {
          command = Object.assign({}, command, {
            programme: { id: this.props.project.id }
          });
        } else if (this.props.project.isRelease) {
          command = Object.assign({}, command, {
            release: { id: this.props.project.id }
          });
        } else {
          command = Object.assign({}, command, {
            project: { id: this.props.project.id }
          });
        }
        (0, _sendCommand2.default)(command).then(function (response) {
          return _this6.setState({
            lastSavedReport: response.report,
            report: _this6.asFormFields(Object.assign({}, response.report, { _currentProgress: reportForm._progress }), _this6.props.lastReport),
            modified: undefined
          });
        }).catch(function (error) {
          console.log("Got error", error);
          _this6.setState({ modified: false });
          alert("Not able to save report, please try again");
        });
      }
    }
  }, {
    key: 'hasChanged',
    value: function hasChanged(lastSavedReport) {
      var _this7 = this;

      var report = this.asFormFields(lastSavedReport);
      return _formDefinition2.default.map(function (area) {
        return area.fields !== undefined && area.fields.map(function (field) {
          return JSON.stringify(report[field.name]) !== JSON.stringify(_this7.state.report[field.name]) || field.includeStatus && JSON.stringify(report[field.name + "_status"]) !== JSON.stringify(_this7.state.report[field.name + "_status"]);
        }).reduce(function (value, result) {
          return result || value;
        });
      }).reduce(function (value, result) {
        return result || value;
      });
    }
  }, {
    key: 'changeWarningOnLeave',
    value: function changeWarningOnLeave(e) {
      if (this.hasChanged(this.state.lastSavedReport) && !this.state.published) {
        e.returnValue = "Do you want to keep changes?";
        return "Do you want to keep changes?";
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener("beforeunload", this.warningOnLeave);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener("beforeunload", this.warningOnLeave);
    }
  }, {
    key: 'handleFieldChange',
    value: function handleFieldChange(fieldName) {
      var _this8 = this;

      return function (event) {
        _this8.setState({
          report: Object.assign({}, _this8.state.report, _defineProperty({}, event.target.name, event.target.value)),
          modified: true
        });
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var actions = _react2.default.createElement(ReportActions, _extends({}, this.props, { onCancel: this.props.onCancel }));
      var displayType = this.props.endStage && this.props.project.currentStage !== undefined ? "endStage" : this.props.endProject == true ? "endProject" : "normal";
      var areas = translations.createTranslatedForm(_formDefinition2.default, this.props.language, this.props.variant);
      return this.state.showPreview ? _react2.default.createElement(
        'div',
        { style: { display: "flex", justifyContent: "center" } },
        _react2.default.createElement(
          'div',
          { style: { flexBasis: "100%", maxWidth: 1016, minWidth: 250 } },
          _react2.default.createElement(ReportPreview, _extends({}, this.props, {
            cancel: this.showReportPreview.bind(this),
            publish: this.publishReport.bind(this)
          }))
        )
      ) : _react2.default.createElement(
        'div',
        { style: { textAlign: "left" } },
        _react2.default.createElement(
          'div',
          { style: { display: "flex", justifyContent: "center" } },
          _react2.default.createElement(
            'div',
            { style: { flexBasis: "100%", maxWidth: 1016, minWidth: 250 } },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_AreaForm2.default, _extends({}, this.props, {
                areas: areas,
                display: 'tab',
                summary: this.summary.bind(this),
                details: this.details.bind(this),
                item: this.state.report,
                actions: actions,
                selected: 0,
                onUpdate: this.update.bind(this),
                modified: this.state.modified,
                handleFieldChange: this.handleFieldChange.bind(this),
                displayType: displayType
              }))
            )
          )
        )
      );
    }
  }]);

  return TabReport;
}(_react2.default.Component);

exports.default = TabReport;

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1040);


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDefaultInjection = __webpack_require__(379);
var ReactServerRendering = __webpack_require__(1041);
var ReactVersion = __webpack_require__(406);

ReactDefaultInjection.inject();

var ReactDOMServer = {
  renderToString: ReactServerRendering.renderToString,
  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
  version: ReactVersion
};

module.exports = ReactDOMServer;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(12);

var React = __webpack_require__(85);
var ReactDOMContainerInfo = __webpack_require__(404);
var ReactDefaultBatchingStrategy = __webpack_require__(399);
var ReactInstrumentation = __webpack_require__(45);
var ReactMarkupChecksum = __webpack_require__(405);
var ReactReconciler = __webpack_require__(93);
var ReactServerBatchingStrategy = __webpack_require__(1042);
var ReactServerRenderingTransaction = __webpack_require__(398);
var ReactUpdates = __webpack_require__(52);

var emptyObject = __webpack_require__(247);
var instantiateReactComponent = __webpack_require__(246);
var invariant = __webpack_require__(6);

var pendingTransactions = 0;

/**
 * @param {ReactElement} element
 * @return {string} the HTML markup
 */
function renderToStringImpl(element, makeStaticMarkup) {
  var transaction;
  try {
    ReactUpdates.injection.injectBatchingStrategy(ReactServerBatchingStrategy);

    transaction = ReactServerRenderingTransaction.getPooled(makeStaticMarkup);

    pendingTransactions++;

    return transaction.perform(function () {
      var componentInstance = instantiateReactComponent(element, true);
      var markup = ReactReconciler.mountComponent(componentInstance, transaction, null, ReactDOMContainerInfo(), emptyObject, 0 /* parentDebugID */
      );
      if (false) {
        ReactInstrumentation.debugTool.onUnmountComponent(componentInstance._debugID);
      }
      if (!makeStaticMarkup) {
        markup = ReactMarkupChecksum.addChecksumToMarkup(markup);
      }
      return markup;
    }, null);
  } finally {
    pendingTransactions--;
    ReactServerRenderingTransaction.release(transaction);
    // Revert to the DOM batching strategy since these two renderers
    // currently share these stateful modules.
    if (!pendingTransactions) {
      ReactUpdates.injection.injectBatchingStrategy(ReactDefaultBatchingStrategy);
    }
  }
}

/**
 * Render a ReactElement to its initial HTML. This should only be used on the
 * server.
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostring
 */
function renderToString(element) {
  !React.isValidElement(element) ?  false ? invariant(false, 'renderToString(): You must pass a valid ReactElement.') : _prodInvariant('46') : void 0;
  return renderToStringImpl(element, false);
}

/**
 * Similar to renderToString, except this doesn't create extra DOM attributes
 * such as data-react-id that React uses internally.
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdomserver.rendertostaticmarkup
 */
function renderToStaticMarkup(element) {
  !React.isValidElement(element) ?  false ? invariant(false, 'renderToStaticMarkup(): You must pass a valid ReactElement.') : _prodInvariant('47') : void 0;
  return renderToStringImpl(element, true);
}

module.exports = {
  renderToString: renderToString,
  renderToStaticMarkup: renderToStaticMarkup
};

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactServerBatchingStrategy = {
  isBatchingUpdates: false,
  batchedUpdates: function (callback) {
    // Don't do anything here. During the server rendering we don't want to
    // schedule any updates. We will simply ignore them.
  }
};

module.exports = ReactServerBatchingStrategy;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IssueMenu = function (_React$Component) {
  _inherits(IssueMenu, _React$Component);

  function IssueMenu() {
    _classCallCheck(this, IssueMenu);

    return _possibleConstructorReturn(this, (IssueMenu.__proto__ || Object.getPrototypeOf(IssueMenu)).apply(this, arguments));
  }

  _createClass(IssueMenu, [{
    key: 'render',
    value: function render() {
      var languageLabels = {
        norwegian: {
          reportOptions: "Rapportvalg",
          publishReport: "Publiser rapport"
        },
        english: {
          reportOptions: "Report Options",
          publishReport: "Publish Report"
        }
      };
      var labels = languageLabels[this.props.language] || languageLabels["english"];

      var reports = this.props.reports; //{id: uuid.v4(),date:new Date()}];
      return _react2.default.createElement(
        'div',
        { style: { display: "inline-block", float: "right", marginRight: 30, width: 250, borderLeft: "solid lightgrey 1px", paddingTop: 10, paddingLeft: 10, paddingBottom: 150 } },
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 15 } },
          _react2.default.createElement(
            'b',
            null,
            labels.reportOptions
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingLeft: 10 } },
            _react2.default.createElement(
              'div',
              { style: { cursor: "pointer", textDecoration: "underline" }, onClick: this.props.publishReport },
              labels.publishReport
            )
          )
        )
      );
    }
  }]);

  return IssueMenu;
}(_react2.default.Component);

exports.default = IssueMenu;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  name: "Overview",
  fields: [{ name: "period", type: "period" }, { name: "summary", height: 5, includeStatus: true, optional: true }, { name: "performedAchivements", height: 5, optional: true }, { name: "plannedAchivements", height: 5, optional: true, excludedFor: ["endStage", "endProject"] }, { name: "deliveryStatus", type: "table", optional: true, includedFor: [],
    columns: [{ name: "product", dragable: true, editable: true }, { name: "responsible", editable: true }, { name: "dueDate", editable: true }, { name: "status", editable: true }],
    includeEmptyLine: true
  }, { name: "benefits", height: 5, includeStatus: true, optional: true }, { name: "time", height: 5, includeStatus: true, optional: true }, { name: "cost", height: 5, includeStatus: true, optional: true }, { name: "quality", height: 5, includeStatus: true, optional: true }, { name: "scope", height: 5, includeStatus: true, optional: true }, { name: "risk", height: 5, includeStatus: true, optional: true }, { name: "teamPerformance", height: 5, optional: true, includedFor: ["endProject", "endStage"] }, { name: "lessonsDescription", height: 5, optional: true, includedFor: ["endProject", "endStage"] }]
}, {
  name: "Preview"
}];

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var english = exports.english = {
  report: {
    cancel: "Cancel",
    publishReport: "Publish report",
    publishInProgress: "... publish ongoing ...",
    inProgress: " .. in progress",
    saveDraft: "Save draft",
    listLimitedTo: "The report will be limited to the",
    top5Risks: "top 5 risks",
    top5Issues: "top 5 issues"
  },
  Overview: {
    title: "Overview",
    fields: {
      period: {
        title: "Reporting period",
        help: "Select the reporting period for this Highlight Report. Double click on a date in the calendar to make it the starting date of the reporting period. Single click on a date to make it the end date."
      },
      summary: {
        title: "Summary",
        help: "What stage and lifecycle phase is the project in right now (or which tranche if you are managing a programme)? Have any major milestones just passed, or are there any in the near future? Are there any resent successes or break throughs? What are currently the main challenges? What is the general health condition?",
        description: "Describe the overall status. Assume the reader has not read the previous report or know any details up front."
      },
      performedAchivements: {
        title: "This period",
        help: "Which work packages were in execution or completed this period? Which products were completed this period? Was any products planned to be completed but was not completed this period? Was any corrective actions taken during the period?",
        description: "Describe the goals achieved this period"

      },
      plannedAchivements: {
        title: "Next period",
        help: "Which work packages will be in execution or will be completed the coming period? Which products are planned to be completed this period? Any corrective actions planned for the coming period?",
        description: "Describe the goals set for the next period"
      },
      deliveryStatus: {
        title: "Status of Deliveries",
        columns: {
          product: { title: "Planned Delivered this Stage" },
          responsible: { title: "Responsible" },
          dueDate: { title: "Due Date" },
          status: { title: "Status" }
        }
      },

      benefits: {
        title: "Benefits",
        help: "Are we on track to deliver the desired return of investment? If not, what is the difference and why? Any new benefits added to, or removed from, the business case?",
        description: "Describe how the business case is performing"
      },
      time: {
        title: "Time",
        help: "What is the latest forecast on completing this stage, and how does it compare to the approved plan? What is the latest forecast on completing the project/programme, and how does it compare to the approved plan?",
        description: "Describe how progress of the project/programme and management stage is performing against the objectives and tolerances"
      },
      cost: {
        title: "Cost",
        help: "How much is spent to date in the current stage, what is forecasted to be spent this stage and what is currently the approved spending for the stage? How much is spent to date in the project/programme, what is forecasted to be spent in the project/programme and what is currently the approved spending?",
        description: "Describe how cost of the project/programme and management stage is performing against the objectives and tolerances"
      },

      quality: {
        title: "Quality",
        help: "Have products delivered this period met the agreed quality criteria? Have the acceptance methods (testing, reviews...)  for the products this period been applied as agreed? Have the products produced to date in the project met the agreed quality criteria? Have applicable quality standards and processes been followed during this period and to date in the project?",
        description: "Describe how the functionalities and requirements of the project/programme and management stage are performing against their tolerances"
      },
      scope: {
        title: "Scope",
        help: "Were the products for this period identified and well defined - including composition and quality criteria? Are the products for this project identified and well defined? Are there any changes to the scope?",
        description: "Describe how the project/programme is performing against the agreed scope"
      },

      risk: {
        title: "Risk",
        help: "What is the current risk level in the project and how is it matching the stakeholders risk appetite?  What are the most important risks and what actions are taken?",
        description: "Describe how the current risk level is compared to the agreed risk appetite"
      },

      teamPerformance: {
        title: "Team performance",
        help: "",
        description: ""
      },
      lessonsDescription: {
        title: "Lessons",
        help: "",
        description: ""
      }
    }
  },
  Preview: {
    title: "Preview Report"
  }
};

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var norwegian = exports.norwegian = {
  report: {
    cancel: "Avbryt",
    publishReport: "Publiser rapport",
    publishInProgress: "... publisering pågår ...",
    inProgress: " .. pågår",
    saveDraft: "Lagre utkast",
    listLimitedTo: "Rapporten er begrenset til bare å vise",
    top5Risks: "top 5 riski",
    top5Issues: "top 5 saker"
  },
  Overview: {
    title: "Oversikt",
    fields: {
      period: {
        title: "Rapporteringsperiode",
        help: "Angi start og sluttdato for denne statusrapporten. Dobbeltklikk på en dato i kalenderen for å angi startdato. Enkeltklikk på en dato for å angi sluttdato."
      },
      summary: {
        title: "Oppsummering",
        help: "Hvilken fase og livssyklusfase er prosjektet i akkurat nå? Har noen viktige milepæler bare passert, eller er det noen i nær fremtid? Er det noen nylige suksesser eller gjennomslag i prosjektet? Hva er for tiden de viktigste utfordringene? Hva er prosjektets generelle helsetilstand?",
        description: "Beskriv prosjektets overordnede status. Anta at leseren ikke har lest den forrige rapporten eller vet detaljene i prosjektet."
      },
      performedAchivements: {
        title: "Denne perioden",
        help: "Hvilke arbeidspakker ble gjennomført eller fullført denne perioden? Hvilke produkter ble gjennomført denne perioden? Var det planlagt at noen produkter skulle være ferdig, men som ikke fullført denne perioden? Har det vært utført noen korrigerende tiltak i perioden?",
        description: "Beskriv målene som ble oppnådd i denne perioden"

      },
      plannedAchivements: {
        title: "Neste periode",
        help: "Hvilke arbeidspakker vil bli gjennomført eller vil bli fullført i kommende periode? Hvilke produkter er planlagt å være ferdig i kommende periode? Eventuelle korrigerende tiltak planlagt for den kommende perioden?",
        description: "Beskriv målene som er fastsatt for neste periode"
      },
      deliveryStatus: {
        title: "Status på ferdigstilling",
        columns: {
          product: { title: "Planlagt denne etappen" },
          responsible: { title: "Ansvarlig" },
          dueDate: { title: "Tidsfrist" },
          status: { title: "Status" }
        }
      },

      benefits: {
        title: "Gevinster",
        help: "Er vi i rute for å levere den ønskede avkastningen på investeringen? Hvis ikke, hva er forskjellen og hvorfor? Er eventuelle nye gevinster lagt til eller fjernet fra begrunnelsen?",
        description: "Beskriv hvordan begrunnelsen for prosjektet har utviklet seg"
      },
      time: {
        title: "Tid",
        help: "Hva er den siste prognosen for å fullføre denne etappen, og hvordan er den sammenlignet med den godkjente planen? Hva er den siste prognosen for å fullføre prosjektet, og hvordan er det sammenlignet med den godkjente planen?",
        description: "Beskriv hvordan fremdriften av prosjektet og etappen ligger ann i forhold til mål og toleranser"
      },
      cost: {
        title: "Kostnad",
        help: "Hvor mye er brukt til nå i gjeldende etappe, hva er det forventet å bli brukt i denne etappen og hva er det nåværende godkjente utgifter for etappen? Hvor mye er brukt til dags dato i prosjektet, hva forventes å bli brukt i prosjektet og hva er nåværende godkjente utgifter i prosjektet?",
        description: "Beskriv hvordan kostnadene i prosjektet og etappen er i forhold til mål og toleranser"
      },

      quality: {
        title: "Kvalitet",
        help: "Har produkter som er levert denne perioden oppfylt de avtalt kvalitetskriteriene? Har akseptmetodene (testing, vurderinger ...) for produktene i denne perioden blitt fulgt som avtalt? Har produktene til dags dato i prosjektet oppfylt de avtalt kvalitetskriteriene? Har gjeldende kvalitetsstandarder og prosesser blitt fulgt i løpet av denne perioden og hittil i prosjektet?",
        description: "Beskriv hvordan funksjonene og kravene til prosjektet og etappen ligger ann i forhold til toleransene"
      },
      scope: {
        title: "Omfang",
        help: "Var produktene for denne perioden identifisert og godt definert - inkludert sammensetning og kvalitetskriterier? Er produktene for dette prosjektet identifisert og godt definert? Er det noen endringer i omfanget?",
        description: "Beskriv hvordan prosjektet ligger ann i forhold til det avtalte omfanget"
      },

      risk: {
        title: "Risiko",
        help: "Hva er det nåværende risikonivået i prosjektet og hvordan samsvarer det med interessentene risikovilligheten? Hva er de viktigste risikoene og hvilke tiltak er utført?",
        description: "Beskriv hvordan dagens risikonivå er sammenlignet med det avtalt risikoappetitten"
      },

      teamPerformance: {
        title: "Gjennomgang av teamets prestasjon",
        help: "Hvordan ble prosjektgruppen opprinnelig organisert? Hadde teamet de ferdigheter og kapasitet som trengs? Har vi hatt noen endringer i teamet under prosjektet? Hvis ja, hvordan har det p\xE5virket ytelsen? En hvilken som helst god prestasjon i teamet som skal gjenkjennes?",
        description: "Beskriv prosjektgruppenes ytelse, spesielt anerkjennelse av god ytelse."
      },
      lessonsDescription: {
        title: "Erfaringer",
        help: "Hva gikk bra, hva gikk d\xE5rlig og hva er anbefalinger for fremtidige prosjekter av tilsvarende art? Hva er de viktigste leksjonene som er l\xE6rt? Hvordan skal disse leksjonene lagres og gjenbrukes?",
        description: "Oppsummer erfaringene i dette prosjektet."
      }
    }
  },
  Preview: {
    title: "Forhåndvisning"
  }
};

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var english_endProject = exports.english_endProject = {
  Overview: {
    fields: {
      period: {
        title: "Project period",
        help: "Select the actual period for the project. Double click on a date in the calendar to make it the starting date of the project. Single click on a date to make it the end date."
      },
      summary: {
        help: "Review the first approved Project Initiation Document \u2013 the baseline when the initiation stage was completed.\n          What was the project\u2019s original intent and main goal?\n          To what extent did the project deliver on the original intent?\n          Did we have any breakthroughs or major failures along the way?",
        description: "Describe the original main intent of the project and to what extent the project has delivered on the objectives agreed."
      },
      performedAchivements: {
        title: "Delivered by this project",
        help: "What did the original Project Product Description cover? What type of changes happened to the planned products during the lifetime of the project? To what extent did the project experience that products were not delivered, were not delivered on time or did not meet the original requirements? Have the products been handed over to the receiving organization, was the receiving organization prepared and have it accepted the handover?",
        description: "What was originally agreed to be delivered by the project, what has been delivered and how is it received?"
      },

      benefits: {
        help: "Review the original Business Case. Are we on track to deliver the desired return of investment? If not, what is the difference and why? Any new benefits added to, or removed from, the business case during the project?",
        description: "Evaluate how the project has met the planned benefits and the business case to date."
      },
      time: {
        help: "What time objectives existed in the original Project Initiation Document and in the original project plan? What was the time ambition in the early days of the project? How has the project delivered compared to those objectives? If deadlines were not met, what were the main reasons and factors?",
        description: "Describe the project’s original time objectives, and evaluate how the project has performed compared to those objectives"
      },
      cost: {
        help: "Which project cost objectives existed in the original Project Initiation Document and in the original project plan? What was the cost ambition in the early days of the project? How has the project delivered compared to those objectives? If cost limits were broken, what were the main reasons and factors?",
        description: "Describe the project’s original cost objectives, and evaluate how the project has performed compared to those objectives"
      },

      quality: {
        help: "Which high level quality objectives and requirements existed in the original Project Product Description and the baseline requirement documents? How has the project delivered compared to those requirements? If products were delivered off specification, what were the main reasons and factors?",
        description: "Describe what the original high level requirements were and to what extent the project has delivered according to those requirements."
      },
      scope: {
        help: "What did the original Project Initiation Document define as the scope? How wide was the project originally? Which disciplines, functions and geographies were included? What type of changes happened to the scope during the lifetime of the project? To what extent did the project deliver on the scope?",
        description: "Describe which topics or disciplines were originally agreed to be in the project, and to what extent those were covered during the execution of the project."
      },

      risk: {
        help: "How was the risk objective or risk appetite expressed in the original Project Initiation Document? How was risk managed in the project? Were risks managed and reported on thoroughly and responded to appropriately by stakeholders? How did risk exposure impact the end result of the project?",
        description: "Describe the risk appetite agreed early in the project, how risk was managed and how realized risks impacted the project’s end result?"
      },

      teamPerformance: {
        help: "How was the project team originally organized? Did the team have the skills and capacity needed? Did we have any changes to the team during the project? If so, how did it affect the performance? Any particular good performance in the team to be recognized?",
        description: "Describe the project team’s performance, in particular, recognition of good performance."
      },
      lessonsDescription: {
        help: "What went well, what went badly and what are the recommendations for future projects of similar nature? What are the key lessons learned? How should these lessons be stored and reused?",
        description: "Summarize the lessons learned in this project."
      }
    }
  }
};

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var norwegian_endProject = exports.norwegian_endProject = {
  Overview: {
    fields: {
      period: {
        title: "Projektets tidsperiode",
        help: "Angi faktisk tidsperiod for prosjektet. Dobbeltklikk på en dato i kalenderen for å angi startdato. Enkeltklikk på en dato for å angi sluttdato."
      },
      summary: {
        title: "Oppsummering",
        help: "Gjennomg\xE5 det f\xF8rste godkjente styringsdokumentet. Hva var prosjektets opprinnelige hensikt og hovedm\xE5l? I hvilken grad leverte prosjektet det som opprinnelige var forventet? Har vi hatt noen gjennombrudd eller store feil underveis?",
        description: "Beskriv prosjektets opprinnelige hovedformål og i hvilken grad prosjektet har levert på målene som ble avtalt."
      },
      performedAchivements: {
        title: "Leveranser fra prosjektet",
        help: "Hva dekker den opprinnelige prosjektproduktbeskrivelsen? Hvilke endriner har skjedde med de planlagte produktene i l\xF8pet av prosjektets levetid? I hvilken grad opplevde prosjektet at produktene ikke ble levert, ikke levert i tide eller ikke oppfylt de opprinnelige kravene? Har produktene blitt overlevert til mottakerorganisasjonen, var mottakerorganisasjonen forberedt og er produktene akseptert som overlevert?",
        description: "Hva ble opprinnelig avtalt at prosjektet skulle levere, hva har blitt levert og hvordan er det mottatt?"
      },

      benefits: {
        help: "Se gjennom den opprinnelige begrunnelsen for prosjektet. Er vi p\xE5 sporet av \xE5 levere den \xF8nskede avkastningen p\xE5 investeringen? Hvis ikke, hva er forskjellen og hvorfor? Er eventuelle nye fordeler lagt til eller fjernet fra begrunnelen til prosjektet?",
        description: "Vurder hvordan prosjektet har møtt de planlagte gevinstene og begrunnelsen for prosjektet til dags dato."
      },
      time: {
        help: "Hvilke tidsm\xE5l var satt i det originale styringsdokumenten og i den opprinnelige prosjektplanen? Hva var tidsambisjonen i prosjektets tidlige dager? Hvordan har prosjektet levert i forhold til disse m\xE5lene? Hvis tidsfrister ikke ble oppfylt, hva var de viktigste \xE5rsakene og faktorene?",
        description: "Beskriv prosjektets opprinnelige mål på tidsperiode, og vurder hvordan prosjektet er utført i forhold til disse målene"
      },
      cost: {
        help: "Hvilke kostnadsm\xE5l fantes for prosjektet i det originale styringsdokumentet og i den opprinnelige prosjektplanen? Hva var kostnadsambisjonen i prosjektets tidlige dager? Hvordan har prosjektet levert i forhold til disse m\xE5lene? Hvis kostnadsgrenser ble brutt, hva var de viktigste \xE5rsakene og faktorene?",
        description: "Beskriv prosjektets opprinnelige kostnadsmål, og vurder hvordan prosjektet er utført i forhold til disse målene"
      },

      quality: {
        help: "Hvilke h\xF8yniv\xE5 kvalitetsm\xE5l og krav eksisterte i den opprinnelige prosjektproduktbeskrivelsen og opprinnelige kravdokumenter? Hvordan har prosjektet levert i forhold til disse kravene? Hvis produktene ble levert som avvik-fra-spesifikasjonen, hva var de viktigste \xE5rsakene og faktorene?",
        description: "Beskriv hva de opprinnelige kravene var og i hvilken grad prosjektet har levert i henhold til disse kravene."
      },
      scope: {
        help: "Hva var definert som omfang i det opprinnelige styringsdokumentet? Hvor stort var prosjektet opprinnelig omfang? Hvilke fagomr\xE5der, funksjoner og geografiske land var inkludert? Hvilken type endringer har skjedd med omfanget i l\xF8pet av prosjektets levetid? I hvilken grad har prosjektet levert p\xE5 omfanget?",
        description: "Beskriv hvilke emner eller disipliner som opprinnelig var enige om å være i prosjektet, og i hvilken grad de var dekket under gjennomføringen av prosjektet."
      },

      risk: {
        help: "Hvordan var m\xE5let for risiko eller risikovilligheten uttrykt i det originale styringsdokumentet? Hvordan ble risikoen styrt i prosjektet? Var risikoen styrt og rapportert grundig og respondert p\xE5 riktig m\xE5te av interessenter? Hvordan p\xE5virket risikoeksponeringen sluttresultatet av prosjektet?",
        description: "Beskriv risikovilligheten som ble avtalt tidlig i prosjektet, hvordan ble risikoen styrt og hvordan påvirket risikohendelser prosjektets sluttresultat?"
      }
    }
  }
};

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var english_release = exports.english_release = {
  Overview: {
    fields: {
      summary: {
        help: "Have any major milestones just passed, or are there any in the near future? Are there any resent successes or break throughs? What are currently the main challenges? What is the general health condition?",
        description: "Describe the overall status. Assume the reader has not read the previous report or know any details up front."
      },
      performedAchivements: {
        help: "What type of work was execution or completed this period? Which tasks, epics or topics were planned to be completed this period? Was any tasks planned to be completed but was not completed this period? Was any corrective actions taken during the period?",
        description: "Describe the work done and the goals achieved this period"

      },
      plannedAchivements: {
        help: "What type of work will be in execution or will be completed the coming period? Which tasks, epics or topics are planned to be completed this period? Any corrective actions planned for the coming period?",
        description: "Describe the work to be done and the goals set for the next period"
      },

      benefits: {
        help: "Are we on track to deliver the desired return of investment? If not, what is the difference and why? Any new benefits added to, or removed from, the business case?",
        description: "Describe to what extent the work is resulting the in benefits assumed or planned."
      },
      time: {
        help: "What is the latest forecast on completing the current release, and how does it compare to the communicated roadmap?",
        description: "Describe how we are doing compared to the timeline set and communicated for this release"
      },
      cost: {
        help: "How much is spent to date in the current release, what is forecasted to be spent this release and what is currently the approved spending for the release?",
        description: "Describe how we are doing compared to the cost planned for this release."
      },

      quality: {
        help: "Have products delivered this period met the agreed quality criteria? Have the acceptance methods (testing, reviews...) for the products this period been applied as agreed? Have the products produced to date in the release met the agreed quality criteria?",
        description: "Describe to what extent we are meeting the planned functionalities and requirements of the release"
      },
      scope: {
        help: "Were the tasks, epics or user stories for this period identified and well defined - including composition and quality criteria? Are there any changes to the scope?",
        description: "Describe how the release is performing against the agreed scope"
      },

      risk: {
        help: "What is the current risk level in the release and how is it matching the stakeholders risk appetite or expectations? What are the most important risks and what actions are taken?",
        description: "Describe how the current risk level is compared to the agreed or commonly understood risk appetite"
      }
    }
  }
};

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var norwegian_release = exports.norwegian_release = {
  Overview: {
    fields: {
      summary: {
        help: "Har noen viktige milepæler bare passert, eller er det noen i nær fremtid? Er det noen nylige suksesser eller gjennomslag? Hva er for tiden de viktigste utfordringene? Hva er den generelle helsetilstanden?",
        description: "Beskriv den overordnede status. Anta at leseren ikke har lest den forrige rapporten eller er kjent med detaljene i hva som skal leveres."
      },
      performedAchivements: {
        help: "Hvilket arbeid er utført eller fullført denne perioden? Hvilke epos, brukerhistorier og oppgaver var planlagt å bli ferdig i perioden? Er det noen planlagte oppgaver som ikke ble utført eller fullført i denne perioden? Har det vært utført noen korrigerende tiltak i perioden?",
        description: "Beskriv arbeidet som er utført og målene som er oppnådd i denne perioden"

      },
      plannedAchivements: {
        help: "Hvilket arbeid vil bli gjennomført eller fullført i kommende periode? Hvilke epos, brukerhistorier eller oppgaver er planlagt å bli ferdig i kommende periode? Er det planlagt korrigerende tiltak i den kommende perioden?",
        description: "Beskriv arbeidet og målene som er fastsatt for neste periode"
      },

      benefits: {
        help: "Er vi i rute for å levere den ønskede avkastningen på investeringen? Hvis ikke, hva er forskjellen og hvorfor? Er eventuelle nye gevinster lagt til eller fjernet fra begrunnelsen?",
        description: "Beskriv hvordan arbeidet fører til forventet eller planlagt verdiskapning"
      },
      time: {
        help: "Hva er den siste prognosen for å fullføre denne oppdateringen, og hvordan er det sammenlignet med den kommuniserte langtidsplanen?",
        description: "Beskriv hvordan fremdriften er i forhold til avtalt tidsplanen for denne oppdateringen"
      },
      cost: {
        help: "Hvor mye er brukt til nå på oppdateringen, hva er det forventet å bli brukt totalt og hva er gjeldende godkjenning for utgifter til oppdateringen?",
        description: "Beskriv påløpte kostnader og forholdet til eventuell godkjenning for oppdateringen"
      },

      quality: {
        help: "Har epos, brukerhistorier og oppgaver levert i denne perioden oppfylt de avtalt kvalitetskriteriene? Har akseptmetodene (testing, vurderinger ...) i denne perioden blitt fulgt som avtalt? Har utført arbeid til dags dato i oppdateringen oppfylt de avtalt kvalitetskriteriene?",
        description: "Beskriv hvordan vi oppfyller planlagt funksjonalitet og krav i oppdateringen"
      },
      scope: {
        help: "Var epos, brukerhistorier og oppgaver for denne perioden identifisert og godt definert - inkludert sammensetning og kvalitetskriterier? Er det noen endringer i omfanget for oppdateringen?",
        description: "Beskriv hvordan innholdet i oppdateringen er i forhold til avtalt omfang"
      },

      risk: {
        help: "Hva er det nåværende risikonivået for oppdateringen og hvordan samsvarer det med interessentene risikovillighet? Hva er de viktigste risikoene og hvilke tiltak er utført?",
        description: "Beskriv hvordan dagens risikonivå er sammenlignet med den avtalte risikoappetitten"
      }
    }
  }
};

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var english_product = exports.english_product = {
  Overview: {
    fields: {
      summary: {
        help: "Have any major milestones just passed, or are there any in the near future? Are there any resent successes or break throughs? What are currently the main challenges? What is the general health condition?",
        description: "Describe the overall status. Assume the reader has not read the previous report or know any details up front."
      },
      performedAchivements: {
        help: "What type of work was execution or completed this period? Which releases or operational improvements were planned to be completed this period? How did it go? ",
        description: "Describe the work done and the goals achieved this period"

      },
      plannedAchivements: {
        help: "What type of work will be in execution or will be completed the coming period? Which releases or operational improvements are planned to be completed this period?",
        description: "Describe the work to be done and the goals set for the next period"
      },

      benefits: {
        help: "Is the product/platform delivering the desired return of investment? If not, what is the difference and why? Any new benefits added to, or removed from, the business case?",
        description: "Describe to what extent the product is currently delivering the benefits assumed or planned."
      },
      time: {
        help: "What is the latest forecast on completing the planned releases and operational improvements, and how does it compare to the communicated roadmap?",
        description: "Describe how we are doing compared to the roadmap and milestones set and communicated"
      },
      cost: {
        help: "What is the planned running cost for development and maintenance? What is forecasted to be spent short term and long term. What is currently the approved spending?",
        description: "Describe the running cost and how we are doing compared to the planned cost."
      },

      quality: {
        help: "Are internal and external customers and users happy with the state of the product? Is functionality, stability, security and reliability good enough?",
        description: "Describe to what extent we currently are meeting customers'/users' expectations to functionality, stability, security, speed and reliability"
      },
      scope: {
        help: "Do we have what we need to promote, sell, deliver and support this product/platform in a good way? Does the product cover the functional domains needed?",
        description: "Describe to what extent the product/platform covers what it needs to cover both in terms of functional domains and operational efficiency"
      },

      risk: {
        help: "What is the current risk level and how is it matching the stakeholders risk appetite or expectations? What are the most important risks and what actions are taken?",
        description: "Describe how the current risk level is compared to the agreed or commonly understood risk appetite"
      }
    }
  }
};

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var norwegian_product = exports.norwegian_product = {
  Overview: {
    fields: {
      summary: {
        help: "Har noen viktige milepæler bare passert, eller er det noen i nær fremtid? Er det noen nylige suksesser eller gjennomslag? Hva er for tiden de viktigste utfordringene? Hva er den generelle helsetilstanden?",
        description: "Beskriv den overordnede status. Anta at leseren ikke har lest den forrige rapporten eller er kjent med detaljene i hva som skal leveres."
      },
      performedAchivements: {
        help: "Hvilket arbeid er utført eller fullført denne perioden? Hvilke oppdateringer eller operasjonelle forbedringer var planlagt å bli ferdig i perioden? Er det noen planlagte oppgaver som ikke ble utført eller fullført i denne perioden? Har det vært utført noen korrigerende tiltak i perioden?",
        description: "Beskriv arbeidet som er utført og målene som er oppnådd i denne perioden"

      },
      plannedAchivements: {
        help: "Hvilket arbeid vil bli gjennomført eller fullført i kommende periode? Hvilke oppdateringer eller operasjonelle forbedringer er planlagt å bli ferdig i kommende periode? Er det planlagt korrigerende tiltak i den kommende perioden?",
        description: "Beskriv arbeidet og målene som er fastsatt for neste periode"
      },

      benefits: {
        help: "Leverer dette produktet ønsket avkastningen på investeringen? Hvis ikke, hva er forskjellen og hvorfor? Er eventuelle nye gevinster lagt til eller fjernet fra begrunnelsen?",
        description: "Beskriv hvordan produktet fører til forventet eller planlagt verdiskapning"
      },
      time: {
        help: "Hva er den siste prognosen for å fullføre de planlagte oppdateringenene og operasjonelle forbedringene, og hvordan er det sammenlignet med den kommuniserte langtidsplanen?",
        description: "Beskriv hvordan fremdriften er i forhold til avtalt langtidsplan"
      },
      cost: {
        help: "Hva er planlagt løpende kostnad for utvikling og vedlikehold? Hva er det forventet å bli brukt på kort sikt og på lang sikt? Hva er i øyeblikket godkjente kostnadsrammer?",
        description: "Beskriv beløp på løpende kostnad og hvordan den er i forhold til planlagt kostnad"
      },

      quality: {
        help: "Er interne og eksterne kunder og brukere tilfreds med tilstanden til produktet? Er funksjonalitet, stabilitet, sikkerhet og pålitelighet god nok?",
        description: "Beskriv i hvilken grad vi nå oppfyller kunders/brukeres forventninger til funksjonalitet, stabilitet, sikkerhet og pålitelighet"
      },
      scope: {
        help: "Har vi det vi trenger for å promotere, selge, levere og støtte dette produktet på en god måte? Dekker produktet de nødvendige funksjonelle områdene?",
        description: "Beskriv i hvilken grad produktet dekker det som trengs av funksjonelle områder og operasjonell effektivitet"
      },

      risk: {
        help: "Hva er det nåværende risikonivået og hvordan samsvarer det med interessentene risikovillighet? Hva er de viktigste risikoene og hvilke tiltak er utført?",
        description: "Beskriv hvordan dagens risikonivå er sammenlignet med den avtalte risikoappetitten"
      }
    }
  }
};

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 1054 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 1055 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectStatus = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _DragAndDropContent = __webpack_require__(314);

var _DragAndDropContent2 = _interopRequireDefault(_DragAndDropContent);

var _DragAndDropTarget = __webpack_require__(339);

var _DragAndDropTarget2 = _interopRequireDefault(_DragAndDropTarget);

var _DragAndDropSource = __webpack_require__(340);

var _DragAndDropSource2 = _interopRequireDefault(_DragAndDropSource);

var _Portfolio = __webpack_require__(175);

var _Portfolio2 = _interopRequireDefault(_Portfolio);

var _Flag = __webpack_require__(424);

var _Flag2 = _interopRequireDefault(_Flag);

var _PopupDescription = __webpack_require__(1057);

var _PopupDescription2 = _interopRequireDefault(_PopupDescription);

var _StatusIndicator = __webpack_require__(425);

var _StatusIndicator2 = _interopRequireDefault(_StatusIndicator);

var _FilterStatus = __webpack_require__(426);

var _FilterStatus2 = _interopRequireDefault(_FilterStatus);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(206), __webpack_require__(207)]);

var StatusDescription = function (_React$Component) {
  _inherits(StatusDescription, _React$Component);

  function StatusDescription() {
    _classCallCheck(this, StatusDescription);

    return _possibleConstructorReturn(this, (StatusDescription.__proto__ || Object.getPrototypeOf(StatusDescription)).apply(this, arguments));
  }

  _createClass(StatusDescription, [{
    key: 'render',
    value: function render() {
      var message = { date: this.props.date, content: this.props.content };
      return _react2.default.createElement(
        _PopupDescription2.default,
        _extends({}, this.props, message),
        _react2.default.createElement(_StatusIndicator2.default, { status: this.props.status })
      );
    }
  }]);

  return StatusDescription;
}(_react2.default.Component);

var FlagDescription = function (_React$Component2) {
  _inherits(FlagDescription, _React$Component2);

  function FlagDescription() {
    _classCallCheck(this, FlagDescription);

    return _possibleConstructorReturn(this, (FlagDescription.__proto__ || Object.getPrototypeOf(FlagDescription)).apply(this, arguments));
  }

  _createClass(FlagDescription, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var labels = translations.getTranslation(this.props);
      var title = "";
      if (this.props.requestedPhase !== undefined) {
        var projectType = this.props.tenant !== undefined && this.props.tenant.projectTypes !== undefined ? this.props.tenant.projectTypes.find(function (type) {
          return type.id === _this3.props.requestedPhase.projectType.id;
        }) : this.props.projectTypes !== undefined ? this.props.projectTypes.find(function (type) {
          return type.id === _this3.props.requestedPhase.projectType.id;
        }) : undefined;
        title = labels.requestedPhase + (projectType !== undefined ? " " + projectType.phases.find(function (phase) {
          return phase.id === _this3.props.requestedPhase.id;
        }).text : "");
      } else if (this.props.recommendedProjectClosure !== undefined) {
        title = this.props.recommendedProjectClosure.description;
      } else if (this.props.requestedStageTransition !== undefined) {
        if (this.props.requestedStageTransition.stage !== undefined) {
          title = labels.requestedStageTransition + " " + this.props.requestedStageTransition.stage.name;
        } else if (this.props.requestedStageTransition.description !== undefined) {
          title = this.props.requestedStageTransition.description;
        }
      }
      var message = this.props.recommendedProjectClosure !== undefined ? {
        date: this.props.recommendedProjectClosure.date,
        content: this.props.recommendedProjectClosure.comments !== undefined ? this.props.recommendedProjectClosure.comments : _react2.default.createElement(
          'i',
          null,
          'No description available'
        ),
        title: title
      } : this.props.requestedPhase !== undefined ? {
        date: this.props.requestedPhase.date,
        content: this.props.requestedPhase.comments !== undefined ? this.props.requestedPhase.comments : _react2.default.createElement(
          'i',
          null,
          'No description available'
        ),
        title: title
      } : this.props.requestedStageTransition !== undefined ? {
        date: this.props.requestedStageTransition.date,
        content: this.props.requestedStageTransition.stage !== undefined ? this.props.requestedStageTransition.stage.comments : this.props.requestedStageTransition.comments !== undefined ? this.props.requestedStageTransition.comments : _react2.default.createElement(
          'i',
          null,
          'No description available'
        ),
        title: title
      } : this.props.requestedStageException !== undefined ? {
        date: this.props.requestedStageException.date,
        content: this.props.requestedStageException.summary !== undefined ? this.props.requestedStageException.summary : _react2.default.createElement(
          'i',
          null,
          'No description available'
        )
      } : undefined;
      return _react2.default.createElement(
        _PopupDescription2.default,
        _extends({}, this.props, message),
        _react2.default.createElement(_Flag2.default, this.props)
      );
    }
  }]);

  return FlagDescription;
}(_react2.default.Component);

var ProjectSummary = function (_React$Component3) {
  _inherits(ProjectSummary, _React$Component3);

  function ProjectSummary(props) {
    _classCallCheck(this, ProjectSummary);

    var _this4 = _possibleConstructorReturn(this, (ProjectSummary.__proto__ || Object.getPrototypeOf(ProjectSummary)).call(this, props));

    _this4.state = { hover: false };
    return _this4;
  }

  _createClass(ProjectSummary, [{
    key: 'toggleHover',
    value: function toggleHover(event) {
      event.preventDefault();
      this.setState({ hover: !this.state.hover });
    }
  }, {
    key: 'prioritize',
    value: function prioritize(item, target) {
      this.props.prioritize({ id: item.id, position: target.position, portfolio: this.props.portfolio });
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      var bgColor = this.state.hover ? "#f1fbfe" : "#ffffff";
      var project = this.props.project;
      var rowStyle = this.props.rowStyle;
      var name = project.name !== undefined && project.name !== null && project.name.trim().length > 0 ? project.name : _react2.default.createElement(
        'i',
        null,
        '(no name)'
      );
      var link = _react2.default.createElement(
        'a',
        { href: (project.isProgramme ? "/programmes/" : project.isProduct ? "/products/" : project.isRelease ? "/releases/" : "/projects/") + project.id },
        name
      );
      var title = this.props.disablePriority !== true && project.isStarted ? _react2.default.createElement(
        _DragAndDropSource2.default,
        { prioritize: this.prioritize.bind(this), id: project.id },
        link
      ) : link;
      var projectType = this.props.tenant !== undefined && this.props.tenant.projectTypes !== undefined ? this.props.tenant.projectTypes.find(function (projectType) {
        return projectType.id === project.projectType;
      }) : this.props.projectTypes !== undefined ? this.props.projectTypes.find(function (projectType) {
        return projectType.id === project.projectType;
      }) : undefined;
      var currentPhase = project.currentPhase !== undefined && projectType !== undefined && projectType.phases !== undefined ? projectType.phases.find(function (phase) {
        return phase.id === project.currentPhase.id;
      }) : undefined;
      var activeReleases = this.props.itemType === "product" && project.isProduct && project.releases !== undefined ? project.releases.filter(function (release) {
        return release.active;
      }).sort(function (a, b) {
        return a.activated > b.activated ? -1 : a.activated < b.activated ? 1 : 0;
      }) : [];
      var phase = this.props.itemType === "programme" ? undefined : this.props.itemType === "product" ? activeReleases.length > 0 ? activeReleases[0].name : labels.product.noActiveReleases : currentPhase !== undefined ? currentPhase.text : project.phase;
      return _react2.default.createElement(
        'tr',
        { onMouseEnter: this.toggleHover.bind(this), onMouseLeave: this.toggleHover.bind(this), style: { backgroundColor: bgColor } },
        this.props.disablePriority !== true ? _react2.default.createElement(
          'td',
          { style: Object.assign({}, rowStyle, { color: this.props.itemType === "product" ? "white" : undefined }) },
          this.props.position,
          this.props.showPriority ? _react2.default.createElement(
            'span',
            null,
            ' (',
            this.props.project.priority,
            ')'
          ) : null
        ) : null,
        _react2.default.createElement(
          'td',
          { style: Object.assign({}, rowStyle, { paddingTop: 0, paddingBottom: 0, textAlign: "left" }) },
          this.props.disablePriority !== true && project.priority !== undefined && this.props.itemType !== "product" ? _react2.default.createElement(
            _DragAndDropTarget2.default,
            { position: project.priority },
            _react2.default.createElement(
              'div',
              { style: { paddingTop: rowStyle.padding, paddingBottom: rowStyle.padding } },
              title
            )
          ) : title
        ),
        _react2.default.createElement(
          'td',
          { style: rowStyle },
          _react2.default.createElement(StatusDescription, _extends({}, this.props, { selection: this.props.selection }, project.overallStatus, { date: project.statusDate }))
        ),
        _react2.default.createElement(
          'td',
          { style: rowStyle },
          phase,
          project.isStopped ? " (" + labels.projectStatus.stopped + ")" : null,
          project.isPaused ? " (" + labels.projectStatus.paused + ")" : null
        ),
        _react2.default.createElement(
          'td',
          { style: rowStyle },
          _react2.default.createElement(FlagDescription, _extends({}, this.props, { selection: this.props.selection, requestedStageException: project.requestedStageException, requestedStageTransition: project.requestedStageTransition, requestedPhase: project.requestedPhase, recommendedProjectClosure: project.recommendedProjectClosure }))
        ),
        _react2.default.createElement(
          'td',
          { style: rowStyle },
          _react2.default.createElement(StatusDescription, _extends({}, this.props, { selection: this.props.selection }, project.benefits, { date: project.statusDate }))
        ),
        _react2.default.createElement(
          'td',
          { style: rowStyle },
          _react2.default.createElement(StatusDescription, _extends({}, this.props, { selection: this.props.selection }, project.time, { date: project.statusDate }))
        ),
        _react2.default.createElement(
          'td',
          { style: rowStyle },
          _react2.default.createElement(StatusDescription, _extends({}, this.props, { selection: this.props.selection }, project.cost, { date: project.statusDate }))
        ),
        _react2.default.createElement(
          'td',
          { style: rowStyle },
          _react2.default.createElement(StatusDescription, _extends({}, this.props, { selection: this.props.selection }, project.quality, { date: project.statusDate }))
        ),
        _react2.default.createElement(
          'td',
          { style: rowStyle },
          _react2.default.createElement(StatusDescription, _extends({}, this.props, { selection: this.props.selection }, project.scope, { date: project.statusDate }))
        ),
        _react2.default.createElement(
          'td',
          { style: rowStyle },
          _react2.default.createElement(StatusDescription, _extends({}, this.props, { selection: this.props.selection }, project.risk, { date: project.statusDate }))
        )
      );
    }
  }]);

  return ProjectSummary;
}(_react2.default.Component);

function getProgramModifiedTranslations(props) {
  var labels = translations.getTranslation(props);
  if (props.itemType === "programme") {
    var programmeLabels = translations.getTranslation(props).programme;
    labels = Object.keys(labels).reduce(function (object, key) {
      return Object.assign({}, object, _defineProperty({}, key, Object.assign({}, labels[key], programmeLabels[key])));
    });
  }
  if (props.itemType === "product") {
    var productLabels = translations.getTranslation(props).product;
    labels = Object.keys(labels).reduce(function (object, key) {
      return Object.assign({}, object, _defineProperty({}, key, Object.assign({}, labels[key], productLabels[key])));
    });
  }
  return labels;
}

var InactiveProjects = function (_React$Component4) {
  _inherits(InactiveProjects, _React$Component4);

  function InactiveProjects(props) {
    _classCallCheck(this, InactiveProjects);

    var _this5 = _possibleConstructorReturn(this, (InactiveProjects.__proto__ || Object.getPrototypeOf(InactiveProjects)).call(this, props));

    _this5.state = { visible: false };
    return _this5;
  }

  _createClass(InactiveProjects, [{
    key: 'toggle',
    value: function toggle(event) {
      event.preventDefault();
      this.setState({ visible: !this.state.visible });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var labels = getProgramModifiedTranslations(this.props);
      return this.props.projects !== undefined && this.props.projects.length > 0 ? this.state.visible ? _react2.default.createElement(
        'tbody',
        { style: { textAlign: "center", backgroundColor: "lightgrey", borderCollapse: "separate", borderTop: "solid black 3px" } },
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'td',
            { colSpan: this.props.disablePriority !== true ? "2" : "1", style: { borderTop: "solid 2px black", padding: 10 } },
            _react2.default.createElement(
              'a',
              { href: '#', onClick: this.toggle.bind(this) },
              labels.inactive.hide
            )
          ),
          _react2.default.createElement('td', { colSpan: '9' })
        ),
        this.props.projects.map(function (project) {
          return _react2.default.createElement(ProjectSummary, _extends({}, _this6.props, { selection: _this6.props.selection, key: project.id, project: project, rowStyle: _this6.props.rowStyle }));
        })
      ) : _react2.default.createElement(
        'tbody',
        { style: { textAlign: "center", backgroundColor: "lightgrey", borderCollapse: "separate", borderTop: "solid black 3px" } },
        _react2.default.createElement(
          'tr',
          null,
          _react2.default.createElement(
            'td',
            { colSpan: this.props.disablePriority !== true ? "2" : "1", style: { borderTop: "solid 2px black", padding: 10 } },
            _react2.default.createElement(
              'a',
              { href: '#', onClick: this.toggle.bind(this) },
              translations.formatLabel(labels.inactive.show, this.props.projects.length, this.props.projects.length > 1 ? labels.inactive.projectsPlural : "")
            )
          ),
          _react2.default.createElement('td', { colSpan: '9' })
        )
      ) : null;
    }
  }]);

  return InactiveProjects;
}(_react2.default.Component);

var ProjectTableItems = function (_React$Component5) {
  _inherits(ProjectTableItems, _React$Component5);

  function ProjectTableItems() {
    _classCallCheck(this, ProjectTableItems);

    return _possibleConstructorReturn(this, (ProjectTableItems.__proto__ || Object.getPrototypeOf(ProjectTableItems)).apply(this, arguments));
  }

  _createClass(ProjectTableItems, [{
    key: 'render',
    value: function render() {
      var labels = getProgramModifiedTranslations(this.props);
      var projects = this.props.projects;
      var prioritizableProjects = projects !== undefined ? projects.filter(function (project) {
        return project.priority !== undefined && project.isStarted;
      }) : [];
      var startingProjects = projects !== undefined ? projects.filter(function (project) {
        return project.priority === undefined && project.isStarted;
      }) : [];
      var rowStyle = { display: "table-cell", borderBottom: "1px solid #ddd", padding: 8, textAlign: "center" };
      var startingRowStyle = Object.assign({}, rowStyle, { fontStyle: "italic" });
      var inactiveRowStyle = Object.assign({}, rowStyle, { color: "darkgrey" });
      var historicRowStyle = rowStyle;
      var prioritize = this.props.prioritize;
      var statusWidth = 120;
      var selection = { showDetails: this.props.showDetailsOf, visible: this.props.visibleDetails };
      var portfolio = this.props.portfolio;
      var inactiveProjects = projects !== undefined ? projects.filter(function (project) {
        return !project.isStarted;
      }) : [];
      var props = this.props;
      return _react2.default.createElement(
        'table',
        { style: { width: "100%", lineHeight: "20px", borderCollapse: "collapse", borderSpacing: 0, marginBottom: 20, marginTop: 0, marginRight: 0, marginLeft: 0, fontFamily: "Lato, Arial, 'Helvetica Neue', Helvetica, sans-serif", fontSize: "11px" } },
        _react2.default.createElement(
          'thead',
          null,
          _react2.default.createElement(
            'tr',
            null,
            this.props.disablePriority !== true ? _react2.default.createElement(
              'th',
              { style: Object.assign({}, rowStyle, { color: this.props.itemType === "product" ? "white" : undefined, paddingLeft: 30 }) },
              labels.columns.priority
            ) : null,
            _react2.default.createElement(
              'th',
              { style: Object.assign({}, rowStyle, { textAlign: "left", minWidth: 230 }) },
              labels.columns.name
            ),
            _react2.default.createElement(
              'th',
              { style: Object.assign({}, rowStyle, { width: statusWidth }) },
              labels.columns.status
            ),
            _react2.default.createElement(
              'th',
              { style: Object.assign({}, rowStyle, { minWidth: 130, color: this.props.itemType === "programme" ? "white" : undefined }) },
              labels.columns.stage
            ),
            _react2.default.createElement('th', { style: Object.assign({}, rowStyle, { width: statusWidth }) }),
            _react2.default.createElement(
              'th',
              { style: Object.assign({}, rowStyle, { width: statusWidth }) },
              labels.columns.benefits
            ),
            _react2.default.createElement(
              'th',
              { style: Object.assign({}, rowStyle, { width: statusWidth }) },
              labels.columns.time
            ),
            _react2.default.createElement(
              'th',
              { style: Object.assign({}, rowStyle, { width: statusWidth }) },
              labels.columns.cost
            ),
            _react2.default.createElement(
              'th',
              { style: Object.assign({}, rowStyle, { width: statusWidth }) },
              labels.columns.quality
            ),
            _react2.default.createElement(
              'th',
              { style: Object.assign({}, rowStyle, { width: statusWidth }) },
              labels.columns.scope
            ),
            _react2.default.createElement(
              'th',
              { style: Object.assign({}, rowStyle, { width: statusWidth }) },
              labels.columns.risk
            )
          )
        ),
        _react2.default.createElement(
          'tbody',
          { style: { textAlign: "center" } },
          prioritizableProjects.slice(0).sort(function (a, b) {
            return a.priority < b.priority ? -1 : a.priority === b.priority ? 0 : 1;
          }).map(function (project, index) {
            return _react2.default.createElement(ProjectSummary, _extends({}, props, { selection: selection, key: index, prioritize: prioritize, position: index + 1, project: project, rowStyle: rowStyle, portfolio: portfolio }));
          }),
          this.props.disablePriority !== true && (prioritizableProjects.length === 0 || startingProjects.length > 0) ? _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'td',
              { colSpan: '2' },
              _react2.default.createElement(
                _DragAndDropTarget2.default,
                { position: prioritizableProjects.length + 1 },
                _react2.default.createElement(
                  'div',
                  { style: { padding: 15 } },
                  labels.prioritize.drop
                )
              )
            ),
            _react2.default.createElement('td', { colSpan: '9' })
          ) : null
        ),
        _react2.default.createElement(
          'tbody',
          { style: { textAlign: "center", borderTop: "solid grey 3px" } },
          startingProjects.map(function (project) {
            return _react2.default.createElement(ProjectSummary, _extends({}, props, { selection: selection, prioritize: prioritize, key: project.id, project: project, rowStyle: startingRowStyle }));
          })
        ),
        this.props.historicProjects !== undefined ? _react2.default.createElement(
          'tbody',
          { style: { textAlign: "center", borderTop: "solid grey 3px", backgroundColor: "#c8d1e8" } },
          this.props.historicProjects.map(function (project) {
            return _react2.default.createElement(ProjectSummary, _extends({}, props, { selection: selection, prioritize: prioritize, key: project.id, project: project, rowStyle: historicRowStyle }));
          })
        ) : null,
        _react2.default.createElement(InactiveProjects, _extends({}, props, { selection: selection, rowStyle: inactiveRowStyle, projects: inactiveProjects }))
      );
    }
  }]);

  return ProjectTableItems;
}(_react2.default.Component);

var ProjectTable = function (_React$Component6) {
  _inherits(ProjectTable, _React$Component6);

  function ProjectTable() {
    _classCallCheck(this, ProjectTable);

    return _possibleConstructorReturn(this, (ProjectTable.__proto__ || Object.getPrototypeOf(ProjectTable)).apply(this, arguments));
  }

  _createClass(ProjectTable, [{
    key: 'render',
    value: function render() {
      var programmes = this.props.projects.filter(function (project) {
        return project.isProgramme === true;
      });
      var products = this.props.projects.filter(function (project) {
        return project.isProduct === true;
      }).map(function (product, index) {
        return Object.assign({}, product, { priority: index + 1 });
      });
      //    let projects=this.props.projects.filter(project=>project.isProgramme!==true && project.isProduct!==true);
      var projects = this.props.projects.filter(function (project) {
        return project.isProduct !== true;
      });
      var labels = translations.getTranslation(this.props).general.sections;
      return _react2.default.createElement(
        'div',
        null,
         false ? _react2.default.createElement(
          'div',
          { style: { paddingBottom: 20 } },
          _react2.default.createElement(
            'h3',
            { style: { backgroundColor: "white", padding: "25px 0px 0px 30px", fontFamily: "Lato, Arial, 'Helvetica Neue', Helvetica, sans-serif" } },
            labels.programmes
          ),
          _react2.default.createElement(ProjectTableItems, _extends({}, this.props, { projects: programmes, itemType: 'programme' }))
        ) : null,
        projects.length > 0 ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h3',
            { style: { backgroundColor: "white", padding: "25px 0px 0px 30px", fontFamily: "Lato, Arial, 'Helvetica Neue', Helvetica, sans-serif" } },
            projects.filter(function (item) {
              return item.isProgramme === true;
            }).length > 0 ? labels.programmes + ", " : null,
            projects.filter(function (item) {
              return item.isRelease === undefined;
            }).length > 0 ? projects.filter(function (item) {
              return item.isRelease === true;
            }).length > 0 ? labels.projectsAndReleases : labels.projects : labels.releases
          ),
          _react2.default.createElement(ProjectTableItems, _extends({}, this.props, { projects: projects }))
        ) : null,
        products.length > 0 ? _react2.default.createElement(
          'div',
          { style: { paddingBottom: 20, paddingTop: 10 } },
          _react2.default.createElement(
            'h3',
            { style: { backgroundColor: "white", padding: "25px 0px 0px 30px", fontFamily: "Lato, Arial, 'Helvetica Neue', Helvetica, sans-serif" } },
            labels.products
          ),
          _react2.default.createElement(ProjectTableItems, _extends({}, this.props, { projects: products, itemType: 'product' }))
        ) : null
      );
    }
  }]);

  return ProjectTable;
}(_react2.default.Component);

var ProjectStatus = exports.ProjectStatus = function (_React$Component7) {
  _inherits(ProjectStatus, _React$Component7);

  function ProjectStatus(props) {
    _classCallCheck(this, ProjectStatus);

    var _this9 = _possibleConstructorReturn(this, (ProjectStatus.__proto__ || Object.getPrototypeOf(ProjectStatus)).call(this, props));

    _this9.state = { visibleDetails: undefined };
    _this9.showDetailsOf = _this9.showDetailsOf.bind(_this9);
    return _this9;
  }

  _createClass(ProjectStatus, [{
    key: 'showDetailsOf',
    value: function showDetailsOf(id) {

      this.setState({ visibleDetails: id });
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      var projects = this.props.projects;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_FilterStatus2.default, this.props),
        projects !== undefined && projects.length > 0 ? this.props.disablePriority !== true ? _react2.default.createElement(
          _DragAndDropContent2.default,
          null,
          _react2.default.createElement(ProjectTable, _extends({}, this.props, { showDetailsOf: this.showDetailsOf, visibleDetails: this.state.visibleDetails }))
        ) : _react2.default.createElement(ProjectTable, _extends({}, this.props, { showDetailsOf: this.showDetailsOf, visibleDetails: this.state.visibleDetails })) : _react2.default.createElement(
          'div',
          { style: { marginTop: 20, marginLeft: 30 } },
          _react2.default.createElement(
            'i',
            null,
            labels.empty
          )
        )
      );
    }
  }]);

  return ProjectStatus;
}(_react2.default.Component);

var IndexPage = function (_React$Component8) {
  _inherits(IndexPage, _React$Component8);

  function IndexPage() {
    _classCallCheck(this, IndexPage);

    return _possibleConstructorReturn(this, (IndexPage.__proto__ || Object.getPrototypeOf(IndexPage)).apply(this, arguments));
  }

  _createClass(IndexPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Layout2.default,
        this.props,
        _react2.default.createElement(_Portfolio2.default, this.props)
      );
    }
  }]);

  return IndexPage;
}(_react2.default.Component);

exports.default = IndexPage;

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _uuid = __webpack_require__(26);

var _uuid2 = _interopRequireDefault(_uuid);

var _FormattedContent = __webpack_require__(15);

var _FormattedContent2 = _interopRequireDefault(_FormattedContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function contrastColor(color) {
  var hexcolor = color.slice(1);
  var r = parseInt(hexcolor.substr(0, 2), 16);
  var g = parseInt(hexcolor.substr(2, 2), 16);
  var b = parseInt(hexcolor.substr(4, 2), 16);
  var yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? 'black' : 'white';
}

var PopupDescription = function (_React$Component) {
  _inherits(PopupDescription, _React$Component);

  function PopupDescription(props) {
    _classCallCheck(this, PopupDescription);

    var _this = _possibleConstructorReturn(this, (PopupDescription.__proto__ || Object.getPrototypeOf(PopupDescription)).call(this, props));

    _this.state = { id: _uuid2.default.v4() };
    _this.switchMode = _this.switchMode.bind(_this);
    return _this;
  }

  _createClass(PopupDescription, [{
    key: 'switchMode',
    value: function switchMode(event) {
      this.props.selection.showDetails(this.props.selection.visible !== this.state.id ? this.state.id : undefined);
    }
  }, {
    key: 'render',
    value: function render() {
      var color = this.props.tenant !== undefined && this.props.tenant.design !== undefined && this.props.tenant.design.enabled && this.props.tenant.design.color !== undefined ? this.props.tenant.design.color : "#e41f1f";
      return this.props.selection.visible === this.state.id ? _react2.default.createElement(
        'div',
        { onClick: this.switchMode.bind(this), style: { position: "relative", cursor: "pointer", backgroundColor: "#e9e7e6" } },
        _react2.default.createElement(
          'div',
          { style: { position: "absolute", right: 34, top: -40, border: "1px solid #E5E5E5", boxShadow: "0px 8px 16px rgba(0,0,0,0.15)", borderRadius: 4, backgroundColor: "#ffffff", width: 270, whiteSpace: "nowrap" } },
          _react2.default.createElement(
            'div',
            { style: { backgroundColor: "#B0D7E7", overflow: "hidden", textAlign: "left", textOverflow: "ellipsis", padding: "5px 5px 5px 15px", color: "#212121", borderRadius: "0px 0px 0px 0px", fontStyle: "normal" } },
            this.props.project !== undefined ? this.props.project.name : ""
          ),
          _react2.default.createElement(
            'div',
            { style: { display: "inline-block", fontStyle: "italic", padding: "5px 5px 5px 0px", width: 210, textAlign: "left", whiteSpace: "normal", backgroundColor: "#FFFFFF" } },
            this.props.title !== undefined ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'b',
                null,
                this.props.title
              )
            ) : null,
            this.props.date !== undefined ? _react2.default.createElement(
              'b',
              null,
              this.props.date.slice(0, 10),
              ': '
            ) : null,
            _react2.default.createElement(_FormattedContent2.default, { value: this.props.content })
          ),
          _react2.default.createElement(
            'div',
            { style: { backgroundColor: "#FFFFFF", display: "inline-block", verticalAlign: "top", paddingRight: 0, paddingTop: 5 } },
            this.props.children
          )
        )
      ) : _react2.default.createElement(
        'div',
        { onClick: this.switchMode.bind(this), style: { cursor: "pointer" } },
        this.props.children
      );
    }
  }]);

  return PopupDescription;
}(_react2.default.Component);

exports.default = PopupDescription;

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccountCreated = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Area = __webpack_require__(115);

var _Area2 = _interopRequireDefault(_Area);

var _Field = __webpack_require__(36);

var _Field2 = _interopRequireDefault(_Field);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _SSOConfiguration = __webpack_require__(1059);

var _SSOConfiguration2 = _interopRequireDefault(_SSOConfiguration);

var _BusinessCaseSettings = __webpack_require__(427);

var _BusinessCaseSettings2 = _interopRequireDefault(_BusinessCaseSettings);

var _LifecycleManagement = __webpack_require__(1061);

var _LifecycleManagement2 = _interopRequireDefault(_LifecycleManagement);

var _currencies = __webpack_require__(429);

var _currencies2 = _interopRequireDefault(_currencies);

var _sendCommand = __webpack_require__(25);

var _sendCommand2 = _interopRequireDefault(_sendCommand);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var request = __webpack_require__(23);

var Person = function (_React$Component) {
  _inherits(Person, _React$Component);

  function Person() {
    _classCallCheck(this, Person);

    return _possibleConstructorReturn(this, (Person.__proto__ || Object.getPrototypeOf(Person)).apply(this, arguments));
  }

  _createClass(Person, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.props.name,
        ', ',
        this.props.email,
        this.props.emailConfirmed ? "" : _react2.default.createElement(
          'span',
          null,
          ' (',
          _react2.default.createElement(
            'i',
            { style: { color: "red" } },
            'not confirmed'
          ),
          ')'
        )
      );
    }
  }]);

  return Person;
}(_react2.default.Component);

var AccessControl = function (_React$Component2) {
  _inherits(AccessControl, _React$Component2);

  function AccessControl() {
    _classCallCheck(this, AccessControl);

    return _possibleConstructorReturn(this, (AccessControl.__proto__ || Object.getPrototypeOf(AccessControl)).apply(this, arguments));
  }

  _createClass(AccessControl, [{
    key: 'submit',
    value: function submit(event) {
      event.preventDefault();
      //Remove html content <p></p> or <ul></ul>
      var value = event.target.access.value.replace(/<.?(p|ul|br).?>/g, "");
      var domains = value.split("\n").map(function (item) {
        return item.trim();
      }).filter(function (item) {
        return item.length > 0;
      });
      this.props.onChange(domains);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { maxWidth: 800, paddingBottom: 40, paddingTop: 30 } },
        _react2.default.createElement(
          'form',
          { onSubmit: this.submit.bind(this) },
          _react2.default.createElement(
            'div',
            { style: { paddingBottom: 20 } },
            _react2.default.createElement(
              'b',
              null,
              this.props.property.name
            ),
            ' - Access accessControl'
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_Field2.default, {
              name: 'access',
              height: 3,
              title: 'Access allowed',
              description: 'List the email domains that should have access, one domain name per line',
              help: 'Only listed email-domains are given access',
              value: this.props.property.accessControl !== undefined ? this.props.property.accessControl.join("\n") : ""
            })
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('input', { type: 'submit', className: 'save', value: 'Restrict access' }),
            _react2.default.createElement(
              'a',
              { href: '#', onClick: this.props.onCancel },
              'Cancel'
            )
          )
        )
      );
    }
  }]);

  return AccessControl;
}(_react2.default.Component);

var ShowProperty = function (_React$Component3) {
  _inherits(ShowProperty, _React$Component3);

  function ShowProperty(props) {
    _classCallCheck(this, ShowProperty);

    var _this3 = _possibleConstructorReturn(this, (ShowProperty.__proto__ || Object.getPrototypeOf(ShowProperty)).call(this, props));

    _this3.state = { edit: false };
    return _this3;
  }

  _createClass(ShowProperty, [{
    key: 'editProperty',
    value: function editProperty(event) {
      event.preventDefault();
      this.setState({ edit: !this.state.edit });
    }
  }, {
    key: 'editAccessControl',
    value: function editAccessControl(event) {
      event.preventDefault();
      this.setState({ editAccessControl: !this.state.editAccessControl });
    }
  }, {
    key: 'setAccessControl',
    value: function setAccessControl(domains) {
      (0, _sendCommand2.default)({
        type: "setAccessControl",
        property: this.props.propertyName,
        item: this.props.property.id,
        access: domains
      }).then(function () {
        return window.location.reload();
      }).catch(function (error) {
        console.log("[ERROR] Not able to limit access, got " + error);
        alert("An error occured, please try again");
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var property = this.props.property;
      var countProject = this.props.count !== undefined ? this.props.count(this.props.property) : 0;
      var countProgramme = this.props.countProgramme !== undefined ? this.props.countProgramme(this.props.property) : 0;
      var countProduct = this.props.countProduct !== undefined ? this.props.countProduct(this.props.property) : 0;
      var count = this.props.count !== undefined || this.props.countProgramme !== undefined || this.props.countProduct !== undefined ? countProduct + countProject + countProgramme : undefined;

      return this.state.editAccessControl ? _react2.default.createElement(AccessControl, _extends({}, this.props, {
        onCancel: this.editAccessControl.bind(this),
        onChange: this.setAccessControl.bind(this)
      })) : _react2.default.createElement(
        'div',
        { style: { display: "table-row", borderBottom: "solid 1px #C1C1C1" } },
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", textAlign: "left", padding: 5 } },
          this.state.edit ? _react2.default.createElement(
            'form',
            { method: 'POST', action: "/" + this.props.propertyName.toLowerCase() + "/" + property.id + "/" },
            'Name:',
            _react2.default.createElement('br', null),
            _react2.default.createElement('input', { defaultValue: property.name, name: 'name' }),
            this.props.propertyName.toLowerCase() === 'portfolio' ? _react2.default.createElement(
              'div',
              { style: { paddingTop: 10, paddingBottom: 10 } },
              'Description',
              _react2.default.createElement('br', null),
              _react2.default.createElement('textarea', { name: 'description', rows: '5', cols: '60', defaultValue: property.description })
            ) : null,
            _react2.default.createElement('input', { onClick: this.editProperty.bind(this), type: 'button', value: 'Cancel' }),
            ' ',
            _react2.default.createElement('input', { type: 'submit', value: 'Update' })
          ) : property.name,
          count !== undefined && !this.state.edit ? _react2.default.createElement(
            'span',
            null,
            ' (',
            count,
            ')'
          ) : null
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", textAlign: "left", padding: 5 } },
          this.props.editEnabled && !this.state.edit ? _react2.default.createElement(
            'a',
            { href: '#', onClick: this.editProperty.bind(this) },
            _react2.default.createElement('img', { src: '/icons/pen_grey_tran.png' })
          ) : null
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", textAlign: "left", padding: 5, paddingRight: 15 } },
          this.props.deleteEnabled && !this.state.edit && count === 0 ? _react2.default.createElement(
            'a',
            { style: { paddingLeft: 20 }, href: "/" + this.props.propertyName.toLowerCase() + "/" + property.id + "/delete" },
            _react2.default.createElement('img', { src: '/icons/delete_grey.png' }),
            ' '
          ) : null
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", textAlign: "left", padding: 5 } },
          this.props.accessControllEnabled && !this.state.edit ? _react2.default.createElement(
            'span',
            null,
            this.props.property.accessControl !== undefined ? _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'span',
                { style: { color: "red" } },
                'limited access'
              ),
              _react2.default.createElement(
                'span',
                null,
                ' ('
              ),
              this.props.property.accessControl.join(", "),
              _react2.default.createElement(
                'span',
                null,
                ') '
              ),
              _react2.default.createElement(
                'a',
                { href: '#', onClick: this.editAccessControl.bind(this) },
                'Edit access control'
              )
            ) : _react2.default.createElement(
              'a',
              { href: '#', onClick: this.editAccessControl.bind(this) },
              'Enable access control'
            )
          ) : null
        )
      );
    }
  }]);

  return ShowProperty;
}(_react2.default.Component);

var ListProperty = function (_React$Component4) {
  _inherits(ListProperty, _React$Component4);

  function ListProperty() {
    _classCallCheck(this, ListProperty);

    return _possibleConstructorReturn(this, (ListProperty.__proto__ || Object.getPrototypeOf(ListProperty)).apply(this, arguments));
  }

  _createClass(ListProperty, [{
    key: 'render',
    value: function render() {
      var _this5 = this;

      var propertyName = this.props.propertyName;
      var pluralName = propertyName.slice(-1) === "y" ? propertyName.slice(0, -1) + "ies" : propertyName + "s";
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h3',
          null,
          pluralName
        ),
        _react2.default.createElement(
          'div',
          { style: { maxWidth: 610 } },
          this.props.description,
          ' ',
          _react2.default.createElement('br', null),
          _react2.default.createElement('br', null)
        ),
        this.props.property !== undefined && this.props.property.length > 0 ? _react2.default.createElement(
          'div',
          { style: { display: "table", minWidth: 610, marginBottom: 20, marginRight: 20, marginTop: 10, float: "left", borderCollapse: "collapse" } },
          this.props.property.map(function (property) {
            return _react2.default.createElement(ShowProperty, _extends({ key: property.id }, _this5.props, { property: property }));
          })
        ) : _react2.default.createElement(
          'i',
          null,
          'No ',
          pluralName.toLowerCase(),
          ' defined yet.'
        )
      );
    }
  }]);

  return ListProperty;
}(_react2.default.Component);

var PropertyManagement = function (_React$Component5) {
  _inherits(PropertyManagement, _React$Component5);

  function PropertyManagement(props) {
    _classCallCheck(this, PropertyManagement);

    var _this6 = _possibleConstructorReturn(this, (PropertyManagement.__proto__ || Object.getPrototypeOf(PropertyManagement)).call(this, props));

    _this6.state = { details: false };
    return _this6;
  }

  _createClass(PropertyManagement, [{
    key: 'render',
    value: function render() {
      if (this.props.user !== undefined && this.props.tenant.owner.id === this.props.user.id) {
        return _react2.default.createElement(
          'div',
          { style: { display: "flex", justifyContent: "flex-start", marginTop: 20, flexWrap: "wrap" } },
          _react2.default.createElement(ListProperty, this.props),
          _react2.default.createElement(
            'form',
            { method: 'POST', action: "/" + this.props.propertyName.toLowerCase() },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { style: { marginBottom: 20 } },
                _react2.default.createElement('input', { name: 'name', className: 'input', placeholder: this.props.propertyName + " name", autoComplete: 'off', size: '73' })
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('input', { type: 'submit', className: 'save', value: "Add " + this.props.propertyName.toLowerCase() })
              )
            )
          )
        );
      } else {
        return this.props.property !== undefined && this.props.propertylength > 0 ? _react2.default.createElement(ListProperty, this.props) : null;
      }
    }
  }]);

  return PropertyManagement;
}(_react2.default.Component);

var DesignConfiguration = function (_React$Component6) {
  _inherits(DesignConfiguration, _React$Component6);

  function DesignConfiguration(props) {
    _classCallCheck(this, DesignConfiguration);

    return _possibleConstructorReturn(this, (DesignConfiguration.__proto__ || Object.getPrototypeOf(DesignConfiguration)).call(this, props));
  }

  _createClass(DesignConfiguration, [{
    key: 'render',
    value: function render() {
      if (this.props.user !== undefined && this.props.tenant.owner.id === this.props.user.id) {
        var layout = this.props.tenant.design !== undefined ? this.props.tenant.design : {};
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'form',
            { method: 'POST', action: '/configureDesign' },
            _react2.default.createElement('input', { type: 'hidden', name: 'tenant', value: this.props.tenant.id }),
            'Logo: ',
            _react2.default.createElement('input', { size: '80', placeholder: '(url)', name: 'logo', defaultValue: layout.logo }),
            _react2.default.createElement('br', null),
            'Logo background color: ',
            _react2.default.createElement('input', { size: '80', placeholder: '(color)', name: 'backgroundColor', defaultValue: layout.backgroundColor }),
            ' (optional)',
            _react2.default.createElement('br', null),
            'Logo background: ',
            _react2.default.createElement('input', { size: '80', placeholder: '(url)', name: 'background', defaultValue: layout.background }),
            ' (optional)',
            _react2.default.createElement('br', null),
            'Logo position: ',
            _react2.default.createElement('input', { size: '20', placeholder: '(eg 0px -400px)', name: 'position', defaultValue: layout.position }),
            ' (optional)',
            _react2.default.createElement('br', null),
            'Logo size: ',
            _react2.default.createElement('input', { size: '10', placeholder: '(eg 100px or contain)', name: 'size', defaultValue: layout.size }),
            ' (default is contain)',
            _react2.default.createElement('br', null),
            'Color:  ',
            _react2.default.createElement('input', { size: '10', placeholder: 'Account color (eg #ab12ef)', name: 'color', defaultValue: layout.color }),
            _react2.default.createElement('br', null),
            'Height: ',
            _react2.default.createElement('input', { size: '15', placeholder: 'Height', name: 'height', defaultValue: layout.height }),
            ' (Header, default is 48)',
            _react2.default.createElement('br', null),
            'Width:  ',
            _react2.default.createElement('input', { size: '15', placeholder: 'Width', name: 'width', defaultValue: layout.width }),
            ' (Logo area i header, default is 165)',
            _react2.default.createElement('br', null),
            'Show account name: ',
            _react2.default.createElement('input', { type: 'checkbox', name: 'showTenantName', defaultChecked: layout.showTenantName }),
            ' (displayed below header as default)',
            _react2.default.createElement('br', null),
            'Use custom header: ',
            _react2.default.createElement('input', { type: 'checkbox', name: 'enabled', defaultChecked: layout.enabled }),
            ' ',
            _react2.default.createElement('br', null),
            'Logo for report: ',
            _react2.default.createElement('input', { size: '80', placeholder: '(url)', name: 'reportLogo', defaultValue: layout.reportLogo }),
            ' (otional, use logo as default)',
            _react2.default.createElement('br', null),
            'Website Title: ',
            _react2.default.createElement('input', { placeholder: 'Progreto - the project portfolio management tool', name: 'title', size: '50', defaultValue: layout.title }),
            _react2.default.createElement('br', null),
            this.props.tenant.sso !== undefined && this.props.tenant.sso.enabled ? _react2.default.createElement(
              'div',
              null,
              'Favicon: ',
              _react2.default.createElement('input', { placeholder: 'Specify url to favicon.ico (https)', name: 'favicon', size: '80', defaultValue: layout.favicon }),
              ' (requests are redirected)'
            ) : null,
            this.props.draftFeaturesEnabled ? _react2.default.createElement(
              'div',
              null,
              'Language:',
              _react2.default.createElement(
                'select',
                { name: 'language', defaultValue: this.props.tenant.language },
                _react2.default.createElement(
                  'option',
                  { value: 'english' },
                  'English'
                ),
                _react2.default.createElement(
                  'option',
                  { value: 'norwegian' },
                  'Norwegian'
                )
              )
            ) : null,
            _react2.default.createElement(
              'div',
              { style: { paddingTop: 10 } },
              _react2.default.createElement('input', { type: 'submit', className: 'save', value: 'Save' })
            )
          )
        );
      }
    }
  }]);

  return DesignConfiguration;
}(_react2.default.Component);

var StandardLinkForm = function (_React$Component7) {
  _inherits(StandardLinkForm, _React$Component7);

  function StandardLinkForm() {
    _classCallCheck(this, StandardLinkForm);

    return _possibleConstructorReturn(this, (StandardLinkForm.__proto__ || Object.getPrototypeOf(StandardLinkForm)).apply(this, arguments));
  }

  _createClass(StandardLinkForm, [{
    key: 'addLink',
    value: function addLink(event) {
      event.preventDefault();
      cosole.log("Add link");
      this.props.sendCommand({
        type: "addStandardLink",
        title: event.target.title.value,
        address: event.target.address.value,
        parameters: event.target.parameterName.value !== undefined && event.target.parameterName.value.trim().length > 0 ? [{ name: event.target.parameterName.value, key: event.target.parameterValue.value }] : []
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _React$createElement;

      return _react2.default.createElement(
        'div',
        { style: { maxWidth: 800 } },
        _react2.default.createElement(
          'h4',
          null,
          'Standard link'
        ),
        _react2.default.createElement(
          'form',
          { action: '/links/standard/', method: 'POST' },
          this.props.id !== undefined ? _react2.default.createElement('input', { type: 'hidden', name: 'id', value: this.props.id }) : null,
          _react2.default.createElement(
            _Area2.default,
            { title: 'Link' },
            _react2.default.createElement(_Field2.default, { title: 'Title', name: 'title', value: this.props.title }),
            _react2.default.createElement(_Field2.default, { title: 'Address', name: 'address', value: this.props.address })
          ),
          _react2.default.createElement(
            _Area2.default,
            { title: 'Parameter' },
            _react2.default.createElement(
              'div',
              { style: { paddingBottom: 10 } },
              _react2.default.createElement(
                'i',
                null,
                'Leave parameter name empty if no parameter is required.'
              )
            ),
            _react2.default.createElement(_Field2.default, { title: 'Name', name: 'parameterName', value: this.props.parameters !== undefined && this.props.parameters.length > 0 ? this.props.parameters[0].name : undefined }),
            _react2.default.createElement(_Field2.default, { title: 'Value', name: 'parameterValue', value: this.props.parameters !== undefined && this.props.parameters.length > 0 ? this.props.parameters[0].key : undefined, options: [{ text: "Project identifier", value: "identifier" }] })
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingBottom: 50 } },
            _react2.default.createElement('input', { className: 'cancel', type: 'button', value: 'Cancel', onClick: this.props.onCancel }),
            _react2.default.createElement('input', (_React$createElement = { className: 'save', type: 'submit' }, _defineProperty(_React$createElement, 'className', 'save'), _defineProperty(_React$createElement, 'value', this.props.id !== undefined ? "Update standard link" : "Add standard link"), _React$createElement))
          )
        )
      );
    }
  }]);

  return StandardLinkForm;
}(_react2.default.Component);

var StandardLinkDetails = function (_React$Component8) {
  _inherits(StandardLinkDetails, _React$Component8);

  function StandardLinkDetails(props) {
    _classCallCheck(this, StandardLinkDetails);

    var _this9 = _possibleConstructorReturn(this, (StandardLinkDetails.__proto__ || Object.getPrototypeOf(StandardLinkDetails)).call(this, props));

    _this9.state = { edit: false };
    return _this9;
  }

  _createClass(StandardLinkDetails, [{
    key: 'toggleEdit',
    value: function toggleEdit(event) {
      event.preventDefault();
      this.setState({ edit: !this.state.edit });
    }
  }, {
    key: 'deleteLink',
    value: function deleteLink(event) {
      event.preventDefault();
      request.delete("/links/standard/" + this.props.id + "/").end(function (err, result) {
        if (err === null) {
          window.location.reload();
        } else {
          console.log("Error deleting " + this.props.title + ": " + JSON.stringify(result), err);
          alert("An error occured, please try again");
        }
      }.bind(this));
    }
  }, {
    key: 'render',
    value: function render() {
      return this.state.edit ? _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { colSpan: '4' },
          _react2.default.createElement(StandardLinkForm, _extends({}, this.props, { onCancel: this.toggleEdit.bind(this) }))
        )
      ) : _react2.default.createElement(
        'div',
        { style: { display: "table-row", borderBottom: "solid 1px #C1C1C1" } },
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", textAlign: "left", padding: 5 } },
          this.props.title
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", textAlign: "left", padding: 5, maxWidth: 600, wordWrap: "break-word" } },
          this.props.address
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", textAlign: "left", padding: 5 } },
          this.props.parameters !== undefined && this.props.parameters.length > 0 ? this.props.parameters.map(function (parameter) {
            return parameter.name + "=<" + parameter.key + ">";
          }).join("&") : null
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", textAlign: "left", padding: 5 } },
          _react2.default.createElement(
            'a',
            { href: '#', onClick: this.toggleEdit.bind(this) },
            _react2.default.createElement('img', { style: { verticalAlign: "bottom" }, src: '/icons/pen_grey_tran.png' })
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "table-cell", textAlign: "left", padding: 5 } },
          _react2.default.createElement(
            'a',
            { href: '#', onClick: this.deleteLink.bind(this), style: { paddingLeft: 20 } },
            _react2.default.createElement('img', { src: '/icons/delete_grey.png' })
          )
        )
      );
    }
  }]);

  return StandardLinkDetails;
}(_react2.default.Component);

var StandardLinks = function (_React$Component9) {
  _inherits(StandardLinks, _React$Component9);

  function StandardLinks(props) {
    _classCallCheck(this, StandardLinks);

    var _this10 = _possibleConstructorReturn(this, (StandardLinks.__proto__ || Object.getPrototypeOf(StandardLinks)).call(this, props));

    _this10.state = { form: false };
    return _this10;
  }

  _createClass(StandardLinks, [{
    key: 'showForm',
    value: function showForm(event) {
      event.preventDefault();
      this.setState({ form: !this.state.form });
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.user !== undefined && this.props.tenant.owner.id === this.props.user.id) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h3',
            null,
            'Standard links'
          ),
          _react2.default.createElement('br', null),
          'Standard links are links to external applications. A standard link will show for all projects.',
          _react2.default.createElement('br', null),
          'Standard links can use the project identifier as parameter. A target system can use this parameter to show the relevant information.',
          _react2.default.createElement('br', null),
          this.props.tenant.standardLinks !== undefined ? _react2.default.createElement(
            'div',
            { style: { display: "table", minWidth: 610, marginBottom: 40, marginRight: 20, marginTop: 30, float: "left", borderCollapse: "collapse" } },
            _react2.default.createElement(
              'div',
              { style: { display: "table-row", borderBottom: "solid 1px #C1C1C1" } },
              _react2.default.createElement(
                'div',
                { style: { display: "table-cell", fontWeight: "bold", textAlign: "left", padding: 5 } },
                'Title'
              ),
              _react2.default.createElement(
                'div',
                { style: { display: "table-cell", fontWeight: "bold", textAlign: "left", padding: 5 } },
                'Address'
              ),
              _react2.default.createElement(
                'div',
                { style: { display: "table-cell", fontWeight: "bold", textAlign: "left", padding: 5 } },
                'Parameters'
              ),
              _react2.default.createElement('div', { style: { display: "table-cell", fontWeight: "bold", textAlign: "left", padding: 5 } }),
              _react2.default.createElement('div', { style: { display: "table-cell", fontWeight: "bold", textAlign: "left", padding: 5 } })
            ),
            this.props.tenant.standardLinks.map(function (link) {
              return _react2.default.createElement(StandardLinkDetails, _extends({ key: link.id }, link));
            })
          ) : _react2.default.createElement(
            'i',
            null,
            _react2.default.createElement('br', null),
            'No standard links are defined'
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingTop: 15, minWidth: 610, float: "left", paddingBottom: 15 } },
            this.state.form ? _react2.default.createElement(StandardLinkForm, { onCancel: this.showForm.bind(this) }) : _react2.default.createElement(
              'a',
              { href: '#', onClick: this.showForm.bind(this) },
              'Add standard link'
            )
          )
        );
      } else {
        return null;
      }
    }
  }]);

  return StandardLinks;
}(_react2.default.Component);

var CurrencySettings = function (_React$Component10) {
  _inherits(CurrencySettings, _React$Component10);

  function CurrencySettings(props) {
    _classCallCheck(this, CurrencySettings);

    var _this11 = _possibleConstructorReturn(this, (CurrencySettings.__proto__ || Object.getPrototypeOf(CurrencySettings)).call(this, props));

    _this11.state = {
      currencies: props.settings !== undefined ? props.settings : []
    };
    return _this11;
  }

  _createClass(CurrencySettings, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState({ currencies: props.settings !== undefined ? props.settings : [] });
    }
  }, {
    key: 'update',
    value: function update(event) {
      event.preventDefault();
      if (this.props.onUpdate !== undefined) {
        var currency = event.target.elements.currency.value;
        this.props.onUpdate(currency);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h3',
          null,
          'Currencies'
        ),
        'These are the currencies one can chose from when documenting budgets in plans. ',
        _react2.default.createElement('br', null),
        this.state.currencies !== undefined && this.state.currencies.length > 0 ? _react2.default.createElement(
          'div',
          { style: { display: "table", minWidth: 610, marginBottom: 20, marginRight: 20, marginTop: 10, float: "left", borderCollapse: "collapse" } },
          this.state.currencies.map(function (currency) {
            return _react2.default.createElement(
              'div',
              { style: { display: "table-row", borderBottom: "solid 1px #C1C1C1" } },
              _react2.default.createElement(
                'div',
                { style: { display: "table-cell", textAlign: "left", padding: 5 } },
                currency,
                ' - ',
                _currencies2.default.find(function (item) {
                  return item.id === currency;
                }).title
              )
            );
          })
        ) : _react2.default.createElement(
          'i',
          null,
          'Currency is not defined'
        ),
        _react2.default.createElement(
          'form',
          { onSubmit: this.update.bind(this), style: { paddingTop: 15, maxWidth: 610 } },
          _react2.default.createElement(
            'select',
            { className: 'input', name: 'currency' },
            _currencies2.default.map(function (item) {
              return _react2.default.createElement(
                'option',
                { value: item.id },
                item.id,
                ' - ',
                item.title
              );
            })
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingTop: 15, paddingBottom: 50 } },
            _react2.default.createElement('input', { className: 'save', type: 'submit', value: 'Add currency' })
          )
        )
      );
    }
  }]);

  return CurrencySettings;
}(_react2.default.Component);

var ProjectSettings = function (_React$Component11) {
  _inherits(ProjectSettings, _React$Component11);

  function ProjectSettings(props) {
    _classCallCheck(this, ProjectSettings);

    var _this12 = _possibleConstructorReturn(this, (ProjectSettings.__proto__ || Object.getPrototypeOf(ProjectSettings)).call(this, props));

    _this12.state = {
      details: false,
      currencies: props.tenant !== undefined && props.tenant.currencies !== undefined ? props.tenant.currencies : []
    };
    return _this12;
  }

  _createClass(ProjectSettings, [{
    key: 'toggle',
    value: function toggle(event) {
      event.preventDefault();
      this.setState({ details: !this.state.details });
    }
  }, {
    key: 'updateBusinessCase',
    value: function updateBusinessCase(newSettings) {
      request.post("/configureProject/businessCase").send({ use: newSettings.use }).then(function () {
        window.location.reload();
      }).catch(function (error) {
        console.log("Error configure business case: ", error);
        alert("An error occured, please try again");
      });
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.user !== undefined && this.props.tenant.owner.id === this.props.user.id) {
        return _react2.default.createElement(
          'div',
          { style: { paddingTop: 35 } },
          _react2.default.createElement(
            'h3',
            null,
            'Project Themes'
          ),
          _react2.default.createElement(_BusinessCaseSettings2.default, _extends({}, this.props, { settings: { enabled: this.props.tenant.settings === undefined || this.props.tenant.settings !== undefined && this.props.tenant.settings.disableBusinessCase !== true }, onUpdate: this.updateBusinessCase.bind(this) }))
        );
      }
    }
  }]);

  return ProjectSettings;
}(_react2.default.Component);

var Users = function (_React$Component12) {
  _inherits(Users, _React$Component12);

  function Users() {
    _classCallCheck(this, Users);

    return _possibleConstructorReturn(this, (Users.__proto__ || Object.getPrototypeOf(Users)).apply(this, arguments));
  }

  _createClass(Users, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 20, paddingBottom: 20, fontWeight: "bold", textAlign: "left", color: "#212121", fontSize: 20, textTransform: "capitalize" } },
          'Users of account:  ',
          this.props.tenant.name
        ),
        _react2.default.createElement(
          'table',
          null,
          _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                { style: { textAlign: "left" } },
                'Admin:'
              ),
              _react2.default.createElement(
                'td',
                null,
                this.props.tenant.owner !== undefined ? _react2.default.createElement(Person, this.props.tenant.owner) : _react2.default.createElement(
                  'span',
                  { style: { color: "red" } },
                  '<not defined>'
                )
              )
            ),
            this.props.tenant.stakeholders !== undefined && this.props.tenant.stakeholders.length > 0 ? _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                { style: { textAlign: "left", verticalAlign: "top" } },
                'Users:'
              ),
              _react2.default.createElement(
                'td',
                { style: { paddingTop: 15 } },
                this.props.tenant.stakeholders.map(function (stakeholder) {
                  return _react2.default.createElement(Person, _extends({ key: stakeholder.id }, stakeholder));
                }),
                ' '
              )
            ) : null
          )
        )
      );
    }
  }]);

  return Users;
}(_react2.default.Component);

var AccountInfo = function (_React$Component13) {
  _inherits(AccountInfo, _React$Component13);

  function AccountInfo() {
    _classCallCheck(this, AccountInfo);

    return _possibleConstructorReturn(this, (AccountInfo.__proto__ || Object.getPrototypeOf(AccountInfo)).apply(this, arguments));
  }

  _createClass(AccountInfo, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 20, paddingBottom: 20, fontWeight: "bold", textAlign: "left", color: "#212121", fontSize: 20, textTransform: "capitalize" } },
          'Account:  ',
          this.props.tenant.name
        ),
        _react2.default.createElement(
          'p',
          null,
          'Thank you for using a registered account. With a registered account you have:'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            'Access to your projects from any browser. Just login with your email address.'
          ),
          _react2.default.createElement(
            'li',
            null,
            'Possibility to share portfolios with other users. You grant someone access to your account by giving them a role in a project (theme \'Organization\')',
            this.props.user === undefined ? _react2.default.createElement(
              'span',
              null,
              ' when you are logged in'
            ) : "",
            '.'
          )
        ),
        _react2.default.createElement(
          'table',
          null,
          _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'th',
                { style: { textAlign: "left" } },
                'Account owner:'
              ),
              _react2.default.createElement(
                'td',
                null,
                this.props.tenant.owner !== undefined ? _react2.default.createElement(Person, this.props.tenant.owner) : _react2.default.createElement(
                  'span',
                  { style: { color: "red" } },
                  '<not defined>'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return AccountInfo;
}(_react2.default.Component);

var AccountCreated = exports.AccountCreated = function (_React$Component14) {
  _inherits(AccountCreated, _React$Component14);

  function AccountCreated(props) {
    _classCallCheck(this, AccountCreated);

    var _this15 = _possibleConstructorReturn(this, (AccountCreated.__proto__ || Object.getPrototypeOf(AccountCreated)).call(this, props));

    _this15.state = {
      selectedTab: props.selectedtab !== undefined ? props.selectedtab : "Account",
      currencies: props.tenant !== undefined && props.tenant.currencies !== undefined ? props.tenant.currencies : []
    };
    return _this15;
  }

  _createClass(AccountCreated, [{
    key: 'updateCurrency',
    value: function updateCurrency(newCurrency) {
      var _this16 = this;

      request.post("/").send({ type: "addCurrency", currency: newCurrency }).then(function (response) {
        var currencies = JSON.parse(response.text).currencies;
        if (currencies !== undefined) {
          _this16.setState({ currencies: currencies });
        } else {
          console.log("[ERROR] Not able to read currencies on updated settings, got " + JSON.stringify(settings));
          alert("An error occured, please try again");
        }
      }).catch(function (error) {
        console.log("Error adding currency: ", error);
        alert("An error occured, please try again");
        window.location.reload();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this17 = this,
          _extends2;

      var supportEmail = "mailto:support@progreto.com?subject=Request from " + this.props.tenant.name + "&body=Hi!%0D%0A%0D%0AI%20have%20request%20regarding%20%0D%0A%0D%0A%0D%0ARegards,%0D%0A" + (this.props.user !== undefined ? this.props.user.name + "%20(ref:%20" + this.props.user.id + ")" : this.props.tenant.owner.name + "%20(ref:%20owner%20" + this.props.tenant.owner.id + ")") + "%0D%0A" + this.props.tenant.name + "%20(ref:%20" + this.props.tenant.id + ")";

      var borderSelected = "solid #0079BD 5px";
      var border = "solid #47b857 5px";
      var color = "black";
      var fontWeight = "bold";
      var textDecoration = "underline";
      var cursor = "pointer";
      var textDecorationSelected = "none";

      return _react2.default.createElement(
        'div',
        { style: { marginLeft: 30, marginTop: 20, marginBottom: 20, maxWidth: 1200, fontFamily: "Lato, Arial, Helvetica Neue, Helvetica, sans-serif" } },
        _react2.default.createElement(
          'div',
          { style: { display: "flex", justifyContent: "space-around", flexWrap: "wrap", fontSize: "14pt", cursor: cursor, textDecoration: textDecoration, fontWeight: fontWeight, fontFamily: "Lato, Arial", textAlign: "center", color: color } },
          this.props.user !== undefined && this.props.tenant.owner.id === this.props.user.id ? _react2.default.createElement(
            'div',
            { style: { display: "contents" } },
            _react2.default.createElement(
              'div',
              { onClick: function onClick() {
                  return _this17.setState({ selectedTab: "Account" });
                }, style: { margin: 3, minWidth: 100, padding: 5, borderBottom: this.state.selectedTab === "Account" ? borderSelected : border } },
              'Account'
            ),
            _react2.default.createElement(
              'div',
              { onClick: function onClick() {
                  return _this17.setState({ selectedTab: "Users" });
                }, style: { margin: 3, minWidth: 100, padding: 5, borderBottom: this.state.selectedTab === "Users" ? borderSelected : border } },
              'Users'
            ),
            _react2.default.createElement(
              'div',
              { onClick: function onClick() {
                  return _this17.setState({ selectedTab: "Portfolios" });
                }, style: { margin: 3, minWidth: 100, padding: 5, borderBottom: this.state.selectedTab === "Portfolios" ? borderSelected : border } },
              'Portfolios'
            ),
            _react2.default.createElement(
              'div',
              { onClick: function onClick() {
                  return _this17.setState({ selectedTab: "Properties" });
                }, style: { margin: 3, minWidth: 100, padding: 5, borderBottom: this.state.selectedTab === "Properties" ? borderSelected : border } },
              'Properties'
            ),
            _react2.default.createElement(
              'div',
              { onClick: function onClick() {
                  return _this17.setState({ selectedTab: "ProjectSettings" });
                }, style: { margin: 3, minWidth: 100, padding: 5, borderBottom: this.state.selectedTab === "ProjectSettings" ? borderSelected : border } },
              'Projects'
            ),
            _react2.default.createElement(
              'div',
              { onClick: function onClick() {
                  return _this17.setState({ selectedTab: "Lifecycles" });
                }, style: { margin: 3, minWidth: 100, padding: 5, borderBottom: this.state.selectedTab === "Lifecycles" ? borderSelected : border } },
              'Lifecycles'
            ),
            _react2.default.createElement(
              'div',
              { onClick: function onClick() {
                  return _this17.setState({ selectedTab: "Design" });
                }, style: { margin: 3, minWidth: 100, padding: 5, borderBottom: this.state.selectedTab === "Design" ? borderSelected : border } },
              'Design'
            ),
            _react2.default.createElement(
              'div',
              { onClick: function onClick() {
                  return _this17.setState({ selectedTab: "SSO" });
                }, style: { margin: 3, minWidth: 100, padding: 5, borderBottom: this.state.selectedTab === "SSO" ? borderSelected : border } },
              'SSO'
            )
          ) : null
        ),
        _react2.default.createElement(
          'div',
          { style: { backgroundColor: "#f7f7f7", paddingLeft: 20, paddingRight: 20, paddingBottom: 20, paddingTop: 5, marginBottom: 20, marginTop: 20, display: "flex", maxWidth: 1200, justifyContent: "space-between", flexWrap: "wrap" } },
          this.state.selectedTab === "Account" ? _react2.default.createElement(AccountInfo, this.props) : null,
          this.state.selectedTab === "Users" ? _react2.default.createElement(Users, this.props) : null,
          this.state.selectedTab === "Design" ? _react2.default.createElement(DesignConfiguration, this.props) : null,
          this.state.selectedTab === "SSO" ? _react2.default.createElement(_SSOConfiguration2.default, this.props) : null,
          this.state.selectedTab === "Portfolios" ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(PropertyManagement, _extends({}, this.props, {
              propertyName: 'Portfolio',
              description: 'Portfolio is a collection of activities you want to manage with respect to funding, prioritization and balance of investment. ',
              property: this.props.tenant.portfolios,
              editEnabled: true,
              count: function count(portfolio) {
                return _this17.props.projects !== undefined ? _this17.props.projects.filter(function (project) {
                  return project.portfolio === portfolio.id;
                }).length : 0;
              },
              countProgramme: function countProgramme(portfolio) {
                return _this17.props.tenant.programmes !== undefined ? _this17.props.tenant.programmes.filter(function (programme) {
                  return programme.portfolio === portfolio.id;
                }).length : 0;
              },
              countProduct: function countProduct(portfolio) {
                return _this17.props.tenant.products !== undefined ? _this17.props.tenant.products.filter(function (product) {
                  return product.portfolio === portfolio.id;
                }).length : 0;
              },
              deleteEnabled: true,
              accessControllEnabled: true
            }))
          ) : null,
          this.state.selectedTab === "Lifecycles" ? _react2.default.createElement(_LifecycleManagement2.default, this.props) : null,
          this.state.selectedTab === "Properties" ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(PropertyManagement, _extends({}, this.props, {
              propertyName: 'Location',
              description: 'Location is the physical or geographic location where an activity is managed from',
              property: this.props.tenant.locations,
              editEnabled: true,
              count: function count(location) {
                return _this17.props.projects !== undefined ? _this17.props.projects.filter(function (project) {
                  return project.location === location.id;
                }).length : 0;
              },
              deleteEnabled: true })),
            _react2.default.createElement(PropertyManagement, _extends({}, this.props, {
              propertyName: 'Department',
              description: 'Department is the business unit, line organization or staff function owning an activity',
              property: this.props.tenant.departments,
              editEnabled: true,
              count: function count(location) {
                return _this17.props.projects !== undefined ? _this17.props.projects.filter(function (project) {
                  return project.department === location.id;
                }).length : 0;
              },
              deleteEnabled: true })),
            _react2.default.createElement(CurrencySettings, _extends({}, this.props, { settings: this.state.currencies, onUpdate: this.updateCurrency.bind(this) }))
          ) : null,
          this.state.selectedTab === "ProjectSettings" ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(PropertyManagement, _extends({}, this.props, {
              propertyName: 'Type',
              description: 'There can be different types of projects like product development, IT Systems, organizational development etc. The main reason for defining types is to connect a type with a Lifecycle.',
              property: this.props.tenant.projectTypes,
              editEnabled: true,
              count: function count(projectType) {
                return _this17.props.projects !== undefined ? _this17.props.projects.filter(function (project) {
                  return project.projectType === projectType.id;
                }).length : 0;
              },
              deleteEnabled: true })),
            _react2.default.createElement(PropertyManagement, _extends({}, this.props, (_extends2 = {
              description: 'Category is a project attribute without any specific definition. It is only useful as a filtering criteria',
              propertyName: 'Category', property: this.props.tenant.categories
            }, _defineProperty(_extends2, 'property', this.props.tenant.categories), _defineProperty(_extends2, 'editEnabled', true), _defineProperty(_extends2, 'count', function count(category) {
              return _this17.props.projects !== undefined ? _this17.props.projects.filter(function (project) {
                return project.category === category.id;
              }).length : 0;
            }), _defineProperty(_extends2, 'deleteEnabled', true), _extends2))),
            _react2.default.createElement(ProjectSettings, this.props),
            _react2.default.createElement(StandardLinks, this.props)
          ) : null
        ),
        _react2.default.createElement(
          'div',
          { style: { marginTop: 60 } },
          this.props.user !== undefined && this.props.user.confirmation !== undefined ? _react2.default.createElement(
            'p',
            null,
            'A confirmation email has been sendt to email address',
            _react2.default.createElement(
              'b',
              null,
              '\'',
              this.props.user.confirmation.email,
              '\''
            ),
            'at ',
            this.props.user.confirmation.sent,
            '.'
          ) : _react2.default.createElement(
            'p',
            null,
            'Please contact support at ',
            _react2.default.createElement(
              'a',
              { href: supportEmail },
              'support@progreto.com'
            ),
            ' if you need assistance.'
          ),
          this.props.user === undefined ? _react2.default.createElement(
            'p',
            null,
            'To get access to all functionality of your account,',
            this.props.tenant.owner !== undefined && this.props.tenant.owner.emailConfirmation !== undefined ? _react2.default.createElement(
              'span',
              null,
              ' please confirm your email address by '
            ) : _react2.default.createElement(
              'span',
              null,
              ' please'
            ),
            ' ',
            _react2.default.createElement(
              'a',
              { href: '/login' },
              'login'
            ),
            '.'
          ) : null,
          this.props.otherTenants !== undefined && this.props.otherTenants.length > 0 ? _react2.default.createElement(
            'p',
            null,
            'Other tenants you can access: ',
            this.props.otherTenants.map(function (tenant) {
              return _react2.default.createElement(
                'a',
                { key: tenant.id, style: { paddingRight: 15 }, href: "/tenants/" + tenant.id + "/" },
                tenant.name
              );
            })
          ) : null,
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'a',
              { href: '/' },
              'Go to ',
              this.props.tenant.name,
              ' home page'
            )
          )
        )
      );
    }
  }]);

  return AccountCreated;
}(_react2.default.Component);

var AccountCreatedPage = function (_React$Component15) {
  _inherits(AccountCreatedPage, _React$Component15);

  function AccountCreatedPage() {
    _classCallCheck(this, AccountCreatedPage);

    return _possibleConstructorReturn(this, (AccountCreatedPage.__proto__ || Object.getPrototypeOf(AccountCreatedPage)).apply(this, arguments));
  }

  _createClass(AccountCreatedPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Layout2.default,
        this.props,
        _react2.default.createElement(AccountCreated, this.props)
      );
    }
  }]);

  return AccountCreatedPage;
}(_react2.default.Component);

exports.default = AccountCreatedPage;

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _TrainingConfiguration = __webpack_require__(1060);

var _TrainingConfiguration2 = _interopRequireDefault(_TrainingConfiguration);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var request = __webpack_require__(23);

var JWTConfig = function (_React$Component) {
  _inherits(JWTConfig, _React$Component);

  function JWTConfig() {
    _classCallCheck(this, JWTConfig);

    return _possibleConstructorReturn(this, (JWTConfig.__proto__ || Object.getPrototypeOf(JWTConfig)).apply(this, arguments));
  }

  _createClass(JWTConfig, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { paddingBottom: 10 } },
          _react2.default.createElement(
            'b',
            null,
            'Login service'
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement('input', { size: '120', name: 'login', placeholder: 'Login service (url)', defaultValue: 'https://mycompany.com/sso?redirect_uri=mycompany.progreto.com' }),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'i',
            null,
            'Login service (url) is the address users in your organization use to log in.'
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { paddingBottom: 10 } },
          _react2.default.createElement(
            'b',
            null,
            'Secret or public key'
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement('textarea', { name: 'secret', cols: '80', rows: '10', placeholder: 'Secret or public key' })
        ),
        _react2.default.createElement(
          'div',
          { style: { paddingBottom: 10 } },
          _react2.default.createElement(
            'b',
            null,
            'Issuer'
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement('input', { size: '50', name: 'issuer', placeholder: 'Issuer (url)', defaultValue: 'https://mycompany.com/' }),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'i',
            null,
            'Issuer (url) is the address that is used to sign the token.'
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { borderRadius: 5, backgroundColor: "#e9e7e6", border: "solid 1px grey", padding: 10, maxWidth: 1016 } },
          _react2.default.createElement(
            'p',
            null,
            'The SSO functionality relies on ',
            _react2.default.createElement(
              'a',
              { href: 'https://jwt.io/' },
              'JWT (Json Web Tokens)'
            ),
            ', which is like a ticket issued by your organisation to confirm your identify, signed with your organizations certificate and sent as a parameter together with the request.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'When SSO is enabled the login process follows this sequence:'
          ),
          _react2.default.createElement(
            'ol',
            null,
            _react2.default.createElement(
              'li',
              null,
              'The user navigates to mycompany.progreto.com (<mycompany> is the domain name you have configured for your account)'
            ),
            _react2.default.createElement(
              'li',
              null,
              'Progreto identifies that the user is not authenticated'
            ),
            _react2.default.createElement(
              'li',
              null,
              'The user is redirected to your login service, eg. https://mycompany.com/sso.'
            ),
            _react2.default.createElement(
              'li',
              null,
              'Your login service authenticates the user and genrate a JWT with information about the user'
            ),
            _react2.default.createElement(
              'li',
              null,
              'The JWT is sent together with the request to mycompany.progreto.com'
            ),
            _react2.default.createElement(
              'li',
              null,
              'Progreto verifies the signature of the JWT and that the issuer for the JWT matches the defined issuer for your account.'
            ),
            _react2.default.createElement(
              'li',
              null,
              'The user is given access to your account at Progreto'
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'The JWT (ticket or token) needs to contain the following keys:'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'b',
                null,
                'id'
              ),
              ' - the internal ',
              _react2.default.createElement(
                'b',
                null,
                'unique'
              ),
              ' identity of the logged in user (user_id might also be used)'
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'b',
                null,
                'name'
              ),
              ' - the full name of the logged in user'
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'b',
                null,
                'email'
              ),
              ' - the email of the logged in user'
            )
          )
        )
      );
    }
  }]);

  return JWTConfig;
}(_react2.default.Component);

var SAML2Config = function (_React$Component2) {
  _inherits(SAML2Config, _React$Component2);

  function SAML2Config(props) {
    _classCallCheck(this, SAML2Config);

    var _this2 = _possibleConstructorReturn(this, (SAML2Config.__proto__ || Object.getPrototypeOf(SAML2Config)).call(this, props));

    _this2.state = { content: undefined };
    return _this2;
  }

  _createClass(SAML2Config, [{
    key: 'parseConfig',
    value: function parseConfig(event) {
      var address = event.target.value;
      var url = undefined;
      try {
        var url = new URL(address);
        console.log("Use address '" + address + " -> " + url);
        request.post("/saml2/verifyMetadata").send({ "url": address }).then(function (res) {
          console.log("Got: " + JSON.stringify(res));
          this.setState({ content: _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Certificate(s)'
              ),
              ':',
              _react2.default.createElement(
                'ul',
                null,
                res.body.certificates.map(function (certificate) {
                  return _react2.default.createElement(
                    'li',
                    { key: certificate.certificate },
                    certificate.content.subject.commonName,
                    ' valid from ',
                    new Date(certificate.content.notBefore).toISOString().slice(0, 10),
                    ' to ',
                    new Date(certificate.content.notAfter).toISOString().slice(0, 10),
                    '                    '
                  );
                })
              ),
              _react2.default.createElement(
                'b',
                null,
                'Login'
              ),
              ': ',
              res.body.login,
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'b',
                null,
                'Logout'
              ),
              ': ',
              res.body.logout
            ) });
        }.bind(this), function (err, res) {
          this.setState({ content: _react2.default.createElement(
              'i',
              null,
              'Invalid metadata address, please provide the address of the metadata xml-file.'
            ) });
        }.bind(this));
      } catch (invalidUrl) {}
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'b',
            null,
            this.props.title,
            'Metadata (url)'
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement('input', { size: '120', name: 'metadata', autoComplete: 'off', placeholder: 'Address of your SAML2 metadata file (url)', onChange: this.parseConfig.bind(this) })
        ),
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 10 } },
          this.state.content
        ),
        _react2.default.createElement(
          'div',
          { style: { borderRadius: 5, backgroundColor: "#e9e7e6", border: "solid 1px grey", padding: 10, maxWidth: 1016 } },
          'SAML2 is configured with metadata files. Please provide the url to your organizations metadata xml file.',
          _react2.default.createElement(
            'p',
            null,
            'The SAML2 configuration should include following claims:'
          ),
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'b',
                null,
                'E-Mail-Address'
              ),
              ' - the email of the logged in user'
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Given Name'
              ),
              ' - the given name of the logged in user'
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Surname'
              ),
              ' - the surname of the logged in user'
            )
          )
        )
      );
    }
  }]);

  return SAML2Config;
}(_react2.default.Component);

var ConfigureSSO = function (_React$Component3) {
  _inherits(ConfigureSSO, _React$Component3);

  function ConfigureSSO(props) {
    _classCallCheck(this, ConfigureSSO);

    var _this3 = _possibleConstructorReturn(this, (ConfigureSSO.__proto__ || Object.getPrototypeOf(ConfigureSSO)).call(this, props));

    _this3.state = { details: false, ssoType: "jwt" };
    return _this3;
  }

  _createClass(ConfigureSSO, [{
    key: 'toggle',
    value: function toggle(event) {
      event.preventDefault();
      this.setState({ details: !this.state.details });
    }
  }, {
    key: 'selectJWT',
    value: function selectJWT(event) {
      console.log("JWT");
      this.setState({ ssoType: "jwt" });
    }
  }, {
    key: 'selectSAML2',
    value: function selectSAML2(event) {
      console.log("SAML2");
      this.setState({ ssoType: "saml2" });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      if (this.props.user !== undefined && this.props.tenant.owner.id === this.props.user.id) {
        return this.state.details ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h3',
            null,
            'Single Sign On (SSO)'
          ),
          _react2.default.createElement(
            'p',
            null,
            'With SSO enabled, all users in your company can access Progreto without additional configuration of their user accounts. SSO can be configured to use SAML2 or JWT. For both altenatives you specify a dedicated domain for your company.'
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'form',
              { action: '/configureSSO', method: 'POST' },
              _react2.default.createElement('input', { type: 'hidden', name: 'tenant', value: this.props.tenant.id }),
              _react2.default.createElement(
                'div',
                { style: { paddingBottom: 10 } },
                _react2.default.createElement(
                  'b',
                  null,
                  'Domain'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement('input', { size: '30', name: 'domain', placeholder: 'yourdomain', autoComplete: 'off', style: { textAlign: "right" } }),
                '.progreto.com',
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  'i',
                  null,
                  'Domain is the address users in your organization shall use to access your account.'
                )
              ),
              _react2.default.createElement('input', { type: 'radio', onChange: this.selectJWT.bind(this), name: 'ssoType', value: 'jwt', id: 'jwt', checked: this.state.ssoType === "jwt" }),
              _react2.default.createElement(
                'label',
                { htmlFor: 'jwt' },
                'JWT'
              ),
              _react2.default.createElement('input', { type: 'radio', onChange: this.selectSAML2.bind(this), name: 'ssoType', value: 'saml2', id: 'saml2', checked: this.state.ssoType === "saml2", style: { marginLeft: 30 } }),
              _react2.default.createElement(
                'label',
                { htmlFor: 'saml2' },
                'SAML2'
              ),
              _react2.default.createElement(
                'div',
                { style: { marginTop: 10, marginBottom: 20 } },
                this.state.ssoType === "jwt" ? _react2.default.createElement(JWTConfig, null) : _react2.default.createElement(SAML2Config, null)
              ),
              _react2.default.createElement('input', { type: 'button', onClick: this.toggle.bind(this), value: 'Cancel' }),
              ' ',
              _react2.default.createElement('input', { type: 'submit', value: 'Configure SSO' })
            )
          )
        ) : _react2.default.createElement(
          'div',
          { style: { paddingTop: 20 } },
          this.props.tenant.sso !== undefined ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'b',
                null,
                'SSO is configured'
              ),
              this.state.edit !== true ? _react2.default.createElement(
                'a',
                { href: '#', style: { paddingLeft: 10 }, onClick: function onClick(event) {
                    event.preventDefault();_this4.setState({ edit: true });
                  } },
                _react2.default.createElement('img', { src: '/icons/pen_grey_tran.png' })
              ) : null
            ),
            _react2.default.createElement(
              'div',
              { style: { paddingLeft: 20 } },
              this.props.tenant.sso.enabled ? "Enabled domain" : "Domain",
              ' ',
              _react2.default.createElement(
                'i',
                null,
                _react2.default.createElement(
                  'a',
                  { href: "https://" + this.props.tenant.sso.domain + "/" },
                  this.props.tenant.sso.domain
                )
              ),
              ' using ',
              this.props.tenant.sso.type !== undefined ? this.props.tenant.sso.type.toUpperCase() : _react2.default.createElement(
                'i',
                null,
                'undefined authentication'
              ),
              ' with',
              this.props.tenant.sso.type === "jwt" || this.props.tenant.sso.type === undefined ? _react2.default.createElement(
                'span',
                null,
                ' login service ',
                _react2.default.createElement(
                  'i',
                  null,
                  _react2.default.createElement(
                    'a',
                    { href: this.props.tenant.sso.login },
                    this.props.tenant.sso.login
                  )
                ),
                ' and issuer ',
                _react2.default.createElement(
                  'i',
                  null,
                  this.props.tenant.sso.issuer
                )
              ) : _react2.default.createElement(
                'span',
                null,
                ' metadata ',
                _react2.default.createElement(
                  'i',
                  null,
                  _react2.default.createElement(
                    'a',
                    { href: this.props.tenant.sso.metadata },
                    this.props.tenant.sso.metadata
                  )
                )
              ),
              this.props.tenant.sso.approved ? _react2.default.createElement(
                'div',
                { style: { paddingTop: 10 } },
                _react2.default.createElement(
                  'i',
                  null,
                  'All users authenticated with SSO is approved to get access to this account.'
                )
              ) : this.props.tenant.sso.enabled && this.props.tenant.sso.verifiedBy !== undefined ? _react2.default.createElement(
                'div',
                { style: { paddingTop: 10 } },
                'SSO login is verified by:',
                _react2.default.createElement(
                  'ul',
                  null,
                  this.props.tenant.sso.verifiedBy.map(function (user) {
                    return _react2.default.createElement(
                      'li',
                      { key: user.id },
                      user.name,
                      ' (',
                      user.email,
                      ')'
                    );
                  })
                ),
                _react2.default.createElement(
                  'i',
                  null,
                  'All users authenticated with SSO will get access to this account.'
                ),
                _react2.default.createElement(
                  'form',
                  { style: { display: "inline-block", paddingLeft: 10 }, action: '/approveSSO', method: 'POST' },
                  _react2.default.createElement('input', { type: 'hidden', name: 'tenant', value: this.props.tenant.id }),
                  _react2.default.createElement('input', { type: 'submit', value: 'Approve SSO access' })
                )
              ) : null,
              this.state.edit ? _react2.default.createElement(
                'div',
                { style: { paddingTop: 10 } },
                this.props.tenant.sso.alternativeMetadata !== undefined && this.props.tenant.sso.alternativeMetadata.length > 0 ? _react2.default.createElement(
                  'p',
                  null,
                  'Alternative metadata:',
                  _react2.default.createElement(
                    'ul',
                    null,
                    this.props.tenant.sso.alternativeMetadata.map(function (item) {
                      return _react2.default.createElement(
                        'li',
                        null,
                        item,
                        _react2.default.createElement(
                          'div',
                          { style: { display: "inline-block", paddingLeft: 10 } },
                          _react2.default.createElement(
                            'form',
                            { method: 'POST', action: '/activateSSOMetadata' },
                            _react2.default.createElement('input', { type: 'hidden', name: 'tenant', value: _this4.props.tenant.id }),
                            _react2.default.createElement('input', { type: 'hidden', name: 'url', value: item }),
                            _react2.default.createElement('input', { type: 'submit', value: 'Set active' })
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { style: { display: "inline-block", paddingLeft: 10 } },
                          _react2.default.createElement(
                            'form',
                            { method: 'POST', action: '/removeSSOMetadata' },
                            _react2.default.createElement('input', { type: 'hidden', name: 'tenant', value: _this4.props.tenant.id }),
                            _react2.default.createElement('input', { type: 'hidden', name: 'url', value: item }),
                            _react2.default.createElement('input', { type: 'image', style: { verticalAlign: 'middle' }, src: '/icons/delete_grey.png' })
                          )
                        )
                      );
                    })
                  )
                ) : null,
                _react2.default.createElement(
                  'form',
                  { action: '/addSSOMetadata', method: 'POST' },
                  _react2.default.createElement('input', { type: 'hidden', name: 'tenant', value: this.props.tenant.id }),
                  _react2.default.createElement(SAML2Config, { title: 'Additinal ' }),
                  _react2.default.createElement(
                    'div',
                    { style: { paddingTop: 10 } },
                    _react2.default.createElement(
                      'button',
                      { onClick: function onClick() {
                          return _this4.setState({ edit: false });
                        } },
                      'Cancel'
                    ),
                    _react2.default.createElement(
                      'span',
                      null,
                      ' '
                    ),
                    _react2.default.createElement('input', { type: 'submit', value: 'Add additional metadata url' })
                  )
                )
              ) : _react2.default.createElement(
                'div',
                { style: { paddingTop: 10 } },
                _react2.default.createElement(
                  'form',
                  { action: '/disableSSO', method: 'POST' },
                  _react2.default.createElement('input', { type: 'hidden', name: 'tenant', value: this.props.tenant.id }),
                  _react2.default.createElement('input', { type: 'submit', value: 'Disable SSO' })
                )
              )
            )
          ) : _react2.default.createElement(
            'a',
            { href: '#', onClick: this.toggle.bind(this) },
            'Configure SSO (Single Sign On)'
          )
        );
      } else {
        return null;
      }
    }
  }]);

  return ConfigureSSO;
}(_react2.default.Component);

var SSOConfiguration = function (_React$Component4) {
  _inherits(SSOConfiguration, _React$Component4);

  function SSOConfiguration() {
    _classCallCheck(this, SSOConfiguration);

    return _possibleConstructorReturn(this, (SSOConfiguration.__proto__ || Object.getPrototypeOf(SSOConfiguration)).apply(this, arguments));
  }

  _createClass(SSOConfiguration, [{
    key: 'render',
    value: function render() {
      return this.props.training !== true ? _react2.default.createElement(ConfigureSSO, this.props) : _react2.default.createElement(_TrainingConfiguration2.default, this.props);
    }
  }]);

  return SSOConfiguration;
}(_react2.default.Component);

exports.default = SSOConfiguration;

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _uuid = __webpack_require__(26);

var _uuid2 = _interopRequireDefault(_uuid);

var _superagent = __webpack_require__(23);

var _superagent2 = _interopRequireDefault(_superagent);

var _Field = __webpack_require__(36);

var _Field2 = _interopRequireDefault(_Field);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TrainingConfiguration = function (_React$Component) {
  _inherits(TrainingConfiguration, _React$Component);

  function TrainingConfiguration(props) {
    _classCallCheck(this, TrainingConfiguration);

    var _this = _possibleConstructorReturn(this, (TrainingConfiguration.__proto__ || Object.getPrototypeOf(TrainingConfiguration)).call(this, props));

    _this.state = { details: false, users: _this.props.access };
    return _this;
  }

  _createClass(TrainingConfiguration, [{
    key: 'toggle',
    value: function toggle(event) {
      event.preventDefault();
      this.setState({ details: !this.state.details });
    }
  }, {
    key: 'addUsers',
    value: function addUsers(event) {
      var _this2 = this;

      event.preventDefault();
      var users = event.target.elements.users.value.split("\n");
      users.forEach(function (user) {
        _superagent2.default.post("/").send({ type: "addPerson", tenant: { id: _this2.props.tenant.id }, person: { id: _uuid2.default.v4(), email: user } }).then(function (response) {
          console.log("Added person");
          _this2.setState({ users: _this2.state.users.concat({ email: user.email }) });
        }).catch(function (error) {
          console.log("[ERROR] Not able to add person " + user.email + ", got", error);
          alert("An error occured");
        });
      });
      console.log("Add users: " + JSON.stringify(users));
    }
  }, {
    key: 'render',
    value: function render() {
      return this.state.details ? this.props.tenant.sso !== undefined ? _react2.default.createElement(
        'div',
        { style: { paddingTop: 10, paddingBottom: 20 } },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'b',
            null,
            'Training domain is configured'
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { paddingLeft: 20 } },
          'Domain:',
          _react2.default.createElement(
            'i',
            null,
            _react2.default.createElement(
              'a',
              { href: "https://" + this.props.tenant.sso.domain + "/" },
              this.props.tenant.sso.domain
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "none", paddingTop: 10, maxWidth: 800 } },
          _react2.default.createElement(
            'form',
            { onSubmit: this.addUsers.bind(this) },
            _react2.default.createElement(_Field2.default, { name: 'users', title: 'New users', description: 'Enter email address to new users, one line per user', height: '3' }),
            _react2.default.createElement('input', { className: 'save', type: 'submit', value: 'Add users' })
          )
        ),
        this.state.users !== undefined ? _react2.default.createElement(
          'div',
          { style: { paddingTop: 10 } },
          _react2.default.createElement(
            'b',
            null,
            'Access granted to:'
          ),
          _react2.default.createElement(
            'ul',
            { style: { paddingLeft: 10 } },
            this.state.users.map(function (item) {
              return _react2.default.createElement(
                'li',
                { key: item.email },
                item.email
              );
            })
          )
        ) : _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'i',
            null,
            'No users are granted access (yet)'
          )
        )
      ) : _react2.default.createElement(
        'div',
        null,
        JSON.stringify(this.props.tenant),
        _react2.default.createElement(
          'h3',
          null,
          'Training domain'
        ),
        _react2.default.createElement(
          'form',
          { action: '/training/domain', method: 'POST' },
          _react2.default.createElement('input', { type: 'hidden', name: 'tenant', value: this.props.tenant.id }),
          _react2.default.createElement(
            'div',
            { style: { paddingBottom: 10 } },
            _react2.default.createElement(
              'b',
              null,
              'Domain'
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement('input', { size: '30', name: 'domain', placeholder: 'yourdomain', autoComplete: 'off', style: { textAlign: "right" } }),
            '.progreto.com',
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'i',
              null,
              'Domain is the address users in your organization shall use to access your training account.'
            )
          ),
          _react2.default.createElement('input', { type: 'button', onClick: this.toggle.bind(this), value: 'Cancel' }),
          ' ',
          _react2.default.createElement('input', { type: 'submit', value: 'Configure Domain' })
        )
      ) : _react2.default.createElement(
        'div',
        { style: { paddingTop: 10 } },
        _react2.default.createElement(
          'a',
          { href: '#', onClick: this.toggle.bind(this) },
          'Configure Training Domain'
        )
      );
    }
  }]);

  return TrainingConfiguration;
}(_react2.default.Component);

exports.default = TrainingConfiguration;

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _uuid = __webpack_require__(26);

var _uuid2 = _interopRequireDefault(_uuid);

var _superagent = __webpack_require__(23);

var _superagent2 = _interopRequireDefault(_superagent);

var _Field = __webpack_require__(36);

var _Field2 = _interopRequireDefault(_Field);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function isUpdatedPhase(item, existing) {
  return JSON.stringify(item) !== JSON.stringify(existing);
}

var ProjectTypeLifecyclePhases = function (_React$Component) {
  _inherits(ProjectTypeLifecyclePhases, _React$Component);

  function ProjectTypeLifecyclePhases(props) {
    _classCallCheck(this, ProjectTypeLifecyclePhases);

    var _this = _possibleConstructorReturn(this, (ProjectTypeLifecyclePhases.__proto__ || Object.getPrototypeOf(ProjectTypeLifecyclePhases)).call(this, props));

    _this.state = { phases: props.projectType.phases !== undefined ? props.projectType.phases : [] };
    return _this;
  }

  _createClass(ProjectTypeLifecyclePhases, [{
    key: 'sendCommand',
    value: function sendCommand(command) {
      return new Promise(function (resolve, reject) {
        _superagent2.default.post("/").send(command).then(function (response) {
          resolve(response);
        }).catch(function (error) {
          reject(error);
        });
      });
    }
  }, {
    key: 'updateLifecycle',
    value: function updateLifecycle(event) {
      var _this2 = this;

      if (event.details !== undefined && event.details.action === "prioritize") {
        console.log("[WARN] Change of sequence is not supported.");
        alert("Operation not supported, yet.");
        this.setState({ phases: this.state.phases });
      } else {
        var newItems = event.target.value.filter(function (item) {
          return item.id === undefined;
        });
        console.log("Items: " + JSON.stringify(event.target.value));
        console.log("  new: " + JSON.stringify(newItems));
        if (newItems.length > 0) {
          var newItemsWithId = newItems.map(function (item) {
            return {
              id: _uuid2.default.v4(),
              text: item.text,
              description: item.description,
              link: item.link
            };
          });
          this.sendCommand({
            type: "addLifecyclePhase",
            phases: newItemsWithId,
            projectType: { id: this.props.projectType.id }
          }).then(function (response) {
            var updatedPhases = JSON.parse(response.text).phases;
            console.log("Updated lifecycles phase: " + JSON.stringify(updatedPhases));
            _this2.setState({ phases: updatedPhases });
          }).catch(function (error) {
            console.log("ERROR: " + (error.response !== undefined ? error.response.text : ""), error);
            alert("An error occured, please try again");
            _this2.setState({ phases: _this2.state.phases });
          });
        } else {
          var updates = event.target.value.filter(function (item) {
            return isUpdatedPhase(item, _this2.state.phases.filter(function (existing) {
              return existing.id === item.id;
            })[0]);
          });
          this.sendCommand({
            type: "updateLifecyclePhase",
            phases: updates,
            projectType: { id: this.props.projectType.id }
          }).then(function (response) {
            var updatedPhases = JSON.parse(response.text).phases;
            console.log("Updated lifecycles phase: " + JSON.stringify(updatedPhases));
            _this2.setState({ phases: updatedPhases });
          }).catch(function (error) {
            console.log("ERROR: " + (error.response !== undefined ? error.response.text : ""), error);
            alert("An error occured, please try again");
            _this2.setState({ phases: _this2.state.phases });
          });
          //        this.setState({phases:this.state.phases});
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var projectType = this.props.projectType;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Field2.default, {
          key: "lifecycle_" + projectType.id,
          language: this.props.language,
          type: 'table',
          value: this.state.phases,
          title: "Lifecycle for \"" + projectType.name + "\"",
          columns: [{ name: "text", title: "Phase", editable: true, dragable: true }, { name: "description", title: "Description", editable: true }, { name: "link", title: "Link to more documentation", editable: true }],
          includeEmptyLine: true,
          samples: [{ text: "Project", description: "What are the expected outputs of this phase?", link: "At which link can more information be found?" }],
          onChange: this.updateLifecycle.bind(this)
        })
      );
    }
  }]);

  return ProjectTypeLifecyclePhases;
}(_react2.default.Component);

var LifecycleManagement = function (_React$Component2) {
  _inherits(LifecycleManagement, _React$Component2);

  function LifecycleManagement() {
    _classCallCheck(this, LifecycleManagement);

    return _possibleConstructorReturn(this, (LifecycleManagement.__proto__ || Object.getPrototypeOf(LifecycleManagement)).apply(this, arguments));
  }

  _createClass(LifecycleManagement, [{
    key: 'render',
    value: function render() {
      var _this4 = this;

      if (this.props.user !== undefined && this.props.tenant.owner.id === this.props.user.id) {
        return _react2.default.createElement(
          'div',
          { style: { paddingTop: 10, paddingBottom: 20 } },
          _react2.default.createElement(
            'h3',
            null,
            'Lifecyle Management'
          ),
          _react2.default.createElement('br', null),
          'A lifecycle can be defined for every Project Type. A project life cycle is the predefined sequence of phases that a project goes through. ',
          _react2.default.createElement('br', null),
          'There can be one or multiple stages in a phase. ',
          _react2.default.createElement('br', null),
          ' ',
          _react2.default.createElement('br', null),
          this.props.tenant.projectTypes !== undefined && this.props.tenant.projectTypes.length > 0 ? this.props.tenant.projectTypes.map(function (projectType) {
            return _react2.default.createElement(ProjectTypeLifecyclePhases, _extends({
              key: projectType.id
            }, _this4.props, {
              projectType: projectType
            }));
          }) : "There are no Project Types for this project yet. You need to define project types in the 'Project' tab first, then you can define a lifecycle per type here"
        );
      } else {
        return null;
      }
    }
  }]);

  return LifecycleManagement;
}(_react2.default.Component);

exports.default = LifecycleManagement;

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TemplateOverview = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _superagent = __webpack_require__(23);

var _superagent2 = _interopRequireDefault(_superagent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//import templateHandler from '../../app/admin/formatTemplate.js';

var EmailHeader = function (_React$Component) {
  _inherits(EmailHeader, _React$Component);

  function EmailHeader() {
    _classCallCheck(this, EmailHeader);

    return _possibleConstructorReturn(this, (EmailHeader.__proto__ || Object.getPrototypeOf(EmailHeader)).apply(this, arguments));
  }

  _createClass(EmailHeader, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { display: "table", paddingBottom: 5 } },
        this.props.from !== undefined ? _react2.default.createElement(
          'div',
          { style: { display: "table-row" } },
          _react2.default.createElement(
            'b',
            { style: { display: "table-cell" } },
            'From:'
          ),
          _react2.default.createElement(
            'span',
            { style: { display: "table-cell" } },
            this.props.from
          )
        ) : null,
        _react2.default.createElement(
          'div',
          { style: { display: "table-row" } },
          _react2.default.createElement(
            'b',
            { style: { display: "table-cell" } },
            'To:'
          ),
          _react2.default.createElement(
            'span',
            { style: { display: "table-cell" } },
            this.props.to
          )
        ),
        this.props.cc !== undefined ? _react2.default.createElement(
          'div',
          { style: { display: "table-row" } },
          _react2.default.createElement(
            'b',
            { style: { display: "table-cell" } },
            'CC:'
          ),
          _react2.default.createElement(
            'span',
            { style: { display: "table-cell" } },
            this.props.cc
          )
        ) : null,
        _react2.default.createElement(
          'div',
          { style: { display: "table-row" } },
          _react2.default.createElement(
            'b',
            { style: { display: "table-cell" } },
            'Subject:'
          ),
          _react2.default.createElement(
            'span',
            { style: { display: "table-cell" } },
            this.props.subject
          )
        )
      );
    }
  }]);

  return EmailHeader;
}(_react2.default.Component);

var Property = function (_React$Component2) {
  _inherits(Property, _React$Component2);

  function Property(props) {
    _classCallCheck(this, Property);

    var _this2 = _possibleConstructorReturn(this, (Property.__proto__ || Object.getPrototypeOf(Property)).call(this, props));

    _this2.update = _this2.updateValue.bind(_this2);
    return _this2;
  }

  _createClass(Property, [{
    key: 'updateValue',
    value: function updateValue(event) {
      event.preventDefault();
      this.props.setParameter(this.props.name, event.target.value);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { display: "table-row" } },
        _react2.default.createElement(
          'b',
          { style: { display: "table-cell" } },
          this.props.label !== undefined ? this.props.label : this.props.name.slice(0, 1).toUpperCase() + this.props.name.slice(1),
          ':'
        ),
        _react2.default.createElement('input', { style: { display: "table-cell" }, size: '50', onChange: this.update, name: this.props.name, value: this.props.parameters !== undefined ? this.props.parameters[this.props.name] : "", placeholder: this.props.name })
      );
    }
  }]);

  return Property;
}(_react2.default.Component);

var TemplateContent = function (_React$Component3) {
  _inherits(TemplateContent, _React$Component3);

  function TemplateContent() {
    _classCallCheck(this, TemplateContent);

    return _possibleConstructorReturn(this, (TemplateContent.__proto__ || Object.getPrototypeOf(TemplateContent)).apply(this, arguments));
  }

  _createClass(TemplateContent, [{
    key: 'inline',
    value: function inline() {
      return { __html: this.props.body };
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', { dangerouslySetInnerHTML: this.inline() });
    }
  }]);

  return TemplateContent;
}(_react2.default.Component);

var ViewTemplate = function (_React$Component4) {
  _inherits(ViewTemplate, _React$Component4);

  function ViewTemplate(props) {
    _classCallCheck(this, ViewTemplate);

    var _this4 = _possibleConstructorReturn(this, (ViewTemplate.__proto__ || Object.getPrototypeOf(ViewTemplate)).call(this, props));

    var parameters = {};
    if (props.type === "email") {
      parameters.recipient = "";
    }
    props.parameters.forEach(function (key) {
      parameters[key] = props.parameterValues !== undefined && props.parameterValues[key] !== undefined ? props.parameterValues[key] : "";
    });
    _this4.state = { parameters: parameters, content: {} };
    _this4.setParameter = _this4.setParameterValue.bind(_this4);
    _this4.setParametersAsJSON = _this4.setJSONParameters.bind(_this4);
    return _this4;
  }

  _createClass(ViewTemplate, [{
    key: 'loadTemplate',
    value: function loadTemplate(id, parameters) {
      _superagent2.default.post("/admin/templates/" + id).send(parameters).then(function (response) {
        this.setState({ content: response.body });
      }.bind(this)).catch(function (error) {
        console.log("Error formatting template: " + JSON.stringify(error));
        console.log("Props: " + JSON.stringify(this.props));
        if (this.props.body !== undefined) {
          console.log("**Set content**: " + this.props.body);
          this.setState({ content: { body: this.props.body } });
        }
      }.bind(this));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.loadTemplate(this.props.id, this.state.parameters);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.loadTemplate(props.id, this.state.parameters);
    }
  }, {
    key: 'setParameterValue',
    value: function setParameterValue(key, value) {
      var newParameters = Object.assign({}, this.state.parameters, _defineProperty({}, key, value));
      this.setState({ parameters: newParameters });
      this.loadTemplate(this.props.id, newParameters);
    }
  }, {
    key: 'setJSONParameters',
    value: function setJSONParameters(event) {
      event.preventDefault();
      var parameters = {};
      var parameters = event.target.value.length > 0 ? JSON.parse(event.target.value) : {};
      this.setState({ parameters: parameters });
      this.loadTemplate(this.props.id, parameters);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      //    var content=templateHandler.formatTemplate(this.props.name,this.state.parameters);
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'b',
          null,
          this.props.title
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "flex" } },
          _react2.default.createElement(
            'div',
            { style: { display: "table" } },
            this.props.type === "email" ? _react2.default.createElement(Property, { parameters: this.state.parameters, setParameter: this.setParameter, label: 'To', name: 'recipient' }) : null,
            this.props.parameters.map(function (parameter) {
              return _react2.default.createElement(Property, { key: parameter, parameters: _this5.state.parameters, name: parameter, setParameter: _this5.setParameter });
            })
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingLeft: 20, flexGrow: 2 } },
            _react2.default.createElement('textarea', { style: { width: "100%", height: "100%" }, onChange: this.setParametersAsJSON, value: JSON.stringify(this.state.parameters) })
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { backgroundColor: "#ffffff", border: "solid 1px grey", borderRadius: 5, padding: 15, marginTop: 10 } },
          this.props.type === "email" ? _react2.default.createElement(EmailHeader, this.state.content) : null,
          _react2.default.createElement(TemplateContent, this.state.content)
        )
      );
    }
  }]);

  return ViewTemplate;
}(_react2.default.Component);

var TemplateLink = function (_React$Component5) {
  _inherits(TemplateLink, _React$Component5);

  function TemplateLink(props) {
    _classCallCheck(this, TemplateLink);

    var _this6 = _possibleConstructorReturn(this, (TemplateLink.__proto__ || Object.getPrototypeOf(TemplateLink)).call(this, props));

    _this6.selectTemplate = _this6.select.bind(_this6);
    return _this6;
  }

  _createClass(TemplateLink, [{
    key: 'select',
    value: function select(event) {
      event.preventDefault();
      this.props.selectTemplate(this.props);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(
          'a',
          { href: '#', onClick: this.selectTemplate },
          this.props.title
        )
      );
    }
  }]);

  return TemplateLink;
}(_react2.default.Component);

var TemplateOverview = exports.TemplateOverview = function (_React$Component6) {
  _inherits(TemplateOverview, _React$Component6);

  function TemplateOverview(props) {
    _classCallCheck(this, TemplateOverview);

    var _this7 = _possibleConstructorReturn(this, (TemplateOverview.__proto__ || Object.getPrototypeOf(TemplateOverview)).call(this, props));

    _this7.state = { display: undefined };
    _this7.selectTemplate = _this7.select.bind(_this7);
    return _this7;
  }

  _createClass(TemplateOverview, [{
    key: 'select',
    value: function select(template) {
      this.setState({ display: template });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      return _react2.default.createElement(
        'div',
        { style: { padding: 10 } },
        _react2.default.createElement(
          'h1',
          null,
          'Templates'
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "flex", justifyContent: "flex-start" } },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'ul',
              null,
              this.props.templates.map(function (template) {
                return _react2.default.createElement(TemplateLink, _extends({ key: template.title }, template, { selectTemplate: _this8.selectTemplate }));
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { flexGrow: 4, paddingLeft: 20 } },
            this.state.display !== undefined ? _react2.default.createElement(ViewTemplate, this.state.display) : null
          )
        )
      );
    }
  }]);

  return TemplateOverview;
}(_react2.default.Component);

var TemplateOverviewPage = function (_React$Component7) {
  _inherits(TemplateOverviewPage, _React$Component7);

  function TemplateOverviewPage() {
    _classCallCheck(this, TemplateOverviewPage);

    return _possibleConstructorReturn(this, (TemplateOverviewPage.__proto__ || Object.getPrototypeOf(TemplateOverviewPage)).apply(this, arguments));
  }

  _createClass(TemplateOverviewPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Layout2.default,
        this.props,
        _react2.default.createElement(TemplateOverview, this.props)
      );
    }
  }]);

  return TemplateOverviewPage;
}(_react2.default.Component);

exports.default = TemplateOverviewPage;

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgrammeProperties = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _ProjectMenu = __webpack_require__(17);

var _ProjectMenu2 = _interopRequireDefault(_ProjectMenu);

var _NewProject = __webpack_require__(176);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProgrammeProperties = exports.ProgrammeProperties = function (_React$Component) {
  _inherits(ProgrammeProperties, _React$Component);

  function ProgrammeProperties() {
    _classCallCheck(this, ProgrammeProperties);

    return _possibleConstructorReturn(this, (ProgrammeProperties.__proto__ || Object.getPrototypeOf(ProgrammeProperties)).apply(this, arguments));
  }

  _createClass(ProgrammeProperties, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { textAlign: "center", display: "flex", justifyContent: "center" } },
          _react2.default.createElement(
            'div',
            { style: { width: 1016 } },
            _react2.default.createElement(_NewProject.RegisterProgramme, _extends({}, this.props, { project: this.props.programme }))
          )
        )
      );
    }
  }]);

  return ProgrammeProperties;
}(_react2.default.Component);

var ProgrammePropertiesPage = function (_React$Component2) {
  _inherits(ProgrammePropertiesPage, _React$Component2);

  function ProgrammePropertiesPage() {
    _classCallCheck(this, ProgrammePropertiesPage);

    return _possibleConstructorReturn(this, (ProgrammePropertiesPage.__proto__ || Object.getPrototypeOf(ProgrammePropertiesPage)).apply(this, arguments));
  }

  _createClass(ProgrammePropertiesPage, [{
    key: 'render',
    value: function render() {
      var menu = this.props.showMenu === true ? _react2.default.createElement(_ProjectMenu2.default, _extends({}, this.props, { project: this.props.programme })) : undefined;
      return _react2.default.createElement(
        _Layout2.default,
        _extends({}, this.props, { projectMenu: menu, project: this.props.programme }),
        _react2.default.createElement(ProgrammeProperties, this.props)
      );
    }
  }]);

  return ProgrammePropertiesPage;
}(_react2.default.Component);

exports.default = ProgrammePropertiesPage;

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductProperties = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _ProjectMenu = __webpack_require__(17);

var _ProjectMenu2 = _interopRequireDefault(_ProjectMenu);

var _NewProject = __webpack_require__(176);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProductProperties = exports.ProductProperties = function (_React$Component) {
  _inherits(ProductProperties, _React$Component);

  function ProductProperties() {
    _classCallCheck(this, ProductProperties);

    return _possibleConstructorReturn(this, (ProductProperties.__proto__ || Object.getPrototypeOf(ProductProperties)).apply(this, arguments));
  }

  _createClass(ProductProperties, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { textAlign: "center", display: "flex", justifyContent: "center" } },
          _react2.default.createElement(
            'div',
            { style: { width: 1016 } },
            _react2.default.createElement(_NewProject.RegisterProduct, _extends({}, this.props, { project: this.props.product }))
          )
        )
      );
    }
  }]);

  return ProductProperties;
}(_react2.default.Component);

var ProgrammePropertiesPage = function (_React$Component2) {
  _inherits(ProgrammePropertiesPage, _React$Component2);

  function ProgrammePropertiesPage() {
    _classCallCheck(this, ProgrammePropertiesPage);

    return _possibleConstructorReturn(this, (ProgrammePropertiesPage.__proto__ || Object.getPrototypeOf(ProgrammePropertiesPage)).apply(this, arguments));
  }

  _createClass(ProgrammePropertiesPage, [{
    key: 'render',
    value: function render() {
      var menu = this.props.showMenu === true ? _react2.default.createElement(_ProjectMenu2.default, _extends({}, this.props, { project: this.props.product })) : undefined;
      return _react2.default.createElement(
        _Layout2.default,
        _extends({}, this.props, { projectMenu: menu, project: this.props.product }),
        _react2.default.createElement(ProductProperties, this.props)
      );
    }
  }]);

  return ProgrammePropertiesPage;
}(_react2.default.Component);

exports.default = ProgrammePropertiesPage;

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReleaseProperties = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _ProjectMenu = __webpack_require__(17);

var _ProjectMenu2 = _interopRequireDefault(_ProjectMenu);

var _NewProject = __webpack_require__(176);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReleaseProperties = exports.ReleaseProperties = function (_React$Component) {
  _inherits(ReleaseProperties, _React$Component);

  function ReleaseProperties() {
    _classCallCheck(this, ReleaseProperties);

    return _possibleConstructorReturn(this, (ReleaseProperties.__proto__ || Object.getPrototypeOf(ReleaseProperties)).apply(this, arguments));
  }

  _createClass(ReleaseProperties, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { textAlign: "center", display: "flex", justifyContent: "center" } },
          _react2.default.createElement(
            'div',
            { style: { width: 1016 } },
            _react2.default.createElement(_NewProject.RegisterRelease, _extends({}, this.props, { project: this.props.release }))
          )
        )
      );
    }
  }]);

  return ReleaseProperties;
}(_react2.default.Component);

var ReleasePropertiesPage = function (_React$Component2) {
  _inherits(ReleasePropertiesPage, _React$Component2);

  function ReleasePropertiesPage() {
    _classCallCheck(this, ReleasePropertiesPage);

    return _possibleConstructorReturn(this, (ReleasePropertiesPage.__proto__ || Object.getPrototypeOf(ReleasePropertiesPage)).apply(this, arguments));
  }

  _createClass(ReleasePropertiesPage, [{
    key: 'render',
    value: function render() {
      var menu = this.props.showMenu === true ? _react2.default.createElement(_ProjectMenu2.default, _extends({}, this.props, { project: this.props.release })) : undefined;
      return _react2.default.createElement(
        _Layout2.default,
        _extends({}, this.props, { projectMenu: menu, project: this.props.release }),
        _react2.default.createElement(ReleaseProperties, this.props)
      );
    }
  }]);

  return ReleasePropertiesPage;
}(_react2.default.Component);

exports.default = ReleasePropertiesPage;

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductDetails = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _ProjectMenu = __webpack_require__(17);

var _ProjectMenu2 = _interopRequireDefault(_ProjectMenu);

var _FormattedContent = __webpack_require__(15);

var _FormattedContent2 = _interopRequireDefault(_FormattedContent);

var _ProjectDetails = __webpack_require__(260);

var _Portfolio = __webpack_require__(175);

var _Portfolio2 = _interopRequireDefault(_Portfolio);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(430), __webpack_require__(431)]);

function hasValue(value) {
  return value !== undefined && value !== null && value.trim().length > 0;
}

var ProductDefinition = function (_React$Component) {
  _inherits(ProductDefinition, _React$Component);

  function ProductDefinition() {
    _classCallCheck(this, ProductDefinition);

    return _possibleConstructorReturn(this, (ProductDefinition.__proto__ || Object.getPrototypeOf(ProductDefinition)).apply(this, arguments));
  }

  _createClass(ProductDefinition, [{
    key: 'render',
    value: function render() {
      var product = this.props.product;
      var labels = translations.getTranslation(this.props).product.fields;
      return hasValue(product.vision) || hasValue(product.description) || hasValue(product.background) ? _react2.default.createElement(
        'div',
        { style: { paddingTop: 20 } },
        _react2.default.createElement(
          'h2',
          null,
          product.name
        ),
        hasValue(product.vision) ? _react2.default.createElement(
          'div',
          { style: { fontStyle: "italic", paddingBottom: 10 } },
          _react2.default.createElement(_FormattedContent2.default, { value: product.vision })
        ) : null,
        hasValue(product.description) ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_FormattedContent2.default, { value: product.description })
        ) : null,
        hasValue(product.background) ? _react2.default.createElement(
          'div',
          { style: { paddingTop: 10 } },
          _react2.default.createElement(
            'b',
            null,
            labels.background.title
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_FormattedContent2.default, { value: product.background })
          )
        ) : null
      ) : null;
    }
  }]);

  return ProductDefinition;
}(_react2.default.Component);

function assignPriority(item) {
  return item.status !== "Closed" ? Object.assign({}, item, { row: parseInt(item.priority), column: parseInt(item.severity) }) : Object.assign({}, item, { row: undefined, column: undefined });
}

var ProductDetails = exports.ProductDetails = function (_React$Component2) {
  _inherits(ProductDetails, _React$Component2);

  function ProductDetails() {
    _classCallCheck(this, ProductDetails);

    return _possibleConstructorReturn(this, (ProductDetails.__proto__ || Object.getPrototypeOf(ProductDetails)).apply(this, arguments));
  }

  _createClass(ProductDetails, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var access = {
        isBusinessCaseEnabled: function isBusinessCaseEnabled() {
          return false;
        }, //this.isBusinessCaseEnabled.bind(this),
        isQualityEnabled: function isQualityEnabled() {
          return false;
        }, //this.isQualityEnabled.bind(this),
        isDefinitionEnabled: function isDefinitionEnabled() {
          return true;
        }, //this.isDefinitionEnabled.bind(this),
        isProjectBriefEnabled: function isProjectBriefEnabled() {
          return false;
        },
        isPIDEnabled: function isPIDEnabled() {
          return false;
        }
      };

      var portfolio = this.props.portfolio !== undefined ? this.props.portfolio : this.props.product !== undefined && this.props.product.portfolio !== undefined && this.props.tenant.portfolios !== undefined ? this.props.tenant.portfolios.filter(function (portfolio) {
        return portfolio.id === _this3.props.product.portfolio;
      })[0] : undefined;

      return _react2.default.createElement(
        'div',
        { style: { marginTop: 40, marginLeft: 30, fontFamily: "Lato" } },
        this.props.product.isStopped ? _react2.default.createElement(
          'span',
          { style: { color: "red", paddingRight: 20 } },
          'STOPPED'
        ) : null,
        this.props.product.isPaused ? _react2.default.createElement(
          'span',
          { style: { color: "red", paddingRight: 20 } },
          'paused'
        ) : null,
        _react2.default.createElement(
          'div',
          { style: { display: "flex", flexWrap: "wrap", justifyContent: "flex-start" } },
          _react2.default.createElement(
            'div',
            { style: { maxWidth: 1016 } },
            _react2.default.createElement(
              'div',
              { style: { fontWeight: "bold", fontSize: 14 } },
              portfolio !== undefined ? portfolio.name : null
            ),
            _react2.default.createElement(
              'div',
              { style: { fontSize: 30, marginBottom: 30, width: "100%", fontWeight: "bold", float: "left" } },
              this.props.product.name
            ),
            _react2.default.createElement(
              'div',
              { style: { display: "inline-block" } },
              _react2.default.createElement(
                'div',
                { style: { padding: 0, marginBottom: 10, display: "flex", justifyContent: "space-between", flexWrap: "wrap" } },
                _react2.default.createElement(_ProjectDetails.StatusSummary, _extends({}, this.props.product, this.props)),
                _react2.default.createElement(_ProjectDetails.KeyInfo, _extends({}, this.props.product, this.props))
              ),
              _react2.default.createElement(
                'div',
                { style: { display: "flex", flexWrap: "wrap", justifyContent: "flex-start" } },
                _react2.default.createElement(
                  'div',
                  { style: { maxWidth: 1016 } },
                  _react2.default.createElement(_ProjectDetails.Themes, _extends({}, this.props, {
                    style: 'small',
                    project: this.props.product,
                    access: access
                  })),
                  this.props.releases !== undefined && (this.props.releases.length > 0 || this.props.historicReleases !== undefined && this.props.historicReleases.length > 0) ? _react2.default.createElement(
                    'div',
                    { style: { minWidth: 1016 } },
                    _react2.default.createElement(_Portfolio2.default, _extends({}, this.props, {
                      tenant: undefined,
                      design: this.props.tenant.design,
                      projects: this.props.releases,
                      historicProjects: this.props.historicReleases,
                      projectTypes: this.props.tenant.projectTypes,
                      disablePriority: true
                    }))
                  ) : _react2.default.createElement('div', { style: { minWidth: 1016 } }),
                  _react2.default.createElement(ProductDefinition, this.props)
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { marginLeft: "auto" } },
            _react2.default.createElement(_ProjectDetails.Links, _extends({}, this.props, this.props.product, {
              standardLinks: this.props.tenant.standardLinks,
              mode: this.props.linkMode,
              edit: this.props.edit,
              add: this.props.add,
              briefEnabled: false,
              pidEnabled: false
            }))
          )
        )
      );
    }
  }]);

  return ProductDetails;
}(_react2.default.Component);

var ProductDetailsPage = function (_React$Component3) {
  _inherits(ProductDetailsPage, _React$Component3);

  function ProductDetailsPage() {
    _classCallCheck(this, ProductDetailsPage);

    return _possibleConstructorReturn(this, (ProductDetailsPage.__proto__ || Object.getPrototypeOf(ProductDetailsPage)).apply(this, arguments));
  }

  _createClass(ProductDetailsPage, [{
    key: 'render',
    value: function render() {
      var menu = this.props.showMenu === true ? _react2.default.createElement(_ProjectMenu2.default, _extends({}, this.props, {
        project: this.props.product
      })) : undefined;
      return _react2.default.createElement(
        _Layout2.default,
        _extends({}, this.props, { project: this.props.product, projectMenu: menu }),
        _react2.default.createElement(ProductDetails, this.props)
      );
    }
  }]);

  return ProductDetailsPage;
}(_react2.default.Component);

exports.default = ProductDetailsPage;

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getProjectDefinition;
function getProjectDefinition(project) {
  return {
    background: {
      initiated: project.background,
      timing: project.timing,
      bigPicture: project.bigPicture
    },
    objective: {
      benefits: project.benefitsDescription,
      summary: project.objectivesSummary,
      comments: project.objectives
    },
    scope: {
      items: project.projectScope,
      exclusions: project.scopeExclusions
    },
    outcomes: project.outcomes,
    constraints: project.constraints,
    assumptions: project.assumptions,
    stakeholders: project.stakeholderDescription,
    interfaces: project.interfaces
  };
}

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var english = exports.english = {
  general: {
    executive: "Executive",
    sro: "SRO",
    projectManager: "PM",
    programmeManager: "PM",
    risks: "Risks",
    issues: "Issues"
  },
  reports: {
    heading: "Generated reports",
    highlightReport: "Latest Highlight Report",
    endProjectReport: "End Project Report",
    brief: "Project Brief",
    pid: "Project Initiation Document"
  },
  link: {
    heading: "Links",
    edit: {
      textPlaceholder: "Display text",
      addressPlaceholder: "Address"
    },
    save: "OK",
    cancel: "Cancel",
    exitEdit: "Exit edit mode",
    add: "Add link",
    goToProduct: "Go to product"
  },
  status: {
    summaryStatus: "Summary Status",
    portfolio: "Portfolio",
    numberOfProjects: "# Activities",
    priority: "Priority",
    name: "Name",
    status: "Status",
    stage: "Part",
    benefits: "Benefits",
    time: "Time",
    cost: "Cost",
    quality: "Quality",
    scope: "Scope",
    risk: "Risk"
  },
  keyInformation: {
    keyInformation: "Key Information",
    identifier: "Identifier",
    projectStage: "Stage"
  },
  themes: {
    background: {
      title: "Background"
    },
    definition: {
      title: "Definition"
    },
    businessCase: {
      title: "Business Case"
    },
    quality: {
      title: "Quality"
    },
    organization: {
      title: "Organization"
    },
    risk: {
      title: "Risk"
    },
    plan: {
      title: "Plans"
    },
    change: {
      title: "Change"
    },
    progress: {
      title: "Progress"
    }
  },
  startupProcess: {
    title: "Recommended activities when starting up a project:",
    help: "Click on an activity below to execute it. Each activity will populate a part of the Project Brief. You do not have to complete all activities to\n      move on and have the Project Brief Approved, but you should make sure there is sufficient information to ensure the project is viable and\n      worthwhile.",
    activities: {
      appointExecutiveAndPM: {
        title: "Appoint Executive and PM",
        help: "Select a decision maker, the Executive, with appropriate authority to chair the Project Board, and name the Project Manager for this project. All projects must have an Executive from the very beginning. The Executive is the ultimately responsible for the project."
      },
      captureLessons: {
        title: "Capture previous lessons",
        help: "Review lessons from previous projects to identify lessons that can be applied to this project. Consult with people with previous experience of similar projects and record relevant lessons identified."
      },
      appointManagementTeam: {
        title: "Appoint project management team",
        help: "Assign people to each of the roles in the Project Board, assurance roles, support roles and Team Manager roles. The project management team needs to reflect the interests of all parties who will be involved, including business, user and supplier interests. It is vital to have the right people in the appropriate roles and ensure responsibilities are well understood."
      },
      prepareOutlineBusinessCase: {
        title: "Prepare Outline Business Case",
        help: "Executive should draft the outline business case stating why the project is worth doing. The outline business case is likely to be a high-level view at this time. A more extensive business case must be developed in the initiating a project process."
      },
      defineProject: {
        title: "Define the project",
        help: "In dialogue with key stakeholders, identify and confirm project objectives, scope, constraints, assumptions, stakeholders and interfaces."
      },
      describeProjectProduct: {
        title: "Describe Project Product",
        help: "Project Manager should consult with the Senior User, Senior Supplier and Executive to define what the project is to deliver. For each scope statement, what are the deliverables handed over to the line organization when the project is done? Think wide to capture all main deliverables, not deep to capture many requirements. Revise and adjust scope (\"Define the project\") if necessary to make the structure work."
      },
      selectApproach: {
        title: "Select Approach",
        help: "Document decisions made regarding how the work of the project is going to be approached. Discuss with Senior Supplier where appropriate resources will come from, if specific working methods or frameworks will apply and if specific technologies will be used."
      },
      planInitiation: {
        title: "Plan Initiation Stage",
        help: "Create a stage plan for \"planning the project\". Add a stage representing the work needed to understand and document the project ground rules and the project plan. This is usually the first stage in the project and is covering the Initiating a Project process."
      },
      assembleBrief: {
        title: "Create a Brief draft for review",
        help: "When sufficient information is gathered to approve the project and to clearly understand the boundaries for the planning of the project, a draft Project Brief should be created and presented to the Project Board for approval. The Initiation Stage Plan should also be presented and approved by the Project Board."
      }
    },
    nextStep: {
      title: "Approve Project Brief"
    }
  },
  initiationProcess: {
    title: "Recommended activities when initiating a project:",
    help: "Click on an activity below to execute it. Each activity will populate a part of the Project Initiation Document. You do not have to complete\nall activities to move on and have the Project Initiation Document approved, but you should make sure there is sufficient information to\nensure a solid foundation for execution of the project.",
    activities: {
      prepareRiskManagementApproach: {
        title: "Prepare risk management approach",
        help: "The risk management approach describes how risk will be managed and what level of risk is acceptable. What will we do to make sure the level of uncertainty is managed?"
      },
      prepareQualityManagementApproach: {
        title: "Prepare quality management approach",
        help: "The quality management approach describes how to manage quality, including requirement management. What will we do to make sure the projects' products are \"fit for purpose\"?"
      },
      prepareConfigurationManagementApproach: {
        title: "Prepare change control approach",
        help: "The change control approach describes how changes and issues arising will be managed. What will we do to make sure we have sufficient control of changes?"
      },
      prepareCommunicationManagementApproach: {
        title: "Prepare communication management approach",
        help: "The communication management approach describes how information will be shared in the project team and how the project team will send information to, and receive information from, project stakeholders"
      },
      setupProjectControls: {
        title: "Set up project controls",
        help: "Project Control defines how the Project Board will maintain enough control of the project and how the Project Manager will maintain sufficient control of work managed by the Team Managers."
      },
      createProjectPlan: {
        title: "Create project plan",
        help: "Build a high level plan broken into management stages. For each stage, define what will be delivered, how much time is needed and what the estimated cost is. Make sure you understand the Project Board's expectation to needed detail level and predictability, and don't waste time going into more details than necessary."
      },
      refineBusinessCase: {
        title: "Refine business case",
        help: "Executive should provide the business case stating why the project is worth doing"
      },
      defineProject: {
        title: "Revise Project Definition",
        help: "In dialogue with key stakeholders, update and confirm project objectives, scope, constraints, assumptions, stakeholders and interfaces."
      },
      describeProjectProduct: {
        title: "Revise Project Product Description",
        help: "Project Manager should consult with the Senior User, Senior Supplier and Executive to update what the project is to deliver. For each scope statement, what are the deliverables handed over to the line organization when the project is done? Think wide to capture all main deliverables, not deep to capture many requirements. Revise and adjust scope (\"Define the project\") if necessary to make the structure work."
      },
      selectApproach: {
        title: "Revise Project Approach",
        help: "Update decisions made regarding how the work of the project is going to be approached. Discuss with Senior Supplier where appropriate resources will come from, if specific working methods or frameworks will apply and if specific technologies will be used."
      },
      assemblePID: {
        title: "Create a PID draft for review",
        help: "When sufficient information is gathered and sufficient planning done to start executing the project, a draft Project Initiation Document (PID) should be created and presented to the Project Board for approval. The Stage Plan for the next stage should also be presented and approved by the Project Board."
      }
    },
    nextStep: {
      title: "Approve Project Initiation Document"
    }
  },
  closeProcess: {
    title: "Recommended activities before closing a project:",
    help: "Before closure of the project can be recommended, the project manager should update the PID and Project Plan, update lessons learned,\nclose open issues and risks, and prepare an end project report. Make sure to inform all stakeholders.",
    activities: {
      acceptProducts: {
        title: "Accept products"
      },
      createLessons: {
        title: "Create Lessons",
        help: "Work together with the Project Management Team to identify and document lessons that could be applied to future projects."
      },
      createEndProjectReport: {
        title: "Create End Project Report",
        help: "Assess how successful the project has been and summarize the conclusions in the End Project Report."
      },
      closeRiskRegister: {
        title: "Close Risk Register",
        help: "Close all open risks. Before a risk is closed, evaluate if it should be transferred to a different risk register, for example at a program or a product level"
      },
      closeIssueRegister: {
        title: "Close Issue Register",
        help: "Close all open issues. Before an issue is closed, evaluate if it should be transferred to a different issue register, for example at a program or a product level"
      },
      recommendClosure: {
        title: "Recommend Closure",
        help: "When all closing activities are completed, a closure recommendation should be raised to the board."
      }
    },
    nextStep: {
      title: "Approve Closure"
    },
    cancel: {
      title: "Abort Closure"
    }
  },
  clone: {
    noName: "Clone of"
  }
};

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var norwegian = exports.norwegian = {
  general: {
    executive: "Eier",
    sro: "Eier",
    projectManager: "Prosjektleder",
    programmeManager: "Programleder",
    risks: "Riski",
    issues: "Saker"
  },
  reports: {
    heading: "Genererte rapporter",
    highlightReport: "Siste statusrapport",
    endProjectReport: "Sluttrapport",
    brief: "Prosjektforslag",
    pid: "Styringsdokument"
  },
  link: {
    heading: "Lenker",
    edit: {
      textPlaceholder: "Visningstekst",
      addressPlaceholder: "Adresse"
    },
    save: "OK",
    cancel: "Avbryt",
    exitEdit: "Avslutt editering",
    add: "Legg til lenke",
    goToProduct: "Gå til produkt"
  },
  keyInformation: {
    keyInformation: "Nøkkelinformasjon",
    identifier: "Identifikator",
    projectStage: "Etappe"
  },

  status: {
    summaryStatus: "Oppsummert status",
    portfolio: "Portefølje",
    numberOfProjects: "# Aktiviteter",
    priority: "Prioritet",
    name: "Navn",
    status: "Status",
    stage: "Del",
    benefits: "Gevinst",
    time: "Tid",
    cost: "Kostnad",
    quality: "Kvalitet",
    scope: "Omfang",
    risk: "Risiko"
  },
  themes: {
    background: {
      title: "Bakgrunn"
    },
    definition: {
      title: "Definisjon"
    },
    businessCase: {
      title: "Begrunnelse"
    },
    quality: {
      title: "Kvalitet"
    },
    organization: {
      title: "Organisation"
    },
    risk: {
      title: "Risiko"
    },
    plan: {
      title: "Planer"
    },
    change: {
      title: "Endring"
    },
    progress: {
      title: "Fremdrift"
    }
  },
  startupProcess: {
    title: "Anbefalte aktiviteter ved oppstart av prosjektet:",
    help: "Klikk p\xE5 en aktivitet under for \xE5 utf\xF8re den. Hver aktivitet vil fylle ut en del av prosjektetforslaget. Du trenger ikke \xE5 fullf\xF8re alle aktiviteter for\n      \xE5 g\xE5 videre og ha prosjektforslaget godkjent, men du b\xF8r s\xF8rge for at det er tilstrekkelig informasjon til \xE5 sikre at prosjektet er levedyktig og\n      l\xF8nnsomt.",
    activities: {
      appointExecutiveAndPM: {
        title: "Utnevne prosjekteier og prosjektleder",
        help: "Velg en beslutningstaker, prosjekteier, med riktig myndighet til \xE5 lede prosjektstyret, og angi prosjektleder for dette prosjektet. Alle prosjekter m\xE5 ha en eier fra begynnelsen. Prosjekteieren er den ansvarlig for prosjektet."
      },
      captureLessons: {
        title: "Fange opp erfaringer",
        help: "Gjennomg\xE5 erfaringer fra tidligere prosjekter for \xE5 identifisere erfaringer som kan brukes p\xE5 dette prosjektet. R\xE5df\xF8r deg med personer med erfaring fra tidligere eller lignende prosjekter og skriv inn de relevante erfaringer som er identifisert."
      },
      appointManagementTeam: {
        title: "Utforme og utnevne prosjektledelsen",
        help: "Identifiser ansvarlige for alle rollene i prosjektstyret, sikrings-rollene, st\xF8tte-rollene og teamlederrollene. Prosjektledelsen m\xE5 gjenspeile interessene som vil v\xE6re involvert, inkludert forretnings-, bruker- og leverand\xF8rinteresser. Det er viktig \xE5 ha de riktige personene i de aktuelle rollene og sikre at ansvar er godt forst\xE5tt."
      },
      prepareOutlineBusinessCase: {
        title: "Skissere begrunnelsen for prosjektet",
        help: "Prosjekteieren b\xF8r utarbeide begrunnelsen for prosjektet med hvorfor prosjektet er verdt \xE5 gjennomf\xF8re. Skissen vil p\xE5 dette tidspunktet i prosjektet v\xE6re overordnet og vil detaljeres ytterligere i neste etappe."
      },
      defineProject: {
        title: "Definere prosjektet",
        help: "Gjennom dialog med sentrale interessenter noterer du ned prosjektm\xE5l, omfang, begrensninger, forutsetninger, interessenter og grensesnitt for prosjektet."
      },
      describeProjectProduct: {
        title: "Beskrive prosjektets produkt",
        help: "Prosjektleder b\xF8r r\xE5df\xF8re seg med seniorbruker, seniorleverand\xF8r og prosjekteier for \xE5 definere hva prosjektet skal levere. For hvert omfangselement angis hva som skal overleveres til linjeorganisasjonen n\xE5r prosjektet er ferdig. Tenk bredt for \xE5 fange alle hovedleveransene, ikke dypt for \xE5 fange mange krav. Endre og juster omfanget (\"Definere prosjektet\") om n\xF8dvendig for \xE5 f\xE5 strukturen til \xE5 fungere."
      },
      selectApproach: {
        title: "Velge prosjekttilnærming",
        help: "Dokumenter avgj\xF8relser om hvordan arbeidet i prosjektet skal gj\xF8res. Avklar med seniorleverand\xF8r hvor hensiktsmessige ressurser kommer fra, om bestemte arbeidsmetoder skal benyttes, om gitt rammebetingelser vil gjelde og om spesifikke teknologier vil bli brukt."
      },
      planInitiation: {
        title: "Planlegge initieringsetappen",
        help: "Lag en etappeplan for \"planleggingen av prosjektet\". Legg til en etappe som representerer arbeidet som trengs for \xE5 forst\xE5 og dokumentere tiln\xE6rminger for prosjektet og overordnet plan. Dette er vanligvis den f\xF8rste etappen i prosjektet og dekker prosessen \"Initiering\"."
      },
      assembleBrief: {
        title: "Opprette utkast av prosjektforslaget til gjennomgang",
        help: "N\xE5r tilstrekkelig informasjon er samlet for \xE5 godkjenne prosjektet og for \xE5 forst\xE5 grensene for planlegging av prosjektet, b\xF8r det opprettes et utkast av prosjektforslaget som presenteres for prosjektstyret til godkjenning. Etappeplan for Initiering skal ogs\xE5 presenteres og godkjennes av prosjektstyret."
      }
    },
    nextStep: {
      title: "Godkjenne prosjektforslaget"
    }
  },
  initiationProcess: {
    title: "Anbefalte aktiviteter ved initiere et prosjekt:",
    help: "Klikk p\xE5 en aktivitet under for \xE5 utf\xF8re den. Hver aktivitet vil fylle ut en del av styringsdokumentet. Du trenger ikke \xE5 fullf\xF8re\nalle aktivitetene for \xE5 g\xE5 videre og f\xE5 godkjent styringsdokumentet, men du b\xF8r s\xF8rge for at det er tilstrekkelig informasjon til\n\xE5 sikre at prosjektet har et solid grunnlag for gjennomf\xF8ringen.",
    activities: {
      prepareRiskManagementApproach: {
        title: "Utforme tilnærming til risikoledelse",
        help: "Tilnærming for risikostyring beskriver hvordan risikoen skal styres og hvilket risikonivå som er akseptabelt. Hva skal vi gjøre for at graden av usikkerhet håndteres?"
      },
      prepareQualityManagementApproach: {
        title: "Utforme kvalitetstilnæming",
        help: "Tiln\xE6rming for kvalitetsh\xE5ndtering beskriver hvordan kvalitet sikres i prosjektet, inkludert styring av krav. Hva skal vi gj\xF8re for \xE5 sikre at prosjektets produkter er \"egnet til form\xE5let\"?"
      },
      prepareConfigurationManagementApproach: {
        title: "Utforme tilnærming til endringskontroll",
        help: "Tiln\xE6rming til endringskontroll beskriver hvordan endringer og problemer som oppst\xE5r vil bli administrert. Hva skal vi gj\xF8re for \xE5 sikre at vi har tilstrekkelig kontroll p\xE5 endringer?"
      },
      prepareCommunicationManagementApproach: {
        title: "Utforme tilnærming for kommunikasjon",
        help: "Tiln\xE6rming for kommunikasjon beskriver hvordan informasjon deles i prosjektgruppen og hvordan prosjektgruppen sender informasjon til og mottar informasjon fra prosjektinteressenter"
      },
      setupProjectControls: {
        title: "Sette opp prosjektkontroll",
        help: "Prosjektkontroll definerer hvordan prosjektstyret vil opprettholde nok kontroll over prosjektet og hvordan prosjektlederen skal opprettholde tilstrekkelig kontroll over arbeidet som forvaltes av teamledere."
      },
      createProjectPlan: {
        title: "Opprette prosjektplan",
        help: "Etabler en plan p\xE5 h\xF8yt plan som er brutt ned i etapper. For hver etappe definerer du hva som skal leveres, hvor mye tid du trenger og hva den ansl\xE5tte kostnaden er. S\xF8rg for at du forst\xE5r prosjektledelsens forventning om \xF8nsket detaljniv\xE5 og forutsigbarhet, og ikke kast bort tid p\xE5 \xE5 g\xE5 inn i flere detaljer enn n\xF8dvendig."
      },
      refineBusinessCase: {
        title: "Forfine prosjektbegrunnelsen",
        help: "Prosjekteier b\xF8r gi bergunnelsen for hvorfor prosjektet er verdt \xE5 gjennomf\xF8re"
      },
      defineProject: {
        title: "Se igjennom prosjektdefinisjonen",
        help: "Gjennom dialog med viktige interessenter oppdaterer og bekrefter du prosjektm\xE5l, omfang, begrensninger, forutsetninger, interessenter og grensesnitt."
      },
      describeProjectProduct: {
        title: "Revider beskrivelsen av prosjektets produkt",
        help: "Prosjektleder b\xF8r r\xE5df\xF8re seg med seniorbruker, seniorleverand\xF8r og prosjekteier for \xE5 oppdatere hva prosjektet skal levere. For hvert omfangselement angis hva som overleveres til linjeorganisasjonen n\xE5r prosjektet er ferdig. Tenk bredt for \xE5 fange alle hovedleveransene, ikke dypt for \xE5 fange mange krav. Endre og juster omfanget (\"Definer prosjektet\") om n\xF8dvendig for \xE5 f\xE5 strukturen til \xE5 fungere."
      },
      selectApproach: {
        title: "Gjennomgå prosjekttilnærmingen",
        help: "Oppdater avgj\xF8relser om hvordan arbeidet i prosjektet skal gj\xF8res. Avklar med seniorleverand\xF8r hvor hensiktsmessige ressurser kommer fra, om bestemte arbeidsmetoder skal benyttes, om gitt rammebetingelser vil gjelde og om spesifikke teknologier vil bli brukt."
      },
      assemblePID: {
        title: "Opprette utkast av styringsdokument til gjennomgang",
        help: "N\xE5r tilstrekkelig informasjon er samlet og tilstrekkelig planlegging er utf\xF8rt for \xE5 starte gjennomf\xF8ringen av prosjektet, b\xF8r det opprettes et utkast til styringsdokument (PID) som presenteres til prosjektstyret for godkjenning. Etappelanen for neste etappe skal ogs\xE5 presenteres og godkjennes av prosjektstyret."
      }
    },
    nextStep: {
      title: "Godkjenne styringsdokumentet"
    }
  },
  closeProcess: {
    title: "Anbefalte aktiviteter før prosjektet avsluttes:",
    help: "F\xF8r det anbefales at prosjektet avsluttes, b\xF8r prosjektleder oppdatere styringsdokumentet og prosjektplanen, oppdatere erfaringene,\nlukke \xE5pne saker og risiko, og utarbeide en sluttrapport. S\xF8rg ogs\xE5 for \xE5 informere alle interessentene.",
    activities: {
      acceptProducts: {
        title: "Aksepter produktene"
      },
      createLessons: {
        title: "Samle erfaringer",
        help: "Samarbeid prosjektledelsen for å identifisere og dokumentere erfaringer som kan brukes i fremtidige prosjekter."
      },
      createEndProjectReport: {
        title: "Opprett sluttrapport",
        help: "Vurder hvor vellykket prosjektet har vært og oppsummer konklusjonene i sluttprosjektrapporten."
      },
      closeRiskRegister: {
        title: "Lukk åpne risiki",
        help: "Lukk alle åpne risiki. Før en risiko lukkes, vurder om den skal overføres til et annet risikoregister, for eksempel på program eller produktnivå"
      },
      closeIssueRegister: {
        title: "Lukk åpne saker",
        help: "Lukk alle åpne saker. Før en sak avsluttes, vurder om den skal overføres til et annet saksregister, for eksempel på program eller produktnivå"
      },
      recommendClosure: {
        title: "Anbefal avslutning av prosjektet",
        help: "Når alle avsluttende aktiviteter er gjennomført, bør en innstilling om prosjektavslutning sendes til styringsgruppen."
      }
    },
    nextStep: {
      title: "Godkjenn avslutning av prosjektet"
    },
    cancel: {
      title: "Avbryt prosjektavslutning"
    }
  },
  clone: {
    noName: "Klone av"
  }
};

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var english_productDetails = exports.english_productDetails = {
  themes: {
    plan: {
      title: "Roadmap"
    }
  }
};

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var norwegian_productDetails = exports.norwegian_productDetails = {
  general: {
    projectManager: "Produktleder"
  },
  themes: {
    plan: {
      title: "Langtidsplan"
    }
  }
};

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var english_releaseDetails = exports.english_releaseDetails = {
  themes: {
    plan: {
      title: "Plan"
    }
  }
};

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var norwegian_releaseDetails = exports.norwegian_releaseDetails = {
  general: {
    projectManager: "Produktleder"
  },
  themes: {
    plan: {
      title: "Plan"
    }
  }
};

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewExtremeProject = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _superagent = __webpack_require__(23);

var _superagent2 = _interopRequireDefault(_superagent);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _Area = __webpack_require__(115);

var _Area2 = _interopRequireDefault(_Area);

var _Field = __webpack_require__(36);

var _Field2 = _interopRequireDefault(_Field);

var _AreaForm = __webpack_require__(28);

var _AreaForm2 = _interopRequireDefault(_AreaForm);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

var _formDefinition = __webpack_require__(1075);

var _formDefinition2 = _interopRequireDefault(_formDefinition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(1076), __webpack_require__(1077)]);

var GeneralInformation = function (_React$Component) {
  _inherits(GeneralInformation, _React$Component);

  function GeneralInformation() {
    _classCallCheck(this, GeneralInformation);

    return _possibleConstructorReturn(this, (GeneralInformation.__proto__ || Object.getPrototypeOf(GeneralInformation)).apply(this, arguments));
  }

  _createClass(GeneralInformation, [{
    key: 'render',
    value: function render() {
      var questions = ["Tell me about the project you have in mind."];
      return _react2.default.createElement(
        _Area2.default,
        { title: 'General Information' },
        _react2.default.createElement(_Field2.default, { title: 'Project Name', name: 'name', description: 'A descriptive name of the project',
          help: questions.join("\n") })
      );
    }
  }]);

  return GeneralInformation;
}(_react2.default.Component);

var BusinessObjective = function (_React$Component2) {
  _inherits(BusinessObjective, _React$Component2);

  function BusinessObjective() {
    _classCallCheck(this, BusinessObjective);

    return _possibleConstructorReturn(this, (BusinessObjective.__proto__ || Object.getPrototypeOf(BusinessObjective)).apply(this, arguments));
  }

  _createClass(BusinessObjective, [{
    key: 'render',
    value: function render() {
      var questions = ["What opportunity are we going after?", "What’s the business need that this project is intended to address?", "What is it that we are fixing, trying to improve, or solve?", "How will the project enable your organization to serve its customers better?"];

      return _react2.default.createElement(
        _Area2.default,
        { title: 'Business Objective' },
        _react2.default.createElement(_Field2.default, { name: 'background', title: 'Business Objective',
          height: '2', help: questions.join("\n"), description: 'The reason to run the project' })
      );
    }
  }]);

  return BusinessObjective;
}(_react2.default.Component);

var DeliverableQualityAndScope = function (_React$Component3) {
  _inherits(DeliverableQualityAndScope, _React$Component3);

  function DeliverableQualityAndScope() {
    _classCallCheck(this, DeliverableQualityAndScope);

    return _possibleConstructorReturn(this, (DeliverableQualityAndScope.__proto__ || Object.getPrototypeOf(DeliverableQualityAndScope)).apply(this, arguments));
  }

  _createClass(DeliverableQualityAndScope, [{
    key: 'render',
    value: function render() {
      var description = "These questions dvelve into the product or service that is to be produced: “If we had it in place right now [the process, system, the product, the new service …”";
      var questions = ["What would you see as its main functions or features?", "Is this intended to be a stop-gap measure: We’ll do it once, and if we replace it, will we start all over from scratch? Or are we trying to do something that we will attempt to fix and upgrade over time?", "What would be the absolute bare minimum functions?", "What would it physically look like?"];

      return _react2.default.createElement(
        _Area2.default,
        { title: 'Deliverables' },
        _react2.default.createElement(_Field2.default, { name: 'benefitsDescription', title: 'Project Deliverable Quality and Scope',
          height: '2', help: description + "\n\n" + questions.join("\n"), description: 'The qualities of deliverables and project scope' })
      );
    }
  }]);

  return DeliverableQualityAndScope;
}(_react2.default.Component);

var BusinessOutcome = function (_React$Component4) {
  _inherits(BusinessOutcome, _React$Component4);

  function BusinessOutcome() {
    _classCallCheck(this, BusinessOutcome);

    return _possibleConstructorReturn(this, (BusinessOutcome.__proto__ || Object.getPrototypeOf(BusinessOutcome)).apply(this, arguments));
  }

  _createClass(BusinessOutcome, [{
    key: 'render',
    value: function render() {
      var description = "These questions are aimed at identifying the value-added dollar-and-cents benefits that are being sought as a result of having produced the project deliverable. “Assuming we had completed the project and it was now up and running…”:";
      var questions = ["What s the most important payoff you are looking to achieve? Increased revenue? Better customer service? Greater marked share? Decreased cost of doing business? Short-term profits?", "How would you quantify the dolar payoff you are targeting? ROI? Reduced cost? Over what period of time?", "What will you want to see to know that the business benefits have been achieved?", "Under what conditions would we shut down the project?"];
      return _react2.default.createElement(
        _Area2.default,
        { title: 'Business Outcome' },
        _react2.default.createElement(_Field2.default, { name: 'outcomes', title: 'Business Outcome',
          height: '2', help: description + "\n\n" + questions.join("\n"), description: 'The expected result of the project' })
      );
    }
  }]);

  return BusinessOutcome;
}(_react2.default.Component);

var Context = function (_React$Component5) {
  _inherits(Context, _React$Component5);

  function Context() {
    _classCallCheck(this, Context);

    return _possibleConstructorReturn(this, (Context.__proto__ || Object.getPrototypeOf(Context)).apply(this, arguments));
  }

  _createClass(Context, [{
    key: 'render',
    value: function render() {
      var description = "These questions elict information about the business climate surrounding the project:";
      var questions = ["How does this project fit in with the origanization’s overall business strategy?", "Who’s driving this project from above?", "Who will you be going to for approvals and funding?", "What’s driving us to this now? What is we did nothing? Waited until next year?", "How does this fit into the overall priority of projects?", "If we have to let another project slip, what might that be?"];
      return _react2.default.createElement(
        _Area2.default,
        { title: 'Context' },
        _react2.default.createElement(_Field2.default, { name: 'bigPicture', title: 'Context',
          height: '2', help: description + "\n\n" + questions.join("\n"), description: 'In which context does the project exist' })
      );
    }
  }]);

  return Context;
}(_react2.default.Component);

var Stakeholders = function (_React$Component6) {
  _inherits(Stakeholders, _React$Component6);

  function Stakeholders() {
    _classCallCheck(this, Stakeholders);

    return _possibleConstructorReturn(this, (Stakeholders.__proto__ || Object.getPrototypeOf(Stakeholders)).apply(this, arguments));
  }

  _createClass(Stakeholders, [{
    key: 'render',
    value: function render() {
      var description = "These questions relate to the politics of the project. Here you want to find out whom this project is intended to affect, for better or for worse. Thiose affected can be wither internal or external to your organization.";
      var questions = ["For whose benefit is the project being undertaken?", "What customer group or department is the project intended to affect?", "Who is likely to feel threathened by this project or have strong opinions?", "Who do we need to talk to that has to be happy with the resoults?", "Who are the strong supporters of this project?"];
      return _react2.default.createElement(
        _Area2.default,
        { title: 'Stakeholders' },
        _react2.default.createElement(_Field2.default, { name: 'stakeholderDescription', title: 'Stakeholders',
          height: '2', help: description + "\n\n" + questions.join("\n"), description: 'Who are affected by the project' })
      );
    }
  }]);

  return Stakeholders;
}(_react2.default.Component);

var Timing = function (_React$Component7) {
  _inherits(Timing, _React$Component7);

  function Timing() {
    _classCallCheck(this, Timing);

    return _possibleConstructorReturn(this, (Timing.__proto__ || Object.getPrototypeOf(Timing)).apply(this, arguments));
  }

  _createClass(Timing, [{
    key: 'render',
    value: function render() {
      var questions = ["What’s the time frame or deadline you have in mind?", "What’s driving the deadline?", "What latitude is there?"];
      return _react2.default.createElement(
        _Area2.default,
        { title: 'Timing' },
        _react2.default.createElement(_Field2.default, { name: 'timing', title: 'Timing',
          height: '2', help: questions.join("\n"), description: 'In which time period will the project be performed' })
      );
    }
  }]);

  return Timing;
}(_react2.default.Component);

var ResourcesAndBudget = function (_React$Component8) {
  _inherits(ResourcesAndBudget, _React$Component8);

  function ResourcesAndBudget() {
    _classCallCheck(this, ResourcesAndBudget);

    return _possibleConstructorReturn(this, (ResourcesAndBudget.__proto__ || Object.getPrototypeOf(ResourcesAndBudget)).apply(this, arguments));
  }

  _createClass(ResourcesAndBudget, [{
    key: 'render',
    value: function render() {
      var questions = ["What would you expect to spend on this project?", "Whose budget is this coming out of?", "Who will I talk to when I need staff for the project?"];
      return _react2.default.createElement(
        _Area2.default,
        { title: 'Resources and Budget' },
        _react2.default.createElement(_Field2.default, { name: 'constraints', title: 'Resources and Budget',
          height: '2', help: questions.join("\n"), description: 'What is required to run the project' })
      );
    }
  }]);

  return ResourcesAndBudget;
}(_react2.default.Component);

var TradeOffs = function (_React$Component9) {
  _inherits(TradeOffs, _React$Component9);

  function TradeOffs() {
    _classCallCheck(this, TradeOffs);

    return _possibleConstructorReturn(this, (TradeOffs.__proto__ || Object.getPrototypeOf(TradeOffs)).apply(this, arguments));
  }

  _createClass(TradeOffs, [{
    key: 'render',
    value: function render() {
      var description = "When trade-offs have to be made, which one of the drivers for this project must be achived (that is, it cannot be sacrificed)?";
      var questions = ["ROI, time line, budge, functions and features, quality, customer / stakeholder satisfaction, team satisfaction?", "What is the second most important driver?"];
      return _react2.default.createElement(
        _Area2.default,
        { title: 'Trade offs' },
        _react2.default.createElement(_Field2.default, { name: 'objectives', title: 'Trade-Offs',
          height: '2', help: questions.join("\n"), description: 'What are the priorities' })
      );
    }
  }]);

  return TradeOffs;
}(_react2.default.Component);

var WorkingRelationship = function (_React$Component10) {
  _inherits(WorkingRelationship, _React$Component10);

  function WorkingRelationship() {
    _classCallCheck(this, WorkingRelationship);

    return _possibleConstructorReturn(this, (WorkingRelationship.__proto__ || Object.getPrototypeOf(WorkingRelationship)).apply(this, arguments));
  }

  _createClass(WorkingRelationship, [{
    key: 'render',
    value: function render() {
      var questions = ["How do you see your role with respect to decision making? Funding? Staffing? Who else wil you look to for this?", "How do you see my role on the project?", "What progress reporting information will be important to you?"];
      return _react2.default.createElement(
        _Area2.default,
        { title: 'Working Relationship' },
        _react2.default.createElement(_Field2.default, { name: 'assumptions', title: 'Working Relationship',
          height: '2', help: questions.join("\n"), description: 'What are the expectations to you as responsible for the project' })
      );
    }
  }]);

  return WorkingRelationship;
}(_react2.default.Component);

var NewExtremeProject = exports.NewExtremeProject = function (_React$Component11) {
  _inherits(NewExtremeProject, _React$Component11);

  function NewExtremeProject() {
    _classCallCheck(this, NewExtremeProject);

    return _possibleConstructorReturn(this, (NewExtremeProject.__proto__ || Object.getPrototypeOf(NewExtremeProject)).apply(this, arguments));
  }

  _createClass(NewExtremeProject, [{
    key: 'submitProject',
    value: function submitProject(form) {
      /*
        translation to PRINCE2 definition:
        Business Objective (objective) -> background
        Project Deliverable Quality and Scope (deliverable) -> benefitsDescription
        Business Outcome (outcomes) -> outcomes
        Context (context) -> bigPicture
        Stakeholders (stakeholders) -> stakeholderDescription
        Timing (timing) -> timing
        Resources and Budget (resources) -> constraints
        Trade-Offs (tradeOffs) -> objectives
        Working Relationship (relation) -> assumptions
      */
      var project = {
        name: form.name,
        background: form.objectives,
        benefitsDescription: form.deliverables,
        outcomes: form.outcomes,
        bigPicture: form.context,
        stakeholderDescription: form.stakeholders,
        timing: form.timing,
        constraints: form.resources,
        objectives: form.tradeOffs,
        assumptions: form.relations
      };
      _superagent2.default.post("/projects/").send(project).then(function () {
        window.location = "/";
      }).catch(function (error) {
        alert("Not able to add project: " + error);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { display: "flex", justifyContent: "center" } },
        _react2.default.createElement(
          'div',
          { style: { maxWidth: 1016, flexBasis: "100%" } },
          this.props.newForm ? _react2.default.createElement(_AreaForm2.default, _extends({}, this.props, {
            display: 'tab',
            item: { _progress: "relationship" },
            selected: 0,
            areas: translations.createTranslatedForm(_formDefinition2.default, this.props.language, this.props.variant),
            onUpdate: this.submitProject.bind(this),
            label: 'Project'
          })) : _react2.default.createElement(
            'form',
            { action: '/projects/', method: 'POST' },
            _react2.default.createElement(GeneralInformation, null),
            _react2.default.createElement(BusinessObjective, null),
            _react2.default.createElement(DeliverableQualityAndScope, null),
            _react2.default.createElement(BusinessOutcome, null),
            _react2.default.createElement(Context, null),
            _react2.default.createElement(Stakeholders, null),
            _react2.default.createElement(Timing, null),
            _react2.default.createElement(ResourcesAndBudget, null),
            _react2.default.createElement(TradeOffs, null),
            _react2.default.createElement(WorkingRelationship, null),
            _react2.default.createElement(
              'div',
              { style: { paddingTop: 30, paddingBottom: 80, clear: "left", float: "none" } },
              _react2.default.createElement('input', { className: 'cancel', type: 'submit', name: 'cancel', value: 'Cancel' }),
              _react2.default.createElement('input', { className: 'save', style: { marginLeft: 15 }, type: 'submit', value: 'Save' })
            )
          )
        )
      );
    }
  }]);

  return NewExtremeProject;
}(_react2.default.Component);

var NewExtremeProjectPage = function (_React$Component12) {
  _inherits(NewExtremeProjectPage, _React$Component12);

  function NewExtremeProjectPage() {
    _classCallCheck(this, NewExtremeProjectPage);

    return _possibleConstructorReturn(this, (NewExtremeProjectPage.__proto__ || Object.getPrototypeOf(NewExtremeProjectPage)).apply(this, arguments));
  }

  _createClass(NewExtremeProjectPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Layout2.default,
        this.props,
        _react2.default.createElement(NewExtremeProject, this.props)
      );
    }
  }]);

  return NewExtremeProjectPage;
}(_react2.default.Component);

exports.default = NewExtremeProjectPage;

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  name: "reason",
  fields: [{ name: "name" }, { name: "objectives", height: 3 }, { name: "deliverables", height: 3 }, { name: "outcomes", height: 3 }]
}, {
  name: "surroundings",
  fields: [{ name: "context", height: 3 }, { name: "stakeholders", height: 3 }]
}, {
  name: "dependencies",
  fields: [{ name: "timing", height: 3 }, { name: "resources", height: 3 }, { name: "tradeOffs", height: 3 }]
}, {
  name: "relationship",
  fields: [{ name: "relations", height: 3 }]
}];

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var english = exports.english = {
  reason: {
    title: "Who need what and why?",
    fields: {
      name: {
        title: "Project Name",
        description: "A descriptive name of the project",
        help: "Tell me about the project you have in mind."
      },
      objectives: {
        title: "Business Objective",
        help: "What opportunity are we going after?\n          What\u2019s the business need that this project is intended to address?\n          What is it that we are fixing, trying to improve, or solve?\n          How will the project enable your organization to serve its customers better?",
        description: "The reason to run the project"
      },
      deliverables: {
        title: "Project Deliverable Quality and Scope",
        help: "These questions dvelve into the product or service that is to be produced: \u201CIf we had it in place right now [the process, system, the product, the new service] \u2026\u201D\n\n          What would you see as its main functions or features?\n          Is this intended to be a stop-gap measure: We\u2019ll do it once, and if we replace it, will we start all over from scratch? Or are we trying to do something that we will attempt to fix and upgrade over time?\n          What would be the absolute bare minimum functions?\n          What would it physically look like?",
        description: "The qualities of deliverables and project scope"
      },
      outcomes: {
        title: "Business Outcome",
        help: "These questions are aimed at identifying the value-added dollar-and-cents benefits that are being sought as a result of having produced the project deliverable. \u201CAssuming we had completed the project and it was now up and running\u2026\u201D\n\n          What s the most important payoff you are looking to achieve? Increased revenue? Better customer service? Greater marked share? Decreased cost of doing business? Short-term profits?\n          How would you quantify the dolar payoff you are targeting? ROI? Reduced cost? Over what period of time?\n          What will you want to see to know that the business benefits have been achieved?\n          Under what conditions would we shut down the project?",
        description: "The expected result of the project"
      }
    }
  },
  surroundings: {
    title: "Surroundings",
    fields: {
      context: {
        title: "Context",
        help: "These questions elict information about the business climate surrounding the project:\n\n          How does this project fit in with the origanization\u2019s overall business strategy?\n          Who\u2019s driving this project from above?\n          Who will you be going to for approvals and funding?\n          What\u2019s driving us to this now? What is we did nothing? Waited until next year?\n          How does this fit into the overall priority of projects?\n          If we have to let another project slip, what might that be?",
        description: "In which context does the project exist"
      },
      stakeholders: {
        title: "Stakeholders",
        help: "These questions relate to the politics of the project. Here you want to find out whom this project is intended to affect, for better or for worse. Thiose affected can be wither internal or external to your organization.\n\n          For whose benefit is the project being undertaken?\n          What customer group or department is the project intended to affect?\n          Who is likely to feel threathened by this project or have strong opinions?\n          Who do we need to talk to that has to be happy with the resoults?\n          Who are the strong supporters of this project?",
        description: "Who are affected by the project"
      }
    }
  },
  dependencies: {
    title: "Dependencies",
    fields: {
      timing: {
        title: "Timing",
        help: "What\u2019s the time frame or deadline you have in mind?\n          What\u2019s driving the deadline?\n          What latitude is there?",
        description: "In which time period will the project be performed"
      },
      resources: {
        title: "Resources and Budget",
        help: "What would you expect to spend on this project?,\n          Whose budget is this coming out of?\n          Who will I talk to when I need staff for the project?",
        description: "What is required to run the project"
      },
      tradeOffs: {
        title: "Trade-Offs",
        help: "When trade-offs have to be made, which one of the drivers for this project must be achived (that is, it cannot be sacrificed)?\n\n          ROI, time line, budget, functions and features, quality, customer / stakeholder satisfaction, team satisfaction?\n          What is the second most important driver?",
        description: "What are the priorities"
      }
    }
  },
  relationship: {
    title: "Relationship",
    fields: {
      relations: {
        title: "Working Relationship",
        help: "How do you see your role with respect to decision making? Funding? Staffing? Who else wil you look to for this?\n          How do you see my role on the project?\n          What progress reporting information will be important to you?",
        description: "What are the expectations to you as responsible for the project"
      }
    }
  }
};

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var norwegian = exports.norwegian = {
  reason: {
    title: "Hvem trenger hva og hvorfor?",
    fields: {
      name: {
        title: "Prosjektnavn",
        description: "Et beskrivende navn på prosjektet",
        help: "Fortell meg om prosjektet du har i tankene."
      },
      objectives: {
        title: "Forretningsmål",
        help: "Hvilke muligheter g\xE5r vi etter?\n          Hvilket forretningsbehov skal prosjektet adressere?\n          Hva er det vi pr\xF8ver fikse, forbedre eller l\xF8se?\n          Hvordan vil dette prosjektet gj\xF8re det mulig for organisasjonen \xE5 betjene sine kunder bedre?",
        description: "Grunnen til å gjennomføre prosjektet"
      },
      deliverables: {
        title: "Prosjektleveranser og omfang",
        help: "Disse sp\xF8rsm\xE5lene omhander produktet eller tjenesten som skal produseres: \u201CHvis vi hadde det p\xE5 plass akkurat n\xE5 [prosessen, systemet, produktet, en ny tjeneste] \u2026\u201D\n\n          Hva ville du se som de viktigste funksjonene eller egenskapene?\n          Hvilken tiln\xE6rming passer best? Vi vil gj\xF8re det en gang, og hvis vi erstatter det, s\xE5 vil vi starte helt p\xE5 nytt igjen? Eller pr\xF8ver vi \xE5 gj\xF8re noe som skal vedlikeholdes og forbedres over tid?\n          Hva er det absolutt minste som kan leveres?\n          Hvordan vil det se ut fysisk?",
        description: "Kvaliteten på leveranser og prosjektomfang"
      },
      outcomes: {
        title: "Forretningsresultat",
        help: "Disse sp\xF8rsm\xE5lene er rettet mot \xE5 identifisere verdi\xF8kende pengemessige fordelene som prosjektets leveranse skal gi. \u201CForutsett at vi hadde fullf\xF8rt prosjektet, og leveransen var p\xE5 plass\u2026\u201D:\n\n          Hva er den viktigste gevinsten du \xF8nsker \xE5 oppn\xE5? \xD8kt omsetning? bedre kundeservice? St\xF8rre markedsandel? Reduserte kostnader ved ordin\xE6r drift? Kortsiktig profitt?\n          Hvordan vil du kvantifisere pengeverdien av l\xF8nnsomheten du sikter mot? ROI? Reduserte kostnader? I l\xF8pet av hvilken tidsperiode?\n          Hva \xF8nsker du \xE5 se forretningsfordelen av \xE5 ha oppn\xE5dd?\n          Under hvilke omstendigheter b\xF8r prosjektet stoppes?",
        description: "Forventet resultat av prosjektet"
      }
    }
  },
  surroundings: {
    title: "Omgivelsene",
    fields: {
      context: {
        title: "Sammenheng",
        help: "Disse sp\xF8rsm\xE5lene vil avdekke informasjon om virksomhetens klima rundt prosjektet.\n\n          Hvordan vil dette prosjektet passe inn i organisasjonens overordnede forretningsstrategi?\n          Hvem kj\xF8rer dette prosjektet ovenfra?\n          Hvem vil du g\xE5 til for godkjenning og finansiering?\n          Hva driver oss til dette n\xE5? Hva hvis vi ikke gj\xF8r noe? Vente til neste \xE5r?\n          Hvordan passer dette inn i den generelle prioriteringen av prosjekter?\n          Hvis vi m\xE5 la et annet prosjekt skli, hva vil det v\xE6re?",
        description: "I hvilken sammenheng eksisterer prosjektet"
      },
      stakeholders: {
        title: "Interessenter",
        help: "Disse sp\xF8rsm\xE5lene er knyttet til politikken i prosjektet. her vil du fnne ut hvem prosjektet er ment \xE5 p\xE5irke, til det bedre eller v\xE6rre. De rammende kan v\xE6re interne eller eksterne i forhold til organisasjonen.\n\n          For hvem blir projektet gjennomf\xF8rt?\n          Hvilken kundegruppe eller avdeling er prosjktet tiltenkt \xE5 p\xE5virke?\n          Hvem vil f\xF8le seg truet av dette prosjektet eller har sterke meninger?\n          Hvem trenger vi \xE5 snakke med som m\xE5 v\xE6re forn\xF8yd med resultatene?\n          Hvem er de st\xF8rste tilhengerne av dette prosjektet?",
        description: "Hvem er berørt av prosjektet"
      }
    }
  },
  dependencies: {
    title: "Avhengigheter",
    fields: {
      timing: {
        title: "Tid",
        help: "Hvilken tidsramme eller frist har du tenkt p\xE5?\n          Hva styrer tidsfristen?\n          Hvilket slingringsmonn finnes?",
        description: "I hvilken tidsperiode vil prosjektet bli utført"
      },
      resources: {
        title: "Ressurser og budsjett",
        help: "Hva forventer du \xE5 bruke p\xE5 prosjektet?\n          Hvilket budsjett kommer midlene fra?\n          Hvem skal jeg snakke med for \xE5 f\xE5 prosjektdeltakere?",
        description: "Hva kreves for å kjøre prosjektet"
      },
      tradeOffs: {
        title: "Avveiinger",
        help: "N\xE5r avveininger m\xE5 gj\xF8res, hvilket av prosjektets vilk\xE5r m\xE5 oppfylles (eller, hvilket vilk\xE5r m\xE5 for all del ikke ofres)?\n          ROI (Return On Investment - avkastning av investeringen), tidsplan, budsjett, funksjoner og egenskaper, kvalitet, kunde- interesent-tilfredshet, team-tilfredshet?\n          Hva er det nest viktigste vilk\xE5ret?",
        description: "Hva er prioritetene"
      }
    }
  },
  relationship: {
    title: "Relasjoner",
    fields: {
      relations: {
        title: "Samarbeid",
        help: "Hvordan ser du p\xE5 din rolle i forhold til beslutningsprosesser? Finansiering? Bemanning? Hvem andre vil du forh\xF8re deg med for dette?\n          Hvordan ser du p\xE5 min rolle i prosjektet?\n          Hvilken informasjon er viktig for deg i forhold til fremdriftsrapportering?",
        description: "Hva er forventningene til deg som ansvarlig for prosjektet"
      }
    }
  }
};

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectDefinition = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _superagent = __webpack_require__(23);

var _superagent2 = _interopRequireDefault(_superagent);

var _uuid = __webpack_require__(26);

var _uuid2 = _interopRequireDefault(_uuid);

var _AreaForm = __webpack_require__(28);

var _AreaForm2 = _interopRequireDefault(_AreaForm);

var _ProjectMenu = __webpack_require__(17);

var _ProjectMenu2 = _interopRequireDefault(_ProjectMenu);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _HighlightReport = __webpack_require__(105);

var _formDefinition = __webpack_require__(1079);

var _formDefinition2 = _interopRequireDefault(_formDefinition);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(177), __webpack_require__(178)]).loadVariants([__webpack_require__(1080)]);

var ProjectDefinition = exports.ProjectDefinition = function (_React$Component) {
  _inherits(ProjectDefinition, _React$Component);

  function ProjectDefinition(props) {
    _classCallCheck(this, ProjectDefinition);

    var _this = _possibleConstructorReturn(this, (ProjectDefinition.__proto__ || Object.getPrototypeOf(ProjectDefinition)).call(this, props));

    var labels = translations.getTranslation(_this.props.language, _this.props.variant);
    var definition = Object.assign({}, _this.props.project, {
      _progress: "stakeholders",
      objectivesSummary: _this.props.project.objectivesSummary !== undefined ? _this.props.project.objectivesSummary.map(function (aspect) {
        return Object.assign({}, aspect, {
          name: labels.aspects[aspect.id],
          description: aspect.description
        });
      }) : ["time", "scope", "cost", "quality", "risk"].map(function (id) {
        return {
          id: id,
          name: labels.aspects[id],
          description: id === "scope" ? labels.aspects.scopeDescription : undefined
        };
      }),
      projectScope: _this.props.project.projectScope !== undefined ? _this.props.project.projectScope : [],
      benefitsDescription: _this.props.project.benefitsDescription !== undefined ? _this.props.project.benefitsDescription : _this.props.project.tolerances,
      scopeExclusions: _this.props.project.scopeExclusions !== undefined ? _this.props.project.scopeExclusions : _this.props.project.scopeAndExclusions,
      constraints: _this.props.project.constraints !== undefined ? _this.props.project.constraints : _this.props.project.constraintsAndAssumptions,
      stakeholders: _this.props.project.stakeholders !== undefined ? _this.props.project.stakeholders : _this.props.project.usersAndStakeholders
    });
    _this.state = {
      definition: definition,
      lastSaved: definition
    };
    _this.warningOnLeave = _this.changeWarningOnLeave.bind(_this);
    return _this;
  }

  _createClass(ProjectDefinition, [{
    key: 'sendCommand',
    value: function sendCommand(command, success) {
      _superagent2.default.post("/").send(command).end(function (error, response) {
        if (error === null && response.status === 200) {
          var message = JSON.parse(response.text);
          if (message.status === "OK") {
            console.log("Success for command '" + command.type + "'");
            success(message.project);
          } else {
            console.log("Error: " + message.message);
            window.alert("Not able to update project definition");
          }
        } else {
          console.log("Error: " + error + ", got " + response.status + " with message " + response.text);
          window.alert("Not able to update project definition");
        }
      });
    }
  }, {
    key: 'update',
    value: function update(project) {
      var _this2 = this;

      var strippedProject = { id: project.id };
      [].concat.apply([], _formDefinition2.default.map(function (tab) {
        return tab.fields;
      })).map(function (field) {
        return field.name;
      }).forEach(function (field) {
        strippedProject[field] = _this2.state.definition[field];
      });
      this.sendCommand({ type: "updateProjectDefinition", project: strippedProject }, function (updatedProject) {
        this.setState({
          definition: Object.assign({}, this.state.definition, {
            _currentProgress: project._progress
          }),
          modified: undefined,
          lastSaved: this.state.definition
        });
      }.bind(this));
    }
  }, {
    key: 'handleFieldChange',
    value: function handleFieldChange(fieldName) {
      var _this3 = this;

      return function (event) {
        var labels = translations.getTranslation(_this3.props);
        var value = event.target.value;
        if (event.target.name === "projectScope") {
          value = value.map(function (item) {
            return item.id === undefined ? Object.assign({}, item, { id: _uuid2.default.v4() }) : item;
          }).map(function (item) {
            return item.text === "" && item.items !== undefined && item.items.length > 0 ? Object.assign({}, item, { text: labels.messages.deletedScope }) : item;
          });
        }
        _this3.setState({
          definition: Object.assign({}, _this3.state.definition, _defineProperty({}, event.target.name, value)),
          modified: true
        });
      };
    }
  }, {
    key: 'hasChanged',
    value: function hasChanged(lastSaved) {
      var _this4 = this;

      return _formDefinition2.default.map(function (area) {
        return area.fields !== undefined && area.fields.map(function (field) {
          return JSON.stringify(lastSaved[field.name]) !== JSON.stringify(_this4.state.definition[field.name]);
        }).reduce(function (value, result) {
          return result || value;
        });
      }).reduce(function (value, result) {
        return result || value;
      });
    }
  }, {
    key: 'changeWarningOnLeave',
    value: function changeWarningOnLeave(e) {
      if (this.hasChanged(this.state.lastSaved)) {
        e.returnValue = "Do you want to keep changes?";
        return "Do you want to keep changes?";
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener("beforeunload", this.warningOnLeave);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener("beforeunload", this.warningOnLeave);
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props.language, this.props.variant);
      var areas = translations.createTranslatedForm(_formDefinition2.default, this.props.language, this.props.variant);
      var selected = 0;
      if (typeof window !== "undefined" && window.location.hash.length > 0) {
        areas.forEach(function (area, index) {
          if (area.name === window.location.hash.slice(1)) {
            selected = index;
          }
        });
      }
      return _react2.default.createElement(
        'div',
        { style: { marginTop: 20, display: "flex", justifyContent: "center", flexWarp: "wrap" } },
        _react2.default.createElement(
          'div',
          { style: { width: 1016 } },
          this.props.showMessage !== undefined && selected === 2 && this.state.definition.projectScope !== undefined && this.state.definition.projectScope.filter(function (item) {
            return item.id === undefined;
          }).length > 0 ? _react2.default.createElement(
            'div',
            { style: { marginBottom: 10 } },
            _react2.default.createElement(_HighlightReport.ReportMessage, { message: labels.messages[this.props.showMessage] })
          ) : null,
          _react2.default.createElement(_AreaForm2.default, _extends({}, this.props, {
            display: 'tab',
            areas: areas,
            item: this.state.definition,
            label: labels.definition,
            selected: selected,
            onUpdate: this.update.bind(this),
            modified: this.state.modified,
            handleFieldChange: this.handleFieldChange.bind(this),
            onCancel: function onCancel() {
              return window.location = ".";
            }
          }))
        )
      );
    }
  }]);

  return ProjectDefinition;
}(_react2.default.Component);

var ProjectDefinitionPage = function (_React$Component2) {
  _inherits(ProjectDefinitionPage, _React$Component2);

  function ProjectDefinitionPage() {
    _classCallCheck(this, ProjectDefinitionPage);

    return _possibleConstructorReturn(this, (ProjectDefinitionPage.__proto__ || Object.getPrototypeOf(ProjectDefinitionPage)).apply(this, arguments));
  }

  _createClass(ProjectDefinitionPage, [{
    key: 'render',
    value: function render() {
      var menu = this.props.showMenu === true ? _react2.default.createElement(_ProjectMenu2.default, this.props) : undefined;
      return _react2.default.createElement(
        _Layout2.default,
        _extends({}, this.props, { projectMenu: menu }),
        _react2.default.createElement(ProjectDefinition, this.props)
      );
    }
  }]);

  return ProjectDefinitionPage;
}(_react2.default.Component);

exports.default = ProjectDefinitionPage;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  name: "background",
  fields: [{ name: "background", height: 5 }, { name: "timing", height: 5 }, { name: "bigPicture", height: 5 }]
}, {
  name: "objectives",
  fields: [{ name: "benefitsDescription", height: 3 }, { name: "objectivesSummary", type: "table",
    columns: [{ name: "pri", priority: true }, { name: "name", dragable: true }, { name: "description", editable: true }, { name: "tolerance", editable: true }]
  }, { name: "objectives", height: 5 }]
}, {
  name: "scope",
  fields: [{ name: "projectScope", type: "table",
    columns: [{ name: "text", editable: true, dragable: true }],
    includeEmptyLine: true
  }, { name: "scopeExclusions", height: 5 }, { name: "outcomes", height: 5 }]
}, {
  name: "constraints",
  fields: [{ name: "constraints", height: 5 }, { name: "assumptions", height: 5 }]
}, {
  name: "stakeholders",
  fields: [{ name: "stakeholderDescription", height: 5 }, { name: "interfaces", height: 5 }]
}];

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var norwegian_noProject = exports.norwegian_noProject = {
  background: {
    fields: {
      background: {
        title: "Hvorfor ble aktiviteten startet?",
        help: "Hva er virksomhetenes behov denne aktviteten skal adressere?\n          Hvilket problemet pr\xF8ver \xE5 l\xF8se?\n          Hvordan vet vi at det er et problem?\n          Hvem l\xF8ser vi problemet for, og hvordan vet vi at de \xF8nsker \xE5 f\xE5 l\xF8st dette udekkede behovet?",
        description: "Begrunnelse for aktiviteten"
      },
      bigPicture: {
        title: "I hvilken sammeheng utføres aktiviteten?",
        help: "Er denne aktiviteten del av et st\xF8rre strategisk initiativ?\n          Hvordan er det knyttet til bedriftsstrategien?",
        description: "Beskriv hvordan aktiviteten er knyttet til strategier og inititativ på et høyere nivå"
      }
    }
  },
  objectives: {
    fields: {
      benefitsDescription: {
        help: "Hvilke m\xE5lbare forbedringer vil denne aktiviteten lede til?\n          Hvilke gevinster er mer eller mindre vitkige?",
        description: "De forventede forbedringene denne aktiviteten vil føre til"
      },
      objectives: {
        description: "Annen relevant informasjon relatert til resultatmålene for denne aktiviteten"
      }

    }
  },
  scope: {
    fields: {
      projectScope: {
        help: undefined
      },
      scopeExclusions: {
        helt: undefined,
        description: "Beskriv hva som ikke inngår i aktiviteten."
      },
      outcomes: {
        help: "Hvordan vil aktiviteten gj\xF8re det mulig for organisasjonen \xE5 betjene sine kunder eller brukere bedre? Hvilke nye ting (evne) kan v\xE5re kunder (intern og ekstern) gj\xF8re n\xE5r aktiviteten er utf\xF8rt?"
      }
    }
  },
  constraints: {
    fields: {
      constraints: {
        help: undefined,
        description: "Restriksjoner eller begrensninger for aktiviteten"
      }
    }
  },
  stakeholders: {
    fields: {
      stakeholders: {
        help: undefined
      },
      interfaces: {
        help: undefined,
        description: "Beskriv grensesnitt for aktiviteten"
      }
    }
  }
};

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectProductDescription = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _superagent = __webpack_require__(23);

var _superagent2 = _interopRequireDefault(_superagent);

var _uuid = __webpack_require__(26);

var _uuid2 = _interopRequireDefault(_uuid);

var _AreaForm = __webpack_require__(28);

var _AreaForm2 = _interopRequireDefault(_AreaForm);

var _ProjectMenu = __webpack_require__(17);

var _ProjectMenu2 = _interopRequireDefault(_ProjectMenu);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _FormattedContent = __webpack_require__(15);

var _FormattedContent2 = _interopRequireDefault(_FormattedContent);

var _sendCommand = __webpack_require__(25);

var _sendCommand2 = _interopRequireDefault(_sendCommand);

var _formDefinition = __webpack_require__(1082);

var _formDefinition2 = _interopRequireDefault(_formDefinition);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(261), __webpack_require__(262)]);

var OutputSummarySimple = function (_React$Component) {
  _inherits(OutputSummarySimple, _React$Component);

  function OutputSummarySimple() {
    _classCallCheck(this, OutputSummarySimple);

    return _possibleConstructorReturn(this, (OutputSummarySimple.__proto__ || Object.getPrototypeOf(OutputSummarySimple)).apply(this, arguments));
  }

  _createClass(OutputSummarySimple, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'b',
          null,
          this.props.scopeEntry.text
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(_FormattedContent2.default, { value: this.props.output }),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'i',
          null,
          _react2.default.createElement(_FormattedContent2.default, { value: this.props.qualityExpectation })
        ),
        _react2.default.createElement(
          'table',
          null,
          _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              null,
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(_FormattedContent2.default, { value: this.props.acceptanceCriteria })
              ),
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(_FormattedContent2.default, { value: this.props.acceptanceMethod })
              ),
              _react2.default.createElement(
                'td',
                null,
                _react2.default.createElement(_FormattedContent2.default, { value: this.props.acceptanceResponsible })
              )
            )
          )
        )
      );
    }
  }]);

  return OutputSummarySimple;
}(_react2.default.Component);

var FieldValue = function (_React$Component2) {
  _inherits(FieldValue, _React$Component2);

  function FieldValue() {
    _classCallCheck(this, FieldValue);

    return _possibleConstructorReturn(this, (FieldValue.__proto__ || Object.getPrototypeOf(FieldValue)).apply(this, arguments));
  }

  _createClass(FieldValue, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'div',
          { style: { display: "flex", alignItems: "center" } },
          this.props.value === undefined || this.props.value.trim().length === 0 ? _react2.default.createElement(
            'span',
            { style: { color: "lightgrey" } },
            '""'
          ) : _react2.default.createElement(
            'div',
            { style: { fontFamily: "Arial, Verdana, Geneva, sans-serif" } },
            _react2.default.createElement(_FormattedContent2.default, { value: this.props.value })
          ),
          _react2.default.createElement(
            'div',
            { style: { fontFamily: "Times", paddingLeft: 10, textTransform: "lowerCase", color: "lightgrey" } },
            '(',
            this.props.name,
            ')'
          )
        )
      );
    }
  }]);

  return FieldValue;
}(_react2.default.Component);

var Label = function (_React$Component3) {
  _inherits(Label, _React$Component3);

  function Label() {
    _classCallCheck(this, Label);

    return _possibleConstructorReturn(this, (Label.__proto__ || Object.getPrototypeOf(Label)).apply(this, arguments));
  }

  _createClass(Label, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        { style: { fontStyle: "italic", color: "grey" } },
        this.props.label
      );
    }
  }]);

  return Label;
}(_react2.default.Component);

var FieldWithLabel = function (_React$Component4) {
  _inherits(FieldWithLabel, _React$Component4);

  function FieldWithLabel() {
    _classCallCheck(this, FieldWithLabel);

    return _possibleConstructorReturn(this, (FieldWithLabel.__proto__ || Object.getPrototypeOf(FieldWithLabel)).apply(this, arguments));
  }

  _createClass(FieldWithLabel, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { paddingBottom: 5 } },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(Label, this.props)
        ),
        _react2.default.createElement(
          'div',
          { style: { paddingLeft: 20 } },
          _react2.default.createElement(FieldValue, this.props)
        )
      );
    }
  }]);

  return FieldWithLabel;
}(_react2.default.Component);

var InlineFieldLabel = function (_React$Component5) {
  _inherits(InlineFieldLabel, _React$Component5);

  function InlineFieldLabel() {
    _classCallCheck(this, InlineFieldLabel);

    return _possibleConstructorReturn(this, (InlineFieldLabel.__proto__ || Object.getPrototypeOf(InlineFieldLabel)).apply(this, arguments));
  }

  _createClass(InlineFieldLabel, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { paddingBottom: 5 } },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(FieldValue, { value: this.props.inlineValue, name: this.props.inlineName }),
          _react2.default.createElement(
            'span',
            null,
            ' '
          ),
          _react2.default.createElement(Label, this.props)
        ),
        _react2.default.createElement(
          'div',
          { style: { paddingLeft: 20 } },
          _react2.default.createElement(FieldValue, this.props)
        )
      );
    }
  }]);

  return InlineFieldLabel;
}(_react2.default.Component);

var OutputSummaryAssisted = function (_React$Component6) {
  _inherits(OutputSummaryAssisted, _React$Component6);

  function OutputSummaryAssisted() {
    _classCallCheck(this, OutputSummaryAssisted);

    return _possibleConstructorReturn(this, (OutputSummaryAssisted.__proto__ || Object.getPrototypeOf(OutputSummaryAssisted)).apply(this, arguments));
  }

  _createClass(OutputSummaryAssisted, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      var labelsText = labels.outputSummary;
      return _react2.default.createElement(
        'div',
        { className: 'outputSummary', style: { fontSize: "80%" } },
        _react2.default.createElement(FieldWithLabel, {
          label: labelsText.cover,
          value: this.props.scopeEntry.text,
          name: labels.general.scope
        }),
        _react2.default.createElement(FieldWithLabel, {
          label: labelsText.projectWillDeliver,
          value: this.props.output,
          name: labels.output.fields.output.title
        }),
        _react2.default.createElement(FieldWithLabel, {
          label: labelsText.theReceiverWants,
          value: this.props.qualityExpectation,
          name: labels.output.fields.qualityExpectation.title
        }),
        _react2.default.createElement(InlineFieldLabel, {
          inlineValue: this.props.acceptanceResponsible,
          inlineName: labels.acceptance.fields.acceptanceResponsible.title,
          label: labelsText.willConfirm,
          value: this.props.acceptanceCriteria,
          name: labels.acceptance.fields.acceptanceCriteria.title
        }),
        _react2.default.createElement(FieldWithLabel, {
          label: labelsText.by,
          value: this.props.acceptanceMethod,
          name: labels.acceptance.fields.acceptanceMethod.title
        })
      );
    }
  }]);

  return OutputSummaryAssisted;
}(_react2.default.Component);

var OutputSummary = function (_React$Component7) {
  _inherits(OutputSummary, _React$Component7);

  function OutputSummary() {
    _classCallCheck(this, OutputSummary);

    return _possibleConstructorReturn(this, (OutputSummary.__proto__ || Object.getPrototypeOf(OutputSummary)).apply(this, arguments));
  }

  _createClass(OutputSummary, [{
    key: 'render',
    value: function render() {
      return false ? _react2.default.createElement(OutputSummarySimple, this.props) : _react2.default.createElement(OutputSummaryAssisted, this.props);
    }
  }]);

  return OutputSummary;
}(_react2.default.Component);

var ProjectProductDescription = exports.ProjectProductDescription = function (_React$Component8) {
  _inherits(ProjectProductDescription, _React$Component8);

  function ProjectProductDescription(props) {
    _classCallCheck(this, ProjectProductDescription);

    var _this8 = _possibleConstructorReturn(this, (ProjectProductDescription.__proto__ || Object.getPrototypeOf(ProjectProductDescription)).call(this, props));

    var labels = translations.getTranslation(props.language);
    var selected = 0;
    if (typeof window !== "undefined" && window.location.hash.length > 0) {
      _formDefinition2.default.forEach(function (area, index) {
        if (area.name === window.location.hash.slice(1)) {
          selected = index;
        }
      });
    }
    var quality = Object.assign({}, props.quality, {
      id: _this8.props.project.qualityApproach !== undefined ? "savedApproach" : undefined,
      _progress: "qualityManagementApproach" //"qualityRegister",
    }, _this8.props.project.qualityApproach);
    _this8.state = {
      quality: quality,
      lastSaved: quality,
      selected: selected
    };
    _this8.warningOnLeave = _this8.changeWarningOnLeave.bind(_this8);
    return _this8;
  }

  _createClass(ProjectProductDescription, [{
    key: 'update',
    value: function update(approach) {
      var _this9 = this;

      var strippedApproach = Object.assign({}, approach, { id: undefined, scopeDetails: undefined, _progress: undefined });
      (0, _sendCommand2.default)({ type: "updateQualityManagementApproach", project: { id: this.props.project.id }, approach: strippedApproach }).then(function (response) {
        var updatedQuality = Object.assign({}, _this9.state.quality, response.approach, {
          _currentProgress: approach._progress,
          id: "savedApproach"
        });
        _this9.setState({
          quality: updatedQuality,
          modified: undefined,
          lastSaved: updatedQuality
        });
      }).catch(function (error) {
        console.log("Got error " + JSON.stringify(error), error);
        alert("Error saving approach");
      });
    }
  }, {
    key: 'handleFieldChange',
    value: function handleFieldChange(fieldName) {
      var _this10 = this;

      return function (event) {
        if (event.details !== undefined && event.details.action === "prioritize") {
          var id = event.target.name.split(".")[1];
          (0, _sendCommand2.default)({ type: "prioritizeOutput", project: { id: _this10.props.project.id }, parent: id, item: { id: event.details.item }, position: event.details.position }).then(function (response) {
            _this10.setState({
              quality: Object.assign({}, _this10.state.quality, { scopeDetails: response.quality }),
              lastSaved: Object.assign({}, _this10.state.quality, { scopeDetails: response.quality }),
              details: undefined,
              modified: true });
          }).catch(function (error) {
            return alert("Not able to prioritize output, " + JSON.stringify(error));
          });
        } else {
          _this10.setState({
            quality: Object.assign({}, _this10.state.quality, _defineProperty({}, event.target.name, event.target.value)),
            modified: true
          });
        }
      };
    }
  }, {
    key: 'hasChanged',
    value: function hasChanged(lastSaved) {
      var _this11 = this;

      return _formDefinition2.default.map(function (area) {
        return area.fields !== undefined && area.fields.map(function (field) {
          return JSON.stringify(lastSaved[field.name]) !== JSON.stringify(_this11.state.quality[field.name]);
        }).reduce(function (value, result) {
          return result || value;
        });
      }).reduce(function (value, result) {
        return result || value;
      });
    }
  }, {
    key: 'changeWarningOnLeave',
    value: function changeWarningOnLeave(e) {
      if (this.hasChanged(this.state.lastSaved)) {
        e.returnValue = "Do you want to keep changes?";
        return "Do you want to keep changes?";
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener("beforeunload", this.warningOnLeave);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener("beforeunload", this.warningOnLeave);
    }
  }, {
    key: 'showDetails',
    value: function showDetails(details) {
      this.setState({ details: details });
    }
  }, {
    key: 'updateDetails',
    value: function updateDetails(content) {
      var _this12 = this;

      if (this.state.details.type === "multiTable") {
        var field = this.state.details.field.split(".");
        if (content.id !== undefined) {
          var quality = Object.assign({}, this.state.quality, _defineProperty({}, field[0], this.state.quality[field[0]].map(function (entry) {
            return entry.id === field[1] ? Object.assign({}, entry, {
              items: entry.items.map(function (item) {
                return item.id === content.id ? Object.assign({}, item, content, { _progress: "dependencies" }) : item;
              })
            }) : entry;
          })));
          var updatedEntry = quality[field[0]].filter(function (entry) {
            return entry.id === field[1];
          })[0].items.filter(function (item) {
            return item.id === content.id;
          })[0];
          (0, _sendCommand2.default)({ type: "updateOutput", project: { id: this.props.project.id }, parent: field[1], item: updatedEntry }).then(function (response) {
            _this12.setState({
              quality: Object.assign({}, _this12.state.quality, { scopeDetails: response.quality }),
              lastSaved: Object.assign({}, _this12.state.quality, { scopeDetails: response.quality }),
              details: undefined,
              modified: false });
          }).catch(function (error) {
            alert("Could not save output" + JSON.stringify(error));
          });
        } else {
          var newOutput = Object.assign({}, content, { id: _uuid2.default.v4(), _progress: "dependencies" });
          var _quality = Object.assign({}, this.state.quality, _defineProperty({}, field[0], this.state.quality[field[0]].map(function (entry) {
            return entry.id === field[1] ? Object.assign({}, entry, {
              items: (entry.items !== undefined ? entry.items : []).concat(newOutput)
            }) : entry;
          })));
          (0, _sendCommand2.default)({ type: "addOutput", project: { id: this.props.project.id }, parent: field[1], item: newOutput }).then(function (response) {
            _this12.setState({
              quality: Object.assign({}, _this12.state.quality, { scopeDetails: response.quality }),
              lastSaved: Object.assign({}, _this12.state.quality, { scopeDetails: response.quality }),
              details: undefined,
              modified: false });
          }).catch(function (error) {
            alert("Could not save output" + JSON.stringify(error));
          });
        }
      } else {
        if (content.id !== undefined) {
          var _quality2 = Object.assign({}, this.state.quality, _defineProperty({}, this.state.details.field, this.state.quality[this.state.details.field].map(function (item) {
            return item.id === content.id ? Object.assign({}, item, content, { _progress: "dependencies" }) : item;
          })));
          this.setState({ quality: _quality2, details: undefined, modified: true });
        } else {
          var _quality3 = Object.assign({}, this.state.quality, _defineProperty({}, this.state.details.field, this.state.quality[this.state.details.field].concat(Object.assign({}, content, { id: _uuid2.default.v4(), _progress: "dependencies" }))));
          this.setState({ quality: _quality3, details: undefined, modified: true });
        }
      }
    }
  }, {
    key: 'canceledDetails',
    value: function canceledDetails() {
      this.setState({ details: undefined });
    }
  }, {
    key: 'deleteOutput',
    value: function deleteOutput(item) {
      var _this13 = this;

      var field = this.state.details.field.split(".");
      (0, _sendCommand2.default)({ type: "deleteOutput", project: { id: this.props.project.id }, parent: field[1], item: { id: item.id } }).then(function (response) {
        _this13.setState({
          quality: Object.assign({}, _this13.state.quality, { scopeDetails: response.quality }),
          lastSaved: Object.assign({}, _this13.state.quality, { scopeDetails: response.quality }),
          details: undefined,
          modified: false });
      }).catch(function (error) {
        alert("Could not delete output" + JSON.stringify(error));
      });
    }
  }, {
    key: 'showOutputSummary',
    value: function showOutputSummary(tab, details) {
      var _this14 = this;

      return _react2.default.createElement(OutputSummary, _extends({}, this.props, details.values, {
        scopeEntry: this.state.quality.scopeDetails.filter(function (entry) {
          return entry.id === _this14.state.details.field.split(".")[1];
        })[0] }));
    }
  }, {
    key: 'handleOutputFieldChange',
    value: function handleOutputFieldChange(fieldName) {
      var _this15 = this;

      return function (event) {
        var updatedDetails = Object.assign({}, _this15.state.details, {
          item: Object.assign({}, _this15.state.details.item, _defineProperty({}, fieldName, event.target.value))
        });
        _this15.setState({
          details: updatedDetails
        });
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this16 = this;

      var labels = translations.getTranslation(this.props);
      var areas = translations.createTranslatedForm(_formDefinition2.default, this.props.language, this.props.variant).filter(function (area) {
        return area.name === "projectProductDescription" || _this16.props.showApproach;
      });

      return _react2.default.createElement(
        'div',
        { style: { marginTop: 20, display: "flex", justifyContent: "center", flexWarp: "wrap" } },
        _react2.default.createElement(
          'div',
          { style: { width: 1016, paddingBottom: 30 } },
          this.state.details !== undefined ? _react2.default.createElement(_AreaForm2.default, _extends({ key: 'details'
          }, this.props, {
            display: 'tab',
            areas: translations.createTranslatedForm(this.state.details.form, this.props.language, this.props.variant),
            item: this.state.details.item,
            selected: 0,
            label: labels.general.output,
            onUpdate: this.updateDetails.bind(this),
            modified: true,
            onCancel: this.canceledDetails.bind(this),
            summary: this.showOutputSummary.bind(this),
            handleFieldChange: this.handleOutputFieldChange.bind(this),
            onDelete: this.deleteOutput.bind(this)
          })) : _react2.default.createElement(_AreaForm2.default, _extends({ key: 'quality'
          }, this.props, {
            display: this.props.editOutput ? "normal" : "tab",
            areas: areas,
            item: this.state.quality,
            label: labels.general.approach,
            selected: this.state.selected,
            onUpdate: this.update.bind(this),
            modified: this.state.modified,
            handleFieldChange: this.handleFieldChange.bind(this),
            onCancel: function onCancel() {
              return window.location = ".";
            },
            summary: function summary(tab) {
              return _react2.default.createElement(
                'i',
                null,
                labels[tab].description
              );
            },
            onAddEntry: this.showDetails.bind(this),
            onEditEntry: this.showDetails.bind(this)
          }))
        )
      );
    }
  }]);

  return ProjectProductDescription;
}(_react2.default.Component);

var ProjectProductDescriptionPage = function (_React$Component9) {
  _inherits(ProjectProductDescriptionPage, _React$Component9);

  function ProjectProductDescriptionPage() {
    _classCallCheck(this, ProjectProductDescriptionPage);

    return _possibleConstructorReturn(this, (ProjectProductDescriptionPage.__proto__ || Object.getPrototypeOf(ProjectProductDescriptionPage)).apply(this, arguments));
  }

  _createClass(ProjectProductDescriptionPage, [{
    key: 'render',
    value: function render() {
      var menu = this.props.showMenu === true ? _react2.default.createElement(_ProjectMenu2.default, this.props) : undefined;
      return _react2.default.createElement(
        _Layout2.default,
        _extends({}, this.props, { projectMenu: menu }),
        _react2.default.createElement(ProjectProductDescription, this.props)
      );
    }
  }]);

  return ProjectProductDescriptionPage;
}(_react2.default.Component);

exports.default = ProjectProductDescriptionPage;

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _outputFormDefinition = __webpack_require__(1083);

var _outputFormDefinition2 = _interopRequireDefault(_outputFormDefinition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [{
  name: "projectProductDescription",
  hideButtons: true,
  fields: [{
    name: "scopeDetails",
    type: "multiTable",
    options: {
      addEntry: {
        formDefinition: _outputFormDefinition2.default
      },
      edit: {
        formDefinition: _outputFormDefinition2.default
      }
    },
    columns: [{ name: "output", dragable: true }, { name: "qualityExpectation" }, { name: "acceptanceCriteria" }, { name: "acceptanceMethod" }]
  }]
}, {
  name: "qualityManagementApproach",
  fields: [{ name: "process", height: 5 }, { name: "tools", height: 2 }, { name: "reporting", height: 3 }, { name: "timing", height: 2 }, { name: "roles", height: 2 }] //,
  /*
    {
      name:"products",
    },
    {
      name:"qualityRegister",
    }
  */
}];

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  name: "output",
  fields: [{ name: "output", height: 3 }, { name: "qualityExpectation", height: 3 }]
}, {
  name: "acceptance",
  fields: [{ name: "acceptanceCriteria", height: 3 }, { name: "acceptanceMethod", height: 3 }, { name: "acceptanceResponsible", height: 3 }]
}, {
  name: "dependencies",
  fields: [{ name: "derivation", height: 3 }, { name: "skills", height: 3 }]
}];

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BusinessCase = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _uuid = __webpack_require__(26);

var _uuid2 = _interopRequireDefault(_uuid);

var _AreaForm = __webpack_require__(28);

var _AreaForm2 = _interopRequireDefault(_AreaForm);

var _ProjectMenu = __webpack_require__(17);

var _ProjectMenu2 = _interopRequireDefault(_ProjectMenu);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _FormattedContent = __webpack_require__(15);

var _FormattedContent2 = _interopRequireDefault(_FormattedContent);

var _sendCommand = __webpack_require__(25);

var _sendCommand2 = _interopRequireDefault(_sendCommand);

var _formDefinition = __webpack_require__(1085);

var _formDefinition2 = _interopRequireDefault(_formDefinition);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(435), __webpack_require__(436)]);

var BenefitSummary = function (_React$Component) {
  _inherits(BenefitSummary, _React$Component);

  function BenefitSummary() {
    _classCallCheck(this, BenefitSummary);

    return _possibleConstructorReturn(this, (BenefitSummary.__proto__ || Object.getPrototypeOf(BenefitSummary)).apply(this, arguments));
  }

  _createClass(BenefitSummary, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      return _react2.default.createElement(
        'div',
        { style: { fontFamily: "Arial, Verdana, Geneva, sans-serif", fontSize: "10pt", fontStyle: "italic" } },
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            labels.strategy.fields.reasons.title
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(_FormattedContent2.default, { value: this.props.reasons })
        ),
        _react2.default.createElement(
          'b',
          null,
          labels.options.title
        ),
        _react2.default.createElement(
          'table',
          null,
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              { style: { backgroundColor: "#7f7f7f", color: "white" } },
              _react2.default.createElement(
                'th',
                null,
                labels.options.fields.doNothing.title
              ),
              _react2.default.createElement(
                'th',
                null,
                labels.options.fields.doMinimal.title
              ),
              _react2.default.createElement(
                'th',
                null,
                labels.options.fields.doSomething.title
              )
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            _react2.default.createElement(
              'tr',
              { style: { backgroundColor: "#f5f5f5" } },
              _react2.default.createElement(
                'td',
                { style: { verticalAlign: "top" } },
                _react2.default.createElement(_FormattedContent2.default, { value: this.props.doNothing })
              ),
              _react2.default.createElement(
                'td',
                { style: { verticalAlign: "top" } },
                _react2.default.createElement(_FormattedContent2.default, { value: this.props.doMinimal })
              ),
              _react2.default.createElement(
                'td',
                { style: { verticalAlign: "top" } },
                _react2.default.createElement(_FormattedContent2.default, { value: this.props.doSomething })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 10 } },
          _react2.default.createElement(
            'b',
            null,
            labels.benefits.title
          ),
          _react2.default.createElement('br', null),
          this.props.benefits !== undefined && this.props.benefits.length > 0 ? _react2.default.createElement(
            'ul',
            null,
            this.props.benefits.map(function (benefit) {
              return _react2.default.createElement(
                'li',
                { key: benefit.title },
                benefit.title
              );
            })
          ) : null
        ),
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 10 } },
          _react2.default.createElement(
            'b',
            null,
            labels.returnOnInvestment.title
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_FormattedContent2.default, { value: this.props.projectPlanSummary })
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_FormattedContent2.default, { value: this.props.investmentAppraisal })
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_FormattedContent2.default, { value: this.props.risks })
          )
        )
      );
    }
  }]);

  return BenefitSummary;
}(_react2.default.Component);

var BusinessCase = exports.BusinessCase = function (_React$Component2) {
  _inherits(BusinessCase, _React$Component2);

  function BusinessCase(props) {
    _classCallCheck(this, BusinessCase);

    var _this2 = _possibleConstructorReturn(this, (BusinessCase.__proto__ || Object.getPrototypeOf(BusinessCase)).call(this, props));

    var businessCase = Object.assign({}, _this2.props.project.businessCase, {
      id: _this2.props.project.businessCase !== undefined ? "definedBusinessCase" : undefined,
      _progress: "summary"
    });
    if (businessCase.benefits === undefined) {
      businessCase.benefits = [];
    }

    _this2.state = {
      businessCase: businessCase,
      lastSaved: businessCase,
      selected: 0
    };
    _this2.warningOnLeave = _this2.changeWarningOnLeave.bind(_this2);
    return _this2;
  }

  _createClass(BusinessCase, [{
    key: 'showDetails',
    value: function showDetails(details) {
      this.setState({ details: details });
    }
  }, {
    key: 'updateDetails',
    value: function updateDetails(content) {
      if (content.id !== undefined) {
        var businessCase = Object.assign({}, this.state.businessCase, _defineProperty({}, this.state.details.field, this.state.businessCase[this.state.details.field].map(function (item) {
          return item.id === content.id ? Object.assign({}, item, content) : item;
        })));
        this.setState({ businessCase: businessCase, details: undefined, selected: 2, modified: true });
      } else {
        var _businessCase = Object.assign({}, this.state.businessCase, _defineProperty({}, this.state.details.field, this.state.businessCase[this.state.details.field].concat(Object.assign({}, content, { id: _uuid2.default.v4() }))));
        this.setState({ businessCase: _businessCase, details: undefined, selected: 2, modified: true });
      }
    }
  }, {
    key: 'canceledDetails',
    value: function canceledDetails() {
      this.setState({ details: undefined });
    }
  }, {
    key: 'showSummary',
    value: function showSummary(tab, details) {
      return tab === "summary" ? _react2.default.createElement(BenefitSummary, _extends({}, this.props, details.values)) : null;
    }
  }, {
    key: 'updateBusinessCase',
    value: function updateBusinessCase(businessCase) {
      var _this3 = this;

      var updatedBusinessCase = Object.assign({}, this.state.businessCase, {
        _progress: undefined,
        benefits: this.state.businessCase.benefits !== undefined ? this.state.businessCase.benefits.map(function (item) {
          return Object.assign({}, item, { _progress: undefined });
        }) : undefined
      });
      (0, _sendCommand2.default)({ type: "updateBusinessCase", project: { id: this.props.project.id }, businessCase: updatedBusinessCase }).then(function (response) {
        _this3.setState({
          businessCase: Object.assign({}, _this3.state.businessCase, {
            id: "definedBusinessCase",
            _currentProgress: businessCase._progress
          }),
          modified: undefined,
          lastSaved: _this3.state.businessCase
        });
      }).catch(function (error) {
        alert("Could not save business case, got " + error + " " + error.stack + " " + JSON.stringify(error));
      });
    }
  }, {
    key: 'handleFieldChange',
    value: function handleFieldChange(fieldName) {
      var _this4 = this;

      return function (event) {
        var labels = translations.getTranslation(_this4.props);
        var value = event.target.value;
        _this4.setState({
          businessCase: Object.assign({}, _this4.state.businessCase, _defineProperty({}, event.target.name, value)),
          modified: true
        });
      };
    }
  }, {
    key: 'hasChanged',
    value: function hasChanged(lastSaved) {
      var _this5 = this;

      return _formDefinition2.default.map(function (area) {
        return area.fields !== undefined && area.fields.map(function (field) {
          return JSON.stringify(lastSaved[field.name]) !== JSON.stringify(_this5.state.businessCase[field.name]);
        }).reduce(function (value, result) {
          return result || value;
        });
      }).reduce(function (value, result) {
        return result || value;
      });
    }
  }, {
    key: 'changeWarningOnLeave',
    value: function changeWarningOnLeave(e) {
      if (this.hasChanged(this.state.lastSaved)) {
        e.returnValue = "Do you want to keep changes?";
        return "Do you want to keep changes?";
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      console.log("Mount warning");
      window.addEventListener("beforeunload", this.warningOnLeave);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener("beforeunload", this.warningOnLeave);
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).general;
      return _react2.default.createElement(
        'div',
        { style: { paddingTop: 20, display: "flex", justifyContent: "center" } },
        _react2.default.createElement(
          'div',
          { style: { width: 1016 } },
          this.state.details !== undefined ? _react2.default.createElement(_AreaForm2.default, _extends({ key: 'details'
          }, this.props, {
            display: 'tab',
            areas: translations.createTranslatedForm(this.state.details.form, this.props.language, this.props.variant),
            item: this.state.details.item,
            selected: 0,
            label: labels.benefit,
            onUpdate: this.updateDetails.bind(this),
            modified: true,
            onCancel: this.canceledDetails.bind(this)
          })) : _react2.default.createElement(_AreaForm2.default, _extends({ key: 'businessCase'
          }, this.props, {
            areas: translations.createTranslatedForm(_formDefinition2.default, this.props.language, this.props.variant),
            display: 'tab',
            item: this.state.businessCase,
            selected: this.state.selected,
            modified: this.state.modified,
            label: translations.getTranslation(this.props).general.businessCase,
            handleFieldChange: this.handleFieldChange.bind(this),
            onUpdate: this.updateBusinessCase.bind(this),
            onAddEntry: this.showDetails.bind(this),
            onEditEntry: this.showDetails.bind(this),
            summary: this.showSummary.bind(this),
            onCancel: function onCancel() {
              return window.location = ".";
            }
          }))
        )
      );
    }
  }]);

  return BusinessCase;
}(_react2.default.Component);

var BusinessCasePage = function (_React$Component3) {
  _inherits(BusinessCasePage, _React$Component3);

  function BusinessCasePage() {
    _classCallCheck(this, BusinessCasePage);

    return _possibleConstructorReturn(this, (BusinessCasePage.__proto__ || Object.getPrototypeOf(BusinessCasePage)).apply(this, arguments));
  }

  _createClass(BusinessCasePage, [{
    key: 'render',
    value: function render() {
      var menu = this.props.showMenu === true ? _react2.default.createElement(_ProjectMenu2.default, this.props) : undefined;
      return _react2.default.createElement(
        _Layout2.default,
        _extends({}, this.props, { projectMenu: menu }),
        _react2.default.createElement(BusinessCase, this.props)
      );
    }
  }]);

  return BusinessCasePage;
}(_react2.default.Component);

exports.default = BusinessCasePage;

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _benefitFormDefinition = __webpack_require__(1086);

var _benefitFormDefinition2 = _interopRequireDefault(_benefitFormDefinition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [{
  name: "strategy",
  fields: [{ name: "reasons", height: 5 }]
}, {
  name: "options",
  fields: [{ name: "doNothing", height: 5 }, { name: "doMinimal", optional: true, height: 5 }, { name: "doSomething", height: 5 }]
}, {
  name: "benefits",
  fields: [{
    name: "benefits",
    type: "table",
    options: {
      addEntry: {
        formDefinition: _benefitFormDefinition2.default
      },
      edit: {
        formDefinition: _benefitFormDefinition2.default
      }
    },
    columns: [{ name: "no", priority: true }, { name: "title", dragable: true }, { name: "baseline" }, { name: "goal" }, { name: "accountable" }],
    samples: [{ id: 1, no: "1", benefit: "My benefit", baseline: "The baseline", goal: "My goal", accountable: "me" }]
  }]

}, {
  name: "returnOnInvestment",
  fields: [{ name: "projectPlanSummary", height: 5 }, { name: "investmentAppraisal", height: 5 }, { name: "risks", height: 5 }]
}, {
  name: "summary",
  fields: [{ name: "executiveSummary", height: 8 }]
}];

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  name: "benefitDetails",
  fields: [{ name: "title" }, { name: "accountable" }, { name: "measurement", height: 3 }, { name: "actions", height: 3 }, { name: "baseline" }, { name: "goal" }]
}];

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stageFormDefinition = __webpack_require__(437);

var _stageFormDefinition2 = _interopRequireDefault(_stageFormDefinition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lessonEntry = [{
  name: "summary",
  fields: [{ name: "title" }, { name: "type", options: [{ value: "project" },
    //        {value:"program"},
    { value: "portfolio" }, { value: "corporate" }] }, { name: "priority", options: [{ value: "high" }, { value: "medium" }, { value: "low" }], defaultValue: "medium" }]
}, {
  name: "detail",
  fields: [{ name: "effect", height: 2, plainText: true }, { name: "event", height: 2, plainText: true }, { name: "cause", height: 2, plainText: true }, { name: "description", height: 2, optional: true }]
}, {
  name: "followUp",
  fields: [{ name: "indicators", height: 2 }, { name: "recommendations", height: 2 }]
}];

exports.default = [{
  name: "planApproach",
  fields: [{ name: "methods", height: 3 }, { name: "resources", height: 3 }, { name: "technology", height: 3 }, { name: "rollOut", height: 3 }, { name: "other", height: 3 }]
}, {
  name: "schedule",
  hideButtons: true,
  fields: [{
    name: "schedule",
    optional: true,
    type: "multiTable",
    options: {
      addEntry: {
        formDefinition: _stageFormDefinition2.default
      },
      edit: {
        formDefinition: _stageFormDefinition2.default
      },
      summaryRow: {
        editable: false
      }
    },
    columnHeaders: [{ name: "stage", columns: 1 }, { name: "time", columns: 3 }, { name: "cost", columns: 5 }],
    columns: [{ name: "name" }, { name: "start", type: "date" }, { name: "end", type: "date" }, { name: "timeTolerance" }, { name: "hours" }, { name: "expences" }, { name: "investments" }, { name: "sum" }, { name: "costTolerance" }]
  }]
}, {
  name: "lessons",
  hideButtons: true,
  fields: [{
    name: "lessonLog",
    type: "table",
    columns: [{ name: "no", priority: true }, { name: "title" }, { name: "priorityLabel" }, { name: "recommendations" }],
    options: {
      addEntry: {
        formDefinition: lessonEntry
      },
      edit: {
        formDefinition: lessonEntry
      }
    }
  }]
}, {
  name: "projectControls",
  fields: [{ name: "projectControls", height: 8 }]
}];

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var definition = __webpack_require__(177).english;
var quality = __webpack_require__(261).english;
var plan = __webpack_require__(58).english;
var businessCase = __webpack_require__(435).english;
var org = __webpack_require__(173).english;

var english = exports.english = {
  menu: {
    reportActions: "Report Actions",
    viewFullScreen: "View full screen",
    tableView: "Show table view",
    reportView: "Show report view",
    viewPDF: "View PDF",
    viewWord: "Download as Word (docx)",
    viewSlideMode: "View slide mode",
    createDraft: "Create draft",
    updateDraft: "Update draft",
    approve: "Approve",
    documentArchive: "Document archive",
    current: "Current",
    draft: "draft",
    briefDetailsIsFollowedUpInPID: "No changes will be reflected in this Brief, as a Project Initiation Document is created."
  },
  brief: {
    title: "Project Brief",
    messagePreview: "Preview",
    messageDraft: "Draft",
    frontPage: "Front Page"
  },
  definition: {
    title: "Definition",
    background: {
      title: definition.background.title
    },
    objectives: {
      title: definition.objectives.title,
      aspects: definition.aspects,
      columns: definition.objectives.fields.objectivesSummary.columns
    },
    scope: {
      title: definition.scope.title,
      outcomes: definition.scope.fields.outcomes,
      excluded: definition.scope.fields.scopeExclusions
    },
    constraints: {
      title: definition.constraints.fields.constraints.title
    },
    assumptions: {
      title: definition.constraints.fields.assumptions.title
    },
    stakeholders: {
      title: definition.stakeholders.fields.stakeholderDescription.title
    },
    interfaces: {
      title: definition.stakeholders.fields.interfaces.title
    }
  },
  businessCase: {
    title: "Business Case",
    executiveSummary: businessCase.summary.fields.executiveSummary.title,
    reasons: businessCase.strategy.fields.reasons.title,
    doNothing: businessCase.options.fields.doNothing.title,
    doMinimal: businessCase.options.fields.doMinimal.title,
    doSomething: businessCase.options.fields.doSomething.title,
    benefits: {
      title: businessCase.benefits.fields.benefits.title,
      columns: businessCase.benefits.fields.benefits.columns
    },
    projectPlanSummary: businessCase.returnOnInvestment.fields.projectPlanSummary.title,
    investmentAppraisal: businessCase.returnOnInvestment.fields.investmentAppraisal.title,
    risks: businessCase.returnOnInvestment.fields.risks.title
  },
  projectProductDescription: {
    title: "Project Product Description",
    noOutputs: "No outputs defined.",
    columns: quality.projectProductDescription.fields.scopeDetails.columns
  },
  approach: {
    title: "Project Approach",
    methods: plan.planApproach.fields.methods.title,
    resources: plan.planApproach.fields.resources.title,
    technology: plan.planApproach.fields.technology.title,
    rollOut: plan.planApproach.fields.rollOut.title,
    other: plan.planApproach.fields.other.title
  },
  organization: {
    title: "Organization",
    columns: {
      name: "Name",
      role: "Role",
      description: "Description"
    },
    executive: org.roles.project.executive,
    seniorUser: org.roles.project.seniorUser,
    seniorSupplier: org.roles.project.seniorSupplier,
    businessAssurance: org.roles.project.businessAssurance,
    projectManager: org.roles.project.projectManager,
    teamManager: org.roles.project.teamManager,
    projectSupport: org.roles.project.projectSupport,
    changeAuthority: org.roles.project.changeAuthority,
    stakeholder: org.roles.project.stakeholder,
    userAssurance: org.roles.project.userAssurance,
    supplierAssurance: org.roles.project.supplierAssurance,
    teamMember: org.roles.project.teamMember
  },
  approval: {
    fields: {
      approvedBy: {
        title: "Approved by",
        description: "Describe by whom and when the document was approved"
      }
    },
    cancel: "Cancel",
    approve: "Approve Project Brief",
    thisFieldIsRequired: "This field is required."
  }
};

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var definition = __webpack_require__(178).norwegian;
var quality = __webpack_require__(262).norwegian;
var plan = __webpack_require__(59).norwegian;
var businessCase = __webpack_require__(436).norwegian;
var org = __webpack_require__(174).norwegian;

var norwegian = exports.norwegian = {
  menu: {
    reportActions: "Rapportvalg",
    viewFullScreen: "Vis i fullskjerm",
    tableView: "Vis med tabelloppsett",
    reportView: "Vis med rapportoppsett",
    viewPDF: "Vis som PDF",
    viewWord: "Last ned som Word (docx)",
    viewSlideMode: "Vis som lysbilde",
    createDraft: "Opprett utkast",
    updateDraft: "Oppdater utkast",
    approve: "Godkjenn",
    documentArchive: "Dokumentarkiv",
    current: "Gjeldende",
    draft: "utkast",
    briefDetailsIsFollowedUpInPID: "Ingen endringer vil bli oppdatert i dette Prosjektforslaget, da et Styringsdokument er påbegynt."
  },
  brief: {
    title: "Prosjektforslag",
    messagePreview: "Forhåndsvisning",
    messageDraft: "Utkast",
    frontPage: "Forside"
  },
  definition: {
    title: "Prosjektdefinisjon",
    background: {
      title: definition.background.title
    },
    objectives: {
      title: definition.objectives.title,
      aspects: definition.aspects,
      columns: { // definition.objectives.fields.objectivesSummary.columns
        name: { title: "Område" },
        description: { title: "Beskrivelse" },
        tolerance: definition.objectives.fields.objectivesSummary.columns.tolerance
      }
    },
    scope: {
      title: definition.scope.title,
      outcomes: definition.scope.fields.outcomes,
      excluded: definition.scope.fields.scopeExclusions
    },
    constraints: {
      title: definition.constraints.fields.constraints.title
    },
    assumptions: {
      title: definition.constraints.fields.assumptions.title
    },
    stakeholders: {
      title: definition.stakeholders.fields.stakeholderDescription.title
    },
    interfaces: {
      title: definition.stakeholders.fields.interfaces.title
    }
  },
  businessCase: {
    title: "Begrunnelse",
    executiveSummary: businessCase.summary.fields.executiveSummary.title,
    reasons: businessCase.strategy.fields.reasons.title,
    doNothing: businessCase.options.fields.doNothing.title,
    doMinimal: businessCase.options.fields.doMinimal.title,
    doSomething: businessCase.options.fields.doSomething.title,
    benefits: {
      title: businessCase.benefits.fields.benefits.title,
      columns: businessCase.benefits.fields.benefits.columns
    },
    projectPlanSummary: businessCase.returnOnInvestment.fields.projectPlanSummary.title,
    investmentAppraisal: businessCase.returnOnInvestment.fields.investmentAppraisal.title,
    risks: businessCase.returnOnInvestment.fields.risks.title
  },
  projectProductDescription: {
    title: "Leveranser",
    noOutputs: "Ingen leveranser er definert.",
    columns: quality.projectProductDescription.fields.scopeDetails.columns
  },
  approach: {
    title: "Prosjekttilnærming",
    methods: plan.planApproach.fields.methods.title,
    resources: plan.planApproach.fields.resources.title,
    technology: plan.planApproach.fields.technology.title,
    rollOut: plan.planApproach.fields.rollOut.title,
    other: plan.planApproach.fields.other.title
  },
  organization: {
    title: "Organisering",
    columns: {
      name: "Navn",
      role: "Rolle",
      description: "Beskrivelse"
    },
    executive: org.roles.project.executive,
    seniorUser: org.roles.project.seniorUser,
    seniorSupplier: org.roles.project.seniorSupplier,
    businessAssurance: org.roles.project.businessAssurance,
    projectManager: org.roles.project.projectManager,
    teamManager: org.roles.project.teamManager,
    projectSupport: org.roles.project.projectSupport,
    changeAuthority: org.roles.project.changeAuthority,
    stakeholder: org.roles.project.stakeholder,
    userAssurance: org.roles.project.userAssurance,
    supplierAssurance: org.roles.project.supplierAssurance,
    teamMember: org.roles.project.teamMember
  },
  approval: {
    fields: {
      approvedBy: {
        title: "Godkjent av",
        description: "Beskriv av hvem og når dokumentet ble godkjent"
      }
    },
    cancel: "Avbryt",
    approve: "Godkjenn prosjektforslaget",
    thisFieldIsRequired: "Dette feltet er påkrevd."
  }
};

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var english_productPlan = exports.english_productPlan = {
  approval: {
    fields: {
      approvedBy: {
        title: "Updated by"
      }
    }
  }
};

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
let translations=new Translations([
    require('./labels/english.js'),
    require('./labels/norwegian.js')
  ]);
*/

var ReleaseImplementationMethod = function (_React$Component) {
  _inherits(ReleaseImplementationMethod, _React$Component);

  function ReleaseImplementationMethod(props) {
    _classCallCheck(this, ReleaseImplementationMethod);

    var _this = _possibleConstructorReturn(this, (ReleaseImplementationMethod.__proto__ || Object.getPrototypeOf(ReleaseImplementationMethod)).call(this, props));

    _this.state = { method: "product", projects: props.projects };
    return _this;
  }

  _createClass(ReleaseImplementationMethod, [{
    key: 'loadProjects',
    value: function loadProjects() {
      var _this2 = this;

      if (this.state.projects === undefined) {
        this.setState({ pending: true });
        fetch("/projects/" + (this.props.product.portfolio !== undefined ? "?portfolio=" + this.props.product.portfolio : "")).then(function (response) {
          return response.json();
        }).then(function (projects) {
          _this2.setState({ projects: projects, panding: false });
        }).catch(function (error) {
          console.log("[ERROR] Not able to load projects, got" + error);
          alert("An error occured while fetching existing projects, please try again");
        });
      }
    }
  }, {
    key: 'submit',
    value: function submit(event) {
      event.preventDefault();
      console.log("Set implementation method to: " + event.target.elements.method.value);
      this.props.onChange(event.target.elements.method.value, event.target.elements.implementationProject !== undefined ? event.target.elements.implementationProject.value : undefined);
    }
  }, {
    key: 'setProductMethod',
    value: function setProductMethod(event) {
      this.setState({ method: "product" });
    }
  }, {
    key: 'setProjectMethod',
    value: function setProjectMethod(event) {
      this.setState({ method: "project" });
      this.loadProjects();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'form',
        { onSubmit: this.submit.bind(this) },
        _react2.default.createElement(
          'h2',
          null,
          'Select Release Implementation Method'
        ),
        _react2.default.createElement(
          'i',
          null,
          'A release can be implemented in a permanent product team using Product Management/Ownership as method, or it can be implemented as part of a project using Project Management as method.'
        ),
        _react2.default.createElement(
          'div',
          { style: { display: "flex", justifyContent: "space-around", paddingTop: 20 } },
          _react2.default.createElement(
            'div',
            { style: { backgroundColor: this.state.method === "product" ? "lightblue" : undefined, borderRadius: 10, padding: 10 } },
            _react2.default.createElement('input', { onChange: this.setProductMethod.bind(this), type: 'radio', name: 'method', value: 'product', defaultChecked: true, id: 'product' }),
            _react2.default.createElement(
              'span',
              null,
              ' '
            ),
            _react2.default.createElement(
              'label',
              { htmlFor: 'product', style: { fontWeight: this.state.method === "product" ? "bold" : undefined } },
              'Product Management'
            ),
            _react2.default.createElement(
              'div',
              { style: { fontStyle: "italic", paddingTop: 15 } },
              'Use Product Management if',
              _react2.default.createElement(
                'ul',
                null,
                [{
                  title: "The team needed is co-located, small and permanent"
                }, {
                  title: "Context is straight forward",
                  items: ["Few stakeholders", "Few interfaces", "Matching competency"]
                }, {
                  title: "There is high degree of certainty",
                  items: ["Clarity in scope", "High stakeholder risk apatite", "Technology is well understood"]
                }].map(function (item) {
                  return _react2.default.createElement(
                    'li',
                    null,
                    item.title,
                    item.items !== undefined ? _react2.default.createElement(
                      'ul',
                      null,
                      item.items.map(function (item) {
                        return _react2.default.createElement(
                          'li',
                          null,
                          item
                        );
                      })
                    ) : null
                  );
                })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { backgroundColor: this.state.method === "project" ? "lightblue" : undefined, borderRadius: 10, padding: 10 } },
            _react2.default.createElement('input', { onChange: this.setProjectMethod.bind(this), ref: 'projectMethod', type: 'radio', name: 'method', value: 'project', id: 'project' }),
            _react2.default.createElement(
              'span',
              null,
              ' '
            ),
            _react2.default.createElement(
              'label',
              { htmlFor: 'project', style: { fontWeight: this.state.method === "project" ? "bold" : undefined } },
              'Project Management'
            ),
            _react2.default.createElement(
              'div',
              { style: { display: this.state.method === "project" ? undefined : "none", paddingTop: 5 } },
              _react2.default.createElement(
                'b',
                null,
                'Select project:'
              ),
              ' ',
              _react2.default.createElement('br', null),
              this.state.projects !== undefined ? _react2.default.createElement(
                'select',
                { name: 'implementationProject' },
                _react2.default.createElement(
                  'option',
                  null,
                  '(select existing project)'
                ),
                this.state.projects.map(function (project) {
                  return _react2.default.createElement(
                    'option',
                    { value: project.id },
                    project.name
                  );
                })
              ) : this.state.pending ? _react2.default.createElement(
                'span',
                { style: { border: "solid 1px red", padding: 1 } },
                _react2.default.createElement(
                  'i',
                  null,
                  'Loading projects, please wait ...'
                )
              ) : _react2.default.createElement(
                'span',
                null,
                'No projects available, please ',
                _react2.default.createElement(
                  'a',
                  { href: '/add' },
                  'add project'
                ),
                ' first'
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { fontStyle: "italic", paddingTop: 15 } },
              'Use Project Management if',
              _react2.default.createElement(
                'ul',
                null,
                [{
                  title: "A team is needed that is",
                  item: ["Temporary", "Large", "Spread across functions or sites"]
                }, {
                  title: "Context is complex",
                  items: ["Many stakeholders", "Many interfaces", "Low matching competency"]
                }, {
                  title: "There is a degree of uncertainty",
                  items: ["Unclarity in scope", "Low stakeholder risk apatite", "Technology is not well understood"]
                }].map(function (item) {
                  return _react2.default.createElement(
                    'li',
                    null,
                    item.title,
                    item.items !== undefined ? _react2.default.createElement(
                      'ul',
                      null,
                      item.items.map(function (item) {
                        return _react2.default.createElement(
                          'li',
                          null,
                          item
                        );
                      })
                    ) : null
                  );
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 15 } },
          _react2.default.createElement('input', { type: 'submit', className: 'save', value: 'Make Release Active' }),
          _react2.default.createElement(
            'a',
            { href: '#', onClick: this.props.onCancel },
            'Cancel'
          )
        )
      );
    }
  }]);

  return ReleaseImplementationMethod;
}(_react2.default.Component);

exports.default = ReleaseImplementationMethod;

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

var _sendCommand = __webpack_require__(25);

var _sendCommand2 = _interopRequireDefault(_sendCommand);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
let translations=new Translations([
    require('./labels/english.js'),
    require('./labels/norwegian.js')
  ]);
*/

var ReleaseFlow = function (_React$Component) {
  _inherits(ReleaseFlow, _React$Component);

  function ReleaseFlow() {
    _classCallCheck(this, ReleaseFlow);

    return _possibleConstructorReturn(this, (ReleaseFlow.__proto__ || Object.getPrototypeOf(ReleaseFlow)).apply(this, arguments));
  }

  _createClass(ReleaseFlow, [{
    key: 'completeRelease',
    value: function completeRelease(event) {
      if (this.props.onComplete) {
        this.props.onComplete();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.release.historic === true ? _react2.default.createElement(
        'div',
        null,
        this.props.release.method === "product" ? _react2.default.createElement(
          'a',
          { href: "/releases/" + this.props.release.id },
          'Go to release'
        ) : null,
        this.props.release.method === "project" ? _react2.default.createElement(
          'a',
          { href: "/projects/" + this.props.release.implementationProject.id },
          'Go to project'
        ) : null
      ) : this.props.release.active !== true ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'a',
          { href: '#', onClick: this.props.activate },
          'Make Release active'
        )
      ) : _react2.default.createElement(
        'div',
        null,
        this.props.disableEdit !== true ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'a',
            { href: '#', onClick: this.completeRelease.bind(this) },
            'Set Completed'
          )
        ) : null,
        this.props.release.method === "product" ? _react2.default.createElement(
          'a',
          { href: "/releases/" + this.props.release.id },
          'Go to release'
        ) : null,
        this.props.release.method === "project" ? _react2.default.createElement(
          'a',
          { href: "/projects/" + this.props.release.implementationProject.id },
          'Go to project'
        ) : null
      );
    }
  }]);

  return ReleaseFlow;
}(_react2.default.Component);

exports.default = ReleaseFlow;

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LessonStatement = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _AreaForm = __webpack_require__(28);

var _FormattedContent = __webpack_require__(15);

var _FormattedContent2 = _interopRequireDefault(_FormattedContent);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(58), __webpack_require__(59)]);

var actionTranslations = new _translations2.default([__webpack_require__(113), __webpack_require__(114)]);

var LessonStatement = exports.LessonStatement = function (_React$Component) {
  _inherits(LessonStatement, _React$Component);

  function LessonStatement() {
    _classCallCheck(this, LessonStatement);

    return _possibleConstructorReturn(this, (LessonStatement.__proto__ || Object.getPrototypeOf(LessonStatement)).apply(this, arguments));
  }

  _createClass(LessonStatement, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).general.statement;
      var lesson = this.props.lesson;
      return _react2.default.createElement(
        'div',
        { style: { fontStyle: "italic" } },
        _react2.default.createElement(
          'span',
          { style: { fontStyle: "normal" } },
          '"',
          lesson.effect,
          '"'
        ),
        _react2.default.createElement(
          'span',
          null,
          ' '
        ),
        '(',
        labels.effect,
        ')',
        _react2.default.createElement(
          'span',
          null,
          ' '
        ),
        labels.because,
        _react2.default.createElement(
          'span',
          null,
          ' '
        ),
        _react2.default.createElement(
          'span',
          { style: { fontStyle: "normal" } },
          '"',
          lesson.event,
          '"'
        ),
        _react2.default.createElement(
          'span',
          null,
          ' '
        ),
        '(',
        labels.event,
        ')',
        _react2.default.createElement(
          'span',
          null,
          '. '
        ),
        _react2.default.createElement(
          'span',
          null,
          labels.thisWasCausedBy
        ),
        _react2.default.createElement(
          'span',
          null,
          ' '
        ),
        _react2.default.createElement(
          'span',
          { style: { fontStyle: "normal" } },
          '"',
          lesson.cause,
          '"'
        ),
        _react2.default.createElement(
          'span',
          null,
          ' '
        ),
        '(',
        labels.cause,
        ')'
      );
    }
  }]);

  return LessonStatement;
}(_react2.default.Component);

var LessonActions = function (_React$Component2) {
  _inherits(LessonActions, _React$Component2);

  function LessonActions() {
    _classCallCheck(this, LessonActions);

    return _possibleConstructorReturn(this, (LessonActions.__proto__ || Object.getPrototypeOf(LessonActions)).apply(this, arguments));
  }

  _createClass(LessonActions, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var labels = actionTranslations.getTranslation(this.props).form;
      var buttonLabels = translations.getTranslation(this.props).general.lessons.actions;
      var deleteLabel = translations.getTranslation(this.props).general.lesson;
      var lesson = this.props.lesson;
      var fromThisProject = this.props.project !== undefined && lesson.source !== undefined && this.props.project.id === lesson.source.id;
      var hasAppliedLesson = this.props.project !== undefined && lesson.applied !== undefined && lesson.applied.filter(function (appliedBy) {
        return appliedBy.id === _this3.props.project.id;
      }).length > 0;
      var deleteEnabled = fromThisProject;
      var editEnabled = fromThisProject;
      var applyEnabled = !fromThisProject && !hasAppliedLesson;
      var unapplyEnabled = !fromThisProject && hasAppliedLesson;
      return _react2.default.createElement(
        'div',
        { style: { paddingTop: 30 } },
        _react2.default.createElement(
          'div',
          { style: { display: "flex", width: "100%", justifyContent: "space-between" } },
          _react2.default.createElement('input', { className: 'cancel', type: 'button', onClick: this.props.onCancel, name: 'cancel', value: labels.cancel }),
          deleteEnabled ? _react2.default.createElement(_AreaForm.DeleteItem, _extends({}, this.props, { label: deleteLabel, confirmDeleteMessage: buttonLabels.confirmDelete,
            onConfirm: this.props.onDelete })) : null,
          applyEnabled ? _react2.default.createElement('input', { onClick: this.props.onApply, className: 'save', type: 'submit', name: 'save', value: buttonLabels.applyLesson }) : unapplyEnabled ? _react2.default.createElement('input', { onClick: this.props.onUnapply, className: 'save', type: 'submit', name: 'save', value: buttonLabels.unapplyLesson }) : editEnabled ? _react2.default.createElement('input', { onClick: this.props.onEdit, className: 'save', type: 'submit', name: 'save', value: buttonLabels.editLesson }) : null
        )
      );
    }
  }]);

  return LessonActions;
}(_react2.default.Component);

var LessonDetails = function (_React$Component3) {
  _inherits(LessonDetails, _React$Component3);

  function LessonDetails() {
    _classCallCheck(this, LessonDetails);

    return _possibleConstructorReturn(this, (LessonDetails.__proto__ || Object.getPrototypeOf(LessonDetails)).apply(this, arguments));
  }

  _createClass(LessonDetails, [{
    key: 'render',
    value: function render() {
      var title = translations.getTranslation(this.props).general.lesson;
      var labels = translations.getTranslation(this.props);
      var lesson = this.props.lesson;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          null,
          lesson.title
        ),
        _react2.default.createElement(LessonStatement, this.props),
        lesson.description !== undefined && lesson.description.trim().length > 0 ? _react2.default.createElement(
          'div',
          { style: { paddingTop: 15 } },
          _react2.default.createElement(_FormattedContent2.default, { value: lesson.description })
        ) : null,
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 15 } },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'b',
              null,
              labels.followUp.fields.indicators.title
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingLeft: 10 } },
            _react2.default.createElement(_FormattedContent2.default, { value: lesson.indicators })
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 15 } },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'b',
              null,
              labels.followUp.fields.recommendations.title
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingLeft: 10 } },
            _react2.default.createElement(_FormattedContent2.default, { value: lesson.recommendations })
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 15 } },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'b',
              null,
              labels.summary.fields.type.title
            )
          ),
          labels.summary.fields.type.options[lesson.type]
        ),
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 15 } },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'b',
              null,
              labels.summary.fields.priority.title
            )
          ),
          labels.summary.fields.priority.options[lesson.priority]
        ),
        lesson.source !== undefined && lesson.source.id !== undefined ? _react2.default.createElement(
          'div',
          { style: { paddingTop: 15 } },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'b',
              null,
              labels.general.lessons.source
            )
          ),
          _react2.default.createElement(
            'a',
            { href: "/projects/" + lesson.source.id + "/" },
            lesson.source.name
          )
        ) : null,
        lesson.applied !== undefined ? _react2.default.createElement(
          'div',
          { style: { paddingTop: 15 } },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'b',
              null,
              labels.general.lessons.appliedIn
            )
          ),
          _react2.default.createElement(
            'ul',
            { style: { marginTop: 0 } },
            lesson.applied.map(function (project) {
              return _react2.default.createElement(
                'li',
                { key: project.id },
                _react2.default.createElement(
                  'a',
                  { href: "/projects/" + project.id + "/" },
                  project.name
                )
              );
            })
          )
        ) : null,
        _react2.default.createElement(LessonActions, this.props)
      );
    }
  }]);

  return LessonDetails;
}(_react2.default.Component);

exports.default = LessonDetails;

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

' use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _FormattedContent = __webpack_require__(15);

var _FormattedContent2 = _interopRequireDefault(_FormattedContent);

var _Field = __webpack_require__(36);

var _Field2 = _interopRequireDefault(_Field);

var _sendCommand = __webpack_require__(25);

var _sendCommand2 = _interopRequireDefault(_sendCommand);

var _superagent = __webpack_require__(23);

var _superagent2 = _interopRequireDefault(_superagent);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(58), __webpack_require__(59)]);

var TransitionLink = function (_React$Component) {
  _inherits(TransitionLink, _React$Component);

  function TransitionLink() {
    _classCallCheck(this, TransitionLink);

    return _possibleConstructorReturn(this, (TransitionLink.__proto__ || Object.getPrototypeOf(TransitionLink)).apply(this, arguments));
  }

  _createClass(TransitionLink, [{
    key: 'requestPhaseTransition',
    value: function requestPhaseTransition(event) {
      event.preventDefault();
      this.props.onClick(this.props.currentPhase, this.props.nextPhase);
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).general.phaseTransition;
      var nextPhase = this.props.nextPhase;
      return _react2.default.createElement(
        'a',
        { onClick: this.requestPhaseTransition.bind(this), href: '#' },
        this.props.endProject === true ? this.props.isClosing !== true ? _react2.default.createElement(
          'span',
          null,
          labels.prepareClosure
        ) : null : _react2.default.createElement(
          'span',
          null,
          this.props.type === "approve" ? _react2.default.createElement(
            'span',
            null,
            labels.requestPending,
            ' '
          ) : _react2.default.createElement(
            'span',
            null,
            labels.requestToStart,
            ' '
          ),
          nextPhase.text
        )
      );
    }
  }]);

  return TransitionLink;
}(_react2.default.Component);

var PhaseTransitionSummary = function (_React$Component2) {
  _inherits(PhaseTransitionSummary, _React$Component2);

  function PhaseTransitionSummary() {
    _classCallCheck(this, PhaseTransitionSummary);

    return _possibleConstructorReturn(this, (PhaseTransitionSummary.__proto__ || Object.getPrototypeOf(PhaseTransitionSummary)).apply(this, arguments));
  }

  _createClass(PhaseTransitionSummary, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var labels = translations.getTranslation(this.props).general.phaseTransition;
      var hasApprovedStage = this.props.project.stages !== undefined && this.props.project.stages.filter(function (stage) {
        return stage.active === true || stage.history === true;
      }).length > 0;
      var hasPhases = this.props.projectType !== undefined && this.props.projectType.phases !== undefined && this.props.projectType.phases.length > 0;
      var hasStagesOutsidePhase = this.props.schedule.filter(function (phase) {
        return phase.id === "_project" && phase.items !== undefined && phase.items.length > 0;
      })[0] !== undefined;
      var currentCalculatedPhase = this.props.schedule.filter(function (phase) {
        return phase.items !== undefined && phase.items.filter(function (item) {
          return item.active === true;
        }).length > 0;
      })[0];
      var currentPhase = hasPhases ? this.props.project.currentPhase !== undefined && hasPhases ? this.props.projectType.phases.filter(function (phase) {
        return phase.id === _this3.props.project.currentPhase.id;
      })[0] : undefined : undefined;
      var assumedCurrentPhase = false;
      /*
          if (currentPhase===undefined && currentCalculatedPhase!==undefined) {
            currentPhase=currentCalculatedPhase;
            assumedCurrentPhase=true;
          }
      */
      var nextPhase = hasPhases ? currentPhase !== undefined ? this.props.projectType.phases.slice(this.props.projectType.phases.findIndex(function (phase) {
        return phase.id === currentPhase.id;
      })).slice(1)[0] : this.props.projectType.phases[0] : undefined;
      var lastStageInPhase = currentPhase !== undefined && (currentPhase.stages === undefined || currentPhase.stages.length === 0 || currentPhase.stages.slice(-1)[0].active === true);
      var hasNextPhase = nextPhase !== undefined;
      var pendingRequest = this.props.project.requestedPhase;
      return this.props.project.isCompleted ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'b',
          null,
          'Project Completed'
        )
      ) : hasPhases ? _react2.default.createElement(
        'div',
        { style: { paddingBottom: 10, paddingTop: 5, fontFamily: "Lato" } },
        hasStagesOutsidePhase ? _react2.default.createElement(
          'div',
          { style: { color: "#212121", padding: 10, marginTop: 10, fontFamily: "Lato", textAlign: "center", backgroundColor: "#FFEADB" } },
          labels.stageOutsidePhases
        ) : currentPhase !== undefined ? _react2.default.createElement(
          'div',
          null,
          labels.currentPhase,
          ': ',
          currentPhase.text,
          ' ',
          assumedCurrentPhase === true ? _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'span',
              { style: { color: "red" } },
              '*'
            ),
            '(',
            _react2.default.createElement(
              'i',
              null,
              'calculated'
            ),
            ')'
          ) : null,
          _react2.default.createElement(
            'span',
            null,
            ' '
          ),
          _react2.default.createElement(
            'span',
            null,
            pendingRequest !== undefined ? _react2.default.createElement(
              'span',
              { style: { paddingLeft: 10 } },
              _react2.default.createElement('img', { style: { paddingRight: 10, verticalAlign: "middle" }, src: '/images/Flag_FinishGrey_22x16.gif' }),
              _react2.default.createElement(TransitionLink, _extends({}, this.props, {
                type: 'approve',
                onClick: this.props.onStartPhase,
                nextPhase: this.props.projectType.phases.find(function (phase) {
                  return phase.id === pendingRequest.id;
                }),
                currentPhase: currentPhase
              })),
              _react2.default.createElement(
                'div',
                { style: { paddingLeft: 10, paddingTop: 5, fontStyle: "italic" } },
                _react2.default.createElement(_FormattedContent2.default, { value: pendingRequest.comments })
              )
            ) : lastStageInPhase ? hasNextPhase ? _react2.default.createElement(TransitionLink, _extends({}, this.props, { nextPhase: nextPhase, currentPhase: currentPhase, onClick: this.props.onStartProject })) : this.props.project.stages !== undefined && this.props.project.stages.length > 0 && this.props.project.stages.slice(-1)[0].active === true ? this.props.project.requestedStageTransition !== undefined ? _react2.default.createElement(
              'i',
              null,
              ' Project close is requested'
            ) : _react2.default.createElement(TransitionLink, _extends({}, this.props, { endProject: true, isClosing: this.props.project.isClosing, currentPhase: currentPhase, onClick: this.props.onStartProject })) : null : "on going"
          )
        ) : _react2.default.createElement(
          'div',
          null,
          labels.projectNotStarted,
          ':',
          _react2.default.createElement(
            'span',
            null,
            ' '
          ),
          pendingRequest !== undefined ? _react2.default.createElement(
            'span',
            { style: { paddingLeft: 10 } },
            _react2.default.createElement('img', { style: { paddingRight: 10, verticalAlign: "middle" }, src: '/images/Flag_FinishGrey_22x16.gif' }),
            _react2.default.createElement(TransitionLink, _extends({}, this.props, {
              type: 'approve',
              onClick: this.props.onStartPhase,
              nextPhase: this.props.projectType.phases.find(function (phase) {
                return phase.id === pendingRequest.id;
              }),
              currentPhase: currentPhase
            })),
            _react2.default.createElement(
              'div',
              { style: { paddingLeft: 10, paddingTop: 5, fontStyle: "italic" } },
              _react2.default.createElement(_FormattedContent2.default, { value: pendingRequest.comments })
            )
          ) : _react2.default.createElement(TransitionLink, _extends({}, this.props, { nextPhase: nextPhase, onClick: this.props.onStartProject }))
        )
      ) : null;
    }
  }]);

  return PhaseTransitionSummary;
}(_react2.default.Component);

var PhaseTransition = function (_React$Component3) {
  _inherits(PhaseTransition, _React$Component3);

  function PhaseTransition(props) {
    _classCallCheck(this, PhaseTransition);

    var _this4 = _possibleConstructorReturn(this, (PhaseTransition.__proto__ || Object.getPrototypeOf(PhaseTransition)).call(this, props));

    _this4.state = { showStart: false };
    return _this4;
  }

  _createClass(PhaseTransition, [{
    key: 'startProject',
    value: function startProject(currentPhase, nextPhase) {
      var _this5 = this;

      if (nextPhase === undefined) {
        console.log("Prepare project closure");
        (0, _sendCommand2.default)({ type: "prepareProjectClosure", project: { id: this.props.project.id } }).then(function () {
          return window.location = "/projects/" + _this5.props.project.id;
        }).catch(function (error) {
          console.log("[ERROR] not able to prepare closure, got ", error);
          alert("An error occured, please try again");
        });
      } else {
        this.setState({ showStart: true, currentPhase: currentPhase, nextPhase: nextPhase });
      }
    }
  }, {
    key: 'cancelStartProject',
    value: function cancelStartProject(event) {
      event.preventDefault();
      this.setState({ showStart: false });
    }
  }, {
    key: 'startPhase',
    value: function startPhase(currentPhase, nextPhase) {
      console.log("Approve request, current: " + (currentPhase !== undefined ? currentPhase.text : "<udefinert>") + ", next:" + (nextPhase !== undefined ? nextPhase.text : "<udefinert>"));
      this.setState({ showStartPhase: true, currentPhase: currentPhase, nextPhase: nextPhase });
    }
  }, {
    key: 'requestTransition',
    value: function requestTransition(event) {
      var _this6 = this;

      event.preventDefault();
      if (this.state.nextPhase === undefined) {
        _superagent2.default.get("/projects/" + this.props.project.id + "/recommend/close?redirect=false&comments=" + event.target.elements.comments.value).then(function (response) {
          if (_this6.props.onUpdate !== undefined) {
            _this6.props.onUpdate(JSON.parse(response.text).project);
          }
        }).catch(function (error) {
          console.log("got error", error);
          alert("An error occures, please try again");
        });
      } else {
        (0, _sendCommand2.default)({
          type: "requestPhaseTransition",
          project: { id: this.props.project.id },
          phase: { id: this.state.nextPhase.id },
          comments: event.target.elements.comments.value
        }).then(function (response) {
          console.log("New state, recalculate schedule");
          if (_this6.props.onUpdate !== undefined) {
            _this6.props.onUpdate(response.project);
          }
        }).catch(function (error) {
          console.log("[ERROR] An error occured", error);
          alert("An error occured, please try again");
        });
        console.log("Send request to start phase");
      }
      this.setState({ showStart: false });
    }
  }, {
    key: 'approveRequest',
    value: function approveRequest(event) {
      var _this7 = this;

      event.preventDefault();
      console.log("Approve phase transition");
      (0, _sendCommand2.default)({
        type: "approvePhaseTransition",
        project: { id: this.props.project.id },
        phase: { id: this.state.nextPhase.id }
      }).then(function (response) {
        console.log("New state, recalculate schedule");
        if (_this7.props.onUpdate !== undefined) {
          _this7.props.onUpdate(response.project);
        }
      }).catch(function (error) {
        console.log("[ERROR] An error occured", error);
        alert("An error occured, please try again");
      });
      console.log("Send request to start phase");
      this.setState({ showStartPhase: false });
    }
  }, {
    key: 'retractRequest',
    value: function retractRequest(event) {
      var _this8 = this;

      event.preventDefault();
      console.log("Retract phase transition request");
      (0, _sendCommand2.default)({
        type: "retractPhaseTransition",
        project: { id: this.props.project.id },
        phase: { id: this.state.nextPhase.id }
      }).then(function (response) {
        console.log("New state, recalculate schedule");
        if (_this8.props.onUpdate !== undefined) {
          _this8.props.onUpdate(response.project);
        }
      }).catch(function (error) {
        console.log("[ERROR] An error occured", error);
        alert("An error occured, please try again");
      });
      console.log("Send request to start phase");
      this.setState({ showStartPhase: false });
    }
  }, {
    key: 'cancelPhaseStart',
    value: function cancelPhaseStart(event) {
      event.preventDefault();
      this.setState({ showStartPhase: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).general.phaseTransition;
      var nextPhase = this.state.nextPhase !== undefined ? this.state.nextPhase : undefined;
      return this.state.showStartPhase ? _react2.default.createElement(
        'div',
        { style: { fontFamily: "Lato" } },
        this.state.currentPhase !== undefined ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h2',
            null,
            labels.requestToEnd,
            ' ',
            this.state.currentPhase.text
          ),
          _react2.default.createElement(_FormattedContent2.default, { value: this.state.currentPhase.description }),
          this.state.currentPhase.link !== undefined && this.state.currentPhase.link.trim().length > 0 ? _react2.default.createElement(
            'div',
            { style: { float: "right" } },
            _react2.default.createElement(
              'a',
              { href: this.state.currentPhase.link, target: '_blank' },
              labels.readMore,
              ' ',
              this.state.currentPhase.text,
              ' ...'
            )
          ) : null
        ) : null,
        _react2.default.createElement(
          'h2',
          null,
          labels.requestToStart,
          ' ',
          nextPhase.text
        ),
        _react2.default.createElement(_FormattedContent2.default, { value: nextPhase.description }),
        nextPhase.link !== undefined && nextPhase.link.trim().length > 0 ? _react2.default.createElement(
          'div',
          { style: { float: "right" } },
          _react2.default.createElement(
            'a',
            { href: nextPhase.link, target: '_blank' },
            labels.readMore,
            ' ',
            nextPhase.text,
            ' ...'
          )
        ) : null,
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 15 } },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'b',
              null,
              labels.requestComments
            )
          ),
          _react2.default.createElement(_FormattedContent2.default, { value: this.props.project.requestedPhase.comments })
        ),
        _react2.default.createElement(
          'form',
          null,
          _react2.default.createElement(
            'div',
            { style: { paddingTop: 15, paddingBottom: 20 } },
            _react2.default.createElement('input', { onClick: this.cancelPhaseStart.bind(this), className: 'cancel', type: 'button', value: labels.cancel }),
            _react2.default.createElement(
              'div',
              { style: { display: "flex", justifyContent: "flex-end" } },
              _react2.default.createElement('input', { onClick: this.retractRequest.bind(this), style: { padding: 5, paddingLeft: 30, paddingRight: 30, marginRight: 40 }, className: 'delete', type: 'button', name: 'delete', value: labels.retractRequest }),
              _react2.default.createElement('input', { onClick: this.approveRequest.bind(this), className: 'save', type: 'button', value: labels.approveRequest })
            )
          )
        )
      ) : this.state.showStart ? _react2.default.createElement(
        'div',
        { style: { fontFamily: "Lato", paddingBottom: 10 } },
        this.state.currentPhase !== undefined ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h2',
            null,
            labels.requestToEnd,
            ' ',
            this.state.currentPhase.text
          ),
          _react2.default.createElement(_FormattedContent2.default, { value: this.state.currentPhase.description }),
          this.state.currentPhase.link !== undefined && this.state.currentPhase.link.trim().length > 0 ? _react2.default.createElement(
            'div',
            { style: { float: "right" } },
            _react2.default.createElement(
              'a',
              { href: this.state.currentPhase.link, target: '_blank' },
              labels.readMore,
              ' ',
              this.state.currentPhase.text,
              ' ...'
            )
          ) : null
        ) : null,
        nextPhase !== undefined ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h2',
            null,
            labels.requestToStart,
            ' ',
            nextPhase.text
          ),
          _react2.default.createElement(_FormattedContent2.default, { value: nextPhase.description }),
          nextPhase.link !== undefined && nextPhase.link.trim().length > 0 ? _react2.default.createElement(
            'div',
            { style: { float: "right" } },
            _react2.default.createElement(
              'a',
              { href: nextPhase.link, target: '_blank' },
              labels.readMore,
              ' ',
              nextPhase.text,
              ' ...'
            )
          ) : null
        ) : _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h2',
            null,
            'Request to end project'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Before closure of the project can be recommended, the Project Manager must ensure that the expected results have all been achieved and delivered.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Key results:',
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                'Products are handed over and accepted by the receiving organization(s)'
              ),
              _react2.default.createElement(
                'li',
                null,
                'Project is evaluated and lessons recorded.'
              )
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'Summarized in:',
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                'End Project Report'
              ),
              _react2.default.createElement(
                'li',
                null,
                'Updated Lessons Log'
              )
            )
          )
        ),
        _react2.default.createElement(
          'form',
          { onSubmit: this.requestTransition.bind(this) },
          _react2.default.createElement(
            'div',
            { style: { paddingTop: 15 } },
            _react2.default.createElement(_Field2.default, { name: 'comments', title: labels.requestComments, height: 2, optional: true })
          ),
          _react2.default.createElement(
            'div',
            { style: { paddingTop: 15, paddingBottom: 20 } },
            _react2.default.createElement('input', { onClick: this.cancelStartProject.bind(this), className: 'cancel', type: 'button', value: labels.cancel }),
            _react2.default.createElement('input', { className: 'save', type: 'submit', value: labels.submitRequest })
          )
        )
      ) : _react2.default.createElement(PhaseTransitionSummary, _extends({}, this.props, {
        onStartProject: this.startProject.bind(this),
        onStartPhase: this.startPhase.bind(this)
      }));
    }
  }]);

  return PhaseTransition;
}(_react2.default.Component);

exports.default = PhaseTransition;

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Filter = __webpack_require__(1096);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(58), __webpack_require__(59)]);

var request = __webpack_require__(23);

var options = {
  time: [{ id: "lessThan12Months" }, { id: "oneToThreeYears" }, { id: "threeToFiveYears" }, { id: "moreThanFiveYears" }]
};

var LessonFilterAdvanced = function (_React$Component) {
  _inherits(LessonFilterAdvanced, _React$Component);

  function LessonFilterAdvanced(props) {
    _classCallCheck(this, LessonFilterAdvanced);

    var _this = _possibleConstructorReturn(this, (LessonFilterAdvanced.__proto__ || Object.getPrototypeOf(LessonFilterAdvanced)).call(this, props));

    _this.state = { loading: true, keywords: "" };
    return _this;
  }

  //TODO: Copied form Filter.jsx


  _createClass(LessonFilterAdvanced, [{
    key: 'pluralName',
    value: function pluralName(propertyName) {
      return propertyName.slice(-1) === "y" ? propertyName.slice(0, -1) + "ies" : propertyName + "s";
    }
  }, {
    key: 'updateOptions',
    value: function updateOptions(availableFilters) {
      var _this2 = this;

      var filter = {};
      ["started", "paused", "stopped", "completed"].forEach(function (value) {
        return filter["state_" + value] = true;
      });
      (this.props.limitToPortfolio !== undefined ? [] : ["portfolio"]).concat(["location", "projectType", "department", "category"]).forEach(function (property) {
        if (availableFilters[_this2.pluralName(property)] !== undefined && availableFilters[_this2.pluralName(property)].length > 0) {
          availableFilters[_this2.pluralName(property)].forEach(function (item) {
            return filter[property + "_" + item.id] = true;
          });
        }
      });

      if (this.props.limitToPortfolio !== undefined) {
        filter["portfolio_" + this.props.limitToPortfolio] = true;
      }

      Object.keys(options).forEach(function (property) {
        return options[property].forEach(function (key) {
          return filter[property + "_" + key.id] = true;
        });
      });
      this.setState({ loading: false, tenant: availableFilters, filter: filter });
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount(props) {
      var _this3 = this;

      request.get("/lessons/filterOptions").then(function (response) {
        return _this3.updateOptions(JSON.parse(response.text).tenant);
      }).catch(function (error) {
        console.log("[ERROR] Not able to load filter options, got", error);
        _this3.setState({ loading: false, error: error.message });
      });
    }
  }, {
    key: 'changeProperty',
    value: function changeProperty(property, key, value) {
      var _this4 = this;

      var updatedFilter = Object.assign({}, this.state.filter, _defineProperty({}, property + "_" + key, value));
      this.setState({ filter: updatedFilter }, function () {
        return _this4.props.onChange(updatedFilter, _this4.state.keywords);
      });
    }
  }, {
    key: 'changedKeywords',
    value: function changedKeywords(event) {
      var _this5 = this;

      event.preventDefault();
      var newKeywords = event.target.value;
      this.setState({ keywords: newKeywords }, function () {
        return _this5.props.onChange(_this5.state.filter, newKeywords);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).general.lessons;
      var optionsWithTranslation = Object.keys(options).reduce(function (object, key) {
        return Object.assign({}, object, _defineProperty({}, key, options[key].map(function (value) {
          return {
            id: value.id,
            name: labels.filterOptions !== undefined ? labels.filterOptions[key] !== undefined ? labels.filterOptions[key].options !== undefined && labels.filterOptions[key].options[value.id] !== undefined ? labels.filterOptions[key].options[value.id] : "(." + key + "." + value.id + ")" : "(." + key + ", missing option" + value.id + ")" : "(." + key + ", missing filterOptions)"
          };
        })));
      }, {});

      return this.state.loading === true ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'i',
          null,
          '...loading search options'
        )
      ) : this.state.error !== undefined ? _react2.default.createElement(
        'div',
        { style: { marginTop: 10, padding: 10, backgroundColor: "lightyellow", border: "solid 1px brown", color: "red" } },
        _react2.default.createElement(
          'b',
          null,
          'An error occured'
        ),
        ': ',
        this.state.error
      ) : _react2.default.createElement(
        'div',
        { style: { paddingTop: 10, paddingLeft: 20 } },
        _react2.default.createElement(_Filter.FilterOptions, _defineProperty({
          exclude: this.props.limitToPortfolio !== undefined ? ["portfolio"] : undefined,
          filter: [],
          tenant: this.state.tenant,
          options: optionsWithTranslation,
          onChange: this.changeProperty.bind(this)
        }, 'filter', this.state.filter)),
        _react2.default.createElement(
          'div',
          null,
          labels.keywords.title,
          ':',
          _react2.default.createElement(
            'span',
            null,
            ' '
          ),
          _react2.default.createElement('input', { onChange: this.changedKeywords.bind(this), size: '40', placeholder: labels.keywords.description, value: this.state.keywords })
        )
      );
    }
  }]);

  return LessonFilterAdvanced;
}(_react2.default.Component);

exports.default = LessonFilterAdvanced;

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FilterOptions = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_React$Component) {
  _inherits(Header, _React$Component);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { paddingTop: 5, paddingBottom: 5, fontWeight: "bold", fontFamily: "Lato, Arial, Helvetica Neue, Helvetica, sans-serif", background: "#FFFFFF", textAlign: "left", color: "#212121", fontSize: 20, textTransform: "capitalize", paddingLeft: 2 } },
        this.props.title
      );
    }
  }]);

  return Header;
}(_react2.default.Component);

var Option = function (_React$Component2) {
  _inherits(Option, _React$Component2);

  function Option(props) {
    _classCallCheck(this, Option);

    var _this2 = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));

    _this2.state = { value: props.value };
    return _this2;
  }

  _createClass(Option, [{
    key: 'changeValue',
    value: function changeValue(event) {
      var _this3 = this;

      var newValue = event.target.checked;
      this.setState({ value: newValue }, this.props.onChange !== undefined ? function () {
        return _this3.props.onChange(_this3.props.property, _this3.props.id, newValue);
      } : undefined);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { style: { paddingLeft: 2 } },
        _react2.default.createElement(
          'label',
          { className: 'checkboxcontainer' },
          ' ',
          this.props.label,
          _react2.default.createElement('input', { className: 'checkbox',
            name: this.props.name,
            type: 'checkbox',
            id: this.props.id,
            checked: this.state.value,
            onChange: this.changeValue.bind(this)
          }),
          _react2.default.createElement('span', { className: 'checkmark' })
        )
      );
    }
  }]);

  return Option;
}(_react2.default.Component);

var FilterOptions = exports.FilterOptions = function (_React$Component3) {
  _inherits(FilterOptions, _React$Component3);

  function FilterOptions() {
    _classCallCheck(this, FilterOptions);

    return _possibleConstructorReturn(this, (FilterOptions.__proto__ || Object.getPrototypeOf(FilterOptions)).apply(this, arguments));
  }

  _createClass(FilterOptions, [{
    key: 'pluralName',
    value: function pluralName(propertyName) {
      return propertyName.slice(-1) === "y" ? propertyName.slice(0, -1) + "ies" : propertyName + "s";
    }
  }, {
    key: 'labelForProperty',
    value: function labelForProperty(propertyName) {
      return propertyName === "projectType" ? "type" : propertyName;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var filter = this.props.filter;
      var tenant = this.props.tenant;
      return _react2.default.createElement(
        'div',
        { style: { display: "flex", justifyContent: "flex-start", flexWrap: "wrap" } },
        _react2.default.createElement(
          'div',
          { style: { marginRight: 15, paddingBottom: 15 } },
          _react2.default.createElement(Header, { title: 'State' }),
          ["started", "paused", "stopped", "completed"].map(function (state) {
            return _react2.default.createElement(Option, {
              key: "state_" + state,
              property: 'state',
              name: "state_" + state,
              id: state,
              value: filter === undefined || filter["state" + "_" + state] === undefined || filter["state" + "_" + state] !== false,
              label: state.slice(0, 1).toUpperCase() + state.slice(1),
              onChange: _this5.props.onChange
            });
          })
        ),
        (this.props.exclude !== undefined && this.props.exclude.includes("portfolio") ? [] : ["portfolio"]).concat(["location", "projectType", "department", "category"]).map(function (property) {
          return _react2.default.createElement(
            'div',
            { key: property, style: { marginRight: 15, paddingBottom: 15 } },
            tenant[_this5.pluralName(property)] !== undefined && tenant[_this5.pluralName(property)].length > 0 ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(Header, { title: _this5.labelForProperty(property) }),
              tenant[_this5.pluralName(property)].map(function (item) {
                return _react2.default.createElement(Option, {
                  key: item.id,
                  property: property,
                  name: property + "_" + item.id,
                  id: item.id,
                  value: filter === undefined || filter[property + "_" + item.id] === undefined || filter[property + "_" + item.id] !== false,
                  label: item.name,
                  onChange: _this5.props.onChange
                });
              })
            ) : null
          );
        }),
        tenant.projects !== undefined ? ["phase"].map(function (property) {
          return _react2.default.createElement(
            'div',
            { key: property, style: { marginRight: 15, paddingBottom: 15 } },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(Header, { title: _this5.labelForProperty(property) }),
              tenant.projects.map(function (project) {
                return project[property];
              }).filter(function (value, index, array) {
                return array.indexOf(value) === index;
              }).sort(function (a, b) {
                return a < b ? -1 : a > b ? 1 : 0;
              }).map(function (item) {
                return _react2.default.createElement(Option, {
                  key: property + "_" + item,
                  property: property,
                  name: property + "_" + Buffer.from(item).toString("base64"),
                  id: property + "_" + Buffer.from(item).toString("base64"),
                  value: filter === undefined || filter[property + "_" + Buffer.from(item).toString("base64")] === undefined || filter[property + "_" + Buffer.from(item).toString("base64")] !== false,
                  label: item,
                  onChange: _this5.props.onChange
                });
              })
            )
          );
        }) : null,
        this.props.options !== undefined ? Object.keys(this.props.options).map(function (property) {
          return _react2.default.createElement(
            'div',
            { key: property, style: { marginRight: 15, paddingBottom: 15 } },
            _react2.default.createElement(Header, { title: property.slice(0, 1).toUpperCase() + property.slice(1) }),
            _this5.props.options[property].map(function (item) {
              return _react2.default.createElement(Option, {
                key: property + "_" + item.id,
                property: property,
                name: property + "_" + item.id,
                id: item.id,
                value: filter === undefined || filter[property + "_" + item.id] === undefined || filter[property + "_" + item.id] !== false,
                label: item.name,
                onChange: _this5.props.onChange
              });
            })
          );
        }) : null
      );
    }
  }]);

  return FilterOptions;
}(_react2.default.Component);

var Filter = function (_React$Component4) {
  _inherits(Filter, _React$Component4);

  function Filter() {
    _classCallCheck(this, Filter);

    return _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).apply(this, arguments));
  }

  _createClass(Filter, [{
    key: 'render',


    //Duplicated from AccountCreated.jsx

    value: function render() {
      var tenant = this.props.tenant;
      var filter = this.props.user.filters !== undefined ? this.props.user.filters[this.props.tenant.id] : undefined;
      return _react2.default.createElement(
        'div',
        { style: { textAlign: "left", fontFamily: "Lato", marginLeft: 30, display: "flex" } },
        _react2.default.createElement(
          'div',
          { style: { maxWidth: 1016, textAlign: "left" } },
          _react2.default.createElement(
            'div',
            { style: { paddingTop: 30, paddingBottom: 25, fontWeight: "bold", fontFamily: "Lato, Arial, Helvetica Neue, Helvetica, sans-serif", background: "#FFFFFF", textAlign: "left", color: "#212121", fontSize: 28, textTransform: "capitalize" } },
            'Filter projects'
          ),
          _react2.default.createElement(
            'form',
            { method: 'POST', action: '/filter' },
            _react2.default.createElement(FilterOptions, { filter: filter, tenant: tenant }),
            _react2.default.createElement(
              'div',
              { style: { paddingTop: 20 } },
              _react2.default.createElement(
                'div',
                { style: { float: "right" } },
                _react2.default.createElement('input', { className: 'cancel', type: 'submit', name: 'cancel', value: 'Cancel' }),
                _react2.default.createElement(
                  'span',
                  { style: { paddingRight: 30 } },
                  ' '
                ),
                _react2.default.createElement('input', { className: 'save', type: 'submit', value: 'Apply filter' })
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'a',
                  { href: '/filter/reset' },
                  _react2.default.createElement(
                    'b',
                    null,
                    'Reset filter'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Filter;
}(_react2.default.Component);

var FilterPage = function (_React$Component5) {
  _inherits(FilterPage, _React$Component5);

  function FilterPage() {
    _classCallCheck(this, FilterPage);

    return _possibleConstructorReturn(this, (FilterPage.__proto__ || Object.getPrototypeOf(FilterPage)).apply(this, arguments));
  }

  _createClass(FilterPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Layout2.default,
        this.props,
        _react2.default.createElement(Filter, this.props)
      );
    }
  }]);

  return FilterPage;
}(_react2.default.Component);

exports.default = FilterPage;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(423).Buffer))

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ExceptionManagement = __webpack_require__(443);

var _ExceptionManagement2 = _interopRequireDefault(_ExceptionManagement);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var request = __webpack_require__(23);

var translations = new _translations2.default([__webpack_require__(58), __webpack_require__(59)]);

var ExceptionPlanHeader = function (_React$Component) {
  _inherits(ExceptionPlanHeader, _React$Component);

  function ExceptionPlanHeader() {
    _classCallCheck(this, ExceptionPlanHeader);

    return _possibleConstructorReturn(this, (ExceptionPlanHeader.__proto__ || Object.getPrototypeOf(ExceptionPlanHeader)).apply(this, arguments));
  }

  _createClass(ExceptionPlanHeader, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).general.baselineHistory.header.exception;
      var plan = this.props.plan;
      var exceptionTitle = function exceptionTitle(level) {
        switch (level) {
          case "stage":
            return labels.stage;

          case "phase":
            return labels.phase;

          case "project":
            return labels.project;

          default:
            return "(" + labels.unknown + ": " + level + ")";
        }
      };
      return _react2.default.createElement(
        'span',
        null,
        exceptionTitle(plan.level),
        plan.exceptionReport !== undefined && plan.exceptionReport !== null ? ": " + this.props.project.issues.find(function (issue) {
          return issue.id === plan.exceptionReport.issue.id;
        }).title : plan.level === "stage" && plan.stage !== undefined && plan.stage.name !== undefined ? ": " + plan.stage.name : plan.level === "phase" && plan.phase !== undefined && plan.phase.name !== undefined ? ": " + plan.phase.name : null
      );
    }
  }]);

  return ExceptionPlanHeader;
}(_react2.default.Component);

var BaselineHeader = function (_React$Component2) {
  _inherits(BaselineHeader, _React$Component2);

  function BaselineHeader() {
    _classCallCheck(this, BaselineHeader);

    return _possibleConstructorReturn(this, (BaselineHeader.__proto__ || Object.getPrototypeOf(BaselineHeader)).apply(this, arguments));
  }

  _createClass(BaselineHeader, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var labels = translations.getTranslation(this.props).general.baselineHistory.header;
      var plan = this.props.plan;
      var details = function details() {
        switch (plan.type) {
          case "approvedPID":
            return labels.approvedPID;

          case "approvedExceptionPlan":
            return _react2.default.createElement(ExceptionPlanHeader, _this3.props);

          case "approvedStage":
            var stage = plan.stages.find(function (stage) {
              return stage.id === plan.stage.id;
            });
            return labels.approvedStage + (stage !== undefined ? ": " + stage.name : "");

          default:
            return "(" + labels.unknown + ", " + plan.type + ")";
        }
      };
      return _react2.default.createElement(
        'span',
        null,
        new Date(plan.approved).toISOString().slice(0, 10),
        _react2.default.createElement(
          'span',
          null,
          ' '
        ),
        details()
      );
    }
  }]);

  return BaselineHeader;
}(_react2.default.Component);

var BaselineEntryDetails = function (_React$Component3) {
  _inherits(BaselineEntryDetails, _React$Component3);

  function BaselineEntryDetails() {
    _classCallCheck(this, BaselineEntryDetails);

    return _possibleConstructorReturn(this, (BaselineEntryDetails.__proto__ || Object.getPrototypeOf(BaselineEntryDetails)).apply(this, arguments));
  }

  _createClass(BaselineEntryDetails, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).general.baselineHistory.entry;
      var plan = this.props.plan;
      switch (this.props.plan.type) {
        case "approvedExceptionPlan":
          return _react2.default.createElement(_ExceptionManagement2.default, _extends({}, this.props, {
            project: Object.assign({}, this.props.project, {
              requestedStageException: plan
            }),
            showDetails: true,
            viewOnly: true,
            baseline: plan.baseline,
            approved: plan
          }));

        case "approvedPID":
          return _react2.default.createElement(
            'div',
            { style: { paddingBottom: 10 } },
            _react2.default.createElement(
              'div',
              { style: { paddingBottom: 5 } },
              _react2.default.createElement(
                'a',
                { target: '_blank', href: "/projects/" + this.props.project.id + "/pid/?version=" + plan.pid.version },
                labels.approvedPID
              )
            ),
            plan.baseline !== undefined ? _react2.default.createElement(
              'div',
              { style: { paddingBottom: 5 } },
              _react2.default.createElement(
                'a',
                { target: '_blank', href: "/projects/" + this.props.project.id + "/plan/baseline/" + plan.baseline.version + "/" },
                labels.baselinePlan
              ),
              ' ',
              labels.beforePIDApproval
            ) : null,
            _react2.default.createElement(
              'div',
              { style: { paddingBottom: 5 } },
              _react2.default.createElement(
                'a',
                { target: '_blank', href: "/projects/" + this.props.project.id + "/plan/baseline/" + plan.version + "/" },
                labels.newBaselinePlan
              ),
              ' ',
              labels.afterPIDApproval
            )
          );

        case "approvedStage":
          return _react2.default.createElement(
            'div',
            { style: { paddingBottom: 10 } },
            _react2.default.createElement(
              'div',
              { style: { paddingBottom: 5 } },
              _react2.default.createElement(
                'a',
                { target: '_blank', href: "/projects/" + this.props.project.id + "/plan/stages/" + plan.stage.id + "?version=" + plan.stage.version },
                labels.approvedStagePlan
              )
            ),
            plan.baseline !== undefined ? _react2.default.createElement(
              'div',
              { style: { paddingBottom: 5 } },
              _react2.default.createElement(
                'a',
                { target: '_blank', href: "/projects/" + this.props.project.id + "/plan/baseline/" + plan.baseline.version + "/" },
                labels.baselinePlan
              ),
              ' ',
              labels.beforeStageApproval
            ) : null,
            _react2.default.createElement(
              'div',
              { style: { paddingBottom: 5 } },
              _react2.default.createElement(
                'a',
                { target: '_blank', href: "/projects/" + this.props.project.id + "/plan/baseline/" + plan.version + "/" },
                labels.newBaselinePlan
              ),
              ' ',
              labels.afterStageApproval
            )
          );

        default:
          return _react2.default.createElement(
            'div',
            { style: { color: "red", paddingBottom: 10 } },
            labels.unknownBaseline,
            ', ',
            this.props.plan.type
          );
      }
    }
  }]);

  return BaselineEntryDetails;
}(_react2.default.Component);

var BaselineEntry = function (_React$Component4) {
  _inherits(BaselineEntry, _React$Component4);

  function BaselineEntry(props) {
    _classCallCheck(this, BaselineEntry);

    var _this5 = _possibleConstructorReturn(this, (BaselineEntry.__proto__ || Object.getPrototypeOf(BaselineEntry)).call(this, props));

    _this5.state = { details: false };
    return _this5;
  }

  _createClass(BaselineEntry, [{
    key: 'toggleDetails',
    value: function toggleDetails(event) {
      event.preventDefault();
      this.setState({ details: !this.state.details });
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).general.baselineHistory;
      var plan = this.props.plan;
      return this.state.details ? _react2.default.createElement(
        'div',
        { style: { paddingBottom: 20 } },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'b',
            null,
            _react2.default.createElement(BaselineHeader, this.props)
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { paddingLeft: 45, paddingTop: 10 } },
          _react2.default.createElement(BaselineEntryDetails, _extends({}, this.props, { plan: plan }))
        ),
        _react2.default.createElement(
          'a',
          { onClick: this.toggleDetails.bind(this), href: '#' },
          labels.hideDetails
        )
      ) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'a',
          { onClick: this.toggleDetails.bind(this), href: '#' },
          _react2.default.createElement(BaselineHeader, this.props)
        )
      );
    }
  }]);

  return BaselineEntry;
}(_react2.default.Component);

var PlanBaseline = function (_React$Component5) {
  _inherits(PlanBaseline, _React$Component5);

  function PlanBaseline() {
    _classCallCheck(this, PlanBaseline);

    return _possibleConstructorReturn(this, (PlanBaseline.__proto__ || Object.getPrototypeOf(PlanBaseline)).apply(this, arguments));
  }

  _createClass(PlanBaseline, [{
    key: 'render',
    value: function render() {
      var _this7 = this;

      var labels = translations.getTranslation(this.props).general.baselineHistory;
      return _react2.default.createElement(
        'div',
        { style: { paddingTop: 10 } },
        this.props.baseline !== undefined && this.props.baseline.length > 0 ? this.props.baseline.concat().sort(function (a, b) {
          return a.approved < b.approved ? 1 : a.approved > b.approved ? -1 : 0;
        }).map(function (plan, index) {
          return _react2.default.createElement(BaselineEntry, _extends({ key: index }, _this7.props, { plan: plan }));
        }) : _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'i',
            null,
            labels.noBaseline
          )
        )
      );
    }
  }]);

  return PlanBaseline;
}(_react2.default.Component);

var BaselineHistory = function (_React$Component6) {
  _inherits(BaselineHistory, _React$Component6);

  function BaselineHistory(props) {
    _classCallCheck(this, BaselineHistory);

    var _this8 = _possibleConstructorReturn(this, (BaselineHistory.__proto__ || Object.getPrototypeOf(BaselineHistory)).call(this, props));

    _this8.state = {
      showDetails: false,
      baseline: props.baseline
    };
    return _this8;
  }

  _createClass(BaselineHistory, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.setState({ baseline: props.baseline });
    }
  }, {
    key: 'loadHistory',
    value: function loadHistory(event) {
      var _this9 = this;

      event.preventDefault();
      this.setState({ showDetails: true, loading: true });
      request.get("/projects/" + this.props.project.id + "/plan/history/").then(function (response) {
        _this9.setState({ loading: false, baseline: JSON.parse(response.text) });
      }).catch(function (error) {
        _this9.setState({ error: error });
      });
    }
  }, {
    key: 'closeHistory',
    value: function closeHistory(event) {
      event.preventDefault();
      this.setState({ showDetails: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).general.baselineHistory;
      return this.props.project.isProduct === true ? null : this.state.showDetails ? this.state.loading === true ? _react2.default.createElement(
        'div',
        null,
        this.state.error === undefined ? _react2.default.createElement(
          'div',
          null,
          labels.loadingHistory
        ) : _react2.default.createElement(
          'div',
          { style: { color: "red" } },
          labels.errorOccuredDurligLoading,
          ': ',
          this.state.error.message
        )
      ) : _react2.default.createElement(
        'div',
        { style: { fontFamily: "Lato" } },
        _react2.default.createElement(
          'b',
          null,
          labels.title
        ),
        _react2.default.createElement(PlanBaseline, _extends({}, this.props, { baseline: this.state.baseline })),
        _react2.default.createElement(
          'div',
          { style: { paddingTop: 10 } },
          _react2.default.createElement(
            'a',
            { onClick: this.closeHistory.bind(this), href: '#' },
            labels.close
          )
        )
      ) : _react2.default.createElement(
        'a',
        { onClick: this.loadHistory.bind(this), href: '#' },
        labels.title
      );
    }
  }]);

  return BaselineHistory;
}(_react2.default.Component);

exports.default = BaselineHistory;

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RiskManagementApproach = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _uuid = __webpack_require__(26);

var _uuid2 = _interopRequireDefault(_uuid);

var _AreaForm = __webpack_require__(28);

var _AreaForm2 = _interopRequireDefault(_AreaForm);

var _ProjectMenu = __webpack_require__(17);

var _ProjectMenu2 = _interopRequireDefault(_ProjectMenu);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _Risk = __webpack_require__(63);

var _riskManagamentApproachFormDefinition = __webpack_require__(1099);

var _riskManagamentApproachFormDefinition2 = _interopRequireDefault(_riskManagamentApproachFormDefinition);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

var _sendCommand = __webpack_require__(25);

var _sendCommand2 = _interopRequireDefault(_sendCommand);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(129), __webpack_require__(130)]);

var RiskManagementApproach = exports.RiskManagementApproach = function (_React$Component) {
  _inherits(RiskManagementApproach, _React$Component);

  function RiskManagementApproach(props) {
    _classCallCheck(this, RiskManagementApproach);

    var _this = _possibleConstructorReturn(this, (RiskManagementApproach.__proto__ || Object.getPrototypeOf(RiskManagementApproach)).call(this, props));

    var selected = 0;
    if (typeof window !== "undefined" && window.location.hash.length > 0) {
      _riskManagamentApproachFormDefinition2.default.forEach(function (area, index) {
        if (area.name === window.location.hash.slice(1)) {
          selected = index;
        }
      });
    }
    _this.state = {
      approach: Object.assign({}, _this.props.project.riskApproach, {
        id: _this.props.project.riskApproach !== undefined ? "savedApproach" : undefined,
        _progress: "riskManagementApproach"
      }),
      fullWidth: props.details === "presentation",
      selected: selected,
      items: props.risks
    };
    return _this;
  }

  _createClass(RiskManagementApproach, [{
    key: 'updateRiskItems',
    value: function updateRiskItems(items) {
      this.setState({ items: items, modified: true });
    }
  }, {
    key: 'summary',
    value: function summary(area, details) {
      var _this2 = this;

      var labels = translations.getTranslation(this.props);
      switch (area) {
        case "riskRegister":
          return _react2.default.createElement(_Risk.Risk, _extends({}, this.props, {
            risks: this.state.items,
            onUpdate: this.updateRiskItems.bind(this),
            onDetails: details.onDetails,
            onPresentation: function onPresentation() {
              return _this2.setState({ fullWidth: true });
            }
          }));
        default:
          return _react2.default.createElement(
            'i',
            null,
            labels[area].description
          );
      }
    }
  }, {
    key: 'updateApproach',
    value: function updateApproach(approach) {
      var _this3 = this;

      var updatedApproach = Object.assign({}, approach, { _progress: undefined });
      var command = { type: "updateRiskManagementApproach", approach: updatedApproach };
      if (this.props.project.isProduct) {
        command = Object.assign({}, command, {
          product: { id: this.props.project.id }
        });
      } else if (this.props.project.isRelease) {
        command = Object.assign({}, command, {
          release: { id: this.props.project.id }
        });
      } else if (this.props.project.isProgramme) {
        command = Object.assign({}, command, {
          programme: { id: this.props.project.id }
        });
      } else {
        command = Object.assign({}, command, {
          project: { id: this.props.project.id }
        });
      }
      (0, _sendCommand2.default)(command).then(function (response) {
        _this3.setState({
          approach: Object.assign({}, _this3.state.approach, response.approach, { id: "saved" }),
          modified: undefined
        });
      }).catch(function (error) {
        console.log("Got error: " + JSON.stringify(error), error);
        alert("Error saving approach.");
      });
    }
  }, {
    key: 'redirectToHomePage',
    value: function redirectToHomePage(event) {
      var type = this.props.project.isProduct ? "/products" : this.props.project.isProgramme ? "/programmes" : "/projects";
      window.location = type + "/" + this.props.project.id;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var labels = translations.getTranslation(this.props);
      return this.state.fullWidth ? _react2.default.createElement(_Risk.Risk, _extends({}, this.props, {
        risks: this.state.items,
        onUpdate: this.updateRiskItems.bind(this),
        view: 'present',
        onListView: function onListView() {
          return _this4.setState({ fullWidth: undefined });
        }
      })) : _react2.default.createElement(
        'div',
        { style: { paddingTop: 20, display: "flex", justifyContent: "center" } },
        _react2.default.createElement(
          'div',
          { style: { width: 1016 } },
          _react2.default.createElement(_AreaForm2.default, _extends({}, this.props, {
            items: this.state.items,
            areas: translations.createTranslatedForm(_riskManagamentApproachFormDefinition2.default, this.props.language, this.props.variant),
            display: 'tab',
            label: labels.general.approach,
            item: this.state.approach,
            selected: this.state.selected,
            summary: this.summary.bind(this),
            onUpdate: this.updateApproach.bind(this),
            modified: this.state.modified,
            onCancel: this.redirectToHomePage.bind(this)
          }))
        )
      );
    }
  }]);

  return RiskManagementApproach;
}(_react2.default.Component);

var RiskPage = function (_React$Component2) {
  _inherits(RiskPage, _React$Component2);

  function RiskPage() {
    _classCallCheck(this, RiskPage);

    return _possibleConstructorReturn(this, (RiskPage.__proto__ || Object.getPrototypeOf(RiskPage)).apply(this, arguments));
  }

  _createClass(RiskPage, [{
    key: 'render',
    value: function render() {
      var menu = this.props.showMenu === true ? _react2.default.createElement(_ProjectMenu2.default, this.props) : undefined;
      return this.props.fullPage ? _react2.default.createElement(RiskManagementApproach, this.props) : _react2.default.createElement(
        _Layout2.default,
        _extends({}, this.props, { projectMenu: menu }),
        _react2.default.createElement(RiskManagementApproach, this.props)
      );
    }
  }]);

  return RiskPage;
}(_react2.default.Component);

exports.default = RiskPage;

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  name: "riskRegister",
  hideButtons: true
}, {
  name: "riskManagementApproach",
  fields: [{ name: "process", height: 5 }, { name: "tools", height: 2 }, { name: "reporting", height: 2 }, { name: "timing", height: 2 }, { name: "roles", height: 3 }, { name: "tolerance", height: 2 }, { name: "budget", height: 2 }]
}];

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChangeControlApproach = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _uuid = __webpack_require__(26);

var _uuid2 = _interopRequireDefault(_uuid);

var _AreaForm = __webpack_require__(28);

var _AreaForm2 = _interopRequireDefault(_AreaForm);

var _ProjectMenu = __webpack_require__(17);

var _ProjectMenu2 = _interopRequireDefault(_ProjectMenu);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _Change = __webpack_require__(95);

var _sendCommand = __webpack_require__(25);

var _sendCommand2 = _interopRequireDefault(_sendCommand);

var _changeControlApproachFormDefinition = __webpack_require__(1101);

var _changeControlApproachFormDefinition2 = _interopRequireDefault(_changeControlApproachFormDefinition);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(72), __webpack_require__(73)]);

var ChangeControlApproach = exports.ChangeControlApproach = function (_React$Component) {
  _inherits(ChangeControlApproach, _React$Component);

  function ChangeControlApproach(props) {
    _classCallCheck(this, ChangeControlApproach);

    var _this = _possibleConstructorReturn(this, (ChangeControlApproach.__proto__ || Object.getPrototypeOf(ChangeControlApproach)).call(this, props));

    var selected = 0;
    if (typeof window !== "undefined" && window.location.hash.length > 0) {
      _changeControlApproachFormDefinition2.default.forEach(function (area, index) {
        if (area.name === window.location.hash.slice(1)) {
          selected = index;
        }
      });
    }
    _this.state = {
      approach: Object.assign({}, _this.props.project.changeControlApproach, {
        id: _this.props.project.changeControlApproach !== undefined ? "savedApproach" : undefined,
        _progress: "changeControlApproach"
      }),
      selected: selected
    };
    return _this;
  }

  _createClass(ChangeControlApproach, [{
    key: 'summary',
    value: function summary(area, details) {
      var labels = translations.getTranslation(this.props);
      switch (area) {
        case "issueRegister":
          return _react2.default.createElement(_Change.Change, _extends({}, this.props, { onDetails: details.onDetails }));
        default:
          return _react2.default.createElement(
            'i',
            null,
            labels[area].description
          );
      }
    }
  }, {
    key: 'updateApproach',
    value: function updateApproach(approach) {
      var _this2 = this;

      var strippedApproach = Object.assign({}, approach, { _progress: undefined, id: undefined });
      var command = { type: "updateChangeControlApproach", approach: strippedApproach };
      if (this.props.project.isProduct === true) {
        command = Object.assign({}, command, {
          product: { id: this.props.project.id }
        });
      } else if (this.props.project.isProgramme === true) {
        command = Object.assign({}, command, {
          programme: { id: this.props.project.id }
        });
      } else if (this.props.project.isRelease === true) {
        command = Object.assign({}, command, {
          release: { id: this.props.project.id }
        });
      } else {
        command = Object.assign({}, command, {
          project: { id: this.props.project.id }
        });
      }
      (0, _sendCommand2.default)(command).then(function (response) {
        _this2.setState({ approach: Object.assign({}, _this2.state.approach, response.approach, { id: "saved" }) });
      }).catch(function (error) {
        console.log("Got error: " + JSON.stringify(error), error);
        alert("Error saving approach.");
      });
    }
  }, {
    key: 'redirectToHomePage',
    value: function redirectToHomePage(event) {
      var type = this.props.project.isProduct ? "/products" : this.props.project.isProgramme ? "/programmes" : "/projects";
      window.location = type + "/" + this.props.project.id;
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props);
      return _react2.default.createElement(
        'div',
        { style: { paddingTop: 20, display: "flex", justifyContent: "center" } },
        _react2.default.createElement(
          'div',
          { style: { width: 1016, paddingBottom: 30 } },
          _react2.default.createElement(_AreaForm2.default, _extends({}, this.props, {
            areas: translations.createTranslatedForm(_changeControlApproachFormDefinition2.default, this.props.language, this.props.variant),
            item: this.state.approach,
            display: 'tab',
            selected: this.state.selected,
            label: labels.general.approach,
            summary: this.summary.bind(this),
            onUpdate: this.updateApproach.bind(this),
            onCancel: this.redirectToHomePage.bind(this)
          }))
        )
      );
    }
  }]);

  return ChangeControlApproach;
}(_react2.default.Component);

var PlanPage = function (_React$Component2) {
  _inherits(PlanPage, _React$Component2);

  function PlanPage() {
    _classCallCheck(this, PlanPage);

    return _possibleConstructorReturn(this, (PlanPage.__proto__ || Object.getPrototypeOf(PlanPage)).apply(this, arguments));
  }

  _createClass(PlanPage, [{
    key: 'render',
    value: function render() {
      var menu = this.props.showMenu === true ? _react2.default.createElement(_ProjectMenu2.default, this.props) : undefined;
      return _react2.default.createElement(
        _Layout2.default,
        _extends({}, this.props, { projectMenu: menu }),
        _react2.default.createElement(ChangeControlApproach, this.props)
      );
    }
  }]);

  return PlanPage;
}(_react2.default.Component);

exports.default = PlanPage;

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  name: "issueRegister",
  hideButtons: true
}, {
  name: "changeControlApproach",
  fields: [{ name: "process", height: 5 }, { name: "tools", height: 3 }, { name: "reporting", height: 2 }, { name: "timing", height: 3 }, { name: "roles", height: 3 }, { name: "scales", height: 2 }]
}];

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommunicationManagementApproach = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _uuid = __webpack_require__(26);

var _uuid2 = _interopRequireDefault(_uuid);

var _AreaForm = __webpack_require__(28);

var _AreaForm2 = _interopRequireDefault(_AreaForm);

var _ProjectMenu = __webpack_require__(17);

var _ProjectMenu2 = _interopRequireDefault(_ProjectMenu);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _Organization = __webpack_require__(422);

var _communicationManagementApproachFormDefinition = __webpack_require__(1103);

var _communicationManagementApproachFormDefinition2 = _interopRequireDefault(_communicationManagementApproachFormDefinition);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

var _sendCommand = __webpack_require__(25);

var _sendCommand2 = _interopRequireDefault(_sendCommand);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(173), __webpack_require__(174)]);

var StakeholdersInDefinition = function (_React$Component) {
  _inherits(StakeholdersInDefinition, _React$Component);

  function StakeholdersInDefinition() {
    _classCallCheck(this, StakeholdersInDefinition);

    return _possibleConstructorReturn(this, (StakeholdersInDefinition.__proto__ || Object.getPrototypeOf(StakeholdersInDefinition)).apply(this, arguments));
  }

  _createClass(StakeholdersInDefinition, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).general;
      return this.props.project.stakeholderDescription !== undefined && this.props.project.stakeholderDescription !== null && this.props.project.stakeholderDescription.trim().length > 0 ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'b',
          null,
          labels.stakeholdersInDefinition
        ),
        ':',
        _react2.default.createElement(
          'div',
          null,
          this.props.project.stakeholderDescription
        )
      ) : null;
    }
  }]);

  return StakeholdersInDefinition;
}(_react2.default.Component);

var CommunicationManagementApproach = exports.CommunicationManagementApproach = function (_React$Component2) {
  _inherits(CommunicationManagementApproach, _React$Component2);

  //**** Duplcate start **** Modified duplication of BusinessCase to show detailed lesson
  function CommunicationManagementApproach(props) {
    _classCallCheck(this, CommunicationManagementApproach);

    var _this2 = _possibleConstructorReturn(this, (CommunicationManagementApproach.__proto__ || Object.getPrototypeOf(CommunicationManagementApproach)).call(this, props));

    var selected = 0;
    if (typeof window !== "undefined" && window.location.hash.length > 0) {
      _communicationManagementApproachFormDefinition2.default.forEach(function (area, index) {
        if (area.name === window.location.hash.slice(1)) {
          selected = index;
        }
      });
    }
    _this2.state = {
      approach: Object.assign({}, props.project.communicationApproach, {
        id: props.project.communicationApproach !== undefined ? "savedApproach" : undefined,
        stakeholders: props.project.stakeholderCommunication !== undefined ? props.project.stakeholderCommunication : [],
        _progress: "stakeholderAnalysis"
      }),
      selected: selected
    };
    return _this2;
  }

  _createClass(CommunicationManagementApproach, [{
    key: 'showDetails',
    value: function showDetails(details) {
      //Allow all tabs to be updated and start on same tab as last save.
      this.setState({
        details: Object.assign({}, details, {
          item: Object.assign({}, details.item, { _progress: "communication", _currentProgress: details.item.id !== undefined ? details.item._progress : "" })
        })
      });
    }
  }, {
    key: 'updateDetails',
    value: function updateDetails(content) {
      var _this3 = this;

      if (content.id !== undefined) {
        (0, _sendCommand2.default)({
          type: "updateStakeholderCommunication",
          project: { id: this.props.project.id },
          stakeholder: content
        }).then(function (response) {
          /*
                      let approach=Object.assign({},this.state.plan,{
                        [this.state.details.field]:this.state.approach[this.state.details.field].map(item=>
                          item.id===content.id ? Object.assign({},item,Object.assign({},content,{_progress:"communication"})) : item
                        )
                      });
          */
          var approach = Object.assign({}, _this3.state.plan, _defineProperty({}, _this3.state.details.field, response.stakeholderCommunication));
          _this3.setState({ approach: Object.assign({}, approach, { _progress: "stakeholderAnalysis" }), details: content._progress !== "communication" ? Object.assign({}, _this3.state.details, { item: Object.assign({}, content, { _progress: "communication", _currentProgress: content._progress }) }) : undefined, selected: 2, modified: true, modifiedDetails: undefined });
        }).catch(function (error) {
          console.log("Got error " + JSON.stringify(error), error);
          alert("Could not update stakeholder");
        });
      } else {
        var stakeholderCommunication = Object.assign({}, content, { id: _uuid2.default.v4() });
        (0, _sendCommand2.default)({
          type: "identifyStakeholderCommunication",
          project: { id: this.props.project.id },
          stakeholder: stakeholderCommunication
        }).then(function (response) {
          /*
                      let approach=Object.assign({},this.state.plan,{
                        [this.state.details.field]:this.state.approach[this.state.details.field]
                          .concat(Object.assign({},stakeholderCommunication,{_progress:"communication"}))
                      });
          */
          var approach = Object.assign({}, _this3.state.plan, _defineProperty({}, _this3.state.details.field, response.stakeholderCommunication));

          _this3.setState({ approach: Object.assign({}, approach, { _progress: "stakeholderAnalysis" }), details: content._progress !== "communication" ? Object.assign({}, _this3.state.details, { item: Object.assign({}, stakeholderCommunication, { _progress: "communication", _currentProgress: content._progress }) }) : undefined, selected: 2, modified: true, modifiedDetails: undefined });
        }).catch(function (error) {
          console.log("Got error " + JSON.stringify(error), error);
          alert("Could not save stakeholder");
        });
      }
    }
  }, {
    key: 'canceledDetails',
    value: function canceledDetails() {
      this.setState({ details: undefined, selected: 2 });
    }
  }, {
    key: 'summary',
    value: function summary(area) {
      var labels = translations.getTranslation(this.props);
      switch (area) {
        case "teamStructure":
          return _react2.default.createElement(_Organization.Organization, this.props);
        case "stakeholderAnalysis":
          return _react2.default.createElement(StakeholdersInDefinition, this.props);
        default:
          return _react2.default.createElement(
            'i',
            null,
            labels[area].description
          );
      }
    }

    //*** Duplicate end ***

  }, {
    key: 'updateApproach',
    value: function updateApproach(approach) {
      var _this4 = this;

      var updatedApproach = Object.assign({}, approach, { stakeholders: undefined, _progress: undefined });
      (0, _sendCommand2.default)({ type: "updateCommunicationManagementApproach", project: { id: this.props.project.id }, approach: updatedApproach }).then(function (response) {
        var emptyApproach = {
          process: undefined,
          tools: undefined,
          reporting: undefined,
          timing: undefined,
          roles: undefined
        };
        _this4.setState({ approach: Object.assign({}, _this4.state.approach, emptyApproach, response.approach, { id: "saved" }) });
      }).catch(function (error) {
        console.log("Got error: " + JSON.stringify(error), error);
        alert("Error saving approach.", error);
      });
    }
  }, {
    key: 'handleDetailsChange',
    value: function handleDetailsChange(fieldName) {
      var _this5 = this;

      return function (event) {
        var details = Object.assign({}, _this5.state.details, {
          item: Object.assign({}, _this5.state.details.item, _defineProperty({}, event.target.name, event.target.value))
        });
        _this5.setState({
          details: details,
          modifiedDetails: true
        });
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).general;
      return _react2.default.createElement(
        'div',
        { style: { paddingTop: 20, display: "flex", justifyContent: "center" } },
        _react2.default.createElement(
          'div',
          { style: { width: 1016 } },
          this.state.details !== undefined ? _react2.default.createElement(_AreaForm2.default, _extends({ key: 'details'
          }, this.props, {
            display: 'tab',
            areas: translations.createTranslatedForm(this.state.details.form, this.props.language, this.props.variant),
            item: this.state.details.item,
            label: labels.stakeholder,
            onUpdate: this.updateDetails.bind(this),
            modified: this.state.modifiedDetails,
            onCancel: this.canceledDetails.bind(this),
            handleFieldChange: this.handleDetailsChange.bind(this)
          })) : _react2.default.createElement(_AreaForm2.default, _extends({}, this.props, {
            areas: translations.createTranslatedForm(_communicationManagementApproachFormDefinition2.default, this.props.language, this.props.variant),
            display: 'tab',
            item: this.state.approach,
            modified: this.state.modified,
            label: labels.approach,
            selected: this.state.selected,
            summary: this.summary.bind(this),
            onUpdate: this.updateApproach.bind(this),
            onAddEntry: this.showDetails.bind(this),
            onEditEntry: this.showDetails.bind(this),
            onCancel: function onCancel() {
              return window.location = ".";
            }
          }))
        )
      );
    }
  }]);

  return CommunicationManagementApproach;
}(_react2.default.Component);

var CommunicationManagementApproachPage = function (_React$Component3) {
  _inherits(CommunicationManagementApproachPage, _React$Component3);

  function CommunicationManagementApproachPage() {
    _classCallCheck(this, CommunicationManagementApproachPage);

    return _possibleConstructorReturn(this, (CommunicationManagementApproachPage.__proto__ || Object.getPrototypeOf(CommunicationManagementApproachPage)).apply(this, arguments));
  }

  _createClass(CommunicationManagementApproachPage, [{
    key: 'render',
    value: function render() {
      var menu = this.props.showMenu === true ? _react2.default.createElement(_ProjectMenu2.default, this.props) : undefined;
      return _react2.default.createElement(
        _Layout2.default,
        _extends({}, this.props, { projectMenu: menu }),
        _react2.default.createElement(CommunicationManagementApproach, this.props)
      );
    }
  }]);

  return CommunicationManagementApproachPage;
}(_react2.default.Component);

exports.default = CommunicationManagementApproachPage;

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var stakeholderCommunicationFormDefinition = [{
  name: "stakeholder",
  fields: [{ name: "name" }, { name: "message", height: 3, optional: true }]
}, {
  name: "information",
  fields: [{ name: "requiredInformation", height: 3, optional: true }, { name: "providedInformation", height: 3, optional: true }]
}, {
  name: "communication",
  fields: [{ name: "frequency", height: 3, optional: true }, { name: "means", optional: true }, { name: "format", optional: true }]
}];

exports.default = [{
  name: "teamStructure",
  hideButtons: true
}, {
  name: "communicationManagementApproach",
  fields: [{ name: "process", height: 5 }, { name: "tools", height: 3 }, { name: "reporting", height: 3 }, { name: "timing", height: 2 }, { name: "roles", height: 3 }]
}, {
  name: "stakeholderAnalysis",
  hideButtons: true,
  fields: [{
    name: "stakeholders",
    type: "table",
    columns: [{ name: "name" }, { name: "message" }, { name: "requiredInformation" }, { name: "providedInformation" }, { name: "frequency" }],
    options: {
      addEntry: {
        formDefinition: stakeholderCommunicationFormDefinition
      },
      edit: {
        formDefinition: stakeholderCommunicationFormDefinition
      }
    }
  }]
}];

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InitiationDocument = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _HighlightReport = __webpack_require__(105);

var _ProjectBrief = __webpack_require__(264);

var _ProjectPlan = __webpack_require__(438);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _ProjectMenu = __webpack_require__(17);

var _ProjectMenu2 = _interopRequireDefault(_ProjectMenu);

var _FormattedContent = __webpack_require__(15);

var _FormattedContent2 = _interopRequireDefault(_FormattedContent);

var _getProjectInitiationDocument = __webpack_require__(433);

var _getProjectInitiationDocument2 = _interopRequireDefault(_getProjectInitiationDocument);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(1105), __webpack_require__(1106)]);

var StakeholderCommunication = function (_React$Component) {
  _inherits(StakeholderCommunication, _React$Component);

  function StakeholderCommunication() {
    _classCallCheck(this, StakeholderCommunication);

    return _possibleConstructorReturn(this, (StakeholderCommunication.__proto__ || Object.getPrototypeOf(StakeholderCommunication)).apply(this, arguments));
  }

  _createClass(StakeholderCommunication, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).communication;
      var approach = this.props.pid.communicationManagementApproach;
      var fields = ["name", "message", "requiredInformation", "providedInformation", "frequency"];
      return approach.stakeholderCommunication !== undefined && approach.stakeholderCommunication !== null && approach.stakeholderCommunication.length > 0 ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h3',
          null,
          labels.stakeholderCommunication.title
        ),
        _react2.default.createElement(
          'table',
          { cellSpacing: '0', style: { fontSize: "inherit", border: "solid 1px lightgrey" } },
          _react2.default.createElement(
            'thead',
            null,
            _react2.default.createElement(
              'tr',
              { style: { backgroundColor: "#e9e7e6" } },
              fields.map(function (field) {
                return _react2.default.createElement(
                  'th',
                  { key: field, style: { borderRight: field !== "frequency" ? "solid 1px lightgrey" : undefined, padding: 5 } },
                  labels.stakeholderCommunication.columns[field].title
                );
              })
            )
          ),
          _react2.default.createElement(
            'tbody',
            null,
            approach.stakeholderCommunication.map(function (stakeholder) {
              return _react2.default.createElement(
                'tr',
                { key: stakeholder.id },
                fields.map(function (field) {
                  return _react2.default.createElement(
                    'td',
                    { key: field, style: { borderTop: "solid 1px lightgrey", borderRight: field !== "frequency" ? "solid 1px lightgrey" : undefined, padding: 5 } },
                    _react2.default.createElement(_FormattedContent2.default, { value: stakeholder[field] })
                  );
                })
              );
            })
          )
        )
      ) : null;
    }
  }]);

  return StakeholderCommunication;
}(_react2.default.Component);

var CommunicationManagementApproach = function (_React$Component2) {
  _inherits(CommunicationManagementApproach, _React$Component2);

  function CommunicationManagementApproach() {
    _classCallCheck(this, CommunicationManagementApproach);

    return _possibleConstructorReturn(this, (CommunicationManagementApproach.__proto__ || Object.getPrototypeOf(CommunicationManagementApproach)).apply(this, arguments));
  }

  _createClass(CommunicationManagementApproach, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).communication;
      var approach = this.props.pid.communicationManagementApproach;
      var fields = ["process", "tools", "reporting", "timing", "roles"];
      return approach !== undefined && approach !== null && (fields.filter(function (field) {
        return approach[field] !== undefined && approach[field] !== null && approach[field].trim().length > 0;
      }).length > 0 || approach.stakeholderCommunication !== undefined && approach.stakeholderCommunication !== null && approach.stakeholderCommunication.length > 0) ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          null,
          labels.title
        ),
        fields.map(function (field) {
          return approach[field] !== undefined && approach[field] !== null && approach[field].trim().length > 0 ? _react2.default.createElement(
            'div',
            { key: field },
            _react2.default.createElement(
              'h3',
              null,
              labels[field]
            ),
            _react2.default.createElement(_FormattedContent2.default, { value: approach[field] })
          ) : null;
        }),
        _react2.default.createElement(StakeholderCommunication, this.props)
      ) : null;
    }
  }]);

  return CommunicationManagementApproach;
}(_react2.default.Component);

var RiskManagementApproach = function (_React$Component3) {
  _inherits(RiskManagementApproach, _React$Component3);

  function RiskManagementApproach() {
    _classCallCheck(this, RiskManagementApproach);

    return _possibleConstructorReturn(this, (RiskManagementApproach.__proto__ || Object.getPrototypeOf(RiskManagementApproach)).apply(this, arguments));
  }

  _createClass(RiskManagementApproach, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).risk;
      var approach = this.props.pid.riskManagementApproach;
      var fields = ["process", "tools", "reporting", "timing", "roles", "tolerance", "budget"];
      return approach !== undefined && approach !== null && fields.filter(function (field) {
        return approach[field] !== undefined && approach[field] !== null && approach[field].trim().length > 0;
      }).length > 0 ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          null,
          labels.title
        ),
        fields.map(function (field) {
          return approach[field] !== undefined && approach[field] !== null && approach[field].trim().length > 0 ? _react2.default.createElement(
            'div',
            { key: field },
            _react2.default.createElement(
              'h3',
              null,
              labels[field]
            ),
            _react2.default.createElement(_FormattedContent2.default, { value: approach[field] })
          ) : null;
        })
      ) : null;
    }
  }]);

  return RiskManagementApproach;
}(_react2.default.Component);

var QualityManagementApproach = function (_React$Component4) {
  _inherits(QualityManagementApproach, _React$Component4);

  function QualityManagementApproach() {
    _classCallCheck(this, QualityManagementApproach);

    return _possibleConstructorReturn(this, (QualityManagementApproach.__proto__ || Object.getPrototypeOf(QualityManagementApproach)).apply(this, arguments));
  }

  _createClass(QualityManagementApproach, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).quality;
      var approach = this.props.pid.qualityManagementApproach;
      var fields = ["process", "tools", "reporting", "timing", "roles"];
      return approach !== undefined && approach !== null && fields.filter(function (field) {
        return approach[field] !== undefined && approach[field] !== null && approach[field].trim().length > 0;
      }).length > 0 ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          null,
          labels.title
        ),
        fields.map(function (field) {
          return approach[field] !== undefined && approach[field] !== null && approach[field].trim().length > 0 ? _react2.default.createElement(
            'div',
            { key: field },
            _react2.default.createElement(
              'h3',
              null,
              labels[field]
            ),
            _react2.default.createElement(_FormattedContent2.default, { value: approach[field] })
          ) : null;
        })
      ) : null;
    }
  }]);

  return QualityManagementApproach;
}(_react2.default.Component);

var ChangeControlApproach = function (_React$Component5) {
  _inherits(ChangeControlApproach, _React$Component5);

  function ChangeControlApproach() {
    _classCallCheck(this, ChangeControlApproach);

    return _possibleConstructorReturn(this, (ChangeControlApproach.__proto__ || Object.getPrototypeOf(ChangeControlApproach)).apply(this, arguments));
  }

  _createClass(ChangeControlApproach, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).change;
      var approach = this.props.pid.changeControlApproach;
      var fields = ["process", "tools", "reporting", "timing", "roles", "scales"];
      return approach !== undefined && approach !== null && fields.filter(function (field) {
        return approach[field] !== undefined && approach[field] !== null && approach[field].trim().length > 0;
      }).length > 0 ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          null,
          labels.title
        ),
        fields.map(function (field) {
          return approach[field] !== undefined && approach[field] !== null && approach[field].trim().length > 0 ? _react2.default.createElement(
            'div',
            { key: field },
            _react2.default.createElement(
              'h3',
              null,
              labels[field]
            ),
            _react2.default.createElement(_FormattedContent2.default, { value: approach[field] })
          ) : null;
        })
      ) : null;
    }
  }]);

  return ChangeControlApproach;
}(_react2.default.Component);

var ProjectControls = function (_React$Component6) {
  _inherits(ProjectControls, _React$Component6);

  function ProjectControls() {
    _classCallCheck(this, ProjectControls);

    return _possibleConstructorReturn(this, (ProjectControls.__proto__ || Object.getPrototypeOf(ProjectControls)).apply(this, arguments));
  }

  _createClass(ProjectControls, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).plan.projectControls;
      var approach = this.props.pid.projectControls;
      var fields = ["projectControls"];
      return approach !== undefined && approach !== null && fields.filter(function (field) {
        return approach[field] !== undefined && approach[field] !== null && approach[field].trim().length > 0;
      }).length > 0 ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          null,
          labels.title
        ),
        fields.map(function (field) {
          return approach[field] !== undefined && approach[field] !== null && approach[field].trim().length > 0 ? _react2.default.createElement(
            'div',
            { key: field },
            _react2.default.createElement(_FormattedContent2.default, { value: approach[field] })
          ) : null;
        })
      ) : null;
    }
  }]);

  return ProjectControls;
}(_react2.default.Component);

var ProjectPlanSection = function (_React$Component7) {
  _inherits(ProjectPlanSection, _React$Component7);

  function ProjectPlanSection() {
    _classCallCheck(this, ProjectPlanSection);

    return _possibleConstructorReturn(this, (ProjectPlanSection.__proto__ || Object.getPrototypeOf(ProjectPlanSection)).apply(this, arguments));
  }

  _createClass(ProjectPlanSection, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).plan.schedule;
      return this.props.pid.plan !== undefined && this.props.pid.plan !== null && this.props.pid.plan.length > 0 ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          null,
          labels.title
        ),
        _react2.default.createElement(
          'div',
          { style: { marginLeft: -20 } },
          _react2.default.createElement(_ProjectPlan.ProjectPlan, _extends({}, this.props, { planVersion: '2', fontSize: '70%', size: 0.5, project: Object.assign({}, this.props.project, { stages: this.props.pid.plan }), showInReport: true }))
        )
      ) : null;
    }
  }]);

  return ProjectPlanSection;
}(_react2.default.Component);

var InitiationDocumentContent = function (_React$Component8) {
  _inherits(InitiationDocumentContent, _React$Component8);

  function InitiationDocumentContent() {
    _classCallCheck(this, InitiationDocumentContent);

    return _possibleConstructorReturn(this, (InitiationDocumentContent.__proto__ || Object.getPrototypeOf(InitiationDocumentContent)).apply(this, arguments));
  }

  _createClass(InitiationDocumentContent, [{
    key: 'render',
    value: function render() {
      var pid = this.props.pid;
      var labels = translations.getTranslation(this.props);
      var slides = [_react2.default.createElement(QualityManagementApproach, _extends({}, this.props, { pid: pid })), _react2.default.createElement(RiskManagementApproach, _extends({}, this.props, { pid: pid })), _react2.default.createElement(ChangeControlApproach, _extends({}, this.props, { pid: pid })), _react2.default.createElement(CommunicationManagementApproach, _extends({}, this.props, { pid: pid })), _react2.default.createElement(ProjectPlanSection, _extends({}, this.props, { pid: pid })), _react2.default.createElement(ProjectControls, _extends({}, this.props, { pid: pid }))];
      var slideTitles = [labels.quality.title, labels.risk.title, labels.change.title, labels.communication.title, labels.plan.schedule.title, labels.plan.projectControls.title];
      return !this.props.presentationMode ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_ProjectBrief.BriefContent, _extends({}, this.props, { brief: pid })),
        _react2.default.createElement(QualityManagementApproach, _extends({}, this.props, { pid: pid })),
        _react2.default.createElement(RiskManagementApproach, _extends({}, this.props, { pid: pid })),
        _react2.default.createElement(ChangeControlApproach, _extends({}, this.props, { pid: pid })),
        _react2.default.createElement(CommunicationManagementApproach, _extends({}, this.props, { pid: pid })),
        _react2.default.createElement(ProjectPlanSection, _extends({}, this.props, { pid: pid })),
        _react2.default.createElement(ProjectControls, _extends({}, this.props, { pid: pid }))
      ) : _react2.default.createElement(_ProjectBrief.BriefPidSlides, _extends({}, this.props, { doc: pid, pidSlides: slides, pidSlideTitles: slideTitles }));
    }
  }]);

  return InitiationDocumentContent;
}(_react2.default.Component);

var InitiationDocumentDetails = function (_React$Component9) {
  _inherits(InitiationDocumentDetails, _React$Component9);

  function InitiationDocumentDetails() {
    _classCallCheck(this, InitiationDocumentDetails);

    return _possibleConstructorReturn(this, (InitiationDocumentDetails.__proto__ || Object.getPrototypeOf(InitiationDocumentDetails)).apply(this, arguments));
  }

  _createClass(InitiationDocumentDetails, [{
    key: 'render',
    value: function render() {
      var date = new Date().toISOString().slice(0, 10);
      var pid = this.props.pid;
      if (pid !== undefined && pid.date !== undefined) {
        date = new Date(Date.parse(pid.date)).toISOString().slice(0, 10);
      }
      var nameAndDate = (this.props.project !== undefined ? this.props.project.name + " - " : "") + date;
      var type = this.props.pid !== undefined ? this.props.pid.type : undefined;
      var labels = translations.getTranslation(this.props);
      return false ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { display: "flex", padding: 5, paddingLeft: 10, fontFamily: "Verdana, sans-serif", justifyContent: "center" } },
          _react2.default.createElement(
            'div',
            { style: { maxWidth: 1016 } },
            _react2.default.createElement(
              'h1',
              { style: { textAlign: "center" } },
              _react2.default.createElement(
                'div',
                { style: { fontSize: "120%" } },
                labels.pid.title
              ),
              _react2.default.createElement(
                'div',
                null,
                nameAndDate
              )
            ),
            type === "preview" ? _react2.default.createElement(_HighlightReport.ReportMessage, { message: labels.pid.messagePreview }) : null,
            _react2.default.createElement(InitiationDocumentContent, this.props)
          )
        )
      ) : _react2.default.createElement(
        _ProjectBrief.ApprovableReport,
        _extends({}, this.props, {
          title: labels.pid.title,
          date: date,
          type: type,
          selected: this.props.pid,
          current: this.props.project.pid,
          report: 'PID',
          approveLabel: labels.approval.approve
        }),
        _react2.default.createElement(InitiationDocumentContent, _extends({}, this.props, { title: labels.pid.title }))
      );
    }
  }]);

  return InitiationDocumentDetails;
}(_react2.default.Component);

function ignoreUndefinedAndInvariants(key, value) {
  if (value === undefined || value === null) {
    return undefined;
  } else {
    switch (key) {
      case "date":
      case "type":
      case "history":
      case "version":
      case "majorVersion":
      case "minorVersion":
        return undefined;
      default:
        return value;
    }
  }
}

var InitiationDocument = exports.InitiationDocument = function (_React$Component10) {
  _inherits(InitiationDocument, _React$Component10);

  function InitiationDocument() {
    _classCallCheck(this, InitiationDocument);

    return _possibleConstructorReturn(this, (InitiationDocument.__proto__ || Object.getPrototypeOf(InitiationDocument)).apply(this, arguments));
  }

  _createClass(InitiationDocument, [{
    key: 'render',
    value: function render() {
      var _this11 = this;

      var pid = (0, _getProjectInitiationDocument2.default)(this.props.project);
      var hasPreview = this.props.project.pid === undefined || this.props.project.pid !== undefined && JSON.stringify(pid, ignoreUndefinedAndInvariants) !== JSON.stringify(this.props.project.pid, ignoreUndefinedAndInvariants);
      if (hasPreview) {
        pid = Object.assign({}, pid, { type: "preview" });
      } else if (this.props.project.pid !== undefined) {
        pid = this.props.project.pid;
      }
      if (this.props.selected !== undefined) {
        if (this.props.selected.indexOf("-DRAFT") > 0 && this.props.project.pid.type === "draft" && this.props.project.pid.version === parseInt(this.props.selected)) {
          pid = this.props.project.pid;
        } else if (this.props.project.pid !== undefined && this.props.project.pid.history !== undefined) {
          var foundPID = this.props.project.pid.history.filter(function (item) {
            return item.version === parseInt(_this11.props.selected);
          })[0];
          if (foundPID !== undefined) {
            pid = foundPID;
          }
        }
      }
      return _react2.default.createElement(InitiationDocumentDetails, _extends({}, this.props, { pid: pid, hasPreview: hasPreview }));
    }
  }]);

  return InitiationDocument;
}(_react2.default.Component);

var InitiationDocumentPage = function (_React$Component11) {
  _inherits(InitiationDocumentPage, _React$Component11);

  function InitiationDocumentPage() {
    _classCallCheck(this, InitiationDocumentPage);

    return _possibleConstructorReturn(this, (InitiationDocumentPage.__proto__ || Object.getPrototypeOf(InitiationDocumentPage)).apply(this, arguments));
  }

  _createClass(InitiationDocumentPage, [{
    key: 'render',
    value: function render() {
      var menu = this.props.showMenu === true ? _react2.default.createElement(_ProjectMenu2.default, this.props) : undefined;
      return this.props.fullPage ? _react2.default.createElement(
        'html',
        null,
        _react2.default.createElement(
          'head',
          null,
          _react2.default.createElement('meta', { 'http-equiv': 'Content-Type', content: 'text/html; charset=UTF-8' })
        ),
        _react2.default.createElement(
          'body',
          null,
          _react2.default.createElement(InitiationDocument, this.props)
        )
      ) : _react2.default.createElement(
        _Layout2.default,
        _extends({}, this.props, { projectMenu: menu }),
        _react2.default.createElement(InitiationDocument, this.props)
      );
    }
  }]);

  return InitiationDocumentPage;
}(_react2.default.Component);

exports.default = InitiationDocumentPage;

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var organization = __webpack_require__(173).english;
var risk = __webpack_require__(129).english;
var quality = __webpack_require__(261).english;
var change = __webpack_require__(72).english;
var plan = __webpack_require__(58).english;

var english = exports.english = {
  communication: {
    title: organization.communicationManagementApproach.title,
    process: organization.communicationManagementApproach.fields.process.title,
    tools: organization.communicationManagementApproach.fields.tools.title,
    reporting: organization.communicationManagementApproach.fields.reporting.title,
    timing: organization.communicationManagementApproach.fields.timing.title,
    roles: organization.communicationManagementApproach.fields.roles.title,
    stakeholderCommunication: {
      title: organization.stakeholderAnalysis.fields.stakeholders.title,
      columns: organization.stakeholderAnalysis.fields.stakeholders.columns
    }
  },
  risk: {
    title: risk.riskManagementApproach.title,
    process: risk.riskManagementApproach.fields.process.title,
    tools: risk.riskManagementApproach.fields.tools.title,
    reporting: risk.riskManagementApproach.fields.reporting.title,
    timing: risk.riskManagementApproach.fields.timing.title,
    roles: risk.riskManagementApproach.fields.roles.title,
    tolerance: risk.riskManagementApproach.fields.tolerance.title,
    budget: risk.riskManagementApproach.fields.budget.title
  },
  quality: {
    title: quality.qualityManagementApproach.title,
    process: quality.qualityManagementApproach.fields.process.title,
    tools: quality.qualityManagementApproach.fields.tools.title,
    reporting: quality.qualityManagementApproach.fields.reporting.title,
    timing: quality.qualityManagementApproach.fields.timing.title,
    roles: quality.qualityManagementApproach.fields.roles.title
  },
  change: {
    title: change.changeControlApproach.title,
    process: change.changeControlApproach.fields.process.title,
    tools: change.changeControlApproach.fields.tools.title,
    reporting: change.changeControlApproach.fields.reporting.title,
    timing: change.changeControlApproach.fields.timing.title,
    roles: change.changeControlApproach.fields.roles.title,
    scales: change.changeControlApproach.fields.scales.title
  },
  plan: {
    projectControls: {
      title: plan.projectControls.title
    },
    schedule: {
      title: "Project Plan"
    }
  },
  pid: {
    title: "Project Initiation Document"
  },
  approval: {
    approve: "Approve Project Initiation Document"
  }
};

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var organization = __webpack_require__(174).norwegian;
var risk = __webpack_require__(130).norwegian;
var quality = __webpack_require__(262).norwegian;
var change = __webpack_require__(73).norwegian;
var plan = __webpack_require__(59).norwegian;

var norwegian = exports.norwegian = {
  communication: {
    title: "Tilnærming til kommunikasjon",
    process: organization.communicationManagementApproach.fields.process.title,
    tools: organization.communicationManagementApproach.fields.tools.title,
    reporting: organization.communicationManagementApproach.fields.reporting.title,
    timing: organization.communicationManagementApproach.fields.timing.title,
    roles: organization.communicationManagementApproach.fields.roles.title,
    stakeholderCommunication: {
      title: organization.stakeholderAnalysis.fields.stakeholders.title,
      columns: organization.stakeholderAnalysis.fields.stakeholders.columns
    }
  },
  risk: {
    title: risk.riskManagementApproach.title,
    process: risk.riskManagementApproach.fields.process.title,
    tools: risk.riskManagementApproach.fields.tools.title,
    reporting: risk.riskManagementApproach.fields.reporting.title,
    timing: risk.riskManagementApproach.fields.timing.title,
    roles: risk.riskManagementApproach.fields.roles.title,
    tolerance: risk.riskManagementApproach.fields.tolerance.title,
    budget: risk.riskManagementApproach.fields.budget.title
  },
  quality: {
    title: quality.qualityManagementApproach.title,
    process: quality.qualityManagementApproach.fields.process.title,
    tools: quality.qualityManagementApproach.fields.tools.title,
    reporting: quality.qualityManagementApproach.fields.reporting.title,
    timing: quality.qualityManagementApproach.fields.timing.title,
    roles: quality.qualityManagementApproach.fields.roles.title
  },
  change: {
    title: change.changeControlApproach.title,
    process: change.changeControlApproach.fields.process.title,
    tools: change.changeControlApproach.fields.tools.title,
    reporting: change.changeControlApproach.fields.reporting.title,
    timing: change.changeControlApproach.fields.timing.title,
    roles: change.changeControlApproach.fields.roles.title,
    scales: change.changeControlApproach.fields.scales.title
  },
  plan: {
    projectControls: {
      title: plan.projectControls.title
    },
    schedule: {
      title: "Prosjektplan"
    }
  },
  pid: {
    title: "Styringsdokument"
  },
  approval: {
    approve: "Godkjenn styringsdokumentet"
  }
};

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgrammeDetails = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _ProjectMenu = __webpack_require__(17);

var _ProjectMenu2 = _interopRequireDefault(_ProjectMenu);

var _ProjectDetails = __webpack_require__(260);

var _Portfolio = __webpack_require__(175);

var _Portfolio2 = _interopRequireDefault(_Portfolio);

var _translations = __webpack_require__(2);

var _translations2 = _interopRequireDefault(_translations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var translations = new _translations2.default([__webpack_require__(1108), __webpack_require__(1109)]);

var IdentifyProgrammeProcessOverview = function (_React$Component) {
  _inherits(IdentifyProgrammeProcessOverview, _React$Component);

  function IdentifyProgrammeProcessOverview() {
    _classCallCheck(this, IdentifyProgrammeProcessOverview);

    return _possibleConstructorReturn(this, (IdentifyProgrammeProcessOverview.__proto__ || Object.getPrototypeOf(IdentifyProgrammeProcessOverview)).apply(this, arguments));
  }

  _createClass(IdentifyProgrammeProcessOverview, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).identifyingProgrammeProcess;
      var activities = [{
        name: "sponsoringTheProgramme",
        link: "/organization",
        status: "notStarted"
      }, {
        name: "confirmProgramMandate",
        link: "/brief",
        status: "notStarted"
      }, {
        name: "appointSROAndProgrammeBoard",
        link: "/organization",
        status: "notStarted"
      }, {
        name: "produceProgrammeBrief",
        link: "/definition?variant=program",
        status: "notStarted"
      }, {
        name: "developProgrammePreparationPlan",
        link: "/plan?show=controls#schedule",
        status: "notStarted"
      }, {
        name: "independentReview",
        link: "?showProgress=identifyProgramme&showMenu=true",
        status: "notStarted"
      }, {
        name: "approvalToProceed",
        link: "?showProgress=identifyProgramme&showMenu=true",
        status: "notStarted"
      }].filter(function (item) {
        return item !== undefined && !item.disabled;
      });
      return _react2.default.createElement(_ProjectDetails.ActivityView, _extends({}, this.props, { activities: activities, labels: labels }));
    }
  }]);

  return IdentifyProgrammeProcessOverview;
}(_react2.default.Component);

var DefiningProgrammeProcessOverview = function (_React$Component2) {
  _inherits(DefiningProgrammeProcessOverview, _React$Component2);

  function DefiningProgrammeProcessOverview() {
    _classCallCheck(this, DefiningProgrammeProcessOverview);

    return _possibleConstructorReturn(this, (DefiningProgrammeProcessOverview.__proto__ || Object.getPrototypeOf(DefiningProgrammeProcessOverview)).apply(this, arguments));
  }

  _createClass(DefiningProgrammeProcessOverview, [{
    key: 'render',
    value: function render() {
      var labels = translations.getTranslation(this.props).definingProgrammeProcess;
      var activities = [{
        name: "establishInfrastructure",
        link: "#",
        status: "notStarted"
      }, {
        name: "establishTeam",
        link: "#",
        status: "notStarted"
      }, {
        name: "identifyStakeholders",
        link: "/organization",
        status: "notStarted"
      }, {
        name: "refineVision",
        link: "#",
        status: "notStarted"
      }, {
        name: "developBlueprint",
        link: "#",
        status: "notStarted"
      }, {
        name: "developBenefitProfiles",
        link: "#",
        status: "notStarted"
      }, {
        name: "modelBenefits",
        link: "#",
        status: "notStarted"
      }, {
        name: "validateBenefits",
        link: "#",
        status: "notStarted"
      }, {
        name: "designProjectsDossier",
        link: "#",
        status: "notStarted"
      }, {
        name: "identifyTranches",
        link: "#",
        status: "notStarted"
      }, {
        name: "designProgrammeOrganization",
        link: "#",
        status: "notStarted"
      }, {
        name: "developGovernanceArrangements",
        link: "#",
        status: "notStarted"
      }, {
        name: "developProgrammePlan",
        link: "#",
        status: "notStarted"
      }, {
        name: "confirmBusinessCase",
        link: "#",
        status: "notStarted"
      }, {
        name: "consolidateProgrammeDefinition",
        link: "#",
        status: "notStarted"
      }, {
        name: "prepareFirstTranche",
        link: "#",
        status: "notStarted"
      }, {
        name: "approvalToProceed",
        link: "#",
        status: "notStarted"
      }].filter(function (item) {
        return item !== undefined && !item.disabled;
      });
      return _react2.default.createElement(_ProjectDetails.ActivityView, _extends({}, this.props, { activities: activities, labels: labels }));
    }
  }]);

  return DefiningProgrammeProcessOverview;
}(_react2.default.Component);

function assignPriority(item) {
  return item.status !== "Closed" ? Object.assign({}, item, { row: parseInt(item.priority), column: parseInt(item.severity) }) : Object.assign({}, item, { row: undefined, column: undefined });
}

var ProgrammeDetails = exports.ProgrammeDetails = function (_React$Component3) {
  _inherits(ProgrammeDetails, _React$Component3);

  function ProgrammeDetails() {
    _classCallCheck(this, ProgrammeDetails);

    return _possibleConstructorReturn(this, (ProgrammeDetails.__proto__ || Object.getPrototypeOf(ProgrammeDetails)).apply(this, arguments));
  }

  _createClass(ProgrammeDetails, [{
    key: 'showIdentifyingProgrammeProcessView',
    value: function showIdentifyingProgrammeProcessView() {
      return this.props.showProgress === "identifyProgramme";
    }
  }, {
    key: 'showDefiningProgrammeProcessView',
    value: function showDefiningProgrammeProcessView() {
      return this.props.showProgress === "defineProgramme";
    }
  }, {
    key: 'isProgrammeBriefEnabled',
    value: function isProgrammeBriefEnabled() {
      return false;
    }
  }, {
    key: 'isProgrammeDefinitionDocumentEnabled',
    value: function isProgrammeDefinitionDocumentEnabled() {
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var access = {
        isBusinessCaseEnabled: function isBusinessCaseEnabled() {
          return false;
        }, //this.isBusinessCaseEnabled.bind(this),
        isQualityEnabled: function isQualityEnabled() {
          return false;
        }, //this.isQualityEnabled.bind(this),
        isDefinitionEnabled: function isDefinitionEnabled() {
          return true;
        }, //this.isDefinitionEnabled.bind(this),
        isProjectBriefEnabled: this.isProgrammeBriefEnabled.bind(this),
        isPIDEnabled: this.isProgrammeDefinitionDocumentEnabled.bind(this)
      };

      var portfolio = this.props.portfolio !== undefined ? this.props.portfolio : this.props.programme !== undefined && this.props.programme.portfolio !== undefined && this.props.tenant.portfolios !== undefined ? this.props.tenant.portfolios.filter(function (portfolio) {
        return portfolio.id === _this4.props.programme.portfolio;
      })[0] : undefined;

      var labels = translations.getTranslation(this.props);

      return _react2.default.createElement(
        'div',
        { style: { marginTop: 40, marginLeft: 30, fontFamily: "Lato" } },
        this.props.programme.isStopped ? _react2.default.createElement(
          'span',
          { style: { color: "red", paddingRight: 20 } },
          'STOPPED'
        ) : null,
        this.props.programme.isPaused ? _react2.default.createElement(
          'span',
          { style: { color: "red", paddingRight: 20 } },
          'paused'
        ) : null,
        _react2.default.createElement(
          'div',
          { style: { display: "flex", flexWrap: "wrap", justifyContent: "flex-start" } },
          _react2.default.createElement(
            'div',
            { style: { maxWidth: 1016 } },
            _react2.default.createElement(
              'div',
              { style: { fontWeight: "bold", fontSize: 14 } },
              portfolio !== undefined ? portfolio.name : null
            ),
            _react2.default.createElement(
              'div',
              { style: { fontSize: 30, marginBottom: 30, width: "100%", fontWeight: "bold", float: "left" } },
              this.props.programme.name
            ),
            _react2.default.createElement(
              'div',
              { style: { display: "inline-block" } },
              _react2.default.createElement(
                'div',
                { style: { padding: 0, marginBottom: 10, display: "flex", justifyContent: "space-between", flexWrap: "wrap" } },
                _react2.default.createElement(_ProjectDetails.StatusSummary, _extends({}, this.props.programme, this.props)),
                _react2.default.createElement(_ProjectDetails.KeyInfo, _extends({}, this.props.programme, this.props))
              ),
              this.showDefiningProgrammeProcessView() ? _react2.default.createElement(DefiningProgrammeProcessOverview, _extends({}, this.props, { project: this.props.programme, access: access })) : this.showIdentifyingProgrammeProcessView() ? _react2.default.createElement(IdentifyProgrammeProcessOverview, _extends({}, this.props, { project: this.props.programme, access: access })) : _react2.default.createElement(
                'div',
                { style: { maxWidth: 1016 } },
                _react2.default.createElement(_ProjectDetails.Themes, _extends({}, this.props, {
                  style: 'small',
                  project: this.props.programme,
                  access: access
                })),
                this.props.projects !== undefined && this.props.projects.length > 0 ? _react2.default.createElement(_Portfolio2.default, _extends({}, this.props, { programOverview: true, tenant: this.props.tenant, projectTypes: this.props.tenant.projectTypes, disablePriority: this.props.programme.useTenantPriority === true })) : _react2.default.createElement('div', { style: { minWidth: 1016 } })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { marginLeft: "auto" } },
            _react2.default.createElement(_ProjectDetails.Links, _extends({}, this.props, this.props.programme, {
              standardLinks: this.props.tenant.standardLinks,
              mode: this.props.linkMode,
              edit: this.props.edit,
              add: this.props.add,
              briefEnabled: this.isProgrammeBriefEnabled(),
              pidEnabled: this.isProgrammeDefinitionDocumentEnabled()
            }))
          )
        )
      );
    }
  }]);

  return ProgrammeDetails;
}(_react2.default.Component);

var ProgrammeDetailsPage = function (_React$Component4) {
  _inherits(ProgrammeDetailsPage, _React$Component4);

  function ProgrammeDetailsPage() {
    _classCallCheck(this, ProgrammeDetailsPage);

    return _possibleConstructorReturn(this, (ProgrammeDetailsPage.__proto__ || Object.getPrototypeOf(ProgrammeDetailsPage)).apply(this, arguments));
  }

  _createClass(ProgrammeDetailsPage, [{
    key: 'render',
    value: function render() {
      var menu = this.props.showMenu === true ? _react2.default.createElement(_ProjectMenu2.default, _extends({}, this.props, {
        project: this.props.programme
      })) : undefined;
      return _react2.default.createElement(
        _Layout2.default,
        _extends({}, this.props, { project: this.props.programme, projectMenu: menu }),
        _react2.default.createElement(ProgrammeDetails, this.props)
      );
    }
  }]);

  return ProgrammeDetailsPage;
}(_react2.default.Component);

exports.default = ProgrammeDetailsPage;

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var english = exports.english = {
  general: {
    executive: "Executive",
    projectManager: "PM",
    risks: "Risks",
    issues: "Issues"
  },
  reports: {
    heading: "Generated reports",
    highlightReport: "Latest Highlight Report",
    brief: "Program Brief",
    pid: "Program Definition Document"
  },
  identifyingProgrammeProcess: {
    title: "Recommended activities when identifying a programme:",
    activities: {
      sponsoringTheProgramme: {
        title: "Sponsoring the programme"
      },
      confirmProgramMandate: {
        title: "Confirm the programme mandate"
      },
      appointSROAndProgrammeBoard: {
        title: "Appoint the SRO and programme board"
      },
      produceProgrammeBrief: {
        title: "Produce the programme brief"
      },
      developProgrammePreparationPlan: {
        title: "Develop the programme preparation plan"
      },
      independentReview: {
        title: "Independent Review"
      },
      approvalToProceed: {
        title: "Approval to proceed"
      }
    }
  },
  definingProgrammeProcess: {
    title: "Recommended activities when defining a programme:",
    activities: {
      establishInfrastructure: {
        title: "Establish the infrastructure for 'Defining a Programme'"
      },
      establishTeam: {
        title: "Establish the team to define the programme"
      },
      identifyStakeholders: {
        title: "Identify and analyse the stakeholders"
      },
      refineVision: {
        title: "Refine the vision statement"
      },
      developBlueprint: {
        title: "Develop the blueprint"
      },
      developBenefitProfiles: {
        title: "Develop the benefit profiles"
      },
      modelBenefits: {
        title: "Model the benefits and refine the profiles"
      },
      validateBenefits: {
        title: "Validate the benefits"
      },
      designProjectsDossier: {
        title: "Design the projects dossier"
      },
      identifyTranches: {
        title: "Identify tranches"
      },
      designProgrammeOrganization: {
        title: "Design the programme organization"
      },
      developGovernanceArrangements: {
        title: "Develop the governance arrangements"
      },
      developProgrammePlan: {
        title: "Develop the programme plan"
      },
      confirmBusinessCase: {
        title: "Develop and confirm programme business case"
      },
      consolidateProgrammeDefinition: {
        title: "Consolidate the programme definition"
      },
      prepareFirstTranche: {
        title: "Prepare for first tranche"
      },
      approvalToProceed: {
        title: "Approval to proceed"
      }
    }
  }
};

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var norwegian = exports.norwegian = {
  general: {
    executive: "Eier",
    projectManager: "Programleder",
    risks: "Riski",
    issues: "Saker"
  },
  reports: {
    heading: "Genererte rapporter",
    highlightReport: "Siste statusrapport",
    brief: "Programforslag",
    pid: "Styringsdokument"
  },
  identifyingProgrammeProcess: {
    title: "Anbefalte aktiviteter ved identifisering av program:",
    activities: {
      sponsoringTheProgramme: {
        title: "Forankre programmet i ledelsen"
      },
      confirmProgramMandate: {
        title: "Bekrefte mandatet for programmet"
      },
      appointSROAndProgrammeBoard: {
        title: "Utpeke eier av programmet og programstyret"
      },
      produceProgrammeBrief: {
        title: "Utarbeide programforslaget"
      },
      developProgrammePreparationPlan: {
        title: "Utvikle plan for å forberede programmet"
      },
      independentReview: {
        title: "Uavhengig gjennomgang"
      },
      approvalToProceed: {
        title: "Godkjenning til å fortsette"
      }
    }
  },
  definingProgrammeProcess: {
    title: "Anbefalte aktiviteter ved presisering av program:",
    activities: {
      establishInfrastructure: {
        title: "Etablere infrastruktur for å 'Presisere programmet'"
      },
      establishTeam: {
        title: "Sette sammen teamet som skal presisere programmet"
      },
      identifyStakeholders: {
        title: "Identifisere og analysere interessentene"
      },
      refineVision: {
        title: "Forbedre visjonen"
      },
      developBlueprint: {
        title: "Utvikle fremtidsmodellen"
      },
      developBenefitProfiles: {
        title: "Utvikle gevinstprofiler"
      },
      modelBenefits: {
        title: "Utarbeide gevinstmodell og avgrens gevinstprofilene"
      },
      validateBenefits: {
        title: "Bekrefte gevinstene"
      },
      designProjectsDossier: {
        title: "Beskrive prosjektene i programmet"
      },
      identifyTranches: {
        title: "Identifisere seksjonene i programmet (milepælene)"
      },
      designProgrammeOrganization: {
        title: "Utforme programorganisasjonen"
      },
      developGovernanceArrangements: {
        title: "Definere styringsmekanismene for programmet"
      },
      developProgrammePlan: {
        title: "Utarbeid programplanen"
      },
      confirmBusinessCase: {
        title: "Utvikle og bekreft begrunnelsen for programmet"
      },
      consolidateProgrammeDefinition: {
        title: "Sett sammen programdefinisjonen"
      },
      prepareFirstTranche: {
        title: "Forbered første seksjon i programmet"
      },
      approvalToProceed: {
        title: "Godkjenning til å fortsette"
      }
    }
  }
};

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PortfolioReportRisk = exports.PortfolioReportRiskOld = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Layout = __webpack_require__(11);

var _Layout2 = _interopRequireDefault(_Layout);

var _PresentationView = __webpack_require__(414);

var _PresentationView2 = _interopRequireDefault(_PresentationView);

var _Risk = __webpack_require__(63);

var _priority = __webpack_require__(102);

var _priority2 = _interopRequireDefault(_priority);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function assignPriority(item) {
  return item.status !== "Closed" ? Object.assign({}, item, { row: parseInt(item.probability), column: parseInt(item.impact) }) : Object.assign({}, item, { row: undefined, column: undefined });
}

var PortfolioReportRiskOld = exports.PortfolioReportRiskOld = function (_React$Component) {
  _inherits(PortfolioReportRiskOld, _React$Component);

  function PortfolioReportRiskOld(props) {
    _classCallCheck(this, PortfolioReportRiskOld);

    var _this = _possibleConstructorReturn(this, (PortfolioReportRiskOld.__proto__ || Object.getPrototypeOf(PortfolioReportRiskOld)).call(this, props));

    var items = _this.props.risks !== undefined ? _this.props.risks : [];

    _this.state = {
      items: items,
      selected: props.selected
    };
    return _this;
  }

  _createClass(PortfolioReportRiskOld, [{
    key: 'render',
    value: function render() {
      var items = this.state.items.slice(0).map(assignPriority).sort(_priority2.default.getProfileSort(this.props.profile));

      var reportStyle = { textAlign: "left", maxWidth: 1016 };
      var style = Object.assign({}, reportStyle, this.props.settings !== undefined ? this.props.settings.style : undefined);

      return _react2.default.createElement(
        'div',
        { style: { paddingLeft: 20, fontFamily: "Lato, Verdana, sans-serif" } },
        _react2.default.createElement(_PresentationView2.default, _extends({}, this.props, {
          items: items,
          selected: this.state.selected
        }))
      );
    }
  }]);

  return PortfolioReportRiskOld;
}(_react2.default.Component);

var PortfolioReportRisk = exports.PortfolioReportRisk = function (_React$Component2) {
  _inherits(PortfolioReportRisk, _React$Component2);

  function PortfolioReportRisk(props) {
    _classCallCheck(this, PortfolioReportRisk);

    var _this2 = _possibleConstructorReturn(this, (PortfolioReportRisk.__proto__ || Object.getPrototypeOf(PortfolioReportRisk)).call(this, props));

    var items = _this2.props.risks !== undefined ? _this2.props.risks : [];

    _this2.state = {
      items: items,
      selected: props.selected
    };
    return _this2;
  }

  _createClass(PortfolioReportRisk, [{
    key: 'render',
    value: function render() {
      var items = this.state.items.slice(0).map(assignPriority).sort(_priority2.default.getProfileSort(this.props.profile));

      var reportStyle = { textAlign: "left", maxWidth: 1016 };
      var style = Object.assign({}, reportStyle, this.props.settings !== undefined ? this.props.settings.style : undefined);

      return _react2.default.createElement(
        'div',
        { style: { paddingLeft: 20, fontFamily: "Lato, Verdana, sans-serif" } },
        _react2.default.createElement(_Risk.Risk, _extends({}, this.props, {
          items: items,
          selected: this.state.selected,
          view: 'presentOnly'
        }))
      );
    }
  }]);

  return PortfolioReportRisk;
}(_react2.default.Component);

var PortfolioReportRiskPage = function (_React$Component3) {
  _inherits(PortfolioReportRiskPage, _React$Component3);

  function PortfolioReportRiskPage() {
    _classCallCheck(this, PortfolioReportRiskPage);

    return _possibleConstructorReturn(this, (PortfolioReportRiskPage.__proto__ || Object.getPrototypeOf(PortfolioReportRiskPage)).apply(this, arguments));
  }

  _createClass(PortfolioReportRiskPage, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _Layout2.default,
        this.props,
        _react2.default.createElement(PortfolioReportRisk, this.props)
      );
    }
  }]);

  return PortfolioReportRiskPage;
}(_react2.default.Component);

exports.default = PortfolioReportRiskPage;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js